(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9416"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9416"] = parcelRequire;
}
parcelRequire.register("a58XM", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $757152ee82640ba0$export$ffb0004e005737fa; }, function (v) { return $757152ee82640ba0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $757152ee82640ba0$export$34b9dba7ce09269b; }, function (v) { return $757152ee82640ba0$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $757152ee82640ba0$export$25062201e9e25d76; }, function (v) { return $757152ee82640ba0$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $757152ee82640ba0$export$ffb0004e005737fa;
var $757152ee82640ba0$export$34b9dba7ce09269b;
var $757152ee82640ba0$export$25062201e9e25d76;
"use strict";

var $6cds3 = parcelRequire("6cds3");
var $757152ee82640ba0$var$k = Symbol.for("react.element"), $757152ee82640ba0$var$l = Symbol.for("react.fragment"), $757152ee82640ba0$var$m = Object.prototype.hasOwnProperty, $757152ee82640ba0$var$n = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $757152ee82640ba0$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $757152ee82640ba0$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$757152ee82640ba0$var$m.call(a, b) && !$757152ee82640ba0$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $757152ee82640ba0$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $757152ee82640ba0$var$n.current
    };
}
$757152ee82640ba0$export$ffb0004e005737fa = $757152ee82640ba0$var$l;
$757152ee82640ba0$export$34b9dba7ce09269b = $757152ee82640ba0$var$q;
$757152ee82640ba0$export$25062201e9e25d76 = $757152ee82640ba0$var$q;

});
parcelRequire.register("6cds3", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gx6CV"));

});
parcelRequire.register("gx6CV", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $c094de5bd35107a3$export$dca3b0875bd9a954; }, function (v) { return $c094de5bd35107a3$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $c094de5bd35107a3$export$16fa2f45be04daa8; }, function (v) { return $c094de5bd35107a3$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c094de5bd35107a3$export$ffb0004e005737fa; }, function (v) { return $c094de5bd35107a3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $c094de5bd35107a3$export$e2c29f18771995cb; }, function (v) { return $c094de5bd35107a3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $c094de5bd35107a3$export$221d75b3f55bb0bd; }, function (v) { return $c094de5bd35107a3$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c094de5bd35107a3$export$5f8d39834fd61797; }, function (v) { return $c094de5bd35107a3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c094de5bd35107a3$export$74bf444e3cd11ea5; }, function (v) { return $c094de5bd35107a3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c094de5bd35107a3$export$ae55be85d98224ed; }, function (v) { return $c094de5bd35107a3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $c094de5bd35107a3$export$e530037191fcd5d7; }, function (v) { return $c094de5bd35107a3$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $c094de5bd35107a3$export$fd42f52fd3ae1109; }, function (v) { return $c094de5bd35107a3$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $c094de5bd35107a3$export$c8a8987d4410bf2d; }, function (v) { return $c094de5bd35107a3$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $c094de5bd35107a3$export$d38cd72104c1f0e9; }, function (v) { return $c094de5bd35107a3$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $c094de5bd35107a3$export$7d1e3a5e95ceca43; }, function (v) { return $c094de5bd35107a3$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $c094de5bd35107a3$export$257a8862b851cb5b; }, function (v) { return $c094de5bd35107a3$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $c094de5bd35107a3$export$a8257692ac88316c; }, function (v) { return $c094de5bd35107a3$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $c094de5bd35107a3$export$488013bae63b21da; }, function (v) { return $c094de5bd35107a3$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $c094de5bd35107a3$export$7c73462e0d25e514; }, function (v) { return $c094de5bd35107a3$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $c094de5bd35107a3$export$7568632d0d33d16d; }, function (v) { return $c094de5bd35107a3$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $c094de5bd35107a3$export$88948ce120ea2619; }, function (v) { return $c094de5bd35107a3$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $c094de5bd35107a3$export$35808ee640e87ca7; }, function (v) { return $c094de5bd35107a3$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $c094de5bd35107a3$export$fae74005e78b1a27; }, function (v) { return $c094de5bd35107a3$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e; }, function (v) { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $c094de5bd35107a3$export$6a7bc4e911dc01cf; }, function (v) { return $c094de5bd35107a3$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $c094de5bd35107a3$export$6d9c69b0de29b591; }, function (v) { return $c094de5bd35107a3$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $c094de5bd35107a3$export$f680877a34711e37; }, function (v) { return $c094de5bd35107a3$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $c094de5bd35107a3$export$d5a552a76deda3c2; }, function (v) { return $c094de5bd35107a3$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $c094de5bd35107a3$export$aaabe4eda9ed9969; }, function (v) { return $c094de5bd35107a3$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $c094de5bd35107a3$export$e5c5a5f917a5871c; }, function (v) { return $c094de5bd35107a3$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $c094de5bd35107a3$export$1538c33de8887b59; }, function (v) { return $c094de5bd35107a3$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $c094de5bd35107a3$export$13e3392192263954; }, function (v) { return $c094de5bd35107a3$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $c094de5bd35107a3$export$b8f5890fc79d6aca; }, function (v) { return $c094de5bd35107a3$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $c094de5bd35107a3$export$60241385465d0a34; }, function (v) { return $c094de5bd35107a3$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $c094de5bd35107a3$export$306c0aa65ff9ec16; }, function (v) { return $c094de5bd35107a3$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $c094de5bd35107a3$export$7b286972b8d8ccbf; }, function (v) { return $c094de5bd35107a3$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $c094de5bd35107a3$export$83d89fbfd8236492; }, function (v) { return $c094de5bd35107a3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c094de5bd35107a3$export$dca3b0875bd9a954;
var $c094de5bd35107a3$export$16fa2f45be04daa8;
var $c094de5bd35107a3$export$ffb0004e005737fa;
var $c094de5bd35107a3$export$e2c29f18771995cb;
var $c094de5bd35107a3$export$221d75b3f55bb0bd;
var $c094de5bd35107a3$export$5f8d39834fd61797;
var $c094de5bd35107a3$export$74bf444e3cd11ea5;
var $c094de5bd35107a3$export$ae55be85d98224ed;
var $c094de5bd35107a3$export$e530037191fcd5d7;
var $c094de5bd35107a3$export$fd42f52fd3ae1109;
var $c094de5bd35107a3$export$c8a8987d4410bf2d;
var $c094de5bd35107a3$export$d38cd72104c1f0e9;
var $c094de5bd35107a3$export$7d1e3a5e95ceca43;
var $c094de5bd35107a3$export$257a8862b851cb5b;
var $c094de5bd35107a3$export$a8257692ac88316c;
var $c094de5bd35107a3$export$488013bae63b21da;
var $c094de5bd35107a3$export$7c73462e0d25e514;
var $c094de5bd35107a3$export$7568632d0d33d16d;
var $c094de5bd35107a3$export$88948ce120ea2619;
var $c094de5bd35107a3$export$35808ee640e87ca7;
var $c094de5bd35107a3$export$fae74005e78b1a27;
var $c094de5bd35107a3$export$dc8fbce3eb94dc1e;
var $c094de5bd35107a3$export$6a7bc4e911dc01cf;
var $c094de5bd35107a3$export$6d9c69b0de29b591;
var $c094de5bd35107a3$export$f680877a34711e37;
var $c094de5bd35107a3$export$d5a552a76deda3c2;
var $c094de5bd35107a3$export$aaabe4eda9ed9969;
var $c094de5bd35107a3$export$e5c5a5f917a5871c;
var $c094de5bd35107a3$export$1538c33de8887b59;
var $c094de5bd35107a3$export$13e3392192263954;
var $c094de5bd35107a3$export$b8f5890fc79d6aca;
var $c094de5bd35107a3$export$60241385465d0a34;
var $c094de5bd35107a3$export$306c0aa65ff9ec16;
var $c094de5bd35107a3$export$7b286972b8d8ccbf;
var $c094de5bd35107a3$export$83d89fbfd8236492;
"use strict";
var $c094de5bd35107a3$var$l = Symbol.for("react.element"), $c094de5bd35107a3$var$n = Symbol.for("react.portal"), $c094de5bd35107a3$var$p = Symbol.for("react.fragment"), $c094de5bd35107a3$var$q = Symbol.for("react.strict_mode"), $c094de5bd35107a3$var$r = Symbol.for("react.profiler"), $c094de5bd35107a3$var$t = Symbol.for("react.provider"), $c094de5bd35107a3$var$u = Symbol.for("react.context"), $c094de5bd35107a3$var$v = Symbol.for("react.forward_ref"), $c094de5bd35107a3$var$w = Symbol.for("react.suspense"), $c094de5bd35107a3$var$x = Symbol.for("react.memo"), $c094de5bd35107a3$var$y = Symbol.for("react.lazy"), $c094de5bd35107a3$var$z = Symbol.iterator;
function $c094de5bd35107a3$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c094de5bd35107a3$var$z && a[$c094de5bd35107a3$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c094de5bd35107a3$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $c094de5bd35107a3$var$C = Object.assign, $c094de5bd35107a3$var$D = {};
function $c094de5bd35107a3$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
$c094de5bd35107a3$var$E.prototype.isReactComponent = {};
$c094de5bd35107a3$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c094de5bd35107a3$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c094de5bd35107a3$var$F() {}
$c094de5bd35107a3$var$F.prototype = $c094de5bd35107a3$var$E.prototype;
function $c094de5bd35107a3$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
var $c094de5bd35107a3$var$H = $c094de5bd35107a3$var$G.prototype = new $c094de5bd35107a3$var$F;
$c094de5bd35107a3$var$H.constructor = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$var$C($c094de5bd35107a3$var$H, $c094de5bd35107a3$var$E.prototype);
$c094de5bd35107a3$var$H.isPureReactComponent = !0;
var $c094de5bd35107a3$var$I = Array.isArray, $c094de5bd35107a3$var$J = Object.prototype.hasOwnProperty, $c094de5bd35107a3$var$K = {
    current: null
}, $c094de5bd35107a3$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c094de5bd35107a3$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c094de5bd35107a3$var$J.call(b, d) && !$c094de5bd35107a3$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $c094de5bd35107a3$var$K.current
    };
}
function $c094de5bd35107a3$var$N(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c094de5bd35107a3$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c094de5bd35107a3$var$l;
}
function $c094de5bd35107a3$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c094de5bd35107a3$var$P = /\/+/g;
function $c094de5bd35107a3$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c094de5bd35107a3$var$escape("" + a.key) : b.toString(36);
}
function $c094de5bd35107a3$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c094de5bd35107a3$var$l:
                case $c094de5bd35107a3$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $c094de5bd35107a3$var$Q(h, 0) : d, $c094de5bd35107a3$var$I(c) ? (e = "", null != a && (e = a.replace($c094de5bd35107a3$var$P, "$&/") + "/"), $c094de5bd35107a3$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($c094de5bd35107a3$var$O(c) && (c = $c094de5bd35107a3$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($c094de5bd35107a3$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($c094de5bd35107a3$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $c094de5bd35107a3$var$Q(k, g);
        h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    }
    else if (f = $c094de5bd35107a3$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $c094de5bd35107a3$var$Q(k, g++), h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $c094de5bd35107a3$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $c094de5bd35107a3$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $c094de5bd35107a3$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $c094de5bd35107a3$var$U = {
    current: null
}, $c094de5bd35107a3$var$V = {
    transition: null
}, $c094de5bd35107a3$var$W = {
    ReactCurrentDispatcher: $c094de5bd35107a3$var$U,
    ReactCurrentBatchConfig: $c094de5bd35107a3$var$V,
    ReactCurrentOwner: $c094de5bd35107a3$var$K
};
$c094de5bd35107a3$export$dca3b0875bd9a954 = {
    map: $c094de5bd35107a3$var$S,
    forEach: function(a, b, e) {
        $c094de5bd35107a3$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $c094de5bd35107a3$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $c094de5bd35107a3$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$c094de5bd35107a3$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$c094de5bd35107a3$export$16fa2f45be04daa8 = $c094de5bd35107a3$var$E;
$c094de5bd35107a3$export$ffb0004e005737fa = $c094de5bd35107a3$var$p;
$c094de5bd35107a3$export$e2c29f18771995cb = $c094de5bd35107a3$var$r;
$c094de5bd35107a3$export$221d75b3f55bb0bd = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$export$5f8d39834fd61797 = $c094de5bd35107a3$var$q;
$c094de5bd35107a3$export$74bf444e3cd11ea5 = $c094de5bd35107a3$var$w;
$c094de5bd35107a3$export$ae55be85d98224ed = $c094de5bd35107a3$var$W;
$c094de5bd35107a3$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $c094de5bd35107a3$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c094de5bd35107a3$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c094de5bd35107a3$var$J.call(b, f) && !$c094de5bd35107a3$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$c094de5bd35107a3$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $c094de5bd35107a3$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $c094de5bd35107a3$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$c094de5bd35107a3$export$c8a8987d4410bf2d = $c094de5bd35107a3$var$M;
$c094de5bd35107a3$export$d38cd72104c1f0e9 = function(a) {
    var b = $c094de5bd35107a3$var$M.bind(null, a);
    b.type = a;
    return b;
};
$c094de5bd35107a3$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c094de5bd35107a3$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$v,
        render: a
    };
};
$c094de5bd35107a3$export$a8257692ac88316c = $c094de5bd35107a3$var$O;
$c094de5bd35107a3$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c094de5bd35107a3$var$T
    };
};
$c094de5bd35107a3$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c094de5bd35107a3$export$7568632d0d33d16d = function(a) {
    var b = $c094de5bd35107a3$var$V.transition;
    $c094de5bd35107a3$var$V.transition = {};
    try {
        a();
    } finally{
        $c094de5bd35107a3$var$V.transition = b;
    }
};
$c094de5bd35107a3$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$c094de5bd35107a3$export$35808ee640e87ca7 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useCallback(a, b);
};
$c094de5bd35107a3$export$fae74005e78b1a27 = function(a) {
    return $c094de5bd35107a3$var$U.current.useContext(a);
};
$c094de5bd35107a3$export$dc8fbce3eb94dc1e = function() {};
$c094de5bd35107a3$export$6a7bc4e911dc01cf = function(a) {
    return $c094de5bd35107a3$var$U.current.useDeferredValue(a);
};
$c094de5bd35107a3$export$6d9c69b0de29b591 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useEffect(a, b);
};
$c094de5bd35107a3$export$f680877a34711e37 = function() {
    return $c094de5bd35107a3$var$U.current.useId();
};
$c094de5bd35107a3$export$d5a552a76deda3c2 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useImperativeHandle(a, b, e);
};
$c094de5bd35107a3$export$aaabe4eda9ed9969 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useInsertionEffect(a, b);
};
$c094de5bd35107a3$export$e5c5a5f917a5871c = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useLayoutEffect(a, b);
};
$c094de5bd35107a3$export$1538c33de8887b59 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useMemo(a, b);
};
$c094de5bd35107a3$export$13e3392192263954 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useReducer(a, b, e);
};
$c094de5bd35107a3$export$b8f5890fc79d6aca = function(a) {
    return $c094de5bd35107a3$var$U.current.useRef(a);
};
$c094de5bd35107a3$export$60241385465d0a34 = function(a) {
    return $c094de5bd35107a3$var$U.current.useState(a);
};
$c094de5bd35107a3$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useSyncExternalStore(a, b, e);
};
$c094de5bd35107a3$export$7b286972b8d8ccbf = function() {
    return $c094de5bd35107a3$var$U.current.useTransition();
};
$c094de5bd35107a3$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("jZA9I", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed; }, function (v) { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389; }, function (v) { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $e8dfc29dafb3bbd7$export$882461b6382ed46c; }, function (v) { return $e8dfc29dafb3bbd7$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $e8dfc29dafb3bbd7$export$466bfc07425424d5; }, function (v) { return $e8dfc29dafb3bbd7$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4; }, function (v) { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db; }, function (v) { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e; }, function (v) { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99; }, function (v) { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $e8dfc29dafb3bbd7$export$502457920280e6be; }, function (v) { return $e8dfc29dafb3bbd7$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1; }, function (v) { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18; }, function (v) { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492; }, function (v) { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e8dfc29dafb3bbd7$export$ae55be85d98224ed;
var $e8dfc29dafb3bbd7$export$d39a5bbd09211389;
var $e8dfc29dafb3bbd7$export$882461b6382ed46c;
var $e8dfc29dafb3bbd7$export$466bfc07425424d5;
var $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4;
var $e8dfc29dafb3bbd7$export$fa8d919ba61d84db;
var $e8dfc29dafb3bbd7$export$757ceba2d55c277e;
var $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99;
var $e8dfc29dafb3bbd7$export$502457920280e6be;
var $e8dfc29dafb3bbd7$export$c78a37762a8d58e1;
var $e8dfc29dafb3bbd7$export$dc54d992c10e8a18;
var $e8dfc29dafb3bbd7$export$83d89fbfd8236492;
"use strict";

var $6cds3 = parcelRequire("6cds3");

var $1c9zD = parcelRequire("1c9zD");
function $e8dfc29dafb3bbd7$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e8dfc29dafb3bbd7$var$da = new Set, $e8dfc29dafb3bbd7$var$ea = {};
function $e8dfc29dafb3bbd7$var$fa(a, b) {
    $e8dfc29dafb3bbd7$var$ha(a, b);
    $e8dfc29dafb3bbd7$var$ha(a + "Capture", b);
}
function $e8dfc29dafb3bbd7$var$ha(a, b) {
    $e8dfc29dafb3bbd7$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$da.add(b[a]);
}
var $e8dfc29dafb3bbd7$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e8dfc29dafb3bbd7$var$ja = Object.prototype.hasOwnProperty, $e8dfc29dafb3bbd7$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e8dfc29dafb3bbd7$var$la = {}, $e8dfc29dafb3bbd7$var$ma = {};
function $e8dfc29dafb3bbd7$var$oa(a) {
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$ma, a)) return !0;
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$la, a)) return !1;
    if ($e8dfc29dafb3bbd7$var$ka.test(a)) return $e8dfc29dafb3bbd7$var$ma[a] = !0;
    $e8dfc29dafb3bbd7$var$la[a] = !0;
    return !1;
}
function $e8dfc29dafb3bbd7$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e8dfc29dafb3bbd7$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e8dfc29dafb3bbd7$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e8dfc29dafb3bbd7$var$ra = /[\-:]([a-z])/g;
function $e8dfc29dafb3bbd7$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e8dfc29dafb3bbd7$var$z.xlinkHref = new $e8dfc29dafb3bbd7$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e8dfc29dafb3bbd7$var$ta(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$z.hasOwnProperty(b) ? $e8dfc29dafb3bbd7$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e8dfc29dafb3bbd7$var$qa(b, c, e, d) && (c = null), d || null === e ? $e8dfc29dafb3bbd7$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e8dfc29dafb3bbd7$var$ua = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e8dfc29dafb3bbd7$var$va = Symbol.for("react.element"), $e8dfc29dafb3bbd7$var$wa = Symbol.for("react.portal"), $e8dfc29dafb3bbd7$var$ya = Symbol.for("react.fragment"), $e8dfc29dafb3bbd7$var$za = Symbol.for("react.strict_mode"), $e8dfc29dafb3bbd7$var$Aa = Symbol.for("react.profiler"), $e8dfc29dafb3bbd7$var$Ba = Symbol.for("react.provider"), $e8dfc29dafb3bbd7$var$Ca = Symbol.for("react.context"), $e8dfc29dafb3bbd7$var$Da = Symbol.for("react.forward_ref"), $e8dfc29dafb3bbd7$var$Ea = Symbol.for("react.suspense"), $e8dfc29dafb3bbd7$var$Fa = Symbol.for("react.suspense_list"), $e8dfc29dafb3bbd7$var$Ga = Symbol.for("react.memo"), $e8dfc29dafb3bbd7$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e8dfc29dafb3bbd7$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e8dfc29dafb3bbd7$var$Ja = Symbol.iterator;
function $e8dfc29dafb3bbd7$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e8dfc29dafb3bbd7$var$Ja && a[$e8dfc29dafb3bbd7$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e8dfc29dafb3bbd7$var$A = Object.assign, $e8dfc29dafb3bbd7$var$La;
function $e8dfc29dafb3bbd7$var$Ma(a) {
    if (void 0 === $e8dfc29dafb3bbd7$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e8dfc29dafb3bbd7$var$La = b && b[1] || "";
    }
    return "\n" + $e8dfc29dafb3bbd7$var$La + a;
}
var $e8dfc29dafb3bbd7$var$Na = !1;
function $e8dfc29dafb3bbd7$var$Oa(a, b) {
    if (!a || $e8dfc29dafb3bbd7$var$Na) return "";
    $e8dfc29dafb3bbd7$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e8dfc29dafb3bbd7$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e8dfc29dafb3bbd7$var$Ma(a) : "";
}
function $e8dfc29dafb3bbd7$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e8dfc29dafb3bbd7$var$Ma(a.type);
        case 16:
            return $e8dfc29dafb3bbd7$var$Ma("Lazy");
        case 13:
            return $e8dfc29dafb3bbd7$var$Ma("Suspense");
        case 19:
            return $e8dfc29dafb3bbd7$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !1), a;
        case 11:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return "Fragment";
        case $e8dfc29dafb3bbd7$var$wa:
            return "Portal";
        case $e8dfc29dafb3bbd7$var$Aa:
            return "Profiler";
        case $e8dfc29dafb3bbd7$var$za:
            return "StrictMode";
        case $e8dfc29dafb3bbd7$var$Ea:
            return "Suspense";
        case $e8dfc29dafb3bbd7$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e8dfc29dafb3bbd7$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e8dfc29dafb3bbd7$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e8dfc29dafb3bbd7$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e8dfc29dafb3bbd7$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e8dfc29dafb3bbd7$var$Qa(a.type) || "Memo";
        case $e8dfc29dafb3bbd7$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e8dfc29dafb3bbd7$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e8dfc29dafb3bbd7$var$Qa(b);
        case 8:
            return b === $e8dfc29dafb3bbd7$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e8dfc29dafb3bbd7$var$Ua(a) {
    var b = $e8dfc29dafb3bbd7$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e8dfc29dafb3bbd7$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e8dfc29dafb3bbd7$var$Ua(a));
}
function $e8dfc29dafb3bbd7$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e8dfc29dafb3bbd7$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e8dfc29dafb3bbd7$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e8dfc29dafb3bbd7$var$Ya(a, b) {
    var c = b.checked;
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e8dfc29dafb3bbd7$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e8dfc29dafb3bbd7$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e8dfc29dafb3bbd7$var$ab(a, b) {
    b = b.checked;
    null != b && $e8dfc29dafb3bbd7$var$ta(a, "checked", b, !1);
}
function $e8dfc29dafb3bbd7$var$bb(a, b) {
    $e8dfc29dafb3bbd7$var$ab(a, b);
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e8dfc29dafb3bbd7$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e8dfc29dafb3bbd7$var$cb(a, b.type, $e8dfc29dafb3bbd7$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e8dfc29dafb3bbd7$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e8dfc29dafb3bbd7$var$cb(a, b, c) {
    if ("number" !== b || $e8dfc29dafb3bbd7$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e8dfc29dafb3bbd7$var$eb = Array.isArray;
function $e8dfc29dafb3bbd7$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e8dfc29dafb3bbd7$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e8dfc29dafb3bbd7$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e8dfc29dafb3bbd7$var$p(91));
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e8dfc29dafb3bbd7$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e8dfc29dafb3bbd7$var$p(92));
            if ($e8dfc29dafb3bbd7$var$eb(c)) {
                if (1 < c.length) throw Error($e8dfc29dafb3bbd7$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e8dfc29dafb3bbd7$var$Sa(c)
    };
}
function $e8dfc29dafb3bbd7$var$ib(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = $e8dfc29dafb3bbd7$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e8dfc29dafb3bbd7$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e8dfc29dafb3bbd7$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e8dfc29dafb3bbd7$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e8dfc29dafb3bbd7$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e8dfc29dafb3bbd7$var$mb, $e8dfc29dafb3bbd7$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e8dfc29dafb3bbd7$var$mb = $e8dfc29dafb3bbd7$var$mb || document.createElement("div");
        $e8dfc29dafb3bbd7$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e8dfc29dafb3bbd7$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e8dfc29dafb3bbd7$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e8dfc29dafb3bbd7$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e8dfc29dafb3bbd7$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e8dfc29dafb3bbd7$var$pb).forEach(function(a) {
    $e8dfc29dafb3bbd7$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e8dfc29dafb3bbd7$var$pb[b] = $e8dfc29dafb3bbd7$var$pb[a];
    });
});
function $e8dfc29dafb3bbd7$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e8dfc29dafb3bbd7$var$pb.hasOwnProperty(a) && $e8dfc29dafb3bbd7$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e8dfc29dafb3bbd7$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e8dfc29dafb3bbd7$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e8dfc29dafb3bbd7$var$tb = $e8dfc29dafb3bbd7$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e8dfc29dafb3bbd7$var$ub(a, b) {
    if (b) {
        if ($e8dfc29dafb3bbd7$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e8dfc29dafb3bbd7$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e8dfc29dafb3bbd7$var$p(62));
    }
}
function $e8dfc29dafb3bbd7$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e8dfc29dafb3bbd7$var$wb = null;
function $e8dfc29dafb3bbd7$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e8dfc29dafb3bbd7$var$yb = null, $e8dfc29dafb3bbd7$var$zb = null, $e8dfc29dafb3bbd7$var$Ab = null;
function $e8dfc29dafb3bbd7$var$Bb(a) {
    if (a = $e8dfc29dafb3bbd7$var$Cb(a)) {
        if ("function" !== typeof $e8dfc29dafb3bbd7$var$yb) throw Error($e8dfc29dafb3bbd7$var$p(280));
        var b = a.stateNode;
        b && (b = $e8dfc29dafb3bbd7$var$Db(b), $e8dfc29dafb3bbd7$var$yb(a.stateNode, a.type, b));
    }
}
function $e8dfc29dafb3bbd7$var$Eb(a) {
    $e8dfc29dafb3bbd7$var$zb ? $e8dfc29dafb3bbd7$var$Ab ? $e8dfc29dafb3bbd7$var$Ab.push(a) : $e8dfc29dafb3bbd7$var$Ab = [
        a
    ] : $e8dfc29dafb3bbd7$var$zb = a;
}
function $e8dfc29dafb3bbd7$var$Fb() {
    if ($e8dfc29dafb3bbd7$var$zb) {
        var a = $e8dfc29dafb3bbd7$var$zb, b = $e8dfc29dafb3bbd7$var$Ab;
        $e8dfc29dafb3bbd7$var$Ab = $e8dfc29dafb3bbd7$var$zb = null;
        $e8dfc29dafb3bbd7$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$Bb(b[a]);
    }
}
function $e8dfc29dafb3bbd7$var$Gb(a, b) {
    return a(b);
}
function $e8dfc29dafb3bbd7$var$Hb() {}
var $e8dfc29dafb3bbd7$var$Ib = !1;
function $e8dfc29dafb3bbd7$var$Jb(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$Ib) return a(b, c);
    $e8dfc29dafb3bbd7$var$Ib = !0;
    try {
        return $e8dfc29dafb3bbd7$var$Gb(a, b, c);
    } finally{
        if ($e8dfc29dafb3bbd7$var$Ib = !1, null !== $e8dfc29dafb3bbd7$var$zb || null !== $e8dfc29dafb3bbd7$var$Ab) $e8dfc29dafb3bbd7$var$Hb(), $e8dfc29dafb3bbd7$var$Fb();
    }
}
function $e8dfc29dafb3bbd7$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e8dfc29dafb3bbd7$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e8dfc29dafb3bbd7$var$p(231, b, typeof c));
    return c;
}
var $e8dfc29dafb3bbd7$var$Lb = !1;
if ($e8dfc29dafb3bbd7$var$ia) try {
    var $e8dfc29dafb3bbd7$var$Mb = {};
    Object.defineProperty($e8dfc29dafb3bbd7$var$Mb, "passive", {
        get: function() {
            $e8dfc29dafb3bbd7$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
    window.removeEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
} catch (a) {
    $e8dfc29dafb3bbd7$var$Lb = !1;
}
function $e8dfc29dafb3bbd7$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e8dfc29dafb3bbd7$var$Ob = !1, $e8dfc29dafb3bbd7$var$Pb = null, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, $e8dfc29dafb3bbd7$var$Sb = {
    onError: function(a) {
        $e8dfc29dafb3bbd7$var$Ob = !0;
        $e8dfc29dafb3bbd7$var$Pb = a;
    }
};
function $e8dfc29dafb3bbd7$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Ob = !1;
    $e8dfc29dafb3bbd7$var$Pb = null;
    $e8dfc29dafb3bbd7$var$Nb.apply($e8dfc29dafb3bbd7$var$Sb, arguments);
}
function $e8dfc29dafb3bbd7$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Tb.apply(this, arguments);
    if ($e8dfc29dafb3bbd7$var$Ob) {
        if ($e8dfc29dafb3bbd7$var$Ob) {
            var l = $e8dfc29dafb3bbd7$var$Pb;
            $e8dfc29dafb3bbd7$var$Ob = !1;
            $e8dfc29dafb3bbd7$var$Pb = null;
        } else throw Error($e8dfc29dafb3bbd7$var$p(198));
        $e8dfc29dafb3bbd7$var$Qb || ($e8dfc29dafb3bbd7$var$Qb = !0, $e8dfc29dafb3bbd7$var$Rb = l);
    }
}
function $e8dfc29dafb3bbd7$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e8dfc29dafb3bbd7$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xb(a) {
    if ($e8dfc29dafb3bbd7$var$Vb(a) !== a) throw Error($e8dfc29dafb3bbd7$var$p(188));
}
function $e8dfc29dafb3bbd7$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e8dfc29dafb3bbd7$var$Vb(a);
        if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e8dfc29dafb3bbd7$var$Xb(e), a;
                if (f === d) return $e8dfc29dafb3bbd7$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e8dfc29dafb3bbd7$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e8dfc29dafb3bbd7$var$p(190));
    }
    if (3 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e8dfc29dafb3bbd7$var$Zb(a) {
    a = $e8dfc29dafb3bbd7$var$Yb(a);
    return null !== a ? $e8dfc29dafb3bbd7$var$$b(a) : null;
}
function $e8dfc29dafb3bbd7$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e8dfc29dafb3bbd7$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$ac = $1c9zD.unstable_scheduleCallback, $e8dfc29dafb3bbd7$var$bc = $1c9zD.unstable_cancelCallback, $e8dfc29dafb3bbd7$var$cc = $1c9zD.unstable_shouldYield, $e8dfc29dafb3bbd7$var$dc = $1c9zD.unstable_requestPaint, $e8dfc29dafb3bbd7$var$B = $1c9zD.unstable_now, $e8dfc29dafb3bbd7$var$ec = $1c9zD.unstable_getCurrentPriorityLevel, $e8dfc29dafb3bbd7$var$fc = $1c9zD.unstable_ImmediatePriority, $e8dfc29dafb3bbd7$var$gc = $1c9zD.unstable_UserBlockingPriority, $e8dfc29dafb3bbd7$var$hc = $1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$ic = $1c9zD.unstable_LowPriority, $e8dfc29dafb3bbd7$var$jc = $1c9zD.unstable_IdlePriority, $e8dfc29dafb3bbd7$var$kc = null, $e8dfc29dafb3bbd7$var$lc = null;
function $e8dfc29dafb3bbd7$var$mc(a) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e8dfc29dafb3bbd7$var$oc = Math.clz32 ? Math.clz32 : $e8dfc29dafb3bbd7$var$nc, $e8dfc29dafb3bbd7$var$pc = Math.log, $e8dfc29dafb3bbd7$var$qc = Math.LN2;
function $e8dfc29dafb3bbd7$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e8dfc29dafb3bbd7$var$pc(a) / $e8dfc29dafb3bbd7$var$qc | 0) | 0;
}
var $e8dfc29dafb3bbd7$var$rc = 64, $e8dfc29dafb3bbd7$var$sc = 4194304;
function $e8dfc29dafb3bbd7$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e8dfc29dafb3bbd7$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e8dfc29dafb3bbd7$var$tc(h) : (f &= g, 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e8dfc29dafb3bbd7$var$tc(g) : 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e8dfc29dafb3bbd7$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e8dfc29dafb3bbd7$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e8dfc29dafb3bbd7$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e8dfc29dafb3bbd7$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e8dfc29dafb3bbd7$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e8dfc29dafb3bbd7$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e8dfc29dafb3bbd7$var$yc() {
    var a = $e8dfc29dafb3bbd7$var$rc;
    $e8dfc29dafb3bbd7$var$rc <<= 1;
    0 === ($e8dfc29dafb3bbd7$var$rc & 4194240) && ($e8dfc29dafb3bbd7$var$rc = 64);
    return a;
}
function $e8dfc29dafb3bbd7$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e8dfc29dafb3bbd7$var$oc(b);
    a[b] = c;
}
function $e8dfc29dafb3bbd7$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e8dfc29dafb3bbd7$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e8dfc29dafb3bbd7$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e8dfc29dafb3bbd7$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e8dfc29dafb3bbd7$var$C = 0;
function $e8dfc29dafb3bbd7$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e8dfc29dafb3bbd7$var$Ec, $e8dfc29dafb3bbd7$var$Fc, $e8dfc29dafb3bbd7$var$Gc, $e8dfc29dafb3bbd7$var$Hc, $e8dfc29dafb3bbd7$var$Ic, $e8dfc29dafb3bbd7$var$Jc = !1, $e8dfc29dafb3bbd7$var$Kc = [], $e8dfc29dafb3bbd7$var$Lc = null, $e8dfc29dafb3bbd7$var$Mc = null, $e8dfc29dafb3bbd7$var$Nc = null, $e8dfc29dafb3bbd7$var$Oc = new Map, $e8dfc29dafb3bbd7$var$Pc = new Map, $e8dfc29dafb3bbd7$var$Qc = [], $e8dfc29dafb3bbd7$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e8dfc29dafb3bbd7$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e8dfc29dafb3bbd7$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e8dfc29dafb3bbd7$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e8dfc29dafb3bbd7$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e8dfc29dafb3bbd7$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e8dfc29dafb3bbd7$var$Pc.delete(b.pointerId);
    }
}
function $e8dfc29dafb3bbd7$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e8dfc29dafb3bbd7$var$Cb(b), null !== b && $e8dfc29dafb3bbd7$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e8dfc29dafb3bbd7$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e8dfc29dafb3bbd7$var$Lc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e8dfc29dafb3bbd7$var$Mc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e8dfc29dafb3bbd7$var$Nc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e8dfc29dafb3bbd7$var$Oc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e8dfc29dafb3bbd7$var$Pc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Vc(a) {
    var b = $e8dfc29dafb3bbd7$var$Wc(a.target);
    if (null !== b) {
        var c = $e8dfc29dafb3bbd7$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e8dfc29dafb3bbd7$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e8dfc29dafb3bbd7$var$Ic(a.priority, function() {
                        $e8dfc29dafb3bbd7$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e8dfc29dafb3bbd7$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e8dfc29dafb3bbd7$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e8dfc29dafb3bbd7$var$wb = d;
            c.target.dispatchEvent(d);
            $e8dfc29dafb3bbd7$var$wb = null;
        } else return b = $e8dfc29dafb3bbd7$var$Cb(c), null !== b && $e8dfc29dafb3bbd7$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Zc(a, b, c) {
    $e8dfc29dafb3bbd7$var$Xc(a) && c.delete(b);
}
function $e8dfc29dafb3bbd7$var$$c() {
    $e8dfc29dafb3bbd7$var$Jc = !1;
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Lc) && ($e8dfc29dafb3bbd7$var$Lc = null);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Mc) && ($e8dfc29dafb3bbd7$var$Mc = null);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Nc) && ($e8dfc29dafb3bbd7$var$Nc = null);
    $e8dfc29dafb3bbd7$var$Oc.forEach($e8dfc29dafb3bbd7$var$Zc);
    $e8dfc29dafb3bbd7$var$Pc.forEach($e8dfc29dafb3bbd7$var$Zc);
}
function $e8dfc29dafb3bbd7$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e8dfc29dafb3bbd7$var$Jc || ($e8dfc29dafb3bbd7$var$Jc = !0, $1c9zD.unstable_scheduleCallback($1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$$c)));
}
function $e8dfc29dafb3bbd7$var$bd(a) {
    function b(b) {
        return $e8dfc29dafb3bbd7$var$ad(b, a);
    }
    if (0 < $e8dfc29dafb3bbd7$var$Kc.length) {
        $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Kc[0], a);
        for(var c = 1; c < $e8dfc29dafb3bbd7$var$Kc.length; c++){
            var d = $e8dfc29dafb3bbd7$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Lc, a);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Mc, a);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Nc, a);
    $e8dfc29dafb3bbd7$var$Oc.forEach(b);
    $e8dfc29dafb3bbd7$var$Pc.forEach(b);
    for(c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length; c++)d = $e8dfc29dafb3bbd7$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e8dfc29dafb3bbd7$var$Qc.length && (c = $e8dfc29dafb3bbd7$var$Qc[0], null === c.blockedOn);)$e8dfc29dafb3bbd7$var$Vc(c), null === c.blockedOn && $e8dfc29dafb3bbd7$var$Qc.shift();
}
var $e8dfc29dafb3bbd7$var$cd = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$dd = !0;
function $e8dfc29dafb3bbd7$var$ed(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$gd(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 4, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$fd(a, b, c, d) {
    if ($e8dfc29dafb3bbd7$var$dd) {
        var e = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
        if (null === e) $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c), $e8dfc29dafb3bbd7$var$Sc(a, d);
        else if ($e8dfc29dafb3bbd7$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e8dfc29dafb3bbd7$var$Sc(a, d), b & 4 && -1 < $e8dfc29dafb3bbd7$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e8dfc29dafb3bbd7$var$Cb(e);
                null !== f && $e8dfc29dafb3bbd7$var$Ec(f);
                f = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
                null === f && $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e8dfc29dafb3bbd7$var$hd(a, b, d, null, c);
    }
}
var $e8dfc29dafb3bbd7$var$id = null;
function $e8dfc29dafb3bbd7$var$Yc(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$id = null;
    a = $e8dfc29dafb3bbd7$var$xb(d);
    a = $e8dfc29dafb3bbd7$var$Wc(a);
    if (null !== a) {
        if (b = $e8dfc29dafb3bbd7$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e8dfc29dafb3bbd7$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e8dfc29dafb3bbd7$var$id = a;
    return null;
}
function $e8dfc29dafb3bbd7$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e8dfc29dafb3bbd7$var$ec()){
                case $e8dfc29dafb3bbd7$var$fc:
                    return 1;
                case $e8dfc29dafb3bbd7$var$gc:
                    return 4;
                case $e8dfc29dafb3bbd7$var$hc:
                case $e8dfc29dafb3bbd7$var$ic:
                    return 16;
                case $e8dfc29dafb3bbd7$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ld = null, $e8dfc29dafb3bbd7$var$md = null;
function $e8dfc29dafb3bbd7$var$nd() {
    if ($e8dfc29dafb3bbd7$var$md) return $e8dfc29dafb3bbd7$var$md;
    var a, b = $e8dfc29dafb3bbd7$var$ld, c = b.length, d, e = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e8dfc29dafb3bbd7$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e8dfc29dafb3bbd7$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e8dfc29dafb3bbd7$var$pd() {
    return !0;
}
function $e8dfc29dafb3bbd7$var$qd() {
    return !1;
}
function $e8dfc29dafb3bbd7$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e8dfc29dafb3bbd7$var$pd : $e8dfc29dafb3bbd7$var$qd;
        this.isPropagationStopped = $e8dfc29dafb3bbd7$var$qd;
        return this;
    }
    $e8dfc29dafb3bbd7$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $e8dfc29dafb3bbd7$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $e8dfc29dafb3bbd7$var$pd);
        },
        persist: function() {},
        isPersistent: $e8dfc29dafb3bbd7$var$pd
    });
    return b;
}
var $e8dfc29dafb3bbd7$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e8dfc29dafb3bbd7$var$td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$sd), $e8dfc29dafb3bbd7$var$ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    view: 0,
    detail: 0
}), $e8dfc29dafb3bbd7$var$vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$ud), $e8dfc29dafb3bbd7$var$wd, $e8dfc29dafb3bbd7$var$xd, $e8dfc29dafb3bbd7$var$yd, $e8dfc29dafb3bbd7$var$Ad = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e8dfc29dafb3bbd7$var$yd && ($e8dfc29dafb3bbd7$var$yd && "mousemove" === a.type ? ($e8dfc29dafb3bbd7$var$wd = a.screenX - $e8dfc29dafb3bbd7$var$yd.screenX, $e8dfc29dafb3bbd7$var$xd = a.screenY - $e8dfc29dafb3bbd7$var$yd.screenY) : $e8dfc29dafb3bbd7$var$xd = $e8dfc29dafb3bbd7$var$wd = 0, $e8dfc29dafb3bbd7$var$yd = a);
        return $e8dfc29dafb3bbd7$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $e8dfc29dafb3bbd7$var$xd;
    }
}), $e8dfc29dafb3bbd7$var$Bd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ad), $e8dfc29dafb3bbd7$var$Cd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    dataTransfer: 0
}), $e8dfc29dafb3bbd7$var$Dd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Cd), $e8dfc29dafb3bbd7$var$Ed = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    relatedTarget: 0
}), $e8dfc29dafb3bbd7$var$Fd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ed), $e8dfc29dafb3bbd7$var$Gd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Hd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Gd), $e8dfc29dafb3bbd7$var$Id = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e8dfc29dafb3bbd7$var$Jd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Id), $e8dfc29dafb3bbd7$var$Kd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    data: 0
}), $e8dfc29dafb3bbd7$var$Ld = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Kd), $e8dfc29dafb3bbd7$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e8dfc29dafb3bbd7$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e8dfc29dafb3bbd7$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e8dfc29dafb3bbd7$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e8dfc29dafb3bbd7$var$Od[a]) ? !!b[a] : !1;
}
function $e8dfc29dafb3bbd7$var$zd() {
    return $e8dfc29dafb3bbd7$var$Pd;
}
var $e8dfc29dafb3bbd7$var$Qd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $e8dfc29dafb3bbd7$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e8dfc29dafb3bbd7$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e8dfc29dafb3bbd7$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e8dfc29dafb3bbd7$var$Rd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Qd), $e8dfc29dafb3bbd7$var$Sd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e8dfc29dafb3bbd7$var$Td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Sd), $e8dfc29dafb3bbd7$var$Ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd
}), $e8dfc29dafb3bbd7$var$Vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ud), $e8dfc29dafb3bbd7$var$Wd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Xd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Wd), $e8dfc29dafb3bbd7$var$Yd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e8dfc29dafb3bbd7$var$Zd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Yd), $e8dfc29dafb3bbd7$var$$d = [
    9,
    13,
    27,
    32
], $e8dfc29dafb3bbd7$var$ae = $e8dfc29dafb3bbd7$var$ia && "CompositionEvent" in window, $e8dfc29dafb3bbd7$var$be = null;
$e8dfc29dafb3bbd7$var$ia && "documentMode" in document && ($e8dfc29dafb3bbd7$var$be = document.documentMode);
var $e8dfc29dafb3bbd7$var$ce = $e8dfc29dafb3bbd7$var$ia && "TextEvent" in window && !$e8dfc29dafb3bbd7$var$be, $e8dfc29dafb3bbd7$var$de = $e8dfc29dafb3bbd7$var$ia && (!$e8dfc29dafb3bbd7$var$ae || $e8dfc29dafb3bbd7$var$be && 8 < $e8dfc29dafb3bbd7$var$be && 11 >= $e8dfc29dafb3bbd7$var$be), $e8dfc29dafb3bbd7$var$ee = String.fromCharCode(32), $e8dfc29dafb3bbd7$var$fe = !1;
function $e8dfc29dafb3bbd7$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e8dfc29dafb3bbd7$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e8dfc29dafb3bbd7$var$ie = !1;
function $e8dfc29dafb3bbd7$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e8dfc29dafb3bbd7$var$fe = !0;
            return $e8dfc29dafb3bbd7$var$ee;
        case "textInput":
            return a = b.data, a === $e8dfc29dafb3bbd7$var$ee && $e8dfc29dafb3bbd7$var$fe ? null : a;
        default:
            return null;
    }
}
function $e8dfc29dafb3bbd7$var$ke(a, b) {
    if ($e8dfc29dafb3bbd7$var$ie) return "compositionend" === a || !$e8dfc29dafb3bbd7$var$ae && $e8dfc29dafb3bbd7$var$ge(a, b) ? (a = $e8dfc29dafb3bbd7$var$nd(), $e8dfc29dafb3bbd7$var$md = $e8dfc29dafb3bbd7$var$ld = $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e8dfc29dafb3bbd7$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e8dfc29dafb3bbd7$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e8dfc29dafb3bbd7$var$ne(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$Eb(d);
    b = $e8dfc29dafb3bbd7$var$oe(b, "onChange");
    0 < b.length && (c = new $e8dfc29dafb3bbd7$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e8dfc29dafb3bbd7$var$pe = null, $e8dfc29dafb3bbd7$var$qe = null;
function $e8dfc29dafb3bbd7$var$re(a) {
    $e8dfc29dafb3bbd7$var$se(a, 0);
}
function $e8dfc29dafb3bbd7$var$te(a) {
    var b = $e8dfc29dafb3bbd7$var$ue(a);
    if ($e8dfc29dafb3bbd7$var$Wa(b)) return a;
}
function $e8dfc29dafb3bbd7$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e8dfc29dafb3bbd7$var$we = !1;
if ($e8dfc29dafb3bbd7$var$ia) {
    var $e8dfc29dafb3bbd7$var$xe;
    if ($e8dfc29dafb3bbd7$var$ia) {
        var $e8dfc29dafb3bbd7$var$ye = "oninput" in document;
        if (!$e8dfc29dafb3bbd7$var$ye) {
            var $e8dfc29dafb3bbd7$var$ze = document.createElement("div");
            $e8dfc29dafb3bbd7$var$ze.setAttribute("oninput", "return;");
            $e8dfc29dafb3bbd7$var$ye = "function" === typeof $e8dfc29dafb3bbd7$var$ze.oninput;
        }
        $e8dfc29dafb3bbd7$var$xe = $e8dfc29dafb3bbd7$var$ye;
    } else $e8dfc29dafb3bbd7$var$xe = !1;
    $e8dfc29dafb3bbd7$var$we = $e8dfc29dafb3bbd7$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e8dfc29dafb3bbd7$var$Ae() {
    $e8dfc29dafb3bbd7$var$pe && ($e8dfc29dafb3bbd7$var$pe.detachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be), $e8dfc29dafb3bbd7$var$qe = $e8dfc29dafb3bbd7$var$pe = null);
}
function $e8dfc29dafb3bbd7$var$Be(a) {
    if ("value" === a.propertyName && $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe)) {
        var b = [];
        $e8dfc29dafb3bbd7$var$ne(b, $e8dfc29dafb3bbd7$var$qe, a, $e8dfc29dafb3bbd7$var$xb(a));
        $e8dfc29dafb3bbd7$var$Jb($e8dfc29dafb3bbd7$var$re, b);
    }
}
function $e8dfc29dafb3bbd7$var$Ce(a, b, c) {
    "focusin" === a ? ($e8dfc29dafb3bbd7$var$Ae(), $e8dfc29dafb3bbd7$var$pe = b, $e8dfc29dafb3bbd7$var$qe = c, $e8dfc29dafb3bbd7$var$pe.attachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be)) : "focusout" === a && $e8dfc29dafb3bbd7$var$Ae();
}
function $e8dfc29dafb3bbd7$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe);
}
function $e8dfc29dafb3bbd7$var$Ee(a, b) {
    if ("click" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e8dfc29dafb3bbd7$var$He = "function" === typeof Object.is ? Object.is : $e8dfc29dafb3bbd7$var$Ge;
function $e8dfc29dafb3bbd7$var$Ie(a, b) {
    if ($e8dfc29dafb3bbd7$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e8dfc29dafb3bbd7$var$ja.call(b, e) || !$e8dfc29dafb3bbd7$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e8dfc29dafb3bbd7$var$Ke(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e8dfc29dafb3bbd7$var$Je(c);
    }
}
function $e8dfc29dafb3bbd7$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e8dfc29dafb3bbd7$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e8dfc29dafb3bbd7$var$Me() {
    for(var a = window, b = $e8dfc29dafb3bbd7$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e8dfc29dafb3bbd7$var$Xa(a.document);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e8dfc29dafb3bbd7$var$Oe(a) {
    var b = $e8dfc29dafb3bbd7$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e8dfc29dafb3bbd7$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e8dfc29dafb3bbd7$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e8dfc29dafb3bbd7$var$Ke(c, f);
                var g = $e8dfc29dafb3bbd7$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e8dfc29dafb3bbd7$var$Pe = $e8dfc29dafb3bbd7$var$ia && "documentMode" in document && 11 >= document.documentMode, $e8dfc29dafb3bbd7$var$Qe = null, $e8dfc29dafb3bbd7$var$Re = null, $e8dfc29dafb3bbd7$var$Se = null, $e8dfc29dafb3bbd7$var$Te = !1;
function $e8dfc29dafb3bbd7$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e8dfc29dafb3bbd7$var$Te || null == $e8dfc29dafb3bbd7$var$Qe || $e8dfc29dafb3bbd7$var$Qe !== $e8dfc29dafb3bbd7$var$Xa(d) || (d = $e8dfc29dafb3bbd7$var$Qe, "selectionStart" in d && $e8dfc29dafb3bbd7$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e8dfc29dafb3bbd7$var$Se && $e8dfc29dafb3bbd7$var$Ie($e8dfc29dafb3bbd7$var$Se, d) || ($e8dfc29dafb3bbd7$var$Se = d, d = $e8dfc29dafb3bbd7$var$oe($e8dfc29dafb3bbd7$var$Re, "onSelect"), 0 < d.length && (b = new $e8dfc29dafb3bbd7$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e8dfc29dafb3bbd7$var$Qe)));
}
function $e8dfc29dafb3bbd7$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e8dfc29dafb3bbd7$var$We = {
    animationend: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationStart"),
    transitionend: $e8dfc29dafb3bbd7$var$Ve("Transition", "TransitionEnd")
}, $e8dfc29dafb3bbd7$var$Xe = {}, $e8dfc29dafb3bbd7$var$Ye = {};
$e8dfc29dafb3bbd7$var$ia && ($e8dfc29dafb3bbd7$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e8dfc29dafb3bbd7$var$We.animationend.animation, delete $e8dfc29dafb3bbd7$var$We.animationiteration.animation, delete $e8dfc29dafb3bbd7$var$We.animationstart.animation), "TransitionEvent" in window || delete $e8dfc29dafb3bbd7$var$We.transitionend.transition);
function $e8dfc29dafb3bbd7$var$Ze(a) {
    if ($e8dfc29dafb3bbd7$var$Xe[a]) return $e8dfc29dafb3bbd7$var$Xe[a];
    if (!$e8dfc29dafb3bbd7$var$We[a]) return a;
    var b = $e8dfc29dafb3bbd7$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e8dfc29dafb3bbd7$var$Ye) return $e8dfc29dafb3bbd7$var$Xe[a] = b[c];
    return a;
}
var $e8dfc29dafb3bbd7$var$$e = $e8dfc29dafb3bbd7$var$Ze("animationend"), $e8dfc29dafb3bbd7$var$af = $e8dfc29dafb3bbd7$var$Ze("animationiteration"), $e8dfc29dafb3bbd7$var$bf = $e8dfc29dafb3bbd7$var$Ze("animationstart"), $e8dfc29dafb3bbd7$var$cf = $e8dfc29dafb3bbd7$var$Ze("transitionend"), $e8dfc29dafb3bbd7$var$df = new Map, $e8dfc29dafb3bbd7$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e8dfc29dafb3bbd7$var$ff(a, b) {
    $e8dfc29dafb3bbd7$var$df.set(a, b);
    $e8dfc29dafb3bbd7$var$fa(b, [
        a
    ]);
}
for(var $e8dfc29dafb3bbd7$var$gf = 0; $e8dfc29dafb3bbd7$var$gf < $e8dfc29dafb3bbd7$var$ef.length; $e8dfc29dafb3bbd7$var$gf++){
    var $e8dfc29dafb3bbd7$var$hf = $e8dfc29dafb3bbd7$var$ef[$e8dfc29dafb3bbd7$var$gf], $e8dfc29dafb3bbd7$var$jf = $e8dfc29dafb3bbd7$var$hf.toLowerCase(), $e8dfc29dafb3bbd7$var$kf = $e8dfc29dafb3bbd7$var$hf[0].toUpperCase() + $e8dfc29dafb3bbd7$var$hf.slice(1);
    $e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$jf, "on" + $e8dfc29dafb3bbd7$var$kf);
}
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$$e, "onAnimationEnd");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$af, "onAnimationIteration");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$bf, "onAnimationStart");
$e8dfc29dafb3bbd7$var$ff("dblclick", "onDoubleClick");
$e8dfc29dafb3bbd7$var$ff("focusin", "onFocus");
$e8dfc29dafb3bbd7$var$ff("focusout", "onBlur");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$cf, "onTransitionEnd");
$e8dfc29dafb3bbd7$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e8dfc29dafb3bbd7$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e8dfc29dafb3bbd7$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e8dfc29dafb3bbd7$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e8dfc29dafb3bbd7$var$lf));
function $e8dfc29dafb3bbd7$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e8dfc29dafb3bbd7$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e8dfc29dafb3bbd7$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e8dfc29dafb3bbd7$var$Qb) throw a = $e8dfc29dafb3bbd7$var$Rb, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, a;
}
function $e8dfc29dafb3bbd7$var$D(a, b) {
    var c = b[$e8dfc29dafb3bbd7$var$of];
    void 0 === c && (c = b[$e8dfc29dafb3bbd7$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e8dfc29dafb3bbd7$var$pf(b, a, 2, !1), c.add(d));
}
function $e8dfc29dafb3bbd7$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e8dfc29dafb3bbd7$var$pf(c, a, d, b);
}
var $e8dfc29dafb3bbd7$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e8dfc29dafb3bbd7$var$sf(a) {
    if (!a[$e8dfc29dafb3bbd7$var$rf]) {
        a[$e8dfc29dafb3bbd7$var$rf] = !0;
        $e8dfc29dafb3bbd7$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e8dfc29dafb3bbd7$var$mf.has(b) || $e8dfc29dafb3bbd7$var$qf(b, !1, a), $e8dfc29dafb3bbd7$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e8dfc29dafb3bbd7$var$rf] || (b[$e8dfc29dafb3bbd7$var$rf] = !0, $e8dfc29dafb3bbd7$var$qf("selectionchange", !1, b));
    }
}
function $e8dfc29dafb3bbd7$var$pf(a, b, c, d) {
    switch($e8dfc29dafb3bbd7$var$jd(b)){
        case 1:
            var e = $e8dfc29dafb3bbd7$var$ed;
            break;
        case 4:
            e = $e8dfc29dafb3bbd7$var$gd;
            break;
        default:
            e = $e8dfc29dafb3bbd7$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e8dfc29dafb3bbd7$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e8dfc29dafb3bbd7$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e8dfc29dafb3bbd7$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e8dfc29dafb3bbd7$var$Jb(function() {
        var d = f, e = $e8dfc29dafb3bbd7$var$xb(c), g = [];
        a: {
            var h = $e8dfc29dafb3bbd7$var$df.get(a);
            if (void 0 !== h) {
                var k = $e8dfc29dafb3bbd7$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e8dfc29dafb3bbd7$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e8dfc29dafb3bbd7$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e8dfc29dafb3bbd7$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e8dfc29dafb3bbd7$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e8dfc29dafb3bbd7$var$Vd;
                        break;
                    case $e8dfc29dafb3bbd7$var$$e:
                    case $e8dfc29dafb3bbd7$var$af:
                    case $e8dfc29dafb3bbd7$var$bf:
                        k = $e8dfc29dafb3bbd7$var$Hd;
                        break;
                    case $e8dfc29dafb3bbd7$var$cf:
                        k = $e8dfc29dafb3bbd7$var$Xd;
                        break;
                    case "scroll":
                        k = $e8dfc29dafb3bbd7$var$vd;
                        break;
                    case "wheel":
                        k = $e8dfc29dafb3bbd7$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e8dfc29dafb3bbd7$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e8dfc29dafb3bbd7$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e8dfc29dafb3bbd7$var$Kb(w, x), null != F && t.push($e8dfc29dafb3bbd7$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e8dfc29dafb3bbd7$var$wb && (n = c.relatedTarget || c.fromElement) && ($e8dfc29dafb3bbd7$var$Wc(n) || n[$e8dfc29dafb3bbd7$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $e8dfc29dafb3bbd7$var$Wc(n) : null, null !== n && (J = $e8dfc29dafb3bbd7$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $e8dfc29dafb3bbd7$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e8dfc29dafb3bbd7$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e8dfc29dafb3bbd7$var$ue(k);
                        u = null == n ? h : $e8dfc29dafb3bbd7$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e8dfc29dafb3bbd7$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e8dfc29dafb3bbd7$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e8dfc29dafb3bbd7$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e8dfc29dafb3bbd7$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e8dfc29dafb3bbd7$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e8dfc29dafb3bbd7$var$vf(t);
                                x = $e8dfc29dafb3bbd7$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e8dfc29dafb3bbd7$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e8dfc29dafb3bbd7$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $e8dfc29dafb3bbd7$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e8dfc29dafb3bbd7$var$ve;
                else if ($e8dfc29dafb3bbd7$var$me(h)) {
                    if ($e8dfc29dafb3bbd7$var$we) na = $e8dfc29dafb3bbd7$var$Fe;
                    else {
                        na = $e8dfc29dafb3bbd7$var$De;
                        var xa = $e8dfc29dafb3bbd7$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e8dfc29dafb3bbd7$var$Ee);
                if (na && (na = na(a, d))) {
                    $e8dfc29dafb3bbd7$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e8dfc29dafb3bbd7$var$cb(h, "number", h.value);
            }
            xa = d ? $e8dfc29dafb3bbd7$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($e8dfc29dafb3bbd7$var$me(xa) || "true" === xa.contentEditable) $e8dfc29dafb3bbd7$var$Qe = xa, $e8dfc29dafb3bbd7$var$Re = d, $e8dfc29dafb3bbd7$var$Se = null;
                    break;
                case "focusout":
                    $e8dfc29dafb3bbd7$var$Se = $e8dfc29dafb3bbd7$var$Re = $e8dfc29dafb3bbd7$var$Qe = null;
                    break;
                case "mousedown":
                    $e8dfc29dafb3bbd7$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e8dfc29dafb3bbd7$var$Te = !1;
                    $e8dfc29dafb3bbd7$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($e8dfc29dafb3bbd7$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e8dfc29dafb3bbd7$var$Ue(g, c, e);
            }
            var $a;
            if ($e8dfc29dafb3bbd7$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e8dfc29dafb3bbd7$var$ie ? $e8dfc29dafb3bbd7$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e8dfc29dafb3bbd7$var$de && "ko" !== c.locale && ($e8dfc29dafb3bbd7$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e8dfc29dafb3bbd7$var$ie && ($a = $e8dfc29dafb3bbd7$var$nd()) : ($e8dfc29dafb3bbd7$var$kd = e, $e8dfc29dafb3bbd7$var$ld = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, $e8dfc29dafb3bbd7$var$ie = !0)), xa = $e8dfc29dafb3bbd7$var$oe(d, ba), 0 < xa.length && (ba = new $e8dfc29dafb3bbd7$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e8dfc29dafb3bbd7$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e8dfc29dafb3bbd7$var$ce ? $e8dfc29dafb3bbd7$var$je(a, c) : $e8dfc29dafb3bbd7$var$ke(a, c)) d = $e8dfc29dafb3bbd7$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $e8dfc29dafb3bbd7$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $e8dfc29dafb3bbd7$var$se(g, b);
    });
}
function $e8dfc29dafb3bbd7$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e8dfc29dafb3bbd7$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e8dfc29dafb3bbd7$var$Kb(a, c), null != f && d.unshift($e8dfc29dafb3bbd7$var$tf(a, f, e)), f = $e8dfc29dafb3bbd7$var$Kb(a, b), null != f && d.push($e8dfc29dafb3bbd7$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e8dfc29dafb3bbd7$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e8dfc29dafb3bbd7$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.unshift($e8dfc29dafb3bbd7$var$tf(c, k, h))) : e || (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.push($e8dfc29dafb3bbd7$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e8dfc29dafb3bbd7$var$xf = /\r\n?/g, $e8dfc29dafb3bbd7$var$yf = /\u0000|\uFFFD/g;
function $e8dfc29dafb3bbd7$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e8dfc29dafb3bbd7$var$xf, "\n").replace($e8dfc29dafb3bbd7$var$yf, "");
}
function $e8dfc29dafb3bbd7$var$Af(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$zf(b);
    if ($e8dfc29dafb3bbd7$var$zf(a) !== b && c) throw Error($e8dfc29dafb3bbd7$var$p(425));
}
function $e8dfc29dafb3bbd7$var$Bf() {}
var $e8dfc29dafb3bbd7$var$Cf = null, $e8dfc29dafb3bbd7$var$Df = null;
function $e8dfc29dafb3bbd7$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e8dfc29dafb3bbd7$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e8dfc29dafb3bbd7$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e8dfc29dafb3bbd7$var$Hf = "function" === typeof Promise ? Promise : void 0, $e8dfc29dafb3bbd7$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e8dfc29dafb3bbd7$var$Hf ? function(a) {
    return $e8dfc29dafb3bbd7$var$Hf.resolve(null).then(a).catch($e8dfc29dafb3bbd7$var$If);
} : $e8dfc29dafb3bbd7$var$Ff;
function $e8dfc29dafb3bbd7$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e8dfc29dafb3bbd7$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e8dfc29dafb3bbd7$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e8dfc29dafb3bbd7$var$bd(b);
}
function $e8dfc29dafb3bbd7$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nf = Math.random().toString(36).slice(2), $e8dfc29dafb3bbd7$var$Of = "__reactFiber$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Pf = "__reactProps$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$uf = "__reactContainer$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$of = "__reactEvents$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Qf = "__reactListeners$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Rf = "__reactHandles$" + $e8dfc29dafb3bbd7$var$Nf;
function $e8dfc29dafb3bbd7$var$Wc(a) {
    var b = a[$e8dfc29dafb3bbd7$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e8dfc29dafb3bbd7$var$uf] || c[$e8dfc29dafb3bbd7$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e8dfc29dafb3bbd7$var$Mf(a); null !== a;){
                if (c = a[$e8dfc29dafb3bbd7$var$Of]) return c;
                a = $e8dfc29dafb3bbd7$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Cb(a) {
    a = a[$e8dfc29dafb3bbd7$var$Of] || a[$e8dfc29dafb3bbd7$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e8dfc29dafb3bbd7$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e8dfc29dafb3bbd7$var$p(33));
}
function $e8dfc29dafb3bbd7$var$Db(a) {
    return a[$e8dfc29dafb3bbd7$var$Pf] || null;
}
var $e8dfc29dafb3bbd7$var$Sf = [], $e8dfc29dafb3bbd7$var$Tf = -1;
function $e8dfc29dafb3bbd7$var$Uf(a) {
    return {
        current: a
    };
}
function $e8dfc29dafb3bbd7$var$E(a) {
    0 > $e8dfc29dafb3bbd7$var$Tf || (a.current = $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf], $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = null, $e8dfc29dafb3bbd7$var$Tf--);
}
function $e8dfc29dafb3bbd7$var$G(a, b) {
    $e8dfc29dafb3bbd7$var$Tf++;
    $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = a.current;
    a.current = b;
}
var $e8dfc29dafb3bbd7$var$Vf = {}, $e8dfc29dafb3bbd7$var$H = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Vf), $e8dfc29dafb3bbd7$var$Wf = $e8dfc29dafb3bbd7$var$Uf(!1), $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$Vf;
function $e8dfc29dafb3bbd7$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e8dfc29dafb3bbd7$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e8dfc29dafb3bbd7$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e8dfc29dafb3bbd7$var$$f() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
}
function $e8dfc29dafb3bbd7$var$ag(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$H.current !== $e8dfc29dafb3bbd7$var$Vf) throw Error($e8dfc29dafb3bbd7$var$p(168));
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
function $e8dfc29dafb3bbd7$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e8dfc29dafb3bbd7$var$p(108, $e8dfc29dafb3bbd7$var$Ra(a) || "Unknown", e));
    return $e8dfc29dafb3bbd7$var$A({}, c, d);
}
function $e8dfc29dafb3bbd7$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e8dfc29dafb3bbd7$var$Vf;
    $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$H.current;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, $e8dfc29dafb3bbd7$var$Wf.current);
    return !0;
}
function $e8dfc29dafb3bbd7$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e8dfc29dafb3bbd7$var$p(169));
    c ? (a = $e8dfc29dafb3bbd7$var$bg(a, b, $e8dfc29dafb3bbd7$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a)) : $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
var $e8dfc29dafb3bbd7$var$eg = null, $e8dfc29dafb3bbd7$var$fg = !1, $e8dfc29dafb3bbd7$var$gg = !1;
function $e8dfc29dafb3bbd7$var$hg(a) {
    null === $e8dfc29dafb3bbd7$var$eg ? $e8dfc29dafb3bbd7$var$eg = [
        a
    ] : $e8dfc29dafb3bbd7$var$eg.push(a);
}
function $e8dfc29dafb3bbd7$var$ig(a) {
    $e8dfc29dafb3bbd7$var$fg = !0;
    $e8dfc29dafb3bbd7$var$hg(a);
}
function $e8dfc29dafb3bbd7$var$jg() {
    if (!$e8dfc29dafb3bbd7$var$gg && null !== $e8dfc29dafb3bbd7$var$eg) {
        $e8dfc29dafb3bbd7$var$gg = !0;
        var a = 0, b = $e8dfc29dafb3bbd7$var$C;
        try {
            var c = $e8dfc29dafb3bbd7$var$eg;
            for($e8dfc29dafb3bbd7$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e8dfc29dafb3bbd7$var$eg = null;
            $e8dfc29dafb3bbd7$var$fg = !1;
        } catch (e) {
            throw null !== $e8dfc29dafb3bbd7$var$eg && ($e8dfc29dafb3bbd7$var$eg = $e8dfc29dafb3bbd7$var$eg.slice(a + 1)), $e8dfc29dafb3bbd7$var$ac($e8dfc29dafb3bbd7$var$fc, $e8dfc29dafb3bbd7$var$jg), e;
        } finally{
            $e8dfc29dafb3bbd7$var$C = b, $e8dfc29dafb3bbd7$var$gg = !1;
        }
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$kg = [], $e8dfc29dafb3bbd7$var$lg = 0, $e8dfc29dafb3bbd7$var$mg = null, $e8dfc29dafb3bbd7$var$ng = 0, $e8dfc29dafb3bbd7$var$og = [], $e8dfc29dafb3bbd7$var$pg = 0, $e8dfc29dafb3bbd7$var$qg = null, $e8dfc29dafb3bbd7$var$rg = 1, $e8dfc29dafb3bbd7$var$sg = "";
function $e8dfc29dafb3bbd7$var$tg(a, b) {
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$ng;
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$mg;
    $e8dfc29dafb3bbd7$var$mg = a;
    $e8dfc29dafb3bbd7$var$ng = b;
}
function $e8dfc29dafb3bbd7$var$ug(a, b, c) {
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg;
    $e8dfc29dafb3bbd7$var$qg = a;
    var d = $e8dfc29dafb3bbd7$var$rg;
    a = $e8dfc29dafb3bbd7$var$sg;
    var e = 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e8dfc29dafb3bbd7$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e8dfc29dafb3bbd7$var$rg = 1 << 32 - $e8dfc29dafb3bbd7$var$oc(b) + e | c << e | d;
        $e8dfc29dafb3bbd7$var$sg = f + a;
    } else $e8dfc29dafb3bbd7$var$rg = 1 << f | c << e | d, $e8dfc29dafb3bbd7$var$sg = a;
}
function $e8dfc29dafb3bbd7$var$vg(a) {
    null !== a.return && ($e8dfc29dafb3bbd7$var$tg(a, 1), $e8dfc29dafb3bbd7$var$ug(a, 1, 0));
}
function $e8dfc29dafb3bbd7$var$wg(a) {
    for(; a === $e8dfc29dafb3bbd7$var$mg;)$e8dfc29dafb3bbd7$var$mg = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null, $e8dfc29dafb3bbd7$var$ng = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null;
    for(; a === $e8dfc29dafb3bbd7$var$qg;)$e8dfc29dafb3bbd7$var$qg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$sg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$rg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null;
}
var $e8dfc29dafb3bbd7$var$xg = null, $e8dfc29dafb3bbd7$var$yg = null, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$zg = null;
function $e8dfc29dafb3bbd7$var$Ag(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e8dfc29dafb3bbd7$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e8dfc29dafb3bbd7$var$qg ? {
                id: $e8dfc29dafb3bbd7$var$rg,
                overflow: $e8dfc29dafb3bbd7$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e8dfc29dafb3bbd7$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e8dfc29dafb3bbd7$var$Eg(a) {
    if ($e8dfc29dafb3bbd7$var$I) {
        var b = $e8dfc29dafb3bbd7$var$yg;
        if (b) {
            var c = b;
            if (!$e8dfc29dafb3bbd7$var$Cg(a, b)) {
                if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
                b = $e8dfc29dafb3bbd7$var$Lf(c.nextSibling);
                var d = $e8dfc29dafb3bbd7$var$xg;
                b && $e8dfc29dafb3bbd7$var$Cg(a, b) ? $e8dfc29dafb3bbd7$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$xg = a);
            }
        } else {
            if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e8dfc29dafb3bbd7$var$I = !1;
            $e8dfc29dafb3bbd7$var$xg = a;
        }
    }
}
function $e8dfc29dafb3bbd7$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e8dfc29dafb3bbd7$var$xg = a;
}
function $e8dfc29dafb3bbd7$var$Gg(a) {
    if (a !== $e8dfc29dafb3bbd7$var$xg) return !1;
    if (!$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$Fg(a), $e8dfc29dafb3bbd7$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e8dfc29dafb3bbd7$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e8dfc29dafb3bbd7$var$yg)) {
        if ($e8dfc29dafb3bbd7$var$Dg(a)) throw $e8dfc29dafb3bbd7$var$Hg(), Error($e8dfc29dafb3bbd7$var$p(418));
        for(; b;)$e8dfc29dafb3bbd7$var$Ag(a, b), b = $e8dfc29dafb3bbd7$var$Lf(b.nextSibling);
    }
    $e8dfc29dafb3bbd7$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e8dfc29dafb3bbd7$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e8dfc29dafb3bbd7$var$yg = null;
        }
    } else $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg ? $e8dfc29dafb3bbd7$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Hg() {
    for(var a = $e8dfc29dafb3bbd7$var$yg; a;)a = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
}
function $e8dfc29dafb3bbd7$var$Ig() {
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg = null;
    $e8dfc29dafb3bbd7$var$I = !1;
}
function $e8dfc29dafb3bbd7$var$Jg(a) {
    null === $e8dfc29dafb3bbd7$var$zg ? $e8dfc29dafb3bbd7$var$zg = [
        a
    ] : $e8dfc29dafb3bbd7$var$zg.push(a);
}
var $e8dfc29dafb3bbd7$var$Kg = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig;
function $e8dfc29dafb3bbd7$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $e8dfc29dafb3bbd7$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$Mg = $e8dfc29dafb3bbd7$var$Uf(null), $e8dfc29dafb3bbd7$var$Ng = null, $e8dfc29dafb3bbd7$var$Og = null, $e8dfc29dafb3bbd7$var$Pg = null;
function $e8dfc29dafb3bbd7$var$Qg() {
    $e8dfc29dafb3bbd7$var$Pg = $e8dfc29dafb3bbd7$var$Og = $e8dfc29dafb3bbd7$var$Ng = null;
}
function $e8dfc29dafb3bbd7$var$Rg(a) {
    var b = $e8dfc29dafb3bbd7$var$Mg.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Mg);
    a._currentValue = b;
}
function $e8dfc29dafb3bbd7$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e8dfc29dafb3bbd7$var$Tg(a, b) {
    $e8dfc29dafb3bbd7$var$Ng = a;
    $e8dfc29dafb3bbd7$var$Pg = $e8dfc29dafb3bbd7$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e8dfc29dafb3bbd7$var$Ug = !0), a.firstContext = null);
}
function $e8dfc29dafb3bbd7$var$Vg(a) {
    var b = a._currentValue;
    if ($e8dfc29dafb3bbd7$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e8dfc29dafb3bbd7$var$Og) {
            if (null === $e8dfc29dafb3bbd7$var$Ng) throw Error($e8dfc29dafb3bbd7$var$p(308));
            $e8dfc29dafb3bbd7$var$Og = a;
            $e8dfc29dafb3bbd7$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e8dfc29dafb3bbd7$var$Og = $e8dfc29dafb3bbd7$var$Og.next = a;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$Wg = null;
function $e8dfc29dafb3bbd7$var$Xg(a) {
    null === $e8dfc29dafb3bbd7$var$Wg ? $e8dfc29dafb3bbd7$var$Wg = [
        a
    ] : $e8dfc29dafb3bbd7$var$Wg.push(a);
}
function $e8dfc29dafb3bbd7$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e8dfc29dafb3bbd7$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e8dfc29dafb3bbd7$var$Zg(a, d);
}
function $e8dfc29dafb3bbd7$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e8dfc29dafb3bbd7$var$$g = !1;
function $e8dfc29dafb3bbd7$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e8dfc29dafb3bbd7$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e8dfc29dafb3bbd7$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e8dfc29dafb3bbd7$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e8dfc29dafb3bbd7$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e8dfc29dafb3bbd7$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e8dfc29dafb3bbd7$var$Zg(a, c);
}
function $e8dfc29dafb3bbd7$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
function $e8dfc29dafb3bbd7$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e8dfc29dafb3bbd7$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $e8dfc29dafb3bbd7$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e8dfc29dafb3bbd7$var$A({}, q, r);
                            break a;
                        case 2:
                            $e8dfc29dafb3bbd7$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e8dfc29dafb3bbd7$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e8dfc29dafb3bbd7$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e8dfc29dafb3bbd7$var$p(191, e));
            e.call(d);
        }
    }
}
var $e8dfc29dafb3bbd7$var$jh = (new $6cds3.Component).refs;
function $e8dfc29dafb3bbd7$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e8dfc29dafb3bbd7$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e8dfc29dafb3bbd7$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $e8dfc29dafb3bbd7$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$L(), e = $e8dfc29dafb3bbd7$var$lh(a), f = $e8dfc29dafb3bbd7$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$dh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, e, d), $e8dfc29dafb3bbd7$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$L(), e = $e8dfc29dafb3bbd7$var$lh(a), f = $e8dfc29dafb3bbd7$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$dh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, e, d), $e8dfc29dafb3bbd7$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $e8dfc29dafb3bbd7$var$L(), d = $e8dfc29dafb3bbd7$var$lh(a), e = $e8dfc29dafb3bbd7$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e8dfc29dafb3bbd7$var$dh(a, e, d);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, d, c), $e8dfc29dafb3bbd7$var$eh(b, a, d));
    }
};
function $e8dfc29dafb3bbd7$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e8dfc29dafb3bbd7$var$Ie(c, d) || !$e8dfc29dafb3bbd7$var$Ie(e, f) : !0;
}
function $e8dfc29dafb3bbd7$var$ph(a, b, c) {
    var d = !1, e = $e8dfc29dafb3bbd7$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e8dfc29dafb3bbd7$var$Vg(f) : (e = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e8dfc29dafb3bbd7$var$Yf(a, e) : $e8dfc29dafb3bbd7$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e8dfc29dafb3bbd7$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e8dfc29dafb3bbd7$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e8dfc29dafb3bbd7$var$nh.enqueueReplaceState(b, b.state, null);
}
function $e8dfc29dafb3bbd7$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $e8dfc29dafb3bbd7$var$jh;
    $e8dfc29dafb3bbd7$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e8dfc29dafb3bbd7$var$Vg(f) : (f = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, e.context = $e8dfc29dafb3bbd7$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e8dfc29dafb3bbd7$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e8dfc29dafb3bbd7$var$nh.enqueueReplaceState(e, e.state, null), $e8dfc29dafb3bbd7$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e8dfc29dafb3bbd7$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e8dfc29dafb3bbd7$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $e8dfc29dafb3bbd7$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e8dfc29dafb3bbd7$var$p(284));
        if (!c._owner) throw Error($e8dfc29dafb3bbd7$var$p(290, a));
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e8dfc29dafb3bbd7$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e8dfc29dafb3bbd7$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $e8dfc29dafb3bbd7$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $e8dfc29dafb3bbd7$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e8dfc29dafb3bbd7$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $e8dfc29dafb3bbd7$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $e8dfc29dafb3bbd7$var$sh(a, b, c), d.return = a, d;
        d = $e8dfc29dafb3bbd7$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e8dfc29dafb3bbd7$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e8dfc29dafb3bbd7$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e8dfc29dafb3bbd7$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e8dfc29dafb3bbd7$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c = $e8dfc29dafb3bbd7$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $e8dfc29dafb3bbd7$var$sh(a, null, b), c.return = a, c;
                case $e8dfc29dafb3bbd7$var$wa:
                    return b = $e8dfc29dafb3bbd7$var$zh(b, a.mode, c), b.return = a, b;
                case $e8dfc29dafb3bbd7$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e8dfc29dafb3bbd7$var$eb(b) || $e8dfc29dafb3bbd7$var$Ka(b)) return b = $e8dfc29dafb3bbd7$var$Ah(b, a.mode, c, null), b.return = a, b;
            $e8dfc29dafb3bbd7$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e8dfc29dafb3bbd7$var$eb(c) || $e8dfc29dafb3bbd7$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e8dfc29dafb3bbd7$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e8dfc29dafb3bbd7$var$eb(d) || $e8dfc29dafb3bbd7$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e8dfc29dafb3bbd7$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $e8dfc29dafb3bbd7$var$Ka(h);
        if ("function" !== typeof l) throw Error($e8dfc29dafb3bbd7$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e8dfc29dafb3bbd7$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e8dfc29dafb3bbd7$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e8dfc29dafb3bbd7$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e8dfc29dafb3bbd7$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e8dfc29dafb3bbd7$var$ya ? (d = $e8dfc29dafb3bbd7$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e8dfc29dafb3bbd7$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $e8dfc29dafb3bbd7$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e8dfc29dafb3bbd7$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e8dfc29dafb3bbd7$var$eb(f)) return n(a, d, f, h);
            if ($e8dfc29dafb3bbd7$var$Ka(f)) return t(a, d, f, h);
            $e8dfc29dafb3bbd7$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e8dfc29dafb3bbd7$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e8dfc29dafb3bbd7$var$Bh = $e8dfc29dafb3bbd7$var$vh(!0), $e8dfc29dafb3bbd7$var$Ch = $e8dfc29dafb3bbd7$var$vh(!1), $e8dfc29dafb3bbd7$var$Dh = {}, $e8dfc29dafb3bbd7$var$Eh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh), $e8dfc29dafb3bbd7$var$Fh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh), $e8dfc29dafb3bbd7$var$Gh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh);
function $e8dfc29dafb3bbd7$var$Hh(a) {
    if (a === $e8dfc29dafb3bbd7$var$Dh) throw Error($e8dfc29dafb3bbd7$var$p(174));
    return a;
}
function $e8dfc29dafb3bbd7$var$Ih(a, b) {
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Gh, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Fh, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, $e8dfc29dafb3bbd7$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e8dfc29dafb3bbd7$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e8dfc29dafb3bbd7$var$lb(b, a);
    }
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, b);
}
function $e8dfc29dafb3bbd7$var$Jh() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Fh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Gh);
}
function $e8dfc29dafb3bbd7$var$Kh(a) {
    $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
    var b = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
    var c = $e8dfc29dafb3bbd7$var$lb(b, a.type);
    b !== c && ($e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Fh, a), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, c));
}
function $e8dfc29dafb3bbd7$var$Lh(a) {
    $e8dfc29dafb3bbd7$var$Fh.current === a && ($e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Fh));
}
var $e8dfc29dafb3bbd7$var$M = $e8dfc29dafb3bbd7$var$Uf(0);
function $e8dfc29dafb3bbd7$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nh = [];
function $e8dfc29dafb3bbd7$var$Oh() {
    for(var a = 0; a < $e8dfc29dafb3bbd7$var$Nh.length; a++)$e8dfc29dafb3bbd7$var$Nh[a]._workInProgressVersionPrimary = null;
    $e8dfc29dafb3bbd7$var$Nh.length = 0;
}
var $e8dfc29dafb3bbd7$var$Ph = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$Qh = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$Rh = 0, $e8dfc29dafb3bbd7$var$N = null, $e8dfc29dafb3bbd7$var$O = null, $e8dfc29dafb3bbd7$var$P = null, $e8dfc29dafb3bbd7$var$Sh = !1, $e8dfc29dafb3bbd7$var$Th = !1, $e8dfc29dafb3bbd7$var$Uh = 0, $e8dfc29dafb3bbd7$var$Vh = 0;
function $e8dfc29dafb3bbd7$var$Q() {
    throw Error($e8dfc29dafb3bbd7$var$p(321));
}
function $e8dfc29dafb3bbd7$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e8dfc29dafb3bbd7$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$Rh = f;
    $e8dfc29dafb3bbd7$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e8dfc29dafb3bbd7$var$Ph.current = null === a || null === a.memoizedState ? $e8dfc29dafb3bbd7$var$Yh : $e8dfc29dafb3bbd7$var$Zh;
    a = c(d, e);
    if ($e8dfc29dafb3bbd7$var$Th) {
        f = 0;
        do {
            $e8dfc29dafb3bbd7$var$Th = !1;
            $e8dfc29dafb3bbd7$var$Uh = 0;
            if (25 <= f) throw Error($e8dfc29dafb3bbd7$var$p(301));
            f += 1;
            $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = null;
            b.updateQueue = null;
            $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$$h;
            a = c(d, e);
        }while ($e8dfc29dafb3bbd7$var$Th);
    }
    $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$ai;
    b = null !== $e8dfc29dafb3bbd7$var$O && null !== $e8dfc29dafb3bbd7$var$O.next;
    $e8dfc29dafb3bbd7$var$Rh = 0;
    $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
    $e8dfc29dafb3bbd7$var$Sh = !1;
    if (b) throw Error($e8dfc29dafb3bbd7$var$p(300));
    return a;
}
function $e8dfc29dafb3bbd7$var$bi() {
    var a = 0 !== $e8dfc29dafb3bbd7$var$Uh;
    $e8dfc29dafb3bbd7$var$Uh = 0;
    return a;
}
function $e8dfc29dafb3bbd7$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState = $e8dfc29dafb3bbd7$var$P = a : $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$P.next = a;
    return $e8dfc29dafb3bbd7$var$P;
}
function $e8dfc29dafb3bbd7$var$di() {
    if (null === $e8dfc29dafb3bbd7$var$O) {
        var a = $e8dfc29dafb3bbd7$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e8dfc29dafb3bbd7$var$O.next;
    var b = null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState : $e8dfc29dafb3bbd7$var$P.next;
    if (null !== b) $e8dfc29dafb3bbd7$var$P = b, $e8dfc29dafb3bbd7$var$O = a;
    else {
        if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(310));
        $e8dfc29dafb3bbd7$var$O = a;
        a = {
            memoizedState: $e8dfc29dafb3bbd7$var$O.memoizedState,
            baseState: $e8dfc29dafb3bbd7$var$O.baseState,
            baseQueue: $e8dfc29dafb3bbd7$var$O.baseQueue,
            queue: $e8dfc29dafb3bbd7$var$O.queue,
            next: null
        };
        null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState = $e8dfc29dafb3bbd7$var$P = a : $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$P.next = a;
    }
    return $e8dfc29dafb3bbd7$var$P;
}
function $e8dfc29dafb3bbd7$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e8dfc29dafb3bbd7$var$fi(a) {
    var b = $e8dfc29dafb3bbd7$var$di(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e8dfc29dafb3bbd7$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e8dfc29dafb3bbd7$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e8dfc29dafb3bbd7$var$N.lanes |= m;
                $e8dfc29dafb3bbd7$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e8dfc29dafb3bbd7$var$He(d, b.memoizedState) || ($e8dfc29dafb3bbd7$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e8dfc29dafb3bbd7$var$N.lanes |= f, $e8dfc29dafb3bbd7$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e8dfc29dafb3bbd7$var$gi(a) {
    var b = $e8dfc29dafb3bbd7$var$di(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e8dfc29dafb3bbd7$var$He(f, b.memoizedState) || ($e8dfc29dafb3bbd7$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e8dfc29dafb3bbd7$var$hi() {}
function $e8dfc29dafb3bbd7$var$ii(a, b) {
    var c = $e8dfc29dafb3bbd7$var$N, d = $e8dfc29dafb3bbd7$var$di(), e = b(), f = !$e8dfc29dafb3bbd7$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e8dfc29dafb3bbd7$var$Ug = !0);
    d = d.queue;
    $e8dfc29dafb3bbd7$var$ji($e8dfc29dafb3bbd7$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e8dfc29dafb3bbd7$var$P && $e8dfc29dafb3bbd7$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e8dfc29dafb3bbd7$var$li(9, $e8dfc29dafb3bbd7$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $e8dfc29dafb3bbd7$var$R) throw Error($e8dfc29dafb3bbd7$var$p(349));
        0 !== ($e8dfc29dafb3bbd7$var$Rh & 30) || $e8dfc29dafb3bbd7$var$ni(c, b, e);
    }
    return e;
}
function $e8dfc29dafb3bbd7$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e8dfc29dafb3bbd7$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e8dfc29dafb3bbd7$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e8dfc29dafb3bbd7$var$oi(b) && $e8dfc29dafb3bbd7$var$pi(a);
}
function $e8dfc29dafb3bbd7$var$ki(a, b, c) {
    return c(function() {
        $e8dfc29dafb3bbd7$var$oi(b) && $e8dfc29dafb3bbd7$var$pi(a);
    });
}
function $e8dfc29dafb3bbd7$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e8dfc29dafb3bbd7$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e8dfc29dafb3bbd7$var$pi(a) {
    var b = $e8dfc29dafb3bbd7$var$Zg(a, 1);
    null !== b && $e8dfc29dafb3bbd7$var$mh(b, a, 1, -1);
}
function $e8dfc29dafb3bbd7$var$qi(a) {
    var b = $e8dfc29dafb3bbd7$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e8dfc29dafb3bbd7$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e8dfc29dafb3bbd7$var$ri.bind(null, $e8dfc29dafb3bbd7$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e8dfc29dafb3bbd7$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e8dfc29dafb3bbd7$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e8dfc29dafb3bbd7$var$si() {
    return $e8dfc29dafb3bbd7$var$di().memoizedState;
}
function $e8dfc29dafb3bbd7$var$ti(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$ci();
    $e8dfc29dafb3bbd7$var$N.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e8dfc29dafb3bbd7$var$ui(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e8dfc29dafb3bbd7$var$O) {
        var g = $e8dfc29dafb3bbd7$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $e8dfc29dafb3bbd7$var$Wh(d, g.deps)) {
            e.memoizedState = $e8dfc29dafb3bbd7$var$li(b, c, f, d);
            return;
        }
    }
    $e8dfc29dafb3bbd7$var$N.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$li(1 | b, c, f, d);
}
function $e8dfc29dafb3bbd7$var$vi(a, b) {
    return $e8dfc29dafb3bbd7$var$ti(8390656, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$ji(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(2048, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$wi(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(4, 2, a, b);
}
function $e8dfc29dafb3bbd7$var$xi(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(4, 4, a, b);
}
function $e8dfc29dafb3bbd7$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e8dfc29dafb3bbd7$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e8dfc29dafb3bbd7$var$ui(4, 4, $e8dfc29dafb3bbd7$var$yi.bind(null, b, a), c);
}
function $e8dfc29dafb3bbd7$var$Ai() {}
function $e8dfc29dafb3bbd7$var$Bi(a, b) {
    var c = $e8dfc29dafb3bbd7$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$Ci(a, b) {
    var c = $e8dfc29dafb3bbd7$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$Di(a, b, c) {
    if (0 === ($e8dfc29dafb3bbd7$var$Rh & 21)) return a.baseState && (a.baseState = !1, $e8dfc29dafb3bbd7$var$Ug = !0), a.memoizedState = c;
    $e8dfc29dafb3bbd7$var$He(c, b) || (c = $e8dfc29dafb3bbd7$var$yc(), $e8dfc29dafb3bbd7$var$N.lanes |= c, $e8dfc29dafb3bbd7$var$hh |= c, a.baseState = !0);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ei(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    $e8dfc29dafb3bbd7$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e8dfc29dafb3bbd7$var$Qh.transition;
    $e8dfc29dafb3bbd7$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$Qh.transition = d;
    }
}
function $e8dfc29dafb3bbd7$var$Fi() {
    return $e8dfc29dafb3bbd7$var$di().memoizedState;
}
function $e8dfc29dafb3bbd7$var$Gi(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$Hi(a)) $e8dfc29dafb3bbd7$var$Ii(b, c);
    else if (c = $e8dfc29dafb3bbd7$var$Yg(a, b, c, d), null !== c) {
        var e = $e8dfc29dafb3bbd7$var$L();
        $e8dfc29dafb3bbd7$var$mh(c, a, d, e);
        $e8dfc29dafb3bbd7$var$Ji(c, b, d);
    }
}
function $e8dfc29dafb3bbd7$var$ri(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$Hi(a)) $e8dfc29dafb3bbd7$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e8dfc29dafb3bbd7$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e8dfc29dafb3bbd7$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e8dfc29dafb3bbd7$var$Yg(a, b, e, d);
        null !== c && (e = $e8dfc29dafb3bbd7$var$L(), $e8dfc29dafb3bbd7$var$mh(c, a, d, e), $e8dfc29dafb3bbd7$var$Ji(c, b, d));
    }
}
function $e8dfc29dafb3bbd7$var$Hi(a) {
    var b = a.alternate;
    return a === $e8dfc29dafb3bbd7$var$N || null !== b && b === $e8dfc29dafb3bbd7$var$N;
}
function $e8dfc29dafb3bbd7$var$Ii(a, b) {
    $e8dfc29dafb3bbd7$var$Th = $e8dfc29dafb3bbd7$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e8dfc29dafb3bbd7$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
var $e8dfc29dafb3bbd7$var$ai = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Q,
    useContext: $e8dfc29dafb3bbd7$var$Q,
    useEffect: $e8dfc29dafb3bbd7$var$Q,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$Q,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$Q,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$Q,
    useMemo: $e8dfc29dafb3bbd7$var$Q,
    useReducer: $e8dfc29dafb3bbd7$var$Q,
    useRef: $e8dfc29dafb3bbd7$var$Q,
    useState: $e8dfc29dafb3bbd7$var$Q,
    useDebugValue: $e8dfc29dafb3bbd7$var$Q,
    useDeferredValue: $e8dfc29dafb3bbd7$var$Q,
    useTransition: $e8dfc29dafb3bbd7$var$Q,
    useMutableSource: $e8dfc29dafb3bbd7$var$Q,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$Q,
    useId: $e8dfc29dafb3bbd7$var$Q,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Yh = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: function(a, b) {
        $e8dfc29dafb3bbd7$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e8dfc29dafb3bbd7$var$ti(4194308, 4, $e8dfc29dafb3bbd7$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $e8dfc29dafb3bbd7$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $e8dfc29dafb3bbd7$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $e8dfc29dafb3bbd7$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e8dfc29dafb3bbd7$var$Gi.bind(null, $e8dfc29dafb3bbd7$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $e8dfc29dafb3bbd7$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e8dfc29dafb3bbd7$var$qi,
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function(a) {
        return $e8dfc29dafb3bbd7$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$qi(!1), b = a[0];
        a = $e8dfc29dafb3bbd7$var$Ei.bind(null, a[1]);
        $e8dfc29dafb3bbd7$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$N, e = $e8dfc29dafb3bbd7$var$ci();
        if ($e8dfc29dafb3bbd7$var$I) {
            if (void 0 === c) throw Error($e8dfc29dafb3bbd7$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e8dfc29dafb3bbd7$var$R) throw Error($e8dfc29dafb3bbd7$var$p(349));
            0 !== ($e8dfc29dafb3bbd7$var$Rh & 30) || $e8dfc29dafb3bbd7$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e8dfc29dafb3bbd7$var$vi($e8dfc29dafb3bbd7$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e8dfc29dafb3bbd7$var$li(9, $e8dfc29dafb3bbd7$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $e8dfc29dafb3bbd7$var$ci(), b = $e8dfc29dafb3bbd7$var$R.identifierPrefix;
        if ($e8dfc29dafb3bbd7$var$I) {
            var c = $e8dfc29dafb3bbd7$var$sg;
            var d = $e8dfc29dafb3bbd7$var$rg;
            c = (d & ~(1 << 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e8dfc29dafb3bbd7$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e8dfc29dafb3bbd7$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Zh = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Bi,
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$ji,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$zi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$wi,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$xi,
    useMemo: $e8dfc29dafb3bbd7$var$Ci,
    useReducer: $e8dfc29dafb3bbd7$var$fi,
    useRef: $e8dfc29dafb3bbd7$var$si,
    useState: function() {
        return $e8dfc29dafb3bbd7$var$fi($e8dfc29dafb3bbd7$var$ei);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function(a) {
        var b = $e8dfc29dafb3bbd7$var$di();
        return $e8dfc29dafb3bbd7$var$Di(b, $e8dfc29dafb3bbd7$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$fi($e8dfc29dafb3bbd7$var$ei)[0], b = $e8dfc29dafb3bbd7$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$hi,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$ii,
    useId: $e8dfc29dafb3bbd7$var$Fi,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$$h = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Bi,
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$ji,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$zi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$wi,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$xi,
    useMemo: $e8dfc29dafb3bbd7$var$Ci,
    useReducer: $e8dfc29dafb3bbd7$var$gi,
    useRef: $e8dfc29dafb3bbd7$var$si,
    useState: function() {
        return $e8dfc29dafb3bbd7$var$gi($e8dfc29dafb3bbd7$var$ei);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function(a) {
        var b = $e8dfc29dafb3bbd7$var$di();
        return null === $e8dfc29dafb3bbd7$var$O ? b.memoizedState = a : $e8dfc29dafb3bbd7$var$Di(b, $e8dfc29dafb3bbd7$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$gi($e8dfc29dafb3bbd7$var$ei)[0], b = $e8dfc29dafb3bbd7$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$hi,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$ii,
    useId: $e8dfc29dafb3bbd7$var$Fi,
    unstable_isNewReconciler: !1
};
function $e8dfc29dafb3bbd7$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $e8dfc29dafb3bbd7$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e8dfc29dafb3bbd7$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e8dfc29dafb3bbd7$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e8dfc29dafb3bbd7$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $e8dfc29dafb3bbd7$var$Oi(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e8dfc29dafb3bbd7$var$Pi || ($e8dfc29dafb3bbd7$var$Pi = !0, $e8dfc29dafb3bbd7$var$Qi = d);
        $e8dfc29dafb3bbd7$var$Mi(a, b);
    };
    return c;
}
function $e8dfc29dafb3bbd7$var$Ri(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e8dfc29dafb3bbd7$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e8dfc29dafb3bbd7$var$Mi(a, b);
        "function" !== typeof d && (null === $e8dfc29dafb3bbd7$var$Si ? $e8dfc29dafb3bbd7$var$Si = new Set([
            this
        ]) : $e8dfc29dafb3bbd7$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $e8dfc29dafb3bbd7$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e8dfc29dafb3bbd7$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e8dfc29dafb3bbd7$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $e8dfc29dafb3bbd7$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e8dfc29dafb3bbd7$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e8dfc29dafb3bbd7$var$ch(-1, 1), b.tag = 2, $e8dfc29dafb3bbd7$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e8dfc29dafb3bbd7$var$Xi = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$Ug = !1;
function $e8dfc29dafb3bbd7$var$Yi(a, b, c, d) {
    b.child = null === a ? $e8dfc29dafb3bbd7$var$Ch(b, null, c, d) : $e8dfc29dafb3bbd7$var$Bh(b, a.child, c, d);
}
function $e8dfc29dafb3bbd7$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    d = $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, f, e);
    c = $e8dfc29dafb3bbd7$var$bi();
    if (null !== a && !$e8dfc29dafb3bbd7$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$$i(a, b, e);
    $e8dfc29dafb3bbd7$var$I && c && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Yi(a, b, d, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e8dfc29dafb3bbd7$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e8dfc29dafb3bbd7$var$cj(a, b, f, d, e);
        a = $e8dfc29dafb3bbd7$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e8dfc29dafb3bbd7$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e8dfc29dafb3bbd7$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $e8dfc29dafb3bbd7$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e8dfc29dafb3bbd7$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e8dfc29dafb3bbd7$var$Ie(f, d) && a.ref === b.ref) {
            if ($e8dfc29dafb3bbd7$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e8dfc29dafb3bbd7$var$Ug = !0);
            else return b.lanes = a.lanes, $e8dfc29dafb3bbd7$var$$i(a, b, e);
        }
    }
    return $e8dfc29dafb3bbd7$var$dj(a, b, c, d, e);
}
function $e8dfc29dafb3bbd7$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj);
            $e8dfc29dafb3bbd7$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= d;
    $e8dfc29dafb3bbd7$var$Yi(a, b, e, c);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e8dfc29dafb3bbd7$var$dj(a, b, c, d, e) {
    var f = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current;
    f = $e8dfc29dafb3bbd7$var$Yf(b, f);
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    c = $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, f, e);
    d = $e8dfc29dafb3bbd7$var$bi();
    if (null !== a && !$e8dfc29dafb3bbd7$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$$i(a, b, e);
    $e8dfc29dafb3bbd7$var$I && d && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Yi(a, b, c, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$ij(a, b, c, d, e) {
    if ($e8dfc29dafb3bbd7$var$Zf(c)) {
        var f = !0;
        $e8dfc29dafb3bbd7$var$cg(b);
    } else f = !1;
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    if (null === b.stateNode) $e8dfc29dafb3bbd7$var$jj(a, b), $e8dfc29dafb3bbd7$var$ph(b, c, d), $e8dfc29dafb3bbd7$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e8dfc29dafb3bbd7$var$Vg(l) : (l = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, l = $e8dfc29dafb3bbd7$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e8dfc29dafb3bbd7$var$qh(b, g, d, l);
        $e8dfc29dafb3bbd7$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$$g ? ("function" === typeof m && ($e8dfc29dafb3bbd7$var$kh(b, c, m, d), k = b.memoizedState), (h = $e8dfc29dafb3bbd7$var$$g || $e8dfc29dafb3bbd7$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e8dfc29dafb3bbd7$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e8dfc29dafb3bbd7$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e8dfc29dafb3bbd7$var$Vg(k) : (k = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, k = $e8dfc29dafb3bbd7$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e8dfc29dafb3bbd7$var$qh(b, g, d, k);
        $e8dfc29dafb3bbd7$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$$g ? ("function" === typeof y && ($e8dfc29dafb3bbd7$var$kh(b, c, y, d), n = b.memoizedState), (l = $e8dfc29dafb3bbd7$var$$g || $e8dfc29dafb3bbd7$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e8dfc29dafb3bbd7$var$kj(a, b, c, d, f, e);
}
function $e8dfc29dafb3bbd7$var$kj(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e8dfc29dafb3bbd7$var$dg(b, c, !1), $e8dfc29dafb3bbd7$var$$i(a, b, f);
    d = b.stateNode;
    $e8dfc29dafb3bbd7$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, f), b.child = $e8dfc29dafb3bbd7$var$Bh(b, null, h, f)) : $e8dfc29dafb3bbd7$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e8dfc29dafb3bbd7$var$dg(b, c, !0);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e8dfc29dafb3bbd7$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e8dfc29dafb3bbd7$var$ag(a, b.context, !1);
    $e8dfc29dafb3bbd7$var$Ih(a, b.containerInfo);
}
function $e8dfc29dafb3bbd7$var$mj(a, b, c, d, e) {
    $e8dfc29dafb3bbd7$var$Ig();
    $e8dfc29dafb3bbd7$var$Jg(e);
    b.flags |= 256;
    $e8dfc29dafb3bbd7$var$Yi(a, b, c, d);
    return b.child;
}
var $e8dfc29dafb3bbd7$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e8dfc29dafb3bbd7$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e8dfc29dafb3bbd7$var$pj(a, b, c) {
    var d = b.pendingProps, e = $e8dfc29dafb3bbd7$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, e & 1);
    if (null === a) {
        $e8dfc29dafb3bbd7$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e8dfc29dafb3bbd7$var$qj(g, d, 0, null), a = $e8dfc29dafb3bbd7$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e8dfc29dafb3bbd7$var$oj(c), b.memoizedState = $e8dfc29dafb3bbd7$var$nj, a) : $e8dfc29dafb3bbd7$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e8dfc29dafb3bbd7$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e8dfc29dafb3bbd7$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e8dfc29dafb3bbd7$var$wh(h, f) : (f = $e8dfc29dafb3bbd7$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e8dfc29dafb3bbd7$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e8dfc29dafb3bbd7$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e8dfc29dafb3bbd7$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e8dfc29dafb3bbd7$var$rj(a, b) {
    b = $e8dfc29dafb3bbd7$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e8dfc29dafb3bbd7$var$tj(a, b, c, d) {
    null !== d && $e8dfc29dafb3bbd7$var$Jg(d);
    $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, c);
    a = $e8dfc29dafb3bbd7$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e8dfc29dafb3bbd7$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e8dfc29dafb3bbd7$var$Li(Error($e8dfc29dafb3bbd7$var$p(422))), $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e8dfc29dafb3bbd7$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e8dfc29dafb3bbd7$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $e8dfc29dafb3bbd7$var$oj(g);
        b.memoizedState = $e8dfc29dafb3bbd7$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e8dfc29dafb3bbd7$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e8dfc29dafb3bbd7$var$p(419));
        d = $e8dfc29dafb3bbd7$var$Li(f, d, void 0);
        return $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e8dfc29dafb3bbd7$var$Ug || h) {
        d = $e8dfc29dafb3bbd7$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e8dfc29dafb3bbd7$var$Zg(a, e), $e8dfc29dafb3bbd7$var$mh(d, a, e, -1));
        }
        $e8dfc29dafb3bbd7$var$uj();
        d = $e8dfc29dafb3bbd7$var$Li(Error($e8dfc29dafb3bbd7$var$p(421)));
        return $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e8dfc29dafb3bbd7$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(e.nextSibling);
    $e8dfc29dafb3bbd7$var$xg = b;
    $e8dfc29dafb3bbd7$var$I = !0;
    $e8dfc29dafb3bbd7$var$zg = null;
    null !== a && ($e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg, $e8dfc29dafb3bbd7$var$rg = a.id, $e8dfc29dafb3bbd7$var$sg = a.overflow, $e8dfc29dafb3bbd7$var$qg = b);
    b = $e8dfc29dafb3bbd7$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e8dfc29dafb3bbd7$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e8dfc29dafb3bbd7$var$Sg(a.return, b, c);
}
function $e8dfc29dafb3bbd7$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e8dfc29dafb3bbd7$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e8dfc29dafb3bbd7$var$Yi(a, b, d.children, c);
    d = $e8dfc29dafb3bbd7$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e8dfc29dafb3bbd7$var$wj(a, c, b);
            else if (19 === a.tag) $e8dfc29dafb3bbd7$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e8dfc29dafb3bbd7$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e8dfc29dafb3bbd7$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e8dfc29dafb3bbd7$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e8dfc29dafb3bbd7$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $e8dfc29dafb3bbd7$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e8dfc29dafb3bbd7$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e8dfc29dafb3bbd7$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e8dfc29dafb3bbd7$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e8dfc29dafb3bbd7$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e8dfc29dafb3bbd7$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $e8dfc29dafb3bbd7$var$lj(b);
            $e8dfc29dafb3bbd7$var$Ig();
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$Kh(b);
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$cg(b);
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e8dfc29dafb3bbd7$var$pj(a, b, c);
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1);
                a = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e8dfc29dafb3bbd7$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e8dfc29dafb3bbd7$var$ej(a, b, c);
    }
    return $e8dfc29dafb3bbd7$var$$i(a, b, c);
}
var $e8dfc29dafb3bbd7$var$Aj, $e8dfc29dafb3bbd7$var$Bj, $e8dfc29dafb3bbd7$var$Cj, $e8dfc29dafb3bbd7$var$Dj;
$e8dfc29dafb3bbd7$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e8dfc29dafb3bbd7$var$Bj = function() {};
$e8dfc29dafb3bbd7$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e8dfc29dafb3bbd7$var$Ya(a, e);
                d = $e8dfc29dafb3bbd7$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e8dfc29dafb3bbd7$var$A({}, e, {
                    value: void 0
                });
                d = $e8dfc29dafb3bbd7$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e8dfc29dafb3bbd7$var$gb(a, e);
                d = $e8dfc29dafb3bbd7$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
        }
        $e8dfc29dafb3bbd7$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e8dfc29dafb3bbd7$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e8dfc29dafb3bbd7$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e8dfc29dafb3bbd7$var$Ej(a, b) {
    if (!$e8dfc29dafb3bbd7$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e8dfc29dafb3bbd7$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e8dfc29dafb3bbd7$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e8dfc29dafb3bbd7$var$S(b), null;
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e8dfc29dafb3bbd7$var$Jh();
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
            $e8dfc29dafb3bbd7$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e8dfc29dafb3bbd7$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Gj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null));
            $e8dfc29dafb3bbd7$var$Bj(a, b);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 5:
            $e8dfc29dafb3bbd7$var$Lh(b);
            var e = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                    $e8dfc29dafb3bbd7$var$S(b);
                    return null;
                }
                a = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    d[$e8dfc29dafb3bbd7$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e8dfc29dafb3bbd7$var$D("cancel", d);
                            $e8dfc29dafb3bbd7$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], d);
                            break;
                        case "source":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "details":
                            $e8dfc29dafb3bbd7$var$D("toggle", d);
                            break;
                        case "input":
                            $e8dfc29dafb3bbd7$var$Za(d, f);
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$hb(d, f), $e8dfc29dafb3bbd7$var$D("invalid", d);
                    }
                    $e8dfc29dafb3bbd7$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e8dfc29dafb3bbd7$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e8dfc29dafb3bbd7$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e8dfc29dafb3bbd7$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e8dfc29dafb3bbd7$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e8dfc29dafb3bbd7$var$Of] = b;
                    a[$e8dfc29dafb3bbd7$var$Pf] = d;
                    $e8dfc29dafb3bbd7$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e8dfc29dafb3bbd7$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e8dfc29dafb3bbd7$var$D("cancel", a);
                                $e8dfc29dafb3bbd7$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e8dfc29dafb3bbd7$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e8dfc29dafb3bbd7$var$Za(a, d);
                                e = $e8dfc29dafb3bbd7$var$Ya(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e8dfc29dafb3bbd7$var$A({}, d, {
                                    value: void 0
                                });
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$hb(a, d);
                                e = $e8dfc29dafb3bbd7$var$gb(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e8dfc29dafb3bbd7$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e8dfc29dafb3bbd7$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e8dfc29dafb3bbd7$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e8dfc29dafb3bbd7$var$ob(a, k) : "number" === typeof k && $e8dfc29dafb3bbd7$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e8dfc29dafb3bbd7$var$D("scroll", a) : null != k && $e8dfc29dafb3bbd7$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e8dfc29dafb3bbd7$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                c = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
                $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e8dfc29dafb3bbd7$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e8dfc29dafb3bbd7$var$Of] = b, b.stateNode = d;
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e8dfc29dafb3bbd7$var$I && null !== $e8dfc29dafb3bbd7$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e8dfc29dafb3bbd7$var$Hg(), $e8dfc29dafb3bbd7$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e8dfc29dafb3bbd7$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(317));
                        f[$e8dfc29dafb3bbd7$var$Of] = b;
                    } else $e8dfc29dafb3bbd7$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e8dfc29dafb3bbd7$var$S(b);
                    f = !1;
                } else null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Gj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e8dfc29dafb3bbd7$var$M.current & 1) ? 0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 3) : $e8dfc29dafb3bbd7$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 4:
            return $e8dfc29dafb3bbd7$var$Jh(), $e8dfc29dafb3bbd7$var$Bj(a, b), null === a && $e8dfc29dafb3bbd7$var$sf(b.stateNode.containerInfo), $e8dfc29dafb3bbd7$var$S(b), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$Rg(b.type._context), $e8dfc29dafb3bbd7$var$S(b), null;
        case 17:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 19:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            f = b.memoizedState;
            if (null === f) return $e8dfc29dafb3bbd7$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e8dfc29dafb3bbd7$var$Ej(f, !1);
                else {
                    if (0 !== $e8dfc29dafb3bbd7$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e8dfc29dafb3bbd7$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e8dfc29dafb3bbd7$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e8dfc29dafb3bbd7$var$B() > $e8dfc29dafb3bbd7$var$Hj && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e8dfc29dafb3bbd7$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e8dfc29dafb3bbd7$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$S(b), null;
                    } else 2 * $e8dfc29dafb3bbd7$var$B() - f.renderingStartTime > $e8dfc29dafb3bbd7$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e8dfc29dafb3bbd7$var$B(), b.sibling = null, c = $e8dfc29dafb3bbd7$var$M.current, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, d ? c & 1 | 2 : c & 1), b;
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e8dfc29dafb3bbd7$var$gj & 1073741824) && ($e8dfc29dafb3bbd7$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e8dfc29dafb3bbd7$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
}
function $e8dfc29dafb3bbd7$var$Jj(a, b) {
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e8dfc29dafb3bbd7$var$Jh(), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e8dfc29dafb3bbd7$var$Lh(b), null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e8dfc29dafb3bbd7$var$p(340));
                $e8dfc29dafb3bbd7$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M), null;
        case 4:
            return $e8dfc29dafb3bbd7$var$Jh(), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$Kj = !1, $e8dfc29dafb3bbd7$var$U = !1, $e8dfc29dafb3bbd7$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $e8dfc29dafb3bbd7$var$V = null;
function $e8dfc29dafb3bbd7$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e8dfc29dafb3bbd7$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e8dfc29dafb3bbd7$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e8dfc29dafb3bbd7$var$W(a, b, d);
    }
}
var $e8dfc29dafb3bbd7$var$Oj = !1;
function $e8dfc29dafb3bbd7$var$Pj(a, b) {
    $e8dfc29dafb3bbd7$var$Cf = $e8dfc29dafb3bbd7$var$dd;
    a = $e8dfc29dafb3bbd7$var$Me();
    if ($e8dfc29dafb3bbd7$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e8dfc29dafb3bbd7$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e8dfc29dafb3bbd7$var$dd = !1;
    for($e8dfc29dafb3bbd7$var$V = b; null !== $e8dfc29dafb3bbd7$var$V;)if (b = $e8dfc29dafb3bbd7$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e8dfc29dafb3bbd7$var$V = a;
    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
        b = $e8dfc29dafb3bbd7$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e8dfc29dafb3bbd7$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(163));
            }
        } catch (F) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e8dfc29dafb3bbd7$var$V = a;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
    n = $e8dfc29dafb3bbd7$var$Oj;
    $e8dfc29dafb3bbd7$var$Oj = !1;
    return n;
}
function $e8dfc29dafb3bbd7$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e8dfc29dafb3bbd7$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e8dfc29dafb3bbd7$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e8dfc29dafb3bbd7$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e8dfc29dafb3bbd7$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e8dfc29dafb3bbd7$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e8dfc29dafb3bbd7$var$Of], delete b[$e8dfc29dafb3bbd7$var$Pf], delete b[$e8dfc29dafb3bbd7$var$of], delete b[$e8dfc29dafb3bbd7$var$Qf], delete b[$e8dfc29dafb3bbd7$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e8dfc29dafb3bbd7$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e8dfc29dafb3bbd7$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e8dfc29dafb3bbd7$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e8dfc29dafb3bbd7$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling;
}
function $e8dfc29dafb3bbd7$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Xj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Xj(a, b, c), a = a.sibling;
}
var $e8dfc29dafb3bbd7$var$X = null, $e8dfc29dafb3bbd7$var$Yj = !1;
function $e8dfc29dafb3bbd7$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$e8dfc29dafb3bbd7$var$ak(a, b, c), c = c.sibling;
}
function $e8dfc29dafb3bbd7$var$ak(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount($e8dfc29dafb3bbd7$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Mj(c, b);
        case 6:
            var d = $e8dfc29dafb3bbd7$var$X, e = $e8dfc29dafb3bbd7$var$Yj;
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Yj = e;
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Yj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e8dfc29dafb3bbd7$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Yj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? $e8dfc29dafb3bbd7$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e8dfc29dafb3bbd7$var$Kf(a, c), $e8dfc29dafb3bbd7$var$bd(a)) : $e8dfc29dafb3bbd7$var$Kf($e8dfc29dafb3bbd7$var$X, c.stateNode));
            break;
        case 4:
            d = $e8dfc29dafb3bbd7$var$X;
            e = $e8dfc29dafb3bbd7$var$Yj;
            $e8dfc29dafb3bbd7$var$X = c.stateNode.containerInfo;
            $e8dfc29dafb3bbd7$var$Yj = !0;
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e8dfc29dafb3bbd7$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e8dfc29dafb3bbd7$var$Nj(c, b, g) : 0 !== (f & 4) && $e8dfc29dafb3bbd7$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 1:
            if (!$e8dfc29dafb3bbd7$var$U && ($e8dfc29dafb3bbd7$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e8dfc29dafb3bbd7$var$W(c, b, h);
            }
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 21:
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (d = $e8dfc29dafb3bbd7$var$U) || null !== c.memoizedState, $e8dfc29dafb3bbd7$var$Zj(a, b, c), $e8dfc29dafb3bbd7$var$U = d) : $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        default:
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e8dfc29dafb3bbd7$var$Lj);
        b.forEach(function(b) {
            var d = $e8dfc29dafb3bbd7$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e8dfc29dafb3bbd7$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode;
                        $e8dfc29dafb3bbd7$var$Yj = !1;
                        break a;
                    case 3:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Yj = !0;
                        break a;
                    case 4:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e8dfc29dafb3bbd7$var$X) throw Error($e8dfc29dafb3bbd7$var$p(160));
            $e8dfc29dafb3bbd7$var$ak(f, g, e);
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e8dfc29dafb3bbd7$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e8dfc29dafb3bbd7$var$ek(b, a), b = b.sibling;
}
function $e8dfc29dafb3bbd7$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4) {
                try {
                    $e8dfc29dafb3bbd7$var$Qj(3, a, a.return), $e8dfc29dafb3bbd7$var$Rj(3, a);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
                try {
                    $e8dfc29dafb3bbd7$var$Qj(5, a, a.return);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Mj(c, c.return);
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e8dfc29dafb3bbd7$var$ob(e, "");
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e8dfc29dafb3bbd7$var$ab(e, f);
                    $e8dfc29dafb3bbd7$var$vb(h, g);
                    var l = $e8dfc29dafb3bbd7$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e8dfc29dafb3bbd7$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e8dfc29dafb3bbd7$var$nb(e, q) : "children" === m ? $e8dfc29dafb3bbd7$var$ob(e, q) : $e8dfc29dafb3bbd7$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e8dfc29dafb3bbd7$var$bb(e, f);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e8dfc29dafb3bbd7$var$Pf] = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e8dfc29dafb3bbd7$var$bd(b.containerInfo);
            } catch (t) {
                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e8dfc29dafb3bbd7$var$gk = $e8dfc29dafb3bbd7$var$B()));
            d & 4 && $e8dfc29dafb3bbd7$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (l = $e8dfc29dafb3bbd7$var$U) || m, $e8dfc29dafb3bbd7$var$dk(b, a), $e8dfc29dafb3bbd7$var$U = l) : $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e8dfc29dafb3bbd7$var$V = a, m = a.child; null !== m;){
                    for(q = $e8dfc29dafb3bbd7$var$V = m; null !== $e8dfc29dafb3bbd7$var$V;){
                        r = $e8dfc29dafb3bbd7$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $e8dfc29dafb3bbd7$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e8dfc29dafb3bbd7$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e8dfc29dafb3bbd7$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e8dfc29dafb3bbd7$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e8dfc29dafb3bbd7$var$V = y) : $e8dfc29dafb3bbd7$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e8dfc29dafb3bbd7$var$rb("display", g));
                            } catch (t) {
                                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 4 && $e8dfc29dafb3bbd7$var$bk(a);
            break;
        case 21:
            break;
        default:
            $e8dfc29dafb3bbd7$var$dk(b, a), $e8dfc29dafb3bbd7$var$fk(a);
    }
}
function $e8dfc29dafb3bbd7$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e8dfc29dafb3bbd7$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e8dfc29dafb3bbd7$var$ob(e, ""), d.flags &= -33);
                    var f = $e8dfc29dafb3bbd7$var$Vj(a);
                    $e8dfc29dafb3bbd7$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e8dfc29dafb3bbd7$var$Vj(a);
                    $e8dfc29dafb3bbd7$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(161));
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e8dfc29dafb3bbd7$var$ik(a, b, c) {
    $e8dfc29dafb3bbd7$var$V = a;
    $e8dfc29dafb3bbd7$var$jk(a, b, c);
}
function $e8dfc29dafb3bbd7$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e8dfc29dafb3bbd7$var$V;){
        var e = $e8dfc29dafb3bbd7$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e8dfc29dafb3bbd7$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e8dfc29dafb3bbd7$var$U;
                h = $e8dfc29dafb3bbd7$var$Kj;
                var l = $e8dfc29dafb3bbd7$var$U;
                $e8dfc29dafb3bbd7$var$Kj = g;
                if (($e8dfc29dafb3bbd7$var$U = k) && !l) for($e8dfc29dafb3bbd7$var$V = e; null !== $e8dfc29dafb3bbd7$var$V;)g = $e8dfc29dafb3bbd7$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e8dfc29dafb3bbd7$var$kk(e) : null !== k ? (k.return = g, $e8dfc29dafb3bbd7$var$V = k) : $e8dfc29dafb3bbd7$var$kk(e);
                for(; null !== f;)$e8dfc29dafb3bbd7$var$V = f, $e8dfc29dafb3bbd7$var$jk(f, b, c), f = f.sibling;
                $e8dfc29dafb3bbd7$var$V = e;
                $e8dfc29dafb3bbd7$var$Kj = h;
                $e8dfc29dafb3bbd7$var$U = l;
            }
            $e8dfc29dafb3bbd7$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e8dfc29dafb3bbd7$var$V = f) : $e8dfc29dafb3bbd7$var$lk(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$lk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e8dfc29dafb3bbd7$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e8dfc29dafb3bbd7$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e8dfc29dafb3bbd7$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e8dfc29dafb3bbd7$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e8dfc29dafb3bbd7$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e8dfc29dafb3bbd7$var$p(163));
                }
                $e8dfc29dafb3bbd7$var$U || b.flags & 512 && $e8dfc29dafb3bbd7$var$Sj(b);
            } catch (r) {
                $e8dfc29dafb3bbd7$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$hk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$kk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Rj(4, b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e8dfc29dafb3bbd7$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Sj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Sj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, k);
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e8dfc29dafb3bbd7$var$V = h;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
var $e8dfc29dafb3bbd7$var$mk = Math.ceil, $e8dfc29dafb3bbd7$var$nk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$ok = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$pk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$K = 0, $e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Y = null, $e8dfc29dafb3bbd7$var$Z = 0, $e8dfc29dafb3bbd7$var$gj = 0, $e8dfc29dafb3bbd7$var$fj = $e8dfc29dafb3bbd7$var$Uf(0), $e8dfc29dafb3bbd7$var$T = 0, $e8dfc29dafb3bbd7$var$qk = null, $e8dfc29dafb3bbd7$var$hh = 0, $e8dfc29dafb3bbd7$var$rk = 0, $e8dfc29dafb3bbd7$var$sk = 0, $e8dfc29dafb3bbd7$var$tk = null, $e8dfc29dafb3bbd7$var$uk = null, $e8dfc29dafb3bbd7$var$gk = 0, $e8dfc29dafb3bbd7$var$Hj = Infinity, $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Pi = !1, $e8dfc29dafb3bbd7$var$Qi = null, $e8dfc29dafb3bbd7$var$Si = null, $e8dfc29dafb3bbd7$var$wk = !1, $e8dfc29dafb3bbd7$var$xk = null, $e8dfc29dafb3bbd7$var$yk = 0, $e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = null, $e8dfc29dafb3bbd7$var$Bk = -1, $e8dfc29dafb3bbd7$var$Ck = 0;
function $e8dfc29dafb3bbd7$var$L() {
    return 0 !== ($e8dfc29dafb3bbd7$var$K & 6) ? $e8dfc29dafb3bbd7$var$B() : -1 !== $e8dfc29dafb3bbd7$var$Bk ? $e8dfc29dafb3bbd7$var$Bk : $e8dfc29dafb3bbd7$var$Bk = $e8dfc29dafb3bbd7$var$B();
}
function $e8dfc29dafb3bbd7$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2) && 0 !== $e8dfc29dafb3bbd7$var$Z) return $e8dfc29dafb3bbd7$var$Z & -$e8dfc29dafb3bbd7$var$Z;
    if (null !== $e8dfc29dafb3bbd7$var$Kg.transition) return 0 === $e8dfc29dafb3bbd7$var$Ck && ($e8dfc29dafb3bbd7$var$Ck = $e8dfc29dafb3bbd7$var$yc()), $e8dfc29dafb3bbd7$var$Ck;
    a = $e8dfc29dafb3bbd7$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e8dfc29dafb3bbd7$var$jd(a.type);
    return a;
}
function $e8dfc29dafb3bbd7$var$mh(a, b, c, d) {
    if (50 < $e8dfc29dafb3bbd7$var$zk) throw $e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = null, Error($e8dfc29dafb3bbd7$var$p(185));
    $e8dfc29dafb3bbd7$var$Ac(a, c, d);
    if (0 === ($e8dfc29dafb3bbd7$var$K & 2) || a !== $e8dfc29dafb3bbd7$var$R) a === $e8dfc29dafb3bbd7$var$R && (0 === ($e8dfc29dafb3bbd7$var$K & 2) && ($e8dfc29dafb3bbd7$var$rk |= c), 4 === $e8dfc29dafb3bbd7$var$T && $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$Z)), $e8dfc29dafb3bbd7$var$Ek(a, d), 1 === c && 0 === $e8dfc29dafb3bbd7$var$K && 0 === (b.mode & 1) && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
}
function $e8dfc29dafb3bbd7$var$Ek(a, b) {
    var c = a.callbackNode;
    $e8dfc29dafb3bbd7$var$wc(a, b);
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$R ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) null !== c && $e8dfc29dafb3bbd7$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e8dfc29dafb3bbd7$var$bc(c);
        if (1 === b) 0 === a.tag ? $e8dfc29dafb3bbd7$var$ig($e8dfc29dafb3bbd7$var$Fk.bind(null, a)) : $e8dfc29dafb3bbd7$var$hg($e8dfc29dafb3bbd7$var$Fk.bind(null, a)), $e8dfc29dafb3bbd7$var$Jf(function() {
            0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
        }), c = null;
        else {
            switch($e8dfc29dafb3bbd7$var$Dc(d)){
                case 1:
                    c = $e8dfc29dafb3bbd7$var$fc;
                    break;
                case 4:
                    c = $e8dfc29dafb3bbd7$var$gc;
                    break;
                case 16:
                    c = $e8dfc29dafb3bbd7$var$hc;
                    break;
                case 536870912:
                    c = $e8dfc29dafb3bbd7$var$jc;
                    break;
                default:
                    c = $e8dfc29dafb3bbd7$var$hc;
            }
            c = $e8dfc29dafb3bbd7$var$Gk(c, $e8dfc29dafb3bbd7$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e8dfc29dafb3bbd7$var$Hk(a, b) {
    $e8dfc29dafb3bbd7$var$Bk = -1;
    $e8dfc29dafb3bbd7$var$Ck = 0;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    var c = a.callbackNode;
    if ($e8dfc29dafb3bbd7$var$Ik() && a.callbackNode !== c) return null;
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$R ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e8dfc29dafb3bbd7$var$Jk(a, d);
    else {
        b = d;
        var e = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 2;
        var f = $e8dfc29dafb3bbd7$var$Kk();
        if ($e8dfc29dafb3bbd7$var$R !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$Lk(a, b);
        for(;;)try {
            $e8dfc29dafb3bbd7$var$Mk();
            break;
        } catch (h) {
            $e8dfc29dafb3bbd7$var$Nk(a, h);
        }
        $e8dfc29dafb3bbd7$var$Qg();
        $e8dfc29dafb3bbd7$var$nk.current = f;
        $e8dfc29dafb3bbd7$var$K = e;
        null !== $e8dfc29dafb3bbd7$var$Y ? b = 0 : ($e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Z = 0, b = $e8dfc29dafb3bbd7$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e8dfc29dafb3bbd7$var$xc(a), 0 !== e && (d = e, b = $e8dfc29dafb3bbd7$var$Ok(a, e)));
        if (1 === b) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, d), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
        if (6 === b) $e8dfc29dafb3bbd7$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e8dfc29dafb3bbd7$var$Pk(e) && (b = $e8dfc29dafb3bbd7$var$Jk(a, d), 2 === b && (f = $e8dfc29dafb3bbd7$var$xc(a), 0 !== f && (d = f, b = $e8dfc29dafb3bbd7$var$Ok(a, f))), 1 === b)) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, d), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e8dfc29dafb3bbd7$var$p(345));
                case 2:
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 3:
                    $e8dfc29dafb3bbd7$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $e8dfc29dafb3bbd7$var$gk + 500 - $e8dfc29dafb3bbd7$var$B(), 10 < b)) {
                        if (0 !== $e8dfc29dafb3bbd7$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e8dfc29dafb3bbd7$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Qk.bind(null, a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk), b);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 4:
                    $e8dfc29dafb3bbd7$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e8dfc29dafb3bbd7$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e8dfc29dafb3bbd7$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e8dfc29dafb3bbd7$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Qk.bind(null, a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk), d);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 5:
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(329));
            }
        }
    }
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    return a.callbackNode === c ? $e8dfc29dafb3bbd7$var$Hk.bind(null, a) : null;
}
function $e8dfc29dafb3bbd7$var$Ok(a, b) {
    var c = $e8dfc29dafb3bbd7$var$tk;
    a.current.memoizedState.isDehydrated && ($e8dfc29dafb3bbd7$var$Lk(a, b).flags |= 256);
    a = $e8dfc29dafb3bbd7$var$Jk(a, b);
    2 !== a && (b = $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$uk = c, null !== b && $e8dfc29dafb3bbd7$var$Gj(b));
    return a;
}
function $e8dfc29dafb3bbd7$var$Gj(a) {
    null === $e8dfc29dafb3bbd7$var$uk ? $e8dfc29dafb3bbd7$var$uk = a : $e8dfc29dafb3bbd7$var$uk.push.apply($e8dfc29dafb3bbd7$var$uk, a);
}
function $e8dfc29dafb3bbd7$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e8dfc29dafb3bbd7$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Dk(a, b) {
    b &= ~$e8dfc29dafb3bbd7$var$sk;
    b &= ~$e8dfc29dafb3bbd7$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e8dfc29dafb3bbd7$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e8dfc29dafb3bbd7$var$Fk(a) {
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    $e8dfc29dafb3bbd7$var$Ik();
    var b = $e8dfc29dafb3bbd7$var$uc(a, 0);
    if (0 === (b & 1)) return $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), null;
    var c = $e8dfc29dafb3bbd7$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e8dfc29dafb3bbd7$var$xc(a);
        0 !== d && (b = d, c = $e8dfc29dafb3bbd7$var$Ok(a, d));
    }
    if (1 === c) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, b), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
    if (6 === c) throw Error($e8dfc29dafb3bbd7$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    return null;
}
function $e8dfc29dafb3bbd7$var$Rk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e8dfc29dafb3bbd7$var$K = c, 0 === $e8dfc29dafb3bbd7$var$K && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
    }
}
function $e8dfc29dafb3bbd7$var$Sk(a) {
    null !== $e8dfc29dafb3bbd7$var$xk && 0 === $e8dfc29dafb3bbd7$var$xk.tag && 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$Ik();
    var b = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    var c = $e8dfc29dafb3bbd7$var$pk.transition, d = $e8dfc29dafb3bbd7$var$C;
    try {
        if ($e8dfc29dafb3bbd7$var$pk.transition = null, $e8dfc29dafb3bbd7$var$C = 1, a) return a();
    } finally{
        $e8dfc29dafb3bbd7$var$C = d, $e8dfc29dafb3bbd7$var$pk.transition = c, $e8dfc29dafb3bbd7$var$K = b, 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
    }
}
function $e8dfc29dafb3bbd7$var$Ij() {
    $e8dfc29dafb3bbd7$var$gj = $e8dfc29dafb3bbd7$var$fj.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$fj);
}
function $e8dfc29dafb3bbd7$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e8dfc29dafb3bbd7$var$Gf(c));
    if (null !== $e8dfc29dafb3bbd7$var$Y) for(c = $e8dfc29dafb3bbd7$var$Y.return; null !== c;){
        var d = c;
        $e8dfc29dafb3bbd7$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e8dfc29dafb3bbd7$var$$f();
                break;
            case 3:
                $e8dfc29dafb3bbd7$var$Jh();
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
                $e8dfc29dafb3bbd7$var$Oh();
                break;
            case 5:
                $e8dfc29dafb3bbd7$var$Lh(d);
                break;
            case 4:
                $e8dfc29dafb3bbd7$var$Jh();
                break;
            case 13:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
                break;
            case 19:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
                break;
            case 10:
                $e8dfc29dafb3bbd7$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $e8dfc29dafb3bbd7$var$Ij();
        }
        c = c.return;
    }
    $e8dfc29dafb3bbd7$var$R = a;
    $e8dfc29dafb3bbd7$var$Y = a = $e8dfc29dafb3bbd7$var$wh(a.current, null);
    $e8dfc29dafb3bbd7$var$Z = $e8dfc29dafb3bbd7$var$gj = b;
    $e8dfc29dafb3bbd7$var$T = 0;
    $e8dfc29dafb3bbd7$var$qk = null;
    $e8dfc29dafb3bbd7$var$sk = $e8dfc29dafb3bbd7$var$rk = $e8dfc29dafb3bbd7$var$hh = 0;
    $e8dfc29dafb3bbd7$var$uk = $e8dfc29dafb3bbd7$var$tk = null;
    if (null !== $e8dfc29dafb3bbd7$var$Wg) {
        for(b = 0; b < $e8dfc29dafb3bbd7$var$Wg.length; b++)if (c = $e8dfc29dafb3bbd7$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e8dfc29dafb3bbd7$var$Wg = null;
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Nk(a, b) {
    do {
        var c = $e8dfc29dafb3bbd7$var$Y;
        try {
            $e8dfc29dafb3bbd7$var$Qg();
            $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$ai;
            if ($e8dfc29dafb3bbd7$var$Sh) {
                for(var d = $e8dfc29dafb3bbd7$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e8dfc29dafb3bbd7$var$Sh = !1;
            }
            $e8dfc29dafb3bbd7$var$Rh = 0;
            $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
            $e8dfc29dafb3bbd7$var$Th = !1;
            $e8dfc29dafb3bbd7$var$Uh = 0;
            $e8dfc29dafb3bbd7$var$ok.current = null;
            if (null === c || null === c.return) {
                $e8dfc29dafb3bbd7$var$T = 1;
                $e8dfc29dafb3bbd7$var$qk = b;
                $e8dfc29dafb3bbd7$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e8dfc29dafb3bbd7$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e8dfc29dafb3bbd7$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e8dfc29dafb3bbd7$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $e8dfc29dafb3bbd7$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e8dfc29dafb3bbd7$var$Ti(f, l, b);
                            $e8dfc29dafb3bbd7$var$uj();
                            break a;
                        }
                        k = Error($e8dfc29dafb3bbd7$var$p(426));
                    }
                } else if ($e8dfc29dafb3bbd7$var$I && h.mode & 1) {
                    var J = $e8dfc29dafb3bbd7$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e8dfc29dafb3bbd7$var$Wi(J, g, h, f, b);
                        $e8dfc29dafb3bbd7$var$Jg($e8dfc29dafb3bbd7$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $e8dfc29dafb3bbd7$var$Ki(k, h);
                4 !== $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 2);
                null === $e8dfc29dafb3bbd7$var$tk ? $e8dfc29dafb3bbd7$var$tk = [
                    f
                ] : $e8dfc29dafb3bbd7$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e8dfc29dafb3bbd7$var$Oi(f, k, b);
                            $e8dfc29dafb3bbd7$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Si || !$e8dfc29dafb3bbd7$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e8dfc29dafb3bbd7$var$Ri(f, h, b);
                                $e8dfc29dafb3bbd7$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e8dfc29dafb3bbd7$var$Tk(c);
        } catch (na) {
            b = na;
            $e8dfc29dafb3bbd7$var$Y === c && null !== c && ($e8dfc29dafb3bbd7$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e8dfc29dafb3bbd7$var$Kk() {
    var a = $e8dfc29dafb3bbd7$var$nk.current;
    $e8dfc29dafb3bbd7$var$nk.current = $e8dfc29dafb3bbd7$var$ai;
    return null === a ? $e8dfc29dafb3bbd7$var$ai : a;
}
function $e8dfc29dafb3bbd7$var$uj() {
    if (0 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T || 2 === $e8dfc29dafb3bbd7$var$T) $e8dfc29dafb3bbd7$var$T = 4;
    null === $e8dfc29dafb3bbd7$var$R || 0 === ($e8dfc29dafb3bbd7$var$hh & 268435455) && 0 === ($e8dfc29dafb3bbd7$var$rk & 268435455) || $e8dfc29dafb3bbd7$var$Dk($e8dfc29dafb3bbd7$var$R, $e8dfc29dafb3bbd7$var$Z);
}
function $e8dfc29dafb3bbd7$var$Jk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 2;
    var d = $e8dfc29dafb3bbd7$var$Kk();
    if ($e8dfc29dafb3bbd7$var$R !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Lk(a, b);
    for(;;)try {
        $e8dfc29dafb3bbd7$var$Uk();
        break;
    } catch (e) {
        $e8dfc29dafb3bbd7$var$Nk(a, e);
    }
    $e8dfc29dafb3bbd7$var$Qg();
    $e8dfc29dafb3bbd7$var$K = c;
    $e8dfc29dafb3bbd7$var$nk.current = d;
    if (null !== $e8dfc29dafb3bbd7$var$Y) throw Error($e8dfc29dafb3bbd7$var$p(261));
    $e8dfc29dafb3bbd7$var$R = null;
    $e8dfc29dafb3bbd7$var$Z = 0;
    return $e8dfc29dafb3bbd7$var$T;
}
function $e8dfc29dafb3bbd7$var$Uk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y;)$e8dfc29dafb3bbd7$var$Vk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Mk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y && !$e8dfc29dafb3bbd7$var$cc();)$e8dfc29dafb3bbd7$var$Vk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Vk(a) {
    var b = $e8dfc29dafb3bbd7$var$Wk(a.alternate, a, $e8dfc29dafb3bbd7$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e8dfc29dafb3bbd7$var$Tk(a) : $e8dfc29dafb3bbd7$var$Y = b;
    $e8dfc29dafb3bbd7$var$ok.current = null;
}
function $e8dfc29dafb3bbd7$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e8dfc29dafb3bbd7$var$Fj(c, b, $e8dfc29dafb3bbd7$var$gj), null !== c) {
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
        } else {
            c = $e8dfc29dafb3bbd7$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e8dfc29dafb3bbd7$var$T = 6;
                $e8dfc29dafb3bbd7$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e8dfc29dafb3bbd7$var$Y = b;
            return;
        }
        $e8dfc29dafb3bbd7$var$Y = b = a;
    }while (null !== b);
    0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 5);
}
function $e8dfc29dafb3bbd7$var$Qk(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$C, e = $e8dfc29dafb3bbd7$var$pk.transition;
    try {
        $e8dfc29dafb3bbd7$var$pk.transition = null, $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$Xk(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$pk.transition = e, $e8dfc29dafb3bbd7$var$C = d;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xk(a, b, c, d) {
    do $e8dfc29dafb3bbd7$var$Ik();
    while (null !== $e8dfc29dafb3bbd7$var$xk);
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e8dfc29dafb3bbd7$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e8dfc29dafb3bbd7$var$Bc(a, f);
    a === $e8dfc29dafb3bbd7$var$R && ($e8dfc29dafb3bbd7$var$Y = $e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e8dfc29dafb3bbd7$var$wk || ($e8dfc29dafb3bbd7$var$wk = !0, $e8dfc29dafb3bbd7$var$Gk($e8dfc29dafb3bbd7$var$hc, function() {
        $e8dfc29dafb3bbd7$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e8dfc29dafb3bbd7$var$pk.transition;
        $e8dfc29dafb3bbd7$var$pk.transition = null;
        var g = $e8dfc29dafb3bbd7$var$C;
        $e8dfc29dafb3bbd7$var$C = 1;
        var h = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 4;
        $e8dfc29dafb3bbd7$var$ok.current = null;
        $e8dfc29dafb3bbd7$var$Pj(a, c);
        $e8dfc29dafb3bbd7$var$ek(c, a);
        $e8dfc29dafb3bbd7$var$Oe($e8dfc29dafb3bbd7$var$Df);
        $e8dfc29dafb3bbd7$var$dd = !!$e8dfc29dafb3bbd7$var$Cf;
        $e8dfc29dafb3bbd7$var$Df = $e8dfc29dafb3bbd7$var$Cf = null;
        a.current = c;
        $e8dfc29dafb3bbd7$var$ik(c, a, e);
        $e8dfc29dafb3bbd7$var$dc();
        $e8dfc29dafb3bbd7$var$K = h;
        $e8dfc29dafb3bbd7$var$C = g;
        $e8dfc29dafb3bbd7$var$pk.transition = f;
    } else a.current = c;
    $e8dfc29dafb3bbd7$var$wk && ($e8dfc29dafb3bbd7$var$wk = !1, $e8dfc29dafb3bbd7$var$xk = a, $e8dfc29dafb3bbd7$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($e8dfc29dafb3bbd7$var$Si = null);
    $e8dfc29dafb3bbd7$var$mc(c.stateNode, d);
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e8dfc29dafb3bbd7$var$Pi) throw $e8dfc29dafb3bbd7$var$Pi = !1, a = $e8dfc29dafb3bbd7$var$Qi, $e8dfc29dafb3bbd7$var$Qi = null, a;
    0 !== ($e8dfc29dafb3bbd7$var$yk & 1) && 0 !== a.tag && $e8dfc29dafb3bbd7$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e8dfc29dafb3bbd7$var$Ak ? $e8dfc29dafb3bbd7$var$zk++ : ($e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = a) : $e8dfc29dafb3bbd7$var$zk = 0;
    $e8dfc29dafb3bbd7$var$jg();
    return null;
}
function $e8dfc29dafb3bbd7$var$Ik() {
    if (null !== $e8dfc29dafb3bbd7$var$xk) {
        var a = $e8dfc29dafb3bbd7$var$Dc($e8dfc29dafb3bbd7$var$yk), b = $e8dfc29dafb3bbd7$var$pk.transition, c = $e8dfc29dafb3bbd7$var$C;
        try {
            $e8dfc29dafb3bbd7$var$pk.transition = null;
            $e8dfc29dafb3bbd7$var$C = 16 > a ? 16 : a;
            if (null === $e8dfc29dafb3bbd7$var$xk) var d = !1;
            else {
                a = $e8dfc29dafb3bbd7$var$xk;
                $e8dfc29dafb3bbd7$var$xk = null;
                $e8dfc29dafb3bbd7$var$yk = 0;
                if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(331));
                var e = $e8dfc29dafb3bbd7$var$K;
                $e8dfc29dafb3bbd7$var$K |= 4;
                for($e8dfc29dafb3bbd7$var$V = a.current; null !== $e8dfc29dafb3bbd7$var$V;){
                    var f = $e8dfc29dafb3bbd7$var$V, g = f.child;
                    if (0 !== ($e8dfc29dafb3bbd7$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e8dfc29dafb3bbd7$var$V = l; null !== $e8dfc29dafb3bbd7$var$V;){
                                    var m = $e8dfc29dafb3bbd7$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e8dfc29dafb3bbd7$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e8dfc29dafb3bbd7$var$V = q;
                                    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
                                        m = $e8dfc29dafb3bbd7$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e8dfc29dafb3bbd7$var$Tj(m);
                                        if (m === l) {
                                            $e8dfc29dafb3bbd7$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e8dfc29dafb3bbd7$var$V = r;
                                            break;
                                        }
                                        $e8dfc29dafb3bbd7$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e8dfc29dafb3bbd7$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e8dfc29dafb3bbd7$var$V = g;
                    else b: for(; null !== $e8dfc29dafb3bbd7$var$V;){
                        f = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e8dfc29dafb3bbd7$var$V = x;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e8dfc29dafb3bbd7$var$V = w; null !== $e8dfc29dafb3bbd7$var$V;){
                    g = $e8dfc29dafb3bbd7$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e8dfc29dafb3bbd7$var$V = u;
                    else b: for(g = w; null !== $e8dfc29dafb3bbd7$var$V;){
                        h = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e8dfc29dafb3bbd7$var$Rj(9, h);
                            }
                        } catch (na) {
                            $e8dfc29dafb3bbd7$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e8dfc29dafb3bbd7$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e8dfc29dafb3bbd7$var$V = F;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = h.return;
                    }
                }
                $e8dfc29dafb3bbd7$var$K = e;
                $e8dfc29dafb3bbd7$var$jg();
                if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot) try {
                    $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$pk.transition = b;
        }
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Yk(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Ki(c, b);
    b = $e8dfc29dafb3bbd7$var$Oi(a, b, 1);
    a = $e8dfc29dafb3bbd7$var$dh(a, b, 1);
    b = $e8dfc29dafb3bbd7$var$L();
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, 1, b), $e8dfc29dafb3bbd7$var$Ek(a, b));
}
function $e8dfc29dafb3bbd7$var$W(a, b, c) {
    if (3 === a.tag) $e8dfc29dafb3bbd7$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e8dfc29dafb3bbd7$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Si || !$e8dfc29dafb3bbd7$var$Si.has(d))) {
                a = $e8dfc29dafb3bbd7$var$Ki(c, a);
                a = $e8dfc29dafb3bbd7$var$Ri(b, a, 1);
                b = $e8dfc29dafb3bbd7$var$dh(b, a, 1);
                a = $e8dfc29dafb3bbd7$var$L();
                null !== b && ($e8dfc29dafb3bbd7$var$Ac(b, 1, a), $e8dfc29dafb3bbd7$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e8dfc29dafb3bbd7$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $e8dfc29dafb3bbd7$var$R === a && ($e8dfc29dafb3bbd7$var$Z & c) === c && (4 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$Z & 130023424) === $e8dfc29dafb3bbd7$var$Z && 500 > $e8dfc29dafb3bbd7$var$B() - $e8dfc29dafb3bbd7$var$gk ? $e8dfc29dafb3bbd7$var$Lk(a, 0) : $e8dfc29dafb3bbd7$var$sk |= c);
    $e8dfc29dafb3bbd7$var$Ek(a, b);
}
function $e8dfc29dafb3bbd7$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e8dfc29dafb3bbd7$var$sc, $e8dfc29dafb3bbd7$var$sc <<= 1, 0 === ($e8dfc29dafb3bbd7$var$sc & 130023424) && ($e8dfc29dafb3bbd7$var$sc = 4194304)));
    var c = $e8dfc29dafb3bbd7$var$L();
    a = $e8dfc29dafb3bbd7$var$Zg(a, b);
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, b, c), $e8dfc29dafb3bbd7$var$Ek(a, c));
}
function $e8dfc29dafb3bbd7$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e8dfc29dafb3bbd7$var$Zk(a, c);
}
function $e8dfc29dafb3bbd7$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e8dfc29dafb3bbd7$var$p(314));
    }
    null !== d && d.delete(b);
    $e8dfc29dafb3bbd7$var$Zk(a, c);
}
var $e8dfc29dafb3bbd7$var$Wk;
$e8dfc29dafb3bbd7$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e8dfc29dafb3bbd7$var$Wf.current) $e8dfc29dafb3bbd7$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e8dfc29dafb3bbd7$var$Ug = !1, $e8dfc29dafb3bbd7$var$zj(a, b, c);
            $e8dfc29dafb3bbd7$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e8dfc29dafb3bbd7$var$Ug = !1, $e8dfc29dafb3bbd7$var$I && 0 !== (b.flags & 1048576) && $e8dfc29dafb3bbd7$var$ug(b, $e8dfc29dafb3bbd7$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e8dfc29dafb3bbd7$var$jj(a, b);
            a = b.pendingProps;
            var e = $e8dfc29dafb3bbd7$var$Yf(b, $e8dfc29dafb3bbd7$var$H.current);
            $e8dfc29dafb3bbd7$var$Tg(b, c);
            e = $e8dfc29dafb3bbd7$var$Xh(null, b, d, a, e, c);
            var f = $e8dfc29dafb3bbd7$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e8dfc29dafb3bbd7$var$Zf(d) ? (f = !0, $e8dfc29dafb3bbd7$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e8dfc29dafb3bbd7$var$ah(b), e.updater = $e8dfc29dafb3bbd7$var$nh, b.stateNode = e, e._reactInternals = b, $e8dfc29dafb3bbd7$var$rh(b, d, a, c), b = $e8dfc29dafb3bbd7$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $e8dfc29dafb3bbd7$var$I && f && $e8dfc29dafb3bbd7$var$vg(b), $e8dfc29dafb3bbd7$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e8dfc29dafb3bbd7$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e8dfc29dafb3bbd7$var$$k(d);
                a = $e8dfc29dafb3bbd7$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $e8dfc29dafb3bbd7$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e8dfc29dafb3bbd7$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e8dfc29dafb3bbd7$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e8dfc29dafb3bbd7$var$aj(null, b, d, $e8dfc29dafb3bbd7$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $e8dfc29dafb3bbd7$var$lj(b);
                if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e8dfc29dafb3bbd7$var$bh(a, b);
                $e8dfc29dafb3bbd7$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(423)), b);
                        b = $e8dfc29dafb3bbd7$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(424)), b);
                        b = $e8dfc29dafb3bbd7$var$mj(a, b, d, c, e);
                        break a;
                    } else for($e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.stateNode.containerInfo.firstChild), $e8dfc29dafb3bbd7$var$xg = b, $e8dfc29dafb3bbd7$var$I = !0, $e8dfc29dafb3bbd7$var$zg = null, c = $e8dfc29dafb3bbd7$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e8dfc29dafb3bbd7$var$Ig();
                    if (d === e) {
                        b = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                        break a;
                    }
                    $e8dfc29dafb3bbd7$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e8dfc29dafb3bbd7$var$Kh(b), null === a && $e8dfc29dafb3bbd7$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e8dfc29dafb3bbd7$var$Ef(d, e) ? g = null : null !== f && $e8dfc29dafb3bbd7$var$Ef(d, f) && (b.flags |= 32), $e8dfc29dafb3bbd7$var$hj(a, b), $e8dfc29dafb3bbd7$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $e8dfc29dafb3bbd7$var$Eg(b), null;
        case 13:
            return $e8dfc29dafb3bbd7$var$pj(a, b, c);
        case 4:
            return $e8dfc29dafb3bbd7$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e8dfc29dafb3bbd7$var$Bh(b, null, d, c) : $e8dfc29dafb3bbd7$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$Zi(a, b, d, e, c);
        case 7:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e8dfc29dafb3bbd7$var$He(f.value, g)) {
                        if (f.children === e.children && !$e8dfc29dafb3bbd7$var$Wf.current) {
                            b = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e8dfc29dafb3bbd7$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e8dfc29dafb3bbd7$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e8dfc29dafb3bbd7$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e8dfc29dafb3bbd7$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e8dfc29dafb3bbd7$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e8dfc29dafb3bbd7$var$Tg(b, c), e = $e8dfc29dafb3bbd7$var$Vg(e), d = d(e), b.flags |= 1, $e8dfc29dafb3bbd7$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e8dfc29dafb3bbd7$var$Lg(d, b.pendingProps), e = $e8dfc29dafb3bbd7$var$Lg(d.type, e), $e8dfc29dafb3bbd7$var$aj(a, b, d, e, c);
        case 15:
            return $e8dfc29dafb3bbd7$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$jj(a, b), b.tag = 1, $e8dfc29dafb3bbd7$var$Zf(d) ? (a = !0, $e8dfc29dafb3bbd7$var$cg(b)) : a = !1, $e8dfc29dafb3bbd7$var$Tg(b, c), $e8dfc29dafb3bbd7$var$ph(b, d, e), $e8dfc29dafb3bbd7$var$rh(b, d, e, c), $e8dfc29dafb3bbd7$var$kj(null, b, d, !0, a, c);
        case 19:
            return $e8dfc29dafb3bbd7$var$yj(a, b, c);
        case 22:
            return $e8dfc29dafb3bbd7$var$ej(a, b, c);
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
};
function $e8dfc29dafb3bbd7$var$Gk(a, b) {
    return $e8dfc29dafb3bbd7$var$ac(a, b);
}
function $e8dfc29dafb3bbd7$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e8dfc29dafb3bbd7$var$Bg(a, b, c, d) {
    return new $e8dfc29dafb3bbd7$var$al(a, b, c, d);
}
function $e8dfc29dafb3bbd7$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e8dfc29dafb3bbd7$var$$k(a) {
    if ("function" === typeof a) return $e8dfc29dafb3bbd7$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e8dfc29dafb3bbd7$var$Da) return 11;
        if (a === $e8dfc29dafb3bbd7$var$Ga) return 14;
    }
    return 2;
}
function $e8dfc29dafb3bbd7$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $e8dfc29dafb3bbd7$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e8dfc29dafb3bbd7$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e8dfc29dafb3bbd7$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return $e8dfc29dafb3bbd7$var$Ah(c.children, e, f, b);
        case $e8dfc29dafb3bbd7$var$za:
            g = 8;
            e |= 8;
            break;
        case $e8dfc29dafb3bbd7$var$Aa:
            return a = $e8dfc29dafb3bbd7$var$Bg(12, c, b, e | 2), a.elementType = $e8dfc29dafb3bbd7$var$Aa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ea:
            return a = $e8dfc29dafb3bbd7$var$Bg(13, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Ea, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Fa:
            return a = $e8dfc29dafb3bbd7$var$Bg(19, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Fa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ia:
            return $e8dfc29dafb3bbd7$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e8dfc29dafb3bbd7$var$Ba:
                    g = 10;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ca:
                    g = 9;
                    break a;
                case $e8dfc29dafb3bbd7$var$Da:
                    g = 11;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ga:
                    g = 14;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $e8dfc29dafb3bbd7$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e8dfc29dafb3bbd7$var$Ah(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$qj(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(22, a, d, b);
    a.elementType = $e8dfc29dafb3bbd7$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e8dfc29dafb3bbd7$var$xh(a, b, c) {
    a = $e8dfc29dafb3bbd7$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$zh(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e8dfc29dafb3bbd7$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e8dfc29dafb3bbd7$var$zc(0);
    this.expirationTimes = $e8dfc29dafb3bbd7$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e8dfc29dafb3bbd7$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e8dfc29dafb3bbd7$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $e8dfc29dafb3bbd7$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e8dfc29dafb3bbd7$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e8dfc29dafb3bbd7$var$ah(f);
    return a;
}
function $e8dfc29dafb3bbd7$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e8dfc29dafb3bbd7$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e8dfc29dafb3bbd7$var$el(a) {
    if (!a) return $e8dfc29dafb3bbd7$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e8dfc29dafb3bbd7$var$Vb(a) !== a || 1 !== a.tag) throw Error($e8dfc29dafb3bbd7$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e8dfc29dafb3bbd7$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e8dfc29dafb3bbd7$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e8dfc29dafb3bbd7$var$Zf(c)) return $e8dfc29dafb3bbd7$var$bg(a, c, b);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $e8dfc29dafb3bbd7$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $e8dfc29dafb3bbd7$var$el(null);
    c = a.current;
    d = $e8dfc29dafb3bbd7$var$L();
    e = $e8dfc29dafb3bbd7$var$lh(c);
    f = $e8dfc29dafb3bbd7$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e8dfc29dafb3bbd7$var$dh(c, f, e);
    a.current.lanes = e;
    $e8dfc29dafb3bbd7$var$Ac(a, e, d);
    $e8dfc29dafb3bbd7$var$Ek(a, d);
    return a;
}
function $e8dfc29dafb3bbd7$var$gl(a, b, c, d) {
    var e = b.current, f = $e8dfc29dafb3bbd7$var$L(), g = $e8dfc29dafb3bbd7$var$lh(e);
    c = $e8dfc29dafb3bbd7$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e8dfc29dafb3bbd7$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e8dfc29dafb3bbd7$var$dh(e, b, g);
    null !== a && ($e8dfc29dafb3bbd7$var$mh(a, e, g, f), $e8dfc29dafb3bbd7$var$eh(a, e, g));
    return g;
}
function $e8dfc29dafb3bbd7$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e8dfc29dafb3bbd7$var$jl(a, b) {
    $e8dfc29dafb3bbd7$var$il(a, b);
    (a = a.alternate) && $e8dfc29dafb3bbd7$var$il(a, b);
}
function $e8dfc29dafb3bbd7$var$kl() {
    return null;
}
var $e8dfc29dafb3bbd7$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $e8dfc29dafb3bbd7$var$ml(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$nl.prototype.render = $e8dfc29dafb3bbd7$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(409));
    $e8dfc29dafb3bbd7$var$gl(a, b, null, null);
};
$e8dfc29dafb3bbd7$var$nl.prototype.unmount = $e8dfc29dafb3bbd7$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e8dfc29dafb3bbd7$var$Sk(function() {
            $e8dfc29dafb3bbd7$var$gl(null, a, null, null);
        });
        b[$e8dfc29dafb3bbd7$var$uf] = null;
    }
};
function $e8dfc29dafb3bbd7$var$nl(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e8dfc29dafb3bbd7$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length && 0 !== b && b < $e8dfc29dafb3bbd7$var$Qc[c].priority; c++);
        $e8dfc29dafb3bbd7$var$Qc.splice(c, 0, a);
        0 === c && $e8dfc29dafb3bbd7$var$Vc(a);
    }
};
function $e8dfc29dafb3bbd7$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e8dfc29dafb3bbd7$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e8dfc29dafb3bbd7$var$ql() {}
function $e8dfc29dafb3bbd7$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $e8dfc29dafb3bbd7$var$hl(g);
                f.call(a);
            };
        }
        var g = $e8dfc29dafb3bbd7$var$fl(b, d, a, 0, null, !1, !1, "", $e8dfc29dafb3bbd7$var$ql);
        a._reactRootContainer = g;
        a[$e8dfc29dafb3bbd7$var$uf] = g.current;
        $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e8dfc29dafb3bbd7$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $e8dfc29dafb3bbd7$var$hl(k);
            h.call(a);
        };
    }
    var k = $e8dfc29dafb3bbd7$var$cl(a, 0, !1, null, null, !1, !1, "", $e8dfc29dafb3bbd7$var$ql);
    a._reactRootContainer = k;
    a[$e8dfc29dafb3bbd7$var$uf] = k.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e8dfc29dafb3bbd7$var$Sk(function() {
        $e8dfc29dafb3bbd7$var$gl(b, k, c, d);
    });
    return k;
}
function $e8dfc29dafb3bbd7$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $e8dfc29dafb3bbd7$var$hl(g);
                h.call(a);
            };
        }
        $e8dfc29dafb3bbd7$var$gl(b, g, a, e);
    } else g = $e8dfc29dafb3bbd7$var$rl(c, b, a, e, d);
    return $e8dfc29dafb3bbd7$var$hl(g);
}
$e8dfc29dafb3bbd7$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e8dfc29dafb3bbd7$var$tc(b.pendingLanes);
                0 !== c && ($e8dfc29dafb3bbd7$var$Cc(b, c | 1), $e8dfc29dafb3bbd7$var$Ek(b, $e8dfc29dafb3bbd7$var$B()), 0 === ($e8dfc29dafb3bbd7$var$K & 6) && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$jg()));
            }
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$Sk(function() {
                var b = $e8dfc29dafb3bbd7$var$Zg(a, 1);
                if (null !== b) {
                    var c = $e8dfc29dafb3bbd7$var$L();
                    $e8dfc29dafb3bbd7$var$mh(b, a, 1, c);
                }
            }), $e8dfc29dafb3bbd7$var$jl(a, 1);
    }
};
$e8dfc29dafb3bbd7$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $e8dfc29dafb3bbd7$var$L();
            $e8dfc29dafb3bbd7$var$mh(b, a, 134217728, c);
        }
        $e8dfc29dafb3bbd7$var$jl(a, 134217728);
    }
};
$e8dfc29dafb3bbd7$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$lh(a), c = $e8dfc29dafb3bbd7$var$Zg(a, b);
        if (null !== c) {
            var d = $e8dfc29dafb3bbd7$var$L();
            $e8dfc29dafb3bbd7$var$mh(c, a, b, d);
        }
        $e8dfc29dafb3bbd7$var$jl(a, b);
    }
};
$e8dfc29dafb3bbd7$var$Hc = function() {
    return $e8dfc29dafb3bbd7$var$C;
};
$e8dfc29dafb3bbd7$var$Ic = function(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    try {
        return $e8dfc29dafb3bbd7$var$C = a, b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c;
    }
};
$e8dfc29dafb3bbd7$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $e8dfc29dafb3bbd7$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e8dfc29dafb3bbd7$var$Db(d);
                        if (!e) throw Error($e8dfc29dafb3bbd7$var$p(90));
                        $e8dfc29dafb3bbd7$var$Wa(d);
                        $e8dfc29dafb3bbd7$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e8dfc29dafb3bbd7$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e8dfc29dafb3bbd7$var$fb(a, !!c.multiple, b, !1);
    }
};
$e8dfc29dafb3bbd7$var$Gb = $e8dfc29dafb3bbd7$var$Rk;
$e8dfc29dafb3bbd7$var$Hb = $e8dfc29dafb3bbd7$var$Sk;
var $e8dfc29dafb3bbd7$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $e8dfc29dafb3bbd7$var$Cb,
        $e8dfc29dafb3bbd7$var$ue,
        $e8dfc29dafb3bbd7$var$Db,
        $e8dfc29dafb3bbd7$var$Eb,
        $e8dfc29dafb3bbd7$var$Fb,
        $e8dfc29dafb3bbd7$var$Rk
    ]
}, $e8dfc29dafb3bbd7$var$ul = {
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $e8dfc29dafb3bbd7$var$vl = {
    bundleType: $e8dfc29dafb3bbd7$var$ul.bundleType,
    version: $e8dfc29dafb3bbd7$var$ul.version,
    rendererPackageName: $e8dfc29dafb3bbd7$var$ul.rendererPackageName,
    rendererConfig: $e8dfc29dafb3bbd7$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $e8dfc29dafb3bbd7$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$ul.findFiberByHostInstance || $e8dfc29dafb3bbd7$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e8dfc29dafb3bbd7$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e8dfc29dafb3bbd7$var$wl.isDisabled && $e8dfc29dafb3bbd7$var$wl.supportsFiber) try {
        $e8dfc29dafb3bbd7$var$kc = $e8dfc29dafb3bbd7$var$wl.inject($e8dfc29dafb3bbd7$var$vl), $e8dfc29dafb3bbd7$var$lc = $e8dfc29dafb3bbd7$var$wl;
    } catch (a) {}
}
$e8dfc29dafb3bbd7$export$ae55be85d98224ed = $e8dfc29dafb3bbd7$var$tl;
$e8dfc29dafb3bbd7$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e8dfc29dafb3bbd7$var$ol(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$dl(a, b, null, c);
};
$e8dfc29dafb3bbd7$export$882461b6382ed46c = function(a, b) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(299));
    var c = !1, d = "", e = $e8dfc29dafb3bbd7$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e8dfc29dafb3bbd7$var$ml(b);
};
$e8dfc29dafb3bbd7$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e8dfc29dafb3bbd7$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e8dfc29dafb3bbd7$var$p(268, a));
    }
    a = $e8dfc29dafb3bbd7$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = function(a) {
    return $e8dfc29dafb3bbd7$var$Sk(a);
};
$e8dfc29dafb3bbd7$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$pl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$sl(null, a, b, !0, c);
};
$e8dfc29dafb3bbd7$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e8dfc29dafb3bbd7$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e8dfc29dafb3bbd7$var$nl(b);
};
$e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$pl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$sl(null, a, b, !1, c);
};
$e8dfc29dafb3bbd7$export$502457920280e6be = function(a) {
    if (!$e8dfc29dafb3bbd7$var$pl(a)) throw Error($e8dfc29dafb3bbd7$var$p(40));
    return a._reactRootContainer ? ($e8dfc29dafb3bbd7$var$Sk(function() {
        $e8dfc29dafb3bbd7$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e8dfc29dafb3bbd7$var$uf] = null;
        });
    }), !0) : !1;
};
$e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = $e8dfc29dafb3bbd7$var$Rk;
$e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e8dfc29dafb3bbd7$var$pl(c)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e8dfc29dafb3bbd7$var$p(38));
    return $e8dfc29dafb3bbd7$var$sl(a, b, c, !1, d);
};
$e8dfc29dafb3bbd7$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("1c9zD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lffg4"));

});
parcelRequire.register("lffg4", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $f776d5a8b0cafef3$export$c4744153514ff05d; }, function (v) { return $f776d5a8b0cafef3$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7; }, function (v) { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875; }, function (v) { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $f776d5a8b0cafef3$export$502329bbf4b505b1; }, function (v) { return $f776d5a8b0cafef3$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $f776d5a8b0cafef3$export$6e3807111c4874c4; }, function (v) { return $f776d5a8b0cafef3$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $f776d5a8b0cafef3$export$c27134553091fb3a; }, function (v) { return $f776d5a8b0cafef3$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2; }, function (v) { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $f776d5a8b0cafef3$export$b00a404bbd5edef2; }, function (v) { return $f776d5a8b0cafef3$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $f776d5a8b0cafef3$export$8352ce38b91d0c62; }, function (v) { return $f776d5a8b0cafef3$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b; }, function (v) { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555; }, function (v) { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $f776d5a8b0cafef3$export$839f9183b0465a69; }, function (v) { return $f776d5a8b0cafef3$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $f776d5a8b0cafef3$export$72fdf0e06517287b; }, function (v) { return $f776d5a8b0cafef3$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $f776d5a8b0cafef3$export$4b844e58a3e414b4; }, function (v) { return $f776d5a8b0cafef3$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $f776d5a8b0cafef3$export$816d2913ae6b83b1; }, function (v) { return $f776d5a8b0cafef3$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $f776d5a8b0cafef3$export$61bcfe829111a1d0; }, function (v) { return $f776d5a8b0cafef3$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f; }, function (v) { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $f776d5a8b0cafef3$export$b5836b71941fa3ed; }, function (v) { return $f776d5a8b0cafef3$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $f776d5a8b0cafef3$export$cf845f2c119da08a; }, function (v) { return $f776d5a8b0cafef3$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f776d5a8b0cafef3$export$c4744153514ff05d;
var $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7;
var $f776d5a8b0cafef3$export$e26fe2ed2fa76875;
var $f776d5a8b0cafef3$export$502329bbf4b505b1;
var $f776d5a8b0cafef3$export$6e3807111c4874c4;
var $f776d5a8b0cafef3$export$c27134553091fb3a;
var $f776d5a8b0cafef3$export$33ee1acdc04fd2a2;
var $f776d5a8b0cafef3$export$b00a404bbd5edef2;
var $f776d5a8b0cafef3$export$8352ce38b91d0c62;
var $f776d5a8b0cafef3$export$d66a1c1c77bd778b;
var $f776d5a8b0cafef3$export$d3dfb8e4810cb555;
var $f776d5a8b0cafef3$export$839f9183b0465a69;
var $f776d5a8b0cafef3$export$72fdf0e06517287b;
var $f776d5a8b0cafef3$export$4b844e58a3e414b4;
var $f776d5a8b0cafef3$export$816d2913ae6b83b1;
var $f776d5a8b0cafef3$export$61bcfe829111a1d0;
var $f776d5a8b0cafef3$export$7ee8c9beb337bc3f;
var $f776d5a8b0cafef3$export$b5836b71941fa3ed;
var $f776d5a8b0cafef3$export$cf845f2c119da08a;
"use strict";
function $f776d5a8b0cafef3$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $f776d5a8b0cafef3$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f776d5a8b0cafef3$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $f776d5a8b0cafef3$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $f776d5a8b0cafef3$var$g(C, c)) n < e && 0 > $f776d5a8b0cafef3$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $f776d5a8b0cafef3$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $f776d5a8b0cafef3$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f776d5a8b0cafef3$var$l = performance;
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$l.now();
    };
} else {
    var $f776d5a8b0cafef3$var$p = Date, $f776d5a8b0cafef3$var$q = $f776d5a8b0cafef3$var$p.now();
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$p.now() - $f776d5a8b0cafef3$var$q;
    };
}
var $f776d5a8b0cafef3$var$r = [], $f776d5a8b0cafef3$var$t = [], $f776d5a8b0cafef3$var$u = 1, $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = 3, $f776d5a8b0cafef3$var$z = !1, $f776d5a8b0cafef3$var$A = !1, $f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$D = "function" === typeof setTimeout ? setTimeout : null, $f776d5a8b0cafef3$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $f776d5a8b0cafef3$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $f776d5a8b0cafef3$var$G(a) {
    for(var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t); null !== b;){
        if (null === b.callback) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t);
        else if (b.startTime <= a) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t), b.sortIndex = b.expirationTime, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, b);
        else break;
        b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
    }
}
function $f776d5a8b0cafef3$var$H(a) {
    $f776d5a8b0cafef3$var$B = !1;
    $f776d5a8b0cafef3$var$G(a);
    if (!$f776d5a8b0cafef3$var$A) {
        if (null !== $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r)) $f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J);
        else {
            var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== b && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, b.startTime - a);
        }
    }
}
function $f776d5a8b0cafef3$var$J(a, b) {
    $f776d5a8b0cafef3$var$A = !1;
    $f776d5a8b0cafef3$var$B && ($f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1);
    $f776d5a8b0cafef3$var$z = !0;
    var c = $f776d5a8b0cafef3$var$y;
    try {
        $f776d5a8b0cafef3$var$G(b);
        for($f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r); null !== $f776d5a8b0cafef3$var$v && (!($f776d5a8b0cafef3$var$v.expirationTime > b) || a && !$f776d5a8b0cafef3$var$M());){
            var d = $f776d5a8b0cafef3$var$v.callback;
            if ("function" === typeof d) {
                $f776d5a8b0cafef3$var$v.callback = null;
                $f776d5a8b0cafef3$var$y = $f776d5a8b0cafef3$var$v.priorityLevel;
                var e = d($f776d5a8b0cafef3$var$v.expirationTime <= b);
                b = $f776d5a8b0cafef3$export$c4744153514ff05d();
                "function" === typeof e ? $f776d5a8b0cafef3$var$v.callback = e : $f776d5a8b0cafef3$var$v === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
                $f776d5a8b0cafef3$var$G(b);
            } else $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
            $f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
        }
        if (null !== $f776d5a8b0cafef3$var$v) var w = !0;
        else {
            var m = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== m && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = c, $f776d5a8b0cafef3$var$z = !1;
    }
}
var $f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null, $f776d5a8b0cafef3$var$L = -1, $f776d5a8b0cafef3$var$P = 5, $f776d5a8b0cafef3$var$Q = -1;
function $f776d5a8b0cafef3$var$M() {
    return $f776d5a8b0cafef3$export$c4744153514ff05d() - $f776d5a8b0cafef3$var$Q < $f776d5a8b0cafef3$var$P ? !1 : !0;
}
function $f776d5a8b0cafef3$var$R() {
    if (null !== $f776d5a8b0cafef3$var$O) {
        var a = $f776d5a8b0cafef3$export$c4744153514ff05d();
        $f776d5a8b0cafef3$var$Q = a;
        var b = !0;
        try {
            b = $f776d5a8b0cafef3$var$O(!0, a);
        } finally{
            b ? $f776d5a8b0cafef3$var$S() : ($f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null);
        }
    } else $f776d5a8b0cafef3$var$N = !1;
}
var $f776d5a8b0cafef3$var$S;
if ("function" === typeof $f776d5a8b0cafef3$var$F) $f776d5a8b0cafef3$var$S = function() {
    $f776d5a8b0cafef3$var$F($f776d5a8b0cafef3$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $f776d5a8b0cafef3$var$T = new MessageChannel, $f776d5a8b0cafef3$var$U = $f776d5a8b0cafef3$var$T.port2;
    $f776d5a8b0cafef3$var$T.port1.onmessage = $f776d5a8b0cafef3$var$R;
    $f776d5a8b0cafef3$var$S = function() {
        $f776d5a8b0cafef3$var$U.postMessage(null);
    };
} else $f776d5a8b0cafef3$var$S = function() {
    $f776d5a8b0cafef3$var$D($f776d5a8b0cafef3$var$R, 0);
};
function $f776d5a8b0cafef3$var$I(a) {
    $f776d5a8b0cafef3$var$O = a;
    $f776d5a8b0cafef3$var$N || ($f776d5a8b0cafef3$var$N = !0, $f776d5a8b0cafef3$var$S());
}
function $f776d5a8b0cafef3$var$K(a, b) {
    $f776d5a8b0cafef3$var$L = $f776d5a8b0cafef3$var$D(function() {
        a($f776d5a8b0cafef3$export$c4744153514ff05d());
    }, b);
}
$f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = 5;
$f776d5a8b0cafef3$export$e26fe2ed2fa76875 = 1;
$f776d5a8b0cafef3$export$502329bbf4b505b1 = 4;
$f776d5a8b0cafef3$export$6e3807111c4874c4 = 3;
$f776d5a8b0cafef3$export$c27134553091fb3a = null;
$f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = 2;
$f776d5a8b0cafef3$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f776d5a8b0cafef3$export$8352ce38b91d0c62 = function() {
    $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J));
};
$f776d5a8b0cafef3$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f776d5a8b0cafef3$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$f776d5a8b0cafef3$export$d3dfb8e4810cb555 = function() {
    return $f776d5a8b0cafef3$var$y;
};
$f776d5a8b0cafef3$export$839f9183b0465a69 = function() {
    return $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
};
$f776d5a8b0cafef3$export$72fdf0e06517287b = function(a) {
    switch($f776d5a8b0cafef3$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f776d5a8b0cafef3$var$y;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = b;
    try {
        return a();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$4b844e58a3e414b4 = function() {};
$f776d5a8b0cafef3$export$816d2913ae6b83b1 = function() {};
$f776d5a8b0cafef3$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = a;
    try {
        return b();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f776d5a8b0cafef3$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f776d5a8b0cafef3$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$t, a), null === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && a === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t) && ($f776d5a8b0cafef3$var$B ? ($f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1) : $f776d5a8b0cafef3$var$B = !0, $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, c - d))) : (a.sortIndex = e, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, a), $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J)));
    return a;
};
$f776d5a8b0cafef3$export$b5836b71941fa3ed = $f776d5a8b0cafef3$var$M;
$f776d5a8b0cafef3$export$cf845f2c119da08a = function(a) {
    var b = $f776d5a8b0cafef3$var$y;
    return function() {
        var c = $f776d5a8b0cafef3$var$y;
        $f776d5a8b0cafef3$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f776d5a8b0cafef3$var$y = c;
        }
    };
};

});



parcelRequire.register("aMJGV", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7da1d47045483a0e$var$ReactIs, $7da1d47045483a0e$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("lrct3"))();

});
parcelRequire.register("lrct3", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $aGGuH = parcelRequire("aGGuH");
function $f9b5ca6aeff231cf$var$emptyFunction() {}
function $f9b5ca6aeff231cf$var$emptyFunctionWithReset() {}
$f9b5ca6aeff231cf$var$emptyFunctionWithReset.resetWarningCache = $f9b5ca6aeff231cf$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $aGGuH) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $f9b5ca6aeff231cf$var$emptyFunctionWithReset,
        resetWarningCache: $f9b5ca6aeff231cf$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("aGGuH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $7c7eca1397927a3e$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $7c7eca1397927a3e$var$ReactPropTypesSecret;

});



parcelRequire.register("7Im6f", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $59ddc905a7c6a059$export$2b8d127b894957b9; }, function (v) { return $59ddc905a7c6a059$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $59ddc905a7c6a059$export$cea3a54a6425200c; }, function (v) { return $59ddc905a7c6a059$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $59ddc905a7c6a059$export$a7c73072b1a182ae; }, function (v) { return $59ddc905a7c6a059$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $59ddc905a7c6a059$export$9f27bc3417b4524d; }, function (v) { return $59ddc905a7c6a059$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $59ddc905a7c6a059$export$db77ccec0bb4ccac; }, function (v) { return $59ddc905a7c6a059$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $59ddc905a7c6a059$export$8392c0c9d3dcbd35; }, function (v) { return $59ddc905a7c6a059$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $59ddc905a7c6a059$export$ffb0004e005737fa; }, function (v) { return $59ddc905a7c6a059$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $59ddc905a7c6a059$export$b624eff549462981; }, function (v) { return $59ddc905a7c6a059$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $59ddc905a7c6a059$export$7897aa7841a5380c; }, function (v) { return $59ddc905a7c6a059$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $59ddc905a7c6a059$export$602eac185826482c; }, function (v) { return $59ddc905a7c6a059$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $59ddc905a7c6a059$export$e2c29f18771995cb; }, function (v) { return $59ddc905a7c6a059$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $59ddc905a7c6a059$export$5f8d39834fd61797; }, function (v) { return $59ddc905a7c6a059$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $59ddc905a7c6a059$export$74bf444e3cd11ea5; }, function (v) { return $59ddc905a7c6a059$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $59ddc905a7c6a059$export$92387174baf9b227; }, function (v) { return $59ddc905a7c6a059$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $59ddc905a7c6a059$export$ec112efeb987d9c6; }, function (v) { return $59ddc905a7c6a059$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $59ddc905a7c6a059$export$b706b080d889d2c9; }, function (v) { return $59ddc905a7c6a059$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $59ddc905a7c6a059$export$5be5a87408f70ddc; }, function (v) { return $59ddc905a7c6a059$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $59ddc905a7c6a059$export$45a5e7f76e0caa8d; }, function (v) { return $59ddc905a7c6a059$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $59ddc905a7c6a059$export$455c2e768291efa6; }, function (v) { return $59ddc905a7c6a059$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $59ddc905a7c6a059$export$9522e17588c12572; }, function (v) { return $59ddc905a7c6a059$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $59ddc905a7c6a059$export$2110ac352bb060b9; }, function (v) { return $59ddc905a7c6a059$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $59ddc905a7c6a059$export$56885ab8b9c456ab; }, function (v) { return $59ddc905a7c6a059$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $59ddc905a7c6a059$export$d927fcb6adf8f9de; }, function (v) { return $59ddc905a7c6a059$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $59ddc905a7c6a059$export$b82d16f27459e05a; }, function (v) { return $59ddc905a7c6a059$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $59ddc905a7c6a059$export$522c17b4f5e123e8; }, function (v) { return $59ddc905a7c6a059$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $59ddc905a7c6a059$export$1aabd8a0274ecfd6; }, function (v) { return $59ddc905a7c6a059$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $59ddc905a7c6a059$export$9b621391a187a31a; }, function (v) { return $59ddc905a7c6a059$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $59ddc905a7c6a059$export$f5bbd400c2f4426f; }, function (v) { return $59ddc905a7c6a059$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $59ddc905a7c6a059$export$2b8d127b894957b9;
var $59ddc905a7c6a059$export$cea3a54a6425200c;
var $59ddc905a7c6a059$export$a7c73072b1a182ae;
var $59ddc905a7c6a059$export$9f27bc3417b4524d;
var $59ddc905a7c6a059$export$db77ccec0bb4ccac;
var $59ddc905a7c6a059$export$8392c0c9d3dcbd35;
var $59ddc905a7c6a059$export$ffb0004e005737fa;
var $59ddc905a7c6a059$export$b624eff549462981;
var $59ddc905a7c6a059$export$7897aa7841a5380c;
var $59ddc905a7c6a059$export$602eac185826482c;
var $59ddc905a7c6a059$export$e2c29f18771995cb;
var $59ddc905a7c6a059$export$5f8d39834fd61797;
var $59ddc905a7c6a059$export$74bf444e3cd11ea5;
var $59ddc905a7c6a059$export$92387174baf9b227;
var $59ddc905a7c6a059$export$ec112efeb987d9c6;
var $59ddc905a7c6a059$export$b706b080d889d2c9;
var $59ddc905a7c6a059$export$5be5a87408f70ddc;
var $59ddc905a7c6a059$export$45a5e7f76e0caa8d;
var $59ddc905a7c6a059$export$455c2e768291efa6;
var $59ddc905a7c6a059$export$9522e17588c12572;
var $59ddc905a7c6a059$export$2110ac352bb060b9;
var $59ddc905a7c6a059$export$56885ab8b9c456ab;
var $59ddc905a7c6a059$export$d927fcb6adf8f9de;
var $59ddc905a7c6a059$export$b82d16f27459e05a;
var $59ddc905a7c6a059$export$522c17b4f5e123e8;
var $59ddc905a7c6a059$export$1aabd8a0274ecfd6;
var $59ddc905a7c6a059$export$9b621391a187a31a;
var $59ddc905a7c6a059$export$f5bbd400c2f4426f;
"use strict";
var $59ddc905a7c6a059$var$b = "function" === typeof Symbol && Symbol.for, $59ddc905a7c6a059$var$c = $59ddc905a7c6a059$var$b ? Symbol.for("react.element") : 60103, $59ddc905a7c6a059$var$d = $59ddc905a7c6a059$var$b ? Symbol.for("react.portal") : 60106, $59ddc905a7c6a059$var$e = $59ddc905a7c6a059$var$b ? Symbol.for("react.fragment") : 60107, $59ddc905a7c6a059$var$f = $59ddc905a7c6a059$var$b ? Symbol.for("react.strict_mode") : 60108, $59ddc905a7c6a059$var$g = $59ddc905a7c6a059$var$b ? Symbol.for("react.profiler") : 60114, $59ddc905a7c6a059$var$h = $59ddc905a7c6a059$var$b ? Symbol.for("react.provider") : 60109, $59ddc905a7c6a059$var$k = $59ddc905a7c6a059$var$b ? Symbol.for("react.context") : 60110, $59ddc905a7c6a059$var$l = $59ddc905a7c6a059$var$b ? Symbol.for("react.async_mode") : 60111, $59ddc905a7c6a059$var$m = $59ddc905a7c6a059$var$b ? Symbol.for("react.concurrent_mode") : 60111, $59ddc905a7c6a059$var$n = $59ddc905a7c6a059$var$b ? Symbol.for("react.forward_ref") : 60112, $59ddc905a7c6a059$var$p = $59ddc905a7c6a059$var$b ? Symbol.for("react.suspense") : 60113, $59ddc905a7c6a059$var$q = $59ddc905a7c6a059$var$b ? Symbol.for("react.suspense_list") : 60120, $59ddc905a7c6a059$var$r = $59ddc905a7c6a059$var$b ? Symbol.for("react.memo") : 60115, $59ddc905a7c6a059$var$t = $59ddc905a7c6a059$var$b ? Symbol.for("react.lazy") : 60116, $59ddc905a7c6a059$var$v = $59ddc905a7c6a059$var$b ? Symbol.for("react.block") : 60121, $59ddc905a7c6a059$var$w = $59ddc905a7c6a059$var$b ? Symbol.for("react.fundamental") : 60117, $59ddc905a7c6a059$var$x = $59ddc905a7c6a059$var$b ? Symbol.for("react.responder") : 60118, $59ddc905a7c6a059$var$y = $59ddc905a7c6a059$var$b ? Symbol.for("react.scope") : 60119;
function $59ddc905a7c6a059$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $59ddc905a7c6a059$var$c:
                switch(a = a.type, a){
                    case $59ddc905a7c6a059$var$l:
                    case $59ddc905a7c6a059$var$m:
                    case $59ddc905a7c6a059$var$e:
                    case $59ddc905a7c6a059$var$g:
                    case $59ddc905a7c6a059$var$f:
                    case $59ddc905a7c6a059$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $59ddc905a7c6a059$var$k:
                            case $59ddc905a7c6a059$var$n:
                            case $59ddc905a7c6a059$var$t:
                            case $59ddc905a7c6a059$var$r:
                            case $59ddc905a7c6a059$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $59ddc905a7c6a059$var$d:
                return u;
        }
    }
}
function $59ddc905a7c6a059$var$A(a) {
    return $59ddc905a7c6a059$var$z(a) === $59ddc905a7c6a059$var$m;
}
$59ddc905a7c6a059$export$2b8d127b894957b9 = $59ddc905a7c6a059$var$l;
$59ddc905a7c6a059$export$cea3a54a6425200c = $59ddc905a7c6a059$var$m;
$59ddc905a7c6a059$export$a7c73072b1a182ae = $59ddc905a7c6a059$var$k;
$59ddc905a7c6a059$export$9f27bc3417b4524d = $59ddc905a7c6a059$var$h;
$59ddc905a7c6a059$export$db77ccec0bb4ccac = $59ddc905a7c6a059$var$c;
$59ddc905a7c6a059$export$8392c0c9d3dcbd35 = $59ddc905a7c6a059$var$n;
$59ddc905a7c6a059$export$ffb0004e005737fa = $59ddc905a7c6a059$var$e;
$59ddc905a7c6a059$export$b624eff549462981 = $59ddc905a7c6a059$var$t;
$59ddc905a7c6a059$export$7897aa7841a5380c = $59ddc905a7c6a059$var$r;
$59ddc905a7c6a059$export$602eac185826482c = $59ddc905a7c6a059$var$d;
$59ddc905a7c6a059$export$e2c29f18771995cb = $59ddc905a7c6a059$var$g;
$59ddc905a7c6a059$export$5f8d39834fd61797 = $59ddc905a7c6a059$var$f;
$59ddc905a7c6a059$export$74bf444e3cd11ea5 = $59ddc905a7c6a059$var$p;
$59ddc905a7c6a059$export$92387174baf9b227 = function(a) {
    return $59ddc905a7c6a059$var$A(a) || $59ddc905a7c6a059$var$z(a) === $59ddc905a7c6a059$var$l;
};
$59ddc905a7c6a059$export$ec112efeb987d9c6 = $59ddc905a7c6a059$var$A;
$59ddc905a7c6a059$export$b706b080d889d2c9 = function(a) {
    return $59ddc905a7c6a059$var$z(a) === $59ddc905a7c6a059$var$k;
};
$59ddc905a7c6a059$export$5be5a87408f70ddc = function(a) {
    return $59ddc905a7c6a059$var$z(a) === $59ddc905a7c6a059$var$h;
};
$59ddc905a7c6a059$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $59ddc905a7c6a059$var$c;
};
$59ddc905a7c6a059$export$455c2e768291efa6 = function(a) {
    return $59ddc905a7c6a059$var$z(a) === $59ddc905a7c6a059$var$n;
};
$59ddc905a7c6a059$export$9522e17588c12572 = function(a) {
    return $59ddc905a7c6a059$var$z(a) === $59ddc905a7c6a059$var$e;
};
$59ddc905a7c6a059$export$2110ac352bb060b9 = function(a) {
    return $59ddc905a7c6a059$var$z(a) === $59ddc905a7c6a059$var$t;
};
$59ddc905a7c6a059$export$56885ab8b9c456ab = function(a) {
    return $59ddc905a7c6a059$var$z(a) === $59ddc905a7c6a059$var$r;
};
$59ddc905a7c6a059$export$d927fcb6adf8f9de = function(a) {
    return $59ddc905a7c6a059$var$z(a) === $59ddc905a7c6a059$var$d;
};
$59ddc905a7c6a059$export$b82d16f27459e05a = function(a) {
    return $59ddc905a7c6a059$var$z(a) === $59ddc905a7c6a059$var$g;
};
$59ddc905a7c6a059$export$522c17b4f5e123e8 = function(a) {
    return $59ddc905a7c6a059$var$z(a) === $59ddc905a7c6a059$var$f;
};
$59ddc905a7c6a059$export$1aabd8a0274ecfd6 = function(a) {
    return $59ddc905a7c6a059$var$z(a) === $59ddc905a7c6a059$var$p;
};
$59ddc905a7c6a059$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $59ddc905a7c6a059$var$e || a === $59ddc905a7c6a059$var$m || a === $59ddc905a7c6a059$var$g || a === $59ddc905a7c6a059$var$f || a === $59ddc905a7c6a059$var$p || a === $59ddc905a7c6a059$var$q || "object" === typeof a && null !== a && (a.$$typeof === $59ddc905a7c6a059$var$t || a.$$typeof === $59ddc905a7c6a059$var$r || a.$$typeof === $59ddc905a7c6a059$var$h || a.$$typeof === $59ddc905a7c6a059$var$k || a.$$typeof === $59ddc905a7c6a059$var$n || a.$$typeof === $59ddc905a7c6a059$var$w || a.$$typeof === $59ddc905a7c6a059$var$x || a.$$typeof === $59ddc905a7c6a059$var$y || a.$$typeof === $59ddc905a7c6a059$var$v);
};
$59ddc905a7c6a059$export$f5bbd400c2f4426f = $59ddc905a7c6a059$var$z;

});

parcelRequire.register("hFtc0", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $cdcce91081d78ae7$export$2b8d127b894957b9; }, function (v) { return $cdcce91081d78ae7$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $cdcce91081d78ae7$export$cea3a54a6425200c; }, function (v) { return $cdcce91081d78ae7$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $cdcce91081d78ae7$export$a7c73072b1a182ae; }, function (v) { return $cdcce91081d78ae7$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $cdcce91081d78ae7$export$9f27bc3417b4524d; }, function (v) { return $cdcce91081d78ae7$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $cdcce91081d78ae7$export$db77ccec0bb4ccac; }, function (v) { return $cdcce91081d78ae7$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $cdcce91081d78ae7$export$8392c0c9d3dcbd35; }, function (v) { return $cdcce91081d78ae7$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $cdcce91081d78ae7$export$ffb0004e005737fa; }, function (v) { return $cdcce91081d78ae7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $cdcce91081d78ae7$export$b624eff549462981; }, function (v) { return $cdcce91081d78ae7$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $cdcce91081d78ae7$export$7897aa7841a5380c; }, function (v) { return $cdcce91081d78ae7$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $cdcce91081d78ae7$export$602eac185826482c; }, function (v) { return $cdcce91081d78ae7$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $cdcce91081d78ae7$export$e2c29f18771995cb; }, function (v) { return $cdcce91081d78ae7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $cdcce91081d78ae7$export$5f8d39834fd61797; }, function (v) { return $cdcce91081d78ae7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $cdcce91081d78ae7$export$74bf444e3cd11ea5; }, function (v) { return $cdcce91081d78ae7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $cdcce91081d78ae7$export$92387174baf9b227; }, function (v) { return $cdcce91081d78ae7$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $cdcce91081d78ae7$export$ec112efeb987d9c6; }, function (v) { return $cdcce91081d78ae7$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $cdcce91081d78ae7$export$b706b080d889d2c9; }, function (v) { return $cdcce91081d78ae7$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $cdcce91081d78ae7$export$5be5a87408f70ddc; }, function (v) { return $cdcce91081d78ae7$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $cdcce91081d78ae7$export$45a5e7f76e0caa8d; }, function (v) { return $cdcce91081d78ae7$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $cdcce91081d78ae7$export$455c2e768291efa6; }, function (v) { return $cdcce91081d78ae7$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $cdcce91081d78ae7$export$9522e17588c12572; }, function (v) { return $cdcce91081d78ae7$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $cdcce91081d78ae7$export$2110ac352bb060b9; }, function (v) { return $cdcce91081d78ae7$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $cdcce91081d78ae7$export$56885ab8b9c456ab; }, function (v) { return $cdcce91081d78ae7$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $cdcce91081d78ae7$export$d927fcb6adf8f9de; }, function (v) { return $cdcce91081d78ae7$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $cdcce91081d78ae7$export$b82d16f27459e05a; }, function (v) { return $cdcce91081d78ae7$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $cdcce91081d78ae7$export$522c17b4f5e123e8; }, function (v) { return $cdcce91081d78ae7$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $cdcce91081d78ae7$export$1aabd8a0274ecfd6; }, function (v) { return $cdcce91081d78ae7$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $cdcce91081d78ae7$export$9b621391a187a31a; }, function (v) { return $cdcce91081d78ae7$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $cdcce91081d78ae7$export$f5bbd400c2f4426f; }, function (v) { return $cdcce91081d78ae7$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cdcce91081d78ae7$export$2b8d127b894957b9;
var $cdcce91081d78ae7$export$cea3a54a6425200c;
var $cdcce91081d78ae7$export$a7c73072b1a182ae;
var $cdcce91081d78ae7$export$9f27bc3417b4524d;
var $cdcce91081d78ae7$export$db77ccec0bb4ccac;
var $cdcce91081d78ae7$export$8392c0c9d3dcbd35;
var $cdcce91081d78ae7$export$ffb0004e005737fa;
var $cdcce91081d78ae7$export$b624eff549462981;
var $cdcce91081d78ae7$export$7897aa7841a5380c;
var $cdcce91081d78ae7$export$602eac185826482c;
var $cdcce91081d78ae7$export$e2c29f18771995cb;
var $cdcce91081d78ae7$export$5f8d39834fd61797;
var $cdcce91081d78ae7$export$74bf444e3cd11ea5;
var $cdcce91081d78ae7$export$92387174baf9b227;
var $cdcce91081d78ae7$export$ec112efeb987d9c6;
var $cdcce91081d78ae7$export$b706b080d889d2c9;
var $cdcce91081d78ae7$export$5be5a87408f70ddc;
var $cdcce91081d78ae7$export$45a5e7f76e0caa8d;
var $cdcce91081d78ae7$export$455c2e768291efa6;
var $cdcce91081d78ae7$export$9522e17588c12572;
var $cdcce91081d78ae7$export$2110ac352bb060b9;
var $cdcce91081d78ae7$export$56885ab8b9c456ab;
var $cdcce91081d78ae7$export$d927fcb6adf8f9de;
var $cdcce91081d78ae7$export$b82d16f27459e05a;
var $cdcce91081d78ae7$export$522c17b4f5e123e8;
var $cdcce91081d78ae7$export$1aabd8a0274ecfd6;
var $cdcce91081d78ae7$export$9b621391a187a31a;
var $cdcce91081d78ae7$export$f5bbd400c2f4426f;
"use strict";
var $cdcce91081d78ae7$var$b = "function" === typeof Symbol && Symbol.for, $cdcce91081d78ae7$var$c = $cdcce91081d78ae7$var$b ? Symbol.for("react.element") : 60103, $cdcce91081d78ae7$var$d = $cdcce91081d78ae7$var$b ? Symbol.for("react.portal") : 60106, $cdcce91081d78ae7$var$e = $cdcce91081d78ae7$var$b ? Symbol.for("react.fragment") : 60107, $cdcce91081d78ae7$var$f = $cdcce91081d78ae7$var$b ? Symbol.for("react.strict_mode") : 60108, $cdcce91081d78ae7$var$g = $cdcce91081d78ae7$var$b ? Symbol.for("react.profiler") : 60114, $cdcce91081d78ae7$var$h = $cdcce91081d78ae7$var$b ? Symbol.for("react.provider") : 60109, $cdcce91081d78ae7$var$k = $cdcce91081d78ae7$var$b ? Symbol.for("react.context") : 60110, $cdcce91081d78ae7$var$l = $cdcce91081d78ae7$var$b ? Symbol.for("react.async_mode") : 60111, $cdcce91081d78ae7$var$m = $cdcce91081d78ae7$var$b ? Symbol.for("react.concurrent_mode") : 60111, $cdcce91081d78ae7$var$n = $cdcce91081d78ae7$var$b ? Symbol.for("react.forward_ref") : 60112, $cdcce91081d78ae7$var$p = $cdcce91081d78ae7$var$b ? Symbol.for("react.suspense") : 60113, $cdcce91081d78ae7$var$q = $cdcce91081d78ae7$var$b ? Symbol.for("react.suspense_list") : 60120, $cdcce91081d78ae7$var$r = $cdcce91081d78ae7$var$b ? Symbol.for("react.memo") : 60115, $cdcce91081d78ae7$var$t = $cdcce91081d78ae7$var$b ? Symbol.for("react.lazy") : 60116, $cdcce91081d78ae7$var$v = $cdcce91081d78ae7$var$b ? Symbol.for("react.block") : 60121, $cdcce91081d78ae7$var$w = $cdcce91081d78ae7$var$b ? Symbol.for("react.fundamental") : 60117, $cdcce91081d78ae7$var$x = $cdcce91081d78ae7$var$b ? Symbol.for("react.responder") : 60118, $cdcce91081d78ae7$var$y = $cdcce91081d78ae7$var$b ? Symbol.for("react.scope") : 60119;
function $cdcce91081d78ae7$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $cdcce91081d78ae7$var$c:
                switch(a = a.type, a){
                    case $cdcce91081d78ae7$var$l:
                    case $cdcce91081d78ae7$var$m:
                    case $cdcce91081d78ae7$var$e:
                    case $cdcce91081d78ae7$var$g:
                    case $cdcce91081d78ae7$var$f:
                    case $cdcce91081d78ae7$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $cdcce91081d78ae7$var$k:
                            case $cdcce91081d78ae7$var$n:
                            case $cdcce91081d78ae7$var$t:
                            case $cdcce91081d78ae7$var$r:
                            case $cdcce91081d78ae7$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $cdcce91081d78ae7$var$d:
                return u;
        }
    }
}
function $cdcce91081d78ae7$var$A(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$m;
}
$cdcce91081d78ae7$export$2b8d127b894957b9 = $cdcce91081d78ae7$var$l;
$cdcce91081d78ae7$export$cea3a54a6425200c = $cdcce91081d78ae7$var$m;
$cdcce91081d78ae7$export$a7c73072b1a182ae = $cdcce91081d78ae7$var$k;
$cdcce91081d78ae7$export$9f27bc3417b4524d = $cdcce91081d78ae7$var$h;
$cdcce91081d78ae7$export$db77ccec0bb4ccac = $cdcce91081d78ae7$var$c;
$cdcce91081d78ae7$export$8392c0c9d3dcbd35 = $cdcce91081d78ae7$var$n;
$cdcce91081d78ae7$export$ffb0004e005737fa = $cdcce91081d78ae7$var$e;
$cdcce91081d78ae7$export$b624eff549462981 = $cdcce91081d78ae7$var$t;
$cdcce91081d78ae7$export$7897aa7841a5380c = $cdcce91081d78ae7$var$r;
$cdcce91081d78ae7$export$602eac185826482c = $cdcce91081d78ae7$var$d;
$cdcce91081d78ae7$export$e2c29f18771995cb = $cdcce91081d78ae7$var$g;
$cdcce91081d78ae7$export$5f8d39834fd61797 = $cdcce91081d78ae7$var$f;
$cdcce91081d78ae7$export$74bf444e3cd11ea5 = $cdcce91081d78ae7$var$p;
$cdcce91081d78ae7$export$92387174baf9b227 = function(a) {
    return $cdcce91081d78ae7$var$A(a) || $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$l;
};
$cdcce91081d78ae7$export$ec112efeb987d9c6 = $cdcce91081d78ae7$var$A;
$cdcce91081d78ae7$export$b706b080d889d2c9 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$k;
};
$cdcce91081d78ae7$export$5be5a87408f70ddc = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$h;
};
$cdcce91081d78ae7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cdcce91081d78ae7$var$c;
};
$cdcce91081d78ae7$export$455c2e768291efa6 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$n;
};
$cdcce91081d78ae7$export$9522e17588c12572 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$e;
};
$cdcce91081d78ae7$export$2110ac352bb060b9 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$t;
};
$cdcce91081d78ae7$export$56885ab8b9c456ab = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$r;
};
$cdcce91081d78ae7$export$d927fcb6adf8f9de = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$d;
};
$cdcce91081d78ae7$export$b82d16f27459e05a = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$g;
};
$cdcce91081d78ae7$export$522c17b4f5e123e8 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$f;
};
$cdcce91081d78ae7$export$1aabd8a0274ecfd6 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$p;
};
$cdcce91081d78ae7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $cdcce91081d78ae7$var$e || a === $cdcce91081d78ae7$var$m || a === $cdcce91081d78ae7$var$g || a === $cdcce91081d78ae7$var$f || a === $cdcce91081d78ae7$var$p || a === $cdcce91081d78ae7$var$q || "object" === typeof a && null !== a && (a.$$typeof === $cdcce91081d78ae7$var$t || a.$$typeof === $cdcce91081d78ae7$var$r || a.$$typeof === $cdcce91081d78ae7$var$h || a.$$typeof === $cdcce91081d78ae7$var$k || a.$$typeof === $cdcce91081d78ae7$var$n || a.$$typeof === $cdcce91081d78ae7$var$w || a.$$typeof === $cdcce91081d78ae7$var$x || a.$$typeof === $cdcce91081d78ae7$var$y || a.$$typeof === $cdcce91081d78ae7$var$v);
};
$cdcce91081d78ae7$export$f5bbd400c2f4426f = $cdcce91081d78ae7$var$z;

});

parcelRequire.register("6PPF0", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRequire.register("gzLuY", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $c114c26e12685207$export$a143d493d941bafc; }, function (v) { return $c114c26e12685207$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $c114c26e12685207$export$e4cf37d7f6fb9e0a; }, function (v) { return $c114c26e12685207$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $c114c26e12685207$export$f99ded8fe4b79145; }, function (v) { return $c114c26e12685207$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $c114c26e12685207$export$599f31c3813fae4d; }, function (v) { return $c114c26e12685207$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $c114c26e12685207$export$a143d493d941bafc;
var $c114c26e12685207$export$e4cf37d7f6fb9e0a;
var $c114c26e12685207$export$f99ded8fe4b79145;
var $c114c26e12685207$export$599f31c3813fae4d;
"use strict";

var $7LFKz = parcelRequire("7LFKz");

var $69U7b = parcelRequire("69U7b");
const $c114c26e12685207$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$c114c26e12685207$export$a143d493d941bafc = $c114c26e12685207$var$Buffer;
$c114c26e12685207$export$e4cf37d7f6fb9e0a = $c114c26e12685207$var$SlowBuffer;
$c114c26e12685207$export$f99ded8fe4b79145 = 50;
const $c114c26e12685207$var$K_MAX_LENGTH = 0x7fffffff;
$c114c26e12685207$export$599f31c3813fae4d = $c114c26e12685207$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT = $c114c26e12685207$var$typedArraySupport();
if (!$c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c114c26e12685207$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c114c26e12685207$var$createBuffer(length) {
    if (length > $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c114c26e12685207$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c114c26e12685207$var$allocUnsafe(arg);
    }
    return $c114c26e12685207$var$from(arg, encodingOrOffset, length);
}
$c114c26e12685207$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c114c26e12685207$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $c114c26e12685207$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c114c26e12685207$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($c114c26e12685207$var$isInstance(value, ArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, ArrayBuffer)) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($c114c26e12685207$var$isInstance(value, SharedArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, SharedArrayBuffer))) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c114c26e12685207$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $c114c26e12685207$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $c114c26e12685207$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c114c26e12685207$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c114c26e12685207$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c114c26e12685207$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c114c26e12685207$var$Buffer, Uint8Array);
function $c114c26e12685207$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c114c26e12685207$var$alloc(size, fill, encoding) {
    $c114c26e12685207$var$assertSize(size);
    if (size <= 0) return $c114c26e12685207$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $c114c26e12685207$var$createBuffer(size).fill(fill, encoding) : $c114c26e12685207$var$createBuffer(size).fill(fill);
    return $c114c26e12685207$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c114c26e12685207$var$Buffer.alloc = function(size, fill, encoding) {
    return $c114c26e12685207$var$alloc(size, fill, encoding);
};
function $c114c26e12685207$var$allocUnsafe(size) {
    $c114c26e12685207$var$assertSize(size);
    return $c114c26e12685207$var$createBuffer(size < 0 ? 0 : $c114c26e12685207$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c114c26e12685207$var$Buffer.allocUnsafe = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c114c26e12685207$var$Buffer.allocUnsafeSlow = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
function $c114c26e12685207$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $c114c26e12685207$var$byteLength(string, encoding) | 0;
    let buf = $c114c26e12685207$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c114c26e12685207$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $c114c26e12685207$var$checked(array.length) | 0;
    const buf = $c114c26e12685207$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c114c26e12685207$var$fromArrayView(arrayView) {
    if ($c114c26e12685207$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $c114c26e12685207$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c114c26e12685207$var$fromArrayLike(arrayView);
}
function $c114c26e12685207$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
function $c114c26e12685207$var$fromObject(obj) {
    if ($c114c26e12685207$var$Buffer.isBuffer(obj)) {
        const len = $c114c26e12685207$var$checked(obj.length) | 0;
        const buf = $c114c26e12685207$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $c114c26e12685207$var$numberIsNaN(obj.length)) return $c114c26e12685207$var$createBuffer(0);
        return $c114c26e12685207$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $c114c26e12685207$var$fromArrayLike(obj.data);
}
function $c114c26e12685207$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c114c26e12685207$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $c114c26e12685207$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c114c26e12685207$var$Buffer.alloc(+length);
}
$c114c26e12685207$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c114c26e12685207$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c114c26e12685207$var$Buffer.compare = function compare(a, b) {
    if ($c114c26e12685207$var$isInstance(a, Uint8Array)) a = $c114c26e12685207$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c114c26e12685207$var$isInstance(b, Uint8Array)) b = $c114c26e12685207$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(a) || !$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c114c26e12685207$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$c114c26e12685207$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c114c26e12685207$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $c114c26e12685207$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($c114c26e12685207$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) buf = $c114c26e12685207$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c114c26e12685207$var$byteLength(string, encoding) {
    if ($c114c26e12685207$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c114c26e12685207$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $c114c26e12685207$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c114c26e12685207$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c114c26e12685207$var$Buffer.byteLength = $c114c26e12685207$var$byteLength;
function $c114c26e12685207$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $c114c26e12685207$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8Slice(this, start, end);
        case "ascii":
            return $c114c26e12685207$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $c114c26e12685207$var$latin1Slice(this, start, end);
        case "base64":
            return $c114c26e12685207$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c114c26e12685207$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c114c26e12685207$var$Buffer.prototype._isBuffer = true;
function $c114c26e12685207$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c114c26e12685207$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$c114c26e12685207$var$swap(this, i, i + 1);
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $c114c26e12685207$var$swap(this, i, i + 3);
        $c114c26e12685207$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $c114c26e12685207$var$swap(this, i, i + 7);
        $c114c26e12685207$var$swap(this, i + 1, i + 6);
        $c114c26e12685207$var$swap(this, i + 2, i + 5);
        $c114c26e12685207$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $c114c26e12685207$var$utf8Slice(this, 0, length);
    return $c114c26e12685207$var$slowToString.apply(this, arguments);
};
$c114c26e12685207$var$Buffer.prototype.toLocaleString = $c114c26e12685207$var$Buffer.prototype.toString;
$c114c26e12685207$var$Buffer.prototype.equals = function equals(b) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $c114c26e12685207$var$Buffer.compare(this, b) === 0;
};
$c114c26e12685207$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $c114c26e12685207$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($c114c26e12685207$var$customInspectSymbol) $c114c26e12685207$var$Buffer.prototype[$c114c26e12685207$var$customInspectSymbol] = $c114c26e12685207$var$Buffer.prototype.inspect;
$c114c26e12685207$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c114c26e12685207$var$isInstance(target, Uint8Array)) target = $c114c26e12685207$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c114c26e12685207$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c114c26e12685207$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $c114c26e12685207$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c114c26e12685207$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c114c26e12685207$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c114c26e12685207$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $c114c26e12685207$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c114c26e12685207$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c114c26e12685207$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c114c26e12685207$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c114c26e12685207$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c114c26e12685207$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c114c26e12685207$var$utf8Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c114c26e12685207$var$asciiWrite(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$asciiToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$base64Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$base64ToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$ucs2Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c114c26e12685207$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $c114c26e12685207$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $c114c26e12685207$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $c114c26e12685207$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c114c26e12685207$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c114c26e12685207$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c114c26e12685207$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $7LFKz.fromByteArray(buf);
    else return $7LFKz.fromByteArray(buf.slice(start, end));
}
function $c114c26e12685207$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c114c26e12685207$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c114c26e12685207$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c114c26e12685207$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c114c26e12685207$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c114c26e12685207$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $c114c26e12685207$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c114c26e12685207$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c114c26e12685207$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c114c26e12685207$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c114c26e12685207$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$c114c26e12685207$var$Buffer.prototype.readUintLE = $c114c26e12685207$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUintBE = $c114c26e12685207$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUint8 = $c114c26e12685207$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c114c26e12685207$var$Buffer.prototype.readUint16LE = $c114c26e12685207$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c114c26e12685207$var$Buffer.prototype.readUint16BE = $c114c26e12685207$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c114c26e12685207$var$Buffer.prototype.readUint32LE = $c114c26e12685207$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c114c26e12685207$var$Buffer.prototype.readUint32BE = $c114c26e12685207$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c114c26e12685207$var$Buffer.prototype.readBigUInt64LE = $c114c26e12685207$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$c114c26e12685207$var$Buffer.prototype.readBigUInt64BE = $c114c26e12685207$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$c114c26e12685207$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c114c26e12685207$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c114c26e12685207$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c114c26e12685207$var$Buffer.prototype.readBigInt64LE = $c114c26e12685207$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$c114c26e12685207$var$Buffer.prototype.readBigInt64BE = $c114c26e12685207$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$c114c26e12685207$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $69U7b.read(this, offset, true, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $69U7b.read(this, offset, false, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $69U7b.read(this, offset, true, 52, 8);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $69U7b.read(this, offset, false, 52, 8);
};
function $c114c26e12685207$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$c114c26e12685207$var$Buffer.prototype.writeUintLE = $c114c26e12685207$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUintBE = $c114c26e12685207$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUint8 = $c114c26e12685207$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16LE = $c114c26e12685207$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16BE = $c114c26e12685207$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32LE = $c114c26e12685207$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32BE = $c114c26e12685207$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c114c26e12685207$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $c114c26e12685207$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeBigUInt64LE = $c114c26e12685207$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$c114c26e12685207$var$Buffer.prototype.writeBigUInt64BE = $c114c26e12685207$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$c114c26e12685207$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeBigInt64LE = $c114c26e12685207$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$c114c26e12685207$var$Buffer.prototype.writeBigInt64BE = $c114c26e12685207$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $c114c26e12685207$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $c114c26e12685207$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $69U7b.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c114c26e12685207$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, false, noAssert);
};
function $c114c26e12685207$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $69U7b.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c114c26e12685207$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c114c26e12685207$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $c114c26e12685207$var$Buffer.isBuffer(val) ? val : $c114c26e12685207$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $c114c26e12685207$var$errors = {};
function $c114c26e12685207$var$E(sym, getMessage, Base) {
    $c114c26e12685207$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$c114c26e12685207$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$c114c26e12685207$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$c114c26e12685207$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $c114c26e12685207$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $c114c26e12685207$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $c114c26e12685207$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $c114c26e12685207$var$checkBounds(buf, offset, byteLength) {
    $c114c26e12685207$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $c114c26e12685207$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $c114c26e12685207$var$checkBounds(buf, offset, byteLength);
}
function $c114c26e12685207$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $c114c26e12685207$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $c114c26e12685207$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $c114c26e12685207$var$validateNumber(value, type);
        throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $c114c26e12685207$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $c114c26e12685207$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c114c26e12685207$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c114c26e12685207$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $c114c26e12685207$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $c114c26e12685207$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c114c26e12685207$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c114c26e12685207$var$base64ToBytes(str) {
    return $7LFKz.toByteArray($c114c26e12685207$var$base64clean(str));
}
function $c114c26e12685207$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c114c26e12685207$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c114c26e12685207$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $c114c26e12685207$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $c114c26e12685207$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $c114c26e12685207$var$BufferBigIntNotDefined : fn;
}
function $c114c26e12685207$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRequire.register("7LFKz", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $5a7d4ee62d502cb1$export$d622b2ad8d90c771; }, function (v) { return $5a7d4ee62d502cb1$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $5a7d4ee62d502cb1$export$6100ba28696e12de; }, function (v) { return $5a7d4ee62d502cb1$export$6100ba28696e12de = v; });
var $5a7d4ee62d502cb1$export$a48f0734ac7c2329;
var $5a7d4ee62d502cb1$export$d622b2ad8d90c771;
var $5a7d4ee62d502cb1$export$6100ba28696e12de;
"use strict";
$5a7d4ee62d502cb1$export$a48f0734ac7c2329 = $5a7d4ee62d502cb1$var$byteLength;
$5a7d4ee62d502cb1$export$d622b2ad8d90c771 = $5a7d4ee62d502cb1$var$toByteArray;
$5a7d4ee62d502cb1$export$6100ba28696e12de = $5a7d4ee62d502cb1$var$fromByteArray;
var $5a7d4ee62d502cb1$var$lookup = [];
var $5a7d4ee62d502cb1$var$revLookup = [];
var $5a7d4ee62d502cb1$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $5a7d4ee62d502cb1$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $5a7d4ee62d502cb1$var$i = 0, $5a7d4ee62d502cb1$var$len = $5a7d4ee62d502cb1$var$code.length; $5a7d4ee62d502cb1$var$i < $5a7d4ee62d502cb1$var$len; ++$5a7d4ee62d502cb1$var$i){
    $5a7d4ee62d502cb1$var$lookup[$5a7d4ee62d502cb1$var$i] = $5a7d4ee62d502cb1$var$code[$5a7d4ee62d502cb1$var$i];
    $5a7d4ee62d502cb1$var$revLookup[$5a7d4ee62d502cb1$var$code.charCodeAt($5a7d4ee62d502cb1$var$i)] = $5a7d4ee62d502cb1$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$5a7d4ee62d502cb1$var$revLookup["-".charCodeAt(0)] = 62;
$5a7d4ee62d502cb1$var$revLookup["_".charCodeAt(0)] = 63;
function $5a7d4ee62d502cb1$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $5a7d4ee62d502cb1$var$byteLength(b64) {
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$toByteArray(b64) {
    var tmp;
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $5a7d4ee62d502cb1$var$Arr($5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 18 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 2 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 10 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $5a7d4ee62d502cb1$var$tripletToBase64(num) {
    return $5a7d4ee62d502cb1$var$lookup[num >> 18 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 12 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 6 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num & 0x3F];
}
function $5a7d4ee62d502cb1$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($5a7d4ee62d502cb1$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $5a7d4ee62d502cb1$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($5a7d4ee62d502cb1$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 2] + $5a7d4ee62d502cb1$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 10] + $5a7d4ee62d502cb1$var$lookup[tmp >> 4 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("69U7b", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942; }, function (v) { return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $47bf1c92b6d3ec4f$export$68d8715fc104d294; }, function (v) { return $47bf1c92b6d3ec4f$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $47bf1c92b6d3ec4f$export$aafa59e2e03f2942;
var $47bf1c92b6d3ec4f$export$68d8715fc104d294;
$47bf1c92b6d3ec4f$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$47bf1c92b6d3ec4f$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRequire.register("aqbQf", function(module, exports) {
"use strict";

});

parcelRequire.register("dKHN6", function(module, exports) {

var $aqbQf = parcelRequire("aqbQf");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $a0318a35c8c657ac$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $a0318a35c8c657ac$var$MAX_UINT32 = 4294967295;
function $a0318a35c8c657ac$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $eN0t8 = parcelRequire("eN0t8");
var $a0318a35c8c657ac$require$Buffer = $eN0t8.Buffer;
var $a0318a35c8c657ac$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($a0318a35c8c657ac$var$crypto && $a0318a35c8c657ac$var$crypto.getRandomValues) module.exports = $a0318a35c8c657ac$var$randomBytes;
else module.exports = $a0318a35c8c657ac$var$oldBrowser;
function $a0318a35c8c657ac$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $a0318a35c8c657ac$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $a0318a35c8c657ac$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $a0318a35c8c657ac$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $a0318a35c8c657ac$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $a0318a35c8c657ac$var$crypto.getRandomValues(bytes.slice(generated, generated + $a0318a35c8c657ac$var$MAX_BYTES));
        else $a0318a35c8c657ac$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $aqbQf.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRequire.register("eN0t8", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $gzLuY = parcelRequire("gzLuY");
var $ac460165df72f91c$var$Buffer = $gzLuY.Buffer;
// alternative to using Object.keys for old browsers
function $ac460165df72f91c$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($ac460165df72f91c$var$Buffer.from && $ac460165df72f91c$var$Buffer.alloc && $ac460165df72f91c$var$Buffer.allocUnsafe && $ac460165df72f91c$var$Buffer.allocUnsafeSlow) module.exports = $gzLuY;
else {
    // Copy properties from require('buffer')
    $ac460165df72f91c$var$copyProps($gzLuY, module.exports);
    module.exports.Buffer = $ac460165df72f91c$var$SafeBuffer;
}
function $ac460165df72f91c$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $ac460165df72f91c$var$Buffer(arg, encodingOrOffset, length);
}
$ac460165df72f91c$var$SafeBuffer.prototype = Object.create($ac460165df72f91c$var$Buffer.prototype);
// Copy static methods from Buffer
$ac460165df72f91c$var$copyProps($ac460165df72f91c$var$Buffer, $ac460165df72f91c$var$SafeBuffer);
$ac460165df72f91c$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $ac460165df72f91c$var$Buffer(arg, encodingOrOffset, length);
};
$ac460165df72f91c$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $ac460165df72f91c$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$ac460165df72f91c$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $ac460165df72f91c$var$Buffer(size);
};
$ac460165df72f91c$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $gzLuY.SlowBuffer(size);
};

});


parcelRequire.register("j8bQA", function(module, exports) {
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");

var $dGbYv = parcelRequire("dGbYv");

var $6B3Qg = parcelRequire("6B3Qg");

var $cWKoG = parcelRequire("cWKoG");

var $61MIM = parcelRequire("61MIM");
function $ded7f442553c17da$var$Hash(hash) {
    $61MIM.call(this, "digest");
    this._hash = hash;
}
$kvFQ5($ded7f442553c17da$var$Hash, $61MIM);
$ded7f442553c17da$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$ded7f442553c17da$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $dGbYv();
    if (alg === "rmd160" || alg === "ripemd160") return new $6B3Qg();
    return new $ded7f442553c17da$var$Hash($cWKoG(alg));
};

});
parcelRequire.register("kvFQ5", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRequire.register("dGbYv", function(module, exports) {
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");

var $4E6hc = parcelRequire("4E6hc");

var $eN0t8 = parcelRequire("eN0t8");
var $9f587c92ce2bd6b7$require$Buffer = $eN0t8.Buffer;
var $9f587c92ce2bd6b7$var$ARRAY16 = new Array(16);
function $9f587c92ce2bd6b7$var$MD5() {
    $4E6hc.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$kvFQ5($9f587c92ce2bd6b7$var$MD5, $4E6hc);
$9f587c92ce2bd6b7$var$MD5.prototype._update = function() {
    var M = $9f587c92ce2bd6b7$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $9f587c92ce2bd6b7$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $9f587c92ce2bd6b7$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $9f587c92ce2bd6b7$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $9f587c92ce2bd6b7$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $9f587c92ce2bd6b7$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $9f587c92ce2bd6b7$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $9f587c92ce2bd6b7$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $9f587c92ce2bd6b7$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $9f587c92ce2bd6b7$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $9f587c92ce2bd6b7$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $9f587c92ce2bd6b7$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $9f587c92ce2bd6b7$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $9f587c92ce2bd6b7$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $9f587c92ce2bd6b7$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $9f587c92ce2bd6b7$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $9f587c92ce2bd6b7$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $9f587c92ce2bd6b7$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $9f587c92ce2bd6b7$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $9f587c92ce2bd6b7$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $9f587c92ce2bd6b7$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $9f587c92ce2bd6b7$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $9f587c92ce2bd6b7$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $9f587c92ce2bd6b7$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $9f587c92ce2bd6b7$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $9f587c92ce2bd6b7$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $9f587c92ce2bd6b7$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $9f587c92ce2bd6b7$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $9f587c92ce2bd6b7$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $9f587c92ce2bd6b7$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $9f587c92ce2bd6b7$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $9f587c92ce2bd6b7$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $9f587c92ce2bd6b7$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $9f587c92ce2bd6b7$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $9f587c92ce2bd6b7$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $9f587c92ce2bd6b7$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $9f587c92ce2bd6b7$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $9f587c92ce2bd6b7$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $9f587c92ce2bd6b7$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $9f587c92ce2bd6b7$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $9f587c92ce2bd6b7$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $9f587c92ce2bd6b7$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $9f587c92ce2bd6b7$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $9f587c92ce2bd6b7$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $9f587c92ce2bd6b7$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $9f587c92ce2bd6b7$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $9f587c92ce2bd6b7$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $9f587c92ce2bd6b7$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $9f587c92ce2bd6b7$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $9f587c92ce2bd6b7$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $9f587c92ce2bd6b7$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $9f587c92ce2bd6b7$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $9f587c92ce2bd6b7$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $9f587c92ce2bd6b7$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $9f587c92ce2bd6b7$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $9f587c92ce2bd6b7$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $9f587c92ce2bd6b7$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $9f587c92ce2bd6b7$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $9f587c92ce2bd6b7$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $9f587c92ce2bd6b7$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $9f587c92ce2bd6b7$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $9f587c92ce2bd6b7$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $9f587c92ce2bd6b7$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $9f587c92ce2bd6b7$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $9f587c92ce2bd6b7$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$9f587c92ce2bd6b7$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $9f587c92ce2bd6b7$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $9f587c92ce2bd6b7$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $9f587c92ce2bd6b7$var$fnF(a, b, c, d, m, k, s) {
    return $9f587c92ce2bd6b7$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $9f587c92ce2bd6b7$var$fnG(a, b, c, d, m, k, s) {
    return $9f587c92ce2bd6b7$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $9f587c92ce2bd6b7$var$fnH(a, b, c, d, m, k, s) {
    return $9f587c92ce2bd6b7$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $9f587c92ce2bd6b7$var$fnI(a, b, c, d, m, k, s) {
    return $9f587c92ce2bd6b7$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $9f587c92ce2bd6b7$var$MD5;

});
parcelRequire.register("4E6hc", function(module, exports) {
"use strict";

var $eN0t8 = parcelRequire("eN0t8");
var $361fc43cbe8e0873$require$Buffer = $eN0t8.Buffer;

var $CyGSj = parcelRequire("CyGSj");
var $361fc43cbe8e0873$require$Transform = $CyGSj.Transform;

var $kvFQ5 = parcelRequire("kvFQ5");
function $361fc43cbe8e0873$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$361fc43cbe8e0873$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $361fc43cbe8e0873$var$HashBase(blockSize) {
    $361fc43cbe8e0873$require$Transform.call(this);
    this._block = $361fc43cbe8e0873$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$kvFQ5($361fc43cbe8e0873$var$HashBase, $361fc43cbe8e0873$require$Transform);
$361fc43cbe8e0873$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$361fc43cbe8e0873$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$361fc43cbe8e0873$var$HashBase.prototype.update = function(data, encoding) {
    $361fc43cbe8e0873$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$361fc43cbe8e0873$require$Buffer.isBuffer(data)) data = $361fc43cbe8e0873$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$361fc43cbe8e0873$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$361fc43cbe8e0873$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$361fc43cbe8e0873$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $361fc43cbe8e0873$var$HashBase;

});
parcelRequire.register("CyGSj", function(module, exports) {

exports = module.exports = (parcelRequire("hJHBh"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("3AY6k"));

exports.Duplex = (parcelRequire("kTUB1"));

exports.Transform = (parcelRequire("9wbVx"));

exports.PassThrough = (parcelRequire("3Frfy"));

exports.finished = (parcelRequire("i1zMF"));

exports.pipeline = (parcelRequire("hI05B"));

});
parcelRequire.register("hJHBh", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $aqbQf = parcelRequire("aqbQf");
"use strict";
module.exports = $ce9875b997915245$var$Readable;
/*<replacement>*/ var $ce9875b997915245$var$Duplex;
/*</replacement>*/ $ce9875b997915245$var$Readable.ReadableState = $ce9875b997915245$var$ReadableState;

var $wvaTc = parcelRequire("wvaTc");
var $ce9875b997915245$require$EE = $wvaTc.EventEmitter;
var $ce9875b997915245$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $7GgdY = parcelRequire("7GgdY");

var $gzLuY = parcelRequire("gzLuY");
var $ce9875b997915245$require$Buffer = $gzLuY.Buffer;
var $ce9875b997915245$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $ce9875b997915245$var$_uint8ArrayToBuffer(chunk) {
    return $ce9875b997915245$require$Buffer.from(chunk);
}
function $ce9875b997915245$var$_isUint8Array(obj) {
    return $ce9875b997915245$require$Buffer.isBuffer(obj) || obj instanceof $ce9875b997915245$var$OurUint8Array;
}

var $aqbQf = parcelRequire("aqbQf");
var $ce9875b997915245$var$debug;
if ($aqbQf && $aqbQf.debuglog) $ce9875b997915245$var$debug = $aqbQf.debuglog("stream");
else $ce9875b997915245$var$debug = function debug() {};

var $9ZPuZ = parcelRequire("9ZPuZ");

var $g2D2d = parcelRequire("g2D2d");

var $hLWAy = parcelRequire("hLWAy");
var $ce9875b997915245$var$getHighWaterMark = $hLWAy.getHighWaterMark;

var $5qPK0 = parcelRequire("5qPK0");
var $ce9875b997915245$require$_require$codes = $5qPK0.codes;
var $ce9875b997915245$var$ERR_INVALID_ARG_TYPE = $ce9875b997915245$require$_require$codes.ERR_INVALID_ARG_TYPE, $ce9875b997915245$var$ERR_STREAM_PUSH_AFTER_EOF = $ce9875b997915245$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $ce9875b997915245$var$ERR_METHOD_NOT_IMPLEMENTED = $ce9875b997915245$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $ce9875b997915245$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $ce9875b997915245$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $ce9875b997915245$var$StringDecoder;
var $ce9875b997915245$var$createReadableStreamAsyncIterator;
var $ce9875b997915245$var$from;

(parcelRequire("kvFQ5"))($ce9875b997915245$var$Readable, $7GgdY);
var $ce9875b997915245$var$errorOrDestroy = $g2D2d.errorOrDestroy;
var $ce9875b997915245$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $ce9875b997915245$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $ce9875b997915245$var$ReadableState(options, stream, isDuplex) {
    $ce9875b997915245$var$Duplex = $ce9875b997915245$var$Duplex || (parcelRequire("kTUB1"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $ce9875b997915245$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $ce9875b997915245$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $9ZPuZ();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$ce9875b997915245$var$StringDecoder) $ce9875b997915245$var$StringDecoder = (parcelRequire("hXidu")).StringDecoder;
        this.decoder = new $ce9875b997915245$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $ce9875b997915245$var$Readable(options) {
    $ce9875b997915245$var$Duplex = $ce9875b997915245$var$Duplex || (parcelRequire("kTUB1"));
    if (!(this instanceof $ce9875b997915245$var$Readable)) return new $ce9875b997915245$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $ce9875b997915245$var$Duplex;
    this._readableState = new $ce9875b997915245$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $7GgdY.call(this);
}
Object.defineProperty($ce9875b997915245$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$ce9875b997915245$var$Readable.prototype.destroy = $g2D2d.destroy;
$ce9875b997915245$var$Readable.prototype._undestroy = $g2D2d.undestroy;
$ce9875b997915245$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$ce9875b997915245$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $ce9875b997915245$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $ce9875b997915245$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$ce9875b997915245$var$Readable.prototype.unshift = function(chunk) {
    return $ce9875b997915245$var$readableAddChunk(this, chunk, null, true, false);
};
function $ce9875b997915245$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $ce9875b997915245$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $ce9875b997915245$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $ce9875b997915245$var$chunkInvalid(state, chunk);
        if (er) $ce9875b997915245$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $ce9875b997915245$require$Buffer.prototype) chunk = $ce9875b997915245$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $ce9875b997915245$var$errorOrDestroy(stream, new $ce9875b997915245$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $ce9875b997915245$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $ce9875b997915245$var$errorOrDestroy(stream, new $ce9875b997915245$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $ce9875b997915245$var$addChunk(stream, state, chunk, false);
                    else $ce9875b997915245$var$maybeReadMore(stream, state);
                } else $ce9875b997915245$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $ce9875b997915245$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $ce9875b997915245$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $ce9875b997915245$var$emitReadable(stream);
    }
    $ce9875b997915245$var$maybeReadMore(stream, state);
}
function $ce9875b997915245$var$chunkInvalid(state, chunk) {
    var er;
    if (!$ce9875b997915245$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $ce9875b997915245$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$ce9875b997915245$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$ce9875b997915245$var$Readable.prototype.setEncoding = function(enc) {
    if (!$ce9875b997915245$var$StringDecoder) $ce9875b997915245$var$StringDecoder = (parcelRequire("hXidu")).StringDecoder;
    var decoder = new $ce9875b997915245$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $ce9875b997915245$var$MAX_HWM = 0x40000000;
function $ce9875b997915245$var$computeNewHighWaterMark(n) {
    if (n >= $ce9875b997915245$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $ce9875b997915245$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $ce9875b997915245$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $ce9875b997915245$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$ce9875b997915245$var$Readable.prototype.read = function(n) {
    $ce9875b997915245$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $ce9875b997915245$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $ce9875b997915245$var$endReadable(this);
        else $ce9875b997915245$var$emitReadable(this);
        return null;
    }
    n = $ce9875b997915245$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $ce9875b997915245$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $ce9875b997915245$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $ce9875b997915245$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $ce9875b997915245$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $ce9875b997915245$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $ce9875b997915245$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $ce9875b997915245$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $ce9875b997915245$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $ce9875b997915245$var$onEofChunk(stream, state) {
    $ce9875b997915245$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $ce9875b997915245$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $ce9875b997915245$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $ce9875b997915245$var$emitReadable(stream) {
    var state = stream._readableState;
    $ce9875b997915245$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $ce9875b997915245$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $aqbQf.nextTick($ce9875b997915245$var$emitReadable_, stream);
    }
}
function $ce9875b997915245$var$emitReadable_(stream) {
    var state = stream._readableState;
    $ce9875b997915245$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $ce9875b997915245$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $ce9875b997915245$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $aqbQf.nextTick($ce9875b997915245$var$maybeReadMore_, stream, state);
    }
}
function $ce9875b997915245$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $ce9875b997915245$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$ce9875b997915245$var$Readable.prototype._read = function(n) {
    $ce9875b997915245$var$errorOrDestroy(this, new $ce9875b997915245$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$ce9875b997915245$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $ce9875b997915245$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $aqbQf.stdout && dest !== $aqbQf.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $aqbQf.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $ce9875b997915245$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $ce9875b997915245$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $ce9875b997915245$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $ce9875b997915245$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $ce9875b997915245$var$debug("ondata");
        var ret = dest.write(chunk);
        $ce9875b997915245$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $ce9875b997915245$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $ce9875b997915245$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $ce9875b997915245$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($ce9875b997915245$var$EElistenerCount(dest, "error") === 0) $ce9875b997915245$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $ce9875b997915245$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $ce9875b997915245$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $ce9875b997915245$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $ce9875b997915245$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $ce9875b997915245$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $ce9875b997915245$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $ce9875b997915245$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $ce9875b997915245$var$flow(src);
        }
    };
}
$ce9875b997915245$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $ce9875b997915245$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$ce9875b997915245$var$Readable.prototype.on = function(ev, fn) {
    var res = $7GgdY.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $ce9875b997915245$var$debug("on readable", state.length, state.reading);
            if (state.length) $ce9875b997915245$var$emitReadable(this);
            else if (!state.reading) $aqbQf.nextTick($ce9875b997915245$var$nReadingNextTick, this);
        }
    }
    return res;
};
$ce9875b997915245$var$Readable.prototype.addListener = $ce9875b997915245$var$Readable.prototype.on;
$ce9875b997915245$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $7GgdY.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $aqbQf.nextTick($ce9875b997915245$var$updateReadableListening, this);
    return res;
};
$ce9875b997915245$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $7GgdY.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $aqbQf.nextTick($ce9875b997915245$var$updateReadableListening, this);
    return res;
};
function $ce9875b997915245$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $ce9875b997915245$var$nReadingNextTick(self1) {
    $ce9875b997915245$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$ce9875b997915245$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $ce9875b997915245$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $ce9875b997915245$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $ce9875b997915245$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $aqbQf.nextTick($ce9875b997915245$var$resume_, stream, state);
    }
}
function $ce9875b997915245$var$resume_(stream, state) {
    $ce9875b997915245$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $ce9875b997915245$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$ce9875b997915245$var$Readable.prototype.pause = function() {
    $ce9875b997915245$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $ce9875b997915245$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $ce9875b997915245$var$flow(stream) {
    var state = stream._readableState;
    $ce9875b997915245$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$ce9875b997915245$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $ce9875b997915245$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $ce9875b997915245$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $ce9875b997915245$var$kProxyEvents.length; n++)stream.on($ce9875b997915245$var$kProxyEvents[n], this.emit.bind(this, $ce9875b997915245$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $ce9875b997915245$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $ce9875b997915245$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($ce9875b997915245$var$createReadableStreamAsyncIterator === undefined) $ce9875b997915245$var$createReadableStreamAsyncIterator = (parcelRequire("1WvTd"));
    return $ce9875b997915245$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($ce9875b997915245$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($ce9875b997915245$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($ce9875b997915245$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$ce9875b997915245$var$Readable._fromList = $ce9875b997915245$var$fromList;
Object.defineProperty($ce9875b997915245$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $ce9875b997915245$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $ce9875b997915245$var$endReadable(stream) {
    var state = stream._readableState;
    $ce9875b997915245$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $aqbQf.nextTick($ce9875b997915245$var$endReadableNT, state, stream);
    }
}
function $ce9875b997915245$var$endReadableNT(state, stream) {
    $ce9875b997915245$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $ce9875b997915245$var$Readable.from = function(iterable, opts) {
    if ($ce9875b997915245$var$from === undefined) $ce9875b997915245$var$from = (parcelRequire("1YZki"));
    return $ce9875b997915245$var$from($ce9875b997915245$var$Readable, iterable, opts);
};
function $ce9875b997915245$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRequire.register("wvaTc", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $061b2be80523d29d$var$R = typeof Reflect === "object" ? Reflect : null;
var $061b2be80523d29d$var$ReflectApply = $061b2be80523d29d$var$R && typeof $061b2be80523d29d$var$R.apply === "function" ? $061b2be80523d29d$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $061b2be80523d29d$var$ReflectOwnKeys;
if ($061b2be80523d29d$var$R && typeof $061b2be80523d29d$var$R.ownKeys === "function") $061b2be80523d29d$var$ReflectOwnKeys = $061b2be80523d29d$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $061b2be80523d29d$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $061b2be80523d29d$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $061b2be80523d29d$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $061b2be80523d29d$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $061b2be80523d29d$var$EventEmitter() {
    $061b2be80523d29d$var$EventEmitter.init.call(this);
}
module.exports = $061b2be80523d29d$var$EventEmitter;
module.exports.once = $061b2be80523d29d$var$once;
// Backwards-compat with node 0.10.x
$061b2be80523d29d$var$EventEmitter.EventEmitter = $061b2be80523d29d$var$EventEmitter;
$061b2be80523d29d$var$EventEmitter.prototype._events = undefined;
$061b2be80523d29d$var$EventEmitter.prototype._eventsCount = 0;
$061b2be80523d29d$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $061b2be80523d29d$var$defaultMaxListeners = 10;
function $061b2be80523d29d$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($061b2be80523d29d$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $061b2be80523d29d$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $061b2be80523d29d$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $061b2be80523d29d$var$defaultMaxListeners = arg;
    }
});
$061b2be80523d29d$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$061b2be80523d29d$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $061b2be80523d29d$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $061b2be80523d29d$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $061b2be80523d29d$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$061b2be80523d29d$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $061b2be80523d29d$var$_getMaxListeners(this);
};
$061b2be80523d29d$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $061b2be80523d29d$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $061b2be80523d29d$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$061b2be80523d29d$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $061b2be80523d29d$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $061b2be80523d29d$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $061b2be80523d29d$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $061b2be80523d29d$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$061b2be80523d29d$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $061b2be80523d29d$var$_addListener(this, type, listener, false);
};
$061b2be80523d29d$var$EventEmitter.prototype.on = $061b2be80523d29d$var$EventEmitter.prototype.addListener;
$061b2be80523d29d$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $061b2be80523d29d$var$_addListener(this, type, listener, true);
};
function $061b2be80523d29d$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $061b2be80523d29d$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $061b2be80523d29d$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$061b2be80523d29d$var$EventEmitter.prototype.once = function once(type, listener) {
    $061b2be80523d29d$var$checkListener(listener);
    this.on(type, $061b2be80523d29d$var$_onceWrap(this, type, listener));
    return this;
};
$061b2be80523d29d$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $061b2be80523d29d$var$checkListener(listener);
    this.prependListener(type, $061b2be80523d29d$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$061b2be80523d29d$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $061b2be80523d29d$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $061b2be80523d29d$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$061b2be80523d29d$var$EventEmitter.prototype.off = $061b2be80523d29d$var$EventEmitter.prototype.removeListener;
$061b2be80523d29d$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $061b2be80523d29d$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $061b2be80523d29d$var$unwrapListeners(evlistener) : $061b2be80523d29d$var$arrayClone(evlistener, evlistener.length);
}
$061b2be80523d29d$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $061b2be80523d29d$var$_listeners(this, type, true);
};
$061b2be80523d29d$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $061b2be80523d29d$var$_listeners(this, type, false);
};
$061b2be80523d29d$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $061b2be80523d29d$var$listenerCount.call(emitter, type);
};
$061b2be80523d29d$var$EventEmitter.prototype.listenerCount = $061b2be80523d29d$var$listenerCount;
function $061b2be80523d29d$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$061b2be80523d29d$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $061b2be80523d29d$var$ReflectOwnKeys(this._events) : [];
};
function $061b2be80523d29d$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $061b2be80523d29d$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $061b2be80523d29d$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $061b2be80523d29d$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $061b2be80523d29d$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $061b2be80523d29d$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $061b2be80523d29d$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $061b2be80523d29d$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $061b2be80523d29d$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRequire.register("7GgdY", function(module, exports) {

module.exports = (parcelRequire("wvaTc")).EventEmitter;

});

parcelRequire.register("9ZPuZ", function(module, exports) {
"use strict";
function $7471c22bb1509672$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7471c22bb1509672$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7471c22bb1509672$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7471c22bb1509672$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7471c22bb1509672$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7471c22bb1509672$var$_defineProperty(obj, key, value) {
    key = $7471c22bb1509672$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7471c22bb1509672$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7471c22bb1509672$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7471c22bb1509672$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7471c22bb1509672$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7471c22bb1509672$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7471c22bb1509672$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7471c22bb1509672$var$_toPropertyKey(arg) {
    var key = $7471c22bb1509672$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $7471c22bb1509672$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $gzLuY = parcelRequire("gzLuY");
var $7471c22bb1509672$var$Buffer = $gzLuY.Buffer;

var $aqbQf = parcelRequire("aqbQf");
var $7471c22bb1509672$var$inspect = $aqbQf.inspect;
var $7471c22bb1509672$var$custom = $7471c22bb1509672$var$inspect && $7471c22bb1509672$var$inspect.custom || "inspect";
function $7471c22bb1509672$var$copyBuffer(src, target, offset) {
    $7471c22bb1509672$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $7471c22bb1509672$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $7471c22bb1509672$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $7471c22bb1509672$var$Buffer.alloc(0);
                var ret = $7471c22bb1509672$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $7471c22bb1509672$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $7471c22bb1509672$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $7471c22bb1509672$var$custom,
            value: function value(_, options) {
                return $7471c22bb1509672$var$inspect(this, $7471c22bb1509672$var$_objectSpread($7471c22bb1509672$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRequire.register("g2D2d", function(module, exports) {

var $aqbQf = parcelRequire("aqbQf");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $badb1cb95d5d9905$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $aqbQf.nextTick($badb1cb95d5d9905$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $aqbQf.nextTick($badb1cb95d5d9905$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $aqbQf.nextTick($badb1cb95d5d9905$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $aqbQf.nextTick($badb1cb95d5d9905$var$emitErrorAndCloseNT, _this, err);
            } else $aqbQf.nextTick($badb1cb95d5d9905$var$emitCloseNT, _this);
        } else if (cb) {
            $aqbQf.nextTick($badb1cb95d5d9905$var$emitCloseNT, _this);
            cb(err);
        } else $aqbQf.nextTick($badb1cb95d5d9905$var$emitCloseNT, _this);
    });
    return this;
}
function $badb1cb95d5d9905$var$emitErrorAndCloseNT(self, err) {
    $badb1cb95d5d9905$var$emitErrorNT(self, err);
    $badb1cb95d5d9905$var$emitCloseNT(self);
}
function $badb1cb95d5d9905$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $badb1cb95d5d9905$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $badb1cb95d5d9905$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $badb1cb95d5d9905$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $badb1cb95d5d9905$var$destroy,
    undestroy: $badb1cb95d5d9905$var$undestroy,
    errorOrDestroy: $badb1cb95d5d9905$var$errorOrDestroy
};

});

parcelRequire.register("hLWAy", function(module, exports) {
"use strict";

var $5qPK0 = parcelRequire("5qPK0");
var $cf0445f13e49d7ed$var$ERR_INVALID_OPT_VALUE = $5qPK0.codes.ERR_INVALID_OPT_VALUE;
function $cf0445f13e49d7ed$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $cf0445f13e49d7ed$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $cf0445f13e49d7ed$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $cf0445f13e49d7ed$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $cf0445f13e49d7ed$var$getHighWaterMark
};

});
parcelRequire.register("5qPK0", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $3f478427523a4e7d$export$e45cb6485273080e; }, function (v) { return $3f478427523a4e7d$export$e45cb6485273080e = v; });
var $3f478427523a4e7d$export$e45cb6485273080e;
"use strict";
function $3f478427523a4e7d$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $3f478427523a4e7d$var$codes = {};
function $3f478427523a4e7d$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $3f478427523a4e7d$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $3f478427523a4e7d$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $3f478427523a4e7d$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $3f478427523a4e7d$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $3f478427523a4e7d$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $3f478427523a4e7d$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$3f478427523a4e7d$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$3f478427523a4e7d$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $3f478427523a4e7d$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($3f478427523a4e7d$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($3f478427523a4e7d$var$oneOf(expected, "type"));
    else {
        var type = $3f478427523a4e7d$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($3f478427523a4e7d$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$3f478427523a4e7d$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$3f478427523a4e7d$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$3f478427523a4e7d$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$3f478427523a4e7d$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$3f478427523a4e7d$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$3f478427523a4e7d$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$3f478427523a4e7d$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$3f478427523a4e7d$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$3f478427523a4e7d$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$3f478427523a4e7d$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$3f478427523a4e7d$export$e45cb6485273080e = $3f478427523a4e7d$var$codes;

});


parcelRequire.register("kTUB1", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $aqbQf = parcelRequire("aqbQf");
"use strict";
/*<replacement>*/ var $f374d88020dc5730$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $f374d88020dc5730$var$Duplex;

var $hJHBh = parcelRequire("hJHBh");

var $3AY6k = parcelRequire("3AY6k");

(parcelRequire("kvFQ5"))($f374d88020dc5730$var$Duplex, $hJHBh);
// Allow the keys array to be GC'ed.
var $f374d88020dc5730$var$keys = $f374d88020dc5730$var$objectKeys($3AY6k.prototype);
for(var $f374d88020dc5730$var$v = 0; $f374d88020dc5730$var$v < $f374d88020dc5730$var$keys.length; $f374d88020dc5730$var$v++){
    var $f374d88020dc5730$var$method = $f374d88020dc5730$var$keys[$f374d88020dc5730$var$v];
    if (!$f374d88020dc5730$var$Duplex.prototype[$f374d88020dc5730$var$method]) $f374d88020dc5730$var$Duplex.prototype[$f374d88020dc5730$var$method] = $3AY6k.prototype[$f374d88020dc5730$var$method];
}
function $f374d88020dc5730$var$Duplex(options) {
    if (!(this instanceof $f374d88020dc5730$var$Duplex)) return new $f374d88020dc5730$var$Duplex(options);
    $hJHBh.call(this, options);
    $3AY6k.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $f374d88020dc5730$var$onend);
        }
    }
}
Object.defineProperty($f374d88020dc5730$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($f374d88020dc5730$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($f374d88020dc5730$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $f374d88020dc5730$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $aqbQf.nextTick($f374d88020dc5730$var$onEndNT, this);
}
function $f374d88020dc5730$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($f374d88020dc5730$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRequire.register("3AY6k", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $aqbQf = parcelRequire("aqbQf");
"use strict";
module.exports = $29e35ab028f8b978$var$Writable;
/* <replacement> */ function $29e35ab028f8b978$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $29e35ab028f8b978$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $29e35ab028f8b978$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $29e35ab028f8b978$var$Duplex;
/*</replacement>*/ $29e35ab028f8b978$var$Writable.WritableState = $29e35ab028f8b978$var$WritableState;

/*<replacement>*/ var $29e35ab028f8b978$var$internalUtil = {
    deprecate: (parcelRequire("hPIqS"))
};

var $7GgdY = parcelRequire("7GgdY");

var $gzLuY = parcelRequire("gzLuY");
var $29e35ab028f8b978$require$Buffer = $gzLuY.Buffer;
var $29e35ab028f8b978$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $29e35ab028f8b978$var$_uint8ArrayToBuffer(chunk) {
    return $29e35ab028f8b978$require$Buffer.from(chunk);
}
function $29e35ab028f8b978$var$_isUint8Array(obj) {
    return $29e35ab028f8b978$require$Buffer.isBuffer(obj) || obj instanceof $29e35ab028f8b978$var$OurUint8Array;
}

var $g2D2d = parcelRequire("g2D2d");

var $hLWAy = parcelRequire("hLWAy");
var $29e35ab028f8b978$var$getHighWaterMark = $hLWAy.getHighWaterMark;

var $5qPK0 = parcelRequire("5qPK0");
var $29e35ab028f8b978$require$_require$codes = $5qPK0.codes;
var $29e35ab028f8b978$var$ERR_INVALID_ARG_TYPE = $29e35ab028f8b978$require$_require$codes.ERR_INVALID_ARG_TYPE, $29e35ab028f8b978$var$ERR_METHOD_NOT_IMPLEMENTED = $29e35ab028f8b978$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $29e35ab028f8b978$var$ERR_MULTIPLE_CALLBACK = $29e35ab028f8b978$require$_require$codes.ERR_MULTIPLE_CALLBACK, $29e35ab028f8b978$var$ERR_STREAM_CANNOT_PIPE = $29e35ab028f8b978$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $29e35ab028f8b978$var$ERR_STREAM_DESTROYED = $29e35ab028f8b978$require$_require$codes.ERR_STREAM_DESTROYED, $29e35ab028f8b978$var$ERR_STREAM_NULL_VALUES = $29e35ab028f8b978$require$_require$codes.ERR_STREAM_NULL_VALUES, $29e35ab028f8b978$var$ERR_STREAM_WRITE_AFTER_END = $29e35ab028f8b978$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $29e35ab028f8b978$var$ERR_UNKNOWN_ENCODING = $29e35ab028f8b978$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $29e35ab028f8b978$var$errorOrDestroy = $g2D2d.errorOrDestroy;

(parcelRequire("kvFQ5"))($29e35ab028f8b978$var$Writable, $7GgdY);
function $29e35ab028f8b978$var$nop() {}

function $29e35ab028f8b978$var$WritableState(options, stream, isDuplex) {
    $29e35ab028f8b978$var$Duplex = $29e35ab028f8b978$var$Duplex || (parcelRequire("kTUB1"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $29e35ab028f8b978$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $29e35ab028f8b978$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $29e35ab028f8b978$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $29e35ab028f8b978$var$CorkedRequest(this);
}
$29e35ab028f8b978$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($29e35ab028f8b978$var$WritableState.prototype, "buffer", {
            get: $29e35ab028f8b978$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $29e35ab028f8b978$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $29e35ab028f8b978$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($29e35ab028f8b978$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($29e35ab028f8b978$var$realHasInstance.call(this, object)) return true;
            if (this !== $29e35ab028f8b978$var$Writable) return false;
            return object && object._writableState instanceof $29e35ab028f8b978$var$WritableState;
        }
    });
} else $29e35ab028f8b978$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $29e35ab028f8b978$var$Writable(options) {
    $29e35ab028f8b978$var$Duplex = $29e35ab028f8b978$var$Duplex || (parcelRequire("kTUB1"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $29e35ab028f8b978$var$Duplex;
    if (!isDuplex && !$29e35ab028f8b978$var$realHasInstance.call($29e35ab028f8b978$var$Writable, this)) return new $29e35ab028f8b978$var$Writable(options);
    this._writableState = new $29e35ab028f8b978$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $7GgdY.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$29e35ab028f8b978$var$Writable.prototype.pipe = function() {
    $29e35ab028f8b978$var$errorOrDestroy(this, new $29e35ab028f8b978$var$ERR_STREAM_CANNOT_PIPE());
};
function $29e35ab028f8b978$var$writeAfterEnd(stream, cb) {
    var er = new $29e35ab028f8b978$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $29e35ab028f8b978$var$errorOrDestroy(stream, er);
    $aqbQf.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $29e35ab028f8b978$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $29e35ab028f8b978$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $29e35ab028f8b978$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $29e35ab028f8b978$var$errorOrDestroy(stream, er);
        $aqbQf.nextTick(cb, er);
        return false;
    }
    return true;
}
$29e35ab028f8b978$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $29e35ab028f8b978$var$_isUint8Array(chunk);
    if (isBuf && !$29e35ab028f8b978$require$Buffer.isBuffer(chunk)) chunk = $29e35ab028f8b978$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $29e35ab028f8b978$var$nop;
    if (state.ending) $29e35ab028f8b978$var$writeAfterEnd(this, cb);
    else if (isBuf || $29e35ab028f8b978$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $29e35ab028f8b978$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$29e35ab028f8b978$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$29e35ab028f8b978$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $29e35ab028f8b978$var$clearBuffer(this, state);
    }
};
$29e35ab028f8b978$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $29e35ab028f8b978$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($29e35ab028f8b978$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $29e35ab028f8b978$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $29e35ab028f8b978$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($29e35ab028f8b978$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $29e35ab028f8b978$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $29e35ab028f8b978$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $29e35ab028f8b978$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $29e35ab028f8b978$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $29e35ab028f8b978$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $29e35ab028f8b978$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $aqbQf.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $aqbQf.nextTick($29e35ab028f8b978$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $29e35ab028f8b978$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $29e35ab028f8b978$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $29e35ab028f8b978$var$finishMaybe(stream, state);
    }
}
function $29e35ab028f8b978$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $29e35ab028f8b978$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $29e35ab028f8b978$var$ERR_MULTIPLE_CALLBACK();
    $29e35ab028f8b978$var$onwriteStateUpdate(state);
    if (er) $29e35ab028f8b978$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $29e35ab028f8b978$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $29e35ab028f8b978$var$clearBuffer(stream, state);
        if (sync) $aqbQf.nextTick($29e35ab028f8b978$var$afterWrite, stream, state, finished, cb);
        else $29e35ab028f8b978$var$afterWrite(stream, state, finished, cb);
    }
}
function $29e35ab028f8b978$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $29e35ab028f8b978$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $29e35ab028f8b978$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $29e35ab028f8b978$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $29e35ab028f8b978$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $29e35ab028f8b978$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $29e35ab028f8b978$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $29e35ab028f8b978$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$29e35ab028f8b978$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $29e35ab028f8b978$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$29e35ab028f8b978$var$Writable.prototype._writev = null;
$29e35ab028f8b978$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $29e35ab028f8b978$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($29e35ab028f8b978$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $29e35ab028f8b978$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $29e35ab028f8b978$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $29e35ab028f8b978$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $29e35ab028f8b978$var$finishMaybe(stream, state);
    });
}
function $29e35ab028f8b978$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $aqbQf.nextTick($29e35ab028f8b978$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $29e35ab028f8b978$var$finishMaybe(stream, state) {
    var need = $29e35ab028f8b978$var$needFinish(state);
    if (need) {
        $29e35ab028f8b978$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $29e35ab028f8b978$var$endWritable(stream, state, cb) {
    state.ending = true;
    $29e35ab028f8b978$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $aqbQf.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $29e35ab028f8b978$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($29e35ab028f8b978$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$29e35ab028f8b978$var$Writable.prototype.destroy = $g2D2d.destroy;
$29e35ab028f8b978$var$Writable.prototype._undestroy = $g2D2d.undestroy;
$29e35ab028f8b978$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRequire.register("hPIqS", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $cfb9aa7327c7efa7$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $cfb9aa7327c7efa7$var$deprecate(fn, msg) {
    if ($cfb9aa7327c7efa7$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($cfb9aa7327c7efa7$var$config("throwDeprecation")) throw new Error(msg);
            else if ($cfb9aa7327c7efa7$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $cfb9aa7327c7efa7$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRequire.register("hXidu", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $d12613cfd4b43149$export$63a7aa211a91ed69; }, function (v) { return $d12613cfd4b43149$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $d12613cfd4b43149$export$63a7aa211a91ed69;
"use strict";

var $eN0t8 = parcelRequire("eN0t8");
var $d12613cfd4b43149$require$Buffer = $eN0t8.Buffer;
/*</replacement>*/ var $d12613cfd4b43149$var$isEncoding = $d12613cfd4b43149$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $d12613cfd4b43149$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $d12613cfd4b43149$var$normalizeEncoding(enc) {
    var nenc = $d12613cfd4b43149$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($d12613cfd4b43149$require$Buffer.isEncoding === $d12613cfd4b43149$var$isEncoding || !$d12613cfd4b43149$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$d12613cfd4b43149$export$63a7aa211a91ed69 = $d12613cfd4b43149$var$StringDecoder;
function $d12613cfd4b43149$var$StringDecoder(encoding) {
    this.encoding = $d12613cfd4b43149$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $d12613cfd4b43149$var$utf16Text;
            this.end = $d12613cfd4b43149$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $d12613cfd4b43149$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $d12613cfd4b43149$var$base64Text;
            this.end = $d12613cfd4b43149$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $d12613cfd4b43149$var$simpleWrite;
            this.end = $d12613cfd4b43149$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $d12613cfd4b43149$require$Buffer.allocUnsafe(nb);
}
$d12613cfd4b43149$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$d12613cfd4b43149$var$StringDecoder.prototype.end = $d12613cfd4b43149$var$utf8End;
// Returns only complete characters in a Buffer
$d12613cfd4b43149$var$StringDecoder.prototype.text = $d12613cfd4b43149$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$d12613cfd4b43149$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $d12613cfd4b43149$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $d12613cfd4b43149$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $d12613cfd4b43149$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d12613cfd4b43149$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d12613cfd4b43149$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $d12613cfd4b43149$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "�";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "�";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "�";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $d12613cfd4b43149$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $d12613cfd4b43149$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $d12613cfd4b43149$var$utf8Text(buf, i) {
    var total = $d12613cfd4b43149$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $d12613cfd4b43149$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "�";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $d12613cfd4b43149$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $d12613cfd4b43149$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $d12613cfd4b43149$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $d12613cfd4b43149$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $d12613cfd4b43149$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $d12613cfd4b43149$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});

parcelRequire.register("1WvTd", function(module, exports) {

var $aqbQf = parcelRequire("aqbQf");
"use strict";
var $16a3f1d8da6f8838$var$_Object$setPrototypeO;
function $16a3f1d8da6f8838$var$_defineProperty(obj, key, value) {
    key = $16a3f1d8da6f8838$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $16a3f1d8da6f8838$var$_toPropertyKey(arg) {
    var key = $16a3f1d8da6f8838$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $16a3f1d8da6f8838$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $i1zMF = parcelRequire("i1zMF");
var $16a3f1d8da6f8838$var$kLastResolve = Symbol("lastResolve");
var $16a3f1d8da6f8838$var$kLastReject = Symbol("lastReject");
var $16a3f1d8da6f8838$var$kError = Symbol("error");
var $16a3f1d8da6f8838$var$kEnded = Symbol("ended");
var $16a3f1d8da6f8838$var$kLastPromise = Symbol("lastPromise");
var $16a3f1d8da6f8838$var$kHandlePromise = Symbol("handlePromise");
var $16a3f1d8da6f8838$var$kStream = Symbol("stream");
function $16a3f1d8da6f8838$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $16a3f1d8da6f8838$var$readAndResolve(iter) {
    var resolve = iter[$16a3f1d8da6f8838$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$16a3f1d8da6f8838$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$16a3f1d8da6f8838$var$kLastPromise] = null;
            iter[$16a3f1d8da6f8838$var$kLastResolve] = null;
            iter[$16a3f1d8da6f8838$var$kLastReject] = null;
            resolve($16a3f1d8da6f8838$var$createIterResult(data, false));
        }
    }
}
function $16a3f1d8da6f8838$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $aqbQf.nextTick($16a3f1d8da6f8838$var$readAndResolve, iter);
}
function $16a3f1d8da6f8838$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$16a3f1d8da6f8838$var$kEnded]) {
                resolve($16a3f1d8da6f8838$var$createIterResult(undefined, true));
                return;
            }
            iter[$16a3f1d8da6f8838$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $16a3f1d8da6f8838$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $16a3f1d8da6f8838$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($16a3f1d8da6f8838$var$_Object$setPrototypeO = {
    get stream () {
        return this[$16a3f1d8da6f8838$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$16a3f1d8da6f8838$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$16a3f1d8da6f8838$var$kEnded]) return Promise.resolve($16a3f1d8da6f8838$var$createIterResult(undefined, true));
        if (this[$16a3f1d8da6f8838$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $aqbQf.nextTick(function() {
                if (_this[$16a3f1d8da6f8838$var$kError]) reject(_this[$16a3f1d8da6f8838$var$kError]);
                else resolve($16a3f1d8da6f8838$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$16a3f1d8da6f8838$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($16a3f1d8da6f8838$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$16a3f1d8da6f8838$var$kStream].read();
            if (data !== null) return Promise.resolve($16a3f1d8da6f8838$var$createIterResult(data, false));
            promise = new Promise(this[$16a3f1d8da6f8838$var$kHandlePromise]);
        }
        this[$16a3f1d8da6f8838$var$kLastPromise] = promise;
        return promise;
    }
}, $16a3f1d8da6f8838$var$_defineProperty($16a3f1d8da6f8838$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $16a3f1d8da6f8838$var$_defineProperty($16a3f1d8da6f8838$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$16a3f1d8da6f8838$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($16a3f1d8da6f8838$var$createIterResult(undefined, true));
        });
    });
}), $16a3f1d8da6f8838$var$_Object$setPrototypeO), $16a3f1d8da6f8838$var$AsyncIteratorPrototype);
var $16a3f1d8da6f8838$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($16a3f1d8da6f8838$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $16a3f1d8da6f8838$var$_defineProperty(_Object$create, $16a3f1d8da6f8838$var$kStream, {
        value: stream,
        writable: true
    }), $16a3f1d8da6f8838$var$_defineProperty(_Object$create, $16a3f1d8da6f8838$var$kLastResolve, {
        value: null,
        writable: true
    }), $16a3f1d8da6f8838$var$_defineProperty(_Object$create, $16a3f1d8da6f8838$var$kLastReject, {
        value: null,
        writable: true
    }), $16a3f1d8da6f8838$var$_defineProperty(_Object$create, $16a3f1d8da6f8838$var$kError, {
        value: null,
        writable: true
    }), $16a3f1d8da6f8838$var$_defineProperty(_Object$create, $16a3f1d8da6f8838$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $16a3f1d8da6f8838$var$_defineProperty(_Object$create, $16a3f1d8da6f8838$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$16a3f1d8da6f8838$var$kStream].read();
            if (data) {
                iterator[$16a3f1d8da6f8838$var$kLastPromise] = null;
                iterator[$16a3f1d8da6f8838$var$kLastResolve] = null;
                iterator[$16a3f1d8da6f8838$var$kLastReject] = null;
                resolve($16a3f1d8da6f8838$var$createIterResult(data, false));
            } else {
                iterator[$16a3f1d8da6f8838$var$kLastResolve] = resolve;
                iterator[$16a3f1d8da6f8838$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$16a3f1d8da6f8838$var$kLastPromise] = null;
    $i1zMF(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$16a3f1d8da6f8838$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$16a3f1d8da6f8838$var$kLastPromise] = null;
                iterator[$16a3f1d8da6f8838$var$kLastResolve] = null;
                iterator[$16a3f1d8da6f8838$var$kLastReject] = null;
                reject(err);
            }
            iterator[$16a3f1d8da6f8838$var$kError] = err;
            return;
        }
        var resolve = iterator[$16a3f1d8da6f8838$var$kLastResolve];
        if (resolve !== null) {
            iterator[$16a3f1d8da6f8838$var$kLastPromise] = null;
            iterator[$16a3f1d8da6f8838$var$kLastResolve] = null;
            iterator[$16a3f1d8da6f8838$var$kLastReject] = null;
            resolve($16a3f1d8da6f8838$var$createIterResult(undefined, true));
        }
        iterator[$16a3f1d8da6f8838$var$kEnded] = true;
    });
    stream.on("readable", $16a3f1d8da6f8838$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $16a3f1d8da6f8838$var$createReadableStreamAsyncIterator;

});
parcelRequire.register("i1zMF", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $5qPK0 = parcelRequire("5qPK0");
var $d1f413f5b5c76170$var$ERR_STREAM_PREMATURE_CLOSE = $5qPK0.codes.ERR_STREAM_PREMATURE_CLOSE;
function $d1f413f5b5c76170$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $d1f413f5b5c76170$var$noop() {}
function $d1f413f5b5c76170$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $d1f413f5b5c76170$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $d1f413f5b5c76170$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $d1f413f5b5c76170$var$once(callback || $d1f413f5b5c76170$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $d1f413f5b5c76170$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $d1f413f5b5c76170$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($d1f413f5b5c76170$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $d1f413f5b5c76170$var$eos;

});


parcelRequire.register("1YZki", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRequire.register("9wbVx", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $6ee05aa7edc18bb2$var$Transform;

var $5qPK0 = parcelRequire("5qPK0");
var $6ee05aa7edc18bb2$require$_require$codes = $5qPK0.codes;
var $6ee05aa7edc18bb2$var$ERR_METHOD_NOT_IMPLEMENTED = $6ee05aa7edc18bb2$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $6ee05aa7edc18bb2$var$ERR_MULTIPLE_CALLBACK = $6ee05aa7edc18bb2$require$_require$codes.ERR_MULTIPLE_CALLBACK, $6ee05aa7edc18bb2$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $6ee05aa7edc18bb2$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $6ee05aa7edc18bb2$var$ERR_TRANSFORM_WITH_LENGTH_0 = $6ee05aa7edc18bb2$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $kTUB1 = parcelRequire("kTUB1");

(parcelRequire("kvFQ5"))($6ee05aa7edc18bb2$var$Transform, $kTUB1);
function $6ee05aa7edc18bb2$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $6ee05aa7edc18bb2$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $6ee05aa7edc18bb2$var$Transform(options) {
    if (!(this instanceof $6ee05aa7edc18bb2$var$Transform)) return new $6ee05aa7edc18bb2$var$Transform(options);
    $kTUB1.call(this, options);
    this._transformState = {
        afterTransform: $6ee05aa7edc18bb2$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $6ee05aa7edc18bb2$var$prefinish);
}
function $6ee05aa7edc18bb2$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $6ee05aa7edc18bb2$var$done(_this, er, data);
    });
    else $6ee05aa7edc18bb2$var$done(this, null, null);
}
$6ee05aa7edc18bb2$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $kTUB1.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$6ee05aa7edc18bb2$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $6ee05aa7edc18bb2$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$6ee05aa7edc18bb2$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$6ee05aa7edc18bb2$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$6ee05aa7edc18bb2$var$Transform.prototype._destroy = function(err, cb) {
    $kTUB1.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $6ee05aa7edc18bb2$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $6ee05aa7edc18bb2$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $6ee05aa7edc18bb2$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRequire.register("3Frfy", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $2aba56adb8231771$var$PassThrough;

var $9wbVx = parcelRequire("9wbVx");

(parcelRequire("kvFQ5"))($2aba56adb8231771$var$PassThrough, $9wbVx);
function $2aba56adb8231771$var$PassThrough(options) {
    if (!(this instanceof $2aba56adb8231771$var$PassThrough)) return new $2aba56adb8231771$var$PassThrough(options);
    $9wbVx.call(this, options);
}
$2aba56adb8231771$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRequire.register("hI05B", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $ce469d7a6528ca9c$var$eos;
function $ce469d7a6528ca9c$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $5qPK0 = parcelRequire("5qPK0");
var $ce469d7a6528ca9c$require$_require$codes = $5qPK0.codes;
var $ce469d7a6528ca9c$var$ERR_MISSING_ARGS = $ce469d7a6528ca9c$require$_require$codes.ERR_MISSING_ARGS, $ce469d7a6528ca9c$var$ERR_STREAM_DESTROYED = $ce469d7a6528ca9c$require$_require$codes.ERR_STREAM_DESTROYED;
function $ce469d7a6528ca9c$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $ce469d7a6528ca9c$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $ce469d7a6528ca9c$var$destroyer(stream, reading, writing, callback) {
    callback = $ce469d7a6528ca9c$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($ce469d7a6528ca9c$var$eos === undefined) $ce469d7a6528ca9c$var$eos = (parcelRequire("i1zMF"));
    $ce469d7a6528ca9c$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($ce469d7a6528ca9c$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $ce469d7a6528ca9c$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $ce469d7a6528ca9c$var$call(fn) {
    fn();
}
function $ce469d7a6528ca9c$var$pipe(from, to) {
    return from.pipe(to);
}
function $ce469d7a6528ca9c$var$popCallback(streams) {
    if (!streams.length) return $ce469d7a6528ca9c$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $ce469d7a6528ca9c$var$noop;
    return streams.pop();
}
function $ce469d7a6528ca9c$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $ce469d7a6528ca9c$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $ce469d7a6528ca9c$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $ce469d7a6528ca9c$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($ce469d7a6528ca9c$var$call);
            if (reading) return;
            destroys.forEach($ce469d7a6528ca9c$var$call);
            callback(error);
        });
    });
    return streams.reduce($ce469d7a6528ca9c$var$pipe);
}
module.exports = $ce469d7a6528ca9c$var$pipeline;

});




parcelRequire.register("6B3Qg", function(module, exports) {
"use strict";

var $gzLuY = parcelRequire("gzLuY");
var $4cd92db7ac4b15a3$require$Buffer = $gzLuY.Buffer;

var $kvFQ5 = parcelRequire("kvFQ5");

var $4E6hc = parcelRequire("4E6hc");
var $4cd92db7ac4b15a3$var$ARRAY16 = new Array(16);
var $4cd92db7ac4b15a3$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $4cd92db7ac4b15a3$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $4cd92db7ac4b15a3$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $4cd92db7ac4b15a3$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $4cd92db7ac4b15a3$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $4cd92db7ac4b15a3$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $4cd92db7ac4b15a3$var$RIPEMD160() {
    $4E6hc.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$kvFQ5($4cd92db7ac4b15a3$var$RIPEMD160, $4E6hc);
$4cd92db7ac4b15a3$var$RIPEMD160.prototype._update = function() {
    var words = $4cd92db7ac4b15a3$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $4cd92db7ac4b15a3$var$fn1(al, bl, cl, dl, el, words[$4cd92db7ac4b15a3$var$zl[i]], $4cd92db7ac4b15a3$var$hl[0], $4cd92db7ac4b15a3$var$sl[i]);
            tr = $4cd92db7ac4b15a3$var$fn5(ar, br, cr, dr, er, words[$4cd92db7ac4b15a3$var$zr[i]], $4cd92db7ac4b15a3$var$hr[0], $4cd92db7ac4b15a3$var$sr[i]);
        } else if (i < 32) {
            tl = $4cd92db7ac4b15a3$var$fn2(al, bl, cl, dl, el, words[$4cd92db7ac4b15a3$var$zl[i]], $4cd92db7ac4b15a3$var$hl[1], $4cd92db7ac4b15a3$var$sl[i]);
            tr = $4cd92db7ac4b15a3$var$fn4(ar, br, cr, dr, er, words[$4cd92db7ac4b15a3$var$zr[i]], $4cd92db7ac4b15a3$var$hr[1], $4cd92db7ac4b15a3$var$sr[i]);
        } else if (i < 48) {
            tl = $4cd92db7ac4b15a3$var$fn3(al, bl, cl, dl, el, words[$4cd92db7ac4b15a3$var$zl[i]], $4cd92db7ac4b15a3$var$hl[2], $4cd92db7ac4b15a3$var$sl[i]);
            tr = $4cd92db7ac4b15a3$var$fn3(ar, br, cr, dr, er, words[$4cd92db7ac4b15a3$var$zr[i]], $4cd92db7ac4b15a3$var$hr[2], $4cd92db7ac4b15a3$var$sr[i]);
        } else if (i < 64) {
            tl = $4cd92db7ac4b15a3$var$fn4(al, bl, cl, dl, el, words[$4cd92db7ac4b15a3$var$zl[i]], $4cd92db7ac4b15a3$var$hl[3], $4cd92db7ac4b15a3$var$sl[i]);
            tr = $4cd92db7ac4b15a3$var$fn2(ar, br, cr, dr, er, words[$4cd92db7ac4b15a3$var$zr[i]], $4cd92db7ac4b15a3$var$hr[3], $4cd92db7ac4b15a3$var$sr[i]);
        } else {
            tl = $4cd92db7ac4b15a3$var$fn5(al, bl, cl, dl, el, words[$4cd92db7ac4b15a3$var$zl[i]], $4cd92db7ac4b15a3$var$hl[4], $4cd92db7ac4b15a3$var$sl[i]);
            tr = $4cd92db7ac4b15a3$var$fn1(ar, br, cr, dr, er, words[$4cd92db7ac4b15a3$var$zr[i]], $4cd92db7ac4b15a3$var$hr[4], $4cd92db7ac4b15a3$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $4cd92db7ac4b15a3$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $4cd92db7ac4b15a3$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$4cd92db7ac4b15a3$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $4cd92db7ac4b15a3$require$Buffer.alloc ? $4cd92db7ac4b15a3$require$Buffer.alloc(20) : new $4cd92db7ac4b15a3$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $4cd92db7ac4b15a3$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $4cd92db7ac4b15a3$var$fn1(a, b, c, d, e, m, k, s) {
    return $4cd92db7ac4b15a3$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $4cd92db7ac4b15a3$var$fn2(a, b, c, d, e, m, k, s) {
    return $4cd92db7ac4b15a3$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $4cd92db7ac4b15a3$var$fn3(a, b, c, d, e, m, k, s) {
    return $4cd92db7ac4b15a3$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $4cd92db7ac4b15a3$var$fn4(a, b, c, d, e, m, k, s) {
    return $4cd92db7ac4b15a3$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $4cd92db7ac4b15a3$var$fn5(a, b, c, d, e, m, k, s) {
    return $4cd92db7ac4b15a3$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $4cd92db7ac4b15a3$var$RIPEMD160;

});

parcelRequire.register("cWKoG", function(module, exports) {
var $96cee456979899bd$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $96cee456979899bd$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$96cee456979899bd$var$exports.sha = (parcelRequire("9C2df"));

$96cee456979899bd$var$exports.sha1 = (parcelRequire("2pwhy"));

$96cee456979899bd$var$exports.sha224 = (parcelRequire("3zu8K"));

$96cee456979899bd$var$exports.sha256 = (parcelRequire("fxEaM"));

$96cee456979899bd$var$exports.sha384 = (parcelRequire("jgu7i"));

$96cee456979899bd$var$exports.sha512 = (parcelRequire("eieYH"));

});
parcelRequire.register("9C2df", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $kvFQ5 = parcelRequire("kvFQ5");

var $jlMGX = parcelRequire("jlMGX");

var $eN0t8 = parcelRequire("eN0t8");
var $6ff9610bb83aff6e$require$Buffer = $eN0t8.Buffer;
var $6ff9610bb83aff6e$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $6ff9610bb83aff6e$var$W = new Array(80);
function $6ff9610bb83aff6e$var$Sha() {
    this.init();
    this._w = $6ff9610bb83aff6e$var$W;
    $jlMGX.call(this, 64, 56);
}
$kvFQ5($6ff9610bb83aff6e$var$Sha, $jlMGX);
$6ff9610bb83aff6e$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $6ff9610bb83aff6e$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $6ff9610bb83aff6e$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $6ff9610bb83aff6e$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$6ff9610bb83aff6e$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $6ff9610bb83aff6e$var$rotl5(a) + $6ff9610bb83aff6e$var$ft(s, b, c, d) + e + W[j] + $6ff9610bb83aff6e$var$K[s] | 0;
        e = d;
        d = c;
        c = $6ff9610bb83aff6e$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$6ff9610bb83aff6e$var$Sha.prototype._hash = function() {
    var H = $6ff9610bb83aff6e$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $6ff9610bb83aff6e$var$Sha;

});
parcelRequire.register("jlMGX", function(module, exports) {

var $eN0t8 = parcelRequire("eN0t8");
var $e165bfac2320c5ec$require$Buffer = $eN0t8.Buffer;
// prototype class for hash functions
function $e165bfac2320c5ec$var$Hash(blockSize, finalSize) {
    this._block = $e165bfac2320c5ec$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$e165bfac2320c5ec$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $e165bfac2320c5ec$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$e165bfac2320c5ec$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$e165bfac2320c5ec$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $e165bfac2320c5ec$var$Hash;

});


parcelRequire.register("2pwhy", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $kvFQ5 = parcelRequire("kvFQ5");

var $jlMGX = parcelRequire("jlMGX");

var $eN0t8 = parcelRequire("eN0t8");
var $1c16f51ebcd2407a$require$Buffer = $eN0t8.Buffer;
var $1c16f51ebcd2407a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $1c16f51ebcd2407a$var$W = new Array(80);
function $1c16f51ebcd2407a$var$Sha1() {
    this.init();
    this._w = $1c16f51ebcd2407a$var$W;
    $jlMGX.call(this, 64, 56);
}
$kvFQ5($1c16f51ebcd2407a$var$Sha1, $jlMGX);
$1c16f51ebcd2407a$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $1c16f51ebcd2407a$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $1c16f51ebcd2407a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $1c16f51ebcd2407a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $1c16f51ebcd2407a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$1c16f51ebcd2407a$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $1c16f51ebcd2407a$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $1c16f51ebcd2407a$var$rotl5(a) + $1c16f51ebcd2407a$var$ft(s, b, c, d) + e + W[j] + $1c16f51ebcd2407a$var$K[s] | 0;
        e = d;
        d = c;
        c = $1c16f51ebcd2407a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$1c16f51ebcd2407a$var$Sha1.prototype._hash = function() {
    var H = $1c16f51ebcd2407a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $1c16f51ebcd2407a$var$Sha1;

});

parcelRequire.register("3zu8K", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $kvFQ5 = parcelRequire("kvFQ5");

var $fxEaM = parcelRequire("fxEaM");

var $jlMGX = parcelRequire("jlMGX");

var $eN0t8 = parcelRequire("eN0t8");
var $299c052ad24da244$require$Buffer = $eN0t8.Buffer;
var $299c052ad24da244$var$W = new Array(64);
function $299c052ad24da244$var$Sha224() {
    this.init();
    this._w = $299c052ad24da244$var$W // new Array(64)
    ;
    $jlMGX.call(this, 64, 56);
}
$kvFQ5($299c052ad24da244$var$Sha224, $fxEaM);
$299c052ad24da244$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$299c052ad24da244$var$Sha224.prototype._hash = function() {
    var H = $299c052ad24da244$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $299c052ad24da244$var$Sha224;

});
parcelRequire.register("fxEaM", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $kvFQ5 = parcelRequire("kvFQ5");

var $jlMGX = parcelRequire("jlMGX");

var $eN0t8 = parcelRequire("eN0t8");
var $b5091999693c4415$require$Buffer = $eN0t8.Buffer;
var $b5091999693c4415$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $b5091999693c4415$var$W = new Array(64);
function $b5091999693c4415$var$Sha256() {
    this.init();
    this._w = $b5091999693c4415$var$W // new Array(64)
    ;
    $jlMGX.call(this, 64, 56);
}
$kvFQ5($b5091999693c4415$var$Sha256, $jlMGX);
$b5091999693c4415$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $b5091999693c4415$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $b5091999693c4415$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $b5091999693c4415$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $b5091999693c4415$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $b5091999693c4415$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $b5091999693c4415$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$b5091999693c4415$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $b5091999693c4415$var$gamma1(W[i - 2]) + W[i - 7] + $b5091999693c4415$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $b5091999693c4415$var$sigma1(e) + $b5091999693c4415$var$ch(e, f, g) + $b5091999693c4415$var$K[j] + W[j] | 0;
        var T2 = $b5091999693c4415$var$sigma0(a) + $b5091999693c4415$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$b5091999693c4415$var$Sha256.prototype._hash = function() {
    var H = $b5091999693c4415$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $b5091999693c4415$var$Sha256;

});


parcelRequire.register("jgu7i", function(module, exports) {

var $kvFQ5 = parcelRequire("kvFQ5");

var $eieYH = parcelRequire("eieYH");

var $jlMGX = parcelRequire("jlMGX");

var $eN0t8 = parcelRequire("eN0t8");
var $e066df821c998c38$require$Buffer = $eN0t8.Buffer;
var $e066df821c998c38$var$W = new Array(160);
function $e066df821c998c38$var$Sha384() {
    this.init();
    this._w = $e066df821c998c38$var$W;
    $jlMGX.call(this, 128, 112);
}
$kvFQ5($e066df821c998c38$var$Sha384, $eieYH);
$e066df821c998c38$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$e066df821c998c38$var$Sha384.prototype._hash = function() {
    var H = $e066df821c998c38$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $e066df821c998c38$var$Sha384;

});
parcelRequire.register("eieYH", function(module, exports) {

var $kvFQ5 = parcelRequire("kvFQ5");

var $jlMGX = parcelRequire("jlMGX");

var $eN0t8 = parcelRequire("eN0t8");
var $a67e5d6d788716bb$require$Buffer = $eN0t8.Buffer;
var $a67e5d6d788716bb$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $a67e5d6d788716bb$var$W = new Array(160);
function $a67e5d6d788716bb$var$Sha512() {
    this.init();
    this._w = $a67e5d6d788716bb$var$W;
    $jlMGX.call(this, 128, 112);
}
$kvFQ5($a67e5d6d788716bb$var$Sha512, $jlMGX);
$a67e5d6d788716bb$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $a67e5d6d788716bb$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $a67e5d6d788716bb$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $a67e5d6d788716bb$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $a67e5d6d788716bb$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $a67e5d6d788716bb$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $a67e5d6d788716bb$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $a67e5d6d788716bb$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $a67e5d6d788716bb$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $a67e5d6d788716bb$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$a67e5d6d788716bb$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $a67e5d6d788716bb$var$Gamma0(xh, xl);
        var gamma0l = $a67e5d6d788716bb$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $a67e5d6d788716bb$var$Gamma1(xh, xl);
        var gamma1l = $a67e5d6d788716bb$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $a67e5d6d788716bb$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $a67e5d6d788716bb$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $a67e5d6d788716bb$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $a67e5d6d788716bb$var$maj(ah, bh, ch);
        var majl = $a67e5d6d788716bb$var$maj(al, bl, cl);
        var sigma0h = $a67e5d6d788716bb$var$sigma0(ah, al);
        var sigma0l = $a67e5d6d788716bb$var$sigma0(al, ah);
        var sigma1h = $a67e5d6d788716bb$var$sigma1(eh, el);
        var sigma1l = $a67e5d6d788716bb$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $a67e5d6d788716bb$var$K[j];
        var Kil = $a67e5d6d788716bb$var$K[j + 1];
        var chh = $a67e5d6d788716bb$var$Ch(eh, fh, gh);
        var chl = $a67e5d6d788716bb$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $a67e5d6d788716bb$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $a67e5d6d788716bb$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $a67e5d6d788716bb$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $a67e5d6d788716bb$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $a67e5d6d788716bb$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $a67e5d6d788716bb$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $a67e5d6d788716bb$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $a67e5d6d788716bb$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $a67e5d6d788716bb$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $a67e5d6d788716bb$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $a67e5d6d788716bb$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $a67e5d6d788716bb$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $a67e5d6d788716bb$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $a67e5d6d788716bb$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $a67e5d6d788716bb$var$getCarry(this._hl, hl) | 0;
};
$a67e5d6d788716bb$var$Sha512.prototype._hash = function() {
    var H = $a67e5d6d788716bb$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $a67e5d6d788716bb$var$Sha512;

});



parcelRequire.register("61MIM", function(module, exports) {

var $eN0t8 = parcelRequire("eN0t8");
var $4638a1175229f183$require$Buffer = $eN0t8.Buffer;

var $b2J01 = parcelRequire("b2J01");
var $4638a1175229f183$require$Transform = $b2J01.Transform;

var $hXidu = parcelRequire("hXidu");
var $4638a1175229f183$require$StringDecoder = $hXidu.StringDecoder;

var $kvFQ5 = parcelRequire("kvFQ5");
function $4638a1175229f183$var$CipherBase(hashMode) {
    $4638a1175229f183$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$kvFQ5($4638a1175229f183$var$CipherBase, $4638a1175229f183$require$Transform);
$4638a1175229f183$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $4638a1175229f183$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$4638a1175229f183$var$CipherBase.prototype.setAutoPadding = function() {};
$4638a1175229f183$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$4638a1175229f183$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$4638a1175229f183$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$4638a1175229f183$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$4638a1175229f183$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$4638a1175229f183$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $4638a1175229f183$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$4638a1175229f183$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $4638a1175229f183$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $4638a1175229f183$var$CipherBase;

});
parcelRequire.register("b2J01", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $80a2c98655d877d9$var$Stream;

var $wvaTc = parcelRequire("wvaTc");
var $80a2c98655d877d9$require$EE = $wvaTc.EventEmitter;

var $kvFQ5 = parcelRequire("kvFQ5");
$kvFQ5($80a2c98655d877d9$var$Stream, $80a2c98655d877d9$require$EE);

$80a2c98655d877d9$var$Stream.Readable = (parcelRequire("hJHBh"));

$80a2c98655d877d9$var$Stream.Writable = (parcelRequire("3AY6k"));

$80a2c98655d877d9$var$Stream.Duplex = (parcelRequire("kTUB1"));

$80a2c98655d877d9$var$Stream.Transform = (parcelRequire("9wbVx"));

$80a2c98655d877d9$var$Stream.PassThrough = (parcelRequire("3Frfy"));

$80a2c98655d877d9$var$Stream.finished = (parcelRequire("i1zMF"));

$80a2c98655d877d9$var$Stream.pipeline = (parcelRequire("hI05B"));
// Backwards-compat with node 0.4.x
$80a2c98655d877d9$var$Stream.Stream = $80a2c98655d877d9$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $80a2c98655d877d9$var$Stream() {
    $80a2c98655d877d9$require$EE.call(this);
}
$80a2c98655d877d9$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($80a2c98655d877d9$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});



parcelRequire.register("l2ANw", function(module, exports) {
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");

var $kpXJ9 = parcelRequire("kpXJ9");

var $61MIM = parcelRequire("61MIM");

var $eN0t8 = parcelRequire("eN0t8");
var $f5165421c703f446$require$Buffer = $eN0t8.Buffer;

var $2ltcv = parcelRequire("2ltcv");

var $6B3Qg = parcelRequire("6B3Qg");

var $cWKoG = parcelRequire("cWKoG");
var $f5165421c703f446$var$ZEROS = $f5165421c703f446$require$Buffer.alloc(128);
function $f5165421c703f446$var$Hmac(alg, key) {
    $61MIM.call(this, "digest");
    if (typeof key === "string") key = $f5165421c703f446$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $6B3Qg() : $cWKoG(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $f5165421c703f446$require$Buffer.concat([
        key,
        $f5165421c703f446$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $f5165421c703f446$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $f5165421c703f446$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $6B3Qg() : $cWKoG(alg);
    this._hash.update(ipad);
}
$kvFQ5($f5165421c703f446$var$Hmac, $61MIM);
$f5165421c703f446$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$f5165421c703f446$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $6B3Qg() : $cWKoG(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $f5165421c703f446$var$Hmac("rmd160", key);
    if (alg === "md5") return new $kpXJ9($2ltcv, key);
    return new $f5165421c703f446$var$Hmac(alg, key);
};

});
parcelRequire.register("kpXJ9", function(module, exports) {
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");

var $eN0t8 = parcelRequire("eN0t8");
var $edd4790b80213788$require$Buffer = $eN0t8.Buffer;

var $61MIM = parcelRequire("61MIM");
var $edd4790b80213788$var$ZEROS = $edd4790b80213788$require$Buffer.alloc(128);
var $edd4790b80213788$var$blocksize = 64;
function $edd4790b80213788$var$Hmac(alg, key) {
    $61MIM.call(this, "digest");
    if (typeof key === "string") key = $edd4790b80213788$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $edd4790b80213788$var$blocksize) key = alg(key);
    else if (key.length < $edd4790b80213788$var$blocksize) key = $edd4790b80213788$require$Buffer.concat([
        key,
        $edd4790b80213788$var$ZEROS
    ], $edd4790b80213788$var$blocksize);
    var ipad = this._ipad = $edd4790b80213788$require$Buffer.allocUnsafe($edd4790b80213788$var$blocksize);
    var opad = this._opad = $edd4790b80213788$require$Buffer.allocUnsafe($edd4790b80213788$var$blocksize);
    for(var i = 0; i < $edd4790b80213788$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$kvFQ5($edd4790b80213788$var$Hmac, $61MIM);
$edd4790b80213788$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$edd4790b80213788$var$Hmac.prototype._final = function() {
    var h = this._alg($edd4790b80213788$require$Buffer.concat(this._hash));
    return this._alg($edd4790b80213788$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $edd4790b80213788$var$Hmac;

});

parcelRequire.register("2ltcv", function(module, exports) {

var $dGbYv = parcelRequire("dGbYv");
module.exports = function(buffer) {
    return new $dGbYv().update(buffer).digest();
};

});


parcelRequire.register("ggpby", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});

parcelRequire.register("dAOoN", function(module, exports) {

var $eN0t8 = parcelRequire("eN0t8");
var $9e55bb59acd987ab$require$Buffer = $eN0t8.Buffer;

var $a8w1O = parcelRequire("a8w1O");

var $26PHw = parcelRequire("26PHw");

var $iUG0Q = parcelRequire("iUG0Q");

var $kGazS = parcelRequire("kGazS");
var $9e55bb59acd987ab$var$ZERO_BUF;
var $9e55bb59acd987ab$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $9e55bb59acd987ab$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $9e55bb59acd987ab$var$checks = [];
function $9e55bb59acd987ab$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$9e55bb59acd987ab$var$subtle || !$9e55bb59acd987ab$var$subtle.importKey || !$9e55bb59acd987ab$var$subtle.deriveBits) return Promise.resolve(false);
    if ($9e55bb59acd987ab$var$checks[algo] !== undefined) return $9e55bb59acd987ab$var$checks[algo];
    $9e55bb59acd987ab$var$ZERO_BUF = $9e55bb59acd987ab$var$ZERO_BUF || $9e55bb59acd987ab$require$Buffer.alloc(8);
    var prom = $9e55bb59acd987ab$var$browserPbkdf2($9e55bb59acd987ab$var$ZERO_BUF, $9e55bb59acd987ab$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $9e55bb59acd987ab$var$checks[algo] = prom;
    return prom;
}
var $9e55bb59acd987ab$var$nextTick;
function $9e55bb59acd987ab$var$getNextTick() {
    if ($9e55bb59acd987ab$var$nextTick) return $9e55bb59acd987ab$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $9e55bb59acd987ab$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $9e55bb59acd987ab$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $9e55bb59acd987ab$var$nextTick = $parcel$global.setImmediate;
    else $9e55bb59acd987ab$var$nextTick = $parcel$global.setTimeout;
    return $9e55bb59acd987ab$var$nextTick;
}
function $9e55bb59acd987ab$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $9e55bb59acd987ab$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $9e55bb59acd987ab$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $9e55bb59acd987ab$require$Buffer.from(res);
    });
}
function $9e55bb59acd987ab$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $9e55bb59acd987ab$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $9e55bb59acd987ab$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $9e55bb59acd987ab$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $9e55bb59acd987ab$var$getNextTick()(function() {
            var out;
            try {
                out = $iUG0Q(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $a8w1O(iterations, keylen);
    password = $kGazS(password, $26PHw, "Password");
    salt = $kGazS(salt, $26PHw, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $9e55bb59acd987ab$var$resolvePromise($9e55bb59acd987ab$var$checkNative(algo).then(function(resp) {
        if (resp) return $9e55bb59acd987ab$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $iUG0Q(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRequire.register("a8w1O", function(module, exports) {
var $76137edb2e21374c$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $76137edb2e21374c$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRequire.register("26PHw", function(module, exports) {

var $aqbQf = parcelRequire("aqbQf");
var $18943f11206ac0c0$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $18943f11206ac0c0$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $18943f11206ac0c0$var$pVersionMajor = parseInt($aqbQf.version.split(".")[0].slice(1), 10);
    $18943f11206ac0c0$var$defaultEncoding = $18943f11206ac0c0$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $18943f11206ac0c0$var$defaultEncoding = "utf-8";
module.exports = $18943f11206ac0c0$var$defaultEncoding;

});

parcelRequire.register("iUG0Q", function(module, exports) {

var $2ltcv = parcelRequire("2ltcv");

var $6B3Qg = parcelRequire("6B3Qg");

var $cWKoG = parcelRequire("cWKoG");

var $eN0t8 = parcelRequire("eN0t8");
var $dc4e0bc70f7259d3$require$Buffer = $eN0t8.Buffer;

var $a8w1O = parcelRequire("a8w1O");

var $26PHw = parcelRequire("26PHw");

var $kGazS = parcelRequire("kGazS");
var $dc4e0bc70f7259d3$var$ZEROS = $dc4e0bc70f7259d3$require$Buffer.alloc(128);
var $dc4e0bc70f7259d3$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $dc4e0bc70f7259d3$var$Hmac(alg, key, saltLen) {
    var hash = $dc4e0bc70f7259d3$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $dc4e0bc70f7259d3$require$Buffer.concat([
        key,
        $dc4e0bc70f7259d3$var$ZEROS
    ], blocksize);
    var ipad = $dc4e0bc70f7259d3$require$Buffer.allocUnsafe(blocksize + $dc4e0bc70f7259d3$var$sizes[alg]);
    var opad = $dc4e0bc70f7259d3$require$Buffer.allocUnsafe(blocksize + $dc4e0bc70f7259d3$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $dc4e0bc70f7259d3$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $dc4e0bc70f7259d3$var$sizes[alg];
}
$dc4e0bc70f7259d3$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $dc4e0bc70f7259d3$var$getDigest(alg) {
    function shaFunc(data) {
        return $cWKoG(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $6B3Qg().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $2ltcv;
    return shaFunc;
}
function $dc4e0bc70f7259d3$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $a8w1O(iterations, keylen);
    password = $kGazS(password, $26PHw, "Password");
    salt = $kGazS(salt, $26PHw, "Salt");
    digest = digest || "sha1";
    var hmac = new $dc4e0bc70f7259d3$var$Hmac(digest, password, salt.length);
    var DK = $dc4e0bc70f7259d3$require$Buffer.allocUnsafe(keylen);
    var block1 = $dc4e0bc70f7259d3$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $dc4e0bc70f7259d3$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $dc4e0bc70f7259d3$var$pbkdf2;

});
parcelRequire.register("kGazS", function(module, exports) {

var $eN0t8 = parcelRequire("eN0t8");
var $f0dfef66b7976d7c$require$Buffer = $eN0t8.Buffer;
module.exports = function(thing, encoding, name) {
    if ($f0dfef66b7976d7c$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $f0dfef66b7976d7c$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $f0dfef66b7976d7c$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});



parcelRequire.register("aBLCl", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", function () { return $7b924be9366471b4$export$cfaef8ed399428b0; }, function (v) { return $7b924be9366471b4$export$cfaef8ed399428b0 = v; });
$parcel$export(module.exports, "writeUInt32BE", function () { return $7b924be9366471b4$export$a80c7deaea7cbd80; }, function (v) { return $7b924be9366471b4$export$a80c7deaea7cbd80 = v; });
$parcel$export(module.exports, "ip", function () { return $7b924be9366471b4$export$ed7577ae6e1cd0ef; }, function (v) { return $7b924be9366471b4$export$ed7577ae6e1cd0ef = v; });
$parcel$export(module.exports, "rip", function () { return $7b924be9366471b4$export$5dcbef3aa594f567; }, function (v) { return $7b924be9366471b4$export$5dcbef3aa594f567 = v; });
$parcel$export(module.exports, "pc1", function () { return $7b924be9366471b4$export$5bc8001ca71ed9c5; }, function (v) { return $7b924be9366471b4$export$5bc8001ca71ed9c5 = v; });
$parcel$export(module.exports, "r28shl", function () { return $7b924be9366471b4$export$3e714e2c5d5d8cb2; }, function (v) { return $7b924be9366471b4$export$3e714e2c5d5d8cb2 = v; });
$parcel$export(module.exports, "pc2", function () { return $7b924be9366471b4$export$94c3e544fd062b7f; }, function (v) { return $7b924be9366471b4$export$94c3e544fd062b7f = v; });
$parcel$export(module.exports, "expand", function () { return $7b924be9366471b4$export$9f77e0932fb78f72; }, function (v) { return $7b924be9366471b4$export$9f77e0932fb78f72 = v; });
$parcel$export(module.exports, "substitute", function () { return $7b924be9366471b4$export$d865ce2836f5927f; }, function (v) { return $7b924be9366471b4$export$d865ce2836f5927f = v; });
$parcel$export(module.exports, "permute", function () { return $7b924be9366471b4$export$95e62ad65da8b7d2; }, function (v) { return $7b924be9366471b4$export$95e62ad65da8b7d2 = v; });
$parcel$export(module.exports, "padSplit", function () { return $7b924be9366471b4$export$209139ff098c441a; }, function (v) { return $7b924be9366471b4$export$209139ff098c441a = v; });
var $7b924be9366471b4$export$cfaef8ed399428b0;
var $7b924be9366471b4$export$a80c7deaea7cbd80;
var $7b924be9366471b4$export$ed7577ae6e1cd0ef;
var $7b924be9366471b4$export$5dcbef3aa594f567;
var $7b924be9366471b4$export$5bc8001ca71ed9c5;
var $7b924be9366471b4$export$3e714e2c5d5d8cb2;
var $7b924be9366471b4$export$94c3e544fd062b7f;
var $7b924be9366471b4$export$9f77e0932fb78f72;
var $7b924be9366471b4$export$d865ce2836f5927f;
var $7b924be9366471b4$export$95e62ad65da8b7d2;
var $7b924be9366471b4$export$209139ff098c441a;
"use strict";
$7b924be9366471b4$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$7b924be9366471b4$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$7b924be9366471b4$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7b924be9366471b4$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7b924be9366471b4$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7b924be9366471b4$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $7b924be9366471b4$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$7b924be9366471b4$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $7b924be9366471b4$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $7b924be9366471b4$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $7b924be9366471b4$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $7b924be9366471b4$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7b924be9366471b4$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $7b924be9366471b4$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$7b924be9366471b4$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $7b924be9366471b4$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $7b924be9366471b4$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $7b924be9366471b4$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$7b924be9366471b4$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $7b924be9366471b4$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $7b924be9366471b4$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$7b924be9366471b4$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRequire.register("ouHy4", function(module, exports) {
"use strict";

var $3210N = parcelRequire("3210N");
function $049a0ea9d0be8ab9$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $049a0ea9d0be8ab9$var$Cipher;
$049a0ea9d0be8ab9$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$049a0ea9d0be8ab9$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$049a0ea9d0be8ab9$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$049a0ea9d0be8ab9$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$049a0ea9d0be8ab9$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$049a0ea9d0be8ab9$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$049a0ea9d0be8ab9$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$049a0ea9d0be8ab9$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$049a0ea9d0be8ab9$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$049a0ea9d0be8ab9$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$049a0ea9d0be8ab9$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $3210N.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRequire.register("3210N", function(module, exports) {
module.exports = $235257eb35d12727$var$assert;
function $235257eb35d12727$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$235257eb35d12727$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});


parcelRequire.register("9Euae", function(module, exports) {
"use strict";

var $3210N = parcelRequire("3210N");

var $kvFQ5 = parcelRequire("kvFQ5");

var $aBLCl = parcelRequire("aBLCl");

var $ouHy4 = parcelRequire("ouHy4");
function $706f3f705553ad90$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $706f3f705553ad90$var$DES(options) {
    $ouHy4.call(this, options);
    var state = new $706f3f705553ad90$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$kvFQ5($706f3f705553ad90$var$DES, $ouHy4);
module.exports = $706f3f705553ad90$var$DES;
$706f3f705553ad90$var$DES.create = function create(options) {
    return new $706f3f705553ad90$var$DES(options);
};
var $706f3f705553ad90$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$706f3f705553ad90$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $3210N.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $aBLCl.readUInt32BE(key, 0);
    var kR = $aBLCl.readUInt32BE(key, 4);
    $aBLCl.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $706f3f705553ad90$var$shiftTable[i >>> 1];
        kL = $aBLCl.r28shl(kL, shift);
        kR = $aBLCl.r28shl(kR, shift);
        $aBLCl.pc2(kL, kR, state.keys, i);
    }
};
$706f3f705553ad90$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $aBLCl.readUInt32BE(inp, inOff);
    var r = $aBLCl.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $aBLCl.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $aBLCl.writeUInt32BE(out, l, outOff);
    $aBLCl.writeUInt32BE(out, r, outOff + 4);
};
$706f3f705553ad90$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$706f3f705553ad90$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$3210N.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$706f3f705553ad90$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $aBLCl.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $aBLCl.substitute(keyL, keyR);
        var f = $aBLCl.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $aBLCl.rip(r, l, out, off);
};
$706f3f705553ad90$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $aBLCl.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $aBLCl.substitute(keyL, keyR);
        var f = $aBLCl.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $aBLCl.rip(l, r, out, off);
};

});

parcelRequire.register("g6X0U", function(module, exports) {

$parcel$export(module.exports, "instantiate", function () { return $bbaafbc209442532$export$f9bb8d20ccc7477a; }, function (v) { return $bbaafbc209442532$export$f9bb8d20ccc7477a = v; });
var $bbaafbc209442532$export$f9bb8d20ccc7477a;
"use strict";

var $3210N = parcelRequire("3210N");

var $kvFQ5 = parcelRequire("kvFQ5");
var $bbaafbc209442532$var$proto = {};
function $bbaafbc209442532$var$CBCState(iv) {
    $3210N.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $bbaafbc209442532$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $kvFQ5(CBC, Base);
    var keys = Object.keys($bbaafbc209442532$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $bbaafbc209442532$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$bbaafbc209442532$export$f9bb8d20ccc7477a = $bbaafbc209442532$var$instantiate;
$bbaafbc209442532$var$proto._cbcInit = function _cbcInit() {
    var state = new $bbaafbc209442532$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$bbaafbc209442532$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRequire.register("jKeW6", function(module, exports) {
"use strict";

var $3210N = parcelRequire("3210N");

var $kvFQ5 = parcelRequire("kvFQ5");

var $ouHy4 = parcelRequire("ouHy4");

var $9Euae = parcelRequire("9Euae");
function $e5fde62e8948339f$var$EDEState(type, key) {
    $3210N.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $9Euae.create({
            type: "encrypt",
            key: k1
        }),
        $9Euae.create({
            type: "decrypt",
            key: k2
        }),
        $9Euae.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $9Euae.create({
            type: "decrypt",
            key: k3
        }),
        $9Euae.create({
            type: "encrypt",
            key: k2
        }),
        $9Euae.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $e5fde62e8948339f$var$EDE(options) {
    $ouHy4.call(this, options);
    var state = new $e5fde62e8948339f$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$kvFQ5($e5fde62e8948339f$var$EDE, $ouHy4);
module.exports = $e5fde62e8948339f$var$EDE;
$e5fde62e8948339f$var$EDE.create = function create(options) {
    return new $e5fde62e8948339f$var$EDE(options);
};
$e5fde62e8948339f$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$e5fde62e8948339f$var$EDE.prototype._pad = $9Euae.prototype._pad;
$e5fde62e8948339f$var$EDE.prototype._unpad = $9Euae.prototype._unpad;

});

parcelRequire.register("1DWOT", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $13270f5c36ac4dfa$export$5b0f6292f11d1d18; }, function (v) { return $13270f5c36ac4dfa$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $13270f5c36ac4dfa$export$e85a0c9a1067c5d3; }, function (v) { return $13270f5c36ac4dfa$export$e85a0c9a1067c5d3 = v; });
var $13270f5c36ac4dfa$export$5b0f6292f11d1d18;
var $13270f5c36ac4dfa$export$e85a0c9a1067c5d3;
$13270f5c36ac4dfa$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$13270f5c36ac4dfa$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRequire.register("kwP8a", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $ef1e7553a5ab36ae$export$5b0f6292f11d1d18; }, function (v) { return $ef1e7553a5ab36ae$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $ef1e7553a5ab36ae$export$e85a0c9a1067c5d3; }, function (v) { return $ef1e7553a5ab36ae$export$e85a0c9a1067c5d3 = v; });
var $ef1e7553a5ab36ae$export$5b0f6292f11d1d18;
var $ef1e7553a5ab36ae$export$e85a0c9a1067c5d3;

var $8tLxg = parcelRequire("8tLxg");
$ef1e7553a5ab36ae$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $8tLxg(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$ef1e7553a5ab36ae$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $8tLxg(out, pad);
};

});
parcelRequire.register("8tLxg", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $62c5e7b7f185e8a4$require$Buffer = $gzLuY.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $62c5e7b7f185e8a4$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRequire.register("3rKMV", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $28282fde8d0414c5$export$5b0f6292f11d1d18; }, function (v) { return $28282fde8d0414c5$export$5b0f6292f11d1d18 = v; });
var $28282fde8d0414c5$export$5b0f6292f11d1d18;

var $eN0t8 = parcelRequire("eN0t8");
var $28282fde8d0414c5$require$Buffer = $eN0t8.Buffer;

var $8tLxg = parcelRequire("8tLxg");
function $28282fde8d0414c5$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $8tLxg(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $28282fde8d0414c5$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$28282fde8d0414c5$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $28282fde8d0414c5$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $28282fde8d0414c5$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $28282fde8d0414c5$require$Buffer.concat([
                out,
                $28282fde8d0414c5$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $28282fde8d0414c5$require$Buffer.concat([
                out,
                $28282fde8d0414c5$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRequire.register("kjrOo", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $ec9b27dbf2455e83$export$5b0f6292f11d1d18; }, function (v) { return $ec9b27dbf2455e83$export$5b0f6292f11d1d18 = v; });
var $ec9b27dbf2455e83$export$5b0f6292f11d1d18;

var $eN0t8 = parcelRequire("eN0t8");
var $ec9b27dbf2455e83$require$Buffer = $eN0t8.Buffer;
function $ec9b27dbf2455e83$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $ec9b27dbf2455e83$require$Buffer.concat([
        self._prev.slice(1),
        $ec9b27dbf2455e83$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$ec9b27dbf2455e83$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $ec9b27dbf2455e83$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $ec9b27dbf2455e83$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRequire.register("e65kP", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $a435c3a0404b3632$export$5b0f6292f11d1d18; }, function (v) { return $a435c3a0404b3632$export$5b0f6292f11d1d18 = v; });
var $a435c3a0404b3632$export$5b0f6292f11d1d18;

var $eN0t8 = parcelRequire("eN0t8");
var $a435c3a0404b3632$require$Buffer = $eN0t8.Buffer;
function $a435c3a0404b3632$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $a435c3a0404b3632$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $a435c3a0404b3632$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $a435c3a0404b3632$require$Buffer.allocUnsafe(buffer.length);
    buffer = $a435c3a0404b3632$require$Buffer.concat([
        buffer,
        $a435c3a0404b3632$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$a435c3a0404b3632$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $a435c3a0404b3632$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $a435c3a0404b3632$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRequire.register("4DRRs", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $361495a46d8b3be3$export$5b0f6292f11d1d18; }, function (v) { return $361495a46d8b3be3$export$5b0f6292f11d1d18 = v; });
var $361495a46d8b3be3$export$5b0f6292f11d1d18;

var $gzLuY = parcelRequire("gzLuY");
var $361495a46d8b3be3$require$Buffer = $gzLuY.Buffer;

var $8tLxg = parcelRequire("8tLxg");
function $361495a46d8b3be3$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$361495a46d8b3be3$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $361495a46d8b3be3$require$Buffer.concat([
        self._cache,
        $361495a46d8b3be3$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $8tLxg(chunk, pad);
};

});

parcelRequire.register("8mVCQ", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $617d140dabb62cb7$export$5b0f6292f11d1d18; }, function (v) { return $617d140dabb62cb7$export$5b0f6292f11d1d18 = v; });
var $617d140dabb62cb7$export$5b0f6292f11d1d18;

var $8tLxg = parcelRequire("8tLxg");

var $eN0t8 = parcelRequire("eN0t8");
var $617d140dabb62cb7$require$Buffer = $eN0t8.Buffer;

var $2dknS = parcelRequire("2dknS");
function $617d140dabb62cb7$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $2dknS(self._prev);
    return out;
}
var $617d140dabb62cb7$var$blockSize = 16;
$617d140dabb62cb7$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $617d140dabb62cb7$var$blockSize);
    var start = self._cache.length;
    self._cache = $617d140dabb62cb7$require$Buffer.concat([
        self._cache,
        $617d140dabb62cb7$require$Buffer.allocUnsafe(chunkNum * $617d140dabb62cb7$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $617d140dabb62cb7$var$getBlock(self);
        var offset = start + i * $617d140dabb62cb7$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $8tLxg(chunk, pad);
};

});
parcelRequire.register("2dknS", function(module, exports) {
function $19cc9b8550c96272$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $19cc9b8550c96272$var$incr32;

});


parcelRequire.register("jlWHo", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") start++;
        if (base === 16) this._parseHex(number, start);
        else this._parseBase(number, base, start);
        if (number[0] === "-") this.negative = 1;
        this.strip();
        if (endian !== "le") return;
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex(str, start, end) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r <<= 4;
            // 'a' - 'f'
            if (c >= 49 && c <= 54) r |= c - 49 + 0xa;
            else if (c >= 17 && c <= 22) r |= c - 17 + 0xa;
            else r |= c & 0xf;
        }
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        // Scan 24-bit chunks and add them to the number
        var off = 0;
        for(i = number.length - 6, j = 0; i >= start; i -= 6){
            w = parseHex(number, i, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        if (i + 6 !== start) {
            w = parseHex(number, start, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else r.strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("8v4zB", function(module, exports) {
var $6304c41c38b6f174$var$r;
module.exports = function rand(len) {
    if (!$6304c41c38b6f174$var$r) $6304c41c38b6f174$var$r = new $6304c41c38b6f174$var$Rand(null);
    return $6304c41c38b6f174$var$r.generate(len);
};
function $6304c41c38b6f174$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $6304c41c38b6f174$var$Rand;
$6304c41c38b6f174$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$6304c41c38b6f174$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $6304c41c38b6f174$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $6304c41c38b6f174$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $6304c41c38b6f174$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $6304c41c38b6f174$var$crypto = (parcelRequire("aqbQf"));
    if (typeof $6304c41c38b6f174$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $6304c41c38b6f174$var$Rand.prototype._rand = function _rand(n) {
        return $6304c41c38b6f174$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRequire.register("jJLyB", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("3tGej", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRequire.register("boA1w", function(module, exports) {
"use strict";
var $84bde1233ebed9e4$var$utils = module.exports;

var $h0anJ = parcelRequire("h0anJ");

var $3210N = parcelRequire("3210N");

var $4YHS3 = parcelRequire("4YHS3");
$84bde1233ebed9e4$var$utils.assert = $3210N;
$84bde1233ebed9e4$var$utils.toArray = $4YHS3.toArray;
$84bde1233ebed9e4$var$utils.zero2 = $4YHS3.zero2;
$84bde1233ebed9e4$var$utils.toHex = $4YHS3.toHex;
$84bde1233ebed9e4$var$utils.encode = $4YHS3.encode;
// Represent num in a w-NAF form
function $84bde1233ebed9e4$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$84bde1233ebed9e4$var$utils.getNAF = $84bde1233ebed9e4$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $84bde1233ebed9e4$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$84bde1233ebed9e4$var$utils.getJSF = $84bde1233ebed9e4$var$getJSF;
function $84bde1233ebed9e4$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$84bde1233ebed9e4$var$utils.cachedProperty = $84bde1233ebed9e4$var$cachedProperty;
function $84bde1233ebed9e4$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $84bde1233ebed9e4$var$utils.toArray(bytes, "hex") : bytes;
}
$84bde1233ebed9e4$var$utils.parseBytes = $84bde1233ebed9e4$var$parseBytes;
function $84bde1233ebed9e4$var$intFromLE(bytes) {
    return new $h0anJ(bytes, "hex", "le");
}
$84bde1233ebed9e4$var$utils.intFromLE = $84bde1233ebed9e4$var$intFromLE;

});
parcelRequire.register("h0anJ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("4YHS3", function(module, exports) {
"use strict";
var $39fecbdfe326fb6f$var$utils = module.exports;
function $39fecbdfe326fb6f$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$39fecbdfe326fb6f$var$utils.toArray = $39fecbdfe326fb6f$var$toArray;
function $39fecbdfe326fb6f$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$39fecbdfe326fb6f$var$utils.zero2 = $39fecbdfe326fb6f$var$zero2;
function $39fecbdfe326fb6f$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $39fecbdfe326fb6f$var$zero2(msg[i].toString(16));
    return res;
}
$39fecbdfe326fb6f$var$utils.toHex = $39fecbdfe326fb6f$var$toHex;
$39fecbdfe326fb6f$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $39fecbdfe326fb6f$var$toHex(arr);
    else return arr;
};

});


parcelRequire.register("hbDhv", function(module, exports) {
"use strict";
var $c831ef38bf9363e2$var$curve = module.exports;

$c831ef38bf9363e2$var$curve.base = (parcelRequire("3Ild8"));

$c831ef38bf9363e2$var$curve.short = (parcelRequire("l2gH1"));

$c831ef38bf9363e2$var$curve.mont = (parcelRequire("hWmH5"));

$c831ef38bf9363e2$var$curve.edwards = (parcelRequire("8SKTg"));

});
parcelRequire.register("3Ild8", function(module, exports) {
"use strict";

var $h0anJ = parcelRequire("h0anJ");

var $boA1w = parcelRequire("boA1w");
var $2b45ef357c32d9df$var$getNAF = $boA1w.getNAF;
var $2b45ef357c32d9df$var$getJSF = $boA1w.getJSF;
var $2b45ef357c32d9df$var$assert = $boA1w.assert;
function $2b45ef357c32d9df$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $h0anJ(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $h0anJ.red(conf.prime) : $h0anJ.mont(this.p);
    // Useful for many curves
    this.zero = new $h0anJ(0).toRed(this.red);
    this.one = new $h0anJ(1).toRed(this.red);
    this.two = new $h0anJ(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $h0anJ(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $2b45ef357c32d9df$var$BaseCurve;
$2b45ef357c32d9df$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$2b45ef357c32d9df$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$2b45ef357c32d9df$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $2b45ef357c32d9df$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $2b45ef357c32d9df$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$2b45ef357c32d9df$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $2b45ef357c32d9df$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $2b45ef357c32d9df$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$2b45ef357c32d9df$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $2b45ef357c32d9df$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $2b45ef357c32d9df$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $2b45ef357c32d9df$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $2b45ef357c32d9df$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$2b45ef357c32d9df$var$BaseCurve.BasePoint = $2b45ef357c32d9df$var$BasePoint;
$2b45ef357c32d9df$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$2b45ef357c32d9df$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$2b45ef357c32d9df$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $boA1w.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $2b45ef357c32d9df$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $2b45ef357c32d9df$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$2b45ef357c32d9df$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$2b45ef357c32d9df$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$2b45ef357c32d9df$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $boA1w.encode(this._encode(compact), enc);
};
$2b45ef357c32d9df$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$2b45ef357c32d9df$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$2b45ef357c32d9df$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$2b45ef357c32d9df$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$2b45ef357c32d9df$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$2b45ef357c32d9df$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRequire.register("l2gH1", function(module, exports) {
"use strict";

var $boA1w = parcelRequire("boA1w");

var $h0anJ = parcelRequire("h0anJ");

var $kvFQ5 = parcelRequire("kvFQ5");

var $3Ild8 = parcelRequire("3Ild8");
var $f506bbbb5a8e71f9$var$assert = $boA1w.assert;
function $f506bbbb5a8e71f9$var$ShortCurve(conf) {
    $3Ild8.call(this, "short", conf);
    this.a = new $h0anJ(conf.a, 16).toRed(this.red);
    this.b = new $h0anJ(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$kvFQ5($f506bbbb5a8e71f9$var$ShortCurve, $3Ild8);
module.exports = $f506bbbb5a8e71f9$var$ShortCurve;
$f506bbbb5a8e71f9$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $h0anJ(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $h0anJ(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $f506bbbb5a8e71f9$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $h0anJ(vec.a, 16),
            b: new $h0anJ(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $h0anJ.mont(num);
    var tinv = new $h0anJ(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $h0anJ(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $h0anJ(1);
    var y1 = new $h0anJ(0);
    var x2 = new $h0anJ(0);
    var y2 = new $h0anJ(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $h0anJ(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $f506bbbb5a8e71f9$var$Point(curve, x, y, isRed) {
    $3Ild8.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $h0anJ(x, 16);
        this.y = new $h0anJ(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$kvFQ5($f506bbbb5a8e71f9$var$Point, $3Ild8.BasePoint);
$f506bbbb5a8e71f9$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $f506bbbb5a8e71f9$var$Point(this, x, y, isRed);
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $f506bbbb5a8e71f9$var$Point.fromJSON(this, obj, red);
};
$f506bbbb5a8e71f9$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$f506bbbb5a8e71f9$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$f506bbbb5a8e71f9$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$f506bbbb5a8e71f9$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$f506bbbb5a8e71f9$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$f506bbbb5a8e71f9$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$f506bbbb5a8e71f9$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$f506bbbb5a8e71f9$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$f506bbbb5a8e71f9$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$f506bbbb5a8e71f9$var$Point.prototype.mul = function mul(k) {
    k = new $h0anJ(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$f506bbbb5a8e71f9$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$f506bbbb5a8e71f9$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$f506bbbb5a8e71f9$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$f506bbbb5a8e71f9$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$f506bbbb5a8e71f9$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $f506bbbb5a8e71f9$var$JPoint(curve, x, y, z) {
    $3Ild8.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $h0anJ(0);
    } else {
        this.x = new $h0anJ(x, 16);
        this.y = new $h0anJ(y, 16);
        this.z = new $h0anJ(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$kvFQ5($f506bbbb5a8e71f9$var$JPoint, $3Ild8.BasePoint);
$f506bbbb5a8e71f9$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $f506bbbb5a8e71f9$var$JPoint(this, x, y, z);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$f506bbbb5a8e71f9$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $h0anJ(k, kbase);
    return this.curve._wnafMul(this, k);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$f506bbbb5a8e71f9$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$f506bbbb5a8e71f9$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$f506bbbb5a8e71f9$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRequire.register("hWmH5", function(module, exports) {
"use strict";

var $h0anJ = parcelRequire("h0anJ");

var $kvFQ5 = parcelRequire("kvFQ5");

var $3Ild8 = parcelRequire("3Ild8");

var $boA1w = parcelRequire("boA1w");
function $d0f97501e3e6b182$var$MontCurve(conf) {
    $3Ild8.call(this, "mont", conf);
    this.a = new $h0anJ(conf.a, 16).toRed(this.red);
    this.b = new $h0anJ(conf.b, 16).toRed(this.red);
    this.i4 = new $h0anJ(4).toRed(this.red).redInvm();
    this.two = new $h0anJ(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$kvFQ5($d0f97501e3e6b182$var$MontCurve, $3Ild8);
module.exports = $d0f97501e3e6b182$var$MontCurve;
$d0f97501e3e6b182$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $d0f97501e3e6b182$var$Point(curve, x, z) {
    $3Ild8.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $h0anJ(x, 16);
        this.z = new $h0anJ(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$kvFQ5($d0f97501e3e6b182$var$Point, $3Ild8.BasePoint);
$d0f97501e3e6b182$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($boA1w.toArray(bytes, enc), 1);
};
$d0f97501e3e6b182$var$MontCurve.prototype.point = function point(x, z) {
    return new $d0f97501e3e6b182$var$Point(this, x, z);
};
$d0f97501e3e6b182$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $d0f97501e3e6b182$var$Point.fromJSON(this, obj);
};
$d0f97501e3e6b182$var$Point.prototype.precompute = function precompute() {
// No-op
};
$d0f97501e3e6b182$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$d0f97501e3e6b182$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $d0f97501e3e6b182$var$Point(curve, obj[0], obj[1] || curve.one);
};
$d0f97501e3e6b182$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$d0f97501e3e6b182$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$d0f97501e3e6b182$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$d0f97501e3e6b182$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$d0f97501e3e6b182$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$d0f97501e3e6b182$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$d0f97501e3e6b182$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$d0f97501e3e6b182$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$d0f97501e3e6b182$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$d0f97501e3e6b182$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$d0f97501e3e6b182$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRequire.register("8SKTg", function(module, exports) {
"use strict";

var $boA1w = parcelRequire("boA1w");

var $h0anJ = parcelRequire("h0anJ");

var $kvFQ5 = parcelRequire("kvFQ5");

var $3Ild8 = parcelRequire("3Ild8");
var $6777bd53b8a6130a$var$assert = $boA1w.assert;
function $6777bd53b8a6130a$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $3Ild8.call(this, "edwards", conf);
    this.a = new $h0anJ(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $h0anJ(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $h0anJ(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $6777bd53b8a6130a$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$kvFQ5($6777bd53b8a6130a$var$EdwardsCurve, $3Ild8);
module.exports = $6777bd53b8a6130a$var$EdwardsCurve;
$6777bd53b8a6130a$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$6777bd53b8a6130a$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$6777bd53b8a6130a$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$6777bd53b8a6130a$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $h0anJ(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$6777bd53b8a6130a$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $h0anJ(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$6777bd53b8a6130a$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $6777bd53b8a6130a$var$Point(curve, x, y, z, t) {
    $3Ild8.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $h0anJ(x, 16);
        this.y = new $h0anJ(y, 16);
        this.z = z ? new $h0anJ(z, 16) : this.curve.one;
        this.t = t && new $h0anJ(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$kvFQ5($6777bd53b8a6130a$var$Point, $3Ild8.BasePoint);
$6777bd53b8a6130a$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $6777bd53b8a6130a$var$Point.fromJSON(this, obj);
};
$6777bd53b8a6130a$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $6777bd53b8a6130a$var$Point(this, x, y, z, t);
};
$6777bd53b8a6130a$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $6777bd53b8a6130a$var$Point(curve, obj[0], obj[1], obj[2]);
};
$6777bd53b8a6130a$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$6777bd53b8a6130a$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$6777bd53b8a6130a$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$6777bd53b8a6130a$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$6777bd53b8a6130a$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$6777bd53b8a6130a$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$6777bd53b8a6130a$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$6777bd53b8a6130a$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$6777bd53b8a6130a$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$6777bd53b8a6130a$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$6777bd53b8a6130a$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$6777bd53b8a6130a$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$6777bd53b8a6130a$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$6777bd53b8a6130a$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$6777bd53b8a6130a$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$6777bd53b8a6130a$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$6777bd53b8a6130a$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$6777bd53b8a6130a$var$Point.prototype.toP = $6777bd53b8a6130a$var$Point.prototype.normalize;
$6777bd53b8a6130a$var$Point.prototype.mixedAdd = $6777bd53b8a6130a$var$Point.prototype.add;

});


parcelRequire.register("kKmfE", function(module, exports) {
"use strict";
var $f1a95d3133313cc8$var$curves = module.exports;

var $dMFrt = parcelRequire("dMFrt");

var $hbDhv = parcelRequire("hbDhv");

var $boA1w = parcelRequire("boA1w");
var $f1a95d3133313cc8$var$assert = $boA1w.assert;
function $f1a95d3133313cc8$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $hbDhv.short(options);
    else if (options.type === "edwards") this.curve = new $hbDhv.edwards(options);
    else this.curve = new $hbDhv.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $f1a95d3133313cc8$var$assert(this.g.validate(), "Invalid curve");
    $f1a95d3133313cc8$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$f1a95d3133313cc8$var$curves.PresetCurve = $f1a95d3133313cc8$var$PresetCurve;
function $f1a95d3133313cc8$var$defineCurve(name, options) {
    Object.defineProperty($f1a95d3133313cc8$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $f1a95d3133313cc8$var$PresetCurve(options);
            Object.defineProperty($f1a95d3133313cc8$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$f1a95d3133313cc8$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $dMFrt.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$f1a95d3133313cc8$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $dMFrt.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$f1a95d3133313cc8$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $dMFrt.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$f1a95d3133313cc8$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $dMFrt.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$f1a95d3133313cc8$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $dMFrt.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$f1a95d3133313cc8$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $dMFrt.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$f1a95d3133313cc8$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $dMFrt.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $f1a95d3133313cc8$var$pre;

try {
    $f1a95d3133313cc8$var$pre = (parcelRequire("cBTAl"));
} catch (e) {
    $f1a95d3133313cc8$var$pre = undefined;
}
$f1a95d3133313cc8$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $dMFrt.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $f1a95d3133313cc8$var$pre
    ]
});

});
parcelRequire.register("dMFrt", function(module, exports) {
var $a08fe79466179a86$var$hash = module.exports;

$a08fe79466179a86$var$hash.utils = (parcelRequire("cYl7t"));

$a08fe79466179a86$var$hash.common = (parcelRequire("1pS1U"));

$a08fe79466179a86$var$hash.sha = (parcelRequire("imuzp"));

$a08fe79466179a86$var$hash.ripemd = (parcelRequire("jAZNy"));

$a08fe79466179a86$var$hash.hmac = (parcelRequire("hC4jp"));
// Proxy hash functions to the main object
$a08fe79466179a86$var$hash.sha1 = $a08fe79466179a86$var$hash.sha.sha1;
$a08fe79466179a86$var$hash.sha256 = $a08fe79466179a86$var$hash.sha.sha256;
$a08fe79466179a86$var$hash.sha224 = $a08fe79466179a86$var$hash.sha.sha224;
$a08fe79466179a86$var$hash.sha384 = $a08fe79466179a86$var$hash.sha.sha384;
$a08fe79466179a86$var$hash.sha512 = $a08fe79466179a86$var$hash.sha.sha512;
$a08fe79466179a86$var$hash.ripemd160 = $a08fe79466179a86$var$hash.ripemd.ripemd160;

});
parcelRequire.register("cYl7t", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $971b7885424ac20e$export$69f1b2dcda23c5f8; }, function (v) { return $971b7885424ac20e$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $971b7885424ac20e$export$45b10814cc054894; }, function (v) { return $971b7885424ac20e$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $971b7885424ac20e$export$7ea66e3774a60b67; }, function (v) { return $971b7885424ac20e$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $971b7885424ac20e$export$34a52f00f601f6f1; }, function (v) { return $971b7885424ac20e$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $971b7885424ac20e$export$812b0cbd5e8a72ab; }, function (v) { return $971b7885424ac20e$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $971b7885424ac20e$export$f24f9e11d63bb314; }, function (v) { return $971b7885424ac20e$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $971b7885424ac20e$export$b71357c7e07ca1f1; }, function (v) { return $971b7885424ac20e$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $971b7885424ac20e$export$2e58a4b541fdcbe8; }, function (v) { return $971b7885424ac20e$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $971b7885424ac20e$export$183b950bde9faab8; }, function (v) { return $971b7885424ac20e$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $971b7885424ac20e$export$4785c77169fea59e; }, function (v) { return $971b7885424ac20e$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $971b7885424ac20e$export$242a185dfcffac5b; }, function (v) { return $971b7885424ac20e$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $971b7885424ac20e$export$58c04ae0ae31877d; }, function (v) { return $971b7885424ac20e$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $971b7885424ac20e$export$d058ca695f8c6f11; }, function (v) { return $971b7885424ac20e$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $971b7885424ac20e$export$a1efd7fc3e986367; }, function (v) { return $971b7885424ac20e$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $971b7885424ac20e$export$bbfea4a2b5abaab4; }, function (v) { return $971b7885424ac20e$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $971b7885424ac20e$export$97ad4afc7de86152; }, function (v) { return $971b7885424ac20e$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $971b7885424ac20e$export$ce4673d9a79f6a4b; }, function (v) { return $971b7885424ac20e$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $971b7885424ac20e$export$786cc99fc6eedc0b; }, function (v) { return $971b7885424ac20e$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $971b7885424ac20e$export$45c59b9a1848dd0; }, function (v) { return $971b7885424ac20e$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $971b7885424ac20e$export$50d8f613e76d3034; }, function (v) { return $971b7885424ac20e$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $971b7885424ac20e$export$b8e83683c60ee162; }, function (v) { return $971b7885424ac20e$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $971b7885424ac20e$export$aeeb51790d1bcc4a; }, function (v) { return $971b7885424ac20e$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $971b7885424ac20e$export$bb7c616f719ad9c; }, function (v) { return $971b7885424ac20e$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $971b7885424ac20e$export$4d63290824f9d7df; }, function (v) { return $971b7885424ac20e$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $971b7885424ac20e$export$2f64ceb90ef28ea1; }, function (v) { return $971b7885424ac20e$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $971b7885424ac20e$export$8d2089d465f6d10d; }, function (v) { return $971b7885424ac20e$export$8d2089d465f6d10d = v; });
var $971b7885424ac20e$export$69f1b2dcda23c5f8;
var $971b7885424ac20e$export$45b10814cc054894;
var $971b7885424ac20e$export$7ea66e3774a60b67;
var $971b7885424ac20e$export$34a52f00f601f6f1;
var $971b7885424ac20e$export$812b0cbd5e8a72ab;
var $971b7885424ac20e$export$f24f9e11d63bb314;
var $971b7885424ac20e$export$b71357c7e07ca1f1;
var $971b7885424ac20e$export$2e58a4b541fdcbe8;
var $971b7885424ac20e$export$183b950bde9faab8;
var $971b7885424ac20e$export$4785c77169fea59e;
var $971b7885424ac20e$export$242a185dfcffac5b;
var $971b7885424ac20e$export$58c04ae0ae31877d;
var $971b7885424ac20e$export$d058ca695f8c6f11;
var $971b7885424ac20e$export$a1efd7fc3e986367;
var $971b7885424ac20e$export$bbfea4a2b5abaab4;
var $971b7885424ac20e$export$97ad4afc7de86152;
var $971b7885424ac20e$export$ce4673d9a79f6a4b;
var $971b7885424ac20e$export$786cc99fc6eedc0b;
var $971b7885424ac20e$export$45c59b9a1848dd0;
var $971b7885424ac20e$export$50d8f613e76d3034;
var $971b7885424ac20e$export$b8e83683c60ee162;
var $971b7885424ac20e$export$aeeb51790d1bcc4a;
var $971b7885424ac20e$export$bb7c616f719ad9c;
var $971b7885424ac20e$export$4d63290824f9d7df;
var $971b7885424ac20e$export$2f64ceb90ef28ea1;
var $971b7885424ac20e$export$8d2089d465f6d10d;
"use strict";

var $3210N = parcelRequire("3210N");

var $kvFQ5 = parcelRequire("kvFQ5");
$971b7885424ac20e$export$69f1b2dcda23c5f8 = $kvFQ5;
function $971b7885424ac20e$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $971b7885424ac20e$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($971b7885424ac20e$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$971b7885424ac20e$export$45b10814cc054894 = $971b7885424ac20e$var$toArray;
function $971b7885424ac20e$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $971b7885424ac20e$var$zero2(msg[i].toString(16));
    return res;
}
$971b7885424ac20e$export$7ea66e3774a60b67 = $971b7885424ac20e$var$toHex;
function $971b7885424ac20e$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$971b7885424ac20e$export$34a52f00f601f6f1 = $971b7885424ac20e$var$htonl;
function $971b7885424ac20e$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $971b7885424ac20e$var$htonl(w);
        res += $971b7885424ac20e$var$zero8(w.toString(16));
    }
    return res;
}
$971b7885424ac20e$export$812b0cbd5e8a72ab = $971b7885424ac20e$var$toHex32;
function $971b7885424ac20e$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$971b7885424ac20e$export$f24f9e11d63bb314 = $971b7885424ac20e$var$zero2;
function $971b7885424ac20e$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$971b7885424ac20e$export$b71357c7e07ca1f1 = $971b7885424ac20e$var$zero8;
function $971b7885424ac20e$var$join32(msg, start, end, endian) {
    var len = end - start;
    $3210N(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$971b7885424ac20e$export$2e58a4b541fdcbe8 = $971b7885424ac20e$var$join32;
function $971b7885424ac20e$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$971b7885424ac20e$export$183b950bde9faab8 = $971b7885424ac20e$var$split32;
function $971b7885424ac20e$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$971b7885424ac20e$export$4785c77169fea59e = $971b7885424ac20e$var$rotr32;
function $971b7885424ac20e$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$971b7885424ac20e$export$242a185dfcffac5b = $971b7885424ac20e$var$rotl32;
function $971b7885424ac20e$var$sum32(a, b) {
    return a + b >>> 0;
}
$971b7885424ac20e$export$58c04ae0ae31877d = $971b7885424ac20e$var$sum32;
function $971b7885424ac20e$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$971b7885424ac20e$export$d058ca695f8c6f11 = $971b7885424ac20e$var$sum32_3;
function $971b7885424ac20e$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$971b7885424ac20e$export$a1efd7fc3e986367 = $971b7885424ac20e$var$sum32_4;
function $971b7885424ac20e$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$971b7885424ac20e$export$bbfea4a2b5abaab4 = $971b7885424ac20e$var$sum32_5;
function $971b7885424ac20e$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$971b7885424ac20e$export$97ad4afc7de86152 = $971b7885424ac20e$var$sum64;
function $971b7885424ac20e$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$971b7885424ac20e$export$ce4673d9a79f6a4b = $971b7885424ac20e$var$sum64_hi;
function $971b7885424ac20e$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$971b7885424ac20e$export$786cc99fc6eedc0b = $971b7885424ac20e$var$sum64_lo;
function $971b7885424ac20e$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$971b7885424ac20e$export$45c59b9a1848dd0 = $971b7885424ac20e$var$sum64_4_hi;
function $971b7885424ac20e$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$971b7885424ac20e$export$50d8f613e76d3034 = $971b7885424ac20e$var$sum64_4_lo;
function $971b7885424ac20e$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$971b7885424ac20e$export$b8e83683c60ee162 = $971b7885424ac20e$var$sum64_5_hi;
function $971b7885424ac20e$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$971b7885424ac20e$export$aeeb51790d1bcc4a = $971b7885424ac20e$var$sum64_5_lo;
function $971b7885424ac20e$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$971b7885424ac20e$export$bb7c616f719ad9c = $971b7885424ac20e$var$rotr64_hi;
function $971b7885424ac20e$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$971b7885424ac20e$export$4d63290824f9d7df = $971b7885424ac20e$var$rotr64_lo;
function $971b7885424ac20e$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$971b7885424ac20e$export$2f64ceb90ef28ea1 = $971b7885424ac20e$var$shr64_hi;
function $971b7885424ac20e$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$971b7885424ac20e$export$8d2089d465f6d10d = $971b7885424ac20e$var$shr64_lo;

});

parcelRequire.register("1pS1U", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $10820970b61d1a41$export$8687658379b577e6; }, function (v) { return $10820970b61d1a41$export$8687658379b577e6 = v; });
var $10820970b61d1a41$export$8687658379b577e6;
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $3210N = parcelRequire("3210N");
function $10820970b61d1a41$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$10820970b61d1a41$export$8687658379b577e6 = $10820970b61d1a41$var$BlockHash;
$10820970b61d1a41$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $cYl7t.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $cYl7t.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$10820970b61d1a41$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $3210N(this.pending === null);
    return this._digest(enc);
};
$10820970b61d1a41$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRequire.register("imuzp", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $d5e1fea904e0f988$export$5091bdda49ba90f5; }, function (v) { return $d5e1fea904e0f988$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $d5e1fea904e0f988$export$97b70509d4e397ea; }, function (v) { return $d5e1fea904e0f988$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $d5e1fea904e0f988$export$bced8d2aada2d1c9; }, function (v) { return $d5e1fea904e0f988$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $d5e1fea904e0f988$export$612d47d55dedde45; }, function (v) { return $d5e1fea904e0f988$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $d5e1fea904e0f988$export$a888d2532e6dc7bb; }, function (v) { return $d5e1fea904e0f988$export$a888d2532e6dc7bb = v; });
var $d5e1fea904e0f988$export$5091bdda49ba90f5;
var $d5e1fea904e0f988$export$97b70509d4e397ea;
var $d5e1fea904e0f988$export$bced8d2aada2d1c9;
var $d5e1fea904e0f988$export$612d47d55dedde45;
var $d5e1fea904e0f988$export$a888d2532e6dc7bb;
"use strict";

$d5e1fea904e0f988$export$5091bdda49ba90f5 = (parcelRequire("2cerY"));

$d5e1fea904e0f988$export$97b70509d4e397ea = (parcelRequire("i5Q5x"));

$d5e1fea904e0f988$export$bced8d2aada2d1c9 = (parcelRequire("3HSKF"));

$d5e1fea904e0f988$export$612d47d55dedde45 = (parcelRequire("aWFyw"));

$d5e1fea904e0f988$export$a888d2532e6dc7bb = (parcelRequire("6bcDP"));

});
parcelRequire.register("2cerY", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $1pS1U = parcelRequire("1pS1U");

var $bznKp = parcelRequire("bznKp");
var $1997e941b78c78de$var$rotl32 = $cYl7t.rotl32;
var $1997e941b78c78de$var$sum32 = $cYl7t.sum32;
var $1997e941b78c78de$var$sum32_5 = $cYl7t.sum32_5;
var $1997e941b78c78de$var$ft_1 = $bznKp.ft_1;
var $1997e941b78c78de$var$BlockHash = $1pS1U.BlockHash;
var $1997e941b78c78de$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $1997e941b78c78de$var$SHA1() {
    if (!(this instanceof $1997e941b78c78de$var$SHA1)) return new $1997e941b78c78de$var$SHA1();
    $1997e941b78c78de$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$cYl7t.inherits($1997e941b78c78de$var$SHA1, $1997e941b78c78de$var$BlockHash);
module.exports = $1997e941b78c78de$var$SHA1;
$1997e941b78c78de$var$SHA1.blockSize = 512;
$1997e941b78c78de$var$SHA1.outSize = 160;
$1997e941b78c78de$var$SHA1.hmacStrength = 80;
$1997e941b78c78de$var$SHA1.padLength = 64;
$1997e941b78c78de$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $1997e941b78c78de$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $1997e941b78c78de$var$sum32_5($1997e941b78c78de$var$rotl32(a, 5), $1997e941b78c78de$var$ft_1(s, b, c, d), e, W[i], $1997e941b78c78de$var$sha1_K[s]);
        e = d;
        d = c;
        c = $1997e941b78c78de$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $1997e941b78c78de$var$sum32(this.h[0], a);
    this.h[1] = $1997e941b78c78de$var$sum32(this.h[1], b);
    this.h[2] = $1997e941b78c78de$var$sum32(this.h[2], c);
    this.h[3] = $1997e941b78c78de$var$sum32(this.h[3], d);
    this.h[4] = $1997e941b78c78de$var$sum32(this.h[4], e);
};
$1997e941b78c78de$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h, "big");
    else return $cYl7t.split32(this.h, "big");
};

});
parcelRequire.register("bznKp", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $86c562611187daa4$export$5a92649d7ddb9f63; }, function (v) { return $86c562611187daa4$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $86c562611187daa4$export$c6d0d020c3a6269; }, function (v) { return $86c562611187daa4$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $86c562611187daa4$export$eb90c27fca05f956; }, function (v) { return $86c562611187daa4$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $86c562611187daa4$export$14a4a98e063b1999; }, function (v) { return $86c562611187daa4$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $86c562611187daa4$export$d20cecfa1564c686; }, function (v) { return $86c562611187daa4$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $86c562611187daa4$export$44fd472a12fc6db; }, function (v) { return $86c562611187daa4$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $86c562611187daa4$export$1ed238bb6ea1dd47; }, function (v) { return $86c562611187daa4$export$1ed238bb6ea1dd47 = v; });
var $86c562611187daa4$export$5a92649d7ddb9f63;
var $86c562611187daa4$export$c6d0d020c3a6269;
var $86c562611187daa4$export$eb90c27fca05f956;
var $86c562611187daa4$export$cc992891a14496a1;
var $86c562611187daa4$export$14a4a98e063b1999;
var $86c562611187daa4$export$d20cecfa1564c686;
var $86c562611187daa4$export$44fd472a12fc6db;
var $86c562611187daa4$export$1ed238bb6ea1dd47;
"use strict";

var $cYl7t = parcelRequire("cYl7t");
var $86c562611187daa4$var$rotr32 = $cYl7t.rotr32;
function $86c562611187daa4$var$ft_1(s, x, y, z) {
    if (s === 0) return $86c562611187daa4$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $86c562611187daa4$var$p32(x, y, z);
    if (s === 2) return $86c562611187daa4$var$maj32(x, y, z);
}
$86c562611187daa4$export$5a92649d7ddb9f63 = $86c562611187daa4$var$ft_1;
function $86c562611187daa4$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$86c562611187daa4$export$c6d0d020c3a6269 = $86c562611187daa4$var$ch32;
function $86c562611187daa4$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$86c562611187daa4$export$eb90c27fca05f956 = $86c562611187daa4$var$maj32;
function $86c562611187daa4$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$86c562611187daa4$export$cc992891a14496a1 = $86c562611187daa4$var$p32;
function $86c562611187daa4$var$s0_256(x) {
    return $86c562611187daa4$var$rotr32(x, 2) ^ $86c562611187daa4$var$rotr32(x, 13) ^ $86c562611187daa4$var$rotr32(x, 22);
}
$86c562611187daa4$export$14a4a98e063b1999 = $86c562611187daa4$var$s0_256;
function $86c562611187daa4$var$s1_256(x) {
    return $86c562611187daa4$var$rotr32(x, 6) ^ $86c562611187daa4$var$rotr32(x, 11) ^ $86c562611187daa4$var$rotr32(x, 25);
}
$86c562611187daa4$export$d20cecfa1564c686 = $86c562611187daa4$var$s1_256;
function $86c562611187daa4$var$g0_256(x) {
    return $86c562611187daa4$var$rotr32(x, 7) ^ $86c562611187daa4$var$rotr32(x, 18) ^ x >>> 3;
}
$86c562611187daa4$export$44fd472a12fc6db = $86c562611187daa4$var$g0_256;
function $86c562611187daa4$var$g1_256(x) {
    return $86c562611187daa4$var$rotr32(x, 17) ^ $86c562611187daa4$var$rotr32(x, 19) ^ x >>> 10;
}
$86c562611187daa4$export$1ed238bb6ea1dd47 = $86c562611187daa4$var$g1_256;

});


parcelRequire.register("i5Q5x", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $3HSKF = parcelRequire("3HSKF");
function $d2c1194d6901331b$var$SHA224() {
    if (!(this instanceof $d2c1194d6901331b$var$SHA224)) return new $d2c1194d6901331b$var$SHA224();
    $3HSKF.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$cYl7t.inherits($d2c1194d6901331b$var$SHA224, $3HSKF);
module.exports = $d2c1194d6901331b$var$SHA224;
$d2c1194d6901331b$var$SHA224.blockSize = 512;
$d2c1194d6901331b$var$SHA224.outSize = 224;
$d2c1194d6901331b$var$SHA224.hmacStrength = 192;
$d2c1194d6901331b$var$SHA224.padLength = 64;
$d2c1194d6901331b$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $cYl7t.toHex32(this.h.slice(0, 7), "big");
    else return $cYl7t.split32(this.h.slice(0, 7), "big");
};

});
parcelRequire.register("3HSKF", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $1pS1U = parcelRequire("1pS1U");

var $bznKp = parcelRequire("bznKp");

var $3210N = parcelRequire("3210N");
var $2b2fdbcd8fab6652$var$sum32 = $cYl7t.sum32;
var $2b2fdbcd8fab6652$var$sum32_4 = $cYl7t.sum32_4;
var $2b2fdbcd8fab6652$var$sum32_5 = $cYl7t.sum32_5;
var $2b2fdbcd8fab6652$var$ch32 = $bznKp.ch32;
var $2b2fdbcd8fab6652$var$maj32 = $bznKp.maj32;
var $2b2fdbcd8fab6652$var$s0_256 = $bznKp.s0_256;
var $2b2fdbcd8fab6652$var$s1_256 = $bznKp.s1_256;
var $2b2fdbcd8fab6652$var$g0_256 = $bznKp.g0_256;
var $2b2fdbcd8fab6652$var$g1_256 = $bznKp.g1_256;
var $2b2fdbcd8fab6652$var$BlockHash = $1pS1U.BlockHash;
var $2b2fdbcd8fab6652$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $2b2fdbcd8fab6652$var$SHA256() {
    if (!(this instanceof $2b2fdbcd8fab6652$var$SHA256)) return new $2b2fdbcd8fab6652$var$SHA256();
    $2b2fdbcd8fab6652$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $2b2fdbcd8fab6652$var$sha256_K;
    this.W = new Array(64);
}
$cYl7t.inherits($2b2fdbcd8fab6652$var$SHA256, $2b2fdbcd8fab6652$var$BlockHash);
module.exports = $2b2fdbcd8fab6652$var$SHA256;
$2b2fdbcd8fab6652$var$SHA256.blockSize = 512;
$2b2fdbcd8fab6652$var$SHA256.outSize = 256;
$2b2fdbcd8fab6652$var$SHA256.hmacStrength = 192;
$2b2fdbcd8fab6652$var$SHA256.padLength = 64;
$2b2fdbcd8fab6652$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $2b2fdbcd8fab6652$var$sum32_4($2b2fdbcd8fab6652$var$g1_256(W[i - 2]), W[i - 7], $2b2fdbcd8fab6652$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $3210N(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $2b2fdbcd8fab6652$var$sum32_5(h, $2b2fdbcd8fab6652$var$s1_256(e), $2b2fdbcd8fab6652$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $2b2fdbcd8fab6652$var$sum32($2b2fdbcd8fab6652$var$s0_256(a), $2b2fdbcd8fab6652$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $2b2fdbcd8fab6652$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $2b2fdbcd8fab6652$var$sum32(T1, T2);
    }
    this.h[0] = $2b2fdbcd8fab6652$var$sum32(this.h[0], a);
    this.h[1] = $2b2fdbcd8fab6652$var$sum32(this.h[1], b);
    this.h[2] = $2b2fdbcd8fab6652$var$sum32(this.h[2], c);
    this.h[3] = $2b2fdbcd8fab6652$var$sum32(this.h[3], d);
    this.h[4] = $2b2fdbcd8fab6652$var$sum32(this.h[4], e);
    this.h[5] = $2b2fdbcd8fab6652$var$sum32(this.h[5], f);
    this.h[6] = $2b2fdbcd8fab6652$var$sum32(this.h[6], g);
    this.h[7] = $2b2fdbcd8fab6652$var$sum32(this.h[7], h);
};
$2b2fdbcd8fab6652$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h, "big");
    else return $cYl7t.split32(this.h, "big");
};

});


parcelRequire.register("aWFyw", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $6bcDP = parcelRequire("6bcDP");
function $7f7f8e474b2a977d$var$SHA384() {
    if (!(this instanceof $7f7f8e474b2a977d$var$SHA384)) return new $7f7f8e474b2a977d$var$SHA384();
    $6bcDP.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$cYl7t.inherits($7f7f8e474b2a977d$var$SHA384, $6bcDP);
module.exports = $7f7f8e474b2a977d$var$SHA384;
$7f7f8e474b2a977d$var$SHA384.blockSize = 1024;
$7f7f8e474b2a977d$var$SHA384.outSize = 384;
$7f7f8e474b2a977d$var$SHA384.hmacStrength = 192;
$7f7f8e474b2a977d$var$SHA384.padLength = 128;
$7f7f8e474b2a977d$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h.slice(0, 12), "big");
    else return $cYl7t.split32(this.h.slice(0, 12), "big");
};

});
parcelRequire.register("6bcDP", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $1pS1U = parcelRequire("1pS1U");

var $3210N = parcelRequire("3210N");
var $47fd937a71a2450c$var$rotr64_hi = $cYl7t.rotr64_hi;
var $47fd937a71a2450c$var$rotr64_lo = $cYl7t.rotr64_lo;
var $47fd937a71a2450c$var$shr64_hi = $cYl7t.shr64_hi;
var $47fd937a71a2450c$var$shr64_lo = $cYl7t.shr64_lo;
var $47fd937a71a2450c$var$sum64 = $cYl7t.sum64;
var $47fd937a71a2450c$var$sum64_hi = $cYl7t.sum64_hi;
var $47fd937a71a2450c$var$sum64_lo = $cYl7t.sum64_lo;
var $47fd937a71a2450c$var$sum64_4_hi = $cYl7t.sum64_4_hi;
var $47fd937a71a2450c$var$sum64_4_lo = $cYl7t.sum64_4_lo;
var $47fd937a71a2450c$var$sum64_5_hi = $cYl7t.sum64_5_hi;
var $47fd937a71a2450c$var$sum64_5_lo = $cYl7t.sum64_5_lo;
var $47fd937a71a2450c$var$BlockHash = $1pS1U.BlockHash;
var $47fd937a71a2450c$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $47fd937a71a2450c$var$SHA512() {
    if (!(this instanceof $47fd937a71a2450c$var$SHA512)) return new $47fd937a71a2450c$var$SHA512();
    $47fd937a71a2450c$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $47fd937a71a2450c$var$sha512_K;
    this.W = new Array(160);
}
$cYl7t.inherits($47fd937a71a2450c$var$SHA512, $47fd937a71a2450c$var$BlockHash);
module.exports = $47fd937a71a2450c$var$SHA512;
$47fd937a71a2450c$var$SHA512.blockSize = 1024;
$47fd937a71a2450c$var$SHA512.outSize = 512;
$47fd937a71a2450c$var$SHA512.hmacStrength = 192;
$47fd937a71a2450c$var$SHA512.padLength = 128;
$47fd937a71a2450c$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $47fd937a71a2450c$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $47fd937a71a2450c$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $47fd937a71a2450c$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $47fd937a71a2450c$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $47fd937a71a2450c$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $47fd937a71a2450c$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$47fd937a71a2450c$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $3210N(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $47fd937a71a2450c$var$s1_512_hi(eh, el);
        var c1_lo = $47fd937a71a2450c$var$s1_512_lo(eh, el);
        var c2_hi = $47fd937a71a2450c$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $47fd937a71a2450c$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $47fd937a71a2450c$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $47fd937a71a2450c$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $47fd937a71a2450c$var$s0_512_hi(ah, al);
        c0_lo = $47fd937a71a2450c$var$s0_512_lo(ah, al);
        c1_hi = $47fd937a71a2450c$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $47fd937a71a2450c$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $47fd937a71a2450c$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $47fd937a71a2450c$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $47fd937a71a2450c$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $47fd937a71a2450c$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $47fd937a71a2450c$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $47fd937a71a2450c$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $47fd937a71a2450c$var$sum64(this.h, 0, ah, al);
    $47fd937a71a2450c$var$sum64(this.h, 2, bh, bl);
    $47fd937a71a2450c$var$sum64(this.h, 4, ch, cl);
    $47fd937a71a2450c$var$sum64(this.h, 6, dh, dl);
    $47fd937a71a2450c$var$sum64(this.h, 8, eh, el);
    $47fd937a71a2450c$var$sum64(this.h, 10, fh, fl);
    $47fd937a71a2450c$var$sum64(this.h, 12, gh, gl);
    $47fd937a71a2450c$var$sum64(this.h, 14, hh, hl);
};
$47fd937a71a2450c$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h, "big");
    else return $cYl7t.split32(this.h, "big");
};
function $47fd937a71a2450c$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$s0_512_hi(xh, xl) {
    var c0_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $47fd937a71a2450c$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $47fd937a71a2450c$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$s0_512_lo(xh, xl) {
    var c0_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $47fd937a71a2450c$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $47fd937a71a2450c$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$s1_512_hi(xh, xl) {
    var c0_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $47fd937a71a2450c$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$s1_512_lo(xh, xl) {
    var c0_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $47fd937a71a2450c$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$g0_512_hi(xh, xl) {
    var c0_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $47fd937a71a2450c$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$g0_512_lo(xh, xl) {
    var c0_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $47fd937a71a2450c$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$g1_512_hi(xh, xl) {
    var c0_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $47fd937a71a2450c$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $47fd937a71a2450c$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$g1_512_lo(xh, xl) {
    var c0_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $47fd937a71a2450c$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $47fd937a71a2450c$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRequire.register("jAZNy", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $e44150fbd2160137$export$d1cea0ee4e3f0d3e; }, function (v) { return $e44150fbd2160137$export$d1cea0ee4e3f0d3e = v; });
var $e44150fbd2160137$export$d1cea0ee4e3f0d3e;
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $1pS1U = parcelRequire("1pS1U");
var $e44150fbd2160137$var$rotl32 = $cYl7t.rotl32;
var $e44150fbd2160137$var$sum32 = $cYl7t.sum32;
var $e44150fbd2160137$var$sum32_3 = $cYl7t.sum32_3;
var $e44150fbd2160137$var$sum32_4 = $cYl7t.sum32_4;
var $e44150fbd2160137$var$BlockHash = $1pS1U.BlockHash;
function $e44150fbd2160137$var$RIPEMD160() {
    if (!(this instanceof $e44150fbd2160137$var$RIPEMD160)) return new $e44150fbd2160137$var$RIPEMD160();
    $e44150fbd2160137$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$cYl7t.inherits($e44150fbd2160137$var$RIPEMD160, $e44150fbd2160137$var$BlockHash);
$e44150fbd2160137$export$d1cea0ee4e3f0d3e = $e44150fbd2160137$var$RIPEMD160;
$e44150fbd2160137$var$RIPEMD160.blockSize = 512;
$e44150fbd2160137$var$RIPEMD160.outSize = 160;
$e44150fbd2160137$var$RIPEMD160.hmacStrength = 192;
$e44150fbd2160137$var$RIPEMD160.padLength = 64;
$e44150fbd2160137$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $e44150fbd2160137$var$sum32($e44150fbd2160137$var$rotl32($e44150fbd2160137$var$sum32_4(A, $e44150fbd2160137$var$f(j, B, C, D), msg[$e44150fbd2160137$var$r[j] + start], $e44150fbd2160137$var$K(j)), $e44150fbd2160137$var$s[j]), E);
        A = E;
        E = D;
        D = $e44150fbd2160137$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $e44150fbd2160137$var$sum32($e44150fbd2160137$var$rotl32($e44150fbd2160137$var$sum32_4(Ah, $e44150fbd2160137$var$f(79 - j, Bh, Ch, Dh), msg[$e44150fbd2160137$var$rh[j] + start], $e44150fbd2160137$var$Kh(j)), $e44150fbd2160137$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $e44150fbd2160137$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $e44150fbd2160137$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $e44150fbd2160137$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $e44150fbd2160137$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $e44150fbd2160137$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $e44150fbd2160137$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$e44150fbd2160137$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h, "little");
    else return $cYl7t.split32(this.h, "little");
};
function $e44150fbd2160137$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $e44150fbd2160137$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $e44150fbd2160137$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $e44150fbd2160137$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $e44150fbd2160137$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $e44150fbd2160137$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $e44150fbd2160137$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRequire.register("hC4jp", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $3210N = parcelRequire("3210N");
function $cd29549494435068$var$Hmac(hash, key, enc) {
    if (!(this instanceof $cd29549494435068$var$Hmac)) return new $cd29549494435068$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($cYl7t.toArray(key, enc));
}
module.exports = $cd29549494435068$var$Hmac;
$cd29549494435068$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $3210N(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$cd29549494435068$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$cd29549494435068$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRequire.register("cBTAl", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRequire.register("jA2EE", function(module, exports) {
"use strict";

var $h0anJ = parcelRequire("h0anJ");

var $kNeip = parcelRequire("kNeip");

var $boA1w = parcelRequire("boA1w");

var $kKmfE = parcelRequire("kKmfE");

var $8v4zB = parcelRequire("8v4zB");
var $03adbb9dfc3c6eed$var$assert = $boA1w.assert;

var $6UxhE = parcelRequire("6UxhE");

var $3VM75 = parcelRequire("3VM75");
function $03adbb9dfc3c6eed$var$EC(options) {
    if (!(this instanceof $03adbb9dfc3c6eed$var$EC)) return new $03adbb9dfc3c6eed$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $03adbb9dfc3c6eed$var$assert(Object.prototype.hasOwnProperty.call($kKmfE, options), "Unknown curve " + options);
        options = $kKmfE[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $kKmfE.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $03adbb9dfc3c6eed$var$EC;
$03adbb9dfc3c6eed$var$EC.prototype.keyPair = function keyPair(options) {
    return new $6UxhE(this, options);
};
$03adbb9dfc3c6eed$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $6UxhE.fromPrivate(this, priv, enc);
};
$03adbb9dfc3c6eed$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $6UxhE.fromPublic(this, pub, enc);
};
$03adbb9dfc3c6eed$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $kNeip({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $8v4zB(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $h0anJ(2));
    for(;;){
        var priv = new $h0anJ(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$03adbb9dfc3c6eed$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$03adbb9dfc3c6eed$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $h0anJ(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $kNeip({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $h0anJ(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $h0anJ(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $3VM75({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$03adbb9dfc3c6eed$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $h0anJ(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $3VM75(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$03adbb9dfc3c6eed$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $03adbb9dfc3c6eed$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $3VM75(signature, enc);
    var n = this.n;
    var e = new $h0anJ(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$03adbb9dfc3c6eed$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $3VM75(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRequire.register("kNeip", function(module, exports) {
"use strict";

var $dMFrt = parcelRequire("dMFrt");

var $4YHS3 = parcelRequire("4YHS3");

var $3210N = parcelRequire("3210N");
function $f2337925eb4d650c$var$HmacDRBG(options) {
    if (!(this instanceof $f2337925eb4d650c$var$HmacDRBG)) return new $f2337925eb4d650c$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $4YHS3.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $4YHS3.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $4YHS3.toArray(options.pers, options.persEnc || "hex");
    $3210N(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $f2337925eb4d650c$var$HmacDRBG;
$f2337925eb4d650c$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$f2337925eb4d650c$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $dMFrt.hmac(this.hash, this.K);
};
$f2337925eb4d650c$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$f2337925eb4d650c$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $4YHS3.toArray(entropy, entropyEnc);
    add = $4YHS3.toArray(add, addEnc);
    $3210N(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$f2337925eb4d650c$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $4YHS3.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $4YHS3.encode(res, enc);
};

});

parcelRequire.register("6UxhE", function(module, exports) {
"use strict";

var $h0anJ = parcelRequire("h0anJ");

var $boA1w = parcelRequire("boA1w");
var $5081ca7d72751237$var$assert = $boA1w.assert;
function $5081ca7d72751237$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $5081ca7d72751237$var$KeyPair;
$5081ca7d72751237$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $5081ca7d72751237$var$KeyPair) return pub;
    return new $5081ca7d72751237$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$5081ca7d72751237$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $5081ca7d72751237$var$KeyPair) return priv;
    return new $5081ca7d72751237$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$5081ca7d72751237$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$5081ca7d72751237$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$5081ca7d72751237$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$5081ca7d72751237$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $h0anJ(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$5081ca7d72751237$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $5081ca7d72751237$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $5081ca7d72751237$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$5081ca7d72751237$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $5081ca7d72751237$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$5081ca7d72751237$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$5081ca7d72751237$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$5081ca7d72751237$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRequire.register("3VM75", function(module, exports) {
"use strict";

var $h0anJ = parcelRequire("h0anJ");

var $boA1w = parcelRequire("boA1w");
var $2dcc0445c1412382$var$assert = $boA1w.assert;
function $2dcc0445c1412382$var$Signature(options, enc) {
    if (options instanceof $2dcc0445c1412382$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $2dcc0445c1412382$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $h0anJ(options.r, 16);
    this.s = new $h0anJ(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $2dcc0445c1412382$var$Signature;
function $2dcc0445c1412382$var$Position() {
    this.place = 0;
}
function $2dcc0445c1412382$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $2dcc0445c1412382$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$2dcc0445c1412382$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $boA1w.toArray(data, enc);
    var p = new $2dcc0445c1412382$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $2dcc0445c1412382$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $2dcc0445c1412382$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $2dcc0445c1412382$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $h0anJ(r);
    this.s = new $h0anJ(s);
    this.recoveryParam = null;
    return true;
};
function $2dcc0445c1412382$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$2dcc0445c1412382$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $2dcc0445c1412382$var$rmPadding(r);
    s = $2dcc0445c1412382$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $2dcc0445c1412382$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $2dcc0445c1412382$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $2dcc0445c1412382$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $boA1w.encode(res, enc);
};

});


parcelRequire.register("51QPl", function(module, exports) {
"use strict";

var $dMFrt = parcelRequire("dMFrt");

var $kKmfE = parcelRequire("kKmfE");

var $boA1w = parcelRequire("boA1w");
var $3a960622930d64ef$var$assert = $boA1w.assert;
var $3a960622930d64ef$var$parseBytes = $boA1w.parseBytes;

var $l7DZZ = parcelRequire("l7DZZ");

var $dfflx = parcelRequire("dfflx");
function $3a960622930d64ef$var$EDDSA(curve) {
    $3a960622930d64ef$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $3a960622930d64ef$var$EDDSA)) return new $3a960622930d64ef$var$EDDSA(curve);
    curve = $kKmfE[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $dMFrt.sha512;
}
module.exports = $3a960622930d64ef$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $3a960622930d64ef$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $3a960622930d64ef$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $3a960622930d64ef$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $3a960622930d64ef$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$3a960622930d64ef$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $boA1w.intFromLE(hash.digest()).umod(this.curve.n);
};
$3a960622930d64ef$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $l7DZZ.fromPublic(this, pub);
};
$3a960622930d64ef$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $l7DZZ.fromSecret(this, secret);
};
$3a960622930d64ef$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $dfflx) return sig;
    return new $dfflx(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $3a960622930d64ef$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$3a960622930d64ef$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $boA1w.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $boA1w.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$3a960622930d64ef$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$3a960622930d64ef$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $boA1w.intFromLE(bytes);
};
$3a960622930d64ef$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRequire.register("l7DZZ", function(module, exports) {
"use strict";

var $boA1w = parcelRequire("boA1w");
var $f609475a1279c31c$var$assert = $boA1w.assert;
var $f609475a1279c31c$var$parseBytes = $boA1w.parseBytes;
var $f609475a1279c31c$var$cachedProperty = $boA1w.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $f609475a1279c31c$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $f609475a1279c31c$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $f609475a1279c31c$var$parseBytes(params.pub);
}
$f609475a1279c31c$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $f609475a1279c31c$var$KeyPair) return pub;
    return new $f609475a1279c31c$var$KeyPair(eddsa, {
        pub: pub
    });
};
$f609475a1279c31c$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $f609475a1279c31c$var$KeyPair) return secret;
    return new $f609475a1279c31c$var$KeyPair(eddsa, {
        secret: secret
    });
};
$f609475a1279c31c$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$f609475a1279c31c$var$cachedProperty($f609475a1279c31c$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$f609475a1279c31c$var$cachedProperty($f609475a1279c31c$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$f609475a1279c31c$var$cachedProperty($f609475a1279c31c$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$f609475a1279c31c$var$cachedProperty($f609475a1279c31c$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$f609475a1279c31c$var$cachedProperty($f609475a1279c31c$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$f609475a1279c31c$var$cachedProperty($f609475a1279c31c$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$f609475a1279c31c$var$KeyPair.prototype.sign = function sign(message) {
    $f609475a1279c31c$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$f609475a1279c31c$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$f609475a1279c31c$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $f609475a1279c31c$var$assert(this._secret, "KeyPair is public only");
    return $boA1w.encode(this.secret(), enc);
};
$f609475a1279c31c$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $boA1w.encode(this.pubBytes(), enc);
};
module.exports = $f609475a1279c31c$var$KeyPair;

});

parcelRequire.register("dfflx", function(module, exports) {
"use strict";

var $h0anJ = parcelRequire("h0anJ");

var $boA1w = parcelRequire("boA1w");
var $9a4894875072ae55$var$assert = $boA1w.assert;
var $9a4894875072ae55$var$cachedProperty = $boA1w.cachedProperty;
var $9a4894875072ae55$var$parseBytes = $boA1w.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $9a4894875072ae55$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $9a4894875072ae55$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $9a4894875072ae55$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $h0anJ) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$9a4894875072ae55$var$cachedProperty($9a4894875072ae55$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$9a4894875072ae55$var$cachedProperty($9a4894875072ae55$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$9a4894875072ae55$var$cachedProperty($9a4894875072ae55$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$9a4894875072ae55$var$cachedProperty($9a4894875072ae55$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$9a4894875072ae55$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$9a4894875072ae55$var$Signature.prototype.toHex = function toHex() {
    return $boA1w.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $9a4894875072ae55$var$Signature;

});


parcelRequire.register("iDQh3", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("byQ4w", function(module, exports) {
"use strict";

var $gw2cK = parcelRequire("gw2cK");

var $b68Bf = parcelRequire("b68Bf");

var $kvFQ5 = parcelRequire("kvFQ5");
const $86ab4310e2e37424$var$api = module.exports;
$86ab4310e2e37424$var$api.define = function define(name, body) {
    return new $86ab4310e2e37424$var$Entity(name, body);
};
function $86ab4310e2e37424$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
$86ab4310e2e37424$var$Entity.prototype._createNamed = function createNamed(Base) {
    const name = this.name;
    function Generated(entity) {
        this._initNamed(entity, name);
    }
    $kvFQ5(Generated, Base);
    Generated.prototype._initNamed = function _initNamed(entity, name) {
        Base.call(this, entity, name);
    };
    return new Generated(this);
};
$86ab4310e2e37424$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($b68Bf[enc]);
    return this.decoders[enc];
};
$86ab4310e2e37424$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$86ab4310e2e37424$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($gw2cK[enc]);
    return this.encoders[enc];
};
$86ab4310e2e37424$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRequire.register("gw2cK", function(module, exports) {
"use strict";
const $c061584bbfa81add$var$encoders = module.exports;

$c061584bbfa81add$var$encoders.der = (parcelRequire("h7Jar"));

$c061584bbfa81add$var$encoders.pem = (parcelRequire("WTsXi"));

});
parcelRequire.register("h7Jar", function(module, exports) {
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");

var $llyme = parcelRequire("llyme");
var $c776206fbdca9bf2$require$Buffer = $llyme.Buffer;

var $7QW6d = parcelRequire("7QW6d");

var $1P4FE = parcelRequire("1P4FE");
function $c776206fbdca9bf2$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $c776206fbdca9bf2$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $c776206fbdca9bf2$var$DEREncoder;
$c776206fbdca9bf2$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $c776206fbdca9bf2$var$DERNode(parent) {
    $7QW6d.call(this, "der", parent);
}
$kvFQ5($c776206fbdca9bf2$var$DERNode, $7QW6d);
$c776206fbdca9bf2$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    const encodedTag = $c776206fbdca9bf2$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        const header = $c776206fbdca9bf2$require$Buffer.alloc(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    let lenOctets = 1;
    for(let i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    const header = $c776206fbdca9bf2$require$Buffer.alloc(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$c776206fbdca9bf2$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        const buf = $c776206fbdca9bf2$require$Buffer.alloc(str.length * 2);
        for(let i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$c776206fbdca9bf2$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s.]+/g);
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    let size = 0;
    for(let i = 0; i < id.length; i++){
        let ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    const objid = $c776206fbdca9bf2$require$Buffer.alloc(size);
    let offset = objid.length - 1;
    for(let i = id.length - 1; i >= 0; i--){
        let ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $c776206fbdca9bf2$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$c776206fbdca9bf2$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    let str;
    const date = new Date(time);
    if (tag === "gentime") str = [
        $c776206fbdca9bf2$var$two(date.getUTCFullYear()),
        $c776206fbdca9bf2$var$two(date.getUTCMonth() + 1),
        $c776206fbdca9bf2$var$two(date.getUTCDate()),
        $c776206fbdca9bf2$var$two(date.getUTCHours()),
        $c776206fbdca9bf2$var$two(date.getUTCMinutes()),
        $c776206fbdca9bf2$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $c776206fbdca9bf2$var$two(date.getUTCFullYear() % 100),
        $c776206fbdca9bf2$var$two(date.getUTCMonth() + 1),
        $c776206fbdca9bf2$var$two(date.getUTCDate()),
        $c776206fbdca9bf2$var$two(date.getUTCHours()),
        $c776206fbdca9bf2$var$two(date.getUTCMinutes()),
        $c776206fbdca9bf2$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$c776206fbdca9bf2$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$c776206fbdca9bf2$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$c776206fbdca9bf2$require$Buffer.isBuffer(num)) {
        const numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = $c776206fbdca9bf2$require$Buffer.from(numArray);
    }
    if ($c776206fbdca9bf2$require$Buffer.isBuffer(num)) {
        let size = num.length;
        if (num.length === 0) size++;
        const out = $c776206fbdca9bf2$require$Buffer.alloc(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    let size = 1;
    for(let i = num; i >= 0x100; i >>= 8)size++;
    const out = new Array(size);
    for(let i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer($c776206fbdca9bf2$require$Buffer.from(out));
};
$c776206fbdca9bf2$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$c776206fbdca9bf2$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$c776206fbdca9bf2$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    const state = this._baseState;
    let i;
    if (state["default"] === null) return false;
    const data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $c776206fbdca9bf2$var$encodeTag(tag, primitive, cls, reporter) {
    let res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($1P4FE.tagByName.hasOwnProperty(tag)) res = $1P4FE.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $1P4FE.tagClassByName[cls || "universal"] << 6;
    return res;
}

});
parcelRequire.register("llyme", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $aqbQf = parcelRequire("aqbQf");
"use strict";

var $gzLuY = parcelRequire("gzLuY");
var $f8a635d7da98a5fa$var$Buffer = $gzLuY.Buffer;
var $f8a635d7da98a5fa$var$safer = {};
var $f8a635d7da98a5fa$var$key;
for($f8a635d7da98a5fa$var$key in $gzLuY){
    if (!$gzLuY.hasOwnProperty($f8a635d7da98a5fa$var$key)) continue;
    if ($f8a635d7da98a5fa$var$key === "SlowBuffer" || $f8a635d7da98a5fa$var$key === "Buffer") continue;
    $f8a635d7da98a5fa$var$safer[$f8a635d7da98a5fa$var$key] = $gzLuY[$f8a635d7da98a5fa$var$key];
}
var $f8a635d7da98a5fa$var$Safer = $f8a635d7da98a5fa$var$safer.Buffer = {};
for($f8a635d7da98a5fa$var$key in $f8a635d7da98a5fa$var$Buffer){
    if (!$f8a635d7da98a5fa$var$Buffer.hasOwnProperty($f8a635d7da98a5fa$var$key)) continue;
    if ($f8a635d7da98a5fa$var$key === "allocUnsafe" || $f8a635d7da98a5fa$var$key === "allocUnsafeSlow") continue;
    $f8a635d7da98a5fa$var$Safer[$f8a635d7da98a5fa$var$key] = $f8a635d7da98a5fa$var$Buffer[$f8a635d7da98a5fa$var$key];
}
$f8a635d7da98a5fa$var$safer.Buffer.prototype = $f8a635d7da98a5fa$var$Buffer.prototype;
if (!$f8a635d7da98a5fa$var$Safer.from || $f8a635d7da98a5fa$var$Safer.from === Uint8Array.from) $f8a635d7da98a5fa$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === "undefined") throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    return $f8a635d7da98a5fa$var$Buffer(value, encodingOrOffset, length);
};
if (!$f8a635d7da98a5fa$var$Safer.alloc) $f8a635d7da98a5fa$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $f8a635d7da98a5fa$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === "string") buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$f8a635d7da98a5fa$var$safer.kStringMaxLength) try {
    $f8a635d7da98a5fa$var$safer.kStringMaxLength = $aqbQf.binding("buffer").kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$f8a635d7da98a5fa$var$safer.constants) {
    $f8a635d7da98a5fa$var$safer.constants = {
        MAX_LENGTH: $f8a635d7da98a5fa$var$safer.kMaxLength
    };
    if ($f8a635d7da98a5fa$var$safer.kStringMaxLength) $f8a635d7da98a5fa$var$safer.constants.MAX_STRING_LENGTH = $f8a635d7da98a5fa$var$safer.kStringMaxLength;
}
module.exports = $f8a635d7da98a5fa$var$safer;

});

parcelRequire.register("7QW6d", function(module, exports) {
"use strict";

var $ast52 = parcelRequire("ast52");
var $5b7a750945be0fbb$require$Reporter = $ast52.Reporter;

var $ihVF1 = parcelRequire("ihVF1");
var $5b7a750945be0fbb$require$EncoderBuffer = $ihVF1.EncoderBuffer;

var $ihVF1 = parcelRequire("ihVF1");
var $5b7a750945be0fbb$require$DecoderBuffer = $ihVF1.DecoderBuffer;

var $3210N = parcelRequire("3210N");
// Supported tags
const $5b7a750945be0fbb$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
const $5b7a750945be0fbb$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($5b7a750945be0fbb$var$tags);
// Overrided methods list
const $5b7a750945be0fbb$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $5b7a750945be0fbb$var$Node(enc, parent, name) {
    const state = {};
    this._baseState = state;
    state.name = name;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $5b7a750945be0fbb$var$Node;
const $5b7a750945be0fbb$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$5b7a750945be0fbb$var$Node.prototype.clone = function clone() {
    const state = this._baseState;
    const cstate = {};
    $5b7a750945be0fbb$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    const res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$5b7a750945be0fbb$var$Node.prototype._wrap = function wrap() {
    const state = this._baseState;
    $5b7a750945be0fbb$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            const clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$5b7a750945be0fbb$var$Node.prototype._init = function init(body) {
    const state = this._baseState;
    $3210N(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $3210N.equal(state.children.length, 1, "Root node can have only one child");
};
$5b7a750945be0fbb$var$Node.prototype._useArgs = function useArgs(args) {
    const state = this._baseState;
    // Filter children and args
    const children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $3210N(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $3210N(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            const res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                const value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$5b7a750945be0fbb$var$overrided.forEach(function(method) {
    $5b7a750945be0fbb$var$Node.prototype[method] = function _overrided() {
        const state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$5b7a750945be0fbb$var$tags.forEach(function(tag) {
    $5b7a750945be0fbb$var$Node.prototype[tag] = function _tagMethod() {
        const state = this._baseState;
        const args = Array.prototype.slice.call(arguments);
        $3210N(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$5b7a750945be0fbb$var$Node.prototype.use = function use(item) {
    $3210N(item);
    const state = this._baseState;
    $3210N(state.use === null);
    state.use = item;
    return this;
};
$5b7a750945be0fbb$var$Node.prototype.optional = function optional() {
    const state = this._baseState;
    state.optional = true;
    return this;
};
$5b7a750945be0fbb$var$Node.prototype.def = function def(val) {
    const state = this._baseState;
    $3210N(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$5b7a750945be0fbb$var$Node.prototype.explicit = function explicit(num) {
    const state = this._baseState;
    $3210N(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$5b7a750945be0fbb$var$Node.prototype.implicit = function implicit(num) {
    const state = this._baseState;
    $3210N(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$5b7a750945be0fbb$var$Node.prototype.obj = function obj() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$5b7a750945be0fbb$var$Node.prototype.key = function key(newKey) {
    const state = this._baseState;
    $3210N(state.key === null);
    state.key = newKey;
    return this;
};
$5b7a750945be0fbb$var$Node.prototype.any = function any() {
    const state = this._baseState;
    state.any = true;
    return this;
};
$5b7a750945be0fbb$var$Node.prototype.choice = function choice(obj) {
    const state = this._baseState;
    $3210N(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$5b7a750945be0fbb$var$Node.prototype.contains = function contains(item) {
    const state = this._baseState;
    $3210N(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$5b7a750945be0fbb$var$Node.prototype._decode = function decode(input, options) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    let result = state["default"];
    let present = true;
    let prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        let tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            const save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    let prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            const explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        const start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            let save;
            if (state.any) save = input.save();
            const body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) ;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            const data = new $5b7a750945be0fbb$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$5b7a750945be0fbb$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    const state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$5b7a750945be0fbb$var$Node.prototype._getUse = function _getUse(entity, obj) {
    const state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $3210N(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$5b7a750945be0fbb$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    const state = this._baseState;
    let result = null;
    let match = false;
    Object.keys(state.choice).some(function(key) {
        const save = input.save();
        const node = state.choice[key];
        try {
            const value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$5b7a750945be0fbb$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $5b7a750945be0fbb$require$EncoderBuffer(data, this.reporter);
};
$5b7a750945be0fbb$var$Node.prototype._encode = function encode(data, reporter, parent) {
    const state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    const result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$5b7a750945be0fbb$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $5b7a750945be0fbb$require$Reporter());
    let result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    let content = null;
    let primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            const prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            const res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            const child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                const state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    if (!state.any && state.choice === null) {
        const tag = state.implicit !== null ? state.implicit : state.tag;
        const cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$5b7a750945be0fbb$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    const state = this._baseState;
    const node = state.choice[data.type];
    if (!node) $3210N(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$5b7a750945be0fbb$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    const state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$5b7a750945be0fbb$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$5b7a750945be0fbb$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};

});
parcelRequire.register("ast52", function(module, exports) {

$parcel$export(module.exports, "Reporter", function () { return $79d313a5b67b4e65$export$957313a2f485e5ed; }, function (v) { return $79d313a5b67b4e65$export$957313a2f485e5ed = v; });
var $79d313a5b67b4e65$export$957313a2f485e5ed;
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");
function $79d313a5b67b4e65$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$79d313a5b67b4e65$export$957313a2f485e5ed = $79d313a5b67b4e65$var$Reporter;
$79d313a5b67b4e65$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $79d313a5b67b4e65$var$ReporterError;
};
$79d313a5b67b4e65$var$Reporter.prototype.save = function save() {
    const state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$79d313a5b67b4e65$var$Reporter.prototype.restore = function restore(data) {
    const state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$79d313a5b67b4e65$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$79d313a5b67b4e65$var$Reporter.prototype.exitKey = function exitKey(index) {
    const state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$79d313a5b67b4e65$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    const state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$79d313a5b67b4e65$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$79d313a5b67b4e65$var$Reporter.prototype.enterObject = function enterObject() {
    const state = this._reporterState;
    const prev = state.obj;
    state.obj = {};
    return prev;
};
$79d313a5b67b4e65$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    const state = this._reporterState;
    const now = state.obj;
    state.obj = prev;
    return now;
};
$79d313a5b67b4e65$var$Reporter.prototype.error = function error(msg) {
    let err;
    const state = this._reporterState;
    const inherited = msg instanceof $79d313a5b67b4e65$var$ReporterError;
    if (inherited) err = msg;
    else err = new $79d313a5b67b4e65$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$79d313a5b67b4e65$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    const state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $79d313a5b67b4e65$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$kvFQ5($79d313a5b67b4e65$var$ReporterError, Error);
$79d313a5b67b4e65$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $79d313a5b67b4e65$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRequire.register("ihVF1", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", function () { return $d5068ab600a003c4$export$bf9f79cdc4a49163; }, function (v) { return $d5068ab600a003c4$export$bf9f79cdc4a49163 = v; });
$parcel$export(module.exports, "EncoderBuffer", function () { return $d5068ab600a003c4$export$8ff24f7760c7a78e; }, function (v) { return $d5068ab600a003c4$export$8ff24f7760c7a78e = v; });
var $d5068ab600a003c4$export$bf9f79cdc4a49163;
var $d5068ab600a003c4$export$8ff24f7760c7a78e;
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");

var $ast52 = parcelRequire("ast52");
var $d5068ab600a003c4$require$Reporter = $ast52.Reporter;

var $llyme = parcelRequire("llyme");
var $d5068ab600a003c4$require$Buffer = $llyme.Buffer;
function $d5068ab600a003c4$var$DecoderBuffer(base, options) {
    $d5068ab600a003c4$require$Reporter.call(this, options);
    if (!$d5068ab600a003c4$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$kvFQ5($d5068ab600a003c4$var$DecoderBuffer, $d5068ab600a003c4$require$Reporter);
$d5068ab600a003c4$export$bf9f79cdc4a49163 = $d5068ab600a003c4$var$DecoderBuffer;
$d5068ab600a003c4$var$DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
    if (data instanceof $d5068ab600a003c4$var$DecoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && $d5068ab600a003c4$require$Buffer.isBuffer(data.base) && data.constructor.name === "DecoderBuffer" && typeof data.offset === "number" && typeof data.length === "number" && typeof data.save === "function" && typeof data.restore === "function" && typeof data.isEmpty === "function" && typeof data.readUInt8 === "function" && typeof data.skip === "function" && typeof data.raw === "function";
    return isCompatible;
};
$d5068ab600a003c4$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $d5068ab600a003c4$require$Reporter.prototype.save.call(this)
    };
};
$d5068ab600a003c4$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    const res = new $d5068ab600a003c4$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $d5068ab600a003c4$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$d5068ab600a003c4$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$d5068ab600a003c4$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$d5068ab600a003c4$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    const res = new $d5068ab600a003c4$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$d5068ab600a003c4$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $d5068ab600a003c4$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!$d5068ab600a003c4$var$EncoderBuffer.isEncoderBuffer(item)) item = new $d5068ab600a003c4$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $d5068ab600a003c4$require$Buffer.byteLength(value);
    } else if ($d5068ab600a003c4$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
$d5068ab600a003c4$export$8ff24f7760c7a78e = $d5068ab600a003c4$var$EncoderBuffer;
$d5068ab600a003c4$var$EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
    if (data instanceof $d5068ab600a003c4$var$EncoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && data.constructor.name === "EncoderBuffer" && typeof data.length === "number" && typeof data.join === "function";
    return isCompatible;
};
$d5068ab600a003c4$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = $d5068ab600a003c4$require$Buffer.alloc(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($d5068ab600a003c4$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});


parcelRequire.register("1P4FE", function(module, exports) {

$parcel$export(module.exports, "tagClass", function () { return $153e2d5dec6f0c65$export$3584c46ed60baee8; }, function (v) { return $153e2d5dec6f0c65$export$3584c46ed60baee8 = v; });
$parcel$export(module.exports, "tagClassByName", function () { return $153e2d5dec6f0c65$export$f18596ef8d632e49; }, function (v) { return $153e2d5dec6f0c65$export$f18596ef8d632e49 = v; });
$parcel$export(module.exports, "tag", function () { return $153e2d5dec6f0c65$export$2b067c6666111485; }, function (v) { return $153e2d5dec6f0c65$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "tagByName", function () { return $153e2d5dec6f0c65$export$f17df38a421ab9e3; }, function (v) { return $153e2d5dec6f0c65$export$f17df38a421ab9e3 = v; });
var $153e2d5dec6f0c65$export$3584c46ed60baee8;
var $153e2d5dec6f0c65$export$f18596ef8d632e49;
var $153e2d5dec6f0c65$export$2b067c6666111485;
var $153e2d5dec6f0c65$export$f17df38a421ab9e3;
"use strict";
// Helper
function $153e2d5dec6f0c65$var$reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
}
$153e2d5dec6f0c65$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$153e2d5dec6f0c65$export$f18596ef8d632e49 = $153e2d5dec6f0c65$var$reverse($153e2d5dec6f0c65$export$3584c46ed60baee8);
$153e2d5dec6f0c65$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$153e2d5dec6f0c65$export$f17df38a421ab9e3 = $153e2d5dec6f0c65$var$reverse($153e2d5dec6f0c65$export$2b067c6666111485);

});


parcelRequire.register("WTsXi", function(module, exports) {
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");

var $h7Jar = parcelRequire("h7Jar");
function $0b10714a982dfbe8$var$PEMEncoder(entity) {
    $h7Jar.call(this, entity);
    this.enc = "pem";
}
$kvFQ5($0b10714a982dfbe8$var$PEMEncoder, $h7Jar);
module.exports = $0b10714a982dfbe8$var$PEMEncoder;
$0b10714a982dfbe8$var$PEMEncoder.prototype.encode = function encode(data, options) {
    const buf = $h7Jar.prototype.encode.call(this, data);
    const p = buf.toString("base64");
    const out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(let i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});


parcelRequire.register("b68Bf", function(module, exports) {
"use strict";
const $8146ecfcca4b3b3d$var$decoders = module.exports;

$8146ecfcca4b3b3d$var$decoders.der = (parcelRequire("eCZe2"));

$8146ecfcca4b3b3d$var$decoders.pem = (parcelRequire("63ZJM"));

});
parcelRequire.register("eCZe2", function(module, exports) {
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");

var $jlWHo = parcelRequire("jlWHo");

var $ihVF1 = parcelRequire("ihVF1");
var $aa641b60233548d4$require$DecoderBuffer = $ihVF1.DecoderBuffer;

var $7QW6d = parcelRequire("7QW6d");

var $1P4FE = parcelRequire("1P4FE");
function $aa641b60233548d4$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $aa641b60233548d4$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $aa641b60233548d4$var$DERDecoder;
$aa641b60233548d4$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!$aa641b60233548d4$require$DecoderBuffer.isDecoderBuffer(data)) data = new $aa641b60233548d4$require$DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $aa641b60233548d4$var$DERNode(parent) {
    $7QW6d.call(this, "der", parent);
}
$kvFQ5($aa641b60233548d4$var$DERNode, $7QW6d);
$aa641b60233548d4$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    const state = buffer.save();
    const decodedTag = $aa641b60233548d4$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$aa641b60233548d4$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    const decodedTag = $aa641b60233548d4$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    let len = $aa641b60233548d4$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    const state = buffer.save();
    const res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$aa641b60233548d4$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    for(;;){
        const tag = $aa641b60233548d4$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        const len = $aa641b60233548d4$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        let res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$aa641b60233548d4$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    const result = [];
    while(!buffer.isEmpty()){
        const possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        const res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$aa641b60233548d4$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        const unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        const raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        let str = "";
        for(let i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        const numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        const printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$aa641b60233548d4$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    let result;
    const identifiers = [];
    let ident = 0;
    let subident = 0;
    while(!buffer.isEmpty()){
        subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    const first = identifiers[0] / 40 | 0;
    const second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        let tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$aa641b60233548d4$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    const str = buffer.raw().toString();
    let year;
    let mon;
    let day;
    let hour;
    let min;
    let sec;
    if (tag === "gentime") {
        year = str.slice(0, 4) | 0;
        mon = str.slice(4, 6) | 0;
        day = str.slice(6, 8) | 0;
        hour = str.slice(8, 10) | 0;
        min = str.slice(10, 12) | 0;
        sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        year = str.slice(0, 2) | 0;
        mon = str.slice(2, 4) | 0;
        day = str.slice(4, 6) | 0;
        hour = str.slice(6, 8) | 0;
        min = str.slice(8, 10) | 0;
        sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$aa641b60233548d4$var$DERNode.prototype._decodeNull = function decodeNull() {
    return null;
};
$aa641b60233548d4$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    const res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$aa641b60233548d4$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    const raw = buffer.raw();
    let res = new $jlWHo(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$aa641b60233548d4$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $aa641b60233548d4$var$derDecodeTag(buf, fail) {
    let tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    const cls = $1P4FE.tagClass[tag >> 6];
    const primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        let oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    const tagStr = $1P4FE.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $aa641b60233548d4$var$derDecodeLen(buf, primitive, fail) {
    let len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    const num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(let i = 0; i < num; i++){
        len <<= 8;
        const j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRequire.register("63ZJM", function(module, exports) {
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");

var $llyme = parcelRequire("llyme");
var $46a2e9a1a8efddd7$require$Buffer = $llyme.Buffer;

var $eCZe2 = parcelRequire("eCZe2");
function $46a2e9a1a8efddd7$var$PEMDecoder(entity) {
    $eCZe2.call(this, entity);
    this.enc = "pem";
}
$kvFQ5($46a2e9a1a8efddd7$var$PEMDecoder, $eCZe2);
module.exports = $46a2e9a1a8efddd7$var$PEMDecoder;
$46a2e9a1a8efddd7$var$PEMDecoder.prototype.decode = function decode(data, options) {
    const lines = data.toString().split(/[\r\n]+/g);
    const label = options.label.toUpperCase();
    const re = /^-----(BEGIN|END) ([^-]+)-----$/;
    let start = -1;
    let end = -1;
    for(let i = 0; i < lines.length; i++){
        const match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    const base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9+/=]+/gi, "");
    const input = $46a2e9a1a8efddd7$require$Buffer.from(base64, "base64");
    return $eCZe2.prototype.decode.call(this, input, options);
};

});



parcelRequire.register("bMHL7", function(module, exports) {
"use strict";
const $89461f04cb258e33$var$base = module.exports;

$89461f04cb258e33$var$base.Reporter = (parcelRequire("ast52")).Reporter;

$89461f04cb258e33$var$base.DecoderBuffer = (parcelRequire("ihVF1")).DecoderBuffer;

$89461f04cb258e33$var$base.EncoderBuffer = (parcelRequire("ihVF1")).EncoderBuffer;

$89461f04cb258e33$var$base.Node = (parcelRequire("7QW6d"));

});

parcelRequire.register("aySCC", function(module, exports) {
"use strict";
const $7b07732185da525c$var$constants = module.exports;
// Helper
$7b07732185da525c$var$constants._reverse = function reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
};

$7b07732185da525c$var$constants.der = (parcelRequire("1P4FE"));

});

parcelRequire.register("jOtxC", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $72Zbf = parcelRequire("72Zbf");
var $e6c99a1ea7bbba53$var$Time = $72Zbf.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $e6c99a1ea7bbba53$var$AttributeTypeValue = $72Zbf.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $e6c99a1ea7bbba53$var$AlgorithmIdentifier = $72Zbf.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $e6c99a1ea7bbba53$var$SubjectPublicKeyInfo = $72Zbf.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($e6c99a1ea7bbba53$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $e6c99a1ea7bbba53$var$RelativeDistinguishedName = $72Zbf.define("RelativeDistinguishedName", function() {
    this.setof($e6c99a1ea7bbba53$var$AttributeTypeValue);
});
var $e6c99a1ea7bbba53$var$RDNSequence = $72Zbf.define("RDNSequence", function() {
    this.seqof($e6c99a1ea7bbba53$var$RelativeDistinguishedName);
});
var $e6c99a1ea7bbba53$var$Name = $72Zbf.define("Name", function() {
    this.choice({
        rdnSequence: this.use($e6c99a1ea7bbba53$var$RDNSequence)
    });
});
var $e6c99a1ea7bbba53$var$Validity = $72Zbf.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($e6c99a1ea7bbba53$var$Time), this.key("notAfter").use($e6c99a1ea7bbba53$var$Time));
});
var $e6c99a1ea7bbba53$var$Extension = $72Zbf.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $e6c99a1ea7bbba53$var$TBSCertificate = $72Zbf.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use($e6c99a1ea7bbba53$var$AlgorithmIdentifier), this.key("issuer").use($e6c99a1ea7bbba53$var$Name), this.key("validity").use($e6c99a1ea7bbba53$var$Validity), this.key("subject").use($e6c99a1ea7bbba53$var$Name), this.key("subjectPublicKeyInfo").use($e6c99a1ea7bbba53$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($e6c99a1ea7bbba53$var$Extension).optional());
});
var $e6c99a1ea7bbba53$var$X509Certificate = $72Zbf.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($e6c99a1ea7bbba53$var$TBSCertificate), this.key("signatureAlgorithm").use($e6c99a1ea7bbba53$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $e6c99a1ea7bbba53$var$X509Certificate;

});
parcelRequire.register("72Zbf", function(module, exports) {
"use strict";
const $52182d78a654c558$var$asn1 = module.exports;

$52182d78a654c558$var$asn1.bignum = (parcelRequire("jlWHo"));

$52182d78a654c558$var$asn1.define = (parcelRequire("byQ4w")).define;

$52182d78a654c558$var$asn1.base = (parcelRequire("bMHL7"));

$52182d78a654c558$var$asn1.constants = (parcelRequire("aySCC"));

$52182d78a654c558$var$asn1.decoders = (parcelRequire("b68Bf"));

$52182d78a654c558$var$asn1.encoders = (parcelRequire("gw2cK"));

});


parcelRequire.register("5NdVi", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $437c543735380863$require$Buffer = $gzLuY.Buffer;

var $492wS = parcelRequire("492wS");

var $jlWHo = parcelRequire("jlWHo");
module.exports = function createECDH(curve) {
    return new $437c543735380863$var$ECDH(curve);
};
var $437c543735380863$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$437c543735380863$var$aliases.p224 = $437c543735380863$var$aliases.secp224r1;
$437c543735380863$var$aliases.p256 = $437c543735380863$var$aliases.secp256r1 = $437c543735380863$var$aliases.prime256v1;
$437c543735380863$var$aliases.p192 = $437c543735380863$var$aliases.secp192r1 = $437c543735380863$var$aliases.prime192v1;
$437c543735380863$var$aliases.p384 = $437c543735380863$var$aliases.secp384r1;
$437c543735380863$var$aliases.p521 = $437c543735380863$var$aliases.secp521r1;
function $437c543735380863$var$ECDH(curve) {
    this.curveType = $437c543735380863$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $492wS.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$437c543735380863$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$437c543735380863$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$437c543735380863$require$Buffer.isBuffer(other)) other = new $437c543735380863$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $437c543735380863$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$437c543735380863$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $437c543735380863$var$formatReturnValue(key, enc);
};
$437c543735380863$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $437c543735380863$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$437c543735380863$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$437c543735380863$require$Buffer.isBuffer(pub)) pub = new $437c543735380863$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$437c543735380863$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$437c543735380863$require$Buffer.isBuffer(priv)) priv = new $437c543735380863$require$Buffer(priv, enc);
    var _priv = new $jlWHo(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $437c543735380863$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $437c543735380863$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $437c543735380863$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $437c543735380863$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRequire.register("492wS", function(module, exports) {
"use strict";
var $3049f6ef72b5b326$var$elliptic = module.exports;

$3049f6ef72b5b326$var$elliptic.version = (parcelRequire("3tGej")).version;

$3049f6ef72b5b326$var$elliptic.utils = (parcelRequire("boA1w"));

$3049f6ef72b5b326$var$elliptic.rand = (parcelRequire("8v4zB"));

$3049f6ef72b5b326$var$elliptic.curve = (parcelRequire("hbDhv"));

$3049f6ef72b5b326$var$elliptic.curves = (parcelRequire("kKmfE"));

// Protocols
$3049f6ef72b5b326$var$elliptic.ec = (parcelRequire("jA2EE"));

$3049f6ef72b5b326$var$elliptic.eddsa = (parcelRequire("51QPl"));

});


parcelRequire.register("gsjO5", function(module, exports) {

var $5nDla = parcelRequire("5nDla");

var $dKHN6 = parcelRequire("dKHN6");

var $j8bQA = parcelRequire("j8bQA");

var $cENfq = parcelRequire("cENfq");

var $jjFgv = parcelRequire("jjFgv");

var $jlWHo = parcelRequire("jlWHo");

var $5Lq0b = parcelRequire("5Lq0b");

var $lp4ea = parcelRequire("lp4ea");

var $eN0t8 = parcelRequire("eN0t8");
var $bfaea013f2020bc9$require$Buffer = $eN0t8.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $5nDla(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $bfaea013f2020bc9$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $bfaea013f2020bc9$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $jlWHo(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $lp4ea(paddedMsg, key);
    else return $5Lq0b(paddedMsg, key);
};
function $bfaea013f2020bc9$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $j8bQA("sha1").update($bfaea013f2020bc9$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $bfaea013f2020bc9$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $dKHN6(hLen);
    var maskedDb = $jjFgv($bfaea013f2020bc9$require$Buffer.concat([
        iHash,
        ps,
        $bfaea013f2020bc9$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $cENfq(seed, dblen));
    var maskedSeed = $jjFgv(seed, $cENfq(maskedDb, hLen));
    return new $jlWHo($bfaea013f2020bc9$require$Buffer.concat([
        $bfaea013f2020bc9$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $bfaea013f2020bc9$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $bfaea013f2020bc9$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $bfaea013f2020bc9$var$nonZero(k - mLen - 3);
    return new $jlWHo($bfaea013f2020bc9$require$Buffer.concat([
        $bfaea013f2020bc9$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $bfaea013f2020bc9$require$Buffer.alloc(1),
        msg
    ], k));
}
function $bfaea013f2020bc9$var$nonZero(len) {
    var out = $bfaea013f2020bc9$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $dKHN6(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $dKHN6(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRequire.register("5nDla", function(module, exports) {

var $6j2SI = parcelRequire("6j2SI");

var $l6piA = parcelRequire("l6piA");

var $lNx08 = parcelRequire("lNx08");

var $X9qDO = parcelRequire("X9qDO");

var $2r16u = parcelRequire("2r16u");

var $eN0t8 = parcelRequire("eN0t8");
var $3ead9de69cdfeb72$require$Buffer = $eN0t8.Buffer;
module.exports = $3ead9de69cdfeb72$var$parseKeys;
function $3ead9de69cdfeb72$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$3ead9de69cdfeb72$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $3ead9de69cdfeb72$require$Buffer.from(buffer);
    var stripped = $lNx08(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $6j2SI.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $6j2SI.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $6j2SI.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $6j2SI.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $6j2SI.EncryptedPrivateKey.decode(data, "der");
            data = $3ead9de69cdfeb72$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $6j2SI.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $6j2SI.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $6j2SI.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $6j2SI.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $6j2SI.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $6j2SI.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $6j2SI.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $6j2SI.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$3ead9de69cdfeb72$var$parseKeys.signature = $6j2SI.signature;
function $3ead9de69cdfeb72$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $l6piA[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $2r16u.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $X9qDO.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $3ead9de69cdfeb72$require$Buffer.concat(out);
}

});
parcelRequire.register("6j2SI", function(module, exports) {

$parcel$export(module.exports, "certificate", function () { return $4976c09f65209dc1$export$c98397a6eb8d0678; }, function (v) { return $4976c09f65209dc1$export$c98397a6eb8d0678 = v; });
$parcel$export(module.exports, "RSAPrivateKey", function () { return $4976c09f65209dc1$export$f4aab6816f64fa6b; }, function (v) { return $4976c09f65209dc1$export$f4aab6816f64fa6b = v; });
$parcel$export(module.exports, "RSAPublicKey", function () { return $4976c09f65209dc1$export$4471f5c65d097c11; }, function (v) { return $4976c09f65209dc1$export$4471f5c65d097c11 = v; });
$parcel$export(module.exports, "PublicKey", function () { return $4976c09f65209dc1$export$ca8b6604d6ce14de; }, function (v) { return $4976c09f65209dc1$export$ca8b6604d6ce14de = v; });
$parcel$export(module.exports, "PrivateKey", function () { return $4976c09f65209dc1$export$8f54525b330fd87b; }, function (v) { return $4976c09f65209dc1$export$8f54525b330fd87b = v; });
$parcel$export(module.exports, "EncryptedPrivateKey", function () { return $4976c09f65209dc1$export$23cd2842b44ca3e7; }, function (v) { return $4976c09f65209dc1$export$23cd2842b44ca3e7 = v; });
$parcel$export(module.exports, "DSAPrivateKey", function () { return $4976c09f65209dc1$export$245c9aaa9f5ce4ce; }, function (v) { return $4976c09f65209dc1$export$245c9aaa9f5ce4ce = v; });
$parcel$export(module.exports, "DSAparam", function () { return $4976c09f65209dc1$export$8ad762e3e6399afe; }, function (v) { return $4976c09f65209dc1$export$8ad762e3e6399afe = v; });
$parcel$export(module.exports, "ECPrivateKey", function () { return $4976c09f65209dc1$export$32ef6f92e22c6ab0; }, function (v) { return $4976c09f65209dc1$export$32ef6f92e22c6ab0 = v; });
$parcel$export(module.exports, "signature", function () { return $4976c09f65209dc1$export$c9cd164b539ebb63; }, function (v) { return $4976c09f65209dc1$export$c9cd164b539ebb63 = v; });
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $4976c09f65209dc1$export$c98397a6eb8d0678;
var $4976c09f65209dc1$export$f4aab6816f64fa6b;
var $4976c09f65209dc1$export$4471f5c65d097c11;
var $4976c09f65209dc1$export$ca8b6604d6ce14de;
var $4976c09f65209dc1$export$8f54525b330fd87b;
var $4976c09f65209dc1$export$23cd2842b44ca3e7;
var $4976c09f65209dc1$export$245c9aaa9f5ce4ce;
var $4976c09f65209dc1$export$8ad762e3e6399afe;
var $4976c09f65209dc1$export$32ef6f92e22c6ab0;
var $4976c09f65209dc1$export$c9cd164b539ebb63;
"use strict";

var $72Zbf = parcelRequire("72Zbf");

$4976c09f65209dc1$export$c98397a6eb8d0678 = (parcelRequire("jOtxC"));
var $4976c09f65209dc1$var$RSAPrivateKey = $72Zbf.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
});
$4976c09f65209dc1$export$f4aab6816f64fa6b = $4976c09f65209dc1$var$RSAPrivateKey;
var $4976c09f65209dc1$var$RSAPublicKey = $72Zbf.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
});
$4976c09f65209dc1$export$4471f5c65d097c11 = $4976c09f65209dc1$var$RSAPublicKey;
var $4976c09f65209dc1$var$PublicKey = $72Zbf.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($4976c09f65209dc1$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$4976c09f65209dc1$export$ca8b6604d6ce14de = $4976c09f65209dc1$var$PublicKey;
var $4976c09f65209dc1$var$AlgorithmIdentifier = $72Zbf.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
});
var $4976c09f65209dc1$var$PrivateKeyInfo = $72Zbf.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version").int(), this.key("algorithm").use($4976c09f65209dc1$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$4976c09f65209dc1$export$8f54525b330fd87b = $4976c09f65209dc1$var$PrivateKeyInfo;
var $4976c09f65209dc1$var$EncryptedPrivateKeyInfo = $72Zbf.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$4976c09f65209dc1$export$23cd2842b44ca3e7 = $4976c09f65209dc1$var$EncryptedPrivateKeyInfo;
var $4976c09f65209dc1$var$DSAPrivateKey = $72Zbf.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
});
$4976c09f65209dc1$export$245c9aaa9f5ce4ce = $4976c09f65209dc1$var$DSAPrivateKey;
$4976c09f65209dc1$export$8ad762e3e6399afe = $72Zbf.define("DSAparam", function() {
    this.int();
});
var $4976c09f65209dc1$var$ECPrivateKey = $72Zbf.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($4976c09f65209dc1$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$4976c09f65209dc1$export$32ef6f92e22c6ab0 = $4976c09f65209dc1$var$ECPrivateKey;
var $4976c09f65209dc1$var$ECParameters = $72Zbf.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$4976c09f65209dc1$export$c9cd164b539ebb63 = $72Zbf.define("signature", function() {
    this.seq().obj(this.key("r").int(), this.key("s").int());
});

});

parcelRequire.register("l6piA", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRequire.register("lNx08", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip
var $fde7c5ea23ad27b4$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $fde7c5ea23ad27b4$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $fde7c5ea23ad27b4$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $bFXtK = parcelRequire("bFXtK");

var $X9qDO = parcelRequire("X9qDO");

var $eN0t8 = parcelRequire("eN0t8");
var $fde7c5ea23ad27b4$require$Buffer = $eN0t8.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($fde7c5ea23ad27b4$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($fde7c5ea23ad27b4$var$fullRegex);
        decrypted = $fde7c5ea23ad27b4$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $fde7c5ea23ad27b4$require$Buffer.from(match[2], "hex");
        var cipherText = $fde7c5ea23ad27b4$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $bFXtK(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $X9qDO.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $fde7c5ea23ad27b4$require$Buffer.concat(out);
    }
    var tag = key.match($fde7c5ea23ad27b4$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});
parcelRequire.register("bFXtK", function(module, exports) {

var $eN0t8 = parcelRequire("eN0t8");
var $8801a94c82eecd54$require$Buffer = $eN0t8.Buffer;

var $dGbYv = parcelRequire("dGbYv");
/* eslint-disable camelcase */ function $8801a94c82eecd54$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$8801a94c82eecd54$require$Buffer.isBuffer(password)) password = $8801a94c82eecd54$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$8801a94c82eecd54$require$Buffer.isBuffer(salt)) salt = $8801a94c82eecd54$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $8801a94c82eecd54$require$Buffer.alloc(keyLen);
    var iv = $8801a94c82eecd54$require$Buffer.alloc(ivLen || 0);
    var tmp = $8801a94c82eecd54$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $dGbYv();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $8801a94c82eecd54$var$EVP_BytesToKey;

});

parcelRequire.register("X9qDO", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $0b1cd32526c8486e$export$2f64596b8cbf08b4; }, function (v) { return $0b1cd32526c8486e$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $0b1cd32526c8486e$export$36b6d6ef312eab39; }, function (v) { return $0b1cd32526c8486e$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $0b1cd32526c8486e$export$58a258485f1e49f6; }, function (v) { return $0b1cd32526c8486e$export$58a258485f1e49f6 = v; });
var $0b1cd32526c8486e$export$bdd223f16383713e;
var $0b1cd32526c8486e$export$26e5786e8ac8e530;
var $0b1cd32526c8486e$export$2f64596b8cbf08b4;
var $0b1cd32526c8486e$export$20533d26f07f1ee0;
var $0b1cd32526c8486e$export$12ada9414fbc594c;
var $0b1cd32526c8486e$export$2ce6d8d0e8b04e1a;
var $0b1cd32526c8486e$export$36b6d6ef312eab39;
var $0b1cd32526c8486e$export$f5e7e39d57cd9700;
var $0b1cd32526c8486e$export$dedd8dc3dc62b370;
var $0b1cd32526c8486e$export$58a258485f1e49f6;

var $cxwy3 = parcelRequire("cxwy3");

var $kicDr = parcelRequire("kicDr");

var $6cI1N = parcelRequire("6cI1N");
function $0b1cd32526c8486e$var$getCiphers() {
    return Object.keys($6cI1N);
}
$0b1cd32526c8486e$export$bdd223f16383713e = $0b1cd32526c8486e$export$26e5786e8ac8e530 = $cxwy3.createCipher;
$0b1cd32526c8486e$export$2f64596b8cbf08b4 = $0b1cd32526c8486e$export$20533d26f07f1ee0 = $cxwy3.createCipheriv;
$0b1cd32526c8486e$export$12ada9414fbc594c = $0b1cd32526c8486e$export$2ce6d8d0e8b04e1a = $kicDr.createDecipher;
$0b1cd32526c8486e$export$36b6d6ef312eab39 = $0b1cd32526c8486e$export$f5e7e39d57cd9700 = $kicDr.createDecipheriv;
$0b1cd32526c8486e$export$dedd8dc3dc62b370 = $0b1cd32526c8486e$export$58a258485f1e49f6 = $0b1cd32526c8486e$var$getCiphers;

});
parcelRequire.register("cxwy3", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $9211d07c2106ad4f$export$2f64596b8cbf08b4; }, function (v) { return $9211d07c2106ad4f$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createCipher", function () { return $9211d07c2106ad4f$export$bdd223f16383713e; }, function (v) { return $9211d07c2106ad4f$export$bdd223f16383713e = v; });
var $9211d07c2106ad4f$export$2f64596b8cbf08b4;
var $9211d07c2106ad4f$export$bdd223f16383713e;

var $E9Jyp = parcelRequire("E9Jyp");

var $hnaP4 = parcelRequire("hnaP4");

var $eN0t8 = parcelRequire("eN0t8");
var $9211d07c2106ad4f$require$Buffer = $eN0t8.Buffer;

var $1kbe1 = parcelRequire("1kbe1");

var $61MIM = parcelRequire("61MIM");

var $eacX5 = parcelRequire("eacX5");

var $bFXtK = parcelRequire("bFXtK");

var $kvFQ5 = parcelRequire("kvFQ5");
function $9211d07c2106ad4f$var$Cipher(mode, key, iv) {
    $61MIM.call(this);
    this._cache = new $9211d07c2106ad4f$var$Splitter();
    this._cipher = new $eacX5.AES(key);
    this._prev = $9211d07c2106ad4f$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$kvFQ5($9211d07c2106ad4f$var$Cipher, $61MIM);
$9211d07c2106ad4f$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $9211d07c2106ad4f$require$Buffer.concat(out);
};
var $9211d07c2106ad4f$var$PADDING = $9211d07c2106ad4f$require$Buffer.alloc(16, 0x10);
$9211d07c2106ad4f$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($9211d07c2106ad4f$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$9211d07c2106ad4f$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $9211d07c2106ad4f$var$Splitter() {
    this.cache = $9211d07c2106ad4f$require$Buffer.allocUnsafe(0);
}
$9211d07c2106ad4f$var$Splitter.prototype.add = function(data) {
    this.cache = $9211d07c2106ad4f$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$9211d07c2106ad4f$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$9211d07c2106ad4f$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $9211d07c2106ad4f$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $9211d07c2106ad4f$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $9211d07c2106ad4f$var$createCipheriv(suite, password, iv) {
    var config = $E9Jyp[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $9211d07c2106ad4f$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $9211d07c2106ad4f$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $1kbe1(config.module, password, iv);
    else if (config.type === "auth") return new $hnaP4(config.module, password, iv);
    return new $9211d07c2106ad4f$var$Cipher(config.module, password, iv);
}
function $9211d07c2106ad4f$var$createCipher(suite, password) {
    var config = $E9Jyp[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bFXtK(password, false, config.key, config.iv);
    return $9211d07c2106ad4f$var$createCipheriv(suite, keys.key, keys.iv);
}
$9211d07c2106ad4f$export$2f64596b8cbf08b4 = $9211d07c2106ad4f$var$createCipheriv;
$9211d07c2106ad4f$export$bdd223f16383713e = $9211d07c2106ad4f$var$createCipher;

});
parcelRequire.register("E9Jyp", function(module, exports) {








var $078b4975cae973dd$var$modeModules = {
    ECB: (parcelRequire("1DWOT")),
    CBC: (parcelRequire("kwP8a")),
    CFB: (parcelRequire("3rKMV")),
    CFB8: (parcelRequire("kjrOo")),
    CFB1: (parcelRequire("e65kP")),
    OFB: (parcelRequire("4DRRs")),
    CTR: (parcelRequire("8mVCQ")),
    GCM: (parcelRequire("8mVCQ"))
};

var $6cI1N = parcelRequire("6cI1N");
for(var $078b4975cae973dd$var$key in $6cI1N)$6cI1N[$078b4975cae973dd$var$key].module = $078b4975cae973dd$var$modeModules[$6cI1N[$078b4975cae973dd$var$key].mode];
module.exports = $6cI1N;

});
parcelRequire.register("6cI1N", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRequire.register("hnaP4", function(module, exports) {

var $eacX5 = parcelRequire("eacX5");

var $eN0t8 = parcelRequire("eN0t8");
var $ca5cfaca7b74a382$require$Buffer = $eN0t8.Buffer;

var $61MIM = parcelRequire("61MIM");

var $kvFQ5 = parcelRequire("kvFQ5");

var $7U3aN = parcelRequire("7U3aN");

var $8tLxg = parcelRequire("8tLxg");

var $2dknS = parcelRequire("2dknS");
function $ca5cfaca7b74a382$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $ca5cfaca7b74a382$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $ca5cfaca7b74a382$require$Buffer.concat([
            iv,
            $ca5cfaca7b74a382$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $ca5cfaca7b74a382$require$Buffer.concat([
            iv,
            $ca5cfaca7b74a382$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $7U3aN(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($ca5cfaca7b74a382$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($ca5cfaca7b74a382$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $ca5cfaca7b74a382$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $ca5cfaca7b74a382$require$Buffer.from(self._finID);
    $2dknS(out);
    return out;
}
function $ca5cfaca7b74a382$var$StreamCipher(mode, key, iv, decrypt) {
    $61MIM.call(this);
    var h = $ca5cfaca7b74a382$require$Buffer.alloc(4, 0);
    this._cipher = new $eacX5.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $7U3aN(ck);
    iv = $ca5cfaca7b74a382$var$calcIv(this, iv, ck);
    this._prev = $ca5cfaca7b74a382$require$Buffer.from(iv);
    this._cache = $ca5cfaca7b74a382$require$Buffer.allocUnsafe(0);
    this._secCache = $ca5cfaca7b74a382$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$kvFQ5($ca5cfaca7b74a382$var$StreamCipher, $61MIM);
$ca5cfaca7b74a382$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $ca5cfaca7b74a382$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$ca5cfaca7b74a382$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $8tLxg(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $ca5cfaca7b74a382$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$ca5cfaca7b74a382$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$ca5cfaca7b74a382$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$ca5cfaca7b74a382$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$ca5cfaca7b74a382$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $ca5cfaca7b74a382$var$StreamCipher;

});
parcelRequire.register("eacX5", function(module, exports) {

$parcel$export(module.exports, "AES", function () { return $a4fc0bd8ebf9a67c$export$b80fbe1c3a2b92b5; }, function (v) { return $a4fc0bd8ebf9a67c$export$b80fbe1c3a2b92b5 = v; });
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $a4fc0bd8ebf9a67c$export$b80fbe1c3a2b92b5;

var $eN0t8 = parcelRequire("eN0t8");
var $a4fc0bd8ebf9a67c$require$Buffer = $eN0t8.Buffer;
function $a4fc0bd8ebf9a67c$var$asUInt32Array(buf) {
    if (!$a4fc0bd8ebf9a67c$require$Buffer.isBuffer(buf)) buf = $a4fc0bd8ebf9a67c$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $a4fc0bd8ebf9a67c$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $a4fc0bd8ebf9a67c$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $a4fc0bd8ebf9a67c$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $a4fc0bd8ebf9a67c$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $a4fc0bd8ebf9a67c$var$AES(key) {
    this._key = $a4fc0bd8ebf9a67c$var$asUInt32Array(key);
    this._reset();
}
$a4fc0bd8ebf9a67c$var$AES.blockSize = 16;
$a4fc0bd8ebf9a67c$var$AES.keySize = 32;
$a4fc0bd8ebf9a67c$var$AES.prototype.blockSize = $a4fc0bd8ebf9a67c$var$AES.blockSize;
$a4fc0bd8ebf9a67c$var$AES.prototype.keySize = $a4fc0bd8ebf9a67c$var$AES.keySize;
$a4fc0bd8ebf9a67c$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $a4fc0bd8ebf9a67c$var$G.SBOX[t >>> 24] << 24 | $a4fc0bd8ebf9a67c$var$G.SBOX[t >>> 16 & 0xff] << 16 | $a4fc0bd8ebf9a67c$var$G.SBOX[t >>> 8 & 0xff] << 8 | $a4fc0bd8ebf9a67c$var$G.SBOX[t & 0xff];
            t ^= $a4fc0bd8ebf9a67c$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $a4fc0bd8ebf9a67c$var$G.SBOX[t >>> 24] << 24 | $a4fc0bd8ebf9a67c$var$G.SBOX[t >>> 16 & 0xff] << 16 | $a4fc0bd8ebf9a67c$var$G.SBOX[t >>> 8 & 0xff] << 8 | $a4fc0bd8ebf9a67c$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $a4fc0bd8ebf9a67c$var$G.INV_SUB_MIX[0][$a4fc0bd8ebf9a67c$var$G.SBOX[tt >>> 24]] ^ $a4fc0bd8ebf9a67c$var$G.INV_SUB_MIX[1][$a4fc0bd8ebf9a67c$var$G.SBOX[tt >>> 16 & 0xff]] ^ $a4fc0bd8ebf9a67c$var$G.INV_SUB_MIX[2][$a4fc0bd8ebf9a67c$var$G.SBOX[tt >>> 8 & 0xff]] ^ $a4fc0bd8ebf9a67c$var$G.INV_SUB_MIX[3][$a4fc0bd8ebf9a67c$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$a4fc0bd8ebf9a67c$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $a4fc0bd8ebf9a67c$var$asUInt32Array(M);
    return $a4fc0bd8ebf9a67c$var$cryptBlock(M, this._keySchedule, $a4fc0bd8ebf9a67c$var$G.SUB_MIX, $a4fc0bd8ebf9a67c$var$G.SBOX, this._nRounds);
};
$a4fc0bd8ebf9a67c$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $a4fc0bd8ebf9a67c$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$a4fc0bd8ebf9a67c$var$AES.prototype.decryptBlock = function(M) {
    M = $a4fc0bd8ebf9a67c$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $a4fc0bd8ebf9a67c$var$cryptBlock(M, this._invKeySchedule, $a4fc0bd8ebf9a67c$var$G.INV_SUB_MIX, $a4fc0bd8ebf9a67c$var$G.INV_SBOX, this._nRounds);
    var buf = $a4fc0bd8ebf9a67c$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$a4fc0bd8ebf9a67c$var$AES.prototype.scrub = function() {
    $a4fc0bd8ebf9a67c$var$scrubVec(this._keySchedule);
    $a4fc0bd8ebf9a67c$var$scrubVec(this._invKeySchedule);
    $a4fc0bd8ebf9a67c$var$scrubVec(this._key);
};
$a4fc0bd8ebf9a67c$export$b80fbe1c3a2b92b5 = $a4fc0bd8ebf9a67c$var$AES;

});

parcelRequire.register("7U3aN", function(module, exports) {

var $eN0t8 = parcelRequire("eN0t8");
var $5c10397faf1b1732$require$Buffer = $eN0t8.Buffer;
var $5c10397faf1b1732$var$ZEROES = $5c10397faf1b1732$require$Buffer.alloc(16, 0);
function $5c10397faf1b1732$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $5c10397faf1b1732$var$fromArray(out) {
    var buf = $5c10397faf1b1732$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $5c10397faf1b1732$var$GHASH(key) {
    this.h = key;
    this.state = $5c10397faf1b1732$require$Buffer.alloc(16, 0);
    this.cache = $5c10397faf1b1732$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$5c10397faf1b1732$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$5c10397faf1b1732$var$GHASH.prototype._multiply = function() {
    var Vi = $5c10397faf1b1732$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $5c10397faf1b1732$var$fromArray(Zi);
};
$5c10397faf1b1732$var$GHASH.prototype.update = function(buf) {
    this.cache = $5c10397faf1b1732$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$5c10397faf1b1732$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($5c10397faf1b1732$require$Buffer.concat([
        this.cache,
        $5c10397faf1b1732$var$ZEROES
    ], 16));
    this.ghash($5c10397faf1b1732$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $5c10397faf1b1732$var$GHASH;

});


parcelRequire.register("1kbe1", function(module, exports) {

var $eacX5 = parcelRequire("eacX5");

var $eN0t8 = parcelRequire("eN0t8");
var $0f705dcd053f0d05$require$Buffer = $eN0t8.Buffer;

var $61MIM = parcelRequire("61MIM");

var $kvFQ5 = parcelRequire("kvFQ5");
function $0f705dcd053f0d05$var$StreamCipher(mode, key, iv, decrypt) {
    $61MIM.call(this);
    this._cipher = new $eacX5.AES(key);
    this._prev = $0f705dcd053f0d05$require$Buffer.from(iv);
    this._cache = $0f705dcd053f0d05$require$Buffer.allocUnsafe(0);
    this._secCache = $0f705dcd053f0d05$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$kvFQ5($0f705dcd053f0d05$var$StreamCipher, $61MIM);
$0f705dcd053f0d05$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$0f705dcd053f0d05$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $0f705dcd053f0d05$var$StreamCipher;

});


parcelRequire.register("kicDr", function(module, exports) {

$parcel$export(module.exports, "createDecipher", function () { return $ec5f4a2c957eed98$export$12ada9414fbc594c; }, function (v) { return $ec5f4a2c957eed98$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $ec5f4a2c957eed98$export$36b6d6ef312eab39; }, function (v) { return $ec5f4a2c957eed98$export$36b6d6ef312eab39 = v; });
var $ec5f4a2c957eed98$export$12ada9414fbc594c;
var $ec5f4a2c957eed98$export$36b6d6ef312eab39;

var $hnaP4 = parcelRequire("hnaP4");

var $eN0t8 = parcelRequire("eN0t8");
var $ec5f4a2c957eed98$require$Buffer = $eN0t8.Buffer;

var $E9Jyp = parcelRequire("E9Jyp");

var $1kbe1 = parcelRequire("1kbe1");

var $61MIM = parcelRequire("61MIM");

var $eacX5 = parcelRequire("eacX5");

var $bFXtK = parcelRequire("bFXtK");

var $kvFQ5 = parcelRequire("kvFQ5");
function $ec5f4a2c957eed98$var$Decipher(mode, key, iv) {
    $61MIM.call(this);
    this._cache = new $ec5f4a2c957eed98$var$Splitter();
    this._last = void 0;
    this._cipher = new $eacX5.AES(key);
    this._prev = $ec5f4a2c957eed98$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$kvFQ5($ec5f4a2c957eed98$var$Decipher, $61MIM);
$ec5f4a2c957eed98$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $ec5f4a2c957eed98$require$Buffer.concat(out);
};
$ec5f4a2c957eed98$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $ec5f4a2c957eed98$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$ec5f4a2c957eed98$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $ec5f4a2c957eed98$var$Splitter() {
    this.cache = $ec5f4a2c957eed98$require$Buffer.allocUnsafe(0);
}
$ec5f4a2c957eed98$var$Splitter.prototype.add = function(data) {
    this.cache = $ec5f4a2c957eed98$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$ec5f4a2c957eed98$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$ec5f4a2c957eed98$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $ec5f4a2c957eed98$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $ec5f4a2c957eed98$var$createDecipheriv(suite, password, iv) {
    var config = $E9Jyp[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $ec5f4a2c957eed98$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $ec5f4a2c957eed98$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $1kbe1(config.module, password, iv, true);
    else if (config.type === "auth") return new $hnaP4(config.module, password, iv, true);
    return new $ec5f4a2c957eed98$var$Decipher(config.module, password, iv);
}
function $ec5f4a2c957eed98$var$createDecipher(suite, password) {
    var config = $E9Jyp[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bFXtK(password, false, config.key, config.iv);
    return $ec5f4a2c957eed98$var$createDecipheriv(suite, keys.key, keys.iv);
}
$ec5f4a2c957eed98$export$12ada9414fbc594c = $ec5f4a2c957eed98$var$createDecipher;
$ec5f4a2c957eed98$export$36b6d6ef312eab39 = $ec5f4a2c957eed98$var$createDecipheriv;

});



parcelRequire.register("2r16u", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $1c5ef58ccb76778e$export$448fa22aedc9dbca; }, function (v) { return $1c5ef58ccb76778e$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $1c5ef58ccb76778e$export$b80c7ba289c8fa56; }, function (v) { return $1c5ef58ccb76778e$export$b80c7ba289c8fa56 = v; });
var $1c5ef58ccb76778e$export$448fa22aedc9dbca;
var $1c5ef58ccb76778e$export$b80c7ba289c8fa56;

$1c5ef58ccb76778e$export$448fa22aedc9dbca = (parcelRequire("dAOoN"));

$1c5ef58ccb76778e$export$b80c7ba289c8fa56 = (parcelRequire("iUG0Q"));

});


parcelRequire.register("cENfq", function(module, exports) {

var $j8bQA = parcelRequire("j8bQA");

var $eN0t8 = parcelRequire("eN0t8");
var $936f6c09fcfea8b6$require$Buffer = $eN0t8.Buffer;
module.exports = function(seed, len) {
    var t = $936f6c09fcfea8b6$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $936f6c09fcfea8b6$var$i2ops(i++);
        t = $936f6c09fcfea8b6$require$Buffer.concat([
            t,
            $j8bQA("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $936f6c09fcfea8b6$var$i2ops(c) {
    var out = $936f6c09fcfea8b6$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRequire.register("jjFgv", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRequire.register("5Lq0b", function(module, exports) {

var $jlWHo = parcelRequire("jlWHo");

var $eN0t8 = parcelRequire("eN0t8");
var $432582f90dfc1d58$require$Buffer = $eN0t8.Buffer;
function $432582f90dfc1d58$var$withPublic(paddedMsg, key) {
    return $432582f90dfc1d58$require$Buffer.from(paddedMsg.toRed($jlWHo.mont(key.modulus)).redPow(new $jlWHo(key.publicExponent)).fromRed().toArray());
}
module.exports = $432582f90dfc1d58$var$withPublic;

});

parcelRequire.register("lp4ea", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $f94f3648911eb247$require$Buffer = $gzLuY.Buffer;

var $jJLyB = parcelRequire("jJLyB");

var $dKHN6 = parcelRequire("dKHN6");
function $f94f3648911eb247$var$blind(priv) {
    var r = $f94f3648911eb247$var$getr(priv);
    var blinder = r.toRed($jJLyB.mont(priv.modulus)).redPow(new $jJLyB(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $f94f3648911eb247$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $jJLyB($dKHN6(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $f94f3648911eb247$var$crt(msg, priv) {
    var blinds = $f94f3648911eb247$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $jJLyB(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($jJLyB.mont(priv.prime1));
    var c2 = blinded.toRed($jJLyB.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($f94f3648911eb247$require$Buffer, "be", len);
}
$f94f3648911eb247$var$crt.getr = $f94f3648911eb247$var$getr;
module.exports = $f94f3648911eb247$var$crt;

});


parcelRequire.register("jxvLt", function(module, exports) {

var $5nDla = parcelRequire("5nDla");

var $cENfq = parcelRequire("cENfq");

var $jjFgv = parcelRequire("jjFgv");

var $jlWHo = parcelRequire("jlWHo");

var $lp4ea = parcelRequire("lp4ea");

var $j8bQA = parcelRequire("j8bQA");

var $5Lq0b = parcelRequire("5Lq0b");

var $eN0t8 = parcelRequire("eN0t8");
var $e399bd346b5f538e$require$Buffer = $eN0t8.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $5nDla(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $jlWHo(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $5Lq0b(new $jlWHo(enc), key);
    else msg = $lp4ea(enc, key);
    var zBuffer = $e399bd346b5f538e$require$Buffer.alloc(k - msg.length);
    msg = $e399bd346b5f538e$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $e399bd346b5f538e$var$oaep(key, msg);
    else if (padding === 1) return $e399bd346b5f538e$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $e399bd346b5f538e$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $j8bQA("sha1").update($e399bd346b5f538e$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $jjFgv(maskedSeed, $cENfq(maskedDb, hLen));
    var db = $jjFgv(maskedDb, $cENfq(seed, k - hLen - 1));
    if ($e399bd346b5f538e$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $e399bd346b5f538e$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $e399bd346b5f538e$var$compare(a, b) {
    a = $e399bd346b5f538e$require$Buffer.from(a);
    b = $e399bd346b5f538e$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});

parcelRequire.register("7gjH7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $160e55350781a4ed$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "replace", function () { return replace; });

var $41Zxr = parcelRequire("41Zxr");

var $EtHZk = parcelRequire("EtHZk");
class STRING {
    static findHashtags(text11, keepSymbol11 = false) {
        text11 = text11.toLowerCase();
        const usernameRegExp11 = /#\b[a-zA-Z0-9_-]+\b/g;
        const matches11 = text11.matchAll(usernameRegExp11);
        if (keepSymbol11) return Array.from(matches11, (match11)=>match11[0]);
        return Array.from(matches11, (match11)=>match11[0].substring(1));
    }
    static findUsernames(text11, keepSymbol11 = false) {
        text11 = text11.toLowerCase();
        const usernameRegExp11 = /@\b[a-zA-Z0-9_-]+\b/g;
        (0, $EtHZk.log)("FIND USERNAMES usernameRegExp", usernameRegExp11);
        const matches11 = text11.matchAll(usernameRegExp11);
        (0, $EtHZk.log)("FIND USERNAMES matches", matches11);
        if (keepSymbol11) return Array.from(matches11, (match11)=>match11[0]);
        return Array.from(matches11, (match11)=>match11[0].substring(1));
    }
    static extractUsernames(text11) {
        let array11 = this.findUsernames(text11);
    }
    static contains(text11, string11) {
        return text11.toLowerCase().indexOf(string11.toLowerCase()) != -1;
    }
    static containsStrict(text11, string11) {
        return text11.indexOf(string11) != -1;
    }
    static split(text11, string11) {
        return text11.toLowerCase().split(string11.toLowerCase())[0];
    }
    static displaySign(number11, msg11) {
        var text11 = number11 > 0 ? "+" + number11 : number11;
        if (msg11) text11 += " " + msg11;
        return text11;
    }
    static trim(str11) {
        while(str11.charAt(0) == " ")str11 = str11.substr(1);
        while(str11.charAt(str11.length - 1) == " ")str11 = str11.substr(0, -1);
        return str11;
    }
    static lTrim(str11) {
        while(str11.charAt(0) == " ")str11 = str11.substr(1);
        return str11;
    }
    static rTrim(str11) {
        while(str11.charAt(str11.length - 1) == " ")str11 = str11.substr(0, -1);
        return str11;
    }
    static string(char11, repeat11 = 1) {
        if (repeat11 <= 0) return "";
        var r11 = "";
        for(var i11 = 0; i11 < repeat11; i11++)r11 += char11;
        return r11;
    }
    static validateEmail(email11) {
        if (!email11) return false;
        var EMAIL_REGEX11 = /^[A-Z0-9._%+-]+@(?:[A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
        return email11.match(EMAIL_REGEX11);
    }
    static beginsWith(input11, prefix11) {
        return prefix11 == input11.substring(0, prefix11.length);
    }
    static getPrefix(text11, separator11 = "_", toLowerCase11 = false) {
        var output11 = text11.split(separator11)[0];
        if (toLowerCase11) output11.toLowerCase();
        return output11;
    }
    static endsWith(input11, suffix11) {
        return suffix11 == input11.substring(input11.length - suffix11.length);
    }
    static getArray(str11, divider11 = " ") {
        if (!str11) return [
            0
        ];
        divider11 = divider11 || ",";
        var array11 = STRING.doReplace(str11 + "", " ", "").split(divider11);
        for(var n11 in array11)array11[n11] = (0, $41Zxr.default).tryParseInt(array11[n11]);
        return array11;
    }
    static doReplace(string11, srch11, replaceWith11) {
        return string11.split(srch11).join(replaceWith11);
    }
    static removeString(text11, stringToRemove11) {
        return text11.replace(new RegExp(stringToRemove11, "g"), "");
    }
    static removeWords(text11, words11) {
        for(let n11 in words11){
            let word11 = words11[n11];
            text11 = this.removeString(text11, " " + word11);
            text11 = this.removeString(text11, word11);
        }
        return text11;
    }
    static removeVowels(str11, minLength11 = 3) {
        if (str11.length <= minLength11) return str11;
        return str11.replace(/[AEIOUaeiou-]/gi, ""); //01234567890
    }
    static getFileExtension(target11) {
        return target11.substring(target11.lastIndexOf(".") + 1, target11.length).toLowerCase();
    }
    static getFileNameWithoutExtension(filePath11) {
        const baseName11 = filePath11.split("/").pop();
        if (!baseName11) return "";
        return baseName11.split(".").slice(0, -1).join(".");
    }
    static containsKeys(txt11, keywords11) {
        if (!keywords11) return false;
        var keys11 = keywords11.split(",");
        var text11 = txt11.toLowerCase();
        for(var n11 in keys11)if (text11.indexOf(keys11[n11]) != -1) return true;
    }
    static replace(string11, srch11, replaceWith11) {
        if (!string11) return "";
        if (typeof srch11 == "string" && replaceWith11) return STRING.doReplace(string11, srch11, replaceWith11);
        for(var name11 in srch11){
            var suffix11 = "";
            var prefix11 = "";
            if (name11 == "percent") suffix11 = "%";
            if (name11 == "USD") prefix11 = "$";
            string11 = STRING.doReplace(string11, "{" + name11 + "}", prefix11 + srch11[name11] + suffix11);
        }
        return string11;
    }
    static excludeChars(target11, chars11) {
        var txt11 = "", valid11;
        var chars11 = chars11 || ":,<>-'{}[]/*-+!;8!@#$%.^&*()";
        for(var c11 = 0; c11 < target11.length; c11++){
            valid11 = true;
            for(var z11 = 0; z11 < chars11.length; z11++)if (target11.charAt(c11) == chars11.charAt(z11)) {
                valid11 = false;
                break;
            }
            if (valid11) txt11 += target11.charAt(c11);
        }
        return txt11;
    }
    static extractKeywords(text11, length11 = 0) {
        var validChars11 = "abcdefghijklmnopqrstuvwxyz";
        var output11 = [];
        var max11 = text11.length;
        var text11 = text11.toLowerCase();
        var string11 = "";
        for(var n11 = 0; n11 < max11; n11++){
            var char11 = text11.charAt(n11);
            if (validChars11.indexOf(char11) != -1) string11 += char11;
            else {
                if (string11.length > length11) output11.push(string11);
                string11 = "";
            }
        }
        return output11;
    }
    static fillZero(input11, zeros11 = 1) {
        var string11 = input11 + "";
        while(string11.length <= zeros11)string11 = "0" + string11;
        if (string11 == "0") string11 = "00";
        return string11;
    }
    static formatRank(input11) {
        var append11 = "th";
        if (input11 == 1) append11 = "st";
        if (input11 == 2) append11 = "nd";
        if (input11 == 3) append11 = "rd";
        return input11 + append11;
    }
    static commas(num11, interval11 = 3) {
        num11 = num11 + "";
        var output11 = "";
        var str11;
        var c11 = 0;
        for(var n11 = num11.length - 1; n11 >= 0; n11--){
            str11 = "";
            if (++c11 >= interval11 && n11 > 0) {
                c11 = 0;
                str11 = " ";
            }
            str11 += num11.charAt(n11);
            output11 = str11 + output11;
        }
        return output11;
    }
    static toDollars(value11, sign11 = "$", divider11 = 1) {
        var isNeg11 = value11 < 0;
        var formatted11 = sign11 + STRING.commas(Math.abs(Math.round(value11 / divider11)));
        if (isNeg11) formatted11 = "-" + formatted11;
        return formatted11;
    }
    static simplify(string11) {
        var output11 = "";
        var vowels11 = "aeiou";
        var string11 = string11.toLowerCase();
        for(var n11 in string11)if (vowels11.indexOf(string11[n11]) == -1) output11 += string11[n11];
        return output11;
    }
    static toArray(string11, isInt11) {
        var output11 = [];
        if (!string11) return output11;
        for(var n11 in string11){
            var value11 = string11[n11];
            if (isInt11) value11 = parseInt(value11);
            output11.push(value11);
        }
        return output11;
    }
    static commarize(number, asObject) {
        if (!(0, $41Zxr.default).isNumber(number)) return number;
        var num = Math.round(number);
        var unitname = "";
        if (num >= 1e3) {
            var unit = Math.floor((number.toFixed(0).length - 1) / 3) * 3;
            num = Math.floor(num / (eval("1e" + unit) * 100)) / 100;
            unitname = STRING.capitalize(STRING.units[Math.floor(unit / 3) - 1]);
        } else num = Math.floor(num * 100) / 100;
        var object = {
            number: num,
            value: num,
            unit: unitname || ""
        };
        if (unitname) unitname = "" + unitname;
        var formatted = num + unitname;
        object.formatted = formatted;
        return asObject ? object : formatted;
    }
    static capitalize(s11) {
        if (typeof s11 !== "string") return "";
        return s11.charAt(0).toUpperCase() + s11.slice(1);
    }
    static stringify(object11) {
        var json11;
        try {
            json11 = JSON.stringify(object11);
        } catch (err11) {
            return (0, $EtHZk.log)("JSON ENCODE FAILED");
        }
        return json11;
    }
    static random(Length11 = 10) {
        let result11 = "";
        let alphabetLength11 = STRING.ALPHABET.length;
        for(let i11 = 0; i11 < Length11; i11++)result11 += STRING.ALPHABET.charAt(Math.floor(Math.random() * alphabetLength11));
        return result11;
    }
}
(function(STRING11) {
    var ALPHABET11 = STRING11.ALPHABET = "#ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var unitsLarge11 = STRING11.unitsLarge = [
        "thousand",
        "million",
        "billion",
        "trillion",
        "quaddrillion",
        "quintillion",
        "sextillion",
        "septillion",
        "octillion",
        "nonillion",
        "decillion",
        "undecillion",
        "duodecillion",
        "tredecillion",
        "quattuordecillion",
        "quindecillion",
        "sexdecillion",
        "septdecillion",
        "octodecillion",
        "novemdecillion",
        "vigintillion",
        "unvigintillion",
        "duovigintillion",
        "trevigintillion",
        "quattuorvigintillion",
        "quinvigintillion",
        "sexvigintillion",
        "septvigintillion",
        "octovigintillion",
        "novemvigintillion",
        "trigintillion",
        "untrigintillion",
        "duotrigintillion",
        "googol",
        "tretrigintillion",
        "quattuortrigintillion",
        "quintrigintillion",
        "sextrigintillion",
        "septtrigintillion",
        "octotrigintillion",
        "novemtrigintillion",
        "quadragintillion",
        "unquadragintillion",
        "duoquadragintillion",
        "trequadragintillion",
        "quattuorquadragintillion",
        "quinquadragintillion",
        "sexquadragintillion",
        "septquadragintillion",
        "octoquadragintillion",
        "novemquadragintillion",
        "quinquagintillion",
        "unquinquagintillion",
        "duoquinquagintillion",
        "trequinquagintillion",
        "quattuorquinquagintillion",
        "quinquinquagintillion",
        "sexquinquagintillion",
        "septquinquagintillion",
        "octoquinquagintillion",
        "novemquinquagintillion",
        "sexagintillion",
        "unsexagintillion",
        "duosexagintillion",
        "tresexagintillion",
        "quattuorsexagintillion",
        "quinsexagintillion",
        "sexsexagintillion",
        "septsexagintillion",
        "octosexagintillion",
        "novemsexagintillion",
        "septuagintillion",
        "unseptuagintillion",
        "duoseptuagintillion",
        "treseptuagintillion",
        "quattuorseptuagintillion",
        "quinseptuagintillion",
        "sexseptuagintillion",
        "septseptuagintillio",
        "octoseptuagintillion",
        "novemseptuagintillion",
        "octogintillion",
        "unoctogintillion",
        "duooctogintillion",
        "treoctogintillion",
        "quattuoroctogintillion",
        "quinoctogintillion",
        "sexoctogintillion",
        "septoctogintillion",
        "octooctogintillion",
        "novemoctogintillion",
        "nonagintillion",
        "unnonagintillion",
        "duononagintillion",
        "trenonagintillion",
        "quattuornonagintillion",
        "quinnonagintillion",
        "sexnonagintillion",
        "septnonagintillion",
        "octononagintillion",
        "novemnonagintillion",
        "centillion"
    ];
    var units11 = STRING11.units = [
        "k",
        "M",
        "B",
        "T",
        "qd",
        "Qn",
        "sx",
        "Sp",
        "O",
        "N",
        "decillion",
        "undecillion",
        "duodecillion",
        "tredecillion",
        "quattuordecillion",
        "quindecillion",
        "sexdecillion",
        "septdecillion",
        "octodecillion",
        "novemdecillion",
        "vigintillion",
        "unvigintillion",
        "duovigintillion",
        "trevigintillion",
        "quattuorvigintillion",
        "quinvigintillion",
        "sexvigintillion",
        "septvigintillion",
        "octovigintillion",
        "novemvigintillion",
        "trigintillion",
        "untrigintillion",
        "duotrigintillion",
        "googol",
        "tretrigintillion",
        "quattuortrigintillion",
        "quintrigintillion",
        "sextrigintillion",
        "septtrigintillion",
        "octotrigintillion",
        "novemtrigintillion",
        "quadragintillion",
        "unquadragintillion",
        "duoquadragintillion",
        "trequadragintillion",
        "quattuorquadragintillion",
        "quinquadragintillion",
        "sexquadragintillion",
        "septquadragintillion",
        "octoquadragintillion",
        "novemquadragintillion",
        "quinquagintillion",
        "unquinquagintillion",
        "duoquinquagintillion",
        "trequinquagintillion",
        "quattuorquinquagintillion",
        "quinquinquagintillion",
        "sexquinquagintillion",
        "septquinquagintillion",
        "octoquinquagintillion",
        "novemquinquagintillion",
        "sexagintillion",
        "unsexagintillion",
        "duosexagintillion",
        "tresexagintillion",
        "quattuorsexagintillion",
        "quinsexagintillion",
        "sexsexagintillion",
        "septsexagintillion",
        "octosexagintillion",
        "novemsexagintillion",
        "septuagintillion",
        "unseptuagintillion",
        "duoseptuagintillion",
        "treseptuagintillion",
        "quattuorseptuagintillion",
        "quinseptuagintillion",
        "sexseptuagintillion",
        "septseptuagintillio",
        "octoseptuagintillion",
        "novemseptuagintillion",
        "octogintillion",
        "unoctogintillion",
        "duooctogintillion",
        "treoctogintillion",
        "quattuoroctogintillion",
        "quinoctogintillion",
        "sexoctogintillion",
        "septoctogintillion",
        "octooctogintillion",
        "novemoctogintillion",
        "nonagintillion",
        "unnonagintillion",
        "duononagintillion",
        "trenonagintillion",
        "quattuornonagintillion",
        "quinnonagintillion",
        "sexnonagintillion",
        "septnonagintillion",
        "octononagintillion",
        "novemnonagintillion",
        "centillion"
    ];
})(STRING || (STRING = {}));
var $160e55350781a4ed$export$2e2bcd8739ae039 = STRING;
var replace = STRING.replace;

});
parcelRequire.register("41Zxr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f55fc5e85c547969$export$2e2bcd8739ae039; });

var $hdhIE = parcelRequire("hdhIE");

var $duPOj = parcelRequire("duPOj");
class $f55fc5e85c547969$var$MATH {
    static hipotenusa(pointA, _pointB) {
        var pointB = _pointB || {
            x: 0,
            y: 0
        };
        var dx = pointB.x - pointA.x;
        var dy = pointB.y - pointA.y;
        return Math.sqrt(dx * dx + dy * dy);
    }
    static hipotenusaZ(pointA, pointB) {
        var dx = pointB.x - pointA.x;
        var dz = pointB.z - pointA.z;
        return Math.sqrt(dx * dx + dz * dz);
    }
    static distanceNoSquare(pointA, pointB) {
        var x = pointB.x - pointA.x;
        var y = pointB.y - pointA.y;
        return x * x + y * y;
    }
    static cycle(value, max = 100, min = 0, incremental = 1) {
        value += incremental;
        while(value > max)value -= max + incremental;
        while(value < min)value += max + incremental;
        return value;
    }
    static getSinCos(pointA, pointB) {
        var dx = pointB.x - pointA.x;
        var dy = pointB.y - pointA.y;
        var h = Math.sqrt(dx * dx + dy * dy);
        var cos = dx / h;
        var sin = dy / h;
        return new (0, $hdhIE.default)(cos, sin);
    }
    static getSinCosZ(pointA, pointB) {
        var dx = pointB.x - pointA.x;
        var dz = pointB.z - pointA.z;
        var h = Math.sqrt(dx * dx + dz * dz);
        return {
            sin: dz / h,
            cos: dx / h
        };
    }
    static aroundRadius(radius, radians) {
        return {
            x: radius * Math.cos(radians),
            y: radius * Math.sin(radians)
        };
    }
    static lerp(value1, value2, amount) {
        var amount = $f55fc5e85c547969$var$MATH.hardLimit(amount, 0, 1);
        return value1 + (value2 - value1) * amount;
    }
    static round(value) {
        for(var n in $f55fc5e85c547969$var$MATH.factors)if (value > $f55fc5e85c547969$var$MATH.factors[n]) return roundFactor(value, $f55fc5e85c547969$var$MATH.factors[n]);
        return value;
        function roundFactor(value, factor) {
            return Math.round(value / factor) * factor;
        }
    }
    static ceil(number, max) {
        return number > max ? max : number;
    }
    static getPercent(number, max) {
        return $f55fc5e85c547969$var$MATH.hardLimit(number * 100 / max, 0, 100);
    }
    static hardLimit(number, min, max) {
        return $f55fc5e85c547969$var$MATH.clamp(number, max, min);
    }
    static clamp(number, max, min = 0) {
        if (number < min) return min;
        if (max && number > max) return max;
        return number;
    }
    static floor(number, min) {
        return number < min ? min : number;
    }
    static commas(value) {
        return typeof value == "number" ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : value;
    }
    static isNumber(value) {
        return typeof value == "number";
    }
    static forceNumber(value) {
        if (!value) return 0;
        var int = parseInt(value);
        return $f55fc5e85c547969$var$MATH.isNumber(int) ? int : 1;
    }
    static tryParseInt(value) {
        var parsed = parseInt(value);
        return isNaN(parsed) ? value : parsed;
    }
    static parseInt(string) {
        string = string.toString();
        if (string.indexOf("E+") == -1) return parseInt(string);
        var array = string.split("E+");
        var first = array[0].split(".");
        var zeroes = parseInt(array[1]);
        if (first[1]) first[0] += first[1];
        var value = first[0];
        for(var n = 0; n < zeroes; n++)value += "0";
        return parseInt(value);
    }
    static middlePoint(pointA, pointB) {
        var x = pointA.x + (pointB.x - pointA.x) / 2;
        var y = pointA.y + (pointB.y - pointA.y) / 2;
        return {
            x: x,
            y: y
        };
    }
    static getRotation(container = {
        x: 0,
        y: 0
    }, lookat = {
        x: 0,
        y: 0
    }) {
        return $f55fc5e85c547969$var$MATH.radiansToDegree(Math.atan2(lookat.y - container.y, lookat.x - container.x)) + 90;
    }
    static distance(A, B) {
        return B - A;
    }
    static degreeToRadians(degree) {
        return (degree || 0) * 0.0174533;
    }
    static radiansToDegree(radian) {
        return radian / 0.0174533;
    }
    static pointToIso(from, to = {}) {
        to.x = (from.x - from.y) * 0.5;
        to.y = (from.x + from.y) * 0.289;
        return to;
    }
    static isoToPoint(iso, normal = {}) {
        normal.x = (iso.y / 0.289 + iso.x / 0.5) / 2;
        normal.y = (iso.y / 0.289 - iso.x / 0.5) / 2;
        return normal;
    }
    static getclosestPoint(lx1, ly1, lx2, ly2, px, py) {
        var oy = ly2 - ly1;
        var ox = lx1 - lx2;
        var det = oy * oy + ox * ox;
        if (det === 0) return undefined;
        var C1 = oy * lx1 + ox * ly1;
        var C2 = -ox * px + oy * py;
        return [
            (oy * C1 - ox * C2) / det,
            (oy * C2 + ox * C1) / det
        ];
    }
    static higherValue(a, b) {
        return a > b ? a : b;
    }
    static lowerValue(a, b) {
        return a < b ? a : b;
    }
    static tsunami(pointA, pointB, aura = 500) {
        var dx = pointB.x - pointA.x;
        var dy = pointB.y - pointA.y;
        var h = Math.sqrt(dx * dx + dy * dy);
        if (h == 0) return false;
        if (h > aura) return false;
        var cos = dx / h;
        var sin = dy / h;
        dx = pointB.x;
        dy = pointB.y;
        if (h < aura / 2) {
            dx += cos * h / 2;
            dy += sin * h / 2;
            return {
                x: dx,
                y: dy
            };
        }
        dx += cos * (aura - h) / 2;
        dy += sin * (aura - h) / 2;
        return {
            x: dx,
            y: dy
        };
    }
    static isBetween(value, min, max) {
        return !(value < min || value > max);
    }
    static isBetweenAB(aMin, aMax, bMin, bMax) {
        return !(aMax < bMin || aMin > bMax);
    }
    static isBetweenAABB(aMin, aMax, bMin, bMax, cMin, cMax, dMin, dMax) {
        return !(aMax < bMin || aMin > bMax || cMax < dMin || cMin > dMax);
    }
    static getClosest(array, to = {
        x: 0,
        y: 0
    }) {
        var closest = undefined;
        var distance = 9999999999999;
        for(var n in array){
            var point = array[n];
            var dist = $f55fc5e85c547969$var$MATH.hipotenusa(point, to);
            if (dist > distance) continue;
            distance = dist;
            closest = point;
        }
        return closest;
    }
    static roundDecimal(value, decimals = 10) {
        return Math.round(value * decimals) / decimals;
    }
    static getSign(value) {
        return value < 0 ? -1 : 1;
    }
    static double(value, times = 1) {
        while(--times >= 1)value *= 2;
        return value;
    }
    static getMiddlePoint(points) {
        var left;
        var right;
        var top;
        var bottom;
        for(var n in points){
            var point = points[n];
            if (!left || point.x < left) left = point.x;
            if (!right || point.x > right) right = point.x;
            if (!bottom || point.y < bottom) bottom = point.y;
            if (!top || point.y > top) top = point.y;
        }
        return new (0, $hdhIE.default)(left + (right - left) / 2, bottom + (top - bottom) / 2);
    }
    static normalizePoints(points) {
        var center = $f55fc5e85c547969$var$MATH.getMiddlePoint(points);
        for(var n in points){
            var point = points[n];
            point.x -= center.x;
            point.y -= center.y;
        }
        return points;
    }
    /*
    public static normalizeAndShiftPoints( points:any, side:number, scale:number ) : number
    {
        if( scale === undefined ) scale = 1;

        const center = MATH.v1;
        const dir = MATH.v2;
        
        let minX = Number.POSITIVE_INFINITY;
        let minY = Number.POSITIVE_INFINITY;
        
        let maxX = Number.NEGATIVE_INFINITY;
        let maxY = Number.NEGATIVE_INFINITY;

        for ( let n = 0, nl = points.length; n < nl; ++n ) 
        {
            const p = points[n];
            
            p.x = p.x / side;
            p.y = p.y / side;
            
            if( p.x < minX ) minX = p.x;
            if( p.y < minY ) minY = p.y;
            
            if( p.x > maxX ) maxX = p.x;
            if( p.y > maxY ) maxY = p.y;            
        }
        
        const cx = minX + (maxX - minX) / 2;
        const cy = minY + (maxY - minY) / 2;
        
        center.set(cx, cy);
        
        for (let n = 0, nl = points.length; n < nl; ++n) {
            const p = points[n];
            
            dir.set(0, 0, 0).sub(center).normalize();
            
            const dist = center.distance( Vec2.ZERO);
            
            const move = dir.mulScalar(dist);
            
            p.add( move ).mulScalar( scale );
        }
        
        return points;
    };
 
    public static angle( from:any, to:any )
    {
        const denom = Math.sqrt(from.length() * to.length());
        if (denom < 1e-15) return 0;

        const dot = pc.math.clamp(from.dot(to) / denom, -1, 1);
       // return Math.acos(dot) * pc.math.RAD_TO_DEG;
    };
 
    public static signedAngle( from, to, axis ) : number
    {
        const unsignedAngle = MATH.angle( from, to );

        const x = from.y * to.z - from.z * to.y;
        const y = from.z * to.x - from.x * to.z;
        const z = from.x * to.y - from.y * to.x;
        const sign = Math.sign(axis.x * x + axis.y * y + axis.z * z);
        return unsignedAngle * sign;
    };

    */ static gain(x, k) {
        const a = 0.5 * Math.pow(2.0 * (x < 0.5 ? x : 1.0 - x), k);
        return x < 0.5 ? a : 1.0 - a;
    }
    static randomSpherePoint(radius) {
        var u = Math.random();
        var v = Math.random();
        var theta = 2 * Math.PI * u;
        var phi = Math.acos(2 * v - 1);
        var x = radius * Math.sin(phi) * Math.cos(theta);
        var y = radius * Math.sin(phi) * Math.sin(theta);
        var z = radius * Math.cos(phi);
        return new (0, $duPOj.default)(x, y, z);
    }
}
(function(MATH) {
    var factors = MATH.factors = [
        1000,
        500,
        100,
        50,
        10,
        5
    ];
})($f55fc5e85c547969$var$MATH || ($f55fc5e85c547969$var$MATH = {}));
var $f55fc5e85c547969$export$2e2bcd8739ae039 = $f55fc5e85c547969$var$MATH;

});
parcelRequire.register("hdhIE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71a81d075a41ee75$export$2e2bcd8739ae039; });
class $71a81d075a41ee75$var$Vec2 {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
}
var $71a81d075a41ee75$export$2e2bcd8739ae039 = $71a81d075a41ee75$var$Vec2;

});

parcelRequire.register("duPOj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b65c50dd37a66f1f$export$2e2bcd8739ae039; });
class $b65c50dd37a66f1f$var$Vec3 {
    constructor(x, y, z){
        this.x = x;
        this.y = y;
        this.z = z;
    }
}
var $b65c50dd37a66f1f$export$2e2bcd8739ae039 = $b65c50dd37a66f1f$var$Vec3;

});


parcelRequire.register("EtHZk", function(module, exports) {

$parcel$export(module.exports, "log", function () { return $234a3c347cc43b53$export$bef1f36f5486a6a3; });
class $234a3c347cc43b53$var$LOG {
    static msg(e) {
        $234a3c347cc43b53$export$bef1f36f5486a6a3("ERROR!", e);
        return new Error(e);
    }
    static log(...args) {
        console.log(args);
    }
    static error(...args) {
        console.log(args);
    }
    static timer(int = 1) {
        let counter = 0;
        //log( "Start "+ text );
        let interval = setInterval(()=>{
            counter += int;
        }, int);
        function stop() {
            clearInterval(interval);
            return counter + "ms";
        }
        return stop;
    }
}
(()=>{
    $234a3c347cc43b53$var$LOG.pool = new Map();
})();
var $234a3c347cc43b53$export$bef1f36f5486a6a3 = $234a3c347cc43b53$var$LOG.log;
var $234a3c347cc43b53$export$a3bc9b8ed74fc = $234a3c347cc43b53$var$LOG.error;
var $234a3c347cc43b53$export$9dc4ecf953986f04 = $234a3c347cc43b53$var$LOG.timer;
var $234a3c347cc43b53$export$c2d084dc44961371 = $234a3c347cc43b53$var$LOG.log;
var $234a3c347cc43b53$export$2e2bcd8739ae039 = $234a3c347cc43b53$var$LOG;

});


parcelRequire.register("9MXKq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $7206f16b60b14c62$export$2e2bcd8739ae039; });
var $7206f16b60b14c62$var$plugin = function() {
    return window.ContactsX || {};
};
var $7206f16b60b14c62$var$ContactsX = /** @class */ function() {
    function ContactsX() {}
    ContactsX.ErrorCodes = $7206f16b60b14c62$var$plugin().ErrorCodes;
    ContactsX.find = function(success, failure, options) {
        var plu = $7206f16b60b14c62$var$plugin();
        return plu.find.apply(plu, arguments);
    };
    ContactsX.pick = function(success, failure) {
        var plu = $7206f16b60b14c62$var$plugin();
        return plu.pick.apply(plu, arguments);
    };
    ContactsX.save = function(contact, success, failure) {
        var plu = $7206f16b60b14c62$var$plugin();
        return plu.save.apply(plu, arguments);
    };
    ContactsX.delete = function(id, success, failure) {
        var plu = $7206f16b60b14c62$var$plugin();
        return plu.delete.apply(plu, arguments);
    };
    ContactsX.hasPermission = function(success, failure) {
        var plu = $7206f16b60b14c62$var$plugin();
        return plu.hasPermission.apply(plu, arguments);
    };
    ContactsX.requestPermission = function(success, failure) {
        var plu = $7206f16b60b14c62$var$plugin();
        return plu.requestPermission.apply(plu, arguments);
    };
    ContactsX.requestWritePermission = function(success, failure) {
        var plu = $7206f16b60b14c62$var$plugin();
        return plu.requestWritePermission.apply(plu, arguments);
    };
    return ContactsX;
}();
var $7206f16b60b14c62$export$2e2bcd8739ae039 = $7206f16b60b14c62$var$ContactsX;

});

parcelRequire.register("jRRlM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e76c59cb106f1f6f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $6cds3 = parcelRequire("6cds3");
var $e76c59cb106f1f6f$var$_react2 = $e76c59cb106f1f6f$var$_interopRequireDefault($6cds3);

var $aMJGV = parcelRequire("aMJGV");
var $e76c59cb106f1f6f$var$_propTypes2 = $e76c59cb106f1f6f$var$_interopRequireDefault($aMJGV);

var $esvtZ = parcelRequire("esvtZ");

var $kFlOJ = parcelRequire("kFlOJ");

var $8OiB8 = parcelRequire("8OiB8");
var $e76c59cb106f1f6f$var$_object2 = $e76c59cb106f1f6f$var$_interopRequireDefault($8OiB8);

var $eI2iN = parcelRequire("eI2iN");
var $e76c59cb106f1f6f$var$_document2 = $e76c59cb106f1f6f$var$_interopRequireDefault($eI2iN);
function $e76c59cb106f1f6f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e76c59cb106f1f6f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e76c59cb106f1f6f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e76c59cb106f1f6f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $e76c59cb106f1f6f$var$DISPLAY = {
    BLOCK: "block",
    FLEX: "flex",
    INLINE: "inline",
    INLINE_BLOCK: "inline-block",
    CONTENTS: "contents"
};
var $e76c59cb106f1f6f$var$propTypes = (0, $esvtZ.forbidExtraProps)({
    children: $e76c59cb106f1f6f$var$_propTypes2["default"].node.isRequired,
    onOutsideClick: $e76c59cb106f1f6f$var$_propTypes2["default"].func.isRequired,
    disabled: $e76c59cb106f1f6f$var$_propTypes2["default"].bool,
    useCapture: $e76c59cb106f1f6f$var$_propTypes2["default"].bool,
    display: $e76c59cb106f1f6f$var$_propTypes2["default"].oneOf((0, $e76c59cb106f1f6f$var$_object2["default"])($e76c59cb106f1f6f$var$DISPLAY))
});
var $e76c59cb106f1f6f$var$defaultProps = {
    disabled: false,
    // `useCapture` is set to true by default so that a `stopPropagation` in the
    // children will not prevent all outside click handlers from firing - maja
    useCapture: true,
    display: $e76c59cb106f1f6f$var$DISPLAY.BLOCK
};
var $e76c59cb106f1f6f$var$OutsideClickHandler = function(_React$Component) {
    $e76c59cb106f1f6f$var$_inherits(OutsideClickHandler, _React$Component);
    function OutsideClickHandler() {
        var _ref;
        $e76c59cb106f1f6f$var$_classCallCheck(this, OutsideClickHandler);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var _this = $e76c59cb106f1f6f$var$_possibleConstructorReturn(this, (_ref = OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call.apply(_ref, [
            this
        ].concat(args)));
        _this.onMouseDown = _this.onMouseDown.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        _this.setChildNodeRef = _this.setChildNodeRef.bind(_this);
        return _this;
    }
    $e76c59cb106f1f6f$var$_createClass(OutsideClickHandler, [
        {
            key: "componentDidMount",
            value: function() {
                function componentDidMount() {
                    var _props = this.props, disabled = _props.disabled, useCapture = _props.useCapture;
                    if (!disabled) this.addMouseDownEventListener(useCapture);
                }
                return componentDidMount;
            }()
        },
        {
            key: "componentDidUpdate",
            value: function() {
                function componentDidUpdate(_ref2) {
                    var prevDisabled = _ref2.disabled;
                    var _props2 = this.props, disabled = _props2.disabled, useCapture = _props2.useCapture;
                    if (prevDisabled !== disabled) {
                        if (disabled) this.removeEventListeners();
                        else this.addMouseDownEventListener(useCapture);
                    }
                }
                return componentDidUpdate;
            }()
        },
        {
            key: "componentWillUnmount",
            value: function() {
                function componentWillUnmount() {
                    this.removeEventListeners();
                }
                return componentWillUnmount;
            }()
        },
        {
            key: "onMouseDown",
            value: function() {
                function onMouseDown(e) {
                    var useCapture = this.props.useCapture;
                    var isDescendantOfRoot = this.childNode && (0, $e76c59cb106f1f6f$var$_document2["default"])(this.childNode, e.target);
                    if (!isDescendantOfRoot) {
                        if (this.removeMouseUp) {
                            this.removeMouseUp();
                            this.removeMouseUp = null;
                        }
                        this.removeMouseUp = (0, $kFlOJ.addEventListener)(document, "mouseup", this.onMouseUp, {
                            capture: useCapture
                        });
                    }
                }
                return onMouseDown;
            }()
        },
        {
            key: "onMouseUp",
            value: function() {
                function onMouseUp(e) {
                    var onOutsideClick = this.props.onOutsideClick;
                    var isDescendantOfRoot = this.childNode && (0, $e76c59cb106f1f6f$var$_document2["default"])(this.childNode, e.target);
                    if (this.removeMouseUp) {
                        this.removeMouseUp();
                        this.removeMouseUp = null;
                    }
                    if (!isDescendantOfRoot) onOutsideClick(e);
                }
                return onMouseUp;
            }()
        },
        {
            key: "setChildNodeRef",
            value: function() {
                function setChildNodeRef(ref) {
                    this.childNode = ref;
                }
                return setChildNodeRef;
            }()
        },
        {
            key: "addMouseDownEventListener",
            value: function() {
                function addMouseDownEventListener(useCapture) {
                    this.removeMouseDown = (0, $kFlOJ.addEventListener)(document, "mousedown", this.onMouseDown, {
                        capture: useCapture
                    });
                }
                return addMouseDownEventListener;
            }()
        },
        {
            key: "removeEventListeners",
            value: function() {
                function removeEventListeners() {
                    if (this.removeMouseDown) this.removeMouseDown();
                    if (this.removeMouseUp) this.removeMouseUp();
                }
                return removeEventListeners;
            }()
        },
        {
            key: "render",
            value: function() {
                function render() {
                    var _props3 = this.props, children = _props3.children, display = _props3.display;
                    return $e76c59cb106f1f6f$var$_react2["default"].createElement("div", {
                        ref: this.setChildNodeRef,
                        style: display !== $e76c59cb106f1f6f$var$DISPLAY.BLOCK && (0, $e76c59cb106f1f6f$var$_object2["default"])($e76c59cb106f1f6f$var$DISPLAY).includes(display) ? {
                            display: display
                        } : undefined
                    }, children);
                }
                return render;
            }()
        }
    ]);
    return OutsideClickHandler;
}($e76c59cb106f1f6f$var$_react2["default"].Component);
module.exports["default"] = $e76c59cb106f1f6f$var$OutsideClickHandler;
$e76c59cb106f1f6f$var$OutsideClickHandler.propTypes = $e76c59cb106f1f6f$var$propTypes;
$e76c59cb106f1f6f$var$OutsideClickHandler.defaultProps = $e76c59cb106f1f6f$var$defaultProps;

});
parcelRequire.register("esvtZ", function(module, exports) {

module.exports = (parcelRequire("EOS7F"));

});
parcelRequire.register("EOS7F", function(module, exports) {
"use strict";
function $07ab32a677abb15c$var$noop() {
    return null;
}
$07ab32a677abb15c$var$noop.isRequired = $07ab32a677abb15c$var$noop;
function $07ab32a677abb15c$var$noopThunk() {
    return $07ab32a677abb15c$var$noop;
}
module.exports = {
    and: $07ab32a677abb15c$var$noopThunk,
    between: $07ab32a677abb15c$var$noopThunk,
    booleanSome: $07ab32a677abb15c$var$noopThunk,
    childrenHavePropXorChildren: $07ab32a677abb15c$var$noopThunk,
    childrenOf: $07ab32a677abb15c$var$noopThunk,
    childrenOfType: $07ab32a677abb15c$var$noopThunk,
    childrenSequenceOf: $07ab32a677abb15c$var$noopThunk,
    componentWithName: $07ab32a677abb15c$var$noopThunk,
    disallowedIf: $07ab32a677abb15c$var$noopThunk,
    elementType: $07ab32a677abb15c$var$noopThunk,
    empty: $07ab32a677abb15c$var$noopThunk,
    explicitNull: $07ab32a677abb15c$var$noopThunk,
    forbidExtraProps: Object,
    integer: $07ab32a677abb15c$var$noopThunk,
    keysOf: $07ab32a677abb15c$var$noopThunk,
    mutuallyExclusiveProps: $07ab32a677abb15c$var$noopThunk,
    mutuallyExclusiveTrueProps: $07ab32a677abb15c$var$noopThunk,
    nChildren: $07ab32a677abb15c$var$noopThunk,
    nonNegativeInteger: $07ab32a677abb15c$var$noop,
    nonNegativeNumber: $07ab32a677abb15c$var$noopThunk,
    numericString: $07ab32a677abb15c$var$noopThunk,
    object: $07ab32a677abb15c$var$noopThunk,
    or: $07ab32a677abb15c$var$noopThunk,
    predicate: $07ab32a677abb15c$var$noopThunk,
    range: $07ab32a677abb15c$var$noopThunk,
    ref: $07ab32a677abb15c$var$noopThunk,
    requiredBy: $07ab32a677abb15c$var$noopThunk,
    restrictedProp: $07ab32a677abb15c$var$noopThunk,
    sequenceOf: $07ab32a677abb15c$var$noopThunk,
    shape: $07ab32a677abb15c$var$noopThunk,
    stringEndsWith: $07ab32a677abb15c$var$noopThunk,
    stringStartsWith: $07ab32a677abb15c$var$noopThunk,
    uniqueArray: $07ab32a677abb15c$var$noopThunk,
    uniqueArrayOf: $07ab32a677abb15c$var$noopThunk,
    valuesOf: $07ab32a677abb15c$var$noopThunk,
    withShape: $07ab32a677abb15c$var$noopThunk
};

});


parcelRequire.register("kFlOJ", function(module, exports) {

$parcel$export(module.exports, "addEventListener", function () { return $f0b88f74faf0837e$export$3f65cefe8380dbea; });
var $f0b88f74faf0837e$var$CAN_USE_DOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
// Adapted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37
function $f0b88f74faf0837e$var$testPassiveEventListeners() {
    if (!$f0b88f74faf0837e$var$CAN_USE_DOM) return false;
    if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) return false;
    var supportsPassiveOption = false;
    try {
        var opts = Object.defineProperty({}, "passive", {
            // eslint-disable-next-line getter-return
            get: function() {
                function get() {
                    supportsPassiveOption = true;
                }
                return get;
            }()
        });
        var noop = function noop() {};
        window.addEventListener("testPassiveEventSupport", noop, opts);
        window.removeEventListener("testPassiveEventSupport", noop, opts);
    } catch (e) {
    // do nothing
    }
    return supportsPassiveOption;
}
var $f0b88f74faf0837e$var$memoized = void 0;
function $f0b88f74faf0837e$var$canUsePassiveEventListeners() {
    if ($f0b88f74faf0837e$var$memoized === undefined) $f0b88f74faf0837e$var$memoized = $f0b88f74faf0837e$var$testPassiveEventListeners();
    return $f0b88f74faf0837e$var$memoized;
}
function $f0b88f74faf0837e$var$normalizeEventOptions(eventOptions) {
    if (!eventOptions) return undefined;
    if (!$f0b88f74faf0837e$var$canUsePassiveEventListeners()) // If the browser does not support the passive option, then it is expecting
    // a boolean for the options argument to specify whether it should use
    // capture or not. In more modern browsers, this is passed via the `capture`
    // option, so let's just hoist that value up.
    return !!eventOptions.capture;
    return eventOptions;
}
/* eslint-disable no-bitwise */ /**
 * Generate a unique key for any set of event options
 */ function $f0b88f74faf0837e$var$eventOptionsKey(normalizedEventOptions) {
    if (!normalizedEventOptions) return 0;
    // If the browser does not support passive event listeners, the normalized
    // event options will be a boolean.
    if (normalizedEventOptions === true) return 100;
    // At this point, the browser supports passive event listeners, so we expect
    // the event options to be an object with possible properties of capture,
    // passive, and once.
    //
    // We want to consistently return the same value, regardless of the order of
    // these properties, so let's use binary maths to assign each property to a
    // bit, and then add those together (with an offset to account for the
    // booleans at the beginning of this function).
    var capture = normalizedEventOptions.capture << 0;
    var passive = normalizedEventOptions.passive << 1;
    var once = normalizedEventOptions.once << 2;
    return capture + passive + once;
}
function $f0b88f74faf0837e$var$ensureCanMutateNextEventHandlers(eventHandlers) {
    if (eventHandlers.handlers === eventHandlers.nextHandlers) // eslint-disable-next-line no-param-reassign
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
}
function $f0b88f74faf0837e$var$TargetEventHandlers(target) {
    this.target = target;
    this.events = {};
}
$f0b88f74faf0837e$var$TargetEventHandlers.prototype.getEventHandlers = function() {
    function getEventHandlers(eventName, options) {
        var key = String(eventName) + " " + String($f0b88f74faf0837e$var$eventOptionsKey(options));
        if (!this.events[key]) {
            this.events[key] = {
                handlers: [],
                handleEvent: undefined
            };
            this.events[key].nextHandlers = this.events[key].handlers;
        }
        return this.events[key];
    }
    return getEventHandlers;
}();
$f0b88f74faf0837e$var$TargetEventHandlers.prototype.handleEvent = function() {
    function handleEvent(eventName, options, event) {
        var eventHandlers = this.getEventHandlers(eventName, options);
        eventHandlers.handlers = eventHandlers.nextHandlers;
        eventHandlers.handlers.forEach(function(handler) {
            if (handler) // We need to check for presence here because a handler function may
            // cause later handlers to get removed. This can happen if you for
            // instance have a waypoint that unmounts another waypoint as part of an
            // onEnter/onLeave handler.
            handler(event);
        });
    }
    return handleEvent;
}();
$f0b88f74faf0837e$var$TargetEventHandlers.prototype.add = function() {
    function add(eventName, listener, options) {
        var _this = this;
        // options has already been normalized at this point.
        var eventHandlers = this.getEventHandlers(eventName, options);
        $f0b88f74faf0837e$var$ensureCanMutateNextEventHandlers(eventHandlers);
        if (eventHandlers.nextHandlers.length === 0) {
            eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
            this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
        }
        eventHandlers.nextHandlers.push(listener);
        var isSubscribed = true;
        var unsubscribe = function() {
            function unsubscribe() {
                if (!isSubscribed) return;
                isSubscribed = false;
                $f0b88f74faf0837e$var$ensureCanMutateNextEventHandlers(eventHandlers);
                var index = eventHandlers.nextHandlers.indexOf(listener);
                eventHandlers.nextHandlers.splice(index, 1);
                if (eventHandlers.nextHandlers.length === 0) {
                    // All event handlers have been removed, so we want to remove the event
                    // listener from the target node.
                    if (_this.target) // There can be a race condition where the target may no longer exist
                    // when this function is called, e.g. when a React component is
                    // unmounting. Guarding against this prevents the following error:
                    //
                    //   Cannot read property 'removeEventListener' of undefined
                    _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
                    eventHandlers.handleEvent = undefined;
                }
            }
            return unsubscribe;
        }();
        return unsubscribe;
    }
    return add;
}();
var $f0b88f74faf0837e$var$EVENT_HANDLERS_KEY = "__consolidated_events_handlers__";
// eslint-disable-next-line import/prefer-default-export
function $f0b88f74faf0837e$export$3f65cefe8380dbea(target, eventName, listener, options) {
    if (!target[$f0b88f74faf0837e$var$EVENT_HANDLERS_KEY]) // eslint-disable-next-line no-param-reassign
    target[$f0b88f74faf0837e$var$EVENT_HANDLERS_KEY] = new $f0b88f74faf0837e$var$TargetEventHandlers(target);
    var normalizedEventOptions = $f0b88f74faf0837e$var$normalizeEventOptions(options);
    return target[$f0b88f74faf0837e$var$EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}

});

parcelRequire.register("8OiB8", function(module, exports) {
"use strict";

var $g6Lkv = parcelRequire("g6Lkv");

var $4bBQu = parcelRequire("4bBQu");

var $j2dnE = parcelRequire("j2dnE");

var $8E8gp = parcelRequire("8E8gp");

var $gf4pF = parcelRequire("gf4pF");
var $66a16b637ff76066$var$polyfill = $4bBQu($8E8gp(), Object);
$g6Lkv($66a16b637ff76066$var$polyfill, {
    getPolyfill: $8E8gp,
    implementation: $j2dnE,
    shim: $gf4pF
});
module.exports = $66a16b637ff76066$var$polyfill;

});
parcelRequire.register("g6Lkv", function(module, exports) {
"use strict";

var $h8j4e = parcelRequire("h8j4e");
var $bba1eb99e9d8db09$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $bba1eb99e9d8db09$var$toStr = Object.prototype.toString;
var $bba1eb99e9d8db09$var$concat = Array.prototype.concat;
var $bba1eb99e9d8db09$var$origDefineProperty = Object.defineProperty;
var $bba1eb99e9d8db09$var$isFunction = function(fn) {
    return typeof fn === "function" && $bba1eb99e9d8db09$var$toStr.call(fn) === "[object Function]";
};

var $bba1eb99e9d8db09$var$hasPropertyDescriptors = (parcelRequire("jvnto"))();
var $bba1eb99e9d8db09$var$supportsDescriptors = $bba1eb99e9d8db09$var$origDefineProperty && $bba1eb99e9d8db09$var$hasPropertyDescriptors;
var $bba1eb99e9d8db09$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$bba1eb99e9d8db09$var$isFunction(predicate) || !predicate()) return;
    }
    if ($bba1eb99e9d8db09$var$supportsDescriptors) $bba1eb99e9d8db09$var$origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
    });
    else object[name] = value; // eslint-disable-line no-param-reassign
};
var $bba1eb99e9d8db09$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $h8j4e(map);
    if ($bba1eb99e9d8db09$var$hasSymbols) props = $bba1eb99e9d8db09$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$bba1eb99e9d8db09$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$bba1eb99e9d8db09$var$defineProperties.supportsDescriptors = !!$bba1eb99e9d8db09$var$supportsDescriptors;
module.exports = $bba1eb99e9d8db09$var$defineProperties;

});
parcelRequire.register("h8j4e", function(module, exports) {
"use strict";
var $c791f9679a992e5c$var$slice = Array.prototype.slice;

var $2Z5w1 = parcelRequire("2Z5w1");
var $c791f9679a992e5c$var$origKeys = Object.keys;

var $c791f9679a992e5c$var$keysShim = $c791f9679a992e5c$var$origKeys ? function keys(o) {
    return $c791f9679a992e5c$var$origKeys(o);
} : (parcelRequire("3zxP0"));
var $c791f9679a992e5c$var$originalKeys = Object.keys;
$c791f9679a992e5c$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($2Z5w1(object)) return $c791f9679a992e5c$var$originalKeys($c791f9679a992e5c$var$slice.call(object));
            return $c791f9679a992e5c$var$originalKeys(object);
        };
    } else Object.keys = $c791f9679a992e5c$var$keysShim;
    return Object.keys || $c791f9679a992e5c$var$keysShim;
};
module.exports = $c791f9679a992e5c$var$keysShim;

});
parcelRequire.register("2Z5w1", function(module, exports) {
"use strict";
var $22c58e8ec6c9864c$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $22c58e8ec6c9864c$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $22c58e8ec6c9864c$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRequire.register("3zxP0", function(module, exports) {
"use strict";
var $299ee041f06a3f7f$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $299ee041f06a3f7f$var$has = Object.prototype.hasOwnProperty;
    var $299ee041f06a3f7f$var$toStr = Object.prototype.toString;
    var $299ee041f06a3f7f$var$isArgs = (parcelRequire("2Z5w1")); // eslint-disable-line global-require
    var $299ee041f06a3f7f$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $299ee041f06a3f7f$var$hasDontEnumBug = !$299ee041f06a3f7f$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $299ee041f06a3f7f$var$hasProtoEnumBug = $299ee041f06a3f7f$var$isEnumerable.call(function() {}, "prototype");
    var $299ee041f06a3f7f$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $299ee041f06a3f7f$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $299ee041f06a3f7f$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $299ee041f06a3f7f$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$299ee041f06a3f7f$var$excludedKeys["$" + k] && $299ee041f06a3f7f$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $299ee041f06a3f7f$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $299ee041f06a3f7f$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$299ee041f06a3f7f$var$hasAutomationEqualityBug) return $299ee041f06a3f7f$var$equalsConstructorPrototype(o);
        try {
            return $299ee041f06a3f7f$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $299ee041f06a3f7f$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $299ee041f06a3f7f$var$toStr.call(object) === "[object Function]";
        var isArguments = $299ee041f06a3f7f$var$isArgs(object);
        var isString = isObject && $299ee041f06a3f7f$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $299ee041f06a3f7f$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$299ee041f06a3f7f$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $299ee041f06a3f7f$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($299ee041f06a3f7f$var$hasDontEnumBug) {
            var skipConstructor = $299ee041f06a3f7f$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $299ee041f06a3f7f$var$dontEnums.length; ++k)if (!(skipConstructor && $299ee041f06a3f7f$var$dontEnums[k] === "constructor") && $299ee041f06a3f7f$var$has.call(object, $299ee041f06a3f7f$var$dontEnums[k])) theKeys.push($299ee041f06a3f7f$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $299ee041f06a3f7f$var$keysShim;

});


parcelRequire.register("jvnto", function(module, exports) {
"use strict";

var $kQEeW = parcelRequire("kQEeW");
var $e3331ed231f0d5e2$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$kQEeW;
};
$e3331ed231f0d5e2$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$kQEeW) return null;
    try {
        return $kQEeW([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $e3331ed231f0d5e2$var$hasPropertyDescriptors;

});
parcelRequire.register("kQEeW", function(module, exports) {
"use strict";

var $5KFGy = parcelRequire("5KFGy");
/** @type {import('.')} */ var $f2d7e0d267cd2189$var$$defineProperty = $5KFGy("%Object.defineProperty%", true) || false;
if ($f2d7e0d267cd2189$var$$defineProperty) try {
    $f2d7e0d267cd2189$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $f2d7e0d267cd2189$var$$defineProperty = false;
}
module.exports = $f2d7e0d267cd2189$var$$defineProperty;

});
parcelRequire.register("5KFGy", function(module, exports) {
"use strict";
var $43019574e681d1e0$var$undefined;

var $gCRQ9 = parcelRequire("gCRQ9");

var $1DRb2 = parcelRequire("1DRb2");

var $1WBBC = parcelRequire("1WBBC");

var $9k8y8 = parcelRequire("9k8y8");

var $9RMU6 = parcelRequire("9RMU6");

var $hehTj = parcelRequire("hehTj");

var $8qxmR = parcelRequire("8qxmR");
var $43019574e681d1e0$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $43019574e681d1e0$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $43019574e681d1e0$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $43019574e681d1e0$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($43019574e681d1e0$var$$gOPD) try {
    $43019574e681d1e0$var$$gOPD({}, "");
} catch (e) {
    $43019574e681d1e0$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $43019574e681d1e0$var$throwTypeError = function() {
    throw new $hehTj();
};
var $43019574e681d1e0$var$ThrowTypeError = $43019574e681d1e0$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $43019574e681d1e0$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $43019574e681d1e0$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $43019574e681d1e0$var$throwTypeError;
        }
    }
}() : $43019574e681d1e0$var$throwTypeError;

var $43019574e681d1e0$var$hasSymbols = (parcelRequire("5r0Q9"))();

var $43019574e681d1e0$var$hasProto = (parcelRequire("bLAfM"))();
var $43019574e681d1e0$var$getProto = Object.getPrototypeOf || ($43019574e681d1e0$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $43019574e681d1e0$var$needsEval = {};
var $43019574e681d1e0$var$TypedArray = typeof Uint8Array === "undefined" || !$43019574e681d1e0$var$getProto ? $43019574e681d1e0$var$undefined : $43019574e681d1e0$var$getProto(Uint8Array);
var $43019574e681d1e0$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? $43019574e681d1e0$var$undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? $43019574e681d1e0$var$undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $43019574e681d1e0$var$hasSymbols && $43019574e681d1e0$var$getProto ? $43019574e681d1e0$var$getProto([][Symbol.iterator]()) : $43019574e681d1e0$var$undefined,
    "%AsyncFromSyncIteratorPrototype%": $43019574e681d1e0$var$undefined,
    "%AsyncFunction%": $43019574e681d1e0$var$needsEval,
    "%AsyncGenerator%": $43019574e681d1e0$var$needsEval,
    "%AsyncGeneratorFunction%": $43019574e681d1e0$var$needsEval,
    "%AsyncIteratorPrototype%": $43019574e681d1e0$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? $43019574e681d1e0$var$undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? $43019574e681d1e0$var$undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? $43019574e681d1e0$var$undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? $43019574e681d1e0$var$undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? $43019574e681d1e0$var$undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $gCRQ9,
    "%eval%": eval,
    "%EvalError%": $1DRb2,
    "%Float32Array%": typeof Float32Array === "undefined" ? $43019574e681d1e0$var$undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? $43019574e681d1e0$var$undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? $43019574e681d1e0$var$undefined : FinalizationRegistry,
    "%Function%": $43019574e681d1e0$var$$Function,
    "%GeneratorFunction%": $43019574e681d1e0$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? $43019574e681d1e0$var$undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? $43019574e681d1e0$var$undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? $43019574e681d1e0$var$undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $43019574e681d1e0$var$hasSymbols && $43019574e681d1e0$var$getProto ? $43019574e681d1e0$var$getProto($43019574e681d1e0$var$getProto([][Symbol.iterator]())) : $43019574e681d1e0$var$undefined,
    "%JSON%": typeof JSON === "object" ? JSON : $43019574e681d1e0$var$undefined,
    "%Map%": typeof Map === "undefined" ? $43019574e681d1e0$var$undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$43019574e681d1e0$var$hasSymbols || !$43019574e681d1e0$var$getProto ? $43019574e681d1e0$var$undefined : $43019574e681d1e0$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? $43019574e681d1e0$var$undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? $43019574e681d1e0$var$undefined : Proxy,
    "%RangeError%": $1WBBC,
    "%ReferenceError%": $9k8y8,
    "%Reflect%": typeof Reflect === "undefined" ? $43019574e681d1e0$var$undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? $43019574e681d1e0$var$undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$43019574e681d1e0$var$hasSymbols || !$43019574e681d1e0$var$getProto ? $43019574e681d1e0$var$undefined : $43019574e681d1e0$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? $43019574e681d1e0$var$undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $43019574e681d1e0$var$hasSymbols && $43019574e681d1e0$var$getProto ? $43019574e681d1e0$var$getProto(""[Symbol.iterator]()) : $43019574e681d1e0$var$undefined,
    "%Symbol%": $43019574e681d1e0$var$hasSymbols ? Symbol : $43019574e681d1e0$var$undefined,
    "%SyntaxError%": $9RMU6,
    "%ThrowTypeError%": $43019574e681d1e0$var$ThrowTypeError,
    "%TypedArray%": $43019574e681d1e0$var$TypedArray,
    "%TypeError%": $hehTj,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? $43019574e681d1e0$var$undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? $43019574e681d1e0$var$undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? $43019574e681d1e0$var$undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? $43019574e681d1e0$var$undefined : Uint32Array,
    "%URIError%": $8qxmR,
    "%WeakMap%": typeof WeakMap === "undefined" ? $43019574e681d1e0$var$undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? $43019574e681d1e0$var$undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? $43019574e681d1e0$var$undefined : WeakSet
};
if ($43019574e681d1e0$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $43019574e681d1e0$var$errorProto = $43019574e681d1e0$var$getProto($43019574e681d1e0$var$getProto(e));
    $43019574e681d1e0$var$INTRINSICS["%Error.prototype%"] = $43019574e681d1e0$var$errorProto;
}
var $43019574e681d1e0$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $43019574e681d1e0$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $43019574e681d1e0$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $43019574e681d1e0$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $43019574e681d1e0$var$getProto) value = $43019574e681d1e0$var$getProto(gen.prototype);
    }
    $43019574e681d1e0$var$INTRINSICS[name] = value;
    return value;
};
var $43019574e681d1e0$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $1F3qt = parcelRequire("1F3qt");

var $2rT67 = parcelRequire("2rT67");
var $43019574e681d1e0$var$$concat = $1F3qt.call(Function.call, Array.prototype.concat);
var $43019574e681d1e0$var$$spliceApply = $1F3qt.call(Function.apply, Array.prototype.splice);
var $43019574e681d1e0$var$$replace = $1F3qt.call(Function.call, String.prototype.replace);
var $43019574e681d1e0$var$$strSlice = $1F3qt.call(Function.call, String.prototype.slice);
var $43019574e681d1e0$var$$exec = $1F3qt.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $43019574e681d1e0$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $43019574e681d1e0$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $43019574e681d1e0$var$stringToPath = function stringToPath(string) {
    var first = $43019574e681d1e0$var$$strSlice(string, 0, 1);
    var last = $43019574e681d1e0$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $9RMU6("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $9RMU6("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $43019574e681d1e0$var$$replace(string, $43019574e681d1e0$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $43019574e681d1e0$var$$replace(subString, $43019574e681d1e0$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $43019574e681d1e0$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($2rT67($43019574e681d1e0$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $43019574e681d1e0$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($2rT67($43019574e681d1e0$var$INTRINSICS, intrinsicName)) {
        var value = $43019574e681d1e0$var$INTRINSICS[intrinsicName];
        if (value === $43019574e681d1e0$var$needsEval) value = $43019574e681d1e0$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $hehTj("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $9RMU6("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $hehTj("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $hehTj('"allowMissing" argument must be a boolean');
    if ($43019574e681d1e0$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $9RMU6("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $43019574e681d1e0$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $43019574e681d1e0$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $43019574e681d1e0$var$$spliceApply(parts, $43019574e681d1e0$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $43019574e681d1e0$var$$strSlice(part, 0, 1);
        var last = $43019574e681d1e0$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $9RMU6("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($2rT67($43019574e681d1e0$var$INTRINSICS, intrinsicRealName)) value = $43019574e681d1e0$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $hehTj("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($43019574e681d1e0$var$$gOPD && i + 1 >= parts.length) {
                var desc = $43019574e681d1e0$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $2rT67(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $43019574e681d1e0$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRequire.register("gCRQ9", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRequire.register("1DRb2", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRequire.register("1WBBC", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRequire.register("9k8y8", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRequire.register("9RMU6", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRequire.register("hehTj", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRequire.register("8qxmR", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRequire.register("5r0Q9", function(module, exports) {
"use strict";
var $3f50203680890d74$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $c2gQh = parcelRequire("c2gQh");
module.exports = function hasNativeSymbols() {
    if (typeof $3f50203680890d74$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $3f50203680890d74$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $c2gQh();
};

});
parcelRequire.register("c2gQh", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRequire.register("bLAfM", function(module, exports) {
"use strict";
var $891034b66877f2be$var$test = {
    foo: {}
};
var $891034b66877f2be$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $891034b66877f2be$var$test
    }).foo === $891034b66877f2be$var$test.foo && !(({
        __proto__: null
    }) instanceof $891034b66877f2be$var$$Object);
};

});

parcelRequire.register("1F3qt", function(module, exports) {
"use strict";

var $eovtQ = parcelRequire("eovtQ");
module.exports = Function.prototype.bind || $eovtQ;

});
parcelRequire.register("eovtQ", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $a7abb9ee5a94438d$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $a7abb9ee5a94438d$var$toStr = Object.prototype.toString;
var $a7abb9ee5a94438d$var$max = Math.max;
var $a7abb9ee5a94438d$var$funcType = "[object Function]";
var $a7abb9ee5a94438d$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $a7abb9ee5a94438d$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $a7abb9ee5a94438d$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $a7abb9ee5a94438d$var$toStr.apply(target) !== $a7abb9ee5a94438d$var$funcType) throw new TypeError($a7abb9ee5a94438d$var$ERROR_MESSAGE + target);
    var args = $a7abb9ee5a94438d$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $a7abb9ee5a94438d$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $a7abb9ee5a94438d$var$concatty(args, arguments));
    };
    var boundLength = $a7abb9ee5a94438d$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $a7abb9ee5a94438d$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRequire.register("2rT67", function(module, exports) {
"use strict";
var $1c88d79eb17b7c4d$var$call = Function.prototype.call;
var $1c88d79eb17b7c4d$var$$hasOwn = Object.prototype.hasOwnProperty;

var $1F3qt = parcelRequire("1F3qt");
/** @type {import('.')} */ module.exports = $1F3qt.call($1c88d79eb17b7c4d$var$call, $1c88d79eb17b7c4d$var$$hasOwn);

});





parcelRequire.register("4bBQu", function(module, exports) {
"use strict";

var $1F3qt = parcelRequire("1F3qt");

var $5KFGy = parcelRequire("5KFGy");

var $81RT3 = parcelRequire("81RT3");

var $hehTj = parcelRequire("hehTj");
var $30c58bd5d30def94$var$$apply = $5KFGy("%Function.prototype.apply%");
var $30c58bd5d30def94$var$$call = $5KFGy("%Function.prototype.call%");
var $30c58bd5d30def94$var$$reflectApply = $5KFGy("%Reflect.apply%", true) || $1F3qt.call($30c58bd5d30def94$var$$call, $30c58bd5d30def94$var$$apply);

var $kQEeW = parcelRequire("kQEeW");
var $30c58bd5d30def94$var$$max = $5KFGy("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $hehTj("a function is required");
    var func = $30c58bd5d30def94$var$$reflectApply($1F3qt, $30c58bd5d30def94$var$$call, arguments);
    return $81RT3(func, 1 + $30c58bd5d30def94$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $30c58bd5d30def94$var$applyBind = function applyBind() {
    return $30c58bd5d30def94$var$$reflectApply($1F3qt, $30c58bd5d30def94$var$$apply, arguments);
};
if ($kQEeW) $kQEeW(module.exports, "apply", {
    value: $30c58bd5d30def94$var$applyBind
});
else module.exports.apply = $30c58bd5d30def94$var$applyBind;

});
parcelRequire.register("81RT3", function(module, exports) {
"use strict";

var $5KFGy = parcelRequire("5KFGy");

var $jTQbZ = parcelRequire("jTQbZ");

var $5d88378bbb9506d2$var$hasDescriptors = (parcelRequire("jvnto"))();

var $lre78 = parcelRequire("lre78");

var $hehTj = parcelRequire("hehTj");
var $5d88378bbb9506d2$var$$floor = $5KFGy("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $hehTj("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $5d88378bbb9506d2$var$$floor(length) !== length) throw new $hehTj("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $lre78) {
        var desc = $lre78(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($5d88378bbb9506d2$var$hasDescriptors) $jTQbZ(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $jTQbZ(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRequire.register("jTQbZ", function(module, exports) {
"use strict";

var $kQEeW = parcelRequire("kQEeW");

var $9RMU6 = parcelRequire("9RMU6");

var $hehTj = parcelRequire("hehTj");

var $lre78 = parcelRequire("lre78");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $hehTj("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $hehTj("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $hehTj("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $hehTj("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $hehTj("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $hehTj("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$lre78 && $lre78(obj, property);
    if ($kQEeW) $kQEeW(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $9RMU6("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRequire.register("lre78", function(module, exports) {
"use strict";

var $5KFGy = parcelRequire("5KFGy");
var $f9b71159b329fd73$var$$gOPD = $5KFGy("%Object.getOwnPropertyDescriptor%", true);
if ($f9b71159b329fd73$var$$gOPD) try {
    $f9b71159b329fd73$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $f9b71159b329fd73$var$$gOPD = null;
}
module.exports = $f9b71159b329fd73$var$$gOPD;

});




parcelRequire.register("j2dnE", function(module, exports) {
"use strict";

var $6u9Xu = parcelRequire("6u9Xu");

var $a990d = parcelRequire("a990d");
var $ddb8954a3936d18a$var$$isEnumerable = $a990d("Object.prototype.propertyIsEnumerable");
var $ddb8954a3936d18a$var$$push = $a990d("Array.prototype.push");
module.exports = function values(O) {
    var obj = $6u9Xu(O);
    var vals = [];
    for(var key in obj)if ($ddb8954a3936d18a$var$$isEnumerable(obj, key)) $ddb8954a3936d18a$var$$push(vals, obj[key]);
    return vals;
};

});
parcelRequire.register("6u9Xu", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3dRd5"));

});
parcelRequire.register("3dRd5", function(module, exports) {
"use strict";

var $5KFGy = parcelRequire("5KFGy");
var $258bdc6d8e98b035$var$$TypeError = $5KFGy("%TypeError%");
// http://262.ecma-international.org/5.1/#sec-9.10
module.exports = function CheckObjectCoercible(value, optMessage) {
    if (value == null) throw new $258bdc6d8e98b035$var$$TypeError(optMessage || "Cannot call method on " + value);
    return value;
};

});


parcelRequire.register("a990d", function(module, exports) {
"use strict";

var $5KFGy = parcelRequire("5KFGy");

var $4bBQu = parcelRequire("4bBQu");
var $7631ba58148dda97$var$$indexOf = $4bBQu($5KFGy("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $5KFGy(name, !!allowMissing);
    if (typeof intrinsic === "function" && $7631ba58148dda97$var$$indexOf(name, ".prototype.") > -1) return $4bBQu(intrinsic);
    return intrinsic;
};

});


parcelRequire.register("8E8gp", function(module, exports) {
"use strict";

var $j2dnE = parcelRequire("j2dnE");
module.exports = function getPolyfill() {
    return typeof Object.values === "function" ? Object.values : $j2dnE;
};

});

parcelRequire.register("gf4pF", function(module, exports) {
"use strict";

var $8E8gp = parcelRequire("8E8gp");

var $g6Lkv = parcelRequire("g6Lkv");
module.exports = function shimValues() {
    var polyfill = $8E8gp();
    $g6Lkv(Object, {
        values: polyfill
    }, {
        values: function testValues() {
            return Object.values !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRequire.register("eI2iN", function(module, exports) {
"use strict";

var $g6Lkv = parcelRequire("g6Lkv");

var $9Sl9b = parcelRequire("9Sl9b");

var $etB97 = parcelRequire("etB97");
var $ab56f5e5539535fa$var$polyfill = $etB97();

var $eMWyY = parcelRequire("eMWyY");
var $ab56f5e5539535fa$var$boundContains = function contains(node, other) {
    return $ab56f5e5539535fa$var$polyfill.apply(node, [
        other
    ]);
};
$g6Lkv($ab56f5e5539535fa$var$boundContains, {
    getPolyfill: $etB97,
    implementation: $9Sl9b,
    shim: $eMWyY
});
module.exports = $ab56f5e5539535fa$var$boundContains;

});
parcelRequire.register("9Sl9b", function(module, exports) {
"use strict";
module.exports = function contains(other) {
    if (arguments.length < 1) throw new TypeError("1 argument is required");
    if (typeof other !== "object") throw new TypeError("Argument 1 (”other“) to Node.contains must be an instance of Node");
    var node = other;
    do {
        if (this === node) return true;
        if (node) node = node.parentNode;
    }while (node);
    return false;
};

});

parcelRequire.register("etB97", function(module, exports) {
"use strict";

var $9Sl9b = parcelRequire("9Sl9b");
module.exports = function getPolyfill() {
    if (typeof document !== "undefined") {
        if (document.contains) return document.contains;
        if (document.body && document.body.contains) try {
            if (typeof document.body.contains.call(document, "") === "boolean") return document.body.contains;
        } catch (e) {}
    }
    return $9Sl9b;
};

});

parcelRequire.register("eMWyY", function(module, exports) {
"use strict";

var $g6Lkv = parcelRequire("g6Lkv");

var $etB97 = parcelRequire("etB97");
module.exports = function shimContains() {
    var polyfill = $etB97();
    if (typeof document !== "undefined") {
        $g6Lkv(document, {
            contains: polyfill
        }, {
            contains: function() {
                return document.contains !== polyfill;
            }
        });
        if (typeof Element !== "undefined") $g6Lkv(Element.prototype, {
            contains: polyfill
        }, {
            contains: function() {
                return Element.prototype.contains !== polyfill;
            }
        });
    }
    return polyfill;
};

});



parcelRequire.register("1kJnE", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1SOLG.default;
    }
});

var $1SOLG = parcelRequire("1SOLG");

});
parcelRequire.register("1SOLG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15f23718f6f4fabb$export$2e2bcd8739ae039; });

var $dpDEA = parcelRequire("dpDEA");

var $6cds3 = parcelRequire("6cds3");

var $1NeGV = parcelRequire("1NeGV");

var $lBpE3 = parcelRequire("lBpE3");
"use client";
function $15f23718f6f4fabb$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $1NeGV.default), (0, $dpDEA.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $1NeGV.default).muiName;
    return /*#__PURE__*/ $6cds3.memo(/*#__PURE__*/ $6cds3.forwardRef(Component));
}

});
parcelRequire.register("dpDEA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c3c5e85872c2b24$export$2e2bcd8739ae039; });
function $9c3c5e85872c2b24$export$2e2bcd8739ae039() {
    $9c3c5e85872c2b24$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9c3c5e85872c2b24$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRequire.register("1NeGV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14e5c3770f188e53$export$2e2bcd8739ae039; });

var $dpDEA = parcelRequire("dpDEA");

var $8pKQA = parcelRequire("8pKQA");

var $6cds3 = parcelRequire("6cds3");


var $aPjpj = parcelRequire("aPjpj");

var $619SG = parcelRequire("619SG");

var $4DxKp = parcelRequire("4DxKp");

var $9ScrR = parcelRequire("9ScrR");

var $iHVyY = parcelRequire("iHVyY");

var $jYYr0 = parcelRequire("jYYr0");

var $lBpE3 = parcelRequire("lBpE3");
"use client";
const $14e5c3770f188e53$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $14e5c3770f188e53$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $4DxKp.default)(color)}`,
            `fontSize${(0, $4DxKp.default)(fontSize)}`
        ]
    };
    return (0, $619SG.default)(slots, (0, $jYYr0.getSvgIconUtilityClass), classes);
};
const $14e5c3770f188e53$var$SvgIconRoot = (0, $iHVyY.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $4DxKp.default)(ownerState.color)}`],
            styles[`fontSize${(0, $4DxKp.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // e.g. heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $14e5c3770f188e53$var$SvgIcon = /*#__PURE__*/ $6cds3.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $9ScrR.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $8pKQA.default)(props, $14e5c3770f188e53$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $6cds3.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $dpDEA.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $14e5c3770f188e53$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)($14e5c3770f188e53$var$SvgIconRoot, (0, $dpDEA.default)({
        as: component,
        className: (0, $aPjpj.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $lBpE3.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$14e5c3770f188e53$var$SvgIcon.muiName = "SvgIcon";
var $14e5c3770f188e53$export$2e2bcd8739ae039 = $14e5c3770f188e53$var$SvgIcon;

});
parcelRequire.register("8pKQA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6204ff68428e4ae4$export$2e2bcd8739ae039; });
function $6204ff68428e4ae4$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRequire.register("aPjpj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ea79c0838f0a9da$export$2e2bcd8739ae039; });
function $7ea79c0838f0a9da$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $7ea79c0838f0a9da$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $7ea79c0838f0a9da$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $7ea79c0838f0a9da$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $7ea79c0838f0a9da$export$2e2bcd8739ae039 = $7ea79c0838f0a9da$export$4f5d2d50c9deca37;

});

parcelRequire.register("619SG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $461a803bd46561b7$export$2e2bcd8739ae039; });
function $461a803bd46561b7$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRequire.register("4DxKp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3604fb853e5a48cd$export$2e2bcd8739ae039; });

var $bbWkh = parcelRequire("bbWkh");
var $3604fb853e5a48cd$export$2e2bcd8739ae039 = (0, $bbWkh.default);

});
parcelRequire.register("bbWkh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $825df721f523b55d$export$2e2bcd8739ae039; });

var $lxstl = parcelRequire("lxstl");
function $825df721f523b55d$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $lxstl.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRequire.register("lxstl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fae2c40864b8c9eb$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $fae2c40864b8c9eb$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRequire.register("9ScrR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7302d0339b9670a0$export$2e2bcd8739ae039; });

var $cNRu9 = parcelRequire("cNRu9");

var $2aEPG = parcelRequire("2aEPG");

var $hDE6h = parcelRequire("hDE6h");
"use client";
function $7302d0339b9670a0$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $cNRu9.default)({
        props: props,
        name: name,
        defaultTheme: $2aEPG.default,
        themeId: (0, $hDE6h.default)
    });
}

});
parcelRequire.register("cNRu9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95238cb067c62592$export$2e2bcd8739ae039; });

var $kqlIg = parcelRequire("kqlIg");

var $jdf6F = parcelRequire("jdf6F");
"use client";
function $95238cb067c62592$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $jdf6F.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $kqlIg.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRequire.register("kqlIg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ede71411f874c3b1$export$2e2bcd8739ae039; });

var $bv7nU = parcelRequire("bv7nU");
function $ede71411f874c3b1$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $bv7nU.default)(theme.components[name].defaultProps, props);
}

});
parcelRequire.register("bv7nU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85f8515fb7e1951c$export$2e2bcd8739ae039; });

var $dpDEA = parcelRequire("dpDEA");
function $85f8515fb7e1951c$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $dpDEA.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $dpDEA.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $dpDEA.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $85f8515fb7e1951c$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRequire.register("jdf6F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfcaf31346542161$export$2e2bcd8739ae039; });

var $eYXiN = parcelRequire("eYXiN");

var $8EeDz = parcelRequire("8EeDz");
"use client";
const $dfcaf31346542161$export$35e57303dbd8a66 = (0, $eYXiN.default)();
function $dfcaf31346542161$var$useTheme(defaultTheme = $dfcaf31346542161$export$35e57303dbd8a66) {
    return (0, $8EeDz.default)(defaultTheme);
}
var $dfcaf31346542161$export$2e2bcd8739ae039 = $dfcaf31346542161$var$useTheme;

});
parcelRequire.register("eYXiN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae84ab759a7278b9$export$2e2bcd8739ae039; });

var $dpDEA = parcelRequire("dpDEA");

var $8pKQA = parcelRequire("8pKQA");

var $K3j0n = parcelRequire("K3j0n");

var $i7STj = parcelRequire("i7STj");

var $3vpQl = parcelRequire("3vpQl");

var $oqSgO = parcelRequire("oqSgO");

var $jNfuS = parcelRequire("jNfuS");

var $iiTTJ = parcelRequire("iiTTJ");
const $ae84ab759a7278b9$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $ae84ab759a7278b9$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $8pKQA.default)(options, $ae84ab759a7278b9$var$_excluded);
    const breakpoints = (0, $i7STj.default)(breakpointsInput);
    const spacing = (0, $oqSgO.default)(spacingInput);
    let muiTheme = (0, $K3j0n.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $dpDEA.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $dpDEA.default)({}, (0, $3vpQl.default), shapeInput)
    }, other);
    muiTheme = args.reduce((acc, argument)=>(0, $K3j0n.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $dpDEA.default)({}, (0, $iiTTJ.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $jNfuS.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $ae84ab759a7278b9$export$2e2bcd8739ae039 = $ae84ab759a7278b9$var$createTheme;

});
parcelRequire.register("K3j0n", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $08a6dc6717755f4f$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $08a6dc6717755f4f$export$2e2bcd8739ae039; });

var $dpDEA = parcelRequire("dpDEA");
function $08a6dc6717755f4f$export$53b83ca8eaab0383(item) {
    return item !== null && typeof item === "object" && item.constructor === Object;
}
function $08a6dc6717755f4f$var$deepClone(source) {
    if (!$08a6dc6717755f4f$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $08a6dc6717755f4f$var$deepClone(source[key]);
    });
    return output;
}
function $08a6dc6717755f4f$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $dpDEA.default)({}, target) : target;
    if ($08a6dc6717755f4f$export$53b83ca8eaab0383(target) && $08a6dc6717755f4f$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($08a6dc6717755f4f$export$53b83ca8eaab0383(source[key]) && key in target && $08a6dc6717755f4f$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $08a6dc6717755f4f$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $08a6dc6717755f4f$export$53b83ca8eaab0383(source[key]) ? $08a6dc6717755f4f$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRequire.register("i7STj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d32375a819d407b5$export$2e2bcd8739ae039; });

var $8pKQA = parcelRequire("8pKQA");

var $dpDEA = parcelRequire("dpDEA");
const $d32375a819d407b5$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $d32375a819d407b5$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $d32375a819d407b5$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $dpDEA.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $d32375a819d407b5$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $8pKQA.default)(breakpoints, $d32375a819d407b5$var$_excluded);
    const sortedValues = $d32375a819d407b5$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $dpDEA.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRequire.register("3vpQl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28d850490fc1bf5f$export$2e2bcd8739ae039; });
const $28d850490fc1bf5f$var$shape = {
    borderRadius: 4
};
var $28d850490fc1bf5f$export$2e2bcd8739ae039 = $28d850490fc1bf5f$var$shape;

});

parcelRequire.register("oqSgO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $049716afee8a1a32$export$2e2bcd8739ae039; });

var $8Dkkv = parcelRequire("8Dkkv");
function $049716afee8a1a32$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $8Dkkv.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRequire.register("8Dkkv", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $6491bc4b604052c0$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $6491bc4b604052c0$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $6491bc4b604052c0$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $6491bc4b604052c0$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $6491bc4b604052c0$export$6f98e8eaf0be1996; });


var $4w6kZ = parcelRequire("4w6kZ");

var $chC98 = parcelRequire("chC98");

var $d6LYs = parcelRequire("d6LYs");

var $MWsmZ = parcelRequire("MWsmZ");
const $6491bc4b604052c0$var$properties = {
    m: "margin",
    p: "padding"
};
const $6491bc4b604052c0$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $6491bc4b604052c0$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $6491bc4b604052c0$var$getCssProperties = (0, $MWsmZ.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($6491bc4b604052c0$var$aliases[prop]) prop = $6491bc4b604052c0$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $6491bc4b604052c0$var$properties[a];
    const direction = $6491bc4b604052c0$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $6491bc4b604052c0$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $6491bc4b604052c0$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $6491bc4b604052c0$var$spacingKeys = [
    ...$6491bc4b604052c0$export$aab52a0dde05ad8a,
    ...$6491bc4b604052c0$export$f8397d44f03ab6ad
];
function $6491bc4b604052c0$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $chC98.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $6491bc4b604052c0$export$1def6f833384e3d1(theme) {
    return $6491bc4b604052c0$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $6491bc4b604052c0$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $6491bc4b604052c0$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $6491bc4b604052c0$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $6491bc4b604052c0$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $6491bc4b604052c0$var$getCssProperties(prop);
    const styleFromPropValue = $6491bc4b604052c0$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $4w6kZ.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $6491bc4b604052c0$var$style(props, keys) {
    const transformer = $6491bc4b604052c0$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$6491bc4b604052c0$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $d6LYs.default), {});
}
function $6491bc4b604052c0$export$7ede87f9b603dd3c(props) {
    return $6491bc4b604052c0$var$style(props, $6491bc4b604052c0$export$aab52a0dde05ad8a);
}
$6491bc4b604052c0$export$7ede87f9b603dd3c.propTypes = {};
$6491bc4b604052c0$export$7ede87f9b603dd3c.filterProps = $6491bc4b604052c0$export$aab52a0dde05ad8a;
function $6491bc4b604052c0$export$6f98e8eaf0be1996(props) {
    return $6491bc4b604052c0$var$style(props, $6491bc4b604052c0$export$f8397d44f03ab6ad);
}
$6491bc4b604052c0$export$6f98e8eaf0be1996.propTypes = {};
$6491bc4b604052c0$export$6f98e8eaf0be1996.filterProps = $6491bc4b604052c0$export$f8397d44f03ab6ad;
function $6491bc4b604052c0$var$spacing(props) {
    return $6491bc4b604052c0$var$style(props, $6491bc4b604052c0$var$spacingKeys);
}
$6491bc4b604052c0$var$spacing.propTypes = {};
$6491bc4b604052c0$var$spacing.filterProps = $6491bc4b604052c0$var$spacingKeys;
var $6491bc4b604052c0$export$2e2bcd8739ae039 = $6491bc4b604052c0$var$spacing;

});
parcelRequire.register("4w6kZ", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $349f1110ccec4f88$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $349f1110ccec4f88$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $349f1110ccec4f88$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $349f1110ccec4f88$export$8922c90b6e020726; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $349f1110ccec4f88$export$980e6a259d807490; });

var $dpDEA = parcelRequire("dpDEA");


var $K3j0n = parcelRequire("K3j0n");

var $d6LYs = parcelRequire("d6LYs");
const $349f1110ccec4f88$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $349f1110ccec4f88$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$349f1110ccec4f88$export$68c286be0e7e55b7[key]}px)`
};
function $349f1110ccec4f88$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $349f1110ccec4f88$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $349f1110ccec4f88$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $349f1110ccec4f88$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $349f1110ccec4f88$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $349f1110ccec4f88$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $dpDEA.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $d6LYs.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $349f1110ccec4f88$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $349f1110ccec4f88$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $349f1110ccec4f88$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $349f1110ccec4f88$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $K3j0n.default)(prev, next), {});
    return $349f1110ccec4f88$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $349f1110ccec4f88$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $349f1110ccec4f88$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $349f1110ccec4f88$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $349f1110ccec4f88$export$2e2bcd8739ae039 = $349f1110ccec4f88$var$breakpoints;

});
parcelRequire.register("d6LYs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98b10c9308be89bc$export$2e2bcd8739ae039; });

var $K3j0n = parcelRequire("K3j0n");
function $98b10c9308be89bc$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $K3j0n.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $98b10c9308be89bc$export$2e2bcd8739ae039 = $98b10c9308be89bc$var$merge;

});


parcelRequire.register("chC98", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $8f14a9a2156beb04$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $8f14a9a2156beb04$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $8f14a9a2156beb04$export$2e2bcd8739ae039; });

var $bbWkh = parcelRequire("bbWkh");


var $4w6kZ = parcelRequire("4w6kZ");
function $8f14a9a2156beb04$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $8f14a9a2156beb04$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $8f14a9a2156beb04$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $8f14a9a2156beb04$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $8f14a9a2156beb04$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $8f14a9a2156beb04$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $8f14a9a2156beb04$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $bbWkh.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $4w6kZ.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $8f14a9a2156beb04$export$2e2bcd8739ae039 = $8f14a9a2156beb04$var$style;

});

parcelRequire.register("MWsmZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0931d4115eaca730$export$2e2bcd8739ae039; });
function $0931d4115eaca730$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRequire.register("jNfuS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e68e9d487416dbd3$export$2e2bcd8739ae039; });

var $bbWkh = parcelRequire("bbWkh");

var $d6LYs = parcelRequire("d6LYs");

var $chC98 = parcelRequire("chC98");

var $4w6kZ = parcelRequire("4w6kZ");

var $iiTTJ = parcelRequire("iiTTJ");
function $e68e9d487416dbd3$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $e68e9d487416dbd3$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $e68e9d487416dbd3$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $chC98.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $chC98.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $chC98.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $bbWkh.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $4w6kZ.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $iiTTJ.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $4w6kZ.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $e68e9d487416dbd3$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $d6LYs.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $4w6kZ.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($e68e9d487416dbd3$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $d6LYs.default)(css, breakpointsValues);
                        }
                    } else css = (0, $d6LYs.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $4w6kZ.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $e68e9d487416dbd3$var$styleFunctionSx = $e68e9d487416dbd3$export$7d53d8bf2911e013();
$e68e9d487416dbd3$var$styleFunctionSx.filterProps = [
    "sx"
];
var $e68e9d487416dbd3$export$2e2bcd8739ae039 = $e68e9d487416dbd3$var$styleFunctionSx;

});
parcelRequire.register("iiTTJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d535449a8de05ea7$export$2e2bcd8739ae039; });

var $8Dkkv = parcelRequire("8Dkkv");

var $hHI0i = parcelRequire("hHI0i");

var $dUz4Z = parcelRequire("dUz4Z");

var $cKMdR = parcelRequire("cKMdR");

var $dkO6h = parcelRequire("dkO6h");
const $d535449a8de05ea7$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $hHI0i.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $hHI0i.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $hHI0i.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $hHI0i.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $hHI0i.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $hHI0i.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $cKMdR.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $cKMdR.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $cKMdR.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $8Dkkv.padding)
    },
    pt: {
        style: (0, $8Dkkv.padding)
    },
    pr: {
        style: (0, $8Dkkv.padding)
    },
    pb: {
        style: (0, $8Dkkv.padding)
    },
    pl: {
        style: (0, $8Dkkv.padding)
    },
    px: {
        style: (0, $8Dkkv.padding)
    },
    py: {
        style: (0, $8Dkkv.padding)
    },
    padding: {
        style: (0, $8Dkkv.padding)
    },
    paddingTop: {
        style: (0, $8Dkkv.padding)
    },
    paddingRight: {
        style: (0, $8Dkkv.padding)
    },
    paddingBottom: {
        style: (0, $8Dkkv.padding)
    },
    paddingLeft: {
        style: (0, $8Dkkv.padding)
    },
    paddingX: {
        style: (0, $8Dkkv.padding)
    },
    paddingY: {
        style: (0, $8Dkkv.padding)
    },
    paddingInline: {
        style: (0, $8Dkkv.padding)
    },
    paddingInlineStart: {
        style: (0, $8Dkkv.padding)
    },
    paddingInlineEnd: {
        style: (0, $8Dkkv.padding)
    },
    paddingBlock: {
        style: (0, $8Dkkv.padding)
    },
    paddingBlockStart: {
        style: (0, $8Dkkv.padding)
    },
    paddingBlockEnd: {
        style: (0, $8Dkkv.padding)
    },
    m: {
        style: (0, $8Dkkv.margin)
    },
    mt: {
        style: (0, $8Dkkv.margin)
    },
    mr: {
        style: (0, $8Dkkv.margin)
    },
    mb: {
        style: (0, $8Dkkv.margin)
    },
    ml: {
        style: (0, $8Dkkv.margin)
    },
    mx: {
        style: (0, $8Dkkv.margin)
    },
    my: {
        style: (0, $8Dkkv.margin)
    },
    margin: {
        style: (0, $8Dkkv.margin)
    },
    marginTop: {
        style: (0, $8Dkkv.margin)
    },
    marginRight: {
        style: (0, $8Dkkv.margin)
    },
    marginBottom: {
        style: (0, $8Dkkv.margin)
    },
    marginLeft: {
        style: (0, $8Dkkv.margin)
    },
    marginX: {
        style: (0, $8Dkkv.margin)
    },
    marginY: {
        style: (0, $8Dkkv.margin)
    },
    marginInline: {
        style: (0, $8Dkkv.margin)
    },
    marginInlineStart: {
        style: (0, $8Dkkv.margin)
    },
    marginInlineEnd: {
        style: (0, $8Dkkv.margin)
    },
    marginBlock: {
        style: (0, $8Dkkv.margin)
    },
    marginBlockStart: {
        style: (0, $8Dkkv.margin)
    },
    marginBlockEnd: {
        style: (0, $8Dkkv.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $dUz4Z.gap)
    },
    rowGap: {
        style: (0, $dUz4Z.rowGap)
    },
    columnGap: {
        style: (0, $dUz4Z.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $dkO6h.sizingTransform)
    },
    maxWidth: {
        style: (0, $dkO6h.maxWidth)
    },
    minWidth: {
        transform: (0, $dkO6h.sizingTransform)
    },
    height: {
        transform: (0, $dkO6h.sizingTransform)
    },
    maxHeight: {
        transform: (0, $dkO6h.sizingTransform)
    },
    minHeight: {
        transform: (0, $dkO6h.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $d535449a8de05ea7$export$2e2bcd8739ae039 = $d535449a8de05ea7$var$defaultSxConfig;

});
parcelRequire.register("hHI0i", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $ce38960b88c03157$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $ce38960b88c03157$export$7a57f79000377ca2; });


var $chC98 = parcelRequire("chC98");

var $f9xGG = parcelRequire("f9xGG");

var $8Dkkv = parcelRequire("8Dkkv");

var $4w6kZ = parcelRequire("4w6kZ");
function $ce38960b88c03157$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
const $ce38960b88c03157$export$1edee58a52776cd9 = (0, $chC98.default)({
    prop: "border",
    themeKey: "borders",
    transform: $ce38960b88c03157$export$34e2febe53ae29cc
});
const $ce38960b88c03157$export$f9a7b6bd24892946 = (0, $chC98.default)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $ce38960b88c03157$export$34e2febe53ae29cc
});
const $ce38960b88c03157$export$5abca33e6be905d2 = (0, $chC98.default)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $ce38960b88c03157$export$34e2febe53ae29cc
});
const $ce38960b88c03157$export$e2ce9f12a980a822 = (0, $chC98.default)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $ce38960b88c03157$export$34e2febe53ae29cc
});
const $ce38960b88c03157$export$47658cca1a909427 = (0, $chC98.default)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $ce38960b88c03157$export$34e2febe53ae29cc
});
const $ce38960b88c03157$export$e7fb0694ba2404fc = (0, $chC98.default)({
    prop: "borderColor",
    themeKey: "palette"
});
const $ce38960b88c03157$export$126a92c968acdb85 = (0, $chC98.default)({
    prop: "borderTopColor",
    themeKey: "palette"
});
const $ce38960b88c03157$export$85cc51cb8fbb8c0e = (0, $chC98.default)({
    prop: "borderRightColor",
    themeKey: "palette"
});
const $ce38960b88c03157$export$340b0327727f6d1a = (0, $chC98.default)({
    prop: "borderBottomColor",
    themeKey: "palette"
});
const $ce38960b88c03157$export$60beef91a985b4bf = (0, $chC98.default)({
    prop: "borderLeftColor",
    themeKey: "palette"
});
const $ce38960b88c03157$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $8Dkkv.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $8Dkkv.getValue)(transformer, propValue)
            });
        return (0, $4w6kZ.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$ce38960b88c03157$export$7a57f79000377ca2.propTypes = {};
$ce38960b88c03157$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $ce38960b88c03157$var$borders = (0, $f9xGG.default)($ce38960b88c03157$export$1edee58a52776cd9, $ce38960b88c03157$export$f9a7b6bd24892946, $ce38960b88c03157$export$5abca33e6be905d2, $ce38960b88c03157$export$e2ce9f12a980a822, $ce38960b88c03157$export$47658cca1a909427, $ce38960b88c03157$export$e7fb0694ba2404fc, $ce38960b88c03157$export$126a92c968acdb85, $ce38960b88c03157$export$85cc51cb8fbb8c0e, $ce38960b88c03157$export$340b0327727f6d1a, $ce38960b88c03157$export$60beef91a985b4bf, $ce38960b88c03157$export$7a57f79000377ca2);
var $ce38960b88c03157$export$2e2bcd8739ae039 = $ce38960b88c03157$var$borders;

});
parcelRequire.register("f9xGG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b081d3ead28db591$export$2e2bcd8739ae039; });

var $d6LYs = parcelRequire("d6LYs");
function $b081d3ead28db591$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $d6LYs.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $b081d3ead28db591$export$2e2bcd8739ae039 = $b081d3ead28db591$var$compose;

});


parcelRequire.register("dUz4Z", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $a20bb7652989736a$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $a20bb7652989736a$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $a20bb7652989736a$export$8a833ffa5f5dbeda; });

var $chC98 = parcelRequire("chC98");

var $f9xGG = parcelRequire("f9xGG");

var $8Dkkv = parcelRequire("8Dkkv");

var $4w6kZ = parcelRequire("4w6kZ");

const $a20bb7652989736a$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $8Dkkv.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $8Dkkv.getValue)(transformer, propValue)
            });
        return (0, $4w6kZ.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$a20bb7652989736a$export$5df9adcb0db95e1e.propTypes = {};
$a20bb7652989736a$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $a20bb7652989736a$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $8Dkkv.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $8Dkkv.getValue)(transformer, propValue)
            });
        return (0, $4w6kZ.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$a20bb7652989736a$export$ec60d70ff941a580.propTypes = {};
$a20bb7652989736a$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $a20bb7652989736a$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $8Dkkv.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $8Dkkv.getValue)(transformer, propValue)
            });
        return (0, $4w6kZ.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$a20bb7652989736a$export$8a833ffa5f5dbeda.propTypes = {};
$a20bb7652989736a$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $a20bb7652989736a$export$baf44164ca3a34e8 = (0, $chC98.default)({
    prop: "gridColumn"
});
const $a20bb7652989736a$export$8f7213a1cd01e832 = (0, $chC98.default)({
    prop: "gridRow"
});
const $a20bb7652989736a$export$b0e0abbc49ba668 = (0, $chC98.default)({
    prop: "gridAutoFlow"
});
const $a20bb7652989736a$export$bcd8b929d4b4142 = (0, $chC98.default)({
    prop: "gridAutoColumns"
});
const $a20bb7652989736a$export$e5039a674e14c828 = (0, $chC98.default)({
    prop: "gridAutoRows"
});
const $a20bb7652989736a$export$42bd9088661ffb03 = (0, $chC98.default)({
    prop: "gridTemplateColumns"
});
const $a20bb7652989736a$export$920682ae05b999bc = (0, $chC98.default)({
    prop: "gridTemplateRows"
});
const $a20bb7652989736a$export$1b88fbdd482fd33a = (0, $chC98.default)({
    prop: "gridTemplateAreas"
});
const $a20bb7652989736a$export$bdb486e40d52d26f = (0, $chC98.default)({
    prop: "gridArea"
});
const $a20bb7652989736a$var$grid = (0, $f9xGG.default)($a20bb7652989736a$export$5df9adcb0db95e1e, $a20bb7652989736a$export$ec60d70ff941a580, $a20bb7652989736a$export$8a833ffa5f5dbeda, $a20bb7652989736a$export$baf44164ca3a34e8, $a20bb7652989736a$export$8f7213a1cd01e832, $a20bb7652989736a$export$b0e0abbc49ba668, $a20bb7652989736a$export$bcd8b929d4b4142, $a20bb7652989736a$export$e5039a674e14c828, $a20bb7652989736a$export$42bd9088661ffb03, $a20bb7652989736a$export$920682ae05b999bc, $a20bb7652989736a$export$1b88fbdd482fd33a, $a20bb7652989736a$export$bdb486e40d52d26f);
var $a20bb7652989736a$export$2e2bcd8739ae039 = $a20bb7652989736a$var$grid;

});

parcelRequire.register("cKMdR", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $948f2fe5f9d21cbf$export$dbaffd4420ea0ac6; });

var $chC98 = parcelRequire("chC98");

var $f9xGG = parcelRequire("f9xGG");
function $948f2fe5f9d21cbf$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $948f2fe5f9d21cbf$export$35e9368ef982300f = (0, $chC98.default)({
    prop: "color",
    themeKey: "palette",
    transform: $948f2fe5f9d21cbf$export$dbaffd4420ea0ac6
});
const $948f2fe5f9d21cbf$export$2506f56c10355b33 = (0, $chC98.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $948f2fe5f9d21cbf$export$dbaffd4420ea0ac6
});
const $948f2fe5f9d21cbf$export$8c5a050822fd698c = (0, $chC98.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $948f2fe5f9d21cbf$export$dbaffd4420ea0ac6
});
const $948f2fe5f9d21cbf$var$palette = (0, $f9xGG.default)($948f2fe5f9d21cbf$export$35e9368ef982300f, $948f2fe5f9d21cbf$export$2506f56c10355b33, $948f2fe5f9d21cbf$export$8c5a050822fd698c);
var $948f2fe5f9d21cbf$export$2e2bcd8739ae039 = $948f2fe5f9d21cbf$var$palette;

});

parcelRequire.register("dkO6h", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $9b54017ad920202c$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $9b54017ad920202c$export$488fda99655ff65a; });

var $chC98 = parcelRequire("chC98");

var $f9xGG = parcelRequire("f9xGG");

var $4w6kZ = parcelRequire("4w6kZ");
function $9b54017ad920202c$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $9b54017ad920202c$export$7e3df82ee760448c = (0, $chC98.default)({
    prop: "width",
    transform: $9b54017ad920202c$export$8afece71750ec241
});
const $9b54017ad920202c$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $4w6kZ.values)[propValue];
            return {
                maxWidth: breakpoint || $9b54017ad920202c$export$8afece71750ec241(propValue)
            };
        };
        return (0, $4w6kZ.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$9b54017ad920202c$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $9b54017ad920202c$export$ee148fbbe8357dd2 = (0, $chC98.default)({
    prop: "minWidth",
    transform: $9b54017ad920202c$export$8afece71750ec241
});
const $9b54017ad920202c$export$ac607276a8fe9f0a = (0, $chC98.default)({
    prop: "height",
    transform: $9b54017ad920202c$export$8afece71750ec241
});
const $9b54017ad920202c$export$dc0d8bd0b94f8570 = (0, $chC98.default)({
    prop: "maxHeight",
    transform: $9b54017ad920202c$export$8afece71750ec241
});
const $9b54017ad920202c$export$a43cf604e12f3b17 = (0, $chC98.default)({
    prop: "minHeight",
    transform: $9b54017ad920202c$export$8afece71750ec241
});
const $9b54017ad920202c$export$ffed9f14fb65e276 = (0, $chC98.default)({
    prop: "size",
    cssProperty: "width",
    transform: $9b54017ad920202c$export$8afece71750ec241
});
const $9b54017ad920202c$export$905076ed6620e671 = (0, $chC98.default)({
    prop: "size",
    cssProperty: "height",
    transform: $9b54017ad920202c$export$8afece71750ec241
});
const $9b54017ad920202c$export$6ccc93f785106a58 = (0, $chC98.default)({
    prop: "boxSizing"
});
const $9b54017ad920202c$var$sizing = (0, $f9xGG.default)($9b54017ad920202c$export$7e3df82ee760448c, $9b54017ad920202c$export$488fda99655ff65a, $9b54017ad920202c$export$ee148fbbe8357dd2, $9b54017ad920202c$export$ac607276a8fe9f0a, $9b54017ad920202c$export$dc0d8bd0b94f8570, $9b54017ad920202c$export$a43cf604e12f3b17, $9b54017ad920202c$export$6ccc93f785106a58);
var $9b54017ad920202c$export$2e2bcd8739ae039 = $9b54017ad920202c$var$sizing;

});




parcelRequire.register("8EeDz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64bd69cbe53430da$export$2e2bcd8739ae039; });

var $6cds3 = parcelRequire("6cds3");
parcelRequire("iMGg1");
var $ielBg = parcelRequire("ielBg");
"use client";
function $64bd69cbe53430da$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $64bd69cbe53430da$var$useTheme(defaultTheme = null) {
    const contextTheme = $6cds3.useContext((0, $ielBg.T));
    return !contextTheme || $64bd69cbe53430da$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $64bd69cbe53430da$export$2e2bcd8739ae039 = $64bd69cbe53430da$var$useTheme;

});
parcelRequire.register("iMGg1", function(module, exports) {

$parcel$export(module.exports, "keyframes", function () { return $dacd7d2074e32fea$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("ielBg")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("ielBg")).w; });

var $ielBg = parcelRequire("ielBg");

var $6cds3 = parcelRequire("6cds3");

var $jgYZb = parcelRequire("jgYZb");

var $9MyW5 = parcelRequire("9MyW5");

var $bttqu = parcelRequire("bttqu");
parcelRequire("6E72a");
parcelRequire("44T6b");
parcelRequire("iPAYd");

parcelRequire("f1S4k");
var $dacd7d2074e32fea$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $dacd7d2074e32fea$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $ielBg.h).call(props, "css")) // $FlowFixMe
    return $6cds3.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $ielBg.E);
    createElementArgArray[1] = (0, $ielBg.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $6cds3.createElement.apply(null, createElementArgArray);
};
var $dacd7d2074e32fea$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $dacd7d2074e32fea$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $ielBg.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $bttqu.serializeStyles)([
        styles
    ], undefined, $6cds3.useContext((0, $ielBg.T)));
    if (!(0, $ielBg.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $6cds3.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $6cds3.useRef();
    (0, $9MyW5.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $9MyW5.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $jgYZb.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $dacd7d2074e32fea$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $bttqu.serializeStyles)(args);
}
var $dacd7d2074e32fea$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $dacd7d2074e32fea$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $dacd7d2074e32fea$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $dacd7d2074e32fea$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $jgYZb.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $dacd7d2074e32fea$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $9MyW5.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $jgYZb.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $dacd7d2074e32fea$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $ielBg.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $bttqu.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $jgYZb.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $dacd7d2074e32fea$var$merge(cache.registered, css, $dacd7d2074e32fea$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $6cds3.useContext((0, $ielBg.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement($dacd7d2074e32fea$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $dacd7d2074e32fea$var$isBrowser, $dacd7d2074e32fea$var$isTestEnv, $dacd7d2074e32fea$var$globalContext, $dacd7d2074e32fea$var$globalKey;

});
parcelRequire.register("ielBg", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $d45a4a2414093d11$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $d45a4a2414093d11$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "w", function () { return $d45a4a2414093d11$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $d45a4a2414093d11$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $d45a4a2414093d11$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $d45a4a2414093d11$export$a9c23c6ac3fc3eca; });

var $6cds3 = parcelRequire("6cds3");

var $6E72a = parcelRequire("6E72a");

var $dpDEA = parcelRequire("dpDEA");

var $iPAYd = parcelRequire("iPAYd");

var $lhv7y = parcelRequire("lhv7y");

var $jgYZb = parcelRequire("jgYZb");

var $bttqu = parcelRequire("bttqu");

var $9MyW5 = parcelRequire("9MyW5");
var $d45a4a2414093d11$export$23f2a1d2818174ef = true;
var $d45a4a2414093d11$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $d45a4a2414093d11$var$EmotionCacheContext = /* #__PURE__ */ $6cds3.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $6E72a.default)({
    key: "css"
}) : null);
var $d45a4a2414093d11$export$e7094788287c5e9b = $d45a4a2414093d11$var$EmotionCacheContext.Provider;
var $d45a4a2414093d11$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $6cds3.useContext)($d45a4a2414093d11$var$EmotionCacheContext);
};
var $d45a4a2414093d11$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $6cds3.useContext)($d45a4a2414093d11$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$d45a4a2414093d11$export$23f2a1d2818174ef) $d45a4a2414093d11$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $6cds3.useContext)($d45a4a2414093d11$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $6E72a.default)({
                key: "css"
            });
            return /*#__PURE__*/ $6cds3.createElement($d45a4a2414093d11$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $d45a4a2414093d11$export$971d5caa766a69d7 = /* #__PURE__ */ $6cds3.createContext({});
var $d45a4a2414093d11$export$3b14a55fb2447963 = function useTheme() {
    return $6cds3.useContext($d45a4a2414093d11$export$971d5caa766a69d7);
};
var $d45a4a2414093d11$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $dpDEA.default)({}, outerTheme, theme);
};
var $d45a4a2414093d11$var$createCacheWithTheme = /* #__PURE__ */ (0, $iPAYd.default)(function(outerTheme) {
    return (0, $iPAYd.default)(function(theme) {
        return $d45a4a2414093d11$var$getTheme(outerTheme, theme);
    });
});
var $d45a4a2414093d11$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $6cds3.useContext($d45a4a2414093d11$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $d45a4a2414093d11$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $6cds3.createElement($d45a4a2414093d11$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $d45a4a2414093d11$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $6cds3.useContext($d45a4a2414093d11$export$971d5caa766a69d7);
        return /*#__PURE__*/ $6cds3.createElement(Component, (0, $dpDEA.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $6cds3.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $lhv7y.default)(WithTheme, Component);
}
var $d45a4a2414093d11$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $d45a4a2414093d11$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $d45a4a2414093d11$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $d45a4a2414093d11$var$getLastPart(match[1]);
    return undefined;
};
var $d45a4a2414093d11$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $d45a4a2414093d11$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $d45a4a2414093d11$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $d45a4a2414093d11$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($d45a4a2414093d11$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $d45a4a2414093d11$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $d45a4a2414093d11$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $d45a4a2414093d11$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $d45a4a2414093d11$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($d45a4a2414093d11$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$d45a4a2414093d11$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $d45a4a2414093d11$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $jgYZb.registerStyles)(cache, serialized, isStringTag);
    (0, $9MyW5.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $jgYZb.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $d45a4a2414093d11$var$Emotion = /* #__PURE__ */ $d45a4a2414093d11$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$d45a4a2414093d11$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $jgYZb.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $bttqu.serializeStyles)(registeredStyles, undefined, $6cds3.useContext($d45a4a2414093d11$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($d45a4a2414093d11$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $d45a4a2414093d11$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement($d45a4a2414093d11$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $6cds3.createElement(WrappedComponent, newProps));
});
var $d45a4a2414093d11$export$a9c23c6ac3fc3eca = $d45a4a2414093d11$var$Emotion;

});
parcelRequire.register("6E72a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d6bef5101ace00d$export$2e2bcd8739ae039; });

var $alMfq = parcelRequire("alMfq");

var $6wCJp = parcelRequire("6wCJp");
parcelRequire("iPAYd");
parcelRequire("hyxPM");
var $4d6bef5101ace00d$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $6wCJp.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $6wCJp.token)(character)) break;
        (0, $6wCJp.next)();
    }
    return (0, $6wCJp.slice)(begin, (0, $6wCJp.position));
};
var $4d6bef5101ace00d$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $6wCJp.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $6wCJp.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $4d6bef5101ace00d$var$identifierWithPointTracking((0, $6wCJp.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $6wCJp.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $6wCJp.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $6wCJp.from)(character);
    }
    while (character = (0, $6wCJp.next)());
    return parsed;
};
var $4d6bef5101ace00d$var$getRules = function getRules(value, points) {
    return (0, $6wCJp.dealloc)($4d6bef5101ace00d$var$toRules((0, $6wCJp.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $4d6bef5101ace00d$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $4d6bef5101ace00d$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$4d6bef5101ace00d$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $4d6bef5101ace00d$var$fixedElements.set(element, true);
    var points = [];
    var rules = $4d6bef5101ace00d$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $4d6bef5101ace00d$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $4d6bef5101ace00d$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $4d6bef5101ace00d$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($4d6bef5101ace00d$var$ignoreFlag) > -1;
};
var $4d6bef5101ace00d$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($4d6bef5101ace00d$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $4d6bef5101ace00d$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $4d6bef5101ace00d$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$4d6bef5101ace00d$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $4d6bef5101ace00d$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $4d6bef5101ace00d$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$4d6bef5101ace00d$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $4d6bef5101ace00d$var$nullifyElement(element);
    } else if ($4d6bef5101ace00d$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $4d6bef5101ace00d$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $4d6bef5101ace00d$var$prefix(value, length) {
    switch((0, $6wCJp.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $6wCJp.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $6wCJp.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $6wCJp.WEBKIT) + value + (0, $6wCJp.MOZ) + value + (0, $6wCJp.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $6wCJp.WEBKIT) + value + (0, $6wCJp.MS) + value + value;
        // order
        case 6165:
            return (0, $6wCJp.WEBKIT) + value + (0, $6wCJp.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $6wCJp.WEBKIT) + value + (0, $6wCJp.replace)(value, /(\w+).+(:[^]+)/, (0, $6wCJp.WEBKIT) + "box-$1$2" + (0, $6wCJp.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $6wCJp.WEBKIT) + value + (0, $6wCJp.MS) + "flex-item-" + (0, $6wCJp.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $6wCJp.WEBKIT) + value + (0, $6wCJp.MS) + "flex-line-pack" + (0, $6wCJp.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $6wCJp.WEBKIT) + value + (0, $6wCJp.MS) + (0, $6wCJp.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $6wCJp.WEBKIT) + value + (0, $6wCJp.MS) + (0, $6wCJp.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $6wCJp.WEBKIT) + "box-" + (0, $6wCJp.replace)(value, "-grow", "") + (0, $6wCJp.WEBKIT) + value + (0, $6wCJp.MS) + (0, $6wCJp.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $6wCJp.WEBKIT) + (0, $6wCJp.replace)(value, /([^-])(transform)/g, "$1" + (0, $6wCJp.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $6wCJp.replace)((0, $6wCJp.replace)((0, $6wCJp.replace)(value, /(zoom-|grab)/, (0, $6wCJp.WEBKIT) + "$1"), /(image-set)/, (0, $6wCJp.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $6wCJp.replace)(value, /(image-set\([^]*)/, (0, $6wCJp.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $6wCJp.replace)((0, $6wCJp.replace)(value, /(.+:)(flex-)?(.*)/, (0, $6wCJp.WEBKIT) + "box-pack:$3" + (0, $6wCJp.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $6wCJp.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $6wCJp.replace)(value, /(.+)-inline(.+)/, (0, $6wCJp.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $6wCJp.strlen)(value) - 1 - length > 6) switch((0, $6wCJp.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $6wCJp.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $6wCJp.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $6wCJp.WEBKIT) + "$2-$3" + "$1" + (0, $6wCJp.MOZ) + ((0, $6wCJp.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $6wCJp.indexof)(value, "stretch") ? $4d6bef5101ace00d$var$prefix((0, $6wCJp.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $6wCJp.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $6wCJp.charat)(value, (0, $6wCJp.strlen)(value) - 3 - (~(0, $6wCJp.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $6wCJp.replace)(value, ":", ":" + (0, $6wCJp.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $6wCJp.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $6wCJp.WEBKIT) + ((0, $6wCJp.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $6wCJp.WEBKIT) + "$2$3" + "$1" + (0, $6wCJp.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $6wCJp.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $6wCJp.WEBKIT) + value + (0, $6wCJp.MS) + (0, $6wCJp.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $6wCJp.WEBKIT) + value + (0, $6wCJp.MS) + (0, $6wCJp.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $6wCJp.WEBKIT) + value + (0, $6wCJp.MS) + (0, $6wCJp.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $6wCJp.WEBKIT) + value + (0, $6wCJp.MS) + value + value;
    }
    return value;
}
var $4d6bef5101ace00d$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $6wCJp.DECLARATION:
                element["return"] = $4d6bef5101ace00d$var$prefix(element.value, element.length);
                break;
            case 0, $6wCJp.KEYFRAMES:
                return (0, $6wCJp.serialize)([
                    (0, $6wCJp.copy)(element, {
                        value: (0, $6wCJp.replace)(element.value, "@", "@" + (0, $6wCJp.WEBKIT))
                    })
                ], callback);
            case 0, $6wCJp.RULESET:
                if (element.length) return (0, $6wCJp.combine)(element.props, function(value) {
                    switch((0, $6wCJp.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $6wCJp.serialize)([
                                (0, $6wCJp.copy)(element, {
                                    props: [
                                        (0, $6wCJp.replace)(value, /:(read-\w+)/, ":" + (0, $6wCJp.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $6wCJp.serialize)([
                                (0, $6wCJp.copy)(element, {
                                    props: [
                                        (0, $6wCJp.replace)(value, /:(plac\w+)/, ":" + (0, $6wCJp.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $6wCJp.copy)(element, {
                                    props: [
                                        (0, $6wCJp.replace)(value, /:(plac\w+)/, ":" + (0, $6wCJp.MOZ) + "$1")
                                    ]
                                }),
                                (0, $6wCJp.copy)(element, {
                                    props: [
                                        (0, $6wCJp.replace)(value, /:(plac\w+)/, (0, $6wCJp.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $4d6bef5101ace00d$var$defaultStylisPlugins = [
    $4d6bef5101ace00d$var$prefixer
];
var $4d6bef5101ace00d$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $4d6bef5101ace00d$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $4d6bef5101ace00d$var$compat,
        $4d6bef5101ace00d$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $6wCJp.stringify),
        (0, $6wCJp.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $6wCJp.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $6wCJp.serialize)((0, $6wCJp.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $alMfq.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRequire.register("alMfq", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $78914a89e069f624$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $78914a89e069f624$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $78914a89e069f624$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $78914a89e069f624$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($78914a89e069f624$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $78914a89e069f624$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRequire.register("6wCJp", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $55fca618e7164f46$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $55fca618e7164f46$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $55fca618e7164f46$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $55fca618e7164f46$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $55fca618e7164f46$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $55fca618e7164f46$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $55fca618e7164f46$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $55fca618e7164f46$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $55fca618e7164f46$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $55fca618e7164f46$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $55fca618e7164f46$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $55fca618e7164f46$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $55fca618e7164f46$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $55fca618e7164f46$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $55fca618e7164f46$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $55fca618e7164f46$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $55fca618e7164f46$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $55fca618e7164f46$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $55fca618e7164f46$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $55fca618e7164f46$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $55fca618e7164f46$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $55fca618e7164f46$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $55fca618e7164f46$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $55fca618e7164f46$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $55fca618e7164f46$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $55fca618e7164f46$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $55fca618e7164f46$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $55fca618e7164f46$export$38bcb760f1d4871c; });
var $55fca618e7164f46$export$71ad59f2e432cfe8 = "-ms-";
var $55fca618e7164f46$export$2c0f367103c8d01c = "-moz-";
var $55fca618e7164f46$export$39dfd62a25e0fe93 = "-webkit-";
var $55fca618e7164f46$export$a29989082612d0d9 = "comm";
var $55fca618e7164f46$export$aa3a2e812ca8570d = "rule";
var $55fca618e7164f46$export$527d108ccf083c2b = "decl";
var $55fca618e7164f46$export$d3d35020fa5b54f0 = "@page";
var $55fca618e7164f46$export$500415a86c544f73 = "@media";
var $55fca618e7164f46$export$a763edbf796b780a = "@import";
var $55fca618e7164f46$export$2790aeb8b4e5c826 = "@charset";
var $55fca618e7164f46$export$1cc683e23b84b133 = "@viewport";
var $55fca618e7164f46$export$9447a5efea57e862 = "@supports";
var $55fca618e7164f46$export$ef011b4e114b1fba = "@document";
var $55fca618e7164f46$export$6aad947bda0f3f46 = "@namespace";
var $55fca618e7164f46$export$b44a8529a35fcb60 = "@keyframes";
var $55fca618e7164f46$export$2c16de31893252e6 = "@font-face";
var $55fca618e7164f46$export$3d846dd52e150c6f = "@counter-style";
var $55fca618e7164f46$export$22314bfbb57653fe = "@font-feature-values";
var $55fca618e7164f46$export$d773506282b3cfe6 = "@layer";
var $55fca618e7164f46$export$2335f513bbd82c6d = Math.abs;
var $55fca618e7164f46$export$6788812c4e6611e6 = String.fromCharCode;
var $55fca618e7164f46$export$e6e34fd1f2686227 = Object.assign;
function $55fca618e7164f46$export$d6af199866bfb566(e, r) {
    return $55fca618e7164f46$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $55fca618e7164f46$export$a9db5e087081082d(e, 0)) << 2 ^ $55fca618e7164f46$export$a9db5e087081082d(e, 1)) << 2 ^ $55fca618e7164f46$export$a9db5e087081082d(e, 2)) << 2 ^ $55fca618e7164f46$export$a9db5e087081082d(e, 3) : 0;
}
function $55fca618e7164f46$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $55fca618e7164f46$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $55fca618e7164f46$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $55fca618e7164f46$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $55fca618e7164f46$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $55fca618e7164f46$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $55fca618e7164f46$export$36776f635604f274(e) {
    return e.length;
}
function $55fca618e7164f46$export$f9084667e487ed46(e) {
    return e.length;
}
function $55fca618e7164f46$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $55fca618e7164f46$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $55fca618e7164f46$export$53f1d5ea8de3d7c = 1;
var $55fca618e7164f46$export$4e0c71f277ca26b3 = 1;
var $55fca618e7164f46$export$f24224f1c91d8156 = 0;
var $55fca618e7164f46$export$5880b8b5730aff45 = 0;
var $55fca618e7164f46$export$c0306caf338ac095 = 0;
var $55fca618e7164f46$export$30a86d91af8ff6e6 = "";
function $55fca618e7164f46$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $55fca618e7164f46$export$53f1d5ea8de3d7c,
        column: $55fca618e7164f46$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $55fca618e7164f46$export$784d13d8ee351f07(e, r) {
    return $55fca618e7164f46$export$e6e34fd1f2686227($55fca618e7164f46$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $55fca618e7164f46$export$eba6f6f03b0a92e7() {
    return $55fca618e7164f46$export$c0306caf338ac095;
}
function $55fca618e7164f46$export$232faf9add678146() {
    $55fca618e7164f46$export$c0306caf338ac095 = $55fca618e7164f46$export$5880b8b5730aff45 > 0 ? $55fca618e7164f46$export$a9db5e087081082d($55fca618e7164f46$export$30a86d91af8ff6e6, --$55fca618e7164f46$export$5880b8b5730aff45) : 0;
    if ($55fca618e7164f46$export$4e0c71f277ca26b3--, $55fca618e7164f46$export$c0306caf338ac095 === 10) $55fca618e7164f46$export$4e0c71f277ca26b3 = 1, $55fca618e7164f46$export$53f1d5ea8de3d7c--;
    return $55fca618e7164f46$export$c0306caf338ac095;
}
function $55fca618e7164f46$export$48cfd1e771a65c4f() {
    $55fca618e7164f46$export$c0306caf338ac095 = $55fca618e7164f46$export$5880b8b5730aff45 < $55fca618e7164f46$export$f24224f1c91d8156 ? $55fca618e7164f46$export$a9db5e087081082d($55fca618e7164f46$export$30a86d91af8ff6e6, $55fca618e7164f46$export$5880b8b5730aff45++) : 0;
    if ($55fca618e7164f46$export$4e0c71f277ca26b3++, $55fca618e7164f46$export$c0306caf338ac095 === 10) $55fca618e7164f46$export$4e0c71f277ca26b3 = 1, $55fca618e7164f46$export$53f1d5ea8de3d7c++;
    return $55fca618e7164f46$export$c0306caf338ac095;
}
function $55fca618e7164f46$export$4d3fb11e950abb9e() {
    return $55fca618e7164f46$export$a9db5e087081082d($55fca618e7164f46$export$30a86d91af8ff6e6, $55fca618e7164f46$export$5880b8b5730aff45);
}
function $55fca618e7164f46$export$e88cb2efb12ae807() {
    return $55fca618e7164f46$export$5880b8b5730aff45;
}
function $55fca618e7164f46$export$58adb3bec8346d0f(e, r) {
    return $55fca618e7164f46$export$2f35ab04d2335697($55fca618e7164f46$export$30a86d91af8ff6e6, e, r);
}
function $55fca618e7164f46$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $55fca618e7164f46$export$2de70f21292aac9e(e) {
    return $55fca618e7164f46$export$53f1d5ea8de3d7c = $55fca618e7164f46$export$4e0c71f277ca26b3 = 1, $55fca618e7164f46$export$f24224f1c91d8156 = $55fca618e7164f46$export$36776f635604f274($55fca618e7164f46$export$30a86d91af8ff6e6 = e), $55fca618e7164f46$export$5880b8b5730aff45 = 0, [];
}
function $55fca618e7164f46$export$45918ac1574455b1(e) {
    return $55fca618e7164f46$export$30a86d91af8ff6e6 = "", e;
}
function $55fca618e7164f46$export$410ac95b9ec204b8(e) {
    return $55fca618e7164f46$export$87c2784dc9fc4ab($55fca618e7164f46$export$58adb3bec8346d0f($55fca618e7164f46$export$5880b8b5730aff45 - 1, $55fca618e7164f46$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $55fca618e7164f46$export$660b2ee2d4fb4eff(e) {
    return $55fca618e7164f46$export$45918ac1574455b1($55fca618e7164f46$export$5f8c09e3ae6f64e1($55fca618e7164f46$export$2de70f21292aac9e(e)));
}
function $55fca618e7164f46$export$7af1228ff777d175(e) {
    while($55fca618e7164f46$export$c0306caf338ac095 = $55fca618e7164f46$export$4d3fb11e950abb9e())if ($55fca618e7164f46$export$c0306caf338ac095 < 33) $55fca618e7164f46$export$48cfd1e771a65c4f();
    else break;
    return $55fca618e7164f46$export$9e1725a4cfeada27(e) > 2 || $55fca618e7164f46$export$9e1725a4cfeada27($55fca618e7164f46$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $55fca618e7164f46$export$5f8c09e3ae6f64e1(e) {
    while($55fca618e7164f46$export$48cfd1e771a65c4f())switch($55fca618e7164f46$export$9e1725a4cfeada27($55fca618e7164f46$export$c0306caf338ac095)){
        case 0:
            $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$c2ab62c7bf24634($55fca618e7164f46$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$410ac95b9ec204b8($55fca618e7164f46$export$c0306caf338ac095), e);
            break;
        default:
            $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$6788812c4e6611e6($55fca618e7164f46$export$c0306caf338ac095), e);
    }
    return e;
}
function $55fca618e7164f46$export$955ba06d119e085e(e, r) {
    while(--r && $55fca618e7164f46$export$48cfd1e771a65c4f())if ($55fca618e7164f46$export$c0306caf338ac095 < 48 || $55fca618e7164f46$export$c0306caf338ac095 > 102 || $55fca618e7164f46$export$c0306caf338ac095 > 57 && $55fca618e7164f46$export$c0306caf338ac095 < 65 || $55fca618e7164f46$export$c0306caf338ac095 > 70 && $55fca618e7164f46$export$c0306caf338ac095 < 97) break;
    return $55fca618e7164f46$export$58adb3bec8346d0f(e, $55fca618e7164f46$export$e88cb2efb12ae807() + (r < 6 && $55fca618e7164f46$export$4d3fb11e950abb9e() == 32 && $55fca618e7164f46$export$48cfd1e771a65c4f() == 32));
}
function $55fca618e7164f46$export$c889f2fcc19dbf12(e) {
    while($55fca618e7164f46$export$48cfd1e771a65c4f())switch($55fca618e7164f46$export$c0306caf338ac095){
        case e:
            return $55fca618e7164f46$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $55fca618e7164f46$export$c889f2fcc19dbf12($55fca618e7164f46$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $55fca618e7164f46$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $55fca618e7164f46$export$48cfd1e771a65c4f();
            break;
    }
    return $55fca618e7164f46$export$5880b8b5730aff45;
}
function $55fca618e7164f46$export$4254d4e2b3745c4c(e, r) {
    while($55fca618e7164f46$export$48cfd1e771a65c4f())if (e + $55fca618e7164f46$export$c0306caf338ac095 === 57) break;
    else if (e + $55fca618e7164f46$export$c0306caf338ac095 === 84 && $55fca618e7164f46$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $55fca618e7164f46$export$58adb3bec8346d0f(r, $55fca618e7164f46$export$5880b8b5730aff45 - 1) + "*" + $55fca618e7164f46$export$6788812c4e6611e6(e === 47 ? e : $55fca618e7164f46$export$48cfd1e771a65c4f());
}
function $55fca618e7164f46$export$c2ab62c7bf24634(e) {
    while(!$55fca618e7164f46$export$9e1725a4cfeada27($55fca618e7164f46$export$4d3fb11e950abb9e()))$55fca618e7164f46$export$48cfd1e771a65c4f();
    return $55fca618e7164f46$export$58adb3bec8346d0f(e, $55fca618e7164f46$export$5880b8b5730aff45);
}
function $55fca618e7164f46$export$ef7acd7185315e22(e) {
    return $55fca618e7164f46$export$45918ac1574455b1($55fca618e7164f46$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $55fca618e7164f46$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $55fca618e7164f46$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $55fca618e7164f46$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $55fca618e7164f46$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($55fca618e7164f46$export$f8e21b1e77979a08(j += $55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $55fca618e7164f46$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $55fca618e7164f46$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $55fca618e7164f46$export$955ba06d119e085e($55fca618e7164f46$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($55fca618e7164f46$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$4a34f930e789283c($55fca618e7164f46$export$4254d4e2b3745c4c($55fca618e7164f46$export$48cfd1e771a65c4f(), $55fca618e7164f46$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $55fca618e7164f46$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $55fca618e7164f46$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $55fca618e7164f46$export$36776f635604f274(j) - l) $55fca618e7164f46$export$10d8903dec122b9d(p > 32 ? $55fca618e7164f46$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $55fca618e7164f46$export$f8483753829ec8f3($55fca618e7164f46$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $55fca618e7164f46$export$10d8903dec122b9d(y = $55fca618e7164f46$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $55fca618e7164f46$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $55fca618e7164f46$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $55fca618e7164f46$export$98e6a39c04603d36(e, y, y, n && $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $55fca618e7164f46$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $55fca618e7164f46$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $55fca618e7164f46$export$232faf9add678146() == 125) continue;
            }
            switch(j += $55fca618e7164f46$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($55fca618e7164f46$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($55fca618e7164f46$export$4d3fb11e950abb9e() === 45) j += $55fca618e7164f46$export$410ac95b9ec204b8($55fca618e7164f46$export$48cfd1e771a65c4f());
                    v = $55fca618e7164f46$export$4d3fb11e950abb9e(), o = l = $55fca618e7164f46$export$36776f635604f274(g = j += $55fca618e7164f46$export$c2ab62c7bf24634($55fca618e7164f46$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $55fca618e7164f46$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $55fca618e7164f46$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $55fca618e7164f46$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $55fca618e7164f46$export$2f35ab04d2335697(e, v + 1, v = $55fca618e7164f46$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $55fca618e7164f46$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $55fca618e7164f46$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $55fca618e7164f46$export$35059013cd4a06db(e, r, a, s === 0 ? $55fca618e7164f46$export$aa3a2e812ca8570d : i, f, o, l);
}
function $55fca618e7164f46$export$4a34f930e789283c(e, r, a) {
    return $55fca618e7164f46$export$35059013cd4a06db(e, r, a, $55fca618e7164f46$export$a29989082612d0d9, $55fca618e7164f46$export$6788812c4e6611e6($55fca618e7164f46$export$eba6f6f03b0a92e7()), $55fca618e7164f46$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $55fca618e7164f46$export$f8483753829ec8f3(e, r, a, n) {
    return $55fca618e7164f46$export$35059013cd4a06db(e, r, a, $55fca618e7164f46$export$527d108ccf083c2b, $55fca618e7164f46$export$2f35ab04d2335697(e, 0, n), $55fca618e7164f46$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $55fca618e7164f46$export$82e9f45cca5ba907(n, c, s) {
    switch($55fca618e7164f46$export$d6af199866bfb566(n, c)){
        case 5103:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $55fca618e7164f46$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$2c0f367103c8d01c + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($55fca618e7164f46$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "box-$1$2" + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-item-" + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$55fca618e7164f46$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $55fca618e7164f46$export$71ad59f2e432cfe8 + "grid-row-" + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-line-pack" + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + "box-" + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "-grow", "") + $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $55fca618e7164f46$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "box-pack:$3" + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $55fca618e7164f46$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$55fca618e7164f46$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $55fca618e7164f46$export$71ad59f2e432cfe8 + "grid-column-align" + $55fca618e7164f46$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $55fca618e7164f46$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$55fca618e7164f46$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$55fca618e7164f46$export$f8e21b1e77979a08(s, "span") ? $55fca618e7164f46$export$4659b591c19bdf3d(s, /\d+/) : +$55fca618e7164f46$export$4659b591c19bdf3d(s, /\d+/) - +$55fca618e7164f46$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $55fca618e7164f46$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($55fca618e7164f46$export$36776f635604f274(n) - 1 - c > 6) switch($55fca618e7164f46$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($55fca618e7164f46$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $55fca618e7164f46$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $55fca618e7164f46$export$2c0f367103c8d01c + ($55fca618e7164f46$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$55fca618e7164f46$export$f8e21b1e77979a08(n, "stretch") ? $55fca618e7164f46$export$82e9f45cca5ba907($55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $55fca618e7164f46$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $55fca618e7164f46$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($55fca618e7164f46$export$a9db5e087081082d(n, c + 6) === 121) return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, ":", ":" + $55fca618e7164f46$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($55fca618e7164f46$export$a9db5e087081082d(n, $55fca618e7164f46$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $55fca618e7164f46$export$39dfd62a25e0fe93 + ($55fca618e7164f46$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $55fca618e7164f46$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $55fca618e7164f46$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, ":", ":" + $55fca618e7164f46$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $55fca618e7164f46$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $55fca618e7164f46$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $55fca618e7164f46$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $55fca618e7164f46$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $55fca618e7164f46$export$a763edbf796b780a:
        case $55fca618e7164f46$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $55fca618e7164f46$export$a29989082612d0d9:
            return "";
        case $55fca618e7164f46$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $55fca618e7164f46$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $55fca618e7164f46$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $55fca618e7164f46$export$36776f635604f274(a = $55fca618e7164f46$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $55fca618e7164f46$export$5a7767152ae0305f(e) {
    var r = $55fca618e7164f46$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $55fca618e7164f46$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $55fca618e7164f46$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $55fca618e7164f46$export$527d108ccf083c2b:
                n.return = $55fca618e7164f46$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $55fca618e7164f46$export$b44a8529a35fcb60:
                return $55fca618e7164f46$export$dfdc1655ccc5b9cb([
                    $55fca618e7164f46$export$784d13d8ee351f07(n, {
                        value: $55fca618e7164f46$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $55fca618e7164f46$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $55fca618e7164f46$export$aa3a2e812ca8570d:
                if (n.length) return $55fca618e7164f46$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($55fca618e7164f46$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $55fca618e7164f46$export$dfdc1655ccc5b9cb([
                                $55fca618e7164f46$export$784d13d8ee351f07(n, {
                                    props: [
                                        $55fca618e7164f46$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $55fca618e7164f46$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $55fca618e7164f46$export$dfdc1655ccc5b9cb([
                                $55fca618e7164f46$export$784d13d8ee351f07(n, {
                                    props: [
                                        $55fca618e7164f46$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $55fca618e7164f46$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $55fca618e7164f46$export$784d13d8ee351f07(n, {
                                    props: [
                                        $55fca618e7164f46$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $55fca618e7164f46$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $55fca618e7164f46$export$784d13d8ee351f07(n, {
                                    props: [
                                        $55fca618e7164f46$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $55fca618e7164f46$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $55fca618e7164f46$export$76a88f7de6507443(e) {
    switch(e.type){
        case $55fca618e7164f46$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $55fca618e7164f46$export$1be1fc439b849fdf($55fca618e7164f46$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($55fca618e7164f46$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $55fca618e7164f46$export$2f35ab04d2335697(r, 1, $55fca618e7164f46$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $55fca618e7164f46$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $55fca618e7164f46$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $55fca618e7164f46$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRequire.register("iPAYd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db59aaf4afe46724$export$2e2bcd8739ae039; });
var $db59aaf4afe46724$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRequire.register("hyxPM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc7fdb626f425e02$export$2e2bcd8739ae039; });
function $cc7fdb626f425e02$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRequire.register("lhv7y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7e3536e590c5735$export$2e2bcd8739ae039; });

var $f1S4k = parcelRequire("f1S4k");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f7e3536e590c5735$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1S4k)))(targetComponent, sourceComponent);
};

});
parcelRequire.register("f1S4k", function(module, exports) {
"use strict";

var $5Hztg = parcelRequire("5Hztg");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $af10e3f63daf3025$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $af10e3f63daf3025$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $af10e3f63daf3025$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $af10e3f63daf3025$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $af10e3f63daf3025$var$TYPE_STATICS = {};
$af10e3f63daf3025$var$TYPE_STATICS[$5Hztg.ForwardRef] = $af10e3f63daf3025$var$FORWARD_REF_STATICS;
$af10e3f63daf3025$var$TYPE_STATICS[$5Hztg.Memo] = $af10e3f63daf3025$var$MEMO_STATICS;
function $af10e3f63daf3025$var$getStatics(component) {
    // React v16.11 and below
    if ($5Hztg.isMemo(component)) return $af10e3f63daf3025$var$MEMO_STATICS;
     // React v16.12 and above
    return $af10e3f63daf3025$var$TYPE_STATICS[component["$$typeof"]] || $af10e3f63daf3025$var$REACT_STATICS;
}
var $af10e3f63daf3025$var$defineProperty = Object.defineProperty;
var $af10e3f63daf3025$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $af10e3f63daf3025$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $af10e3f63daf3025$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $af10e3f63daf3025$var$getPrototypeOf = Object.getPrototypeOf;
var $af10e3f63daf3025$var$objectPrototype = Object.prototype;
function $af10e3f63daf3025$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($af10e3f63daf3025$var$objectPrototype) {
            var inheritedComponent = $af10e3f63daf3025$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $af10e3f63daf3025$var$objectPrototype) $af10e3f63daf3025$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $af10e3f63daf3025$var$getOwnPropertyNames(sourceComponent);
        if ($af10e3f63daf3025$var$getOwnPropertySymbols) keys = keys.concat($af10e3f63daf3025$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $af10e3f63daf3025$var$getStatics(targetComponent);
        var sourceStatics = $af10e3f63daf3025$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$af10e3f63daf3025$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $af10e3f63daf3025$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $af10e3f63daf3025$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $af10e3f63daf3025$var$hoistNonReactStatics;

});
parcelRequire.register("5Hztg", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hFtc0"));

});



parcelRequire.register("jgYZb", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $e07ed173578a1d54$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $e07ed173578a1d54$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $e07ed173578a1d54$export$6f077d94b33a01aa; });
var $e07ed173578a1d54$var$isBrowser = true;
function $e07ed173578a1d54$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $e07ed173578a1d54$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $e07ed173578a1d54$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $e07ed173578a1d54$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $e07ed173578a1d54$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRequire.register("bttqu", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $85a93a92bf0430bc$export$6321afa313b251b5; });

var $kEjYV = parcelRequire("kEjYV");

var $fDLhR = parcelRequire("fDLhR");

var $hyxPM = parcelRequire("hyxPM");
var $85a93a92bf0430bc$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $85a93a92bf0430bc$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $85a93a92bf0430bc$var$hyphenateRegex = /[A-Z]|^ms/g;
var $85a93a92bf0430bc$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $85a93a92bf0430bc$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $85a93a92bf0430bc$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $85a93a92bf0430bc$var$processStyleName = /* #__PURE__ */ (0, $hyxPM.default)(function(styleName) {
    return $85a93a92bf0430bc$var$isCustomProperty(styleName) ? styleName : styleName.replace($85a93a92bf0430bc$var$hyphenateRegex, "-$&").toLowerCase();
});
var $85a93a92bf0430bc$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($85a93a92bf0430bc$var$animationRegex, function(match, p1, p2) {
                $85a93a92bf0430bc$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $85a93a92bf0430bc$var$cursor
                };
                return p1;
            });
    }
    if ((0, $fDLhR.default)[key] !== 1 && !$85a93a92bf0430bc$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $85a93a92bf0430bc$var$contentValuePattern, $85a93a92bf0430bc$var$contentValues, $85a93a92bf0430bc$var$oldProcessStyleValue, $85a93a92bf0430bc$var$msPattern, $85a93a92bf0430bc$var$hyphenPattern, $85a93a92bf0430bc$var$hyphenatedCache;
var $85a93a92bf0430bc$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $85a93a92bf0430bc$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $85a93a92bf0430bc$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $85a93a92bf0430bc$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $85a93a92bf0430bc$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $85a93a92bf0430bc$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $85a93a92bf0430bc$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $85a93a92bf0430bc$var$cursor;
                var result = interpolation(mergedProps);
                $85a93a92bf0430bc$var$cursor = previousCursor;
                return $85a93a92bf0430bc$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $85a93a92bf0430bc$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $85a93a92bf0430bc$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($85a93a92bf0430bc$var$isProcessableValue(value)) string += $85a93a92bf0430bc$var$processStyleName(_key) + ":" + $85a93a92bf0430bc$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($85a93a92bf0430bc$var$isProcessableValue(value[_i])) string += $85a93a92bf0430bc$var$processStyleName(_key) + ":" + $85a93a92bf0430bc$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $85a93a92bf0430bc$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $85a93a92bf0430bc$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $85a93a92bf0430bc$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $85a93a92bf0430bc$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $85a93a92bf0430bc$var$cursor;
var $85a93a92bf0430bc$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $85a93a92bf0430bc$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $85a93a92bf0430bc$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $85a93a92bf0430bc$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $85a93a92bf0430bc$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $85a93a92bf0430bc$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $kEjYV.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $85a93a92bf0430bc$var$cursor
    };
};

});
parcelRequire.register("kEjYV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0870afdfe966906$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $f0870afdfe966906$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRequire.register("fDLhR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b62f2dc75e2ff17e$export$2e2bcd8739ae039; });
var $b62f2dc75e2ff17e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRequire.register("9MyW5", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $71f3b247da06e75a$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $71f3b247da06e75a$export$811a713a7276cb9d; });

var $6cds3 = parcelRequire("6cds3");
var $71f3b247da06e75a$var$syncFallback = function syncFallback(create) {
    return create();
};
var $71f3b247da06e75a$var$useInsertionEffect = $6cds3.useInsertionEffect ? $6cds3.useInsertionEffect : false;
var $71f3b247da06e75a$export$db21c7ffa21794e7 = $71f3b247da06e75a$var$useInsertionEffect || $71f3b247da06e75a$var$syncFallback;
var $71f3b247da06e75a$export$811a713a7276cb9d = $71f3b247da06e75a$var$useInsertionEffect || $6cds3.useLayoutEffect;

});


parcelRequire.register("44T6b", function(module, exports) {
function $2f82469e03d52db2$var$_extends() {
    module.exports = $2f82469e03d52db2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $2f82469e03d52db2$var$_extends.apply(this, arguments);
}
module.exports = $2f82469e03d52db2$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRequire.register("2aEPG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $194c30714e2fec61$export$2e2bcd8739ae039; });

var $7uJCf = parcelRequire("7uJCf");
"use client";
const $194c30714e2fec61$var$defaultTheme = (0, $7uJCf.default)();
var $194c30714e2fec61$export$2e2bcd8739ae039 = $194c30714e2fec61$var$defaultTheme;

});
parcelRequire.register("7uJCf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $574eb821aa0a99d8$export$2e2bcd8739ae039; });

var $dpDEA = parcelRequire("dpDEA");

var $8pKQA = parcelRequire("8pKQA");

var $K3j0n = parcelRequire("K3j0n");
var $lxstl = parcelRequire("lxstl");

var $eYXiN = parcelRequire("eYXiN");
var $iiTTJ = parcelRequire("iiTTJ");
var $jNfuS = parcelRequire("jNfuS");


var $2eKom = parcelRequire("2eKom");

var $f5eD7 = parcelRequire("f5eD7");

var $57i8K = parcelRequire("57i8K");

var $32Gjo = parcelRequire("32Gjo");

var $ejwaj = parcelRequire("ejwaj");

var $2iKMA = parcelRequire("2iKMA");
const $574eb821aa0a99d8$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $574eb821aa0a99d8$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $8pKQA.default)(options, $574eb821aa0a99d8$var$_excluded);
    if (options.vars) throw new Error((0, $lxstl.default)(18));
    const palette = (0, $f5eD7.default)(paletteInput);
    const systemTheme = (0, $eYXiN.default)(options);
    let muiTheme = (0, $K3j0n.default)(systemTheme, {
        mixins: (0, $2eKom.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $32Gjo.default).slice(),
        typography: (0, $57i8K.default)(palette, typographyInput),
        transitions: (0, $ejwaj.default)(transitionsInput),
        zIndex: (0, $dpDEA.default)({}, (0, $2iKMA.default))
    });
    muiTheme = (0, $K3j0n.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $K3j0n.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $dpDEA.default)({}, (0, $iiTTJ.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $jNfuS.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $574eb821aa0a99d8$var$warnedOnce = false;
function $574eb821aa0a99d8$export$c469355549431d9b(...args) {
    return $574eb821aa0a99d8$var$createTheme(...args);
}
var $574eb821aa0a99d8$export$2e2bcd8739ae039 = $574eb821aa0a99d8$var$createTheme;

});
parcelRequire.register("2eKom", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a10e01176970891$export$2e2bcd8739ae039; });

var $dpDEA = parcelRequire("dpDEA");
function $1a10e01176970891$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $dpDEA.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRequire.register("f5eD7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afb2abdd99a50d91$export$2e2bcd8739ae039; });

var $dpDEA = parcelRequire("dpDEA");

var $8pKQA = parcelRequire("8pKQA");

var $K3j0n = parcelRequire("K3j0n");
var $lxstl = parcelRequire("lxstl");

var $lVNFJ = parcelRequire("lVNFJ");

var $heEum = parcelRequire("heEum");

var $82Cuz = parcelRequire("82Cuz");

var $5PnIG = parcelRequire("5PnIG");

var $5EeI6 = parcelRequire("5EeI6");

var $h143G = parcelRequire("h143G");

var $iVlUQ = parcelRequire("iVlUQ");

var $aPKaC = parcelRequire("aPKaC");

var $kc7dv = parcelRequire("kc7dv");
const $afb2abdd99a50d91$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $afb2abdd99a50d91$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $heEum.default).white,
        default: (0, $heEum.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $afb2abdd99a50d91$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $heEum.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $heEum.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $afb2abdd99a50d91$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $lVNFJ.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $lVNFJ.darken)(intent.main, tonalOffsetDark);
    }
}
function $afb2abdd99a50d91$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $iVlUQ.default)[200],
        light: (0, $iVlUQ.default)[50],
        dark: (0, $iVlUQ.default)[400]
    };
    return {
        main: (0, $iVlUQ.default)[700],
        light: (0, $iVlUQ.default)[400],
        dark: (0, $iVlUQ.default)[800]
    };
}
function $afb2abdd99a50d91$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $5PnIG.default)[200],
        light: (0, $5PnIG.default)[50],
        dark: (0, $5PnIG.default)[400]
    };
    return {
        main: (0, $5PnIG.default)[500],
        light: (0, $5PnIG.default)[300],
        dark: (0, $5PnIG.default)[700]
    };
}
function $afb2abdd99a50d91$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $5EeI6.default)[500],
        light: (0, $5EeI6.default)[300],
        dark: (0, $5EeI6.default)[700]
    };
    return {
        main: (0, $5EeI6.default)[700],
        light: (0, $5EeI6.default)[400],
        dark: (0, $5EeI6.default)[800]
    };
}
function $afb2abdd99a50d91$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $aPKaC.default)[400],
        light: (0, $aPKaC.default)[300],
        dark: (0, $aPKaC.default)[700]
    };
    return {
        main: (0, $aPKaC.default)[700],
        light: (0, $aPKaC.default)[500],
        dark: (0, $aPKaC.default)[900]
    };
}
function $afb2abdd99a50d91$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $kc7dv.default)[400],
        light: (0, $kc7dv.default)[300],
        dark: (0, $kc7dv.default)[700]
    };
    return {
        main: (0, $kc7dv.default)[800],
        light: (0, $kc7dv.default)[500],
        dark: (0, $kc7dv.default)[900]
    };
}
function $afb2abdd99a50d91$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $h143G.default)[400],
        light: (0, $h143G.default)[300],
        dark: (0, $h143G.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $h143G.default)[500],
        dark: (0, $h143G.default)[900]
    };
}
function $afb2abdd99a50d91$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $8pKQA.default)(palette, $afb2abdd99a50d91$var$_excluded);
    const primary = palette.primary || $afb2abdd99a50d91$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $afb2abdd99a50d91$var$getDefaultSecondary(mode);
    const error = palette.error || $afb2abdd99a50d91$var$getDefaultError(mode);
    const info = palette.info || $afb2abdd99a50d91$var$getDefaultInfo(mode);
    const success = palette.success || $afb2abdd99a50d91$var$getDefaultSuccess(mode);
    const warning = palette.warning || $afb2abdd99a50d91$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $lVNFJ.getContrastRatio)(background, $afb2abdd99a50d91$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $afb2abdd99a50d91$export$55ce6f3a06c59543.text.primary : $afb2abdd99a50d91$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $dpDEA.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $lxstl.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $lxstl.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $afb2abdd99a50d91$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $afb2abdd99a50d91$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $afb2abdd99a50d91$export$55ce6f3a06c59543,
        light: $afb2abdd99a50d91$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $K3j0n.default)((0, $dpDEA.default)({
        // A collection of common colors.
        common: (0, $dpDEA.default)({}, (0, $heEum.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $82Cuz.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRequire.register("lVNFJ", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $ff7573acbbe86deb$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $ff7573acbbe86deb$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "darken", function () { return $ff7573acbbe86deb$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $ff7573acbbe86deb$export$c0816ed86df316af; });

var $lxstl = parcelRequire("lxstl");
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $ff7573acbbe86deb$var$clamp(value, min = 0, max = 1) {
    return Math.min(Math.max(min, value), max);
}
function $ff7573acbbe86deb$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $ff7573acbbe86deb$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $ff7573acbbe86deb$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $ff7573acbbe86deb$export$677b39864803984e($ff7573acbbe86deb$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $lxstl.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $lxstl.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $ff7573acbbe86deb$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $ff7573acbbe86deb$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $ff7573acbbe86deb$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $ff7573acbbe86deb$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $ff7573acbbe86deb$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $ff7573acbbe86deb$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $ff7573acbbe86deb$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$ff7573acbbe86deb$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $ff7573acbbe86deb$export$29fb7152bd3f781a(color) {
    color = $ff7573acbbe86deb$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $ff7573acbbe86deb$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $ff7573acbbe86deb$export$c852d90bf7403b62(color) {
    color = $ff7573acbbe86deb$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $ff7573acbbe86deb$export$677b39864803984e($ff7573acbbe86deb$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $ff7573acbbe86deb$export$d061e26956a60b0a(foreground, background) {
    const lumA = $ff7573acbbe86deb$export$c852d90bf7403b62(foreground);
    const lumB = $ff7573acbbe86deb$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $ff7573acbbe86deb$export$58f0f39f63f3cf42(color, value) {
    color = $ff7573acbbe86deb$export$677b39864803984e(color);
    value = $ff7573acbbe86deb$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $ff7573acbbe86deb$export$211a73f2b8c10ce4(color);
}
function $ff7573acbbe86deb$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $ff7573acbbe86deb$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $ff7573acbbe86deb$export$4b073707ff63303(color, coefficient) {
    color = $ff7573acbbe86deb$export$677b39864803984e(color);
    coefficient = $ff7573acbbe86deb$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $ff7573acbbe86deb$export$211a73f2b8c10ce4(color);
}
function $ff7573acbbe86deb$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $ff7573acbbe86deb$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $ff7573acbbe86deb$export$c0816ed86df316af(color, coefficient) {
    color = $ff7573acbbe86deb$export$677b39864803984e(color);
    coefficient = $ff7573acbbe86deb$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $ff7573acbbe86deb$export$211a73f2b8c10ce4(color);
}
function $ff7573acbbe86deb$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $ff7573acbbe86deb$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $ff7573acbbe86deb$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $ff7573acbbe86deb$export$c852d90bf7403b62(color) > 0.5 ? $ff7573acbbe86deb$export$4b073707ff63303(color, coefficient) : $ff7573acbbe86deb$export$c0816ed86df316af(color, coefficient);
}
function $ff7573acbbe86deb$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $ff7573acbbe86deb$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}

});

parcelRequire.register("heEum", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8c326b0b1c31d41$export$2e2bcd8739ae039; });
const $c8c326b0b1c31d41$var$common = {
    black: "#000",
    white: "#fff"
};
var $c8c326b0b1c31d41$export$2e2bcd8739ae039 = $c8c326b0b1c31d41$var$common;

});

parcelRequire.register("82Cuz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dac5e5934772658$export$2e2bcd8739ae039; });
const $5dac5e5934772658$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $5dac5e5934772658$export$2e2bcd8739ae039 = $5dac5e5934772658$var$grey;

});

parcelRequire.register("5PnIG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43e41d6be2fde7b1$export$2e2bcd8739ae039; });
const $43e41d6be2fde7b1$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $43e41d6be2fde7b1$export$2e2bcd8739ae039 = $43e41d6be2fde7b1$var$purple;

});

parcelRequire.register("5EeI6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41cc1958ab6d68e4$export$2e2bcd8739ae039; });
const $41cc1958ab6d68e4$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $41cc1958ab6d68e4$export$2e2bcd8739ae039 = $41cc1958ab6d68e4$var$red;

});

parcelRequire.register("h143G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c635ad9652dec420$export$2e2bcd8739ae039; });
const $c635ad9652dec420$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $c635ad9652dec420$export$2e2bcd8739ae039 = $c635ad9652dec420$var$orange;

});

parcelRequire.register("iVlUQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc6e8ce54b316b93$export$2e2bcd8739ae039; });
const $dc6e8ce54b316b93$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $dc6e8ce54b316b93$export$2e2bcd8739ae039 = $dc6e8ce54b316b93$var$blue;

});

parcelRequire.register("aPKaC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e327b458a1ca603$export$2e2bcd8739ae039; });
const $7e327b458a1ca603$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $7e327b458a1ca603$export$2e2bcd8739ae039 = $7e327b458a1ca603$var$lightBlue;

});

parcelRequire.register("kc7dv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb3a86c337b1b7a6$export$2e2bcd8739ae039; });
const $eb3a86c337b1b7a6$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $eb3a86c337b1b7a6$export$2e2bcd8739ae039 = $eb3a86c337b1b7a6$var$green;

});


parcelRequire.register("57i8K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b9bad74f006e398$export$2e2bcd8739ae039; });

var $dpDEA = parcelRequire("dpDEA");

var $8pKQA = parcelRequire("8pKQA");

var $K3j0n = parcelRequire("K3j0n");
const $3b9bad74f006e398$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $3b9bad74f006e398$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $3b9bad74f006e398$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $3b9bad74f006e398$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $3b9bad74f006e398$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $3b9bad74f006e398$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $8pKQA.default)(_ref, $3b9bad74f006e398$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $dpDEA.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $3b9bad74f006e398$var$defaultFontFamily ? {
            letterSpacing: `${$3b9bad74f006e398$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $3b9bad74f006e398$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $3b9bad74f006e398$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $K3j0n.default)((0, $dpDEA.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRequire.register("32Gjo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2372613789c43f54$export$2e2bcd8739ae039; });
const $2372613789c43f54$var$shadowKeyUmbraOpacity = 0.2;
const $2372613789c43f54$var$shadowKeyPenumbraOpacity = 0.14;
const $2372613789c43f54$var$shadowAmbientShadowOpacity = 0.12;
function $2372613789c43f54$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$2372613789c43f54$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$2372613789c43f54$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$2372613789c43f54$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $2372613789c43f54$var$shadows = [
    "none",
    $2372613789c43f54$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $2372613789c43f54$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $2372613789c43f54$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $2372613789c43f54$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $2372613789c43f54$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $2372613789c43f54$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $2372613789c43f54$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $2372613789c43f54$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $2372613789c43f54$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $2372613789c43f54$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $2372613789c43f54$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $2372613789c43f54$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $2372613789c43f54$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $2372613789c43f54$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $2372613789c43f54$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $2372613789c43f54$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $2372613789c43f54$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $2372613789c43f54$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $2372613789c43f54$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $2372613789c43f54$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $2372613789c43f54$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $2372613789c43f54$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $2372613789c43f54$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $2372613789c43f54$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $2372613789c43f54$export$2e2bcd8739ae039 = $2372613789c43f54$var$shadows;

});

parcelRequire.register("ejwaj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6bbca65a5ed7036$export$2e2bcd8739ae039; });

var $8pKQA = parcelRequire("8pKQA");

var $dpDEA = parcelRequire("dpDEA");
const $a6bbca65a5ed7036$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $a6bbca65a5ed7036$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $a6bbca65a5ed7036$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $a6bbca65a5ed7036$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $a6bbca65a5ed7036$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $a6bbca65a5ed7036$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $dpDEA.default)({}, $a6bbca65a5ed7036$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $dpDEA.default)({}, $a6bbca65a5ed7036$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $8pKQA.default)(options, $a6bbca65a5ed7036$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $a6bbca65a5ed7036$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $a6bbca65a5ed7036$var$formatMs(delay)}`).join(",");
    };
    return (0, $dpDEA.default)({
        getAutoHeightDuration: $a6bbca65a5ed7036$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRequire.register("2iKMA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ad18d4a19af9ae9$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $1ad18d4a19af9ae9$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $1ad18d4a19af9ae9$export$2e2bcd8739ae039 = $1ad18d4a19af9ae9$var$zIndex;

});



parcelRequire.register("hDE6h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd752f42a963b861$export$2e2bcd8739ae039; });
var $cd752f42a963b861$export$2e2bcd8739ae039 = "$$material";

});


parcelRequire.register("iHVyY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9e8e4fcf1846f61$export$2e2bcd8739ae039; });

var $ezmyR = parcelRequire("ezmyR");

var $2aEPG = parcelRequire("2aEPG");

var $hDE6h = parcelRequire("hDE6h");
"use client";
const $d9e8e4fcf1846f61$export$effb20ecdbf4d6aa = (prop)=>(0, $ezmyR.shouldForwardProp)(prop) && prop !== "classes";
const $d9e8e4fcf1846f61$export$f10c5a10d27438e5 = (0, $ezmyR.shouldForwardProp);
const $d9e8e4fcf1846f61$var$styled = (0, $ezmyR.default)({
    themeId: (0, $hDE6h.default),
    defaultTheme: $2aEPG.default,
    rootShouldForwardProp: $d9e8e4fcf1846f61$export$effb20ecdbf4d6aa
});
var $d9e8e4fcf1846f61$export$2e2bcd8739ae039 = $d9e8e4fcf1846f61$var$styled;

});
parcelRequire.register("ezmyR", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", function () { return $a9b5d5ca94feec01$export$3ba67b570e26eea0; });
$parcel$export(module.exports, "default", function () { return $a9b5d5ca94feec01$export$2e2bcd8739ae039; });

var $8pKQA = parcelRequire("8pKQA");

var $dpDEA = parcelRequire("dpDEA");

var $gpuVq = parcelRequire("gpuVq");


var $eYXiN = parcelRequire("eYXiN");

var $68x3B = parcelRequire("68x3B");

var $jNfuS = parcelRequire("jNfuS");
const $a9b5d5ca94feec01$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $a9b5d5ca94feec01$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $a9b5d5ca94feec01$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
const $a9b5d5ca94feec01$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $a9b5d5ca94feec01$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    const variantsStyles = {};
    variants.forEach((definition)=>{
        const key = (0, $68x3B.default)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $a9b5d5ca94feec01$var$variantsResolver = (props, styles, theme, name)=>{
    var _theme$components;
    const { ownerState: ownerState = {} } = props;
    const variantsStyles = [];
    const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[name]) == null ? void 0 : _theme$components.variants;
    if (themeVariants) themeVariants.forEach((themeVariant)=>{
        let isMatch = true;
        Object.keys(themeVariant.props).forEach((key)=>{
            if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) isMatch = false;
        });
        if (isMatch) variantsStyles.push(styles[(0, $68x3B.default)(themeVariant.props)]);
    });
    return variantsStyles;
};
function $a9b5d5ca94feec01$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $a9b5d5ca94feec01$export$35e57303dbd8a66 = (0, $eYXiN.default)();
const $a9b5d5ca94feec01$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $a9b5d5ca94feec01$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $a9b5d5ca94feec01$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $a9b5d5ca94feec01$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $a9b5d5ca94feec01$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $a9b5d5ca94feec01$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $a9b5d5ca94feec01$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $a9b5d5ca94feec01$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $jNfuS.default)((0, $dpDEA.default)({}, props, {
            theme: $a9b5d5ca94feec01$var$resolveTheme((0, $dpDEA.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $gpuVq.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $a9b5d5ca94feec01$var$defaultOverridesResolver($a9b5d5ca94feec01$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $8pKQA.default)(inputOptions, $a9b5d5ca94feec01$var$_excluded);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $a9b5d5ca94feec01$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($a9b5d5ca94feec01$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $gpuVq.default)(tag, (0, $dpDEA.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server Emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                return typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg ? (props)=>{
                    return stylesArg((0, $dpDEA.default)({}, props, {
                        theme: $a9b5d5ca94feec01$var$resolveTheme((0, $dpDEA.default)({}, props, {
                            defaultTheme: defaultTheme,
                            themeId: themeId
                        }))
                    }));
                } : stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $a9b5d5ca94feec01$var$resolveTheme((0, $dpDEA.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const styleOverrides = $a9b5d5ca94feec01$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle((0, $dpDEA.default)({}, props, {
                            theme: theme
                        })) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $a9b5d5ca94feec01$var$resolveTheme((0, $dpDEA.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                return $a9b5d5ca94feec01$var$variantsResolver(props, $a9b5d5ca94feec01$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            } else if (typeof styleArg === "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (props)=>styleArg((0, $dpDEA.default)({}, props, {
                    theme: $a9b5d5ca94feec01$var$resolveTheme((0, $dpDEA.default)({}, props, {
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    }))
                }));
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRequire.register("gpuVq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf26f83a165b6e0f$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $bf26f83a165b6e0f$export$e00380445f2b9e0c; });
/**
 * @mui/styled-engine v5.13.2
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $gBKL7 = parcelRequire("gBKL7");
parcelRequire("iMGg1");
var $ielBg = parcelRequire("ielBg");
var $iMGg1 = parcelRequire("iMGg1");


function $bf26f83a165b6e0f$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $gBKL7.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $bf26f83a165b6e0f$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRequire.register("gBKL7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1745f6a302b8eb3$export$2e2bcd8739ae039; });

var $aH5og = parcelRequire("aH5og");
parcelRequire("44T6b");
parcelRequire("6cds3");
parcelRequire("eWCkp");

parcelRequire("jgYZb");
parcelRequire("bttqu");
parcelRequire("9MyW5");
var $c1745f6a302b8eb3$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $c1745f6a302b8eb3$export$2e2bcd8739ae039 = (0, $aH5og.default).bind();
$c1745f6a302b8eb3$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $c1745f6a302b8eb3$export$2e2bcd8739ae039[tagName] = $c1745f6a302b8eb3$export$2e2bcd8739ae039(tagName);
});

});
parcelRequire.register("aH5og", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c9219ec7a68c432$export$2e2bcd8739ae039; });

var $dpDEA = parcelRequire("dpDEA");

var $6cds3 = parcelRequire("6cds3");

var $eWCkp = parcelRequire("eWCkp");
parcelRequire("iMGg1");
var $ielBg = parcelRequire("ielBg");

var $jgYZb = parcelRequire("jgYZb");

var $bttqu = parcelRequire("bttqu");

var $9MyW5 = parcelRequire("9MyW5");
var $7c9219ec7a68c432$var$testOmitPropsOnStringTag = (0, $eWCkp.default);
var $7c9219ec7a68c432$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $7c9219ec7a68c432$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $7c9219ec7a68c432$var$testOmitPropsOnStringTag : $7c9219ec7a68c432$var$testOmitPropsOnComponent;
};
var $7c9219ec7a68c432$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $7c9219ec7a68c432$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $7c9219ec7a68c432$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $jgYZb.registerStyles)(cache, serialized, isStringTag);
    (0, $9MyW5.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $jgYZb.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $7c9219ec7a68c432$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $7c9219ec7a68c432$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $7c9219ec7a68c432$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $ielBg.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $6cds3.useContext((0, $ielBg.T));
            }
            if (typeof props.className === "string") className = (0, $jgYZb.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $bttqu.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $7c9219ec7a68c432$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement($7c9219ec7a68c432$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $6cds3.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $dpDEA.default)({}, options, nextOptions, {
                shouldForwardProp: $7c9219ec7a68c432$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRequire.register("eWCkp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae1436a51f26d258$export$2e2bcd8739ae039; });

var $hyxPM = parcelRequire("hyxPM");
var $ae1436a51f26d258$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $ae1436a51f26d258$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $hyxPM.default)(function(prop) {
    return $ae1436a51f26d258$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});




parcelRequire.register("68x3B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $477d21deb221855d$export$2e2bcd8739ae039; });

var $8pKQA = parcelRequire("8pKQA");

var $bbWkh = parcelRequire("bbWkh");
const $477d21deb221855d$var$_excluded = [
    "variant"
];
function $477d21deb221855d$var$isEmpty(string) {
    return string.length === 0;
}
function $477d21deb221855d$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $8pKQA.default)(props, $477d21deb221855d$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $477d21deb221855d$var$isEmpty(classKey) ? props[key] : (0, $bbWkh.default)(props[key]);
        else classKey += `${$477d21deb221855d$var$isEmpty(classKey) ? key : (0, $bbWkh.default)(key)}${(0, $bbWkh.default)(props[key].toString())}`;
    });
    return classKey;
}

});



parcelRequire.register("jYYr0", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $e8c27ff4ab84df2d$export$c7c50641356bdfa5; });

var $3DnVy = parcelRequire("3DnVy");

var $3hxuv = parcelRequire("3hxuv");
function $e8c27ff4ab84df2d$export$c7c50641356bdfa5(slot) {
    return (0, $3hxuv.default)("MuiSvgIcon", slot);
}
const $e8c27ff4ab84df2d$var$svgIconClasses = (0, $3DnVy.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $e8c27ff4ab84df2d$export$2e2bcd8739ae039 = $e8c27ff4ab84df2d$var$svgIconClasses;

});
parcelRequire.register("3DnVy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a5793135d570e0c$export$2e2bcd8739ae039; });

var $3hxuv = parcelRequire("3hxuv");
function $2a5793135d570e0c$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $3hxuv.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRequire.register("3hxuv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $263cf04278623b89$export$2e2bcd8739ae039; });

var $8I3VB = parcelRequire("8I3VB");
// If GlobalStateSlot is changed, GLOBAL_STATE_CLASSES in
// \packages\api-docs-builder\utils\parseSlotsAndClasses.ts must be updated accordingly.
const $263cf04278623b89$var$globalStateClassesMapping = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    readOnly: "readOnly",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    required: "required",
    selected: "selected"
};
function $263cf04278623b89$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $263cf04278623b89$var$globalStateClassesMapping[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $8I3VB.default).generate(componentName)}-${slot}`;
}

});
parcelRequire.register("8I3VB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65757acefa7cd624$export$2e2bcd8739ae039; });
const $65757acefa7cd624$var$defaultGenerator = (componentName)=>componentName;
const $65757acefa7cd624$var$createClassNameGenerator = ()=>{
    let generate = $65757acefa7cd624$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $65757acefa7cd624$var$defaultGenerator;
        }
    };
};
const $65757acefa7cd624$var$ClassNameGenerator = $65757acefa7cd624$var$createClassNameGenerator();
var $65757acefa7cd624$export$2e2bcd8739ae039 = $65757acefa7cd624$var$ClassNameGenerator;

});




parcelRequire.register("lBpE3", function(module, exports) {
"use strict";

module.exports = (parcelRequire("a58XM"));

});




parcelRequire.register("cCjFr", function(module, exports) {

var $aqbQf = parcelRequire("aqbQf");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $aqbQf === "object" && $aqbQf.versions && $aqbQf.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

});

parcelRequire.register("6IEmH", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("i4ZT1", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("hUlrm", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $d0984c3e63bb909e$export$bf730a2d8bf68b42; }, function (v) { return $d0984c3e63bb909e$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d0984c3e63bb909e$export$bf730a2d8bf68b42;
"use strict";

var $6cds3 = parcelRequire("6cds3");

var $aBb94 = parcelRequire("aBb94");
function $d0984c3e63bb909e$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d0984c3e63bb909e$var$q = "function" === typeof Object.is ? Object.is : $d0984c3e63bb909e$var$p, $d0984c3e63bb909e$var$r = $aBb94.useSyncExternalStore, $d0984c3e63bb909e$var$t = $6cds3.useRef, $d0984c3e63bb909e$var$u = $6cds3.useEffect, $d0984c3e63bb909e$var$v = $6cds3.useMemo, $d0984c3e63bb909e$var$w = $6cds3.useDebugValue;
$d0984c3e63bb909e$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $d0984c3e63bb909e$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $d0984c3e63bb909e$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($d0984c3e63bb909e$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $d0984c3e63bb909e$var$r(a, c[0], c[1]);
    $d0984c3e63bb909e$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $d0984c3e63bb909e$var$w(d);
    return d;
};

});
parcelRequire.register("aBb94", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5OMzK"));

});
parcelRequire.register("5OMzK", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $43c74d5c8958da58$export$306c0aa65ff9ec16; }, function (v) { return $43c74d5c8958da58$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $43c74d5c8958da58$export$306c0aa65ff9ec16;
"use strict";

var $6cds3 = parcelRequire("6cds3");
function $43c74d5c8958da58$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $43c74d5c8958da58$var$k = "function" === typeof Object.is ? Object.is : $43c74d5c8958da58$var$h, $43c74d5c8958da58$var$l = $6cds3.useState, $43c74d5c8958da58$var$m = $6cds3.useEffect, $43c74d5c8958da58$var$n = $6cds3.useLayoutEffect, $43c74d5c8958da58$var$p = $6cds3.useDebugValue;
function $43c74d5c8958da58$var$q(a, b) {
    var d = b(), f = $43c74d5c8958da58$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $43c74d5c8958da58$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $43c74d5c8958da58$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $43c74d5c8958da58$var$m(function() {
        $43c74d5c8958da58$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $43c74d5c8958da58$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $43c74d5c8958da58$var$p(d);
    return d;
}
function $43c74d5c8958da58$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$43c74d5c8958da58$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $43c74d5c8958da58$var$t(a, b) {
    return b();
}
var $43c74d5c8958da58$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $43c74d5c8958da58$var$t : $43c74d5c8958da58$var$q;
$43c74d5c8958da58$export$306c0aa65ff9ec16 = void 0 !== $6cds3.useSyncExternalStore ? $6cds3.useSyncExternalStore : $43c74d5c8958da58$var$u;

});



parcelRequire.register("j86fo", function(module, exports) {
"use strict";
function $ded39c46ef423f48$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ded39c46ef423f48$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ded39c46ef423f48$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ded39c46ef423f48$var$_react = $ded39c46ef423f48$var$_interopRequireDefault((parcelRequire("6cds3")));

var $ded39c46ef423f48$var$_propTypes = $ded39c46ef423f48$var$_interopRequireDefault((parcelRequire("aMJGV")));

var $cAtrm = parcelRequire("cAtrm");
var $guWa8 = parcelRequire("guWa8");

var $ded39c46ef423f48$var$_classnames = $ded39c46ef423f48$var$_interopRequireDefault((parcelRequire("6PPF0")));

var $ded39c46ef423f48$var$_Notification = $ded39c46ef423f48$var$_interopRequireDefault((parcelRequire("3atEr")));
function $ded39c46ef423f48$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ded39c46ef423f48$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ded39c46ef423f48$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ded39c46ef423f48$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ded39c46ef423f48$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ded39c46ef423f48$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ded39c46ef423f48$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ded39c46ef423f48$var$_setPrototypeOf(subClass, superClass);
}
function $ded39c46ef423f48$var$_setPrototypeOf(o, p) {
    $ded39c46ef423f48$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ded39c46ef423f48$var$_setPrototypeOf(o, p);
}
function $ded39c46ef423f48$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ded39c46ef423f48$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $ded39c46ef423f48$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ded39c46ef423f48$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ded39c46ef423f48$var$_possibleConstructorReturn(this, result);
    };
}
function $ded39c46ef423f48$var$_possibleConstructorReturn(self, call) {
    if (call && ($ded39c46ef423f48$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ded39c46ef423f48$var$_assertThisInitialized(self);
}
function $ded39c46ef423f48$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ded39c46ef423f48$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ded39c46ef423f48$var$_getPrototypeOf(o) {
    $ded39c46ef423f48$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ded39c46ef423f48$var$_getPrototypeOf(o);
}
function $ded39c46ef423f48$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $ded39c46ef423f48$var$Notifications = /*#__PURE__*/ function(_React$Component) {
    $ded39c46ef423f48$var$_inherits(Notifications, _React$Component);
    var _super = $ded39c46ef423f48$var$_createSuper(Notifications);
    function Notifications() {
        var _this;
        $ded39c46ef423f48$var$_classCallCheck(this, Notifications);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $ded39c46ef423f48$var$_defineProperty($ded39c46ef423f48$var$_assertThisInitialized(_this), "handleRequestHide", function(notification) {
            return function() {
                var onRequestHide = _this.props.onRequestHide;
                if (onRequestHide) onRequestHide(notification);
            };
        });
        return _this;
    }
    $ded39c46ef423f48$var$_createClass(Notifications, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, notifications = _this$props.notifications, enterTimeout = _this$props.enterTimeout, leaveTimeout = _this$props.leaveTimeout;
                var className = (0, $ded39c46ef423f48$var$_classnames.default)("notification-container", {
                    "notification-container-empty": notifications.length === 0
                });
                var items = notifications.map(function(notification) {
                    var key = notification.id || new Date().getTime();
                    return /*#__PURE__*/ $ded39c46ef423f48$var$_react.default.createElement($cAtrm.default, {
                        key: key,
                        classNames: "notification",
                        timeout: {
                            enter: enterTimeout,
                            exit: leaveTimeout
                        }
                    }, /*#__PURE__*/ $ded39c46ef423f48$var$_react.default.createElement($ded39c46ef423f48$var$_Notification.default, {
                        type: notification.type,
                        title: notification.title,
                        message: notification.message,
                        timeOut: notification.timeOut,
                        onClick: notification.onClick,
                        onRequestHide: _this2.handleRequestHide(notification)
                    }));
                });
                return /*#__PURE__*/ $ded39c46ef423f48$var$_react.default.createElement("div", {
                    className: className
                }, /*#__PURE__*/ $ded39c46ef423f48$var$_react.default.createElement($guWa8.default, null, items));
            }
        }
    ]);
    return Notifications;
}($ded39c46ef423f48$var$_react.default.Component);
$ded39c46ef423f48$var$_defineProperty($ded39c46ef423f48$var$Notifications, "propTypes", {
    notifications: $ded39c46ef423f48$var$_propTypes.default.array,
    onRequestHide: $ded39c46ef423f48$var$_propTypes.default.func,
    enterTimeout: $ded39c46ef423f48$var$_propTypes.default.number,
    leaveTimeout: $ded39c46ef423f48$var$_propTypes.default.number
});
$ded39c46ef423f48$var$_defineProperty($ded39c46ef423f48$var$Notifications, "defaultProps", {
    notifications: [],
    onRequestHide: function onRequestHide() {},
    enterTimeout: 400,
    leaveTimeout: 400
});
var $ded39c46ef423f48$var$_default = $ded39c46ef423f48$var$Notifications;
module.exports.default = $ded39c46ef423f48$var$_default;

});
parcelRequire.register("cAtrm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $929faf13f3205b9b$export$2e2bcd8739ae039; });

var $dpDEA = parcelRequire("dpDEA");

var $8pKQA = parcelRequire("8pKQA");

var $jdEcH = parcelRequire("jdEcH");


var $jmGE5 = parcelRequire("jmGE5");

var $grYah = parcelRequire("grYah");

var $6cds3 = parcelRequire("6cds3");

var $jDkIp = parcelRequire("jDkIp");


var $3VZCd = parcelRequire("3VZCd");
var $929faf13f3205b9b$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $jmGE5.default)(node, c);
    });
};
var $929faf13f3205b9b$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $grYah.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $929faf13f3205b9b$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $jdEcH.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, $3VZCd.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $929faf13f3205b9b$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $929faf13f3205b9b$var$removeClass(node, baseClassName);
        if (activeClassName) $929faf13f3205b9b$var$removeClass(node, activeClassName);
        if (doneClassName) $929faf13f3205b9b$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $8pKQA.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, $jDkIp.default), (0, $dpDEA.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component);
$929faf13f3205b9b$var$CSSTransition.defaultProps = {
    classNames: ""
};
$929faf13f3205b9b$var$CSSTransition.propTypes = {};
var $929faf13f3205b9b$export$2e2bcd8739ae039 = $929faf13f3205b9b$var$CSSTransition;

});
parcelRequire.register("jdEcH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfde6adacd9b015f$export$2e2bcd8739ae039; });

var $6UCch = parcelRequire("6UCch");
function $dfde6adacd9b015f$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $6UCch.default)(subClass, superClass);
}

});
parcelRequire.register("6UCch", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50859a28edac1620$export$2e2bcd8739ae039; });
function $50859a28edac1620$export$2e2bcd8739ae039(o, p) {
    $50859a28edac1620$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $50859a28edac1620$export$2e2bcd8739ae039(o, p);
}

});


parcelRequire.register("jmGE5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e19126e9af75eaab$export$2e2bcd8739ae039; });

var $9uzMc = parcelRequire("9uzMc");
function $e19126e9af75eaab$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $9uzMc.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}

});
parcelRequire.register("9uzMc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e92aadc75b4abf4$export$2e2bcd8739ae039; });
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $6e92aadc75b4abf4$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRequire.register("grYah", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf9dd674acfe2810$export$2e2bcd8739ae039; });
function $bf9dd674acfe2810$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $bf9dd674acfe2810$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $bf9dd674acfe2810$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $bf9dd674acfe2810$var$replaceClassName(element.className && element.className.baseVal || "", className));
}

});

parcelRequire.register("jDkIp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4b1ba7c3a6ebf93$export$2e2bcd8739ae039; });

var $8pKQA = parcelRequire("8pKQA");

var $jdEcH = parcelRequire("jdEcH");


var $6cds3 = parcelRequire("6cds3");

var $9nHRL = parcelRequire("9nHRL");

var $h3ijy = parcelRequire("h3ijy");


var $1DzjM = parcelRequire("1DzjM");

var $3VZCd = parcelRequire("3VZCd");
var $e4b1ba7c3a6ebf93$export$bb38bb9a1161268 = "unmounted";
var $e4b1ba7c3a6ebf93$export$84cbff306f539230 = "exited";
var $e4b1ba7c3a6ebf93$export$df38205c966be359 = "entering";
var $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a = "entered";
var $e4b1ba7c3a6ebf93$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $e4b1ba7c3a6ebf93$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $jdEcH.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $e4b1ba7c3a6ebf93$export$84cbff306f539230;
                _this.appearStatus = $e4b1ba7c3a6ebf93$export$df38205c966be359;
            } else initialStatus = $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $e4b1ba7c3a6ebf93$export$bb38bb9a1161268;
        else initialStatus = $e4b1ba7c3a6ebf93$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $e4b1ba7c3a6ebf93$export$bb38bb9a1161268) return {
            status: $e4b1ba7c3a6ebf93$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $e4b1ba7c3a6ebf93$export$df38205c966be359 && status !== $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a) nextStatus = $e4b1ba7c3a6ebf93$export$df38205c966be359;
            } else if (status === $e4b1ba7c3a6ebf93$export$df38205c966be359 || status === $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a) nextStatus = $e4b1ba7c3a6ebf93$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $e4b1ba7c3a6ebf93$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($9nHRL))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $3VZCd.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $e4b1ba7c3a6ebf93$export$84cbff306f539230) this.setState({
            status: $e4b1ba7c3a6ebf93$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($9nHRL))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $h3ijy.default).disabled) {
            this.safeSetState({
                status: $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $e4b1ba7c3a6ebf93$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($9nHRL))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $h3ijy.default).disabled) {
            this.safeSetState({
                status: $e4b1ba7c3a6ebf93$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $e4b1ba7c3a6ebf93$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $e4b1ba7c3a6ebf93$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($9nHRL))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $e4b1ba7c3a6ebf93$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $8pKQA.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, $1DzjM.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component);
$e4b1ba7c3a6ebf93$var$Transition.contextType = (0, $1DzjM.default);
$e4b1ba7c3a6ebf93$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $e4b1ba7c3a6ebf93$var$noop() {}
$e4b1ba7c3a6ebf93$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $e4b1ba7c3a6ebf93$var$noop,
    onEntering: $e4b1ba7c3a6ebf93$var$noop,
    onEntered: $e4b1ba7c3a6ebf93$var$noop,
    onExit: $e4b1ba7c3a6ebf93$var$noop,
    onExiting: $e4b1ba7c3a6ebf93$var$noop,
    onExited: $e4b1ba7c3a6ebf93$var$noop
};
$e4b1ba7c3a6ebf93$var$Transition.UNMOUNTED = $e4b1ba7c3a6ebf93$export$bb38bb9a1161268;
$e4b1ba7c3a6ebf93$var$Transition.EXITED = $e4b1ba7c3a6ebf93$export$84cbff306f539230;
$e4b1ba7c3a6ebf93$var$Transition.ENTERING = $e4b1ba7c3a6ebf93$export$df38205c966be359;
$e4b1ba7c3a6ebf93$var$Transition.ENTERED = $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a;
$e4b1ba7c3a6ebf93$var$Transition.EXITING = $e4b1ba7c3a6ebf93$export$4aacc83d4d59139f;
var $e4b1ba7c3a6ebf93$export$2e2bcd8739ae039 = $e4b1ba7c3a6ebf93$var$Transition;

});
parcelRequire.register("9nHRL", function(module, exports) {
"use strict";
function $6d4849ee44552f5f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6d4849ee44552f5f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6d4849ee44552f5f$var$checkDCE();

module.exports = (parcelRequire("jZA9I"));

});

parcelRequire.register("h3ijy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6a0ec579ecacc40$export$2e2bcd8739ae039; });
var $c6a0ec579ecacc40$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRequire.register("1DzjM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1314d46969e1885b$export$2e2bcd8739ae039; });

var $6cds3 = parcelRequire("6cds3");
var $1314d46969e1885b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext(null);

});

parcelRequire.register("3VZCd", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $2dd67d835621c5d6$export$7d26bbb1236dafd6; });
var $2dd67d835621c5d6$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});



parcelRequire.register("guWa8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c02c908afd2e438e$export$2e2bcd8739ae039; });

var $8pKQA = parcelRequire("8pKQA");

var $dpDEA = parcelRequire("dpDEA");

var $eesxI = parcelRequire("eesxI");

var $jdEcH = parcelRequire("jdEcH");


var $6cds3 = parcelRequire("6cds3");

var $1DzjM = parcelRequire("1DzjM");

var $5Mtxv = parcelRequire("5Mtxv");
var $c02c908afd2e438e$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $c02c908afd2e438e$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $c02c908afd2e438e$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $jdEcH.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $eesxI.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $5Mtxv.getInitialChildMapping)(nextProps, handleExited) : (0, $5Mtxv.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $5Mtxv.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $dpDEA.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $8pKQA.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $c02c908afd2e438e$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, $1DzjM.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, $1DzjM.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component);
$c02c908afd2e438e$var$TransitionGroup.propTypes = {};
$c02c908afd2e438e$var$TransitionGroup.defaultProps = $c02c908afd2e438e$var$defaultProps;
var $c02c908afd2e438e$export$2e2bcd8739ae039 = $c02c908afd2e438e$var$TransitionGroup;

});
parcelRequire.register("eesxI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5c883865d903b3c$export$2e2bcd8739ae039; });
function $a5c883865d903b3c$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRequire.register("5Mtxv", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $43585955694bf078$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $43585955694bf078$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $43585955694bf078$export$36fd1af28d383ec0; });

var $6cds3 = parcelRequire("6cds3");
function $43585955694bf078$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $6cds3.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $6cds3.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $43585955694bf078$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $43585955694bf078$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $43585955694bf078$export$fa71e2345c31d7a2(props, onExited) {
    return $43585955694bf078$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $6cds3.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $43585955694bf078$var$getProp(child, "appear", props),
            enter: $43585955694bf078$var$getProp(child, "enter", props),
            exit: $43585955694bf078$var$getProp(child, "exit", props)
        });
    });
}
function $43585955694bf078$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $43585955694bf078$export$bbc8a025727ea824(nextProps.children);
    var children = $43585955694bf078$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $6cds3.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $6cds3.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $6cds3.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $43585955694bf078$var$getProp(child, "exit", nextProps),
            enter: $43585955694bf078$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $6cds3.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $6cds3.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $6cds3.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $43585955694bf078$var$getProp(child, "exit", nextProps),
            enter: $43585955694bf078$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});


parcelRequire.register("3atEr", function(module, exports) {
"use strict";
function $24e94e5ef0e09958$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $24e94e5ef0e09958$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $24e94e5ef0e09958$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $24e94e5ef0e09958$var$_react = $24e94e5ef0e09958$var$_interopRequireDefault((parcelRequire("6cds3")));

var $24e94e5ef0e09958$var$_propTypes = $24e94e5ef0e09958$var$_interopRequireDefault((parcelRequire("aMJGV")));

var $24e94e5ef0e09958$var$_classnames = $24e94e5ef0e09958$var$_interopRequireDefault((parcelRequire("6PPF0")));
function $24e94e5ef0e09958$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $24e94e5ef0e09958$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $24e94e5ef0e09958$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $24e94e5ef0e09958$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $24e94e5ef0e09958$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $24e94e5ef0e09958$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $24e94e5ef0e09958$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $24e94e5ef0e09958$var$_setPrototypeOf(subClass, superClass);
}
function $24e94e5ef0e09958$var$_setPrototypeOf(o, p) {
    $24e94e5ef0e09958$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $24e94e5ef0e09958$var$_setPrototypeOf(o, p);
}
function $24e94e5ef0e09958$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $24e94e5ef0e09958$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $24e94e5ef0e09958$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $24e94e5ef0e09958$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $24e94e5ef0e09958$var$_possibleConstructorReturn(this, result);
    };
}
function $24e94e5ef0e09958$var$_possibleConstructorReturn(self, call) {
    if (call && ($24e94e5ef0e09958$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $24e94e5ef0e09958$var$_assertThisInitialized(self);
}
function $24e94e5ef0e09958$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $24e94e5ef0e09958$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $24e94e5ef0e09958$var$_getPrototypeOf(o) {
    $24e94e5ef0e09958$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $24e94e5ef0e09958$var$_getPrototypeOf(o);
}
function $24e94e5ef0e09958$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $24e94e5ef0e09958$var$Notification = /*#__PURE__*/ function(_React$Component) {
    $24e94e5ef0e09958$var$_inherits(Notification, _React$Component);
    var _super = $24e94e5ef0e09958$var$_createSuper(Notification);
    function Notification() {
        var _this;
        $24e94e5ef0e09958$var$_classCallCheck(this, Notification);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $24e94e5ef0e09958$var$_defineProperty($24e94e5ef0e09958$var$_assertThisInitialized(_this), "componentDidMount", function() {
            var timeOut = _this.props.timeOut;
            if (timeOut !== 0) _this.timer = setTimeout(_this.requestHide, timeOut);
        });
        $24e94e5ef0e09958$var$_defineProperty($24e94e5ef0e09958$var$_assertThisInitialized(_this), "componentWillUnmount", function() {
            if (_this.timer) clearTimeout(_this.timer);
        });
        $24e94e5ef0e09958$var$_defineProperty($24e94e5ef0e09958$var$_assertThisInitialized(_this), "handleClick", function() {
            var onClick = _this.props.onClick;
            if (onClick) onClick();
            _this.requestHide();
        });
        $24e94e5ef0e09958$var$_defineProperty($24e94e5ef0e09958$var$_assertThisInitialized(_this), "requestHide", function() {
            var onRequestHide = _this.props.onRequestHide;
            if (onRequestHide) onRequestHide();
        });
        return _this;
    }
    $24e94e5ef0e09958$var$_createClass(Notification, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, type = _this$props.type, message = _this$props.message;
                var title = this.props.title;
                var className = (0, $24e94e5ef0e09958$var$_classnames.default)([
                    "notification",
                    "notification-".concat(type)
                ]);
                title = title ? /*#__PURE__*/ $24e94e5ef0e09958$var$_react.default.createElement("h4", {
                    className: "title"
                }, title) : null;
                return /*#__PURE__*/ $24e94e5ef0e09958$var$_react.default.createElement("div", {
                    className: className,
                    onClick: this.handleClick
                }, /*#__PURE__*/ $24e94e5ef0e09958$var$_react.default.createElement("div", {
                    className: "notification-message",
                    role: "alert"
                }, title, /*#__PURE__*/ $24e94e5ef0e09958$var$_react.default.createElement("div", {
                    className: "message"
                }, message)));
            }
        }
    ]);
    return Notification;
}($24e94e5ef0e09958$var$_react.default.Component);
$24e94e5ef0e09958$var$_defineProperty($24e94e5ef0e09958$var$Notification, "propTypes", {
    type: $24e94e5ef0e09958$var$_propTypes.default.oneOf([
        "info",
        "success",
        "warning",
        "error"
    ]),
    title: $24e94e5ef0e09958$var$_propTypes.default.node,
    message: $24e94e5ef0e09958$var$_propTypes.default.node,
    timeOut: $24e94e5ef0e09958$var$_propTypes.default.number,
    onClick: $24e94e5ef0e09958$var$_propTypes.default.func,
    onRequestHide: $24e94e5ef0e09958$var$_propTypes.default.func
});
$24e94e5ef0e09958$var$_defineProperty($24e94e5ef0e09958$var$Notification, "defaultProps", {
    type: "info",
    title: null,
    message: null,
    timeOut: 5000,
    onClick: function onClick() {},
    onRequestHide: function onRequestHide() {}
});
var $24e94e5ef0e09958$var$_default = $24e94e5ef0e09958$var$Notification;
module.exports.default = $24e94e5ef0e09958$var$_default;

});


parcelRequire.register("44AIm", function(module, exports) {
"use strict";
function $2f7403e46e7346a0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2f7403e46e7346a0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2f7403e46e7346a0$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f7403e46e7346a0$var$_react = $2f7403e46e7346a0$var$_interopRequireDefault((parcelRequire("6cds3")));

var $2f7403e46e7346a0$var$_propTypes = $2f7403e46e7346a0$var$_interopRequireDefault((parcelRequire("aMJGV")));

var $2f7403e46e7346a0$var$_NotificationManager = $2f7403e46e7346a0$var$_interopRequireDefault((parcelRequire("diFWH")));

var $2f7403e46e7346a0$var$_Notifications = $2f7403e46e7346a0$var$_interopRequireDefault((parcelRequire("j86fo")));
function $2f7403e46e7346a0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2f7403e46e7346a0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2f7403e46e7346a0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2f7403e46e7346a0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2f7403e46e7346a0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2f7403e46e7346a0$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $2f7403e46e7346a0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $2f7403e46e7346a0$var$_setPrototypeOf(subClass, superClass);
}
function $2f7403e46e7346a0$var$_setPrototypeOf(o, p) {
    $2f7403e46e7346a0$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2f7403e46e7346a0$var$_setPrototypeOf(o, p);
}
function $2f7403e46e7346a0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2f7403e46e7346a0$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $2f7403e46e7346a0$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $2f7403e46e7346a0$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $2f7403e46e7346a0$var$_possibleConstructorReturn(this, result);
    };
}
function $2f7403e46e7346a0$var$_possibleConstructorReturn(self, call) {
    if (call && ($2f7403e46e7346a0$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $2f7403e46e7346a0$var$_assertThisInitialized(self);
}
function $2f7403e46e7346a0$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2f7403e46e7346a0$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $2f7403e46e7346a0$var$_getPrototypeOf(o) {
    $2f7403e46e7346a0$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2f7403e46e7346a0$var$_getPrototypeOf(o);
}
function $2f7403e46e7346a0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $2f7403e46e7346a0$var$NotificationContainer = /*#__PURE__*/ function(_React$Component) {
    $2f7403e46e7346a0$var$_inherits(NotificationContainer, _React$Component);
    var _super = $2f7403e46e7346a0$var$_createSuper(NotificationContainer);
    function NotificationContainer() {
        var _this;
        $2f7403e46e7346a0$var$_classCallCheck(this, NotificationContainer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $2f7403e46e7346a0$var$_defineProperty($2f7403e46e7346a0$var$_assertThisInitialized(_this), "state", {
            notifications: []
        });
        $2f7403e46e7346a0$var$_defineProperty($2f7403e46e7346a0$var$_assertThisInitialized(_this), "componentDidMount", function() {
            $2f7403e46e7346a0$var$_NotificationManager.default.addChangeListener(_this.handleStoreChange);
        });
        $2f7403e46e7346a0$var$_defineProperty($2f7403e46e7346a0$var$_assertThisInitialized(_this), "componentWillUnmount", function() {
            $2f7403e46e7346a0$var$_NotificationManager.default.removeChangeListener(_this.handleStoreChange);
        });
        $2f7403e46e7346a0$var$_defineProperty($2f7403e46e7346a0$var$_assertThisInitialized(_this), "handleStoreChange", function(notifications) {
            _this.setState({
                notifications: notifications
            });
        });
        $2f7403e46e7346a0$var$_defineProperty($2f7403e46e7346a0$var$_assertThisInitialized(_this), "handleRequestHide", function(notification) {
            $2f7403e46e7346a0$var$_NotificationManager.default.remove(notification);
        });
        return _this;
    }
    $2f7403e46e7346a0$var$_createClass(NotificationContainer, [
        {
            key: "render",
            value: function render() {
                var notifications = this.state.notifications;
                var _this$props = this.props, enterTimeout = _this$props.enterTimeout, leaveTimeout = _this$props.leaveTimeout;
                return /*#__PURE__*/ $2f7403e46e7346a0$var$_react.default.createElement($2f7403e46e7346a0$var$_Notifications.default, {
                    enterTimeout: enterTimeout,
                    leaveTimeout: leaveTimeout,
                    notifications: notifications,
                    onRequestHide: this.handleRequestHide
                });
            }
        }
    ]);
    return NotificationContainer;
}($2f7403e46e7346a0$var$_react.default.Component);
$2f7403e46e7346a0$var$_defineProperty($2f7403e46e7346a0$var$NotificationContainer, "propTypes", {
    enterTimeout: $2f7403e46e7346a0$var$_propTypes.default.number,
    leaveTimeout: $2f7403e46e7346a0$var$_propTypes.default.number
});
$2f7403e46e7346a0$var$_defineProperty($2f7403e46e7346a0$var$NotificationContainer, "defaultProps", {
    enterTimeout: 400,
    leaveTimeout: 400
});
var $2f7403e46e7346a0$var$_default = $2f7403e46e7346a0$var$NotificationContainer;
module.exports.default = $2f7403e46e7346a0$var$_default;

});
parcelRequire.register("diFWH", function(module, exports) {
"use strict";
function $9aed7e58471b590f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9aed7e58471b590f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9aed7e58471b590f$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $wvaTc = parcelRequire("wvaTc");
function $9aed7e58471b590f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9aed7e58471b590f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9aed7e58471b590f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9aed7e58471b590f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9aed7e58471b590f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $9aed7e58471b590f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $9aed7e58471b590f$var$_setPrototypeOf(subClass, superClass);
}
function $9aed7e58471b590f$var$_setPrototypeOf(o, p) {
    $9aed7e58471b590f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9aed7e58471b590f$var$_setPrototypeOf(o, p);
}
function $9aed7e58471b590f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9aed7e58471b590f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $9aed7e58471b590f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $9aed7e58471b590f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $9aed7e58471b590f$var$_possibleConstructorReturn(this, result);
    };
}
function $9aed7e58471b590f$var$_possibleConstructorReturn(self, call) {
    if (call && ($9aed7e58471b590f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $9aed7e58471b590f$var$_assertThisInitialized(self);
}
function $9aed7e58471b590f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9aed7e58471b590f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $9aed7e58471b590f$var$_getPrototypeOf(o) {
    $9aed7e58471b590f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9aed7e58471b590f$var$_getPrototypeOf(o);
}
var $9aed7e58471b590f$var$createUUID = function createUUID() {
    var pattern = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
    return pattern.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        var v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
var $9aed7e58471b590f$var$Constants = {
    CHANGE: "change",
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error"
};
var $9aed7e58471b590f$var$NotificationManager = /*#__PURE__*/ function(_EventEmitter) {
    $9aed7e58471b590f$var$_inherits(NotificationManager, _EventEmitter);
    var _super = $9aed7e58471b590f$var$_createSuper(NotificationManager);
    function NotificationManager() {
        var _this;
        $9aed7e58471b590f$var$_classCallCheck(this, NotificationManager);
        _this = _super.call(this);
        _this.listNotify = [];
        return _this;
    }
    $9aed7e58471b590f$var$_createClass(NotificationManager, [
        {
            key: "create",
            value: function create(notify) {
                var defaultNotify = {
                    id: $9aed7e58471b590f$var$createUUID(),
                    type: "info",
                    title: null,
                    message: null,
                    timeOut: 5000
                };
                if (notify.priority) this.listNotify.unshift(Object.assign(defaultNotify, notify));
                else this.listNotify.push(Object.assign(defaultNotify, notify));
                this.emitChange();
            }
        },
        {
            key: "info",
            value: function info(message, title, timeOut, onClick, priority) {
                this.create({
                    type: $9aed7e58471b590f$var$Constants.INFO,
                    message: message,
                    title: title,
                    timeOut: timeOut,
                    onClick: onClick,
                    priority: priority
                });
            }
        },
        {
            key: "success",
            value: function success(message, title, timeOut, onClick, priority) {
                this.create({
                    type: $9aed7e58471b590f$var$Constants.SUCCESS,
                    message: message,
                    title: title,
                    timeOut: timeOut,
                    onClick: onClick,
                    priority: priority
                });
            }
        },
        {
            key: "warning",
            value: function warning(message, title, timeOut, onClick, priority) {
                this.create({
                    type: $9aed7e58471b590f$var$Constants.WARNING,
                    message: message,
                    title: title,
                    timeOut: timeOut,
                    onClick: onClick,
                    priority: priority
                });
            }
        },
        {
            key: "error",
            value: function error(message, title, timeOut, onClick, priority) {
                this.create({
                    type: $9aed7e58471b590f$var$Constants.ERROR,
                    message: message,
                    title: title,
                    timeOut: timeOut,
                    onClick: onClick,
                    priority: priority
                });
            }
        },
        {
            key: "remove",
            value: function remove(notification) {
                this.listNotify = this.listNotify.filter(function(n) {
                    return notification.id !== n.id;
                });
                this.emitChange();
            }
        },
        {
            key: "removeAll",
            value: function removeAll() {
                this.listNotify.length = 0;
                this.emitChange();
            }
        },
        {
            key: "emitChange",
            value: function emitChange() {
                this.emit($9aed7e58471b590f$var$Constants.CHANGE, this.listNotify);
            }
        },
        {
            key: "addChangeListener",
            value: function addChangeListener(callback) {
                this.addListener($9aed7e58471b590f$var$Constants.CHANGE, callback);
            }
        },
        {
            key: "removeChangeListener",
            value: function removeChangeListener(callback) {
                this.removeListener($9aed7e58471b590f$var$Constants.CHANGE, callback);
            }
        }
    ]);
    return NotificationManager;
}($wvaTc.EventEmitter);
var $9aed7e58471b590f$var$_default = new $9aed7e58471b590f$var$NotificationManager();
module.exports.default = $9aed7e58471b590f$var$_default;

});


parcelRequire.register("kkbyb", function(module, exports) {



module.exports = (parcelRequire("9FZDf"))((parcelRequire("17QCl")).getBundleURL("6pKNL") + (parcelRequire("lGKbD")).resolve("e2YVh")).then(()=>parcelRequire("WT8Rb"));

});
parcelRequire.register("9FZDf", function(module, exports) {
"use strict";

var $9jW6n = parcelRequire("9jW6n");
module.exports = $9jW6n(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRequire.register("9jW6n", function(module, exports) {
"use strict";
var $6c92f53da2785287$var$cachedBundles = {};
var $6c92f53da2785287$var$cachedPreloads = {};
var $6c92f53da2785287$var$cachedPrefetches = {};
function $6c92f53da2785287$var$getCache(type) {
    switch(type){
        case "preload":
            return $6c92f53da2785287$var$cachedPreloads;
        case "prefetch":
            return $6c92f53da2785287$var$cachedPrefetches;
        default:
            return $6c92f53da2785287$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $6c92f53da2785287$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRequire.register("17QCl", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $0d1f42a1cefd465e$export$bdfd709ae4826697; }, function (v) { return $0d1f42a1cefd465e$export$bdfd709ae4826697 = v; });
var $0d1f42a1cefd465e$export$bdfd709ae4826697;
var $0d1f42a1cefd465e$export$c9e73fbda7da57b6;
var $0d1f42a1cefd465e$export$5a759dc7a1cfb72a;
"use strict";
var $0d1f42a1cefd465e$var$bundleURL = {};
function $0d1f42a1cefd465e$var$getBundleURLCached(id) {
    var value = $0d1f42a1cefd465e$var$bundleURL[id];
    if (!value) {
        value = $0d1f42a1cefd465e$var$getBundleURL();
        $0d1f42a1cefd465e$var$bundleURL[id] = value;
    }
    return value;
}
function $0d1f42a1cefd465e$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $0d1f42a1cefd465e$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $0d1f42a1cefd465e$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $0d1f42a1cefd465e$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$0d1f42a1cefd465e$export$bdfd709ae4826697 = $0d1f42a1cefd465e$var$getBundleURLCached;
$0d1f42a1cefd465e$export$c9e73fbda7da57b6 = $0d1f42a1cefd465e$var$getBaseURL;
$0d1f42a1cefd465e$export$5a759dc7a1cfb72a = $0d1f42a1cefd465e$var$getOrigin;

});



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
var $64d0b1ebdd6bcffe$exports = {};

$parcel$export($64d0b1ebdd6bcffe$exports, "createRoot", function () { return $64d0b1ebdd6bcffe$export$882461b6382ed46c; }, function (v) { return $64d0b1ebdd6bcffe$export$882461b6382ed46c = v; });
$parcel$export($64d0b1ebdd6bcffe$exports, "hydrateRoot", function () { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e; }, function (v) { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e = v; });
var $64d0b1ebdd6bcffe$export$882461b6382ed46c;
var $64d0b1ebdd6bcffe$export$757ceba2d55c277e;
"use strict";

var $9nHRL = parcelRequire("9nHRL");
var $64d0b1ebdd6bcffe$var$i;
$64d0b1ebdd6bcffe$export$882461b6382ed46c = $9nHRL.createRoot;
$64d0b1ebdd6bcffe$export$757ceba2d55c277e = $9nHRL.hydrateRoot;



var $lBpE3 = parcelRequire("lBpE3");

var $jdEcH = parcelRequire("jdEcH");

var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");

var $dpDEA = parcelRequire("dpDEA");
function $ca9322de911282f3$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $ca9322de911282f3$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $ca9322de911282f3$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $ca9322de911282f3$var$isAbsolute(to);
    var isFromAbs = from && $ca9322de911282f3$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $ca9322de911282f3$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $ca9322de911282f3$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $ca9322de911282f3$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $ca9322de911282f3$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$ca9322de911282f3$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $ca9322de911282f3$export$2e2bcd8739ae039 = $ca9322de911282f3$var$resolvePathname;


function $e0279e3ba0bd87f3$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $e0279e3ba0bd87f3$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $e0279e3ba0bd87f3$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $e0279e3ba0bd87f3$var$valueOf(a);
        var bValue = $e0279e3ba0bd87f3$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $e0279e3ba0bd87f3$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $e0279e3ba0bd87f3$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $e0279e3ba0bd87f3$export$2e2bcd8739ae039 = $e0279e3ba0bd87f3$var$valueEqual;



var $ad70c57529687670$var$isProduction = true;
var $ad70c57529687670$var$prefix = "Invariant failed";
function $ad70c57529687670$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($ad70c57529687670$var$isProduction) throw new Error($ad70c57529687670$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($ad70c57529687670$var$prefix, ": ").concat(provided) : $ad70c57529687670$var$prefix;
    throw new Error(value);
}


function $ef809a76356144ca$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $ef809a76356144ca$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $ef809a76356144ca$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $ef809a76356144ca$var$stripBasename(path, prefix) {
    return $ef809a76356144ca$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $ef809a76356144ca$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $ef809a76356144ca$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $ef809a76356144ca$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $ef809a76356144ca$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $ef809a76356144ca$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $dpDEA.default)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $ca9322de911282f3$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $ef809a76356144ca$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $e0279e3ba0bd87f3$export$2e2bcd8739ae039)(a.state, b.state);
}
function $ef809a76356144ca$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $ef809a76356144ca$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $ef809a76356144ca$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $ef809a76356144ca$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $ef809a76356144ca$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $ef809a76356144ca$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $ef809a76356144ca$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $ef809a76356144ca$var$PopStateEvent = "popstate";
var $ef809a76356144ca$var$HashChangeEvent = "hashchange";
function $ef809a76356144ca$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $ef809a76356144ca$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$ef809a76356144ca$var$canUseDOM && (0, $ad70c57529687670$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $ef809a76356144ca$var$supportsHistory();
    var needsHashChangeListener = !$ef809a76356144ca$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $ef809a76356144ca$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $ef809a76356144ca$var$stripTrailingSlash($ef809a76356144ca$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $ef809a76356144ca$var$stripBasename(path, basename);
        return $ef809a76356144ca$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $ef809a76356144ca$var$createTransitionManager();
    function setState(nextState) {
        (0, $dpDEA.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($ef809a76356144ca$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($ef809a76356144ca$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($ef809a76356144ca$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $ef809a76356144ca$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $ef809a76356144ca$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $ef809a76356144ca$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($ef809a76356144ca$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($ef809a76356144ca$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($ef809a76356144ca$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($ef809a76356144ca$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $ef809a76356144ca$var$HashChangeEvent$1 = "hashchange";
var $ef809a76356144ca$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $ef809a76356144ca$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $ef809a76356144ca$var$stripLeadingSlash,
        decodePath: $ef809a76356144ca$var$addLeadingSlash
    },
    slash: {
        encodePath: $ef809a76356144ca$var$addLeadingSlash,
        decodePath: $ef809a76356144ca$var$addLeadingSlash
    }
};
function $ef809a76356144ca$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $ef809a76356144ca$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $ef809a76356144ca$var$pushHashPath(path) {
    window.location.hash = path;
}
function $ef809a76356144ca$var$replaceHashPath(path) {
    window.location.replace($ef809a76356144ca$var$stripHash(window.location.href) + "#" + path);
}
function $ef809a76356144ca$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$ef809a76356144ca$var$canUseDOM && (0, $ad70c57529687670$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $ef809a76356144ca$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $ef809a76356144ca$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $ef809a76356144ca$var$stripTrailingSlash($ef809a76356144ca$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $ef809a76356144ca$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($ef809a76356144ca$var$getHashPath());
        if (basename) path = $ef809a76356144ca$var$stripBasename(path, basename);
        return $ef809a76356144ca$export$90c043f1c57770b8(path);
    }
    var transitionManager = $ef809a76356144ca$var$createTransitionManager();
    function setState(nextState) {
        (0, $dpDEA.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $ef809a76356144ca$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $ef809a76356144ca$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $ef809a76356144ca$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($ef809a76356144ca$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($ef809a76356144ca$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $ef809a76356144ca$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $ef809a76356144ca$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $ef809a76356144ca$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $ef809a76356144ca$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $ef809a76356144ca$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $ef809a76356144ca$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $ef809a76356144ca$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $ef809a76356144ca$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $ef809a76356144ca$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($ef809a76356144ca$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $ef809a76356144ca$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $ef809a76356144ca$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $ef809a76356144ca$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $ef809a76356144ca$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($ef809a76356144ca$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($ef809a76356144ca$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($ef809a76356144ca$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $ef809a76356144ca$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $ef809a76356144ca$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $ef809a76356144ca$var$createTransitionManager();
    function setState(nextState) {
        (0, $dpDEA.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $ef809a76356144ca$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $ef809a76356144ca$export$90c043f1c57770b8(entry, undefined, createKey()) : $ef809a76356144ca$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $ef809a76356144ca$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $ef809a76356144ca$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $ef809a76356144ca$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $ef809a76356144ca$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $dpDEA = parcelRequire("dpDEA");
var $ce5cb9317b61557c$exports = {};
var $53b41161ed26c542$exports = {};
$53b41161ed26c542$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};


/**
 * Expose `pathToRegexp`.
 */ $ce5cb9317b61557c$exports = $ce5cb9317b61557c$var$pathToRegexp;
$ce5cb9317b61557c$exports.parse = $ce5cb9317b61557c$var$parse;
$ce5cb9317b61557c$exports.compile = $ce5cb9317b61557c$var$compile;
$ce5cb9317b61557c$exports.tokensToFunction = $ce5cb9317b61557c$var$tokensToFunction;
$ce5cb9317b61557c$exports.tokensToRegExp = $ce5cb9317b61557c$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $ce5cb9317b61557c$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $ce5cb9317b61557c$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $ce5cb9317b61557c$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $ce5cb9317b61557c$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $ce5cb9317b61557c$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $ce5cb9317b61557c$var$compile(str, options) {
    return $ce5cb9317b61557c$var$tokensToFunction($ce5cb9317b61557c$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $ce5cb9317b61557c$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $ce5cb9317b61557c$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $ce5cb9317b61557c$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $ce5cb9317b61557c$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $ce5cb9317b61557c$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($53b41161ed26c542$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $ce5cb9317b61557c$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $ce5cb9317b61557c$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $ce5cb9317b61557c$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $ce5cb9317b61557c$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $ce5cb9317b61557c$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $ce5cb9317b61557c$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $ce5cb9317b61557c$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $ce5cb9317b61557c$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($ce5cb9317b61557c$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $ce5cb9317b61557c$var$flags(options));
    return $ce5cb9317b61557c$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $ce5cb9317b61557c$var$stringToRegexp(path, keys, options) {
    return $ce5cb9317b61557c$var$tokensToRegExp($ce5cb9317b61557c$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $ce5cb9317b61557c$var$tokensToRegExp(tokens, keys, options) {
    if (!$53b41161ed26c542$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $ce5cb9317b61557c$var$escapeString(token);
        else {
            var prefix = $ce5cb9317b61557c$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $ce5cb9317b61557c$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $ce5cb9317b61557c$var$attachKeys(new RegExp("^" + route, $ce5cb9317b61557c$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $ce5cb9317b61557c$var$pathToRegexp(path, keys, options) {
    if (!$53b41161ed26c542$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $ce5cb9317b61557c$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($53b41161ed26c542$exports(path)) return $ce5cb9317b61557c$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $ce5cb9317b61557c$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $16a6a6aaf933aa74$exports = {};
"use strict";

$16a6a6aaf933aa74$exports = (parcelRequire("7Im6f"));



var $8pKQA = parcelRequire("8pKQA");

var $f1S4k = parcelRequire("f1S4k");
var $cff2dc0cc7b954fc$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $cff2dc0cc7b954fc$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $cff2dc0cc7b954fc$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $cff2dc0cc7b954fc$var$commonjsGlobal[key] = ($cff2dc0cc7b954fc$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $cff2dc0cc7b954fc$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $cff2dc0cc7b954fc$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $cff2dc0cc7b954fc$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $cff2dc0cc7b954fc$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $cff2dc0cc7b954fc$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $jdEcH.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $cff2dc0cc7b954fc$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($cff2dc0cc7b954fc$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $cff2dc0cc7b954fc$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $jdEcH.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $cff2dc0cc7b954fc$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $cff2dc0cc7b954fc$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $cff2dc0cc7b954fc$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $cff2dc0cc7b954fc$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext || $cff2dc0cc7b954fc$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $cff2dc0cc7b954fc$var$createNamedContext = function createNamedContext(name) {
    var context = $cff2dc0cc7b954fc$var$createContext();
    context.displayName = name;
    return context;
};
var $cff2dc0cc7b954fc$export$c213558b66925821 = /*#__PURE__*/ $cff2dc0cc7b954fc$var$createNamedContext("Router-History");
var $cff2dc0cc7b954fc$export$63baa8ccbe60bb07 = /*#__PURE__*/ $cff2dc0cc7b954fc$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $cff2dc0cc7b954fc$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $jdEcH.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($cff2dc0cc7b954fc$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($cff2dc0cc7b954fc$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $cff2dc0cc7b954fc$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $jdEcH.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $ef809a76356144ca$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($cff2dc0cc7b954fc$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component);
var $cff2dc0cc7b954fc$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $jdEcH.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $cff2dc0cc7b954fc$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($cff2dc0cc7b954fc$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $ad70c57529687670$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($cff2dc0cc7b954fc$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $cff2dc0cc7b954fc$var$messageType;
var $cff2dc0cc7b954fc$var$cache = {};
var $cff2dc0cc7b954fc$var$cacheLimit = 10000;
var $cff2dc0cc7b954fc$var$cacheCount = 0;
function $cff2dc0cc7b954fc$var$compilePath(path) {
    if ($cff2dc0cc7b954fc$var$cache[path]) return $cff2dc0cc7b954fc$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($ce5cb9317b61557c$exports))).compile(path);
    if ($cff2dc0cc7b954fc$var$cacheCount < $cff2dc0cc7b954fc$var$cacheLimit) {
        $cff2dc0cc7b954fc$var$cache[path] = generator;
        $cff2dc0cc7b954fc$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $cff2dc0cc7b954fc$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $cff2dc0cc7b954fc$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $cff2dc0cc7b954fc$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($cff2dc0cc7b954fc$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $ad70c57529687670$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $ef809a76356144ca$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $cff2dc0cc7b954fc$export$82476f982757e71e(to, computedMatch.params) : (0, $dpDEA.default)({}, to, {
            pathname: $cff2dc0cc7b954fc$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($cff2dc0cc7b954fc$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $ef809a76356144ca$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $ef809a76356144ca$export$c3e8bb440bd55b18)(prevLocation, (0, $dpDEA.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $cff2dc0cc7b954fc$var$cache$1 = {};
var $cff2dc0cc7b954fc$var$cacheLimit$1 = 10000;
var $cff2dc0cc7b954fc$var$cacheCount$1 = 0;
function $cff2dc0cc7b954fc$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $cff2dc0cc7b954fc$var$cache$1[cacheKey] || ($cff2dc0cc7b954fc$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($ce5cb9317b61557c$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($cff2dc0cc7b954fc$var$cacheCount$1 < $cff2dc0cc7b954fc$var$cacheLimit$1) {
        pathCache[path] = result;
        $cff2dc0cc7b954fc$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $cff2dc0cc7b954fc$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $cff2dc0cc7b954fc$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $cff2dc0cc7b954fc$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Children.count(children) === 0;
}
function $cff2dc0cc7b954fc$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $cff2dc0cc7b954fc$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $jdEcH.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($cff2dc0cc7b954fc$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $ad70c57529687670$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $cff2dc0cc7b954fc$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $dpDEA.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $cff2dc0cc7b954fc$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($cff2dc0cc7b954fc$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component);
function $cff2dc0cc7b954fc$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $cff2dc0cc7b954fc$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $dpDEA.default)({}, location, {
        pathname: $cff2dc0cc7b954fc$var$addLeadingSlash(basename) + location.pathname
    });
}
function $cff2dc0cc7b954fc$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $cff2dc0cc7b954fc$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $dpDEA.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $cff2dc0cc7b954fc$var$createURL(location) {
    return typeof location === "string" ? location : (0, $ef809a76356144ca$export$fe53371bee54353d)(location);
}
function $cff2dc0cc7b954fc$var$staticHandler(methodName) {
    return function() {
        (0, $ad70c57529687670$export$2e2bcd8739ae039)(false);
    };
}
function $cff2dc0cc7b954fc$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $cff2dc0cc7b954fc$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $jdEcH.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $cff2dc0cc7b954fc$var$noop;
        };
        _this.handleBlock = function() {
            return $cff2dc0cc7b954fc$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $cff2dc0cc7b954fc$var$addBasename(basename, (0, $ef809a76356144ca$export$90c043f1c57770b8)(location));
        context.url = $cff2dc0cc7b954fc$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $8pKQA.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $cff2dc0cc7b954fc$var$addLeadingSlash(basename + $cff2dc0cc7b954fc$var$createURL(path));
            },
            action: "POP",
            location: $cff2dc0cc7b954fc$var$stripBasename(basename, (0, $ef809a76356144ca$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $cff2dc0cc7b954fc$var$staticHandler("go"),
            goBack: $cff2dc0cc7b954fc$var$staticHandler("goBack"),
            goForward: $cff2dc0cc7b954fc$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($cff2dc0cc7b954fc$export$55185c17a0fcbe46, (0, $dpDEA.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $cff2dc0cc7b954fc$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $jdEcH.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($cff2dc0cc7b954fc$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $ad70c57529687670$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $cff2dc0cc7b954fc$export$81336c211d5ff295(location.pathname, (0, $dpDEA.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $cff2dc0cc7b954fc$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $8pKQA.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($cff2dc0cc7b954fc$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $ad70c57529687670$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(Component, (0, $dpDEA.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1S4k)))(C, Component);
}
var $cff2dc0cc7b954fc$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useContext;
function $cff2dc0cc7b954fc$export$3420e1dc2c4a518c() {
    return $cff2dc0cc7b954fc$var$useContext($cff2dc0cc7b954fc$export$c213558b66925821);
}
function $cff2dc0cc7b954fc$export$45d76561a5302f2b() {
    return $cff2dc0cc7b954fc$var$useContext($cff2dc0cc7b954fc$export$63baa8ccbe60bb07).location;
}
function $cff2dc0cc7b954fc$export$99eaa27ddbbb95ef() {
    var match = $cff2dc0cc7b954fc$var$useContext($cff2dc0cc7b954fc$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $cff2dc0cc7b954fc$export$632be4bb944c1bc7(path) {
    var location = $cff2dc0cc7b954fc$export$45d76561a5302f2b();
    var match = $cff2dc0cc7b954fc$var$useContext($cff2dc0cc7b954fc$export$63baa8ccbe60bb07).match;
    return path ? $cff2dc0cc7b954fc$export$81336c211d5ff295(location.pathname, path) : match;
}
var $cff2dc0cc7b954fc$var$global$1, $cff2dc0cc7b954fc$var$key, $cff2dc0cc7b954fc$var$buildNames, $cff2dc0cc7b954fc$var$initialBuildName, $cff2dc0cc7b954fc$var$secondaryBuildName;



var $jdEcH = parcelRequire("jdEcH");

var $6cds3 = parcelRequire("6cds3");




var $dpDEA = parcelRequire("dpDEA");

var $8pKQA = parcelRequire("8pKQA");

/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $60fd0126d8b57f34$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $jdEcH.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $ef809a76356144ca$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, $cff2dc0cc7b954fc$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $60fd0126d8b57f34$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $jdEcH.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $ef809a76356144ca$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, $cff2dc0cc7b954fc$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component);
var $60fd0126d8b57f34$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $60fd0126d8b57f34$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $ef809a76356144ca$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $60fd0126d8b57f34$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $60fd0126d8b57f34$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).forwardRef;
if (typeof $60fd0126d8b57f34$var$forwardRef === "undefined") $60fd0126d8b57f34$var$forwardRef = $60fd0126d8b57f34$var$forwardRefShim;
function $60fd0126d8b57f34$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $60fd0126d8b57f34$var$LinkAnchor = $60fd0126d8b57f34$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $8pKQA.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $dpDEA.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$60fd0126d8b57f34$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($60fd0126d8b57f34$var$forwardRefShim !== $60fd0126d8b57f34$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $60fd0126d8b57f34$export$a6c7ac8248d6e38a = $60fd0126d8b57f34$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $60fd0126d8b57f34$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $8pKQA.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, $cff2dc0cc7b954fc$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $ad70c57529687670$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $60fd0126d8b57f34$var$normalizeToLocation($60fd0126d8b57f34$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $dpDEA.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $60fd0126d8b57f34$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $ef809a76356144ca$export$fe53371bee54353d)(context.location) === (0, $ef809a76356144ca$export$fe53371bee54353d)($60fd0126d8b57f34$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($60fd0126d8b57f34$var$forwardRefShim !== $60fd0126d8b57f34$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(component, props);
    });
});
var $60fd0126d8b57f34$var$toType, $60fd0126d8b57f34$var$refType;
var $60fd0126d8b57f34$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $60fd0126d8b57f34$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).forwardRef;
if (typeof $60fd0126d8b57f34$var$forwardRef$1 === "undefined") $60fd0126d8b57f34$var$forwardRef$1 = $60fd0126d8b57f34$var$forwardRefShim$1;
function $60fd0126d8b57f34$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $60fd0126d8b57f34$export$b0d92dbee9b5b60d = $60fd0126d8b57f34$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $8pKQA.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, $cff2dc0cc7b954fc$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $ad70c57529687670$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $60fd0126d8b57f34$var$normalizeToLocation($60fd0126d8b57f34$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $cff2dc0cc7b954fc$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $60fd0126d8b57f34$var$joinClassnames(className, activeClassName);
            style = (0, $dpDEA.default)({}, style, activeStyle);
        }
        var props = (0, $dpDEA.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($60fd0126d8b57f34$var$forwardRefShim$1 !== $60fd0126d8b57f34$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($60fd0126d8b57f34$export$a6c7ac8248d6e38a, props);
    });
});
var $60fd0126d8b57f34$var$ariaCurrentType;




var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

function $3b4e05b540ea4d30$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
// Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
var $3b4e05b540ea4d30$var$hasPassiveEvents = false;
if (typeof window !== "undefined") {
    var $3b4e05b540ea4d30$var$passiveTestOptions = {
        get passive () {
            $3b4e05b540ea4d30$var$hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener("testPassive", null, $3b4e05b540ea4d30$var$passiveTestOptions);
    window.removeEventListener("testPassive", null, $3b4e05b540ea4d30$var$passiveTestOptions);
}
var $3b4e05b540ea4d30$var$isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
var $3b4e05b540ea4d30$var$locks = [];
var $3b4e05b540ea4d30$var$documentListenerAdded = false;
var $3b4e05b540ea4d30$var$initialClientY = -1;
var $3b4e05b540ea4d30$var$previousBodyOverflowSetting = void 0;
var $3b4e05b540ea4d30$var$previousBodyPaddingRight = void 0;
// returns true if `el` should be allowed to receive touchmove events.
var $3b4e05b540ea4d30$var$allowTouchMove = function allowTouchMove(el) {
    return $3b4e05b540ea4d30$var$locks.some(function(lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
};
var $3b4e05b540ea4d30$var$preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if ($3b4e05b540ea4d30$var$allowTouchMove(e.target)) return true;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
var $3b4e05b540ea4d30$var$setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if ($3b4e05b540ea4d30$var$previousBodyPaddingRight === undefined) {
        var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        if (_reserveScrollBarGap && scrollBarGap > 0) {
            $3b4e05b540ea4d30$var$previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = scrollBarGap + "px";
        }
    }
    // If previousBodyOverflowSetting is already set, don't set it again.
    if ($3b4e05b540ea4d30$var$previousBodyOverflowSetting === undefined) {
        $3b4e05b540ea4d30$var$previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = "hidden";
    }
};
var $3b4e05b540ea4d30$var$restoreOverflowSetting = function restoreOverflowSetting() {
    if ($3b4e05b540ea4d30$var$previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = $3b4e05b540ea4d30$var$previousBodyPaddingRight;
        // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
        // can be set again.
        $3b4e05b540ea4d30$var$previousBodyPaddingRight = undefined;
    }
    if ($3b4e05b540ea4d30$var$previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = $3b4e05b540ea4d30$var$previousBodyOverflowSetting;
        // Restore previousBodyOverflowSetting to undefined
        // so setOverflowHidden knows it can be set again.
        $3b4e05b540ea4d30$var$previousBodyOverflowSetting = undefined;
    }
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var $3b4e05b540ea4d30$var$isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var $3b4e05b540ea4d30$var$handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - $3b4e05b540ea4d30$var$initialClientY;
    if ($3b4e05b540ea4d30$var$allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) // element is at the top of its scroll.
    return $3b4e05b540ea4d30$var$preventDefault(event);
    if ($3b4e05b540ea4d30$var$isTargetElementTotallyScrolled(targetElement) && clientY < 0) // element is at the bottom of its scroll.
    return $3b4e05b540ea4d30$var$preventDefault(event);
    event.stopPropagation();
    return true;
};
var $3b4e05b540ea4d30$export$24fdf68abf432c44 = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
        return;
    }
    // disableBodyScroll must not have been called on this targetElement before
    if ($3b4e05b540ea4d30$var$locks.some(function(lock) {
        return lock.targetElement === targetElement;
    })) return;
    var lock = {
        targetElement: targetElement,
        options: options || {}
    };
    $3b4e05b540ea4d30$var$locks = [].concat($3b4e05b540ea4d30$var$_toConsumableArray($3b4e05b540ea4d30$var$locks), [
        lock
    ]);
    if ($3b4e05b540ea4d30$var$isIosDevice) {
        targetElement.ontouchstart = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $3b4e05b540ea4d30$var$initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $3b4e05b540ea4d30$var$handleScroll(event, targetElement);
        };
        if (!$3b4e05b540ea4d30$var$documentListenerAdded) {
            document.addEventListener("touchmove", $3b4e05b540ea4d30$var$preventDefault, $3b4e05b540ea4d30$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $3b4e05b540ea4d30$var$documentListenerAdded = true;
        }
    } else $3b4e05b540ea4d30$var$setOverflowHidden(options);
};
var $3b4e05b540ea4d30$export$45a3ef215b2a5866 = function clearAllBodyScrollLocks() {
    if ($3b4e05b540ea4d30$var$isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        $3b4e05b540ea4d30$var$locks.forEach(function(lock) {
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if ($3b4e05b540ea4d30$var$documentListenerAdded) {
            document.removeEventListener("touchmove", $3b4e05b540ea4d30$var$preventDefault, $3b4e05b540ea4d30$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $3b4e05b540ea4d30$var$documentListenerAdded = false;
        }
        // Reset initial clientY.
        $3b4e05b540ea4d30$var$initialClientY = -1;
    } else $3b4e05b540ea4d30$var$restoreOverflowSetting();
    $3b4e05b540ea4d30$var$locks = [];
};
var $3b4e05b540ea4d30$export$e5d0524c3725571e = function enableBodyScroll(targetElement) {
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
        return;
    }
    $3b4e05b540ea4d30$var$locks = $3b4e05b540ea4d30$var$locks.filter(function(lock) {
        return lock.targetElement !== targetElement;
    });
    if ($3b4e05b540ea4d30$var$isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if ($3b4e05b540ea4d30$var$documentListenerAdded && $3b4e05b540ea4d30$var$locks.length === 0) {
            document.removeEventListener("touchmove", $3b4e05b540ea4d30$var$preventDefault, $3b4e05b540ea4d30$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $3b4e05b540ea4d30$var$documentListenerAdded = false;
        }
    } else if (!$3b4e05b540ea4d30$var$locks.length) $3b4e05b540ea4d30$var$restoreOverflowSetting();
};


var $59054c12ba7db3de$exports = {};

$parcel$export($59054c12ba7db3de$exports, "chat", function () { return $59054c12ba7db3de$export$530dccc8e24f4e99; }, function (v) { return $59054c12ba7db3de$export$530dccc8e24f4e99 = v; });
$parcel$export($59054c12ba7db3de$exports, "column_center", function () { return $59054c12ba7db3de$export$882ddcfbacbf9bdf; }, function (v) { return $59054c12ba7db3de$export$882ddcfbacbf9bdf = v; });
$parcel$export($59054c12ba7db3de$exports, "column_left", function () { return $59054c12ba7db3de$export$cf599b742fd67a71; }, function (v) { return $59054c12ba7db3de$export$cf599b742fd67a71 = v; });
$parcel$export($59054c12ba7db3de$exports, "column_right", function () { return $59054c12ba7db3de$export$f3c3342da659e49e; }, function (v) { return $59054c12ba7db3de$export$f3c3342da659e49e = v; });
$parcel$export($59054c12ba7db3de$exports, "hide", function () { return $59054c12ba7db3de$export$fe8985bb6374093c; }, function (v) { return $59054c12ba7db3de$export$fe8985bb6374093c = v; });
$parcel$export($59054c12ba7db3de$exports, "inner", function () { return $59054c12ba7db3de$export$4ae363f1d88fb658; }, function (v) { return $59054c12ba7db3de$export$4ae363f1d88fb658 = v; });
$parcel$export($59054c12ba7db3de$exports, "page", function () { return $59054c12ba7db3de$export$523fb3936f49e028; }, function (v) { return $59054c12ba7db3de$export$523fb3936f49e028 = v; });
$parcel$export($59054c12ba7db3de$exports, "side_section", function () { return $59054c12ba7db3de$export$43cca40f8f5ea3ad; }, function (v) { return $59054c12ba7db3de$export$43cca40f8f5ea3ad = v; });
var $59054c12ba7db3de$export$530dccc8e24f4e99;
var $59054c12ba7db3de$export$882ddcfbacbf9bdf;
var $59054c12ba7db3de$export$cf599b742fd67a71;
var $59054c12ba7db3de$export$f3c3342da659e49e;
var $59054c12ba7db3de$export$fe8985bb6374093c;
var $59054c12ba7db3de$export$4ae363f1d88fb658;
var $59054c12ba7db3de$export$523fb3936f49e028;
var $59054c12ba7db3de$export$43cca40f8f5ea3ad;
$59054c12ba7db3de$export$530dccc8e24f4e99 = `nKf_FG_chat`;
$59054c12ba7db3de$export$882ddcfbacbf9bdf = `nKf_FG_column_center`;
$59054c12ba7db3de$export$cf599b742fd67a71 = `nKf_FG_column_left`;
$59054c12ba7db3de$export$f3c3342da659e49e = `nKf_FG_column_right`;
$59054c12ba7db3de$export$fe8985bb6374093c = `nKf_FG_hide`;
$59054c12ba7db3de$export$4ae363f1d88fb658 = `nKf_FG_inner`;
$59054c12ba7db3de$export$523fb3936f49e028 = `nKf_FG_page`;
$59054c12ba7db3de$export$43cca40f8f5ea3ad = `nKf_FG_side_section`;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $6PPF0 = parcelRequire("6PPF0");
var $32173854adf97353$exports = {};

$parcel$export($32173854adf97353$exports, "active", function () { return $32173854adf97353$export$89da14300d534261; }, function (v) { return $32173854adf97353$export$89da14300d534261 = v; });
$parcel$export($32173854adf97353$exports, "burger", function () { return $32173854adf97353$export$9f42c466da956b3; }, function (v) { return $32173854adf97353$export$9f42c466da956b3 = v; });
$parcel$export($32173854adf97353$exports, "button", function () { return $32173854adf97353$export$2ba01fb71ed41cb6; }, function (v) { return $32173854adf97353$export$2ba01fb71ed41cb6 = v; });
$parcel$export($32173854adf97353$exports, "center", function () { return $32173854adf97353$export$3481c78889e8fbe8; }, function (v) { return $32173854adf97353$export$3481c78889e8fbe8 = v; });
$parcel$export($32173854adf97353$exports, "chatIcons", function () { return $32173854adf97353$export$b155c7424ba89ad7; }, function (v) { return $32173854adf97353$export$b155c7424ba89ad7 = v; });
$parcel$export($32173854adf97353$exports, "fixedContainer", function () { return $32173854adf97353$export$fc66f88975b715ac; }, function (v) { return $32173854adf97353$export$fc66f88975b715ac = v; });
$parcel$export($32173854adf97353$exports, "header_zone", function () { return $32173854adf97353$export$73e837fc0db8b511; }, function (v) { return $32173854adf97353$export$73e837fc0db8b511 = v; });
$parcel$export($32173854adf97353$exports, "iconsContainer", function () { return $32173854adf97353$export$94cec53e3205acbe; }, function (v) { return $32173854adf97353$export$94cec53e3205acbe = v; });
$parcel$export($32173854adf97353$exports, "input", function () { return $32173854adf97353$export$b7e3ae3d7c15e42e; }, function (v) { return $32173854adf97353$export$b7e3ae3d7c15e42e = v; });
$parcel$export($32173854adf97353$exports, "left", function () { return $32173854adf97353$export$eabcd2c8791e7bf4; }, function (v) { return $32173854adf97353$export$eabcd2c8791e7bf4 = v; });
$parcel$export($32173854adf97353$exports, "link", function () { return $32173854adf97353$export$9c30223ca0a664fb; }, function (v) { return $32173854adf97353$export$9c30223ca0a664fb = v; });
$parcel$export($32173854adf97353$exports, "logo", function () { return $32173854adf97353$export$db3c28d99448dcff; }, function (v) { return $32173854adf97353$export$db3c28d99448dcff = v; });
$parcel$export($32173854adf97353$exports, "nav", function () { return $32173854adf97353$export$80e4b313e5e6b30d; }, function (v) { return $32173854adf97353$export$80e4b313e5e6b30d = v; });
$parcel$export($32173854adf97353$exports, "news", function () { return $32173854adf97353$export$df4cb166265252c7; }, function (v) { return $32173854adf97353$export$df4cb166265252c7 = v; });
$parcel$export($32173854adf97353$exports, "newsicon", function () { return $32173854adf97353$export$b71f7583e3491ee7; }, function (v) { return $32173854adf97353$export$b71f7583e3491ee7 = v; });
$parcel$export($32173854adf97353$exports, "result", function () { return $32173854adf97353$export$aaf36426b5008f7a; }, function (v) { return $32173854adf97353$export$aaf36426b5008f7a = v; });
$parcel$export($32173854adf97353$exports, "right", function () { return $32173854adf97353$export$79ffe56a765070d2; }, function (v) { return $32173854adf97353$export$79ffe56a765070d2 = v; });
$parcel$export($32173854adf97353$exports, "search", function () { return $32173854adf97353$export$d76128d007d19019; }, function (v) { return $32173854adf97353$export$d76128d007d19019 = v; });
$parcel$export($32173854adf97353$exports, "searchInputMobile", function () { return $32173854adf97353$export$522f52afb9cc955f; }, function (v) { return $32173854adf97353$export$522f52afb9cc955f = v; });
$parcel$export($32173854adf97353$exports, "wrapper", function () { return $32173854adf97353$export$cc74dcc53cfce4eb; }, function (v) { return $32173854adf97353$export$cc74dcc53cfce4eb = v; });
var $32173854adf97353$export$89da14300d534261;
var $32173854adf97353$export$9f42c466da956b3;
var $32173854adf97353$export$2ba01fb71ed41cb6;
var $32173854adf97353$export$3481c78889e8fbe8;
var $32173854adf97353$export$b155c7424ba89ad7;
var $32173854adf97353$export$fc66f88975b715ac;
var $32173854adf97353$export$73e837fc0db8b511;
var $32173854adf97353$export$94cec53e3205acbe;
var $32173854adf97353$export$b7e3ae3d7c15e42e;
var $32173854adf97353$export$eabcd2c8791e7bf4;
var $32173854adf97353$export$9c30223ca0a664fb;
var $32173854adf97353$export$db3c28d99448dcff;
var $32173854adf97353$export$80e4b313e5e6b30d;
var $32173854adf97353$export$df4cb166265252c7;
var $32173854adf97353$export$b71f7583e3491ee7;
var $32173854adf97353$export$aaf36426b5008f7a;
var $32173854adf97353$export$79ffe56a765070d2;
var $32173854adf97353$export$d76128d007d19019;
var $32173854adf97353$export$522f52afb9cc955f;
var $32173854adf97353$export$cc74dcc53cfce4eb;
$32173854adf97353$export$89da14300d534261 = `zXrDsW_active`;
$32173854adf97353$export$9f42c466da956b3 = `zXrDsW_burger`;
$32173854adf97353$export$2ba01fb71ed41cb6 = `zXrDsW_button`;
$32173854adf97353$export$3481c78889e8fbe8 = `zXrDsW_center`;
$32173854adf97353$export$b155c7424ba89ad7 = `zXrDsW_chatIcons`;
$32173854adf97353$export$fc66f88975b715ac = `zXrDsW_fixedContainer`;
$32173854adf97353$export$73e837fc0db8b511 = `zXrDsW_header_zone`;
$32173854adf97353$export$94cec53e3205acbe = `zXrDsW_iconsContainer`;
$32173854adf97353$export$b7e3ae3d7c15e42e = `zXrDsW_input`;
$32173854adf97353$export$eabcd2c8791e7bf4 = `zXrDsW_left`;
$32173854adf97353$export$9c30223ca0a664fb = `zXrDsW_link`;
$32173854adf97353$export$db3c28d99448dcff = `zXrDsW_logo`;
$32173854adf97353$export$80e4b313e5e6b30d = `zXrDsW_nav`;
$32173854adf97353$export$df4cb166265252c7 = `zXrDsW_news`;
$32173854adf97353$export$b71f7583e3491ee7 = `zXrDsW_newsicon`;
$32173854adf97353$export$aaf36426b5008f7a = `zXrDsW_result`;
$32173854adf97353$export$79ffe56a765070d2 = `zXrDsW_right`;
$32173854adf97353$export$d76128d007d19019 = `zXrDsW_search`;
$32173854adf97353$export$522f52afb9cc955f = `zXrDsW_searchInputMobile`;
$32173854adf97353$export$cc74dcc53cfce4eb = `zXrDsW_wrapper`;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
const $df8278a96b606336$var$Image = ({ className: className, src: src, srcDark: srcDark, srcSet: srcSet, srcSetDark: srcSetDark, alt: alt })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("img", {
        className: className,
        srcSet: srcSetDark,
        src: srcDark,
        alt: alt
    });
};
var $df8278a96b606336$export$2e2bcd8739ae039 = $df8278a96b606336$var$Image;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $6PPF0 = parcelRequire("6PPF0");
var $021ca37f9971eb83$exports = {};

$parcel$export($021ca37f9971eb83$exports, "code", function () { return $021ca37f9971eb83$export$6565f9f03506010b; }, function (v) { return $021ca37f9971eb83$export$6565f9f03506010b = v; });
$parcel$export($021ca37f9971eb83$exports, "connect", function () { return $021ca37f9971eb83$export$64605811ab45167f; }, function (v) { return $021ca37f9971eb83$export$64605811ab45167f = v; });
$parcel$export($021ca37f9971eb83$exports, "copy", function () { return $021ca37f9971eb83$export$784d13d8ee351f07; }, function (v) { return $021ca37f9971eb83$export$784d13d8ee351f07 = v; });
$parcel$export($021ca37f9971eb83$exports, "currency", function () { return $021ca37f9971eb83$export$f4f21ed02b0ddb8f; }, function (v) { return $021ca37f9971eb83$export$f4f21ed02b0ddb8f = v; });
$parcel$export($021ca37f9971eb83$exports, "info", function () { return $021ca37f9971eb83$export$a80b3bd66acc52ff; }, function (v) { return $021ca37f9971eb83$export$a80b3bd66acc52ff = v; });
$parcel$export($021ca37f9971eb83$exports, "line", function () { return $021ca37f9971eb83$export$53f1d5ea8de3d7c; }, function (v) { return $021ca37f9971eb83$export$53f1d5ea8de3d7c = v; });
$parcel$export($021ca37f9971eb83$exports, "number", function () { return $021ca37f9971eb83$export$98e628dec113755e; }, function (v) { return $021ca37f9971eb83$export$98e628dec113755e = v; });
$parcel$export($021ca37f9971eb83$exports, "preview", function () { return $021ca37f9971eb83$export$48c2d0f2f545ac27; }, function (v) { return $021ca37f9971eb83$export$48c2d0f2f545ac27 = v; });
$parcel$export($021ca37f9971eb83$exports, "price", function () { return $021ca37f9971eb83$export$321c0b1a406de31f; }, function (v) { return $021ca37f9971eb83$export$321c0b1a406de31f = v; });
$parcel$export($021ca37f9971eb83$exports, "user", function () { return $021ca37f9971eb83$export$ddb906a32562356c; }, function (v) { return $021ca37f9971eb83$export$ddb906a32562356c = v; });
$parcel$export($021ca37f9971eb83$exports, "wallet", function () { return $021ca37f9971eb83$export$4b6dd4ac026934d2; }, function (v) { return $021ca37f9971eb83$export$4b6dd4ac026934d2 = v; });
var $021ca37f9971eb83$export$6565f9f03506010b;
var $021ca37f9971eb83$export$64605811ab45167f;
var $021ca37f9971eb83$export$784d13d8ee351f07;
var $021ca37f9971eb83$export$f4f21ed02b0ddb8f;
var $021ca37f9971eb83$export$a80b3bd66acc52ff;
var $021ca37f9971eb83$export$53f1d5ea8de3d7c;
var $021ca37f9971eb83$export$98e628dec113755e;
var $021ca37f9971eb83$export$48c2d0f2f545ac27;
var $021ca37f9971eb83$export$321c0b1a406de31f;
var $021ca37f9971eb83$export$ddb906a32562356c;
var $021ca37f9971eb83$export$4b6dd4ac026934d2;
$021ca37f9971eb83$export$6565f9f03506010b = `F1goAG_code`;
$021ca37f9971eb83$export$64605811ab45167f = `F1goAG_connect`;
$021ca37f9971eb83$export$784d13d8ee351f07 = `F1goAG_copy`;
$021ca37f9971eb83$export$f4f21ed02b0ddb8f = `F1goAG_currency`;
$021ca37f9971eb83$export$a80b3bd66acc52ff = `F1goAG_info`;
$021ca37f9971eb83$export$53f1d5ea8de3d7c = `F1goAG_line`;
$021ca37f9971eb83$export$98e628dec113755e = `F1goAG_number`;
$021ca37f9971eb83$export$48c2d0f2f545ac27 = `F1goAG_preview`;
$021ca37f9971eb83$export$321c0b1a406de31f = `F1goAG_price`;
$021ca37f9971eb83$export$ddb906a32562356c = `F1goAG_user`;
$021ca37f9971eb83$export$4b6dd4ac026934d2 = `F1goAG_wallet`;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
const $ab5703ab2c2a0de8$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$ab5703ab2c2a0de8$export$c169aefb7330cccb["open"] = "0";
$ab5703ab2c2a0de8$export$c169aefb7330cccb["close"] = "1";
$ab5703ab2c2a0de8$export$c169aefb7330cccb["ping"] = "2";
$ab5703ab2c2a0de8$export$c169aefb7330cccb["pong"] = "3";
$ab5703ab2c2a0de8$export$c169aefb7330cccb["message"] = "4";
$ab5703ab2c2a0de8$export$c169aefb7330cccb["upgrade"] = "5";
$ab5703ab2c2a0de8$export$c169aefb7330cccb["noop"] = "6";
const $ab5703ab2c2a0de8$export$47791e8004edd485 = Object.create(null);
Object.keys($ab5703ab2c2a0de8$export$c169aefb7330cccb).forEach((key)=>{
    $ab5703ab2c2a0de8$export$47791e8004edd485[$ab5703ab2c2a0de8$export$c169aefb7330cccb[key]] = key;
});
const $ab5703ab2c2a0de8$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};


const $19e6947867ed8ed4$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $19e6947867ed8ed4$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $19e6947867ed8ed4$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $19e6947867ed8ed4$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($19e6947867ed8ed4$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $19e6947867ed8ed4$var$encodeBlobAsBase64(data, callback);
    } else if ($19e6947867ed8ed4$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $19e6947867ed8ed4$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $19e6947867ed8ed4$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $ab5703ab2c2a0de8$export$c169aefb7330cccb)[type] + (data || ""));
};
const $19e6947867ed8ed4$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $19e6947867ed8ed4$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $19e6947867ed8ed4$var$TEXT_ENCODER;
function $19e6947867ed8ed4$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($19e6947867ed8ed4$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($19e6947867ed8ed4$var$toArray).then(callback);
    else if ($19e6947867ed8ed4$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $19e6947867ed8ed4$var$isView(packet.data))) return callback($19e6947867ed8ed4$var$toArray(packet.data));
    $19e6947867ed8ed4$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$19e6947867ed8ed4$var$TEXT_ENCODER) $19e6947867ed8ed4$var$TEXT_ENCODER = new TextEncoder();
        callback($19e6947867ed8ed4$var$TEXT_ENCODER.encode(encoded));
    });
}



// imported from https://github.com/socketio/base64-arraybuffer
const $058ae839b2c2d8e6$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
const $058ae839b2c2d8e6$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(let i = 0; i < $058ae839b2c2d8e6$var$chars.length; i++)$058ae839b2c2d8e6$var$lookup[$058ae839b2c2d8e6$var$chars.charCodeAt(i)] = i;
const $058ae839b2c2d8e6$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
    for(i = 0; i < len; i += 3){
        base64 += $058ae839b2c2d8e6$var$chars[bytes[i] >> 2];
        base64 += $058ae839b2c2d8e6$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $058ae839b2c2d8e6$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $058ae839b2c2d8e6$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
const $058ae839b2c2d8e6$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $058ae839b2c2d8e6$var$lookup[base64.charCodeAt(i)];
        encoded2 = $058ae839b2c2d8e6$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $058ae839b2c2d8e6$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $058ae839b2c2d8e6$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};


const $56c3748867acddb5$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $56c3748867acddb5$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $56c3748867acddb5$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $56c3748867acddb5$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $ab5703ab2c2a0de8$export$47791e8004edd485)[type];
    if (!packetType) return 0, $ab5703ab2c2a0de8$export$c718b5840781f8a7;
    return encodedPacket.length > 1 ? {
        type: (0, $ab5703ab2c2a0de8$export$47791e8004edd485)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $ab5703ab2c2a0de8$export$47791e8004edd485)[type]
    };
};
const $56c3748867acddb5$var$decodeBase64Packet = (data, binaryType)=>{
    if ($56c3748867acddb5$var$withNativeArrayBuffer) {
        const decoded = (0, $058ae839b2c2d8e6$export$2f872c0f2117be69)(data);
        return $56c3748867acddb5$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $56c3748867acddb5$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};



const $4c50b6ff9467b60f$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $4c50b6ff9467b60f$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $19e6947867ed8ed4$export$57852049361a8e62)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($4c50b6ff9467b60f$var$SEPARATOR));
        });
    });
};
const $4c50b6ff9467b60f$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($4c50b6ff9467b60f$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $56c3748867acddb5$export$4647901878f33f31)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $4c50b6ff9467b60f$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $19e6947867ed8ed4$export$ec0c9b9013ee0ef5)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $4c50b6ff9467b60f$var$TEXT_DECODER;
function $4c50b6ff9467b60f$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $4c50b6ff9467b60f$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $4c50b6ff9467b60f$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$4c50b6ff9467b60f$var$TEXT_DECODER) $4c50b6ff9467b60f$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* READ_HEADER */ ) {
                    if ($4c50b6ff9467b60f$var$totalLength(chunks) < 1) break;
                    const header = $4c50b6ff9467b60f$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* READ_EXTENDED_LENGTH_16 */ ) {
                    if ($4c50b6ff9467b60f$var$totalLength(chunks) < 2) break;
                    const headerArray = $4c50b6ff9467b60f$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* READ_PAYLOAD */ ;
                } else if (state === 2 /* READ_EXTENDED_LENGTH_64 */ ) {
                    if ($4c50b6ff9467b60f$var$totalLength(chunks) < 8) break;
                    const headerArray = $4c50b6ff9467b60f$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $ab5703ab2c2a0de8$export$c718b5840781f8a7));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* READ_PAYLOAD */ ;
                } else {
                    if ($4c50b6ff9467b60f$var$totalLength(chunks) < expectedLength) break;
                    const data = $4c50b6ff9467b60f$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $56c3748867acddb5$export$4647901878f33f31)(isBinary ? data : $4c50b6ff9467b60f$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $ab5703ab2c2a0de8$export$c718b5840781f8a7));
                    break;
                }
            }
        }
    });
}
const $4c50b6ff9467b60f$export$a51d6b395ff4c65a = 4;


/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $2468bdada33fd512$export$4293555f241ae35a(obj) {
    if (obj) return $2468bdada33fd512$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $2468bdada33fd512$var$mixin(obj) {
    for(var key in $2468bdada33fd512$export$4293555f241ae35a.prototype)obj[key] = $2468bdada33fd512$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $2468bdada33fd512$export$4293555f241ae35a.prototype.on = $2468bdada33fd512$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $2468bdada33fd512$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $2468bdada33fd512$export$4293555f241ae35a.prototype.off = $2468bdada33fd512$export$4293555f241ae35a.prototype.removeListener = $2468bdada33fd512$export$4293555f241ae35a.prototype.removeAllListeners = $2468bdada33fd512$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks["$" + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks["$" + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks["$" + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $2468bdada33fd512$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$2468bdada33fd512$export$4293555f241ae35a.prototype.emitReserved = $2468bdada33fd512$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $2468bdada33fd512$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks["$" + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $2468bdada33fd512$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};


const $cae3c65e336a36d6$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();


function $9dcaad2add9892a3$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $9dcaad2add9892a3$var$NATIVE_SET_TIMEOUT = (0, $cae3c65e336a36d6$export$394f9358f6231289).setTimeout;
const $9dcaad2add9892a3$var$NATIVE_CLEAR_TIMEOUT = (0, $cae3c65e336a36d6$export$394f9358f6231289).clearTimeout;
function $9dcaad2add9892a3$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $9dcaad2add9892a3$var$NATIVE_SET_TIMEOUT.bind((0, $cae3c65e336a36d6$export$394f9358f6231289));
        obj.clearTimeoutFn = $9dcaad2add9892a3$var$NATIVE_CLEAR_TIMEOUT.bind((0, $cae3c65e336a36d6$export$394f9358f6231289));
    } else {
        obj.setTimeoutFn = (0, $cae3c65e336a36d6$export$394f9358f6231289).setTimeout.bind((0, $cae3c65e336a36d6$export$394f9358f6231289));
        obj.clearTimeoutFn = (0, $cae3c65e336a36d6$export$394f9358f6231289).clearTimeout.bind((0, $cae3c65e336a36d6$export$394f9358f6231289));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $9dcaad2add9892a3$var$BASE64_OVERHEAD = 1.33;
function $9dcaad2add9892a3$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $9dcaad2add9892a3$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $9dcaad2add9892a3$var$BASE64_OVERHEAD);
}
function $9dcaad2add9892a3$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}


// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $e859a97b0f460ea1$export$c564cdbbe6da493(obj) {
    let str = "";
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += "&";
        str += encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]);
    }
    return str;
}
function $e859a97b0f460ea1$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split("&");
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split("=");
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}


class $a290c9fa365a06c8$var$TransportError extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $a290c9fa365a06c8$export$86495b081fef8e52 extends (0, $2468bdada33fd512$export$4293555f241ae35a) {
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $a290c9fa365a06c8$var$TransportError(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $56c3748867acddb5$export$4647901878f33f31)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $e859a97b0f460ea1$export$c564cdbbe6da493)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $9dcaad2add9892a3$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
    }
}


// imported from https://github.com/unshiftio/yeast
"use strict";
const $fa80c52b6c308887$var$alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), $fa80c52b6c308887$var$length = 64, $fa80c52b6c308887$var$map = {};
let $fa80c52b6c308887$var$seed = 0, $fa80c52b6c308887$var$i = 0, $fa80c52b6c308887$var$prev;
function $fa80c52b6c308887$export$c564cdbbe6da493(num) {
    let encoded = "";
    do {
        encoded = $fa80c52b6c308887$var$alphabet[num % $fa80c52b6c308887$var$length] + encoded;
        num = Math.floor(num / $fa80c52b6c308887$var$length);
    }while (num > 0);
    return encoded;
}
function $fa80c52b6c308887$export$2f872c0f2117be69(str) {
    let decoded = 0;
    for($fa80c52b6c308887$var$i = 0; $fa80c52b6c308887$var$i < str.length; $fa80c52b6c308887$var$i++)decoded = decoded * $fa80c52b6c308887$var$length + $fa80c52b6c308887$var$map[str.charAt($fa80c52b6c308887$var$i)];
    return decoded;
}
function $fa80c52b6c308887$export$5bb64b92cb4135a() {
    const now = $fa80c52b6c308887$export$c564cdbbe6da493(+new Date());
    if (now !== $fa80c52b6c308887$var$prev) return $fa80c52b6c308887$var$seed = 0, $fa80c52b6c308887$var$prev = now;
    return now + "." + $fa80c52b6c308887$export$c564cdbbe6da493($fa80c52b6c308887$var$seed++);
}
//
// Map each character to its index.
//
for(; $fa80c52b6c308887$var$i < $fa80c52b6c308887$var$length; $fa80c52b6c308887$var$i++)$fa80c52b6c308887$var$map[$fa80c52b6c308887$var$alphabet[$fa80c52b6c308887$var$i]] = $fa80c52b6c308887$var$i;



// browser shim for xmlhttprequest module
// imported from https://github.com/component/has-cors
let $2ea53ec0100ee508$var$value = false;
try {
    $2ea53ec0100ee508$var$value = typeof XMLHttpRequest !== "undefined" && "withCredentials" in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $2ea53ec0100ee508$export$5235bbd4a1ef06e = $2ea53ec0100ee508$var$value;



function $1d5e4cb0cb901891$export$a2d42eb087c10497(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $2ea53ec0100ee508$export$5235bbd4a1ef06e))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $cae3c65e336a36d6$export$394f9358f6231289)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}
function $1d5e4cb0cb901891$export$19413efcf2fac759() {}





function $626fe328385ca768$var$empty() {}
const $626fe328385ca768$var$hasXHR2 = function() {
    const xhr = new (0, $1d5e4cb0cb901891$export$a2d42eb087c10497)({
        xdomain: false
    });
    return null != xhr.responseType;
}();
class $626fe328385ca768$export$265ee5eefd4c309b extends (0, $a290c9fa365a06c8$export$86495b081fef8e52) {
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this.poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this.polling || !this.writable) {
            let total = 0;
            if (this.polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ poll() {
        this.polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $4c50b6ff9467b60f$export$d10cc2e7f7566a2d)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this.polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this.poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $4c50b6ff9467b60f$export$144d64fe58dad441)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $fa80c52b6c308887$export$5bb64b92cb4135a)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Creates a request.
     *
     * @param {String} method
     * @private
     */ request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd,
            cookieJar: this.cookieJar
        }, this.opts);
        return new $626fe328385ca768$export$7fa6c5b6f8193917(this.uri(), opts);
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        this.polling = false;
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
        /**
         * XHR supports binary
         */ const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $626fe328385ca768$var$hasXHR2 && !forceBase64;
        if (this.opts.withCredentials) this.cookieJar = (0, $1d5e4cb0cb901891$export$19413efcf2fac759)();
    }
}
class $626fe328385ca768$export$7fa6c5b6f8193917 extends (0, $2468bdada33fd512$export$4293555f241ae35a) {
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ create() {
        var _a;
        const opts = (0, $9dcaad2add9892a3$export$357523c63a2253b9)(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this.opts.xd;
        const xhr = this.xhr = new (0, $1d5e4cb0cb901891$export$a2d42eb087c10497)(opts);
        try {
            xhr.open(this.method, this.uri, true);
            try {
                if (this.opts.extraHeaders) {
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this.opts.extraHeaders)if (this.opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this.opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this.method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this.opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this.opts.withCredentials;
            if (this.opts.requestTimeout) xhr.timeout = this.opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this.opts.cookieJar) === null || _a === void 0 || _a.parseCookies(xhr);
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this.onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this.onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this.data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this.onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this.index = $626fe328385ca768$export$7fa6c5b6f8193917.requestsCount++;
            $626fe328385ca768$export$7fa6c5b6f8193917.requests[this.index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ onError(err) {
        this.emitReserved("error", err, this.xhr);
        this.cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ cleanup(fromError) {
        if ("undefined" === typeof this.xhr || null === this.xhr) return;
        this.xhr.onreadystatechange = $626fe328385ca768$var$empty;
        if (fromError) try {
            this.xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $626fe328385ca768$export$7fa6c5b6f8193917.requests[this.index];
        this.xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ onLoad() {
        const data = this.xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this.cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this.cleanup();
    }
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(uri, opts){
        super();
        (0, $9dcaad2add9892a3$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.method = opts.method || "GET";
        this.uri = uri;
        this.data = undefined !== opts.data ? opts.data : null;
        this.create();
    }
}
$626fe328385ca768$export$7fa6c5b6f8193917.requestsCount = 0;
$626fe328385ca768$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $626fe328385ca768$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $cae3c65e336a36d6$export$394f9358f6231289) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $626fe328385ca768$var$unloadHandler, false);
    }
}
function $626fe328385ca768$var$unloadHandler() {
    for(let i in $626fe328385ca768$export$7fa6c5b6f8193917.requests)if ($626fe328385ca768$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $626fe328385ca768$export$7fa6c5b6f8193917.requests[i].abort();
}






const $481d3642a908789a$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $481d3642a908789a$export$3909fb301d3dc8c9 = (0, $cae3c65e336a36d6$export$394f9358f6231289).WebSocket || (0, $cae3c65e336a36d6$export$394f9358f6231289).MozWebSocket;
const $481d3642a908789a$export$3407ba5dfb7a683d = true;
const $481d3642a908789a$export$790dcbc41e2d75d5 = "arraybuffer";




var $gzLuY = parcelRequire("gzLuY");
var $fbae8859cf51f96f$require$Buffer = $gzLuY.Buffer;
// detect ReactNative environment
const $fbae8859cf51f96f$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $fbae8859cf51f96f$export$911baa0677ac404c extends (0, $a290c9fa365a06c8$export$86495b081fef8e52) {
    get name() {
        return "websocket";
    }
    doOpen() {
        if (!this.check()) // let probe timeout
        return;
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $fbae8859cf51f96f$var$isReactNative ? {} : (0, $9dcaad2add9892a3$export$357523c63a2253b9)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = (0, $481d3642a908789a$export$3407ba5dfb7a683d) && !$fbae8859cf51f96f$var$isReactNative ? protocols ? new (0, $481d3642a908789a$export$3909fb301d3dc8c9)(uri, protocols) : new (0, $481d3642a908789a$export$3909fb301d3dc8c9)(uri) : new (0, $481d3642a908789a$export$3909fb301d3dc8c9)(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $19e6947867ed8ed4$export$57852049361a8e62)(packet, this.supportsBinary, (data)=>{
                // always create a new object (GH-437)
                const opts = {};
                if (!(0, $481d3642a908789a$export$3407ba5dfb7a683d)) {
                    if (packet.options) opts.compress = packet.options.compress;
                    if (this.opts.perMessageDeflate) {
                        const len = // @ts-ignore
                        "string" === typeof data ? $fbae8859cf51f96f$require$Buffer.byteLength(data) : data.length;
                        if (len < this.opts.perMessageDeflate.threshold) opts.compress = false;
                    }
                }
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    if (0, $481d3642a908789a$export$3407ba5dfb7a683d) // TypeError is thrown when passing the second argument on Safari
                    this.ws.send(data);
                    else this.ws.send(data, opts);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $481d3642a908789a$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $fa80c52b6c308887$export$5bb64b92cb4135a)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Feature detection for WebSocket.
     *
     * @return {Boolean} whether this transport is available.
     * @private
     */ check() {
        return !!(0, $481d3642a908789a$export$3909fb301d3dc8c9);
    }
    /**
     * WebSocket transport constructor.
     *
     * @param {Object} opts - connection options
     * @protected
     */ constructor(opts){
        super(opts);
        this.supportsBinary = !opts.forceBase64;
    }
}





class $9b9d332f76dbd61f$export$961c930859384407 extends (0, $a290c9fa365a06c8$export$86495b081fef8e52) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        // @ts-ignore
        if (typeof WebTransport !== "function") return;
        // @ts-ignore
        this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        this.transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this.transport.ready.then(()=>{
            this.transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $4c50b6ff9467b60f$export$552d20aac7500f47)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $4c50b6ff9467b60f$export$a525fb718e9c623a)();
                encoderStream.readable.pipeTo(stream.writable);
                this.writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this.writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this.writer.write(packet).then(()=>{
                if (lastPacket) (0, $481d3642a908789a$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this.transport) === null || _a === void 0 || _a.close();
    }
}


const $dd1999b1ee54d9d4$export$46dec00755c1153b = {
    websocket: (0, $fbae8859cf51f96f$export$911baa0677ac404c),
    webtransport: (0, $9b9d332f76dbd61f$export$961c930859384407),
    polling: (0, $626fe328385ca768$export$265ee5eefd4c309b)
};




// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $9d5d42ed1593912e$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $9d5d42ed1593912e$var$parts = [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor"
];
function $9d5d42ed1593912e$export$98e6a39c04603d36(str) {
    const src = str, b = str.indexOf("["), e = str.indexOf("]");
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ";") + str.substring(e, str.length);
    let m = $9d5d42ed1593912e$var$re.exec(str || ""), uri = {}, i = 14;
    while(i--)uri[$9d5d42ed1593912e$var$parts[i]] = m[i] || "";
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ":");
        uri.authority = uri.authority.replace("[", "").replace("]", "").replace(/;/g, ":");
        uri.ipv6uri = true;
    }
    uri.pathNames = $9d5d42ed1593912e$var$pathNames(uri, uri["path"]);
    uri.queryKey = $9d5d42ed1593912e$var$queryKey(uri, uri["query"]);
    return uri;
}
function $9d5d42ed1593912e$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == "/" || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == "/") names.splice(names.length - 1, 1);
    return names;
}
function $9d5d42ed1593912e$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}





class $41f55a0bdd6074aa$export$4798917dbf149b79 extends (0, $2468bdada33fd512$export$4293555f241ae35a) {
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $4c50b6ff9467b60f$export$a51d6b395ff4c65a);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new (0, $dd1999b1ee54d9d4$export$46dec00755c1153b)[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ open() {
        let transport;
        if (this.opts.rememberUpgrade && $41f55a0bdd6074aa$export$4798917dbf149b79.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) transport = "websocket";
        else if (0 === this.transports.length) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        } else transport = this.transports[0];
        this.readyState = "opening";
        // Retry with the next transport if the transport is disabled (jsonp: false)
        try {
            transport = this.createTransport(transport);
        } catch (e) {
            this.transports.shift();
            this.open();
            return;
        }
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (reason)=>this.onClose("transport close", reason));
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $41f55a0bdd6074aa$export$4798917dbf149b79.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $41f55a0bdd6074aa$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this.upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $41f55a0bdd6074aa$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
        // we check for `readyState` in case an `open`
        // listener already closed the socket
        if ("open" === this.readyState && this.opts.upgrade) {
            let i = 0;
            const l = this.upgrades.length;
            for(; i < l; i++)this.probe(this.upgrades[i]);
        }
    }
    /**
     * Handles a packet.
     *
     * @private
     */ onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            this.resetPingTimeout();
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this.sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this.onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this.upgrades = this.filterUpgrades(data.upgrades);
        this.pingInterval = data.pingInterval;
        this.pingTimeout = data.pingTimeout;
        this.maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this.resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ resetPingTimeout() {
        this.clearTimeoutFn(this.pingTimeoutTimer);
        this.pingTimeoutTimer = this.setTimeoutFn(()=>{
            this.onClose("ping timeout");
        }, this.pingInterval + this.pingTimeout);
        if (this.opts.autoUnref) this.pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ onDrain() {
        this.writeBuffer.splice(0, this.prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this.prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this.getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this.prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ getWritablePackets() {
        const shouldCheckPayloadSize = this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $9dcaad2add9892a3$export$a48f0734ac7c2329)(data);
            if (i > 0 && payloadSize > this.maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    send(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this.onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ onError(err) {
        $41f55a0bdd6074aa$export$4798917dbf149b79.priorWebsocketSuccess = false;
        this.emitReserved("error", err);
        this.onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this.pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if (typeof removeEventListener === "function") {
                removeEventListener("beforeunload", this.beforeunloadEventListener, false);
                removeEventListener("offline", this.offlineEventListener, false);
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this.prevBufferLen = 0;
        }
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        let i = 0;
        const j = upgrades.length;
        for(; i < j; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts = {}){
        super();
        this.binaryType = (0, $481d3642a908789a$export$790dcbc41e2d75d5);
        this.writeBuffer = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            uri = (0, $9d5d42ed1593912e$export$98e6a39c04603d36)(uri);
            opts.hostname = uri.host;
            opts.secure = uri.protocol === "https" || uri.protocol === "wss";
            opts.port = uri.port;
            if (uri.query) opts.query = uri.query;
        } else if (opts.host) opts.hostname = (0, $9d5d42ed1593912e$export$98e6a39c04603d36)(opts.host).host;
        (0, $9dcaad2add9892a3$export$2f67576668b97183)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = opts.transports || [
            "polling",
            "websocket",
            "webtransport"
        ];
        this.writeBuffer = [];
        this.prevBufferLen = 0;
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $e859a97b0f460ea1$export$2f872c0f2117be69)(this.opts.query);
        // set on handshake
        this.id = null;
        this.upgrades = null;
        this.pingInterval = null;
        this.pingTimeout = null;
        // set on heartbeat
        this.pingTimeoutTimer = null;
        if (typeof addEventListener === "function") {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this.beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this.beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this.offlineEventListener = ()=>{
                    this.onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                addEventListener("offline", this.offlineEventListener, false);
            }
        }
        this.open();
    }
}
$41f55a0bdd6074aa$export$4798917dbf149b79.protocol = (0, $4c50b6ff9467b60f$export$a51d6b395ff4c65a);







const $a7ccdf2d59430fde$export$a51d6b395ff4c65a = (0, $41f55a0bdd6074aa$export$4798917dbf149b79).protocol;


function $631908147496233c$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $9d5d42ed1593912e$export$98e6a39c04603d36)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}



var $26ce4f82640f7614$exports = {};

$parcel$export($26ce4f82640f7614$exports, "protocol", function () { return $26ce4f82640f7614$export$a51d6b395ff4c65a; });
$parcel$export($26ce4f82640f7614$exports, "PacketType", function () { return $26ce4f82640f7614$export$84d4095e16c6fc19; });
$parcel$export($26ce4f82640f7614$exports, "Encoder", function () { return $26ce4f82640f7614$export$a50aceb0e02a00aa; });
$parcel$export($26ce4f82640f7614$exports, "Decoder", function () { return $26ce4f82640f7614$export$f9de6ca0bc043724; });

const $ea4235ae87c1f3b2$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $ea4235ae87c1f3b2$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $ea4235ae87c1f3b2$var$toString = Object.prototype.toString;
const $ea4235ae87c1f3b2$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $ea4235ae87c1f3b2$var$toString.call(Blob) === "[object BlobConstructor]";
const $ea4235ae87c1f3b2$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $ea4235ae87c1f3b2$var$toString.call(File) === "[object FileConstructor]";
function $ea4235ae87c1f3b2$export$37488ff1135b1696(obj) {
    return $ea4235ae87c1f3b2$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $ea4235ae87c1f3b2$var$isView(obj)) || $ea4235ae87c1f3b2$var$withNativeBlob && obj instanceof Blob || $ea4235ae87c1f3b2$var$withNativeFile && obj instanceof File;
}
function $ea4235ae87c1f3b2$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($ea4235ae87c1f3b2$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($ea4235ae87c1f3b2$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $ea4235ae87c1f3b2$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $ea4235ae87c1f3b2$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}


function $4caf8097c57cf8b9$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $4caf8097c57cf8b9$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $4caf8097c57cf8b9$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $ea4235ae87c1f3b2$export$37488ff1135b1696)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $4caf8097c57cf8b9$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $4caf8097c57cf8b9$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $4caf8097c57cf8b9$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $4caf8097c57cf8b9$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $4caf8097c57cf8b9$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $4caf8097c57cf8b9$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $4caf8097c57cf8b9$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}



/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $26ce4f82640f7614$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $26ce4f82640f7614$export$a51d6b395ff4c65a = 5;
var $26ce4f82640f7614$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($26ce4f82640f7614$export$84d4095e16c6fc19 || ($26ce4f82640f7614$export$84d4095e16c6fc19 = {}));
class $26ce4f82640f7614$export$a50aceb0e02a00aa {
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $26ce4f82640f7614$export$84d4095e16c6fc19.EVENT || obj.type === $26ce4f82640f7614$export$84d4095e16c6fc19.ACK) {
            if ((0, $ea4235ae87c1f3b2$export$5234c529abdb5610)(obj)) return this.encodeAsBinary({
                type: obj.type === $26ce4f82640f7614$export$84d4095e16c6fc19.EVENT ? $26ce4f82640f7614$export$84d4095e16c6fc19.BINARY_EVENT : $26ce4f82640f7614$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $26ce4f82640f7614$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $26ce4f82640f7614$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $4caf8097c57cf8b9$export$ac2edb9eb7af56f6)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $26ce4f82640f7614$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class $26ce4f82640f7614$export$f9de6ca0bc043724 extends (0, $2468bdada33fd512$export$4293555f241ae35a) {
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $26ce4f82640f7614$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $26ce4f82640f7614$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $26ce4f82640f7614$export$84d4095e16c6fc19.EVENT : $26ce4f82640f7614$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $26ce4f82640f7614$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $ea4235ae87c1f3b2$export$37488ff1135b1696)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($26ce4f82640f7614$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $26ce4f82640f7614$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $26ce4f82640f7614$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($26ce4f82640f7614$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $26ce4f82640f7614$export$84d4095e16c6fc19.CONNECT:
                return $26ce4f82640f7614$var$isObject(payload);
            case $26ce4f82640f7614$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $26ce4f82640f7614$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $26ce4f82640f7614$var$isObject(payload);
            case $26ce4f82640f7614$export$84d4095e16c6fc19.EVENT:
            case $26ce4f82640f7614$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $26ce4f82640f7614$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $26ce4f82640f7614$export$84d4095e16c6fc19.ACK:
            case $26ce4f82640f7614$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $26ce4f82640f7614$var$BinaryReconstructor {
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $4caf8097c57cf8b9$export$a00da3b1ec037a04)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
}


function $c887ff53c7601923$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}



/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $16bad1ea371fa421$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $16bad1ea371fa421$export$4798917dbf149b79 extends (0, $2468bdada33fd512$export$4293555f241ae35a) {
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $c887ff53c7601923$export$af631764ddc44097)(io, "open", this.onopen.bind(this)),
            (0, $c887ff53c7601923$export$af631764ddc44097)(io, "packet", this.onpacket.bind(this)),
            (0, $c887ff53c7601923$export$af631764ddc44097)(io, "error", this.onerror.bind(this)),
            (0, $c887ff53c7601923$export$af631764ddc44097)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        if ($16bad1ea371fa421$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $26ce4f82640f7614$export$84d4095e16c6fc19).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
        const discardPacket = this.flags.volatile && (!isTransportWritable || !this.connected);
        if (discardPacket) ;
        else if (this.connected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        this.acks[id] = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, [
                null,
                ...args
            ]);
        };
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        // the timeout flag is optional
        const withErr = this.flags.timeout !== undefined || this._opts.ackTimeout !== undefined;
        return new Promise((resolve, reject)=>{
            args.push((arg1, arg2)=>{
                if (withErr) return arg1 ? reject(arg1) : resolve(arg2);
                else return resolve(arg1);
            });
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $26ce4f82640f7614$export$84d4095e16c6fc19).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $26ce4f82640f7614$export$84d4095e16c6fc19).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $26ce4f82640f7614$export$84d4095e16c6fc19).EVENT:
            case (0, $26ce4f82640f7614$export$84d4095e16c6fc19).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $26ce4f82640f7614$export$84d4095e16c6fc19).ACK:
            case (0, $26ce4f82640f7614$export$84d4095e16c6fc19).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $26ce4f82640f7614$export$84d4095e16c6fc19).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $26ce4f82640f7614$export$84d4095e16c6fc19).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $26ce4f82640f7614$export$84d4095e16c6fc19).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowlegement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if ("function" === typeof ack) {
            ack.apply(this, packet.data);
            delete this.acks[packet.id];
        }
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $26ce4f82640f7614$export$84d4095e16c6fc19).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
}




/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $b3029ef64ddfcf62$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $b3029ef64ddfcf62$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $b3029ef64ddfcf62$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $b3029ef64ddfcf62$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $b3029ef64ddfcf62$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $b3029ef64ddfcf62$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};



class $dcb02adbb91b4a4e$export$d0d38e7dec7a1a61 extends (0, $2468bdada33fd512$export$4293555f241ae35a) {
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $41f55a0bdd6074aa$export$4798917dbf149b79)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $c887ff53c7601923$export$af631764ddc44097)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $c887ff53c7601923$export$af631764ddc44097)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $c887ff53c7601923$export$af631764ddc44097)(socket, "ping", this.onping.bind(this)), (0, $c887ff53c7601923$export$af631764ddc44097)(socket, "data", this.ondata.bind(this)), (0, $c887ff53c7601923$export$af631764ddc44097)(socket, "error", this.onerror.bind(this)), (0, $c887ff53c7601923$export$af631764ddc44097)(socket, "close", this.onclose.bind(this)), (0, $c887ff53c7601923$export$af631764ddc44097)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $481d3642a908789a$export$bdd553fddd433dcb)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $16bad1ea371fa421$export$4798917dbf149b79)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
        if (this.engine) this.engine.close();
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called upon engine close.
     *
     * @private
     */ onclose(reason, description) {
        this.cleanup();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $9dcaad2add9892a3$export$2f67576668b97183)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $b3029ef64ddfcf62$export$2d38012449449c89)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $26ce4f82640f7614$exports;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
}




/**
 * Managers cache.
 */ const $7a4e4a149da75b1d$var$cache = {};
function $7a4e4a149da75b1d$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $631908147496233c$export$128fa18b7194ef)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $7a4e4a149da75b1d$var$cache[id] && path in $7a4e4a149da75b1d$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $dcb02adbb91b4a4e$export$d0d38e7dec7a1a61)(source, opts);
    else {
        if (!$7a4e4a149da75b1d$var$cache[id]) $7a4e4a149da75b1d$var$cache[id] = new (0, $dcb02adbb91b4a4e$export$d0d38e7dec7a1a61)(source, opts);
        io = $7a4e4a149da75b1d$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($7a4e4a149da75b1d$export$841407ceb083bd74, {
    Manager: $dcb02adbb91b4a4e$export$d0d38e7dec7a1a61,
    Socket: $16bad1ea371fa421$export$4798917dbf149b79,
    io: $7a4e4a149da75b1d$export$841407ceb083bd74,
    connect: $7a4e4a149da75b1d$export$841407ceb083bd74
});


var $e926e63dbac648e0$exports = {};

var $aqbQf = parcelRequire("aqbQf");

var $gzLuY = parcelRequire("gzLuY");
var $e926e63dbac648e0$require$Buffer = $gzLuY.Buffer;

var $aqbQf = parcelRequire("aqbQf");
var $ad1e3b7171b5b1ff$exports = {};
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $aqbQf = parcelRequire("aqbQf");
"use strict";
function $ad1e3b7171b5b1ff$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $ad1e3b7171b5b1ff$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $ad1e3b7171b5b1ff$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $ad1e3b7171b5b1ff$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $aqbQf.cwd();
                path = cwd;
            }
            $ad1e3b7171b5b1ff$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $ad1e3b7171b5b1ff$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $ad1e3b7171b5b1ff$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $ad1e3b7171b5b1ff$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $ad1e3b7171b5b1ff$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $ad1e3b7171b5b1ff$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $ad1e3b7171b5b1ff$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $ad1e3b7171b5b1ff$var$assertPath(from);
        $ad1e3b7171b5b1ff$var$assertPath(to);
        if (from === to) return "";
        from = $ad1e3b7171b5b1ff$var$posix.resolve(from);
        to = $ad1e3b7171b5b1ff$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $ad1e3b7171b5b1ff$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $ad1e3b7171b5b1ff$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $ad1e3b7171b5b1ff$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $ad1e3b7171b5b1ff$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $ad1e3b7171b5b1ff$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$ad1e3b7171b5b1ff$var$posix.posix = $ad1e3b7171b5b1ff$var$posix;
$ad1e3b7171b5b1ff$exports = $ad1e3b7171b5b1ff$var$posix;


var $87fbed32e4e4f629$export$edf525f30916fbb8;
var $87fbed32e4e4f629$export$640106f6dc7d2706;
var $87fbed32e4e4f629$export$3ea386628068cf62;
var $87fbed32e4e4f629$export$749d472264fad440;
var $87fbed32e4e4f629$export$8b931a48d9488767;
var $87fbed32e4e4f629$export$9123f37609399513;
var $87fbed32e4e4f629$export$9b60beb643db4d69;
var $87fbed32e4e4f629$export$bf9fb029d174d554;
var $87fbed32e4e4f629$export$23d3fad09dc44362;
var $87fbed32e4e4f629$export$d2f3c2f7e0c7dcf5;
var $87fbed32e4e4f629$export$3bf7c33313eba0fe;
var $87fbed32e4e4f629$export$7925d89f138dad5b;
var $87fbed32e4e4f629$export$722a64dea1b767dc;
var $87fbed32e4e4f629$export$9e6c06a7d47f9af7;
var $87fbed32e4e4f629$export$6b76988456c0292f;
var $87fbed32e4e4f629$export$266d3b9babd1fc45;
var $87fbed32e4e4f629$export$c1d46b5ea6262c0b;
$87fbed32e4e4f629$export$edf525f30916fbb8 = function() {
    return "LE";
};
$87fbed32e4e4f629$export$640106f6dc7d2706 = function() {
    if (typeof location !== "undefined") return location.hostname;
    else return "";
};
$87fbed32e4e4f629$export$3ea386628068cf62 = function() {
    return [];
};
$87fbed32e4e4f629$export$749d472264fad440 = function() {
    return 0;
};
$87fbed32e4e4f629$export$8b931a48d9488767 = function() {
    return Number.MAX_VALUE;
};
$87fbed32e4e4f629$export$9123f37609399513 = function() {
    return Number.MAX_VALUE;
};
$87fbed32e4e4f629$export$9b60beb643db4d69 = function() {
    return [];
};
$87fbed32e4e4f629$export$bf9fb029d174d554 = function() {
    return "Browser";
};
$87fbed32e4e4f629$export$23d3fad09dc44362 = function() {
    if (typeof navigator !== "undefined") return navigator.appVersion;
    return "";
};
$87fbed32e4e4f629$export$d2f3c2f7e0c7dcf5 = $87fbed32e4e4f629$export$3bf7c33313eba0fe = function() {
    return {};
};
$87fbed32e4e4f629$export$7925d89f138dad5b = function() {
    return "javascript";
};
$87fbed32e4e4f629$export$722a64dea1b767dc = function() {
    return "browser";
};
$87fbed32e4e4f629$export$9e6c06a7d47f9af7 = $87fbed32e4e4f629$export$6b76988456c0292f = function() {
    return "/tmp";
};
$87fbed32e4e4f629$export$266d3b9babd1fc45 = "\n";
$87fbed32e4e4f629$export$c1d46b5ea6262c0b = function() {
    return "/";
};


var $01727eaed9f6d092$exports = {};

$parcel$export($01727eaed9f6d092$exports, "randomBytes", function () { return $01727eaed9f6d092$export$5f828d93ff035aa8; }, function (v) { return $01727eaed9f6d092$export$5f828d93ff035aa8 = v; });
$parcel$export($01727eaed9f6d092$exports, "rng", function () { return $01727eaed9f6d092$export$cd94982b18c6332c; }, function (v) { return $01727eaed9f6d092$export$cd94982b18c6332c = v; });
$parcel$export($01727eaed9f6d092$exports, "pseudoRandomBytes", function () { return $01727eaed9f6d092$export$1d518568e4f529b0; }, function (v) { return $01727eaed9f6d092$export$1d518568e4f529b0 = v; });
$parcel$export($01727eaed9f6d092$exports, "prng", function () { return $01727eaed9f6d092$export$5285b6d41c912b41; }, function (v) { return $01727eaed9f6d092$export$5285b6d41c912b41 = v; });
$parcel$export($01727eaed9f6d092$exports, "createHash", function () { return $01727eaed9f6d092$export$2fb37efbf6ae0c0e; }, function (v) { return $01727eaed9f6d092$export$2fb37efbf6ae0c0e = v; });
$parcel$export($01727eaed9f6d092$exports, "Hash", function () { return $01727eaed9f6d092$export$ab85ecd77ce6a5cd; }, function (v) { return $01727eaed9f6d092$export$ab85ecd77ce6a5cd = v; });
$parcel$export($01727eaed9f6d092$exports, "createHmac", function () { return $01727eaed9f6d092$export$da39cf97e1eb7c91; }, function (v) { return $01727eaed9f6d092$export$da39cf97e1eb7c91 = v; });
$parcel$export($01727eaed9f6d092$exports, "Hmac", function () { return $01727eaed9f6d092$export$52a9039d7177394f; }, function (v) { return $01727eaed9f6d092$export$52a9039d7177394f = v; });
$parcel$export($01727eaed9f6d092$exports, "getHashes", function () { return $01727eaed9f6d092$export$f7201db400317331; }, function (v) { return $01727eaed9f6d092$export$f7201db400317331 = v; });
$parcel$export($01727eaed9f6d092$exports, "pbkdf2", function () { return $01727eaed9f6d092$export$448fa22aedc9dbca; }, function (v) { return $01727eaed9f6d092$export$448fa22aedc9dbca = v; });
$parcel$export($01727eaed9f6d092$exports, "pbkdf2Sync", function () { return $01727eaed9f6d092$export$b80c7ba289c8fa56; }, function (v) { return $01727eaed9f6d092$export$b80c7ba289c8fa56 = v; });
$parcel$export($01727eaed9f6d092$exports, "Cipher", function () { return $01727eaed9f6d092$export$26e5786e8ac8e530; }, function (v) { return $01727eaed9f6d092$export$26e5786e8ac8e530 = v; });
$parcel$export($01727eaed9f6d092$exports, "createCipher", function () { return $01727eaed9f6d092$export$bdd223f16383713e; }, function (v) { return $01727eaed9f6d092$export$bdd223f16383713e = v; });
$parcel$export($01727eaed9f6d092$exports, "Cipheriv", function () { return $01727eaed9f6d092$export$20533d26f07f1ee0; }, function (v) { return $01727eaed9f6d092$export$20533d26f07f1ee0 = v; });
$parcel$export($01727eaed9f6d092$exports, "createCipheriv", function () { return $01727eaed9f6d092$export$2f64596b8cbf08b4; }, function (v) { return $01727eaed9f6d092$export$2f64596b8cbf08b4 = v; });
$parcel$export($01727eaed9f6d092$exports, "Decipher", function () { return $01727eaed9f6d092$export$2ce6d8d0e8b04e1a; }, function (v) { return $01727eaed9f6d092$export$2ce6d8d0e8b04e1a = v; });
$parcel$export($01727eaed9f6d092$exports, "createDecipher", function () { return $01727eaed9f6d092$export$12ada9414fbc594c; }, function (v) { return $01727eaed9f6d092$export$12ada9414fbc594c = v; });
$parcel$export($01727eaed9f6d092$exports, "Decipheriv", function () { return $01727eaed9f6d092$export$f5e7e39d57cd9700; }, function (v) { return $01727eaed9f6d092$export$f5e7e39d57cd9700 = v; });
$parcel$export($01727eaed9f6d092$exports, "createDecipheriv", function () { return $01727eaed9f6d092$export$36b6d6ef312eab39; }, function (v) { return $01727eaed9f6d092$export$36b6d6ef312eab39 = v; });
$parcel$export($01727eaed9f6d092$exports, "getCiphers", function () { return $01727eaed9f6d092$export$58a258485f1e49f6; }, function (v) { return $01727eaed9f6d092$export$58a258485f1e49f6 = v; });
$parcel$export($01727eaed9f6d092$exports, "listCiphers", function () { return $01727eaed9f6d092$export$dedd8dc3dc62b370; }, function (v) { return $01727eaed9f6d092$export$dedd8dc3dc62b370 = v; });
$parcel$export($01727eaed9f6d092$exports, "DiffieHellmanGroup", function () { return $01727eaed9f6d092$export$971862a2fcb1bb40; }, function (v) { return $01727eaed9f6d092$export$971862a2fcb1bb40 = v; });
$parcel$export($01727eaed9f6d092$exports, "createDiffieHellmanGroup", function () { return $01727eaed9f6d092$export$c6ff6a88acbeaf40; }, function (v) { return $01727eaed9f6d092$export$c6ff6a88acbeaf40 = v; });
$parcel$export($01727eaed9f6d092$exports, "getDiffieHellman", function () { return $01727eaed9f6d092$export$fdc27893e98845cc; }, function (v) { return $01727eaed9f6d092$export$fdc27893e98845cc = v; });
$parcel$export($01727eaed9f6d092$exports, "createDiffieHellman", function () { return $01727eaed9f6d092$export$6671fb9a1323bed; }, function (v) { return $01727eaed9f6d092$export$6671fb9a1323bed = v; });
$parcel$export($01727eaed9f6d092$exports, "DiffieHellman", function () { return $01727eaed9f6d092$export$d74daf141a551db; }, function (v) { return $01727eaed9f6d092$export$d74daf141a551db = v; });
$parcel$export($01727eaed9f6d092$exports, "createSign", function () { return $01727eaed9f6d092$export$45df7cae684751af; }, function (v) { return $01727eaed9f6d092$export$45df7cae684751af = v; });
$parcel$export($01727eaed9f6d092$exports, "Sign", function () { return $01727eaed9f6d092$export$1db683ad541682f6; }, function (v) { return $01727eaed9f6d092$export$1db683ad541682f6 = v; });
$parcel$export($01727eaed9f6d092$exports, "createVerify", function () { return $01727eaed9f6d092$export$6f65485f87568e37; }, function (v) { return $01727eaed9f6d092$export$6f65485f87568e37 = v; });
$parcel$export($01727eaed9f6d092$exports, "Verify", function () { return $01727eaed9f6d092$export$91a8e56769aeb334; }, function (v) { return $01727eaed9f6d092$export$91a8e56769aeb334 = v; });
$parcel$export($01727eaed9f6d092$exports, "createECDH", function () { return $01727eaed9f6d092$export$2d4117e99c2179e4; }, function (v) { return $01727eaed9f6d092$export$2d4117e99c2179e4 = v; });
$parcel$export($01727eaed9f6d092$exports, "publicEncrypt", function () { return $01727eaed9f6d092$export$512823e338ddb1b7; }, function (v) { return $01727eaed9f6d092$export$512823e338ddb1b7 = v; });
$parcel$export($01727eaed9f6d092$exports, "privateEncrypt", function () { return $01727eaed9f6d092$export$9d0e0c0c4a8d30f3; }, function (v) { return $01727eaed9f6d092$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export($01727eaed9f6d092$exports, "publicDecrypt", function () { return $01727eaed9f6d092$export$b9d55ff329113abd; }, function (v) { return $01727eaed9f6d092$export$b9d55ff329113abd = v; });
$parcel$export($01727eaed9f6d092$exports, "privateDecrypt", function () { return $01727eaed9f6d092$export$7efb24e2fddf99b9; }, function (v) { return $01727eaed9f6d092$export$7efb24e2fddf99b9 = v; });
$parcel$export($01727eaed9f6d092$exports, "randomFill", function () { return $01727eaed9f6d092$export$bb1abf2ce84fc7e8; }, function (v) { return $01727eaed9f6d092$export$bb1abf2ce84fc7e8 = v; });
$parcel$export($01727eaed9f6d092$exports, "randomFillSync", function () { return $01727eaed9f6d092$export$2f7171e78e524d5e; }, function (v) { return $01727eaed9f6d092$export$2f7171e78e524d5e = v; });
$parcel$export($01727eaed9f6d092$exports, "createCredentials", function () { return $01727eaed9f6d092$export$e1d879b482f37d98; }, function (v) { return $01727eaed9f6d092$export$e1d879b482f37d98 = v; });
$parcel$export($01727eaed9f6d092$exports, "constants", function () { return $01727eaed9f6d092$export$1a988e7317c65621; }, function (v) { return $01727eaed9f6d092$export$1a988e7317c65621 = v; });
var $01727eaed9f6d092$export$5f828d93ff035aa8;
var $01727eaed9f6d092$export$cd94982b18c6332c;
var $01727eaed9f6d092$export$1d518568e4f529b0;
var $01727eaed9f6d092$export$5285b6d41c912b41;
var $01727eaed9f6d092$export$2fb37efbf6ae0c0e;
var $01727eaed9f6d092$export$ab85ecd77ce6a5cd;
var $01727eaed9f6d092$export$da39cf97e1eb7c91;
var $01727eaed9f6d092$export$52a9039d7177394f;
var $01727eaed9f6d092$export$f7201db400317331;
var $01727eaed9f6d092$export$448fa22aedc9dbca;
var $01727eaed9f6d092$export$b80c7ba289c8fa56;
var $01727eaed9f6d092$export$26e5786e8ac8e530;
var $01727eaed9f6d092$export$bdd223f16383713e;
var $01727eaed9f6d092$export$20533d26f07f1ee0;
var $01727eaed9f6d092$export$2f64596b8cbf08b4;
var $01727eaed9f6d092$export$2ce6d8d0e8b04e1a;
var $01727eaed9f6d092$export$12ada9414fbc594c;
var $01727eaed9f6d092$export$f5e7e39d57cd9700;
var $01727eaed9f6d092$export$36b6d6ef312eab39;
var $01727eaed9f6d092$export$58a258485f1e49f6;
var $01727eaed9f6d092$export$dedd8dc3dc62b370;
var $01727eaed9f6d092$export$971862a2fcb1bb40;
var $01727eaed9f6d092$export$c6ff6a88acbeaf40;
var $01727eaed9f6d092$export$fdc27893e98845cc;
var $01727eaed9f6d092$export$6671fb9a1323bed;
var $01727eaed9f6d092$export$d74daf141a551db;
var $01727eaed9f6d092$export$45df7cae684751af;
var $01727eaed9f6d092$export$1db683ad541682f6;
var $01727eaed9f6d092$export$6f65485f87568e37;
var $01727eaed9f6d092$export$91a8e56769aeb334;
var $01727eaed9f6d092$export$2d4117e99c2179e4;
var $01727eaed9f6d092$export$512823e338ddb1b7;
var $01727eaed9f6d092$export$9d0e0c0c4a8d30f3;
var $01727eaed9f6d092$export$b9d55ff329113abd;
var $01727eaed9f6d092$export$7efb24e2fddf99b9;
var $01727eaed9f6d092$export$bb1abf2ce84fc7e8;
var $01727eaed9f6d092$export$2f7171e78e524d5e;
var $01727eaed9f6d092$export$e1d879b482f37d98;
var $01727eaed9f6d092$export$1a988e7317c65621;
"use strict";

$01727eaed9f6d092$export$5f828d93ff035aa8 = $01727eaed9f6d092$export$cd94982b18c6332c = $01727eaed9f6d092$export$1d518568e4f529b0 = $01727eaed9f6d092$export$5285b6d41c912b41 = (parcelRequire("dKHN6"));

$01727eaed9f6d092$export$2fb37efbf6ae0c0e = $01727eaed9f6d092$export$ab85ecd77ce6a5cd = (parcelRequire("j8bQA"));

$01727eaed9f6d092$export$da39cf97e1eb7c91 = $01727eaed9f6d092$export$52a9039d7177394f = (parcelRequire("l2ANw"));
var $99b935d54e56d4c9$exports = {};
"use strict";

$99b935d54e56d4c9$exports = (parcelRequire("ggpby"));


var $01727eaed9f6d092$var$algoKeys = Object.keys($99b935d54e56d4c9$exports);
var $01727eaed9f6d092$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($01727eaed9f6d092$var$algoKeys);
$01727eaed9f6d092$export$f7201db400317331 = function() {
    return $01727eaed9f6d092$var$hashes;
};

var $2r16u = parcelRequire("2r16u");
$01727eaed9f6d092$export$448fa22aedc9dbca = $2r16u.pbkdf2;
$01727eaed9f6d092$export$b80c7ba289c8fa56 = $2r16u.pbkdf2Sync;
var $4291626505339b67$export$bdd223f16383713e;
var $4291626505339b67$export$26e5786e8ac8e530;
var $4291626505339b67$export$2f64596b8cbf08b4;
var $4291626505339b67$export$20533d26f07f1ee0;
var $4291626505339b67$export$12ada9414fbc594c;
var $4291626505339b67$export$2ce6d8d0e8b04e1a;
var $4291626505339b67$export$36b6d6ef312eab39;
var $4291626505339b67$export$f5e7e39d57cd9700;
var $4291626505339b67$export$dedd8dc3dc62b370;
var $4291626505339b67$export$58a258485f1e49f6;
var $4e7b59b52c41db33$exports = {};

var $61MIM = parcelRequire("61MIM");
var $efe0cc6de85c3d9f$export$eab97d15b1788b8d;
var $efe0cc6de85c3d9f$export$26e5786e8ac8e530;
var $efe0cc6de85c3d9f$export$cc8859615686b300;
var $efe0cc6de85c3d9f$export$8ad3f227af08fcc5;
var $efe0cc6de85c3d9f$export$947646e34766044f;
"use strict";

$efe0cc6de85c3d9f$export$eab97d15b1788b8d = (parcelRequire("aBLCl"));

$efe0cc6de85c3d9f$export$26e5786e8ac8e530 = (parcelRequire("ouHy4"));

$efe0cc6de85c3d9f$export$cc8859615686b300 = (parcelRequire("9Euae"));

$efe0cc6de85c3d9f$export$8ad3f227af08fcc5 = (parcelRequire("g6X0U"));

$efe0cc6de85c3d9f$export$947646e34766044f = (parcelRequire("jKeW6"));



var $kvFQ5 = parcelRequire("kvFQ5");

var $eN0t8 = parcelRequire("eN0t8");
var $4e7b59b52c41db33$require$Buffer = $eN0t8.Buffer;
var $4e7b59b52c41db33$var$modes = {
    "des-ede3-cbc": $efe0cc6de85c3d9f$export$8ad3f227af08fcc5.instantiate($efe0cc6de85c3d9f$export$947646e34766044f),
    "des-ede3": $efe0cc6de85c3d9f$export$947646e34766044f,
    "des-ede-cbc": $efe0cc6de85c3d9f$export$8ad3f227af08fcc5.instantiate($efe0cc6de85c3d9f$export$947646e34766044f),
    "des-ede": $efe0cc6de85c3d9f$export$947646e34766044f,
    "des-cbc": $efe0cc6de85c3d9f$export$8ad3f227af08fcc5.instantiate($efe0cc6de85c3d9f$export$cc8859615686b300),
    "des-ecb": $efe0cc6de85c3d9f$export$cc8859615686b300
};
$4e7b59b52c41db33$var$modes.des = $4e7b59b52c41db33$var$modes["des-cbc"];
$4e7b59b52c41db33$var$modes.des3 = $4e7b59b52c41db33$var$modes["des-ede3-cbc"];
$4e7b59b52c41db33$exports = $4e7b59b52c41db33$var$DES;
$kvFQ5($4e7b59b52c41db33$var$DES, $61MIM);
function $4e7b59b52c41db33$var$DES(opts) {
    $61MIM.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $4e7b59b52c41db33$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$4e7b59b52c41db33$require$Buffer.isBuffer(key)) key = $4e7b59b52c41db33$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $4e7b59b52c41db33$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$4e7b59b52c41db33$require$Buffer.isBuffer(iv)) iv = $4e7b59b52c41db33$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$4e7b59b52c41db33$var$DES.prototype._update = function(data) {
    return $4e7b59b52c41db33$require$Buffer.from(this._des.update(data));
};
$4e7b59b52c41db33$var$DES.prototype._final = function() {
    return $4e7b59b52c41db33$require$Buffer.from(this._des.final());
};



var $X9qDO = parcelRequire("X9qDO");

var $E9Jyp = parcelRequire("E9Jyp");
var $d59896ab6aaf4a76$exports = {};

$parcel$export($d59896ab6aaf4a76$exports, "des-ecb", function () { return $d59896ab6aaf4a76$export$116f8a5cee447347; }, function (v) { return $d59896ab6aaf4a76$export$116f8a5cee447347 = v; });
$parcel$export($d59896ab6aaf4a76$exports, "des-cbc", function () { return $d59896ab6aaf4a76$export$7483c4066bfb7ae9; }, function (v) { return $d59896ab6aaf4a76$export$7483c4066bfb7ae9 = v; });
$parcel$export($d59896ab6aaf4a76$exports, "des", function () { return $d59896ab6aaf4a76$export$e7a565d2e588bb06; }, function (v) { return $d59896ab6aaf4a76$export$e7a565d2e588bb06 = v; });
$parcel$export($d59896ab6aaf4a76$exports, "des-ede3-cbc", function () { return $d59896ab6aaf4a76$export$aaa2f54a426f3eb8; }, function (v) { return $d59896ab6aaf4a76$export$aaa2f54a426f3eb8 = v; });
$parcel$export($d59896ab6aaf4a76$exports, "des3", function () { return $d59896ab6aaf4a76$export$eba20568dde4ada; }, function (v) { return $d59896ab6aaf4a76$export$eba20568dde4ada = v; });
$parcel$export($d59896ab6aaf4a76$exports, "des-ede3", function () { return $d59896ab6aaf4a76$export$d3b5e5996938f5ae; }, function (v) { return $d59896ab6aaf4a76$export$d3b5e5996938f5ae = v; });
$parcel$export($d59896ab6aaf4a76$exports, "des-ede-cbc", function () { return $d59896ab6aaf4a76$export$57c08356130bc99b; }, function (v) { return $d59896ab6aaf4a76$export$57c08356130bc99b = v; });
$parcel$export($d59896ab6aaf4a76$exports, "des-ede", function () { return $d59896ab6aaf4a76$export$c7169791d5c1e65d; }, function (v) { return $d59896ab6aaf4a76$export$c7169791d5c1e65d = v; });
var $d59896ab6aaf4a76$export$116f8a5cee447347;
var $d59896ab6aaf4a76$export$7483c4066bfb7ae9;
var $d59896ab6aaf4a76$export$e7a565d2e588bb06;
var $d59896ab6aaf4a76$export$aaa2f54a426f3eb8;
var $d59896ab6aaf4a76$export$eba20568dde4ada;
var $d59896ab6aaf4a76$export$d3b5e5996938f5ae;
var $d59896ab6aaf4a76$export$57c08356130bc99b;
var $d59896ab6aaf4a76$export$c7169791d5c1e65d;
$d59896ab6aaf4a76$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$d59896ab6aaf4a76$export$7483c4066bfb7ae9 = $d59896ab6aaf4a76$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$d59896ab6aaf4a76$export$aaa2f54a426f3eb8 = $d59896ab6aaf4a76$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$d59896ab6aaf4a76$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$d59896ab6aaf4a76$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$d59896ab6aaf4a76$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};



var $bFXtK = parcelRequire("bFXtK");
function $4291626505339b67$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($E9Jyp[suite]) {
        keyLen = $E9Jyp[suite].key;
        ivLen = $E9Jyp[suite].iv;
    } else if ($d59896ab6aaf4a76$exports[suite]) {
        keyLen = $d59896ab6aaf4a76$exports[suite].key * 8;
        ivLen = $d59896ab6aaf4a76$exports[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bFXtK(password, false, keyLen, ivLen);
    return $4291626505339b67$var$createCipheriv(suite, keys.key, keys.iv);
}
function $4291626505339b67$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($E9Jyp[suite]) {
        keyLen = $E9Jyp[suite].key;
        ivLen = $E9Jyp[suite].iv;
    } else if ($d59896ab6aaf4a76$exports[suite]) {
        keyLen = $d59896ab6aaf4a76$exports[suite].key * 8;
        ivLen = $d59896ab6aaf4a76$exports[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bFXtK(password, false, keyLen, ivLen);
    return $4291626505339b67$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $4291626505339b67$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($E9Jyp[suite]) return $X9qDO.createCipheriv(suite, key, iv);
    if ($d59896ab6aaf4a76$exports[suite]) return new $4e7b59b52c41db33$exports({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $4291626505339b67$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($E9Jyp[suite]) return $X9qDO.createDecipheriv(suite, key, iv);
    if ($d59896ab6aaf4a76$exports[suite]) return new $4e7b59b52c41db33$exports({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $4291626505339b67$var$getCiphers() {
    return Object.keys($d59896ab6aaf4a76$exports).concat($X9qDO.getCiphers());
}
$4291626505339b67$export$bdd223f16383713e = $4291626505339b67$export$26e5786e8ac8e530 = $4291626505339b67$var$createCipher;
$4291626505339b67$export$2f64596b8cbf08b4 = $4291626505339b67$export$20533d26f07f1ee0 = $4291626505339b67$var$createCipheriv;
$4291626505339b67$export$12ada9414fbc594c = $4291626505339b67$export$2ce6d8d0e8b04e1a = $4291626505339b67$var$createDecipher;
$4291626505339b67$export$36b6d6ef312eab39 = $4291626505339b67$export$f5e7e39d57cd9700 = $4291626505339b67$var$createDecipheriv;
$4291626505339b67$export$dedd8dc3dc62b370 = $4291626505339b67$export$58a258485f1e49f6 = $4291626505339b67$var$getCiphers;


$01727eaed9f6d092$export$26e5786e8ac8e530 = $4291626505339b67$export$26e5786e8ac8e530;
$01727eaed9f6d092$export$bdd223f16383713e = $4291626505339b67$export$bdd223f16383713e;
$01727eaed9f6d092$export$20533d26f07f1ee0 = $4291626505339b67$export$20533d26f07f1ee0;
$01727eaed9f6d092$export$2f64596b8cbf08b4 = $4291626505339b67$export$2f64596b8cbf08b4;
$01727eaed9f6d092$export$2ce6d8d0e8b04e1a = $4291626505339b67$export$2ce6d8d0e8b04e1a;
$01727eaed9f6d092$export$12ada9414fbc594c = $4291626505339b67$export$12ada9414fbc594c;
$01727eaed9f6d092$export$f5e7e39d57cd9700 = $4291626505339b67$export$f5e7e39d57cd9700;
$01727eaed9f6d092$export$36b6d6ef312eab39 = $4291626505339b67$export$36b6d6ef312eab39;
$01727eaed9f6d092$export$58a258485f1e49f6 = $4291626505339b67$export$58a258485f1e49f6;
$01727eaed9f6d092$export$dedd8dc3dc62b370 = $4291626505339b67$export$dedd8dc3dc62b370;
var $5f8f97ac25e7a545$export$971862a2fcb1bb40;
var $5f8f97ac25e7a545$export$c6ff6a88acbeaf40;
var $5f8f97ac25e7a545$export$fdc27893e98845cc;
var $5f8f97ac25e7a545$export$6671fb9a1323bed;
var $5f8f97ac25e7a545$export$d74daf141a551db;

var $gzLuY = parcelRequire("gzLuY");
var $5f8f97ac25e7a545$require$Buffer = $gzLuY.Buffer;
var $87934870d13ece7f$exports = {};

var $dKHN6 = parcelRequire("dKHN6");
$87934870d13ece7f$exports = $87934870d13ece7f$var$findPrime;
$87934870d13ece7f$var$findPrime.simpleSieve = $87934870d13ece7f$var$simpleSieve;
$87934870d13ece7f$var$findPrime.fermatTest = $87934870d13ece7f$var$fermatTest;

var $jlWHo = parcelRequire("jlWHo");
var $87934870d13ece7f$var$TWENTYFOUR = new $jlWHo(24);
var $0189b730b56b1c28$exports = {};

var $jlWHo = parcelRequire("jlWHo");

var $8v4zB = parcelRequire("8v4zB");
function $0189b730b56b1c28$var$MillerRabin(rand) {
    this.rand = rand || new $8v4zB.Rand();
}
$0189b730b56b1c28$exports = $0189b730b56b1c28$var$MillerRabin;
$0189b730b56b1c28$var$MillerRabin.create = function create(rand) {
    return new $0189b730b56b1c28$var$MillerRabin(rand);
};
$0189b730b56b1c28$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $jlWHo(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$0189b730b56b1c28$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$0189b730b56b1c28$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $jlWHo.mont(n);
    var rone = new $jlWHo(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $jlWHo(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$0189b730b56b1c28$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $jlWHo.mont(n);
    var rone = new $jlWHo(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $jlWHo(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};


var $87934870d13ece7f$var$millerRabin = new $0189b730b56b1c28$exports();
var $87934870d13ece7f$var$ONE = new $jlWHo(1);
var $87934870d13ece7f$var$TWO = new $jlWHo(2);
var $87934870d13ece7f$var$FIVE = new $jlWHo(5);
var $87934870d13ece7f$var$SIXTEEN = new $jlWHo(16);
var $87934870d13ece7f$var$EIGHT = new $jlWHo(8);
var $87934870d13ece7f$var$TEN = new $jlWHo(10);
var $87934870d13ece7f$var$THREE = new $jlWHo(3);
var $87934870d13ece7f$var$SEVEN = new $jlWHo(7);
var $87934870d13ece7f$var$ELEVEN = new $jlWHo(11);
var $87934870d13ece7f$var$FOUR = new $jlWHo(4);
var $87934870d13ece7f$var$TWELVE = new $jlWHo(12);
var $87934870d13ece7f$var$primes = null;
function $87934870d13ece7f$var$_getPrimes() {
    if ($87934870d13ece7f$var$primes !== null) return $87934870d13ece7f$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $87934870d13ece7f$var$primes = res;
    return res;
}
function $87934870d13ece7f$var$simpleSieve(p) {
    var primes = $87934870d13ece7f$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $87934870d13ece7f$var$fermatTest(p) {
    var red = $jlWHo.mont(p);
    return $87934870d13ece7f$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $87934870d13ece7f$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $jlWHo([
            0x8c,
            0x7b
        ]);
        else return new $jlWHo([
            0x8c,
            0x27
        ]);
    }
    gen = new $jlWHo(gen);
    var num, n2;
    while(true){
        num = new $jlWHo($dKHN6(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($87934870d13ece7f$var$ONE);
        if (!num.testn(1)) num.iadd($87934870d13ece7f$var$TWO);
        if (!gen.cmp($87934870d13ece7f$var$TWO)) while(num.mod($87934870d13ece7f$var$TWENTYFOUR).cmp($87934870d13ece7f$var$ELEVEN))num.iadd($87934870d13ece7f$var$FOUR);
        else if (!gen.cmp($87934870d13ece7f$var$FIVE)) while(num.mod($87934870d13ece7f$var$TEN).cmp($87934870d13ece7f$var$THREE))num.iadd($87934870d13ece7f$var$FOUR);
        n2 = num.shrn(1);
        if ($87934870d13ece7f$var$simpleSieve(n2) && $87934870d13ece7f$var$simpleSieve(num) && $87934870d13ece7f$var$fermatTest(n2) && $87934870d13ece7f$var$fermatTest(num) && $87934870d13ece7f$var$millerRabin.test(n2) && $87934870d13ece7f$var$millerRabin.test(num)) return num;
    }
}


var $433880d1bfbdb3ed$exports = {};
$433880d1bfbdb3ed$exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');


var $17aa365fa91a3dcc$exports = {};

var $gzLuY = parcelRequire("gzLuY");
var $17aa365fa91a3dcc$require$Buffer = $gzLuY.Buffer;

var $jlWHo = parcelRequire("jlWHo");

var $17aa365fa91a3dcc$var$millerRabin = new $0189b730b56b1c28$exports();
var $17aa365fa91a3dcc$var$TWENTYFOUR = new $jlWHo(24);
var $17aa365fa91a3dcc$var$ELEVEN = new $jlWHo(11);
var $17aa365fa91a3dcc$var$TEN = new $jlWHo(10);
var $17aa365fa91a3dcc$var$THREE = new $jlWHo(3);
var $17aa365fa91a3dcc$var$SEVEN = new $jlWHo(7);


var $dKHN6 = parcelRequire("dKHN6");
$17aa365fa91a3dcc$exports = $17aa365fa91a3dcc$var$DH;
function $17aa365fa91a3dcc$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$17aa365fa91a3dcc$require$Buffer.isBuffer(pub)) pub = new $17aa365fa91a3dcc$require$Buffer(pub, enc);
    this._pub = new $jlWHo(pub);
    return this;
}
function $17aa365fa91a3dcc$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$17aa365fa91a3dcc$require$Buffer.isBuffer(priv)) priv = new $17aa365fa91a3dcc$require$Buffer(priv, enc);
    this._priv = new $jlWHo(priv);
    return this;
}
var $17aa365fa91a3dcc$var$primeCache = {};
function $17aa365fa91a3dcc$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $17aa365fa91a3dcc$var$primeCache) return $17aa365fa91a3dcc$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$87934870d13ece7f$exports.simpleSieve || !$87934870d13ece7f$exports.fermatTest(prime) || !$17aa365fa91a3dcc$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $17aa365fa91a3dcc$var$primeCache[hex] = error;
        return error;
    }
    if (!$17aa365fa91a3dcc$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($17aa365fa91a3dcc$var$TWENTYFOUR).cmp($17aa365fa91a3dcc$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($17aa365fa91a3dcc$var$TEN);
            if (rem.cmp($17aa365fa91a3dcc$var$THREE) && rem.cmp($17aa365fa91a3dcc$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $17aa365fa91a3dcc$var$primeCache[hex] = error;
    return error;
}
function $17aa365fa91a3dcc$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $jlWHo(prime);
    this._prime = $jlWHo.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $17aa365fa91a3dcc$var$setPublicKey;
        this.setPrivateKey = $17aa365fa91a3dcc$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($17aa365fa91a3dcc$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = $17aa365fa91a3dcc$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$17aa365fa91a3dcc$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $jlWHo($dKHN6(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$17aa365fa91a3dcc$var$DH.prototype.computeSecret = function(other) {
    other = new $jlWHo(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $17aa365fa91a3dcc$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $17aa365fa91a3dcc$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $17aa365fa91a3dcc$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$17aa365fa91a3dcc$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $17aa365fa91a3dcc$var$formatReturnValue(this._pub, enc);
};
$17aa365fa91a3dcc$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $17aa365fa91a3dcc$var$formatReturnValue(this._priv, enc);
};
$17aa365fa91a3dcc$var$DH.prototype.getPrime = function(enc) {
    return $17aa365fa91a3dcc$var$formatReturnValue(this.__prime, enc);
};
$17aa365fa91a3dcc$var$DH.prototype.getGenerator = function(enc) {
    return $17aa365fa91a3dcc$var$formatReturnValue(this._gen, enc);
};
$17aa365fa91a3dcc$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$17aa365fa91a3dcc$require$Buffer.isBuffer(gen)) gen = new $17aa365fa91a3dcc$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $jlWHo(gen);
    return this;
};
function $17aa365fa91a3dcc$var$formatReturnValue(bn, enc) {
    var buf = new $17aa365fa91a3dcc$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}


function $5f8f97ac25e7a545$var$getDiffieHellman(mod) {
    var prime = new $5f8f97ac25e7a545$require$Buffer($433880d1bfbdb3ed$exports[mod].prime, "hex");
    var gen = new $5f8f97ac25e7a545$require$Buffer($433880d1bfbdb3ed$exports[mod].gen, "hex");
    return new $17aa365fa91a3dcc$exports(prime, gen);
}
var $5f8f97ac25e7a545$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $5f8f97ac25e7a545$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($5f8f97ac25e7a545$require$Buffer.isBuffer(enc) || $5f8f97ac25e7a545$var$ENCODINGS[enc] === undefined) return $5f8f97ac25e7a545$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $5f8f97ac25e7a545$require$Buffer([
        2
    ]);
    if (!$5f8f97ac25e7a545$require$Buffer.isBuffer(generator)) generator = new $5f8f97ac25e7a545$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $17aa365fa91a3dcc$exports($87934870d13ece7f$exports(prime, generator), generator, true);
    if (!$5f8f97ac25e7a545$require$Buffer.isBuffer(prime)) prime = new $5f8f97ac25e7a545$require$Buffer(prime, enc);
    return new $17aa365fa91a3dcc$exports(prime, generator, true);
}
$5f8f97ac25e7a545$export$971862a2fcb1bb40 = $5f8f97ac25e7a545$export$c6ff6a88acbeaf40 = $5f8f97ac25e7a545$export$fdc27893e98845cc = $5f8f97ac25e7a545$var$getDiffieHellman;
$5f8f97ac25e7a545$export$6671fb9a1323bed = $5f8f97ac25e7a545$export$d74daf141a551db = $5f8f97ac25e7a545$var$createDiffieHellman;


$01727eaed9f6d092$export$971862a2fcb1bb40 = $5f8f97ac25e7a545$export$971862a2fcb1bb40;
$01727eaed9f6d092$export$c6ff6a88acbeaf40 = $5f8f97ac25e7a545$export$c6ff6a88acbeaf40;
$01727eaed9f6d092$export$fdc27893e98845cc = $5f8f97ac25e7a545$export$fdc27893e98845cc;
$01727eaed9f6d092$export$6671fb9a1323bed = $5f8f97ac25e7a545$export$6671fb9a1323bed;
$01727eaed9f6d092$export$d74daf141a551db = $5f8f97ac25e7a545$export$d74daf141a551db;
var $ed6948bfbd0d8ac6$exports = {};
"use strict";

var $eN0t8 = parcelRequire("eN0t8");
var $ed6948bfbd0d8ac6$require$Buffer = $eN0t8.Buffer;

var $j8bQA = parcelRequire("j8bQA");

var $CyGSj = parcelRequire("CyGSj");

var $kvFQ5 = parcelRequire("kvFQ5");
var $0bd6d60ea2b8775c$exports = {};
"use strict";

var $eN0t8 = parcelRequire("eN0t8");
var $0bd6d60ea2b8775c$require$Buffer = $eN0t8.Buffer;

var $l2ANw = parcelRequire("l2ANw");

var $lp4ea = parcelRequire("lp4ea");

var $492wS = parcelRequire("492wS");
var $0bd6d60ea2b8775c$require$EC = $492wS.ec;

var $iDQh3 = parcelRequire("iDQh3");

var $5nDla = parcelRequire("5nDla");
var $98149f309b1e3054$exports = {};
$98149f309b1e3054$exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');


var $0bd6d60ea2b8775c$var$RSA_PKCS1_PADDING = 1;
function $0bd6d60ea2b8775c$var$sign(hash, key, hashType, signType, tag) {
    var priv = $5nDla(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $0bd6d60ea2b8775c$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $0bd6d60ea2b8775c$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    if (key.padding !== undefined && key.padding !== $0bd6d60ea2b8775c$var$RSA_PKCS1_PADDING) throw new Error("illegal or unsupported padding mode");
    hash = $0bd6d60ea2b8775c$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $lp4ea(pad, priv);
    return out;
}
function $0bd6d60ea2b8775c$var$ecSign(hash, priv) {
    var curveId = $98149f309b1e3054$exports[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $0bd6d60ea2b8775c$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $0bd6d60ea2b8775c$require$Buffer.from(out.toDER());
}
function $0bd6d60ea2b8775c$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $iDQh3(0);
    var k;
    var H = $0bd6d60ea2b8775c$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $0bd6d60ea2b8775c$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $0bd6d60ea2b8775c$var$makeKey(q, kv, algo);
        r = $0bd6d60ea2b8775c$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $iDQh3(0);
        }
    }
    return $0bd6d60ea2b8775c$var$toDER(r, s);
}
function $0bd6d60ea2b8775c$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $0bd6d60ea2b8775c$require$Buffer.from(res);
}
function $0bd6d60ea2b8775c$var$getKey(x, q, hash, algo) {
    x = $0bd6d60ea2b8775c$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $0bd6d60ea2b8775c$require$Buffer.alloc(q.byteLength() - x.length);
        x = $0bd6d60ea2b8775c$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $0bd6d60ea2b8775c$var$bits2octets(hash, q);
    var v = $0bd6d60ea2b8775c$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $0bd6d60ea2b8775c$require$Buffer.alloc(hlen);
    k = $l2ANw(algo, k).update(v).update($0bd6d60ea2b8775c$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $l2ANw(algo, k).update(v).digest();
    k = $l2ANw(algo, k).update(v).update($0bd6d60ea2b8775c$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $l2ANw(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $0bd6d60ea2b8775c$var$bits2int(obits, q) {
    var bits = new $iDQh3(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $0bd6d60ea2b8775c$var$bits2octets(bits, q) {
    bits = $0bd6d60ea2b8775c$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $0bd6d60ea2b8775c$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $0bd6d60ea2b8775c$require$Buffer.alloc(q.byteLength() - out.length);
        out = $0bd6d60ea2b8775c$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $0bd6d60ea2b8775c$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $0bd6d60ea2b8775c$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $l2ANw(algo, kv.k).update(kv.v).digest();
            t = $0bd6d60ea2b8775c$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $0bd6d60ea2b8775c$var$bits2int(t, q);
        kv.k = $l2ANw(algo, kv.k).update(kv.v).update($0bd6d60ea2b8775c$require$Buffer.from([
            0
        ])).digest();
        kv.v = $l2ANw(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $0bd6d60ea2b8775c$var$makeR(g, k, p, q) {
    return g.toRed($iDQh3.mont(p)).redPow(k).fromRed().mod(q);
}
$0bd6d60ea2b8775c$exports = $0bd6d60ea2b8775c$var$sign;
$0bd6d60ea2b8775c$exports.getKey = $0bd6d60ea2b8775c$var$getKey;
$0bd6d60ea2b8775c$exports.makeKey = $0bd6d60ea2b8775c$var$makeKey;


var $8921520de794f4c4$exports = {};
"use strict";

var $eN0t8 = parcelRequire("eN0t8");
var $8921520de794f4c4$require$Buffer = $eN0t8.Buffer;

var $iDQh3 = parcelRequire("iDQh3");

var $492wS = parcelRequire("492wS");
var $8921520de794f4c4$require$EC = $492wS.ec;

var $5nDla = parcelRequire("5nDla");

function $8921520de794f4c4$var$verify(sig, hash, key, signType, tag) {
    var pub = $5nDla(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $8921520de794f4c4$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $8921520de794f4c4$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    hash = $8921520de794f4c4$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $8921520de794f4c4$require$Buffer.from(pad);
    var red = $iDQh3.mont(pub.modulus);
    sig = new $iDQh3(sig).toRed(red);
    sig = sig.redPow(new $iDQh3(pub.publicExponent));
    sig = $8921520de794f4c4$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $8921520de794f4c4$var$ecVerify(sig, hash, pub) {
    var curveId = $98149f309b1e3054$exports[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $8921520de794f4c4$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $8921520de794f4c4$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $5nDla.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $8921520de794f4c4$var$checkValue(s, q);
    $8921520de794f4c4$var$checkValue(r, q);
    var montp = $iDQh3.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $iDQh3(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $8921520de794f4c4$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= 0) throw new Error("invalid sig");
}
$8921520de794f4c4$exports = $8921520de794f4c4$var$verify;



var $ggpby = parcelRequire("ggpby");
Object.keys($ggpby).forEach(function(key) {
    $ggpby[key].id = $ed6948bfbd0d8ac6$require$Buffer.from($ggpby[key].id, "hex");
    $ggpby[key.toLowerCase()] = $ggpby[key];
});
function $ed6948bfbd0d8ac6$var$Sign(algorithm) {
    $CyGSj.Writable.call(this);
    var data = $ggpby[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $j8bQA(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$kvFQ5($ed6948bfbd0d8ac6$var$Sign, $CyGSj.Writable);
$ed6948bfbd0d8ac6$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$ed6948bfbd0d8ac6$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $ed6948bfbd0d8ac6$require$Buffer.from(data, enc) : data);
    return this;
};
$ed6948bfbd0d8ac6$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $0bd6d60ea2b8775c$exports(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $ed6948bfbd0d8ac6$var$Verify(algorithm) {
    $CyGSj.Writable.call(this);
    var data = $ggpby[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $j8bQA(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$kvFQ5($ed6948bfbd0d8ac6$var$Verify, $CyGSj.Writable);
$ed6948bfbd0d8ac6$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$ed6948bfbd0d8ac6$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $ed6948bfbd0d8ac6$require$Buffer.from(data, enc) : data);
    return this;
};
$ed6948bfbd0d8ac6$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === "string" ? $ed6948bfbd0d8ac6$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $8921520de794f4c4$exports(sigBuffer, hash, key, this._signType, this._tag);
};
function $ed6948bfbd0d8ac6$var$createSign(algorithm) {
    return new $ed6948bfbd0d8ac6$var$Sign(algorithm);
}
function $ed6948bfbd0d8ac6$var$createVerify(algorithm) {
    return new $ed6948bfbd0d8ac6$var$Verify(algorithm);
}
$ed6948bfbd0d8ac6$exports = {
    Sign: $ed6948bfbd0d8ac6$var$createSign,
    Verify: $ed6948bfbd0d8ac6$var$createVerify,
    createSign: $ed6948bfbd0d8ac6$var$createSign,
    createVerify: $ed6948bfbd0d8ac6$var$createVerify
};


$01727eaed9f6d092$export$45df7cae684751af = $ed6948bfbd0d8ac6$exports.createSign;
$01727eaed9f6d092$export$1db683ad541682f6 = $ed6948bfbd0d8ac6$exports.Sign;
$01727eaed9f6d092$export$6f65485f87568e37 = $ed6948bfbd0d8ac6$exports.createVerify;
$01727eaed9f6d092$export$91a8e56769aeb334 = $ed6948bfbd0d8ac6$exports.Verify;

$01727eaed9f6d092$export$2d4117e99c2179e4 = (parcelRequire("5NdVi"));
var $001340f5b02c20b3$export$512823e338ddb1b7;
var $001340f5b02c20b3$export$7efb24e2fddf99b9;
var $001340f5b02c20b3$export$9d0e0c0c4a8d30f3;
var $001340f5b02c20b3$export$b9d55ff329113abd;

$001340f5b02c20b3$export$512823e338ddb1b7 = (parcelRequire("gsjO5"));

$001340f5b02c20b3$export$7efb24e2fddf99b9 = (parcelRequire("jxvLt"));
$001340f5b02c20b3$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $001340f5b02c20b3$export$512823e338ddb1b7(key, buf, true);
};
$001340f5b02c20b3$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $001340f5b02c20b3$export$7efb24e2fddf99b9(key, buf, true);
};


$01727eaed9f6d092$export$512823e338ddb1b7 = $001340f5b02c20b3$export$512823e338ddb1b7;
$01727eaed9f6d092$export$9d0e0c0c4a8d30f3 = $001340f5b02c20b3$export$9d0e0c0c4a8d30f3;
$01727eaed9f6d092$export$b9d55ff329113abd = $001340f5b02c20b3$export$b9d55ff329113abd;
$01727eaed9f6d092$export$7efb24e2fddf99b9 = $001340f5b02c20b3$export$7efb24e2fddf99b9;
var $5c8eac7a23417e30$export$bb1abf2ce84fc7e8;
var $5c8eac7a23417e30$export$2f7171e78e524d5e;

var $aqbQf = parcelRequire("aqbQf");
"use strict";
function $5c8eac7a23417e30$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $eN0t8 = parcelRequire("eN0t8");

var $dKHN6 = parcelRequire("dKHN6");
var $5c8eac7a23417e30$var$Buffer = $eN0t8.Buffer;
var $5c8eac7a23417e30$var$kBufferMaxLength = $eN0t8.kMaxLength;
var $5c8eac7a23417e30$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $5c8eac7a23417e30$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $5c8eac7a23417e30$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $5c8eac7a23417e30$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $5c8eac7a23417e30$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $5c8eac7a23417e30$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $5c8eac7a23417e30$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $5c8eac7a23417e30$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($5c8eac7a23417e30$var$crypto && $5c8eac7a23417e30$var$crypto.getRandomValues || false) {
    $5c8eac7a23417e30$export$bb1abf2ce84fc7e8 = $5c8eac7a23417e30$var$randomFill;
    $5c8eac7a23417e30$export$2f7171e78e524d5e = $5c8eac7a23417e30$var$randomFillSync;
} else {
    $5c8eac7a23417e30$export$bb1abf2ce84fc7e8 = $5c8eac7a23417e30$var$oldBrowser;
    $5c8eac7a23417e30$export$2f7171e78e524d5e = $5c8eac7a23417e30$var$oldBrowser;
}
function $5c8eac7a23417e30$var$randomFill(buf, offset, size, cb) {
    if (!$5c8eac7a23417e30$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $5c8eac7a23417e30$var$assertOffset(offset, buf.length);
    $5c8eac7a23417e30$var$assertSize(size, offset, buf.length);
    return $5c8eac7a23417e30$var$actualFill(buf, offset, size, cb);
}
function $5c8eac7a23417e30$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $5c8eac7a23417e30$var$crypto.getRandomValues(uint);
    if (cb) {
        $aqbQf.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $dKHN6(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $dKHN6(size);
    bytes.copy(buf, offset);
    return buf;
}
function $5c8eac7a23417e30$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$5c8eac7a23417e30$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $5c8eac7a23417e30$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $5c8eac7a23417e30$var$assertSize(size, offset, buf.length);
    return $5c8eac7a23417e30$var$actualFill(buf, offset, size);
}


$01727eaed9f6d092$export$bb1abf2ce84fc7e8 = $5c8eac7a23417e30$export$bb1abf2ce84fc7e8;
$01727eaed9f6d092$export$2f7171e78e524d5e = $5c8eac7a23417e30$export$2f7171e78e524d5e;
$01727eaed9f6d092$export$e1d879b482f37d98 = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
$01727eaed9f6d092$export$1a988e7317c65621 = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};


var $3d6ef1dd507024a2$exports = {};
$3d6ef1dd507024a2$exports = JSON.parse('{"name":"dotenv","version":"16.3.1","description":"Loads environment variables from .env file","main":"lib/main.js","types":"lib/main.d.ts","exports":{".":{"types":"./lib/main.d.ts","require":"./lib/main.js","default":"./lib/main.js"},"./config":"./config.js","./config.js":"./config.js","./lib/env-options":"./lib/env-options.js","./lib/env-options.js":"./lib/env-options.js","./lib/cli-options":"./lib/cli-options.js","./lib/cli-options.js":"./lib/cli-options.js","./package.json":"./package.json"},"scripts":{"dts-check":"tsc --project tests/types/tsconfig.json","lint":"standard","lint-readme":"standard-markdown","pretest":"npm run lint && npm run dts-check","test":"tap tests/*.js --100 -Rspec","prerelease":"npm test","release":"standard-version"},"repository":{"type":"git","url":"git://github.com/motdotla/dotenv.git"},"funding":"https://github.com/motdotla/dotenv?sponsor=1","keywords":["dotenv","env",".env","environment","variables","config","settings"],"readmeFilename":"README.md","license":"BSD-2-Clause","devDependencies":{"@definitelytyped/dtslint":"^0.0.133","@types/node":"^18.11.3","decache":"^4.6.1","sinon":"^14.0.1","standard":"^17.0.0","standard-markdown":"^7.1.0","standard-version":"^9.5.0","tap":"^16.3.0","tar":"^6.1.11","typescript":"^4.8.4"},"engines":{"node":">=12"},"browser":{"fs":false}}');


const $e926e63dbac648e0$var$version = $3d6ef1dd507024a2$exports.version;
const $e926e63dbac648e0$var$LINE = /(?:^|^)\s*(?:export\s+)?([\w.-]+)(?:\s*=\s*?|:\s+?)(\s*'(?:\\'|[^'])*'|\s*"(?:\\"|[^"])*"|\s*`(?:\\`|[^`])*`|[^#\r\n]+)?\s*(?:#.*)?(?:$|$)/mg;
// Parse src into an Object
function $e926e63dbac648e0$var$parse(src) {
    const obj = {};
    // Convert buffer to string
    let lines = src.toString();
    // Convert line breaks to same format
    lines = lines.replace(/\r\n?/mg, "\n");
    let match;
    while((match = $e926e63dbac648e0$var$LINE.exec(lines)) != null){
        const key = match[1];
        // Default undefined or null to empty string
        let value = match[2] || "";
        // Remove whitespace
        value = value.trim();
        // Check if double quoted
        const maybeQuote = value[0];
        // Remove surrounding quotes
        value = value.replace(/^(['"`])([\s\S]*)\1$/mg, "$2");
        // Expand newlines if double quoted
        if (maybeQuote === '"') {
            value = value.replace(/\\n/g, "\n");
            value = value.replace(/\\r/g, "\r");
        }
        // Add to object
        obj[key] = value;
    }
    return obj;
}
function $e926e63dbac648e0$var$_parseVault(options) {
    const vaultPath = $e926e63dbac648e0$var$_vaultPath(options);
    // Parse .env.vault
    const result = $e926e63dbac648e0$var$DotenvModule.configDotenv({
        path: vaultPath
    });
    if (!result.parsed) throw new Error(`MISSING_DATA: Cannot parse ${vaultPath} for an unknown reason`);
    // handle scenario for comma separated keys - for use with key rotation
    // example: DOTENV_KEY="dotenv://:key_1234@dotenv.org/vault/.env.vault?environment=prod,dotenv://:key_7890@dotenv.org/vault/.env.vault?environment=prod"
    const keys = $e926e63dbac648e0$var$_dotenvKey(options).split(",");
    const length = keys.length;
    let decrypted;
    for(let i = 0; i < length; i++)try {
        // Get full key
        const key = keys[i].trim();
        // Get instructions for decrypt
        const attrs = $e926e63dbac648e0$var$_instructions(result, key);
        // Decrypt
        decrypted = $e926e63dbac648e0$var$DotenvModule.decrypt(attrs.ciphertext, attrs.key);
        break;
    } catch (error) {
        // last key
        if (i + 1 >= length) throw error;
    // try next key
    }
    // Parse decrypted .env string
    return $e926e63dbac648e0$var$DotenvModule.parse(decrypted);
}
function $e926e63dbac648e0$var$_log(message) {
    console.log(`[dotenv@${$e926e63dbac648e0$var$version}][INFO] ${message}`);
}
function $e926e63dbac648e0$var$_warn(message) {
    console.log(`[dotenv@${$e926e63dbac648e0$var$version}][WARN] ${message}`);
}
function $e926e63dbac648e0$var$_debug(message) {
    console.log(`[dotenv@${$e926e63dbac648e0$var$version}][DEBUG] ${message}`);
}
function $e926e63dbac648e0$var$_dotenvKey(options) {
    // prioritize developer directly setting options.DOTENV_KEY
    if (options && options.DOTENV_KEY && options.DOTENV_KEY.length > 0) return options.DOTENV_KEY;
    // fallback to empty string
    return "";
}
function $e926e63dbac648e0$var$_instructions(result, dotenvKey) {
    // Parse DOTENV_KEY. Format is a URI
    let uri;
    try {
        uri = new URL(dotenvKey);
    } catch (error) {
        if (error.code === "ERR_INVALID_URL") throw new Error("INVALID_DOTENV_KEY: Wrong format. Must be in valid uri format like dotenv://:key_1234@dotenv.org/vault/.env.vault?environment=development");
        throw error;
    }
    // Get decrypt key
    const key = uri.password;
    if (!key) throw new Error("INVALID_DOTENV_KEY: Missing key part");
    // Get environment
    const environment = uri.searchParams.get("environment");
    if (!environment) throw new Error("INVALID_DOTENV_KEY: Missing environment part");
    // Get ciphertext payload
    const environmentKey = `DOTENV_VAULT_${environment.toUpperCase()}`;
    const ciphertext = result.parsed[environmentKey] // DOTENV_VAULT_PRODUCTION
    ;
    if (!ciphertext) throw new Error(`NOT_FOUND_DOTENV_ENVIRONMENT: Cannot locate environment ${environmentKey} in your .env.vault file.`);
    return {
        ciphertext: ciphertext,
        key: key
    };
}
function $e926e63dbac648e0$var$_vaultPath(options) {
    let dotenvPath = $ad1e3b7171b5b1ff$exports.resolve($aqbQf.cwd(), ".env");
    if (options && options.path && options.path.length > 0) dotenvPath = options.path;
    // Locate .env.vault
    return dotenvPath.endsWith(".vault") ? dotenvPath : `${dotenvPath}.vault`;
}
function $e926e63dbac648e0$var$_resolveHome(envPath) {
    return envPath[0] === "~" ? $ad1e3b7171b5b1ff$exports.join($87fbed32e4e4f629$export$c1d46b5ea6262c0b(), envPath.slice(1)) : envPath;
}
function $e926e63dbac648e0$var$_configVault(options) {
    $e926e63dbac648e0$var$_log("Loading env from encrypted .env.vault");
    const parsed = $e926e63dbac648e0$var$DotenvModule._parseVault(options);
    let processEnv = {};
    if (options && options.processEnv != null) processEnv = options.processEnv;
    $e926e63dbac648e0$var$DotenvModule.populate(processEnv, parsed, options);
    return {
        parsed: parsed
    };
}
function $e926e63dbac648e0$var$configDotenv(options) {
    let dotenvPath = $ad1e3b7171b5b1ff$exports.resolve($aqbQf.cwd(), ".env");
    let encoding = "utf8";
    const debug = Boolean(options && options.debug);
    if (options) {
        if (options.path != null) dotenvPath = $e926e63dbac648e0$var$_resolveHome(options.path);
        if (options.encoding != null) encoding = options.encoding;
    }
    try {
        // Specifying an encoding returns a string instead of a buffer
        const parsed = $e926e63dbac648e0$var$DotenvModule.parse($aqbQf.readFileSync(dotenvPath, {
            encoding: encoding
        }));
        let processEnv = {};
        if (options && options.processEnv != null) processEnv = options.processEnv;
        $e926e63dbac648e0$var$DotenvModule.populate(processEnv, parsed, options);
        return {
            parsed: parsed
        };
    } catch (e) {
        if (debug) $e926e63dbac648e0$var$_debug(`Failed to load ${dotenvPath} ${e.message}`);
        return {
            error: e
        };
    }
}
// Populates process.env from .env file
function $e926e63dbac648e0$var$config(options) {
    const vaultPath = $e926e63dbac648e0$var$_vaultPath(options);
    // fallback to original dotenv if DOTENV_KEY is not set
    if ($e926e63dbac648e0$var$_dotenvKey(options).length === 0) return $e926e63dbac648e0$var$DotenvModule.configDotenv(options);
    // dotenvKey exists but .env.vault file does not exist
    if (!$aqbQf.existsSync(vaultPath)) {
        $e926e63dbac648e0$var$_warn(`You set DOTENV_KEY but you are missing a .env.vault file at ${vaultPath}. Did you forget to build it?`);
        return $e926e63dbac648e0$var$DotenvModule.configDotenv(options);
    }
    return $e926e63dbac648e0$var$DotenvModule._configVault(options);
}
function $e926e63dbac648e0$var$decrypt(encrypted, keyStr) {
    const key = $e926e63dbac648e0$require$Buffer.from(keyStr.slice(-64), "hex");
    let ciphertext = $e926e63dbac648e0$require$Buffer.from(encrypted, "base64");
    const nonce = ciphertext.slice(0, 12);
    const authTag = ciphertext.slice(-16);
    ciphertext = ciphertext.slice(12, -16);
    try {
        const aesgcm = $01727eaed9f6d092$export$36b6d6ef312eab39("aes-256-gcm", key, nonce);
        aesgcm.setAuthTag(authTag);
        return `${aesgcm.update(ciphertext)}${aesgcm.final()}`;
    } catch (error) {
        const isRange = error instanceof RangeError;
        const invalidKeyLength = error.message === "Invalid key length";
        const decryptionFailed = error.message === "Unsupported state or unable to authenticate data";
        if (isRange || invalidKeyLength) {
            const msg = "INVALID_DOTENV_KEY: It must be 64 characters long (or more)";
            throw new Error(msg);
        } else if (decryptionFailed) {
            const msg = "DECRYPTION_FAILED: Please check your DOTENV_KEY";
            throw new Error(msg);
        } else {
            console.error("Error: ", error.code);
            console.error("Error: ", error.message);
            throw error;
        }
    }
}
// Populate process.env with parsed values
function $e926e63dbac648e0$var$populate(processEnv, parsed, options = {}) {
    const debug = Boolean(options && options.debug);
    const override = Boolean(options && options.override);
    if (typeof parsed !== "object") throw new Error("OBJECT_REQUIRED: Please check the processEnv argument being passed to populate");
    // Set process.env
    for (const key of Object.keys(parsed))if (Object.prototype.hasOwnProperty.call(processEnv, key)) {
        if (override === true) processEnv[key] = parsed[key];
        if (debug) {
            if (override === true) $e926e63dbac648e0$var$_debug(`"${key}" is already defined and WAS overwritten`);
            else $e926e63dbac648e0$var$_debug(`"${key}" is already defined and was NOT overwritten`);
        }
    } else processEnv[key] = parsed[key];
}
const $e926e63dbac648e0$var$DotenvModule = {
    configDotenv: $e926e63dbac648e0$var$configDotenv,
    _configVault: $e926e63dbac648e0$var$_configVault,
    _parseVault: $e926e63dbac648e0$var$_parseVault,
    config: $e926e63dbac648e0$var$config,
    decrypt: $e926e63dbac648e0$var$decrypt,
    parse: $e926e63dbac648e0$var$parse,
    populate: $e926e63dbac648e0$var$populate
};
$e926e63dbac648e0$exports.configDotenv = $e926e63dbac648e0$var$DotenvModule.configDotenv;
$e926e63dbac648e0$exports._configVault = $e926e63dbac648e0$var$DotenvModule._configVault;
$e926e63dbac648e0$exports._parseVault = $e926e63dbac648e0$var$DotenvModule._parseVault;
$e926e63dbac648e0$exports.config = $e926e63dbac648e0$var$DotenvModule.config;
$e926e63dbac648e0$exports.decrypt = $e926e63dbac648e0$var$DotenvModule.decrypt;
$e926e63dbac648e0$exports.parse = $e926e63dbac648e0$var$DotenvModule.parse;
$e926e63dbac648e0$exports.populate = $e926e63dbac648e0$var$DotenvModule.populate;
$e926e63dbac648e0$exports = $e926e63dbac648e0$var$DotenvModule;





var $aqbQf = parcelRequire("aqbQf");
var $b07e5453767f2b67$var$__dirname = "src/Core/CONFIG";

var $gzLuY = parcelRequire("gzLuY");
var $b07e5453767f2b67$require$Buffer = $gzLuY.Buffer;
if (typeof $aqbQf.cwd != "undefined") {
    let envPath = (0, (/*@__PURE__*/$parcel$interopDefault($ad1e3b7171b5b1ff$exports))).resolve($b07e5453767f2b67$var$__dirname, "..", "..", "..", ".env");
    // console.log(`envPath`, envPath);
    (0, (/*@__PURE__*/$parcel$interopDefault($e926e63dbac648e0$exports))).config({
        path: envPath
    });
}
class $b07e5453767f2b67$var$CONFIG {
    static get vars() {
        if (!this._vars) this._vars = this.MainConfig;
        return this._vars;
    }
    static get algorithm() {
        return "aes-256-cbc"; //Using AES encryption
    }
    static encrypt(input) {
        let ivString = this.vars.ENCRYPT_IV;
        let keyString = this.vars.ENCRYPT_KEY;
        let keyBuffer = $b07e5453767f2b67$require$Buffer.from(keyString, "hex");
        let ivBuffer = $b07e5453767f2b67$require$Buffer.from(ivString, "hex");
        let cipher = (0, (/*@__PURE__*/$parcel$interopDefault($01727eaed9f6d092$exports))).createCipheriv(this.algorithm, $b07e5453767f2b67$require$Buffer.from(keyBuffer), ivBuffer);
        let encrypted = cipher.update(input);
        encrypted = $b07e5453767f2b67$require$Buffer.concat([
            encrypted,
            cipher.final()
        ]);
        return encrypted.toString("hex");
    }
    // Decrypting text
    static decrypt(input) {
        let ivString = this.vars.ENCRYPT_IV;
        let keyString = this.vars.ENCRYPT_KEY;
        let keyBuffer = $b07e5453767f2b67$require$Buffer.from(keyString, "hex");
        let encryptedText = $b07e5453767f2b67$require$Buffer.from(input, "hex");
        let decipher = (0, (/*@__PURE__*/$parcel$interopDefault($01727eaed9f6d092$exports))).createDecipheriv(this.algorithm, $b07e5453767f2b67$require$Buffer.from(keyBuffer), $b07e5453767f2b67$require$Buffer.from(ivString, "hex"));
        let decrypted = decipher.update(encryptedText);
        decrypted = $b07e5453767f2b67$require$Buffer.concat([
            decrypted,
            decipher.final()
        ]);
        return decrypted.toString();
    }
    static GetFullUrl(port, url, useSsl, isWebSocket = false) {
        let protocol = isWebSocket ? `ws` : `http`;
        if (useSsl) protocol += `s`;
        return protocol + `://` + `${url}` + `:` + `${port}`;
    }
    static get MainConfig() {
        let corePort = parseInt("9000");
        let coreHost = "127.0.0.1";
        let coreUseSsl = false;
        let coreFullUrl = this.GetFullUrl(corePort, coreHost, coreUseSsl);
        let publicPort = parseInt("443");
        let publicHost = "nowwa.io";
        let publicUseSsl = true;
        let publicFullUrl = this.GetFullUrl(publicPort, publicHost, publicUseSsl);
        let publicServerUrl = undefined;
        let coreSocketPort = parseInt("9003");
        let coreSocketHost = "localhost";
        let coreSocketUseSsl = false;
        let coreSocketFullUrl = this.GetFullUrl(coreSocketPort, coreSocketHost, coreSocketUseSsl);
        let publicSocketPort = parseInt("9005");
        let publicSocketHost = "nowwa.io";
        let publicSocketUseSsl = true;
        let publicSocketFullUrl = this.GetFullUrl(publicSocketPort, publicSocketHost, publicSocketUseSsl);
        let publicColyseusPort = parseInt("9007");
        let publicColyseusHost = "nowwa.io";
        let publicColyseusUseSsl = true;
        let publicColyseusFullUrl = this.GetFullUrl(publicColyseusPort, publicColyseusHost, publicColyseusUseSsl, true);
        let gameSocketPort = parseInt("443");
        let gameSocketHost = "gamebop.io";
        let gameSocketUseSsl = true;
        let gameSocketFullUrl = this.GetFullUrl(gameSocketPort, gameSocketHost, gameSocketUseSsl);
        let mongodbCert = "";
        if (typeof $aqbQf.cwd != "undefined") mongodbCert = (0, (/*@__PURE__*/$parcel$interopDefault($ad1e3b7171b5b1ff$exports))).resolve($b07e5453767f2b67$var$__dirname, "..", "..", "..", "certificates/db.ca-certificate.crt");
        else mongodbCert = "certificates/db.ca-certificate.crt";
        return {
            VERSION: "0.0.3",
            ENVIRONMENT: this.parseEnvironment("production"),
            EXPRESS_SECRET: "conqueros",
            MONGODB_HOST: "conquer.du8ua.mongodb.net",
            MONGODB_PORT: parseInt("27017"),
            MONGODB_DB: "admin",
            MONGODB_USER: "doadmin2",
            MONGODB_PASS: "Zndomt7o8nAbYFPo",
            MONGODB_CERT: mongodbCert,
            CLOUDINARY_NAME: "gearball",
            CLOUDINARY_KEY: "155952797698712",
            CLOUDINARY_SECRET: "_qyQf6rr2QpB_-grhKotmrF-twQ",
            CORE_SOCKET_PORT: coreSocketPort,
            PUBLIC_SOCKET_PORT: publicSocketPort,
            PUBLIC_SOCKET_HOST: publicSocketHost,
            PUBLIC_SOCKET_FULL_URL: publicSocketFullUrl,
            PUBLIC_COLYSEUS_PORT: publicColyseusPort,
            PUBLIC_COLYSEUS_HOST: publicColyseusHost,
            PUBLIC_COLYSEUS_FULL_URL: publicColyseusFullUrl,
            CORE_PORT: corePort,
            CORE_FULL_URL: coreFullUrl,
            PUBLIC_FULL_URL: publicFullUrl,
            PUBLIC_SERVER_URL: publicServerUrl,
            PLAYCANVAS_AUTH_TOKEN: "BGaSdbmMDrmQKVVkgNffpAsruFeVD8Oj",
            NAKAMA_PORT: parseInt("7350"),
            NAKAMA_HOST: "127.0.0.1",
            NAKAMA_HTTP_KEY: "server-N0ww@",
            NAKAMA_SERVER_KEY: "server-N0ww@",
            NAKAMA_USE_SSL: false,
            TWITTER_CLIENT_ID: "Y0hRYi1qaC1mU0ZYdTgtbGZXNVA6MTpjaQ",
            TWITTER_CALLBACK_URL: `${publicFullUrl}${$b07e5453767f2b67$export$e2b0d884f225a4fa}`,
            TWITTER_CLIENT_SECRET: "tWeyCLNxn1XKcSzarGw4H5t3RdVBu2u0W5Yrux9MRMRzFvSpqM",
            DISCORD_CLIENT_ID: "1037020376892452864",
            DISCORD_CALLBACK_URL: `${publicFullUrl}${$b07e5453767f2b67$export$7cae1e0073415aca}`,
            DISCORD_CLIENT_SECRET: "laUsJFYDewoElB51evKhJZx4cjm-9w4g",
            SNAPCHAT_CLIENT_ID: "e6a503b3-6929-4feb-a6d9-b1dc0bd963ed",
            SNAPCHAT_CALLBACK_URL: `${publicFullUrl}${$b07e5453767f2b67$export$8def640a6f3f44da}`,
            SNAPCHAT_CLIENT_SECRET: "CqbjgYrWsK-8xmZW_CLWJ4xfc6DR4RvPegGlx590hGI",
            GOOGLE_CLIENT_ID: "1393947514-i2lfirub42okuremrh8o5dj85tu57l37.apps.googleusercontent.com",
            GOOGLE_CALLBACK_URL: `${publicFullUrl}${$b07e5453767f2b67$export$f813edb9fbd30319}`,
            GOOGLE_CLIENT_SECRET: "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",
            VERIFY_EMAIL_SENDER: "contact@supersnappy.io",
            VERIFY_EMAIL_PASSWORD: "nB96EwRQcTMJ",
            ENCRYPT_IV: "b2a362ebd38f1212d406abef4d9b4fe0",
            ENCRYPT_KEY: "0058baaeef43b8fcee765a8bb52c36a821c001679a9c2190d2e53e166bfa261e",
            TWILIO_ACCOUNT_SID: "ACab0c558c5fbc59fc804190ea9737ef42",
            TWILIO_AUTH_TOKEN: "825913460ad4567ff982816571021755",
            TWILIO_VERIFY_SID: "VAb854951cbd7065c3d1db5673f487d8b0",
            ONESIGNAL_APP_ID: "21336dca-4458-47b3-b0e5-60fe71412024",
            ONESIGNAL_REST_API_KEY: "MWI5Nzk5ZWYtNDk0Yi00ZDliLTlhMjQtNjE0NmQ0NmE3MjY4",
            CLOUDFLARE_ACCOUNT_ID: "ea5d30661191ef080096499bdacdf751",
            CLOUDFLARE_R2_ACCESS_KEY_ID: "77933d2993b6bb88081a4e39d786feef",
            CLOUDFLARE_R2_SECRET_ACCESS_KEY: "525ace49a48654af1be1d8191f49ca410cc62f817cf8cc22bbeb2560adbf23a0",
            CLOUDFLARE_R2_BUCKET_NAME: "storage",
            GAME_PORT: gameSocketPort,
            GAME_HOST: gameSocketHost,
            GAME_FULL_URL: gameSocketFullUrl
        };
    }
}
(function(CONFIG) {
    var parseEnvironment = CONFIG.parseEnvironment = (input)=>{
        if (input == "development") return "development";
        else if (input == "production") return "production";
        else if (input == "ssl_development") return "ssl_development";
        else return "unknown";
    };
})($b07e5453767f2b67$var$CONFIG || ($b07e5453767f2b67$var$CONFIG = {}));
var $b07e5453767f2b67$export$2e2bcd8739ae039 = $b07e5453767f2b67$var$CONFIG;
const $b07e5453767f2b67$export$eb358ce4b496240c = `/authentication`;
const $b07e5453767f2b67$export$4bece828587e068f = `/twitterAuth`;
const $b07e5453767f2b67$export$e2b0d884f225a4fa = `/twitterCallback`;
const $b07e5453767f2b67$export$6345b73836ca7e1a = `/twitterShare`;
const $b07e5453767f2b67$export$bdb77b59220be0c6 = `/discordAuth`;
const $b07e5453767f2b67$export$7cae1e0073415aca = `/discordCallback`;
const $b07e5453767f2b67$export$55841b1593cede73 = `/googleAuth`;
const $b07e5453767f2b67$export$f813edb9fbd30319 = `/googleCallback`;
const $b07e5453767f2b67$export$1441d32b022b1654 = `/snapchatAuth`;
const $b07e5453767f2b67$export$8def640a6f3f44da = `/snapchatCallback`;
const $b07e5453767f2b67$export$d24b0767a7629a0f = `/emailSubscribe`;
const $b07e5453767f2b67$export$3152e8668a2caa6c = `/authTokenize`;
const $b07e5453767f2b67$export$7b13c61120c28603 = `/authLinks`;
const $b07e5453767f2b67$export$295e28c1fd574054 = `/authVerify`;
const $b07e5453767f2b67$export$8095c826583b59d5 = `/authLogin`;
const $b07e5453767f2b67$export$ca874d529269c698 = `/authRegister`;
const $b07e5453767f2b67$export$203a460f8d81836a = `/cronHourly`;
const $b07e5453767f2b67$export$9bbce068dc2294a4 = `/cronDaily`;
const $b07e5453767f2b67$export$4a8b657cc4fb4c7f = `/fileUpload`;
const $b07e5453767f2b67$export$a66b4562bcaa3c8a = `/fileGet`;
const $b07e5453767f2b67$export$c5d63bf68ef129c6 = `/temp`;
const $b07e5453767f2b67$export$20abc4f6c15827a9 = `/storage`;
const $b07e5453767f2b67$export$24b86f67501c6cd9 = `/toyList`;
const $b07e5453767f2b67$export$3aacc8364a1e1b40 = `/toyArchive`;
const $b07e5453767f2b67$export$978449aef2611b65 = `/toyArchiveAll`;
const $b07e5453767f2b67$export$2947c54a19fa0d47 = `/toyDelete`;
const $b07e5453767f2b67$export$e9b466b38cdac3fe = `/toyRemovePublicBuild`;
const $b07e5453767f2b67$export$2155fb4a502cdb26 = `/toyBuild`;
const $b07e5453767f2b67$export$601c48dbbd272db1 = `/toySave`;
const $b07e5453767f2b67$export$1a68598754cbc74c = `/toyStatus`;
const $b07e5453767f2b67$export$d7c9553718cae3d2 = `/toyTest`;
const $b07e5453767f2b67$export$f6b7d04792516d44 = `/verifyRequestOTP`;
const $b07e5453767f2b67$export$cc617afc61bfd4a3 = `/verifySendOTP`;
const $b07e5453767f2b67$export$7eb57114e5c98701 = `/listSubscriber`;
const $b07e5453767f2b67$export$ab1a57be7b2a5d6c = `/evaluation`;
const $b07e5453767f2b67$export$c9413495429b375f = `/tokenize`;



var $7gjH7 = parcelRequire("7gjH7");
class $445b61b73b0f5f22$var$DATE {
    static now() {
        return this.getISO();
    //return Date.now();
    }
    static getISO() {
        return new Date(new Date().toISOString()).getTime();
    }
    static today() {
        let now = new Date(this.now());
        return now.getTime() - now.getHours() * 3600000 - now.getMinutes() * 60000 - now.getSeconds() * 1000 - now.getMilliseconds();
    }
    static getNextMonday() {
        let date = new Date(this.getISO());
        return new Date(date.setDate(date.getDate() + ((7 - date.getDay() + 1) % 7 || 7))).getTime();
    }
    static daysFrom(timestamp) {
        return Math.floor($445b61b73b0f5f22$var$DATE.millisecondsFrom(timestamp) / 86400000);
    }
    static hoursFrom(timestamp) {
        return Math.floor($445b61b73b0f5f22$var$DATE.fractionHoursFrom(timestamp));
    }
    static fractionHoursFrom(timestamp) {
        return $445b61b73b0f5f22$var$DATE.millisecondsFrom(timestamp) / 3600000;
    }
    static secondsFrom(timestamp) {
        return Math.floor($445b61b73b0f5f22$var$DATE.millisecondsFrom(timestamp) / 1000);
    }
    static millisecondsFrom(timestamp) {
        return $445b61b73b0f5f22$var$DATE.now() - timestamp;
    }
    static format(thedate) {
        return thedate.getFullYear() + "." + thedate.getMonth() + "." + thedate.getDate();
    }
    static days(millisecs) {
        if (millisecs < 1000) return Math.round(millisecs) + "msec ";
        var seconds = Math.round(millisecs / 1000);
        var days = 0;
        var hours = 0;
        var minutes = 0;
        while(seconds >= 86400){
            days++;
            seconds -= 86400;
        }
        while(seconds >= 3600){
            hours++;
            seconds -= 3600;
        }
        while(seconds >= 60){
            seconds -= 60;
            minutes++;
        }
        var string = [];
        if (days) string.push(days + "D");
        if (hours) string.push(hours + "H");
        if (days) return string.join(" ");
        if (minutes) string.push(minutes + "Min");
        if (hours) return string.join(" ");
        if (seconds) string.push((0, $7gjH7.default).fillZero(seconds, 1) + "sec");
        return string.join(" ");
    }
    static seconds(secs) {
        var hours = 0;
        var minutes = 0;
        var seconds = Math.round(secs);
        while(seconds >= 60){
            seconds -= 60;
            minutes++;
        }
        while(minutes >= 60){
            minutes -= 60;
            hours++;
        }
        var string = "";
        if (hours) return (0, $7gjH7.default).fillZero(hours, 1) + ":" + (0, $7gjH7.default).fillZero(minutes, 1) + (0, $7gjH7.default).fillZero(seconds, 1);
        else if (minutes) return (0, $7gjH7.default).fillZero(minutes, 1) + ":" + (0, $7gjH7.default).fillZero(seconds, 1);
        return "0:" + (0, $7gjH7.default).fillZero(seconds, 1);
    }
    static millisecondsToSeconds(milliseconds) {
        return Math.round(milliseconds / 1000);
    }
    static mts(ms) {
        return $445b61b73b0f5f22$var$DATE.millisecondsToSeconds(ms);
    }
    static secondsToMinutes(seconds) {
        return seconds / 60;
    }
    static millisecondsToMinutes(milliseconds) {
        return Math.ceil(milliseconds / 60000);
    }
}
var $445b61b73b0f5f22$export$2e2bcd8739ae039 = $445b61b73b0f5f22$var$DATE;



var $EtHZk = parcelRequire("EtHZk");
class $5d84fedb9ac830c7$var$TimerInstance {
    constructor(vars){
        this.duration = 0;
        this.isPlaying = false;
        this.percent = 100;
        this.remaining = 0;
        this.elapsed = 0;
        var self = this;
        vars = vars || {};
        var id = vars.id || "Timer";
        var interval = vars.interval || 1000;
        var duration = vars.duration || 0;
        var elapsed = 0;
        var startTime = vars.startTime || 0;
        var isPaused = false;
        self.remaining = 0;
        self.elapsed = 0;
        var onTimeUp = vars.onTimeUp;
        var onUpdate = vars.onUpdate;
        var intervalID;
        var Signal = vars.Signal;
        let logName = false; // "EnergyTimer"; //
        if (id == logName) (0, $EtHZk.log)("NEW TIMER", id, vars);
        self.start = function(vars) {
            vars = vars || {};
            if (vars.seconds) duration = self.duration = vars.seconds * 1000;
            if (vars.duration) duration = self.duration = vars.duration;
            onUpdate = vars.onUpdate;
            if (vars.onTimeUp) onTimeUp = vars.onTimeUp;
            if (id == logName) (0, $EtHZk.log)("TIMER START", logName, duration, vars);
            self.restart(vars.startTime);
        };
        self.restart = function(_startTime) {
            self.stop();
            isPaused = false;
            startTime = _startTime || (0, $445b61b73b0f5f22$export$2e2bcd8739ae039).now();
            elapsed = (0, $445b61b73b0f5f22$export$2e2bcd8739ae039).now() - startTime;
            self.isPlaying = true;
            if (id == logName) (0, $EtHZk.log)("TIMER restart", logName, _startTime, startTime, "elapsed", elapsed);
            self.percent = elapsed * 100 / duration;
            self.remaining = duration - elapsed;
            intervalID = setInterval(update, interval);
        };
        self.increase = function(seconds) {
            duration += seconds * 1000;
        };
        self.pause = function() {
            if (!self.isPlaying || isPaused) return;
            isPaused = true;
        };
        self.resume = function() {
            isPaused = false;
            if (!self.isPlaying) return;
            self.start({
                duration: duration - elapsed,
                startTime: (0, $445b61b73b0f5f22$export$2e2bcd8739ae039).now()
            });
        };
        self.stop = function() {
            if (id == logName) (0, $EtHZk.log)("TIMER stop", logName);
            startTime = 0;
            self.isPlaying = false;
            clearInterval(intervalID);
        };
        self.setDuration = function(value) {
            duration = self.duration = value;
        };
        function onReach() {
            if (id == logName) (0, $EtHZk.log)("TIMER onReach", logName);
            self.stop();
            if (onTimeUp) onTimeUp(self);
            if (Signal) Signal.set(id + ":onTimeUp");
        }
        function update() {
            if (!self.isPlaying || isPaused) return;
            self.elapsed = elapsed = (0, $445b61b73b0f5f22$export$2e2bcd8739ae039).now() - startTime;
            if (id == logName) (0, $EtHZk.log)(logName, "update, duration", duration);
            if (duration) {
                self.percent = elapsed * 100 / duration;
                self.remaining = duration - elapsed;
                if (id == logName) (0, $EtHZk.log)(logName, "elapsed", elapsed, "remaining", self.remaining, "percent", self.percent);
                if (self.remaining <= 0) onReach();
            }
            if (Signal) Signal.set(id + ":onSecond", self.remaining);
            if (onUpdate) onUpdate(self);
        }
        if (vars.autoStart) self.start(vars);
    }
}
var $5d84fedb9ac830c7$export$2e2bcd8739ae039 = $5d84fedb9ac830c7$var$TimerInstance;



var $EtHZk = parcelRequire("EtHZk");
class $1fd6bc23f295a45a$var$Socket {
    async init() {
        let version = "4.5.2";
        console.log(`socket.io client version: ${version}`);
        // console.log('socket initializing...');
        // log( "client: Init New Socket Client" );
        let self = this;
        await this.connect();
        this.sendTimer = new (0, $5d84fedb9ac830c7$export$2e2bcd8739ae039)({
            onUpdate: function() {
                self.doSend();
            },
            interval: 300,
            autoStart: true
        });
        // console.log('socket initialized!');
        return Promise.resolve();
    }
    async connect() {
        // log( "client: Socket Connect" );
        var self = this;
        return new Promise((resolve)=>{
            console.log(`socket connect to : ${(0, $b07e5453767f2b67$export$2e2bcd8739ae039).vars.PUBLIC_SOCKET_FULL_URL}`);
            var socket = self.socket = (0, $7a4e4a149da75b1d$export$841407ceb083bd74)((0, $b07e5453767f2b67$export$2e2bcd8739ae039).vars.PUBLIC_SOCKET_FULL_URL, {
                timeout: 3600000,
                reconnection: true,
                transports: [
                    "websocket"
                ]
            });
            socket.on("disconnect", (e)=>{
                console.log(`disconnected`, e);
                (0, $EtHZk.log)(`client: connect status: ${socket.connected}`);
                self.connect();
            });
            socket.on("message", (obj)=>{
                self.conquer.Rooms._onServerMessage(obj);
            });
            socket.on("connect", ()=>{
                self.id = socket.id;
                resolve(self.id);
            });
            socket.on("error", (error)=>{
                console.log("socket error: ", error);
            });
            socket.on("connect_error", (err)=>{
                console.log(`connect_error due to ${err.message}`);
            });
        });
    //  return Promise.resolve("OK I SEE");
    }
    async do(action, data) {
        return new Promise((resolve)=>this.socket.emit("action", action, data, resolve));
    }
    send(action, graphID, data) {
        this.messagesCue.push({
            action: action,
            graphID: graphID,
            data: data
        });
    }
    doSend() {
        if (!this.messagesCue.length) return;
        this.socket.emit("message", this.messagesCue);
        this.messagesCue = [];
    }
    disconnect() {
        this.socket.disconnect();
    }
    constructor(instance){
        this.messagesCue = [];
        this.conquer = instance;
    }
}
var $1fd6bc23f295a45a$export$2e2bcd8739ae039 = $1fd6bc23f295a45a$var$Socket;


var $db396e8726140e32$export$92a1a3b7554e9387;
(function(ACTIONS) {
    ACTIONS[ACTIONS["MESSAGE"] = 0] = "MESSAGE";
    ACTIONS[ACTIONS["GAMEDATA"] = 1] = "GAMEDATA";
    ACTIONS[ACTIONS["PLAYERJOIN"] = 2] = "PLAYERJOIN";
    ACTIONS[ACTIONS["PLAYERLEFT"] = 3] = "PLAYERLEFT";
    ACTIONS[ACTIONS["PLAYERVARS"] = 4] = "PLAYERVARS";
    ACTIONS[ACTIONS["SYNCREQUEST"] = 5] = "SYNCREQUEST";
    ACTIONS[ACTIONS["GAMESTART"] = 6] = "GAMESTART";
    ACTIONS[ACTIONS["ROOMREADY"] = 7] = "ROOMREADY";
    ACTIONS[ACTIONS["ROOMSTATUS"] = 8] = "ROOMSTATUS";
    ACTIONS[ACTIONS["PLAYERSTATUS"] = 9] = "PLAYERSTATUS";
    ACTIONS[ACTIONS["TIME"] = 10] = "TIME";
    ACTIONS[ACTIONS["TIMER"] = 11] = "TIMER";
    ACTIONS[ACTIONS["LOADING"] = 12] = "LOADING";
    ACTIONS[ACTIONS["PLAYERSTATE"] = 13] = "PLAYERSTATE";
    ACTIONS[ACTIONS["INSYNC"] = 14] = "INSYNC";
    ACTIONS[ACTIONS["ENTRY"] = 15] = "ENTRY";
    ACTIONS[ACTIONS["CALL_ACTION"] = 16] = "CALL_ACTION";
    ACTIONS[ACTIONS["CALL_ACCEPT"] = 17] = "CALL_ACCEPT";
    ACTIONS[ACTIONS["CALL_CANCEL"] = 18] = "CALL_CANCEL";
    ACTIONS[ACTIONS["AUTH_SET"] = 19] = "AUTH_SET";
    ACTIONS[ACTIONS["AUTH_GET"] = 20] = "AUTH_GET";
    ACTIONS[ACTIONS["FILE_SET"] = 21] = "FILE_SET";
    ACTIONS[ACTIONS["FILE_GET"] = 22] = "FILE_GET";
    ACTIONS[ACTIONS["ROOM_SET"] = 23] = "ROOM_SET";
    ACTIONS[ACTIONS["ROOM_GET"] = 24] = "ROOM_GET";
    ACTIONS[ACTIONS["ROOM_GETONE"] = 25] = "ROOM_GETONE";
    ACTIONS[ACTIONS["ROOM_ENTRIES_GET"] = 26] = "ROOM_ENTRIES_GET";
    ACTIONS[ACTIONS["ROOM_ENTRIES_SET"] = 27] = "ROOM_ENTRIES_SET";
    ACTIONS[ACTIONS["ROOM_ENTRIES_CHANGE"] = 28] = "ROOM_ENTRIES_CHANGE";
    ACTIONS[ACTIONS["ROOM_ENTRIES_REMOVE"] = 29] = "ROOM_ENTRIES_REMOVE";
    ACTIONS[ACTIONS["FRIENDS_GET"] = 30] = "FRIENDS_GET";
    ACTIONS[ACTIONS["FRIENDS_SET"] = 31] = "FRIENDS_SET";
    ACTIONS[ACTIONS["FRIENDS_CHANGE"] = 32] = "FRIENDS_CHANGE";
    ACTIONS[ACTIONS["FRIENDS_REMOVE"] = 33] = "FRIENDS_REMOVE";
    ACTIONS[ACTIONS["CHAT"] = 34] = "CHAT";
    ACTIONS[ACTIONS["ANALYTICS_SET"] = 35] = "ANALYTICS_SET";
    ACTIONS[ACTIONS["ANALYTICS_GET"] = 36] = "ANALYTICS_GET";
    ACTIONS[ACTIONS["FOLLOWERS_GET"] = 37] = "FOLLOWERS_GET";
    ACTIONS[ACTIONS["FOLLOWERS_SET"] = 38] = "FOLLOWERS_SET";
    ACTIONS[ACTIONS["FOLLOWERS_REMOVE"] = 39] = "FOLLOWERS_REMOVE";
    ACTIONS[ACTIONS["GAME_GETONE"] = 40] = "GAME_GETONE";
    ACTIONS[ACTIONS["GAME_GET"] = 41] = "GAME_GET";
    ACTIONS[ACTIONS["GAME_DATA_GET"] = 42] = "GAME_DATA_GET";
    ACTIONS[ACTIONS["GAME_DATA_SET"] = 43] = "GAME_DATA_SET";
    ACTIONS[ACTIONS["GAME_SCORE_SET"] = 44] = "GAME_SCORE_SET";
    ACTIONS[ACTIONS["GAME_SCORE_GET"] = 45] = "GAME_SCORE_GET";
    ACTIONS[ACTIONS["GAME_SCORE_GETALLTIME"] = 46] = "GAME_SCORE_GETALLTIME";
    ACTIONS[ACTIONS["GAME_SCORE_GETTODAY"] = 47] = "GAME_SCORE_GETTODAY";
    ACTIONS[ACTIONS["GAME_SCORE_GETFRIENDSALLTIME"] = 48] = "GAME_SCORE_GETFRIENDSALLTIME";
    ACTIONS[ACTIONS["GAME_SCORE_GETFRIENDSTODAY"] = 49] = "GAME_SCORE_GETFRIENDSTODAY";
    ACTIONS[ACTIONS["MATCHMAKING"] = 50] = "MATCHMAKING";
    ACTIONS[ACTIONS["SCOREBOARD_GET"] = 51] = "SCOREBOARD_GET";
    ACTIONS[ACTIONS["SCOREBOARD_ENTRIES_SET"] = 52] = "SCOREBOARD_ENTRIES_SET";
    ACTIONS[ACTIONS["GAME_TURN_SET"] = 53] = "GAME_TURN_SET";
    ACTIONS[ACTIONS["GAME_TURN_GET"] = 54] = "GAME_TURN_GET";
    ACTIONS[ACTIONS["GAME_TURN_GETONE"] = 55] = "GAME_TURN_GETONE";
    ACTIONS[ACTIONS["GAME_TURN_CHANGE"] = 56] = "GAME_TURN_CHANGE";
    ACTIONS[ACTIONS["GAME_SHOP_GET"] = 57] = "GAME_SHOP_GET";
    ACTIONS[ACTIONS["GAME_SHOP_SET"] = 58] = "GAME_SHOP_SET";
    ACTIONS[ACTIONS["GAME_PLAYERINVENTORY_BUY"] = 59] = "GAME_PLAYERINVENTORY_BUY";
    ACTIONS[ACTIONS["GAME_PLAYERINVENTORY_GET"] = 60] = "GAME_PLAYERINVENTORY_GET";
    ACTIONS[ACTIONS["GAME_PLAYERINVENTORY_CHANGE"] = 61] = "GAME_PLAYERINVENTORY_CHANGE";
    ACTIONS[ACTIONS["GAME_PLAYERINVENTORY_REMOVE"] = 62] = "GAME_PLAYERINVENTORY_REMOVE";
    ACTIONS[ACTIONS["GAME_CURRENCY_GET"] = 63] = "GAME_CURRENCY_GET";
    ACTIONS[ACTIONS["GAME_CURRENCY_GETONE"] = 64] = "GAME_CURRENCY_GETONE";
    ACTIONS[ACTIONS["GAME_CURRENCY_CHANGE"] = 65] = "GAME_CURRENCY_CHANGE";
    ACTIONS[ACTIONS["GAME_DAILYREWARDS_GET"] = 66] = "GAME_DAILYREWARDS_GET";
    ACTIONS[ACTIONS["GAME_DAILYREWARDS_SET"] = 67] = "GAME_DAILYREWARDS_SET";
    ACTIONS[ACTIONS["INSTANCE_GETONE"] = 68] = "INSTANCE_GETONE";
    ACTIONS[ACTIONS["INSTANCE_GET"] = 69] = "INSTANCE_GET";
    ACTIONS[ACTIONS["TAG_ASSOCIATIONS_GET"] = 70] = "TAG_ASSOCIATIONS_GET";
    ACTIONS[ACTIONS["TAG_ASSOCIATIONS_SET"] = 71] = "TAG_ASSOCIATIONS_SET";
    ACTIONS[ACTIONS["JUDGEMENT_GETONE"] = 72] = "JUDGEMENT_GETONE";
    ACTIONS[ACTIONS["JUDGEMENT_SET"] = 73] = "JUDGEMENT_SET";
    ACTIONS[ACTIONS["STATS_CHANGE"] = 74] = "STATS_CHANGE";
    ACTIONS[ACTIONS["AVATAR_GET"] = 75] = "AVATAR_GET";
    ACTIONS[ACTIONS["AVATAR_GETONE"] = 76] = "AVATAR_GETONE";
    ACTIONS[ACTIONS["WALLET_GETSET"] = 77] = "WALLET_GETSET";
    ACTIONS[ACTIONS["WALLET_HISTORY_GET"] = 78] = "WALLET_HISTORY_GET";
    ACTIONS[ACTIONS["WALLET_ASSETS_GET"] = 79] = "WALLET_ASSETS_GET";
    ACTIONS[ACTIONS["WALLET_SEND"] = 80] = "WALLET_SEND";
    ACTIONS[ACTIONS["SOCIAL_TWITTER_SHARE"] = 81] = "SOCIAL_TWITTER_SHARE";
    ACTIONS[ACTIONS["SOCIAL_GOOGLE_SHARE"] = 82] = "SOCIAL_GOOGLE_SHARE";
    ACTIONS[ACTIONS["SOCIAL_GOOGLE_SHARE_GET"] = 83] = "SOCIAL_GOOGLE_SHARE_GET";
    ACTIONS[ACTIONS["SOCIAL_DISCORD_SHARE"] = 84] = "SOCIAL_DISCORD_SHARE";
    ACTIONS[ACTIONS["SOCIAL_DISCORD_SHARE_GET"] = 85] = "SOCIAL_DISCORD_SHARE_GET";
    ACTIONS[ACTIONS["EMAIL_SEND"] = 86] = "EMAIL_SEND";
    ACTIONS[ACTIONS["NFT_COLLECTION_GET"] = 87] = "NFT_COLLECTION_GET";
    ACTIONS[ACTIONS["NFT_COLLECTION_MINT"] = 88] = "NFT_COLLECTION_MINT";
    ACTIONS[ACTIONS["NFT_TOKEN_GET"] = 89] = "NFT_TOKEN_GET";
    ACTIONS[ACTIONS["NFT_TOKEN_REMOVE"] = 90] = "NFT_TOKEN_REMOVE";
    ACTIONS[ACTIONS["NFT_TOKEN_CHANGE"] = 91] = "NFT_TOKEN_CHANGE";
    ACTIONS[ACTIONS["NFT_HISTORY_GET"] = 92] = "NFT_HISTORY_GET";
    ACTIONS[ACTIONS["GAME_DATA_REMOVE"] = 93] = "GAME_DATA_REMOVE";
    ACTIONS[ACTIONS["GAME_TURN_REMOVE"] = 94] = "GAME_TURN_REMOVE";
    ACTIONS[ACTIONS["GAME_SET"] = 95] = "GAME_SET";
    ACTIONS[ACTIONS["AVATAR_PHOTO_SET"] = 96] = "AVATAR_PHOTO_SET";
    ACTIONS[ACTIONS["AVATAR_PHOTO_GET"] = 97] = "AVATAR_PHOTO_GET";
    ACTIONS[ACTIONS["SNAPPY_SET"] = 98] = "SNAPPY_SET";
    ACTIONS[ACTIONS["SNAPPY_GETONE"] = 99] = "SNAPPY_GETONE";
    ACTIONS[ACTIONS["BOT_GET"] = 100] = "BOT_GET";
    ACTIONS[ACTIONS["BOT_SET"] = 101] = "BOT_SET";
    ACTIONS[ACTIONS["GAME_MISSIONS_SET"] = 102] = "GAME_MISSIONS_SET";
    ACTIONS[ACTIONS["GAME_MISSIONS_GET"] = 103] = "GAME_MISSIONS_GET";
    ACTIONS[ACTIONS["SCOREBOARD_ENTRIES_GET"] = 104] = "SCOREBOARD_ENTRIES_GET";
    ACTIONS[ACTIONS["AUTH_VERIFY"] = 105] = "AUTH_VERIFY";
    ACTIONS[ACTIONS["AUTH_RESEND_VERIFY"] = 106] = "AUTH_RESEND_VERIFY";
    ACTIONS[ACTIONS["AUTH_RESET_PASSWORD"] = 107] = "AUTH_RESET_PASSWORD";
    ACTIONS[ACTIONS["AUTH_CHANGE_PASSWORD"] = 108] = "AUTH_CHANGE_PASSWORD";
    ACTIONS[ACTIONS["AUTH_RESEND_RESETKEY"] = 109] = "AUTH_RESEND_RESETKEY";
    ACTIONS[ACTIONS["AVATAR_CHANGE"] = 110] = "AVATAR_CHANGE";
    ACTIONS[ACTIONS["EMAIL_CHANGE"] = 111] = "EMAIL_CHANGE";
    ACTIONS[ACTIONS["EMAIL_GETONE"] = 112] = "EMAIL_GETONE";
    ACTIONS[ACTIONS["USERNAME_GETONE"] = 113] = "USERNAME_GETONE";
    ACTIONS[ACTIONS["EMAIL_EXISTS"] = 114] = "EMAIL_EXISTS";
    ACTIONS[ACTIONS["USERNAME_GET"] = 115] = "USERNAME_GET";
    ACTIONS[ACTIONS["EMAIL_CREATE"] = 116] = "EMAIL_CREATE";
    ACTIONS[ACTIONS["CHAT_ICECANDIDATE"] = 117] = "CHAT_ICECANDIDATE";
    ACTIONS[ACTIONS["CHAT_VIDEO_CHANGE"] = 118] = "CHAT_VIDEO_CHANGE";
    ACTIONS[ACTIONS["CHAT_MUTE_CHANGE"] = 119] = "CHAT_MUTE_CHANGE";
    ACTIONS[ACTIONS["USERNAME_PROXY_GET"] = 120] = "USERNAME_PROXY_GET";
    ACTIONS[ACTIONS["SHARE_GET"] = 121] = "SHARE_GET";
    ACTIONS[ACTIONS["SHARE_GETONE"] = 122] = "SHARE_GETONE";
    ACTIONS[ACTIONS["SHARE_SET"] = 123] = "SHARE_SET";
    ACTIONS[ACTIONS["GAME_GETDATA"] = 124] = "GAME_GETDATA";
    ACTIONS[ACTIONS["GAME_MESSAGES_GET"] = 125] = "GAME_MESSAGES_GET";
    ACTIONS[ACTIONS["GAME_MESSAGES_SET"] = 126] = "GAME_MESSAGES_SET";
    ACTIONS[ACTIONS["GAME_MESSAGES_CHANGE"] = 127] = "GAME_MESSAGES_CHANGE";
    ACTIONS[ACTIONS["GAME_MESSAGES_REMOVE"] = 128] = "GAME_MESSAGES_REMOVE";
    ACTIONS[ACTIONS["PHONE_SEND"] = 129] = "PHONE_SEND";
    ACTIONS[ACTIONS["PHONE_CHANGE"] = 130] = "PHONE_CHANGE";
    ACTIONS[ACTIONS["PHONE_GETONE"] = 131] = "PHONE_GETONE";
    ACTIONS[ACTIONS["PHONE_SET"] = 132] = "PHONE_SET";
    ACTIONS[ACTIONS["PHONE_EXISTS"] = 133] = "PHONE_EXISTS";
    ACTIONS[ACTIONS["POST_SET"] = 134] = "POST_SET";
    ACTIONS[ACTIONS["POST_CHANGE"] = 135] = "POST_CHANGE";
    ACTIONS[ACTIONS["POST_GET"] = 136] = "POST_GET";
    ACTIONS[ACTIONS["POST_GETONE"] = 137] = "POST_GETONE";
    ACTIONS[ACTIONS["FEED_GET"] = 138] = "FEED_GET";
    ACTIONS[ACTIONS["FEED_GETONE"] = 139] = "FEED_GETONE";
    ACTIONS[ACTIONS["FOLLOWERS_GETONE"] = 140] = "FOLLOWERS_GETONE";
    ACTIONS[ACTIONS["BIO_GETONE"] = 141] = "BIO_GETONE";
    ACTIONS[ACTIONS["BIO_SET"] = 142] = "BIO_SET";
    ACTIONS[ACTIONS["CONTACTS_GET"] = 143] = "CONTACTS_GET";
    ACTIONS[ACTIONS["CONTACTS_SET"] = 144] = "CONTACTS_SET";
    ACTIONS[ACTIONS["AVATAR_SOCKET_SET"] = 145] = "AVATAR_SOCKET_SET";
    ACTIONS[ACTIONS["AVATAR_SOCKET_REMOVE"] = 146] = "AVATAR_SOCKET_REMOVE";
    ACTIONS[ACTIONS["ROOM_ENTRY_REACTIONS_SET"] = 147] = "ROOM_ENTRY_REACTIONS_SET";
    ACTIONS[ACTIONS["USERNAME_EXISTS"] = 148] = "USERNAME_EXISTS";
    ACTIONS[ACTIONS["PROFILE_GET"] = 149] = "PROFILE_GET";
    ACTIONS[ACTIONS["PROFILE_SET"] = 150] = "PROFILE_SET";
    ACTIONS[ACTIONS["FRIENDS_SEARCH"] = 151] = "FRIENDS_SEARCH";
    ACTIONS[ACTIONS["TYPING"] = 152] = "TYPING";
    ACTIONS[ACTIONS["ROOM_ENTRIES_READ_GET"] = 153] = "ROOM_ENTRIES_READ_GET";
    ACTIONS[ACTIONS["ROOM_ENTRIES_READ_SET"] = 154] = "ROOM_ENTRIES_READ_SET";
    ACTIONS[ACTIONS["EDIT"] = 155] = "EDIT";
    ACTIONS[ACTIONS["REMOVE"] = 156] = "REMOVE";
    ACTIONS[ACTIONS["REPLY"] = 157] = "REPLY";
    ACTIONS[ACTIONS["QUOTE"] = 158] = "QUOTE";
    ACTIONS[ACTIONS["EMOJI"] = 159] = "EMOJI";
    ACTIONS[ACTIONS["ROOM_ENTRY_REACTIONS_GET"] = 160] = "ROOM_ENTRY_REACTIONS_GET";
    ACTIONS[ACTIONS["CALL_CANDIDATE"] = 161] = "CALL_CANDIDATE";
    ACTIONS[ACTIONS["INVITE_GET"] = 162] = "INVITE_GET";
    ACTIONS[ACTIONS["INVITE_SET"] = 163] = "INVITE_SET";
    ACTIONS[ACTIONS["AUTH_REMOVE"] = 164] = "AUTH_REMOVE";
    ACTIONS[ACTIONS["PET_GET"] = 165] = "PET_GET";
    ACTIONS[ACTIONS["PET_ENTRY_SET"] = 166] = "PET_ENTRY_SET";
    ACTIONS[ACTIONS["PET_ROOM_SET"] = 167] = "PET_ROOM_SET";
    ACTIONS[ACTIONS["NOTIFICATION_SET"] = 168] = "NOTIFICATION_SET";
    ACTIONS[ACTIONS["REALTIME_ONMESSAGE"] = 169] = "REALTIME_ONMESSAGE";
    ACTIONS[ACTIONS["COLYSEUS_ECHO"] = 170] = "COLYSEUS_ECHO";
})($db396e8726140e32$export$92a1a3b7554e9387 || ($db396e8726140e32$export$92a1a3b7554e9387 = {}));
var $db396e8726140e32$export$e50006273435e7d4;
(function(STATUS) {
    STATUS[STATUS["LOBBY"] = 0] = "LOBBY";
    STATUS[STATUS["WAITING"] = 1] = "WAITING";
    STATUS[STATUS["COUNTDOWN"] = 2] = "COUNTDOWN";
    STATUS[STATUS["PLAYING"] = 3] = "PLAYING";
    STATUS[STATUS["OVER"] = 4] = "OVER";
    STATUS[STATUS["PLAYERSREADY"] = 5] = "PLAYERSREADY";
    STATUS[STATUS["RESET"] = 6] = "RESET";
    STATUS[STATUS["READY"] = 7] = "READY";
    STATUS[STATUS["REWARDED"] = 8] = "REWARDED";
    STATUS[STATUS["BUSY"] = 9] = "BUSY";
    STATUS[STATUS["SENT"] = 10] = "SENT";
    STATUS[STATUS["INBOX"] = 11] = "INBOX";
    STATUS[STATUS["ACTIVE"] = 12] = "ACTIVE";
    STATUS[STATUS["NORESPONSE"] = 13] = "NORESPONSE";
    STATUS[STATUS["VICTORY"] = 14] = "VICTORY";
    STATUS[STATUS["DEFEAT"] = 15] = "DEFEAT";
    STATUS[STATUS["FINISH"] = 16] = "FINISH";
    STATUS[STATUS["VIEW"] = 17] = "VIEW";
    STATUS[STATUS["AUTO"] = 18] = "AUTO";
})($db396e8726140e32$export$e50006273435e7d4 || ($db396e8726140e32$export$e50006273435e7d4 = {}));
var $db396e8726140e32$export$63b4527a2777036f;
(function(STATE) {
    STATE[STATE["IDLE"] = 0] = "IDLE";
    STATE[STATE["JUMP"] = 1] = "JUMP";
    STATE[STATE["ATTACK"] = 2] = "ATTACK";
    STATE[STATE["DYING"] = 3] = "DYING";
    STATE[STATE["DEAD"] = 4] = "DEAD";
    STATE[STATE["SPAWN"] = 5] = "SPAWN";
    STATE[STATE["DANCE"] = 6] = "DANCE";
    STATE[STATE["DEFEAT"] = 7] = "DEFEAT";
    STATE[STATE["CARRY"] = 8] = "CARRY";
    STATE[STATE["WALK"] = 9] = "WALK";
    STATE[STATE["RUN"] = 10] = "RUN";
    STATE[STATE["CRAZY"] = 11] = "CRAZY";
    STATE[STATE["FALL"] = 12] = "FALL";
    STATE[STATE["WALLRUN"] = 13] = "WALLRUN";
    STATE[STATE["SLIDE"] = 14] = "SLIDE";
    STATE[STATE["WALLSLIDE"] = 15] = "WALLSLIDE";
    STATE[STATE["DOUBLEJUMP"] = 16] = "DOUBLEJUMP";
})($db396e8726140e32$export$63b4527a2777036f || ($db396e8726140e32$export$63b4527a2777036f = {}));
var $db396e8726140e32$export$426db7a6155b7a80;
(function(TYPES) {
    TYPES[TYPES["ENTRY"] = 0] = "ENTRY";
    TYPES[TYPES["TYPING"] = 1] = "TYPING";
    TYPES[TYPES["SEPARATOR"] = 2] = "SEPARATOR";
    TYPES[TYPES["IMAGE"] = 3] = "IMAGE";
    TYPES[TYPES["VIDEO"] = 4] = "VIDEO";
    TYPES[TYPES["MEDIA"] = 5] = "MEDIA";
    TYPES[TYPES["AUDIO"] = 6] = "AUDIO";
    TYPES[TYPES["UNKNOWN"] = 7] = "UNKNOWN";
    TYPES[TYPES["CALL"] = 8] = "CALL";
    TYPES[TYPES["GAME"] = 9] = "GAME";
    TYPES[TYPES["VS"] = 10] = "VS";
    TYPES[TYPES["ASYNC"] = 11] = "ASYNC";
    TYPES[TYPES["ME"] = 12] = "ME";
    TYPES[TYPES["RIVAL"] = 13] = "RIVAL";
    TYPES[TYPES["FRIENDS"] = 14] = "FRIENDS";
    TYPES[TYPES["AVATAR"] = 15] = "AVATAR";
})($db396e8726140e32$export$426db7a6155b7a80 || ($db396e8726140e32$export$426db7a6155b7a80 = {}));
var $db396e8726140e32$export$d54e9889145bdfd7;
(function(FRIEND_STATUS) {
    FRIEND_STATUS["UKNOWN"] = "uknown";
    FRIEND_STATUS["PENDING"] = "pending";
    FRIEND_STATUS["ACCEPTED"] = "accepted";
    FRIEND_STATUS["ACTIVE"] = "active";
    FRIEND_STATUS["INVITED"] = "invited";
})($db396e8726140e32$export$d54e9889145bdfd7 || ($db396e8726140e32$export$d54e9889145bdfd7 = {}));



var $EtHZk = parcelRequire("EtHZk");

class $e3618ffcb6abb3f2$var$RANDOM {
    static value(max, min = 0, avoid) {
        var value = Math.round(Math.random() * (max - min)) + min;
        return value !== avoid ? value : $e3618ffcb6abb3f2$var$RANDOM.value(max, min, avoid);
    }
    static decimal(max = 1, min = 0) {
        return Math.random() * (max - min) + min;
    }
    static int(min = 999, max = 0) {
        min = Math.ceil(min);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    static chance(probability = 0.5) {
        if (probability === 0) return false;
        return Math.random() <= probability;
    }
    static spectrum(max, min = 0) {
        var val = $e3618ffcb6abb3f2$var$RANDOM.value(max, min);
        return $e3618ffcb6abb3f2$var$RANDOM.chance(0.5) ? val : -val;
    }
    static spectrumDecimal(max, min = 0) {
        var val = $e3618ffcb6abb3f2$var$RANDOM.decimal(max, min);
        return $e3618ffcb6abb3f2$var$RANDOM.chance(0.5) ? val : -val;
    }
    static boolean() {
        return $e3618ffcb6abb3f2$var$RANDOM.chance() ? true : false;
    }
    static direction() {
        return $e3618ffcb6abb3f2$var$RANDOM.chance() ? 1 : -1;
    }
    static fortune(amount) {
        for(var n = 0; n < amount; n++)if ($e3618ffcb6abb3f2$var$RANDOM.chance(1 / (amount * 2) * (amount - n))) return n;
        return 0;
    }
}
var $e3618ffcb6abb3f2$export$2e2bcd8739ae039 = $e3618ffcb6abb3f2$var$RANDOM;


class $daaaf85f028fd9ae$var$Auth {
    async init(disableAutoAuth) {
        // if (typeof this.conquer.User != 'undefined' && 
        // (
        //     this.conquer.User!.type == 'FACEBOOK' || 
        // this.conquer.User!.type == 'DISCORD' || 
        // this.conquer.User!.type == 'GOOGLE' || 
        // this.conquer.User!.type == 'TWITTER' || 
        // this.conquer.User!.type == 'SNAPCHAT' || 
        //     this.conquer.User!.type == 'WALLET' ||
        //     typeof this.conquer.User!.token != 'undefined'
        // )
        // ) 
        // console.log(`[Conquer Auth] init conquer.User: ${JSON.stringify(this.conquer.User)}`);
        if (!disableAutoAuth) await this.tryToPreAuth();
        return Promise.resolve();
    }
    async tryToPreAuth() {
        if (typeof this.conquer.User == "string") {
            this.conquer.User = {
                username: this.conquer.User,
                type: "GUEST"
            };
            await this.get(this.conquer.User);
            return;
        }
        let authToken = this.conquer.Storage.get(this.authTokenKey);
        if (authToken) await this.get({
            token: authToken,
            type: "USERNAME"
        });
        if (!this.conquer.User || !this.conquer.User.token) await this.guest();
    }
    async set(params) {
        params.password += "";
        params.type = "USERNAME";
        // params: { username: string, password: string, email: string, firstName: string, lastName: string }
        let response = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).AUTH_SET, params);
        if (!response.error) await this.get({
            username: params.username,
            password: params.password,
            type: "USERNAME"
        });
        return Promise.resolve(response);
    }
    async verify(params) {
        let response = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).AUTH_VERIFY, {
            username: params.username,
            code: params.code
        });
        // this.conquer.Storage.setAccount( response );
        // this.conquer.Avatars.init();
        // this.conquer.Analytics.onEntryPoint();
        await this.tryToPreAuth();
        return Promise.resolve(response);
    }
    async resend(params) {
        let response = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).AUTH_RESEND_VERIFY, {
            username: params.username
        });
        return Promise.resolve(response);
    }
    //No longer using the success/message structure
    async resendResetKey(vars) {
        let response = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).AUTH_RESEND_RESETKEY, vars);
        return Promise.resolve(response);
    }
    async sendResetPassword(params) {
        let response = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).AUTH_RESET_PASSWORD, params);
        return Promise.resolve(response);
    }
    async changePassword(params) {
        let response = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).AUTH_CHANGE_PASSWORD, {
            email: params.email,
            password: params.password,
            resetKey: params.resetKey
        });
        return Promise.resolve(response);
    }
    async logout() {
        if (typeof this.conquer.User != "undefined" && this.conquer.User.type == "FACEBOOK") await new Promise((resolve, reject)=>{
            FB.logout((response)=>{
                resolve();
            });
        });
        this.conquer.Storage.remove(this.authTokenKey);
        await this.guest();
        return Promise.resolve();
    }
    async guest() {
        // await this.logout();
        this.conquer.User = {
            type: "GUEST",
            username: "Guest_" + (0, $445b61b73b0f5f22$export$2e2bcd8739ae039).now() + (0, $e3618ffcb6abb3f2$export$2e2bcd8739ae039).value(1000),
            firstName: "GUEST",
            lastName: ""
        };
        // console.log(`[Conquer Auth] guest conquer.User: ${JSON.stringify(this.conquer.User)}`);
        let response = await this.get(this.conquer.User);
        return Promise.resolve(response);
    }
    async admin() {
        this.conquer.User.type = "ADMIN";
        let response = await this.get(this.conquer.User);
        return Promise.resolve(response);
    }
    async get(vars) {
        (0, $EtHZk.log)("Auth get");
        // if( !vars ) vars = this.conquer.User;
        //    log("Auth vars", vars );
        if (vars && !vars.type && vars.password) vars.type = "USERNAME";
        let response = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).AUTH_GET, vars);
        //    log("Auth response", response );
        if (Object.keys(response).length == 0) response = {
            error: true
        };
        if (response.error) return Promise.resolve(response);
        // if( response.type != 'GUEST' ) response.isVerified = true;
        this.conquer.User = response;
        //  log("User", this.conquer.User );
        this.conquer.Avatars.init();
        this.conquer.Friends.get(true);
        this.conquer.Bots.get();
        this.conquer.Analytics.onEntryPoint();
        if (response.token) this.conquer.Storage.set(this.authTokenKey, response.token);
        else this.conquer.Storage.remove(this.authTokenKey);
        this.conquer.Signal.set("AUTH:onLogin");
        return Promise.resolve(this.conquer.User);
    }
    async getProxy() {
        let response = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).USERNAME_PROXY_GET, {
            usernameID: this.conquer.User.usernameID
        });
        return Promise.resolve(response);
    }
    constructor(instance){
        this.authTokenKey = "CONQUERAUTHTOKEN";
        this.conquer = instance;
    }
}
var $daaaf85f028fd9ae$export$2e2bcd8739ae039 = $daaaf85f028fd9ae$var$Auth;


// getOne
// change -> allow edit email

class $cf8dfd9c89f8a3a7$var$Username {
    async get(username) {
        let response = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).USERNAME_GET, {
            username: username,
            similar: true
        });
        return Promise.resolve(response);
    }
    async getFromAvatarID(avatarID) {
        let response = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).USERNAME_GETONE, {
            avatarID: avatarID
        });
        return Promise.resolve(response ? response.username : null);
    }
    async getOne(username) {
        let response = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).USERNAME_GETONE, {
            username: username
        });
        return Promise.resolve(response);
    }
    constructor(instance){
        this.conquer = instance;
    }
}
var $cf8dfd9c89f8a3a7$export$2e2bcd8739ae039 = $cf8dfd9c89f8a3a7$var$Username;




class $c20e8f87d1b6e64d$var$Files {
    async set(params) {
        return this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).FILE_SET, params);
    }
    async get(params) {
        return this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).FILE_GET, params);
    }
    download(url) {
        var dlink = document.createElement("a");
        dlink.href = `${window.location.origin}${0, $b07e5453767f2b67$export$a66b4562bcaa3c8a}/${url}`;
        dlink.target = "_blank";
        dlink.onclick = function(e) {};
        dlink.click();
    }
    constructor(instance){
        this.conquer = instance;
    }
}
var $c20e8f87d1b6e64d$export$2e2bcd8739ae039 = $c20e8f87d1b6e64d$var$Files;




class $b333bdb643789b56$var$WebAuth {
    async init() {
        // console.log('web auth initializing...');
        // await this.authLinks();
        // console.log('web auth initialized!');
        return Promise.resolve();
    }
    async authLinks() {
        if (typeof window != "undefined") {
            let authLinkResponse = await new Promise((resolve, reject)=>{
                let authLinksUrl = new URL(`${(0, $b07e5453767f2b67$export$2e2bcd8739ae039).vars.PUBLIC_FULL_URL}${(0, $b07e5453767f2b67$export$7b13c61120c28603)}`);
                // let authLinksUrl        : URL = new URL(`http://localhost:3000${authLinks}`);
                let authLinksRequest = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Access-Control-Allow-Origin": "*"
                    },
                    body: "{}"
                };
                fetch(authLinksUrl, authLinksRequest).then((authLinkResponse)=>authLinkResponse.json()).then((authLinkResponse)=>{
                    resolve(authLinkResponse);
                }).catch((error)=>{
                    console.error(`error: ${error}`);
                    reject(error);
                });
            });
            this.vars.twitter = authLinkResponse.twitter;
            this.vars.discord = authLinkResponse.discord;
            this.vars.google = authLinkResponse.google;
            this.vars.snapchat = authLinkResponse.snapchat;
        }
    }
    async discord() {
        window.open(this.vars.discord, "_self");
    }
    async twitter() {
        window.open(this.vars.twitter, "_self");
    }
    async snapchat() {
        window.open(this.vars.snapchat, "_self");
    }
    async google() {
        window.open(this.vars.google, "_self");
    }
    async metamask() {
        let self = this;
        let ethereum = window.ethereum;
        if (!ethereum) alert("install metamask wallet first!");
        else try {
            let address = await new Promise((resolve, reject)=>{
                window.ethereum.request({
                    method: "eth_requestAccounts"
                }).then((accounts)=>{
                    let address = accounts[0];
                    resolve(address);
                }).catch((error)=>{
                    reject(error);
                });
            });
            let redirectParams = {
                username: address,
                wallet: address,
                type: "METAMASK"
            };
            let searchParams = Object.keys(redirectParams).map((key)=>key + "=" + redirectParams[key]).join("&");
            if (window.location.href.indexOf("?") >= 0) window.location.replace(`${window.location.href}&${searchParams}`);
            else window.location.replace(`${window.location.href}?${searchParams}`);
        } catch (error) {
            return Promise.resolve({
                success: false,
                account: error
            });
        }
    }
    async facebook() {
        if (typeof window != "undefined") {
            if (!this.vars.facebook) {
                await new Promise((resolve, reject)=>{
                    let facebookScript = document.createElement("script");
                    facebookScript.type = "text/javascript";
                    facebookScript.src = "https://connect.facebook.net/en_US/sdk.js";
                    facebookScript.async = true;
                    facebookScript.defer = true;
                    facebookScript.onload = ()=>{
                        FB.init({
                            appId: this.facebookAppId,
                            autoLogAppEvents: true,
                            xfbml: true,
                            version: "v15.0"
                        });
                        FB.AppEvents.logPageView();
                        resolve();
                    };
                    document.body.appendChild(facebookScript);
                });
                this.vars.facebook = true;
            }
            let loginStatus = await new Promise((resolve, reject)=>{
                FB.getLoginStatus((loginStatus)=>{
                    // console.log(`loginStatus`, JSON.stringify(loginStatus, null, 4));
                    // statusChangeCallback(response);
                    resolve(loginStatus);
                });
            });
            let authResponse = loginStatus.authResponse;
            if (!authResponse) authResponse = await new Promise((resolve, reject)=>{
                FB.login((loginResponse)=>{
                    resolve(loginResponse.authResponse);
                }, {
                    scope: "public_profile,email,user_friends"
                });
            });
            let fields = [
                "name",
                "email"
            ];
            let apiResponse1 = await new Promise((resolve, reject)=>{
                FB.api("/me", {
                    fields: fields.join(", ")
                }, (apiResponse1)=>{
                    resolve(apiResponse1);
                });
            });
            let apiResponse2 = await new Promise((resolve, reject)=>{
                FB.api("/me/friends", {}, (apiResponse2)=>{
                    resolve(apiResponse2);
                });
            });
            let userInfo = apiResponse1;
            let contactInfo = apiResponse2;
            let friend_count = contactInfo.summary.total_count;
            let redirectParams = {
                username: userInfo.email,
                email: userInfo.email,
                firstName: userInfo.name,
                type: "FACEBOOK"
            };
            let searchParams = Object.keys(redirectParams).map((key)=>key + "=" + redirectParams[key]).join("&");
            if (window.location.href.indexOf("?") >= 0) window.location.replace(`${window.location.href}&${searchParams}`);
            else window.location.replace(`${window.location.href}?${searchParams}`);
        }
    }
    async shareDiscordGet() {
        let avatarID = this.conquer.User.avatarID;
        return this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).SOCIAL_DISCORD_SHARE_GET, {
            avatarID: avatarID
        });
    }
    async shareDiscord(guild) {
        let shareMessage = `Join supersnappy.io!`;
        let shareUrl = `https://supersnappy.io`;
        let avatarID = this.conquer.User.avatarID;
        return this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).SOCIAL_DISCORD_SHARE, {
            shareMessage: shareMessage,
            shareUrl: shareUrl,
            guild: guild,
            avatarID: avatarID
        });
    }
    async shareGoogleGet() {
        let avatarID = this.conquer.User.avatarID;
        return this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).SOCIAL_GOOGLE_SHARE_GET, {
            avatarID: avatarID
        });
    }
    async shareGoogle(email) {
        let shareMessage = `Join supersnappy.io!`;
        let shareUrl = `https://supersnappy.io`;
        return this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).SOCIAL_GOOGLE_SHARE, {
            shareMessage: shareMessage,
            shareUrl: shareUrl,
            email: email
        });
    }
    async shareTwitter() {
        let shareMessage = `Join supersnappy.io!`;
        let shareUrl = `https://supersnappy.io`;
        let avatarID = this.conquer.User.avatarID;
        return this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).SOCIAL_TWITTER_SHARE, {
            avatarID: avatarID,
            shareMessage: shareMessage,
            shareUrl: shareUrl
        });
    }
    async shareFacebook() {
        if (typeof window != "undefined") {
            if (!this.vars.facebook) {
                await new Promise((resolve, reject)=>{
                    let facebookScript = document.createElement("script");
                    facebookScript.type = "text/javascript";
                    facebookScript.src = "https://connect.facebook.net/en_US/sdk.js";
                    facebookScript.async = true;
                    facebookScript.defer = true;
                    facebookScript.onload = ()=>{
                        FB.init({
                            appId: this.facebookAppId,
                            autoLogAppEvents: true,
                            xfbml: true,
                            version: "v15.0"
                        });
                        FB.AppEvents.logPageView();
                        resolve();
                    };
                    document.body.appendChild(facebookScript);
                });
                this.vars.facebook = true;
            }
            await new Promise((resolve, reject)=>{
                let shareMessage = `Join supersnappy.io!`;
                let shareUrl = `https://supersnappy.io`;
                FB.ui({
                    method: "share",
                    href: shareUrl,
                    quote: shareMessage
                }, (response)=>{
                    resolve();
                });
            });
        }
        return Promise.resolve();
    }
    constructor(instance){
        this.facebookAppId = `2303120786519319`;
        // Move all social stuff here
        this.vars = {};
        this.conquer = instance;
    }
}
var $b333bdb643789b56$export$2e2bcd8739ae039 = $b333bdb643789b56$var$WebAuth;




class $6970118f64b5f60d$var$User {
}
(function(User) {
    var Fields = User.Fields = [
        `avatarID`,
        `username`,
        `token`,
        `type`,
        `email`,
        `accessToken`,
        `wallet`
    ];
})($6970118f64b5f60d$var$User || ($6970118f64b5f60d$var$User = {}));
var $6970118f64b5f60d$export$2e2bcd8739ae039 = $6970118f64b5f60d$var$User;


class $e6ad980482c28eb3$var$AltStorage {
    removeItem(key) {
        delete this.data[key];
    }
    getItem(key) {
        if (typeof this.data[key] != "undefined") return this.data[key];
        return "";
    }
    setItem(key, value) {
        this.data[key] = value;
    }
    constructor(){
        this.data = {};
    }
}
var $e6ad980482c28eb3$export$2e2bcd8739ae039 = $e6ad980482c28eb3$var$AltStorage;


class $040cf500777e5912$var$Storage {
    get storage() {
        if (this.canAccessLocalStorage) return window.localStorage;
        else return this.altStorage;
    }
    /*=============== 


    INIT
    

    ================*/ async init() {
        // this.setAccount( this.conquer.User );
        // this.setAccount( this.loadAccount() );
        // this.setAccount( this.parseUrlSearchParams() );
        // console.log('storage initialized!');
        // check if local storage is available by checking cookie
        if (typeof window != "undefined" && !navigator.cookieEnabled) {
            this.canAccessLocalStorage = false;
            console.log("use altStorage");
        } else console.log("use localStorage");
        return Promise.resolve();
    }
    generateUsername() {
        return "Guest_" + (0, $445b61b73b0f5f22$export$2e2bcd8739ae039).now() + (0, $e3618ffcb6abb3f2$export$2e2bcd8739ae039).value(1000);
    }
    loadAccount() {
        let oldUsername = typeof this.conquer.User != "undefined" ? this.conquer.User.username : null;
        let type = typeof this.conquer.User != "undefined" ? this.conquer.User.type : null;
        console.log(`[Conquer Storage] loadAccount oldUsername: ${JSON.stringify(oldUsername)}`);
        let json = typeof window != "undefined" ? this.storage.getItem("account") : null;
        console.log(`[Conquer Storage] loadAccount json 1: ${JSON.stringify(json)}`);
        if (json == "null" || json == "{}") json = null;
        console.log(`[Conquer Storage] loadAccount json 2: ${JSON.stringify(json)}`);
        var user = json ? JSON.parse(json) : {
            username: oldUsername == null ? this.generateUsername() : oldUsername,
            type: type == null ? "GUEST" : type
        };
        console.log(`[Conquer Storage] loadAccount user: ${JSON.stringify(user)}`);
        return user;
    }
    parseUrlSearchParams() {
        let originalParams = {};
        let params = {};
        if (typeof window == "undefined") return null;
        new URL(window.location.href).searchParams.forEach((val, key)=>{
            if ((0, $6970118f64b5f60d$export$2e2bcd8739ae039).Fields.indexOf(key) >= 0) {
                if (params[key] !== undefined) {
                    if (!Array.isArray(params[key])) params[key] = [
                        params[key]
                    ];
                    params[key].push(val);
                } else params[key] = val;
            } else originalParams[key] = val;
        });
        // console.log(`window.location.href`, window.location.href);
        // console.log(`params`, params);
        let originalSearchParams = Object.keys(originalParams).map((key)=>key + "=" + originalParams[key]).join("&");
        let originalUrl = window.location.href.substring(0, window.location.href.indexOf("?")) + `${originalSearchParams.length > 0 ? "?" + originalSearchParams : ""}`;
        window.history.pushState(params, "", `${originalUrl}`);
        return params.username ? params : null;
    }
    /*=============== 


    GET
    

    ================*/ get(key) {
        return typeof window != "undefined" ? this.storage.getItem(key) : null;
    }
    /*=============== 


    SET
    

    ================*/ set(key, value) {
        if (typeof window != "undefined") {
            if (value == null) this.storage.removeItem(key);
            else {
                let safeValue = typeof value == "string" ? value : JSON.stringify(value);
                this.storage.setItem(key, safeValue);
            }
        }
        return value;
    }
    /*=============== 


    REMOVE
    

    ================*/ remove(key) {
        this.set(key, null);
    }
    removeAccount() {
        this.remove("account");
    // this.setAccount( this.loadAccount() );
    }
    constructor(instance){
        this.conquer = instance;
        this.canAccessLocalStorage = true;
        this.altStorage = new (0, $e6ad980482c28eb3$export$2e2bcd8739ae039)();
    }
}
var $040cf500777e5912$export$2e2bcd8739ae039 = $040cf500777e5912$var$Storage;






var $EtHZk = parcelRequire("EtHZk");

var $41Zxr = parcelRequire("41Zxr");
class $1a1d551abb85861f$var$ARRAY {
    static push(array, _output) {
        var output = _output || [];
        for(var n in array)output.push(array[n]);
        return output;
    }
    static clone(object) {
        var output = {};
        for(var n in object)output[n] = object[n];
        return output;
    }
    static deepClone(object) {
        return JSON.parse(JSON.stringify(object));
    }
    static extract(from, to) {
        var output = to || {};
        if (!from) return output;
        if (from._attributes) for(var varName in from._attributes)to[varName] = from[varName];
        else for(var n in from)output[n] = from[n];
        return output;
    }
    static getFields(from, fields) {
        if (!from || !fields) return from;
        if (!Array.isArray(from)) return doGetFields(from);
        let output = [];
        for(let n = 0; n < from.length; n++)output.push(doGetFields(from[n]));
        return output;
        function doGetFields(from) {
            var item = {};
            for(let n = 0; n < fields.length; n++){
                let field = fields[n];
                from[field];
                item[field] = from[field];
            }
            return item;
        }
    }
    static merge(from, to) {
        var output = $1a1d551abb85861f$var$ARRAY.clone(to);
        for(var n in from)output[n] = from[n];
        return output;
    }
    static mergeUnique(from, to) {
        for(var n in from)if (to[n] == null) to[n] = from[n];
        return to;
    }
    static tostring(array) {
        return array.sort().toString();
    }
    static pushUnique(array, item) {
        if (array.indexOf(item) == -1) array.push(item);
        return item;
    }
    static copy(array) {
        var output = [];
        for(var n = 0; n < array.length; n++)output[n] = array[n];
        return output;
    }
    static getRandomItem(array, andRemove, andAvoid) {
        if (!array.length) return null;
        var n = (0, $e3618ffcb6abb3f2$export$2e2bcd8739ae039).value(array.length - 1);
        var item = array[n];
        if (item == andAvoid) return $1a1d551abb85861f$var$ARRAY.getRandomItem(array, andRemove, andAvoid);
        if (andRemove) array.splice(n, 1);
        return item;
    }
    static removeItem(array, item) {
        var index = array.indexOf(item);
        if (index == -1) return false;
        array.splice(index, 1);
        return item;
    }
    static removeItems(array, items) {
        for(var n in items)$1a1d551abb85861f$var$ARRAY.removeItem(array, items[n]);
    }
    static extractUnique(a, _output) {
        var output = _output || [];
        for(var n in a)if (output.indexOf(a[n]) == -1) output.push(a[n]);
        return output;
    }
    static sort(array, property) {
        array.sort(function(a, b) {
            return a[property] > b[property] ? 1 : b[property] > a[property] ? -1 : 0;
        });
        return array;
    }
    static shuffle(refArray, length) {
        var array = $1a1d551abb85861f$var$ARRAY.copy(refArray);
        var output = [];
        while(array.length){
            output.push($1a1d551abb85861f$var$ARRAY.getRandomItem(array, true));
            if (output.length == length) return output;
        }
        return output;
    }
    static shuffleLinear(array) {
        var output = $1a1d551abb85861f$var$ARRAY.copy(array);
        for(var n = 0; n < array.length; n++)if ((0, $e3618ffcb6abb3f2$export$2e2bcd8739ae039).chance()) $1a1d551abb85861f$var$ARRAY.firstToLast(output);
        if ((0, $e3618ffcb6abb3f2$export$2e2bcd8739ae039).chance()) output.reverse();
        return output;
    }
    static firstToLast(array) {
        array.push(array.shift());
        return array;
    }
    static lastToFirst(array) {
        array.reverse();
        $1a1d551abb85861f$var$ARRAY.firstToLast(array);
        array.reverse();
        return array;
    }
    static searchObject(object, label) {
        var output = {};
        for(var name in object)if (name.includes(label)) output[name] = object[name];
        return output;
    }
    static pages(array, perpage = 0) {
        var array = $1a1d551abb85861f$var$ARRAY.copy(array);
        var output = [];
        while(array.length){
            var page = [];
            var i = 0;
            while(++i <= perpage && array.length)page.push(array.shift());
            output.push(page);
        }
        return output;
    }
    static toNameVar(array, field) {
        var output = {};
        for(var n in array)output[array[n][field]] = array[n];
        return output;
    }
    static lastItem(array) {
        return array[array.length - 1];
    }
    static getWithin(array, position) {
        return array[(0, $41Zxr.default).clamp(position, array.length - 1)];
    }
    static parse(value, toArray = false) {
        let empty = toArray ? [] : {};
        if (!value || value === "") return empty;
        if (typeof value != "string") return value;
        try {
            return JSON.parse(value);
        } catch (e) {
            (0, $EtHZk.log)("----------JSON PARSE ERROR---------", value);
        }
        return empty;
    }
    static rotate(grid, times = 0) {
        var times = times == null ? (0, $e3618ffcb6abb3f2$export$2e2bcd8739ae039).value(3) : times;
        var newGrid = [];
        var rowLength = Math.sqrt(grid.length);
        newGrid.length = grid.length;
        for(var i = 0; i < grid.length; i++){
            //convert to x/y
            var x = i % rowLength;
            var y = Math.floor(i / rowLength);
            //find new x/y
            var newX = rowLength - y - 1;
            var newY = x;
            //convert back to index
            var newPosition = newY * rowLength + newX;
            newGrid[newPosition] = grid[i];
        }
        if (times > 0) return $1a1d551abb85861f$var$ARRAY.rotate(newGrid, times - 1);
        return newGrid;
    }
    static flip(grid) {
        var output = [];
        var n = 0;
        var side = Math.sqrt(grid.length);
        for(var y = 0; y < side; y++){
            var line = [];
            for(var x = 0; x < side; x++)line.push(grid[n++]);
            $1a1d551abb85861f$var$ARRAY.push(line.reverse(), output);
        }
        return output;
    }
    static findItemByAttribute(array, attribute, value) {
        for(var n in array)if (array[n][attribute] == value) return array[n];
    }
    static salchiche(array, andReverse = false) {
        var output = $1a1d551abb85861f$var$ARRAY.clone(array);
        var halve = [];
        while(halve.length < output.length)halve.push(output.shift());
        if (andReverse) halve = halve.reverse();
        while(halve.length)output.push(halve.shift());
        return output;
    }
    static mirror(array, length = 0) {
        array = $1a1d551abb85861f$var$ARRAY.clone(array);
        var halve = [];
        length = length || array.length;
        while(halve.length < length)halve.push(array.shift());
        var halve2 = $1a1d551abb85861f$var$ARRAY.clone(halve);
        halve2 = halve2.reverse();
        while(halve2.length)halve.push(halve2.shift());
        return halve;
    }
    static contains(array, value) {
        return array.indexOf(value) != -1;
    }
    static getCue(array, source) {
        if (!array.length) $1a1d551abb85861f$var$ARRAY.push($1a1d551abb85861f$var$ARRAY.shuffle(source), array);
        return array.shift();
    }
    static toString(array) {
        var output = "";
        for(var n in array)output += array[n];
        return output;
    }
    static isArray(a) {
        return Array.isArray(a);
    }
    static trim(array, amount = 0) {
        var output = [];
        var amount = amount || array.length;
        for(var n = 0; n < amount; n++)if (array[n] != null) output.push(array[n]);
        return output;
    }
    static cycle(array, pos = 0, amount = 1, increment = 1) {
        var output = [];
        var laps = 0;
        while(amount){
            pos += increment;
            if (pos >= array.length) {
                pos -= array.length;
                laps++;
            }
            output.push(pos);
            amount--;
        }
        return output;
    }
    static getClamp(array, position = 0) {
        if (position >= array.length) return array[array.length - 1];
        return array[position];
    }
    static toKey(array) {
        for(let n in array)array[n].toString();
        array.sort();
        let key = "";
        for(let n = 0; n < array.length; n++){
            key += array[n];
            if (n < array.length - 1) key += "_";
        }
        return key;
    }
}
var $1a1d551abb85861f$export$4950aa0f605343fb = $1a1d551abb85861f$var$ARRAY.merge;
var $1a1d551abb85861f$export$f9380c9a627682d3 = $1a1d551abb85861f$var$ARRAY.extract;
var $1a1d551abb85861f$export$4cbf152802aa238 = $1a1d551abb85861f$var$ARRAY.push;
var $1a1d551abb85861f$export$43bee75e5e14138e = $1a1d551abb85861f$var$ARRAY.isArray;
var $1a1d551abb85861f$export$e91d9f829d98c173 = $1a1d551abb85861f$var$ARRAY.pushUnique;
var $1a1d551abb85861f$export$127d9dc446d2951b = $1a1d551abb85861f$var$ARRAY.getRandomItem;
var $1a1d551abb85861f$export$fe2d9b4e03920b4c = $1a1d551abb85861f$var$ARRAY.removeItem;
var $1a1d551abb85861f$export$448332262467e042 = $1a1d551abb85861f$var$ARRAY.shuffle;
var $1a1d551abb85861f$export$784d13d8ee351f07 = $1a1d551abb85861f$var$ARRAY.copy;
var $1a1d551abb85861f$export$97db5808d8f88186 = $1a1d551abb85861f$var$ARRAY.sort;
var $1a1d551abb85861f$export$2e2bcd8739ae039 = $1a1d551abb85861f$var$ARRAY;


class $0a95283b4a388957$var$FriendInstance {
    fill(vars) {
        this.membershipID = vars.membershipID;
        this.status = vars.status;
        this.role = vars.role;
    }
    async set() {
        let membership;
        if (!this.membershipID) {
            membership = await this.conquer.Friends.set(this.avatarID);
            return Promise.resolve(this);
        }
        if (this.status != "pending") return;
        membership = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).FRIENDS_CHANGE, {
            membershipID: this.membershipID,
            status: "active"
        });
        this.fill(membership);
        this.conquer.Friends.refresh();
        return Promise.resolve(this);
    }
    remove() {
        this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).FRIENDS_REMOVE, {
            membershipID: this.membershipID
        });
        (0, $1a1d551abb85861f$export$2e2bcd8739ae039).removeItem(this.conquer.Friends.pool, this);
    }
    constructor(instance, vars){
        this.conquer = instance;
        this.fill(vars);
        this.avatarInstance = this.conquer.Avatars.pushInstance(vars);
        this.avatarID = this.avatarInstance.avatarID;
        this.fullName = this.avatarInstance.fullName;
        this.userPhoto = this.avatarInstance.userPhoto;
    }
}
var $0a95283b4a388957$export$2e2bcd8739ae039 = $0a95283b4a388957$var$FriendInstance;



class $1a25aa5249685cf1$var$Cue {
    push(value) {
        this._pool.push(value);
        this.getLength();
        return value;
    }
    pushUnique(value) {
        (0, $1a1d551abb85861f$export$2e2bcd8739ae039).pushUnique(this._pool, value);
        this.getLength();
        return value;
    }
    copy(array) {
        this._pool = (0, $1a1d551abb85861f$export$2e2bcd8739ae039).copy(array);
        this.getLength();
        return this;
    }
    pushArray(array) {
        (0, $1a1d551abb85861f$export$2e2bcd8739ae039).push(array, this._pool);
        this.getLength();
        return this;
    }
    clone() {
        return new $1a25aa5249685cf1$var$Cue(this.isRandom).copy(this._pool);
    }
    fillChance(chanceValue) {
        chanceValue *= 10;
        this.isRandom = true;
        var n;
        for(n = 0; n < chanceValue; n++)this.push(true);
        for(n = chanceValue; n < 10; n++)this.push(false);
        return this;
    }
    getLength() {
        this.length = this._pool.length;
        return this.length;
    }
    add(id, value) {
        id += "";
        this.data[id] = value;
        return this.push(value);
    }
    get(id) {
        if (id != null) return this.setSelected(this.data[id]);
        if (!this.pool.length) this.reset();
        return this.setSelected(this.pool.shift());
    }
    shift(id) {
        return this.get(id);
    }
    getNext() {
        return this.pool[0];
    }
    setSelected(item) {
        this.selected = Array.isArray(item) ? this.isRandom ? (0, $1a1d551abb85861f$export$2e2bcd8739ae039).shuffle(item) : (0, $1a1d551abb85861f$export$2e2bcd8739ae039).copy(item) : item;
        return this.selected;
    }
    consume() {
        if (!this.selected) return;
        var value = this.selected;
        if (Array.isArray(value)) {
            if (value.length) return value.shift();
            value = null;
        } else this.position++;
        this.selected = null;
        return value;
    }
    removeItem(item) {
        (0, $1a1d551abb85861f$export$2e2bcd8739ae039).removeItem(this.pool, item);
        if (this.selected == item) this.selected = null;
        return item;
    }
    reset() {
        this.position = 0;
        this.pool = this.isRandom ? (0, $1a1d551abb85861f$export$2e2bcd8739ae039).shuffle(this._pool) : (0, $1a1d551abb85861f$export$2e2bcd8739ae039).copy(this._pool);
        this.selected = null;
    }
    clear() {
        this.pool = [];
        this.selected = null;
    }
    getPosition(pos) {
        if (!pos || pos < 0) return;
        this.reset();
        while(pos > this._pool.length)pos -= this.pool.length;
        var value;
        while(this.position < pos)value = this.get();
        return value;
    }
    constructor(_isRandom){
        this._pool = [];
        this.data = {};
        this.pool = [];
        this.position = 0;
        this.selected = null;
        this.length = 0;
        this.isRandom = _isRandom;
    }
}
var $1a25aa5249685cf1$export$2e2bcd8739ae039 = $1a25aa5249685cf1$var$Cue;


class $8ef7c4683564d83a$var$Friends {
    /*=============== 


    GET
    

    ================*/ async get(force) {
        // return Promise.resolve( this.pool );
        if (this.isLoaded && !force) return Promise.resolve(this.pool);
        this.pool = [];
        if (this.conquer.User.type != "USERNAME") return Promise.resolve(this.refresh());
        let array = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).FRIENDS_GET);
        this.isLoaded = true;
        for(var n in array)this.pool.push(new (0, $0a95283b4a388957$export$2e2bcd8739ae039)(this.conquer, array[n]));
        return Promise.resolve(this.refresh());
    }
    refresh() {
        this.active = [];
        this.cue = new (0, $1a25aa5249685cf1$export$2e2bcd8739ae039)(true);
        for(var n in this.pool){
            let item = this.pool[n];
            if (item.status != "active") continue;
            this.active.push(item);
            this.cue.push(item);
        }
        return this.pool;
    }
    /*=============== 


    GET
    

    ================*/ async getRandom() {
        if (!this.isLoaded) await this.get();
        return Promise.resolve(this.cue.get());
    }
    async getOrBot() {
        let friend;
        this.counter++;
        if (++this.counter > 3) this.counter = 0;
        if (this.counter > 0) friend = await this.getRandom();
        if (!friend) {
            let bots = await this.conquer.Bots.get(1);
            friend = bots[0];
        }
        return Promise.resolve(friend);
    }
    /*=============== 


    SET
    

    ================*/ async set(friendID) {
        var friendship = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).FRIENDS_SET, {
            friendID: friendID,
            avatarID: this.conquer.User.avatarID
        });
        return Promise.resolve(friendship);
    }
    async setUsernames(usernames) {
        let result = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).FRIENDS_SET, {
            usernames: usernames,
            avatarID: this.conquer.User.avatarID
        });
        return this.get(true);
    }
    /*=============== 


    CHANGE
    

    ================*/ async change(friendID) {
        var friendship = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).FRIENDS_CHANGE, {
            friendID: friendID,
            avatarID: this.conquer.User.avatarID
        });
        return Promise.resolve(friendship);
    }
    /*=============== 


    REMOVE
    

    ================*/ async remove(friendID) {
        var friendship = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).FRIENDS_REMOVE, {
            friendID: friendID,
            avatarID: this.conquer.User.avatarID
        });
        return Promise.resolve(friendship);
    }
    constructor(instance){
        this.isLoaded = false;
        this.pool = [];
        this.active = [];
        this.counter = 0;
        this.conquer = instance;
    }
}
var $8ef7c4683564d83a$export$2e2bcd8739ae039 = $8ef7c4683564d83a$var$Friends;




class $30c1488244e5792e$var$Entries {
    async get(vars) {
        vars = vars || {};
        vars.graphID = this.graphID;
        let values = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).ROOM_ENTRIES_GET, vars);
        return Promise.resolve(values);
    }
    set(text) {
        this.roomInstance.entry(text);
    }
    async change(vars) {
        let value = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).ROOM_ENTRIES_CHANGE, vars);
        return Promise.resolve(value);
    }
    async remove(vars) {
        await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).ROOM_ENTRIES_REMOVE, vars);
        return Promise.resolve();
    }
    constructor(instance, roomInstance){
        this.conquer = instance;
        this.roomInstance = roomInstance;
        this.graphID = roomInstance.graphID;
    }
}
var $30c1488244e5792e$export$2e2bcd8739ae039 = $30c1488244e5792e$var$Entries;







class $2996544f6f1ff97a$var$RoomPlayerStatus {
    playing(data) {
        this.set((0, $db396e8726140e32$export$e50006273435e7d4).PLAYING, data);
    }
    ready(data) {
        this.set((0, $db396e8726140e32$export$e50006273435e7d4).READY, data);
    }
    rewarded(data) {
        this.set((0, $db396e8726140e32$export$e50006273435e7d4).REWARDED, data);
    }
    OVER(data) {
        this.set((0, $db396e8726140e32$export$e50006273435e7d4).OVER, data);
    }
    busy(data) {
        this.set((0, $db396e8726140e32$export$e50006273435e7d4).BUSY, data);
    }
    lobby(data) {
        this.set((0, $db396e8726140e32$export$e50006273435e7d4).LOBBY, data);
    }
    set(status, data) {
        if (this.Player.data.status === status) return;
        this.Player.Room.doSend((0, $db396e8726140e32$export$92a1a3b7554e9387).PLAYERSTATUS, (0, $1a1d551abb85861f$export$2e2bcd8739ae039).extract({
            status: status
        }, data));
    }
    constructor(Player){
        this.Player = Player;
    }
}
var $2996544f6f1ff97a$export$2e2bcd8739ae039 = $2996544f6f1ff97a$var$RoomPlayerStatus;




class $4c7a76498ee10b7f$var$RoomPlayerState {
    idle(data) {
        this.set((0, $db396e8726140e32$export$63b4527a2777036f).IDLE, data);
    }
    attack(data) {
        this.set((0, $db396e8726140e32$export$63b4527a2777036f).ATTACK, data);
    }
    dying(data) {
        this.set((0, $db396e8726140e32$export$63b4527a2777036f).DYING, data);
    }
    dead(data) {
        this.set((0, $db396e8726140e32$export$63b4527a2777036f).DEAD, data);
    }
    carry(data) {
        this.set((0, $db396e8726140e32$export$63b4527a2777036f).CARRY, data);
    }
    dance(data) {
        this.set((0, $db396e8726140e32$export$63b4527a2777036f).DANCE, data);
    }
    defeat(data) {
        this.set((0, $db396e8726140e32$export$63b4527a2777036f).DEFEAT, data);
    }
    walk(data) {
        this.set((0, $db396e8726140e32$export$63b4527a2777036f).WALK, data);
    }
    run(data) {
        this.set((0, $db396e8726140e32$export$63b4527a2777036f).RUN, data);
    }
    crazy(data) {
        this.set((0, $db396e8726140e32$export$63b4527a2777036f).CRAZY, data);
    }
    fall(data) {
        this.set((0, $db396e8726140e32$export$63b4527a2777036f).FALL, data);
    }
    wallrun(data) {
        this.set((0, $db396e8726140e32$export$63b4527a2777036f).WALLRUN, data);
    }
    slide(data) {
        this.set((0, $db396e8726140e32$export$63b4527a2777036f).SLIDE, data);
    }
    wallslide(data) {
        this.set((0, $db396e8726140e32$export$63b4527a2777036f).WALLSLIDE, data);
    }
    doublejump(data) {
        this.set((0, $db396e8726140e32$export$63b4527a2777036f).DOUBLEJUMP, data);
    }
    set(status, data) {
        if (this.Player.data.status === status) return;
        this.Player.Room.doSend((0, $db396e8726140e32$export$92a1a3b7554e9387).PLAYERSTATE, (0, $1a1d551abb85861f$export$2e2bcd8739ae039).extract({
            status: status
        }, data));
    }
    constructor(Player){
        this.Player = Player;
    }
}
var $4c7a76498ee10b7f$export$2e2bcd8739ae039 = $4c7a76498ee10b7f$var$RoomPlayerState;


class $a1d7a7be645036fb$var$RoomPlayerInstance {
    leave() {
        this.Room.leave();
    }
    chat(text) {
        this.Room.chat(text);
    }
    entry(text) {
        this.Room.chat(text);
    }
    send(data) {
        this.Room.doSend((0, $db396e8726140e32$export$92a1a3b7554e9387).PLAYERVARS, data);
    }
    sync(callback) {
        this.syncCallback = callback;
        this.Room.doSend((0, $db396e8726140e32$export$92a1a3b7554e9387).SYNCREQUEST);
    }
    onServerSynced() {
        if (this.syncCallback) this.syncCallback();
        this.syncCallback = null;
    }
    update(data) {
        (0, $1a1d551abb85861f$export$2e2bcd8739ae039).extract(data, this.data);
    // fire or something
    }
    constructor(Room, data){
        this.data = {};
        this.isBot = true;
        this.isNPC = false;
        this.isME = false;
        this.Room = Room;
        this.Status = new (0, $2996544f6f1ff97a$export$2e2bcd8739ae039)(this);
        this.State = new (0, $4c7a76498ee10b7f$export$2e2bcd8739ae039)(this);
        this.data = data;
        this.avatarID = data.avatarID;
        this.isBot = data.isBot;
        this.isME = this.avatarID == Room.conquer.User.avatarID;
        this.snappy = data.snappy;
        this.fullName = data.fullName;
        this.userPhoto = data.userPhoto;
    }
}
var $a1d7a7be645036fb$export$2e2bcd8739ae039 = $a1d7a7be645036fb$var$RoomPlayerInstance;


const $773044369c5cd207$export$3f6e35e5a5245cb7 = {
    "IDLE": 0,
    "CALLING": 1,
    "RECEIVED": 2,
    "IN_PROGRESS": 3,
    "WAITING_PERMISSIONS": 4,
    "NO_PERMISSIONS": 5
};
class $773044369c5cd207$var$RoomInstance {
    doConstruct(vars) {
        if (!vars) return;
        if (vars.gameKey) this.gameKey = vars.gameKey;
        if (!vars._id) return;
        this.graphID = vars._id;
        this.name = vars.name;
        this.avatarIDs = vars.avatarIDs;
        this.key = vars.key;
        this.gameKey = vars.gameKey;
        this.Entries = new (0, $30c1488244e5792e$export$2e2bcd8739ae039)(this.conquer, this);
        this.eventsKey = "ROOM_" + this.graphID;
        this.conquer.Rooms.pool[this.graphID] = this;
    }
    async connect(onMessage, onJoin) {
        let value = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).ROOM_GETONE, {
            gameKey: this.gameKey
        }); // ADD AVATAR IDS FOR PROD
        this.doConstruct(value);
        if (onMessage) this.onMessage = onMessage;
        this.isConnected = true;
        await this.join(onJoin);
        return Promise.resolve();
    }
    async join(onJoin) {
        this.onJoin = onJoin;
        let avatar = this.conquer.Avatars.ME;
        let snappy = await avatar.Snappy.get();
        this.doSend((0, $db396e8726140e32$export$92a1a3b7554e9387).PLAYERJOIN, {
            snappy: snappy,
            fullName: avatar.fullName,
            userPhoto: avatar.userPhoto
        });
        this.isConnected = true;
        return Promise.resolve();
    }
    leave() {
        this.isConnected = false;
        this.doSend((0, $db396e8726140e32$export$92a1a3b7554e9387).PLAYERLEFT);
        this.conquer.Rooms.leave(this);
    }
    chat(text) {
    // this.doSend( ACTIONS.CHAT, text );
    }
    entry(text, metadata) {
        this.doSend((0, $db396e8726140e32$export$92a1a3b7554e9387).ENTRY, {
            text: text,
            metadata: metadata
        });
    }
    doSend(action, data) {
        this.conquer.send(action, this.graphID, data || {});
    }
    _onServerMessage(message) {
        let action = message.action;
        let avatarID = message.avatarID;
        if (action == (0, $db396e8726140e32$export$92a1a3b7554e9387).GAMEDATA) {
            this.data = message.data;
            this.updatePlayers();
        }
        if (action == (0, $db396e8726140e32$export$92a1a3b7554e9387).PLAYERJOIN) {
            this.players[message.data.avatarID] = message.playerInstance = new (0, $a1d7a7be645036fb$export$2e2bcd8739ae039)(this, message.data);
            if (this.conquer.User.avatarID === message.data.avatarID) {
                this.ME = this.players[message.data.avatarID];
                if (this.onJoin) this.onJoin(this.ME);
                this.onJoin = null;
                return;
            } else if (!this.RIVAL) this.RIVAL = this.players[message.data.avatarID];
        }
        if (action == (0, $db396e8726140e32$export$92a1a3b7554e9387).TIME) this.data.remaining = message.data.remaining;
        if (action == (0, $db396e8726140e32$export$92a1a3b7554e9387).PLAYERVARS || action == (0, $db396e8726140e32$export$92a1a3b7554e9387).PLAYERSTATE || action == (0, $db396e8726140e32$export$92a1a3b7554e9387).PLAYERSTATUS) {
            let player = this.players[avatarID];
            if (player) player.update(message.data);
        }
        if (action == (0, $db396e8726140e32$export$92a1a3b7554e9387).ROOMSTATUS) {
            (0, $1a1d551abb85861f$export$2e2bcd8739ae039).extract(message.data, this.data);
            this.updatePlayers();
            let status = this.data.status;
            if (status == (0, $db396e8726140e32$export$e50006273435e7d4).PLAYERSREADY) {
                if (this.ME.data.status == (0, $db396e8726140e32$export$e50006273435e7d4).READY) this.ME.Status.playing();
            }
        }
        if (action == (0, $db396e8726140e32$export$92a1a3b7554e9387).INSYNC) return this.ME.onServerSynced();
        if (message.avatarID == this.conquer.User.avatarID) return;
        if (!this.isConnected) return;
        this.onMessage(message);
        this.conquer.Signal.set(this.eventsKey + ":onMessage", message);
    }
    updatePlayers() {
        for(let avatarID in this.data.playerVars){
            if (this.players[avatarID]) {
                this.players[avatarID].update(this.data.playerVars[avatarID]);
                continue;
            }
            this.players[avatarID] = new (0, $a1d7a7be645036fb$export$2e2bcd8739ae039)(this, this.data.playerVars[avatarID]);
        }
    }
    setCallState(newState) {
        var _this, _this_onCallState;
        this.callState = newState;
        (_this_onCallState = (_this = this).onCallState) === null || _this_onCallState === void 0 ? void 0 : _this_onCallState.call(_this, newState);
    }
    constructor(conquer, vars){
        this.onMessage = function(e) {};
        this.onCallState = function(e) {};
        this.data = {};
        this.players = {};
        this.isConnected = false;
        this.callState = $773044369c5cd207$export$3f6e35e5a5245cb7.IDLE;
        this.conquer = conquer;
        this.doConstruct(vars);
    }
}
var $773044369c5cd207$export$2e2bcd8739ae039 = $773044369c5cd207$var$RoomInstance;



class $11d56420e3f1e1c7$var$Rooms {
    /*=============== 
 
    GET (get rooms list)
    {
      // no params needed, avatarID is passed in the back
    }

 
    ================*/ async get(vars) {
        let values = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).ROOM_GET, vars);
        for(var n in values){
            let room = new (0, $773044369c5cd207$export$2e2bcd8739ae039)(this.conquer, values[n]);
            this.pool[room.graphID] = room;
        }
        return Promise.resolve(this.pool);
    }
    /*=============== 
 
    GET (JOIN)
    {
        avatarIDs?:[ avatarID ] // [ yohamiID, JID ] 
    }

    [ avatarID1, avatarID2, etc ]
 
    ================*/ //give avatarIDs or graphID
    async getOne(vars) {
        if (Array.isArray(vars)) vars = {
            memberIDs: vars
        };
        if (typeof vars == "string") vars = {
            gameKey: vars
        };
        let value = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).ROOM_GETONE, vars);
        let room = new (0, $773044369c5cd207$export$2e2bcd8739ae039)(this.conquer, value);
        this.pool[room.graphID] = room;
        return Promise.resolve(room);
    }
    async getRoomEntries(vars) {
        let value = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).ROOM_ENTRIES_GET, vars);
        return Promise.resolve(value);
    }
    /*=============== 


    LEAVE
    

    ================*/ async leave(graphID) {
        delete this.pool[graphID];
        return Promise.resolve();
    }
    /*=============== 


    ON MESSAGE
    

    ================*/ _onServerMessage(object) {
        for(let n in object.messages){
            let message = object.messages[n];
            let room = this.pool[message.graphID];
            if (room) room._onServerMessage(message);
        }
    }
    constructor(instance){
        this.pool = {};
        this.conquer = instance;
    }
}
var $11d56420e3f1e1c7$export$2e2bcd8739ae039 = $11d56420e3f1e1c7$var$Rooms;




class $1d43f68c0dc7a784$var$Analytics {
    setPayload(object) {
        this.vars = object;
    }
    async get(vars) {
        let values = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).ANALYTICS_GET, vars);
        return Promise.resolve(values);
    }
    set(label, value) {
        return;
    }
    async onEntryPoint() {
        var os = "";
        var browser = "";
        var ip = "";
        var domain = "";
        if (typeof window != "undefined") domain = window.location.origin;
        // ADD: country, time, browser, os, platform, everything
        if (typeof navigator != "undefined") {
            var userAgent = navigator.userAgent;
            if (userAgent.indexOf("X11") >= 0) os = "Unix";
            if (userAgent.indexOf("CrOS") >= 0) os = "ChromeOS";
            if (userAgent.indexOf("Android") >= 0) os = "Android";
            if (userAgent.indexOf("Windows NT") >= 0) os = "Windows";
            if (userAgent.indexOf("Macintosh") >= 0) os = "MacOS";
            if (userAgent.indexOf("iOS") >= 0) os = "iOS";
            if (userAgent.indexOf("iPhone") >= 0) os = "iPhone";
            if (userAgent.indexOf("iPad") >= 0) os = "iPad";
            if (os == "") os = "unknown";
            if (userAgent.match(/Edge\/[0-9.]*$/g)) browser = "Edge";
            if (userAgent.match(/Safari\/[0-9.]*$/g)) browser = "Safari";
            if (userAgent.match(/OPR\/[0-9.]*$/g)) browser = "Opera";
            if (userAgent.match(/Firefox\/[0-9.]*$/g)) browser = "Firefox";
            if (navigator.vendor.indexOf("Google") >= 0) browser = "Chrome";
            if (browser == "") os = "unknown";
            const xhrIP = new XMLHttpRequest();
            const urlIP = "https://api.ipify.org/?format=json";
            xhrIP.open("GET", urlIP, true);
            await new Promise((resolve, reject)=>{
                xhrIP.onload = ()=>{
                    ip = xhrIP.responseText;
                    resolve();
                };
                xhrIP.send();
            });
            try {
                ip = JSON.parse(ip).ip;
            } catch (e) {
                ip = "undefined";
            }
        }
        let vars = {
            label: "onEntryPoint",
            ip: ip,
            browser: browser,
            os: os,
            domain: domain
        };
        this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).ANALYTICS_SET, (0, $1a1d551abb85861f$export$2e2bcd8739ae039).extract(this.vars, vars));
    }
    constructor(conquer){
        this.vars = {};
        this.conquer = conquer;
    }
}
var $1d43f68c0dc7a784$export$2e2bcd8739ae039 = $1d43f68c0dc7a784$var$Analytics;




class $286099c459260b30$var$Score {
    reset() {
        this.conquer.Avatars.ME.vars.score = 0;
        this.vars = {};
        this.resetMultiplier();
        this.set(0);
        this.setRival(0);
    }
    setVars(vars) {
        this.vars = vars;
    }
    /*=======================


    ME


    ========================*/ setPermanentMultiplier(value = 1) {
        this.permanentMultiplier = value;
    }
    increaseMultiplier(value = 1) {
        this.setMultiplier(this.multiplier + value);
    }
    resetMultiplier() {
        this.setMultiplier(1);
    }
    setMultiplier(value = 1) {
        this.multiplier = value;
        this.color = this.getColor();
        if (this.multiplier === 1) {
            this.gameInstance.Signal.set("ACTIVEFX:Remove", {
                id: "ScoreMultiplier"
            });
            return;
        }
        this.gameInstance.Signal.set("ACTIVEFX:Set", {
            id: "ScoreMultiplier",
            text: "X" + this.multiplier
        });
    }
    getColor() {
        if (this.multiplier > 3) return "RED";
        if (this.multiplier > 2) return "GREEN";
        if (this.multiplier > 1) return "YELLOW";
        return "WHITE";
    }
    increase(value = 1, avatarID) {
        if (avatarID) return this.increaseAvatar(value, avatarID);
        this.conquer.Haptic.short();
        value = value * this.multiplier * this.permanentMultiplier;
        this.set((this.conquer.Avatars.ME.vars.score || 0) + value);
        this.gameInstance.Signal.set("PlayerScoreIncrease", value);
    }
    set(score, avatarID) {
        if (avatarID) return this.setAvatar(score, avatarID);
        this.conquer.Avatars.ME.vars.score = this.gameInstance.Data.display(this.meVar, score);
        this.gameInstance.Data.setMax(this.meVar, score);
        this.gameInstance.Signal.set("SCORE:onUpdate");
        this.gameInstance.Data.display("SCORE:" + this.conquer.Avatars.ME.avatarID, score);
    }
    get(avatarID) {
        if (avatarID) return this.getAvatar(avatarID);
        return this.gameInstance.Data.get(this.meVar);
    }
    isWinning() {
        return this.get() > this.getRival();
    }
    /*=======================


    AVATARS


    ========================*/ increaseAvatar(value = 1, avatarID) {
        if (avatarID == this.conquer.Avatars.ME.avatarID) return this.increase(value);
        let Avatar = this.conquer.Avatars.data[avatarID];
        if (!Avatar) return value;
        return this.setAvatar((Avatar.vars.score || 0) + value, avatarID);
    }
    setAvatar(score, avatarID) {
        if (avatarID == this.conquer.Avatars.ME.avatarID) return this.set(score);
        let Avatar = this.conquer.Avatars.data[avatarID];
        if (!Avatar) return;
        Avatar.vars.score = score;
        this.gameInstance.Data.display("SCORE:" + avatarID, score);
        return score;
    }
    getAvatar(avatarID) {
        if (avatarID == this.conquer.Avatars.ME.avatarID) return this.get();
        let Avatar = this.conquer.Avatars.data[avatarID];
        if (!Avatar) return;
        return Avatar.vars.score;
    }
    toCoins(multiplier) {
        if (!multiplier) return;
        this.gameInstance.Coins.setPermanentMultiplier(1);
        this.gameInstance.Coins.increase(Math.round(this.get() * multiplier));
    }
    /*=======================


    RIVAL


    ========================*/ increaseRival(value) {
        this.setRival(this.gameInstance.Data.get(this.rivalVar) + (value || 1));
    }
    getRival() {
        return this.gameInstance.Data.get(this.rivalVar);
    }
    setRival(value) {
        this.gameInstance.Data.display(this.rivalVar, value);
        if (this.gameInstance.Rivals.RIVAL) this.gameInstance.Rivals.RIVAL.vars.score = value;
        this.gameInstance.Signal.set("SCORE:onUpdate");
        return value;
    }
    /*=======================


    RIVAL


    ========================*/ save() {
        let score = this.get();
        this.gameInstance.Scoreboard.set(score);
        let turnsInstance = this.gameInstance.Turns.selected;
        if (turnsInstance) {
            let turnData = {
                score: score
            };
            if (this.permanentMultiplier > 1) turnData.permanentMultiplier = this.permanentMultiplier;
            turnsInstance.set({
                turnData: turnData
            });
        }
    }
    /*=======================


    GET


    ========================*/ async getOne() {
        let value = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_SCORE_GET, this.query);
        return Promise.resolve(value);
    }
    async getAllTime() {
        let values = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_SCORE_GETALLTIME, this.query);
        return Promise.resolve(values);
    }
    async getToday() {
        let values = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_SCORE_GETTODAY, this.query);
        return Promise.resolve(values);
    }
    async getFriendsAllTime() {
        let values = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_SCORE_GETFRIENDSALLTIME, this.query);
        return Promise.resolve(values);
    }
    async getFriendsToday() {
        let values = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_SCORE_GETFRIENDSTODAY, this.query);
        return Promise.resolve(values);
    }
    constructor(gameInstance){
        this.multiplier = 1;
        this.permanentMultiplier = 1;
        this.meVar = "PlayerScore";
        this.rivalVar = "RivalScore";
        this.vars = {};
        this.color = "";
        this.conquer = gameInstance.conquer;
        this.gameInstance = gameInstance;
        this.conquer = gameInstance.conquer;
        this.query = {
            gameID: gameInstance.gameID
        };
    }
}
var $286099c459260b30$export$2e2bcd8739ae039 = $286099c459260b30$var$Score;


class $1f19a55e97c24865$var$Coins {
    reset() {
        this.set(0);
        this.setRival(0);
        this.setPermanentMultiplier();
        this.gameInstance.Data.display(this.Reward, 0);
    }
    /*=======================


    ME


    ========================*/ get() {
        return this.gameInstance.Data.get(this.meVar);
    }
    set(value) {
        this.conquer.Avatars.ME.vars.gameCoin = this.gameInstance.Data.display(this.meVar, value);
    }
    setPermanentMultiplier(value = 1) {
        this.permanentMultiplier = value || 1;
    }
    increase(value = 1) {
        value = value * this.permanentMultiplier;
        this.gameInstance.Signal.set("GameCoinsIncrease", value);
        this.gameInstance.Signal.set("CoinEarned", value);
        this.set(this.get() + value);
    // this.conquer.Sounds.SFX.play('Coin');
    }
    toScore(multiplier = 1) {
        this.gameInstance.Score.increase(this.get() * multiplier);
        this.gameInstance.Score.increaseRival(this.getRival() * multiplier);
    }
    /*=======================


    RIVAL


    ========================*/ increaseRival(value) {
        this.set(this.getRival() + value);
    }
    setRival(value) {
        this.gameInstance.Data.display(this.rivalVar, value);
        if (this.gameInstance.Rivals.RIVAL) this.gameInstance.Rivals.RIVAL.vars.gameCoin = value;
    }
    getRival() {
        return this.gameInstance.Data.get(this.rivalVar);
    }
    constructor(gameInstance){
        this.meVar = "GameCoins";
        this.rivalVar = "RivalGameCoins";
        this.Reward = "RewardCoins";
        this.permanentMultiplier = 1;
        this.gameInstance = gameInstance;
        this.conquer = gameInstance.conquer;
    }
}
var $1f19a55e97c24865$export$2e2bcd8739ae039 = $1f19a55e97c24865$var$Coins;





var $41Zxr = parcelRequire("41Zxr");





class $e74c763d6061a163$var$ScoreboardInstance {
    async get() {
        let scoreboard = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).SCOREBOARD_GET, {
            scoreboardID: this.scoreboardID
        });
        this.endDate = scoreboard.endDate;
        this.items = [];
        let bots = await this.conquer.Bots.get(25 - scoreboard.items.length);
        for(let n = 0; n < bots.length; n++){
            let item = bots[n];
            this.items.push({
                fullName: item.fullName,
                userPhoto: item.userPhoto,
                avatarID: item.avatarID,
                score: (0, $e3618ffcb6abb3f2$export$2e2bcd8739ae039).value(n * 500, n * 10),
                avatar: item
            });
        }
        for(let n in scoreboard.items){
            let item = scoreboard.items[n];
            item.avatar = this.conquer.Avatars.pushInstance(item);
            item.fullName = item.avatar.fullName;
            this.items.push(item);
        }
        this.items = (0, $1a1d551abb85861f$export$2e2bcd8739ae039).sort(this.items, "score");
        this.items.reverse();
        for(let n = 0; n < this.items.length; n++){
            let item = this.items[n];
            item.rank = n + 1;
            let isME = item.avatarID === this.conquer.Avatars.ME.avatarID;
            if (this.gameInstance.Shop.items) {
                let shopItem = this.gameInstance.Shop.items[this.rewards[n]];
                if (shopItem) {
                    item.shopItem = shopItem;
                    if (isME) this.shopItem = shopItem;
                }
            }
        }
        this.gameInstance.Signal.set("SCOREBOARD:onRefresh");
        return Promise.resolve(this);
    }
    async set(score) {
        if (!score || this.endDate < (0, $445b61b73b0f5f22$export$2e2bcd8739ae039).now()) return;
        this.gameInstance.Data.setMax("Score", score);
        await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).SCOREBOARD_ENTRIES_SET, {
            scoreboardEntryID: this.scoreboardEntryID,
            score: score,
            gameID: this.gameInstance.gameID
        });
        return this.get();
    }
    collect() {
        if (this.isCollected || this.endDate > (0, $445b61b73b0f5f22$export$2e2bcd8739ae039).now()) return;
        this.isCollected = true;
        let result = this.shopItem ? this.shopItem.set(true) : false;
        this.gameInstance.Scoreboard.remove(this);
        this.gameInstance.Analytics.onCollectScoreboard(this.shopItem ? this.shopItem.key : null);
        this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).SCOREBOARD_ENTRIES_SET, {
            scoreboardEntryID: this.scoreboardEntryID,
            isCollected: true
        });
        return result;
    }
    constructor(gameInstance, vars){
        this.ladderLength = 0;
        this.endDate = 0;
        this.rewards = [
            "Loot_Legendary",
            "Loot_Legendary",
            "Loot_Legendary",
            "Loot_Epic",
            "Loot_Rare",
            "Coin5K",
            "Coin4K",
            "Coin3K",
            "Coin2K",
            "Coin1K"
        ];
        this.gameInstance = gameInstance;
        this.conquer = gameInstance.conquer;
        this.scoreboardID = vars.scoreboardID;
        this.scoreboardEntryID = vars._id;
    }
}
var $e74c763d6061a163$export$2e2bcd8739ae039 = $e74c763d6061a163$var$ScoreboardInstance;



class $28e012825c0e9d9c$var$Scoreboard {
    init() {
        this.pool = [];
        this.query = {
            gameID: this.gameInstance.gameID
        };
        /*
        for( let n=0; n<scoreboards.length; n++ ) 
        {
            let scoreboardInstance : ScoreboardInstance = new ScoreboardInstance( this.gameInstance, scoreboards[n] );
            this.pool.push( scoreboardInstance );
        } */ this.get();
    }
    async get() {
        let query = this.query;
        query.level = this.gameInstance.UserXP.level;
        this.pool = [];
        let scoreboards = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).SCOREBOARD_ENTRIES_GET, query);
        for(let n = 0; n < scoreboards.length; n++){
            let scoreboardInstance = new (0, $e74c763d6061a163$export$2e2bcd8739ae039)(this.gameInstance, scoreboards[n]);
            this.pool.push(scoreboardInstance);
        }
        this.refresh();
        return Promise.resolve(this.pool);
    }
    async set(score) {
        if (!score) return;
        if (this.current) return this.current.set(score);
        await this.get();
        if (this.current) return this.current.set(score);
    }
    remove(scoreboardInstance) {
        (0, $1a1d551abb85861f$export$2e2bcd8739ae039).removeItem(this.pool, scoreboardInstance);
        this.refresh();
    }
    refresh() {
        if (!this.pool.length) return this.get();
        let readyAmount = 0;
        (0, $1a1d551abb85861f$export$2e2bcd8739ae039).sort(this.pool, "endDate");
        this.pool.reverse();
        for(let n in this.pool)if (this.pool[n].endDate < (0, $445b61b73b0f5f22$export$2e2bcd8739ae039).now()) readyAmount++;
        this.gameInstance.Signal.set("ScoreboardReady", readyAmount);
        this.current = this.pool[0];
        this.current.get();
    }
    /* ============================= 




    LADDER




    ================================ */ reset() {
        this.ladder = null;
    }
    async getLadder() {
        if (this.gameInstance.CONFIG.MULTIPLAYER.mode === "Realtime") await this.getMultiplayerLadder();
        else await this.getAsyncLadder();
        return Promise.resolve(this.ladder);
    }
    async getAsyncLadder() {
        if (this.ladder) {
            this.sortLadder();
            return Promise.resolve(this.ladder);
        }
        var scorePerMinute = this.gameInstance.CONFIG.SCORING.scorePerMinute || 100;
        var scoreIncrement = scorePerMinute / 4;
        var scoreMaxInc = scorePerMinute * 1.24;
        var score = 0;
        this.ladderLength = 30;
        // call get Scores from backend
        var players = [
            this.conquer.Avatars.ME
        ];
        let self = this;
        var ladder = this.ladder = [];
        let array = await this.conquer.Bots.get(this.ladderLength);
        onScores(array);
        Promise.resolve(self.ladder);
        function onScores(array) {
            (0, $1a1d551abb85861f$export$2e2bcd8739ae039).push(array, players);
            for(let n = 0; n < self.ladderLength; n++){
                let player = players[n];
                var vars = player.vars;
                score = score + scoreIncrement;
                scoreIncrement = (0, $41Zxr.default).clamp(scoreIncrement * 1.1, scoreMaxInc);
                if (player !== self.conquer.Avatars.ME) vars.score = Math.round(score + (0, $e3618ffcb6abb3f2$export$2e2bcd8739ae039).value(scoreIncrement * 0.5));
                player.score = vars.score;
                (0, $1a1d551abb85861f$export$2e2bcd8739ae039).pushUnique(ladder, player);
            }
            return self.sortLadder();
        }
    }
    getMultiplayerLadder() {
        /*
        ladder = [];
 
        ladderLength = SOCKET.data.players.length;

        for( var n in SOCKET.data.players ) 
        {
            var player = PLAYERS.get( SOCKET.data.players[n] );
            if( player ) ladder.push( player.vars );        
        }

        sortLadder();

        if( ladder[0].avatarID == ME.avatarID ) fire( "WinGames" );

        */ return Promise.resolve();
    }
    sortLadder() {
        (0, $1a1d551abb85861f$export$2e2bcd8739ae039).sort(this.ladder, "score");
        for(let n = 0; n < this.ladder.length; n++)this.ladder[n].rank = this.ladderLength - n;
        return this.ladder;
    }
    constructor(gameInstance){
        this.ladderLength = 0;
        this.pool = [];
        this.gameInstance = gameInstance;
        this.conquer = gameInstance.conquer;
    }
}
var $28e012825c0e9d9c$export$2e2bcd8739ae039 = $28e012825c0e9d9c$var$Scoreboard;



var $41Zxr = parcelRequire("41Zxr");
class $a6cea0b41372589b$var$Lives {
    reset() {
        this.max = (0, $41Zxr.default).clamp(this.gameInstance.CONFIG.LIVES.max || 1, this.gameInstance.CONFIG.LIVES.value, 0);
        this.set(this.gameInstance.CONFIG.LIVES.value);
    }
    setConfig(vars) {
        this.value = this.gameInstance.Data.display(this.meVar + "Config", vars);
    }
    set(newValue) {
        newValue = (0, $41Zxr.default).clamp(newValue, this.max, 0);
        this.value = this.conquer.Avatars.ME.vars.lives = this.gameInstance.Data.display(this.meVar, newValue);
        return this.value;
    }
    increase(value = 1) {
        return this.set(this.value + value);
    }
    decrease(value = 1) {
        this.set(this.value - value);
        return this.value;
    }
    get() {
        return this.gameInstance.Data.get(this.meVar);
    }
    constructor(gameInstance){
        this.meVar = "PlayerLives";
        this.vars = {};
        this.color = "";
        this.value = 1;
        this.max = 1;
        this.conquer = gameInstance.conquer;
        this.gameInstance = gameInstance;
        this.conquer = gameInstance.conquer;
    }
}
var $a6cea0b41372589b$export$2e2bcd8739ae039 = $a6cea0b41372589b$var$Lives;







var $EtHZk = parcelRequire("EtHZk");


var $41Zxr = parcelRequire("41Zxr");
class $52596d7632dcdf10$var$TurnsInstance {
    fill(params) {
        (0, $EtHZk.log)("Fill turnInstance", params);
        this.avatarIDs = params.avatarIDs || [];
        this.maxTurns = params.maxTurns;
        this.turnData = params.turnData || [];
        this.lastChange = params.lastChange;
        this.firstTurn = params.firstTurn;
        this.viewedResults = params.viewedResults;
        this.currentTurn = params.currentTurn;
        this.currentAvatarID = this.avatarIDs[params.currentTurn];
        this.status = params.status;
        this.isBot = params.isBot;
        this.isVS = this.conquer.Games.Game.CONFIG.MULTIPLAYER.module == "VS";
        return this;
    }
    async init() {
        for(let n in this.avatarIDs)if (this.avatarIDs[n] != this.conquer.User.avatarID) {
            let avatar = await this.conquer.Avatars.get(this.avatarIDs[n]);
            if (!avatar) {
                this.isValid = false;
                this.remove();
                Promise.resolve();
            } else {
                this.avatarID = avatar.avatarID;
                this.fullName = avatar.fullName;
                this.userPhoto = avatar.userPhoto;
            }
            return Promise.resolve();
        }
        return Promise.resolve();
    }
    async get() {
        let value = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_TURN_GETONE, {
            _id: this.query.turnID
        });
        return Promise.resolve(this.fill(value));
    }
    async set(query, avatarID) {
        // query - turnData, finishTurn, viewResults
        query.avatarID = avatarID || this.conquer.Avatars.ME.avatarID;
        if ((query.viewResults || query.finishGame) && query.avatarID === this.conquer.Avatars.ME.avatarID) {
            this.gameInstance.Analytics.onMatchEnd();
            if (this.isBot) return this.remove();
        }
        let value = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_TURN_CHANGE, (0, $1a1d551abb85861f$export$2e2bcd8739ae039).extract(this.query, query));
        (0, $EtHZk.log)("GOT GAME_TURN_CHANGE VALUE", value);
        if (value) this.fill(value);
        this.gameInstance.Turns.refresh();
        return Promise.resolve(this);
    }
    async setBot() {
        if (this.currentAvatarID === this.conquer.Avatars.ME.avatarID) return Promise.resolve();
        if (!this.isVS) return this.set({}, this.currentAvatarID);
        let scorePerMinute = this.gameInstance.CONFIG.SCORING.scorePerMinute || 10;
        let minutes = (0, $41Zxr.default).clamp(this.gameInstance.UserXP.level || 1, 3, 1);
        let score = (0, $e3618ffcb6abb3f2$export$2e2bcd8739ae039).value(scorePerMinute * minutes, Math.round(scorePerMinute / 10));
        return this.set({
            turnData: {
                score: score
            }
        }, this.currentAvatarID);
    }
    async sendTurnData(turnData, avatarID) {
        return this.set({
            turnData: turnData
        }, avatarID);
    }
    async finishGame(avatarID) {
        return this.set({
            finishGame: true
        }, avatarID);
    }
    async finishTurn(avatarID) {
        return this.set({
            finishTurn: true
        }, avatarID);
    }
    async viewResults(avatarID) {
        this.gameInstance.Turns.remove(this);
        return this.set({
            viewResults: true
        }, avatarID);
    }
    async remove() {
        this.gameInstance.Turns.remove(this);
        if (this.isBot) {
            await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_TURN_REMOVE, {
                _id: this.turnID
            });
            return Promise.resolve();
        }
        return this.set({
            viewResults: true,
            isBot: true
        });
    }
    getLadder() {
        let scores = {};
        for(let n in this.turnData){
            let item = this.turnData[n];
            if (!scores[item.avatarID]) scores[item.avatarID] = 0;
            scores[item.avatarID] += item.score || 0;
        }
        let ladder = [];
        for(let avatarID in scores)ladder.push({
            avatarID: avatarID,
            score: scores[avatarID]
        });
        (0, $1a1d551abb85861f$export$2e2bcd8739ae039).sort(ladder, "score");
        return ladder;
    }
    setWinner(boolean) {
        if (this._hasSetWinner) return this.isWinner;
        this._hasSetWinner = true;
        this.isWinner = boolean === true || boolean === false ? boolean : this.getWinner();
        if (this.isWinner) {
            this.gameInstance.Signal.set("WinGames");
            this.gameInstance.Data.increaseTotal("Win");
            this.gameInstance.Data.increaseMax("WinStreak");
        } else this.gameInstance.Data.set("WinStreak", 0);
        return this.isWinner;
    }
    getWinner() {
        let ladder = this.getLadder();
        if (!ladder.length) return false;
        return ladder[0].avatarID !== this.conquer.Avatars.ME.avatarID;
    }
    select() {
        this.gameInstance.Rivals.set(this.avatarID);
    }
    refillScores() {
        this.gameInstance.Score.reset();
        for(let n in this.turnData){
            let item = this.turnData[n];
            this.gameInstance.Score.increaseAvatar(item.score || 0, item.avatarID);
        }
    }
    getReplay() {
        let currentAvatarID;
        let output = [];
        if (!Array.isArray(this.turnData)) return output;
        for(let n = this.turnData.length - 1; n >= 0; n--){
            let item = this.turnData[n];
            if (!item) continue;
            if (!currentAvatarID) currentAvatarID = item.avatarID;
            if (item.avatarID != currentAvatarID) break;
            output.unshift(item);
        }
        return output;
    }
    constructor(gameInstance, params){
        this.maxTurns = 9999;
        this.currentTurn = 0;
        this.status = "waiting";
        this.isValid = true;
        this.isVS = false;
        this.lastChange = 0;
        this.isBot = false;
        this.isWinner = false;
        this._hasSetWinner = false;
        this.gameInstance = gameInstance;
        this.conquer = gameInstance.conquer;
        this.turnID = params._id;
        this.query = {
            turnID: this.turnID
        };
        this.fill(params);
    }
}
var $52596d7632dcdf10$export$2e2bcd8739ae039 = $52596d7632dcdf10$var$TurnsInstance;


class $43a92ea5d5d1d467$var$Turns {
    async set(friendID, vars) {
        let avatarID = this.conquer.Avatars.ME.avatarID;
        vars = vars || {
            isVS: this.conquer.Games.Game.CONFIG.MULTIPLAYER.module == "VS"
        };
        friendID = this.gameInstance.Rivals.set(friendID).avatarID;
        let isBot = this.conquer.Avatars.data[friendID].isBot;
        let query = (0, $1a1d551abb85861f$export$2e2bcd8739ae039).extract(vars, {
            avatarID: avatarID,
            firstTurn: avatarID,
            avatarIDs: [
                friendID
            ],
            isBot: isBot,
            gameID: this.gameInstance.gameID
        });
        return this.setQuery(query);
    }
    async setBot(bot) {
        let avatarID = bot.avatarID;
        let query = {
            isVS: this.conquer.Games.Game.CONFIG.MULTIPLAYER.module == "VS",
            isBot: true,
            avatarIDs: [
                this.conquer.Avatars.ME.avatarID
            ],
            avatarID: avatarID,
            firstTurn: avatarID,
            gameID: this.gameInstance.gameID
        };
        let turnInstance = await this.setQuery(query);
        await turnInstance.setBot();
        return turnInstance;
    }
    async setQuery(query) {
        let value = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_TURN_SET, query);
        let turnInstance = await this.pushInstance(value);
        return Promise.resolve(turnInstance ? this.select(turnInstance) : null);
    }
    async get() {
        this.deselect();
        let vars = {
            avatarID: this.conquer.Avatars.ME.avatarID,
            gameID: this.gameInstance.gameID
        };
        let values = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_TURN_GET, vars);
        this.items = [];
        for(let n in values)await this.pushInstance(values[n]);
        this.refresh();
        return Promise.resolve(this.items);
    }
    refresh() {
        this.yourItems = [];
        this.theirItems = [];
        this.items = (0, $1a1d551abb85861f$export$2e2bcd8739ae039).sort(this.items, "lastChange");
        for(let n in this.items){
            let item = this.items[n];
            if (item.currentAvatarID === this.conquer.Avatars.ME.avatarID) {
                this.yourItems.push(item);
                continue;
            }
            this.theirItems.push(item);
        }
        this.gameInstance.Data.display("yourTurnCount", this.yourItems.length);
        this.gameInstance.Data.display("theirTurnCount", this.theirItems.length);
        this.gameInstance.Signal.set("TURNS:onRefresh");
    }
    async pushInstance(value) {
        let turnInstance = new (0, $52596d7632dcdf10$export$2e2bcd8739ae039)(this.gameInstance, value);
        if (!turnInstance.isValid || turnInstance.viewedResults.includes(this.conquer.Avatars.ME.avatarID)) return Promise.resolve();
        await turnInstance.init();
        this.items.push(turnInstance);
        return Promise.resolve(turnInstance);
    }
    select(turnsInstance) {
        this.selected = turnsInstance;
        turnsInstance.select();
        return turnsInstance;
    }
    deselect() {
        this.selected = null;
    }
    remove(turnsInstance) {
        (0, $1a1d551abb85861f$export$2e2bcd8739ae039).removeItem(this.items, turnsInstance);
        (0, $1a1d551abb85861f$export$2e2bcd8739ae039).removeItem(this.yourItems, turnsInstance);
        (0, $1a1d551abb85861f$export$2e2bcd8739ae039).removeItem(this.theirItems, turnsInstance);
        this.refresh();
        if (this.selected === turnsInstance) this.deselect();
    }
    constructor(gameInstance){
        this.items = [];
        this.yourItems = [];
        this.theirItems = [];
        this.gameInstance = gameInstance;
        this.conquer = gameInstance.conquer;
    }
}
var $43a92ea5d5d1d467$export$2e2bcd8739ae039 = $43a92ea5d5d1d467$var$Turns;




class $f48418ff5ec48d9a$var$ShopTab {
    sort() {
        this.items = (0, $1a1d551abb85861f$export$2e2bcd8739ae039).sort(this.items, "value");
    }
    constructor(Shop, data){
        this.items = [];
        this.Shop = Shop;
        this.id = data._id;
        this.color = data.color;
        this.key = data.key;
        this.title = data.title;
        this.description = data.description;
        this.platform = data.platform;
        this.symbol = data.symbol;
        this.type = data.type;
        this.sorting = data.sorting || 0;
        if (this.type === "Inventory") Shop.inventory.push(this);
        Shop.tabs[this.key] = this;
    }
}
var $f48418ff5ec48d9a$export$2e2bcd8739ae039 = $f48418ff5ec48d9a$var$ShopTab;





var $EtHZk = parcelRequire("EtHZk");

class $cc377628d81ed6f4$var$ShopItem {
    refresh() {
        this.canCollect = this.currency == "Ad" || this.Timer && this.Timer.remaining <= 0;
        if (this.canCollect) {
            this.price = "GET";
            this.currSymbol = "Symbol_Ad";
            if (this.onRefresh) this.onRefresh();
            return;
        }
        this.refreshLevel();
        this.currSymbol = "Symbol_" + this.currency;
        if (this.onRefresh) this.onRefresh();
    //  if( this.Timer ) //log( this.key, "REFRESH lastCollected", this.gameInstance.Data.data[ this.key ], "canCollect", this.canCollect, this.currency, "remaining", this.Timer.remaining );
    }
    stop() {
        if (this.Timer) this.Timer.stop();
    }
    async buy() {
        //log("BUY!", this, this.data.value );
        if (this.type === "Inventory") {
            let item = this.gameInstance.Inventory.items[this.key];
            if (!item.isLocked) return Promise.resolve(false);
        }
        var isPurchased = false;
        if (this.canCollect) {
            this.lastCollected = this.gameInstance.Data.set(this.key, (0, $445b61b73b0f5f22$export$2e2bcd8739ae039).now());
            isPurchased = true;
            if (this.Timer) this.Timer.start();
        } else {
            let success = await this.doPurchase();
            if (!success) return Promise.resolve(false);
            isPurchased = true;
            this.gameInstance.Signal.set("onPurchase");
        }
        if (isPurchased) this.gameInstance.Analytics.onPurchase(this.key);
        let results = this.set(isPurchased);
        this.refresh();
        return Promise.resolve(results);
    }
    set(bool) {
        //log("SET", bool );
        if (!bool) return false;
        // Inventory 
        if (this.type === "Inventory") {
            let inventoryItem = this.gameInstance.Inventory.items[this.key];
            if (inventoryItem) inventoryItem.unlock();
            if (!this.canLevelUp || this.isMaxxed) return false;
            this.quantity = this.gameInstance.Data.increase(this.quantityKey, 1);
            this.refresh();
            return true;
        }
        // Wallet
        let currencyInstance = this.gameInstance.Wallet.currencies[this.variable];
        if (currencyInstance) {
            currencyInstance.increase(this.amount);
            return this.amount;
        }
        // Timewarp
        if (this.variable === "TimeWarp") return true;
        // Lootbox
        if (this.variable === "Lootbox") {
            //log("Its a lootbox", this.value );
            if (!this.value) return false;
            for(let n in this.value.currencies){
                let item = this.value.currencies[n];
                //log("had currency", item );
                let currencyInstance = this.gameInstance.Wallet.currencies[item.currency];
                if (currencyInstance) {
                    //log("currency increased" );
                    currencyInstance.increase(item.amount);
                    continue;
                }
                if (item.currency == "userXP") {
                    //log("userXP increased" );
                    this.gameInstance.UserXP.increase(item.amount);
                    continue;
                }
                //log("increased something else", item.currency );
                this.gameInstance.Data.increase(item.currency, item.amount);
            }
            this.gameInstance.Data.increaseTotal("OpenLoot");
            let contentItems = this.gameInstance.Inventory.setLoot(this.value);
            let output = (0, $1a1d551abb85861f$export$2e2bcd8739ae039).extract(this.value, {
                items: contentItems
            });
            return output;
        }
        // XP
        if (this.variable === "userXP") {
            this.gameInstance.UserXP.increase(this.amount);
            return this.amount;
        }
        // Variables
        if (this.variable && this.amount) {
            this.gameInstance.Data.increase(this.variable, this.amount);
            return this.amount;
        }
        return true;
    }
    async doPurchase(_currency, _price) {
        let currencyInstance = await this.gameInstance.Wallet.getCurrency(_currency || this.currency);
        if (!currencyInstance) return Promise.resolve(false);
        let cashInHand = currencyInstance.value;
        let price = _price || this.price;
        if (price > cashInHand) return Promise.resolve(false);
        currencyInstance.decrease(price);
        return Promise.resolve(true);
    }
    async buyLevelUp() {
        if (this.isMaxxed || !this.canLevelUp) return Promise.resolve();
        let success = await this.doPurchase(this.levelUpCurrency, this.priceLevelUp);
        if (!success) return Promise.resolve(false);
        this.gameInstance.Data.increase(this.levelKey, 1);
        this.refresh();
        return Promise.resolve(true);
    }
    refreshLevel() {
        let rarities = [
            "None",
            "Common",
            "Rare",
            "Epic",
            "Legendary",
            "Mythic"
        ];
        this.multiplier = rarities.indexOf(this.rarity);
        if (!this.canLevelUp) {
            this.level = 1;
            this.price = this._price;
            this.isMaxxed = this.quantity > 0;
            return;
        }
        let levelUpTable = [
            0,
            5,
            15,
            35,
            65
        ];
        if (this.level >= levelUpTable.length - 1) {
            this.price = this._price * this.level;
            this.isMaxxed = true;
            this.multiplier *= this.level;
            return;
        }
        this.isMaxxed = false;
        var newLevel = 0;
        var min = levelUpTable[0];
        var max = levelUpTable[1];
        var n;
        for(n = 1; n < levelUpTable.length; n++){
            newLevel++;
            min = levelUpTable[n - 1];
            max = levelUpTable[n];
            if (this.quantity < levelUpTable[n] || newLevel >= this.level) {
                this.max = max;
                this.min = min;
                this.level = newLevel;
                this.price = this._price * this.level;
                this.priceLevelUp = this._priceLevelUp * this.level;
                this.multiplier *= this.level;
                return;
            }
        }
    }
    constructor(gameInstance, vars){
        this.sorting = 0;
        this.level = 0;
        this.quantity = 0;
        this.multiplier = 1;
        this.min = 0;
        this.max = 1;
        this.isMaxxed = false;
        this.lastCollected = 0;
        this.canCollect = false;
        this.currSymbol = "";
        this.onRefresh = function() {};
        this.gameInstance = gameInstance;
        this.Shop = gameInstance.Shop;
        this.tabKey = vars.tabKey;
        this.key = vars.key;
        this.id = vars._id;
        let data = this.data = vars.data;
        this._price = data.price;
        this.price = this._price;
        this.currency = data.currency;
        this.title = data.title;
        this.ad = data.ad;
        this.amount = data.amount || 0;
        this.metadata = data.metadata;
        this.rarity = data.rarity;
        this.description = data.description;
        this.canLevelUp = data.canLevelUp;
        this.levelUpCurrency = data.levelUpCurrency || this.currency;
        this.isMaxxed = false;
        this._priceLevelUp = data.priceLevelUp || this.price;
        this.priceLevelUp = this._priceLevelUp;
        this.quantityKey = "$Q_" + this.key;
        this.levelKey = "$L_" + this.key;
        this.quantity = this.gameInstance.Data.data[this.quantityKey] || (data.autoEquip ? 1 : 0);
        this.level = this.gameInstance.Data.data[this.levelKey] || 1;
        if (this.Shop.tabs[this.tabKey]) {
            if (!this.description) this.description = this.Shop.tabs[this.tabKey].description;
        } else (0, $EtHZk.log)("ERROR, missing shop tab", this.tabKey);
        this.iap = data.iap;
        this.symbol = data.symbol = data.symbol || this.key;
        this.timer = data.timer || 0;
        this.type = data.type;
        this.value = data.value;
        this.variable = data.variable;
        let Shop = this.Shop;
        Shop.items[this.key] = this;
        if (this.type == "Inventory") Shop.inventory.push(this);
        let tab = Shop.tabs[this.tabKey];
        if (tab) tab.items.push(this);
        if (this.timer > 0 && this.currency != "Ad") {
            this.lastCollected = this.gameInstance.Data.data[this.key] || 0;
            if (!this.lastCollected) this.lastCollected = this.gameInstance.Data.set(this.key, (0, $445b61b73b0f5f22$export$2e2bcd8739ae039).now());
            let self = this;
            this.Timer = new (0, $5d84fedb9ac830c7$export$2e2bcd8739ae039)({
                id: this.key + "Timer",
                autoStart: true,
                duration: this.timer,
                startTime: this.lastCollected,
                Signal: gameInstance.Signal,
                onTimeUp: function() {
                    self.refresh();
                }
            });
        }
        this.refresh();
    }
}
var $cc377628d81ed6f4$export$2e2bcd8739ae039 = $cc377628d81ed6f4$var$ShopItem;


class $cb11298ca1f23cf9$var$Shop {
    init(data) {
        this.vars = {
            gameID: this.gameInstance.gameID
        };
        //  log("INIT SHOP", data );
        this.processData(data);
    }
    async set(shopTabs) // Deprecated for now
    {}
    async setShop(shop) {
        let results = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_SHOP_SET, {
            gameID: this.vars.gameID,
            shop: shop
        });
        return Promise.resolve(this.processData(results));
    }
    async get(force) {
        if (!force && this.tabs) return Promise.resolve(this);
        for(let n in this.items)this.items[n].stop();
        let results = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_SHOP_GET, this.vars);
        return Promise.resolve(this.processData(results));
    }
    find(keysArray) {
        let output = [];
        for(let n in keysArray){
            let shopItem = this.items[keysArray[n]];
            if (shopItem) output.push(shopItem);
        }
        return output;
    }
    processData(shopData) {
        this.tabs = {};
        this.items = {};
        this.inventory = [];
        for(let key in shopData){
            let tab = shopData[key];
            new (0, $f48418ff5ec48d9a$export$2e2bcd8739ae039)(this, tab);
            for(let n in tab.items)new (0, $cc377628d81ed6f4$export$2e2bcd8739ae039)(this.gameInstance, tab.items[n]);
        }
        for(let key in this.tabs)this.tabs[key].sort();
        return shopData;
    }
    constructor(gameInstance){
        this.vars = {};
        this.gameInstance = gameInstance;
        this.conquer = gameInstance.conquer;
    }
}
var $cb11298ca1f23cf9$export$2e2bcd8739ae039 = $cb11298ca1f23cf9$var$Shop;






class $37e03e2c69151488$var$GameCurrency {
    fill(data) {
        this.currencyID = data._id;
        this.value = data.value;
        this.gameID = data.gameID;
        this.name = data.name;
        this.collectedID = "$C_" + this.name;
        this.consumedID = "$Co_" + this.name;
        this.lastCollected = this.gameInstance.Data.data[this.collectedID] || 0;
        this.lastConsumed = this.gameInstance.Data.data[this.consumedID] || 0;
        var self = this;
        if (this.name === "Energy") {
            this.max = 20;
            this.time = 1800000;
            if (!this.Timer) this.Timer = new (0, $5d84fedb9ac830c7$export$2e2bcd8739ae039)({
                id: this.name + "Timer",
                duration: this.time,
                Signal: this.gameInstance.Signal,
                onTimeUp: function() {
                    self.onTimeUp();
                }
            });
            if (!this.lastCollected) {
                this.lastCollected = this.gameInstance.Data.set(this.collectedID, (0, $445b61b73b0f5f22$export$2e2bcd8739ae039).now());
                if (!this.value) this.increase(20);
            }
            this.startTimer();
        }
        if (this.name === "Gem") {
            if (!this.value && !this.lastConsumed) this.increase(100);
        }
    }
    async increase(amount) {
        if (!amount) return Promise.resolve(this.value);
        // let data    = await 
        this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_CURRENCY_CHANGE, {
            _id: this.currencyID,
            increase: amount
        });
        if (amount > 0) this.gameInstance.Data.increaseTotal(this.name, amount);
        return Promise.resolve(this.onChange(this.value + amount));
    }
    async decrease(amount) {
        this.lastConsumed = this.gameInstance.Data.set(this.consumedID, (0, $445b61b73b0f5f22$export$2e2bcd8739ae039).now());
        return this.increase(-amount);
    }
    async get() {
        let data = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_CURRENCY_GETONE, {
            _id: this.currencyID
        });
        return Promise.resolve(this.onChange(data.value));
    }
    onChange(value) {
        this.value = value;
        this.gameInstance.Data.display(this.name, this.value);
        return value;
    }
    onTimeUp() {
        let leftover = this.Timer.elapsed - this.time;
        this.startTimer();
        this.lastCollected = this.gameInstance.Data.set(this.collectedID, (0, $445b61b73b0f5f22$export$2e2bcd8739ae039).now());
        if (this.value >= this.max) return;
        let inc = 5;
        let refill = 0;
        do {
            refill += inc;
            leftover -= this.time;
            if (this.value + refill >= this.max) break;
        }while (leftover > this.time);
        if (this.value + refill > this.max) refill = this.max - this.value;
        if (refill > 0) this.increase(refill);
    }
    startTimer() {
        //log("startTimer", this.name, this.lastCollected );
        this.Timer.start({
            startTime: this.lastCollected
        });
    }
    constructor(gameInstance){
        this.value = 0;
        this.name = "";
        this.max = 0;
        this.time = 0;
        this.lastCollected = 0;
        this.collectedID = "";
        this.consumedID = "";
        this.lastConsumed = 0;
        this.gameInstance = gameInstance;
        this.conquer = gameInstance.conquer;
    }
}
var $37e03e2c69151488$export$2e2bcd8739ae039 = $37e03e2c69151488$var$GameCurrency;


class $7f36d504609ce4f9$var$GameWallet {
    init(data) {
        this.vars = {
            gameID: this.gameInstance.gameID
        };
        for(let name in this.currencies){
            let found = false;
            for(let n in data)if (data[n].name == name) {
                found = true;
                break;
            }
            if (found) continue;
            delete this.currencies[name];
        }
        for(let n in data)this.setCurrency(data[n]);
    }
    async get(currencyName) {
        if (currencyName) {
            let gameCurrency = await this.getCurrency(currencyName);
            return Promise.resolve(gameCurrency);
        }
        this.vars.avatarID = this.conquer.Avatars.ME.avatarID;
        this.currencies = {};
        let entries = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_CURRENCY_GET, this.vars);
        for(let n in entries)await this.setCurrency(entries[n]);
        return Promise.resolve(this.currencies);
    }
    async getPublic(avatarID, names) {
        let results = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_CURRENCY_GET, {
            gameID: this.gameID,
            avatarID: avatarID,
            names: names
        });
        return Promise.resolve(results);
    }
    async setCurrency(currencyData) {
        let gameCurrency = this.currencies[currencyData.name] = this.currencies[currencyData.name] || new (0, $37e03e2c69151488$export$2e2bcd8739ae039)(this.gameInstance);
        gameCurrency.fill(currencyData);
        return Promise.resolve(gameCurrency);
    }
    async increase(currencyName, amount) {
        let gameCurrency = await this.getCurrency(currencyName);
        await gameCurrency.increase(amount);
        return Promise.resolve(gameCurrency);
    }
    async getCurrency(currencyName) {
        let gameCurrency = this.currencies[currencyName];
        if (gameCurrency) return Promise.resolve(gameCurrency);
        let currencyData = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_CURRENCY_GETONE, {
            gameID: this.vars.gameID,
            name: currencyName
        });
        return this.setCurrency(currencyData);
    }
    constructor(gameInstance){
        this.currencies = {};
        this.gameInstance = gameInstance;
        this.gameID = gameInstance.gameID;
        this.conquer = gameInstance.conquer;
    }
}
var $7f36d504609ce4f9$export$2e2bcd8739ae039 = $7f36d504609ce4f9$var$GameWallet;



class $22a1ef45c15cc096$var$InventoryItem {
    select() {
        //log("InventoryItem select", this.key, this.isSelected );
        if (this.isSelected) return;
        //log( "InventoryItem select", this.key, "SELECTED!!!" );
        this.isSelected = this.vars.isSelected = true;
        //this.isLocked   = this.vars.isLocked = false;
        this.gameInstance.Data.set(this.inventoryID, this.vars);
        this.gameInstance.Inventory.tabs[this.tabKey].select(this.key);
        this.gameInstance.Signal.set("INVENTORY:onUpdate", {
            tab: this.tabKey,
            inventoryItem: this
        });
        return this;
    }
    async deselect() {
        //  log("deselect item-", this.key, this.selected );
        if (!this.isSelected) return;
        this.isSelected = this.vars.isSelected = false;
        this.gameInstance.Data.set(this.inventoryID, this.vars);
    }
    remove() {
        this.gameInstance.Inventory.remove(this);
    }
    unlock() {
        if (!this.isLocked) return;
        this.isLocked = this.vars.isLocked = false;
        this.gameInstance.Data.set(this.inventoryID, this.vars);
        let tab = this.gameInstance.Inventory.tabs[this.tabKey];
        (0, $1a1d551abb85861f$export$2e2bcd8739ae039).removeItem(tab.locked, this);
        (0, $1a1d551abb85861f$export$2e2bcd8739ae039).pushUnique(tab.unlocked, this);
        return;
    }
    constructor(gameInstance, vars){
        this.sorting = 0;
        this.canLevelUp = false;
        this.level = 0;
        this.amount = 0;
        this.levelUpTable = [
            0,
            3,
            5,
            10,
            25
        ];
        this.gameInstance = gameInstance;
        this.inventoryID = vars.inventoryID;
        this.key = vars.key;
        this.isLocked = vars.isLocked;
        this.isSelected = vars.isSelected || false;
        this.vars = vars;
        this.shopItem = gameInstance.Shop.items[this.key];
        this.data = this.shopItem.data;
        this.symbol = this.shopItem.symbol;
        this.tabKey = this.shopItem.tabKey;
        this.title = this.shopItem.title;
        this.description = this.shopItem.description;
        this.rarity = this.shopItem.rarity;
        this.sorting = this.shopItem.sorting;
    }
}
var $22a1ef45c15cc096$export$2e2bcd8739ae039 = $22a1ef45c15cc096$var$InventoryItem;




class $e6808078504e38cb$var$InventoryTab {
    push(inventoryItem) {
        this.items.push(inventoryItem);
        if (inventoryItem.isSelected) this.inventory.selected[this.tabKey] = inventoryItem.key;
        if (!inventoryItem.isLocked) this.unlocked.push(inventoryItem);
        else this.locked.push(inventoryItem);
    }
    checkSelect() {
        //log("========== TAB", this.tabKey, "checkSelect", this.items[0] != undefined );
        if (!this.items[0]) return;
        if (this.items[0].sorting) this.items = (0, $1a1d551abb85861f$export$2e2bcd8739ae039).sort(this.items, "sorting");
        //log("TAB SELECTED?", this.tabKey, this.inventory.selected[ this.tabKey ] );
        if (this.inventory.selected[this.tabKey]) return;
        for(let n in this.items)if (!this.items[n].isLocked) return this.select(this.items[n].key);
        //log("NOTHING SELECTED, DO IT" );
        this.items[0].unlock();
        this.select(this.items[0].key);
    }
    select(key) {
        //log("== TAB", this.tabKey, "SELECT", key );
        //log( "=== tab select", shopItemKey, "current", this.inventory.selected[ this.tabKey ] );
        // if( this.inventory.selected[ this.tabKey ] == shopItemKey ) return;
        let current = this.inventory.getItem(key);
        // log("current!", current );
        if (current && this.inventory.selected[this.tabKey] != key) current.select();
        this.inventory.selected[this.tabKey] = key;
        for(let n in this.items){
            //  log("n", n )
            let inventoryItem = this.items[n];
            if (inventoryItem != current) inventoryItem.deselect();
        }
    }
    constructor(inventory, tabKey){
        this.items = [];
        this.unlocked = [];
        this.locked = [];
        this.inventory = inventory;
        this.tabKey = tabKey;
        let shopTab = inventory.gameInstance.Shop.tabs[tabKey] || {};
        this.title = shopTab.title;
        this.description = shopTab.description;
        this.symbol = shopTab.symbol || "Symbol_" + tabKey;
        this.color = shopTab.color;
        this.sorting = shopTab.sorting;
    }
}
var $e6808078504e38cb$export$2e2bcd8739ae039 = $e6808078504e38cb$var$InventoryTab;



class $0a0379c8e5ff6401$var$PlayerInventory {
    get(force) {
        if (this.items && !force) return this.items;
        this.items = {};
        this.tabs = {};
        this.selected = {};
        // RELOAD
        let data = (0, $1a1d551abb85861f$export$2e2bcd8739ae039).searchObject(this.gameInstance.Data.data, this.idKey);
        for(let varName in data)this.push(data[varName]);
        // CREATE
        let shopItems = this.gameInstance.Shop.items;
        for(let key in shopItems){
            let shopItem = shopItems[key];
            if (shopItem.type != "Inventory" || this.items[key]) continue;
            let vars = {
                inventoryID: this.idKey + key,
                key: key,
                isLocked: !shopItem.data.autoEquip
            };
            this.push(vars);
            this.gameInstance.Data.display(vars.inventoryID, vars);
        }
        for(let n in this.tabs)this.tabs[n].checkSelect();
        //log( "PlayerInventory Tabs", this.tabs );
        // log( "PlayerInventory Items", this.items );
        //log("GOT INVENTORY", this.selected );
        return this.items;
    }
    push(itemData) {
        let items = this.items;
        let tabs = this.tabs;
        if (items[itemData.key]) return;
        if (!this.gameInstance.Shop.items[itemData.key]) // delete inventory from data
        return;
        let item = new (0, $22a1ef45c15cc096$export$2e2bcd8739ae039)(this.gameInstance, itemData);
        items[item.key] = item;
        // Rarity
        if (!this.rarity[item.data.rarity]) this.rarity[item.data.rarity] = [];
        this.rarity[item.data.rarity].push(item);
        // Tabs
        let tabKey = item.tabKey;
        if (!tabs[tabKey]) tabs[tabKey] = new (0, $e6808078504e38cb$export$2e2bcd8739ae039)(this, tabKey);
        tabs[tabKey].push(item);
        return item;
    }
    getItem(key) {
        return this.items[key || ""];
    }
    reset() {
        // replace with a backend function to remove them all at once
        for(let key in this.items)this.remove(this.items[key]);
    }
    remove(inventoryItem) {
        delete this.items[inventoryItem.key];
        this.tabs[inventoryItem.data.tabKey].remove(inventoryItem);
    }
    setLoot(data) {
        let items = [];
        let names = [
            "Common",
            "Rare",
            "Epic",
            "Legendary",
            "Mythic"
        ];
        let self = this;
        for(let n in data.shopItems){
            let shopItem = this.gameInstance.Shop.items[data.shopItems[n]];
            if (!shopItem) continue;
            shopItem.set(true);
            items.push(shopItem);
        }
        for(let n = 0; n <= data.guaranteed.length; n++){
            let amount = data.guaranteed[n];
            if (amount <= 0) continue;
            for(let i = 0; i < amount; i++)pushCard(n);
        }
        while(items.length < data.cards)pushCard(getOdds());
        function getOdds() {
            for(var n = 0; n < data.odds.length; n++){
                let random = (0, $e3618ffcb6abb3f2$export$2e2bcd8739ae039).decimal() * 100;
                let myOdds = data.odds[n];
                if (random < myOdds) return n;
            }
            return getOdds();
        }
        function pushCard(n) {
            let item = self.getRarity(names[n]);
            if (!item) return;
            item.shopItem.set(true);
            items.push(self.gameInstance.Shop.items[item.key]);
        }
        return items;
    }
    getRarity(rarityName) {
        let array = (0, $1a1d551abb85861f$export$2e2bcd8739ae039).shuffle(this.rarity[rarityName] || []);
        for(let n in array){
            let item = array[n];
            if (!item.shopItem.isMaxxed) return item;
        }
        return (0, $1a1d551abb85861f$export$2e2bcd8739ae039).getRandomItem(array);
    }
    constructor(gameInstance){
        this.idKey = "$i_";
        this.rarity = {};
        this.conquer = gameInstance.conquer;
        this.gameInstance = gameInstance;
    }
}
var $0a0379c8e5ff6401$export$2e2bcd8739ae039 = $0a0379c8e5ff6401$var$PlayerInventory;



class $289f8029d07a2643$var$DailyRewards {
    set() {
        let data = this.get();
        let item = data.items[data.current];
        if (!item || !data.canCollect) return null;
        data.current++;
        data.rewardDate = (0, $445b61b73b0f5f22$export$2e2bcd8739ae039).now();
        this.save();
        if (item.varName == "Lootbox") {
            let shopItem = this.gameInstance.Shop.items[item.value];
            if (shopItem) {
                item.value = shopItem.set(true);
                return item;
            }
        }
        let currencyInstance = this.gameInstance.Wallet.currencies[item.varName];
        if (currencyInstance) {
            currencyInstance.increase(item.value);
            return item;
        }
        return item;
    }
    get() {
        let data = this.data = this.gameInstance.Data.data[this.key] || this.createObject();
        let current = data.current = parseInt(data.current);
        let timePassed = (0, $445b61b73b0f5f22$export$2e2bcd8739ae039).hoursFrom(data.rewardDate);
        data.canCollect = data.rewardDate && timePassed > 16;
        let items = data.items;
        let isDirty = false;
        if (timePassed > 36 || current >= items.length) {
            current = data.current = 0;
            isDirty = true;
        }
        for(let n = 0; n < items.length; n++){
            let item = items[n];
            if (n < current) item.state = "Collected";
            if (n > current) item.state = "Pending";
            if (n === current) item.state = "Ready";
        }
        if (!data.rewardDate) {
            data.rewardDate = (0, $445b61b73b0f5f22$export$2e2bcd8739ae039).now();
            isDirty = true;
        }
        if (isDirty) this.save();
        return data;
    }
    createObject() {
        let data = this.data = {};
        data.rewardDate = 0;
        data.current = 0;
        data.items = [];
        data.canCollect = false;
        for(let n = 0; n < 15; n++){
            let varName = "Coin";
            let value = (n + 1) * 100;
            if (n === 4 || n === 9 || n === 14) {
                varName = "Lootbox";
                if (n === 4) value = "Loot_Rare";
                if (n === 9) value = "Loot_Epic";
                if (n === 14) value = "Loot_Legendary";
            }
            data.items.push({
                id: n,
                varName: varName,
                value: value,
                day: "DAY " + (n + 1),
                state: "Pending"
            });
        }
        return this.save();
    }
    save() {
        this.gameInstance.Data.set(this.key, this.data);
        return this.data;
    }
    constructor(gameInstance){
        this.key = "DailyRewards";
        this.data = {};
        this.gameInstance = gameInstance;
    }
}
var $289f8029d07a2643$export$2e2bcd8739ae039 = $289f8029d07a2643$var$DailyRewards;



class $7e2be98449edb176$var$GameData {
    setVersion(vars) {}
    async init(data) {
        this.data = data;
        this.gameID = this.gameInstance.gameID;
        this.vars = {
            gameID: this.gameID
        };
        this.stop();
        let self = this;
        let conquer = this.conquer;
        let gameID = this.gameID;
        this.interval = setInterval(function() {
            if (!self.dirty) return;
            conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_DATA_SET, {
                gameID: gameID,
                value: self.dirty
            });
            //.then( function(e){
            //    console.log("SAVED DATA", e );
            //}); 
            self.dirty = false;
        }, 1000);
        this.conquer.Haptic.setEnabled(!this.get("vibration"));
        return Promise.resolve(data);
    }
    get(name) {
        return this.data[name] || 0;
    }
    async getPublic(avatarID, names) {
        let results = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_DATA_GET, {
            gameID: this.gameID,
            avatarID: avatarID,
            names: names
        });
        return Promise.resolve(results);
    }
    set(name, value) {
        return this.display(name, value, true);
    }
    increase(name, value = 1) {
        return this.set(name, this.get(name) + value);
    }
    decrease(name, value) {
        return this.set(name, -value);
    }
    display(name, value, andSave) {
        this.data[name] = value;
        this.gameInstance.Signal.set(name, value);
        if (andSave) {
            if (!this.dirty) this.dirty = {};
            this.dirty[name] = value;
        }
        return value;
    }
    displayIncrease(name, value) {
        return this.display(name, this.get(name) + value);
    }
    displayDecrease(name, value) {
        return this.displayIncrease(name, -value);
    }
    increaseTotal(name, value = 1) {
        var totalName = "total" + name;
        var newVal = this.increase(totalName, value);
        this.setMax(name, newVal);
    }
    increaseMax(name, value = 1) {
        this.increase(name, value);
        this.setMax(name);
    }
    setMax(name, value = 1) {
        var maxName = "max" + name;
        var currVal = this.get(maxName);
        if (currVal > value) return;
        this.set(maxName, value);
    }
    async remove(vars) {
        for(let n in this.data)delete this.data[n];
        vars = vars || {};
        vars.gameID = this.gameID;
        let results = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_DATA_REMOVE, vars);
        return Promise.resolve(results);
    }
    reset() {
        this.remove();
    }
    stop() {
        clearInterval(this.interval);
    }
    constructor(gameInstance){
        this.vars = {};
        this.data = {};
        this.version = 1;
        this.dirty = false;
        this.isInitialized = false;
        this.gameInstance = gameInstance;
        this.conquer = gameInstance.conquer;
    }
}
var $7e2be98449edb176$export$2e2bcd8739ae039 = $7e2be98449edb176$var$GameData;




class $e622fd15d82ead87$var$GameAnalytics {
    /*================


    SET


    =================*/ set(label, value) {
        this.dirty.push({
            label: label,
            value: value
        });
    }
    setPayload(object) {
        this.vars = object;
    }
    /*================


    BUG REPORTING


    =================*/ onError(value) {
        this.set("onError", value);
    }
    /*================


    STARTUP


    =================*/ onPreloadEnd(value) {
        this.set("onPreloadEnd", value);
    }
    /*================


    INTERFACE


    =================*/ onUI(value) {
        this.set("onUI", value);
    }
    onUIOut(value) {
        this.set("onUIOut", value);
    }
    onButton(value) {
        if (!value || value === "Button") return;
        if (this.isFirstClick) this.set("onFirstClick", value);
        this.isFirstClick = false;
        this.set("onButton", value);
    }
    /*================


    TUTORIAL


    =================*/ onTutorialStart(value) {
        this.set("onTutorialStart", value);
    }
    onTutorialStage(value) {
        this.set("onTutorialStage", value);
    }
    onTutorialComplete(value) {
        this.set("onTutorialComplete", value);
    }
    /*================


    ADS


    =================*/ noAds(value) {
        this.set("noAds", value);
    }
    onAdRequest(value) {
        this.set("onAdRequest", value);
    }
    onAdComplete(value) {
        this.set("onAdComplete", value);
    }
    onAdError(value) {
        this.set("onAdError", value);
    }
    /*================


    SHOP


    =================*/ onShopEnter(value) {
        this.set("onShopEnter", value);
    }
    onShopExit(value) {
        this.set("onShopExit", value);
    }
    onPurchase(value) {
        this.set("onPurchase", value);
    }
    /*================


    GAME


    =================*/ onGame() {
        this.set("onGame");
    }
    onPlay(boolean) {
        this.set("onPlay");
        if (boolean) this.set("onPlayRewarded");
    }
    onGameReady() {
        this.set("onGameReady");
    }
    onGameStart() {
        this.set("onGameStart");
    }
    onDie(value) {
        this.set("onDie", value);
    }
    onTimeUp(value) {
        this.set("onTimeUp", value);
    }
    onContinue(value) {
        this.set("onContinue", value);
    }
    onGameOver(value) {
        this.set("onGameOver", value);
    }
    onGameExit(value) {
        this.set("onGameExit", value);
    }
    /*================


    MATCH


    =================*/ onMatchEnd(value) {
        this.set("onMatchEnd", value);
    }
    /*================


    SCOREBOARD


    =================*/ onCollectScoreboard(value) {
        this.set("onCollectScoreboard", value);
    }
    constructor(gameInstance){
        this.vars = {};
        this.data = {};
        this.dirty = [];
        this.isFirstClick = true;
        this.gameInstance = gameInstance;
        this.conquer = gameInstance.conquer;
        this.vars = {
            gameID: gameInstance.gameID
        };
        let self = this;
        let vars = this.vars;
        let conquer = this.conquer;
        this.interval = setInterval(function() {
            if (!self.dirty.length) return;
            conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).ANALYTICS_SET, (0, $1a1d551abb85861f$export$2e2bcd8739ae039).extract(vars, {
                $vars: self.dirty
            }));
            self.dirty = [];
        }, 16.66);
        if (typeof window != "undefined") window.onerror = function(event, source, lineno, colno, error) {
            conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).ANALYTICS_SET, (0, $1a1d551abb85861f$export$2e2bcd8739ae039).extract(vars, {
                label: "onJSError",
                value: event,
                source: source,
                lineno: lineno,
                colno: colno,
                error: error
            }));
        };
        this.onGame();
    }
}
var $e622fd15d82ead87$export$2e2bcd8739ae039 = $e622fd15d82ead87$var$GameAnalytics;




var $EtHZk = parcelRequire("EtHZk");
class $252326b9bdba11b6$var$Signal {
    get(name, callback) {
        if (!this.listeners[name]) this.listeners[name] = [];
        (0, $1a1d551abb85861f$export$2e2bcd8739ae039).pushUnique(this.listeners[name], callback);
    }
    set(name, value) {
        var _this, _this_broadcast;
        (_this_broadcast = (_this = this).broadcast) === null || _this_broadcast === void 0 ? void 0 : _this_broadcast.call(_this, name, value);
        if (typeof window != "undefined" && window.parent != window) window.parent.postMessage(JSON.stringify({
            label: name,
            value: value
        }));
        if (!this.listeners[name]) return;
        for(let n in this.listeners[name])this.listeners[name][n](value);
    }
    remove(name, callback) {
        if (!this.listeners[name]) return;
        (0, $1a1d551abb85861f$export$2e2bcd8739ae039).removeItem(this.listeners[name], callback);
    }
    getInstance() {
        return new $252326b9bdba11b6$var$Signal();
    }
    constructor(){
        this.listeners = {};
        this.broadcast = function(name, value) {};
        (0, $EtHZk.log)("SIGNAL CREATED");
        if (typeof window != "undefined") {
            window.addEventListener("message", function(event) {
                console.log("WINDOW msg received from Dart:", event.data);
            }, false);
            if (window.parent != window) window.parent.addEventListener("message", function(event) {
                console.log("PARENT msg received from Dart:", event.data);
            }, false);
        }
    }
}
var $252326b9bdba11b6$export$2e2bcd8739ae039 = $252326b9bdba11b6$var$Signal;







var $EtHZk = parcelRequire("EtHZk");
class $940f063abf4936c1$var$CueProgression {
    // Pattern blocks
    addPattern(id, isRandom) {
        return this.patterns.add(id, new (0, $1a25aa5249685cf1$export$2e2bcd8739ae039)(isRandom));
    }
    // Segments grouping patterns together
    addSegments(id, isRandom) {
        return this.segments.add(id, new (0, $1a25aa5249685cf1$export$2e2bcd8739ae039)(isRandom));
    }
    // Sequential progression of segments
    addProgressions(id, isRandom) {
        return this.progressions.add(id, new (0, $1a25aa5249685cf1$export$2e2bcd8739ae039)(isRandom));
    }
    // Pool of randomized segments to use after progression is complete
    addEndless(id) {
        return this.endless.add(id, new (0, $1a25aa5249685cf1$export$2e2bcd8739ae039)(true));
    }
    getLength() {
        if (this.length) return this.length;
        this.length = 0;
        var segmentNames = this.progressions._pool[0]._pool[0];
        for(var n in segmentNames){
            var segmentPool = this.segments.data[segmentNames[n]]._pool[0];
            for(var i in segmentPool){
                var patternPool = this.patterns.data[segmentPool[i]]._pool;
                for(var p in patternPool)this.length += Array.isArray(patternPool[p]) ? patternPool[p].length : 1;
            }
        }
        return this.length;
    }
    reset() {
        this.position = 0;
        this.patterns.reset();
        this.segments.reset();
        this.progressions.reset();
        this.endless.reset();
        this.finishedProgression = false;
        this.nextProgression();
    }
    nextProgression() {
        if (this.finishedProgression) return this.nextEndless();
        if (this.progressions.selected) {
            var value = this.progressions.selected.consume();
            if (!value) {
                this.finishedProgression = true;
                return this.nextEndless();
            }
            return this.setSegment(value);
        }
        this.progressions.get();
        this.progressions.selected.get();
        this.setSegment(this.progressions.selected.consume());
    }
    nextEndless() {
        var value;
        if (this.endless.selected) {
            value = this.endless.selected.consume();
            if (value) return this.setSegment(value);
        }
        this.endless.get();
        this.endless.selected.get();
        this.setSegment(this.endless.selected.consume());
    }
    setSegment(id) {
        this.segments.get(id);
        this.segments.selected.get();
        this.setPattern(this.segments.selected.consume());
    }
    nextSegment() {
        var value = this.segments.selected.consume();
        if (value != null) return this.setPattern(value);
        this.nextProgression();
    }
    setPattern(value) {
        this.patterns.get(value);
        this.current = this.patterns.selected;
        this.current.get();
    }
    clear() {
        this.patterns.clear();
        this.segments.clear();
        this.progressions.clear();
        this.endless.clear();
    }
    // The magical get method
    get() {
        if (!this.current) this.reset();
        var value = this.current.consume();
        if (value !== null && value !== undefined) {
            this.position++;
            return value;
        }
        this.nextSegment();
        return this.get();
    }
    getPosition(seekPosition = 0) {
        if (!seekPosition || seekPosition < 0) return;
        this.reset();
        this.getLength();
        // Already in endless mode?
        if (seekPosition > this.length) {
            //  log("FINISHED PROGRESSION, iS ENDLESS" );
            this.finishedProgression = true;
            this.position = seekPosition;
            this.nextEndless();
            return this.get();
        }
        var value;
        while(seekPosition > this.position)value = this.get();
        return value;
    }
    /*================================


    RESETS


    ================================*/ endlessDifficulty() {
        this.clear();
        // PATTERNS
        this.addPattern("easy", true);
        this.addPattern("medium", true);
        this.addPattern("hard", true);
        this.addPattern("crazy", true);
        this.prefillSegments();
        return this;
    }
    endlessStatic() {
        this.clear();
        // PATTERNS
        this.addPattern("easy");
        this.addPattern("medium");
        this.addPattern("hard");
        this.addPattern("crazy");
        this.prefillSegments();
        return this;
    }
    endlessPrefill() {
        this.endlessDifficulty();
        let data = this.patterns.data;
        data.easy.push([
            "easy",
            "easy",
            "easy"
        ]);
        data.easy.push([
            "easy",
            "easy",
            "easy"
        ]);
        data.easy.push([
            "easy",
            "easy"
        ]);
        data.medium.push([
            "medium",
            "medium",
            "medium"
        ]);
        data.medium.push([
            "medium",
            "medium"
        ]);
        data.medium.push([
            "medium",
            "easy",
            "medium"
        ]);
        data.medium.push([
            "medium",
            "hard",
            "medium"
        ]);
        data.hard.push([
            "hard",
            "hard",
            "hard"
        ]);
        data.hard.push([
            "hard",
            "hard"
        ]);
        data.hard.push([
            "hard",
            "medium",
            "hard"
        ]);
        data.hard.push([
            "hard",
            "easy",
            "hard"
        ]);
        data.hard.push([
            "hard",
            "crazy",
            "hard"
        ]);
        data.crazy.push([
            "crazy",
            "crazy",
            "crazy"
        ]);
        data.crazy.push([
            "crazy",
            "medium",
            "crazy"
        ]);
        data.crazy.push([
            "crazy",
            "hard",
            "crazy"
        ]);
        data.crazy.push([
            "crazy",
            "easy",
            "crazy"
        ]);
    }
    linear(amount) {
        this.clear();
        if (!amount) return (0, $EtHZk.log)("Pass an amount for Linear preset");
        var name;
        var names = [];
        for(var n = 0; n < amount; n++){
            name = "linear" + n;
            this.addPattern(name);
            this.addSegments(name).push([
                name
            ]);
            names.push(name);
        }
        // PROGRESSION
        this.addProgressions("progression1").push(names);
        // ENDGAME
        name = "endless";
        this.addPattern(name);
        this.addSegments(name).push([
            name
        ]);
        this.addEndless(name).push([
            name
        ]);
    }
    // HELPERS
    prefillSegments() {
        // SEGMENTS
        var cue;
        cue = this.addSegments("easySegments");
        cue.push([
            "easy",
            "easy",
            "medium"
        ]);
        cue = this.addSegments("mediumSegments", true);
        cue.push([
            "easy",
            "easy",
            "medium",
            "medium"
        ]);
        cue = this.addSegments("hardSegments", true);
        cue.push([
            "easy",
            "easy",
            "medium",
            "medium",
            "hard",
            "hard",
            "hard"
        ]);
        cue = this.addSegments("crazySegments", true);
        cue.push([
            "easy",
            "easy",
            "medium",
            "hard",
            "hard",
            "crazy",
            "crazy",
            "crazy"
        ]);
        cue = this.addSegments("endlessSegments", true);
        cue.push([
            "easy",
            "medium",
            "medium",
            "hard",
            "hard",
            "hard",
            "crazy",
            "crazy",
            "crazy"
        ]);
        // PROGRESSION
        cue = this.addProgressions("progression1");
        cue.push([
            "easySegments",
            "mediumSegments",
            "easySegments",
            "hardSegments",
            "mediumSegments",
            "crazySegments"
        ]);
        // ENDGAME
        cue = this.addEndless("endgame1");
        cue.push([
            "endlessSegments"
        ]);
    }
    constructor(preset, value){
        this.patterns = new (0, $1a25aa5249685cf1$export$2e2bcd8739ae039)(true);
        this.segments = new (0, $1a25aa5249685cf1$export$2e2bcd8739ae039)(true);
        this.progressions = new (0, $1a25aa5249685cf1$export$2e2bcd8739ae039)(true);
        this.endless = new (0, $1a25aa5249685cf1$export$2e2bcd8739ae039)(true);
        this.position = 0;
        this.length = 0;
        if (preset == "endlessDifficulty") this.endlessDifficulty();
        if (preset == "endlessStatic") this.endlessStatic();
        if (preset == "endlessPrefill") this.endlessPrefill();
        if (preset == "linear") this.linear(value);
    }
}
var $940f063abf4936c1$export$2e2bcd8739ae039 = $940f063abf4936c1$var$CueProgression;





var $7gjH7 = parcelRequire("7gjH7");

var $41Zxr = parcelRequire("41Zxr");

class $6226783f5202600d$var$MissionInstance {
    start() {
        if (!this.isEnabled || this.isStarted) return;
        this.reset();
        this.isStarted = true;
        if (this.time) this.timer.start({
            seconds: this.time
        });
        if (this.varName === "PlayerScoreIncrease") {
            this.value = this.gameInstance.Data.data.PlayerScore || 0;
            this.amount += this.value;
        }
        if (this.category === "BeatRival") this.amount = (this.gameInstance.Data.data.RivalScore || 0) + 1;
        if (this.varName === "Survive") {
            this.amount = this.time;
            this.varName = "MissionTime:onSecond";
        }
        this.text = (0, $7gjH7.default).replace(this.vars.text, {
            amount: this.amount,
            time: this.time,
            name: this.name,
            currency: this.currency || "Coins"
        });
    }
    onValue(name, value) {
        if (!this.isEnabled) return;
        if (this.isComplete) return;
        if (name !== this.varName) return;
        this.setValue(value || 1);
    }
    setValue(value) {
        if (!this.isEnabled) return;
        if (this.isComplete) return;
        value = value || 1;
        if (this.isCollection) (0, $1a1d551abb85861f$export$2e2bcd8739ae039).pushUnique(this.value, value);
        else {
            if (this.varName === "MissionTime:onSecond") this.value = this.time - value;
            else this.value += value;
            value = (0, $41Zxr.default).clamp(value, this.amount);
        }
        if (this.persistent) this.gameInstance.Data.set(this.key, this.value);
        else this.gameInstance.Data.display(this.key, this.value);
        this.onUpdate();
        let val = this.isCollection ? this.value.length : this.value;
        if (val < this.amount) return;
        this.isComplete = true;
        this.stop();
        this.gameInstance.Quest.increase();
        this.onComplete();
    }
    onUpdate() {
    //fire( "MISSION:onUpdate" );
    }
    onComplete() {
    //fire( "MISSION:onComplete" );
    }
    pause() {
        if (this.timer) this.timer.pause();
    }
    resume() {
        if (this.timer) this.timer.resume();
    }
    remove() {
        this.isStarted = false;
        this.gameInstance.Missions.remove(this.key);
        this.stopTime();
        this.disable();
    }
    disable() {
        this.isStarted = false;
        this.isEnabled = false;
    }
    _onTimeUpdate() {
        this.setValue(1);
        this.onTimeUpdate();
    }
    onTimeUpdate() {}
    _onTimeUp() {
        this.onTimeUp();
    }
    onTimeUp() {}
    reset() {
        this.stop();
        this.value = this.persistent ? this.gameInstance.Data.data[this.key] || 0 : 0;
        if (this.isCollection && !this.value) this.value = [];
    }
    stop() {
        this.isStarted = false;
        this.stopTime();
    }
    stopTime() {
        if (this.timer) this.timer.stop();
    }
    constructor(gameInstance, vars){
        this.amount = 0;
        this.isComplete = false;
        this.isEnabled = true;
        this.isStarted = false;
        this.gameInstance = gameInstance;
        this.conquer = gameInstance.conquer;
        this.vars = vars;
        this.key = vars.key;
        this.category = vars.category;
        this.text = vars.text;
        this.amount = vars.amount;
        this.varName = vars.varName;
        this.time = vars.time;
        this.persistent = vars.persistent;
        this.isCollection = vars.isCollection;
        this.currency = vars.currency || "Coin";
        this.name = vars.name;
        let self = this;
        if (this.time) this.timer = new (0, $5d84fedb9ac830c7$export$2e2bcd8739ae039)({
            id: "MissionTime",
            onUpdate: ()=>self.onTimeUpdate(),
            onTimeUp: ()=>self.onTimeUp(),
            Signal: gameInstance.Signal
        });
    }
}
var $6226783f5202600d$export$2e2bcd8739ae039 = $6226783f5202600d$var$MissionInstance;


class $90b62abbacf3d7e8$var$Missions {
    async set(data) {
        let results = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_MISSIONS_SET, {
            gameID: this.vars.gameID,
            data: data
        });
        return Promise.resolve(this.processData(results.data));
    }
    init(results) {
        this.vars = {
            gameID: this.gameInstance.gameID
        };
        this.processData(results);
    }
    async get(force) {
        return Promise.resolve(this.getMission());
    }
    processData(raw) {
        this.reset();
        if (!raw) return;
        var index = {};
        var array;
        var patterns;
        var mission;
        var KEYCount = 0;
        this.data = {};
        // INDEX
        for(let label in raw){
            this.state[label] = 0;
            this.randomCategory.push(label);
            array = raw[label];
            index[label] = [];
            for(let n in array){
                mission = array[n];
                mission.key = mission.key || "Mi" + KEYCount++;
                this.data[mission.key] = mission;
                mission.pos = parseInt(n);
                if (!index[label][mission.index]) index[label][mission.index] = [];
                index[label][mission.index].push(mission);
                this.length++;
            }
        }
        // MISSION PROGRESSION 
        for(let label in index){
            let category = index[label];
            let progression = this.missionCues[label] = new (0, $940f063abf4936c1$export$2e2bcd8739ae039)("linear", category.length);
            patterns = progression.patterns.data;
            for(let n = 0; n < category.length; n++){
                var item = category[n];
                patterns["linear" + n].push(item);
                patterns["linear" + n].isRandom = label != "FTUE";
            }
            // Endless mixes the last two levels of difficulty
            var a = (0, $1a1d551abb85861f$export$2e2bcd8739ae039).copy(category[category.length - 1]);
            var b = (0, $1a1d551abb85861f$export$2e2bcd8739ae039).copy(category[category.length - 2] || a);
            patterns.endless.push((0, $1a1d551abb85861f$export$2e2bcd8739ae039).push(a, b));
        }
        let state = this.state;
        (0, $1a1d551abb85861f$export$2e2bcd8739ae039).extract(this.gameInstance.Data.data[this.stateID], state);
        this.progression.getPosition(state.progression);
        for(let category in this.missionCues)if (state[category]) this.missionCues[category].getPosition(state[category]);
        return this.getMission();
    }
    getMission() {
        if (!this.length) return null;
        // log("====== GET MISSION" );
        if (!this.state.progression) //log( "no progression" );
        return this.setMission(this.getCategoryMission(this.progression.get()));
        if (!this.state.active.length) //log( "no active missions" );
        return this.setMission(this.getCategoryMission(this.progression.get()));
        // log( "has active missions" );
        for(let n in this.state.active)return this.setMission(this.data[this.state.active[n]]);
    }
    setMission(missionVars) {
        if (!missionVars) {
            this.reset();
            return this.getMission();
        }
        let key = missionVars.key;
        if (this.items[key]) return this.items[key];
        let mission = this.items[key] = new (0, $6226783f5202600d$export$2e2bcd8739ae039)(this.gameInstance, missionVars);
        if (!this.state.active.includes(key)) {
            this.state.active.push(key);
            this.save();
        }
        this.gameInstance.Signal.set("MISSION:onSet", mission);
        return mission;
    }
    getCategoryMission(category) {
        //if( ( category == "Purchase" || category == "CoinSpend" ) && !INVENTORY.hasAvailable() ) return getCategoryMission( randomCategory.get() );
        //if( category == "WinGames" && !CONFIG.GAME.SCORING.canWinGame ) return getCategoryMission( "PlayGames" ); 
        if (this.missionCues[category]) return this.missionCues[category].get();
        if (category == "ScoreTime") return this.getReplacement([
            "GameActivityTime",
            "Score",
            "GameActivity"
        ]);
        if (category == "GameActivityTime") return this.getReplacement([
            "ScoreTime",
            "GameActivity",
            "Score"
        ]);
        if (category == "GameActivity") return this.getReplacement([
            "GameActivityTime",
            "ScoreTime",
            "Score"
        ]);
        return this.getCategoryMission(this.randomCategory.get());
    }
    getReplacement(array) {
        for(var n in array)if (this.missionCues[array[n]]) return this.getCategoryMission(array[n]);
        return this.getCategoryMission(this.randomCategory.get());
    }
    save() {
        this.state.progression = this.progression.position;
        for(let category in this.missionCues)this.state[category] = this.missionCues[category].position;
        this.gameInstance.Data.set(this.stateID, this.state);
    }
    reset() {
        for(let n in this.items)this.items[n].disable();
        this.items = {};
        this.state = {
            progression: 0,
            active: []
        };
        this.progression.reset();
        for(let category in this.missionCues)this.missionCues[category].reset();
    }
    remove(missionKey) {
        if (!this.items[missionKey]) return;
        let mission = this.items[missionKey];
        delete this.items[missionKey];
        if (mission) mission.remove();
        if (!this.state.active.includes(missionKey)) return;
        (0, $1a1d551abb85861f$export$2e2bcd8739ae039).removeItem(this.state.active, missionKey);
        this.save();
    }
    constructor(gameInstance){
        this.randomCategory = new (0, $1a25aa5249685cf1$export$2e2bcd8739ae039)(true);
        this.missionCues = {};
        this.progression = new (0, $940f063abf4936c1$export$2e2bcd8739ae039)("linear", 6);
        this.state = {
            progression: 0,
            active: []
        };
        this.stateID = "Missions";
        this.items = {};
        this.length = 0;
        this.gameInstance = gameInstance;
        this.conquer = gameInstance.conquer;
        let data = this.progression.patterns.data;
        data.linear0.push([
            "FTUE",
            "FTUE",
            "FTUE"
        ]);
        data.linear1.push([
            "Score",
            "GameAction",
            "GameAction"
        ]); //PlayWithFriend
        data.linear2.push([
            "GameActionTime",
            "CoinEarn",
            "Purchase"
        ]);
        data.linear3.push([
            "ScoreTime",
            "GameAction",
            "WinGames"
        ]);
        data.linear4.push([
            "GameAction",
            "GameActionTime",
            "WinGames"
        ]);
        data.linear5.push([
            "Score",
            "ScoreTime",
            "GameAction"
        ]); //PlayWithFriend
        data.endless.push([
            "GameAction",
            "GameActionTime",
            "GameAction",
            "Score",
            "ScoreTime",
            "Score",
            "GameAction",
            "GameAction",
            "ScoreTime",
            "CoinEarn",
            "Purchase",
            "PlayGames",
            "WinGames",
            "Survive"
        ]); //"PlayWithFriend", "PlayWithFriend",
    }
}
var $90b62abbacf3d7e8$export$2e2bcd8739ae039 = $90b62abbacf3d7e8$var$Missions;




class $3095236df304579a$var$MessageItem {
    async remove() {
        await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_MESSAGES_REMOVE, {
            _id: this.messageID
        });
        return Promise.resolve();
    }
    async setRead() {
        this.isRead = true;
        await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_MESSAGES_CHANGE, {
            where: {
                _id: this.messageID
            },
            values: {
                isRead: true
            }
        });
        return Promise.resolve();
    }
    async setConsumed() {
        this.isConsumed = true;
        await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_MESSAGES_CHANGE, {
            where: {
                _id: this.messageID
            },
            values: {
                isConsumed: true
            }
        });
        return Promise.resolve();
    }
    async setReplied() {
        this.isReplied = true;
        await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_MESSAGES_CHANGE, {
            where: {
                _id: this.messageID
            },
            values: {
                isReplied: true
            }
        });
        return Promise.resolve();
    }
    constructor(Messages, vars){
        this.Messages = Messages;
        this.conquer = Messages.conquer;
        this.messageID = vars._id;
        this.fromAvatarID = vars.fromAvatarID;
        this.toAvatarID = vars.toAvatarID;
        this.avatarID = vars.fromAvatarID;
        this.data = vars.data || {};
        this.type = this.data.type || "Message";
        this.timestamp = vars.timestamp;
        this.isRead = vars.isRead || false;
        this.isConsumed = vars.isConsumed || false;
        this.isReplied = vars.isReplied || false;
        let self = this;
        this.Messages.conquer.Avatars.get(this.fromAvatarID).then(function(Avatar) {
            self.fullName = Avatar.fullName;
            self.userPhoto = Avatar.userPhoto;
        });
    }
}
var $3095236df304579a$export$2e2bcd8739ae039 = $3095236df304579a$var$MessageItem;



class $469ca4c8ced07ee3$var$Messages {
    init() {
        this.gameID = this.gameInstance.gameID;
        this.fromAvatarID = this.conquer.Avatars.ME.avatarID;
    }
    async set(toAvatarID, data, fromAvatarID) {
        if (!data.type) data.type = "Message";
        let result = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_MESSAGES_SET, {
            gameID: this.gameID,
            fromAvatarID: fromAvatarID || this.fromAvatarID,
            toAvatarID: toAvatarID,
            data: data
        });
        return Promise.resolve(new (0, $3095236df304579a$export$2e2bcd8739ae039)(this, result));
    }
    async get() {
        let results = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_MESSAGES_GET, {
            gameID: this.gameID,
            toAvatarID: this.fromAvatarID
        });
        return Promise.resolve(this.processData(results));
    }
    getTab(type) {
        if (!this.tabs[type]) this.tabs[type] = [];
        return this.tabs[type];
    }
    processData(messagesData) {
        this.tabs = {};
        this.items = {};
        for(let n in messagesData){
            let messageItem = new (0, $3095236df304579a$export$2e2bcd8739ae039)(this, messagesData[n]);
            this.getTab(messageItem.type).push(messageItem);
        }
        return this.tabs;
    }
    remove(messageItem) {
        if (this.tabs[messageItem.type]) (0, $1a1d551abb85861f$export$2e2bcd8739ae039).removeItem(this.tabs[messageItem.type], messageItem);
    }
    constructor(gameInstance){
        this.gameInstance = gameInstance;
        this.conquer = gameInstance.conquer;
    }
}
var $469ca4c8ced07ee3$export$2e2bcd8739ae039 = $469ca4c8ced07ee3$var$Messages;




class $f44035dfced7d796$var$QuestItem {
    refresh() {
        this.isConsumed = this.gameInstance.Quest.state[this.saveKey];
        this.isLocked = this.isConsumed || this.unlocksAt > this.gameInstance.Quest.state.progression;
        return this.isLocked ? 0 : 1;
    }
    get() {
        if (this.isLocked) return;
        this.isConsumed = this.gameInstance.Quest.state[this.saveKey] = true;
        this.gameInstance.Quest.save();
        return this.shopItem.set(true);
    }
    constructor(vars, isPremium){
        this.isLocked = true;
        this.isConsumed = false;
        this.gameInstance = vars.gameInstance;
        this.unlocksAt = vars.unlocksAt;
        this.key = vars.key;
        this.isPremium = isPremium;
        this.saveKey = (isPremium ? "P" : "F") + this.unlocksAt;
        this.shopItem = this.gameInstance.Shop.items[this.key];
    }
}
var $f44035dfced7d796$export$2e2bcd8739ae039 = $f44035dfced7d796$var$QuestItem;


class $0b852d546d6deb1e$var$Quest {
    get() {
        let state = this.state = this.gameInstance.Data.data[this.key] || {};
        if (!state.startTime) return this.reset();
        //log("GOT QUEST" );
        // items
        let keys = [
            "Loot_Common",
            "Energy20",
            "Loot_Rare",
            "Coin3K",
            "Loot_Epic",
            "Coin5K",
            "Loot_Legendary"
        ];
        this.items = [];
        for(let n = 0; n < 7; n++){
            let vars = {
                gameInstance: this.gameInstance,
                key: keys[n],
                unlocksAt: n * 3
            };
            this.items.push({
                id: n + 1,
                unlocksAt: vars.unlocksAt,
                Free: new (0, $f44035dfced7d796$export$2e2bcd8739ae039)(vars, false),
                Premium: new (0, $f44035dfced7d796$export$2e2bcd8739ae039)(vars, true)
            });
        }
        this.Timer.start({
            duration: state.endTime - state.startTime
        });
        this.save();
    }
    increase() {
        this.state.progression++;
        this.save();
    }
    refresh() {
        let collectable = 0;
        let current = 0;
        for(let n = 0; n < this.items.length; n++){
            let tier = this.items[n];
            tier.isLocked = tier.unlocksAt > this.state.progression;
            if (!tier.isLocked) current = n;
            delete tier.isCurrent;
            collectable += tier.Free.refresh();
            collectable += tier.Premium.refresh();
        }
        this.items[current].isCurrent = true;
        this.gameInstance.Data.display("QuestCollectable", collectable);
        this.gameInstance.Signal.set("Quest:onRefresh", true);
    }
    save() {
        this.refresh();
        this.gameInstance.Data.set(this.key, this.state);
        this.gameInstance.Signal.set("Quest:onRefresh", true);
    }
    reset() {
        //log("RESET QUEST" );
        let startTime = (0, $445b61b73b0f5f22$export$2e2bcd8739ae039).now();
        this.state = this.gameInstance.Data.data[this.key] = {
            startTime: startTime,
            endTime: startTime + 604800000,
            progression: 0
        };
        return this.get();
    }
    constructor(gameInstance){
        this.key = "$Quest";
        this.items = [];
        this.gameInstance = gameInstance;
        this.conquer = gameInstance.conquer;
        let self = this;
        this.Timer = new (0, $5d84fedb9ac830c7$export$2e2bcd8739ae039)({
            id: "QuestTimer",
            Signal: this.gameInstance.Signal,
            onTimeUp: function() {
                self.reset();
            }
        });
    }
}
var $0b852d546d6deb1e$export$2e2bcd8739ae039 = $0b852d546d6deb1e$var$Quest;




class $0c8165dc5cf1d284$var$Rivals {
    async init() {
        // let timed = LOG.timer(); 
        let bots = await this.conquer.Bots.get();
        //  log("Rival GOT BOTS", timed() );
        this.botsCue.copy(bots);
        // timed = LOG.timer();
        let friends = await this.conquer.Friends.get();
        // log("Rival GOT FRIENDS", timed() );
        for(let n in friends)this.friendCue.push(friends[n].avatarInstance);
        return Promise.resolve();
    }
    /*=============== 


  GET


  ================*/ get(amount = 1) {
        // TODO: matchmaking, balance friends and strangers
        let output = [];
        /* // disable matching with friends for now
    
    while( output.length < amount )
    {
      let friend = this.friendCue.get();

      if( !friend || output.includes( friend ) ) break;

      output.push( friend );
    }*/ while(output.length < amount)(0, $1a1d551abb85861f$export$2e2bcd8739ae039).pushUnique(output, this.botsCue.get());
        return output;
    }
    getNext() {
        // TODO: matchmaking, balance friends and strangers
        // Note, cue.getNext will be empty when it reaches the end of the cue
        if (++this.counter > 3) this.counter = 0;
        if (!this.counter) return null;
        return this.friendCue.getNext() || this.botsCue.getNext();
    }
    /*=============== 


  SET
 

  ================*/ set(avatarID, data) {
        if (this.RIVAL && avatarID == this.RIVAL.avatarID) return this.RIVAL;
        let avatarInstance;
        if (!avatarID) avatarInstance = this.get()[0];
        else avatarInstance = this.conquer.Avatars.data[avatarID];
        this.RIVAL = avatarInstance;
        return this.RIVAL;
    }
    /*=============== 


  REMOVE
 

  ================*/ remove() {
        this.RIVAL = null;
    }
    getRival() {
        return this.RIVAL || this.set();
    }
    constructor(gameInstance){
        this.friendCue = new (0, $1a25aa5249685cf1$export$2e2bcd8739ae039)(true);
        this.botsCue = new (0, $1a25aa5249685cf1$export$2e2bcd8739ae039)(true);
        this.counter = 0;
        this.gameInstance = gameInstance;
        this.conquer = gameInstance.conquer;
    }
}
var $0c8165dc5cf1d284$export$2e2bcd8739ae039 = $0c8165dc5cf1d284$var$Rivals;



class $136f9b8eb51d2a81$var$Players {
    /*=============== 


  GET


  ================*/ get(amount = 1) {
        if (this.items) return this.items;
        this.items = [
            this.conquer.Avatars.ME
        ];
        this.items = (0, $1a1d551abb85861f$export$2e2bcd8739ae039).shuffle((0, $1a1d551abb85861f$export$2e2bcd8739ae039).push(this.gameInstance.Rivals.get(amount - 1), this.items));
        this.current = -1;
        this.currentAvatarID = null;
        return this.items;
    }
    /*=============== 


  NEXT


  ================*/ next() {
        if (!this.items) this.get();
        if (++this.current >= this.items.length) this.current = 0;
        let Avatar = this.items[this.current];
        this.currentAvatarID = Avatar.avatarID;
        this.gameInstance.Signal.set("PLAYERS:onNext", Avatar);
        return Avatar;
    }
    /*=============== 


  GET


  ================*/ set(player) {}
    /*=============== 


  REMOVE
 

  ================*/ remove() {}
    reset() {
        this.items = null;
    }
    constructor(gameInstance){
        this.current = 0;
        this.gameInstance = gameInstance;
        this.conquer = gameInstance.conquer;
    }
}
var $136f9b8eb51d2a81$export$2e2bcd8739ae039 = $136f9b8eb51d2a81$var$Players;



var $41Zxr = parcelRequire("41Zxr");

class $21b0104b46318e81$var$UserXP {
    get() {
        this.value = this.gameInstance.Data.data[this.varName] || 0;
        this.refresh();
        this.gameInstance.Data.set("userLevel", this.level);
        return this.level;
    }
    increase(amount = 1) {
        this.value = (0, $41Zxr.default).clamp(this.value + amount, this.maxValue);
        var lastlevel = this.level;
        this.gameInstance.Data.set(this.varName, this.value);
        this.get();
        if (lastlevel <= this.level) this.gameInstance.Data.display("onLevelUp", 1);
        return this.level;
    }
    decrease(amount = 1) {
        return this.increase(-1);
    }
    refresh() {
        this.isComplete = false;
        this.level = 0;
        let table = this.levelUpTable;
        for(let n = 0; n < table.length; n++){
            var max = table[n];
            if (this.value >= max) continue;
            if (this.value < max) {
                this.level = n;
                this.nextLevel = this.level + 1;
                this.max = max;
                this.min = table[n - 1] || 0;
                this.rank = (0, $1a1d551abb85861f$export$2e2bcd8739ae039).getWithin(this.rankNames, this.level);
                this.isFull = this.value === max;
                if (this.level >= this.maxLevel) this.setMax();
                return;
            }
        }
        this.setMax();
    }
    setMax() {
        this.level = this.maxLevel;
        this.nextLevel = this.level;
        this.isComplete = true;
        this.rank = (0, $1a1d551abb85861f$export$2e2bcd8739ae039).lastItem(this.rankNames);
    }
    reset() {
        this.value = this.gameInstance.Data.set(this.varName, 0);
        this.refresh();
    }
    constructor(gameInstance){
        this.rankNames = [
            "Newbie",
            "Amateur",
            "Rookie",
            "Apprentice",
            "Trainee",
            "Athlete",
            "Semi Pro",
            "Professional",
            "Rockstar",
            "Master",
            "Conquerer",
            "Legendary",
            "Demigod",
            "Invincible"
        ];
        this.maxLevel = 7;
        this.levelUpTable = [
            1,
            5,
            150,
            500,
            1000,
            2000,
            3000,
            4000
        ];
        this.level = 0;
        this.varName = "userXP";
        this.rank = "";
        this.isComplete = false;
        this.value = 0;
        this.nextLevel = 0;
        this.max = 0;
        this.min = 0;
        this.isFull = false;
        this.maxValue = (0, $1a1d551abb85861f$export$2e2bcd8739ae039).lastItem(this.levelUpTable);
        this.gameInstance = gameInstance;
        this.conquer = gameInstance.conquer;
        this.query = {
            gameID: gameInstance.gameID
        };
    }
}
var $21b0104b46318e81$export$2e2bcd8739ae039 = $21b0104b46318e81$var$UserXP;






class $d5f62521bbe9a265$var$GameInstance {
    loadConfig(vars) {
        (0, $1a1d551abb85861f$export$2e2bcd8739ae039).extract(vars, this.CONFIG);
        this.Lives.setConfig(this.CONFIG.LIVES);
    }
    async init() {
        let vars = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_GETONE, {
            gameKey: this.gameKey
        });
        this.gameID = vars.game._id;
        //log("GOT GAME", this.gameID );
        this.Rivals.init();
        this.Data.init(vars.data);
        this.Shop.init(vars.shop);
        this.Wallet.init(vars.wallet);
        this.Scoreboard.init();
        this.Missions.init(vars.missions);
        this.Messages.init();
        this.Inventory.get(true);
        this.Quest.get();
        this.UserXP.get();
        //log("==GAME:onInit");
        this.Signal.set("GAME:onInit");
    }
    /*==========================






    GAME 






    ===========================*/ play() {
        //log("==GAME: Play");
        this.reset();
        this.isActive = true;
        this.isAlive = true;
        if (this.CONFIG.MULTIPLAYER.maxPlayers === 2) this.Rivals.getRival();
        this.Analytics.onPlay(this.Score.permanentMultiplier > 1);
        this.Signal.set("GAME:onPlay");
    }
    ready() {
        //log("==GAME: Ready");
        this.Analytics.onGameReady();
        this.Signal.set("GAME:onReady");
    }
    start() {
        //log("==GAME: Start", this.isStarted );
        if (this.isStarted) return;
        this.isStarted = true;
        this.didStart = false;
        let self = this;
        this.Signal.set("GAME:onReveal");
        if (!this.CONFIG.TIME.countDown) return this.doStart();
        this.Signal.set("GAME:onStartCountDown");
        this.Timer.start({
            seconds: 3,
            onTimeUp: function() {
                self.doStart();
            }
        });
    }
    doStart() {
        //log("==GAME: Do Start", this.didStart );
        if (this.didStart) return;
        this.didStart = true;
        this.Analytics.onGameStart();
        this.Signal.set("GAME:onStart");
        this.startTime = (0, $445b61b73b0f5f22$export$2e2bcd8739ae039).now();
        this.startTimer(this.CONFIG.TIME.duration);
    }
    startTimer(seconds) {
        //log("== startTimer", seconds );
        if (!seconds) return;
        let self = this;
        this.Timer.start({
            seconds: seconds,
            onTimeUp: function() {
                self.timeUp();
            }
        });
    }
    pause() {
        this.Signal.set("GAME:onPause");
        if (this.CONFIG.globalPause) return;
        this.Timer.pause();
        this.isPaused = true;
    }
    resume() {
        if (!this.isAlive) return;
        this.Timer.resume();
        this.isPaused = false;
        this.Signal.set("GAME:onResume");
    }
    kill() {
        if (this.CONFIG.DEBUG.invulnerable || !this.isAlive) return;
        this.Lives.set(0);
        this.die();
    }
    die() {
        if (this.CONFIG.DEBUG.invulnerable || !this.isAlive) return;
        //log("==GAME: Die", this.isAlive );
        let lives = this.Lives.decrease();
        if (lives > 0) return;
        this.isAlive = false;
        this.Analytics.onDie();
        if (!this.CONFIG.LIVES.revive || this.usedRevive) return this.end(); //|| this.conquer.Ads.loadedNetwork != 'None'
        this.conquer.Haptic.long();
        this.pause();
        this.Signal.set("GAME:onDie");
    }
    timeUp() {
        //log("GAME:time up!");
        if (this.CONFIG.DEBUG.invulnerable) return;
        this.isAlive = false;
        //log("==GAME:TimeUp", this.CONFIG.TIME.extraTime, this.usedExtraTime );
        if (!this.CONFIG.TIME.extraTime || this.usedExtraTime) return this.end(); //|| this.conquer.Ads.loadedNetwork != 'None'
        this.conquer.Haptic.long();
        this.pause();
        this.Analytics.onTimeUp();
        //log("BEFORE ONTIMEUP EVENT");
        this.Signal.set("GAME:onTimeUp");
    }
    onExtraTime(boolean, extraTime) {
        extraTime = extraTime || this.CONFIG.TIME.extraTime;
        //log("== ON EXTRA TIME", boolean, extraTime );
        if (!boolean) return this.end();
        this.startTimer(extraTime);
        this.usedExtraTime = true;
        this.onContinue();
    }
    onRevive(boolean) {
        //log("==GAME onRevive", boolean );
        if (!boolean) return this.end();
        this.Lives.reset();
        this.usedRevive = true;
        this.onContinue();
    }
    onContinue() {
        //log("==GAME onContinue" );
        this.isAlive = true;
        this.Analytics.onContinue();
        this.Signal.set("GAME:onContinue");
        this.resume();
    }
    end() {
        //log("== GAME END!");
        this.isAlive = false;
        this.Data.increaseTotal("GamesPlayed");
        this.Timer.stop();
        this.UserXP.increase();
        this.conquer.Haptic.long();
        this.Analytics.onGameOver((0, $445b61b73b0f5f22$export$2e2bcd8739ae039).now() - this.startTime);
        //log("GAME END! Before event");
        this.Signal.set("GAME:onEnd");
    }
    over() {
        //log("Game over, Score to coins", this.CONFIG.SCORING.scoreToCoins );
        this.Signal.set("PlayGames");
        this.Score.toCoins(this.CONFIG.SCORING.scoreToCoins);
        this.Score.save();
        this.Signal.set("GAME:onOver");
    }
    reset() {
        this.Timer.stop();
        this.Score.reset();
        this.Coins.reset();
        this.Lives.reset();
        this.usedRevive = false;
        this.usedExtraTime = false;
        this.isPaused = false;
        this.isStarted = false;
        this.isActive = false;
        this.isStarted = false;
        this.didStart = false;
        this.isAlive = true;
    }
    exit() {
        if (!this.isActive) return;
        //log("GAME:onExit");
        this.isActive = false;
        this.Analytics.onGameExit();
        this.Score.setPermanentMultiplier();
        this.Coins.setPermanentMultiplier();
        this.Timer.stop();
        this.Signal.set("GAME:onExit");
    }
    constructor(conquer, gameKey){
        this.CONFIG = {
            MULTIPLAYER: {},
            SCORING: {},
            TIME: {},
            LIVES: {
                value: 1,
                max: 1
            },
            DEBUG: {}
        };
        this.isActive = false;
        this.isPaused = false;
        this.usedRevive = false;
        this.usedExtraTime = false;
        this.startTime = 0;
        this.isAlive = false;
        this.isStarted = false;
        this.didStart = false;
        this.conquer = conquer;
        this.gameKey = gameKey;
        this.Score = new (0, $286099c459260b30$export$2e2bcd8739ae039)(this);
        this.Scoreboard = new (0, $28e012825c0e9d9c$export$2e2bcd8739ae039)(this);
        this.Coins = new (0, $1f19a55e97c24865$export$2e2bcd8739ae039)(this);
        this.Turns = new (0, $43a92ea5d5d1d467$export$2e2bcd8739ae039)(this);
        this.Lives = new (0, $a6cea0b41372589b$export$2e2bcd8739ae039)(this);
        this.Shop = new (0, $cb11298ca1f23cf9$export$2e2bcd8739ae039)(this);
        this.Wallet = new (0, $7f36d504609ce4f9$export$2e2bcd8739ae039)(this);
        this.Inventory = new (0, $0a0379c8e5ff6401$export$2e2bcd8739ae039)(this);
        this.DailyRewards = new (0, $289f8029d07a2643$export$2e2bcd8739ae039)(this);
        this.Data = new (0, $7e2be98449edb176$export$2e2bcd8739ae039)(this);
        this.Analytics = new (0, $e622fd15d82ead87$export$2e2bcd8739ae039)(this);
        this.Signal = new (0, $252326b9bdba11b6$export$2e2bcd8739ae039)();
        this.Missions = new (0, $90b62abbacf3d7e8$export$2e2bcd8739ae039)(this);
        this.Rivals = new (0, $0c8165dc5cf1d284$export$2e2bcd8739ae039)(this);
        this.Players = new (0, $136f9b8eb51d2a81$export$2e2bcd8739ae039)(this);
        this.Room = new (0, $773044369c5cd207$export$2e2bcd8739ae039)(conquer, {
            gameKey: this.gameKey
        });
        this.UserXP = new (0, $21b0104b46318e81$export$2e2bcd8739ae039)(this);
        this.Quest = new (0, $0b852d546d6deb1e$export$2e2bcd8739ae039)(this);
        this.Messages = new (0, $469ca4c8ced07ee3$export$2e2bcd8739ae039)(this);
        this.Timer = new (0, $5d84fedb9ac830c7$export$2e2bcd8739ae039)({
            id: "GAMETIMER",
            sound: "Alarm",
            autoStart: false,
            onSecond: true,
            Signal: this.Signal
        });
    }
}
var $d5f62521bbe9a265$export$2e2bcd8739ae039 = $d5f62521bbe9a265$var$GameInstance;


class $f867a28506ed87e3$var$Games {
    async get() {
        // Move the builder stuff here 
        let games = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_GET, {
            isPublic: true
        });
        return Promise.resolve(games);
    }
    /*=============== 


    GET
    

    ================*/ async getOne(gameKey) {
        this.Game = new (0, $d5f62521bbe9a265$export$2e2bcd8739ae039)(this.conquer, gameKey);
        return this.refresh();
    }
    async getData(gameKey) {
        let game = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_GETDATA, {
            gameKey: gameKey
        });
        return Promise.resolve(game);
    }
    async refresh() {
        if (!this.Game) return Promise.resolve();
        await this.Game.init();
        return Promise.resolve(this.Game);
    }
    async set(params) {
        return await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).GAME_SET, params);
    }
    constructor(instance){
        this.conquer = instance;
    }
}
var $f867a28506ed87e3$export$2e2bcd8739ae039 = $f867a28506ed87e3$var$Games;





class $27f7b20e8ddd8f8c$var$Awesome {
    /*=============== 
 
    GET  
    {
         
    }

    ================*/ async get() {
        let entry = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).JUDGEMENT_GETONE, {
            postID: this.postInstance.postID
        });
        if (entry) this.value = entry.value;
        return Promise.resolve();
    }
    /*=============== 
 
    SET  
    {
        awesome : -1, 0, 1
    }

    ================*/ async set(value) {
        await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).JUDGEMENT_SET, {
            postID: this.postInstance.postID,
            value: value
        });
        await this.postInstance.refresh();
        this.value = value;
        return Promise.resolve();
    }
    async positive() {
        if (this.value == 1) return Promise.resolve();
        return this.set(1);
    }
    async negative() {
        if (this.value == -1) Promise.resolve();
        return this.set(-1);
    }
    async remove() {
        return this.set(0);
    }
    constructor(instance, postInstance){
        this.value = 0;
        this.conquer = instance;
        this.postInstance = postInstance;
    }
}
var $27f7b20e8ddd8f8c$export$2e2bcd8739ae039 = $27f7b20e8ddd8f8c$var$Awesome;



class $02e4a608fb1c486d$var$PostInstance {
    fill(data) {
        this.data = data;
        this.postID = data._id;
        this.text = data.text;
        this.image = data.image;
        this.video = data.video;
        this.title = data.title;
        this.replyToID = data.replyToID;
        this.quoteID = data.quoteID;
        this.avatarID = data.text;
        this.isReply = data.isReply;
        this.positive = data.positive;
        this.negative = data.negative;
    /*
        
        this.Avatar 

        this.conquer.Avatars.load( this.avatarID, function( Avatar:any )
        {
            self.avatarID = Avatar;
        })
        */ }
    async refresh() {
        let data = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).POST_GETONE, {
            _id: this.postID
        });
        this.fill(data);
        return Promise.resolve();
    }
    constructor(conquer, data){
        this.isReply = false;
        this.views = 0;
        this.positive = 0;
        this.negative = 0;
        this.conquer = conquer;
        this.fill(data);
        this.Judgement = new (0, $27f7b20e8ddd8f8c$export$2e2bcd8739ae039)(this.conquer, this);
        // this.Stats      = new Stats( conquer, this.postID );
        let self = this;
    }
}
var $02e4a608fb1c486d$export$2e2bcd8739ae039 = $02e4a608fb1c486d$var$PostInstance;




class $7de8aa751de22f76$var$FollowerInstance {
    fill(vars) {
        this.avatarID = vars.avatarID || this.avatarID;
        this.fullName = vars.fullName || this.fullName;
        this.userPhoto = vars.userPhoto || this.userPhoto;
        this.refresh(vars);
    }
    async get() {
        let data = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).FOLLOWERS_GETONE);
        this.refresh(data);
        return Promise.resolve();
    }
    refresh(data) {
        this.membershipID = null;
        this.status = null;
        if (!data) return;
        this.membershipID = data._id;
        this.status = data.status;
    }
    async set() {
        if (this.membershipID) return Promise.resolve();
        let membership = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).FOLLOWERS_SET, {
            graphID: this.feedInstance.feedID
        });
        this.refresh(membership);
        return Promise.resolve();
    }
    remove() {
        if (!this.membershipID) return;
        this.refresh();
        this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).FOLLOWERS_REMOVE, {
            graphID: this.feedInstance.feedID
        });
    }
    constructor(conquer, feedInstance, vars){
        this.conquer = conquer;
        this.feedInstance = feedInstance;
        this.fill(vars);
    }
}
var $7de8aa751de22f76$export$2e2bcd8739ae039 = $7de8aa751de22f76$var$FollowerInstance;


class $755935a2965bba76$var$Followers {
    /*=============== 


    GET
    

    ================*/ async getMine() {
        this.Membership = new (0, $7de8aa751de22f76$export$2e2bcd8739ae039)(this.conquer, this.feedInstance, this.conquer.Avatars.ME);
        await this.Membership.get();
        return Promise.resolve();
    }
    async get(force) // pagination needed
    {
        if (this.pool.length && !force) return Promise.resolve(this.pool);
        let array = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).FOLLOWERS_GET, {
            _id: this.feedInstance.feedID
        });
        this.pool = [];
        for(var n in array)this.pool.push(new (0, $7de8aa751de22f76$export$2e2bcd8739ae039)(this.conquer, this.feedInstance, array[n]));
        return Promise.resolve(this.pool);
    }
    /*=============== 


    SET
    

    ================*/ async set() {
        var friendship = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).FOLLOWERS_SET, {
            _id: this.feedInstance.feedID
        });
        return Promise.resolve(friendship);
    }
    async remove() {
        var friendship = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).FOLLOWERS_REMOVE, {
            graphID: this.feedInstance.feedID
        });
        return Promise.resolve(friendship);
    }
    constructor(instance, feedInstance){
        this.pool = [];
        this.conquer = instance;
        this.feedInstance = feedInstance;
        this.getMine();
    }
}
var $755935a2965bba76$export$2e2bcd8739ae039 = $755935a2965bba76$var$Followers;


class $a5b24411f3ea1690$var$FeedInstance {
    async get() // pagination
    {
        let search = {
            type: this.type,
            memberIDs: this.memberIDs,
            searchParams: this.searchParams,
            tags: this.tags
        };
        let data = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).POST_GET, {
            search: search
        });
        for(let n in data)this.posts.push(new (0, $02e4a608fb1c486d$export$2e2bcd8739ae039)(this.conquer, data[n]));
        return Promise.resolve(this.posts);
    }
    constructor(conquer, data){
        this.memberIDs = [];
        this.tags = [];
        this.searchParams = false;
        this.posts = [];
        this.followers = 0;
        this.conquer = conquer;
        this.type = data.type || "posts";
        this.memberIDs = data.memberIDs || [];
        this.tags = data.tags || [];
        this.searchParams = data.searchParams || false;
        this.posts = data.posts || [];
        this.followers = data.followers || 0;
        this.Followers = new (0, $755935a2965bba76$export$2e2bcd8739ae039)(this.conquer, this);
    }
}
var $a5b24411f3ea1690$export$2e2bcd8739ae039 = $a5b24411f3ea1690$var$FeedInstance;


class $a157c951bba1f79d$var$Feeds {
    async get(vars) {
        let data = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).FEED_GET, vars);
        for(let n in data)new (0, $a5b24411f3ea1690$export$2e2bcd8739ae039)(this.conquer, data[n]);
        return Promise.resolve();
    }
    async getOne(vars) {
        vars = vars || {};
        if (!vars.ownerID) vars.ownerID = this.conquer.Avatars.ME.avatarID;
        if (!vars.type) vars.type = "posts";
        let data = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).FEED_GETONE, vars);
        if (!data) return Promise.resolve(null);
        let feed = new (0, $a5b24411f3ea1690$export$2e2bcd8739ae039)(this.conquer, data);
        return Promise.resolve(feed);
    }
    constructor(conquer){
        this.pool = [];
        this.conquer = conquer;
    }
}
var $a157c951bba1f79d$export$2e2bcd8739ae039 = $a157c951bba1f79d$var$Feeds;




class $a78615195800fc83$var$WalletAssets {
    async get() {
        let result = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).WALLET_HISTORY_GET);
        return Promise.resolve(result);
    }
    constructor(conquer){
        this.conquer = conquer;
    }
}
var $a78615195800fc83$export$2e2bcd8739ae039 = $a78615195800fc83$var$WalletAssets;



class $ddfe560866decd95$var$WalletHistory {
    async get() {
        let result = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).WALLET_HISTORY_GET);
        return Promise.resolve(result);
    }
    constructor(conquer){
        this.conquer = conquer;
    }
}
var $ddfe560866decd95$export$2e2bcd8739ae039 = $ddfe560866decd95$var$WalletHistory;


class $de4ca678237bf357$var$WalletInstance {
    async send(recipientAddress, amount) {
        let result = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).WALLET_SEND, {
            recipientAddress: recipientAddress,
            amount: amount
        });
        return Promise.resolve(result);
    }
    constructor(conquer, data){
        this.conquer = conquer;
        this.address = data.address;
        this.balance = data.balance;
        this.History = new (0, $ddfe560866decd95$export$2e2bcd8739ae039)(conquer);
        this.Assets = new (0, $a78615195800fc83$export$2e2bcd8739ae039)(conquer);
    }
}
var $de4ca678237bf357$export$2e2bcd8739ae039 = $de4ca678237bf357$var$WalletInstance;



class $7ef0c20968e9e658$var$Wallets {
    /*=============== 
 
    GET  

    ================*/ async get() {
        let res = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).WALLET_GETSET);
        if (res.success) res.data = new (0, $de4ca678237bf357$export$2e2bcd8739ae039)(this.conquer, res.data);
        return res;
    }
    constructor(conquer){
        this.conquer = conquer;
    }
}
var $7ef0c20968e9e658$export$2e2bcd8739ae039 = $7ef0c20968e9e658$var$Wallets;



var $cc43b7352a965294$export$c9d39ca3bcd93abb;
var $cc43b7352a965294$export$b791fe48eec8032a;
/*!
 *  howler.js v2.2.3
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    "use strict";
    /** Global Methods **/ /***************************************************************************/ /**
   * Create the global controller. All contained methods and properties apply
   * to all sounds that are currently playing or will be in the future.
   */ var HowlerGlobal1 = function() {
        this.init();
    };
    HowlerGlobal1.prototype = {
        /**
     * Initialize the global Howler object.
     * @return {Howler}
     */ init: function() {
            var self = this || Howler1;
            // Create a global ID counter.
            self._counter = 1000;
            // Pool of unlocked HTML5 Audio objects.
            self._html5AudioPool = [];
            self.html5PoolSize = 10;
            // Internal properties.
            self._codecs = {};
            self._howls = [];
            self._muted = false;
            self._volume = 1;
            self._canPlayEvent = "canplaythrough";
            self._navigator = typeof window !== "undefined" && window.navigator ? window.navigator : null;
            // Public properties.
            self.masterGain = null;
            self.noAudio = false;
            self.usingWebAudio = true;
            self.autoSuspend = true;
            self.ctx = null;
            // Set to false to disable the auto audio unlocker.
            self.autoUnlock = true;
            // Setup the various state values for global tracking.
            self._setup();
            return self;
        },
        /**
     * Get/set the global volume for all sounds.
     * @param  {Float} vol Volume from 0.0 to 1.0.
     * @return {Howler/Float}     Returns self or current volume.
     */ volume: function(vol) {
            var self = this || Howler1;
            vol = parseFloat(vol);
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            if (typeof vol !== "undefined" && vol >= 0 && vol <= 1) {
                self._volume = vol;
                // Don't update any of the nodes if we are muted.
                if (self._muted) return self;
                // When using Web Audio, we just need to adjust the master gain.
                if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                // Loop through and change volume for all HTML5 audio nodes.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and change the volumes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node) sound._node.volume = sound._volume * vol;
                    }
                }
                return self;
            }
            return self._volume;
        },
        /**
     * Handle muting and unmuting globally.
     * @param  {Boolean} muted Is muted or not.
     */ mute: function(muted) {
            var self = this || Howler1;
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            self._muted = muted;
            // With Web Audio, we just need to mute the master gain.
            if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(muted ? 0 : self._volume, Howler1.ctx.currentTime);
            // Loop through and mute all HTML5 Audio nodes.
            for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                // Get all of the sounds in this Howl group.
                var ids = self._howls[i]._getSoundIds();
                // Loop through all sounds and mark the audio node as muted.
                for(var j = 0; j < ids.length; j++){
                    var sound = self._howls[i]._soundById(ids[j]);
                    if (sound && sound._node) sound._node.muted = muted ? true : sound._muted;
                }
            }
            return self;
        },
        /**
     * Handle stopping all sounds globally.
     */ stop: function() {
            var self = this || Howler1;
            // Loop through all Howls and stop them.
            for(var i = 0; i < self._howls.length; i++)self._howls[i].stop();
            return self;
        },
        /**
     * Unload and destroy all currently loaded Howl objects.
     * @return {Howler}
     */ unload: function() {
            var self = this || Howler1;
            for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].unload();
            // Create a new AudioContext to make sure it is fully reset.
            if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== "undefined") {
                self.ctx.close();
                self.ctx = null;
                setupAudioContext();
            }
            return self;
        },
        /**
     * Check for codec support of specific extension.
     * @param  {String} ext Audio file extention.
     * @return {Boolean}
     */ codecs: function(ext) {
            return (this || Howler1)._codecs[ext.replace(/^x-/, "")];
        },
        /**
     * Setup various state values for global tracking.
     * @return {Howler}
     */ _setup: function() {
            var self = this || Howler1;
            // Keeps track of the suspend/resume state of the AudioContext.
            self.state = self.ctx ? self.ctx.state || "suspended" : "suspended";
            // Automatically begin the 30-second suspend process
            self._autoSuspend();
            // Check if audio is available.
            if (!self.usingWebAudio) {
                // No audio is available on this system if noAudio is set to true.
                if (typeof Audio !== "undefined") try {
                    var test = new Audio();
                    // Check if the canplaythrough event is available.
                    if (typeof test.oncanplaythrough === "undefined") self._canPlayEvent = "canplay";
                } catch (e) {
                    self.noAudio = true;
                }
                else self.noAudio = true;
            }
            // Test to make sure audio isn't disabled in Internet Explorer.
            try {
                var test = new Audio();
                if (test.muted) self.noAudio = true;
            } catch (e) {}
            // Check for supported codecs.
            if (!self.noAudio) self._setupCodecs();
            return self;
        },
        /**
     * Check for browser support for various codecs and cache the results.
     * @return {Howler}
     */ _setupCodecs: function() {
            var self = this || Howler1;
            var audioTest = null;
            // Must wrap in a try/catch because IE11 in server mode throws an error.
            try {
                audioTest = typeof Audio !== "undefined" ? new Audio() : null;
            } catch (err) {
                return self;
            }
            if (!audioTest || typeof audioTest.canPlayType !== "function") return self;
            var mpegTest = audioTest.canPlayType("audio/mpeg;").replace(/^no$/, "");
            // Opera version <33 has mixed MP3 support, so we need to check for and block it.
            var ua = self._navigator ? self._navigator.userAgent : "";
            var checkOpera = ua.match(/OPR\/([0-6].)/g);
            var isOldOpera = checkOpera && parseInt(checkOpera[0].split("/")[1], 10) < 33;
            var checkSafari = ua.indexOf("Safari") !== -1 && ua.indexOf("Chrome") === -1;
            var safariVersion = ua.match(/Version\/(.*?) /);
            var isOldSafari = checkSafari && safariVersion && parseInt(safariVersion[1], 10) < 15;
            self._codecs = {
                mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType("audio/mp3;").replace(/^no$/, ""))),
                mpeg: !!mpegTest,
                opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ""),
                ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                wav: !!(audioTest.canPlayType('audio/wav; codecs="1"') || audioTest.canPlayType("audio/wav")).replace(/^no$/, ""),
                aac: !!audioTest.canPlayType("audio/aac;").replace(/^no$/, ""),
                caf: !!audioTest.canPlayType("audio/x-caf;").replace(/^no$/, ""),
                m4a: !!(audioTest.canPlayType("audio/x-m4a;") || audioTest.canPlayType("audio/m4a;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                m4b: !!(audioTest.canPlayType("audio/x-m4b;") || audioTest.canPlayType("audio/m4b;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                mp4: !!(audioTest.canPlayType("audio/x-mp4;") || audioTest.canPlayType("audio/mp4;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                weba: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                webm: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ""),
                flac: !!(audioTest.canPlayType("audio/x-flac;") || audioTest.canPlayType("audio/flac;")).replace(/^no$/, "")
            };
            return self;
        },
        /**
     * Some browsers/devices will only allow audio to be played after a user interaction.
     * Attempt to automatically unlock audio on the first user interaction.
     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     * @return {Howler}
     */ _unlockAudio: function() {
            var self = this || Howler1;
            // Only run this if Web Audio is supported and it hasn't already been unlocked.
            if (self._audioUnlocked || !self.ctx) return;
            self._audioUnlocked = false;
            self.autoUnlock = false;
            // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
            // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
            // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
            if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
                self._mobileUnloaded = true;
                self.unload();
            }
            // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
            // http://stackoverflow.com/questions/24119684
            self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);
            // Call this method on touch start to create and play a buffer,
            // then check if the audio actually played to determine if
            // audio has now been unlocked on iOS, Android, etc.
            var unlock = function(e) {
                // Create a pool of unlocked HTML5 Audio objects that can
                // be used for playing sounds without user interaction. HTML5
                // Audio objects must be individually unlocked, as opposed
                // to the WebAudio API which only needs a single activation.
                // This must occur before WebAudio setup or the source.onended
                // event will not fire.
                while(self._html5AudioPool.length < self.html5PoolSize)try {
                    var audioNode = new Audio();
                    // Mark this Audio object as unlocked to ensure it can get returned
                    // to the unlocked pool when released.
                    audioNode._unlocked = true;
                    // Add the audio node to the pool.
                    self._releaseHtml5Audio(audioNode);
                } catch (e) {
                    self.noAudio = true;
                    break;
                }
                // Loop through any assigned audio nodes and unlock them.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and unlock the audio nodes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node && !sound._node._unlocked) {
                            sound._node._unlocked = true;
                            sound._node.load();
                        }
                    }
                }
                // Fix Android can not play in suspend state.
                self._autoResume();
                // Create an empty buffer.
                var source = self.ctx.createBufferSource();
                source.buffer = self._scratchBuffer;
                source.connect(self.ctx.destination);
                // Play the empty buffer.
                if (typeof source.start === "undefined") source.noteOn(0);
                else source.start(0);
                // Calling resume() on a stack initiated by user gesture is what actually unlocks the audio on Android Chrome >= 55.
                if (typeof self.ctx.resume === "function") self.ctx.resume();
                // Setup a timeout to check that we are unlocked on the next event loop.
                source.onended = function() {
                    source.disconnect(0);
                    // Update the unlocked state and prevent this check from happening again.
                    self._audioUnlocked = true;
                    // Remove the touch start listener.
                    document.removeEventListener("touchstart", unlock, true);
                    document.removeEventListener("touchend", unlock, true);
                    document.removeEventListener("click", unlock, true);
                    document.removeEventListener("keydown", unlock, true);
                    // Let all sounds know that audio has been unlocked.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit("unlock");
                };
            };
            // Setup a touch start listener to attempt an unlock in.
            document.addEventListener("touchstart", unlock, true);
            document.addEventListener("touchend", unlock, true);
            document.addEventListener("click", unlock, true);
            document.addEventListener("keydown", unlock, true);
            return self;
        },
        /**
     * Get an unlocked HTML5 Audio object from the pool. If none are left,
     * return a new Audio object and throw a warning.
     * @return {Audio} HTML5 Audio object.
     */ _obtainHtml5Audio: function() {
            var self = this || Howler1;
            // Return the next object from the pool if one exists.
            if (self._html5AudioPool.length) return self._html5AudioPool.pop();
            //.Check if the audio is locked and throw a warning.
            var testPlay = new Audio().play();
            if (testPlay && typeof Promise !== "undefined" && (testPlay instanceof Promise || typeof testPlay.then === "function")) testPlay.catch(function() {
                console.warn("HTML5 Audio pool exhausted, returning potentially locked audio object.");
            });
            return new Audio();
        },
        /**
     * Return an activated HTML5 Audio object to the pool.
     * @return {Howler}
     */ _releaseHtml5Audio: function(audio) {
            var self = this || Howler1;
            // Don't add audio to the pool if we don't know if it has been unlocked.
            if (audio._unlocked) self._html5AudioPool.push(audio);
            return self;
        },
        /**
     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
     * @return {Howler}
     */ _autoSuspend: function() {
            var self = this;
            if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === "undefined" || !Howler1.usingWebAudio) return;
            // Check if any sounds are playing.
            for(var i = 0; i < self._howls.length; i++){
                if (self._howls[i]._webAudio) for(var j = 0; j < self._howls[i]._sounds.length; j++){
                    if (!self._howls[i]._sounds[j]._paused) return self;
                }
            }
            if (self._suspendTimer) clearTimeout(self._suspendTimer);
            // If no sound has played after 30 seconds, suspend the context.
            self._suspendTimer = setTimeout(function() {
                if (!self.autoSuspend) return;
                self._suspendTimer = null;
                self.state = "suspending";
                // Handle updating the state of the audio context after suspending.
                var handleSuspension = function() {
                    self.state = "suspended";
                    if (self._resumeAfterSuspend) {
                        delete self._resumeAfterSuspend;
                        self._autoResume();
                    }
                };
                // Either the state gets suspended or it is interrupted.
                // Either way, we need to update the state to suspended.
                self.ctx.suspend().then(handleSuspension, handleSuspension);
            }, 30000);
            return self;
        },
        /**
     * Automatically resume the Web Audio AudioContext when a new sound is played.
     * @return {Howler}
     */ _autoResume: function() {
            var self = this;
            if (!self.ctx || typeof self.ctx.resume === "undefined" || !Howler1.usingWebAudio) return;
            if (self.state === "running" && self.ctx.state !== "interrupted" && self._suspendTimer) {
                clearTimeout(self._suspendTimer);
                self._suspendTimer = null;
            } else if (self.state === "suspended" || self.state === "running" && self.ctx.state === "interrupted") {
                self.ctx.resume().then(function() {
                    self.state = "running";
                    // Emit to all Howls that the audio has resumed.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit("resume");
                });
                if (self._suspendTimer) {
                    clearTimeout(self._suspendTimer);
                    self._suspendTimer = null;
                }
            } else if (self.state === "suspending") self._resumeAfterSuspend = true;
            return self;
        }
    };
    // Setup the global audio controller.
    var Howler1 = new HowlerGlobal1();
    /** Group Methods **/ /***************************************************************************/ /**
   * Create an audio group controller.
   * @param {Object} o Passed in properties for this group.
   */ var Howl1 = function(o) {
        var self = this;
        // Throw an error if no source is provided.
        if (!o.src || o.src.length === 0) {
            console.error("An array of source files must be passed with any new Howl.");
            return;
        }
        self.init(o);
    };
    Howl1.prototype = {
        /**
     * Initialize a new Howl group object.
     * @param  {Object} o Passed in properties for this group.
     * @return {Howl}
     */ init: function(o) {
            var self = this;
            // If we don't have an AudioContext created yet, run the setup.
            if (!Howler1.ctx) setupAudioContext();
            // Setup user-defined default properties.
            self._autoplay = o.autoplay || false;
            self._format = typeof o.format !== "string" ? o.format : [
                o.format
            ];
            self._html5 = o.html5 || false;
            self._muted = o.mute || false;
            self._loop = o.loop || false;
            self._pool = o.pool || 5;
            self._preload = typeof o.preload === "boolean" || o.preload === "metadata" ? o.preload : true;
            self._rate = o.rate || 1;
            self._sprite = o.sprite || {};
            self._src = typeof o.src !== "string" ? o.src : [
                o.src
            ];
            self._volume = o.volume !== undefined ? o.volume : 1;
            self._xhr = {
                method: o.xhr && o.xhr.method ? o.xhr.method : "GET",
                headers: o.xhr && o.xhr.headers ? o.xhr.headers : null,
                withCredentials: o.xhr && o.xhr.withCredentials ? o.xhr.withCredentials : false
            };
            // Setup all other default properties.
            self._duration = 0;
            self._state = "unloaded";
            self._sounds = [];
            self._endTimers = {};
            self._queue = [];
            self._playLock = false;
            // Setup event listeners.
            self._onend = o.onend ? [
                {
                    fn: o.onend
                }
            ] : [];
            self._onfade = o.onfade ? [
                {
                    fn: o.onfade
                }
            ] : [];
            self._onload = o.onload ? [
                {
                    fn: o.onload
                }
            ] : [];
            self._onloaderror = o.onloaderror ? [
                {
                    fn: o.onloaderror
                }
            ] : [];
            self._onplayerror = o.onplayerror ? [
                {
                    fn: o.onplayerror
                }
            ] : [];
            self._onpause = o.onpause ? [
                {
                    fn: o.onpause
                }
            ] : [];
            self._onplay = o.onplay ? [
                {
                    fn: o.onplay
                }
            ] : [];
            self._onstop = o.onstop ? [
                {
                    fn: o.onstop
                }
            ] : [];
            self._onmute = o.onmute ? [
                {
                    fn: o.onmute
                }
            ] : [];
            self._onvolume = o.onvolume ? [
                {
                    fn: o.onvolume
                }
            ] : [];
            self._onrate = o.onrate ? [
                {
                    fn: o.onrate
                }
            ] : [];
            self._onseek = o.onseek ? [
                {
                    fn: o.onseek
                }
            ] : [];
            self._onunlock = o.onunlock ? [
                {
                    fn: o.onunlock
                }
            ] : [];
            self._onresume = [];
            // Web Audio or HTML5 Audio?
            self._webAudio = Howler1.usingWebAudio && !self._html5;
            // Automatically try to enable audio.
            if (typeof Howler1.ctx !== "undefined" && Howler1.ctx && Howler1.autoUnlock) Howler1._unlockAudio();
            // Keep track of this Howl group in the global controller.
            Howler1._howls.push(self);
            // If they selected autoplay, add a play event to the load queue.
            if (self._autoplay) self._queue.push({
                event: "play",
                action: function() {
                    self.play();
                }
            });
            // Load the source file unless otherwise specified.
            if (self._preload && self._preload !== "none") self.load();
            return self;
        },
        /**
     * Load the audio file.
     * @return {Howler}
     */ load: function() {
            var self = this;
            var url = null;
            // If no audio is available, quit immediately.
            if (Howler1.noAudio) {
                self._emit("loaderror", null, "No audio support.");
                return;
            }
            // Make sure our source is in an array.
            if (typeof self._src === "string") self._src = [
                self._src
            ];
            // Loop through the sources and pick the first one that is compatible.
            for(var i = 0; i < self._src.length; i++){
                var ext, str;
                if (self._format && self._format[i]) // If an extension was specified, use that instead.
                ext = self._format[i];
                else {
                    // Make sure the source is a string.
                    str = self._src[i];
                    if (typeof str !== "string") {
                        self._emit("loaderror", null, "Non-string found in selected audio sources - ignoring.");
                        continue;
                    }
                    // Extract the file extension from the URL or base64 data URI.
                    ext = /^data:audio\/([^;,]+);/i.exec(str);
                    if (!ext) ext = /\.([^.]+)$/.exec(str.split("?", 1)[0]);
                    if (ext) ext = ext[1].toLowerCase();
                }
                // Log a warning if no extension was found.
                if (!ext) console.warn('No file extension was found. Consider using the "format" property or specify an extension.');
                // Check if this extension is available.
                if (ext && Howler1.codecs(ext)) {
                    url = self._src[i];
                    break;
                }
            }
            if (!url) {
                self._emit("loaderror", null, "No codec support for selected audio sources.");
                return;
            }
            self._src = url;
            self._state = "loading";
            // If the hosting page is HTTPS and the source isn't,
            // drop down to HTML5 Audio to avoid Mixed Content errors.
            if (window.location.protocol === "https:" && url.slice(0, 5) === "http:") {
                self._html5 = true;
                self._webAudio = false;
            }
            // Create a new sound object and add it to the pool.
            new Sound1(self);
            // Load and decode the audio data for playback.
            if (self._webAudio) loadBuffer(self);
            return self;
        },
        /**
     * Play a sound or resume previous playback.
     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Number}          Sound ID.
     */ play: function(sprite, internal) {
            var self = this;
            var id = null;
            // Determine if a sprite, sound id or nothing was passed
            if (typeof sprite === "number") {
                id = sprite;
                sprite = null;
            } else if (typeof sprite === "string" && self._state === "loaded" && !self._sprite[sprite]) // If the passed sprite doesn't exist, do nothing.
            return null;
            else if (typeof sprite === "undefined") {
                // Use the default sound sprite (plays the full audio length).
                sprite = "__default";
                // Check if there is a single paused sound that isn't ended.
                // If there is, play that sound. If not, continue as usual.
                if (!self._playLock) {
                    var num = 0;
                    for(var i = 0; i < self._sounds.length; i++)if (self._sounds[i]._paused && !self._sounds[i]._ended) {
                        num++;
                        id = self._sounds[i]._id;
                    }
                    if (num === 1) sprite = null;
                    else id = null;
                }
            }
            // Get the selected node, or get one from the pool.
            var sound = id ? self._soundById(id) : self._inactiveSound();
            // If the sound doesn't exist, do nothing.
            if (!sound) return null;
            // Select the sprite definition.
            if (id && !sprite) sprite = sound._sprite || "__default";
            // If the sound hasn't loaded, we must wait to get the audio's duration.
            // We also need to wait to make sure we don't run into race conditions with
            // the order of function calls.
            if (self._state !== "loaded") {
                // Set the sprite value on this sound.
                sound._sprite = sprite;
                // Mark this sound as not ended in case another sound is played before this one loads.
                sound._ended = false;
                // Add the sound to the queue to be played on load.
                var soundId = sound._id;
                self._queue.push({
                    event: "play",
                    action: function() {
                        self.play(soundId);
                    }
                });
                return soundId;
            }
            // Don't play the sound if an id was passed and it is already playing.
            if (id && !sound._paused) {
                // Trigger the play event, in order to keep iterating through queue.
                if (!internal) self._loadQueue("play");
                return sound._id;
            }
            // Make sure the AudioContext isn't suspended, and resume it if it is.
            if (self._webAudio) Howler1._autoResume();
            // Determine how long to play for and where to start playing.
            var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
            var duration = Math.max(0, (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000 - seek);
            var timeout = duration * 1000 / Math.abs(sound._rate);
            var start = self._sprite[sprite][0] / 1000;
            var stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
            sound._sprite = sprite;
            // Mark the sound as ended instantly so that this async playback
            // doesn't get grabbed by another call to play while this one waits to start.
            sound._ended = false;
            // Update the parameters of the sound.
            var setParams = function() {
                sound._paused = false;
                sound._seek = seek;
                sound._start = start;
                sound._stop = stop;
                sound._loop = !!(sound._loop || self._sprite[sprite][2]);
            };
            // End the sound instantly if seek is at the end.
            if (seek >= stop) {
                self._ended(sound);
                return;
            }
            // Begin the actual playback.
            var node = sound._node;
            if (self._webAudio) {
                // Fire this when the sound is ready to play to begin Web Audio playback.
                var playWebAudio = function() {
                    self._playLock = false;
                    setParams();
                    self._refreshBuffer(sound);
                    // Setup the playback params.
                    var vol = sound._muted || self._muted ? 0 : sound._volume;
                    node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                    sound._playStart = Howler1.ctx.currentTime;
                    // Play the sound using the supported method.
                    if (typeof node.bufferSource.start === "undefined") sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
                    else sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
                    // Start a new timer if none is present.
                    if (timeout !== Infinity) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                    if (!internal) setTimeout(function() {
                        self._emit("play", sound._id);
                        self._loadQueue();
                    }, 0);
                };
                if (Howler1.state === "running" && Howler1.ctx.state !== "interrupted") playWebAudio();
                else {
                    self._playLock = true;
                    // Wait for the audio context to resume before playing.
                    self.once("resume", playWebAudio);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            } else {
                // Fire this when the sound is ready to play to begin HTML5 Audio playback.
                var playHtml5 = function() {
                    node.currentTime = seek;
                    node.muted = sound._muted || self._muted || Howler1._muted || node.muted;
                    node.volume = sound._volume * Howler1.volume();
                    node.playbackRate = sound._rate;
                    // Some browsers will throw an error if this is called without user interaction.
                    try {
                        var play = node.play();
                        // Support older browsers that don't support promises, and thus don't have this issue.
                        if (play && typeof Promise !== "undefined" && (play instanceof Promise || typeof play.then === "function")) {
                            // Implements a lock to prevent DOMException: The play() request was interrupted by a call to pause().
                            self._playLock = true;
                            // Set param values immediately.
                            setParams();
                            // Releases the lock and executes queued actions.
                            play.then(function() {
                                self._playLock = false;
                                node._unlocked = true;
                                if (!internal) self._emit("play", sound._id);
                                else self._loadQueue();
                            }).catch(function() {
                                self._playLock = false;
                                self._emit("playerror", sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                                // Reset the ended and paused values.
                                sound._ended = true;
                                sound._paused = true;
                            });
                        } else if (!internal) {
                            self._playLock = false;
                            setParams();
                            self._emit("play", sound._id);
                        }
                        // Setting rate before playing won't work in IE, so we set it again here.
                        node.playbackRate = sound._rate;
                        // If the node is still paused, then we can assume there was a playback issue.
                        if (node.paused) {
                            self._emit("playerror", sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                            return;
                        }
                        // Setup the end timer on sprites or listen for the ended event.
                        if (sprite !== "__default" || sound._loop) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                        else {
                            self._endTimers[sound._id] = function() {
                                // Fire ended on this audio node.
                                self._ended(sound);
                                // Clear this listener.
                                node.removeEventListener("ended", self._endTimers[sound._id], false);
                            };
                            node.addEventListener("ended", self._endTimers[sound._id], false);
                        }
                    } catch (err) {
                        self._emit("playerror", sound._id, err);
                    }
                };
                // If this is streaming audio, make sure the src is set and load again.
                if (node.src === "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA") {
                    node.src = self._src;
                    node.load();
                }
                // Play immediately if ready, or wait for the 'canplaythrough'e vent.
                var loadedNoReadyState = window && window.ejecta || !node.readyState && Howler1._navigator.isCocoonJS;
                if (node.readyState >= 3 || loadedNoReadyState) playHtml5();
                else {
                    self._playLock = true;
                    self._state = "loading";
                    var listener = function() {
                        self._state = "loaded";
                        // Begin playback.
                        playHtml5();
                        // Clear this listener.
                        node.removeEventListener(Howler1._canPlayEvent, listener, false);
                    };
                    node.addEventListener(Howler1._canPlayEvent, listener, false);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            }
            return sound._id;
        },
        /**
     * Pause playback and save current position.
     * @param  {Number} id The sound ID (empty to pause all in group).
     * @return {Howl}
     */ pause: function(id) {
            var self = this;
            // If the sound hasn't loaded or a play() promise is pending, add it to the load queue to pause when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "pause",
                    action: function() {
                        self.pause(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be paused.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound && !sound._paused) {
                    // Reset the seek position.
                    sound._seek = self.seek(ids[i]);
                    sound._rateSeek = 0;
                    sound._paused = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) {
                            // Make sure the sound has been created.
                            if (!sound._node.bufferSource) continue;
                            if (typeof sound._node.bufferSource.stop === "undefined") sound._node.bufferSource.noteOff(0);
                            else sound._node.bufferSource.stop(0);
                            // Clean up the buffer source.
                            self._cleanBuffer(sound._node);
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) sound._node.pause();
                    }
                }
                // Fire the pause event, unless `true` is passed as the 2nd argument.
                if (!arguments[1]) self._emit("pause", sound ? sound._id : null);
            }
            return self;
        },
        /**
     * Stop playback and reset to start.
     * @param  {Number} id The sound ID (empty to stop all in group).
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Howl}
     */ stop: function(id, internal) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to stop when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "stop",
                    action: function() {
                        self.stop(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be stopped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    // Reset the seek position.
                    sound._seek = sound._start || 0;
                    sound._rateSeek = 0;
                    sound._paused = true;
                    sound._ended = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) // Make sure the sound's AudioBufferSourceNode has been created.
                        {
                            if (sound._node.bufferSource) {
                                if (typeof sound._node.bufferSource.stop === "undefined") sound._node.bufferSource.noteOff(0);
                                else sound._node.bufferSource.stop(0);
                                // Clean up the buffer source.
                                self._cleanBuffer(sound._node);
                            }
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
                            sound._node.currentTime = sound._start || 0;
                            sound._node.pause();
                            // If this is a live stream, stop download once the audio is stopped.
                            if (sound._node.duration === Infinity) self._clearSound(sound._node);
                        }
                    }
                    if (!internal) self._emit("stop", sound._id);
                }
            }
            return self;
        },
        /**
     * Mute/unmute a single sound or all sounds in this Howl group.
     * @param  {Boolean} muted Set to true to mute and false to unmute.
     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
     * @return {Howl}
     */ mute: function(muted, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to mute when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "mute",
                    action: function() {
                        self.mute(muted, id);
                    }
                });
                return self;
            }
            // If applying mute/unmute to all sounds, update the group's value.
            if (typeof id === "undefined") {
                if (typeof muted === "boolean") self._muted = muted;
                else return self._muted;
            }
            // If no id is passed, get all ID's to be muted.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    sound._muted = muted;
                    // Cancel active fade and set the volume to the end value.
                    if (sound._interval) self._stopFade(sound._id);
                    if (self._webAudio && sound._node) sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler1.ctx.currentTime);
                    else if (sound._node) sound._node.muted = Howler1._muted ? true : muted;
                    self._emit("mute", sound._id);
                }
            }
            return self;
        },
        /**
     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
     *   volume() -> Returns the group's volume value.
     *   volume(id) -> Returns the sound id's current volume.
     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
     *   volume(vol, id) -> Sets the volume of passed sound id.
     * @return {Howl/Number} Returns self or current volume.
     */ volume: function() {
            var self = this;
            var args = arguments;
            var vol, id;
            // Determine the values based on arguments.
            if (args.length === 0) // Return the value of the groups' volume.
            return self._volume;
            else if (args.length === 1 || args.length === 2 && typeof args[1] === "undefined") {
                // First check if this is an ID, and if not, assume it is a new volume.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else vol = parseFloat(args[0]);
            } else if (args.length >= 2) {
                vol = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the volume or return the current volume.
            var sound;
            if (typeof vol !== "undefined" && vol >= 0 && vol <= 1) {
                // If the sound hasn't loaded, add it to the load queue to change volume when capable.
                if (self._state !== "loaded" || self._playLock) {
                    self._queue.push({
                        event: "volume",
                        action: function() {
                            self.volume.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group volume.
                if (typeof id === "undefined") self._volume = vol;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        sound._volume = vol;
                        // Stop currently running fades.
                        if (!args[2]) self._stopFade(id[i]);
                        if (self._webAudio && sound._node && !sound._muted) sound._node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                        else if (sound._node && !sound._muted) sound._node.volume = vol * Howler1.volume();
                        self._emit("volume", sound._id);
                    }
                }
            } else {
                sound = id ? self._soundById(id) : self._sounds[0];
                return sound ? sound._volume : 0;
            }
            return self;
        },
        /**
     * Fade a currently playing sound between two volumes (if no id is passed, all sounds will fade).
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id (omit to fade all sounds).
     * @return {Howl}
     */ fade: function(from, to, len, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to fade when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "fade",
                    action: function() {
                        self.fade(from, to, len, id);
                    }
                });
                return self;
            }
            // Make sure the to/from/len values are numbers.
            from = Math.min(Math.max(0, parseFloat(from)), 1);
            to = Math.min(Math.max(0, parseFloat(to)), 1);
            len = parseFloat(len);
            // Set the volume to the start position.
            self.volume(from, id);
            // Fade the volume of one or all sounds.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                // Create a linear fade or fall back to timeouts with HTML5 Audio.
                if (sound) {
                    // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
                    if (!id) self._stopFade(ids[i]);
                    // If we are using Web Audio, let the native methods do the actual fade.
                    if (self._webAudio && !sound._muted) {
                        var currentTime = Howler1.ctx.currentTime;
                        var end = currentTime + len / 1000;
                        sound._volume = from;
                        sound._node.gain.setValueAtTime(from, currentTime);
                        sound._node.gain.linearRampToValueAtTime(to, end);
                    }
                    self._startFadeInterval(sound, from, to, len, ids[i], typeof id === "undefined");
                }
            }
            return self;
        },
        /**
     * Starts the internal interval to fade a sound.
     * @param  {Object} sound Reference to sound to fade.
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id to fade.
     * @param  {Boolean} isGroup   If true, set the volume on the group.
     */ _startFadeInterval: function(sound, from, to, len, id, isGroup) {
            var self = this;
            var vol = from;
            var diff = to - from;
            var steps = Math.abs(diff / 0.01);
            var stepLen = Math.max(4, steps > 0 ? len / steps : len);
            var lastTick = Date.now();
            // Store the value being faded to.
            sound._fadeTo = to;
            // Update the volume value on each interval tick.
            sound._interval = setInterval(function() {
                // Update the volume based on the time since the last tick.
                var tick = (Date.now() - lastTick) / len;
                lastTick = Date.now();
                vol += diff * tick;
                // Round to within 2 decimal points.
                vol = Math.round(vol * 100) / 100;
                // Make sure the volume is in the right bounds.
                if (diff < 0) vol = Math.max(to, vol);
                else vol = Math.min(to, vol);
                // Change the volume.
                if (self._webAudio) sound._volume = vol;
                else self.volume(vol, sound._id, true);
                // Set the group's volume.
                if (isGroup) self._volume = vol;
                // When the fade is complete, stop it and fire event.
                if (to < from && vol <= to || to > from && vol >= to) {
                    clearInterval(sound._interval);
                    sound._interval = null;
                    sound._fadeTo = null;
                    self.volume(to, sound._id);
                    self._emit("fade", sound._id);
                }
            }, stepLen);
        },
        /**
     * Internal method that stops the currently playing fade when
     * a new fade starts, volume is changed or the sound is stopped.
     * @param  {Number} id The sound id.
     * @return {Howl}
     */ _stopFade: function(id) {
            var self = this;
            var sound = self._soundById(id);
            if (sound && sound._interval) {
                if (self._webAudio) sound._node.gain.cancelScheduledValues(Howler1.ctx.currentTime);
                clearInterval(sound._interval);
                sound._interval = null;
                self.volume(sound._fadeTo, id);
                sound._fadeTo = null;
                self._emit("fade", id);
            }
            return self;
        },
        /**
     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
     *   loop() -> Returns the group's loop value.
     *   loop(id) -> Returns the sound id's loop value.
     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
     *   loop(loop, id) -> Sets the loop value of passed sound id.
     * @return {Howl/Boolean} Returns self or current loop value.
     */ loop: function() {
            var self = this;
            var args = arguments;
            var loop, id, sound;
            // Determine the values for loop and id.
            if (args.length === 0) // Return the grou's loop value.
            return self._loop;
            else if (args.length === 1) {
                if (typeof args[0] === "boolean") {
                    loop = args[0];
                    self._loop = loop;
                } else {
                    // Return this sound's loop value.
                    sound = self._soundById(parseInt(args[0], 10));
                    return sound ? sound._loop : false;
                }
            } else if (args.length === 2) {
                loop = args[0];
                id = parseInt(args[1], 10);
            }
            // If no id is passed, get all ID's to be looped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                sound = self._soundById(ids[i]);
                if (sound) {
                    sound._loop = loop;
                    if (self._webAudio && sound._node && sound._node.bufferSource) {
                        sound._node.bufferSource.loop = loop;
                        if (loop) {
                            sound._node.bufferSource.loopStart = sound._start || 0;
                            sound._node.bufferSource.loopEnd = sound._stop;
                            // If playing, restart playback to ensure looping updates.
                            if (self.playing(ids[i])) {
                                self.pause(ids[i], true);
                                self.play(ids[i], true);
                            }
                        }
                    }
                }
            }
            return self;
        },
        /**
     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   rate() -> Returns the first sound node's current playback rate.
     *   rate(id) -> Returns the sound id's current playback rate.
     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
     *   rate(rate, id) -> Sets the playback rate of passed sound id.
     * @return {Howl/Number} Returns self or the current playback rate.
     */ rate: function() {
            var self = this;
            var args = arguments;
            var rate, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current rate of the first node.
            id = self._sounds[0]._id;
            else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new rate value.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else rate = parseFloat(args[0]);
            } else if (args.length === 2) {
                rate = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the playback rate or return the current value.
            var sound;
            if (typeof rate === "number") {
                // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
                if (self._state !== "loaded" || self._playLock) {
                    self._queue.push({
                        event: "rate",
                        action: function() {
                            self.rate.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group rate.
                if (typeof id === "undefined") self._rate = rate;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        // Keep track of our position when the rate changed and update the playback
                        // start position so we can properly adjust the seek position for time elapsed.
                        if (self.playing(id[i])) {
                            sound._rateSeek = self.seek(id[i]);
                            sound._playStart = self._webAudio ? Howler1.ctx.currentTime : sound._playStart;
                        }
                        sound._rate = rate;
                        // Change the playback rate.
                        if (self._webAudio && sound._node && sound._node.bufferSource) sound._node.bufferSource.playbackRate.setValueAtTime(rate, Howler1.ctx.currentTime);
                        else if (sound._node) sound._node.playbackRate = rate;
                        // Reset the timers.
                        var seek = self.seek(id[i]);
                        var duration = (self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000 - seek;
                        var timeout = duration * 1000 / Math.abs(sound._rate);
                        // Start a new end timer if sound is already playing.
                        if (self._endTimers[id[i]] || !sound._paused) {
                            self._clearTimer(id[i]);
                            self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
                        }
                        self._emit("rate", sound._id);
                    }
                }
            } else {
                sound = self._soundById(id);
                return sound ? sound._rate : self._rate;
            }
            return self;
        },
        /**
     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   seek() -> Returns the first sound node's current seek position.
     *   seek(id) -> Returns the sound id's current seek position.
     *   seek(seek) -> Sets the seek position of the first sound node.
     *   seek(seek, id) -> Sets the seek position of passed sound id.
     * @return {Howl/Number} Returns self or the current seek position.
     */ seek: function() {
            var self = this;
            var args = arguments;
            var seek, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current position of the first node.
            {
                if (self._sounds.length) id = self._sounds[0]._id;
            } else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new seek position.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else if (self._sounds.length) {
                    id = self._sounds[0]._id;
                    seek = parseFloat(args[0]);
                }
            } else if (args.length === 2) {
                seek = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // If there is no ID, bail out.
            if (typeof id === "undefined") return 0;
            // If the sound hasn't loaded, add it to the load queue to seek when capable.
            if (typeof seek === "number" && (self._state !== "loaded" || self._playLock)) {
                self._queue.push({
                    event: "seek",
                    action: function() {
                        self.seek.apply(self, args);
                    }
                });
                return self;
            }
            // Get the sound.
            var sound = self._soundById(id);
            if (sound) {
                if (typeof seek === "number" && seek >= 0) {
                    // Pause the sound and update position for restarting playback.
                    var playing = self.playing(id);
                    if (playing) self.pause(id, true);
                    // Move the position of the track and cancel timer.
                    sound._seek = seek;
                    sound._ended = false;
                    self._clearTimer(id);
                    // Update the seek position for HTML5 Audio.
                    if (!self._webAudio && sound._node && !isNaN(sound._node.duration)) sound._node.currentTime = seek;
                    // Seek and emit when ready.
                    var seekAndEmit = function() {
                        // Restart the playback if the sound was playing.
                        if (playing) self.play(id, true);
                        self._emit("seek", id);
                    };
                    // Wait for the play lock to be unset before emitting (HTML5 Audio).
                    if (playing && !self._webAudio) {
                        var emitSeek = function() {
                            if (!self._playLock) seekAndEmit();
                            else setTimeout(emitSeek, 0);
                        };
                        setTimeout(emitSeek, 0);
                    } else seekAndEmit();
                } else {
                    if (self._webAudio) {
                        var realTime = self.playing(id) ? Howler1.ctx.currentTime - sound._playStart : 0;
                        var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
                        return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
                    } else return sound._node.currentTime;
                }
            }
            return self;
        },
        /**
     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
     * @return {Boolean} True if playing and false if not.
     */ playing: function(id) {
            var self = this;
            // Check the passed sound ID (if any).
            if (typeof id === "number") {
                var sound = self._soundById(id);
                return sound ? !sound._paused : false;
            }
            // Otherwise, loop through all sounds and check if any are playing.
            for(var i = 0; i < self._sounds.length; i++){
                if (!self._sounds[i]._paused) return true;
            }
            return false;
        },
        /**
     * Get the duration of this sound. Passing a sound id will return the sprite duration.
     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
     * @return {Number} Audio duration in seconds.
     */ duration: function(id) {
            var self = this;
            var duration = self._duration;
            // If we pass an ID, get the sound and return the sprite length.
            var sound = self._soundById(id);
            if (sound) duration = self._sprite[sound._sprite][1] / 1000;
            return duration;
        },
        /**
     * Returns the current loaded state of this Howl.
     * @return {String} 'unloaded', 'loading', 'loaded'
     */ state: function() {
            return this._state;
        },
        /**
     * Unload and destroy the current Howl object.
     * This will immediately stop all sound instances attached to this group.
     */ unload: function() {
            var self = this;
            // Stop playing any active sounds.
            var sounds = self._sounds;
            for(var i = 0; i < sounds.length; i++){
                // Stop the sound if it is currently playing.
                if (!sounds[i]._paused) self.stop(sounds[i]._id);
                // Remove the source or disconnect.
                if (!self._webAudio) {
                    // Set the source to 0-second silence to stop any downloading (except in IE).
                    self._clearSound(sounds[i]._node);
                    // Remove any event listeners.
                    sounds[i]._node.removeEventListener("error", sounds[i]._errorFn, false);
                    sounds[i]._node.removeEventListener(Howler1._canPlayEvent, sounds[i]._loadFn, false);
                    sounds[i]._node.removeEventListener("ended", sounds[i]._endFn, false);
                    // Release the Audio object back to the pool.
                    Howler1._releaseHtml5Audio(sounds[i]._node);
                }
                // Empty out all of the nodes.
                delete sounds[i]._node;
                // Make sure all timers are cleared out.
                self._clearTimer(sounds[i]._id);
            }
            // Remove the references in the global Howler object.
            var index = Howler1._howls.indexOf(self);
            if (index >= 0) Howler1._howls.splice(index, 1);
            // Delete this sound from the cache (if no other Howl is using it).
            var remCache = true;
            for(i = 0; i < Howler1._howls.length; i++)if (Howler1._howls[i]._src === self._src || self._src.indexOf(Howler1._howls[i]._src) >= 0) {
                remCache = false;
                break;
            }
            if (cache && remCache) delete cache[self._src];
            // Clear global errors.
            Howler1.noAudio = false;
            // Clear out `self`.
            self._state = "unloaded";
            self._sounds = [];
            self = null;
            return null;
        },
        /**
     * Listen to a custom event.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
     * @return {Howl}
     */ on: function(event, fn, id, once) {
            var self = this;
            var events = self["_on" + event];
            if (typeof fn === "function") events.push(once ? {
                id: id,
                fn: fn,
                once: once
            } : {
                id: id,
                fn: fn
            });
            return self;
        },
        /**
     * Remove a custom event. Call without parameters to remove all events.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
     * @param  {Number}   id    (optional) Only remove events for this sound.
     * @return {Howl}
     */ off: function(event, fn, id) {
            var self = this;
            var events = self["_on" + event];
            var i = 0;
            // Allow passing just an event and ID.
            if (typeof fn === "number") {
                id = fn;
                fn = null;
            }
            if (fn || id) // Loop through event store and remove the passed function.
            for(i = 0; i < events.length; i++){
                var isId = id === events[i].id;
                if (fn === events[i].fn && isId || !fn && isId) {
                    events.splice(i, 1);
                    break;
                }
            }
            else if (event) // Clear out all events of this type.
            self["_on" + event] = [];
            else {
                // Clear out all events of every type.
                var keys = Object.keys(self);
                for(i = 0; i < keys.length; i++)if (keys[i].indexOf("_on") === 0 && Array.isArray(self[keys[i]])) self[keys[i]] = [];
            }
            return self;
        },
        /**
     * Listen to a custom event and remove it once fired.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @return {Howl}
     */ once: function(event, fn, id) {
            var self = this;
            // Setup the event listener.
            self.on(event, fn, id, 1);
            return self;
        },
        /**
     * Emit all events of a specific type and pass the sound id.
     * @param  {String} event Event name.
     * @param  {Number} id    Sound ID.
     * @param  {Number} msg   Message to go with event.
     * @return {Howl}
     */ _emit: function(event, id, msg) {
            var self = this;
            var events = self["_on" + event];
            // Loop through event store and fire all functions.
            for(var i = events.length - 1; i >= 0; i--)// Only fire the listener if the correct ID is used.
            if (!events[i].id || events[i].id === id || event === "load") {
                setTimeout((function(fn) {
                    fn.call(this, id, msg);
                }).bind(self, events[i].fn), 0);
                // If this event was setup with `once`, remove it.
                if (events[i].once) self.off(event, events[i].fn, events[i].id);
            }
            // Pass the event type into load queue so that it can continue stepping.
            self._loadQueue(event);
            return self;
        },
        /**
     * Queue of actions initiated before the sound has loaded.
     * These will be called in sequence, with the next only firing
     * after the previous has finished executing (even if async like play).
     * @return {Howl}
     */ _loadQueue: function(event) {
            var self = this;
            if (self._queue.length > 0) {
                var task = self._queue[0];
                // Remove this task if a matching event was passed.
                if (task.event === event) {
                    self._queue.shift();
                    self._loadQueue();
                }
                // Run the task if no event type is passed.
                if (!event) task.action();
            }
            return self;
        },
        /**
     * Fired when playback ends at the end of the duration.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _ended: function(sound) {
            var self = this;
            var sprite = sound._sprite;
            // If we are using IE and there was network latency we may be clipping
            // audio before it completes playing. Lets check the node to make sure it
            // believes it has completed, before ending the playback.
            if (!self._webAudio && sound._node && !sound._node.paused && !sound._node.ended && sound._node.currentTime < sound._stop) {
                setTimeout(self._ended.bind(self, sound), 100);
                return self;
            }
            // Should this sound loop?
            var loop = !!(sound._loop || self._sprite[sprite][2]);
            // Fire the ended event.
            self._emit("end", sound._id);
            // Restart the playback for HTML5 Audio loop.
            if (!self._webAudio && loop) self.stop(sound._id, true).play(sound._id);
            // Restart this timer if on a Web Audio loop.
            if (self._webAudio && loop) {
                self._emit("play", sound._id);
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                sound._playStart = Howler1.ctx.currentTime;
                var timeout = (sound._stop - sound._start) * 1000 / Math.abs(sound._rate);
                self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
            }
            // Mark the node as paused.
            if (self._webAudio && !loop) {
                sound._paused = true;
                sound._ended = true;
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                self._clearTimer(sound._id);
                // Clean up the buffer source.
                self._cleanBuffer(sound._node);
                // Attempt to auto-suspend AudioContext if no sounds are still playing.
                Howler1._autoSuspend();
            }
            // When using a sprite, end the track.
            if (!self._webAudio && !loop) self.stop(sound._id, true);
            return self;
        },
        /**
     * Clear the end timer for a sound playback.
     * @param  {Number} id The sound ID.
     * @return {Howl}
     */ _clearTimer: function(id) {
            var self = this;
            if (self._endTimers[id]) {
                // Clear the timeout or remove the ended listener.
                if (typeof self._endTimers[id] !== "function") clearTimeout(self._endTimers[id]);
                else {
                    var sound = self._soundById(id);
                    if (sound && sound._node) sound._node.removeEventListener("ended", self._endTimers[id], false);
                }
                delete self._endTimers[id];
            }
            return self;
        },
        /**
     * Return the sound identified by this ID, or return null.
     * @param  {Number} id Sound ID
     * @return {Object}    Sound object or null.
     */ _soundById: function(id) {
            var self = this;
            // Loop through all sounds and find the one with this ID.
            for(var i = 0; i < self._sounds.length; i++){
                if (id === self._sounds[i]._id) return self._sounds[i];
            }
            return null;
        },
        /**
     * Return an inactive sound from the pool or create a new one.
     * @return {Sound} Sound playback object.
     */ _inactiveSound: function() {
            var self = this;
            self._drain();
            // Find the first inactive node to recycle.
            for(var i = 0; i < self._sounds.length; i++){
                if (self._sounds[i]._ended) return self._sounds[i].reset();
            }
            // If no inactive node was found, create a new one.
            return new Sound1(self);
        },
        /**
     * Drain excess inactive sounds from the pool.
     */ _drain: function() {
            var self = this;
            var limit = self._pool;
            var cnt = 0;
            var i = 0;
            // If there are less sounds than the max pool size, we are done.
            if (self._sounds.length < limit) return;
            // Count the number of inactive sounds.
            for(i = 0; i < self._sounds.length; i++)if (self._sounds[i]._ended) cnt++;
            // Remove excess inactive sounds, going in reverse order.
            for(i = self._sounds.length - 1; i >= 0; i--){
                if (cnt <= limit) return;
                if (self._sounds[i]._ended) {
                    // Disconnect the audio source when using Web Audio.
                    if (self._webAudio && self._sounds[i]._node) self._sounds[i]._node.disconnect(0);
                    // Remove sounds until we have the pool size.
                    self._sounds.splice(i, 1);
                    cnt--;
                }
            }
        },
        /**
     * Get all ID's from the sounds pool.
     * @param  {Number} id Only return one ID if one is passed.
     * @return {Array}    Array of IDs.
     */ _getSoundIds: function(id) {
            var self = this;
            if (typeof id === "undefined") {
                var ids = [];
                for(var i = 0; i < self._sounds.length; i++)ids.push(self._sounds[i]._id);
                return ids;
            } else return [
                id
            ];
        },
        /**
     * Load the sound back into the buffer source.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _refreshBuffer: function(sound) {
            var self = this;
            // Setup the buffer source for playback.
            sound._node.bufferSource = Howler1.ctx.createBufferSource();
            sound._node.bufferSource.buffer = cache[self._src];
            // Connect to the correct node.
            if (sound._panner) sound._node.bufferSource.connect(sound._panner);
            else sound._node.bufferSource.connect(sound._node);
            // Setup looping and playback rate.
            sound._node.bufferSource.loop = sound._loop;
            if (sound._loop) {
                sound._node.bufferSource.loopStart = sound._start || 0;
                sound._node.bufferSource.loopEnd = sound._stop || 0;
            }
            sound._node.bufferSource.playbackRate.setValueAtTime(sound._rate, Howler1.ctx.currentTime);
            return self;
        },
        /**
     * Prevent memory leaks by cleaning up the buffer source after playback.
     * @param  {Object} node Sound's audio node containing the buffer source.
     * @return {Howl}
     */ _cleanBuffer: function(node) {
            var self = this;
            var isIOS = Howler1._navigator && Howler1._navigator.vendor.indexOf("Apple") >= 0;
            if (Howler1._scratchBuffer && node.bufferSource) {
                node.bufferSource.onended = null;
                node.bufferSource.disconnect(0);
                if (isIOS) try {
                    node.bufferSource.buffer = Howler1._scratchBuffer;
                } catch (e) {}
            }
            node.bufferSource = null;
            return self;
        },
        /**
     * Set the source to a 0-second silence to stop any downloading (except in IE).
     * @param  {Object} node Audio node to clear.
     */ _clearSound: function(node) {
            var checkIE = /MSIE |Trident\//.test(Howler1._navigator && Howler1._navigator.userAgent);
            if (!checkIE) node.src = "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA";
        }
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Setup the sound object, which each node attached to a Howl group is contained in.
   * @param {Object} howl The Howl parent group.
   */ var Sound1 = function(howl) {
        this._parent = howl;
        this.init();
    };
    Sound1.prototype = {
        /**
     * Initialize a new Sound object.
     * @return {Sound}
     */ init: function() {
            var self = this;
            var parent = self._parent;
            // Setup the default parameters.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = "__default";
            // Generate a unique ID for this sound.
            self._id = ++Howler1._counter;
            // Add itself to the parent's pool.
            parent._sounds.push(self);
            // Create the new node.
            self.create();
            return self;
        },
        /**
     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
     * @return {Sound}
     */ create: function() {
            var self = this;
            var parent = self._parent;
            var volume = Howler1._muted || self._muted || self._parent._muted ? 0 : self._volume;
            if (parent._webAudio) {
                // Create the gain node for controlling volume (the source will connect to this).
                self._node = typeof Howler1.ctx.createGain === "undefined" ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
                self._node.gain.setValueAtTime(volume, Howler1.ctx.currentTime);
                self._node.paused = true;
                self._node.connect(Howler1.masterGain);
            } else if (!Howler1.noAudio) {
                // Get an unlocked Audio object from the pool.
                self._node = Howler1._obtainHtml5Audio();
                // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
                self._errorFn = self._errorListener.bind(self);
                self._node.addEventListener("error", self._errorFn, false);
                // Listen for 'canplaythrough' event to let us know the sound is ready.
                self._loadFn = self._loadListener.bind(self);
                self._node.addEventListener(Howler1._canPlayEvent, self._loadFn, false);
                // Listen for the 'ended' event on the sound to account for edge-case where
                // a finite sound has a duration of Infinity.
                self._endFn = self._endListener.bind(self);
                self._node.addEventListener("ended", self._endFn, false);
                // Setup the new audio node.
                self._node.src = parent._src;
                self._node.preload = parent._preload === true ? "auto" : parent._preload;
                self._node.volume = volume * Howler1.volume();
                // Begin loading the source.
                self._node.load();
            }
            return self;
        },
        /**
     * Reset the parameters of this sound to the original state (for recycle).
     * @return {Sound}
     */ reset: function() {
            var self = this;
            var parent = self._parent;
            // Reset all of the parameters of this sound.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._rateSeek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = "__default";
            // Generate a new ID so that it isn't confused with the previous sound.
            self._id = ++Howler1._counter;
            return self;
        },
        /**
     * HTML5 Audio error listener callback.
     */ _errorListener: function() {
            var self = this;
            // Fire an error event and pass back the code.
            self._parent._emit("loaderror", self._id, self._node.error ? self._node.error.code : 0);
            // Clear the event listener.
            self._node.removeEventListener("error", self._errorFn, false);
        },
        /**
     * HTML5 Audio canplaythrough listener callback.
     */ _loadListener: function() {
            var self = this;
            var parent = self._parent;
            // Round up the duration to account for the lower precision in HTML5 Audio.
            parent._duration = Math.ceil(self._node.duration * 10) / 10;
            // Setup a sprite if none is defined.
            if (Object.keys(parent._sprite).length === 0) parent._sprite = {
                __default: [
                    0,
                    parent._duration * 1000
                ]
            };
            if (parent._state !== "loaded") {
                parent._state = "loaded";
                parent._emit("load");
                parent._loadQueue();
            }
            // Clear the event listener.
            self._node.removeEventListener(Howler1._canPlayEvent, self._loadFn, false);
        },
        /**
     * HTML5 Audio ended listener callback.
     */ _endListener: function() {
            var self = this;
            var parent = self._parent;
            // Only handle the `ended`` event if the duration is Infinity.
            if (parent._duration === Infinity) {
                // Update the parent duration to match the real audio duration.
                // Round up the duration to account for the lower precision in HTML5 Audio.
                parent._duration = Math.ceil(self._node.duration * 10) / 10;
                // Update the sprite that corresponds to the real duration.
                if (parent._sprite.__default[1] === Infinity) parent._sprite.__default[1] = parent._duration * 1000;
                // Run the regular ended method.
                parent._ended(self);
            }
            // Clear the event listener since the duration is now correct.
            self._node.removeEventListener("ended", self._endFn, false);
        }
    };
    /** Helper Methods **/ /***************************************************************************/ var cache = {};
    /**
   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
   * @param  {Howl} self
   */ var loadBuffer = function(self) {
        var url = self._src;
        // Check if the buffer has already been cached and use it instead.
        if (cache[url]) {
            // Set the duration from the cache.
            self._duration = cache[url].duration;
            // Load the sound into this Howl.
            loadSound(self);
            return;
        }
        if (/^data:[^;]+;base64,/.test(url)) {
            // Decode the base64 data URI without XHR, since some browsers don't support it.
            var data = atob(url.split(",")[1]);
            var dataView = new Uint8Array(data.length);
            for(var i = 0; i < data.length; ++i)dataView[i] = data.charCodeAt(i);
            decodeAudioData(dataView.buffer, self);
        } else {
            // Load the buffer from the URL.
            var xhr = new XMLHttpRequest();
            xhr.open(self._xhr.method, url, true);
            xhr.withCredentials = self._xhr.withCredentials;
            xhr.responseType = "arraybuffer";
            // Apply any custom headers to the request.
            if (self._xhr.headers) Object.keys(self._xhr.headers).forEach(function(key) {
                xhr.setRequestHeader(key, self._xhr.headers[key]);
            });
            xhr.onload = function() {
                // Make sure we get a successful response back.
                var code = (xhr.status + "")[0];
                if (code !== "0" && code !== "2" && code !== "3") {
                    self._emit("loaderror", null, "Failed loading audio file with status: " + xhr.status + ".");
                    return;
                }
                decodeAudioData(xhr.response, self);
            };
            xhr.onerror = function() {
                // If there is an error, switch to HTML5 Audio.
                if (self._webAudio) {
                    self._html5 = true;
                    self._webAudio = false;
                    self._sounds = [];
                    delete cache[url];
                    self.load();
                }
            };
            safeXhrSend(xhr);
        }
    };
    /**
   * Send the XHR request wrapped in a try/catch.
   * @param  {Object} xhr XHR to send.
   */ var safeXhrSend = function(xhr) {
        try {
            xhr.send();
        } catch (e) {
            xhr.onerror();
        }
    };
    /**
   * Decode audio data from an array buffer.
   * @param  {ArrayBuffer} arraybuffer The audio data.
   * @param  {Howl}        self
   */ var decodeAudioData = function(arraybuffer, self) {
        // Fire a load error if something broke.
        var error = function() {
            self._emit("loaderror", null, "Decoding audio data failed.");
        };
        // Load the sound on success.
        var success = function(buffer) {
            if (buffer && self._sounds.length > 0) {
                cache[self._src] = buffer;
                loadSound(self, buffer);
            } else error();
        };
        // Decode the buffer into an audio source.
        if (typeof Promise !== "undefined" && Howler1.ctx.decodeAudioData.length === 1) Howler1.ctx.decodeAudioData(arraybuffer).then(success).catch(error);
        else Howler1.ctx.decodeAudioData(arraybuffer, success, error);
    };
    /**
   * Sound is now loaded, so finish setting everything up and fire the loaded event.
   * @param  {Howl} self
   * @param  {Object} buffer The decoded buffer sound source.
   */ var loadSound = function(self, buffer) {
        // Set the duration.
        if (buffer && !self._duration) self._duration = buffer.duration;
        // Setup a sprite if none is defined.
        if (Object.keys(self._sprite).length === 0) self._sprite = {
            __default: [
                0,
                self._duration * 1000
            ]
        };
        // Fire the loaded event.
        if (self._state !== "loaded") {
            self._state = "loaded";
            self._emit("load");
            self._loadQueue();
        }
    };
    /**
   * Setup the audio context when available, or switch to HTML5 Audio mode.
   */ var setupAudioContext = function() {
        // If we have already detected that Web Audio isn't supported, don't run this step again.
        if (!Howler1.usingWebAudio) return;
        // Check if we are using Web Audio and setup the AudioContext if we are.
        try {
            if (typeof AudioContext !== "undefined") Howler1.ctx = new AudioContext();
            else if (typeof webkitAudioContext !== "undefined") Howler1.ctx = new webkitAudioContext();
            else Howler1.usingWebAudio = false;
        } catch (e) {
            Howler1.usingWebAudio = false;
        }
        // If the audio context creation still failed, set using web audio to false.
        if (!Howler1.ctx) Howler1.usingWebAudio = false;
        // Check if a webview is being used on iOS8 or earlier (rather than the browser).
        // If it is, disable Web Audio as it causes crashing.
        var iOS = /iP(hone|od|ad)/.test(Howler1._navigator && Howler1._navigator.platform);
        var appVersion = Howler1._navigator && Howler1._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        var version = appVersion ? parseInt(appVersion[1], 10) : null;
        if (iOS && version && version < 9) {
            var safari = /safari/.test(Howler1._navigator && Howler1._navigator.userAgent.toLowerCase());
            if (Howler1._navigator && !safari) Howler1.usingWebAudio = false;
        }
        // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
        if (Howler1.usingWebAudio) {
            Howler1.masterGain = typeof Howler1.ctx.createGain === "undefined" ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
            Howler1.masterGain.gain.setValueAtTime(Howler1._muted ? 0 : Howler1._volume, Howler1.ctx.currentTime);
            Howler1.masterGain.connect(Howler1.ctx.destination);
        }
        // Re-run the setup on Howler.
        Howler1._setup();
    };
    // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
    if (typeof define === "function" && define.amd) define([], function() {
        return {
            Howler: Howler1,
            Howl: Howl1
        };
    });
    $cc43b7352a965294$export$c9d39ca3bcd93abb = Howler1;
    $cc43b7352a965294$export$b791fe48eec8032a = Howl1;
    // Add to global in Node.js (for testing, etc).
    if (typeof $parcel$global !== "undefined") {
        $parcel$global.HowlerGlobal = HowlerGlobal1;
        $parcel$global.Howler = Howler1;
        $parcel$global.Howl = Howl1;
        $parcel$global.Sound = Sound1;
    } else if (typeof window !== "undefined") {
        window.HowlerGlobal = HowlerGlobal1;
        window.Howler = Howler1;
        window.Howl = Howl1;
        window.Sound = Sound1;
    }
})();
/*!
 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
 *  
 *  howler.js v2.2.3
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    "use strict";
    // Setup default properties.
    HowlerGlobal.prototype._pos = [
        0,
        0,
        0
    ];
    HowlerGlobal.prototype._orientation = [
        0,
        0,
        -1,
        0,
        1,
        0
    ];
    /** Global Methods **/ /***************************************************************************/ /**
   * Helper method to update the stereo panning position of all current Howls.
   * Future Howls will not use this value unless explicitly set.
   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
   * @return {Howler/Number}     Self or current stereo panning value.
   */ HowlerGlobal.prototype.stereo = function(pan) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Loop through all Howls and update their stereo panning.
        for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].stereo(pan);
        return self;
    };
    /**
   * Get/set the position of the listener in 3D cartesian space. Sounds using
   * 3D position will be relative to the listener's position.
   * @param  {Number} x The x-position of the listener.
   * @param  {Number} y The y-position of the listener.
   * @param  {Number} z The z-position of the listener.
   * @return {Howler/Array}   Self or current listener position.
   */ HowlerGlobal.prototype.pos = function(x, y, z) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? self._pos[1] : y;
        z = typeof z !== "number" ? self._pos[2] : z;
        if (typeof x === "number") {
            self._pos = [
                x,
                y,
                z
            ];
            if (typeof self.ctx.listener.positionX !== "undefined") {
                self.ctx.listener.positionX.setTargetAtTime(self._pos[0], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionY.setTargetAtTime(self._pos[1], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionZ.setTargetAtTime(self._pos[2], Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
        } else return self._pos;
        return self;
    };
    /**
   * Get/set the direction the listener is pointing in the 3D cartesian space.
   * A front and up vector must be provided. The front is the direction the
   * face of the listener is pointing, and up is the direction the top of the
   * listener is pointing. Thus, these values are expected to be at right angles
   * from each other.
   * @param  {Number} x   The x-orientation of the listener.
   * @param  {Number} y   The y-orientation of the listener.
   * @param  {Number} z   The z-orientation of the listener.
   * @param  {Number} xUp The x-orientation of the top of the listener.
   * @param  {Number} yUp The y-orientation of the top of the listener.
   * @param  {Number} zUp The z-orientation of the top of the listener.
   * @return {Howler/Array}     Returns self or the current orientation vectors.
   */ HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        var or = self._orientation;
        y = typeof y !== "number" ? or[1] : y;
        z = typeof z !== "number" ? or[2] : z;
        xUp = typeof xUp !== "number" ? or[3] : xUp;
        yUp = typeof yUp !== "number" ? or[4] : yUp;
        zUp = typeof zUp !== "number" ? or[5] : zUp;
        if (typeof x === "number") {
            self._orientation = [
                x,
                y,
                z,
                xUp,
                yUp,
                zUp
            ];
            if (typeof self.ctx.listener.forwardX !== "undefined") {
                self.ctx.listener.forwardX.setTargetAtTime(x, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardY.setTargetAtTime(y, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardZ.setTargetAtTime(z, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upX.setTargetAtTime(xUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upY.setTargetAtTime(yUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upZ.setTargetAtTime(zUp, Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
        } else return or;
        return self;
    };
    /** Group Methods **/ /***************************************************************************/ /**
   * Add new properties to the core init.
   * @param  {Function} _super Core init method.
   * @return {Howl}
   */ Howl.prototype.init = function(_super) {
        return function(o) {
            var self = this;
            // Setup user-defined default properties.
            self._orientation = o.orientation || [
                1,
                0,
                0
            ];
            self._stereo = o.stereo || null;
            self._pos = o.pos || null;
            self._pannerAttr = {
                coneInnerAngle: typeof o.coneInnerAngle !== "undefined" ? o.coneInnerAngle : 360,
                coneOuterAngle: typeof o.coneOuterAngle !== "undefined" ? o.coneOuterAngle : 360,
                coneOuterGain: typeof o.coneOuterGain !== "undefined" ? o.coneOuterGain : 0,
                distanceModel: typeof o.distanceModel !== "undefined" ? o.distanceModel : "inverse",
                maxDistance: typeof o.maxDistance !== "undefined" ? o.maxDistance : 10000,
                panningModel: typeof o.panningModel !== "undefined" ? o.panningModel : "HRTF",
                refDistance: typeof o.refDistance !== "undefined" ? o.refDistance : 1,
                rolloffFactor: typeof o.rolloffFactor !== "undefined" ? o.rolloffFactor : 1
            };
            // Setup event listeners.
            self._onstereo = o.onstereo ? [
                {
                    fn: o.onstereo
                }
            ] : [];
            self._onpos = o.onpos ? [
                {
                    fn: o.onpos
                }
            ] : [];
            self._onorientation = o.onorientation ? [
                {
                    fn: o.onorientation
                }
            ] : [];
            // Complete initilization with howler.js core's init function.
            return _super.call(this, o);
        };
    }(Howl.prototype.init);
    /**
   * Get/set the stereo panning of the audio source for this sound or all in the group.
   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Number}    Returns self or the current stereo panning value.
   */ Howl.prototype.stereo = function(pan, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "stereo",
                action: function() {
                    self.stereo(pan, id);
                }
            });
            return self;
        }
        // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
        var pannerType = typeof Howler.ctx.createStereoPanner === "undefined" ? "spatial" : "stereo";
        // Setup the group's stereo panning if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's stereo panning if no parameters are passed.
            if (typeof pan === "number") {
                self._stereo = pan;
                self._pos = [
                    pan,
                    0,
                    0
                ];
            } else return self._stereo;
        }
        // Change the streo panning of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof pan === "number") {
                    sound._stereo = pan;
                    sound._pos = [
                        pan,
                        0,
                        0
                    ];
                    if (sound._node) {
                        // If we are falling back, make sure the panningModel is equalpower.
                        sound._pannerAttr.panningModel = "equalpower";
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || !sound._panner.pan) setupPanner(sound, pannerType);
                        if (pannerType === "spatial") {
                            if (typeof sound._panner.positionX !== "undefined") {
                                sound._panner.positionX.setValueAtTime(pan, Howler.ctx.currentTime);
                                sound._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime);
                                sound._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime);
                            } else sound._panner.setPosition(pan, 0, 0);
                        } else sound._panner.pan.setValueAtTime(pan, Howler.ctx.currentTime);
                    }
                    self._emit("stereo", sound._id);
                } else return sound._stereo;
            }
        }
        return self;
    };
    /**
   * Get/set the 3D spatial position of the audio source for this sound or group relative to the global listener.
   * @param  {Number} x  The x-position of the audio source.
   * @param  {Number} y  The y-position of the audio source.
   * @param  {Number} z  The z-position of the audio source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
   */ Howl.prototype.pos = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change position when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "pos",
                action: function() {
                    self.pos(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? 0 : y;
        z = typeof z !== "number" ? -0.5 : z;
        // Setup the group's spatial position if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's spatial position if no parameters are passed.
            if (typeof x === "number") self._pos = [
                x,
                y,
                z
            ];
            else return self._pos;
        }
        // Change the spatial position of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === "number") {
                    sound._pos = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || sound._panner.pan) setupPanner(sound, "spatial");
                        if (typeof sound._panner.positionX !== "undefined") {
                            sound._panner.positionX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.positionY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.positionZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setPosition(x, y, z);
                    }
                    self._emit("pos", sound._id);
                } else return sound._pos;
            }
        }
        return self;
    };
    /**
   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
   * space. Depending on how direction the sound is, based on the `cone` attributes,
   * a sound pointing away from the listener can be quiet or silent.
   * @param  {Number} x  The x-orientation of the source.
   * @param  {Number} y  The y-orientation of the source.
   * @param  {Number} z  The z-orientation of the source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
   */ Howl.prototype.orientation = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "orientation",
                action: function() {
                    self.orientation(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? self._orientation[1] : y;
        z = typeof z !== "number" ? self._orientation[2] : z;
        // Setup the group's spatial orientation if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's spatial orientation if no parameters are passed.
            if (typeof x === "number") self._orientation = [
                x,
                y,
                z
            ];
            else return self._orientation;
        }
        // Change the spatial orientation of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === "number") {
                    sound._orientation = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner) {
                            // Make sure we have a position to setup the node with.
                            if (!sound._pos) sound._pos = self._pos || [
                                0,
                                0,
                                -0.5
                            ];
                            setupPanner(sound, "spatial");
                        }
                        if (typeof sound._panner.orientationX !== "undefined") {
                            sound._panner.orientationX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.orientationY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.orientationZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setOrientation(x, y, z);
                    }
                    self._emit("orientation", sound._id);
                } else return sound._orientation;
            }
        }
        return self;
    };
    /**
   * Get/set the panner node's attributes for a sound or group of sounds.
   * This method can optionall take 0, 1 or 2 arguments.
   *   pannerAttr() -> Returns the group's values.
   *   pannerAttr(id) -> Returns the sound id's values.
   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
   *   pannerAttr(o, id) -> Set's the values of passed sound id.
   *
   *   Attributes:
   *     coneInnerAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      inside of which there will be no volume reduction.
   *     coneOuterAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      outside of which the volume will be reduced to a constant value of `coneOuterGain`.
   *     coneOuterGain - (0 by default) A parameter for directional audio sources, this is the gain outside of the
   *                     `coneOuterAngle`. It is a linear value in the range `[0, 1]`.
   *     distanceModel - ('inverse' by default) Determines algorithm used to reduce volume as audio moves away from
   *                     listener. Can be `linear`, `inverse` or `exponential.
   *     maxDistance - (10000 by default) The maximum distance between source and listener, after which the volume
   *                   will not be reduced any further.
   *     refDistance - (1 by default) A reference distance for reducing volume as source moves further from the listener.
   *                   This is simply a variable of the distance model and has a different effect depending on which model
   *                   is used and the scale of your coordinates. Generally, volume will be equal to 1 at this distance.
   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener. This is simply a
   *                     variable of the distance model and can be in the range of `[0, 1]` with `linear` and `[0, ∞]`
   *                     with `inverse` and `exponential`.
   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
   *                     Can be `HRTF` or `equalpower`.
   *
   * @return {Howl/Object} Returns self or current panner attributes.
   */ Howl.prototype.pannerAttr = function() {
        var self = this;
        var args = arguments;
        var o, id, sound;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // Determine the values based on arguments.
        if (args.length === 0) // Return the group's panner attribute values.
        return self._pannerAttr;
        else if (args.length === 1) {
            if (typeof args[0] === "object") {
                o = args[0];
                // Set the grou's panner attribute values.
                if (typeof id === "undefined") {
                    if (!o.pannerAttr) o.pannerAttr = {
                        coneInnerAngle: o.coneInnerAngle,
                        coneOuterAngle: o.coneOuterAngle,
                        coneOuterGain: o.coneOuterGain,
                        distanceModel: o.distanceModel,
                        maxDistance: o.maxDistance,
                        refDistance: o.refDistance,
                        rolloffFactor: o.rolloffFactor,
                        panningModel: o.panningModel
                    };
                    self._pannerAttr = {
                        coneInnerAngle: typeof o.pannerAttr.coneInnerAngle !== "undefined" ? o.pannerAttr.coneInnerAngle : self._coneInnerAngle,
                        coneOuterAngle: typeof o.pannerAttr.coneOuterAngle !== "undefined" ? o.pannerAttr.coneOuterAngle : self._coneOuterAngle,
                        coneOuterGain: typeof o.pannerAttr.coneOuterGain !== "undefined" ? o.pannerAttr.coneOuterGain : self._coneOuterGain,
                        distanceModel: typeof o.pannerAttr.distanceModel !== "undefined" ? o.pannerAttr.distanceModel : self._distanceModel,
                        maxDistance: typeof o.pannerAttr.maxDistance !== "undefined" ? o.pannerAttr.maxDistance : self._maxDistance,
                        refDistance: typeof o.pannerAttr.refDistance !== "undefined" ? o.pannerAttr.refDistance : self._refDistance,
                        rolloffFactor: typeof o.pannerAttr.rolloffFactor !== "undefined" ? o.pannerAttr.rolloffFactor : self._rolloffFactor,
                        panningModel: typeof o.pannerAttr.panningModel !== "undefined" ? o.pannerAttr.panningModel : self._panningModel
                    };
                }
            } else {
                // Return this sound's panner attribute values.
                sound = self._soundById(parseInt(args[0], 10));
                return sound ? sound._pannerAttr : self._pannerAttr;
            }
        } else if (args.length === 2) {
            o = args[0];
            id = parseInt(args[1], 10);
        }
        // Update the values of the specified sounds.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            sound = self._soundById(ids[i]);
            if (sound) {
                // Merge the new values into the sound.
                var pa = sound._pannerAttr;
                pa = {
                    coneInnerAngle: typeof o.coneInnerAngle !== "undefined" ? o.coneInnerAngle : pa.coneInnerAngle,
                    coneOuterAngle: typeof o.coneOuterAngle !== "undefined" ? o.coneOuterAngle : pa.coneOuterAngle,
                    coneOuterGain: typeof o.coneOuterGain !== "undefined" ? o.coneOuterGain : pa.coneOuterGain,
                    distanceModel: typeof o.distanceModel !== "undefined" ? o.distanceModel : pa.distanceModel,
                    maxDistance: typeof o.maxDistance !== "undefined" ? o.maxDistance : pa.maxDistance,
                    refDistance: typeof o.refDistance !== "undefined" ? o.refDistance : pa.refDistance,
                    rolloffFactor: typeof o.rolloffFactor !== "undefined" ? o.rolloffFactor : pa.rolloffFactor,
                    panningModel: typeof o.panningModel !== "undefined" ? o.panningModel : pa.panningModel
                };
                // Update the panner values or create a new panner if none exists.
                var panner = sound._panner;
                if (panner) {
                    panner.coneInnerAngle = pa.coneInnerAngle;
                    panner.coneOuterAngle = pa.coneOuterAngle;
                    panner.coneOuterGain = pa.coneOuterGain;
                    panner.distanceModel = pa.distanceModel;
                    panner.maxDistance = pa.maxDistance;
                    panner.refDistance = pa.refDistance;
                    panner.rolloffFactor = pa.rolloffFactor;
                    panner.panningModel = pa.panningModel;
                } else {
                    // Make sure we have a position to setup the node with.
                    if (!sound._pos) sound._pos = self._pos || [
                        0,
                        0,
                        -0.5
                    ];
                    // Create a new panner node.
                    setupPanner(sound, "spatial");
                }
            }
        }
        return self;
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Add new properties to the core Sound init.
   * @param  {Function} _super Core Sound init method.
   * @return {Sound}
   */ Sound.prototype.init = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Setup user-defined default properties.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // Complete initilization with howler.js core Sound's init function.
            _super.call(this);
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
        };
    }(Sound.prototype.init);
    /**
   * Override the Sound.reset method to clean up properties from the spatial plugin.
   * @param  {Function} _super Sound reset method.
   * @return {Sound}
   */ Sound.prototype.reset = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Reset all spatial plugin properties on this sound.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
            else if (self._panner) {
                // Disconnect the panner.
                self._panner.disconnect(0);
                self._panner = undefined;
                parent._refreshBuffer(self);
            }
            // Complete resetting of the sound.
            return _super.call(this);
        };
    }(Sound.prototype.reset);
    /** Helper Methods **/ /***************************************************************************/ /**
   * Create a new panner node and save it on the sound.
   * @param  {Sound} sound Specific sound to setup panning on.
   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
   */ var setupPanner = function(sound, type) {
        type = type || "spatial";
        // Create the new panner node.
        if (type === "spatial") {
            sound._panner = Howler.ctx.createPanner();
            sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
            sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
            sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
            sound._panner.distanceModel = sound._pannerAttr.distanceModel;
            sound._panner.maxDistance = sound._pannerAttr.maxDistance;
            sound._panner.refDistance = sound._pannerAttr.refDistance;
            sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
            sound._panner.panningModel = sound._pannerAttr.panningModel;
            if (typeof sound._panner.positionX !== "undefined") {
                sound._panner.positionX.setValueAtTime(sound._pos[0], Howler.ctx.currentTime);
                sound._panner.positionY.setValueAtTime(sound._pos[1], Howler.ctx.currentTime);
                sound._panner.positionZ.setValueAtTime(sound._pos[2], Howler.ctx.currentTime);
            } else sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
            if (typeof sound._panner.orientationX !== "undefined") {
                sound._panner.orientationX.setValueAtTime(sound._orientation[0], Howler.ctx.currentTime);
                sound._panner.orientationY.setValueAtTime(sound._orientation[1], Howler.ctx.currentTime);
                sound._panner.orientationZ.setValueAtTime(sound._orientation[2], Howler.ctx.currentTime);
            } else sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
        } else {
            sound._panner = Howler.ctx.createStereoPanner();
            sound._panner.pan.setValueAtTime(sound._stereo, Howler.ctx.currentTime);
        }
        sound._panner.connect(sound._node);
        // Update the connections.
        if (!sound._paused) sound._parent.pause(sound._id, true).play(sound._id, true);
    };
})();



class $cbb64bbf7bdc57e1$var$SoundChannel {
    play(_label, vars) {
        let label = this.Sounds.get(_label);
        if (this.isMuted) {
            if (!this.isMulti) this.current = label;
            return;
        }
        if (!this.isMulti) {
            if (this.current == label) return;
            this.stopCurrent();
        }
        vars = vars || {};
        this.current = label;
        vars.loop = vars.loop || false;
        if (this.id == "voice") vars.rate = 1 + (0, $e3618ffcb6abb3f2$export$2e2bcd8739ae039).decimal(0.08);
        let howl = this.get(label, vars);
        howl.playID = howl.play();
        if (vars.volume) howl.volume(vars.volume);
        if (vars.rate) howl.rate(vars.rate, howl.playID);
        if (this.group == "music") {
            howl.volume(0.2);
            this.fadeIn(howl);
        }
        return howl;
    }
    pause() {
        this.lastPlayed = this.current;
        this.stop();
    }
    resume() {
        if (this.lastPlayed) this.play(this.lastPlayed);
    }
    stop(name) {
        if (name) {
            if (this.pool[name]) this.stopSound(this.pool[name]);
            if (this.current == name) this.current = null;
            return;
        }
        for(name in this.pool)this.stopSound(this.pool[name]);
        this.current = null;
    }
    loop(name, vars) {
        vars = vars || {};
        vars.loop = true;
        return this.play(name, vars);
    }
    playPitch(name, vars) {
        vars = vars || {};
        return this.play(name, (0, $1a1d551abb85861f$export$2e2bcd8739ae039).extract({
            rate: 1.2 + (0, $e3618ffcb6abb3f2$export$2e2bcd8739ae039).spectrumDecimal(0.4)
        }, vars));
    }
    playPitchSmall(name, vars) {
        vars = vars || {};
        return this.play(name, (0, $1a1d551abb85861f$export$2e2bcd8739ae039).extract({
            rate: 1 + (0, $e3618ffcb6abb3f2$export$2e2bcd8739ae039).spectrumDecimal(0.12)
        }, vars));
    }
    mute(bool) {
        if (this.isMuted == Boolean(bool)) return;
        this.isMuted = Boolean(bool);
        if (!this.current) return;
        let label = this.current;
        if (this.isMuted) {
            this.stopCurrent();
            if (this.group == "music") this.current = label;
            return;
        }
        if (this.group != "music") return;
        this.current = null;
        this.play(label);
    }
    /*============================ 




    PLAY, SEARCH, INDEX




    =============================*/ get(label, vars) {
        this.current = label;
        let howl = this.pool[label];
        if (howl) return howl;
        let isMusic = this.group == "music";
        howl = this.pool[label] = new (0, $cc43b7352a965294$export$b791fe48eec8032a)({
            src: [
                this.url + this.id + "/" + label + ".mp3"
            ],
            // html5       : true,
            loop: isMusic || vars.loop,
            autoplay: !this.isMuted,
            volume: isMusic ? 0.2 : 1
        });
        return howl;
    }
    stopCurrent() {
        this.stopSound(this.pool[this.current]);
        this.current = null;
    }
    stopSound(howl) {
        if (!howl) return;
        howl.stop();
    //howl.unload();    
    }
    fadeIn(howl, volume) {
        howl.fade(0, volume || 0.2, 1000, howl.playID);
    }
    fadeOut(howl) {
        howl.fade(0.2, 0, 1000, howl.playID);
    }
    constructor(Sounds, id, group, isMulti){
        this.pool = {};
        this.isMuted = false;
        this.url = "https://supersnappy.io/artlib/audio/";
        this.Sounds = Sounds;
        this.isMulti = isMulti;
        this.id = id;
        this.group = group;
    }
}
var $cbb64bbf7bdc57e1$export$2e2bcd8739ae039 = $cbb64bbf7bdc57e1$var$SoundChannel;




class $cda3552f150d130c$var$Sounds {
    addChannel(id, b, c) {
        let channel = this.channels[id] = new (0, $cbb64bbf7bdc57e1$export$2e2bcd8739ae039)(this, id, b, c);
        return channel;
    }
    setVolume(vol) {
        (0, $cc43b7352a965294$export$c9d39ca3bcd93abb).volume(vol);
    // if( vol === 0 ) return Howler.mute( true );
    // if( !this.isMuted ) Howler.mute( false );
    }
    mute() {
        this.isMuted = true;
    }
    unmute() {
        this.isMuted = false;
        (0, $cc43b7352a965294$export$c9d39ca3bcd93abb).mute(false);
    }
    resetMappings() {
        this.mappings = {};
    }
    init(vars) {
        this.isInitialized = true;
        this.stop();
        this.resetMappings();
        if (!vars) return;
        for(let key in vars)this.set(key, vars[key]);
    }
    set(key, array) {
        let cue = this.mappings[key] = new (0, $1a25aa5249685cf1$export$2e2bcd8739ae039)(true);
        cue.copy(array);
    }
    get(key) {
        let cue = this.mappings[key];
        return cue ? cue.get() : key;
    }
    stop() {
        this.SFX.stop();
        this.Voice.stop();
        this.Music.stop();
        this.Ambiance.stop();
    }
    constructor(){
        this.channels = {};
        this.isMuted = false;
        this.mappings = {};
        this.isInitialized = false;
        this.SFX = this.addChannel("sfx", "sound", true);
        this.Voice = this.addChannel("voice", "sound", true);
        this.Music = this.addChannel("music", "music", false);
        this.Ambiance = this.addChannel("amb", "music", false);
        (0, $cc43b7352a965294$export$c9d39ca3bcd93abb).autoUnlock = true;
        (0, $cc43b7352a965294$export$c9d39ca3bcd93abb).html5PoolSize = 100;
    }
}
var $cda3552f150d130c$export$2e2bcd8739ae039 = $cda3552f150d130c$var$Sounds;






class $9d2f9b935083c015$var$Snappy {
    async set(data) {
        var value = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).SNAPPY_SET, {
            avatarID: this.avatarID,
            data: data
        });
        this.conquer.Signal.set("SNAPPY:onSet", value);
        return Promise.resolve(this.fill(value));
    }
    async get() {
        if (this.isFilled) return Promise.resolve(this.data);
        var value = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).SNAPPY_GETONE, {
            avatarID: this.avatarID
        });
        return Promise.resolve(this.fill(value));
    }
    fill(vars) {
        if (vars) {
            (0, $1a1d551abb85861f$export$2e2bcd8739ae039).extract(vars, this.data);
            if (vars.userPhoto) this.avatar.userPhoto = this.userPhoto = vars.userPhoto;
        }
        this.data.userPhoto = this.userPhoto;
        this.data.fullName = this.fullName;
        this.data.avatarID = this.avatarID;
        this.body = this.data.body;
        this.snappyFace = this.data.snappyFace;
        this.parts = this.data.parts;
        this.isFilled = true;
        return this.data;
    }
    constructor(instance, avatar){
        this.data = {
            color: {},
            parts: {
                Mouth: {
                    "asset": "mouth_001"
                }
            },
            body: "m",
            snappyFace: null,
            userPhoto: null
        };
        this.isFilled = false;
        this.conquer = instance;
        this.fullName = avatar.fullName;
        this.avatarID = avatar.avatarID;
        this.userPhoto = avatar.userPhoto;
        this.avatar = avatar;
    }
}
var $9d2f9b935083c015$export$2e2bcd8739ae039 = $9d2f9b935083c015$var$Snappy;


class $c237781819e1648d$var$AvatarInstance {
    fill(vars) {
        if (vars.firstName && vars.firstName.includes("_GUEST")) vars.firstName = "GUEST";
        this.avatarID = vars._id || vars.avatarID || this.avatarID;
        this.name = vars.name || this.name;
        this.firstName = this.name.split(" ")[0];
        this.lastName = this.name.split(" ")[1] || this.lastName;
        this.userPhoto = vars.userPhoto || this.userPhoto;
        this.isBot = vars.isBot || false;
        this.type = vars.type || "";
        this.bio = vars.bio || this.bio;
        this.username = vars.username || this.username;
        this.fullName = vars.name;
        this.following = vars.following || 0;
        // LOG.log("Avatar!", this.firstName, vars.name ); 
        this.resetVars();
    }
    async set() {
        let membership = await this.conquer.Friends.set(this.avatarID);
        return Promise.resolve(membership);
    }
    resetVars() {
        let vars = this.vars;
        vars.x = 0;
        vars.y = 0;
        vars.z = 0;
        vars.firstName = this.firstName;
        vars.userPhoto = this.userPhoto;
        vars.avatarID = this.avatarID;
        vars.fullName = this.fullName;
    }
    async change(vars) {
        vars.avatarID = this.avatarID;
        this.fill(vars);
        return this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).AVATAR_CHANGE, vars);
    }
    constructor(conquer, vars){
        this.firstName = "";
        this.lastName = "";
        this.userPhoto = "User.png";
        this.bio = "";
        this.isBot = false;
        this.vars = {};
        this.type = "";
        this.name = "Player";
        this.fullName = "Plater";
        this.following = 0;
        this.username = "";
        this.conquer = conquer;
        this.fill(vars);
        this.Snappy = new (0, $9d2f9b935083c015$export$2e2bcd8739ae039)(conquer, this);
    }
}
var $c237781819e1648d$export$2e2bcd8739ae039 = $c237781819e1648d$var$AvatarInstance;


class $4e44475405793673$var$Avatars {
    init() {
        this.ME = this.pushInstance(this.conquer.User);
    }
    /*=============== 


    GET
    get() - get all, set conquer.Room.pool
    get('avatarID1')
    get(['avatarID1','avatarID2'])

    ================*/ async get(vars) {
        if (!vars) return;
        if (typeof vars == "string") {
            if (this.data[vars]) return Promise.resolve(this.data[vars]);
            let value = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).AVATAR_GETONE, {
                _id: vars
            });
            return Promise.resolve(this.pushInstance(value));
        }
        var n;
        return Promise.resolve();
    }
    async load(avatarID, callback) {
        if (this.data[avatarID]) return callback(this.data[avatarID]);
        let isLoading = this.listeners[avatarID];
        if (!isLoading) this.listeners[avatarID] = [];
        this.listeners[avatarID].push(callback);
        if (isLoading) return;
        let value = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).AVATAR_GETONE, {
            _id: avatarID
        });
        let Avatar = this.pushInstance(value);
        for(let n in this.listeners[avatarID])this.listeners[avatarID][n](Avatar);
    }
    pushInstance(vars) {
        if (this.data[vars.avatarID]) return this.data[vars.avatarID];
        let instance = new (0, $c237781819e1648d$export$2e2bcd8739ae039)(this.conquer, vars);
        this.pool.push(instance);
        this.data[instance.avatarID] = instance;
        return instance;
    }
    /*=============== 


    SET
    

  ================*/ async set(toFollowID) {
        var friendship = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).FOLLOWERS_SET, {
            toFollowID: toFollowID
        });
        return Promise.resolve(friendship);
    }
    async setUserPhoto(userPhoto) {
        let response = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).AVATAR_PHOTO_SET, {
            avatarID: this.conquer.User.avatarID,
            userPhoto: userPhoto
        });
        //if( !response.error ) this.conquer.User.userPhoto = `${response}?${Date.now()}`;
        return response;
    }
    async getUserPhoto() {
        return await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).AVATAR_PHOTO_GET, {
            avatarID: this.conquer.User.avatarID
        });
    }
    constructor(conquer){
        this.pool = [];
        this.data = {};
        this.ME = {};
        this.listeners = {};
        this.conquer = conquer;
    }
}
var $4e44475405793673$export$2e2bcd8739ae039 = $4e44475405793673$var$Avatars;





class $1ac573b73118d914$var$Bots {
    init() {}
    /*=============== 


  GET

  Gets 200 bots


  ================*/ async get(amount) {
        if (this.isLoaded) return Promise.resolve(this.doGet(amount));
        this.cue.clear();
        let array = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).BOT_GET);
        let bots = [];
        for(var n in array)bots.push(this.conquer.Avatars.pushInstance(array[n]));
        this.cue.copy(bots);
        this.isLoaded = true;
        return Promise.resolve(this.doGet(amount));
    }
    doGet(amount) {
        if (!amount) return this.cue._pool;
        let output = [];
        while(output.length < amount)(0, $1a1d551abb85861f$export$2e2bcd8739ae039).pushUnique(output, this.cue.get());
        return output;
    }
    constructor(conquer){
        this.cue = new (0, $1a25aa5249685cf1$export$2e2bcd8739ae039)(true);
        this.data = {};
        this.isLoaded = false;
        this.conquer = conquer;
    }
}
var $1ac573b73118d914$export$2e2bcd8739ae039 = $1ac573b73118d914$var$Bots;



class $8fc06295c541b9b2$var$Email {
    async init() {
        return Promise.resolve();
    }
    async sendEmail(args) {
        let response = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).EMAIL_SEND, args);
        return Promise.resolve();
    }
    async change(email) {
        return this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).EMAIL_CHANGE, {
            email: email
        });
    }
    async getOne() {
        return this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).EMAIL_GETONE, {});
    }
    async exists(email) {
        return this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).EMAIL_EXISTS, {
            email: email,
            isVerified: true
        });
    }
    constructor(instance){
        this.conquer = instance;
    }
}
var $8fc06295c541b9b2$export$2e2bcd8739ae039 = $8fc06295c541b9b2$var$Email;



class $1d2c7303b57839e8$var$Haptic {
    init() {
        let obj = navigator;
        if (!obj) return;
        this.isAllowed = obj.vibrate || obj.webkitVibrate || obj.mozVibrate || obj.msVibrate;
    }
    setEnabled(bool) {
        this.isEnabled = bool;
    }
    vibrate(value) {
        if (!this.isAllowed || !this.isEnabled) return;
        navigator.vibrate(value);
    }
    long() {
        this.vibrate(1000);
    }
    medium() {
        this.vibrate(250);
    }
    short() {
        this.vibrate(50);
    }
    mini() {
        this.vibrate(25);
    }
    stop() {
        this.vibrate(0);
    }
    // EFFECTS: Fade In
    fadeIn(duration) {
        duration = duration || 1000;
        var pulses = [], d, i;
        if (duration < 100) pulses = duration;
        else {
            d = duration / 100;
            for(i = 1; i <= 10; i += 1){
                pulses.push(i * d);
                if (i < 10) pulses.push((10 - i) * d);
            }
        }
        this.vibrate(pulses);
    }
    // EFFECTS: Fade Out
    fadeOut(duration) {
        duration = duration || 1000;
        var pulses = [], d, i;
        if (duration < 100) pulses = duration;
        else {
            d = duration / 100;
            for(i = 1; i <= 10; i += 1){
                pulses.push(i * d);
                if (i < 10) pulses.push((10 - i) * d);
            }
            pulses.reverse();
        }
        this.vibrate(pulses);
    }
    // EFFECTS: notification
    notification(duration) {
        var pause, dot, dash;
        duration = duration || 1000;
        pause = duration / 27;
        dot = 2 * pause;
        dash = 3 * pause;
        this.vibrate([
            dot,
            pause,
            dot,
            pause,
            dot,
            pause * 2,
            dash,
            pause,
            dash,
            pause * 2,
            dot,
            pause,
            dot,
            pause,
            dot
        ]);
    }
    // EFFECTS: heartbeat
    heartBeat(duration) {
        var pause, dot, dash;
        duration = duration || 500;
        dot = duration / 60;
        pause = dot * 2;
        dash = dot * 24;
        this.vibrate([
            dot,
            pause,
            dash,
            pause * 2,
            dash,
            pause * 2,
            dot
        ]);
    }
    // EFFECTS: clunk
    clunk(duration) {
        var pause, dot, dash;
        duration = duration || 500;
        dot = duration * 4 / 22;
        pause = dot * 2;
        dash = dot / 2 * 5;
        this.vibrate([
            dot,
            pause,
            dash
        ]);
    }
    constructor(){
        this.isAllowed = false;
        this.isEnabled = true;
        if (typeof window == "undefined") return;
        this.init();
    }
}
var $1d2c7303b57839e8$export$2e2bcd8739ae039 = $1d2c7303b57839e8$var$Haptic;


const $59f1eccc1bab51c1$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $59f1eccc1bab51c1$export$2e2bcd8739ae039 = {
    randomUUID: $59f1eccc1bab51c1$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $a95f55cc0d514475$var$getRandomValues;
const $a95f55cc0d514475$var$rnds8 = new Uint8Array(16);
function $a95f55cc0d514475$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$a95f55cc0d514475$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $a95f55cc0d514475$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$a95f55cc0d514475$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $a95f55cc0d514475$var$getRandomValues($a95f55cc0d514475$var$rnds8);
}


var $e3ab9a51f3837379$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $53b03c6bdb19eff9$var$validate(uuid) {
    return typeof uuid === "string" && (0, $e3ab9a51f3837379$export$2e2bcd8739ae039).test(uuid);
}
var $53b03c6bdb19eff9$export$2e2bcd8739ae039 = $53b03c6bdb19eff9$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $f89b840e5e6f2ec4$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$f89b840e5e6f2ec4$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $f89b840e5e6f2ec4$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $f89b840e5e6f2ec4$var$byteToHex[arr[offset + 0]] + $f89b840e5e6f2ec4$var$byteToHex[arr[offset + 1]] + $f89b840e5e6f2ec4$var$byteToHex[arr[offset + 2]] + $f89b840e5e6f2ec4$var$byteToHex[arr[offset + 3]] + "-" + $f89b840e5e6f2ec4$var$byteToHex[arr[offset + 4]] + $f89b840e5e6f2ec4$var$byteToHex[arr[offset + 5]] + "-" + $f89b840e5e6f2ec4$var$byteToHex[arr[offset + 6]] + $f89b840e5e6f2ec4$var$byteToHex[arr[offset + 7]] + "-" + $f89b840e5e6f2ec4$var$byteToHex[arr[offset + 8]] + $f89b840e5e6f2ec4$var$byteToHex[arr[offset + 9]] + "-" + $f89b840e5e6f2ec4$var$byteToHex[arr[offset + 10]] + $f89b840e5e6f2ec4$var$byteToHex[arr[offset + 11]] + $f89b840e5e6f2ec4$var$byteToHex[arr[offset + 12]] + $f89b840e5e6f2ec4$var$byteToHex[arr[offset + 13]] + $f89b840e5e6f2ec4$var$byteToHex[arr[offset + 14]] + $f89b840e5e6f2ec4$var$byteToHex[arr[offset + 15]];
}
function $f89b840e5e6f2ec4$var$stringify(arr, offset = 0) {
    const uuid = $f89b840e5e6f2ec4$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $53b03c6bdb19eff9$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $f89b840e5e6f2ec4$export$2e2bcd8739ae039 = $f89b840e5e6f2ec4$var$stringify;


function $913b3c31dff5764b$var$v4(options, buf, offset) {
    if ((0, $59f1eccc1bab51c1$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $59f1eccc1bab51c1$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $a95f55cc0d514475$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $f89b840e5e6f2ec4$export$8fb373d660548968)(rnds);
}
var $913b3c31dff5764b$export$2e2bcd8739ae039 = $913b3c31dff5764b$var$v4;


class $b5b9cba8e33659d4$var$Ads {
    onMessageToWebviewReceived(endpoint, message) {
        var result = JSON.parse(message);
        console.log("this", this);
        if (endpoint == `adsLoadRewarded`) this.isRewardedLoaded = result;
        else if (endpoint == `adsShowRewarded`) this.isRewardedLoaded = result;
        else if (endpoint == `adsLoadInterstitial`) this.isInterstitialLoaded = result;
        else if (endpoint == `adsShowInterstitial`) this.isInterstitialLoaded = result;
    }
    async loadInterstitial() {
        if (typeof window == "undefined") return Promise.resolve({
            result: false,
            error: new Error(`window is not defined`)
        });
        if (!this.isEventRegistered && typeof window.onMessageToWebviewReceived != "undefined") {
            window.onMessageToWebviewReceived.push((endpoint, message)=>{
                window.conquer.Ads.onMessageToWebviewReceived(endpoint, message);
            });
            window.conquer.Ads.isEventRegistered = true;
        }
        if (this.isInterstitialLoaded) return Promise.resolve({
            result: false,
            error: new Error(`[ads] interstitial ads  is already loaded`)
        });
        if (this.conquer.currentPlatform == "Android") {
            // HACK : prevent ads actually being called
            // this.isInterstitialLoaded = true;
            // return Promise.resolve({ result: true });
            if (typeof window.adsLoadInterstitial == "undefined") return Promise.resolve({
                result: false,
                error: new Error(`[ads] ${this.conquer.currentPlatform} is not implemented`)
            });
            let output = await window.adsLoadInterstitial();
            this.isInterstitialLoaded = output.result;
            return Promise.resolve({
                result: output.result,
                error: output.error
            });
        } else if (this.conquer.currentPlatform == "Web") // return this.adsAdsenseLoad('Interstitial');
        return this.adsApplixirLoad("Interstitial");
        else if (this.conquer.currentPlatform == "iOS") return Promise.resolve({
            result: false,
            error: new Error(`[ads] ${this.conquer.currentPlatform} is not implemented`)
        });
        else return Promise.resolve({
            result: false,
            error: new Error(`[ads] ${this.conquer.currentPlatform} is not recognized`)
        });
    }
    async showInterstitial() {
        if (typeof window == "undefined") return Promise.resolve({
            result: false,
            error: new Error(`window is not defined`)
        });
        if (!this.isEventRegistered && typeof window.onMessageToWebviewReceived != "undefined") {
            window.onMessageToWebviewReceived.push((endpoint, message)=>{
                var w = window;
                w.conquer.Ads.onMessageToWebviewReceived(endpoint, message);
            });
            window.conquer.Ads.isEventRegistered = true;
        }
        if (!this.isInterstitialLoaded) return Promise.resolve({
            result: false,
            error: new Error(`[ads] interstitial ads  is not yet loaded`)
        });
        if (this.conquer.currentPlatform == "Android") {
            // HACK : prevent ads actually being called
            // this.isInterstitialLoaded = false;
            // return Promise.resolve({ result: true });
            if (typeof window.adsShowInterstitial == "undefined") return Promise.resolve({
                result: false,
                error: new Error(`[ads] ${this.conquer.currentPlatform} is not implemented`)
            });
            let output = await window.adsShowInterstitial();
            this.isInterstitialLoaded = !output.result;
            return Promise.resolve({
                result: output.result,
                error: output.error
            });
        } else if (this.conquer.currentPlatform == "Web") // return this.adsAdsenseShow('Interstitial');
        return this.adsApplixirShow("Interstitial");
        else if (this.conquer.currentPlatform == "iOS") return Promise.resolve({
            result: false,
            error: new Error(`[ads] ${this.conquer.currentPlatform} is not implemented`)
        });
        else return Promise.resolve({
            result: false,
            error: new Error(`[ads] ${this.conquer.currentPlatform} is not recognized`)
        });
    }
    async loadRewarded() {
        if (typeof window == "undefined") return Promise.resolve({
            result: false,
            error: new Error(`window is not defined`)
        });
        if (!this.isEventRegistered && typeof window.onMessageToWebviewReceived != "undefined") {
            window.onMessageToWebviewReceived.push((endpoint, message)=>{
                var w = window;
                w.conquer.Ads.onMessageToWebviewReceived(endpoint, message);
            });
            window.conquer.Ads.isEventRegistered = true;
        }
        if (this.isRewardedLoaded) {
            if (this.conquer.currentPlatform == "Web") return Promise.resolve({
                result: true
            });
            return Promise.resolve({
                result: false,
                error: new Error(`[ads] rewarded ads is already loaded`)
            });
        }
        if (this.conquer.currentPlatform == "Android") {
            // HACK : prevent ads actually being called
            // this.isRewardedLoaded = true;
            // return Promise.resolve({ result: true });
            if (typeof window.adsLoadRewarded == "undefined") return Promise.resolve({
                result: false,
                error: new Error(`[ads] ${this.conquer.currentPlatform} is not implemented`)
            });
            let output = await window.adsLoadRewarded();
            this.isRewardedLoaded = output.result;
            return Promise.resolve({
                result: output.result,
                error: output.error
            });
        } else if (this.conquer.currentPlatform == "Web") // return this.adsAdsenseLoad('Rewarded');
        return this.adsApplixirLoad("Rewarded");
        else if (this.conquer.currentPlatform == "iOS") return Promise.resolve({
            result: false,
            error: new Error(`[ads] ${this.conquer.currentPlatform} is not implemented`)
        });
        else return Promise.resolve({
            result: false,
            error: new Error(`[ads] ${this.conquer.currentPlatform} is not recognized`)
        });
    }
    async showRewarded() {
        if (typeof window == "undefined") return Promise.resolve({
            result: false,
            error: new Error(`window is not defined`)
        });
        if (!this.isEventRegistered && typeof window.onMessageToWebviewReceived != "undefined") {
            window.onMessageToWebviewReceived.push((endpoint, message)=>{
                var w = window;
                w.conquer.Ads.onMessageToWebviewReceived(endpoint, message);
            });
            window.conquer.Ads.isEventRegistered = true;
        }
        if (!this.isRewardedLoaded) return Promise.resolve({
            result: false,
            error: new Error(`[ads] rewarded ads is not yet loaded`)
        });
        if (this.conquer.currentPlatform == "Android") {
            // HACK : prevent ads actually being called
            // this.isRewardedLoaded = false;
            // return Promise.resolve({ result: true });
            if (typeof window.adsShowRewarded == "undefined") return Promise.resolve({
                result: false,
                error: new Error(`[ads] ${this.conquer.currentPlatform} is not implemented`)
            });
            let output = await window.adsShowRewarded();
            this.isRewardedLoaded = !output.result;
            return Promise.resolve({
                result: output.result,
                error: output.error
            });
        } else if (this.conquer.currentPlatform == "Web") // return this.adsAdsenseShow('Rewarded');
        return this.adsApplixirShow("Rewarded");
        else if (this.conquer.currentPlatform == "iOS") return Promise.resolve({
            result: false,
            error: new Error(`[ads] ${this.conquer.currentPlatform} is not implemented`)
        });
        else return Promise.resolve({
            result: false,
            error: new Error(`[ads] ${this.conquer.currentPlatform} is not recognized`)
        });
    }
    get adsApplixirInstance() {
        return (async ()=>{
            if (!this._adsApplixirInstance) {
                console.log("init applixir");
                await new Promise((resolve, reject)=>{
                    var applixirIFrame = document.createElement("iframe");
                    applixirIFrame.id = "applixir_parent";
                    applixirIFrame.setAttribute("allow", "autoplay; fullscreen");
                    var applixirDiv = document.createElement("div");
                    applixirDiv.id = "applixir_vanishing_div";
                    applixirDiv.setAttribute("style", "z-index: 9999;");
                    applixirDiv.hidden = true;
                    applixirDiv.append(applixirIFrame);
                    var applixirFrameTop = document.createElement("div");
                    applixirFrameTop.id = "applixir_frame_top";
                    applixirFrameTop.setAttribute("style", "z-index:20000; position:absolute; background-color:#888; width:100%; height:calc((100% - 430px) / 2); top:0;");
                    applixirFrameTop.hidden = true;
                    applixirFrameTop.onclick = (event)=>{
                        event.stopPropagation();
                    };
                    var applixirFrameBottom = document.createElement("div");
                    applixirFrameBottom.id = "applixir_frame_bottom";
                    applixirFrameBottom.setAttribute("style", "z-index:20000; position:absolute; background-color:#888; width:100%; height:calc((100% - 430px) / 2); bottom:-25px;");
                    applixirFrameBottom.hidden = true;
                    applixirFrameBottom.onclick = (event)=>{
                        event.stopPropagation();
                    };
                    var applixirFrameLeft = document.createElement("div");
                    applixirFrameLeft.id = "applixir_frame_left";
                    applixirFrameLeft.setAttribute("style", "z-index:20000; position:absolute; background-color:#888; width:calc((100% - 640px) / 2); height:100%; left:-20px;");
                    applixirFrameLeft.hidden = true;
                    applixirFrameLeft.onclick = (event)=>{
                        event.stopPropagation();
                    };
                    var applixirFrameRight = document.createElement("div");
                    applixirFrameRight.id = "applixir_frame_right";
                    applixirFrameRight.setAttribute("style", "z-index:20000; position:absolute; background-color:#888; width:calc((100% - 640px) / 2); height:100%; right:0px;");
                    applixirFrameRight.hidden = true;
                    applixirFrameRight.onclick = (event)=>{
                        event.stopPropagation();
                    };
                    document.body.prepend(applixirDiv);
                    document.body.append(applixirFrameTop);
                    document.body.append(applixirFrameBottom);
                    document.body.append(applixirFrameLeft);
                    document.body.append(applixirFrameRight);
                    var applixirScript = document.createElement("script");
                    applixirScript.type = "text/javascript";
                    applixirScript.src = "https://cdn.applixir.com/applixir.sdk3.0m.js";
                    applixirScript.async = true;
                    applixirScript.defer = true;
                    applixirScript.onload = ()=>{
                        console.log("applixir loaded!");
                        resolve();
                    };
                    console.log("applixir load...");
                    document.body.appendChild(applixirScript);
                });
                var zoneId = 2050; // test applixir's 
                // var zoneId:number = 5667; // garibaldy's
                var gameId = 7840; // garibaldy's
                var onAdStatus = (status)=>{
                    // This can contain whatever code you like. The err parameter will return the 
                    // following values (see online documentation for other values):
                    //	'ad-blocker' = an ad blocker was detected
                    //	'network-error' = network connection not available
                    //  'cors-error' = cross-origin error (try clearing browser cache)
                    //  'no-zoneId' = the required zoneId value is missing
                    //	'ad-watched' = an ad was presented and ran for more than 5 seconds
                    //	'ad-interrupted' = ad was ended prior to 5 seconds (abnormal end)
                    //	'ads-unavailable' = no ads were returned to the player
                    if (status != undefined) console.log("Applixir status: " + status);
                    if (status == "ad-watched" || status == "fb-watched") {
                        this.adApplixirRawResult = status;
                        this.adApplixirResult = "Watched";
                    } else if (status == "ad-interrupted") {
                        this.adApplixirRawResult = status;
                        this.adApplixirResult = "Skipped";
                    } else if (status == "ads-unavailable") {
                        this.adApplixirRawResult = status;
                        this.adApplixirResult = "Unavailable";
                    } else if (status == "cors-error" || status == "network-error" || status == "ad-blocker" || status == "no-zoneId") {
                        this.adApplixirRawResult = status;
                        this.adApplixirResult = "Error";
                    }
                };
                var options = {
                    zoneId: zoneId,
                    gameId: gameId,
                    userId: this.uuid,
                    adStatusCb: onAdStatus
                };
                var loadAd = async (adType)=>{
                    console.log("load ad applixir");
                    if (adType == "Interstitial") this.isInterstitialLoaded = true;
                    else if (adType == "Rewarded") this.isRewardedLoaded = true;
                    this.adApplixirResult = "Wait";
                    return Promise.resolve({
                        result: true
                    });
                };
                var showAd = async (adType)=>{
                    console.log("show ad applixir");
                    document.getElementById("applixir_frame_top").hidden = false;
                    document.getElementById("applixir_frame_bottom").hidden = false;
                    document.getElementById("applixir_frame_left").hidden = false;
                    document.getElementById("applixir_frame_right").hidden = false;
                    window.invokeApplixirVideoUnit(options);
                    await new Promise((resolve, reject)=>{
                        if (adType == "Interstitial") this.isInterstitialLoaded = false;
                        else if (adType == "Rewarded") this.isRewardedLoaded = false;
                        var interval = setInterval(()=>{
                            if (this.adApplixirResult != "Wait") {
                                clearInterval(interval);
                                resolve();
                            }
                        }, 500);
                    });
                    document.getElementById("applixir_frame_top").hidden = true;
                    document.getElementById("applixir_frame_bottom").hidden = true;
                    document.getElementById("applixir_frame_left").hidden = true;
                    document.getElementById("applixir_frame_right").hidden = true;
                    if (this.adApplixirResult == "Watched") return Promise.resolve({
                        result: true
                    });
                    else {
                        var error = new Error(`${this.adApplixirResult} ${this.adApplixirRawResult}`);
                        return Promise.resolve({
                            result: false,
                            error: error
                        });
                    }
                };
                this._adsApplixirInstance = {
                    load: loadAd,
                    show: showAd
                };
            }
            return Promise.resolve(this._adsApplixirInstance);
        })();
    }
    async adsApplixirLoad(adType) {
        let output = await this.adsApplixirInstance;
        if (!output) return Promise.resolve({
            result: false,
            error: new Error(`adsApplixirInstance is not defined`)
        });
        return output.load(adType);
    }
    async adsApplixirShow(adType) {
        let output = await this.adsApplixirInstance;
        if (!output) return Promise.resolve({
            result: false,
            error: new Error(`adsApplixirInstance is not defined`)
        });
        return output.show(adType);
    }
    async adsAdmob() {
        if (typeof window == "undefined") return Promise.resolve();
        let w = window;
        if (!this.adsAdmobInstance) {
            console.log("init admob");
            var adUnitId = "ca-app-pub-3940256099942544/5224354917"; // demo google
            // var adUnitId = 'ca-app-pub-8639500763810556/5776030071'; // actual ad unit id
            this.adsAdmobInstance = new w.admob.RewardedAd({
                adUnitId: adUnitId
            });
            this.adsAdmobInstance.on("load", async (evt)=>{
                // Once a rewarded ad is shown, it cannot be shown again.
                // Starts loading the next rewarded ad as soon as it is dismissed.
                this.loadedNetwork = "AdMob";
                console.log("Admob loaded");
                console.log(evt);
            });
            this.adsAdmobInstance.on("loadfail", async (evt)=>{
                this.loadedNetwork = "None";
                console.log("Admob fail to load");
                console.log(evt);
            });
            this.adsAdmobInstance.on("show", async (evt)=>{
                console.log("Admob shown");
                console.log(evt);
            });
            this.adsAdmobInstance.on("showfail", async (evt)=>{
                console.log("Admob fail to show");
                console.log(evt);
            });
            this.adsAdmobInstance.on("reward", async (evt)=>{
                console.log("Admob reward");
                console.log(evt);
            });
            this.adsAdmobInstance.on("dismiss", async (evt)=>{
                console.log("Admob dismiss");
                console.log(evt);
            });
            this.adsAdmobInstance.on("impression", async (evt)=>{
                console.log("Admob impression");
                console.log(evt);
            });
        }
        await this.adsAdmobInstance.load();
    }
    get adsAdsenseInstance() {
        return (async ()=>{
            if (!this._adsAdsenseInstance) {
                console.log("[ads] init adsense 1", this._adsAdsenseInstance);
                var publisherId = "ca-pub-9296671723525300";
                // var adSlotId:string = "6925757303";
                var adSlotId = "7699405620";
                await new Promise((resolve, reject)=>{
                    var testObj = document.createElement("div");
                    document.body.appendChild(testObj);
                    setTimeout(()=>{
                        resolve();
                    }, 100);
                });
                await new Promise((resolve, reject)=>{
                    var adsenseObj = document.createElement("ins");
                    adsenseObj.style.display = "block";
                    adsenseObj.style.width = "728px";
                    adsenseObj.style.height = "90px";
                    adsenseObj.className = "adsbygoogle";
                    adsenseObj.setAttribute("data-ad-client", publisherId);
                    adsenseObj.setAttribute("data-ad-slot", adSlotId);
                    adsenseObj.setAttribute("data-ad-format", "auto");
                    adsenseObj.setAttribute("data-full-width-responsive", "true");
                    // adsenseObj.setAttribute('data-adtest', 'on'); // indicates testing
                    document.body.appendChild(adsenseObj);
                    setTimeout(()=>{
                        console.log("adsense obj loaded!");
                        resolve();
                    }, 100);
                });
                await new Promise((resolve, reject)=>{
                    var adsenseScript = document.createElement("script");
                    adsenseScript.type = "text/javascript";
                    adsenseScript.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${publisherId}`;
                    adsenseScript.async = true;
                    adsenseScript.defer = true;
                    adsenseScript.setAttribute("crossorigin", "anonymous");
                    adsenseScript.setAttribute("data-adbreak-test", "on"); // indicates testing
                    adsenseScript.onload = ()=>{
                        console.log("adsense script loaded!");
                        resolve();
                    };
                    document.head.appendChild(adsenseScript);
                });
                await new Promise((resolve, reject)=>{
                    window.adsbygoogle = window.adsbygoogle || [];
                    window.adBreak = window.adConfig = (o)=>{
                        window.adsbygoogle.push(o);
                    };
                    resolve();
                });
                var showAd = async (adType)=>{
                    console.log(`adsense show`);
                    try {
                        let output = await new Promise((resolve, reject)=>{
                            var adBreakOption = {
                                adBreakDone: (evt)=>{
                                    // console.log('adBreakDone', evt);
                                    if (adType == "Interstitial") this.isInterstitialLoaded = false;
                                    else if (adType == "Rewarded") this.isRewardedLoaded = false;
                                    if (evt.breakStatus == "viewed") {
                                        this.adSenseRetried = false;
                                        resolve({
                                            result: evt.breakStatus == "viewed",
                                            error: evt.breakStatus == "viewed" ? undefined : new Error(`[ads] ads cannot be shown: ${evt.breakStatus}`)
                                        });
                                    }
                                    if (evt.breakStatus == "frequencyCapped" && !this.adSenseRetried) {
                                        this.adSenseRetried = true;
                                        loadAd(adType).then(()=>{
                                            showAd(adType).then(resolve);
                                        });
                                        resolve({
                                            result: evt.breakStatus == "frequencyCapped",
                                            error: new Error(`[ads] ads cannot be shown: ${evt.breakStatus}`)
                                        });
                                    } else resolve({
                                        result: evt.breakStatus == "viewed",
                                        error: evt.breakStatus == "viewed" ? undefined : new Error(`[ads] ads cannot be shown: ${evt.breakStatus}`)
                                    });
                                },
                                beforeAd: ()=>{
                                // console.log(`beforeAd`);
                                },
                                afterAd: ()=>{
                                // console.log(`afterAd`);
                                }
                            };
                            if (adType == "Interstitial") adBreakOption.type = "start";
                            else if (adType == "Rewarded") {
                                adBreakOption.type = "reward";
                                adBreakOption.beforeReward = (showAds)=>{
                                    // console.log(`beforeReward`);
                                    showAds();
                                };
                                adBreakOption.adDismissed = ()=>{
                                // console.log(`adDismissed`);
                                };
                                adBreakOption.adViewed = ()=>{
                                // console.log(`adViewed`);
                                };
                            }
                            window.adBreak(adBreakOption);
                        });
                        return Promise.resolve(output);
                    } catch (err) {
                        return Promise.resolve({
                            result: false,
                            error: err
                        });
                    }
                };
                var loadAd = async (adType)=>{
                    console.log(`adsense load`);
                    try {
                        if (this._adsAdsenseInstance.isNew) await new Promise((resolve, reject)=>{
                            var adConfigOption = {
                                preloadAdBreaks: "on",
                                onReady: (evt)=>{
                                    // console.log('loadAdDone', evt);
                                    this.loadedNetwork = "AdSense";
                                    resolve();
                                }
                            };
                            window.adConfig(adConfigOption);
                        });
                        if (adType == "Interstitial") this.isInterstitialLoaded = true;
                        else if (adType == "Rewarded") this.isRewardedLoaded = true;
                        this._adsAdsenseInstance.isNew = false;
                        return Promise.resolve({
                            result: true
                        });
                    } catch (err) {
                        return Promise.resolve({
                            result: false,
                            error: err
                        });
                    }
                };
                this._adsAdsenseInstance = {
                    load: loadAd,
                    show: showAd,
                    isNew: true
                };
            }
            return Promise.resolve(this._adsAdsenseInstance);
        })();
    }
    async adsAdsenseLoad(adType) {
        let output = await this.adsAdsenseInstance;
        if (!output) return Promise.resolve({
            result: false,
            error: new Error(`adsAdsenseInstance is not defined`)
        });
        return output.load(adType);
    }
    async adsAdsenseShow(adType) {
        let output = await this.adsAdsenseInstance;
        if (!output) return Promise.resolve({
            result: false,
            error: new Error(`adsAdsenseInstance is not defined`)
        });
        return output.show(adType);
    }
    async get() {
        if (typeof window != "undefined") {
            if (this.conquer.currentPlatform == "Web") {
                if (this.loadedNetwork == "None") await this.adsAdsenseLoad("Interstitial");
                return Promise.resolve(this.loadedNetwork != "None");
            } else if (this.conquer.currentPlatform == "Android" || this.conquer.currentPlatform == "iOS") {
                if (this.loadedNetwork == "None") await this.adsAdmob();
                return Promise.resolve(this.loadedNetwork != "None");
            }
        }
        return Promise.resolve(false);
    }
    async set() {
        if (typeof window != "undefined") {
            if (this.loadedNetwork == "AdMob") {
                await this.adsAdmobInstance.show();
                return Promise.resolve(true);
            } else if (this.loadedNetwork == "AdSense") // await this.adsAdsenseInstance!.show();
            return Promise.resolve(true);
            else if (this.loadedNetwork == "Applixir") // await this.adsApplixirInstance!.show();
            return Promise.resolve(true);
        }
        return Promise.resolve(false);
    }
    constructor(conquer){
        this.adSenseRetried = false;
        this.adApplixirResult = "Wait";
        this.conquer = conquer;
        this.uuid = (0, $913b3c31dff5764b$export$2e2bcd8739ae039)();
        this.isInterstitialLoaded = false;
        this.isRewardedLoaded = false;
        this.isEventRegistered = false;
        console.log(`uuid: ${this.uuid}`);
        this.loadedNetwork = "None";
    }
}
var $b5b9cba8e33659d4$export$2e2bcd8739ae039 = $b5b9cba8e33659d4$var$Ads;



class $908eb8dc23d2f250$var$Share {
    async get(params) {
        return await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).SHARE_GET, params);
    }
    async getOne(params) {
        return await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).SHARE_GETONE, params);
    }
    async set(params) {
        return await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).SHARE_GET, params);
    }
    // OLD CODE NOW:
    share(title, text, url, bitmapData) {
        if (typeof window == "undefined") return;
        if (this.conquer.currentPlatform != "Android" && this.conquer.currentPlatform != "iOS") {
            if (typeof window.share == "undefined") return Promise.resolve({
                result: false,
                error: new Error(`[share] ${this.conquer.currentPlatform} is not implemented`)
            });
            window.share(`${title} - ${text}`, url, bitmapData);
            return Promise.resolve({
                result: true
            });
        }
        //@ts-expect-error
        if (this.conquer.currentPlatform == "Web") navigator.share({
            "title": title,
            "text": text,
            "url": url
        }).then(()=>{
            console.log("Successful share");
        }).catch((error)=>{
            console.log("Error sharing:", error);
        });
    }
    whatsApp(title, text, url) {
        if (typeof window == "undefined") return;
        title = title.length > 0 ? `*${title}* ` : ``;
        text = text.length > 0 ? `${text} ` : ``;
        url = url.length > 0 ? `_${url}_ ` : ``;
        let message = `${title}${text}${url}`;
        window.open(`https://api.whatsapp.com/send/?&text=${message}&type=phone_number&app_absent=0`);
    }
    contactsGet() {
        if (typeof window == "undefined") return;
        var onSuccess = (contacts)=>{
            console.log("Found " + contacts.length + " contacts.");
        };
        var onError = (contactError)=>{
            console.log("onError!");
        };
        var cordovaNavigator = navigator;
        var fields = [
            cordovaNavigator.contacts.fieldType.displayName,
            cordovaNavigator.contacts.fieldType.name
        ];
        cordovaNavigator.contacts.find(fields, onSuccess, onError);
    }
    constructor(conquer){
        this.conquer = conquer;
    }
}
var $908eb8dc23d2f250$export$2e2bcd8739ae039 = $908eb8dc23d2f250$var$Share;


let $26879387177e3f9a$var$CX;

if (typeof window != "undefined") $26879387177e3f9a$var$CX = (parcelRequire("9MXKq"));
class $26879387177e3f9a$var$Contacts {
    find() {
        if (typeof window != "undefined") {
            if (!this.hasPermission) {
                this.isRequesting = true;
                $26879387177e3f9a$var$CX.hasPermission(this.contactXHasPermissionResult, this.contactXError);
            } else {
                let options = {
                    fields: {
                        phoneNumbers: true
                    }
                };
                $26879387177e3f9a$var$CX.find(this.contactXFind, this.contactXError, options);
            }
        }
    }
    contactXHasPermissionResult(result) {
        if (typeof window != "undefined") {
            if (!result.read) {
                console.log(`[CONTACTS] hasPermission: false`);
                $26879387177e3f9a$var$CX.requestPermission(this.contactXRequestPermissionResult, this.contactXError);
            }
        }
    }
    contactXError(err) {
        console.log(`[CONTACTS] contactXError error: ${err.message}`);
    }
    contactXRequestPermissionResult(result) {
        if (typeof window != "undefined") {
            this.hasPermission = result.read;
            if (this.isRequesting) {
                this.isRequesting = false;
                let options = {
                    fields: {
                        phoneNumbers: true
                    }
                };
                $26879387177e3f9a$var$CX.find(this.contactXFind, this.contactXError, options);
            }
        }
    }
    contactXFind(result) {
        if (typeof window != "undefined") {
            console.log(`[CONTACTS] found: ${result.length} contacts`);
            if (result.length > 0) console.log(`[CONTACTS] 1st contact: ${JSON.stringify(result[0], null, 2)}`);
        }
    }
    constructor(conquer){
        this.conquer = conquer;
        this.hasPermission = false;
        this.isRequesting = true;
    }
}
var $26879387177e3f9a$export$2e2bcd8739ae039 = $26879387177e3f9a$var$Contacts;


class $2085acd63d19c7b7$var$MiscSystem {
    onMessageToWebviewReceived(endpoint, message) {
        var result = JSON.parse(message);
        endpoint;
    }
    async setNotification(notifId, notifTitle, notifDelay) {
        if (this.conquer.currentPlatform == "Android" || this.conquer.currentPlatform == "iOS") {
            if (typeof window.setNotification == "undefined") return Promise.resolve({
                result: false,
                error: new Error(`[notification] ${this.conquer.currentPlatform} is not implemented`)
            });
            window.setNotification(notifId, notifTitle, notifDelay);
            return Promise.resolve({
                result: true
            });
        }
        return Promise.resolve({
            result: false,
            error: new Error(`[notification] ${this.conquer.currentPlatform} is not recognized`)
        });
    }
    async rateApp() {
        if (this.conquer.currentPlatform == "Android" || this.conquer.currentPlatform == "iOS") {
            if (typeof window.rateApp == "undefined") return Promise.resolve({
                result: false,
                error: new Error(`[rate] ${this.conquer.currentPlatform} is not implemented`)
            });
            window.rateApp();
            return Promise.resolve({
                result: true
            });
        }
        return Promise.resolve({
            result: false,
            error: new Error(`[rate] ${this.conquer.currentPlatform} is not recognized`)
        });
    }
    async showGDPR() {
        if (this.conquer.currentPlatform == "Android" || this.conquer.currentPlatform == "iOS") {
            if (typeof window.showGDPR == "undefined") return Promise.resolve({
                result: false,
                error: new Error(`[gdpr] ${this.conquer.currentPlatform} is not implemented`)
            });
            window.showGDPR();
            return Promise.resolve({
                result: true
            });
        }
        return Promise.resolve({
            result: false,
            error: new Error(`[gdpr] ${this.conquer.currentPlatform} is not recognized`)
        });
    }
    async purchase(productId) {
        if (this.conquer.currentPlatform == "Android" || this.conquer.currentPlatform == "iOS") {
            if (typeof window.purchase == "undefined") return Promise.resolve({
                result: false,
                error: new Error(`[purchase] ${this.conquer.currentPlatform} is not implemented`)
            });
            let output = await window.purchase(productId);
            return Promise.resolve({
                result: output.result,
                error: output.error
            });
        }
        return Promise.resolve({
            result: false,
            error: new Error(`[purchase] ${this.conquer.currentPlatform} is not recognized`)
        });
    }
    constructor(conquer){
        this.conquer = conquer;
        if (typeof window == "undefined") return;
        if (typeof window.onMessageToWebviewReceived != "undefined") window.onMessageToWebviewReceived.push((endpoint, message)=>{
            window.conquer.MiscSystem.onMessageToWebviewReceived(endpoint, message);
        });
    }
}
var $2085acd63d19c7b7$export$2e2bcd8739ae039 = $2085acd63d19c7b7$var$MiscSystem;


var $aa6f7ae92c6b8abb$exports = {};
// colyseus.js@0.15.26 (@colyseus/schema 2.0.9)
(function(global1, factory) {
    factory($aa6f7ae92c6b8abb$exports);
})($aa6f7ae92c6b8abb$exports, function(exports1) {
    "use strict";
    function _mergeNamespaces(n, m) {
        m.forEach(function(e) {
            e && typeof e !== "string" && !Array.isArray(e) && Object.keys(e).forEach(function(k) {
                if (k !== "default" && !(k in n)) {
                    var d = Object.getOwnPropertyDescriptor(e, k);
                    Object.defineProperty(n, k, d.get ? d : {
                        enumerable: true,
                        get: function() {
                            return e[k];
                        }
                    });
                }
            });
        });
        return Object.freeze(n);
    }
    //
    // Polyfills for legacy environments
    //
    /*
     * Support Android 4.4.x
     */ if (!ArrayBuffer.isView) ArrayBuffer.isView = function(a) {
        return a !== null && typeof a === "object" && a.buffer instanceof ArrayBuffer;
    };
    // Define globalThis if not available.
    // https://github.com/colyseus/colyseus.js/issues/86
    if (typeof globalThis === "undefined" && typeof window !== "undefined") // @ts-ignore
    window["globalThis"] = window;
    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(g && (g = 0, op[0] && (_ = 0)), _)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __classPrivateFieldGet(receiver, state, kind, f) {
        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
    }
    function __classPrivateFieldSet(receiver, state, value, kind, f) {
        if (kind === "m") throw new TypeError("Private method is not writable");
        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
        return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
    }
    var CloseCode;
    (function(CloseCode) {
        CloseCode[CloseCode["CONSENTED"] = 4000] = "CONSENTED";
        CloseCode[CloseCode["DEVMODE_RESTART"] = 4010] = "DEVMODE_RESTART";
    })(CloseCode || (CloseCode = {}));
    var ServerError = /** @class */ function(_super) {
        __extends(ServerError, _super);
        function ServerError(code, message) {
            var _this = _super.call(this, message) || this;
            _this.name = "ServerError";
            _this.code = code;
            return _this;
        }
        return ServerError;
    }(Error);
    /**
     * Copyright (c) 2014 Ion Drive Software Ltd.
     * https://github.com/darrachequesne/notepack/
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all
     * copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
     * SOFTWARE.
     */ /**
     * Patch for Colyseus:
     * -------------------
     * notepack.io@3.0.1
     *
     * added `offset` on Decoder constructor, for messages arriving with a code
     * before actual msgpack data
     */ //
    // DECODER
    //
    function Decoder(buffer, offset) {
        this._offset = offset;
        if (buffer instanceof ArrayBuffer) {
            this._buffer = buffer;
            this._view = new DataView(this._buffer);
        } else if (ArrayBuffer.isView(buffer)) {
            this._buffer = buffer.buffer;
            this._view = new DataView(this._buffer, buffer.byteOffset, buffer.byteLength);
        } else throw new Error("Invalid argument");
    }
    function utf8Read$1(view, offset, length) {
        var string = "", chr = 0;
        for(var i = offset, end = offset + length; i < end; i++){
            var byte = view.getUint8(i);
            if ((byte & 0x80) === 0x00) {
                string += String.fromCharCode(byte);
                continue;
            }
            if ((byte & 0xe0) === 0xc0) {
                string += String.fromCharCode((byte & 0x1f) << 6 | view.getUint8(++i) & 0x3f);
                continue;
            }
            if ((byte & 0xf0) === 0xe0) {
                string += String.fromCharCode((byte & 0x0f) << 12 | (view.getUint8(++i) & 0x3f) << 6 | (view.getUint8(++i) & 0x3f) << 0);
                continue;
            }
            if ((byte & 0xf8) === 0xf0) {
                chr = (byte & 0x07) << 18 | (view.getUint8(++i) & 0x3f) << 12 | (view.getUint8(++i) & 0x3f) << 6 | (view.getUint8(++i) & 0x3f) << 0;
                if (chr >= 0x010000) {
                    chr -= 0x010000;
                    string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
                } else string += String.fromCharCode(chr);
                continue;
            }
            throw new Error("Invalid byte " + byte.toString(16));
        }
        return string;
    }
    Decoder.prototype._array = function(length) {
        var value = new Array(length);
        for(var i = 0; i < length; i++)value[i] = this._parse();
        return value;
    };
    Decoder.prototype._map = function(length) {
        var key = "", value = {};
        for(var i = 0; i < length; i++){
            key = this._parse();
            value[key] = this._parse();
        }
        return value;
    };
    Decoder.prototype._str = function(length) {
        var value = utf8Read$1(this._view, this._offset, length);
        this._offset += length;
        return value;
    };
    Decoder.prototype._bin = function(length) {
        var value = this._buffer.slice(this._offset, this._offset + length);
        this._offset += length;
        return value;
    };
    Decoder.prototype._parse = function() {
        var prefix = this._view.getUint8(this._offset++);
        var value, length = 0, type = 0, hi = 0, lo = 0;
        if (prefix < 0xc0) {
            // positive fixint
            if (prefix < 0x80) return prefix;
            // fixmap
            if (prefix < 0x90) return this._map(prefix & 0x0f);
            // fixarray
            if (prefix < 0xa0) return this._array(prefix & 0x0f);
            // fixstr
            return this._str(prefix & 0x1f);
        }
        // negative fixint
        if (prefix > 0xdf) return (0xff - prefix + 1) * -1;
        switch(prefix){
            // nil
            case 0xc0:
                return null;
            // false
            case 0xc2:
                return false;
            // true
            case 0xc3:
                return true;
            // bin
            case 0xc4:
                length = this._view.getUint8(this._offset);
                this._offset += 1;
                return this._bin(length);
            case 0xc5:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._bin(length);
            case 0xc6:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._bin(length);
            // ext
            case 0xc7:
                length = this._view.getUint8(this._offset);
                type = this._view.getInt8(this._offset + 1);
                this._offset += 2;
                if (type === -1) {
                    // timestamp 96
                    var ns = this._view.getUint32(this._offset);
                    hi = this._view.getInt32(this._offset + 4);
                    lo = this._view.getUint32(this._offset + 8);
                    this._offset += 12;
                    return new Date((hi * 0x100000000 + lo) * 1e3 + ns / 1e6);
                }
                return [
                    type,
                    this._bin(length)
                ];
            case 0xc8:
                length = this._view.getUint16(this._offset);
                type = this._view.getInt8(this._offset + 2);
                this._offset += 3;
                return [
                    type,
                    this._bin(length)
                ];
            case 0xc9:
                length = this._view.getUint32(this._offset);
                type = this._view.getInt8(this._offset + 4);
                this._offset += 5;
                return [
                    type,
                    this._bin(length)
                ];
            // float
            case 0xca:
                value = this._view.getFloat32(this._offset);
                this._offset += 4;
                return value;
            case 0xcb:
                value = this._view.getFloat64(this._offset);
                this._offset += 8;
                return value;
            // uint
            case 0xcc:
                value = this._view.getUint8(this._offset);
                this._offset += 1;
                return value;
            case 0xcd:
                value = this._view.getUint16(this._offset);
                this._offset += 2;
                return value;
            case 0xce:
                value = this._view.getUint32(this._offset);
                this._offset += 4;
                return value;
            case 0xcf:
                hi = this._view.getUint32(this._offset) * Math.pow(2, 32);
                lo = this._view.getUint32(this._offset + 4);
                this._offset += 8;
                return hi + lo;
            // int
            case 0xd0:
                value = this._view.getInt8(this._offset);
                this._offset += 1;
                return value;
            case 0xd1:
                value = this._view.getInt16(this._offset);
                this._offset += 2;
                return value;
            case 0xd2:
                value = this._view.getInt32(this._offset);
                this._offset += 4;
                return value;
            case 0xd3:
                hi = this._view.getInt32(this._offset) * Math.pow(2, 32);
                lo = this._view.getUint32(this._offset + 4);
                this._offset += 8;
                return hi + lo;
            // fixext
            case 0xd4:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                if (type === 0x00) {
                    // custom encoding for 'undefined' (kept for backward-compatibility)
                    this._offset += 1;
                    return void 0;
                }
                return [
                    type,
                    this._bin(1)
                ];
            case 0xd5:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                return [
                    type,
                    this._bin(2)
                ];
            case 0xd6:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                if (type === -1) {
                    // timestamp 32
                    value = this._view.getUint32(this._offset);
                    this._offset += 4;
                    return new Date(value * 1e3);
                }
                return [
                    type,
                    this._bin(4)
                ];
            case 0xd7:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                if (type === 0x00) {
                    // custom date encoding (kept for backward-compatibility)
                    hi = this._view.getInt32(this._offset) * Math.pow(2, 32);
                    lo = this._view.getUint32(this._offset + 4);
                    this._offset += 8;
                    return new Date(hi + lo);
                }
                if (type === -1) {
                    // timestamp 64
                    hi = this._view.getUint32(this._offset);
                    lo = this._view.getUint32(this._offset + 4);
                    this._offset += 8;
                    var s = (hi & 0x3) * 0x100000000 + lo;
                    return new Date(s * 1e3 + (hi >>> 2) / 1e6);
                }
                return [
                    type,
                    this._bin(8)
                ];
            case 0xd8:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                return [
                    type,
                    this._bin(16)
                ];
            // str
            case 0xd9:
                length = this._view.getUint8(this._offset);
                this._offset += 1;
                return this._str(length);
            case 0xda:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._str(length);
            case 0xdb:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._str(length);
            // array
            case 0xdc:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._array(length);
            case 0xdd:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._array(length);
            // map
            case 0xde:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._map(length);
            case 0xdf:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._map(length);
        }
        throw new Error("Could not parse");
    };
    function decode(buffer, offset) {
        if (offset === void 0) offset = 0;
        var decoder = new Decoder(buffer, offset);
        var value = decoder._parse();
        if (decoder._offset !== buffer.byteLength) throw new Error(buffer.byteLength - decoder._offset + " trailing bytes");
        return value;
    }
    //
    // ENCODER
    //
    var TIMESTAMP32_MAX_SEC = 4294967295; // 32-bit unsigned int
    var TIMESTAMP64_MAX_SEC = 17179869183; // 34-bit unsigned int
    function utf8Write(view, offset, str) {
        var c = 0;
        for(var i = 0, l = str.length; i < l; i++){
            c = str.charCodeAt(i);
            if (c < 0x80) view.setUint8(offset++, c);
            else if (c < 0x800) {
                view.setUint8(offset++, 0xc0 | c >> 6);
                view.setUint8(offset++, 0x80 | c & 0x3f);
            } else if (c < 0xd800 || c >= 0xe000) {
                view.setUint8(offset++, 0xe0 | c >> 12);
                view.setUint8(offset++, 0x80 | c >> 6 & 0x3f);
                view.setUint8(offset++, 0x80 | c & 0x3f);
            } else {
                i++;
                c = 0x10000 + ((c & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
                view.setUint8(offset++, 0xf0 | c >> 18);
                view.setUint8(offset++, 0x80 | c >> 12 & 0x3f);
                view.setUint8(offset++, 0x80 | c >> 6 & 0x3f);
                view.setUint8(offset++, 0x80 | c & 0x3f);
            }
        }
    }
    function utf8Length$1(str) {
        var c = 0, length = 0;
        for(var i = 0, l = str.length; i < l; i++){
            c = str.charCodeAt(i);
            if (c < 0x80) length += 1;
            else if (c < 0x800) length += 2;
            else if (c < 0xd800 || c >= 0xe000) length += 3;
            else {
                i++;
                length += 4;
            }
        }
        return length;
    }
    function _encode(bytes, defers, value) {
        var type = typeof value, i = 0, l = 0, hi = 0, lo = 0, length = 0, size = 0;
        if (type === "string") {
            length = utf8Length$1(value);
            // fixstr
            if (length < 0x20) {
                bytes.push(length | 0xa0);
                size = 1;
            } else if (length < 0x100) {
                bytes.push(0xd9, length);
                size = 2;
            } else if (length < 0x10000) {
                bytes.push(0xda, length >> 8, length);
                size = 3;
            } else if (length < 0x100000000) {
                bytes.push(0xdb, length >> 24, length >> 16, length >> 8, length);
                size = 5;
            } else throw new Error("String too long");
            defers.push({
                _str: value,
                _length: length,
                _offset: bytes.length
            });
            return size + length;
        }
        if (type === "number") {
            // TODO: encode to float 32?
            // float 64
            if (Math.floor(value) !== value || !isFinite(value)) {
                bytes.push(0xcb);
                defers.push({
                    _float: value,
                    _length: 8,
                    _offset: bytes.length
                });
                return 9;
            }
            if (value >= 0) {
                // positive fixnum
                if (value < 0x80) {
                    bytes.push(value);
                    return 1;
                }
                // uint 8
                if (value < 0x100) {
                    bytes.push(0xcc, value);
                    return 2;
                }
                // uint 16
                if (value < 0x10000) {
                    bytes.push(0xcd, value >> 8, value);
                    return 3;
                }
                // uint 32
                if (value < 0x100000000) {
                    bytes.push(0xce, value >> 24, value >> 16, value >> 8, value);
                    return 5;
                }
                // uint 64
                hi = value / Math.pow(2, 32) >> 0;
                lo = value >>> 0;
                bytes.push(0xcf, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
                return 9;
            } else {
                // negative fixnum
                if (value >= -32) {
                    bytes.push(value);
                    return 1;
                }
                // int 8
                if (value >= -128) {
                    bytes.push(0xd0, value);
                    return 2;
                }
                // int 16
                if (value >= -32768) {
                    bytes.push(0xd1, value >> 8, value);
                    return 3;
                }
                // int 32
                if (value >= -2147483648) {
                    bytes.push(0xd2, value >> 24, value >> 16, value >> 8, value);
                    return 5;
                }
                // int 64
                hi = Math.floor(value / Math.pow(2, 32));
                lo = value >>> 0;
                bytes.push(0xd3, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
                return 9;
            }
        }
        if (type === "object") {
            // nil
            if (value === null) {
                bytes.push(0xc0);
                return 1;
            }
            if (Array.isArray(value)) {
                length = value.length;
                // fixarray
                if (length < 0x10) {
                    bytes.push(length | 0x90);
                    size = 1;
                } else if (length < 0x10000) {
                    bytes.push(0xdc, length >> 8, length);
                    size = 3;
                } else if (length < 0x100000000) {
                    bytes.push(0xdd, length >> 24, length >> 16, length >> 8, length);
                    size = 5;
                } else throw new Error("Array too large");
                for(i = 0; i < length; i++)size += _encode(bytes, defers, value[i]);
                return size;
            }
            if (value instanceof Date) {
                var ms = value.getTime();
                var s = Math.floor(ms / 1e3);
                var ns = (ms - s * 1e3) * 1e6;
                if (s >= 0 && ns >= 0 && s <= TIMESTAMP64_MAX_SEC) {
                    if (ns === 0 && s <= TIMESTAMP32_MAX_SEC) {
                        // timestamp 32
                        bytes.push(0xd6, 0xff, s >> 24, s >> 16, s >> 8, s);
                        return 6;
                    } else {
                        // timestamp 64
                        hi = s / 0x100000000;
                        lo = s & 0xffffffff;
                        bytes.push(0xd7, 0xff, ns >> 22, ns >> 14, ns >> 6, hi, lo >> 24, lo >> 16, lo >> 8, lo);
                        return 10;
                    }
                } else {
                    // timestamp 96
                    hi = Math.floor(s / 0x100000000);
                    lo = s >>> 0;
                    bytes.push(0xc7, 0x0c, 0xff, ns >> 24, ns >> 16, ns >> 8, ns, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
                    return 15;
                }
            }
            if (value instanceof ArrayBuffer) {
                length = value.byteLength;
                // bin 8
                if (length < 0x100) {
                    bytes.push(0xc4, length);
                    size = 2;
                } else // bin 16
                if (length < 0x10000) {
                    bytes.push(0xc5, length >> 8, length);
                    size = 3;
                } else // bin 32
                if (length < 0x100000000) {
                    bytes.push(0xc6, length >> 24, length >> 16, length >> 8, length);
                    size = 5;
                } else throw new Error("Buffer too large");
                defers.push({
                    _bin: value,
                    _length: length,
                    _offset: bytes.length
                });
                return size + length;
            }
            if (typeof value.toJSON === "function") return _encode(bytes, defers, value.toJSON());
            var keys = [], key = "";
            var allKeys = Object.keys(value);
            for(i = 0, l = allKeys.length; i < l; i++){
                key = allKeys[i];
                if (value[key] !== undefined && typeof value[key] !== "function") keys.push(key);
            }
            length = keys.length;
            // fixmap
            if (length < 0x10) {
                bytes.push(length | 0x80);
                size = 1;
            } else if (length < 0x10000) {
                bytes.push(0xde, length >> 8, length);
                size = 3;
            } else if (length < 0x100000000) {
                bytes.push(0xdf, length >> 24, length >> 16, length >> 8, length);
                size = 5;
            } else throw new Error("Object too large");
            for(i = 0; i < length; i++){
                key = keys[i];
                size += _encode(bytes, defers, key);
                size += _encode(bytes, defers, value[key]);
            }
            return size;
        }
        // false/true
        if (type === "boolean") {
            bytes.push(value ? 0xc3 : 0xc2);
            return 1;
        }
        if (type === "undefined") {
            bytes.push(0xc0);
            return 1;
        }
        // custom types like BigInt (typeof value === 'bigint')
        if (typeof value.toJSON === "function") return _encode(bytes, defers, value.toJSON());
        throw new Error("Could not encode");
    }
    function encode(value) {
        var bytes = [];
        var defers = [];
        var size = _encode(bytes, defers, value);
        var buf = new ArrayBuffer(size);
        var view = new DataView(buf);
        var deferIndex = 0;
        var deferWritten = 0;
        var nextOffset = -1;
        if (defers.length > 0) nextOffset = defers[0]._offset;
        var defer, deferLength = 0, offset = 0;
        for(var i = 0, l = bytes.length; i < l; i++){
            view.setUint8(deferWritten + i, bytes[i]);
            if (i + 1 !== nextOffset) continue;
            defer = defers[deferIndex];
            deferLength = defer._length;
            offset = deferWritten + nextOffset;
            if (defer._bin) {
                var bin = new Uint8Array(defer._bin);
                for(var j = 0; j < deferLength; j++)view.setUint8(offset + j, bin[j]);
            } else if (defer._str) utf8Write(view, offset, defer._str);
            else if (defer._float !== undefined) view.setFloat64(offset, defer._float);
            deferIndex++;
            deferWritten += deferLength;
            if (defers[deferIndex]) nextOffset = defers[deferIndex]._offset;
        }
        return buf;
    }
    var browser = function() {
        throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
    };
    var WebSocket = globalThis.WebSocket || browser;
    var WebSocketTransport = /** @class */ function() {
        function WebSocketTransport(events) {
            this.events = events;
        }
        WebSocketTransport.prototype.send = function(data) {
            if (data instanceof ArrayBuffer) this.ws.send(data);
            else if (Array.isArray(data)) this.ws.send(new Uint8Array(data).buffer);
        };
        WebSocketTransport.prototype.connect = function(url) {
            this.ws = new WebSocket(url, this.protocols);
            this.ws.binaryType = "arraybuffer";
            this.ws.onopen = this.events.onopen;
            this.ws.onmessage = this.events.onmessage;
            this.ws.onclose = this.events.onclose;
            this.ws.onerror = this.events.onerror;
        };
        WebSocketTransport.prototype.close = function(code, reason) {
            this.ws.close(code, reason);
        };
        Object.defineProperty(WebSocketTransport.prototype, "isOpen", {
            get: function() {
                return this.ws.readyState === WebSocket.OPEN;
            },
            enumerable: false,
            configurable: true
        });
        return WebSocketTransport;
    }();
    var Connection = /** @class */ function() {
        function Connection() {
            this.events = {};
            this.transport = new WebSocketTransport(this.events);
        }
        Connection.prototype.send = function(data) {
            this.transport.send(data);
        };
        Connection.prototype.connect = function(url) {
            this.transport.connect(url);
        };
        Connection.prototype.close = function(code, reason) {
            this.transport.close(code, reason);
        };
        Object.defineProperty(Connection.prototype, "isOpen", {
            get: function() {
                return this.transport.isOpen;
            },
            enumerable: false,
            configurable: true
        });
        return Connection;
    }();
    // Use codes between 0~127 for lesser throughput (1 byte)
    exports1.Protocol = void 0;
    (function(Protocol) {
        // Room-related (10~19)
        Protocol[Protocol["HANDSHAKE"] = 9] = "HANDSHAKE";
        Protocol[Protocol["JOIN_ROOM"] = 10] = "JOIN_ROOM";
        Protocol[Protocol["ERROR"] = 11] = "ERROR";
        Protocol[Protocol["LEAVE_ROOM"] = 12] = "LEAVE_ROOM";
        Protocol[Protocol["ROOM_DATA"] = 13] = "ROOM_DATA";
        Protocol[Protocol["ROOM_STATE"] = 14] = "ROOM_STATE";
        Protocol[Protocol["ROOM_STATE_PATCH"] = 15] = "ROOM_STATE_PATCH";
        Protocol[Protocol["ROOM_DATA_SCHEMA"] = 16] = "ROOM_DATA_SCHEMA";
        Protocol[Protocol["ROOM_DATA_BYTES"] = 17] = "ROOM_DATA_BYTES";
    })(exports1.Protocol || (exports1.Protocol = {}));
    exports1.ErrorCode = void 0;
    (function(ErrorCode) {
        ErrorCode[ErrorCode["MATCHMAKE_NO_HANDLER"] = 4210] = "MATCHMAKE_NO_HANDLER";
        ErrorCode[ErrorCode["MATCHMAKE_INVALID_CRITERIA"] = 4211] = "MATCHMAKE_INVALID_CRITERIA";
        ErrorCode[ErrorCode["MATCHMAKE_INVALID_ROOM_ID"] = 4212] = "MATCHMAKE_INVALID_ROOM_ID";
        ErrorCode[ErrorCode["MATCHMAKE_UNHANDLED"] = 4213] = "MATCHMAKE_UNHANDLED";
        ErrorCode[ErrorCode["MATCHMAKE_EXPIRED"] = 4214] = "MATCHMAKE_EXPIRED";
        ErrorCode[ErrorCode["AUTH_FAILED"] = 4215] = "AUTH_FAILED";
        ErrorCode[ErrorCode["APPLICATION_ERROR"] = 4216] = "APPLICATION_ERROR";
    })(exports1.ErrorCode || (exports1.ErrorCode = {}));
    function utf8Read(view, offset) {
        var length = view[offset++];
        var string = "", chr = 0;
        for(var i = offset, end = offset + length; i < end; i++){
            var byte = view[i];
            if ((byte & 0x80) === 0x00) {
                string += String.fromCharCode(byte);
                continue;
            }
            if ((byte & 0xe0) === 0xc0) {
                string += String.fromCharCode((byte & 0x1f) << 6 | view[++i] & 0x3f);
                continue;
            }
            if ((byte & 0xf0) === 0xe0) {
                string += String.fromCharCode((byte & 0x0f) << 12 | (view[++i] & 0x3f) << 6 | (view[++i] & 0x3f) << 0);
                continue;
            }
            if ((byte & 0xf8) === 0xf0) {
                chr = (byte & 0x07) << 18 | (view[++i] & 0x3f) << 12 | (view[++i] & 0x3f) << 6 | (view[++i] & 0x3f) << 0;
                if (chr >= 0x010000) {
                    chr -= 0x010000;
                    string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
                } else string += String.fromCharCode(chr);
                continue;
            }
            throw new Error("Invalid byte " + byte.toString(16));
        }
        return string;
    }
    // Faster for short strings than Buffer.byteLength
    function utf8Length(str) {
        if (str === void 0) str = "";
        var c = 0;
        var length = 0;
        for(var i = 0, l = str.length; i < l; i++){
            c = str.charCodeAt(i);
            if (c < 0x80) length += 1;
            else if (c < 0x800) length += 2;
            else if (c < 0xd800 || c >= 0xe000) length += 3;
            else {
                i++;
                length += 4;
            }
        }
        return length + 1;
    }
    var serializers = {};
    function registerSerializer(id, serializer) {
        serializers[id] = serializer;
    }
    function getSerializer(id) {
        var serializer = serializers[id];
        if (!serializer) throw new Error("missing serializer: " + id);
        return serializer;
    }
    /**
     * The MIT License (MIT)
     *
     * Copyright 2016 Andrey Sitnik <andrey@sitnik.ru>
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy of
     * this software and associated documentation files (the "Software"), to deal in
     * the Software without restriction, including without limitation the rights to
     * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
     * the Software, and to permit persons to whom the Software is furnished to do so,
     * subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all
     * copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
     * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
     * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
     * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
     * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
     */ var createNanoEvents = function() {
        return {
            emit: function(event) {
                var args = [];
                for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                var callbacks = this.events[event] || [];
                for(var i = 0, length_1 = callbacks.length; i < length_1; i++)callbacks[i].apply(callbacks, args);
            },
            events: {},
            on: function(event, cb) {
                var _this = this;
                var _a;
                ((_a = this.events[event]) === null || _a === void 0 ? void 0 : _a.push(cb)) || (this.events[event] = [
                    cb
                ]);
                return function() {
                    var _a;
                    _this.events[event] = (_a = _this.events[event]) === null || _a === void 0 ? void 0 : _a.filter(function(i) {
                        return cb !== i;
                    });
                };
            }
        };
    };
    var EventEmitter = /** @class */ function() {
        function EventEmitter() {
            this.handlers = [];
        }
        EventEmitter.prototype.register = function(cb, once) {
            this.handlers.push(cb);
            return this;
        };
        EventEmitter.prototype.invoke = function() {
            var _this = this;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            this.handlers.forEach(function(handler) {
                return handler.apply(_this, args);
            });
        };
        EventEmitter.prototype.invokeAsync = function() {
            var _this = this;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return Promise.all(this.handlers.map(function(handler) {
                return handler.apply(_this, args);
            }));
        };
        EventEmitter.prototype.remove = function(cb) {
            var index = this.handlers.indexOf(cb);
            this.handlers[index] = this.handlers[this.handlers.length - 1];
            this.handlers.pop();
        };
        EventEmitter.prototype.clear = function() {
            this.handlers = [];
        };
        return EventEmitter;
    }();
    function createSignal() {
        var emitter = new EventEmitter();
        function register(cb) {
            return emitter.register(cb, this === null);
        }
        register.once = function(cb) {
            var callback = function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                cb.apply(this, args);
                emitter.remove(callback);
            };
            emitter.register(callback);
        };
        register.remove = function(cb) {
            return emitter.remove(cb);
        };
        register.invoke = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return emitter.invoke.apply(emitter, args);
        };
        register.invokeAsync = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return emitter.invokeAsync.apply(emitter, args);
        };
        register.clear = function() {
            return emitter.clear();
        };
        return register;
    }
    var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
    function createCommonjsModule(fn) {
        var module = {
            exports: {}
        };
        return fn(module, module.exports), module.exports;
    }
    var umd = createCommonjsModule(function(module, exports1) {
        (function(global1, factory) {
            factory(exports1);
        })(commonjsGlobal, function(exports1) {
            /******************************************************************************
        Copyright (c) Microsoft Corporation.

        Permission to use, copy, modify, and/or distribute this software for any
        purpose with or without fee is hereby granted.

        THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
        REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
        AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
        INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
        LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
        OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
        PERFORMANCE OF THIS SOFTWARE.
        ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
                extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
                return extendStatics(d, b);
            };
            function __extends(d, b) {
                if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                extendStatics(d, b);
                function __() {
                    this.constructor = d;
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            }
            function __decorate(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            }
            function __spreadArray(to, from, pack) {
                if (pack || arguments.length === 2) {
                    for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                        ar[i] = from[i];
                    }
                }
                return to.concat(ar || Array.prototype.slice.call(from));
            }
            // export const SWITCH_TO_STRUCTURE = 193; (easily collides with DELETE_AND_ADD + fieldIndex = 2)
            var SWITCH_TO_STRUCTURE = 255; // (decoding collides with DELETE_AND_ADD + fieldIndex = 63)
            var TYPE_ID = 213;
            /**
         * Encoding Schema field operations.
         */ exports1.OPERATION = void 0;
            (function(OPERATION) {
                // add new structure/primitive
                OPERATION[OPERATION["ADD"] = 128] = "ADD";
                // replace structure/primitive
                OPERATION[OPERATION["REPLACE"] = 0] = "REPLACE";
                // delete field
                OPERATION[OPERATION["DELETE"] = 64] = "DELETE";
                // DELETE field, followed by an ADD
                OPERATION[OPERATION["DELETE_AND_ADD"] = 192] = "DELETE_AND_ADD";
                // TOUCH is used to determine hierarchy of nested Schema structures during serialization.
                // touches are NOT encoded.
                OPERATION[OPERATION["TOUCH"] = 1] = "TOUCH";
                // MapSchema Operations
                OPERATION[OPERATION["CLEAR"] = 10] = "CLEAR";
            })(exports1.OPERATION || (exports1.OPERATION = {}));
            // export enum OPERATION {
            //     // add new structure/primitive
            //     // (128)
            //     ADD = 128, // 10000000,
            //     // replace structure/primitive
            //     REPLACE = 1,// 00000001
            //     // delete field
            //     DELETE = 192, // 11000000
            //     // DELETE field, followed by an ADD
            //     DELETE_AND_ADD = 224, // 11100000
            //     // TOUCH is used to determine hierarchy of nested Schema structures during serialization.
            //     // touches are NOT encoded.
            //     TOUCH = 0, // 00000000
            //     // MapSchema Operations
            //     CLEAR = 10,
            // }
            var ChangeTree = /** @class */ function() {
                function ChangeTree(ref, parent, root) {
                    this.changed = false;
                    this.changes = new Map();
                    this.allChanges = new Set();
                    // cached indexes for filtering
                    this.caches = {};
                    this.currentCustomOperation = 0;
                    this.ref = ref;
                    this.setParent(parent, root);
                }
                ChangeTree.prototype.setParent = function(parent, root, parentIndex) {
                    var _this = this;
                    if (!this.indexes) this.indexes = this.ref instanceof Schema ? this.ref["_definition"].indexes : {};
                    this.parent = parent;
                    this.parentIndex = parentIndex;
                    // avoid setting parents with empty `root`
                    if (!root) return;
                    this.root = root;
                    //
                    // assign same parent on child structures
                    //
                    if (this.ref instanceof Schema) {
                        var definition = this.ref["_definition"];
                        for(var field in definition.schema){
                            var value = this.ref[field];
                            if (value && value["$changes"]) {
                                var parentIndex_1 = definition.indexes[field];
                                value["$changes"].setParent(this.ref, root, parentIndex_1);
                            }
                        }
                    } else if (typeof this.ref === "object") this.ref.forEach(function(value, key) {
                        if (value instanceof Schema) {
                            var changeTreee = value["$changes"];
                            var parentIndex_2 = _this.ref["$changes"].indexes[key];
                            changeTreee.setParent(_this.ref, _this.root, parentIndex_2);
                        }
                    });
                };
                ChangeTree.prototype.operation = function(op) {
                    this.changes.set(--this.currentCustomOperation, op);
                };
                ChangeTree.prototype.change = function(fieldName, operation) {
                    if (operation === void 0) operation = exports1.OPERATION.ADD;
                    var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
                    this.assertValidIndex(index, fieldName);
                    var previousChange = this.changes.get(index);
                    if (!previousChange || previousChange.op === exports1.OPERATION.DELETE || previousChange.op === exports1.OPERATION.TOUCH // (mazmorra.io's BattleAction issue)
                    ) this.changes.set(index, {
                        op: !previousChange ? operation : previousChange.op === exports1.OPERATION.DELETE ? exports1.OPERATION.DELETE_AND_ADD : operation,
                        // : OPERATION.REPLACE,
                        index: index
                    });
                    this.allChanges.add(index);
                    this.changed = true;
                    this.touchParents();
                };
                ChangeTree.prototype.touch = function(fieldName) {
                    var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
                    this.assertValidIndex(index, fieldName);
                    if (!this.changes.has(index)) this.changes.set(index, {
                        op: exports1.OPERATION.TOUCH,
                        index: index
                    });
                    this.allChanges.add(index);
                    // ensure touch is placed until the $root is found.
                    this.touchParents();
                };
                ChangeTree.prototype.touchParents = function() {
                    if (this.parent) this.parent["$changes"].touch(this.parentIndex);
                };
                ChangeTree.prototype.getType = function(index) {
                    if (this.ref["_definition"]) {
                        var definition = this.ref["_definition"];
                        return definition.schema[definition.fieldsByIndex[index]];
                    } else {
                        var definition = this.parent["_definition"];
                        var parentType = definition.schema[definition.fieldsByIndex[this.parentIndex]];
                        //
                        // Get the child type from parent structure.
                        // - ["string"] => "string"
                        // - { map: "string" } => "string"
                        // - { set: "string" } => "string"
                        //
                        return Object.values(parentType)[0];
                    }
                };
                ChangeTree.prototype.getChildrenFilter = function() {
                    var childFilters = this.parent["_definition"].childFilters;
                    return childFilters && childFilters[this.parentIndex];
                };
                //
                // used during `.encode()`
                //
                ChangeTree.prototype.getValue = function(index) {
                    return this.ref["getByIndex"](index);
                };
                ChangeTree.prototype.delete = function(fieldName) {
                    var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
                    if (index === undefined) {
                        console.warn("@colyseus/schema ".concat(this.ref.constructor.name, ": trying to delete non-existing index: ").concat(fieldName, " (").concat(index, ")"));
                        return;
                    }
                    var previousValue = this.getValue(index);
                    // console.log("$changes.delete =>", { fieldName, index, previousValue });
                    this.changes.set(index, {
                        op: exports1.OPERATION.DELETE,
                        index: index
                    });
                    this.allChanges.delete(index);
                    // delete cache
                    delete this.caches[index];
                    // remove `root` reference
                    if (previousValue && previousValue["$changes"]) previousValue["$changes"].parent = undefined;
                    this.changed = true;
                    this.touchParents();
                };
                ChangeTree.prototype.discard = function(changed, discardAll) {
                    var _this = this;
                    if (changed === void 0) changed = false;
                    if (discardAll === void 0) discardAll = false;
                    //
                    // Map, Array, etc:
                    // Remove cached key to ensure ADD operations is unsed instead of
                    // REPLACE in case same key is used on next patches.
                    //
                    // TODO: refactor this. this is not relevant for Collection and Set.
                    //
                    if (!(this.ref instanceof Schema)) this.changes.forEach(function(change) {
                        if (change.op === exports1.OPERATION.DELETE) {
                            var index = _this.ref["getIndex"](change.index);
                            delete _this.indexes[index];
                        }
                    });
                    this.changes.clear();
                    this.changed = changed;
                    if (discardAll) this.allChanges.clear();
                    // re-set `currentCustomOperation`
                    this.currentCustomOperation = 0;
                };
                /**
             * Recursively discard all changes from this, and child structures.
             */ ChangeTree.prototype.discardAll = function() {
                    var _this = this;
                    this.changes.forEach(function(change) {
                        var value = _this.getValue(change.index);
                        if (value && value["$changes"]) value["$changes"].discardAll();
                    });
                    this.discard();
                };
                // cache(field: number, beginIndex: number, endIndex: number) {
                ChangeTree.prototype.cache = function(field, cachedBytes) {
                    this.caches[field] = cachedBytes;
                };
                ChangeTree.prototype.clone = function() {
                    return new ChangeTree(this.ref, this.parent, this.root);
                };
                ChangeTree.prototype.ensureRefId = function() {
                    // skip if refId is already set.
                    if (this.refId !== undefined) return;
                    this.refId = this.root.getNextUniqueId();
                };
                ChangeTree.prototype.assertValidIndex = function(index, fieldName) {
                    if (index === undefined) throw new Error('ChangeTree: missing index for field "'.concat(fieldName, '"'));
                };
                return ChangeTree;
            }();
            function addCallback($callbacks, op, callback, existing) {
                // initialize list of callbacks
                if (!$callbacks[op]) $callbacks[op] = [];
                $callbacks[op].push(callback);
                //
                // Trigger callback for existing elements
                // - OPERATION.ADD
                // - OPERATION.REPLACE
                //
                existing === null || existing === void 0 || existing.forEach(function(item, key) {
                    return callback(item, key);
                });
                return function() {
                    return spliceOne($callbacks[op], $callbacks[op].indexOf(callback));
                };
            }
            function removeChildRefs(changes) {
                var _this = this;
                var needRemoveRef = typeof this.$changes.getType() !== "string";
                this.$items.forEach(function(item, key) {
                    changes.push({
                        refId: _this.$changes.refId,
                        op: exports1.OPERATION.DELETE,
                        field: key,
                        value: undefined,
                        previousValue: item
                    });
                    if (needRemoveRef) _this.$changes.root.removeRef(item["$changes"].refId);
                });
            }
            function spliceOne(arr, index) {
                // manually splice an array
                if (index === -1 || index >= arr.length) return false;
                var len = arr.length - 1;
                for(var i = index; i < len; i++)arr[i] = arr[i + 1];
                arr.length = len;
                return true;
            }
            var DEFAULT_SORT = function(a, b) {
                var A = a.toString();
                var B = b.toString();
                if (A < B) return -1;
                else if (A > B) return 1;
                else return 0;
            };
            function getArrayProxy(value) {
                value["$proxy"] = true;
                //
                // compatibility with @colyseus/schema 0.5.x
                // - allow `map["key"]`
                // - allow `map["key"] = "xxx"`
                // - allow `delete map["key"]`
                //
                value = new Proxy(value, {
                    get: function(obj, prop) {
                        if (typeof prop !== "symbol" && !isNaN(prop) // https://stackoverflow.com/a/175787/892698
                        ) return obj.at(prop);
                        else return obj[prop];
                    },
                    set: function(obj, prop, setValue) {
                        if (typeof prop !== "symbol" && !isNaN(prop)) {
                            var indexes = Array.from(obj["$items"].keys());
                            var key = parseInt(indexes[prop] || prop);
                            if (setValue === undefined || setValue === null) obj.deleteAt(key);
                            else obj.setAt(key, setValue);
                        } else obj[prop] = setValue;
                        return true;
                    },
                    deleteProperty: function(obj, prop) {
                        if (typeof prop === "number") obj.deleteAt(prop);
                        else delete obj[prop];
                        return true;
                    }
                });
                return value;
            }
            var ArraySchema = /** @class */ function() {
                function ArraySchema() {
                    var items = [];
                    for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    this.push.apply(this, items);
                }
                ArraySchema.prototype.onAdd = function(callback, triggerAll) {
                    if (triggerAll === void 0) triggerAll = true;
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
                };
                ArraySchema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                ArraySchema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                ArraySchema.is = function(type) {
                    return(// type format: ["string"]
                    Array.isArray(type) || // type format: { array: "string" }
                    type["array"] !== undefined);
                };
                Object.defineProperty(ArraySchema.prototype, "length", {
                    get: function() {
                        return this.$items.size;
                    },
                    set: function(value) {
                        if (value === 0) this.clear();
                        else this.splice(value, this.length - value);
                    },
                    enumerable: false,
                    configurable: true
                });
                ArraySchema.prototype.push = function() {
                    var _this = this;
                    var values = [];
                    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
                    var lastIndex;
                    values.forEach(function(value) {
                        // set "index" for reference.
                        lastIndex = _this.$refId++;
                        _this.setAt(lastIndex, value);
                    });
                    return lastIndex;
                };
                /**
             * Removes the last element from an array and returns it.
             */ ArraySchema.prototype.pop = function() {
                    var key = Array.from(this.$indexes.values()).pop();
                    if (key === undefined) return undefined;
                    this.$changes.delete(key);
                    this.$indexes.delete(key);
                    var value = this.$items.get(key);
                    this.$items.delete(key);
                    return value;
                };
                ArraySchema.prototype.at = function(index) {
                    //
                    // FIXME: this should be O(1)
                    //
                    var key = Array.from(this.$items.keys())[index];
                    return this.$items.get(key);
                };
                ArraySchema.prototype.setAt = function(index, value) {
                    var _a, _b;
                    if (value["$changes"] !== undefined) value["$changes"].setParent(this, this.$changes.root, index);
                    var operation = (_b = (_a = this.$changes.indexes[index]) === null || _a === void 0 ? void 0 : _a.op) !== null && _b !== void 0 ? _b : exports1.OPERATION.ADD;
                    this.$changes.indexes[index] = index;
                    this.$indexes.set(index, index);
                    this.$items.set(index, value);
                    this.$changes.change(index, operation);
                };
                ArraySchema.prototype.deleteAt = function(index) {
                    var key = Array.from(this.$items.keys())[index];
                    if (key === undefined) return false;
                    return this.$deleteAt(key);
                };
                ArraySchema.prototype.$deleteAt = function(index) {
                    // delete at internal index
                    this.$changes.delete(index);
                    this.$indexes.delete(index);
                    return this.$items.delete(index);
                };
                ArraySchema.prototype.clear = function(changes) {
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    //
                    // When decoding:
                    // - enqueue items for DELETE callback.
                    // - flag child items for garbage collection.
                    //
                    if (changes) removeChildRefs.call(this, changes);
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                /**
             * Combines two or more arrays.
             * @param items Additional items to add to the end of array1.
             */ // @ts-ignore
                ArraySchema.prototype.concat = function() {
                    var _a;
                    var items = [];
                    for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
                    return new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                        void 0
                    ], (_a = Array.from(this.$items.values())).concat.apply(_a, items), false)))();
                };
                /**
             * Adds all the elements of an array separated by the specified separator string.
             * @param separator A string used to separate one element of an array from the next in the resulting String. If omitted, the array elements are separated with a comma.
             */ ArraySchema.prototype.join = function(separator) {
                    return Array.from(this.$items.values()).join(separator);
                };
                /**
             * Reverses the elements in an Array.
             */ // @ts-ignore
                ArraySchema.prototype.reverse = function() {
                    var _this = this;
                    var indexes = Array.from(this.$items.keys());
                    var reversedItems = Array.from(this.$items.values()).reverse();
                    reversedItems.forEach(function(item, i) {
                        _this.setAt(indexes[i], item);
                    });
                    return this;
                };
                /**
             * Removes the first element from an array and returns it.
             */ ArraySchema.prototype.shift = function() {
                    var indexes = Array.from(this.$items.keys());
                    var shiftAt = indexes.shift();
                    if (shiftAt === undefined) return undefined;
                    var value = this.$items.get(shiftAt);
                    this.$deleteAt(shiftAt);
                    return value;
                };
                /**
             * Returns a section of an array.
             * @param start The beginning of the specified portion of the array.
             * @param end The end of the specified portion of the array. This is exclusive of the element at the index 'end'.
             */ ArraySchema.prototype.slice = function(start, end) {
                    var sliced = new ArraySchema();
                    sliced.push.apply(sliced, Array.from(this.$items.values()).slice(start, end));
                    return sliced;
                };
                /**
             * Sorts an array.
             * @param compareFn Function used to determine the order of the elements. It is expected to return
             * a negative value if first argument is less than second argument, zero if they're equal and a positive
             * value otherwise. If omitted, the elements are sorted in ascending, ASCII character order.
             * ```ts
             * [11,2,22,1].sort((a, b) => a - b)
             * ```
             */ ArraySchema.prototype.sort = function(compareFn) {
                    var _this = this;
                    if (compareFn === void 0) compareFn = DEFAULT_SORT;
                    var indexes = Array.from(this.$items.keys());
                    var sortedItems = Array.from(this.$items.values()).sort(compareFn);
                    sortedItems.forEach(function(item, i) {
                        _this.setAt(indexes[i], item);
                    });
                    return this;
                };
                /**
             * Removes elements from an array and, if necessary, inserts new elements in their place, returning the deleted elements.
             * @param start The zero-based location in the array from which to start removing elements.
             * @param deleteCount The number of elements to remove.
             * @param items Elements to insert into the array in place of the deleted elements.
             */ ArraySchema.prototype.splice = function(start, deleteCount) {
                    if (deleteCount === void 0) deleteCount = this.length - start;
                    var indexes = Array.from(this.$items.keys());
                    var removedItems = [];
                    for(var i = start; i < start + deleteCount; i++){
                        removedItems.push(this.$items.get(indexes[i]));
                        this.$deleteAt(indexes[i]);
                    }
                    return removedItems;
                };
                /**
             * Inserts new elements at the start of an array.
             * @param items  Elements to insert at the start of the Array.
             */ ArraySchema.prototype.unshift = function() {
                    var _this = this;
                    var items = [];
                    for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
                    var length = this.length;
                    var addedLength = items.length;
                    // const indexes = Array.from(this.$items.keys());
                    var previousValues = Array.from(this.$items.values());
                    items.forEach(function(item, i) {
                        _this.setAt(i, item);
                    });
                    previousValues.forEach(function(previousValue, i) {
                        _this.setAt(addedLength + i, previousValue);
                    });
                    return length + addedLength;
                };
                /**
             * Returns the index of the first occurrence of a value in an array.
             * @param searchElement The value to locate in the array.
             * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at index 0.
             */ ArraySchema.prototype.indexOf = function(searchElement, fromIndex) {
                    return Array.from(this.$items.values()).indexOf(searchElement, fromIndex);
                };
                /**
             * Returns the index of the last occurrence of a specified value in an array.
             * @param searchElement The value to locate in the array.
             * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at the last index in the array.
             */ ArraySchema.prototype.lastIndexOf = function(searchElement, fromIndex) {
                    if (fromIndex === void 0) fromIndex = this.length - 1;
                    return Array.from(this.$items.values()).lastIndexOf(searchElement, fromIndex);
                };
                /**
             * Determines whether all the members of an array satisfy the specified test.
             * @param callbackfn A function that accepts up to three arguments. The every method calls
             * the callbackfn function for each element in the array until the callbackfn returns a value
             * which is coercible to the Boolean value false, or until the end of the array.
             * @param thisArg An object to which the this keyword can refer in the callbackfn function.
             * If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.every = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).every(callbackfn, thisArg);
                };
                /**
             * Determines whether the specified callback function returns true for any element of an array.
             * @param callbackfn A function that accepts up to three arguments. The some method calls
             * the callbackfn function for each element in the array until the callbackfn returns a value
             * which is coercible to the Boolean value true, or until the end of the array.
             * @param thisArg An object to which the this keyword can refer in the callbackfn function.
             * If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.some = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).some(callbackfn, thisArg);
                };
                /**
             * Performs the specified action for each element in an array.
             * @param callbackfn  A function that accepts up to three arguments. forEach calls the callbackfn function one time for each element in the array.
             * @param thisArg  An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.forEach = function(callbackfn, thisArg) {
                    Array.from(this.$items.values()).forEach(callbackfn, thisArg);
                };
                /**
             * Calls a defined callback function on each element of an array, and returns an array that contains the results.
             * @param callbackfn A function that accepts up to three arguments. The map method calls the callbackfn function one time for each element in the array.
             * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.map = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).map(callbackfn, thisArg);
                };
                ArraySchema.prototype.filter = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).filter(callbackfn, thisArg);
                };
                /**
             * Calls the specified callback function for all the elements in an array. The return value of the callback function is the accumulated result, and is provided as an argument in the next call to the callback function.
             * @param callbackfn A function that accepts up to four arguments. The reduce method calls the callbackfn function one time for each element in the array.
             * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
             */ ArraySchema.prototype.reduce = function(callbackfn, initialValue) {
                    return Array.prototype.reduce.apply(Array.from(this.$items.values()), arguments);
                };
                /**
             * Calls the specified callback function for all the elements in an array, in descending order. The return value of the callback function is the accumulated result, and is provided as an argument in the next call to the callback function.
             * @param callbackfn A function that accepts up to four arguments. The reduceRight method calls the callbackfn function one time for each element in the array.
             * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
             */ ArraySchema.prototype.reduceRight = function(callbackfn, initialValue) {
                    return Array.prototype.reduceRight.apply(Array.from(this.$items.values()), arguments);
                };
                /**
             * Returns the value of the first element in the array where predicate is true, and undefined
             * otherwise.
             * @param predicate find calls predicate once for each element of the array, in ascending
             * order, until it finds one where predicate returns true. If such an element is found, find
             * immediately returns that element value. Otherwise, find returns undefined.
             * @param thisArg If provided, it will be used as the this value for each invocation of
             * predicate. If it is not provided, undefined is used instead.
             */ ArraySchema.prototype.find = function(predicate, thisArg) {
                    return Array.from(this.$items.values()).find(predicate, thisArg);
                };
                /**
             * Returns the index of the first element in the array where predicate is true, and -1
             * otherwise.
             * @param predicate find calls predicate once for each element of the array, in ascending
             * order, until it finds one where predicate returns true. If such an element is found,
             * findIndex immediately returns that element index. Otherwise, findIndex returns -1.
             * @param thisArg If provided, it will be used as the this value for each invocation of
             * predicate. If it is not provided, undefined is used instead.
             */ ArraySchema.prototype.findIndex = function(predicate, thisArg) {
                    return Array.from(this.$items.values()).findIndex(predicate, thisArg);
                };
                /**
             * Returns the this object after filling the section identified by start and end with value
             * @param value value to fill array section with
             * @param start index to start filling the array at. If start is negative, it is treated as
             * length+start where length is the length of the array.
             * @param end index to stop filling the array at. If end is negative, it is treated as
             * length+end.
             */ ArraySchema.prototype.fill = function(value, start, end) {
                    //
                    // TODO
                    //
                    throw new Error("ArraySchema#fill() not implemented");
                };
                /**
             * Returns the this object after copying a section of the array identified by start and end
             * to the same array starting at position target
             * @param target If target is negative, it is treated as length+target where length is the
             * length of the array.
             * @param start If start is negative, it is treated as length+start. If end is negative, it
             * is treated as length+end.
             * @param end If not specified, length of the this object is used as its default value.
             */ ArraySchema.prototype.copyWithin = function(target, start, end) {
                    //
                    // TODO
                    //
                    throw new Error("ArraySchema#copyWithin() not implemented");
                };
                /**
             * Returns a string representation of an array.
             */ ArraySchema.prototype.toString = function() {
                    return this.$items.toString();
                };
                /**
             * Returns a string representation of an array. The elements are converted to string using their toLocalString methods.
             */ ArraySchema.prototype.toLocaleString = function() {
                    return this.$items.toLocaleString();
                };
                /** Iterator */ ArraySchema.prototype[Symbol.iterator] = function() {
                    return Array.from(this.$items.values())[Symbol.iterator]();
                };
                /**
             * Returns an iterable of key, value pairs for every entry in the array
             */ ArraySchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                /**
             * Returns an iterable of keys in the array
             */ ArraySchema.prototype.keys = function() {
                    return this.$items.keys();
                };
                /**
             * Returns an iterable of values in the array
             */ ArraySchema.prototype.values = function() {
                    return this.$items.values();
                };
                /**
             * Determines whether an array includes a certain element, returning true or false as appropriate.
             * @param searchElement The element to search for.
             * @param fromIndex The position in this array at which to begin searching for searchElement.
             */ ArraySchema.prototype.includes = function(searchElement, fromIndex) {
                    return Array.from(this.$items.values()).includes(searchElement, fromIndex);
                };
                /**
             * Calls a defined callback function on each element of an array. Then, flattens the result into
             * a new array.
             * This is identical to a map followed by flat with depth 1.
             *
             * @param callback A function that accepts up to three arguments. The flatMap method calls the
             * callback function one time for each element in the array.
             * @param thisArg An object to which the this keyword can refer in the callback function. If
             * thisArg is omitted, undefined is used as the this value.
             */ // @ts-ignore
                ArraySchema.prototype.flatMap = function(callback, thisArg) {
                    // @ts-ignore
                    throw new Error("ArraySchema#flatMap() is not supported.");
                };
                /**
             * Returns a new array with all sub-array elements concatenated into it recursively up to the
             * specified depth.
             *
             * @param depth The maximum recursion depth
             */ // @ts-ignore
                ArraySchema.prototype.flat = function(depth) {
                    throw new Error("ArraySchema#flat() is not supported.");
                };
                ArraySchema.prototype.findLast = function() {
                    var arr = Array.from(this.$items.values());
                    // @ts-ignore
                    return arr.findLast.apply(arr, arguments);
                };
                ArraySchema.prototype.findLastIndex = function() {
                    var arr = Array.from(this.$items.values());
                    // @ts-ignore
                    return arr.findLastIndex.apply(arr, arguments);
                };
                // get size () {
                //     return this.$items.size;
                // }
                ArraySchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                ArraySchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                ArraySchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                ArraySchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                ArraySchema.prototype.toArray = function() {
                    return Array.from(this.$items.values());
                };
                ArraySchema.prototype.toJSON = function() {
                    return this.toArray().map(function(value) {
                        return typeof value["toJSON"] === "function" ? value["toJSON"]() : value;
                    });
                };
                //
                // Decoding utilities
                //
                ArraySchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) cloned = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                        void 0
                    ], Array.from(this.$items.values()), false)))();
                    else cloned = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                        void 0
                    ], this.map(function(item) {
                        return item["$changes"] ? item.clone() : item;
                    }), false)))();
                    return cloned;
                };
                return ArraySchema;
            }();
            function getMapProxy(value) {
                value["$proxy"] = true;
                value = new Proxy(value, {
                    get: function(obj, prop) {
                        if (typeof prop !== "symbol" && // accessing properties
                        typeof obj[prop] === "undefined") return obj.get(prop);
                        else return obj[prop];
                    },
                    set: function(obj, prop, setValue) {
                        if (typeof prop !== "symbol" && prop.indexOf("$") === -1 && prop !== "onAdd" && prop !== "onRemove" && prop !== "onChange") obj.set(prop, setValue);
                        else obj[prop] = setValue;
                        return true;
                    },
                    deleteProperty: function(obj, prop) {
                        obj.delete(prop);
                        return true;
                    }
                });
                return value;
            }
            var MapSchema = /** @class */ function() {
                function MapSchema(initialValues) {
                    var _this = this;
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    if (initialValues) {
                        if (initialValues instanceof Map || initialValues instanceof MapSchema) initialValues.forEach(function(v, k) {
                            return _this.set(k, v);
                        });
                        else for(var k in initialValues)this.set(k, initialValues[k]);
                    }
                }
                MapSchema.prototype.onAdd = function(callback, triggerAll) {
                    if (triggerAll === void 0) triggerAll = true;
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
                };
                MapSchema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                MapSchema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                MapSchema.is = function(type) {
                    return type["map"] !== undefined;
                };
                /** Iterator */ MapSchema.prototype[Symbol.iterator] = function() {
                    return this.$items[Symbol.iterator]();
                };
                Object.defineProperty(MapSchema.prototype, Symbol.toStringTag, {
                    get: function() {
                        return this.$items[Symbol.toStringTag];
                    },
                    enumerable: false,
                    configurable: true
                });
                MapSchema.prototype.set = function(key, value) {
                    if (value === undefined || value === null) throw new Error("MapSchema#set('".concat(key, "', ").concat(value, "): trying to set ").concat(value, " value on '").concat(key, "'."));
                    // get "index" for this value.
                    var hasIndex = typeof this.$changes.indexes[key] !== "undefined";
                    var index = hasIndex ? this.$changes.indexes[key] : this.$refId++;
                    var operation = hasIndex ? exports1.OPERATION.REPLACE : exports1.OPERATION.ADD;
                    var isRef = value["$changes"] !== undefined;
                    if (isRef) value["$changes"].setParent(this, this.$changes.root, index);
                    //
                    // (encoding)
                    // set a unique id to relate directly with this key/value.
                    //
                    if (!hasIndex) {
                        this.$changes.indexes[key] = index;
                        this.$indexes.set(index, key);
                    } else if (isRef && // if is schema, force ADD operation if value differ from previous one.
                    this.$items.get(key) !== value) operation = exports1.OPERATION.ADD;
                    this.$items.set(key, value);
                    this.$changes.change(key, operation);
                    return this;
                };
                MapSchema.prototype.get = function(key) {
                    return this.$items.get(key);
                };
                MapSchema.prototype.delete = function(key) {
                    //
                    // TODO: add a "purge" method after .encode() runs, to cleanup removed `$indexes`
                    //
                    // We don't remove $indexes to allow setting the same key in the same patch
                    // (See "should allow to remove and set an item in the same place" test)
                    //
                    // // const index = this.$changes.indexes[key];
                    // // this.$indexes.delete(index);
                    this.$changes.delete(key);
                    return this.$items.delete(key);
                };
                MapSchema.prototype.clear = function(changes) {
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    //
                    // When decoding:
                    // - enqueue items for DELETE callback.
                    // - flag child items for garbage collection.
                    //
                    if (changes) removeChildRefs.call(this, changes);
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                MapSchema.prototype.has = function(key) {
                    return this.$items.has(key);
                };
                MapSchema.prototype.forEach = function(callbackfn) {
                    this.$items.forEach(callbackfn);
                };
                MapSchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                MapSchema.prototype.keys = function() {
                    return this.$items.keys();
                };
                MapSchema.prototype.values = function() {
                    return this.$items.values();
                };
                Object.defineProperty(MapSchema.prototype, "size", {
                    get: function() {
                        return this.$items.size;
                    },
                    enumerable: false,
                    configurable: true
                });
                MapSchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                MapSchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                MapSchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                MapSchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                MapSchema.prototype.toJSON = function() {
                    var map = {};
                    this.forEach(function(value, key) {
                        map[key] = typeof value["toJSON"] === "function" ? value["toJSON"]() : value;
                    });
                    return map;
                };
                //
                // Decoding utilities
                //
                MapSchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) // client-side
                    cloned = Object.assign(new MapSchema(), this);
                    else {
                        // server-side
                        cloned = new MapSchema();
                        this.forEach(function(value, key) {
                            if (value["$changes"]) cloned.set(key, value["clone"]());
                            else cloned.set(key, value);
                        });
                    }
                    return cloned;
                };
                return MapSchema;
            }();
            var registeredTypes = {};
            function registerType(identifier, definition) {
                registeredTypes[identifier] = definition;
            }
            function getType(identifier) {
                return registeredTypes[identifier];
            }
            var SchemaDefinition = /** @class */ function() {
                function SchemaDefinition() {
                    //
                    // TODO: use a "field" structure combining all these properties per-field.
                    //
                    this.indexes = {};
                    this.fieldsByIndex = {};
                    this.deprecated = {};
                    this.descriptors = {};
                }
                SchemaDefinition.create = function(parent) {
                    var definition = new SchemaDefinition();
                    // support inheritance
                    definition.schema = Object.assign({}, parent && parent.schema || {});
                    definition.indexes = Object.assign({}, parent && parent.indexes || {});
                    definition.fieldsByIndex = Object.assign({}, parent && parent.fieldsByIndex || {});
                    definition.descriptors = Object.assign({}, parent && parent.descriptors || {});
                    definition.deprecated = Object.assign({}, parent && parent.deprecated || {});
                    return definition;
                };
                SchemaDefinition.prototype.addField = function(field, type) {
                    var index = this.getNextFieldIndex();
                    this.fieldsByIndex[index] = field;
                    this.indexes[field] = index;
                    this.schema[field] = Array.isArray(type) ? {
                        array: type[0]
                    } : type;
                };
                SchemaDefinition.prototype.hasField = function(field) {
                    return this.indexes[field] !== undefined;
                };
                SchemaDefinition.prototype.addFilter = function(field, cb) {
                    if (!this.filters) {
                        this.filters = {};
                        this.indexesWithFilters = [];
                    }
                    this.filters[this.indexes[field]] = cb;
                    this.indexesWithFilters.push(this.indexes[field]);
                    return true;
                };
                SchemaDefinition.prototype.addChildrenFilter = function(field, cb) {
                    var index = this.indexes[field];
                    var type = this.schema[field];
                    if (getType(Object.keys(type)[0])) {
                        if (!this.childFilters) this.childFilters = {};
                        this.childFilters[index] = cb;
                        return true;
                    } else console.warn("@filterChildren: field '".concat(field, "' can't have children. Ignoring filter."));
                };
                SchemaDefinition.prototype.getChildrenFilter = function(field) {
                    return this.childFilters && this.childFilters[this.indexes[field]];
                };
                SchemaDefinition.prototype.getNextFieldIndex = function() {
                    return Object.keys(this.schema || {}).length;
                };
                return SchemaDefinition;
            }();
            function hasFilter(klass) {
                return klass._context && klass._context.useFilters;
            }
            var Context = /** @class */ function() {
                function Context() {
                    this.types = {};
                    this.schemas = new Map();
                    this.useFilters = false;
                }
                Context.prototype.has = function(schema) {
                    return this.schemas.has(schema);
                };
                Context.prototype.get = function(typeid) {
                    return this.types[typeid];
                };
                Context.prototype.add = function(schema, typeid) {
                    if (typeid === void 0) typeid = this.schemas.size;
                    // FIXME: move this to somewhere else?
                    // support inheritance
                    schema._definition = SchemaDefinition.create(schema._definition);
                    schema._typeid = typeid;
                    this.types[typeid] = schema;
                    this.schemas.set(schema, typeid);
                };
                Context.create = function(options) {
                    if (options === void 0) options = {};
                    return function(definition) {
                        if (!options.context) options.context = new Context();
                        return type(definition, options);
                    };
                };
                return Context;
            }();
            var globalContext = new Context();
            /**
         * [See documentation](https://docs.colyseus.io/state/schema/)
         *
         * Annotate a Schema property to be serializeable.
         * \@type()'d fields are automatically flagged as "dirty" for the next patch.
         *
         * @example Standard usage, with automatic change tracking.
         * ```
         * \@type("string") propertyName: string;
         * ```
         *
         * @example You can provide the "manual" option if you'd like to manually control your patches via .setDirty().
         * ```
         * \@type("string", { manual: true })
         * ```
         */ function type(type, options) {
                if (options === void 0) options = {};
                return function(target, field) {
                    var context = options.context || globalContext;
                    var constructor = target.constructor;
                    constructor._context = context;
                    if (!type) throw new Error("".concat(constructor.name, ': @type() reference provided for "').concat(field, "\" is undefined. Make sure you don't have any circular dependencies."));
                    /*
                 * static schema
                 */ if (!context.has(constructor)) context.add(constructor);
                    var definition = constructor._definition;
                    definition.addField(field, type);
                    /**
                 * skip if descriptor already exists for this field (`@deprecated()`)
                 */ if (definition.descriptors[field]) {
                        if (definition.deprecated[field]) // do not create accessors for deprecated properties.
                        return;
                        else // trying to define same property multiple times across inheritance.
                        // https://github.com/colyseus/colyseus-unity3d/issues/131#issuecomment-814308572
                        try {
                            throw new Error("@colyseus/schema: Duplicate '".concat(field, "' definition on '").concat(constructor.name, "'.\nCheck @type() annotation"));
                        } catch (e) {
                            var definitionAtLine = e.stack.split("\n")[4].trim();
                            throw new Error("".concat(e.message, " ").concat(definitionAtLine));
                        }
                    }
                    var isArray = ArraySchema.is(type);
                    var isMap = !isArray && MapSchema.is(type);
                    // TODO: refactor me.
                    // Allow abstract intermediary classes with no fields to be serialized
                    // (See "should support an inheritance with a Schema type without fields" test)
                    if (typeof type !== "string" && !Schema.is(type)) {
                        var childType = Object.values(type)[0];
                        if (typeof childType !== "string" && !context.has(childType)) context.add(childType);
                    }
                    if (options.manual) {
                        // do not declare getter/setter descriptor
                        definition.descriptors[field] = {
                            enumerable: true,
                            configurable: true,
                            writable: true
                        };
                        return;
                    }
                    var fieldCached = "_".concat(field);
                    definition.descriptors[fieldCached] = {
                        enumerable: false,
                        configurable: false,
                        writable: true
                    };
                    definition.descriptors[field] = {
                        get: function() {
                            return this[fieldCached];
                        },
                        set: function(value) {
                            /**
                         * Create Proxy for array or map items
                         */ // skip if value is the same as cached.
                            if (value === this[fieldCached]) return;
                            if (value !== undefined && value !== null) {
                                // automaticallty transform Array into ArraySchema
                                if (isArray && !(value instanceof ArraySchema)) value = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                                    void 0
                                ], value, false)))();
                                // automaticallty transform Map into MapSchema
                                if (isMap && !(value instanceof MapSchema)) value = new MapSchema(value);
                                // try to turn provided structure into a Proxy
                                if (value["$proxy"] === undefined) {
                                    if (isMap) value = getMapProxy(value);
                                    else if (isArray) value = getArrayProxy(value);
                                }
                                // flag the change for encoding.
                                this.$changes.change(field);
                                //
                                // call setParent() recursively for this and its child
                                // structures.
                                //
                                if (value["$changes"]) value["$changes"].setParent(this, this.$changes.root, this._definition.indexes[field]);
                            } else if (this[fieldCached]) //
                            // Setting a field to `null` or `undefined` will delete it.
                            //
                            this.$changes.delete(field);
                            this[fieldCached] = value;
                        },
                        enumerable: true,
                        configurable: true
                    };
                };
            }
            /**
         * `@filter()` decorator for defining data filters per client
         */ function filter(cb) {
                return function(target, field) {
                    var constructor = target.constructor;
                    var definition = constructor._definition;
                    if (definition.addFilter(field, cb)) constructor._context.useFilters = true;
                };
            }
            function filterChildren(cb) {
                return function(target, field) {
                    var constructor = target.constructor;
                    var definition = constructor._definition;
                    if (definition.addChildrenFilter(field, cb)) constructor._context.useFilters = true;
                };
            }
            /**
         * `@deprecated()` flag a field as deprecated.
         * The previous `@type()` annotation should remain along with this one.
         */ function deprecated(throws) {
                if (throws === void 0) throws = true;
                return function(target, field) {
                    var constructor = target.constructor;
                    var definition = constructor._definition;
                    definition.deprecated[field] = true;
                    if (throws) definition.descriptors[field] = {
                        get: function() {
                            throw new Error("".concat(field, " is deprecated."));
                        },
                        set: function(value) {},
                        enumerable: false,
                        configurable: true
                    };
                };
            }
            function defineTypes(target, fields, options) {
                if (options === void 0) options = {};
                if (!options.context) options.context = target._context || options.context || globalContext;
                for(var field in fields)type(fields[field], options)(target.prototype, field);
                return target;
            }
            /**
         * Copyright (c) 2018 Endel Dreyer
         * Copyright (c) 2014 Ion Drive Software Ltd.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in all
         * copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
         * SOFTWARE
         */ /**
         * msgpack implementation highly based on notepack.io
         * https://github.com/darrachequesne/notepack
         */ function utf8Length(str) {
                var c = 0, length = 0;
                for(var i = 0, l = str.length; i < l; i++){
                    c = str.charCodeAt(i);
                    if (c < 0x80) length += 1;
                    else if (c < 0x800) length += 2;
                    else if (c < 0xd800 || c >= 0xe000) length += 3;
                    else {
                        i++;
                        length += 4;
                    }
                }
                return length;
            }
            function utf8Write(view, offset, str) {
                var c = 0;
                for(var i = 0, l = str.length; i < l; i++){
                    c = str.charCodeAt(i);
                    if (c < 0x80) view[offset++] = c;
                    else if (c < 0x800) {
                        view[offset++] = 0xc0 | c >> 6;
                        view[offset++] = 0x80 | c & 0x3f;
                    } else if (c < 0xd800 || c >= 0xe000) {
                        view[offset++] = 0xe0 | c >> 12;
                        view[offset++] = 0x80 | c >> 6 & 0x3f;
                        view[offset++] = 0x80 | c & 0x3f;
                    } else {
                        i++;
                        c = 0x10000 + ((c & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
                        view[offset++] = 0xf0 | c >> 18;
                        view[offset++] = 0x80 | c >> 12 & 0x3f;
                        view[offset++] = 0x80 | c >> 6 & 0x3f;
                        view[offset++] = 0x80 | c & 0x3f;
                    }
                }
            }
            function int8$1(bytes, value) {
                bytes.push(value & 255);
            }
            function uint8$1(bytes, value) {
                bytes.push(value & 255);
            }
            function int16$1(bytes, value) {
                bytes.push(value & 255);
                bytes.push(value >> 8 & 255);
            }
            function uint16$1(bytes, value) {
                bytes.push(value & 255);
                bytes.push(value >> 8 & 255);
            }
            function int32$1(bytes, value) {
                bytes.push(value & 255);
                bytes.push(value >> 8 & 255);
                bytes.push(value >> 16 & 255);
                bytes.push(value >> 24 & 255);
            }
            function uint32$1(bytes, value) {
                var b4 = value >> 24;
                var b3 = value >> 16;
                var b2 = value >> 8;
                var b1 = value;
                bytes.push(b1 & 255);
                bytes.push(b2 & 255);
                bytes.push(b3 & 255);
                bytes.push(b4 & 255);
            }
            function int64$1(bytes, value) {
                var high = Math.floor(value / Math.pow(2, 32));
                var low = value >>> 0;
                uint32$1(bytes, low);
                uint32$1(bytes, high);
            }
            function uint64$1(bytes, value) {
                var high = value / Math.pow(2, 32) >> 0;
                var low = value >>> 0;
                uint32$1(bytes, low);
                uint32$1(bytes, high);
            }
            function float32$1(bytes, value) {
                writeFloat32(bytes, value);
            }
            function float64$1(bytes, value) {
                writeFloat64(bytes, value);
            }
            var _int32$1 = new Int32Array(2);
            var _float32$1 = new Float32Array(_int32$1.buffer);
            var _float64$1 = new Float64Array(_int32$1.buffer);
            function writeFloat32(bytes, value) {
                _float32$1[0] = value;
                int32$1(bytes, _int32$1[0]);
            }
            function writeFloat64(bytes, value) {
                _float64$1[0] = value;
                int32$1(bytes, _int32$1[0]);
                int32$1(bytes, _int32$1[1]);
            }
            function boolean$1(bytes, value) {
                return uint8$1(bytes, value ? 1 : 0);
            }
            function string$1(bytes, value) {
                // encode `null` strings as empty.
                if (!value) value = "";
                var length = utf8Length(value);
                var size = 0;
                // fixstr
                if (length < 0x20) {
                    bytes.push(length | 0xa0);
                    size = 1;
                } else if (length < 0x100) {
                    bytes.push(0xd9);
                    uint8$1(bytes, length);
                    size = 2;
                } else if (length < 0x10000) {
                    bytes.push(0xda);
                    uint16$1(bytes, length);
                    size = 3;
                } else if (length < 0x100000000) {
                    bytes.push(0xdb);
                    uint32$1(bytes, length);
                    size = 5;
                } else throw new Error("String too long");
                utf8Write(bytes, bytes.length, value);
                return size + length;
            }
            function number$1(bytes, value) {
                if (isNaN(value)) return number$1(bytes, 0);
                else if (!isFinite(value)) return number$1(bytes, value > 0 ? Number.MAX_SAFE_INTEGER : -Number.MAX_SAFE_INTEGER);
                else if (value !== (value | 0)) {
                    bytes.push(0xcb);
                    writeFloat64(bytes, value);
                    return 9;
                // TODO: encode float 32?
                // is it possible to differentiate between float32 / float64 here?
                // // float 32
                // bytes.push(0xca);
                // writeFloat32(bytes, value);
                // return 5;
                }
                if (value >= 0) {
                    // positive fixnum
                    if (value < 0x80) {
                        uint8$1(bytes, value);
                        return 1;
                    }
                    // uint 8
                    if (value < 0x100) {
                        bytes.push(0xcc);
                        uint8$1(bytes, value);
                        return 2;
                    }
                    // uint 16
                    if (value < 0x10000) {
                        bytes.push(0xcd);
                        uint16$1(bytes, value);
                        return 3;
                    }
                    // uint 32
                    if (value < 0x100000000) {
                        bytes.push(0xce);
                        uint32$1(bytes, value);
                        return 5;
                    }
                    // uint 64
                    bytes.push(0xcf);
                    uint64$1(bytes, value);
                    return 9;
                } else {
                    // negative fixnum
                    if (value >= -32) {
                        bytes.push(0xe0 | value + 0x20);
                        return 1;
                    }
                    // int 8
                    if (value >= -128) {
                        bytes.push(0xd0);
                        int8$1(bytes, value);
                        return 2;
                    }
                    // int 16
                    if (value >= -32768) {
                        bytes.push(0xd1);
                        int16$1(bytes, value);
                        return 3;
                    }
                    // int 32
                    if (value >= -2147483648) {
                        bytes.push(0xd2);
                        int32$1(bytes, value);
                        return 5;
                    }
                    // int 64
                    bytes.push(0xd3);
                    int64$1(bytes, value);
                    return 9;
                }
            }
            var encode = /*#__PURE__*/ Object.freeze({
                __proto__: null,
                utf8Write: utf8Write,
                int8: int8$1,
                uint8: uint8$1,
                int16: int16$1,
                uint16: uint16$1,
                int32: int32$1,
                uint32: uint32$1,
                int64: int64$1,
                uint64: uint64$1,
                float32: float32$1,
                float64: float64$1,
                writeFloat32: writeFloat32,
                writeFloat64: writeFloat64,
                boolean: boolean$1,
                string: string$1,
                number: number$1
            });
            /**
         * Copyright (c) 2018 Endel Dreyer
         * Copyright (c) 2014 Ion Drive Software Ltd.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in all
         * copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
         * SOFTWARE
         */ function utf8Read(bytes, offset, length) {
                var string = "", chr = 0;
                for(var i = offset, end = offset + length; i < end; i++){
                    var byte = bytes[i];
                    if ((byte & 0x80) === 0x00) {
                        string += String.fromCharCode(byte);
                        continue;
                    }
                    if ((byte & 0xe0) === 0xc0) {
                        string += String.fromCharCode((byte & 0x1f) << 6 | bytes[++i] & 0x3f);
                        continue;
                    }
                    if ((byte & 0xf0) === 0xe0) {
                        string += String.fromCharCode((byte & 0x0f) << 12 | (bytes[++i] & 0x3f) << 6 | (bytes[++i] & 0x3f) << 0);
                        continue;
                    }
                    if ((byte & 0xf8) === 0xf0) {
                        chr = (byte & 0x07) << 18 | (bytes[++i] & 0x3f) << 12 | (bytes[++i] & 0x3f) << 6 | (bytes[++i] & 0x3f) << 0;
                        if (chr >= 0x010000) {
                            chr -= 0x010000;
                            string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
                        } else string += String.fromCharCode(chr);
                        continue;
                    }
                    console.error("Invalid byte " + byte.toString(16));
                // (do not throw error to avoid server/client from crashing due to hack attemps)
                // throw new Error('Invalid byte ' + byte.toString(16));
                }
                return string;
            }
            function int8(bytes, it) {
                return uint8(bytes, it) << 24 >> 24;
            }
            function uint8(bytes, it) {
                return bytes[it.offset++];
            }
            function int16(bytes, it) {
                return uint16(bytes, it) << 16 >> 16;
            }
            function uint16(bytes, it) {
                return bytes[it.offset++] | bytes[it.offset++] << 8;
            }
            function int32(bytes, it) {
                return bytes[it.offset++] | bytes[it.offset++] << 8 | bytes[it.offset++] << 16 | bytes[it.offset++] << 24;
            }
            function uint32(bytes, it) {
                return int32(bytes, it) >>> 0;
            }
            function float32(bytes, it) {
                return readFloat32(bytes, it);
            }
            function float64(bytes, it) {
                return readFloat64(bytes, it);
            }
            function int64(bytes, it) {
                var low = uint32(bytes, it);
                var high = int32(bytes, it) * Math.pow(2, 32);
                return high + low;
            }
            function uint64(bytes, it) {
                var low = uint32(bytes, it);
                var high = uint32(bytes, it) * Math.pow(2, 32);
                return high + low;
            }
            var _int32 = new Int32Array(2);
            var _float32 = new Float32Array(_int32.buffer);
            var _float64 = new Float64Array(_int32.buffer);
            function readFloat32(bytes, it) {
                _int32[0] = int32(bytes, it);
                return _float32[0];
            }
            function readFloat64(bytes, it) {
                _int32[0] = int32(bytes, it);
                _int32[1] = int32(bytes, it);
                return _float64[0];
            }
            function boolean(bytes, it) {
                return uint8(bytes, it) > 0;
            }
            function string(bytes, it) {
                var prefix = bytes[it.offset++];
                var length;
                if (prefix < 0xc0) // fixstr
                length = prefix & 0x1f;
                else if (prefix === 0xd9) length = uint8(bytes, it);
                else if (prefix === 0xda) length = uint16(bytes, it);
                else if (prefix === 0xdb) length = uint32(bytes, it);
                var value = utf8Read(bytes, it.offset, length);
                it.offset += length;
                return value;
            }
            function stringCheck(bytes, it) {
                var prefix = bytes[it.offset];
                return(// fixstr
                prefix < 0xc0 && prefix > 0xa0 || // str 8
                prefix === 0xd9 || // str 16
                prefix === 0xda || // str 32
                prefix === 0xdb);
            }
            function number(bytes, it) {
                var prefix = bytes[it.offset++];
                if (prefix < 0x80) // positive fixint
                return prefix;
                else if (prefix === 0xca) // float 32
                return readFloat32(bytes, it);
                else if (prefix === 0xcb) // float 64
                return readFloat64(bytes, it);
                else if (prefix === 0xcc) // uint 8
                return uint8(bytes, it);
                else if (prefix === 0xcd) // uint 16
                return uint16(bytes, it);
                else if (prefix === 0xce) // uint 32
                return uint32(bytes, it);
                else if (prefix === 0xcf) // uint 64
                return uint64(bytes, it);
                else if (prefix === 0xd0) // int 8
                return int8(bytes, it);
                else if (prefix === 0xd1) // int 16
                return int16(bytes, it);
                else if (prefix === 0xd2) // int 32
                return int32(bytes, it);
                else if (prefix === 0xd3) // int 64
                return int64(bytes, it);
                else if (prefix > 0xdf) // negative fixint
                return (0xff - prefix + 1) * -1;
            }
            function numberCheck(bytes, it) {
                var prefix = bytes[it.offset];
                // positive fixint - 0x00 - 0x7f
                // float 32        - 0xca
                // float 64        - 0xcb
                // uint 8          - 0xcc
                // uint 16         - 0xcd
                // uint 32         - 0xce
                // uint 64         - 0xcf
                // int 8           - 0xd0
                // int 16          - 0xd1
                // int 32          - 0xd2
                // int 64          - 0xd3
                return prefix < 0x80 || prefix >= 0xca && prefix <= 0xd3;
            }
            function arrayCheck(bytes, it) {
                return bytes[it.offset] < 0xa0;
            // const prefix = bytes[it.offset] ;
            // if (prefix < 0xa0) {
            //   return prefix;
            // // array
            // } else if (prefix === 0xdc) {
            //   it.offset += 2;
            // } else if (0xdd) {
            //   it.offset += 4;
            // }
            // return prefix;
            }
            function switchStructureCheck(bytes, it) {
                return(// previous byte should be `SWITCH_TO_STRUCTURE`
                bytes[it.offset - 1] === SWITCH_TO_STRUCTURE && // next byte should be a number
                (bytes[it.offset] < 0x80 || bytes[it.offset] >= 0xca && bytes[it.offset] <= 0xd3));
            }
            var decode = /*#__PURE__*/ Object.freeze({
                __proto__: null,
                int8: int8,
                uint8: uint8,
                int16: int16,
                uint16: uint16,
                int32: int32,
                uint32: uint32,
                float32: float32,
                float64: float64,
                int64: int64,
                uint64: uint64,
                readFloat32: readFloat32,
                readFloat64: readFloat64,
                boolean: boolean,
                string: string,
                stringCheck: stringCheck,
                number: number,
                numberCheck: numberCheck,
                arrayCheck: arrayCheck,
                switchStructureCheck: switchStructureCheck
            });
            var CollectionSchema = /** @class */ function() {
                function CollectionSchema(initialValues) {
                    var _this = this;
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    if (initialValues) initialValues.forEach(function(v) {
                        return _this.add(v);
                    });
                }
                CollectionSchema.prototype.onAdd = function(callback, triggerAll) {
                    if (triggerAll === void 0) triggerAll = true;
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
                };
                CollectionSchema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                CollectionSchema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                CollectionSchema.is = function(type) {
                    return type["collection"] !== undefined;
                };
                CollectionSchema.prototype.add = function(value) {
                    // set "index" for reference.
                    var index = this.$refId++;
                    var isRef = value["$changes"] !== undefined;
                    if (isRef) value["$changes"].setParent(this, this.$changes.root, index);
                    this.$changes.indexes[index] = index;
                    this.$indexes.set(index, index);
                    this.$items.set(index, value);
                    this.$changes.change(index);
                    return index;
                };
                CollectionSchema.prototype.at = function(index) {
                    var key = Array.from(this.$items.keys())[index];
                    return this.$items.get(key);
                };
                CollectionSchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                CollectionSchema.prototype.delete = function(item) {
                    var entries = this.$items.entries();
                    var index;
                    var entry;
                    while(entry = entries.next()){
                        if (entry.done) break;
                        if (item === entry.value[1]) {
                            index = entry.value[0];
                            break;
                        }
                    }
                    if (index === undefined) return false;
                    this.$changes.delete(index);
                    this.$indexes.delete(index);
                    return this.$items.delete(index);
                };
                CollectionSchema.prototype.clear = function(changes) {
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    //
                    // When decoding:
                    // - enqueue items for DELETE callback.
                    // - flag child items for garbage collection.
                    //
                    if (changes) removeChildRefs.call(this, changes);
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                CollectionSchema.prototype.has = function(value) {
                    return Array.from(this.$items.values()).some(function(v) {
                        return v === value;
                    });
                };
                CollectionSchema.prototype.forEach = function(callbackfn) {
                    var _this = this;
                    this.$items.forEach(function(value, key, _) {
                        return callbackfn(value, key, _this);
                    });
                };
                CollectionSchema.prototype.values = function() {
                    return this.$items.values();
                };
                Object.defineProperty(CollectionSchema.prototype, "size", {
                    get: function() {
                        return this.$items.size;
                    },
                    enumerable: false,
                    configurable: true
                });
                CollectionSchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                CollectionSchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                CollectionSchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                CollectionSchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                CollectionSchema.prototype.toArray = function() {
                    return Array.from(this.$items.values());
                };
                CollectionSchema.prototype.toJSON = function() {
                    var values = [];
                    this.forEach(function(value, key) {
                        values.push(typeof value["toJSON"] === "function" ? value["toJSON"]() : value);
                    });
                    return values;
                };
                //
                // Decoding utilities
                //
                CollectionSchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) // client-side
                    cloned = Object.assign(new CollectionSchema(), this);
                    else {
                        // server-side
                        cloned = new CollectionSchema();
                        this.forEach(function(value) {
                            if (value["$changes"]) cloned.add(value["clone"]());
                            else cloned.add(value);
                        });
                    }
                    return cloned;
                };
                return CollectionSchema;
            }();
            var SetSchema = /** @class */ function() {
                function SetSchema(initialValues) {
                    var _this = this;
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    if (initialValues) initialValues.forEach(function(v) {
                        return _this.add(v);
                    });
                }
                SetSchema.prototype.onAdd = function(callback, triggerAll) {
                    if (triggerAll === void 0) triggerAll = true;
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
                };
                SetSchema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                SetSchema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                SetSchema.is = function(type) {
                    return type["set"] !== undefined;
                };
                SetSchema.prototype.add = function(value) {
                    var _a, _b;
                    // immediatelly return false if value already added.
                    if (this.has(value)) return false;
                    // set "index" for reference.
                    var index = this.$refId++;
                    if (value["$changes"] !== undefined) value["$changes"].setParent(this, this.$changes.root, index);
                    var operation = (_b = (_a = this.$changes.indexes[index]) === null || _a === void 0 ? void 0 : _a.op) !== null && _b !== void 0 ? _b : exports1.OPERATION.ADD;
                    this.$changes.indexes[index] = index;
                    this.$indexes.set(index, index);
                    this.$items.set(index, value);
                    this.$changes.change(index, operation);
                    return index;
                };
                SetSchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                SetSchema.prototype.delete = function(item) {
                    var entries = this.$items.entries();
                    var index;
                    var entry;
                    while(entry = entries.next()){
                        if (entry.done) break;
                        if (item === entry.value[1]) {
                            index = entry.value[0];
                            break;
                        }
                    }
                    if (index === undefined) return false;
                    this.$changes.delete(index);
                    this.$indexes.delete(index);
                    return this.$items.delete(index);
                };
                SetSchema.prototype.clear = function(changes) {
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    //
                    // When decoding:
                    // - enqueue items for DELETE callback.
                    // - flag child items for garbage collection.
                    //
                    if (changes) removeChildRefs.call(this, changes);
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                SetSchema.prototype.has = function(value) {
                    var values = this.$items.values();
                    var has = false;
                    var entry;
                    while(entry = values.next()){
                        if (entry.done) break;
                        if (value === entry.value) {
                            has = true;
                            break;
                        }
                    }
                    return has;
                };
                SetSchema.prototype.forEach = function(callbackfn) {
                    var _this = this;
                    this.$items.forEach(function(value, key, _) {
                        return callbackfn(value, key, _this);
                    });
                };
                SetSchema.prototype.values = function() {
                    return this.$items.values();
                };
                Object.defineProperty(SetSchema.prototype, "size", {
                    get: function() {
                        return this.$items.size;
                    },
                    enumerable: false,
                    configurable: true
                });
                SetSchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                SetSchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                SetSchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                SetSchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                SetSchema.prototype.toArray = function() {
                    return Array.from(this.$items.values());
                };
                SetSchema.prototype.toJSON = function() {
                    var values = [];
                    this.forEach(function(value, key) {
                        values.push(typeof value["toJSON"] === "function" ? value["toJSON"]() : value);
                    });
                    return values;
                };
                //
                // Decoding utilities
                //
                SetSchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) // client-side
                    cloned = Object.assign(new SetSchema(), this);
                    else {
                        // server-side
                        cloned = new SetSchema();
                        this.forEach(function(value) {
                            if (value["$changes"]) cloned.add(value["clone"]());
                            else cloned.add(value);
                        });
                    }
                    return cloned;
                };
                return SetSchema;
            }();
            var ClientState = /** @class */ function() {
                function ClientState() {
                    this.refIds = new WeakSet();
                    this.containerIndexes = new WeakMap();
                }
                // containerIndexes = new Map<ChangeTree, Set<number>>();
                ClientState.prototype.addRefId = function(changeTree) {
                    if (!this.refIds.has(changeTree)) {
                        this.refIds.add(changeTree);
                        this.containerIndexes.set(changeTree, new Set());
                    }
                };
                ClientState.get = function(client) {
                    if (client.$filterState === undefined) client.$filterState = new ClientState();
                    return client.$filterState;
                };
                return ClientState;
            }();
            var ReferenceTracker = /** @class */ function() {
                function ReferenceTracker() {
                    //
                    // Relation of refId => Schema structure
                    // For direct access of structures during decoding time.
                    //
                    this.refs = new Map();
                    this.refCounts = {};
                    this.deletedRefs = new Set();
                    this.nextUniqueId = 0;
                }
                ReferenceTracker.prototype.getNextUniqueId = function() {
                    return this.nextUniqueId++;
                };
                // for decoding
                ReferenceTracker.prototype.addRef = function(refId, ref, incrementCount) {
                    if (incrementCount === void 0) incrementCount = true;
                    this.refs.set(refId, ref);
                    if (incrementCount) this.refCounts[refId] = (this.refCounts[refId] || 0) + 1;
                };
                // for decoding
                ReferenceTracker.prototype.removeRef = function(refId) {
                    this.refCounts[refId] = this.refCounts[refId] - 1;
                    this.deletedRefs.add(refId);
                };
                ReferenceTracker.prototype.clearRefs = function() {
                    this.refs.clear();
                    this.deletedRefs.clear();
                    this.refCounts = {};
                };
                // for decoding
                ReferenceTracker.prototype.garbageCollectDeletedRefs = function() {
                    var _this = this;
                    this.deletedRefs.forEach(function(refId) {
                        //
                        // Skip active references.
                        //
                        if (_this.refCounts[refId] > 0) return;
                        var ref = _this.refs.get(refId);
                        //
                        // Ensure child schema instances have their references removed as well.
                        //
                        if (ref instanceof Schema) {
                            for(var fieldName in ref["_definition"].schema)if (typeof ref["_definition"].schema[fieldName] !== "string" && ref[fieldName] && ref[fieldName]["$changes"]) _this.removeRef(ref[fieldName]["$changes"].refId);
                        } else {
                            var definition = ref["$changes"].parent._definition;
                            var type = definition.schema[definition.fieldsByIndex[ref["$changes"].parentIndex]];
                            if (typeof Object.values(type)[0] === "function") Array.from(ref.values()).forEach(function(child) {
                                return _this.removeRef(child["$changes"].refId);
                            });
                        }
                        _this.refs.delete(refId);
                        delete _this.refCounts[refId];
                    });
                    // clear deleted refs.
                    this.deletedRefs.clear();
                };
                return ReferenceTracker;
            }();
            var EncodeSchemaError = /** @class */ function(_super) {
                __extends(EncodeSchemaError, _super);
                function EncodeSchemaError() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return EncodeSchemaError;
            }(Error);
            function assertType(value, type, klass, field) {
                var typeofTarget;
                var allowNull = false;
                switch(type){
                    case "number":
                    case "int8":
                    case "uint8":
                    case "int16":
                    case "uint16":
                    case "int32":
                    case "uint32":
                    case "int64":
                    case "uint64":
                    case "float32":
                    case "float64":
                        typeofTarget = "number";
                        if (isNaN(value)) console.log('trying to encode "NaN" in '.concat(klass.constructor.name, "#").concat(field));
                        break;
                    case "string":
                        typeofTarget = "string";
                        allowNull = true;
                        break;
                    case "boolean":
                        // boolean is always encoded as true/false based on truthiness
                        return;
                }
                if (typeof value !== typeofTarget && (!allowNull || allowNull && value !== null)) {
                    var foundValue = "'".concat(JSON.stringify(value), "'").concat(value && value.constructor && " (".concat(value.constructor.name, ")") || "");
                    throw new EncodeSchemaError("a '".concat(typeofTarget, "' was expected, but ").concat(foundValue, " was provided in ").concat(klass.constructor.name, "#").concat(field));
                }
            }
            function assertInstanceType(value, type, klass, field) {
                if (!(value instanceof type)) throw new EncodeSchemaError("a '".concat(type.name, "' was expected, but '").concat(value.constructor.name, "' was provided in ").concat(klass.constructor.name, "#").concat(field));
            }
            function encodePrimitiveType(type, bytes, value, klass, field) {
                assertType(value, type, klass, field);
                var encodeFunc = encode[type];
                if (encodeFunc) encodeFunc(bytes, value);
                else throw new EncodeSchemaError("a '".concat(type, "' was expected, but ").concat(value, " was provided in ").concat(klass.constructor.name, "#").concat(field));
            }
            function decodePrimitiveType(type, bytes, it) {
                return decode[type](bytes, it);
            }
            /**
         * Schema encoder / decoder
         */ var Schema = /** @class */ function() {
                // allow inherited classes to have a constructor
                function Schema() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    // fix enumerability of fields for end-user
                    Object.defineProperties(this, {
                        $changes: {
                            value: new ChangeTree(this, undefined, new ReferenceTracker()),
                            enumerable: false,
                            writable: true
                        },
                        // $listeners: {
                        //     value: undefined,
                        //     enumerable: false,
                        //     writable: true
                        // },
                        $callbacks: {
                            value: undefined,
                            enumerable: false,
                            writable: true
                        }
                    });
                    var descriptors = this._definition.descriptors;
                    if (descriptors) Object.defineProperties(this, descriptors);
                    //
                    // Assign initial values
                    //
                    if (args[0]) this.assign(args[0]);
                }
                Schema.onError = function(e) {
                    console.error(e);
                };
                Schema.is = function(type) {
                    return type["_definition"] && type["_definition"].schema !== undefined;
                };
                Schema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                Schema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                Schema.prototype.assign = function(props) {
                    Object.assign(this, props);
                    return this;
                };
                Object.defineProperty(Schema.prototype, "_definition", {
                    get: function() {
                        return this.constructor._definition;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
             * (Server-side): Flag a property to be encoded for the next patch.
             * @param instance Schema instance
             * @param property string representing the property name, or number representing the index of the property.
             * @param operation OPERATION to perform (detected automatically)
             */ Schema.prototype.setDirty = function(property, operation) {
                    this.$changes.change(property, operation);
                };
                /**
             * Client-side: listen for changes on property.
             * @param prop the property name
             * @param callback callback to be triggered on property change
             * @param immediate trigger immediatelly if property has been already set.
             */ Schema.prototype.listen = function(prop, callback, immediate) {
                    var _this = this;
                    if (immediate === void 0) immediate = true;
                    if (!this.$callbacks) this.$callbacks = {};
                    if (!this.$callbacks[prop]) this.$callbacks[prop] = [];
                    this.$callbacks[prop].push(callback);
                    if (immediate && this[prop] !== undefined) callback(this[prop], undefined);
                    // return un-register callback.
                    return function() {
                        return spliceOne(_this.$callbacks[prop], _this.$callbacks[prop].indexOf(callback));
                    };
                };
                Schema.prototype.decode = function(bytes, it, ref) {
                    var _a;
                    if (it === void 0) it = {
                        offset: 0
                    };
                    if (ref === void 0) ref = this;
                    var allChanges = [];
                    var $root = this.$changes.root;
                    var totalBytes = bytes.length;
                    var refId = 0;
                    $root.refs.set(refId, this);
                    while(it.offset < totalBytes){
                        var byte = bytes[it.offset++];
                        if (byte == SWITCH_TO_STRUCTURE) {
                            refId = number(bytes, it);
                            var nextRef = $root.refs.get(refId);
                            //
                            // Trying to access a reference that haven't been decoded yet.
                            //
                            if (!nextRef) throw new Error('"refId" not found: '.concat(refId));
                            ref = nextRef;
                            continue;
                        }
                        var changeTree = ref["$changes"];
                        var isSchema = ref["_definition"] !== undefined;
                        var operation = isSchema ? byte >> 6 << 6 // "compressed" index + operation
                         : byte; // "uncompressed" index + operation (array/map items)
                        if (operation === exports1.OPERATION.CLEAR) {
                            //
                            // TODO: refactor me!
                            // The `.clear()` method is calling `$root.removeRef(refId)` for
                            // each item inside this collection
                            //
                            ref.clear(allChanges);
                            continue;
                        }
                        var fieldIndex = isSchema ? byte % (operation || 255 // if "REPLACE" operation (0), use 255
                        ) : number(bytes, it);
                        var fieldName = isSchema ? ref["_definition"].fieldsByIndex[fieldIndex] : "";
                        var type = changeTree.getType(fieldIndex);
                        var value = void 0;
                        var previousValue = void 0;
                        var dynamicIndex = void 0;
                        if (!isSchema) {
                            previousValue = ref["getByIndex"](fieldIndex);
                            if ((operation & exports1.OPERATION.ADD) === exports1.OPERATION.ADD) {
                                dynamicIndex = ref instanceof MapSchema ? string(bytes, it) : fieldIndex;
                                ref["setIndex"](fieldIndex, dynamicIndex);
                            } else // here
                            dynamicIndex = ref["getIndex"](fieldIndex);
                        } else previousValue = ref["_".concat(fieldName)];
                        //
                        // Delete operations
                        //
                        if ((operation & exports1.OPERATION.DELETE) === exports1.OPERATION.DELETE) {
                            if (operation !== exports1.OPERATION.DELETE_AND_ADD) ref["deleteByIndex"](fieldIndex);
                            // Flag `refId` for garbage collection.
                            if (previousValue && previousValue["$changes"]) $root.removeRef(previousValue["$changes"].refId);
                            value = null;
                        }
                        if (fieldName === undefined) {
                            console.warn("@colyseus/schema: definition mismatch");
                            //
                            // keep skipping next bytes until reaches a known structure
                            // by local decoder.
                            //
                            var nextIterator = {
                                offset: it.offset
                            };
                            while(it.offset < totalBytes){
                                if (switchStructureCheck(bytes, it)) {
                                    nextIterator.offset = it.offset + 1;
                                    if ($root.refs.has(number(bytes, nextIterator))) break;
                                }
                                it.offset++;
                            }
                            continue;
                        } else if (operation === exports1.OPERATION.DELETE) ;
                        else if (Schema.is(type)) {
                            var refId_1 = number(bytes, it);
                            value = $root.refs.get(refId_1);
                            if (operation !== exports1.OPERATION.REPLACE) {
                                var childType = this.getSchemaType(bytes, it, type);
                                if (!value) {
                                    value = this.createTypeInstance(childType);
                                    value.$changes.refId = refId_1;
                                    if (previousValue) {
                                        value.$callbacks = previousValue.$callbacks;
                                        // value.$listeners = previousValue.$listeners;
                                        if (previousValue["$changes"].refId && refId_1 !== previousValue["$changes"].refId) $root.removeRef(previousValue["$changes"].refId);
                                    }
                                }
                                $root.addRef(refId_1, value, value !== previousValue);
                            }
                        } else if (typeof type === "string") //
                        // primitive value (number, string, boolean, etc)
                        //
                        value = decodePrimitiveType(type, bytes, it);
                        else {
                            var typeDef = getType(Object.keys(type)[0]);
                            var refId_2 = number(bytes, it);
                            var valueRef = $root.refs.has(refId_2) ? previousValue || $root.refs.get(refId_2) : new typeDef.constructor();
                            value = valueRef.clone(true);
                            value.$changes.refId = refId_2;
                            // preserve schema callbacks
                            if (previousValue) {
                                value["$callbacks"] = previousValue["$callbacks"];
                                if (previousValue["$changes"].refId && refId_2 !== previousValue["$changes"].refId) {
                                    $root.removeRef(previousValue["$changes"].refId);
                                    //
                                    // Trigger onRemove if structure has been replaced.
                                    //
                                    var entries = previousValue.entries();
                                    var iter = void 0;
                                    while((iter = entries.next()) && !iter.done){
                                        var key = (_a = iter.value, _a[0]), value_1 = _a[1];
                                        allChanges.push({
                                            refId: refId_2,
                                            op: exports1.OPERATION.DELETE,
                                            field: key,
                                            value: undefined,
                                            previousValue: value_1
                                        });
                                    }
                                }
                            }
                            $root.addRef(refId_2, value, valueRef !== previousValue);
                        }
                        if (value !== null && value !== undefined) {
                            if (value["$changes"]) value["$changes"].setParent(changeTree.ref, changeTree.root, fieldIndex);
                            if (ref instanceof Schema) ref[fieldName] = value;
                            else if (ref instanceof MapSchema) {
                                // const key = ref['$indexes'].get(field);
                                var key = dynamicIndex;
                                // ref.set(key, value);
                                ref["$items"].set(key, value);
                                ref["$changes"].allChanges.add(fieldIndex);
                            } else if (ref instanceof ArraySchema) // const key = ref['$indexes'][field];
                            // console.log("SETTING FOR ArraySchema =>", { field, key, value });
                            // ref[key] = value;
                            ref.setAt(fieldIndex, value);
                            else if (ref instanceof CollectionSchema) {
                                var index = ref.add(value);
                                ref["setIndex"](fieldIndex, index);
                            } else if (ref instanceof SetSchema) {
                                var index = ref.add(value);
                                if (index !== false) ref["setIndex"](fieldIndex, index);
                            }
                        }
                        if (previousValue !== value) allChanges.push({
                            refId: refId,
                            op: operation,
                            field: fieldName,
                            dynamicIndex: dynamicIndex,
                            value: value,
                            previousValue: previousValue
                        });
                    }
                    this._triggerChanges(allChanges);
                    // drop references of unused schemas
                    $root.garbageCollectDeletedRefs();
                    return allChanges;
                };
                Schema.prototype.encode = function(encodeAll, bytes, useFilters) {
                    if (encodeAll === void 0) encodeAll = false;
                    if (bytes === void 0) bytes = [];
                    if (useFilters === void 0) useFilters = false;
                    var rootChangeTree = this.$changes;
                    var refIdsVisited = new WeakSet();
                    var changeTrees = [
                        rootChangeTree
                    ];
                    var numChangeTrees = 1;
                    for(var i = 0; i < numChangeTrees; i++){
                        var changeTree = changeTrees[i];
                        var ref = changeTree.ref;
                        var isSchema = ref instanceof Schema;
                        // Generate unique refId for the ChangeTree.
                        changeTree.ensureRefId();
                        // mark this ChangeTree as visited.
                        refIdsVisited.add(changeTree);
                        // root `refId` is skipped.
                        if (changeTree !== rootChangeTree && (changeTree.changed || encodeAll)) {
                            uint8$1(bytes, SWITCH_TO_STRUCTURE);
                            number$1(bytes, changeTree.refId);
                        }
                        var changes = encodeAll ? Array.from(changeTree.allChanges) : Array.from(changeTree.changes.values());
                        for(var j = 0, cl = changes.length; j < cl; j++){
                            var operation = encodeAll ? {
                                op: exports1.OPERATION.ADD,
                                index: changes[j]
                            } : changes[j];
                            var fieldIndex = operation.index;
                            var field = isSchema ? ref["_definition"].fieldsByIndex && ref["_definition"].fieldsByIndex[fieldIndex] : fieldIndex;
                            // cache begin index if `useFilters`
                            var beginIndex = bytes.length;
                            // encode field index + operation
                            if (operation.op !== exports1.OPERATION.TOUCH) {
                                if (isSchema) //
                                // Compress `fieldIndex` + `operation` into a single byte.
                                // This adds a limitaion of 64 fields per Schema structure
                                //
                                uint8$1(bytes, fieldIndex | operation.op);
                                else {
                                    uint8$1(bytes, operation.op);
                                    // custom operations
                                    if (operation.op === exports1.OPERATION.CLEAR) continue;
                                    // indexed operations
                                    number$1(bytes, fieldIndex);
                                }
                            }
                            //
                            // encode "alias" for dynamic fields (maps)
                            //
                            if (!isSchema && (operation.op & exports1.OPERATION.ADD) == exports1.OPERATION.ADD // ADD or DELETE_AND_ADD
                            ) {
                                if (ref instanceof MapSchema) {
                                    //
                                    // MapSchema dynamic key
                                    //
                                    var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                                    string$1(bytes, dynamicIndex);
                                }
                            }
                            if (operation.op === exports1.OPERATION.DELETE) continue;
                            // const type = changeTree.childType || ref._schema[field];
                            var type = changeTree.getType(fieldIndex);
                            // const type = changeTree.getType(fieldIndex);
                            var value = changeTree.getValue(fieldIndex);
                            // Enqueue ChangeTree to be visited
                            if (value && value["$changes"] && !refIdsVisited.has(value["$changes"])) {
                                changeTrees.push(value["$changes"]);
                                value["$changes"].ensureRefId();
                                numChangeTrees++;
                            }
                            if (operation.op === exports1.OPERATION.TOUCH) continue;
                            if (Schema.is(type)) {
                                assertInstanceType(value, type, ref, field);
                                //
                                // Encode refId for this instance.
                                // The actual instance is going to be encoded on next `changeTree` iteration.
                                //
                                number$1(bytes, value.$changes.refId);
                                // Try to encode inherited TYPE_ID if it's an ADD operation.
                                if ((operation.op & exports1.OPERATION.ADD) === exports1.OPERATION.ADD) this.tryEncodeTypeId(bytes, type, value.constructor);
                            } else if (typeof type === "string") //
                            // Primitive values
                            //
                            encodePrimitiveType(type, bytes, value, ref, field);
                            else {
                                //
                                // Custom type (MapSchema, ArraySchema, etc)
                                //
                                var definition = getType(Object.keys(type)[0]);
                                //
                                // ensure a ArraySchema has been provided
                                //
                                assertInstanceType(ref["_".concat(field)], definition.constructor, ref, field);
                                //
                                // Encode refId for this instance.
                                // The actual instance is going to be encoded on next `changeTree` iteration.
                                //
                                number$1(bytes, value.$changes.refId);
                            }
                            if (useFilters) // cache begin / end index
                            changeTree.cache(fieldIndex, bytes.slice(beginIndex));
                        }
                        if (!encodeAll && !useFilters) changeTree.discard();
                    }
                    return bytes;
                };
                Schema.prototype.encodeAll = function(useFilters) {
                    return this.encode(true, [], useFilters);
                };
                Schema.prototype.applyFilters = function(client, encodeAll) {
                    var _a, _b;
                    if (encodeAll === void 0) encodeAll = false;
                    var root = this;
                    var refIdsDissallowed = new Set();
                    var $filterState = ClientState.get(client);
                    var changeTrees = [
                        this.$changes
                    ];
                    var numChangeTrees = 1;
                    var filteredBytes = [];
                    var _loop_1 = function(i) {
                        var changeTree = changeTrees[i];
                        if (refIdsDissallowed.has(changeTree.refId)) return "continue";
                        var ref = changeTree.ref;
                        var isSchema = ref instanceof Schema;
                        uint8$1(filteredBytes, SWITCH_TO_STRUCTURE);
                        number$1(filteredBytes, changeTree.refId);
                        var clientHasRefId = $filterState.refIds.has(changeTree);
                        var isEncodeAll = encodeAll || !clientHasRefId;
                        // console.log("REF:", ref.constructor.name);
                        // console.log("Encode all?", isEncodeAll);
                        //
                        // include `changeTree` on list of known refIds by this client.
                        //
                        $filterState.addRefId(changeTree);
                        var containerIndexes = $filterState.containerIndexes.get(changeTree);
                        var changes = isEncodeAll ? Array.from(changeTree.allChanges) : Array.from(changeTree.changes.values());
                        //
                        // WORKAROUND: tries to re-evaluate previously not included @filter() attributes
                        // - see "DELETE a field of Schema" test case.
                        //
                        if (!encodeAll && isSchema && ref._definition.indexesWithFilters) {
                            var indexesWithFilters = ref._definition.indexesWithFilters;
                            indexesWithFilters.forEach(function(indexWithFilter) {
                                if (!containerIndexes.has(indexWithFilter) && changeTree.allChanges.has(indexWithFilter)) {
                                    if (isEncodeAll) changes.push(indexWithFilter);
                                    else changes.push({
                                        op: exports1.OPERATION.ADD,
                                        index: indexWithFilter
                                    });
                                }
                            });
                        }
                        for(var j = 0, cl = changes.length; j < cl; j++){
                            var change = isEncodeAll ? {
                                op: exports1.OPERATION.ADD,
                                index: changes[j]
                            } : changes[j];
                            // custom operations
                            if (change.op === exports1.OPERATION.CLEAR) {
                                uint8$1(filteredBytes, change.op);
                                continue;
                            }
                            var fieldIndex = change.index;
                            //
                            // Deleting fields: encode the operation + field index
                            //
                            if (change.op === exports1.OPERATION.DELETE) {
                                //
                                // DELETE operations also need to go through filtering.
                                //
                                // TODO: cache the previous value so we can access the value (primitive or `refId`)
                                // (check against `$filterState.refIds`)
                                //
                                if (isSchema) uint8$1(filteredBytes, change.op | fieldIndex);
                                else {
                                    uint8$1(filteredBytes, change.op);
                                    number$1(filteredBytes, fieldIndex);
                                }
                                continue;
                            }
                            // indexed operation
                            var value = changeTree.getValue(fieldIndex);
                            var type = changeTree.getType(fieldIndex);
                            if (isSchema) {
                                // Is a Schema!
                                var filter = ref._definition.filters && ref._definition.filters[fieldIndex];
                                if (filter && !filter.call(ref, client, value, root)) {
                                    if (value && value["$changes"]) refIdsDissallowed.add(value["$changes"].refId);
                                    continue;
                                }
                            } else {
                                // Is a collection! (map, array, etc.)
                                var parent = changeTree.parent;
                                var filter = changeTree.getChildrenFilter();
                                if (filter && !filter.call(parent, client, ref["$indexes"].get(fieldIndex), value, root)) {
                                    if (value && value["$changes"]) refIdsDissallowed.add(value["$changes"].refId);
                                    continue;
                                }
                            }
                            // visit child ChangeTree on further iteration.
                            if (value["$changes"]) {
                                changeTrees.push(value["$changes"]);
                                numChangeTrees++;
                            }
                            //
                            // Copy cached bytes
                            //
                            if (change.op !== exports1.OPERATION.TOUCH) {
                                //
                                // TODO: refactor me!
                                //
                                if (change.op === exports1.OPERATION.ADD || isSchema) {
                                    //
                                    // use cached bytes directly if is from Schema type.
                                    //
                                    filteredBytes.push.apply(filteredBytes, (_a = changeTree.caches[fieldIndex]) !== null && _a !== void 0 ? _a : []);
                                    containerIndexes.add(fieldIndex);
                                } else if (containerIndexes.has(fieldIndex)) //
                                // use cached bytes if already has the field
                                //
                                filteredBytes.push.apply(filteredBytes, (_b = changeTree.caches[fieldIndex]) !== null && _b !== void 0 ? _b : []);
                                else {
                                    //
                                    // force ADD operation if field is not known by this client.
                                    //
                                    containerIndexes.add(fieldIndex);
                                    uint8$1(filteredBytes, exports1.OPERATION.ADD);
                                    number$1(filteredBytes, fieldIndex);
                                    if (ref instanceof MapSchema) {
                                        //
                                        // MapSchema dynamic key
                                        //
                                        var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                                        string$1(filteredBytes, dynamicIndex);
                                    }
                                    if (value["$changes"]) number$1(filteredBytes, value["$changes"].refId);
                                    else // "encodePrimitiveType" without type checking.
                                    // the type checking has been done on the first .encode() call.
                                    encode[type](filteredBytes, value);
                                }
                            } else if (value["$changes"] && !isSchema) {
                                //
                                // TODO:
                                // - track ADD/REPLACE/DELETE instances on `$filterState`
                                // - do NOT always encode dynamicIndex for MapSchema.
                                //   (If client already has that key, only the first index is necessary.)
                                //
                                uint8$1(filteredBytes, exports1.OPERATION.ADD);
                                number$1(filteredBytes, fieldIndex);
                                if (ref instanceof MapSchema) {
                                    //
                                    // MapSchema dynamic key
                                    //
                                    var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                                    string$1(filteredBytes, dynamicIndex);
                                }
                                number$1(filteredBytes, value["$changes"].refId);
                            }
                        }
                    };
                    for(var i = 0; i < numChangeTrees; i++)_loop_1(i);
                    return filteredBytes;
                };
                Schema.prototype.clone = function() {
                    var _a;
                    var cloned = new this.constructor;
                    var schema = this._definition.schema;
                    for(var field in schema)if (typeof this[field] === "object" && typeof ((_a = this[field]) === null || _a === void 0 ? void 0 : _a.clone) === "function") // deep clone
                    cloned[field] = this[field].clone();
                    else // primitive values
                    cloned[field] = this[field];
                    return cloned;
                };
                Schema.prototype.toJSON = function() {
                    var schema = this._definition.schema;
                    var deprecated = this._definition.deprecated;
                    var obj = {};
                    for(var field in schema)if (!deprecated[field] && this[field] !== null && typeof this[field] !== "undefined") obj[field] = typeof this[field]["toJSON"] === "function" ? this[field]["toJSON"]() : this["_".concat(field)];
                    return obj;
                };
                Schema.prototype.discardAllChanges = function() {
                    this.$changes.discardAll();
                };
                Schema.prototype.getByIndex = function(index) {
                    return this[this._definition.fieldsByIndex[index]];
                };
                Schema.prototype.deleteByIndex = function(index) {
                    this[this._definition.fieldsByIndex[index]] = undefined;
                };
                Schema.prototype.tryEncodeTypeId = function(bytes, type, targetType) {
                    if (type._typeid !== targetType._typeid) {
                        uint8$1(bytes, TYPE_ID);
                        number$1(bytes, targetType._typeid);
                    }
                };
                Schema.prototype.getSchemaType = function(bytes, it, defaultType) {
                    var type;
                    if (bytes[it.offset] === TYPE_ID) {
                        it.offset++;
                        type = this.constructor._context.get(number(bytes, it));
                    }
                    return type || defaultType;
                };
                Schema.prototype.createTypeInstance = function(type) {
                    var instance = new type();
                    // assign root on $changes
                    instance.$changes.root = this.$changes.root;
                    return instance;
                };
                Schema.prototype._triggerChanges = function(changes) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    var uniqueRefIds = new Set();
                    var $refs = this.$changes.root.refs;
                    var _loop_2 = function(i) {
                        var change = changes[i];
                        var refId = change.refId;
                        var ref = $refs.get(refId);
                        var $callbacks = ref["$callbacks"];
                        //
                        // trigger onRemove on child structure.
                        //
                        if ((change.op & exports1.OPERATION.DELETE) === exports1.OPERATION.DELETE && change.previousValue instanceof Schema) (_b = (_a = change.previousValue["$callbacks"]) === null || _a === void 0 ? void 0 : _a[exports1.OPERATION.DELETE]) === null || _b === void 0 || _b.forEach(function(callback) {
                            return callback();
                        });
                        // no callbacks defined, skip this structure!
                        if (!$callbacks) return "continue";
                        if (ref instanceof Schema) {
                            if (!uniqueRefIds.has(refId)) try {
                                // trigger onChange
                                (_c = $callbacks === null || $callbacks === void 0 ? void 0 : $callbacks[exports1.OPERATION.REPLACE]) === null || _c === void 0 || _c.forEach(function(callback) {
                                    return callback(changes);
                                });
                            } catch (e) {
                                Schema.onError(e);
                            }
                            try {
                                if ($callbacks.hasOwnProperty(change.field)) (_d = $callbacks[change.field]) === null || _d === void 0 || _d.forEach(function(callback) {
                                    return callback(change.value, change.previousValue);
                                });
                            } catch (e) {
                                Schema.onError(e);
                            }
                        } else {
                            // is a collection of items
                            if (change.op === exports1.OPERATION.ADD && change.previousValue === undefined) // triger onAdd
                            (_e = $callbacks[exports1.OPERATION.ADD]) === null || _e === void 0 || _e.forEach(function(callback) {
                                var _a;
                                return callback(change.value, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                            });
                            else if (change.op === exports1.OPERATION.DELETE) //
                            // FIXME: `previousValue` should always be available.
                            // ADD + DELETE operations are still encoding DELETE operation.
                            //
                            {
                                if (change.previousValue !== undefined) // triger onRemove
                                (_f = $callbacks[exports1.OPERATION.DELETE]) === null || _f === void 0 || _f.forEach(function(callback) {
                                    var _a;
                                    return callback(change.previousValue, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                                });
                            } else if (change.op === exports1.OPERATION.DELETE_AND_ADD) {
                                // triger onRemove
                                if (change.previousValue !== undefined) (_g = $callbacks[exports1.OPERATION.DELETE]) === null || _g === void 0 || _g.forEach(function(callback) {
                                    var _a;
                                    return callback(change.previousValue, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                                });
                                // triger onAdd
                                (_h = $callbacks[exports1.OPERATION.ADD]) === null || _h === void 0 || _h.forEach(function(callback) {
                                    var _a;
                                    return callback(change.value, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                                });
                            }
                            // trigger onChange
                            if (change.value !== change.previousValue) (_j = $callbacks[exports1.OPERATION.REPLACE]) === null || _j === void 0 || _j.forEach(function(callback) {
                                var _a;
                                return callback(change.value, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                            });
                        }
                        uniqueRefIds.add(refId);
                    };
                    for(var i = 0; i < changes.length; i++)_loop_2(i);
                };
                Schema._definition = SchemaDefinition.create();
                return Schema;
            }();
            function dumpChanges(schema) {
                var changeTrees = [
                    schema["$changes"]
                ];
                var numChangeTrees = 1;
                var dump = {};
                var currentStructure = dump;
                var _loop_1 = function(i) {
                    var changeTree = changeTrees[i];
                    changeTree.changes.forEach(function(change) {
                        var ref = changeTree.ref;
                        var fieldIndex = change.index;
                        var field = ref["_definition"] ? ref["_definition"].fieldsByIndex[fieldIndex] : ref["$indexes"].get(fieldIndex);
                        currentStructure[field] = changeTree.getValue(fieldIndex);
                    });
                };
                for(var i = 0; i < numChangeTrees; i++)_loop_1(i);
                return dump;
            }
            var reflectionContext = {
                context: new Context()
            };
            /**
         * Reflection
         */ var ReflectionField = /** @class */ function(_super) {
                __extends(ReflectionField, _super);
                function ReflectionField() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                __decorate([
                    type("string", reflectionContext)
                ], ReflectionField.prototype, "name", void 0);
                __decorate([
                    type("string", reflectionContext)
                ], ReflectionField.prototype, "type", void 0);
                __decorate([
                    type("number", reflectionContext)
                ], ReflectionField.prototype, "referencedType", void 0);
                return ReflectionField;
            }(Schema);
            var ReflectionType = /** @class */ function(_super) {
                __extends(ReflectionType, _super);
                function ReflectionType() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.fields = new ArraySchema();
                    return _this;
                }
                __decorate([
                    type("number", reflectionContext)
                ], ReflectionType.prototype, "id", void 0);
                __decorate([
                    type([
                        ReflectionField
                    ], reflectionContext)
                ], ReflectionType.prototype, "fields", void 0);
                return ReflectionType;
            }(Schema);
            var Reflection = /** @class */ function(_super) {
                __extends(Reflection, _super);
                function Reflection() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.types = new ArraySchema();
                    return _this;
                }
                Reflection.encode = function(instance) {
                    var rootSchemaType = instance.constructor;
                    var reflection = new Reflection();
                    reflection.rootType = rootSchemaType._typeid;
                    var buildType = function(currentType, schema) {
                        for(var fieldName in schema){
                            var field = new ReflectionField();
                            field.name = fieldName;
                            var fieldType = void 0;
                            if (typeof schema[fieldName] === "string") fieldType = schema[fieldName];
                            else {
                                var type_1 = schema[fieldName];
                                var childTypeSchema = void 0;
                                //
                                // TODO: refactor below.
                                //
                                if (Schema.is(type_1)) {
                                    fieldType = "ref";
                                    childTypeSchema = schema[fieldName];
                                } else {
                                    fieldType = Object.keys(type_1)[0];
                                    if (typeof type_1[fieldType] === "string") fieldType += ":" + type_1[fieldType]; // array:string
                                    else childTypeSchema = type_1[fieldType];
                                }
                                field.referencedType = childTypeSchema ? childTypeSchema._typeid : -1;
                            }
                            field.type = fieldType;
                            currentType.fields.push(field);
                        }
                        reflection.types.push(currentType);
                    };
                    var types = rootSchemaType._context.types;
                    for(var typeid in types){
                        var type_2 = new ReflectionType();
                        type_2.id = Number(typeid);
                        buildType(type_2, types[typeid]._definition.schema);
                    }
                    return reflection.encodeAll();
                };
                Reflection.decode = function(bytes, it) {
                    var context = new Context();
                    var reflection = new Reflection();
                    reflection.decode(bytes, it);
                    var schemaTypes = reflection.types.reduce(function(types, reflectionType) {
                        var schema = /** @class */ function(_super) {
                            __extends(_, _super);
                            function _() {
                                return _super !== null && _super.apply(this, arguments) || this;
                            }
                            return _;
                        }(Schema);
                        var typeid = reflectionType.id;
                        types[typeid] = schema;
                        context.add(schema, typeid);
                        return types;
                    }, {});
                    reflection.types.forEach(function(reflectionType) {
                        var schemaType = schemaTypes[reflectionType.id];
                        reflectionType.fields.forEach(function(field) {
                            var _a;
                            if (field.referencedType !== undefined) {
                                var fieldType = field.type;
                                var refType = schemaTypes[field.referencedType];
                                // map or array of primitive type (-1)
                                if (!refType) {
                                    var typeInfo = field.type.split(":");
                                    fieldType = typeInfo[0];
                                    refType = typeInfo[1];
                                }
                                if (fieldType === "ref") type(refType, {
                                    context: context
                                })(schemaType.prototype, field.name);
                                else type((_a = {}, _a[fieldType] = refType, _a), {
                                    context: context
                                })(schemaType.prototype, field.name);
                            } else type(field.type, {
                                context: context
                            })(schemaType.prototype, field.name);
                        });
                    });
                    var rootType = schemaTypes[reflection.rootType];
                    var rootInstance = new rootType();
                    /**
                 * auto-initialize referenced types on root type
                 * to allow registering listeners immediatelly on client-side
                 */ for(var fieldName in rootType._definition.schema){
                        var fieldType = rootType._definition.schema[fieldName];
                        if (typeof fieldType !== "string") rootInstance[fieldName] = typeof fieldType === "function" ? new fieldType() // is a schema reference
                         : new (getType(Object.keys(fieldType)[0])).constructor(); // is a "collection"
                    }
                    return rootInstance;
                };
                __decorate([
                    type([
                        ReflectionType
                    ], reflectionContext)
                ], Reflection.prototype, "types", void 0);
                __decorate([
                    type("number", reflectionContext)
                ], Reflection.prototype, "rootType", void 0);
                return Reflection;
            }(Schema);
            registerType("map", {
                constructor: MapSchema
            });
            registerType("array", {
                constructor: ArraySchema
            });
            registerType("set", {
                constructor: SetSchema
            });
            registerType("collection", {
                constructor: CollectionSchema
            });
            exports1.ArraySchema = ArraySchema;
            exports1.CollectionSchema = CollectionSchema;
            exports1.Context = Context;
            exports1.MapSchema = MapSchema;
            exports1.Reflection = Reflection;
            exports1.ReflectionField = ReflectionField;
            exports1.ReflectionType = ReflectionType;
            exports1.Schema = Schema;
            exports1.SchemaDefinition = SchemaDefinition;
            exports1.SetSchema = SetSchema;
            exports1.decode = decode;
            exports1.defineTypes = defineTypes;
            exports1.deprecated = deprecated;
            exports1.dumpChanges = dumpChanges;
            exports1.encode = encode;
            exports1.filter = filter;
            exports1.filterChildren = filterChildren;
            exports1.hasFilter = hasFilter;
            exports1.registerType = registerType;
            exports1.type = type;
            Object.defineProperty(exports1, "__esModule", {
                value: true
            });
        });
    });
    var Room = /** @class */ function() {
        function Room(name, rootSchema) {
            var _this = this;
            // Public signals
            this.onStateChange = createSignal();
            this.onError = createSignal();
            this.onLeave = createSignal();
            this.onJoin = createSignal();
            this.hasJoined = false;
            this.onMessageHandlers = createNanoEvents();
            this.roomId = null;
            this.name = name;
            if (rootSchema) {
                this.serializer = new (getSerializer("schema"));
                this.rootSchema = rootSchema;
                this.serializer.state = new rootSchema();
            }
            this.onError(function(code, message) {
                var _a;
                return (_a = console.warn) === null || _a === void 0 ? void 0 : _a.call(console, "colyseus.js - onError => (".concat(code, ") ").concat(message));
            });
            this.onLeave(function() {
                return _this.removeAllListeners();
            });
        }
        Object.defineProperty(Room.prototype, "id", {
            // TODO: deprecate me on version 1.0
            get: function() {
                return this.roomId;
            },
            enumerable: false,
            configurable: true
        });
        Room.prototype.connect = function(endpoint, devModeCloseCallback, room // when reconnecting on devMode, re-use previous room intance for handling events.
        ) {
            if (room === void 0) room = this;
            var connection = new Connection();
            room.connection = connection;
            connection.events.onmessage = Room.prototype.onMessageCallback.bind(room);
            connection.events.onclose = function(e) {
                var _a;
                if (!room.hasJoined) {
                    (_a = console.warn) === null || _a === void 0 || _a.call(console, "Room connection was closed unexpectedly (".concat(e.code, "): ").concat(e.reason));
                    room.onError.invoke(e.code, e.reason);
                    return;
                }
                if (e.code === CloseCode.DEVMODE_RESTART && devModeCloseCallback) devModeCloseCallback();
                else {
                    room.onLeave.invoke(e.code);
                    room.destroy();
                }
            };
            connection.events.onerror = function(e) {
                var _a;
                (_a = console.warn) === null || _a === void 0 || _a.call(console, "Room, onError (".concat(e.code, "): ").concat(e.reason));
                room.onError.invoke(e.code, e.reason);
            };
            connection.connect(endpoint);
        };
        Room.prototype.leave = function(consented) {
            var _this = this;
            if (consented === void 0) consented = true;
            return new Promise(function(resolve) {
                _this.onLeave(function(code) {
                    return resolve(code);
                });
                if (_this.connection) {
                    if (consented) _this.connection.send([
                        exports1.Protocol.LEAVE_ROOM
                    ]);
                    else _this.connection.close();
                } else _this.onLeave.invoke(CloseCode.CONSENTED);
            });
        };
        Room.prototype.onMessage = function(type, callback) {
            return this.onMessageHandlers.on(this.getMessageHandlerKey(type), callback);
        };
        Room.prototype.send = function(type, message) {
            var initialBytes = [
                exports1.Protocol.ROOM_DATA
            ];
            if (typeof type === "string") umd.encode.string(initialBytes, type);
            else umd.encode.number(initialBytes, type);
            var arr;
            if (message !== undefined) {
                var encoded = encode(message);
                arr = new Uint8Array(initialBytes.length + encoded.byteLength);
                arr.set(new Uint8Array(initialBytes), 0);
                arr.set(new Uint8Array(encoded), initialBytes.length);
            } else arr = new Uint8Array(initialBytes);
            this.connection.send(arr.buffer);
        };
        Room.prototype.sendBytes = function(type, bytes) {
            var initialBytes = [
                exports1.Protocol.ROOM_DATA_BYTES
            ];
            if (typeof type === "string") umd.encode.string(initialBytes, type);
            else umd.encode.number(initialBytes, type);
            var arr;
            arr = new Uint8Array(initialBytes.length + (bytes.byteLength || bytes.length));
            arr.set(new Uint8Array(initialBytes), 0);
            arr.set(new Uint8Array(bytes), initialBytes.length);
            this.connection.send(arr.buffer);
        };
        Object.defineProperty(Room.prototype, "state", {
            get: function() {
                return this.serializer.getState();
            },
            enumerable: false,
            configurable: true
        });
        Room.prototype.removeAllListeners = function() {
            this.onJoin.clear();
            this.onStateChange.clear();
            this.onError.clear();
            this.onLeave.clear();
            this.onMessageHandlers.events = {};
        };
        Room.prototype.onMessageCallback = function(event) {
            var bytes = Array.from(new Uint8Array(event.data));
            var code = bytes[0];
            if (code === exports1.Protocol.JOIN_ROOM) {
                var offset = 1;
                var reconnectionToken = utf8Read(bytes, offset);
                offset += utf8Length(reconnectionToken);
                this.serializerId = utf8Read(bytes, offset);
                offset += utf8Length(this.serializerId);
                // Instantiate serializer if not locally available.
                if (!this.serializer) {
                    var serializer = getSerializer(this.serializerId);
                    this.serializer = new serializer();
                }
                if (bytes.length > offset && this.serializer.handshake) this.serializer.handshake(bytes, {
                    offset: offset
                });
                this.reconnectionToken = "".concat(this.roomId, ":").concat(reconnectionToken);
                this.hasJoined = true;
                this.onJoin.invoke();
                // acknowledge successfull JOIN_ROOM
                this.connection.send([
                    exports1.Protocol.JOIN_ROOM
                ]);
            } else if (code === exports1.Protocol.ERROR) {
                var it_1 = {
                    offset: 1
                };
                var code_1 = umd.decode.number(bytes, it_1);
                var message = umd.decode.string(bytes, it_1);
                this.onError.invoke(code_1, message);
            } else if (code === exports1.Protocol.LEAVE_ROOM) this.leave();
            else if (code === exports1.Protocol.ROOM_DATA_SCHEMA) {
                var it_2 = {
                    offset: 1
                };
                var context_1 = this.serializer.getState().constructor._context;
                var type = context_1.get(umd.decode.number(bytes, it_2));
                var message = new type();
                message.decode(bytes, it_2);
                this.dispatchMessage(type, message);
            } else if (code === exports1.Protocol.ROOM_STATE) {
                bytes.shift(); // drop `code` byte
                this.setState(bytes);
            } else if (code === exports1.Protocol.ROOM_STATE_PATCH) {
                bytes.shift(); // drop `code` byte
                this.patch(bytes);
            } else if (code === exports1.Protocol.ROOM_DATA) {
                var it_3 = {
                    offset: 1
                };
                var type = umd.decode.stringCheck(bytes, it_3) ? umd.decode.string(bytes, it_3) : umd.decode.number(bytes, it_3);
                var message = bytes.length > it_3.offset ? decode(event.data, it_3.offset) : undefined;
                this.dispatchMessage(type, message);
            } else if (code === exports1.Protocol.ROOM_DATA_BYTES) {
                var it_4 = {
                    offset: 1
                };
                var type = umd.decode.stringCheck(bytes, it_4) ? umd.decode.string(bytes, it_4) : umd.decode.number(bytes, it_4);
                this.dispatchMessage(type, new Uint8Array(bytes.slice(it_4.offset)));
            }
        };
        Room.prototype.setState = function(encodedState) {
            this.serializer.setState(encodedState);
            this.onStateChange.invoke(this.serializer.getState());
        };
        Room.prototype.patch = function(binaryPatch) {
            this.serializer.patch(binaryPatch);
            this.onStateChange.invoke(this.serializer.getState());
        };
        Room.prototype.dispatchMessage = function(type, message) {
            var _a;
            var messageType = this.getMessageHandlerKey(type);
            if (this.onMessageHandlers.events[messageType]) this.onMessageHandlers.emit(messageType, message);
            else if (this.onMessageHandlers.events["*"]) this.onMessageHandlers.emit("*", type, message);
            else (_a = console.warn) === null || _a === void 0 || _a.call(console, "colyseus.js: onMessage() not registered for type '".concat(type, "'."));
        };
        Room.prototype.destroy = function() {
            if (this.serializer) this.serializer.teardown();
        };
        Room.prototype.getMessageHandlerKey = function(type) {
            switch(typeof type){
                // typeof Schema
                case "function":
                    return "$".concat(type._typeid);
                // string
                case "string":
                    return type;
                // number
                case "number":
                    return "i".concat(type);
                default:
                    throw new Error("invalid message type.");
            }
        };
        return Room;
    }();
    function apply(src, tar) {
        tar.statusMessage = src.statusText;
        tar.statusCode = src.status;
        tar.data = src.body;
    }
    function send(method, uri, opts) {
        opts = opts || {};
        var timer, ctrl, tmp = opts.body;
        opts.method = method;
        opts.headers = opts.headers || {};
        if (tmp instanceof FormData) ;
        else if (tmp && typeof tmp == "object") {
            opts.headers["content-type"] = "application/json";
            opts.body = JSON.stringify(tmp);
        }
        if (opts.withCredentials) opts.credentials = "include";
        if (opts.timeout) {
            ctrl = new AbortController;
            opts.signal = ctrl.signal;
            timer = setTimeout(ctrl.abort, opts.timeout);
        }
        return new Promise((res, rej)=>{
            fetch(uri, opts).then((rr, reply)=>{
                clearTimeout(timer);
                apply(rr, rr); //=> rr.headers
                reply = rr.status >= 400 ? rej : res;
                tmp = rr.headers.get("content-type");
                if (!tmp || !~tmp.indexOf("application/json")) reply(rr);
                else rr.text().then((str)=>{
                    try {
                        rr.data = JSON.parse(str, opts.reviver);
                        reply(rr);
                    } catch (err) {
                        err.headers = rr.headers;
                        apply(rr, err);
                        rej(err);
                    }
                });
            }).catch((err)=>{
                err.timeout = ctrl && ctrl.signal.aborted;
                rej(err);
            });
        });
    }
    var get = /*#__PURE__*/ send.bind(send, "GET");
    var post = /*#__PURE__*/ send.bind(send, "POST");
    var patch = /*#__PURE__*/ send.bind(send, "PATCH");
    var del = /*#__PURE__*/ send.bind(send, "DELETE");
    var put = /*#__PURE__*/ send.bind(send, "PUT");
    var del_1 = del;
    var get_1 = get;
    var patch_1 = patch;
    var post_1 = post;
    var put_1 = put;
    var send_1 = send;
    var fetch_1 = {
        del: del_1,
        get: get_1,
        patch: patch_1,
        post: post_1,
        put: put_1,
        send: send_1
    };
    var httpie = /*#__PURE__*/ _mergeNamespaces({
        __proto__: null,
        "default": fetch_1,
        del: del_1,
        get: get_1,
        patch: patch_1,
        post: post_1,
        put: put_1,
        send: send_1
    }, [
        fetch_1
    ]);
    var HTTP = /** @class */ function() {
        function HTTP(client) {
            this.client = client;
        }
        HTTP.prototype.get = function(path, options) {
            if (options === void 0) options = {};
            return this.request("get", path, options);
        };
        HTTP.prototype.post = function(path, options) {
            if (options === void 0) options = {};
            return this.request("post", path, options);
        };
        HTTP.prototype.del = function(path, options) {
            if (options === void 0) options = {};
            return this.request("del", path, options);
        };
        HTTP.prototype.put = function(path, options) {
            if (options === void 0) options = {};
            return this.request("put", path, options);
        };
        HTTP.prototype.request = function(method, path, options) {
            if (options === void 0) options = {};
            return httpie[method](this.client["getHttpEndpoint"](path), this.getOptions(options)).catch(function(e) {
                var _a;
                var status = e.statusCode; //  || -1
                var message = ((_a = e.data) === null || _a === void 0 ? void 0 : _a.error) || e.statusMessage || e.message; //  || "offline"
                if (!status && !message) throw e;
                throw new ServerError(status, message);
            });
        };
        HTTP.prototype.getOptions = function(options) {
            if (this.authToken) {
                if (!options.headers) options.headers = {};
                options.headers["Authorization"] = "Bearer ".concat(this.authToken);
            }
            if (typeof cc !== "undefined" && cc.sys && cc.sys.isNative) ;
            else // always include credentials
            options.withCredentials = true;
            return options;
        };
        return HTTP;
    }();
    /// <reference path="../typings/cocos-creator.d.ts" />
    /**
     * We do not assign 'storage' to window.localStorage immediatelly for React
     * Native compatibility. window.localStorage is not present when this module is
     * loaded.
     */ var storage;
    function getStorage() {
        if (!storage) try {
            storage = typeof cc !== "undefined" && cc.sys && cc.sys.localStorage ? cc.sys.localStorage // compatibility with cocos creator
             : window.localStorage; // RN does have window object at this point, but localStorage is not defined
        } catch (e) {
        // ignore error
        }
        if (!storage) // mock localStorage if not available (Node.js or RN environment)
        storage = {
            cache: {},
            setItem: function(key, value) {
                this.cache[key] = value;
            },
            getItem: function(key) {
                this.cache[key];
            },
            removeItem: function(key) {
                delete this.cache[key];
            }
        };
        return storage;
    }
    function setItem(key, value) {
        getStorage().setItem(key, value);
    }
    function removeItem(key) {
        getStorage().removeItem(key);
    }
    function getItem(key, callback) {
        var value = getStorage().getItem(key);
        if (typeof Promise === "undefined" || // old browsers
        !(value instanceof Promise)) // browser has synchronous return
        callback(value);
        else // react-native is asynchronous
        value.then(function(id) {
            return callback(id);
        });
    }
    var _Auth__initialized, _Auth__initializationPromise, _Auth__signInWindow, _Auth__events;
    var Auth = /** @class */ function() {
        function Auth(http) {
            var _this = this;
            this.http = http;
            this.settings = {
                path: "/auth",
                key: "colyseus-auth-token"
            };
            _Auth__initialized.set(this, false);
            _Auth__initializationPromise.set(this, void 0);
            _Auth__signInWindow.set(this, undefined);
            _Auth__events.set(this, createNanoEvents());
            getItem(this.settings.key, function(token) {
                return _this.token = token;
            });
        }
        Object.defineProperty(Auth.prototype, "token", {
            get: function() {
                return this.http.authToken;
            },
            set: function(token) {
                this.http.authToken = token;
            },
            enumerable: false,
            configurable: true
        });
        Auth.prototype.onChange = function(callback) {
            var _this = this;
            var unbindChange = __classPrivateFieldGet(this, _Auth__events, "f").on("change", callback);
            if (!__classPrivateFieldGet(this, _Auth__initialized, "f")) __classPrivateFieldSet(this, _Auth__initializationPromise, new Promise(function(resolve, reject) {
                _this.getUserData().then(function(userData) {
                    _this.emitChange(__assign(__assign({}, userData), {
                        token: _this.token
                    }));
                }).catch(function(e) {
                    // user is not logged in, or service is down
                    _this.emitChange({
                        user: null,
                        token: undefined
                    });
                }).finally(function() {
                    resolve();
                });
            }), "f");
            __classPrivateFieldSet(this, _Auth__initialized, true, "f");
            return unbindChange;
        };
        Auth.prototype.getUserData = function() {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!this.token) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.http.get("".concat(this.settings.path, "/userdata"))
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent().data
                            ];
                        case 2:
                            throw new Error("missing auth.token");
                    }
                });
            });
        };
        Auth.prototype.registerWithEmailAndPassword = function(email, password, options) {
            return __awaiter(this, void 0, void 0, function() {
                var data;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.http.post("".concat(this.settings.path, "/register"), {
                                    body: {
                                        email: email,
                                        password: password,
                                        options: options
                                    }
                                })
                            ];
                        case 1:
                            data = _a.sent().data;
                            this.emitChange(data);
                            return [
                                2 /*return*/ ,
                                data
                            ];
                    }
                });
            });
        };
        Auth.prototype.signInWithEmailAndPassword = function(email, password) {
            return __awaiter(this, void 0, void 0, function() {
                var data;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.http.post("".concat(this.settings.path, "/login"), {
                                    body: {
                                        email: email,
                                        password: password
                                    }
                                })
                            ];
                        case 1:
                            data = _a.sent().data;
                            this.emitChange(data);
                            return [
                                2 /*return*/ ,
                                data
                            ];
                    }
                });
            });
        };
        Auth.prototype.signInAnonymously = function(options) {
            return __awaiter(this, void 0, void 0, function() {
                var data;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.http.post("".concat(this.settings.path, "/anonymous"), {
                                    body: {
                                        options: options
                                    }
                                })
                            ];
                        case 1:
                            data = _a.sent().data;
                            this.emitChange(data);
                            return [
                                2 /*return*/ ,
                                data
                            ];
                    }
                });
            });
        };
        Auth.prototype.sendPasswordResetEmail = function(email) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.http.post("".concat(this.settings.path, "/forgot-password"), {
                                    body: {
                                        email: email
                                    }
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent().data
                            ];
                    }
                });
            });
        };
        Auth.prototype.signInWithProvider = function(providerName, settings) {
            if (settings === void 0) settings = {};
            return __awaiter(this, void 0, void 0, function() {
                var _this = this;
                return __generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        new Promise(function(resolve, reject) {
                            var w = settings.width || 480;
                            var h = settings.height || 768;
                            // forward existing token for upgrading
                            var upgradingToken = _this.token ? "?token=".concat(_this.token) : "";
                            // Capitalize first letter of providerName
                            var title = "Login with ".concat(providerName[0].toUpperCase() + providerName.substring(1));
                            var url = _this.http["client"]["getHttpEndpoint"]("".concat(settings.prefix || "".concat(_this.settings.path, "/provider"), "/").concat(providerName).concat(upgradingToken));
                            var left = screen.width / 2 - w / 2;
                            var top = screen.height / 2 - h / 2;
                            __classPrivateFieldSet(_this, _Auth__signInWindow, window.open(url, title, "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left), "f");
                            var onMessage = function(event) {
                                // TODO: it is a good idea to check if event.origin can be trusted!
                                // if (event.origin.indexOf(window.location.hostname) === -1) { return; }
                                // require 'user' and 'token' inside received data.
                                if (event.data.user === undefined && event.data.token === undefined) return;
                                clearInterval(rejectionChecker);
                                __classPrivateFieldGet(_this, _Auth__signInWindow, "f").close();
                                __classPrivateFieldSet(_this, _Auth__signInWindow, undefined, "f");
                                window.removeEventListener("message", onMessage);
                                if (event.data.error !== undefined) reject(event.data.error);
                                else {
                                    resolve(event.data);
                                    _this.emitChange(event.data);
                                }
                            };
                            var rejectionChecker = setInterval(function() {
                                if (!__classPrivateFieldGet(_this, _Auth__signInWindow, "f") || __classPrivateFieldGet(_this, _Auth__signInWindow, "f").closed) {
                                    __classPrivateFieldSet(_this, _Auth__signInWindow, undefined, "f");
                                    reject("cancelled");
                                    window.removeEventListener("message", onMessage);
                                }
                            }, 200);
                            window.addEventListener("message", onMessage);
                        })
                    ];
                });
            });
        };
        Auth.prototype.signOut = function() {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.emitChange({
                        user: null,
                        token: null
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        Auth.prototype.emitChange = function(authData) {
            if (authData.token !== undefined) {
                this.token = authData.token;
                if (authData.token === null) removeItem(this.settings.key);
                else // store key in localStorage
                setItem(this.settings.key, authData.token);
            }
            __classPrivateFieldGet(this, _Auth__events, "f").emit("change", authData);
        };
        return Auth;
    }();
    _Auth__initialized = new WeakMap(), _Auth__initializationPromise = new WeakMap(), _Auth__signInWindow = new WeakMap(), _Auth__events = new WeakMap();
    /**
     * Discord Embedded App SDK
     * https://github.com/colyseus/colyseus/issues/707
     *
     * All URLs must go through the local proxy from
     * https://<app_id>.discordsays.com/.proxy/<mapped_url>/...
     *
     * URL Mapping Examples:
     *
     * 1. Using Colyseus Cloud:
     *   - /colyseus/{subdomain} -> {subdomain}.colyseus.cloud
     *
     *   Example:
     *     const client = new Client("https://xxxx.colyseus.cloud");
     *
     * -------------------------------------------------------------
     *
     * 2. Using `cloudflared` tunnel:
     *   - /colyseus/ -> <your-cloudflared-url>.trycloudflare.com
     *
     *   Example:
     *     const client = new Client("https://<your-cloudflared-url>.trycloudflare.com");
     *
     * -------------------------------------------------------------
     *
     * 3. Providing a manual /.proxy/your-mapping:
     *   - /your-mapping/ -> your-endpoint.com
     *
     *   Example:
     *     const client = new Client("/.proxy/your-mapping");
     *
     */ function discordURLBuilder(url) {
        var _a;
        var localHostname = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) || "localhost";
        var remoteHostnameSplitted = url.hostname.split(".");
        var subdomain = !url.hostname.includes("trycloudflare.com") && // ignore cloudflared subdomains
        !url.hostname.includes("discordsays.com") && // ignore discordsays.com subdomains
        remoteHostnameSplitted.length > 2 ? "/".concat(remoteHostnameSplitted[0]) : "";
        return url.pathname.startsWith("/.proxy") ? "".concat(url.protocol, "//").concat(localHostname).concat(subdomain).concat(url.pathname).concat(url.search) : "".concat(url.protocol, "//").concat(localHostname, "/.proxy/colyseus").concat(subdomain).concat(url.pathname).concat(url.search);
    }
    var _a;
    var MatchMakeError = /** @class */ function(_super) {
        __extends(MatchMakeError, _super);
        function MatchMakeError(message, code) {
            var _this = _super.call(this, message) || this;
            _this.code = code;
            Object.setPrototypeOf(_this, MatchMakeError.prototype);
            return _this;
        }
        return MatchMakeError;
    }(Error);
    // - React Native does not provide `window.location`
    // - Cocos Creator (Native) does not provide `window.location.hostname`
    var DEFAULT_ENDPOINT = typeof window !== "undefined" && typeof ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) !== "undefined" ? "".concat(window.location.protocol.replace("http", "ws"), "//").concat(window.location.hostname).concat(window.location.port && ":".concat(window.location.port)) : "ws://127.0.0.1:2567";
    var Client = /** @class */ function() {
        function Client(settings, customURLBuilder) {
            if (settings === void 0) settings = DEFAULT_ENDPOINT;
            var _a, _b;
            if (typeof settings === "string") {
                //
                // endpoint by url
                //
                var url = settings.startsWith("/") ? new URL(settings, DEFAULT_ENDPOINT) : new URL(settings);
                var secure = url.protocol === "https:" || url.protocol === "wss:";
                var port = Number(url.port || (secure ? 443 : 80));
                this.settings = {
                    hostname: url.hostname,
                    pathname: url.pathname,
                    port: port,
                    secure: secure
                };
            } else {
                //
                // endpoint by settings
                //
                if (settings.port === undefined) settings.port = settings.secure ? 443 : 80;
                if (settings.pathname === undefined) settings.pathname = "";
                this.settings = settings;
            }
            // make sure pathname does not end with "/"
            if (this.settings.pathname.endsWith("/")) this.settings.pathname = this.settings.pathname.slice(0, -1);
            this.http = new HTTP(this);
            this.auth = new Auth(this.http);
            this.urlBuilder = customURLBuilder;
            //
            // Discord Embedded SDK requires a custom URL builder
            //
            if (!this.urlBuilder && typeof window !== "undefined" && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) === null || _b === void 0 ? void 0 : _b.includes("discordsays.com"))) {
                this.urlBuilder = discordURLBuilder;
                console.log("Colyseus SDK: Discord Embedded SDK detected. Using custom URL builder.");
            }
        }
        Client.prototype.joinOrCreate = function(roomName, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("joinOrCreate", roomName, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.create = function(roomName, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("create", roomName, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.join = function(roomName, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("join", roomName, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.joinById = function(roomId, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("joinById", roomId, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        /**
         * Re-establish connection with a room this client was previously connected to.
         *
         * @param reconnectionToken The `room.reconnectionToken` from previously connected room.
         * @param rootSchema (optional) Concrete root schema definition
         * @returns Promise<Room>
         */ Client.prototype.reconnect = function(reconnectionToken, rootSchema) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, roomId, token;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            if (typeof reconnectionToken === "string" && typeof rootSchema === "string") throw new Error("DEPRECATED: .reconnect() now only accepts 'reconnectionToken' as argument.\nYou can get this token from previously connected `room.reconnectionToken`");
                            _a = reconnectionToken.split(":"), roomId = _a[0], token = _a[1];
                            if (!roomId || !token) throw new Error("Invalid reconnection token format.\nThe format should be roomId:reconnectionToken");
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("reconnect", roomId, {
                                    reconnectionToken: token
                                }, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _b.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.getAvailableRooms = function(roomName) {
            if (roomName === void 0) roomName = "";
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.http.get("matchmake/".concat(roomName), {
                                    headers: {
                                        "Accept": "application/json"
                                    }
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent().data
                            ];
                    }
                });
            });
        };
        Client.prototype.consumeSeatReservation = function(response, rootSchema, reuseRoomInstance // used in devMode
        ) {
            return __awaiter(this, void 0, void 0, function() {
                var room, options, targetRoom;
                var _this = this;
                return __generator(this, function(_a) {
                    room = this.createRoom(response.room.name, rootSchema);
                    room.roomId = response.room.roomId;
                    room.sessionId = response.sessionId;
                    options = {
                        sessionId: room.sessionId
                    };
                    // forward "reconnection token" in case of reconnection.
                    if (response.reconnectionToken) options.reconnectionToken = response.reconnectionToken;
                    targetRoom = reuseRoomInstance || room;
                    room.connect(this.buildEndpoint(response.room, options), response.devMode && function() {
                        return __awaiter(_this, void 0, void 0, function() {
                            var retryCount, retryMaxRetries, retryReconnection;
                            var _this = this;
                            return __generator(this, function(_a) {
                                console.info("[Colyseus devMode]: ".concat(String.fromCodePoint(0x1F504), " Re-establishing connection with room id '").concat(room.roomId, "'...")); // 🔄
                                retryCount = 0;
                                retryMaxRetries = 8;
                                retryReconnection = function() {
                                    return __awaiter(_this, void 0, void 0, function() {
                                        return __generator(this, function(_a) {
                                            switch(_a.label){
                                                case 0:
                                                    retryCount++;
                                                    _a.label = 1;
                                                case 1:
                                                    _a.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        4
                                                    ]);
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.consumeSeatReservation(response, rootSchema, targetRoom)
                                                    ];
                                                case 2:
                                                    _a.sent();
                                                    console.info("[Colyseus devMode]: ".concat(String.fromCodePoint(0x2705), " Successfully re-established connection with room '").concat(room.roomId, "'")); // ✅
                                                    return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                case 3:
                                                    _a.sent();
                                                    if (retryCount < retryMaxRetries) {
                                                        console.info("[Colyseus devMode]: ".concat(String.fromCodePoint(0x1F504), " retrying... (").concat(retryCount, " out of ").concat(retryMaxRetries, ")")); // 🔄
                                                        setTimeout(retryReconnection, 2000);
                                                    } else console.info("[Colyseus devMode]: ".concat(String.fromCodePoint(0x274C), " Failed to reconnect. Is your server running? Please check server logs.")); // ❌
                                                    return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                case 4:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                };
                                setTimeout(retryReconnection, 2000);
                                return [
                                    2 /*return*/ 
                                ];
                            });
                        });
                    }, targetRoom);
                    return [
                        2 /*return*/ ,
                        new Promise(function(resolve, reject) {
                            var onError = function(code, message) {
                                return reject(new ServerError(code, message));
                            };
                            targetRoom.onError.once(onError);
                            targetRoom["onJoin"].once(function() {
                                targetRoom.onError.remove(onError);
                                resolve(targetRoom);
                            });
                        })
                    ];
                });
            });
        };
        Client.prototype.createMatchMakeRequest = function(method, roomName, options, rootSchema, reuseRoomInstance) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                var response;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.http.post("matchmake/".concat(method, "/").concat(roomName), {
                                    headers: {
                                        "Accept": "application/json",
                                        "Content-Type": "application/json"
                                    },
                                    body: JSON.stringify(options)
                                })
                            ];
                        case 1:
                            response = _a.sent().data;
                            // FIXME: HTTP class is already handling this as ServerError.
                            if (response.error) throw new MatchMakeError(response.error, response.code);
                            // forward reconnection token during "reconnect" methods.
                            if (method === "reconnect") response.reconnectionToken = options.reconnectionToken;
                            return [
                                4 /*yield*/ ,
                                this.consumeSeatReservation(response, rootSchema, reuseRoomInstance)
                            ];
                        case 2:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.createRoom = function(roomName, rootSchema) {
            return new Room(roomName, rootSchema);
        };
        Client.prototype.buildEndpoint = function(room, options) {
            if (options === void 0) options = {};
            var params = [];
            // append provided options
            for(var name_1 in options){
                if (!options.hasOwnProperty(name_1)) continue;
                params.push("".concat(name_1, "=").concat(options[name_1]));
            }
            var endpoint = this.settings.secure ? "wss://" : "ws://";
            if (room.publicAddress) endpoint += "".concat(room.publicAddress);
            else endpoint += "".concat(this.settings.hostname).concat(this.getEndpointPort()).concat(this.settings.pathname);
            var endpointURL = "".concat(endpoint, "/").concat(room.processId, "/").concat(room.roomId, "?").concat(params.join("&"));
            return this.urlBuilder ? this.urlBuilder(new URL(endpointURL)) : endpointURL;
        };
        Client.prototype.getHttpEndpoint = function(segments) {
            if (segments === void 0) segments = "";
            var path = segments.startsWith("/") ? segments : "/".concat(segments);
            var endpointURL = "".concat(this.settings.secure ? "https" : "http", "://").concat(this.settings.hostname).concat(this.getEndpointPort()).concat(this.settings.pathname).concat(path);
            return this.urlBuilder ? this.urlBuilder(new URL(endpointURL)) : endpointURL;
        };
        Client.prototype.getEndpointPort = function() {
            return this.settings.port !== 80 && this.settings.port !== 443 ? ":".concat(this.settings.port) : "";
        };
        return Client;
    }();
    var SchemaSerializer = /** @class */ function() {
        function SchemaSerializer() {}
        SchemaSerializer.prototype.setState = function(rawState) {
            return this.state.decode(rawState);
        };
        SchemaSerializer.prototype.getState = function() {
            return this.state;
        };
        SchemaSerializer.prototype.patch = function(patches) {
            return this.state.decode(patches);
        };
        SchemaSerializer.prototype.teardown = function() {
            var _a, _b;
            (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a["$changes"]) === null || _b === void 0 || _b.root.clearRefs();
        };
        SchemaSerializer.prototype.handshake = function(bytes, it) {
            if (this.state) {
                // TODO: validate client/server definitinos
                var reflection = new umd.Reflection();
                reflection.decode(bytes, it);
            } else // initialize reflected state from server
            this.state = umd.Reflection.decode(bytes, it);
        };
        return SchemaSerializer;
    }();
    var NoneSerializer = /** @class */ function() {
        function NoneSerializer() {}
        NoneSerializer.prototype.setState = function(rawState) {};
        NoneSerializer.prototype.getState = function() {
            return null;
        };
        NoneSerializer.prototype.patch = function(patches) {};
        NoneSerializer.prototype.teardown = function() {};
        NoneSerializer.prototype.handshake = function(bytes) {};
        return NoneSerializer;
    }();
    registerSerializer("schema", SchemaSerializer);
    registerSerializer("none", NoneSerializer);
    exports1.Auth = Auth;
    exports1.Client = Client;
    exports1.Room = Room;
    exports1.SchemaSerializer = SchemaSerializer;
    exports1.registerSerializer = registerSerializer;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});



var $436806aabc46b071$var$__defProp = Object.defineProperty;
var $436806aabc46b071$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $436806aabc46b071$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $436806aabc46b071$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $436806aabc46b071$var$__defNormalProp = (obj, key, value)=>key in obj ? $436806aabc46b071$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $436806aabc46b071$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($436806aabc46b071$var$__hasOwnProp.call(b, prop)) $436806aabc46b071$var$__defNormalProp(a, prop, b[prop]);
    if ($436806aabc46b071$var$__getOwnPropSymbols) {
        for (var prop of $436806aabc46b071$var$__getOwnPropSymbols(b))if ($436806aabc46b071$var$__propIsEnum.call(b, prop)) $436806aabc46b071$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/Event.ts
var $436806aabc46b071$var$defaultEventInit = {
    properties: {}
};
var $436806aabc46b071$export$d61e24a684f9e51 = class {
    defineProperties(properties) {
        for(const property in properties)this[property] = properties[property];
    }
    constructor(type, options){
        const mergedOptions = $436806aabc46b071$var$__spreadValues($436806aabc46b071$var$__spreadValues({}, $436806aabc46b071$var$defaultEventInit), options);
        this.type = type;
        this.defineProperties(mergedOptions.properties);
    }
};
// src/TypeGuards.ts
function $436806aabc46b071$var$isArray(obj) {
    if (Array.isArray) return Array.isArray(obj);
    return Object.prototype.toString.call(obj) === "[object Array]";
}
function $436806aabc46b071$var$isRegexp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
}
function $436806aabc46b071$var$isEventObject(value) {
    return typeof value === "object" && "type" in value;
}
// src/EventDispatcher.ts
var $436806aabc46b071$export$ec8b666c5fe2c75a = class {
    setCallbackContext(context) {
        this.callbackContext = context;
        return this;
    }
    on(eventType, callback, options) {
        this.validateEventType(eventType);
        const triggerLastEvent = (options == null ? void 0 : options.triggerLastEvent) || this.triggerLastEvent;
        if (!this.hasCallbacks(eventType)) this.callbacks[eventType] = new Set();
        this.callbacks[eventType].add(callback);
        if (triggerLastEvent) {
            const lastEventObject = this.getLastEventObjectOf(eventType);
            lastEventObject && callback.call(this.callbackContext || this, lastEventObject);
        }
        const off = ()=>{
            this.off(eventType, callback);
        };
        return off;
    }
    off(eventType, callback) {
        this.validateEventType(eventType);
        if (!this.hasCallbacks(eventType)) return this;
        if (!callback) {
            delete this.callbacks[eventType];
            return this;
        }
        this.callbacks[eventType].delete(callback);
        return this;
    }
    one(eventType, callback, options) {
        this.validateEventType(eventType);
        const onetimeCallback = (eventObject)=>{
            this.off(eventType, onetimeCallback);
            return callback.call(this.callbackContext || this, eventObject);
        };
        return this.on(eventType, onetimeCallback, options);
    }
    trigger(eventTypeOrEventObject, args) {
        const eventObject = $436806aabc46b071$var$isEventObject(eventTypeOrEventObject) ? eventTypeOrEventObject : new $436806aabc46b071$export$d61e24a684f9e51(eventTypeOrEventObject, {
            properties: args || {}
        });
        const eventType = $436806aabc46b071$var$isEventObject(eventTypeOrEventObject) ? eventTypeOrEventObject.type : eventTypeOrEventObject;
        this.validateEventType(eventType);
        this.lastEvents[eventType] = eventObject;
        if (this.disabled || !this.hasCallbacks(eventType)) return null;
        const callbacks = this.callbacksForEvent(eventType);
        const responses = Array.from(callbacks).map((callback)=>{
            return callback.call(this.callbackContext || this, eventObject);
        });
        return responses;
    }
    getLastEventObjectOf(eventType) {
        if (eventType in this.lastEvents) return this.lastEvents[eventType];
        return null;
    }
    removeLastEventObjectOf(eventType) {
        if (eventType in this.lastEvents) {
            const lastEvent = this.lastEvents[eventType];
            delete this.lastEvents[eventType];
            return lastEvent;
        }
        return null;
    }
    disable() {
        this.disabled = true;
        return this;
    }
    enable() {
        this.disabled = false;
        return this;
    }
    clear() {
        this.callbacks = {};
        return this;
    }
    callbacksForEvent(eventType) {
        return this.callbacks[eventType];
    }
    hasCallbacks(eventType) {
        return eventType in this.callbacks;
    }
    validateEventType(eventType) {
        if (!this.isValidEvent(eventType)) {
            const validEvents = this.validEventTypes.join("|");
            throw new Error(`Invalid Event Type: '${eventType}'.
Event type should be any of: ${validEvents}.`);
        }
    }
    isValidEvent(eventType) {
        let validEventCount = 0;
        const eventTypes = $436806aabc46b071$var$asArray(eventType);
        for (let eventType2 of eventTypes)for (let validEvent of this.validEventTypes){
            let isValid;
            if ($436806aabc46b071$var$isRegexp(validEvent)) isValid = validEvent.test(eventType2);
            else isValid = eventType2 === validEvent;
            if (isValid) {
                validEventCount++;
                if (validEventCount === eventTypes.length) return true;
            }
        }
        return false;
    }
    Api() {
        const { validEventTypes: validEventTypes, triggerLastEvent: triggerLastEvent } = this;
        const createInstance = ()=>{
            return new $436806aabc46b071$export$ec8b666c5fe2c75a({
                validEventTypes: validEventTypes,
                triggerLastEvent: triggerLastEvent
            });
        };
        return class {
            on(eventType, fn) {
                return this.eventDispatcher.on(eventType, fn);
            }
            off(eventType, fn) {
                this.eventDispatcher.off(eventType, fn);
                return this;
            }
            one(eventType, fn) {
                return this.eventDispatcher.one(eventType, fn);
            }
            trigger(eventTypeOrEventObject, args) {
                return this.eventDispatcher.trigger(eventTypeOrEventObject, args);
            }
            constructor(){
                this.eventDispatcher = createInstance();
            }
        };
    }
    constructor({ validEventTypes: validEventTypes = [
        /.*/
    ], triggerLastEvent: triggerLastEvent = false } = {}){
        this.callbacks = {};
        this.lastEvents = {};
        this.disabled = false;
        this.validEventTypes = validEventTypes;
        this.triggerLastEvent = triggerLastEvent;
        this.callbackContext = this;
    }
};
function $436806aabc46b071$var$asArray(value) {
    return $436806aabc46b071$var$isArray(value) ? value : [
        value
    ];
}


class $be402f22b040cc66$export$2e2bcd8739ae039 {
    async init() {
        let self = this;
        await new Promise((resolve)=>{
            self.client.create($be402f22b040cc66$export$2e2bcd8739ae039.roomType).then((tmpRoom)=>{
                console.log("create");
                self.room = tmpRoom;
                self.room.onMessage($be402f22b040cc66$export$2e2bcd8739ae039.messageType, (message)=>{
                    self.onMessage(message);
                });
                console.log(self.room.sessionId, "joined", self.room.name);
                resolve();
            }).catch((e)=>{
                console.log("JOIN ERROR", e);
                resolve();
            });
        });
    }
    onMessage(message) {
        // console.log('message',message)
        this.ed.trigger("action", message);
    }
    async do(action, data) {
        let self = this;
        return new Promise((resolve)=>{
            self.ed.one("action", (message)=>{
                // purify message by removing 'type'
                let output = {};
                Object.assign(output, message);
                delete output.type;
                resolve(output);
            });
            self.room.send($be402f22b040cc66$export$2e2bcd8739ae039.messageType, {
                action: action,
                data: data
            });
        });
    }
    constructor(conquer){
        this.conquer = conquer;
        this.ed = new (0, $436806aabc46b071$export$ec8b666c5fe2c75a)({
            validEventTypes: $be402f22b040cc66$export$2e2bcd8739ae039.myEventTypes
        });
        console.log("constructor");
        this.client = new $aa6f7ae92c6b8abb$exports.Client((0, $b07e5453767f2b67$export$2e2bcd8739ae039).vars.PUBLIC_COLYSEUS_FULL_URL);
        console.log("client");
    }
}
(()=>{
    $be402f22b040cc66$export$2e2bcd8739ae039.messageType = "ACTION";
})();
(()=>{
    $be402f22b040cc66$export$2e2bcd8739ae039.roomType = "room_type";
})();
(()=>{
    $be402f22b040cc66$export$2e2bcd8739ae039.myEventTypes = [
        "action"
    ];
})();



class $2cc3990f27bb6ce8$var$Notification {
    async set(data) {
        var value = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).NOTIFICATION_SET, {
            message: data.message,
            receiverId: data.receiverId,
            timestamp: data.timestamp
        });
        return Promise.resolve(value);
    }
    constructor(instance){
        this.conquer = instance;
    }
}
var $2cc3990f27bb6ce8$export$2e2bcd8739ae039 = $2cc3990f27bb6ce8$var$Notification;






class $c29489363c297af3$var$TokenHistory {
    async get() {
        let result = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).NFT_HISTORY_GET, {
            contract: this.contract,
            tokenID: this.tokenID
        });
        return Promise.resolve(result);
    }
    constructor(conquer, contract, tokenID){
        this.conquer = conquer;
        this.contract = contract;
        this.tokenID = tokenID;
    }
}
var $c29489363c297af3$export$2e2bcd8739ae039 = $c29489363c297af3$var$TokenHistory;


class $c734122a5b587715$var$TokenInstance {
    async list(price = 0) {
        return this.doAction("list", {
            price: price
        });
    }
    async unlist(vars) {
        return this.doAction("unlist", vars);
    }
    async buy(vars) {
        return this.doAction("buy", vars);
    }
    async doAction(action, vars) {
        vars = vars || {};
        vars.tokenID = this.tokenID;
        vars.action = action;
        let result = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).NFT_TOKEN_CHANGE, vars);
        return Promise.resolve(result);
    }
    constructor(conquer, data){
        this.conquer = conquer;
        this.contract = data.contract;
        this.tokenID = data.tokenID;
        this.ownerAddress = data.ownerAddress;
        this.ownerUsernameID = data.ownerUsernameID;
        this.tokenURI = data.tokenURI;
        this.metadata = data.metadata;
        this.imageURL = data.imageURL;
        this.attributes = data.attributes;
        this.explorerURL = data.explorerURL;
        this.openseaURL = data.openseaURL;
        this.listed = data.listed;
        this.listingPrice = data.listingPrice;
        this.History = new (0, $c29489363c297af3$export$2e2bcd8739ae039)(conquer, this.contract, this.tokenID);
    }
}
var $c734122a5b587715$export$2e2bcd8739ae039 = $c734122a5b587715$var$TokenInstance;


class $8892e63a17bc7299$var$NFTInstance {
    /*=============== 
 
   MINT

    ================*/ async mint(amount) {
        let array = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).NFT_COLLECTION_MINT, {
            amount: amount
        });
        let output = [];
        for(let n in array)output.push(new (0, $c734122a5b587715$export$2e2bcd8739ae039)(this.conquer, array[n]));
        return Promise.resolve(output);
    }
    /*=============== 
 
    GET TOKENS - get by ownerAvatarID or get all

    ================*/ async getTokens(ownerAvatarID) {
        let vars = {};
        if (ownerAvatarID) vars = {
            type: "owner",
            contract: this.address,
            ownerAvatarID: ownerAvatarID
        };
        else vars = {
            type: "all",
            contract: this.address
        };
        let array = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).NFT_TOKEN_GET, vars);
        let output = [];
        for(let n in array)output.push(new (0, $c734122a5b587715$export$2e2bcd8739ae039)(this.conquer, array[n]));
        return Promise.resolve(output);
    }
    async getToken(tokenID) {
        let vars = {
            type: "tokenID",
            contract: this.address,
            tokenID: tokenID
        };
        let result = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).NFT_TOKEN_GET, vars);
        return Promise.resolve(new (0, $c734122a5b587715$export$2e2bcd8739ae039)(this.conquer, result));
    }
    async getListedTokens() {
        let vars = {
            type: "listed",
            contract: this.address
        };
        let array = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).NFT_TOKEN_GET, vars);
        let output = [];
        for(let n in array)output.push(new (0, $c734122a5b587715$export$2e2bcd8739ae039)(this.conquer, array[n]));
        return Promise.resolve(output);
    }
    constructor(conquer, data){
        this.conquer = conquer;
        this.data = data;
        this.address = data.address;
        this.chainID = data.chainID;
        this.name = data.name;
        this.symbol = data.symbol;
        this.totalSupply = data.totalSupply;
        this.mintPrice = data.mintPrice;
    }
}
var $8892e63a17bc7299$export$2e2bcd8739ae039 = $8892e63a17bc7299$var$NFTInstance;


class $b1adcb532b5f8023$var$NFT {
    /*=============== 
 
    GET  

    ================*/ async get(vars) {
        let data = await this.conquer.do((0, $db396e8726140e32$export$92a1a3b7554e9387).NFT_COLLECTION_GET, vars);
        return Promise.resolve(new (0, $8892e63a17bc7299$export$2e2bcd8739ae039)(this.conquer, data));
    }
    constructor(conquer){
        this.conquer = conquer;
    }
}
var $b1adcb532b5f8023$export$2e2bcd8739ae039 = $b1adcb532b5f8023$var$NFT;



class $238d1d3234cc7db0$var$CONQUER {
    get currentPlatform() {
        if (typeof window != "undefined") // console.log(`window platform: ${(window as any).platform} | type: ${typeof (window as any).platform} | current: ${this._currentPlatform}`);
        // let browserInfo:string = window.navigator.userAgent.toLowerCase();
        // if (browserInfo.indexOf('macintosh') >= 0 || browserInfo.indexOf('windows') >= 0 || browserInfo.indexOf('cros') >= 0 || browserInfo.indexOf('ubuntu')) {
        //     this._currentPlatform = 'Web';
        // } else if (browserInfo.indexOf('ipad') >= 0 || browserInfo.indexOf('iphone') >= 0) {
        //     this._currentPlatform = 'iOS';
        // } else if (browserInfo.indexOf('android') >= 0) {
        //     this._currentPlatform = 'Android';
        // }
        {
            if (typeof window.platform != "undefined") this._currentPlatform = window.platform;
        }
        // console.log(`current platform equals None: ${this._currentPlatform == 'None'}`);
        // console.log(`current platform toString equals None: ${this._currentPlatform.toString() == 'None'}`);
        if (this._currentPlatform == "None") return "Web";
        // console.log(`about to return currentPlatform: ${this._currentPlatform}`);
        return this._currentPlatform;
    }
    async init() {
        // TODO : remove test colyseus
        // await this.ColyseusClient.init();
        // return Promise.resolve();
        if (typeof window != "undefined") {
            let w = window;
            try {
                if (window.parent != window.self && typeof window.parent.conquerInstance != "undefined") {
                    w.conquerInstance = window.parent.conquerInstance;
                    console.log("conquer instance used from parent!");
                    return Promise.resolve();
                } else console.log("conquer instance about to be created from self!");
            } catch (err) {
                console.log("conquer instance about to be created from self!");
            }
        }
        var timerCount = 0;
        var timerInterval = 10;
        var timer = setInterval(()=>{
            timerCount += timerInterval;
        }, timerInterval);
        let version = "0.0.4";
        console.log(`conquer version: ${version}`);
        // console.log('conquer initializing...');
        try {
            // console.log(`[Conquer CONQUER] conquer.User 1: ${JSON.stringify(this.User)}`); 
            var duration = 0;
            var timerStart = 0;
            timerStart = timerCount;
            await this.Storage.init();
            duration = timerCount - timerStart;
            console.log(`[CONQUER init] storage: ${duration}`);
            // console.log(`[Conquer CONQUER] conquer.User 2: ${JSON.stringify(this.User)}`); 
            timerStart = timerCount;
            await this.WebAuth.init();
            duration = timerCount - timerStart;
            console.log(`[CONQUER init] web: ${duration}`);
            // console.log(`[Conquer CONQUER] conquer.User 3: ${JSON.stringify(this.User)}`); 
            timerStart = timerCount;
            await this.Socket.init();
            duration = timerCount - timerStart;
            console.log(`[CONQUER init] socket: ${duration}`);
            // console.log(`[Conquer CONQUER] conquer.User 4: ${JSON.stringify(this.User)}`); 
            timerStart = timerCount;
            // await this.Auth.init(this.disableAutoAuth);
            duration = timerCount - timerStart;
            console.log(`[CONQUER init] auth: ${duration}`);
            this.initialized = true;
            if (typeof window != "undefined") {
                let w = window;
                w.conquer = w.conquerInstance = this;
            // console.log('conquer instance created!');
            }
            console.log("conquer initialized!");
            clearInterval(timer);
        // await this.ColyseusClient.init();
        } catch (e) {
            console.log("conquer NOT initialized...");
            console.log(e);
        } finally{
            return Promise.resolve();
        }
    }
    async do(action, data) {
        let result;
        try {
            let actions = [
                (0, $db396e8726140e32$export$92a1a3b7554e9387).COLYSEUS_ECHO,
                (0, $db396e8726140e32$export$92a1a3b7554e9387).AUTH_GET
            ];
            if (actions.indexOf(action) >= 0) result = this.ColyseusClient.do(action, data);
            else result = this.Socket.do(action, data);
        } catch (e) {
            console.log(`do [${action}] error...`);
            console.log(e);
            result = Promise.resolve();
        } finally{
            return result;
        }
    }
    send(action, graphID, data) {
        let result;
        try {
            result = this.Socket.send(action, graphID, data);
        } catch (e) {
            console.log(`do [${action}] error...`);
            console.log(e);
            result = Promise.resolve();
        } finally{
            return result;
        }
    }
    constructor(params){
        this.initialized = false;
        this.User = {};
        this.disableAutoAuth = false;
        this._currentPlatform = "None";
        if (params) {
            if (params.username) this.User = params.username;
            if (params.disableAutoAuth) this.disableAutoAuth = true;
        }
        // console.log(`[Conquer CONQUER] constructor this: ${JSON.stringify(this.User)}`);
        this.Storage = new (0, $040cf500777e5912$export$2e2bcd8739ae039)(this);
        this.Friends = new (0, $8ef7c4683564d83a$export$2e2bcd8739ae039)(this);
        this.Auth = new (0, $daaaf85f028fd9ae$export$2e2bcd8739ae039)(this);
        this.Username = new (0, $cf8dfd9c89f8a3a7$export$2e2bcd8739ae039)(this);
        this.WebAuth = new (0, $b333bdb643789b56$export$2e2bcd8739ae039)(this);
        this.Files = new (0, $c20e8f87d1b6e64d$export$2e2bcd8739ae039)(this);
        this.Rooms = new (0, $11d56420e3f1e1c7$export$2e2bcd8739ae039)(this);
        this.Socket = new (0, $1fd6bc23f295a45a$export$2e2bcd8739ae039)(this);
        this.Analytics = new (0, $1d43f68c0dc7a784$export$2e2bcd8739ae039)(this);
        this.Games = new (0, $f867a28506ed87e3$export$2e2bcd8739ae039)(this);
        // this.Instances  = new Instances( this );
        this.Wallets = new (0, $7ef0c20968e9e658$export$2e2bcd8739ae039)(this);
        this.Sounds = new (0, $cda3552f150d130c$export$2e2bcd8739ae039)();
        this.Avatars = new (0, $4e44475405793673$export$2e2bcd8739ae039)(this);
        this.Bots = new (0, $1ac573b73118d914$export$2e2bcd8739ae039)(this);
        this.Email = new (0, $8fc06295c541b9b2$export$2e2bcd8739ae039)(this);
        this.NFT = new (0, $b1adcb532b5f8023$export$2e2bcd8739ae039)(this);
        this.Signal = new (0, $252326b9bdba11b6$export$2e2bcd8739ae039)();
        this.Haptic = new (0, $1d2c7303b57839e8$export$2e2bcd8739ae039)();
        this.Feeds = new (0, $a157c951bba1f79d$export$2e2bcd8739ae039)(this);
        //this.Video      = new Video( this );
        this.Ads = new (0, $b5b9cba8e33659d4$export$2e2bcd8739ae039)(this);
        this.Share = new (0, $908eb8dc23d2f250$export$2e2bcd8739ae039)(this);
        this.Contacts = new (0, $26879387177e3f9a$export$2e2bcd8739ae039)(this);
        this.MiscSystem = new (0, $2085acd63d19c7b7$export$2e2bcd8739ae039)(this);
        this.Notification = new (0, $2cc3990f27bb6ce8$export$2e2bcd8739ae039)(this);
        this.ColyseusClient = new (0, $be402f22b040cc66$export$2e2bcd8739ae039)(this);
    }
}
var $238d1d3234cc7db0$export$2e2bcd8739ae039 = $238d1d3234cc7db0$var$CONQUER;
let $238d1d3234cc7db0$var$w;
if (typeof window !== "undefined") $238d1d3234cc7db0$var$w = window;
const $238d1d3234cc7db0$export$fb1208122242c205 = $238d1d3234cc7db0$var$w /* browser */  || $parcel$global /* node */ ;
$238d1d3234cc7db0$export$fb1208122242c205.CONQUER = $238d1d3234cc7db0$var$CONQUER;


const $7e8bea31627b54c7$export$e01a68034b8b230 = /*#__PURE__*/ (0, $6cds3.createContext)();
const $7e8bea31627b54c7$var$ConquerContextProvider = (props)=>{
    const [conquerInstance, setConquerInstance] = (0, $6cds3.useState)(false);
    function loadConquer() {
        async function asyncLoad() {
            let conquer = new (0, $238d1d3234cc7db0$export$2e2bcd8739ae039)();
            await conquer.init();
            setConquerInstance(conquer);
        }
        asyncLoad();
    }
    (0, $6cds3.useEffect)(loadConquer, []);
    return /*#__PURE__*/ (0, $lBpE3.jsx)($7e8bea31627b54c7$export$e01a68034b8b230.Provider, {
        value: conquerInstance,
        children: props.children
    });
};
var $7e8bea31627b54c7$export$2e2bcd8739ae039 = $7e8bea31627b54c7$var$ConquerContextProvider;


const $260d68481938071c$export$38ee920e59704589 = /*#__PURE__*/ (0, $6cds3.createContext)();
const $260d68481938071c$var$UserContextProvider = (props)=>{
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const [userData, setUserData] = (0, $6cds3.useState)({
        isLogged: false
    });
    function loadUser() {
        async function asyncLoad() {
            if (!conquer) return setUserData({
                isLogged: false
            });
            let newData = Object.assign({}, conquer.User);
            newData.isLogged = newData && newData.type != "GUEST" && newData.token && true;
            setUserData(newData);
        }
        asyncLoad();
    }
    (0, $6cds3.useEffect)(loadUser, [
        conquer.initialized
    ]);
    (0, $6cds3.useEffect)(function() {
        if (conquer) conquer.Signal.get("AUTH:onLogin", loadUser);
        return ()=>conquer && conquer.Signal.remove("AUTH:onLogin", loadUser);
    }, [
        conquer
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsx)($260d68481938071c$export$38ee920e59704589.Provider, {
        value: {
            userData: userData,
            refresh: loadUser
        },
        children: props.children
    });
};
var $260d68481938071c$export$2e2bcd8739ae039 = $260d68481938071c$var$UserContextProvider;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

parcelRequire("6PPF0");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $6PPF0 = parcelRequire("6PPF0");
const $2c63ec6d3d1d0cb4$var$icons = {
    search: "M6.667 1.334c2.945 0 5.333 2.388 5.333 5.333a5.31 5.31 0 0 1-1.12 3.27l3.592 3.592c.26.26.26.682 0 .943s-.682.26-.943 0l-3.591-3.592a5.31 5.31 0 0 1-3.27 1.12c-2.946 0-5.333-2.388-5.333-5.333s2.388-5.333 5.333-5.333zm0 1.333a4 4 0 1 0 0 8 4 4 0 1 0 0-8z",
    notification: "M8.833 12.861c.368 0 .679.313.516.643-.072.146-.169.281-.289.398-.281.276-.663.431-1.061.431s-.779-.155-1.061-.431a1.47 1.47 0 0 1-.289-.398c-.163-.33.148-.643.516-.643h1.667zM8 1.667c2.982 0 5.4 2.382 5.4 5.321v4.106h.011a.59.59 0 0 1 .589.589.59.59 0 0 1-.589.589H2.589A.59.59 0 0 1 2 11.683a.59.59 0 0 1 .589-.589H2.6V6.988c0-2.939 2.418-5.321 5.4-5.321zm0 1.178c-2.32 0-4.2 1.855-4.2 4.142v4.106h8.4V6.988c0-2.288-1.88-4.142-4.2-4.142z",
    copy: "M11.988 9.672c.015.249.276.418.487.285 1.315-.825 2.19-2.288 2.19-3.956a4.67 4.67 0 0 0-4.667-4.667c-1.667 0-3.131.875-3.956 2.19-.133.212.035.472.285.487 2.984.179 5.481 2.679 5.66 5.66zm-1.323.329a4.67 4.67 0 0 1-4.667 4.667 4.67 4.67 0 0 1-4.667-4.667 4.67 4.67 0 0 1 4.667-4.667 4.67 4.67 0 0 1 4.667 4.667z",
    user: "M8 .668a4 4 0 0 1 4 4c0 1.296-.617 2.449-1.573 3.18 2.104.93 3.573 3.037 3.573 5.487v1.333c0 .368-.298.667-.667.667s-.667-.298-.667-.667v-1.333a4.67 4.67 0 0 0-4.645-4.667H8h0l-.021-.001-.193.006a4.67 4.67 0 0 0-4.453 4.662v1.333c0 .368-.298.667-.667.667S2 15.036 2 14.668v-1.333c0-2.45 1.468-4.557 3.573-5.489C4.617 7.117 4 5.964 4 4.668a4 4 0 0 1 4-4zm0 1.333c-1.473 0-2.667 1.194-2.667 2.667S6.527 7.335 8 7.335s2.667-1.194 2.667-2.667S9.473 2.001 8 2.001z",
    image: "M8.001 1.334a28.06 28.06 0 0 1 3.639.246c1.464.193 2.588 1.317 2.782 2.782.133 1.007.246 2.266.246 3.639a28.05 28.05 0 0 1-.246 3.639c-.193 1.464-1.317 2.588-2.782 2.782-1.007.133-2.266.246-3.639.246s-2.632-.113-3.639-.246c-1.465-.193-2.588-1.317-2.782-2.782a28.06 28.06 0 0 1-.246-3.639 28.06 28.06 0 0 1 .246-3.639c.193-1.465 1.317-2.588 2.782-2.782a28.06 28.06 0 0 1 3.639-.246zm0 1.333c-1.301 0-2.501.107-3.464.235-.867.114-1.52.768-1.635 1.635-.127.963-.235 2.163-.235 3.464 0 1.055.071 2.043.165 2.892l1.086-1.087a2 2 0 0 1 2.828 0l.114.114c.26.26.682.26.943 0l1.448-1.448a2 2 0 0 1 2.828 0l1.196 1.196-.168 1.718-1.971-1.971c-.26-.26-.682-.26-.943 0l-1.448 1.448a2 2 0 0 1-2.828 0l-.114-.114c-.26-.26-.682-.26-.943 0l-1.605 1.606a1.88 1.88 0 0 0 1.28.745c.963.127 2.163.235 3.464.235a26.72 26.72 0 0 0 3.464-.235c.867-.114 1.52-.768 1.635-1.635.127-.963.235-2.163.235-3.464s-.107-2.501-.235-3.464c-.114-.867-.768-1.52-1.635-1.635-.963-.127-2.163-.235-3.464-.235zm-2.001 2c.736 0 1.333.597 1.333 1.333s-.597 1.333-1.333 1.333-1.333-.597-1.333-1.333.597-1.333 1.333-1.333z",
    exit: "M10.668 1.334c.866 0 1.519.045 2.005.104 1.044.128 1.728.94 1.825 1.92.086.863.169 2.301.169 4.642l-.169 4.642c-.098.98-.781 1.792-1.825 1.92a16.68 16.68 0 0 1-2.005.104 16.68 16.68 0 0 1-2.005-.104c-1.044-.128-1.728-.94-1.825-1.92l-.124-1.951c-.014-.368.273-.677.641-.691s.677.273.691.641l.119 1.869c.043.427.301.685.66.729a15.36 15.36 0 0 0 1.844.094c.821 0 1.419-.042 1.844-.094.36-.044.618-.301.66-.729.08-.806.163-2.198.163-4.51l-.163-4.51c-.043-.428-.301-.685-.66-.729-.424-.052-1.022-.094-1.844-.094s-1.42.042-1.844.094c-.36.044-.618.301-.66.729l-.119 1.869c-.014.368-.323.655-.691.641s-.655-.323-.641-.691l.124-1.951c.098-.98.781-1.792 1.825-1.92.486-.059 1.139-.104 2.005-.104zM4.805 5.196c.26.26.26.682 0 .943L3.61 7.334h6.391c.368 0 .667.298.667.667s-.298.667-.667.667H3.61l1.195 1.195c.26.26.26.682 0 .943s-.682.26-.943 0L1.529 8.472c-.26-.26-.26-.682 0-.943l2.333-2.333c.26-.26.682-.26.943 0z",
    bulb: "M7.999 0c2.946 0 5.333 2.388 5.333 5.333 0 1.684-.781 3.186-2 4.164v1.17c0 .591-.256 1.122-.663 1.488L10.668 14a2 2 0 0 1-2 2H7.335a2 2 0 0 1-2-2v-1.841c-.41-.366-.668-.899-.668-1.492v-1.17c-1.219-.977-2-2.479-2-4.164C2.666 2.388 5.054 0 7.999 0zm1.335 12.667l-2.667-.001V14c0 .368.298.667.667.667h1.333c.368 0 .667-.298.667-.667v-1.333h0zM7.999 1.333a4 4 0 0 0-4 4A3.99 3.99 0 0 0 5.5 8.457l.499.4v1.81c0 .368.298.667.667.667h.668V7.609L6.196 6.471c-.26-.26-.26-.682 0-.943s.682-.26.943 0h0L8 6.39l.862-.862c.26-.26.682-.26.943 0s.26.682 0 .943h0L8.667 7.609v3.724h.666c.368 0 .667-.298.667-.667v-1.81l.499-.4a3.99 3.99 0 0 0 1.501-3.123 4 4 0 0 0-4-4z",
    "arrow-next": "M10.39 3.765c.464-.375 1.187-.349 1.615.057l3.692 3.5a.91.91 0 0 1 0 1.357l-3.692 3.5c-.428.406-1.151.431-1.615.057s-.493-1.007-.065-1.413L12.247 9H1.143C.512 9 0 8.552 0 8s.512-1 1.143-1h11.104l-1.922-1.822c-.428-.406-.399-1.038.065-1.413z",
    "arrow-prev": "M5.61 12.235c-.464.375-1.187.349-1.615-.057l-3.692-3.5a.91.91 0 0 1 0-1.357l3.692-3.5c.428-.406 1.151-.431 1.615-.057s.493 1.007.065 1.413L3.753 7h11.104C15.488 7 16 7.448 16 8s-.512 1-1.143 1H3.753l1.922 1.822c.428.406.399 1.038-.065 1.413z",
    "arrow-bottom": "M15.039 3.961c-.653-.653-1.713-.653-2.366 0L8 8.634 3.327 3.961c-.653-.653-1.713-.653-2.366 0s-.653 1.713 0 2.366l5.856 5.856c.653.653 1.713.653 2.366 0l5.856-5.856c.653-.653.653-1.713 0-2.366z",
    stop: "M8 1.333a28.06 28.06 0 0 1 3.639.246c1.465.193 2.588 1.317 2.782 2.782.133 1.007.246 2.266.246 3.639s-.113 2.632-.246 3.639c-.193 1.465-1.317 2.588-2.782 2.782-1.007.133-2.266.246-3.639.246s-2.632-.113-3.639-.246c-1.465-.193-2.588-1.317-2.782-2.782A28.06 28.06 0 0 1 1.333 8a28.06 28.06 0 0 1 .246-3.639c.193-1.465 1.317-2.588 2.782-2.782A28.06 28.06 0 0 1 8 1.333zm0 1.333c-1.301 0-2.501.107-3.464.235-.867.114-1.52.768-1.635 1.635A26.73 26.73 0 0 0 2.667 8c0 1.301.107 2.501.235 3.464.114.867.768 1.52 1.635 1.635.963.127 2.163.235 3.464.235s2.501-.107 3.464-.235c.867-.114 1.52-.768 1.635-1.635.127-.963.235-2.163.235-3.464s-.107-2.501-.235-3.464c-.114-.867-.768-1.52-1.635-1.635A26.73 26.73 0 0 0 8 2.667z",
    play: "M1.8 2.923c0-1.567 1.72-2.525 3.053-1.701l8.2 5.076a2 2 0 0 1 0 3.401l-8.2 5.076c-1.332.825-3.053-.134-3.053-1.701V2.923z",
    "full-screen": "M8 1.333a28.06 28.06 0 0 1 3.639.246c1.465.193 2.588 1.317 2.782 2.782.133 1.007.246 2.266.246 3.639s-.113 2.632-.246 3.639c-.193 1.465-1.317 2.588-2.782 2.782-1.007.133-2.266.246-3.639.246s-2.632-.113-3.639-.246c-1.465-.193-2.588-1.317-2.782-2.782A28.06 28.06 0 0 1 1.333 8a28.06 28.06 0 0 1 .246-3.639c.193-1.465 1.317-2.588 2.782-2.782A28.06 28.06 0 0 1 8 1.333zm-4.667 8c-.368 0-.667.298-.667.667h0v1.333a2 2 0 0 0 2 2h0H6c.368 0 .667-.298.667-.667S6.368 12 6 12h0-1.333C4.298 12 4 11.701 4 11.333h0V10c0-.368-.298-.667-.667-.667zm9.333 0c-.368 0-.667.298-.667.667h0v1.333c0 .368-.298.667-.667.667h0H10c-.368 0-.667.298-.667.667s.298.667.667.667h0 1.333a2 2 0 0 0 2-2h0V10c0-.368-.298-.667-.667-.667zM6 2.666H4.666a2 2 0 0 0-2 2V6c0 .368.298.667.667.667S4 6.368 4 6V4.666C4 4.298 4.298 4 4.666 4H6c.368 0 .667-.298.667-.667S6.368 2.666 6 2.666zm5.333 0H10c-.368 0-.667.298-.667.667S9.631 4 10 4h1.333c.368 0 .667.298.667.667V6c0 .368.298.667.667.667s.667-.298.667-.667V4.666a2 2 0 0 0-2-2z",
    volume: "M10.667 2.667c-.368 0-.667.298-.667.667s.298.667.667.667a4 4 0 1 1 0 8c-.368 0-.667.298-.667.667s.298.667.667.667C13.612 13.334 16 10.946 16 8s-2.388-5.333-5.333-5.333zm0 2.667c-.368 0-.667.298-.667.667s.298.667.667.667A1.33 1.33 0 0 1 12 8c0 .736-.597 1.333-1.333 1.333-.368 0-.667.298-.667.667s.298.667.667.667A2.67 2.67 0 0 0 13.334 8a2.67 2.67 0 0 0-2.667-2.667zM3.333 6l3.088-2.895c.852-.798 2.245-.195 2.245.973v7.845c0 1.167-1.394 1.771-2.245.973L3.333 10h-2C.597 10 0 9.403 0 8.667V7.334C0 6.597.597 6 1.333 6h2z",
    "arrow-expand": "M11.281 9.207a.75.75 0 0 0 .719-.779l-.143-3.567a.75.75 0 0 0-.719-.719l-3.567-.143a.75.75 0 0 0-.779.719.75.75 0 0 0 .719.779l1.856.074-5.148 5.148a.75.75 0 0 0 0 1.06.75.75 0 0 0 1.06 0l5.148-5.148.074 1.856a.75.75 0 0 0 .779.719z",
    "add-square": "M8 1.333a28.06 28.06 0 0 1 3.639.246c1.465.193 2.588 1.317 2.782 2.782.133 1.007.246 2.266.246 3.639s-.113 2.632-.246 3.639c-.193 1.465-1.317 2.588-2.782 2.782-1.007.133-2.266.246-3.639.246s-2.632-.113-3.639-.246c-1.465-.193-2.588-1.317-2.782-2.782A28.06 28.06 0 0 1 1.333 8a28.06 28.06 0 0 1 .246-3.639c.193-1.465 1.317-2.588 2.782-2.782A28.06 28.06 0 0 1 8 1.333zm0 1.333c-1.301 0-2.501.107-3.464.235-.867.114-1.52.768-1.635 1.635-.127.963-.235 2.163-.235 3.464s.107 2.501.235 3.464c.114.867.768 1.52 1.635 1.635.963.127 2.163.235 3.464.235s2.501-.107 3.464-.235c.867-.114 1.52-.768 1.635-1.635.127-.963.235-2.163.235-3.464s-.107-2.501-.235-3.464c-.114-.867-.768-1.52-1.635-1.635A26.73 26.73 0 0 0 8 2.666zm0 2c.368 0 .667.298.667.667h0v2h2c.368 0 .667.298.667.667s-.298.667-.667.667h0-2v2c0 .368-.298.667-.667.667s-.667-.298-.667-.667h0v-2h-2c-.368 0-.667-.298-.667-.667s.298-.667.667-.667h0 2v-2c0-.368.298-.667.667-.667z",
    "scatter-up": "M13.334 12.667c.368 0 .667.298.667.667s-.299.667-.667.667-.667-.298-.667-.667.298-.667.667-.667zm-5.333 0c.368 0 .667.298.667.667S8.369 14 8 14s-.667-.298-.667-.667.298-.667.667-.667zm-5.333 0c.368 0 .667.298.667.667S3.035 14 2.667 14 2 13.702 2 13.334s.298-.667.667-.667zM13.334 10c.368 0 .667.298.667.667s-.299.667-.667.667-.667-.299-.667-.667.298-.667.667-.667zM8 10c.368 0 .667.298.667.667s-.298.667-.667.667-.667-.299-.667-.667S7.632 10 8 10zM2.667 7.333a2 2 0 0 1 0 4 2 2 0 0 1-2-2 2 2 0 0 1 2-2zm0 1.333c-.368 0-.667.298-.667.667s.298.667.667.667.667-.298.667-.667-.298-.667-.667-.667zm10.667-1.333c.368 0 .667.298.667.667s-.299.667-.667.667-.667-.298-.667-.667.298-.667.667-.667zM8 4.667a2 2 0 1 1 0 4 2 2 0 1 1 0-4zM8 6c-.368 0-.667.298-.667.667s.298.667.667.667.667-.298.667-.667S8.369 6 8 6zm5.333-4a2 2 0 1 1 0 4 2 2 0 1 1 0-4zm0 1.333c-.368 0-.667.298-.667.667s.299.667.667.667S14 4.368 14 4s-.298-.667-.667-.667z",
    heart: "M11 2.112c2.393 0 4.333 1.94 4.333 4.333 0 4.245-4.647 6.59-6.542 7.37-.511.21-1.071.21-1.582 0-1.896-.78-6.543-3.124-6.543-7.37 0-2.393 1.94-4.333 4.333-4.333a4.32 4.32 0 0 1 3 1.206 4.32 4.32 0 0 1 3-1.206zm0 1.333c-.807 0-1.537.317-2.077.835l-.462.443c-.258.248-.665.248-.923 0l-.462-.443c-.54-.518-1.27-.835-2.077-.835a3 3 0 0 0-3 3c0 1.588.86 2.9 2.101 3.978s2.728 1.794 3.615 2.159a.73.73 0 0 0 .567 0c.888-.365 2.373-1.08 3.615-2.159S14 8.034 14 6.445a3 3 0 0 0-3-3z",
    "heart-fill": "M8 3.339a4.32 4.32 0 0 0-3-1.206c-2.393 0-4.333 1.94-4.333 4.333 0 4.246 4.647 6.59 6.543 7.37.511.21 1.071.21 1.582 0 1.896-.78 6.543-3.124 6.543-7.37 0-2.393-1.94-4.333-4.333-4.333a4.32 4.32 0 0 0-3 1.206z",
    "candlesticks-up": "M4.667 2.667c.368 0 .667.298.667.667v4.781A2 2 0 0 1 6.667 10v1.333a2 2 0 0 1-1.333 1.886v2.114c0 .368-.298.667-.667.667S4 15.702 4 15.333v-2.114a2 2 0 0 1-1.333-1.886V10A2 2 0 0 1 4 8.114V3.333c0-.368.298-.667.667-.667zM11.334 0c.368 0 .667.298.667.667l.001.781a2 2 0 0 1 1.333 1.886v4a2 2 0 0 1-1.333 1.886L12 12.667c0 .368-.298.667-.667.667s-.667-.298-.667-.667l-.001-3.448a2 2 0 0 1-1.333-1.886v-4a2 2 0 0 1 1.333-1.886l.001-.781c0-.368.298-.667.667-.667zM4.667 9.333c-.335 0-.612.247-.659.568L4 10v1.333c0 .368.298.667.667.667.335 0 .612-.247.659-.568l.007-.099V10c0-.368-.298-.667-.667-.667zm6.667-6.667c-.335 0-.612.247-.659.568l-.007.099v4c0 .368.298.667.667.667.335 0 .612-.247.659-.568L12 7.333v-4c0-.368-.298-.667-.667-.667z",
    close: "M.335.335c.446-.446 1.17-.446 1.616 0L8 6.384 14.049.335c.446-.446 1.17-.446 1.616 0s.446 1.17 0 1.616L9.616 8l6.049 6.049c.446.446.446 1.17 0 1.616s-1.17.446-1.616 0L8 9.616l-6.049 6.049c-.446.446-1.17.446-1.616 0s-.446-1.17 0-1.616L6.384 8 .335 1.951c-.446-.446-.446-1.17 0-1.616",
    "upload-file": "M10.229.667c.707 0 1.386.281 1.886.781l1.105 1.105c.5.5.781 1.178.781 1.886v8.229c0 1.473-1.194 2.667-2.667 2.667H4.667C3.194 15.334 2 14.14 2 12.667V3.334C2 1.861 3.194.667 4.667.667h5.562zM9.333 2H4.667c-.693 0-1.263.529-1.327 1.205l-.006.128v9.333c0 .693.529 1.263 1.205 1.327l.128.006h6.667c.693 0 1.263-.529 1.327-1.205l.006-.128V5.334h-1.333a2 2 0 0 1-1.995-1.851l-.005-.149V2zM7.745 6.051c.242-.1.53-.052.727.145h0l2 2c.26.26.26.682 0 .943s-.682.26-.943 0h0l-.862-.862v3.057c0 .368-.298.667-.667.667s-.667-.298-.667-.667h0V8.276l-.862.862c-.26.26-.682.26-.943 0s-.26-.682 0-.943h0l2-2c.064-.064.138-.112.216-.145zm2.922-3.977v1.259c0 .368.298.667.667.667h1.259c-.065-.188-.173-.361-.317-.505l-1.105-1.105c-.144-.144-.317-.251-.505-.317z",
    plus: "M8.667 4.667C8.667 4.298 8.368 4 8 4s-.667.298-.667.667v2.667H4.667C4.298 7.333 4 7.632 4 8s.298.667.667.667h2.667v2.667c0 .368.298.667.667.667s.667-.298.667-.667V8.667h2.667c.368 0 .667-.298.667-.667s-.298-.667-.667-.667H8.667V4.667z",
    "circle-close": "M8 1.333A6.67 6.67 0 0 1 14.666 8 6.67 6.67 0 0 1 8 14.666 6.67 6.67 0 0 1 1.333 8 6.67 6.67 0 0 1 8 1.333zm0 1.333C5.054 2.666 2.666 5.054 2.666 8S5.054 13.333 8 13.333 13.333 10.945 13.333 8 10.945 2.666 8 2.666zm2.471 2.862c.26.26.26.682 0 .943L8.942 8l1.529 1.529c.26.26.26.682 0 .943s-.682.26-.943 0L8 8.942l-1.529 1.529c-.26.26-.682.26-.943 0s-.26-.682 0-.943L7.057 8 5.528 6.471c-.26-.26-.26-.682 0-.943s.682-.26.943 0L8 7.057l1.529-1.529c.26-.26.682-.26.943 0z",
    wallet: "M12.667 2c1.416 0 2.574 1.104 2.661 2.498l.005.169v6.667c0 1.416-1.104 2.574-2.498 2.661l-.169.005H3.334C1.918 14 .759 12.896.672 11.502l-.005-.169V4.667c0-1.416 1.104-2.574 2.498-2.661L3.334 2h9.333zm0 1.333H3.334C2.597 3.333 2 3.93 2 4.667v6.667c0 .736.597 1.333 1.333 1.333h9.333c.736 0 1.333-.597 1.333-1.333h-2c-1.841 0-3.333-1.492-3.333-3.333S10.159 4.667 12 4.667h2c0-.736-.597-1.333-1.333-1.333zM14 6h-2a2 2 0 1 0 0 4h2V6zm-2 1.333c.368 0 .667.298.667.667s-.298.667-.667.667-.667-.298-.667-.667.298-.667.667-.667z",
    check: "M15.665 2.668c.446.446.446 1.17 0 1.616l-9.143 9.143c-.446.446-1.17.446-1.616 0L.335 8.855c-.446-.446-.446-1.17 0-1.616s1.17-.446 1.616 0l3.763 3.763 8.335-8.335c.446-.446 1.17-.446 1.616 0z",
    "circle-and-square": "M13.334 5.334c.736 0 1.333.597 1.333 1.333v6.667c0 .736-.597 1.333-1.333 1.333H6.667c-.736 0-1.333-.597-1.333-1.333v-.998a.35.35 0 0 1 .371-.343l.296.007a6 6 0 0 0 6-6l-.007-.296a.35.35 0 0 1 .343-.371h.998zm-7.333-4a4.67 4.67 0 0 1 4.667 4.667 4.67 4.67 0 0 1-4.667 4.667 4.67 4.67 0 0 1-4.667-4.667 4.67 4.67 0 0 1 4.667-4.667z",
    pen: "M14.11 9.444c.491.491.491 1.287 0 1.778l-2.889 2.889c-.491.491-1.287.491-1.778 0a.63.63 0 0 1 0-.889l3.778-3.778a.63.63 0 0 1 .889 0zM3.027 1.584l.067.001 5.43.776a4 4 0 0 1 3.059 2.268h0l1.22 2.615c.118.254.066.555-.133.753h0L7.997 12.67c-.198.198-.499.251-.753.133h0l-2.615-1.22a4 4 0 0 1-2.268-3.059h0l-.776-5.43c-.034-.237.243-.323.412-.153h0l3.912 3.912c.084.084.114.207.1.325-.006.051-.009.104-.009.157 0 .736.597 1.333 1.333 1.333s1.333-.597 1.333-1.333S8.07 6 7.333 6a1.35 1.35 0 0 0-.157.009.39.39 0 0 1-.325-.1h0L2.94 1.997c-.169-.169-.084-.446.153-.412z",
    lightning: "M2.764 8.943L9.002.307a.67.67 0 0 1 1.198.5L9.334 6h3.363a.67.67 0 0 1 .54 1.057L7 15.694a.67.67 0 0 1-1.198-.5L6.668 10H3.305a.67.67 0 0 1-.54-1.057z",
    "lightning-outline": "M9.001.332a.67.67 0 0 1 1.198.5h0l-.866 5.194h3.363a.67.67 0 0 1 .54 1.057h0l-6.237 8.637a.67.67 0 0 1-1.198-.5h0l.866-5.194H3.304a.67.67 0 0 1-.54-1.057h0zm-.585 3.087L4.608 8.692h3.633l-.657 3.94 3.808-5.273H7.759l.657-3.94z",
    home: "M13.333 12.534V5.978l.99.594c.316.189.725.087.915-.229s.087-.725-.229-.915L11.661 3.42 9.1 1.877h0l-.45-.263-.086-.044c-.101-.049-.188-.082-.278-.102-.189-.042-.385-.042-.574 0-.09.02-.178.053-.279.102l-.084.043-.451.263h0L4.334 3.422.99 5.429c-.316.189-.418.599-.229.915s.599.418.915.229l.99-.594v6.556c0 .747 0 1.12.145 1.405.128.251.332.455.583.583.285.145.659.145 1.405.145h1.2v-4a2 2 0 0 1 4 0v4h1.2c.747 0 1.12 0 1.405-.145.251-.128.455-.332.583-.583.145-.285.145-.659.145-1.405z",
    "home-outline": "M4.428 14.814c-.508-.004-.8-.026-1.033-.144-.251-.128-.455-.332-.583-.583-.119-.233-.141-.526-.144-1.033l-.001-6.928-.99.594c-.316.189-.725.087-.915-.229s-.087-.725.229-.915h0L4.335 3.57l2.565-1.545.451-.263.084-.043a1.23 1.23 0 0 1 .279-.102c.189-.042.385-.042.574 0 .09.02.177.053.278.102l.086.044.45.263h0l2.561 1.543 3.348 2.009c.316.189.418.599.229.915s-.599.418-.915.229h0l-.99-.594v6.751c-.001.619-.013.951-.145 1.211-.128.251-.332.455-.583.583-.233.119-.526.14-1.033.144zM8 2.926l-.006.003-2.973 1.784L4 5.328l.001 7.651.013.469h0l.002.018.018.002a6.48 6.48 0 0 0 .469.013H6v-2.666a2 2 0 0 1 3.995-.149l.005.149v2.666h1.498l.399-.008.071-.005.018-.002.002-.018c.013-.155.014-.372.014-.767V5.328l-1.025-.618-2.969-1.781L8 2.926zm0 7.222c-.368 0-.667.298-.667.667v2.667h1.333v-2.667c0-.368-.298-.667-.667-.667z",
    "close-circle-fill": "M8 1.333A6.67 6.67 0 0 1 14.666 8 6.67 6.67 0 0 1 8 14.666 6.67 6.67 0 0 1 1.333 8 6.67 6.67 0 0 1 8 1.333zm1.529 4.195L8 7.057 6.471 5.528c-.26-.26-.682-.26-.943 0s-.26.682 0 .943L7.057 8 5.528 9.528c-.26.26-.26.682 0 .943s.682.26.943 0L8 8.942l1.529 1.529c.26.26.682.26.943 0s.26-.682 0-.943L8.942 8l1.529-1.529c.26-.26.26-.682 0-.943s-.682-.26-.943 0z",
    edit: "M13.283 14c.368 0 .667.298.667.667s-.299.667-.667.667H2.617c-.368 0-.667-.298-.667-.667S2.248 14 2.617 14h10.667zM12.031 1.138l1.448 1.448a2 2 0 0 1 0 2.828l-6.862 6.862c-.25.25-.589.39-.943.39H3.283c-.736 0-1.333-.597-1.333-1.333V8.943c0-.354.14-.693.391-.943l6.862-6.862a2 2 0 0 1 2.828 0zM3.617 8.609l-.333.333v2.391h2.391L6.007 11l-2.391-2.39zm5-5L4.56 7.666l2.391 2.39L11.007 6 8.617 3.609zm1.529-1.529l-.586.586 2.39 2.391.586-.586c.26-.26.26-.682 0-.943l-1.448-1.448c-.26-.26-.682-.26-.943 0z",
    globe: "M8.001 1.334a6.67 6.67 0 0 1 6.631 5.971l.003.029.033.667a6.67 6.67 0 0 1-6.667 6.667h-.003l-.231-.004a6.67 6.67 0 0 1-6.4-5.996l-.033-.667c0-.225.011-.447.033-.667h0a6.67 6.67 0 0 1 6.632-6h0 .002zm1.98 7.334H6.018c.077 1.396.391 2.599.817 3.451.532 1.065 1.021 1.216 1.164 1.216s.632-.151 1.164-1.216c.426-.852.74-2.055.817-3.451zm3.312 0h-1.977c-.081 1.623-.452 3.075-1.009 4.144a5.34 5.34 0 0 0 2.986-4.144zm-8.61 0H2.709c.228 1.83 1.384 3.373 2.982 4.142-.557-1.069-.928-2.519-1.008-4.141zM5.69 3.192l-.141.07c-1.525.79-2.619 2.295-2.841 4.07h1.974c.081-1.622.452-3.073 1.008-4.141zm2.309-.525c-.143 0-.632.151-1.164 1.216-.426.852-.74 2.055-.817 3.451h3.963c-.077-1.396-.391-2.599-.817-3.451-.532-1.065-1.021-1.216-1.164-1.216zm2.308.523l.049.096c.529 1.059.882 2.472.96 4.047h1.976c-.229-1.831-1.386-3.374-2.985-4.142z",
    share: "M10.702 6.063l1.279.098c.99.104 1.779.806 1.898 1.843.068.591.122 1.444.122 2.663l-.122 2.663c-.118 1.036-.906 1.739-1.896 1.843-.787.083-2.042.161-3.982.161s-3.195-.078-3.982-.161c-.99-.104-1.778-.807-1.896-1.843C2.054 12.739 2 11.886 2 10.667l.122-2.663c.119-1.037.908-1.739 1.897-1.843l1.279-.098c.368-.02.682.263.701.63s-.263.682-.63.701l-1.21.092c-.417.044-.671.3-.713.669-.06.529-.113 1.33-.113 2.511l.113 2.511c.042.369.295.625.711.669C4.887 13.924 6.093 14 8 14l3.842-.154c.416-.044.669-.299.711-.669.06-.529.113-1.33.113-2.511l-.113-2.511c-.042-.369-.296-.625-.713-.669l-1.21-.092c-.368-.02-.65-.334-.63-.701s.334-.65.701-.63zM8.471.862l2.333 2.333c.26.26.26.682 0 .943s-.682.26-.943 0L8.667 2.943v6.391c0 .368-.298.667-.667.667s-.667-.298-.667-.667V2.943L6.138 4.138c-.26.26-.682.26-.943 0s-.26-.682 0-.943L7.529.862c.26-.26.682-.26.943 0z",
    more: "M3.333 6.667A1.34 1.34 0 0 1 4.667 8a1.34 1.34 0 0 1-1.333 1.333A1.34 1.34 0 0 1 2 8a1.34 1.34 0 0 1 1.333-1.333zm9.333 0A1.34 1.34 0 0 1 14 8a1.34 1.34 0 0 1-1.333 1.333A1.34 1.34 0 0 1 11.333 8a1.34 1.34 0 0 1 1.333-1.333zM8 6.667A1.34 1.34 0 0 1 9.333 8 1.34 1.34 0 0 1 8 9.334 1.34 1.34 0 0 1 6.667 8 1.34 1.34 0 0 1 8 6.667z",
    instagram: "M10.666 1.333a4 4 0 0 1 3.995 3.8l.005.2v5.333a4 4 0 0 1-3.8 3.995l-.2.005H5.333a4 4 0 0 1-3.995-3.8l-.005-.2V5.333a4 4 0 0 1 3.8-3.995l.2-.005h5.333zm0 1.333H5.333c-1.473 0-2.667 1.194-2.667 2.667v5.333c0 1.473 1.194 2.667 2.667 2.667h5.333c1.473 0 2.667-1.194 2.667-2.667V5.333c0-1.473-1.194-2.667-2.667-2.667zm-2.666 2c1.841 0 3.333 1.492 3.333 3.333s-1.492 3.333-3.333 3.333S4.667 9.841 4.667 8 6.16 4.667 8.001 4.667zm0 1.333a2 2 0 1 0 0 4 2 2 0 1 0 0-4zm3.333-2c.368 0 .667.298.667.667s-.298.667-.667.667-.667-.298-.667-.667.298-.667.667-.667z",
    facebook: "M8 1.333A6.67 6.67 0 0 1 14.666 8 6.67 6.67 0 0 1 8 14.666 6.67 6.67 0 0 1 1.333 8 6.67 6.67 0 0 1 8 1.333zm0 1.333C5.054 2.666 2.666 5.054 2.666 8c0 2.485 1.699 4.573 3.999 5.165V9.333H6c-.368 0-.667-.298-.667-.667S5.631 8 6 8h0 .667V6.667a2 2 0 0 1 2-2h0 .667c.368 0 .667.298.667.667S9.701 6 9.333 6h0-.667C8.298 6 8 6.298 8 6.667h0V8h1.333c.368 0 .667.298.667.667s-.298.667-.667.667h0H8v4h0c2.946 0 5.333-2.388 5.333-5.333S10.945 2.666 8 2.666z",
    twitter: "M10.334 2c.508 0 1.057.117 1.511.265.233.076.505.181.768.32h0l.993-.198c1.142-.228 2.048.957 1.527 1.999h0l-.751 1.503C14.893 10.281 11.23 14 6.667 14c-2.945 0-4.709-1.094-5.681-2.456-.679-.952.032-2.208 1.135-2.211l.151-.001a6.57 6.57 0 0 1-.754-1.324c-.578-1.36-.755-3.042-.111-4.462.457-1.007 1.757-1.065 2.371-.29.366.462 1.015.989 1.817 1.404.354.183.715.333 1.069.445.038-.249.096-.508.185-.766.191-.561.54-1.171 1.159-1.635C8.633 2.234 9.421 2 10.334 2zm0 1.333c-2.723 0-2.425 2.747-2.347 3.254.006.042-.025.08-.067.079-1.939-.034-4.167-1.294-5.187-2.581-.031-.039-.091-.033-.112.012-.892 1.968.364 5.117 2.575 5.86.054.018.065.09.016.119-.948.555-2.386.588-3.087.59-.053 0-.084.059-.054.103.689.965 2.02 1.898 4.596 1.898 3.992 0 6.988-3.32 6.337-6.978-.002-.014 0-.029.006-.042h0l.929-1.858c.025-.05-.018-.106-.073-.095h0l-1.498.3a.07.07 0 0 1-.061-.017c-.356-.325-1.324-.642-1.974-.642z",
    pinterest: "M8 1.333A6.67 6.67 0 0 1 14.666 8 6.67 6.67 0 0 1 8 14.666 6.67 6.67 0 0 1 1.333 8 6.67 6.67 0 0 1 8 1.333zm0 1.333C5.054 2.666 2.666 5.054 2.666 8c0 2.151 1.274 4.005 3.109 4.849l.702-2.524.88-3.17c.099-.355.466-.562.821-.464s.562.466.464.821l-.702 2.526c.834.177 1.419.026 1.811-.233.495-.327.813-.914.893-1.61s-.091-1.428-.481-1.969c-.375-.522-.969-.892-1.831-.892-1.281 0-2.043.554-2.415 1.236-.387.71-.4 1.645.011 2.466.165.329.031.73-.298.894s-.73.031-.894-.298c-.589-1.179-.602-2.577.011-3.701C5.376 4.779 6.614 4 8.333 4c1.305 0 2.295.588 2.913 1.446.604.839.836 1.909.723 2.9s-.585 1.977-1.483 2.57c-.766.506-1.752.668-2.903.407l-.535 1.925c.309.056.627.085.951.085 2.946 0 5.333-2.388 5.333-5.333S10.945 2.666 8 2.666z",
    "info-circle": "M8 1.334a6.67 6.67 0 0 1 6.667 6.667A6.67 6.67 0 0 1 8 14.667a6.67 6.67 0 0 1-6.667-6.667A6.67 6.67 0 0 1 8 1.334zm0 1.333c-2.946 0-5.333 2.388-5.333 5.333S5.054 13.334 8 13.334s5.333-2.388 5.333-5.333S10.945 2.667 8 2.667zm0 4.667c.368 0 .667.298.667.667h0v2.667c0 .368-.298.667-.667.667s-.667-.298-.667-.667h0V8.001c0-.368.298-.667.667-.667zm0-2.667c.368 0 .667.298.667.667s-.298.667-.667.667-.667-.298-.667-.667.298-.667.667-.667z",
    coin: "M8 1.334a6.67 6.67 0 0 1 6.667 6.667A6.67 6.67 0 0 1 8 14.667a6.67 6.67 0 0 1-6.667-6.667A6.67 6.67 0 0 1 8 1.334zm0 1.333c-2.946 0-5.333 2.388-5.333 5.333S5.054 13.334 8 13.334s5.333-2.388 5.333-5.333S10.945 2.667 8 2.667zm0 1.333c.368 0 .667.298.667.667a2 2 0 0 1 2 2c0 .368-.298.667-.667.667s-.667-.298-.667-.667-.298-.667-.667-.667H7.162c-.274 0-.496.222-.496.496 0 .213.137.403.339.47l2.411.804a1.83 1.83 0 0 1-.578 3.564h-.171c0 .368-.298.667-.667.667s-.667-.298-.667-.667a2 2 0 0 1-2-2c0-.368.298-.667.667-.667s.667.298.667.667.298.667.667.667h1.504c.274 0 .496-.222.496-.496 0-.213-.136-.403-.339-.47l-2.411-.804a1.83 1.83 0 0 1 .578-3.564h.171c0-.368.298-.667.667-.667z",
    "close-circle": "M8 1.334a6.67 6.67 0 0 1 6.667 6.667A6.67 6.67 0 0 1 8 14.667a6.67 6.67 0 0 1-6.667-6.667A6.67 6.67 0 0 1 8 1.334zm0 1.333c-2.946 0-5.333 2.388-5.333 5.333S5.054 13.334 8 13.334s5.333-2.388 5.333-5.333S10.945 2.667 8 2.667zm2.471 2.862c.26.26.26.682 0 .943L8.943 8.001l1.529 1.529c.26.26.26.682 0 .943s-.682.26-.943 0L8 8.943l-1.529 1.529c-.26.26-.682.26-.943 0s-.26-.682 0-.943l1.529-1.529-1.529-1.529c-.26-.26-.26-.682 0-.943s.682-.26.943 0L8 7.058l1.529-1.529c.26-.26.682-.26.943 0z",
    "arrow-right-square": "M8 1.334c1.373 0 2.632.113 3.639.246 1.465.193 2.588 1.317 2.782 2.782a28.06 28.06 0 0 1 .246 3.639c0 1.372-.113 2.632-.246 3.639-.193 1.464-1.317 2.588-2.782 2.782-1.007.133-2.266.246-3.639.246s-2.632-.113-3.639-.246c-1.465-.193-2.588-1.317-2.782-2.782a28.06 28.06 0 0 1-.246-3.639 28.06 28.06 0 0 1 .246-3.639c.193-1.465 1.317-2.588 2.782-2.782A28.06 28.06 0 0 1 8 1.334zm0 1.333c-1.301 0-2.501.107-3.464.235-.867.114-1.52.768-1.635 1.635-.127.963-.235 2.163-.235 3.464s.107 2.501.235 3.464c.114.867.768 1.52 1.635 1.635.963.127 2.163.235 3.464.235s2.501-.107 3.464-.235c.867-.114 1.52-.768 1.635-1.635.127-.963.234-2.163.234-3.464a26.74 26.74 0 0 0-.234-3.464c-.114-.867-.768-1.52-1.635-1.635-.963-.127-2.163-.235-3.464-.235zM6.529 5.196c.26-.26.682-.26.943 0h0l2.333 2.333c.26.26.26.682 0 .943h0l-2.333 2.333c-.26.26-.682.26-.943 0s-.26-.682 0-.943h0l1.862-1.862-1.862-1.862c-.26-.26-.26-.682 0-.943z",
    bag: "M8 1.333c1.612 0 2.957 1.145 3.267 2.666l.562.001a2.67 2.67 0 0 1 2.667 2.669l-.005.164-.333 5.333c-.084 1.349-1.162 2.412-2.494 2.495l-.168.005h-6.99c-1.352 0-2.48-1.009-2.646-2.333l-.016-.167-.333-5.333a2.67 2.67 0 0 1 2.498-2.828L4.172 4l.561-.001C5.042 2.478 6.387 1.333 8 1.333zm3.828 4h-.495V6c0 .368-.298.667-.667.667S10 6.368 10 6l-.001-.667h-4L6 6c0 .368-.298.667-.667.667S4.666 6.368 4.666 6v-.667h-.494c-.769 0-1.379.649-1.331 1.417l.333 5.333c.044.703.627 1.25 1.331 1.25h6.99c.704 0 1.287-.547 1.331-1.25l.333-5.333c.048-.768-.562-1.417-1.331-1.417zM8 2.666a2 2 0 0 0-1.886 1.333h3.772A2 2 0 0 0 8 2.666z",
    pencil: "M12.885 2.219l.895.895c1.041 1.041 1.041 2.73 0 3.771l-6.565 6.565c-.359.359-.812.608-1.307.718l-2.174.483a2 2 0 0 1-2.386-2.386l.483-2.174c.11-.495.359-.948.718-1.307l6.565-6.565c1.041-1.041 2.73-1.041 3.771 0zM3.471 9.748c-.168.176-.286.395-.338.633l-.483 2.174c-.106.476.319.901.795.795l2.174-.483c.238-.053.457-.17.633-.338L3.471 9.748zm4.666-4.667L4.414 8.805l2.781 2.781 3.724-3.724-2.781-2.781zm3.805-1.919c-.521-.521-1.365-.521-1.886 0h0l-.976.976 2.781 2.781.976-.976c.521-.521.521-1.365 0-1.886h0z",
    filter: "M12.263 1.333c1.597 0 2.55 1.78 1.664 3.109h0l-3.148 4.723c-.073.109-.112.238-.112.37h0v2.69a2 2 0 0 1-.94 1.696h0l-1.333.833c-1.332.833-3.06-.125-3.06-1.696h0V9.535c0-.132-.039-.26-.112-.37h0L2.073 4.442c-.886-1.329.067-3.109 1.664-3.109h0zm0 1.333H3.737a.67.67 0 0 0-.555 1.036l3.372 5.059c.073.11.112.238.112.37v3.927a.67.67 0 0 0 1.02.565l1.333-.833c.195-.122.313-.336.313-.565V9.131c0-.132.039-.26.112-.37l3.372-5.059a.67.67 0 0 0-.555-1.036z",
    "plus-circle": "M8.001 1.333A6.67 6.67 0 0 1 14.667 8a6.67 6.67 0 0 1-6.667 6.667A6.67 6.67 0 0 1 1.334 8a6.67 6.67 0 0 1 6.667-6.667zm0 2A4.67 4.67 0 0 0 3.334 8a4.67 4.67 0 0 0 4.667 4.667A4.67 4.67 0 0 0 12.667 8a4.67 4.67 0 0 0-4.667-4.667zm0 .333a1 1 0 0 1 1 1V7h2.333a1 1 0 1 1 0 2H9.001v2.333a1 1 0 1 1-2 0V9H4.667a1 1 0 1 1 0-2h2.333V4.666a1 1 0 0 1 1-1z",
    report: "M3.411 0c.368 0 .667.298.667.667v.666h7.768c1.097 0 1.707 1.239 1.089 2.103l-.077.098L10.744 6l2.113 2.466c.714.833.17 2.103-.888 2.196l-.124.005-7.768-.001v4.667c0 .335-.247.612-.568.659L3.411 16c-.368 0-.667-.298-.667-.667V.667c0-.335.247-.612.568-.659L3.411 0zm8.434 2.667H4.077v6.667h7.768L8.988 6l2.857-3.333z",
    "minus-square": "M8 1.333a28.06 28.06 0 0 1 3.639.246c1.465.193 2.588 1.317 2.782 2.782.133 1.007.246 2.266.246 3.639s-.113 2.632-.246 3.639c-.193 1.465-1.317 2.588-2.782 2.782-1.007.133-2.266.246-3.639.246s-2.632-.113-3.639-.246c-1.465-.193-2.588-1.317-2.782-2.782A28.06 28.06 0 0 1 1.333 8a28.06 28.06 0 0 1 .246-3.639c.193-1.465 1.317-2.588 2.782-2.782A28.06 28.06 0 0 1 8 1.333zm2.667 6H5.333c-.368 0-.667.298-.667.667s.298.667.667.667h5.333c.368 0 .667-.298.667-.667s-.298-.667-.667-.667z"
};
const $2c63ec6d3d1d0cb4$var$Icon = (props)=>{
    const size = props.size ? props.size : 16;
    const fill = props.fill ? props.fill : "inherit";
    return /*#__PURE__*/ (0, $lBpE3.jsx)("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))(props.className),
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: fill,
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("path", {
            d: $2c63ec6d3d1d0cb4$var$icons[props.name]
        })
    });
};
var $2c63ec6d3d1d0cb4$export$2e2bcd8739ae039 = $2c63ec6d3d1d0cb4$var$Icon;


var $136d2049cfd34a82$exports = {};

$parcel$export($136d2049cfd34a82$exports, "avatar", function () { return $136d2049cfd34a82$export$345c5736c8054f22; }, function (v) { return $136d2049cfd34a82$export$345c5736c8054f22 = v; });
$parcel$export($136d2049cfd34a82$exports, "avatarProfile", function () { return $136d2049cfd34a82$export$bcb17717ea143a4d; }, function (v) { return $136d2049cfd34a82$export$bcb17717ea143a4d = v; });
$parcel$export($136d2049cfd34a82$exports, "body", function () { return $136d2049cfd34a82$export$32180ef41b15b513; }, function (v) { return $136d2049cfd34a82$export$32180ef41b15b513 = v; });
$parcel$export($136d2049cfd34a82$exports, "button", function () { return $136d2049cfd34a82$export$2ba01fb71ed41cb6; }, function (v) { return $136d2049cfd34a82$export$2ba01fb71ed41cb6 = v; });
$parcel$export($136d2049cfd34a82$exports, "disconnect", function () { return $136d2049cfd34a82$export$37dfea93db2e14ed; }, function (v) { return $136d2049cfd34a82$export$37dfea93db2e14ed = v; });
$parcel$export($136d2049cfd34a82$exports, "head", function () { return $136d2049cfd34a82$export$5fd5031fecdacec3; }, function (v) { return $136d2049cfd34a82$export$5fd5031fecdacec3 = v; });
$parcel$export($136d2049cfd34a82$exports, "icon", function () { return $136d2049cfd34a82$export$1ca1ec8b29a4ce27; }, function (v) { return $136d2049cfd34a82$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($136d2049cfd34a82$exports, "item", function () { return $136d2049cfd34a82$export$7061c75fc5af8b7e; }, function (v) { return $136d2049cfd34a82$export$7061c75fc5af8b7e = v; });
$parcel$export($136d2049cfd34a82$exports, "name", function () { return $136d2049cfd34a82$export$a8ff84c12d48cfa6; }, function (v) { return $136d2049cfd34a82$export$a8ff84c12d48cfa6 = v; });
$parcel$export($136d2049cfd34a82$exports, "showUser", function () { return $136d2049cfd34a82$export$eab8f0ccdb89d626; }, function (v) { return $136d2049cfd34a82$export$eab8f0ccdb89d626 = v; });
$parcel$export($136d2049cfd34a82$exports, "text", function () { return $136d2049cfd34a82$export$6f093cfa640b7166; }, function (v) { return $136d2049cfd34a82$export$6f093cfa640b7166 = v; });
$parcel$export($136d2049cfd34a82$exports, "wrap", function () { return $136d2049cfd34a82$export$4997ffc0176396a6; }, function (v) { return $136d2049cfd34a82$export$4997ffc0176396a6 = v; });
var $136d2049cfd34a82$export$345c5736c8054f22;
var $136d2049cfd34a82$export$bcb17717ea143a4d;
var $136d2049cfd34a82$export$32180ef41b15b513;
var $136d2049cfd34a82$export$2ba01fb71ed41cb6;
var $136d2049cfd34a82$export$37dfea93db2e14ed;
var $136d2049cfd34a82$export$5fd5031fecdacec3;
var $136d2049cfd34a82$export$1ca1ec8b29a4ce27;
var $136d2049cfd34a82$export$7061c75fc5af8b7e;
var $136d2049cfd34a82$export$a8ff84c12d48cfa6;
var $136d2049cfd34a82$export$eab8f0ccdb89d626;
var $136d2049cfd34a82$export$6f093cfa640b7166;
var $136d2049cfd34a82$export$4997ffc0176396a6;
$136d2049cfd34a82$export$345c5736c8054f22 = `Cp24fq_avatar`;
$136d2049cfd34a82$export$bcb17717ea143a4d = `Cp24fq_avatarProfile`;
$136d2049cfd34a82$export$32180ef41b15b513 = `Cp24fq_body`;
$136d2049cfd34a82$export$2ba01fb71ed41cb6 = `Cp24fq_button`;
$136d2049cfd34a82$export$37dfea93db2e14ed = `Cp24fq_disconnect`;
$136d2049cfd34a82$export$5fd5031fecdacec3 = `Cp24fq_head`;
$136d2049cfd34a82$export$1ca1ec8b29a4ce27 = `Cp24fq_icon`;
$136d2049cfd34a82$export$7061c75fc5af8b7e = `Cp24fq_item`;
$136d2049cfd34a82$export$a8ff84c12d48cfa6 = `Cp24fq_name`;
$136d2049cfd34a82$export$eab8f0ccdb89d626 = `Cp24fq_showUser`;
$136d2049cfd34a82$export$eab8f0ccdb89d626;
$136d2049cfd34a82$export$6f093cfa640b7166 = `Cp24fq_text`;
$136d2049cfd34a82$export$4997ffc0176396a6 = `Cp24fq_wrap`;


var $e0a1893f069f0ea4$exports = {};
// eslint-disable-next-line import/no-unresolved

$e0a1893f069f0ea4$exports = (parcelRequire("jRRlM"));





var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $333acc8d68c0317b$exports = {};

$parcel$export($333acc8d68c0317b$exports, "active", function () { return $333acc8d68c0317b$export$89da14300d534261; }, function (v) { return $333acc8d68c0317b$export$89da14300d534261 = v; });
$parcel$export($333acc8d68c0317b$exports, "avatarContainer", function () { return $333acc8d68c0317b$export$4ea799498ef4a755; }, function (v) { return $333acc8d68c0317b$export$4ea799498ef4a755 = v; });
$parcel$export($333acc8d68c0317b$exports, "bc1", function () { return $333acc8d68c0317b$export$28a7e1cc2f61f274; }, function (v) { return $333acc8d68c0317b$export$28a7e1cc2f61f274 = v; });
$parcel$export($333acc8d68c0317b$exports, "bc2", function () { return $333acc8d68c0317b$export$24aea382614d10a6; }, function (v) { return $333acc8d68c0317b$export$24aea382614d10a6 = v; });
$parcel$export($333acc8d68c0317b$exports, "bc3", function () { return $333acc8d68c0317b$export$526c62562db9fbff; }, function (v) { return $333acc8d68c0317b$export$526c62562db9fbff = v; });
$parcel$export($333acc8d68c0317b$exports, "bc4", function () { return $333acc8d68c0317b$export$7fc3f88aaf4eab06; }, function (v) { return $333acc8d68c0317b$export$7fc3f88aaf4eab06 = v; });
$parcel$export($333acc8d68c0317b$exports, "bc5", function () { return $333acc8d68c0317b$export$6cb6f788ccb9541b; }, function (v) { return $333acc8d68c0317b$export$6cb6f788ccb9541b = v; });
$parcel$export($333acc8d68c0317b$exports, "photo", function () { return $333acc8d68c0317b$export$524e8e9a7451037d; }, function (v) { return $333acc8d68c0317b$export$524e8e9a7451037d = v; });
$parcel$export($333acc8d68c0317b$exports, "status", function () { return $333acc8d68c0317b$export$471f7ae5c4103ae1; }, function (v) { return $333acc8d68c0317b$export$471f7ae5c4103ae1 = v; });
var $333acc8d68c0317b$export$89da14300d534261;
var $333acc8d68c0317b$export$4ea799498ef4a755;
var $333acc8d68c0317b$export$28a7e1cc2f61f274;
var $333acc8d68c0317b$export$24aea382614d10a6;
var $333acc8d68c0317b$export$526c62562db9fbff;
var $333acc8d68c0317b$export$7fc3f88aaf4eab06;
var $333acc8d68c0317b$export$6cb6f788ccb9541b;
var $333acc8d68c0317b$export$524e8e9a7451037d;
var $333acc8d68c0317b$export$471f7ae5c4103ae1;
$333acc8d68c0317b$export$89da14300d534261 = `GPDP8W_active`;
$333acc8d68c0317b$export$4ea799498ef4a755 = `GPDP8W_avatarContainer`;
$333acc8d68c0317b$export$28a7e1cc2f61f274 = `GPDP8W_bc1`;
$333acc8d68c0317b$export$24aea382614d10a6 = `GPDP8W_bc2`;
$333acc8d68c0317b$export$526c62562db9fbff = `GPDP8W_bc3`;
$333acc8d68c0317b$export$7fc3f88aaf4eab06 = `GPDP8W_bc4`;
$333acc8d68c0317b$export$6cb6f788ccb9541b = `GPDP8W_bc5`;
$333acc8d68c0317b$export$524e8e9a7451037d = `GPDP8W_photo`;
$333acc8d68c0317b$export$471f7ae5c4103ae1 = `GPDP8W_status`;



var $6PPF0 = parcelRequire("6PPF0");
const $6d7bf74e72bae737$var$UserPhoto = ({ data: data, online: online, fallbackToMe: fallbackToMe = false, removeOnline: removeOnline })=>{
    const defaultPhoto = "/assets/User.png";
    const userContext = (0, $6cds3.useContext)((0, $260d68481938071c$export$38ee920e59704589));
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const [photoUrl, setPhotoUrl] = (0, $6cds3.useState)(defaultPhoto);
    function isDefault(url) {
        return !url || url == "User.png";
    }
    (0, $6cds3.useEffect)(()=>{
        function reloadAvatar(snappy) {
            userContext.userData.userPhoto = snappy.userPhoto;
            setPhotoUrl(snappy.userPhoto + "?v" + Date.now());
        }
        function doWork() {
            if (fallbackToMe) conquer.Signal.get("SNAPPY:onSet", reloadAvatar);
        }
        doWork();
        return ()=>conquer.Signal.remove("SNAPPY:onSet", reloadAvatar);
    }, [
        data
    ]);
    (0, $6cds3.useEffect)(function() {
        function doWork() {
            if (data && data.userPhoto && !isDefault(data.userPhoto)) return setPhotoUrl(data.userPhoto);
            if (!fallbackToMe) return setPhotoUrl(defaultPhoto);
            if (!userContext.userData || !userContext.userData.isLogged) return setPhotoUrl(defaultPhoto);
            if (isDefault(userContext.userData.userPhoto)) return setPhotoUrl(defaultPhoto);
            setPhotoUrl(userContext.userData.userPhoto);
        }
        doWork();
    }, [
        userContext.userData.userPhoto,
        userContext.userData.isLogged,
        data
    ]);
    function getRandomColor() {
        if (!conquer.User) return (0, (/*@__PURE__*/$parcel$interopDefault($333acc8d68c0317b$exports))).bc2;
        let ownID = conquer.User.avatarID;
        if (data && data.avatarID == ownID || !data && fallbackToMe) return (0, (/*@__PURE__*/$parcel$interopDefault($333acc8d68c0317b$exports))).bc1;
        return (0, (/*@__PURE__*/$parcel$interopDefault($333acc8d68c0317b$exports))).bc2;
    }
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($333acc8d68c0317b$exports))).avatarContainer,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("img", {
                src: photoUrl,
                alt: "UserAvatar",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($333acc8d68c0317b$exports))).photo, getRandomColor())
            }),
            !removeOnline && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($333acc8d68c0317b$exports))).status, (0, (/*@__PURE__*/$parcel$interopDefault($333acc8d68c0317b$exports))).active)
            })
        ]
    });
};
var $6d7bf74e72bae737$export$2e2bcd8739ae039 = $6d7bf74e72bae737$var$UserPhoto;


const $cca70c7ab7f90262$var$ProfileNav = ()=>{
    const [isVisible, setIsVisible] = (0, $6cds3.useState)(false);
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const userContext = (0, $6cds3.useContext)((0, $260d68481938071c$export$38ee920e59704589));
    const name = userContext.userData ? userContext.userData.firstName : "";
    function show() {
        setIsVisible(true);
    }
    function close() {
        setIsVisible(false);
    }
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $60fd0126d8b57f34$export$a6c7ac8248d6e38a), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($136d2049cfd34a82$exports))).avatarProfile,
            to: "/profile",
            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6d7bf74e72bae737$export$2e2bcd8739ae039), {
                fallbackToMe: true
            })
        })
    });
};
var $cca70c7ab7f90262$export$2e2bcd8739ae039 = $cca70c7ab7f90262$var$ProfileNav;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $9nHRL = parcelRequire("9nHRL");



var $6PPF0 = parcelRequire("6PPF0");
var $20662242a4b44feb$exports = {};

$parcel$export($20662242a4b44feb$exports, "close", function () { return $20662242a4b44feb$export$8360e631d277ea4d; }, function (v) { return $20662242a4b44feb$export$8360e631d277ea4d = v; });
$parcel$export($20662242a4b44feb$exports, "modal", function () { return $20662242a4b44feb$export$96e4b36520c26a2c; }, function (v) { return $20662242a4b44feb$export$96e4b36520c26a2c = v; });
$parcel$export($20662242a4b44feb$exports, "outer", function () { return $20662242a4b44feb$export$e4f60e4df8811b1; }, function (v) { return $20662242a4b44feb$export$e4f60e4df8811b1 = v; });
$parcel$export($20662242a4b44feb$exports, "showModal", function () { return $20662242a4b44feb$export$d7e8d4d4450c819c; }, function (v) { return $20662242a4b44feb$export$d7e8d4d4450c819c = v; });
$parcel$export($20662242a4b44feb$exports, "title", function () { return $20662242a4b44feb$export$fb184b623420d9be; }, function (v) { return $20662242a4b44feb$export$fb184b623420d9be = v; });
var $20662242a4b44feb$export$8360e631d277ea4d;
var $20662242a4b44feb$export$96e4b36520c26a2c;
var $20662242a4b44feb$export$e4f60e4df8811b1;
var $20662242a4b44feb$export$d7e8d4d4450c819c;
var $20662242a4b44feb$export$fb184b623420d9be;
$20662242a4b44feb$export$8360e631d277ea4d = `eU6vdq_close`;
$20662242a4b44feb$export$96e4b36520c26a2c = `eU6vdq_modal`;
$20662242a4b44feb$export$e4f60e4df8811b1 = `eU6vdq_outer`;
$20662242a4b44feb$export$d7e8d4d4450c819c = `eU6vdq_showModal`;
$20662242a4b44feb$export$d7e8d4d4450c819c;
$20662242a4b44feb$export$fb184b623420d9be = `eU6vdq_title`;



const $96f09411dda7faae$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $6cds3.createContext)();
const $96f09411dda7faae$var$Modal = ({ outerClassName: outerClassName, containerClassName: containerClassName, visible: visible, onClose: onClose, title: title, children: children })=>{
    const escFunction = (0, $6cds3.useCallback)((e)=>{
        if (e.keyCode === 27) onClose();
    }, [
        onClose
    ]);
    (0, $6cds3.useEffect)(()=>{
        document.addEventListener("keydown", escFunction, false);
        return ()=>{
            document.removeEventListener("keydown", escFunction, false);
        };
    }, [
        escFunction
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (visible) {
            const target = document.querySelector("#modal");
            (0, $3b4e05b540ea4d30$export$24fdf68abf432c44)(target);
        } else (0, $3b4e05b540ea4d30$export$45a3ef215b2a5866)();
    }, [
        visible
    ]);
    return /*#__PURE__*/ (0, $9nHRL.createPortal)(visible && /*#__PURE__*/ (0, $lBpE3.jsx)($96f09411dda7faae$export$ab57792b9b6974a6.Provider, {
        value: {
            close: onClose
        },
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($20662242a4b44feb$exports))).modal,
            id: "modal",
            children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($20662242a4b44feb$exports))).outer, outerClassName),
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e0a1893f069f0ea4$exports))), {
                    onOutsideClick: onClose,
                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($20662242a4b44feb$exports))).container, containerClassName),
                        children: [
                            title && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($20662242a4b44feb$exports))).title,
                                children: title
                            }),
                            children,
                            /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($20662242a4b44feb$exports))).close,
                                onClick: onClose,
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $2c63ec6d3d1d0cb4$export$2e2bcd8739ae039), {
                                    name: "close",
                                    size: "14"
                                })
                            })
                        ]
                    })
                })
            })
        })
    }), document.body);
};
var $96f09411dda7faae$export$2e2bcd8739ae039 = $96f09411dda7faae$var$Modal;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
var $fe8f9b867cd341d9$exports = {};

$parcel$export($fe8f9b867cd341d9$exports, "form__btn", function () { return $fe8f9b867cd341d9$export$a6f3909a03205f52; }, function (v) { return $fe8f9b867cd341d9$export$a6f3909a03205f52 = v; });
$parcel$export($fe8f9b867cd341d9$exports, "form__column", function () { return $fe8f9b867cd341d9$export$6996f2dd902f5924; }, function (v) { return $fe8f9b867cd341d9$export$6996f2dd902f5924 = v; });
$parcel$export($fe8f9b867cd341d9$exports, "form__inputbox", function () { return $fe8f9b867cd341d9$export$a91ef574b9f2b9e; }, function (v) { return $fe8f9b867cd341d9$export$a91ef574b9f2b9e = v; });
$parcel$export($fe8f9b867cd341d9$exports, "form__inputsass", function () { return $fe8f9b867cd341d9$export$2f380af1639e5b8; }, function (v) { return $fe8f9b867cd341d9$export$2f380af1639e5b8 = v; });
$parcel$export($fe8f9b867cd341d9$exports, "form__title", function () { return $fe8f9b867cd341d9$export$a90c3fc2db73d8e2; }, function (v) { return $fe8f9b867cd341d9$export$a90c3fc2db73d8e2 = v; });
var $fe8f9b867cd341d9$export$a6f3909a03205f52;
var $fe8f9b867cd341d9$export$6996f2dd902f5924;
var $fe8f9b867cd341d9$export$a91ef574b9f2b9e;
var $fe8f9b867cd341d9$export$2f380af1639e5b8;
var $fe8f9b867cd341d9$export$a90c3fc2db73d8e2;
$fe8f9b867cd341d9$export$a6f3909a03205f52 = `d0JoWa_form__btn`;
$fe8f9b867cd341d9$export$6996f2dd902f5924 = `d0JoWa_form__column`;
$fe8f9b867cd341d9$export$a91ef574b9f2b9e = `d0JoWa_form__inputbox`;
$fe8f9b867cd341d9$export$2f380af1639e5b8 = `d0JoWa_form__inputsass`;
$fe8f9b867cd341d9$export$a90c3fc2db73d8e2 = `d0JoWa_form__title`;



var $6PPF0 = parcelRequire("6PPF0");

var $1SOLG = parcelRequire("1SOLG");

var $lBpE3 = parcelRequire("lBpE3");
"use client";
var $9ca0d9c999d982ad$export$2e2bcd8739ae039 = (0, $1SOLG.default)(/*#__PURE__*/ (0, $lBpE3.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
}), "Visibility");


var $1SOLG = parcelRequire("1SOLG");

var $lBpE3 = parcelRequire("lBpE3");
"use client";
var $0dcbea00ae5defbb$export$2e2bcd8739ae039 = (0, $1SOLG.default)(/*#__PURE__*/ (0, $lBpE3.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
}), "VisibilityOff");





var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $6PPF0 = parcelRequire("6PPF0");
var $a22ef391fabf22b1$exports = {};

$parcel$export($a22ef391fabf22b1$exports, "loader", function () { return $a22ef391fabf22b1$export$f4c5de44377d2946; }, function (v) { return $a22ef391fabf22b1$export$f4c5de44377d2946 = v; });
var $a22ef391fabf22b1$export$f4c5de44377d2946;
$a22ef391fabf22b1$export$f4c5de44377d2946 = `_15hWIq_loader`;
$a22ef391fabf22b1$export$f4c5de44377d2946;


const $a22e9bdfa443b231$var$Loader = ({ className: className })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($a22ef391fabf22b1$exports))).loader, className)
    });
};
var $a22e9bdfa443b231$export$2e2bcd8739ae039 = $a22e9bdfa443b231$var$Loader;


const $2de52fc6bfbeb856$var$LoginForm = ({ requestZoneChange: requestZoneChange, onFinishCallback: onFinishCallback })=>{
    const [showPassword, setShowPassword] = (0, $6cds3.useState)(false);
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const [username, setUsername] = (0, $6cds3.useState)("");
    const [password, setPassword] = (0, $6cds3.useState)("");
    const [error, setError] = (0, $6cds3.useState)("");
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(false);
    function showError(message) {
        setError(message);
        return false;
    }
    function checkFields() {
        if (!username || checkUsername(username)) return showError("You have to provide a valid username");
        if (!password || password.length < 8 || password.length > 16) return showError("You need to provide a valid password. Min 8 chars and max 16 chars");
        setError("");
        return true;
    }
    function checkUsername(text) {
        const chars = "/@#$%^& ";
        for(var z = 0; z < chars.length; z++)if (text.includes(chars.charAt(z))) return true;
        return false;
    }
    async function tryToLogin() {
        if (!checkFields()) return false;
        setIsLoading(true);
        let response = await conquer.Auth.get({
            username: username,
            password: password,
            type: "USERNAME"
        });
        setIsLoading(false);
        if (response.error) return showError(response.error);
        if (!response.username) return showError("There was an error when trying to log you in. Please try again.");
        onFinishCallback === null || onFinishCallback === void 0 ? void 0 : onFinishCallback();
    }
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "form",
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fe8f9b867cd341d9$exports))).form__column,
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: "fields_container",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("input", {
                            type: "text",
                            placeholder: "Username",
                            className: error && !isLoading ? "error" : "",
                            onChange: (event)=>{
                                setUsername(event.target.value);
                            }
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: "input_container",
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("input", {
                                    type: showPassword ? "text" : "password",
                                    placeholder: "Password",
                                    className: error && !isLoading ? "error" : "",
                                    onChange: (event)=>{
                                        setPassword(event.target.value);
                                    }
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                    onClick: ()=>{
                                        setShowPassword(!showPassword);
                                    },
                                    className: "input_icon",
                                    children: showPassword ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9ca0d9c999d982ad$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0dcbea00ae5defbb$export$2e2bcd8739ae039), {})
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "form_bottom",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                        onClick: ()=>{
                            requestZoneChange((0, $157bd6031ad0a800$export$1922d33c059dfdaf).PASSWORD_RESET);
                        },
                        className: "helperLink",
                        children: " Forgot your password? "
                    })
                }),
                isLoading ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a22e9bdfa443b231$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: "btn_container",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))("button", "secondary"),
                            onClick: ()=>{
                                requestZoneChange((0, $157bd6031ad0a800$export$1922d33c059dfdaf).REGISTER);
                            },
                            children: "Register"
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))("button", "primary"),
                            onClick: tryToLogin,
                            children: "Login"
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                    className: "error",
                    children: error
                })
            ]
        })
    });
};
var $2de52fc6bfbeb856$export$2e2bcd8739ae039 = $2de52fc6bfbeb856$var$LoginForm;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $6PPF0 = parcelRequire("6PPF0");






var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $b08dbf239f81ed02$exports = {};

$parcel$export($b08dbf239f81ed02$exports, "form__input", function () { return $b08dbf239f81ed02$export$f85d11b4d16815f5; }, function (v) { return $b08dbf239f81ed02$export$f85d11b4d16815f5 = v; });
$parcel$export($b08dbf239f81ed02$exports, "input_container", function () { return $b08dbf239f81ed02$export$d1e5aa525afca4fb; }, function (v) { return $b08dbf239f81ed02$export$d1e5aa525afca4fb = v; });
var $b08dbf239f81ed02$export$f85d11b4d16815f5;
var $b08dbf239f81ed02$export$d1e5aa525afca4fb;
$b08dbf239f81ed02$export$f85d11b4d16815f5 = `nWpbsa_form__input`;
$b08dbf239f81ed02$export$d1e5aa525afca4fb = `nWpbsa_input_container`;


const $32b7d5bdd50967eb$var$PasswordInput = ({ onValueChange: onValueChange, placeholder: placeholder, error: error, value: value })=>{
    const [showContent, setShowContent] = (0, $6cds3.useState)(false);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($b08dbf239f81ed02$exports))).input_container,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("input", {
                type: showContent ? "text" : "password",
                placeholder: placeholder,
                className: error && "error",
                onChange: (event)=>{
                    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(event.target.value);
                },
                value: value
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                onClick: ()=>{
                    setShowContent(!showContent);
                },
                className: "input_icon",
                children: showContent ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9ca0d9c999d982ad$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0dcbea00ae5defbb$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $32b7d5bdd50967eb$export$2e2bcd8739ae039 = $32b7d5bdd50967eb$var$PasswordInput;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
var $e247272890c27030$export$34e0f9847d4c02dd;
$e247272890c27030$export$34e0f9847d4c02dd = `_7D3wJq_container`;


const $e52cf04dcb47bab5$var$CheckInput = ({ title: title, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: "helperLink center",
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("label", {
                children: title
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("input", {
                type: "checkbox",
                onChange: (event)=>{
                    onChange === null || onChange === void 0 ? void 0 : onChange(event.target.checked);
                }
            })
        ]
    });
};
var $e52cf04dcb47bab5$export$2e2bcd8739ae039 = $e52cf04dcb47bab5$var$CheckInput;


const $01008aef088378a0$var$FORM_STEP = {
    FIRST: 0,
    LAST: 1
};
const $01008aef088378a0$var$RegisterForm = ({ onFinishCallback: onFinishCallback })=>{
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const userContext = (0, $6cds3.useContext)((0, $260d68481938071c$export$38ee920e59704589));
    const [formStep, setFormStep] = (0, $6cds3.useState)($01008aef088378a0$var$FORM_STEP.FIRST);
    const [email, setEmail] = (0, $6cds3.useState)("");
    const [password, setPassword] = (0, $6cds3.useState)("");
    const [repeatPassword, setRepeatPassword] = (0, $6cds3.useState)("");
    const [username, setUsername] = (0, $6cds3.useState)("");
    const [firstName, setFirstName] = (0, $6cds3.useState)("");
    const [lastName, setLastName] = (0, $6cds3.useState)("");
    const [privacyCheck, setPrivacyCheck] = (0, $6cds3.useState)(false);
    const [ageCheck, setAgeCheck] = (0, $6cds3.useState)(false);
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(false);
    const [error, setError] = (0, $6cds3.useState)("");
    function showError(message) {
        if (typeof message !== "string") message = "There was an error when executing the register. Please try again.";
        setError(message);
        return false;
    }
    function checkFields() {
        if (!ageCheck) return showError("You need to be more than 13 years old to register in Supersnappy");
        if (!privacyCheck) return showError("You need to accept our Privacy Policy");
        if (!/\S+@\S+\.\S+/.test(email)) return showError("The email doesnt have a valid format");
        if (!username || validUsername(username)) return showError("You need to provide a valid username");
        if (!firstName) return showError("You need to provide a valid firstName");
        if (!lastName) return showError("You need to provide a valid lastName");
        if (!password || password.length < 8 || password.length > 16) return showError("You need to provide a valid password. Min 8 chars and max 16 chars");
        if (password != repeatPassword) return showError("The password doesnt match");
        setError("");
        return true;
    }
    function validUsername(text) {
        const chars = "/@#$%^& ";
        for(var z = 0; z < chars.length; z++)if (text.includes(chars.charAt(z))) return true;
        return false;
    }
    async function checkUsername() {
        setIsLoading(true);
        let response = await conquer.Username.getOne(username);
        setIsLoading(false);
        return !response || !response.username;
    }
    async function tryToRegister() {
        if (!checkFields()) return false;
        if (!await checkUsername()) return showError("The username already exists");
        setIsLoading(true);
        let response = await conquer.Auth.set({
            username: username,
            password: password,
            email: email,
            firstName: firstName,
            lastName: lastName
        });
        setIsLoading(false);
        if (response.error) return showError(response.error);
        if (!response.token) return showError("There was an error when executing the register. Please try again.");
        onFinishCallback === null || onFinishCallback === void 0 ? void 0 : onFinishCallback();
    }
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "form",
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fe8f9b867cd341d9$exports))).form__column,
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: "fields_container",
                    children: [
                        //STEP 1 ===
                        formStep == $01008aef088378a0$var$FORM_STEP.FIRST && /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("input", {
                                    type: "email",
                                    placeholder: "Email",
                                    className: error && !isLoading ? "error" : "",
                                    onChange: (event)=>{
                                        setEmail(event.target.value);
                                    },
                                    value: email
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)((0, $32b7d5bdd50967eb$export$2e2bcd8739ae039), {
                                    onValueChange: (value)=>{
                                        setPassword(value);
                                    },
                                    placeholder: "Password",
                                    value: password,
                                    error: error && !isLoading
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)((0, $32b7d5bdd50967eb$export$2e2bcd8739ae039), {
                                    onValueChange: (value)=>{
                                        setRepeatPassword(value);
                                    },
                                    placeholder: "Repeat Password",
                                    value: repeatPassword,
                                    error: error && !isLoading
                                })
                            ]
                        }),
                        //STEP 2 ===
                        formStep == $01008aef088378a0$var$FORM_STEP.LAST && /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("input", {
                                    type: "text",
                                    placeholder: "Username",
                                    className: error && !isLoading ? "error" : "",
                                    onChange: (event)=>{
                                        setUsername(event.target.value);
                                    },
                                    value: username
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("input", {
                                    type: "text",
                                    placeholder: "Firstname",
                                    className: error && !isLoading ? "error" : "",
                                    onChange: (event)=>{
                                        setFirstName(event.target.value);
                                    },
                                    value: firstName
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("input", {
                                    type: "text",
                                    placeholder: "Lastname",
                                    className: error && !isLoading ? "error" : "",
                                    onChange: (event)=>{
                                        setLastName(event.target.value);
                                    },
                                    value: lastName
                                })
                            ]
                        })
                    ]
                }),
                formStep == $01008aef088378a0$var$FORM_STEP.LAST && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: "form_bottom",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)((0, $e52cf04dcb47bab5$export$2e2bcd8739ae039), {
                            title: "I accept the Privacy Policy",
                            onChange: (isChecked)=>{
                                setPrivacyCheck(isChecked);
                            }
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)((0, $e52cf04dcb47bab5$export$2e2bcd8739ae039), {
                            title: "I am 13 years old or older",
                            onChange: (isChecked)=>{
                                setAgeCheck(isChecked);
                            }
                        })
                    ]
                }),
                isLoading ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a22e9bdfa443b231$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "btn_container",
                    children: formStep == $01008aef088378a0$var$FORM_STEP.FIRST ? /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                        name: "Next",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))("button", "primary"),
                        onClick: ()=>{
                            setFormStep($01008aef088378a0$var$FORM_STEP.LAST);
                        },
                        children: "Next"
                    }) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                name: "Back",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))("button", "secondary"),
                                onClick: ()=>{
                                    setFormStep($01008aef088378a0$var$FORM_STEP.FIRST);
                                },
                                children: "Back"
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))("button", "primary"),
                                onClick: tryToRegister,
                                children: "Register"
                            })
                        ]
                    })
                }),
                error && /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                    className: "error",
                    children: error
                })
            ]
        })
    });
};
var $01008aef088378a0$export$2e2bcd8739ae039 = $01008aef088378a0$var$RegisterForm;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $6PPF0 = parcelRequire("6PPF0");




const $b87228da460983d8$var$EmailVerificationForm = ({ onFinishCallback: onFinishCallback, email: email })=>{
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const userContext = (0, $6cds3.useContext)((0, $260d68481938071c$export$38ee920e59704589));
    const [verificationCode, setVerificationCode] = (0, $6cds3.useState)("");
    const [error, setError] = (0, $6cds3.useState)("");
    const [sendTimer, setSendTimer] = (0, $6cds3.useState)(0);
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(false);
    function showError(message) {
        setError(message);
        return false;
    }
    async function tryToSendVerificationCode() {
        if (sendTimer != 0) return showError("Please wait a bit to send a new code.");
        if (!userContext.userData || !userContext.userData.username) return showError("There was an error when getting your email. Please reload the page");
        setSendTimer(10);
        setIsLoading(true);
        let response = await conquer.Auth.resend({
            username: email || userContext.userData.username
        });
        setIsLoading(false);
    }
    async function tryToVerify() {
        setError("");
        if (!userContext.userData || !userContext.userData.username) return showError("There was an error when getting your email. Please reload the page");
        if (!verificationCode || verificationCode.length != 4) return showError("You have to provide a valid verification code.");
        setIsLoading(true);
        let response = await conquer.Auth.verify({
            username: email || userContext.userData.username,
            code: verificationCode
        });
        setIsLoading(false);
        if (response.error) return showError(response.error);
        onFinishCallback === null || onFinishCallback === void 0 ? void 0 : onFinishCallback();
    }
    function tryToLogout() {
        conquer.Auth.logout();
    }
    function updateSendTimer() {
        let newTime = sendTimer - 1;
        if (newTime < 0) newTime = 0;
        setSendTimer(newTime);
    }
    (0, $6cds3.useEffect)(()=>{
        let interval;
        if (sendTimer > 0) interval = setInterval(updateSendTimer, 1000);
        return ()=>{
            if (interval) clearInterval(interval);
        };
    }, [
        sendTimer
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "form",
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fe8f9b867cd341d9$exports))).form__column,
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "fields_container",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("input", {
                        type: "text",
                        placeholder: "Code",
                        className: error && !isLoading ? "error" : "",
                        max: "4",
                        min: "4",
                        onChange: (event)=>{
                            setVerificationCode(event.target.value);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "form_bottom",
                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)("button", {
                        onClick: tryToSendVerificationCode,
                        className: "helperLink",
                        children: [
                            "Send Again ",
                            sendTimer > 0 && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                children: [
                                    "(",
                                    sendTimer,
                                    "s)"
                                ]
                            })
                        ]
                    })
                }),
                isLoading ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a22e9bdfa443b231$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: "btn_container",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))("button", "secondary"),
                            onClick: tryToLogout,
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))("button", "primary"),
                            onClick: tryToVerify,
                            children: "Verify"
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                    className: "error",
                    style: {
                        textAlign: "left"
                    },
                    children: error
                })
            ]
        })
    });
};
var $b87228da460983d8$export$2e2bcd8739ae039 = $b87228da460983d8$var$EmailVerificationForm;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $6PPF0 = parcelRequire("6PPF0");





const $ff076cc56efa415f$var$PasswordRecoverForm = ({ onFinishCallback: onFinishCallback, customEmail: customEmail })=>{
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const [waitingForCode, setWaitingForCode] = (0, $6cds3.useState)(customEmail ? true : false);
    //First Step
    const [email, setEmail] = (0, $6cds3.useState)("");
    //Second Step
    const [verificationCode, setVerificationCode] = (0, $6cds3.useState)("");
    const [password, setPassword] = (0, $6cds3.useState)("");
    const [repeatPassword, setRepeatPassword] = (0, $6cds3.useState)("");
    const [error, setError] = (0, $6cds3.useState)("");
    const [sendTimer, setSendTimer] = (0, $6cds3.useState)(0);
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(false);
    //Swap logic:
    const buttonCallback = waitingForCode ? tryToChangePassword : tryToRequestPasswordReset;
    const buttonText = waitingForCode ? "Change Password" : "Send Email";
    function showError(message) {
        setError(message);
        return false;
    }
    async function tryToRequestPasswordReset() {
        if (!/\S+@\S+\.\S+/.test(customEmail || email)) return showError("The email doesnt have a valid format");
        setError("");
        setIsLoading(true);
        let response = await conquer.Auth.sendResetPassword({
            email: customEmail || email
        });
        setIsLoading(false);
        if (response.error) return showError(response.error);
        setError("");
        setWaitingForCode(true);
    }
    async function tryToSendVerificationCode() {
        if (sendTimer != 0) return showError("Please wait a bit to send a new code.");
        setSendTimer(10);
        setError("");
        setIsLoading(true);
        let response = await conquer.Auth.resendResetKey({
            email: customEmail || email
        });
        setIsLoading(false);
        if (response.error) return showError(response.error);
    }
    async function tryToChangePassword() {
        if (!verificationCode || verificationCode.length != 4) return showError("You have to provide a valid verification code.");
        if (!password || password.length < 8 || password.length > 16) return showError("You need to provide a valid password. Min 8 chars and max 16 chars");
        if (password != repeatPassword) return showError("The password doesnt match");
        setError("");
        setIsLoading(true);
        let response = await conquer.Auth.changePassword({
            email: customEmail || email,
            password: password,
            resetKey: verificationCode
        });
        console.log(response);
        setIsLoading(false);
        if (response.error) return showError(response.error);
        onFinishCallback();
    }
    function updateSendTimer() {
        let newTime = sendTimer - 1;
        if (newTime < 0) newTime = 0;
        setSendTimer(newTime);
    }
    (0, $6cds3.useEffect)(()=>{
        let interval;
        if (sendTimer > 0) interval = setInterval(updateSendTimer, 1000);
        return ()=>{
            if (interval) clearInterval(interval);
        };
    }, [
        sendTimer
    ]);
    (0, $6cds3.useEffect)(()=>{
        async function logic() {
            if (!customEmail) return;
            await tryToRequestPasswordReset();
            await tryToSendVerificationCode();
        }
        logic();
    }, [
        conquer.initialized
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: "form",
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fe8f9b867cd341d9$exports))).form__column,
            children: [
                !waitingForCode ? /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: "fields_container",
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("input", {
                        type: "email",
                        placeholder: "Email",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($fe8f9b867cd341d9$exports))).form__input,
                        value: email,
                        onChange: (event)=>{
                            setEmail(event.target.value);
                        }
                    })
                }) : /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: "fields_container",
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("input", {
                            type: "text",
                            placeholder: "Code",
                            className: error && !isLoading ? "error" : "",
                            max: "4",
                            min: "4",
                            value: verificationCode,
                            onChange: (event)=>{
                                setVerificationCode(event.target.value);
                            }
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)((0, $32b7d5bdd50967eb$export$2e2bcd8739ae039), {
                            placeholder: "Password",
                            onValueChange: (value)=>{
                                setPassword(value);
                            },
                            error: error && !isLoading
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)((0, $32b7d5bdd50967eb$export$2e2bcd8739ae039), {
                            placeholder: "Repeat Password",
                            onValueChange: (value)=>{
                                setRepeatPassword(value);
                            },
                            error: error && !isLoading
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($fe8f9b867cd341d9$exports))).form_bottom,
                            children: /*#__PURE__*/ (0, $lBpE3.jsxs)("button", {
                                className: "helperLink",
                                onClick: tryToSendVerificationCode,
                                children: [
                                    "Send Again ",
                                    sendTimer > 0 && /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                                        children: [
                                            "(",
                                            sendTimer,
                                            "s)"
                                        ]
                                    }),
                                    " "
                                ]
                            })
                        })
                    ]
                }),
                isLoading ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a22e9bdfa443b231$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($fe8f9b867cd341d9$exports))).form__btn,
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))("button", "primary"),
                        onClick: buttonCallback,
                        children: buttonText
                    })
                }),
                error && /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                    className: "error",
                    children: error
                })
            ]
        })
    });
};
var $ff076cc56efa415f$export$2e2bcd8739ae039 = $ff076cc56efa415f$var$PasswordRecoverForm;


const $157bd6031ad0a800$export$1922d33c059dfdaf = {
    LOGIN: 0,
    REGISTER: 1,
    EMAIL_VERIFICATION: 2,
    PASSWORD_RESET: 3
};
const $157bd6031ad0a800$var$AuthForms = ({ onFinishCallback: onFinishCallback, onAuthZoneChanged: onAuthZoneChanged })=>{
    const [zone, setZone] = (0, $6cds3.useState)($157bd6031ad0a800$export$1922d33c059dfdaf.LOGIN);
    function changeZone(newZone) {
        onAuthZoneChanged === null || onAuthZoneChanged === void 0 ? void 0 : onAuthZoneChanged(newZone);
        setZone(newZone);
    }
    function getFooterNav() {
        switch(zone){
            case $157bd6031ad0a800$export$1922d33c059dfdaf.PASSWORD_RESET:
            case $157bd6031ad0a800$export$1922d33c059dfdaf.REGISTER:
                return /*#__PURE__*/ (0, $lBpE3.jsxs)("button", {
                    onClick: ()=>{
                        changeZone($157bd6031ad0a800$export$1922d33c059dfdaf.LOGIN);
                    },
                    className: "helperLink left",
                    children: [
                        "Go back to ",
                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            children: "Login"
                        })
                    ]
                });
            case $157bd6031ad0a800$export$1922d33c059dfdaf.EMAIL_VERIFICATION:
                return /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                    onClick: onFinishCallback,
                    className: "helperLink left",
                    children: "I'll do it later"
                });
            default:
                return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {});
        }
    }
    function getZoneWidget() {
        switch(zone){
            case $157bd6031ad0a800$export$1922d33c059dfdaf.REGISTER:
                return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $01008aef088378a0$export$2e2bcd8739ae039), {
                    onFinishCallback: onFinishCallback
                });
            case $157bd6031ad0a800$export$1922d33c059dfdaf.EMAIL_VERIFICATION:
                return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $b87228da460983d8$export$2e2bcd8739ae039), {
                    onFinishCallback: onFinishCallback
                });
            case $157bd6031ad0a800$export$1922d33c059dfdaf.PASSWORD_RESET:
                return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ff076cc56efa415f$export$2e2bcd8739ae039), {
                    onFinishCallback: onFinishCallback
                });
            default:
            case $157bd6031ad0a800$export$1922d33c059dfdaf.LOGIN:
                return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $2de52fc6bfbeb856$export$2e2bcd8739ae039), {
                    onFinishCallback: onFinishCallback,
                    requestZoneChange: changeZone
                });
        }
    }
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            getZoneWidget(),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "forms_footer",
                children: getFooterNav()
            })
        ]
    });
};
var $157bd6031ad0a800$export$2e2bcd8739ae039 = $157bd6031ad0a800$var$AuthForms;


var $67ff106c779a79a0$exports = {};

$parcel$export($67ff106c779a79a0$exports, "actioner", function () { return $67ff106c779a79a0$export$697b04f9ac1ab86a; }, function (v) { return $67ff106c779a79a0$export$697b04f9ac1ab86a = v; });
$parcel$export($67ff106c779a79a0$exports, "avatar", function () { return $67ff106c779a79a0$export$345c5736c8054f22; }, function (v) { return $67ff106c779a79a0$export$345c5736c8054f22 = v; });
$parcel$export($67ff106c779a79a0$exports, "button", function () { return $67ff106c779a79a0$export$2ba01fb71ed41cb6; }, function (v) { return $67ff106c779a79a0$export$2ba01fb71ed41cb6 = v; });
$parcel$export($67ff106c779a79a0$exports, "head", function () { return $67ff106c779a79a0$export$5fd5031fecdacec3; }, function (v) { return $67ff106c779a79a0$export$5fd5031fecdacec3 = v; });
$parcel$export($67ff106c779a79a0$exports, "modal_container", function () { return $67ff106c779a79a0$export$b0e0fdbd3d5b5a34; }, function (v) { return $67ff106c779a79a0$export$b0e0fdbd3d5b5a34 = v; });
var $67ff106c779a79a0$export$697b04f9ac1ab86a;
var $67ff106c779a79a0$export$345c5736c8054f22;
var $67ff106c779a79a0$export$2ba01fb71ed41cb6;
var $67ff106c779a79a0$export$5fd5031fecdacec3;
var $67ff106c779a79a0$export$b0e0fdbd3d5b5a34;
$67ff106c779a79a0$export$697b04f9ac1ab86a = `RpvUgW_actioner`;
$67ff106c779a79a0$export$345c5736c8054f22 = `RpvUgW_avatar`;
$67ff106c779a79a0$export$2ba01fb71ed41cb6 = `RpvUgW_button`;
$67ff106c779a79a0$export$5fd5031fecdacec3 = `RpvUgW_head`;
$67ff106c779a79a0$export$b0e0fdbd3d5b5a34 = `RpvUgW_modal_container`;


parcelRequire("6PPF0");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
parcelRequire("9nHRL");
parcelRequire("6PPF0");
var $c68fd3036e8d8267$exports = {};

$parcel$export($c68fd3036e8d8267$exports, "close", function () { return $c68fd3036e8d8267$export$8360e631d277ea4d; }, function (v) { return $c68fd3036e8d8267$export$8360e631d277ea4d = v; });
$parcel$export($c68fd3036e8d8267$exports, "modal", function () { return $c68fd3036e8d8267$export$96e4b36520c26a2c; }, function (v) { return $c68fd3036e8d8267$export$96e4b36520c26a2c = v; });
$parcel$export($c68fd3036e8d8267$exports, "modal_content", function () { return $c68fd3036e8d8267$export$bd6171bed1545a03; }, function (v) { return $c68fd3036e8d8267$export$bd6171bed1545a03 = v; });
$parcel$export($c68fd3036e8d8267$exports, "modal_header", function () { return $c68fd3036e8d8267$export$a9094b00d8cc2958; }, function (v) { return $c68fd3036e8d8267$export$a9094b00d8cc2958 = v; });
$parcel$export($c68fd3036e8d8267$exports, "outer", function () { return $c68fd3036e8d8267$export$e4f60e4df8811b1; }, function (v) { return $c68fd3036e8d8267$export$e4f60e4df8811b1 = v; });
$parcel$export($c68fd3036e8d8267$exports, "showModal", function () { return $c68fd3036e8d8267$export$d7e8d4d4450c819c; }, function (v) { return $c68fd3036e8d8267$export$d7e8d4d4450c819c = v; });
$parcel$export($c68fd3036e8d8267$exports, "title", function () { return $c68fd3036e8d8267$export$fb184b623420d9be; }, function (v) { return $c68fd3036e8d8267$export$fb184b623420d9be = v; });
var $c68fd3036e8d8267$export$8360e631d277ea4d;
var $c68fd3036e8d8267$export$96e4b36520c26a2c;
var $c68fd3036e8d8267$export$bd6171bed1545a03;
var $c68fd3036e8d8267$export$a9094b00d8cc2958;
var $c68fd3036e8d8267$export$e4f60e4df8811b1;
var $c68fd3036e8d8267$export$d7e8d4d4450c819c;
var $c68fd3036e8d8267$export$fb184b623420d9be;
$c68fd3036e8d8267$export$8360e631d277ea4d = `_5wKvpa_close`;
$c68fd3036e8d8267$export$96e4b36520c26a2c = `_5wKvpa_modal`;
$c68fd3036e8d8267$export$bd6171bed1545a03 = `_5wKvpa_modal_content`;
$c68fd3036e8d8267$export$a9094b00d8cc2958 = `_5wKvpa_modal_header`;
$c68fd3036e8d8267$export$e4f60e4df8811b1 = `_5wKvpa_outer`;
$c68fd3036e8d8267$export$d7e8d4d4450c819c = `_5wKvpa_showModal`;
$c68fd3036e8d8267$export$d7e8d4d4450c819c;
$c68fd3036e8d8267$export$fb184b623420d9be = `_5wKvpa_title`;






const $fbd77a4ebafd8162$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $6cds3.createContext)();
const $fbd77a4ebafd8162$var$ModalContextProvider = ({ children: children })=>{
    const [data, setData] = (0, $6cds3.useState)();
    const dataRef = (0, $6cds3.useRef)();
    dataRef.current = data;
    const show = function({ title: title, content: content, closeButton: closeButton = true, closeOutside: closeOutside = true, onClose: onClose }) {
        setData({
            title: title || "",
            content: content || /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {}),
            closeButton: closeButton,
            closeOutside: closeOutside,
            onClose: onClose
        });
    };
    const hide = function() {
        setData(undefined);
    };
    const close = function() {
        var _dataRef_current, _dataRef_current_onClose;
        if (dataRef.current) (_dataRef_current_onClose = (_dataRef_current = dataRef.current).onClose) === null || _dataRef_current_onClose === void 0 ? void 0 : _dataRef_current_onClose.call(_dataRef_current);
        hide();
    };
    const escFunction = (0, $6cds3.useCallback)((e)=>e.keyCode === 27 && hide(), [
        data
    ]);
    (0, $6cds3.useEffect)(()=>{
        document.addEventListener("keydown", escFunction, false);
        return ()=>{
            document.removeEventListener("keydown", escFunction, false);
        };
    }, [
        escFunction
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (data) {
            const target = document.querySelector("#modal");
            (0, $3b4e05b540ea4d30$export$24fdf68abf432c44)(target);
        } else (0, $3b4e05b540ea4d30$export$45a3ef215b2a5866)();
    }, [
        data
    ]);
    const setTitle = (0, $6cds3.useCallback)((newTitle)=>{
        setData({
            ...dataRef.current,
            title: newTitle || ""
        });
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)($fbd77a4ebafd8162$export$ab57792b9b6974a6.Provider, {
        value: {
            hide: hide,
            show: show,
            setTitle: setTitle
        },
        children: [
            children,
            data && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c68fd3036e8d8267$exports))).modal,
                id: "modal",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c68fd3036e8d8267$exports))).outer,
                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($e0a1893f069f0ea4$exports))), {
                        onOutsideClick: data.closeOutside && close || (()=>{}),
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c68fd3036e8d8267$exports))).modal_header,
                                children: [
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("h4", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c68fd3036e8d8267$exports))).title,
                                        children: data.title
                                    }),
                                    data.closeButton && /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c68fd3036e8d8267$exports))).close,
                                        onClick: close,
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $df8278a96b606336$export$2e2bcd8739ae039), {
                                            src: "/assets/icon_close.png",
                                            srcDark: "/assets/icon_close.png"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c68fd3036e8d8267$exports))).modal_content,
                                children: data.content
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $fbd77a4ebafd8162$export$2e2bcd8739ae039 = $fbd77a4ebafd8162$var$ModalContextProvider;



const $bb77bdefa754f138$var$ModalAuth = ({ userData: userData })=>{
    const { show: show, hide: hide, setTitle: setTitle } = (0, $6cds3.useContext)((0, $fbd77a4ebafd8162$export$ab57792b9b6974a6));
    const renderAuthForms = function() {
        return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $157bd6031ad0a800$export$2e2bcd8739ae039), {
            onFinishCallback: hide,
            onAuthZoneChanged: onAuthZoneChanged
        });
    };
    const onAuthZoneChanged = function(zoneType) {
        switch(zoneType){
            case (0, $157bd6031ad0a800$export$1922d33c059dfdaf).LOGIN:
                return setTitle("Login");
            case (0, $157bd6031ad0a800$export$1922d33c059dfdaf).EMAIL_VERIFICATION:
                return setTitle("Verify Email");
            case (0, $157bd6031ad0a800$export$1922d33c059dfdaf).PASSWORD_RESET:
                return setTitle("Reset Password");
            case (0, $157bd6031ad0a800$export$1922d33c059dfdaf).REGISTER:
                return setTitle("Register");
        }
    };
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
        children: !userData.isLogged && /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($67ff106c779a79a0$exports))).actioner,
            onClick: ()=>{
                show({
                    content: renderAuthForms(),
                    title: "Login"
                });
            },
            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $df8278a96b606336$export$2e2bcd8739ae039), {
                src: "/assets/icon_profile.png",
                srcDark: "/assets/icon_profile.png"
            })
        })
    });
};
var $bb77bdefa754f138$export$2e2bcd8739ae039 = $bb77bdefa754f138$var$ModalAuth;


const $c51dc355b0a1efd3$var$User = ({ className: className })=>{
    const userContext = (0, $6cds3.useContext)((0, $260d68481938071c$export$38ee920e59704589));
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($021ca37f9971eb83$exports))).user, className),
        children: [
            userContext.userData.isLogged && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $cca70c7ab7f90262$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $bb77bdefa754f138$export$2e2bcd8739ae039), {
                userData: userContext.userData
            })
        ]
    });
};
var $c51dc355b0a1efd3$export$2e2bcd8739ae039 = $c51dc355b0a1efd3$var$User;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $6PPF0 = parcelRequire("6PPF0");

var $4dccfbf57734741e$exports = {};

$parcel$export($4dccfbf57734741e$exports, "breadcrumbs", function () { return $4dccfbf57734741e$export$515d2155aaad79e4; }, function (v) { return $4dccfbf57734741e$export$515d2155aaad79e4 = v; });
$parcel$export($4dccfbf57734741e$exports, "button", function () { return $4dccfbf57734741e$export$2ba01fb71ed41cb6; }, function (v) { return $4dccfbf57734741e$export$2ba01fb71ed41cb6 = v; });
$parcel$export($4dccfbf57734741e$exports, "container", function () { return $4dccfbf57734741e$export$34e0f9847d4c02dd; }, function (v) { return $4dccfbf57734741e$export$34e0f9847d4c02dd = v; });
$parcel$export($4dccfbf57734741e$exports, "control", function () { return $4dccfbf57734741e$export$b5cde1de278b4330; }, function (v) { return $4dccfbf57734741e$export$b5cde1de278b4330 = v; });
$parcel$export($4dccfbf57734741e$exports, "item", function () { return $4dccfbf57734741e$export$7061c75fc5af8b7e; }, function (v) { return $4dccfbf57734741e$export$7061c75fc5af8b7e = v; });
$parcel$export($4dccfbf57734741e$exports, "link", function () { return $4dccfbf57734741e$export$9c30223ca0a664fb; }, function (v) { return $4dccfbf57734741e$export$9c30223ca0a664fb = v; });
var $4dccfbf57734741e$export$515d2155aaad79e4;
var $4dccfbf57734741e$export$2ba01fb71ed41cb6;
var $4dccfbf57734741e$export$34e0f9847d4c02dd;
var $4dccfbf57734741e$export$b5cde1de278b4330;
var $4dccfbf57734741e$export$7061c75fc5af8b7e;
var $4dccfbf57734741e$export$9c30223ca0a664fb;
$4dccfbf57734741e$export$515d2155aaad79e4 = `_K32DG_breadcrumbs`;
$4dccfbf57734741e$export$2ba01fb71ed41cb6 = `_K32DG_button`;
$4dccfbf57734741e$export$34e0f9847d4c02dd = `_K32DG_container`;
$4dccfbf57734741e$export$b5cde1de278b4330 = `_K32DG_control`;
$4dccfbf57734741e$export$7061c75fc5af8b7e = `_K32DG_item`;
$4dccfbf57734741e$export$9c30223ca0a664fb = `_K32DG_link`;



const $9faf859cd82fc757$var$Control = ({ className: className, item: item })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($4dccfbf57734741e$exports))).control, className),
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))("container", (0, (/*@__PURE__*/$parcel$interopDefault($4dccfbf57734741e$exports))).container),
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $60fd0126d8b57f34$export$a6c7ac8248d6e38a), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))("button-stroke button-small", (0, (/*@__PURE__*/$parcel$interopDefault($4dccfbf57734741e$exports))).button),
                    to: item[0].url,
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)((0, $2c63ec6d3d1d0cb4$export$2e2bcd8739ae039), {
                            name: "arrow-prev",
                            size: "10"
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("span", {
                            children: [
                                "Back to ",
                                item[0].title
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4dccfbf57734741e$exports))).breadcrumbs,
                    children: item.map((x, index)=>/*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4dccfbf57734741e$exports))).item,
                            children: x.url ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $60fd0126d8b57f34$export$a6c7ac8248d6e38a), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4dccfbf57734741e$exports))).link,
                                to: x.url,
                                children: x.title
                            }) : x.title
                        }, index))
                })
            ]
        })
    });
};
var $9faf859cd82fc757$export$2e2bcd8739ae039 = $9faf859cd82fc757$var$Control;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $6PPF0 = parcelRequire("6PPF0");

var $9e871bb3d67b3e87$export$89da14300d534261;
var $9e871bb3d67b3e87$export$32180ef41b15b513;
var $9e871bb3d67b3e87$export$2ba01fb71ed41cb6;
var $9e871bb3d67b3e87$export$324d90190a8b822a;
var $9e871bb3d67b3e87$export$41ee12f6f6f05843;
var $9e871bb3d67b3e87$export$5fd5031fecdacec3;
var $9e871bb3d67b3e87$export$7061c75fc5af8b7e;
var $9e871bb3d67b3e87$export$8837f4fc672e936d;
var $9e871bb3d67b3e87$export$2adf6238a2d0dafa;
var $9e871bb3d67b3e87$export$48c2d0f2f545ac27;
var $9e871bb3d67b3e87$export$321c0b1a406de31f;
var $9e871bb3d67b3e87$export$f7dc72e91f29c7d7;
var $9e871bb3d67b3e87$export$471f7ae5c4103ae1;
var $9e871bb3d67b3e87$export$c96745152eb2740f;
var $9e871bb3d67b3e87$export$fb184b623420d9be;
$9e871bb3d67b3e87$export$89da14300d534261 = `kDdYVa_active`;
$9e871bb3d67b3e87$export$32180ef41b15b513 = `kDdYVa_body`;
$9e871bb3d67b3e87$export$2ba01fb71ed41cb6 = `kDdYVa_button`;
$9e871bb3d67b3e87$export$324d90190a8b822a = `kDdYVa_date`;
$9e871bb3d67b3e87$export$41ee12f6f6f05843 = `kDdYVa_details`;
$9e871bb3d67b3e87$export$5fd5031fecdacec3 = `kDdYVa_head`;
$9e871bb3d67b3e87$export$7061c75fc5af8b7e = `kDdYVa_item`;
$9e871bb3d67b3e87$export$8837f4fc672e936d = `kDdYVa_list`;
$9e871bb3d67b3e87$export$2adf6238a2d0dafa = `kDdYVa_notification`;
$9e871bb3d67b3e87$export$48c2d0f2f545ac27 = `kDdYVa_preview`;
$9e871bb3d67b3e87$export$321c0b1a406de31f = `kDdYVa_price`;
$9e871bb3d67b3e87$export$f7dc72e91f29c7d7 = `kDdYVa_showNotification`;
$9e871bb3d67b3e87$export$f7dc72e91f29c7d7;
$9e871bb3d67b3e87$export$471f7ae5c4103ae1 = `kDdYVa_status`;
$9e871bb3d67b3e87$export$c96745152eb2740f = `kDdYVa_subtitle`;
$9e871bb3d67b3e87$export$fb184b623420d9be = `kDdYVa_title`;






const $89ae40cc09440c69$var$items = [
    {
        title: "ETH received",
        price: "0.08 ETH recived",
        date: "2 days ago",
        color: "#3772FF",
        image: "/images/content/notification-pic-1.jpg",
        url: "/activity"
    },
    {
        title: "C O I N Z",
        price: "New bid 0.2 ETH",
        date: "3 days ago",
        color: "#3772FF",
        image: "/images/content/notification-pic-2.jpg",
        url: "/activity"
    },
    {
        title: "ETH received",
        price: "0.08 ETH recived",
        date: "4 days ago",
        color: "#3772FF",
        image: "/images/content/notification-pic-3.jpg",
        url: "/activity"
    },
    {
        title: "ETH received",
        price: "0.08 ETH recived",
        date: "5 days ago",
        color: "#3772FF",
        image: "/images/content/notification-pic-4.jpg",
        url: "/activity"
    }
];
const $89ae40cc09440c69$var$Notification = ({ className: className })=>{
    const [visible, setVisible] = (0, $6cds3.useState)(false);
    const [permission, setPermission] = (0, $6cds3.useState)(false);
    function checkPermisisons() {
        let isGranted = window.Notification.permission === "granted";
        setPermission(isGranted);
    }
    // useEffect( checkPermisisons, [window.Notification.permission]);
    function requestPermission() {
        window.Notification.requestPermission().then(checkPermisisons);
    }
    // useEffect(requestPermission, []);
    let iconUrl = permission ? "/assets/icon_bell.png" : "/assets/icon_bell_blue.png";
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e0a1893f069f0ea4$exports))), {
        onOutsideClick: ()=>setVisible(false),
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))($9e871bb3d67b3e87$export$2adf6238a2d0dafa, className, permission && $9e871bb3d67b3e87$export$89da14300d534261),
            children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))($9e871bb3d67b3e87$export$5fd5031fecdacec3),
                onClick: requestPermission,
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $df8278a96b606336$export$2e2bcd8739ae039), {
                    src: iconUrl,
                    srcDark: iconUrl
                })
            })
        })
    });
};
var $89ae40cc09440c69$export$2e2bcd8739ae039 = $89ae40cc09440c69$var$Notification;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $e6172c28f94f816e$exports = {};

$parcel$export($e6172c28f94f816e$exports, "icon", function () { return $e6172c28f94f816e$export$1ca1ec8b29a4ce27; }, function (v) { return $e6172c28f94f816e$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($e6172c28f94f816e$exports, "input", function () { return $e6172c28f94f816e$export$b7e3ae3d7c15e42e; }, function (v) { return $e6172c28f94f816e$export$b7e3ae3d7c15e42e = v; });
$parcel$export($e6172c28f94f816e$exports, "searchBtn", function () { return $e6172c28f94f816e$export$c90e3f2a074946aa; }, function (v) { return $e6172c28f94f816e$export$c90e3f2a074946aa = v; });
$parcel$export($e6172c28f94f816e$exports, "searchContainer", function () { return $e6172c28f94f816e$export$100aa851bad32d9d; }, function (v) { return $e6172c28f94f816e$export$100aa851bad32d9d = v; });
var $e6172c28f94f816e$export$1ca1ec8b29a4ce27;
var $e6172c28f94f816e$export$b7e3ae3d7c15e42e;
var $e6172c28f94f816e$export$c90e3f2a074946aa;
var $e6172c28f94f816e$export$100aa851bad32d9d;
$e6172c28f94f816e$export$1ca1ec8b29a4ce27 = `AT53tW_icon`;
$e6172c28f94f816e$export$b7e3ae3d7c15e42e = `AT53tW_input`;
$e6172c28f94f816e$export$c90e3f2a074946aa = `AT53tW_searchBtn`;
$e6172c28f94f816e$export$100aa851bad32d9d = `AT53tW_searchContainer`;



var $6PPF0 = parcelRequire("6PPF0");
const $3a4595cf761cd9e9$var$SearchInput = ({ className: className, onChange: onChange, value: value })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($e6172c28f94f816e$exports))).searchContainer, className),
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e6172c28f94f816e$exports))).input,
                type: "text",
                name: "search",
                placeholder: "Search People",
                onChange: (event)=>{
                    onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value);
                },
                value: value
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $2c63ec6d3d1d0cb4$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e6172c28f94f816e$exports))).icon,
                    name: "search",
                    size: "28"
                })
            })
        ]
    });
};
var $3a4595cf761cd9e9$export$2e2bcd8739ae039 = $3a4595cf761cd9e9$var$SearchInput;




var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
const $f7a30d3cc05f1d27$export$abe847132b142195 = /*#__PURE__*/ (0, $6cds3.createContext)();
const $f7a30d3cc05f1d27$var$SearchContextProvider = ({ children: children })=>{
    const [search, setSearch] = (0, $6cds3.useState)("");
    return /*#__PURE__*/ (0, $lBpE3.jsx)($f7a30d3cc05f1d27$export$abe847132b142195.Provider, {
        value: {
            search: search,
            setSearch: setSearch
        },
        children: children
    });
};
var $f7a30d3cc05f1d27$export$2e2bcd8739ae039 = $f7a30d3cc05f1d27$var$SearchContextProvider;


const $7ef34d46dd7dad80$var$breadcrumbs = [
    {
        title: "Profile",
        url: "/profile"
    },
    {
        title: "Edit Profile"
    }
];
const $7ef34d46dd7dad80$var$Headers = ({ location: location })=>{
    const isChat = location.pathname.includes("chat");
    const chatIcon = isChat ? "/assets/icon_chat.png" : "/assets/icon_chat_blue.png";
    const { search: search, setSearch: setSearch } = (0, $6cds3.useContext)((0, $f7a30d3cc05f1d27$export$abe847132b142195));
    return /*#__PURE__*/ (0, $lBpE3.jsx)("header", {
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($32173854adf97353$exports))).fixedContainer,
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($32173854adf97353$exports))).header_zone, (0, (/*@__PURE__*/$parcel$interopDefault($32173854adf97353$exports))).left),
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $60fd0126d8b57f34$export$a6c7ac8248d6e38a), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($32173854adf97353$exports))).logo,
                        to: "/",
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $df8278a96b606336$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($32173854adf97353$exports))).pic,
                            src: "/assets/Logo.svg",
                            srcDark: "/assets/Logo.svg",
                            alt: "Nowwa"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($32173854adf97353$exports))).header_zone, (0, (/*@__PURE__*/$parcel$interopDefault($32173854adf97353$exports))).right),
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($32173854adf97353$exports))).iconsContainer,
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $89ae40cc09440c69$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($32173854adf97353$exports))).notification
                            })
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)((0, $c51dc355b0a1efd3$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($32173854adf97353$exports))).user
                        })
                    ]
                })
            ]
        })
    });
};
var $7ef34d46dd7dad80$export$2e2bcd8739ae039 = (0, $cff2dc0cc7b954fc$export$369b6b2b30582e8e)($7ef34d46dd7dad80$var$Headers);



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $6PPF0 = parcelRequire("6PPF0");
var $8f9f957fbc516111$exports = {};

$parcel$export($8f9f957fbc516111$exports, "category", function () { return $8f9f957fbc516111$export$657ee1858213601f; }, function (v) { return $8f9f957fbc516111$export$657ee1858213601f = v; });
$parcel$export($8f9f957fbc516111$exports, "col", function () { return $8f9f957fbc516111$export$aba86695643891f5; }, function (v) { return $8f9f957fbc516111$export$aba86695643891f5 = v; });
$parcel$export($8f9f957fbc516111$exports, "copyright", function () { return $8f9f957fbc516111$export$666c3ad173ff70db; }, function (v) { return $8f9f957fbc516111$export$666c3ad173ff70db = v; });
$parcel$export($8f9f957fbc516111$exports, "details", function () { return $8f9f957fbc516111$export$41ee12f6f6f05843; }, function (v) { return $8f9f957fbc516111$export$41ee12f6f6f05843 = v; });
$parcel$export($8f9f957fbc516111$exports, "foot", function () { return $8f9f957fbc516111$export$8b0cec5315ee1d44; }, function (v) { return $8f9f957fbc516111$export$8b0cec5315ee1d44 = v; });
$parcel$export($8f9f957fbc516111$exports, "footer", function () { return $8f9f957fbc516111$export$adb608be33961c98; }, function (v) { return $8f9f957fbc516111$export$adb608be33961c98 = v; });
$parcel$export($8f9f957fbc516111$exports, "info", function () { return $8f9f957fbc516111$export$a80b3bd66acc52ff; }, function (v) { return $8f9f957fbc516111$export$a80b3bd66acc52ff = v; });
$parcel$export($8f9f957fbc516111$exports, "logo", function () { return $8f9f957fbc516111$export$db3c28d99448dcff; }, function (v) { return $8f9f957fbc516111$export$db3c28d99448dcff = v; });
$parcel$export($8f9f957fbc516111$exports, "note", function () { return $8f9f957fbc516111$export$a92e4c44d367d0af; }, function (v) { return $8f9f957fbc516111$export$a92e4c44d367d0af = v; });
$parcel$export($8f9f957fbc516111$exports, "row", function () { return $8f9f957fbc516111$export$120ff0929b202a6d; }, function (v) { return $8f9f957fbc516111$export$120ff0929b202a6d = v; });
$parcel$export($8f9f957fbc516111$exports, "text", function () { return $8f9f957fbc516111$export$6f093cfa640b7166; }, function (v) { return $8f9f957fbc516111$export$6f093cfa640b7166 = v; });
$parcel$export($8f9f957fbc516111$exports, "version", function () { return $8f9f957fbc516111$export$83d89fbfd8236492; }, function (v) { return $8f9f957fbc516111$export$83d89fbfd8236492 = v; });
var $8f9f957fbc516111$export$657ee1858213601f;
var $8f9f957fbc516111$export$aba86695643891f5;
var $8f9f957fbc516111$export$666c3ad173ff70db;
var $8f9f957fbc516111$export$41ee12f6f6f05843;
var $8f9f957fbc516111$export$8b0cec5315ee1d44;
var $8f9f957fbc516111$export$adb608be33961c98;
var $8f9f957fbc516111$export$a80b3bd66acc52ff;
var $8f9f957fbc516111$export$db3c28d99448dcff;
var $8f9f957fbc516111$export$a92e4c44d367d0af;
var $8f9f957fbc516111$export$120ff0929b202a6d;
var $8f9f957fbc516111$export$6f093cfa640b7166;
var $8f9f957fbc516111$export$83d89fbfd8236492;
$8f9f957fbc516111$export$657ee1858213601f = `Q_jGnq_category`;
$8f9f957fbc516111$export$aba86695643891f5 = `Q_jGnq_col`;
$8f9f957fbc516111$export$666c3ad173ff70db = `Q_jGnq_copyright`;
$8f9f957fbc516111$export$41ee12f6f6f05843 = `Q_jGnq_details`;
$8f9f957fbc516111$export$8b0cec5315ee1d44 = `Q_jGnq_foot`;
$8f9f957fbc516111$export$adb608be33961c98 = `Q_jGnq_footer`;
$8f9f957fbc516111$export$a80b3bd66acc52ff = `Q_jGnq_info`;
$8f9f957fbc516111$export$db3c28d99448dcff = `Q_jGnq_logo`;
$8f9f957fbc516111$export$a92e4c44d367d0af = `Q_jGnq_note`;
$8f9f957fbc516111$export$120ff0929b202a6d = `Q_jGnq_row`;
$8f9f957fbc516111$export$6f093cfa640b7166 = `Q_jGnq_text`;
$8f9f957fbc516111$export$83d89fbfd8236492 = `Q_jGnq_version`;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $6PPF0 = parcelRequire("6PPF0");
var $26fdedb45559f957$exports = {};

$parcel$export($26fdedb45559f957$exports, "active", function () { return $26fdedb45559f957$export$89da14300d534261; }, function (v) { return $26fdedb45559f957$export$89da14300d534261 = v; });
$parcel$export($26fdedb45559f957$exports, "group", function () { return $26fdedb45559f957$export$e5e25fbcc1f7affe; }, function (v) { return $26fdedb45559f957$export$e5e25fbcc1f7affe = v; });
$parcel$export($26fdedb45559f957$exports, "head", function () { return $26fdedb45559f957$export$5fd5031fecdacec3; }, function (v) { return $26fdedb45559f957$export$5fd5031fecdacec3 = v; });
$parcel$export($26fdedb45559f957$exports, "link", function () { return $26fdedb45559f957$export$9c30223ca0a664fb; }, function (v) { return $26fdedb45559f957$export$9c30223ca0a664fb = v; });
$parcel$export($26fdedb45559f957$exports, "menu", function () { return $26fdedb45559f957$export$b1e5508a851be14d; }, function (v) { return $26fdedb45559f957$export$b1e5508a851be14d = v; });
var $26fdedb45559f957$export$89da14300d534261;
var $26fdedb45559f957$export$e5e25fbcc1f7affe;
var $26fdedb45559f957$export$5fd5031fecdacec3;
var $26fdedb45559f957$export$9c30223ca0a664fb;
var $26fdedb45559f957$export$b1e5508a851be14d;
$26fdedb45559f957$export$89da14300d534261 = `_4kPg8a_active`;
$26fdedb45559f957$export$e5e25fbcc1f7affe = `_4kPg8a_group`;
$26fdedb45559f957$export$5fd5031fecdacec3 = `_4kPg8a_head`;
$26fdedb45559f957$export$9c30223ca0a664fb = `_4kPg8a_link`;
$26fdedb45559f957$export$b1e5508a851be14d = `_4kPg8a_menu`;



const $7f42bedacb01ff6f$var$Group = ({ className: className, item: item })=>{
    const [visible, setVisible] = (0, $6cds3.useState)(false);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))(className, (0, (/*@__PURE__*/$parcel$interopDefault($26fdedb45559f957$exports))).group, {
            [(0, (/*@__PURE__*/$parcel$interopDefault($26fdedb45559f957$exports))).active]: visible
        }),
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($26fdedb45559f957$exports))).head,
                onClick: ()=>setVisible(!visible),
                children: [
                    item.title,
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $2c63ec6d3d1d0cb4$export$2e2bcd8739ae039), {
                        name: "arrow-bottom",
                        size: "10"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($26fdedb45559f957$exports))).menu,
                children: item.menu.map((x, index)=>x.url.startsWith("http") ? /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($26fdedb45559f957$exports))).link,
                        href: x.url,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: x.title
                    }, index) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, $60fd0126d8b57f34$export$a6c7ac8248d6e38a), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($26fdedb45559f957$exports))).link,
                        to: x.url,
                        children: x.title
                    }, index))
            })
        ]
    });
};
var $7f42bedacb01ff6f$export$2e2bcd8739ae039 = $7f42bedacb01ff6f$var$Group;




var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $6PPF0 = parcelRequire("6PPF0");
var $b5678432951ea346$exports = {};

$parcel$export($b5678432951ea346$exports, "btn", function () { return $b5678432951ea346$export$534219b709288da9; }, function (v) { return $b5678432951ea346$export$534219b709288da9 = v; });
$parcel$export($b5678432951ea346$exports, "form", function () { return $b5678432951ea346$export$6210fa4921d2a466; }, function (v) { return $b5678432951ea346$export$6210fa4921d2a466 = v; });
$parcel$export($b5678432951ea346$exports, "input", function () { return $b5678432951ea346$export$b7e3ae3d7c15e42e; }, function (v) { return $b5678432951ea346$export$b7e3ae3d7c15e42e = v; });
var $b5678432951ea346$export$534219b709288da9;
var $b5678432951ea346$export$6210fa4921d2a466;
var $b5678432951ea346$export$b7e3ae3d7c15e42e;
$b5678432951ea346$export$534219b709288da9 = `TyLUwW_btn`;
$b5678432951ea346$export$6210fa4921d2a466 = `TyLUwW_form`;
$b5678432951ea346$export$b7e3ae3d7c15e42e = `TyLUwW_input`;



const $3df78d74dc02c174$var$Form = ({ className: className, onSubmit: onSubmit, placeholder: placeholder, value: value, setValue: setValue, type: type, name: name })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($b5678432951ea346$exports))).form, className),
        action: "",
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b5678432951ea346$exports))).input,
                type: type,
                value: value,
                onChange: (e)=>setValue(e.target.value),
                name: name,
                placeholder: placeholder,
                required: true
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b5678432951ea346$exports))).btn,
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $2c63ec6d3d1d0cb4$export$2e2bcd8739ae039), {
                    name: "arrow-next",
                    size: "14"
                })
            })
        ]
    });
};
var $3df78d74dc02c174$export$2e2bcd8739ae039 = $3df78d74dc02c174$var$Form;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $6PPF0 = parcelRequire("6PPF0");
var $904477aec77f46c8$export$827f4ee28efc37;
var $904477aec77f46c8$export$4ae363f1d88fb658;
var $904477aec77f46c8$export$b7e3ae3d7c15e42e;
var $904477aec77f46c8$export$bca14c5b3b88a9c9;
var $904477aec77f46c8$export$356b88ab96ecb78b;
$904477aec77f46c8$export$827f4ee28efc37 = `ea01-G_box`;
$904477aec77f46c8$export$4ae363f1d88fb658 = `ea01-G_inner`;
$904477aec77f46c8$export$b7e3ae3d7c15e42e = `ea01-G_input`;
$904477aec77f46c8$export$bca14c5b3b88a9c9 = `ea01-G_theme`;
$904477aec77f46c8$export$356b88ab96ecb78b = `ea01-G_themeBig`;


const $39a60ca5a65ea8a1$var$Theme = ({ className: className })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("label", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))($904477aec77f46c8$export$bca14c5b3b88a9c9, {
            [$904477aec77f46c8$export$bca14c5b3b88a9c9]: className === "theme"
        }, {
            [$904477aec77f46c8$export$356b88ab96ecb78b]: className === "theme-big"
        }),
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("input", {
                className: $904477aec77f46c8$export$b7e3ae3d7c15e42e,
                // checked={darkMode.value}
                // onChange={darkMode.toggle}
                type: "checkbox"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                className: $904477aec77f46c8$export$4ae363f1d88fb658,
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                    className: $904477aec77f46c8$export$827f4ee28efc37
                })
            })
        ]
    });
};
var $39a60ca5a65ea8a1$export$2e2bcd8739ae039 = $39a60ca5a65ea8a1$var$Theme;


const $87abbf17ffbe42b1$var$items = [
    {
        title: "Crypter.",
        menu: [
            {
                title: "Discover",
                url: "/search01"
            },
            {
                title: "Connect wallet",
                url: "/connect-wallet"
            }
        ]
    },
    {
        title: "Info",
        menu: [
            {
                title: "FAQ",
                url: "/faq"
            },
            {
                title: "Create item",
                url: "/upload-variants"
            }
        ]
    }
];
const $87abbf17ffbe42b1$var$Footers = ()=>{
    const [email, setEmail] = (0, $6cds3.useState)("");
    const handleSubmit = (e)=>{
        alert();
    };
    return /*#__PURE__*/ (0, $lBpE3.jsx)("footer", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8f9f957fbc516111$exports))).footer,
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))("container", (0, (/*@__PURE__*/$parcel$interopDefault($8f9f957fbc516111$exports))).container),
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8f9f957fbc516111$exports))).row,
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8f9f957fbc516111$exports))).col,
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)((0, $60fd0126d8b57f34$export$a6c7ac8248d6e38a), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8f9f957fbc516111$exports))).logo,
                                    to: "/",
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $df8278a96b606336$export$2e2bcd8739ae039), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8f9f957fbc516111$exports))).pic,
                                        src: "/images/logo-dark.png",
                                        srcDark: "/images/logo-light.png",
                                        alt: "Nowwa"
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8f9f957fbc516111$exports))).info,
                                    children: "The New Creative Economy."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8f9f957fbc516111$exports))).col,
                            children: $87abbf17ffbe42b1$var$items.map((x, index)=>/*#__PURE__*/ (0, $lBpE3.jsx)((0, $7f42bedacb01ff6f$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8f9f957fbc516111$exports))).group,
                                    item: x
                                }, index))
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8f9f957fbc516111$exports))).col,
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8f9f957fbc516111$exports))).category,
                                    children: "Join Newsletter"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8f9f957fbc516111$exports))).text,
                                    children: "Subscribe our newsletter to get more free design course and resource"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3df78d74dc02c174$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8f9f957fbc516111$exports))).form,
                                    value: email,
                                    setValue: setEmail,
                                    onSubmit: ()=>handleSubmit(),
                                    placeholder: "Enter your email",
                                    type: "email",
                                    name: "email"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8f9f957fbc516111$exports))).foot,
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8f9f957fbc516111$exports))).copyright,
                            children: "Copyright \xa9 2021 UI8 LLC. All rights reserved"
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8f9f957fbc516111$exports))).note,
                            children: [
                                "We use cookies for better service. ",
                                /*#__PURE__*/ (0, $lBpE3.jsx)("a", {
                                    href: "/#",
                                    children: "Accept"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $87abbf17ffbe42b1$export$2e2bcd8739ae039 = $87abbf17ffbe42b1$var$Footers;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
var $bbb668af7bc774ac$exports = {};

$parcel$export($bbb668af7bc774ac$exports, "active", function () { return $bbb668af7bc774ac$export$89da14300d534261; }, function (v) { return $bbb668af7bc774ac$export$89da14300d534261 = v; });
$parcel$export($bbb668af7bc774ac$exports, "navContainer", function () { return $bbb668af7bc774ac$export$338cdc846fda74cd; }, function (v) { return $bbb668af7bc774ac$export$338cdc846fda74cd = v; });
$parcel$export($bbb668af7bc774ac$exports, "navItem", function () { return $bbb668af7bc774ac$export$f1de0d6ae757bad; }, function (v) { return $bbb668af7bc774ac$export$f1de0d6ae757bad = v; });
$parcel$export($bbb668af7bc774ac$exports, "simple", function () { return $bbb668af7bc774ac$export$52257e56c24a8923; }, function (v) { return $bbb668af7bc774ac$export$52257e56c24a8923 = v; });
var $bbb668af7bc774ac$export$89da14300d534261;
var $bbb668af7bc774ac$export$338cdc846fda74cd;
var $bbb668af7bc774ac$export$f1de0d6ae757bad;
var $bbb668af7bc774ac$export$52257e56c24a8923;
$bbb668af7bc774ac$export$89da14300d534261 = `NK-tOq_active`;
$bbb668af7bc774ac$export$338cdc846fda74cd = `NK-tOq_navContainer`;
$bbb668af7bc774ac$export$f1de0d6ae757bad = `NK-tOq_navItem`;
$bbb668af7bc774ac$export$52257e56c24a8923 = `NK-tOq_simple`;



var $6PPF0 = parcelRequire("6PPF0");



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");




var $919277dd1157d14b$exports = {};

$parcel$export($919277dd1157d14b$exports, "friendLink", function () { return $919277dd1157d14b$export$314799f5404ade86; }, function (v) { return $919277dd1157d14b$export$314799f5404ade86 = v; });
var $919277dd1157d14b$export$314799f5404ade86;
$919277dd1157d14b$export$314799f5404ade86 = `_9F01TW_friendLink`;


var $997060ca4ee618aa$exports = {};
"use strict";
"use client";
var $4bfaad0176813de2$exports = {};
function $4bfaad0176813de2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$4bfaad0176813de2$exports = $4bfaad0176813de2$var$_interopRequireDefault, $4bfaad0176813de2$exports.__esModule = true, $4bfaad0176813de2$exports["default"] = $4bfaad0176813de2$exports;


Object.defineProperty($997060ca4ee618aa$exports, "__esModule", {
    value: true
});
$997060ca4ee618aa$exports.default = void 0;

var $997060ca4ee618aa$var$_createSvgIcon = $4bfaad0176813de2$exports((parcelRequire("1kJnE")));

var $lBpE3 = parcelRequire("lBpE3");
var $997060ca4ee618aa$var$_default = (0, $997060ca4ee618aa$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $lBpE3.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), "Add");
$997060ca4ee618aa$exports.default = $997060ca4ee618aa$var$_default;


const $20141ed21c5b92ae$var$FriendsList = ({})=>{
    const userContext = (0, $6cds3.useContext)((0, $260d68481938071c$export$38ee920e59704589));
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const [friends, setFriends] = (0, $6cds3.useState)([]);
    (0, $6cds3.useEffect)(()=>{
        async function doWork() {
            if (!userContext.userData.isLogged) return setFriends([]);
            let response = await conquer.Friends.get(true);
            setFriends([
                ...response
            ]);
        }
        doWork();
    }, [
        userContext.userData
    ]);
    // if( !userContext.userData.isLogged || !friends || friends.length == 0 ) return <></>;
    function getRemainingButtons() {
        let final = [];
        for(let i = 0; i < 6 - friends.length; i++)final.push(/*#__PURE__*/ (0, $lBpE3.jsx)("li", {
            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $60fd0126d8b57f34$export$a6c7ac8248d6e38a), {
                to: "/chat",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($919277dd1157d14b$exports))).friendLink,
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($997060ca4ee618aa$exports))), {})
            })
        }, i));
        return final;
    }
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("ul", {
        children: [
            friends.map((data)=>{
                return /*#__PURE__*/ (0, $lBpE3.jsx)("li", {
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $60fd0126d8b57f34$export$a6c7ac8248d6e38a), {
                        to: "/chat",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($919277dd1157d14b$exports))).friendLink,
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6d7bf74e72bae737$export$2e2bcd8739ae039), {
                            data: data,
                            online: true
                        })
                    })
                }, data.avatarID);
            }),
            friends.length < 6 && getRemainingButtons().map((button)=>{
                return button;
            })
        ]
    });
};
var $20141ed21c5b92ae$export$2e2bcd8739ae039 = $20141ed21c5b92ae$var$FriendsList;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
var $851a286ba5b5b1d8$exports = {};

$parcel$export($851a286ba5b5b1d8$exports, "Invited", function () { return $851a286ba5b5b1d8$export$1cffcc170847bf0b; }, function (v) { return $851a286ba5b5b1d8$export$1cffcc170847bf0b = v; });
$parcel$export($851a286ba5b5b1d8$exports, "active", function () { return $851a286ba5b5b1d8$export$89da14300d534261; }, function (v) { return $851a286ba5b5b1d8$export$89da14300d534261 = v; });
$parcel$export($851a286ba5b5b1d8$exports, "avatar", function () { return $851a286ba5b5b1d8$export$345c5736c8054f22; }, function (v) { return $851a286ba5b5b1d8$export$345c5736c8054f22 = v; });
$parcel$export($851a286ba5b5b1d8$exports, "container", function () { return $851a286ba5b5b1d8$export$34e0f9847d4c02dd; }, function (v) { return $851a286ba5b5b1d8$export$34e0f9847d4c02dd = v; });
$parcel$export($851a286ba5b5b1d8$exports, "friendItem", function () { return $851a286ba5b5b1d8$export$ee4dbe6e701c13f8; }, function (v) { return $851a286ba5b5b1d8$export$ee4dbe6e701c13f8 = v; });
$parcel$export($851a286ba5b5b1d8$exports, "friendState", function () { return $851a286ba5b5b1d8$export$8ab87c4fe1ab1f5e; }, function (v) { return $851a286ba5b5b1d8$export$8ab87c4fe1ab1f5e = v; });
$parcel$export($851a286ba5b5b1d8$exports, "friendState__friendName", function () { return $851a286ba5b5b1d8$export$39cf7d61b07f79b; }, function (v) { return $851a286ba5b5b1d8$export$39cf7d61b07f79b = v; });
$parcel$export($851a286ba5b5b1d8$exports, "friendState__lastMsg", function () { return $851a286ba5b5b1d8$export$73a92999cf9505d5; }, function (v) { return $851a286ba5b5b1d8$export$73a92999cf9505d5 = v; });
$parcel$export($851a286ba5b5b1d8$exports, "friendState__typingIndicator", function () { return $851a286ba5b5b1d8$export$fe1e401cc4ec7ee0; }, function (v) { return $851a286ba5b5b1d8$export$fe1e401cc4ec7ee0 = v; });
$parcel$export($851a286ba5b5b1d8$exports, "friendState__typingIndicator__editIcon", function () { return $851a286ba5b5b1d8$export$415e9285c209904f; }, function (v) { return $851a286ba5b5b1d8$export$415e9285c209904f = v; });
$parcel$export($851a286ba5b5b1d8$exports, "infoContainer", function () { return $851a286ba5b5b1d8$export$22e25551094b01ef; }, function (v) { return $851a286ba5b5b1d8$export$22e25551094b01ef = v; });
$parcel$export($851a286ba5b5b1d8$exports, "msgState", function () { return $851a286ba5b5b1d8$export$95ee1196010971e6; }, function (v) { return $851a286ba5b5b1d8$export$95ee1196010971e6 = v; });
$parcel$export($851a286ba5b5b1d8$exports, "msgState__check", function () { return $851a286ba5b5b1d8$export$35496110d325f9bf; }, function (v) { return $851a286ba5b5b1d8$export$35496110d325f9bf = v; });
$parcel$export($851a286ba5b5b1d8$exports, "msgState__time", function () { return $851a286ba5b5b1d8$export$c1661903c4fe3560; }, function (v) { return $851a286ba5b5b1d8$export$c1661903c4fe3560 = v; });
$parcel$export($851a286ba5b5b1d8$exports, "msgState__unread", function () { return $851a286ba5b5b1d8$export$9e346fa340d53f1c; }, function (v) { return $851a286ba5b5b1d8$export$9e346fa340d53f1c = v; });
$parcel$export($851a286ba5b5b1d8$exports, "simple", function () { return $851a286ba5b5b1d8$export$52257e56c24a8923; }, function (v) { return $851a286ba5b5b1d8$export$52257e56c24a8923 = v; });
$parcel$export($851a286ba5b5b1d8$exports, "status", function () { return $851a286ba5b5b1d8$export$471f7ae5c4103ae1; }, function (v) { return $851a286ba5b5b1d8$export$471f7ae5c4103ae1 = v; });
var $851a286ba5b5b1d8$export$1cffcc170847bf0b;
var $851a286ba5b5b1d8$export$89da14300d534261;
var $851a286ba5b5b1d8$export$345c5736c8054f22;
var $851a286ba5b5b1d8$export$34e0f9847d4c02dd;
var $851a286ba5b5b1d8$export$ee4dbe6e701c13f8;
var $851a286ba5b5b1d8$export$8ab87c4fe1ab1f5e;
var $851a286ba5b5b1d8$export$39cf7d61b07f79b;
var $851a286ba5b5b1d8$export$73a92999cf9505d5;
var $851a286ba5b5b1d8$export$fe1e401cc4ec7ee0;
var $851a286ba5b5b1d8$export$415e9285c209904f;
var $851a286ba5b5b1d8$export$22e25551094b01ef;
var $851a286ba5b5b1d8$export$95ee1196010971e6;
var $851a286ba5b5b1d8$export$35496110d325f9bf;
var $851a286ba5b5b1d8$export$c1661903c4fe3560;
var $851a286ba5b5b1d8$export$9e346fa340d53f1c;
var $851a286ba5b5b1d8$export$52257e56c24a8923;
var $851a286ba5b5b1d8$export$471f7ae5c4103ae1;
$851a286ba5b5b1d8$export$1cffcc170847bf0b = `CDh7Aq_Invited`;
$851a286ba5b5b1d8$export$89da14300d534261 = `CDh7Aq_active`;
$851a286ba5b5b1d8$export$345c5736c8054f22 = `CDh7Aq_avatar`;
$851a286ba5b5b1d8$export$34e0f9847d4c02dd = `CDh7Aq_container`;
$851a286ba5b5b1d8$export$ee4dbe6e701c13f8 = `CDh7Aq_friendItem`;
$851a286ba5b5b1d8$export$8ab87c4fe1ab1f5e = `CDh7Aq_friendState`;
$851a286ba5b5b1d8$export$39cf7d61b07f79b = `CDh7Aq_friendState__friendName`;
$851a286ba5b5b1d8$export$73a92999cf9505d5 = `CDh7Aq_friendState__lastMsg`;
$851a286ba5b5b1d8$export$fe1e401cc4ec7ee0 = `CDh7Aq_friendState__typingIndicator`;
$851a286ba5b5b1d8$export$415e9285c209904f = `CDh7Aq_friendState__typingIndicator__editIcon`;
$851a286ba5b5b1d8$export$22e25551094b01ef = `CDh7Aq_infoContainer`;
$851a286ba5b5b1d8$export$95ee1196010971e6 = `CDh7Aq_msgState`;
$851a286ba5b5b1d8$export$35496110d325f9bf = `CDh7Aq_msgState__check`;
$851a286ba5b5b1d8$export$c1661903c4fe3560 = `CDh7Aq_msgState__time`;
$851a286ba5b5b1d8$export$9e346fa340d53f1c = `CDh7Aq_msgState__unread`;
$851a286ba5b5b1d8$export$52257e56c24a8923 = `CDh7Aq_simple`;
$851a286ba5b5b1d8$export$471f7ae5c4103ae1 = `CDh7Aq_status`;




var $ffe1463ae0e2611a$exports = {};
"use strict";
"use client";

Object.defineProperty($ffe1463ae0e2611a$exports, "__esModule", {
    value: true
});
$ffe1463ae0e2611a$exports.default = void 0;

var $ffe1463ae0e2611a$var$_createSvgIcon = $4bfaad0176813de2$exports((parcelRequire("1kJnE")));

var $lBpE3 = parcelRequire("lBpE3");
var $ffe1463ae0e2611a$var$_default = (0, $ffe1463ae0e2611a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $lBpE3.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), "Edit");
$ffe1463ae0e2611a$exports.default = $ffe1463ae0e2611a$var$_default;



const $68e94d90188813cf$export$b139bd30bc162c86 = (string, count = 10)=>{
    if (string.length > count) return string.slice(0, count) + "...";
    else return string;
};
const $68e94d90188813cf$export$e6e2bc9967bf256c = (address, count = 4)=>{
    if (!address) return "";
    return address.slice(0, count) + "..." + address.slice(-count);
};
const $68e94d90188813cf$export$545f5e3f2388236f = (username)=>{
    return username.slice(0, username.search("@"));
};



var $6PPF0 = parcelRequire("6PPF0");





var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
var $b2bc4e5c75d87a22$exports = {};

$parcel$export($b2bc4e5c75d87a22$exports, "container", function () { return $b2bc4e5c75d87a22$export$34e0f9847d4c02dd; }, function (v) { return $b2bc4e5c75d87a22$export$34e0f9847d4c02dd = v; });
var $b2bc4e5c75d87a22$export$34e0f9847d4c02dd;
$b2bc4e5c75d87a22$export$34e0f9847d4c02dd = `E0LlOG_container`;




var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $6PPF0 = parcelRequire("6PPF0");
var $9d04049e1fbe00e6$exports = {};

$parcel$export($9d04049e1fbe00e6$exports, "input", function () { return $9d04049e1fbe00e6$export$b7e3ae3d7c15e42e; }, function (v) { return $9d04049e1fbe00e6$export$b7e3ae3d7c15e42e = v; });
$parcel$export($9d04049e1fbe00e6$exports, "label", function () { return $9d04049e1fbe00e6$export$1237798dc640739a; }, function (v) { return $9d04049e1fbe00e6$export$1237798dc640739a = v; });
var $9d04049e1fbe00e6$export$b7e3ae3d7c15e42e;
var $9d04049e1fbe00e6$export$1237798dc640739a;
$9d04049e1fbe00e6$export$b7e3ae3d7c15e42e = `DxTzdW_input`;
$9d04049e1fbe00e6$export$1237798dc640739a = `DxTzdW_label`;


const $742193a6f0a9c5fe$var$TextInput = ({ className: className, label: label, ...props })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($9d04049e1fbe00e6$exports))).field, className),
        children: [
            label && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9d04049e1fbe00e6$exports))).label,
                children: label
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9d04049e1fbe00e6$exports))).wrap,
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("input", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9d04049e1fbe00e6$exports))).input,
                    ...props
                })
            })
        ]
    });
};
var $742193a6f0a9c5fe$export$2e2bcd8739ae039 = $742193a6f0a9c5fe$var$TextInput;




const $9fd541d90e7f7063$var$RemoveFriendModal = ({ onFriendRemoved: onFriendRemoved, friend: friend })=>{
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const [isVisible, setIsVisible] = (0, $6cds3.useState)(false);
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(false);
    const [error, setError] = (0, $6cds3.useState)("");
    function showError(message) {
        setError(message);
        return false;
    }
    async function tryToRemoveFriend() {
        setIsLoading(true);
        let response = await conquer.Friends.remove(friend.avatarID);
        console.log(response);
        setIsLoading(false);
        if (response.error) return showError(response.error);
        onFriendRemoved === null || onFriendRemoved === void 0 ? void 0 : onFriendRemoved();
    }
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                className: "button small",
                onClick: ()=>{
                    setIsVisible(true);
                },
                children: "Remove"
            }),
            isVisible && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $96f09411dda7faae$export$2e2bcd8739ae039), {
                visible: true,
                onClose: ()=>{
                    setIsVisible(false);
                },
                title: "Remove Friend",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($b2bc4e5c75d87a22$exports))).container,
                    children: isLoading ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a22e9bdfa443b231$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("p", {
                                children: [
                                    "Are you sure you want to remove ",
                                    friend.firstName,
                                    " from your friends? "
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                className: "button",
                                onClick: tryToRemoveFriend,
                                children: "Remove Friend"
                            }),
                            error && /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                                style: {
                                    color: "red",
                                    maxWidth: "75%",
                                    textAlign: "center"
                                },
                                children: error
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $9fd541d90e7f7063$export$2e2bcd8739ae039 = $9fd541d90e7f7063$var$RemoveFriendModal;



const $e708bb3ae8d39d08$var$FriendItem = ({ data: data, onClick: onClick, id: id, onFriendAccept: onFriendAccept, onFriendRemoved: onFriendRemoved, simple: simple, isSelected: isSelected })=>{
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const userContext = (0, $6cds3.useContext)((0, $260d68481938071c$export$38ee920e59704589));
    const [status, setStatus] = (0, $6cds3.useState)(data.status);
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(false);
    let avatar = data.avatarInstance;
    const state = {
        name: "Leo",
        avatar: "/images/content/avatar-0.jpg",
        time: "",
        lastMsg: "",
        isTyping: false,
        // state: "3",
        isActive: false,
        selected: false
    };
    let isInvited = status == (0, $db396e8726140e32$export$d54e9889145bdfd7).INVITED;
    let isPending = status == (0, $db396e8726140e32$export$d54e9889145bdfd7).PENDING;
    let isFriend = status == (0, $db396e8726140e32$export$d54e9889145bdfd7).ACCEPTED || status == (0, $db396e8726140e32$export$d54e9889145bdfd7).ACTIVE;
    let notAFriend = status == (0, $db396e8726140e32$export$d54e9889145bdfd7).UKNOWN;
    async function tryToAccept() {
        if (!isPending) return;
        if (!userContext.userData.isLogged) return;
        setIsLoading(true);
        let response = await conquer.Friends.change(data.avatarID);
        console.log("ACCEPT RESPONSE", response);
        setIsLoading(false);
        if (response.success) setStatus((0, $db396e8726140e32$export$d54e9889145bdfd7).ACCEPTED);
    }
    async function tryToInvite() {
        setIsLoading(true);
        let response = await conquer.Friends.set(data.avatarID);
        setIsLoading(false);
        console.log("INVITE RESPONSE:", response);
        if (response.error) return console.log("ERROR", response.error);
        setStatus((0, $db396e8726140e32$export$d54e9889145bdfd7).INVITED);
    }
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($851a286ba5b5b1d8$exports))).friendItem, isSelected && (0, (/*@__PURE__*/$parcel$interopDefault($851a286ba5b5b1d8$exports))).active, isInvited ? (0, (/*@__PURE__*/$parcel$interopDefault($851a286ba5b5b1d8$exports))).Invited : "", simple && (0, (/*@__PURE__*/$parcel$interopDefault($851a286ba5b5b1d8$exports))).simple),
        onClick: ()=>{
            onClick === null || onClick === void 0 ? void 0 : onClick(data);
        },
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($851a286ba5b5b1d8$exports))).container,
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($851a286ba5b5b1d8$exports))).avatar,
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6d7bf74e72bae737$export$2e2bcd8739ae039), {
                            data: data
                        }),
                        state.isActive && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($851a286ba5b5b1d8$exports))).active
                        })
                    ]
                }),
                !simple && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($851a286ba5b5b1d8$exports))).infoContainer,
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($851a286ba5b5b1d8$exports))).friendState,
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($851a286ba5b5b1d8$exports))).friendState__friendName,
                                    children: (0, $68e94d90188813cf$export$b139bd30bc162c86)(avatar.firstName + " " + avatar.lastName || "", 13)
                                }),
                                state.isTyping ? /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($851a286ba5b5b1d8$exports))).friendState__typingIndicator,
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ffe1463ae0e2611a$exports))), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($851a286ba5b5b1d8$exports))).friendState__typingIndicator__editIcon
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                            children: state.name + " is typing..."
                                        })
                                    ]
                                }) : state.lastMsg && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($851a286ba5b5b1d8$exports))).friendState__lastMsg,
                                    children: state.lastMsg
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($851a286ba5b5b1d8$exports))).msgState,
                            children: isLoading ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a22e9bdfa443b231$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                                children: [
                                    isFriend && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($851a286ba5b5b1d8$exports))).msgState__time,
                                        children: state.time
                                    }),
                                    isInvited && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($851a286ba5b5b1d8$exports))).status,
                                        children: "Invited"
                                    }),
                                    isPending && /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))("button small"),
                                        onClick: tryToAccept,
                                        children: "Accept"
                                    }),
                                    notAFriend && /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))("button small"),
                                        onClick: tryToInvite,
                                        children: "ADD"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $e708bb3ae8d39d08$export$2e2bcd8739ae039 = $e708bb3ae8d39d08$var$FriendItem;


var $a4cb028681b2d422$exports = {};

$parcel$export($a4cb028681b2d422$exports, "container", function () { return $a4cb028681b2d422$export$34e0f9847d4c02dd; }, function (v) { return $a4cb028681b2d422$export$34e0f9847d4c02dd = v; });
$parcel$export($a4cb028681b2d422$exports, "container__bottomGradient", function () { return $a4cb028681b2d422$export$729ce27bdf6b5c75; }, function (v) { return $a4cb028681b2d422$export$729ce27bdf6b5c75 = v; });
$parcel$export($a4cb028681b2d422$exports, "friendLink", function () { return $a4cb028681b2d422$export$314799f5404ade86; }, function (v) { return $a4cb028681b2d422$export$314799f5404ade86 = v; });
$parcel$export($a4cb028681b2d422$exports, "friends_container", function () { return $a4cb028681b2d422$export$6abc686a628d5ead; }, function (v) { return $a4cb028681b2d422$export$6abc686a628d5ead = v; });
$parcel$export($a4cb028681b2d422$exports, "header", function () { return $a4cb028681b2d422$export$38e42c68cf43b5d4; }, function (v) { return $a4cb028681b2d422$export$38e42c68cf43b5d4 = v; });
$parcel$export($a4cb028681b2d422$exports, "header__search", function () { return $a4cb028681b2d422$export$dc3eb27efac2a865; }, function (v) { return $a4cb028681b2d422$export$dc3eb27efac2a865 = v; });
$parcel$export($a4cb028681b2d422$exports, "header__title", function () { return $a4cb028681b2d422$export$60230b607d205c38; }, function (v) { return $a4cb028681b2d422$export$60230b607d205c38 = v; });
$parcel$export($a4cb028681b2d422$exports, "header__title_new", function () { return $a4cb028681b2d422$export$3cd734981cdc5af4; }, function (v) { return $a4cb028681b2d422$export$3cd734981cdc5af4 = v; });
$parcel$export($a4cb028681b2d422$exports, "header__title_number", function () { return $a4cb028681b2d422$export$16615951758419b; }, function (v) { return $a4cb028681b2d422$export$16615951758419b = v; });
$parcel$export($a4cb028681b2d422$exports, "header__title_row", function () { return $a4cb028681b2d422$export$2511bfaf25bd56a; }, function (v) { return $a4cb028681b2d422$export$2511bfaf25bd56a = v; });
$parcel$export($a4cb028681b2d422$exports, "input", function () { return $a4cb028681b2d422$export$b7e3ae3d7c15e42e; }, function (v) { return $a4cb028681b2d422$export$b7e3ae3d7c15e42e = v; });
$parcel$export($a4cb028681b2d422$exports, "simple", function () { return $a4cb028681b2d422$export$52257e56c24a8923; }, function (v) { return $a4cb028681b2d422$export$52257e56c24a8923 = v; });
var $a4cb028681b2d422$export$34e0f9847d4c02dd;
var $a4cb028681b2d422$export$729ce27bdf6b5c75;
var $a4cb028681b2d422$export$314799f5404ade86;
var $a4cb028681b2d422$export$6abc686a628d5ead;
var $a4cb028681b2d422$export$38e42c68cf43b5d4;
var $a4cb028681b2d422$export$dc3eb27efac2a865;
var $a4cb028681b2d422$export$60230b607d205c38;
var $a4cb028681b2d422$export$3cd734981cdc5af4;
var $a4cb028681b2d422$export$16615951758419b;
var $a4cb028681b2d422$export$2511bfaf25bd56a;
var $a4cb028681b2d422$export$b7e3ae3d7c15e42e;
var $a4cb028681b2d422$export$52257e56c24a8923;
$a4cb028681b2d422$export$34e0f9847d4c02dd = `BNRKRG_container`;
$a4cb028681b2d422$export$729ce27bdf6b5c75 = `BNRKRG_container__bottomGradient`;
$a4cb028681b2d422$export$314799f5404ade86 = `BNRKRG_friendLink`;
$a4cb028681b2d422$export$6abc686a628d5ead = `BNRKRG_friends_container`;
$a4cb028681b2d422$export$38e42c68cf43b5d4 = `BNRKRG_header`;
$a4cb028681b2d422$export$dc3eb27efac2a865 = `BNRKRG_header__search`;
$a4cb028681b2d422$export$60230b607d205c38 = `BNRKRG_header__title`;
$a4cb028681b2d422$export$3cd734981cdc5af4 = `BNRKRG_header__title_new`;
$a4cb028681b2d422$export$16615951758419b = `BNRKRG_header__title_number`;
$a4cb028681b2d422$export$2511bfaf25bd56a = `BNRKRG_header__title_row`;
$a4cb028681b2d422$export$b7e3ae3d7c15e42e = `BNRKRG_input`;
$a4cb028681b2d422$export$52257e56c24a8923 = `BNRKRG_simple`;









var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
var $06248d11b68ccad3$exports = {};

$parcel$export($06248d11b68ccad3$exports, "container", function () { return $06248d11b68ccad3$export$34e0f9847d4c02dd; }, function (v) { return $06248d11b68ccad3$export$34e0f9847d4c02dd = v; });
var $06248d11b68ccad3$export$34e0f9847d4c02dd;
$06248d11b68ccad3$export$34e0f9847d4c02dd = `MboRyq_container`;






const $d97f831cb4c5b5e3$var$NewFriendModal = ({ onFriendAdded: onFriendAdded })=>{
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const [avatarID, setAvatarID] = (0, $6cds3.useState)("");
    const [isVisible, setIsVisible] = (0, $6cds3.useState)(false);
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(false);
    const [error, setError] = (0, $6cds3.useState)("");
    function showError(message) {
        setError(message);
        return false;
    }
    async function tryToAddFriend() {
        // if (!/\S+@\S+\.\S+/.test(email)) return showError('The email doesnt have a valid format');
        if (!conquer.instance || !conquer.isInitialized) return showError("There was an error when connecting to our servers. Please try again.");
        setIsLoading(true);
        let response = await conquer.instance.Friends.set(avatarID);
        console.log(response);
        setIsLoading(false);
        if (response.error || !response.avatarID) return showError(response.error || "The user doesnt exists");
        onFriendAdded === null || onFriendAdded === void 0 ? void 0 : onFriendAdded();
        setIsVisible(false);
    }
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                className: "button-small",
                onClick: ()=>{
                    setIsVisible(true);
                },
                children: "Add Friend"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $96f09411dda7faae$export$2e2bcd8739ae039), {
                visible: isVisible,
                onClose: ()=>{
                    setIsVisible(false);
                },
                title: "Add Friend",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($06248d11b68ccad3$exports))).container,
                    children: isLoading ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a22e9bdfa443b231$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $742193a6f0a9c5fe$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($06248d11b68ccad3$exports))).field,
                                type: "text",
                                placeholder: "Avatar ID",
                                onChange: (event)=>{
                                    setAvatarID(event.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                className: "button",
                                onClick: tryToAddFriend,
                                children: "Send Invitation"
                            }),
                            error && /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                                style: {
                                    color: "red",
                                    maxWidth: "75%",
                                    textAlign: "center"
                                },
                                children: error
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $d97f831cb4c5b5e3$export$2e2bcd8739ae039 = $d97f831cb4c5b5e3$var$NewFriendModal;








var $6PPF0 = parcelRequire("6PPF0");

const $e3dc9a043b396d07$var$Friends = ({ onSelected: onSelected, hideSearch: hideSearch = true, simple: simple = false, initialSelectedFriend: initialSelectedFriend })=>{
    const { search: search, setSearch: setSearch } = (0, $6cds3.useContext)((0, $f7a30d3cc05f1d27$export$abe847132b142195));
    const userContext = (0, $6cds3.useContext)((0, $260d68481938071c$export$38ee920e59704589));
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    // const [search, setSearch] = useState('');
    const [friends, setFriends] = (0, $6cds3.useState)({});
    const [otherUsers, setOtherUsers] = (0, $6cds3.useState)([]);
    const [filteredFriends, setFilteredFriends] = (0, $6cds3.useState)({});
    const [selectedFriend, setSelectedFriend] = (0, $6cds3.useState)({});
    async function loadFriends() {
        if (!userContext.userData.isLogged) return setFriends({});
        let response = await conquer.Friends.get(true);
        if (!Array.isArray(response)) setFriends({});
        let finalFriends = {};
        for (const eachFriend of response)finalFriends[eachFriend.avatarID] = eachFriend;
        setFriends(finalFriends);
        if (initialSelectedFriend && finalFriends[initialSelectedFriend]) onFriendSelected(finalFriends[initialSelectedFriend]);
    }
    (0, $6cds3.useEffect)(()=>{
        loadFriends();
    }, [
        userContext.userData
    ]);
    function onFriendAccept(friendID) {
        setFilteredFriends({
            ...filteredFriends,
            [friendID]: {
                ...filteredFriends[friendID],
                status: "active"
            }
        });
    }
    (0, $6cds3.useEffect)(function() {
        let temp = {};
        for (const eachFriend of Object.values(friends))if (simple || !search || eachFriend.firstName && eachFriend.firstName.toLowerCase().includes(search)) temp[eachFriend.avatarID] = eachFriend;
        setFilteredFriends(temp);
    }, [
        friends,
        simple
    ]);
    function onFriendSelected(friendData) {
        let result = onSelected(friendData);
        if (result && friendData) setSelectedFriend(friendData.avatarID);
    }
    // loadOtherUsers();
    (0, $6cds3.useEffect)(()=>{
        async function doWork() {
            if (!search || simple) return setOtherUsers([]);
            let response = await conquer.Avatars.getByUsername(search);
            if (!Array.isArray(response)) return setOtherUsers([]);
            let final = [];
            for (const eachUser of response){
                if (eachUser.avatarID == conquer.Avatars.ME.avatarID || friends[eachUser.avatarID]) continue;
                final.push(new (0, $0a95283b4a388957$export$2e2bcd8739ae039)(conquer, eachUser));
            }
            setOtherUsers(final);
        }
        doWork();
    }, [
        search
    ]);
    function getRemainingButtons() {
        let final = [];
        if (!simple) return final;
        for(let i = 0; i < 6 - Object.values(filteredFriends).length; i++)final.push(/*#__PURE__*/ (0, $lBpE3.jsx)("button", {
            onClick: ()=>{
                onFriendSelected();
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($a4cb028681b2d422$exports))).friendLink, simple && (0, (/*@__PURE__*/$parcel$interopDefault($a4cb028681b2d422$exports))).simple),
            children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $df8278a96b606336$export$2e2bcd8739ae039), {
                    src: "/assets/icon_profile_blue.png",
                    srcDark: "/assets/icon_profile_blue.png"
                })
            })
        }, i));
        return final;
    }
    // console.log( isSearching, search, simple );
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a4cb028681b2d422$exports))).container,
        children: [
            !simple && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a4cb028681b2d422$exports))).header,
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a4cb028681b2d422$exports))).header__title_row,
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a4cb028681b2d422$exports))).header__title,
                            children: "Friends"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($a4cb028681b2d422$exports))).header_zone, (0, (/*@__PURE__*/$parcel$interopDefault($a4cb028681b2d422$exports))).center),
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3a4595cf761cd9e9$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a4cb028681b2d422$exports))).searchInput,
                    onChange: (value)=>{
                        setSearch(value);
                    },
                    value: search
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a4cb028681b2d422$exports))).friends_container,
                children: [
                    filteredFriends && !(!simple && search) && Object.values(filteredFriends).map((friend)=>{
                        return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $e708bb3ae8d39d08$export$2e2bcd8739ae039), {
                            data: friend,
                            id: friend.avatarID,
                            onFriendAccept: onFriendAccept,
                            onFriendRemoved: loadFriends,
                            onClick: onFriendSelected,
                            simple: simple,
                            isSelected: !simple && selectedFriend == friend.avatarID
                        }, friend.avatarID);
                    }),
                    !(!simple && search) && filteredFriends && Object.values(filteredFriends).length < 6 && getRemainingButtons().map((button)=>{
                        return button;
                    }),
                    otherUsers.length > 0 && !simple && /*#__PURE__*/ (0, $lBpE3.jsx)("h3", {
                        children: "Other people"
                    }),
                    !simple && search && Object.values(otherUsers).map((friend)=>{
                        friend.status = (0, $db396e8726140e32$export$d54e9889145bdfd7).UKNOWN;
                        return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $e708bb3ae8d39d08$export$2e2bcd8739ae039), {
                            data: friend,
                            id: friend.avatarID,
                            onFriendAccept: onFriendAccept,
                            onFriendRemoved: loadFriends
                        }, friend.avatarID);
                    })
                ]
            })
        ]
    });
};
var $e3dc9a043b396d07$export$2e2bcd8739ae039 = $e3dc9a043b396d07$var$Friends;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
var $ea3ac5dab7415ac7$exports = {};

$parcel$export($ea3ac5dab7415ac7$exports, "active", function () { return $ea3ac5dab7415ac7$export$89da14300d534261; }, function (v) { return $ea3ac5dab7415ac7$export$89da14300d534261 = v; });
$parcel$export($ea3ac5dab7415ac7$exports, "column_chat", function () { return $ea3ac5dab7415ac7$export$99f7979dd5c59239; }, function (v) { return $ea3ac5dab7415ac7$export$99f7979dd5c59239 = v; });
$parcel$export($ea3ac5dab7415ac7$exports, "column_messages", function () { return $ea3ac5dab7415ac7$export$2478cba63b800034; }, function (v) { return $ea3ac5dab7415ac7$export$2478cba63b800034 = v; });
$parcel$export($ea3ac5dab7415ac7$exports, "container", function () { return $ea3ac5dab7415ac7$export$34e0f9847d4c02dd; }, function (v) { return $ea3ac5dab7415ac7$export$34e0f9847d4c02dd = v; });
$parcel$export($ea3ac5dab7415ac7$exports, "hide", function () { return $ea3ac5dab7415ac7$export$fe8985bb6374093c; }, function (v) { return $ea3ac5dab7415ac7$export$fe8985bb6374093c = v; });
$parcel$export($ea3ac5dab7415ac7$exports, "simple", function () { return $ea3ac5dab7415ac7$export$52257e56c24a8923; }, function (v) { return $ea3ac5dab7415ac7$export$52257e56c24a8923 = v; });
var $ea3ac5dab7415ac7$export$89da14300d534261;
var $ea3ac5dab7415ac7$export$99f7979dd5c59239;
var $ea3ac5dab7415ac7$export$2478cba63b800034;
var $ea3ac5dab7415ac7$export$34e0f9847d4c02dd;
var $ea3ac5dab7415ac7$export$fe8985bb6374093c;
var $ea3ac5dab7415ac7$export$52257e56c24a8923;
$ea3ac5dab7415ac7$export$89da14300d534261 = `DDo9Oq_active`;
$ea3ac5dab7415ac7$export$99f7979dd5c59239 = `DDo9Oq_column_chat`;
$ea3ac5dab7415ac7$export$2478cba63b800034 = `DDo9Oq_column_messages`;
$ea3ac5dab7415ac7$export$34e0f9847d4c02dd = `DDo9Oq_container`;
$ea3ac5dab7415ac7$export$fe8985bb6374093c = `DDo9Oq_hide`;
$ea3ac5dab7415ac7$export$52257e56c24a8923 = `DDo9Oq_simple`;



var $dpDEA = parcelRequire("dpDEA");

var $8pKQA = parcelRequire("8pKQA");

var $6cds3 = parcelRequire("6cds3");

var $aPjpj = parcelRequire("aPjpj");

var $gpuVq = parcelRequire("gpuVq");

var $jNfuS = parcelRequire("jNfuS");
var $dpDEA = parcelRequire("dpDEA");

var $8pKQA = parcelRequire("8pKQA");

var $K3j0n = parcelRequire("K3j0n");

var $iiTTJ = parcelRequire("iiTTJ");
const $f885dc3e6bc22d53$var$_excluded = [
    "sx"
];
const $f885dc3e6bc22d53$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $iiTTJ.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $f885dc3e6bc22d53$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $8pKQA.default)(props, $f885dc3e6bc22d53$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $f885dc3e6bc22d53$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $K3j0n.isPlainObject)(result)) return systemProps;
        return (0, $dpDEA.default)({}, systemProps, result);
    };
    else finalSx = (0, $dpDEA.default)({}, systemProps, inSx);
    return (0, $dpDEA.default)({}, otherProps, {
        sx: finalSx
    });
}



var $jdf6F = parcelRequire("jdf6F");

var $lBpE3 = parcelRequire("lBpE3");
"use client";
const $9ac7ed764345d143$var$_excluded = [
    "className",
    "component"
];
function $9ac7ed764345d143$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $gpuVq.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $jNfuS.default));
    const Box = /*#__PURE__*/ $6cds3.forwardRef(function Box(inProps, ref) {
        const theme = (0, $jdf6F.default)(defaultTheme);
        const _extendSxProp = (0, $f885dc3e6bc22d53$export$2e2bcd8739ae039)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $8pKQA.default)(_extendSxProp, $9ac7ed764345d143$var$_excluded);
        return /*#__PURE__*/ (0, $lBpE3.jsx)(BoxRoot, (0, $dpDEA.default)({
            as: component,
            ref: ref,
            className: (0, $aPjpj.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $8I3VB = parcelRequire("8I3VB");

var $7uJCf = parcelRequire("7uJCf");

var $hDE6h = parcelRequire("hDE6h");
"use client";
const $2125686102fb0a1f$var$defaultTheme = (0, $7uJCf.default)();
const $2125686102fb0a1f$var$Box = (0, $9ac7ed764345d143$export$2e2bcd8739ae039)({
    themeId: (0, $hDE6h.default),
    defaultTheme: $2125686102fb0a1f$var$defaultTheme,
    defaultClassName: "MuiBox-root",
    generateClassName: (0, $8I3VB.default).generate
});
var $2125686102fb0a1f$export$2e2bcd8739ae039 = $2125686102fb0a1f$var$Box;



var $6PPF0 = parcelRequire("6PPF0");


var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $a96ef94ef7a08820$exports = {};

$parcel$export($a96ef94ef7a08820$exports, "main_container", function () { return $a96ef94ef7a08820$export$efc8cd27c72d90dc; }, function (v) { return $a96ef94ef7a08820$export$efc8cd27c72d90dc = v; });
var $a96ef94ef7a08820$export$efc8cd27c72d90dc;
$a96ef94ef7a08820$export$efc8cd27c72d90dc = `K7Ld9W_main_container`;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
var $48f12740132cc051$exports = {};

$parcel$export($48f12740132cc051$exports, "active", function () { return $48f12740132cc051$export$89da14300d534261; }, function (v) { return $48f12740132cc051$export$89da14300d534261 = v; });
$parcel$export($48f12740132cc051$exports, "avatar", function () { return $48f12740132cc051$export$345c5736c8054f22; }, function (v) { return $48f12740132cc051$export$345c5736c8054f22 = v; });
$parcel$export($48f12740132cc051$exports, "backButton", function () { return $48f12740132cc051$export$8d6d009d1f06226e; }, function (v) { return $48f12740132cc051$export$8d6d009d1f06226e = v; });
$parcel$export($48f12740132cc051$exports, "chatAction", function () { return $48f12740132cc051$export$1b8e722337485284; }, function (v) { return $48f12740132cc051$export$1b8e722337485284 = v; });
$parcel$export($48f12740132cc051$exports, "container", function () { return $48f12740132cc051$export$34e0f9847d4c02dd; }, function (v) { return $48f12740132cc051$export$34e0f9847d4c02dd = v; });
$parcel$export($48f12740132cc051$exports, "container__left", function () { return $48f12740132cc051$export$f08627fca1a18e14; }, function (v) { return $48f12740132cc051$export$f08627fca1a18e14 = v; });
$parcel$export($48f12740132cc051$exports, "container__left__avatar", function () { return $48f12740132cc051$export$252f9ef57db38802; }, function (v) { return $48f12740132cc051$export$252f9ef57db38802 = v; });
$parcel$export($48f12740132cc051$exports, "container__left__info", function () { return $48f12740132cc051$export$b0a9f7e6255a553e; }, function (v) { return $48f12740132cc051$export$b0a9f7e6255a553e = v; });
$parcel$export($48f12740132cc051$exports, "container__left__info__name", function () { return $48f12740132cc051$export$708613a1e5329dd6; }, function (v) { return $48f12740132cc051$export$708613a1e5329dd6 = v; });
$parcel$export($48f12740132cc051$exports, "container__left__info__state", function () { return $48f12740132cc051$export$a97f9b23cb40478e; }, function (v) { return $48f12740132cc051$export$a97f9b23cb40478e = v; });
$parcel$export($48f12740132cc051$exports, "container__left__info__state__icon", function () { return $48f12740132cc051$export$eb3f43445151157c; }, function (v) { return $48f12740132cc051$export$eb3f43445151157c = v; });
$parcel$export($48f12740132cc051$exports, "container__left__info__state__stringActive", function () { return $48f12740132cc051$export$e9085586807a443e; }, function (v) { return $48f12740132cc051$export$e9085586807a443e = v; });
$parcel$export($48f12740132cc051$exports, "container__right", function () { return $48f12740132cc051$export$d77b467f4f3fb992; }, function (v) { return $48f12740132cc051$export$d77b467f4f3fb992 = v; });
$parcel$export($48f12740132cc051$exports, "group", function () { return $48f12740132cc051$export$e5e25fbcc1f7affe; }, function (v) { return $48f12740132cc051$export$e5e25fbcc1f7affe = v; });
$parcel$export($48f12740132cc051$exports, "setting", function () { return $48f12740132cc051$export$60d2a73d9c319f71; }, function (v) { return $48f12740132cc051$export$60d2a73d9c319f71 = v; });
$parcel$export($48f12740132cc051$exports, "topGradient", function () { return $48f12740132cc051$export$7bcbf8443bdb976c; }, function (v) { return $48f12740132cc051$export$7bcbf8443bdb976c = v; });
var $48f12740132cc051$export$89da14300d534261;
var $48f12740132cc051$export$345c5736c8054f22;
var $48f12740132cc051$export$8d6d009d1f06226e;
var $48f12740132cc051$export$1b8e722337485284;
var $48f12740132cc051$export$34e0f9847d4c02dd;
var $48f12740132cc051$export$f08627fca1a18e14;
var $48f12740132cc051$export$252f9ef57db38802;
var $48f12740132cc051$export$b0a9f7e6255a553e;
var $48f12740132cc051$export$708613a1e5329dd6;
var $48f12740132cc051$export$a97f9b23cb40478e;
var $48f12740132cc051$export$eb3f43445151157c;
var $48f12740132cc051$export$e9085586807a443e;
var $48f12740132cc051$export$d77b467f4f3fb992;
var $48f12740132cc051$export$e5e25fbcc1f7affe;
var $48f12740132cc051$export$60d2a73d9c319f71;
var $48f12740132cc051$export$7bcbf8443bdb976c;
$48f12740132cc051$export$89da14300d534261 = `-_S2mW_active`;
$48f12740132cc051$export$345c5736c8054f22 = `-_S2mW_avatar`;
$48f12740132cc051$export$8d6d009d1f06226e = `-_S2mW_backButton`;
$48f12740132cc051$export$1b8e722337485284 = `-_S2mW_chatAction`;
$48f12740132cc051$export$34e0f9847d4c02dd = `-_S2mW_container`;
$48f12740132cc051$export$f08627fca1a18e14 = `-_S2mW_container__left`;
$48f12740132cc051$export$252f9ef57db38802 = `-_S2mW_container__left__avatar`;
$48f12740132cc051$export$b0a9f7e6255a553e = `-_S2mW_container__left__info`;
$48f12740132cc051$export$708613a1e5329dd6 = `-_S2mW_container__left__info__name`;
$48f12740132cc051$export$a97f9b23cb40478e = `-_S2mW_container__left__info__state`;
$48f12740132cc051$export$eb3f43445151157c = `-_S2mW_container__left__info__state__icon`;
$48f12740132cc051$export$e9085586807a443e = `-_S2mW_container__left__info__state__stringActive`;
$48f12740132cc051$export$d77b467f4f3fb992 = `-_S2mW_container__right`;
$48f12740132cc051$export$e5e25fbcc1f7affe = `-_S2mW_group`;
$48f12740132cc051$export$60d2a73d9c319f71 = `-_S2mW_setting`;
$48f12740132cc051$export$7bcbf8443bdb976c = `-_S2mW_topGradient`;





var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");




var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
var $26abb23381f93eca$exports = {};

$parcel$export($26abb23381f93eca$exports, "actionBar", function () { return $26abb23381f93eca$export$795623e8105ba10a; }, function (v) { return $26abb23381f93eca$export$795623e8105ba10a = v; });
$parcel$export($26abb23381f93eca$exports, "hide", function () { return $26abb23381f93eca$export$fe8985bb6374093c; }, function (v) { return $26abb23381f93eca$export$fe8985bb6374093c = v; });
$parcel$export($26abb23381f93eca$exports, "videoContainer", function () { return $26abb23381f93eca$export$1dd3a692e0000769; }, function (v) { return $26abb23381f93eca$export$1dd3a692e0000769 = v; });
$parcel$export($26abb23381f93eca$exports, "videocallContainer", function () { return $26abb23381f93eca$export$8f5955470563faad; }, function (v) { return $26abb23381f93eca$export$8f5955470563faad = v; });
$parcel$export($26abb23381f93eca$exports, "videos", function () { return $26abb23381f93eca$export$44f7f66ce2177700; }, function (v) { return $26abb23381f93eca$export$44f7f66ce2177700 = v; });
var $26abb23381f93eca$export$795623e8105ba10a;
var $26abb23381f93eca$export$fe8985bb6374093c;
var $26abb23381f93eca$export$1dd3a692e0000769;
var $26abb23381f93eca$export$8f5955470563faad;
var $26abb23381f93eca$export$44f7f66ce2177700;
$26abb23381f93eca$export$795623e8105ba10a = `_4gtOlq_actionBar`;
$26abb23381f93eca$export$fe8985bb6374093c = `_4gtOlq_hide`;
$26abb23381f93eca$export$1dd3a692e0000769 = `_4gtOlq_videoContainer`;
$26abb23381f93eca$export$8f5955470563faad = `_4gtOlq_videocallContainer`;
$26abb23381f93eca$export$44f7f66ce2177700 = `_4gtOlq_videos`;




class $d9b1b8e8a2890313$var$$e8379818650e2442$export$93654d4f2d6cd524 {
    append_buffer(data) {
        this.flush();
        this._parts.push(data);
    }
    append(data) {
        this._pieces.push(data);
    }
    flush() {
        if (this._pieces.length > 0) {
            const buf = new Uint8Array(this._pieces);
            this._parts.push(buf);
            this._pieces = [];
        }
    }
    toArrayBuffer() {
        const buffer = [];
        for (const part of this._parts)buffer.push(part);
        return $d9b1b8e8a2890313$var$$e8379818650e2442$var$concatArrayBuffers(buffer).buffer;
    }
    constructor(){
        this.encoder = new TextEncoder();
        this._pieces = [];
        this._parts = [];
    }
}
function $d9b1b8e8a2890313$var$$e8379818650e2442$var$concatArrayBuffers(bufs) {
    let size = 0;
    for (const buf of bufs)size += buf.byteLength;
    const result = new Uint8Array(size);
    let offset = 0;
    for (const buf of bufs){
        const view = new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
        result.set(view, offset);
        offset += buf.byteLength;
    }
    return result;
}
function $d9b1b8e8a2890313$export$417857010dc9287f(data) {
    const unpacker = new $d9b1b8e8a2890313$var$$0cfd7828ad59115f$var$Unpacker(data);
    return unpacker.unpack();
}
function $d9b1b8e8a2890313$export$2a703dbb0cb35339(data) {
    const packer = new $d9b1b8e8a2890313$export$b9ec4b114aa40074();
    packer.pack(data);
    return packer.getBuffer();
}
class $d9b1b8e8a2890313$var$$0cfd7828ad59115f$var$Unpacker {
    unpack() {
        const type = this.unpack_uint8();
        if (type < 0x80) return type;
        else if ((type ^ 0xe0) < 0x20) return (type ^ 0xe0) - 0x20;
        let size;
        if ((size = type ^ 0xa0) <= 0x0f) return this.unpack_raw(size);
        else if ((size = type ^ 0xb0) <= 0x0f) return this.unpack_string(size);
        else if ((size = type ^ 0x90) <= 0x0f) return this.unpack_array(size);
        else if ((size = type ^ 0x80) <= 0x0f) return this.unpack_map(size);
        switch(type){
            case 0xc0:
                return null;
            case 0xc1:
                return undefined;
            case 0xc2:
                return false;
            case 0xc3:
                return true;
            case 0xca:
                return this.unpack_float();
            case 0xcb:
                return this.unpack_double();
            case 0xcc:
                return this.unpack_uint8();
            case 0xcd:
                return this.unpack_uint16();
            case 0xce:
                return this.unpack_uint32();
            case 0xcf:
                return this.unpack_uint64();
            case 0xd0:
                return this.unpack_int8();
            case 0xd1:
                return this.unpack_int16();
            case 0xd2:
                return this.unpack_int32();
            case 0xd3:
                return this.unpack_int64();
            case 0xd4:
                return undefined;
            case 0xd5:
                return undefined;
            case 0xd6:
                return undefined;
            case 0xd7:
                return undefined;
            case 0xd8:
                size = this.unpack_uint16();
                return this.unpack_string(size);
            case 0xd9:
                size = this.unpack_uint32();
                return this.unpack_string(size);
            case 0xda:
                size = this.unpack_uint16();
                return this.unpack_raw(size);
            case 0xdb:
                size = this.unpack_uint32();
                return this.unpack_raw(size);
            case 0xdc:
                size = this.unpack_uint16();
                return this.unpack_array(size);
            case 0xdd:
                size = this.unpack_uint32();
                return this.unpack_array(size);
            case 0xde:
                size = this.unpack_uint16();
                return this.unpack_map(size);
            case 0xdf:
                size = this.unpack_uint32();
                return this.unpack_map(size);
        }
    }
    unpack_uint8() {
        const byte = this.dataView[this.index] & 0xff;
        this.index++;
        return byte;
    }
    unpack_uint16() {
        const bytes = this.read(2);
        const uint16 = (bytes[0] & 0xff) * 256 + (bytes[1] & 0xff);
        this.index += 2;
        return uint16;
    }
    unpack_uint32() {
        const bytes = this.read(4);
        const uint32 = ((bytes[0] * 256 + bytes[1]) * 256 + bytes[2]) * 256 + bytes[3];
        this.index += 4;
        return uint32;
    }
    unpack_uint64() {
        const bytes = this.read(8);
        const uint64 = ((((((bytes[0] * 256 + bytes[1]) * 256 + bytes[2]) * 256 + bytes[3]) * 256 + bytes[4]) * 256 + bytes[5]) * 256 + bytes[6]) * 256 + bytes[7];
        this.index += 8;
        return uint64;
    }
    unpack_int8() {
        const uint8 = this.unpack_uint8();
        return uint8 < 0x80 ? uint8 : uint8 - 256;
    }
    unpack_int16() {
        const uint16 = this.unpack_uint16();
        return uint16 < 0x8000 ? uint16 : uint16 - 65536;
    }
    unpack_int32() {
        const uint32 = this.unpack_uint32();
        return uint32 < 2 ** 31 ? uint32 : uint32 - 2 ** 32;
    }
    unpack_int64() {
        const uint64 = this.unpack_uint64();
        return uint64 < 2 ** 63 ? uint64 : uint64 - 2 ** 64;
    }
    unpack_raw(size) {
        if (this.length < this.index + size) throw new Error(`BinaryPackFailure: index is out of range ${this.index} ${size} ${this.length}`);
        const buf = this.dataBuffer.slice(this.index, this.index + size);
        this.index += size;
        return buf;
    }
    unpack_string(size) {
        const bytes = this.read(size);
        let i = 0;
        let str = "";
        let c;
        let code;
        while(i < size){
            c = bytes[i];
            // The length of a UTF-8 sequence is specified in the first byte:
            // 0xxxxxxx means length 1,
            // 110xxxxx means length 2,
            // 1110xxxx means length 3,
            // 11110xxx means length 4.
            // 10xxxxxx is for non-initial bytes.
            if (c < 0xa0) {
                // One-byte sequence: bits 0xxxxxxx
                code = c;
                i++;
            } else if ((c ^ 0xc0) < 0x20) {
                // Two-byte sequence: bits 110xxxxx 10xxxxxx
                code = (c & 0x1f) << 6 | bytes[i + 1] & 0x3f;
                i += 2;
            } else if ((c ^ 0xe0) < 0x10) {
                // Three-byte sequence: bits 1110xxxx 10xxxxxx 10xxxxxx
                code = (c & 0x0f) << 12 | (bytes[i + 1] & 0x3f) << 6 | bytes[i + 2] & 0x3f;
                i += 3;
            } else {
                // Four-byte sequence: bits 11110xxx 10xxxxxx 10xxxxxx 10xxxxxx
                code = (c & 0x07) << 18 | (bytes[i + 1] & 0x3f) << 12 | (bytes[i + 2] & 0x3f) << 6 | bytes[i + 3] & 0x3f;
                i += 4;
            }
            str += String.fromCodePoint(code);
        }
        this.index += size;
        return str;
    }
    unpack_array(size) {
        const objects = new Array(size);
        for(let i = 0; i < size; i++)objects[i] = this.unpack();
        return objects;
    }
    unpack_map(size) {
        const map = {};
        for(let i = 0; i < size; i++){
            const key = this.unpack();
            map[key] = this.unpack();
        }
        return map;
    }
    unpack_float() {
        const uint32 = this.unpack_uint32();
        const sign = uint32 >> 31;
        const exp = (uint32 >> 23 & 0xff) - 127;
        const fraction = uint32 & 0x7fffff | 0x800000;
        return (sign === 0 ? 1 : -1) * fraction * 2 ** (exp - 23);
    }
    unpack_double() {
        const h32 = this.unpack_uint32();
        const l32 = this.unpack_uint32();
        const sign = h32 >> 31;
        const exp = (h32 >> 20 & 0x7ff) - 1023;
        const hfrac = h32 & 0xfffff | 0x100000;
        const frac = hfrac * 2 ** (exp - 20) + l32 * 2 ** (exp - 52);
        return (sign === 0 ? 1 : -1) * frac;
    }
    read(length) {
        const j = this.index;
        if (j + length <= this.length) return this.dataView.subarray(j, j + length);
        else throw new Error("BinaryPackFailure: read index out of range");
    }
    constructor(data){
        this.index = 0;
        this.dataBuffer = data;
        this.dataView = new Uint8Array(this.dataBuffer);
        this.length = this.dataBuffer.byteLength;
    }
}
class $d9b1b8e8a2890313$export$b9ec4b114aa40074 {
    getBuffer() {
        return this._bufferBuilder.toArrayBuffer();
    }
    pack(value) {
        if (typeof value === "string") this.pack_string(value);
        else if (typeof value === "number") {
            if (Math.floor(value) === value) this.pack_integer(value);
            else this.pack_double(value);
        } else if (typeof value === "boolean") {
            if (value === true) this._bufferBuilder.append(0xc3);
            else if (value === false) this._bufferBuilder.append(0xc2);
        } else if (value === undefined) this._bufferBuilder.append(0xc0);
        else if (typeof value === "object") {
            if (value === null) this._bufferBuilder.append(0xc0);
            else {
                const constructor = value.constructor;
                if (value instanceof Array) this.pack_array(value);
                else if (value instanceof ArrayBuffer) this.pack_bin(new Uint8Array(value));
                else if ("BYTES_PER_ELEMENT" in value) {
                    const v = value;
                    this.pack_bin(new Uint8Array(v.buffer, v.byteOffset, v.byteLength));
                } else if (value instanceof Date) this.pack_string(value.toString());
                else if (constructor == Object || constructor.toString().startsWith("class")) this.pack_object(value);
                else throw new Error(`Type "${constructor.toString()}" not yet supported`);
            }
        } else throw new Error(`Type "${typeof value}" not yet supported`);
        this._bufferBuilder.flush();
    }
    pack_bin(blob) {
        const length = blob.length;
        if (length <= 0x0f) this.pack_uint8(0xa0 + length);
        else if (length <= 0xffff) {
            this._bufferBuilder.append(0xda);
            this.pack_uint16(length);
        } else if (length <= 0xffffffff) {
            this._bufferBuilder.append(0xdb);
            this.pack_uint32(length);
        } else throw new Error("Invalid length");
        this._bufferBuilder.append_buffer(blob);
    }
    pack_string(str) {
        const encoded = this._textEncoder.encode(str);
        const length = encoded.length;
        if (length <= 0x0f) this.pack_uint8(0xb0 + length);
        else if (length <= 0xffff) {
            this._bufferBuilder.append(0xd8);
            this.pack_uint16(length);
        } else if (length <= 0xffffffff) {
            this._bufferBuilder.append(0xd9);
            this.pack_uint32(length);
        } else throw new Error("Invalid length");
        this._bufferBuilder.append_buffer(encoded);
    }
    pack_array(ary) {
        const length = ary.length;
        if (length <= 0x0f) this.pack_uint8(0x90 + length);
        else if (length <= 0xffff) {
            this._bufferBuilder.append(0xdc);
            this.pack_uint16(length);
        } else if (length <= 0xffffffff) {
            this._bufferBuilder.append(0xdd);
            this.pack_uint32(length);
        } else throw new Error("Invalid length");
        for(let i = 0; i < length; i++)this.pack(ary[i]);
    }
    pack_integer(num) {
        if (num >= -32 && num <= 0x7f) this._bufferBuilder.append(num & 0xff);
        else if (num >= 0x00 && num <= 0xff) {
            this._bufferBuilder.append(0xcc);
            this.pack_uint8(num);
        } else if (num >= -128 && num <= 0x7f) {
            this._bufferBuilder.append(0xd0);
            this.pack_int8(num);
        } else if (num >= 0x0000 && num <= 0xffff) {
            this._bufferBuilder.append(0xcd);
            this.pack_uint16(num);
        } else if (num >= -32768 && num <= 0x7fff) {
            this._bufferBuilder.append(0xd1);
            this.pack_int16(num);
        } else if (num >= 0x00000000 && num <= 0xffffffff) {
            this._bufferBuilder.append(0xce);
            this.pack_uint32(num);
        } else if (num >= -2147483648 && num <= 0x7fffffff) {
            this._bufferBuilder.append(0xd2);
            this.pack_int32(num);
        } else if (num >= -9223372036854776000 && num <= 0x7fffffffffffffff) {
            this._bufferBuilder.append(0xd3);
            this.pack_int64(num);
        } else if (num >= 0x0000000000000000 && num <= 0xffffffffffffffff) {
            this._bufferBuilder.append(0xcf);
            this.pack_uint64(num);
        } else throw new Error("Invalid integer");
    }
    pack_double(num) {
        let sign = 0;
        if (num < 0) {
            sign = 1;
            num = -num;
        }
        const exp = Math.floor(Math.log(num) / Math.LN2);
        const frac0 = num / 2 ** exp - 1;
        const frac1 = Math.floor(frac0 * 2 ** 52);
        const b32 = 2 ** 32;
        const h32 = sign << 31 | exp + 1023 << 20 | frac1 / b32 & 0x0fffff;
        const l32 = frac1 % b32;
        this._bufferBuilder.append(0xcb);
        this.pack_int32(h32);
        this.pack_int32(l32);
    }
    pack_object(obj) {
        const keys = Object.keys(obj);
        const length = keys.length;
        if (length <= 0x0f) this.pack_uint8(0x80 + length);
        else if (length <= 0xffff) {
            this._bufferBuilder.append(0xde);
            this.pack_uint16(length);
        } else if (length <= 0xffffffff) {
            this._bufferBuilder.append(0xdf);
            this.pack_uint32(length);
        } else throw new Error("Invalid length");
        for(const prop in obj)if (obj.hasOwnProperty(prop)) {
            this.pack(prop);
            this.pack(obj[prop]);
        }
    }
    pack_uint8(num) {
        this._bufferBuilder.append(num);
    }
    pack_uint16(num) {
        this._bufferBuilder.append(num >> 8);
        this._bufferBuilder.append(num & 0xff);
    }
    pack_uint32(num) {
        const n = num & 0xffffffff;
        this._bufferBuilder.append((n & 0xff000000) >>> 24);
        this._bufferBuilder.append((n & 0x00ff0000) >>> 16);
        this._bufferBuilder.append((n & 0x0000ff00) >>> 8);
        this._bufferBuilder.append(n & 0x000000ff);
    }
    pack_uint64(num) {
        const high = num / 2 ** 32;
        const low = num % 2 ** 32;
        this._bufferBuilder.append((high & 0xff000000) >>> 24);
        this._bufferBuilder.append((high & 0x00ff0000) >>> 16);
        this._bufferBuilder.append((high & 0x0000ff00) >>> 8);
        this._bufferBuilder.append(high & 0x000000ff);
        this._bufferBuilder.append((low & 0xff000000) >>> 24);
        this._bufferBuilder.append((low & 0x00ff0000) >>> 16);
        this._bufferBuilder.append((low & 0x0000ff00) >>> 8);
        this._bufferBuilder.append(low & 0x000000ff);
    }
    pack_int8(num) {
        this._bufferBuilder.append(num & 0xff);
    }
    pack_int16(num) {
        this._bufferBuilder.append((num & 0xff00) >> 8);
        this._bufferBuilder.append(num & 0xff);
    }
    pack_int32(num) {
        this._bufferBuilder.append(num >>> 24 & 0xff);
        this._bufferBuilder.append((num & 0x00ff0000) >>> 16);
        this._bufferBuilder.append((num & 0x0000ff00) >>> 8);
        this._bufferBuilder.append(num & 0x000000ff);
    }
    pack_int64(num) {
        const high = Math.floor(num / 2 ** 32);
        const low = num % 2 ** 32;
        this._bufferBuilder.append((high & 0xff000000) >>> 24);
        this._bufferBuilder.append((high & 0x00ff0000) >>> 16);
        this._bufferBuilder.append((high & 0x0000ff00) >>> 8);
        this._bufferBuilder.append(high & 0x000000ff);
        this._bufferBuilder.append((low & 0xff000000) >>> 24);
        this._bufferBuilder.append((low & 0x00ff0000) >>> 16);
        this._bufferBuilder.append((low & 0x0000ff00) >>> 8);
        this._bufferBuilder.append(low & 0x000000ff);
    }
    constructor(){
        this._bufferBuilder = new $d9b1b8e8a2890313$var$$e8379818650e2442$export$93654d4f2d6cd524();
        this._textEncoder = new TextEncoder();
    }
}


/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";
let $8c32ceb1592ddcbb$var$logDisabled_ = true;
let $8c32ceb1592ddcbb$var$deprecationWarnings_ = true;
function $8c32ceb1592ddcbb$export$e3c02be309be1f23(uastring, expr, pos) {
    const match = uastring.match(expr);
    return match && match.length >= pos && parseInt(match[pos], 10);
}
function $8c32ceb1592ddcbb$export$1f48841962b828b1(window1, eventNameToWrap, wrapper) {
    if (!window1.RTCPeerConnection) return;
    const proto = window1.RTCPeerConnection.prototype;
    const nativeAddEventListener = proto.addEventListener;
    proto.addEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap) return nativeAddEventListener.apply(this, arguments);
        const wrappedCallback = (e)=>{
            const modifiedEvent = wrapper(e);
            if (modifiedEvent) {
                if (cb.handleEvent) cb.handleEvent(modifiedEvent);
                else cb(modifiedEvent);
            }
        };
        this._eventMap = this._eventMap || {};
        if (!this._eventMap[eventNameToWrap]) this._eventMap[eventNameToWrap] = new Map();
        this._eventMap[eventNameToWrap].set(cb, wrappedCallback);
        return nativeAddEventListener.apply(this, [
            nativeEventName,
            wrappedCallback
        ]);
    };
    const nativeRemoveEventListener = proto.removeEventListener;
    proto.removeEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap || !this._eventMap || !this._eventMap[eventNameToWrap]) return nativeRemoveEventListener.apply(this, arguments);
        if (!this._eventMap[eventNameToWrap].has(cb)) return nativeRemoveEventListener.apply(this, arguments);
        const unwrappedCb = this._eventMap[eventNameToWrap].get(cb);
        this._eventMap[eventNameToWrap].delete(cb);
        if (this._eventMap[eventNameToWrap].size === 0) delete this._eventMap[eventNameToWrap];
        if (Object.keys(this._eventMap).length === 0) delete this._eventMap;
        return nativeRemoveEventListener.apply(this, [
            nativeEventName,
            unwrappedCb
        ]);
    };
    Object.defineProperty(proto, "on" + eventNameToWrap, {
        get () {
            return this["_on" + eventNameToWrap];
        },
        set (cb) {
            if (this["_on" + eventNameToWrap]) {
                this.removeEventListener(eventNameToWrap, this["_on" + eventNameToWrap]);
                delete this["_on" + eventNameToWrap];
            }
            if (cb) this.addEventListener(eventNameToWrap, this["_on" + eventNameToWrap] = cb);
        },
        enumerable: true,
        configurable: true
    });
}
function $8c32ceb1592ddcbb$export$afbfee8cc06fd3e4(bool) {
    if (typeof bool !== "boolean") return new Error("Argument type: " + typeof bool + ". Please use a boolean.");
    $8c32ceb1592ddcbb$var$logDisabled_ = bool;
    return bool ? "adapter.js logging disabled" : "adapter.js logging enabled";
}
function $8c32ceb1592ddcbb$export$51516be4b019e41e(bool) {
    if (typeof bool !== "boolean") return new Error("Argument type: " + typeof bool + ". Please use a boolean.");
    $8c32ceb1592ddcbb$var$deprecationWarnings_ = !bool;
    return "adapter.js deprecation warnings " + (bool ? "disabled" : "enabled");
}
function $8c32ceb1592ddcbb$export$bef1f36f5486a6a3() {
    if (typeof window === "object") {
        if ($8c32ceb1592ddcbb$var$logDisabled_) return;
        if (typeof console !== "undefined" && typeof console.log === "function") console.log.apply(console, arguments);
    }
}
function $8c32ceb1592ddcbb$export$cdd73fc4100a6ef4(oldMethod, newMethod) {
    if (!$8c32ceb1592ddcbb$var$deprecationWarnings_) return;
    console.warn(oldMethod + " is deprecated, please use " + newMethod + " instead.");
}
function $8c32ceb1592ddcbb$export$2d31490a0c05f094(window1) {
    // Returned result object.
    const result = {
        browser: null,
        version: null
    };
    // Fail early if it's not a browser
    if (typeof window1 === "undefined" || !window1.navigator || !window1.navigator.userAgent) {
        result.browser = "Not a browser.";
        return result;
    }
    const { navigator: navigator } = window1;
    if (navigator.mozGetUserMedia) {
        result.browser = "firefox";
        result.version = $8c32ceb1592ddcbb$export$e3c02be309be1f23(navigator.userAgent, /Firefox\/(\d+)\./, 1);
    } else if (navigator.webkitGetUserMedia || window1.isSecureContext === false && window1.webkitRTCPeerConnection) {
        // Chrome, Chromium, Webview, Opera.
        // Version matches Chrome/WebRTC version.
        // Chrome 74 removed webkitGetUserMedia on http as well so we need the
        // more complicated fallback to webkitRTCPeerConnection.
        result.browser = "chrome";
        result.version = $8c32ceb1592ddcbb$export$e3c02be309be1f23(navigator.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
    } else if (window1.RTCPeerConnection && navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) {
        result.browser = "safari";
        result.version = $8c32ceb1592ddcbb$export$e3c02be309be1f23(navigator.userAgent, /AppleWebKit\/(\d+)\./, 1);
        result.supportsUnifiedPlan = window1.RTCRtpTransceiver && "currentDirection" in window1.RTCRtpTransceiver.prototype;
    } else {
        result.browser = "Not a supported browser.";
        return result;
    }
    return result;
}
/**
 * Checks if something is an object.
 *
 * @param {*} val The something you want to check.
 * @return true if val is an object, false otherwise.
 */ function $8c32ceb1592ddcbb$var$isObject(val) {
    return Object.prototype.toString.call(val) === "[object Object]";
}
function $8c32ceb1592ddcbb$export$15384eac40dc88c8(data) {
    if (!$8c32ceb1592ddcbb$var$isObject(data)) return data;
    return Object.keys(data).reduce(function(accumulator, key) {
        const isObj = $8c32ceb1592ddcbb$var$isObject(data[key]);
        const value = isObj ? $8c32ceb1592ddcbb$export$15384eac40dc88c8(data[key]) : data[key];
        const isEmptyObject = isObj && !Object.keys(value).length;
        if (value === undefined || isEmptyObject) return accumulator;
        return Object.assign(accumulator, {
            [key]: value
        });
    }, {});
}
function $8c32ceb1592ddcbb$export$571b373e75babb58(stats, base, resultSet) {
    if (!base || resultSet.has(base.id)) return;
    resultSet.set(base.id, base);
    Object.keys(base).forEach((name)=>{
        if (name.endsWith("Id")) $8c32ceb1592ddcbb$export$571b373e75babb58(stats, stats.get(base[name]), resultSet);
        else if (name.endsWith("Ids")) base[name].forEach((id)=>{
            $8c32ceb1592ddcbb$export$571b373e75babb58(stats, stats.get(id), resultSet);
        });
    });
}
function $8c32ceb1592ddcbb$export$93439ffc3f787d51(result, track, outbound) {
    const streamStatsType = outbound ? "outbound-rtp" : "inbound-rtp";
    const filteredResult = new Map();
    if (track === null) return filteredResult;
    const trackStats = [];
    result.forEach((value)=>{
        if (value.type === "track" && value.trackIdentifier === track.id) trackStats.push(value);
    });
    trackStats.forEach((trackStat)=>{
        result.forEach((stats)=>{
            if (stats.type === streamStatsType && stats.trackId === trackStat.id) $8c32ceb1592ddcbb$export$571b373e75babb58(result, stats, filteredResult);
        });
    });
    return filteredResult;
}


var $0383d60919cdcbbd$exports = {};

$parcel$export($0383d60919cdcbbd$exports, "shimMediaStream", function () { return $0383d60919cdcbbd$export$33ee24e7a300bcd1; });
$parcel$export($0383d60919cdcbbd$exports, "shimOnTrack", function () { return $0383d60919cdcbbd$export$f358708f68ab068; });
$parcel$export($0383d60919cdcbbd$exports, "shimGetSendersWithDtmf", function () { return $0383d60919cdcbbd$export$a41a030a2842f5d6; });
$parcel$export($0383d60919cdcbbd$exports, "shimGetStats", function () { return $0383d60919cdcbbd$export$90608323826f0b17; });
$parcel$export($0383d60919cdcbbd$exports, "shimSenderReceiverGetStats", function () { return $0383d60919cdcbbd$export$f2f0f2338114eb4b; });
$parcel$export($0383d60919cdcbbd$exports, "shimAddTrackRemoveTrackWithNative", function () { return $0383d60919cdcbbd$export$30e3cdd46f8d5100; });
$parcel$export($0383d60919cdcbbd$exports, "shimAddTrackRemoveTrack", function () { return $0383d60919cdcbbd$export$9588259fcf4ebc91; });
$parcel$export($0383d60919cdcbbd$exports, "shimPeerConnection", function () { return $0383d60919cdcbbd$export$852a08dda9a55ea7; });
$parcel$export($0383d60919cdcbbd$exports, "fixNegotiationNeeded", function () { return $0383d60919cdcbbd$export$341293bbeaae37cb; });
$parcel$export($0383d60919cdcbbd$exports, "shimGetUserMedia", function () { return $7a3fedceac06beec$export$1ed4910f4d37dc5e; });
$parcel$export($0383d60919cdcbbd$exports, "shimGetDisplayMedia", function () { return $c6547dd9a9eafc2e$export$97270b87351d9c04; });
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
"use strict";
const $7a3fedceac06beec$var$logging = $8c32ceb1592ddcbb$export$bef1f36f5486a6a3;
function $7a3fedceac06beec$export$1ed4910f4d37dc5e(window, browserDetails) {
    const navigator = window && window.navigator;
    if (!navigator.mediaDevices) return;
    const constraintsToChrome_ = function(c) {
        if (typeof c !== "object" || c.mandatory || c.optional) return c;
        const cc = {};
        Object.keys(c).forEach((key)=>{
            if (key === "require" || key === "advanced" || key === "mediaSource") return;
            const r = typeof c[key] === "object" ? c[key] : {
                ideal: c[key]
            };
            if (r.exact !== undefined && typeof r.exact === "number") r.min = r.max = r.exact;
            const oldname_ = function(prefix, name) {
                if (prefix) return prefix + name.charAt(0).toUpperCase() + name.slice(1);
                return name === "deviceId" ? "sourceId" : name;
            };
            if (r.ideal !== undefined) {
                cc.optional = cc.optional || [];
                let oc = {};
                if (typeof r.ideal === "number") {
                    oc[oldname_("min", key)] = r.ideal;
                    cc.optional.push(oc);
                    oc = {};
                    oc[oldname_("max", key)] = r.ideal;
                    cc.optional.push(oc);
                } else {
                    oc[oldname_("", key)] = r.ideal;
                    cc.optional.push(oc);
                }
            }
            if (r.exact !== undefined && typeof r.exact !== "number") {
                cc.mandatory = cc.mandatory || {};
                cc.mandatory[oldname_("", key)] = r.exact;
            } else [
                "min",
                "max"
            ].forEach((mix)=>{
                if (r[mix] !== undefined) {
                    cc.mandatory = cc.mandatory || {};
                    cc.mandatory[oldname_(mix, key)] = r[mix];
                }
            });
        });
        if (c.advanced) cc.optional = (cc.optional || []).concat(c.advanced);
        return cc;
    };
    const shimConstraints_ = function(constraints, func) {
        if (browserDetails.version >= 61) return func(constraints);
        constraints = JSON.parse(JSON.stringify(constraints));
        if (constraints && typeof constraints.audio === "object") {
            const remap = function(obj, a, b) {
                if (a in obj && !(b in obj)) {
                    obj[b] = obj[a];
                    delete obj[a];
                }
            };
            constraints = JSON.parse(JSON.stringify(constraints));
            remap(constraints.audio, "autoGainControl", "googAutoGainControl");
            remap(constraints.audio, "noiseSuppression", "googNoiseSuppression");
            constraints.audio = constraintsToChrome_(constraints.audio);
        }
        if (constraints && typeof constraints.video === "object") {
            // Shim facingMode for mobile & surface pro.
            let face = constraints.video.facingMode;
            face = face && (typeof face === "object" ? face : {
                ideal: face
            });
            const getSupportedFacingModeLies = browserDetails.version < 66;
            if (face && (face.exact === "user" || face.exact === "environment" || face.ideal === "user" || face.ideal === "environment") && !(navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().facingMode && !getSupportedFacingModeLies)) {
                delete constraints.video.facingMode;
                let matches;
                if (face.exact === "environment" || face.ideal === "environment") matches = [
                    "back",
                    "rear"
                ];
                else if (face.exact === "user" || face.ideal === "user") matches = [
                    "front"
                ];
                if (matches) // Look for matches in label, or use last cam for back (typical).
                return navigator.mediaDevices.enumerateDevices().then((devices)=>{
                    devices = devices.filter((d)=>d.kind === "videoinput");
                    let dev = devices.find((d)=>matches.some((match)=>d.label.toLowerCase().includes(match)));
                    if (!dev && devices.length && matches.includes("back")) dev = devices[devices.length - 1]; // more likely the back cam
                    if (dev) constraints.video.deviceId = face.exact ? {
                        exact: dev.deviceId
                    } : {
                        ideal: dev.deviceId
                    };
                    constraints.video = constraintsToChrome_(constraints.video);
                    $7a3fedceac06beec$var$logging("chrome: " + JSON.stringify(constraints));
                    return func(constraints);
                });
            }
            constraints.video = constraintsToChrome_(constraints.video);
        }
        $7a3fedceac06beec$var$logging("chrome: " + JSON.stringify(constraints));
        return func(constraints);
    };
    const shimError_ = function(e) {
        if (browserDetails.version >= 64) return e;
        return {
            name: ({
                PermissionDeniedError: "NotAllowedError",
                PermissionDismissedError: "NotAllowedError",
                InvalidStateError: "NotAllowedError",
                DevicesNotFoundError: "NotFoundError",
                ConstraintNotSatisfiedError: "OverconstrainedError",
                TrackStartError: "NotReadableError",
                MediaDeviceFailedDueToShutdown: "NotAllowedError",
                MediaDeviceKillSwitchOn: "NotAllowedError",
                TabCaptureError: "AbortError",
                ScreenCaptureError: "AbortError",
                DeviceCaptureError: "AbortError"
            })[e.name] || e.name,
            message: e.message,
            constraint: e.constraint || e.constraintName,
            toString () {
                return this.name + (this.message && ": ") + this.message;
            }
        };
    };
    const getUserMedia_ = function(constraints, onSuccess, onError) {
        shimConstraints_(constraints, (c)=>{
            navigator.webkitGetUserMedia(c, onSuccess, (e)=>{
                if (onError) onError(shimError_(e));
            });
        });
    };
    navigator.getUserMedia = getUserMedia_.bind(navigator);
    // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
    // function which returns a Promise, it does not accept spec-style
    // constraints.
    if (navigator.mediaDevices.getUserMedia) {
        const origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        navigator.mediaDevices.getUserMedia = function(cs) {
            return shimConstraints_(cs, (c)=>origGetUserMedia(c).then((stream)=>{
                    if (c.audio && !stream.getAudioTracks().length || c.video && !stream.getVideoTracks().length) {
                        stream.getTracks().forEach((track)=>{
                            track.stop();
                        });
                        throw new DOMException("", "NotFoundError");
                    }
                    return stream;
                }, (e)=>Promise.reject(shimError_(e))));
        };
    }
}


/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";
function $c6547dd9a9eafc2e$export$97270b87351d9c04(window, getSourceId) {
    if (window.navigator.mediaDevices && "getDisplayMedia" in window.navigator.mediaDevices) return;
    if (!window.navigator.mediaDevices) return;
    // getSourceId is a function that returns a promise resolving with
    // the sourceId of the screen/window/tab to be shared.
    if (typeof getSourceId !== "function") {
        console.error("shimGetDisplayMedia: getSourceId argument is not a function");
        return;
    }
    window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
        return getSourceId(constraints).then((sourceId)=>{
            const widthSpecified = constraints.video && constraints.video.width;
            const heightSpecified = constraints.video && constraints.video.height;
            const frameRateSpecified = constraints.video && constraints.video.frameRate;
            constraints.video = {
                mandatory: {
                    chromeMediaSource: "desktop",
                    chromeMediaSourceId: sourceId,
                    maxFrameRate: frameRateSpecified || 3
                }
            };
            if (widthSpecified) constraints.video.mandatory.maxWidth = widthSpecified;
            if (heightSpecified) constraints.video.mandatory.maxHeight = heightSpecified;
            return window.navigator.mediaDevices.getUserMedia(constraints);
        });
    };
}


"use strict";
function $0383d60919cdcbbd$export$33ee24e7a300bcd1(window) {
    window.MediaStream = window.MediaStream || window.webkitMediaStream;
}
function $0383d60919cdcbbd$export$f358708f68ab068(window) {
    if (typeof window === "object" && window.RTCPeerConnection && !("ontrack" in window.RTCPeerConnection.prototype)) {
        Object.defineProperty(window.RTCPeerConnection.prototype, "ontrack", {
            get () {
                return this._ontrack;
            },
            set (f) {
                if (this._ontrack) this.removeEventListener("track", this._ontrack);
                this.addEventListener("track", this._ontrack = f);
            },
            enumerable: true,
            configurable: true
        });
        const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
        window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            if (!this._ontrackpoly) {
                this._ontrackpoly = (e)=>{
                    // onaddstream does not fire when a track is added to an existing
                    // stream. But stream.onaddtrack is implemented so we use that.
                    e.stream.addEventListener("addtrack", (te)=>{
                        let receiver;
                        if (window.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === te.track.id);
                        else receiver = {
                            track: te.track
                        };
                        const event = new Event("track");
                        event.track = te.track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                    e.stream.getTracks().forEach((track)=>{
                        let receiver;
                        if (window.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === track.id);
                        else receiver = {
                            track: track
                        };
                        const event = new Event("track");
                        event.track = track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                };
                this.addEventListener("addstream", this._ontrackpoly);
            }
            return origSetRemoteDescription.apply(this, arguments);
        };
    } else // even if RTCRtpTransceiver is in window, it is only used and
    // emitted in unified-plan. Unfortunately this means we need
    // to unconditionally wrap the event.
    $8c32ceb1592ddcbb$export$1f48841962b828b1(window, "track", (e)=>{
        if (!e.transceiver) Object.defineProperty(e, "transceiver", {
            value: {
                receiver: e.receiver
            }
        });
        return e;
    });
}
function $0383d60919cdcbbd$export$a41a030a2842f5d6(window) {
    // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
    if (typeof window === "object" && window.RTCPeerConnection && !("getSenders" in window.RTCPeerConnection.prototype) && "createDTMFSender" in window.RTCPeerConnection.prototype) {
        const shimSenderWithDtmf = function(pc, track) {
            return {
                track: track,
                get dtmf () {
                    if (this._dtmf === undefined) {
                        if (track.kind === "audio") this._dtmf = pc.createDTMFSender(track);
                        else this._dtmf = null;
                    }
                    return this._dtmf;
                },
                _pc: pc
            };
        };
        // augment addTrack when getSenders is not available.
        if (!window.RTCPeerConnection.prototype.getSenders) {
            window.RTCPeerConnection.prototype.getSenders = function getSenders() {
                this._senders = this._senders || [];
                return this._senders.slice(); // return a copy of the internal state.
            };
            const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
            window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
                let sender = origAddTrack.apply(this, arguments);
                if (!sender) {
                    sender = shimSenderWithDtmf(this, track);
                    this._senders.push(sender);
                }
                return sender;
            };
            const origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
            window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
                origRemoveTrack.apply(this, arguments);
                const idx = this._senders.indexOf(sender);
                if (idx !== -1) this._senders.splice(idx, 1);
            };
        }
        const origAddStream = window.RTCPeerConnection.prototype.addStream;
        window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            this._senders = this._senders || [];
            origAddStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                this._senders.push(shimSenderWithDtmf(this, track));
            });
        };
        const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
        window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
            this._senders = this._senders || [];
            origRemoveStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                const sender = this._senders.find((s)=>s.track === track);
                if (sender) this._senders.splice(this._senders.indexOf(sender), 1);
            });
        };
    } else if (typeof window === "object" && window.RTCPeerConnection && "getSenders" in window.RTCPeerConnection.prototype && "createDTMFSender" in window.RTCPeerConnection.prototype && window.RTCRtpSender && !("dtmf" in window.RTCRtpSender.prototype)) {
        const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
        window.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        Object.defineProperty(window.RTCRtpSender.prototype, "dtmf", {
            get () {
                if (this._dtmf === undefined) {
                    if (this.track.kind === "audio") this._dtmf = this._pc.createDTMFSender(this.track);
                    else this._dtmf = null;
                }
                return this._dtmf;
            }
        });
    }
}
function $0383d60919cdcbbd$export$90608323826f0b17(window) {
    if (!window.RTCPeerConnection) return;
    const origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        const [selector, onSucc, onErr] = arguments;
        // If selector is a function then we are in the old style stats so just
        // pass back the original getStats format to avoid breaking old users.
        if (arguments.length > 0 && typeof selector === "function") return origGetStats.apply(this, arguments);
        // When spec-style getStats is supported, return those when called with
        // either no arguments or the selector argument is null.
        if (origGetStats.length === 0 && (arguments.length === 0 || typeof selector !== "function")) return origGetStats.apply(this, []);
        const fixChromeStats_ = function(response) {
            const standardReport = {};
            const reports = response.result();
            reports.forEach((report)=>{
                const standardStats = {
                    id: report.id,
                    timestamp: report.timestamp,
                    type: {
                        localcandidate: "local-candidate",
                        remotecandidate: "remote-candidate"
                    }[report.type] || report.type
                };
                report.names().forEach((name)=>{
                    standardStats[name] = report.stat(name);
                });
                standardReport[standardStats.id] = standardStats;
            });
            return standardReport;
        };
        // shim getStats with maplike support
        const makeMapStats = function(stats) {
            return new Map(Object.keys(stats).map((key)=>[
                    key,
                    stats[key]
                ]));
        };
        if (arguments.length >= 2) {
            const successCallbackWrapper_ = function(response) {
                onSucc(makeMapStats(fixChromeStats_(response)));
            };
            return origGetStats.apply(this, [
                successCallbackWrapper_,
                selector
            ]);
        }
        // promise-support
        return new Promise((resolve, reject)=>{
            origGetStats.apply(this, [
                function(response) {
                    resolve(makeMapStats(fixChromeStats_(response)));
                },
                reject
            ]);
        }).then(onSucc, onErr);
    };
}
function $0383d60919cdcbbd$export$f2f0f2338114eb4b(window) {
    if (!(typeof window === "object" && window.RTCPeerConnection && window.RTCRtpSender && window.RTCRtpReceiver)) return;
    // shim sender stats.
    if (!("getStats" in window.RTCRtpSender.prototype)) {
        const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
        if (origGetSenders) window.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
        if (origAddTrack) window.RTCPeerConnection.prototype.addTrack = function addTrack() {
            const sender = origAddTrack.apply(this, arguments);
            sender._pc = this;
            return sender;
        };
        window.RTCRtpSender.prototype.getStats = function getStats() {
            const sender = this;
            return this._pc.getStats().then((result)=>/* Note: this will include stats of all senders that
         *   send a track with the same id as sender.track as
         *   it is not possible to identify the RTCRtpSender.
         */ $8c32ceb1592ddcbb$export$93439ffc3f787d51(result, sender.track, true));
        };
    }
    // shim receiver stats.
    if (!("getStats" in window.RTCRtpReceiver.prototype)) {
        const origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
        if (origGetReceivers) window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
            const receivers = origGetReceivers.apply(this, []);
            receivers.forEach((receiver)=>receiver._pc = this);
            return receivers;
        };
        $8c32ceb1592ddcbb$export$1f48841962b828b1(window, "track", (e)=>{
            e.receiver._pc = e.srcElement;
            return e;
        });
        window.RTCRtpReceiver.prototype.getStats = function getStats() {
            const receiver = this;
            return this._pc.getStats().then((result)=>$8c32ceb1592ddcbb$export$93439ffc3f787d51(result, receiver.track, false));
        };
    }
    if (!("getStats" in window.RTCRtpSender.prototype && "getStats" in window.RTCRtpReceiver.prototype)) return;
    // shim RTCPeerConnection.getStats(track).
    const origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        if (arguments.length > 0 && arguments[0] instanceof window.MediaStreamTrack) {
            const track = arguments[0];
            let sender;
            let receiver;
            let err;
            this.getSenders().forEach((s)=>{
                if (s.track === track) {
                    if (sender) err = true;
                    else sender = s;
                }
            });
            this.getReceivers().forEach((r)=>{
                if (r.track === track) {
                    if (receiver) err = true;
                    else receiver = r;
                }
                return r.track === track;
            });
            if (err || sender && receiver) return Promise.reject(new DOMException("There are more than one sender or receiver for the track.", "InvalidAccessError"));
            else if (sender) return sender.getStats();
            else if (receiver) return receiver.getStats();
            return Promise.reject(new DOMException("There is no sender or receiver for the track.", "InvalidAccessError"));
        }
        return origGetStats.apply(this, arguments);
    };
}
function $0383d60919cdcbbd$export$30e3cdd46f8d5100(window) {
    // shim addTrack/removeTrack with native variants in order to make
    // the interactions with legacy getLocalStreams behave as in other browsers.
    // Keeps a mapping stream.id => [stream, rtpsenders...]
    window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        return Object.keys(this._shimmedLocalStreams).map((streamId)=>this._shimmedLocalStreams[streamId][0]);
    };
    const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (!stream) return origAddTrack.apply(this, arguments);
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        const sender = origAddTrack.apply(this, arguments);
        if (!this._shimmedLocalStreams[stream.id]) this._shimmedLocalStreams[stream.id] = [
            stream,
            sender
        ];
        else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) this._shimmedLocalStreams[stream.id].push(sender);
        return sender;
    };
    const origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException("Track already exists.", "InvalidAccessError");
        });
        const existingSenders = this.getSenders();
        origAddStream.apply(this, arguments);
        const newSenders = this.getSenders().filter((newSender)=>existingSenders.indexOf(newSender) === -1);
        this._shimmedLocalStreams[stream.id] = [
            stream
        ].concat(newSenders);
    };
    const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        delete this._shimmedLocalStreams[stream.id];
        return origRemoveStream.apply(this, arguments);
    };
    const origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
    window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        if (sender) Object.keys(this._shimmedLocalStreams).forEach((streamId)=>{
            const idx = this._shimmedLocalStreams[streamId].indexOf(sender);
            if (idx !== -1) this._shimmedLocalStreams[streamId].splice(idx, 1);
            if (this._shimmedLocalStreams[streamId].length === 1) delete this._shimmedLocalStreams[streamId];
        });
        return origRemoveTrack.apply(this, arguments);
    };
}
function $0383d60919cdcbbd$export$9588259fcf4ebc91(window, browserDetails) {
    if (!window.RTCPeerConnection) return;
    // shim addTrack and removeTrack.
    if (window.RTCPeerConnection.prototype.addTrack && browserDetails.version >= 65) return $0383d60919cdcbbd$export$30e3cdd46f8d5100(window);
    // also shim pc.getLocalStreams when addTrack is shimmed
    // to return the original streams.
    const origGetLocalStreams = window.RTCPeerConnection.prototype.getLocalStreams;
    window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        const nativeStreams = origGetLocalStreams.apply(this);
        this._reverseStreams = this._reverseStreams || {};
        return nativeStreams.map((stream)=>this._reverseStreams[stream.id]);
    };
    const origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException("Track already exists.", "InvalidAccessError");
        });
        // Add identity mapping for consistency with addTrack.
        // Unless this is being used with a stream from addTrack.
        if (!this._reverseStreams[stream.id]) {
            const newStream = new window.MediaStream(stream.getTracks());
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            stream = newStream;
        }
        origAddStream.apply(this, [
            stream
        ]);
    };
    const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        origRemoveStream.apply(this, [
            this._streams[stream.id] || stream
        ]);
        delete this._reverseStreams[this._streams[stream.id] ? this._streams[stream.id].id : stream.id];
        delete this._streams[stream.id];
    };
    window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (this.signalingState === "closed") throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.", "InvalidStateError");
        const streams = [].slice.call(arguments, 1);
        if (streams.length !== 1 || !streams[0].getTracks().find((t)=>t === track)) // this is not fully correct but all we can manage without
        // [[associated MediaStreams]] internal slot.
        throw new DOMException("The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.", "NotSupportedError");
        const alreadyExists = this.getSenders().find((s)=>s.track === track);
        if (alreadyExists) throw new DOMException("Track already exists.", "InvalidAccessError");
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        const oldStream = this._streams[stream.id];
        if (oldStream) {
            // this is using odd Chrome behaviour, use with caution:
            // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
            // Note: we rely on the high-level addTrack/dtmf shim to
            // create the sender with a dtmf sender.
            oldStream.addTrack(track);
            // Trigger ONN async.
            Promise.resolve().then(()=>{
                this.dispatchEvent(new Event("negotiationneeded"));
            });
        } else {
            const newStream = new window.MediaStream([
                track
            ]);
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            this.addStream(newStream);
        }
        return this.getSenders().find((s)=>s.track === track);
    };
    // replace the internal stream id with the external one and
    // vice versa.
    function replaceInternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(internalStream.id, "g"), externalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    function replaceExternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(externalStream.id, "g"), internalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    [
        "createOffer",
        "createAnswer"
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                const args = arguments;
                const isLegacyCall = arguments.length && typeof arguments[0] === "function";
                if (isLegacyCall) return nativeMethod.apply(this, [
                    (description)=>{
                        const desc = replaceInternalStreamId(this, description);
                        args[0].apply(null, [
                            desc
                        ]);
                    },
                    (err)=>{
                        if (args[1]) args[1].apply(null, err);
                    },
                    arguments[2]
                ]);
                return nativeMethod.apply(this, arguments).then((description)=>replaceInternalStreamId(this, description));
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const origSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;
    window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        if (!arguments.length || !arguments[0].type) return origSetLocalDescription.apply(this, arguments);
        arguments[0] = replaceExternalStreamId(this, arguments[0]);
        return origSetLocalDescription.apply(this, arguments);
    };
    // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier
    const origLocalDescription = Object.getOwnPropertyDescriptor(window.RTCPeerConnection.prototype, "localDescription");
    Object.defineProperty(window.RTCPeerConnection.prototype, "localDescription", {
        get () {
            const description = origLocalDescription.get.apply(this);
            if (description.type === "") return description;
            return replaceInternalStreamId(this, description);
        }
    });
    window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        if (this.signalingState === "closed") throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.", "InvalidStateError");
        // We can not yet check for sender instanceof RTCRtpSender
        // since we shim RTPSender. So we check if sender._pc is set.
        if (!sender._pc) throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.", "TypeError");
        const isLocal = sender._pc === this;
        if (!isLocal) throw new DOMException("Sender was not created by this connection.", "InvalidAccessError");
        // Search for the native stream the senders track belongs to.
        this._streams = this._streams || {};
        let stream;
        Object.keys(this._streams).forEach((streamid)=>{
            const hasTrack = this._streams[streamid].getTracks().find((track)=>sender.track === track);
            if (hasTrack) stream = this._streams[streamid];
        });
        if (stream) {
            if (stream.getTracks().length === 1) // if this is the last track of the stream, remove the stream. This
            // takes care of any shimmed _senders.
            this.removeStream(this._reverseStreams[stream.id]);
            else // relying on the same odd chrome behaviour as above.
            stream.removeTrack(sender.track);
            this.dispatchEvent(new Event("negotiationneeded"));
        }
    };
}
function $0383d60919cdcbbd$export$852a08dda9a55ea7(window, browserDetails) {
    if (!window.RTCPeerConnection && window.webkitRTCPeerConnection) // very basic support for old versions.
    window.RTCPeerConnection = window.webkitRTCPeerConnection;
    if (!window.RTCPeerConnection) return;
    // shim implicit creation of RTCSessionDescription/RTCIceCandidate
    if (browserDetails.version < 53) [
        "setLocalDescription",
        "setRemoteDescription",
        "addIceCandidate"
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === "addIceCandidate" ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
}
function $0383d60919cdcbbd$export$341293bbeaae37cb(window, browserDetails) {
    $8c32ceb1592ddcbb$export$1f48841962b828b1(window, "negotiationneeded", (e)=>{
        const pc = e.target;
        if (browserDetails.version < 72 || pc.getConfiguration && pc.getConfiguration().sdpSemantics === "plan-b") {
            if (pc.signalingState !== "stable") return;
        }
        return e;
    });
}


var $023795fee9cfe0ef$exports = {};

$parcel$export($023795fee9cfe0ef$exports, "shimOnTrack", function () { return $023795fee9cfe0ef$export$f358708f68ab068; });
$parcel$export($023795fee9cfe0ef$exports, "shimPeerConnection", function () { return $023795fee9cfe0ef$export$852a08dda9a55ea7; });
$parcel$export($023795fee9cfe0ef$exports, "shimSenderGetStats", function () { return $023795fee9cfe0ef$export$f0525502095c04ef; });
$parcel$export($023795fee9cfe0ef$exports, "shimReceiverGetStats", function () { return $023795fee9cfe0ef$export$83d69126527b1171; });
$parcel$export($023795fee9cfe0ef$exports, "shimRemoveStream", function () { return $023795fee9cfe0ef$export$825e523ef749bd8c; });
$parcel$export($023795fee9cfe0ef$exports, "shimRTCDataChannel", function () { return $023795fee9cfe0ef$export$ff9cb3bc8990e8f7; });
$parcel$export($023795fee9cfe0ef$exports, "shimAddTransceiver", function () { return $023795fee9cfe0ef$export$70c77533b6e9908d; });
$parcel$export($023795fee9cfe0ef$exports, "shimGetParameters", function () { return $023795fee9cfe0ef$export$66238223c298fbaa; });
$parcel$export($023795fee9cfe0ef$exports, "shimCreateOffer", function () { return $023795fee9cfe0ef$export$51beccf0e777b843; });
$parcel$export($023795fee9cfe0ef$exports, "shimCreateAnswer", function () { return $023795fee9cfe0ef$export$df0b46e7cef08150; });
$parcel$export($023795fee9cfe0ef$exports, "shimGetUserMedia", function () { return $566988154a8e2409$export$1ed4910f4d37dc5e; });
$parcel$export($023795fee9cfe0ef$exports, "shimGetDisplayMedia", function () { return $ce586aa44cafe900$export$97270b87351d9c04; });
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
"use strict";
function $566988154a8e2409$export$1ed4910f4d37dc5e(window, browserDetails) {
    const navigator = window && window.navigator;
    const MediaStreamTrack = window && window.MediaStreamTrack;
    navigator.getUserMedia = function(constraints, onSuccess, onError) {
        // Replace Firefox 44+'s deprecation warning with unprefixed version.
        $8c32ceb1592ddcbb$export$cdd73fc4100a6ef4("navigator.getUserMedia", "navigator.mediaDevices.getUserMedia");
        navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
    };
    if (!(browserDetails.version > 55 && "autoGainControl" in navigator.mediaDevices.getSupportedConstraints())) {
        const remap = function(obj, a, b) {
            if (a in obj && !(b in obj)) {
                obj[b] = obj[a];
                delete obj[a];
            }
        };
        const nativeGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        navigator.mediaDevices.getUserMedia = function(c) {
            if (typeof c === "object" && typeof c.audio === "object") {
                c = JSON.parse(JSON.stringify(c));
                remap(c.audio, "autoGainControl", "mozAutoGainControl");
                remap(c.audio, "noiseSuppression", "mozNoiseSuppression");
            }
            return nativeGetUserMedia(c);
        };
        if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
            const nativeGetSettings = MediaStreamTrack.prototype.getSettings;
            MediaStreamTrack.prototype.getSettings = function() {
                const obj = nativeGetSettings.apply(this, arguments);
                remap(obj, "mozAutoGainControl", "autoGainControl");
                remap(obj, "mozNoiseSuppression", "noiseSuppression");
                return obj;
            };
        }
        if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
            const nativeApplyConstraints = MediaStreamTrack.prototype.applyConstraints;
            MediaStreamTrack.prototype.applyConstraints = function(c) {
                if (this.kind === "audio" && typeof c === "object") {
                    c = JSON.parse(JSON.stringify(c));
                    remap(c, "autoGainControl", "mozAutoGainControl");
                    remap(c, "noiseSuppression", "mozNoiseSuppression");
                }
                return nativeApplyConstraints.apply(this, [
                    c
                ]);
            };
        }
    }
}


/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";
function $ce586aa44cafe900$export$97270b87351d9c04(window, preferredMediaSource) {
    if (window.navigator.mediaDevices && "getDisplayMedia" in window.navigator.mediaDevices) return;
    if (!window.navigator.mediaDevices) return;
    window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
        if (!(constraints && constraints.video)) {
            const err = new DOMException("getDisplayMedia without video constraints is undefined");
            err.name = "NotFoundError";
            // from https://heycam.github.io/webidl/#idl-DOMException-error-names
            err.code = 8;
            return Promise.reject(err);
        }
        if (constraints.video === true) constraints.video = {
            mediaSource: preferredMediaSource
        };
        else constraints.video.mediaSource = preferredMediaSource;
        return window.navigator.mediaDevices.getUserMedia(constraints);
    };
}


"use strict";
function $023795fee9cfe0ef$export$f358708f68ab068(window) {
    if (typeof window === "object" && window.RTCTrackEvent && "receiver" in window.RTCTrackEvent.prototype && !("transceiver" in window.RTCTrackEvent.prototype)) Object.defineProperty(window.RTCTrackEvent.prototype, "transceiver", {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $023795fee9cfe0ef$export$852a08dda9a55ea7(window, browserDetails) {
    if (typeof window !== "object" || !(window.RTCPeerConnection || window.mozRTCPeerConnection)) return; // probably media.peerconnection.enabled=false in about:config
    if (!window.RTCPeerConnection && window.mozRTCPeerConnection) // very basic support for old versions.
    window.RTCPeerConnection = window.mozRTCPeerConnection;
    if (browserDetails.version < 53) // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
    [
        "setLocalDescription",
        "setRemoteDescription",
        "addIceCandidate"
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === "addIceCandidate" ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const modernStatsTypes = {
        inboundrtp: "inbound-rtp",
        outboundrtp: "outbound-rtp",
        candidatepair: "candidate-pair",
        localcandidate: "local-candidate",
        remotecandidate: "remote-candidate"
    };
    const nativeGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        const [selector, onSucc, onErr] = arguments;
        return nativeGetStats.apply(this, [
            selector || null
        ]).then((stats)=>{
            if (browserDetails.version < 53 && !onSucc) // Shim only promise getStats with spec-hyphens in type names
            // Leave callback version alone; misc old uses of forEach before Map
            try {
                stats.forEach((stat)=>{
                    stat.type = modernStatsTypes[stat.type] || stat.type;
                });
            } catch (e) {
                if (e.name !== "TypeError") throw e;
                // Avoid TypeError: "type" is read-only, in old versions. 34-43ish
                stats.forEach((stat, i)=>{
                    stats.set(i, Object.assign({}, stat, {
                        type: modernStatsTypes[stat.type] || stat.type
                    }));
                });
            }
            return stats;
        }).then(onSucc, onErr);
    };
}
function $023795fee9cfe0ef$export$f0525502095c04ef(window) {
    if (!(typeof window === "object" && window.RTCPeerConnection && window.RTCRtpSender)) return;
    if (window.RTCRtpSender && "getStats" in window.RTCRtpSender.prototype) return;
    const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
    if (origGetSenders) window.RTCPeerConnection.prototype.getSenders = function getSenders() {
        const senders = origGetSenders.apply(this, []);
        senders.forEach((sender)=>sender._pc = this);
        return senders;
    };
    const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    if (origAddTrack) window.RTCPeerConnection.prototype.addTrack = function addTrack() {
        const sender = origAddTrack.apply(this, arguments);
        sender._pc = this;
        return sender;
    };
    window.RTCRtpSender.prototype.getStats = function getStats() {
        return this.track ? this._pc.getStats(this.track) : Promise.resolve(new Map());
    };
}
function $023795fee9cfe0ef$export$83d69126527b1171(window) {
    if (!(typeof window === "object" && window.RTCPeerConnection && window.RTCRtpSender)) return;
    if (window.RTCRtpSender && "getStats" in window.RTCRtpReceiver.prototype) return;
    const origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
    if (origGetReceivers) window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
        const receivers = origGetReceivers.apply(this, []);
        receivers.forEach((receiver)=>receiver._pc = this);
        return receivers;
    };
    $8c32ceb1592ddcbb$export$1f48841962b828b1(window, "track", (e)=>{
        e.receiver._pc = e.srcElement;
        return e;
    });
    window.RTCRtpReceiver.prototype.getStats = function getStats() {
        return this._pc.getStats(this.track);
    };
}
function $023795fee9cfe0ef$export$825e523ef749bd8c(window) {
    if (!window.RTCPeerConnection || "removeStream" in window.RTCPeerConnection.prototype) return;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        $8c32ceb1592ddcbb$export$cdd73fc4100a6ef4("removeStream", "removeTrack");
        this.getSenders().forEach((sender)=>{
            if (sender.track && stream.getTracks().includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $023795fee9cfe0ef$export$ff9cb3bc8990e8f7(window) {
    // rename DataChannel to RTCDataChannel (native fix in FF60):
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
    if (window.DataChannel && !window.RTCDataChannel) window.RTCDataChannel = window.DataChannel;
}
function $023795fee9cfe0ef$export$70c77533b6e9908d(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === "object" && window.RTCPeerConnection)) return;
    const origAddTransceiver = window.RTCPeerConnection.prototype.addTransceiver;
    if (origAddTransceiver) window.RTCPeerConnection.prototype.addTransceiver = function addTransceiver() {
        this.setParametersPromises = [];
        // WebIDL input coercion and validation
        let sendEncodings = arguments[1] && arguments[1].sendEncodings;
        if (sendEncodings === undefined) sendEncodings = [];
        sendEncodings = [
            ...sendEncodings
        ];
        const shouldPerformCheck = sendEncodings.length > 0;
        if (shouldPerformCheck) // If sendEncodings params are provided, validate grammar
        sendEncodings.forEach((encodingParam)=>{
            if ("rid" in encodingParam) {
                const ridRegex = /^[a-z0-9]{0,16}$/i;
                if (!ridRegex.test(encodingParam.rid)) throw new TypeError("Invalid RID value provided.");
            }
            if ("scaleResolutionDownBy" in encodingParam) {
                if (!(parseFloat(encodingParam.scaleResolutionDownBy) >= 1.0)) throw new RangeError("scale_resolution_down_by must be >= 1.0");
            }
            if ("maxFramerate" in encodingParam) {
                if (!(parseFloat(encodingParam.maxFramerate) >= 0)) throw new RangeError("max_framerate must be >= 0.0");
            }
        });
        const transceiver = origAddTransceiver.apply(this, arguments);
        if (shouldPerformCheck) {
            // Check if the init options were applied. If not we do this in an
            // asynchronous way and save the promise reference in a global object.
            // This is an ugly hack, but at the same time is way more robust than
            // checking the sender parameters before and after the createOffer
            // Also note that after the createoffer we are not 100% sure that
            // the params were asynchronously applied so we might miss the
            // opportunity to recreate offer.
            const { sender: sender } = transceiver;
            const params = sender.getParameters();
            if (!("encodings" in params) || // Avoid being fooled by patched getParameters() below.
            params.encodings.length === 1 && Object.keys(params.encodings[0]).length === 0) {
                params.encodings = sendEncodings;
                sender.sendEncodings = sendEncodings;
                this.setParametersPromises.push(sender.setParameters(params).then(()=>{
                    delete sender.sendEncodings;
                }).catch(()=>{
                    delete sender.sendEncodings;
                }));
            }
        }
        return transceiver;
    };
}
function $023795fee9cfe0ef$export$66238223c298fbaa(window) {
    if (!(typeof window === "object" && window.RTCRtpSender)) return;
    const origGetParameters = window.RTCRtpSender.prototype.getParameters;
    if (origGetParameters) window.RTCRtpSender.prototype.getParameters = function getParameters() {
        const params = origGetParameters.apply(this, arguments);
        if (!("encodings" in params)) params.encodings = [].concat(this.sendEncodings || [
            {}
        ]);
        return params;
    };
}
function $023795fee9cfe0ef$export$51beccf0e777b843(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === "object" && window.RTCPeerConnection)) return;
    const origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function createOffer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateOffer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateOffer.apply(this, arguments);
    };
}
function $023795fee9cfe0ef$export$df0b46e7cef08150(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === "object" && window.RTCPeerConnection)) return;
    const origCreateAnswer = window.RTCPeerConnection.prototype.createAnswer;
    window.RTCPeerConnection.prototype.createAnswer = function createAnswer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateAnswer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateAnswer.apply(this, arguments);
    };
}


var $34b63042928c15c2$exports = {};

$parcel$export($34b63042928c15c2$exports, "shimLocalStreamsAPI", function () { return $34b63042928c15c2$export$8df41282f4fdcea2; });
$parcel$export($34b63042928c15c2$exports, "shimRemoteStreamsAPI", function () { return $34b63042928c15c2$export$762aa4cbb4f2f857; });
$parcel$export($34b63042928c15c2$exports, "shimCallbacksAPI", function () { return $34b63042928c15c2$export$da31df245debdd3; });
$parcel$export($34b63042928c15c2$exports, "shimGetUserMedia", function () { return $34b63042928c15c2$export$1ed4910f4d37dc5e; });
$parcel$export($34b63042928c15c2$exports, "shimConstraints", function () { return $34b63042928c15c2$export$494a01ac68ba81ac; });
$parcel$export($34b63042928c15c2$exports, "shimRTCIceServerUrls", function () { return $34b63042928c15c2$export$671a8b47b41b6f41; });
$parcel$export($34b63042928c15c2$exports, "shimTrackEventTransceiver", function () { return $34b63042928c15c2$export$85d53da088cb1b14; });
$parcel$export($34b63042928c15c2$exports, "shimCreateOfferLegacy", function () { return $34b63042928c15c2$export$d444266503fdd2d4; });
$parcel$export($34b63042928c15c2$exports, "shimAudioContext", function () { return $34b63042928c15c2$export$857cd739a7b795d2; });
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ 
"use strict";
function $34b63042928c15c2$export$8df41282f4fdcea2(window) {
    if (typeof window !== "object" || !window.RTCPeerConnection) return;
    if (!("getLocalStreams" in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        if (!this._localStreams) this._localStreams = [];
        return this._localStreams;
    };
    if (!("addStream" in window.RTCPeerConnection.prototype)) {
        const _addTrack = window.RTCPeerConnection.prototype.addTrack;
        window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            if (!this._localStreams) this._localStreams = [];
            if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            // Try to emulate Chrome's behaviour of adding in audio-video order.
            // Safari orders by track id.
            stream.getAudioTracks().forEach((track)=>_addTrack.call(this, track, stream));
            stream.getVideoTracks().forEach((track)=>_addTrack.call(this, track, stream));
        };
        window.RTCPeerConnection.prototype.addTrack = function addTrack(track, ...streams) {
            if (streams) streams.forEach((stream)=>{
                if (!this._localStreams) this._localStreams = [
                    stream
                ];
                else if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            });
            return _addTrack.apply(this, arguments);
        };
    }
    if (!("removeStream" in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        if (!this._localStreams) this._localStreams = [];
        const index = this._localStreams.indexOf(stream);
        if (index === -1) return;
        this._localStreams.splice(index, 1);
        const tracks = stream.getTracks();
        this.getSenders().forEach((sender)=>{
            if (tracks.includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $34b63042928c15c2$export$762aa4cbb4f2f857(window) {
    if (typeof window !== "object" || !window.RTCPeerConnection) return;
    if (!("getRemoteStreams" in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.getRemoteStreams = function getRemoteStreams() {
        return this._remoteStreams ? this._remoteStreams : [];
    };
    if (!("onaddstream" in window.RTCPeerConnection.prototype)) {
        Object.defineProperty(window.RTCPeerConnection.prototype, "onaddstream", {
            get () {
                return this._onaddstream;
            },
            set (f) {
                if (this._onaddstream) {
                    this.removeEventListener("addstream", this._onaddstream);
                    this.removeEventListener("track", this._onaddstreampoly);
                }
                this.addEventListener("addstream", this._onaddstream = f);
                this.addEventListener("track", this._onaddstreampoly = (e)=>{
                    e.streams.forEach((stream)=>{
                        if (!this._remoteStreams) this._remoteStreams = [];
                        if (this._remoteStreams.includes(stream)) return;
                        this._remoteStreams.push(stream);
                        const event = new Event("addstream");
                        event.stream = stream;
                        this.dispatchEvent(event);
                    });
                });
            }
        });
        const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
        window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            const pc = this;
            if (!this._onaddstreampoly) this.addEventListener("track", this._onaddstreampoly = function(e) {
                e.streams.forEach((stream)=>{
                    if (!pc._remoteStreams) pc._remoteStreams = [];
                    if (pc._remoteStreams.indexOf(stream) >= 0) return;
                    pc._remoteStreams.push(stream);
                    const event = new Event("addstream");
                    event.stream = stream;
                    pc.dispatchEvent(event);
                });
            });
            return origSetRemoteDescription.apply(pc, arguments);
        };
    }
}
function $34b63042928c15c2$export$da31df245debdd3(window) {
    if (typeof window !== "object" || !window.RTCPeerConnection) return;
    const prototype = window.RTCPeerConnection.prototype;
    const origCreateOffer = prototype.createOffer;
    const origCreateAnswer = prototype.createAnswer;
    const setLocalDescription = prototype.setLocalDescription;
    const setRemoteDescription = prototype.setRemoteDescription;
    const addIceCandidate = prototype.addIceCandidate;
    prototype.createOffer = function createOffer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateOffer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.createAnswer = function createAnswer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateAnswer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    let withCallback = function(description, successCallback, failureCallback) {
        const promise = setLocalDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setLocalDescription = withCallback;
    withCallback = function(description, successCallback, failureCallback) {
        const promise = setRemoteDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setRemoteDescription = withCallback;
    withCallback = function(candidate, successCallback, failureCallback) {
        const promise = addIceCandidate.apply(this, [
            candidate
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.addIceCandidate = withCallback;
}
function $34b63042928c15c2$export$1ed4910f4d37dc5e(window) {
    const navigator = window && window.navigator;
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // shim not needed in Safari 12.1
        const mediaDevices = navigator.mediaDevices;
        const _getUserMedia = mediaDevices.getUserMedia.bind(mediaDevices);
        navigator.mediaDevices.getUserMedia = (constraints)=>{
            return _getUserMedia($34b63042928c15c2$export$494a01ac68ba81ac(constraints));
        };
    }
    if (!navigator.getUserMedia && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) navigator.getUserMedia = (function getUserMedia(constraints, cb, errcb) {
        navigator.mediaDevices.getUserMedia(constraints).then(cb, errcb);
    }).bind(navigator);
}
function $34b63042928c15c2$export$494a01ac68ba81ac(constraints) {
    if (constraints && constraints.video !== undefined) return Object.assign({}, constraints, {
        video: $8c32ceb1592ddcbb$export$15384eac40dc88c8(constraints.video)
    });
    return constraints;
}
function $34b63042928c15c2$export$671a8b47b41b6f41(window) {
    if (!window.RTCPeerConnection) return;
    // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
    const OrigPeerConnection = window.RTCPeerConnection;
    window.RTCPeerConnection = function RTCPeerConnection(pcConfig, pcConstraints) {
        if (pcConfig && pcConfig.iceServers) {
            const newIceServers = [];
            for(let i = 0; i < pcConfig.iceServers.length; i++){
                let server = pcConfig.iceServers[i];
                if (server.urls === undefined && server.url) {
                    $8c32ceb1592ddcbb$export$cdd73fc4100a6ef4("RTCIceServer.url", "RTCIceServer.urls");
                    server = JSON.parse(JSON.stringify(server));
                    server.urls = server.url;
                    delete server.url;
                    newIceServers.push(server);
                } else newIceServers.push(pcConfig.iceServers[i]);
            }
            pcConfig.iceServers = newIceServers;
        }
        return new OrigPeerConnection(pcConfig, pcConstraints);
    };
    window.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
    // wrap static methods. Currently just generateCertificate.
    if ("generateCertificate" in OrigPeerConnection) Object.defineProperty(window.RTCPeerConnection, "generateCertificate", {
        get () {
            return OrigPeerConnection.generateCertificate;
        }
    });
}
function $34b63042928c15c2$export$85d53da088cb1b14(window) {
    // Add event.transceiver member over deprecated event.receiver
    if (typeof window === "object" && window.RTCTrackEvent && "receiver" in window.RTCTrackEvent.prototype && !("transceiver" in window.RTCTrackEvent.prototype)) Object.defineProperty(window.RTCTrackEvent.prototype, "transceiver", {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $34b63042928c15c2$export$d444266503fdd2d4(window) {
    const origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function createOffer(offerOptions) {
        if (offerOptions) {
            if (typeof offerOptions.offerToReceiveAudio !== "undefined") // support bit values
            offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
            const audioTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === "audio");
            if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
                if (audioTransceiver.direction === "sendrecv") {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection("sendonly");
                    else audioTransceiver.direction = "sendonly";
                } else if (audioTransceiver.direction === "recvonly") {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection("inactive");
                    else audioTransceiver.direction = "inactive";
                }
            } else if (offerOptions.offerToReceiveAudio === true && !audioTransceiver) this.addTransceiver("audio", {
                direction: "recvonly"
            });
            if (typeof offerOptions.offerToReceiveVideo !== "undefined") // support bit values
            offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
            const videoTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === "video");
            if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
                if (videoTransceiver.direction === "sendrecv") {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection("sendonly");
                    else videoTransceiver.direction = "sendonly";
                } else if (videoTransceiver.direction === "recvonly") {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection("inactive");
                    else videoTransceiver.direction = "inactive";
                }
            } else if (offerOptions.offerToReceiveVideo === true && !videoTransceiver) this.addTransceiver("video", {
                direction: "recvonly"
            });
        }
        return origCreateOffer.apply(this, arguments);
    };
}
function $34b63042928c15c2$export$857cd739a7b795d2(window) {
    if (typeof window !== "object" || window.AudioContext) return;
    window.AudioContext = window.webkitAudioContext;
}


var $b08d2165ffec3b5d$exports = {};

$parcel$export($b08d2165ffec3b5d$exports, "shimRTCIceCandidate", function () { return $b08d2165ffec3b5d$export$cf133661e444ccfe; });
$parcel$export($b08d2165ffec3b5d$exports, "shimRTCIceCandidateRelayProtocol", function () { return $b08d2165ffec3b5d$export$fdafb8d8280e29b5; });
$parcel$export($b08d2165ffec3b5d$exports, "shimMaxMessageSize", function () { return $b08d2165ffec3b5d$export$a99147c78a56edc4; });
$parcel$export($b08d2165ffec3b5d$exports, "shimSendThrowTypeError", function () { return $b08d2165ffec3b5d$export$d461c8d5c5db5da7; });
$parcel$export($b08d2165ffec3b5d$exports, "shimConnectionState", function () { return $b08d2165ffec3b5d$export$63bb816cc75460; });
$parcel$export($b08d2165ffec3b5d$exports, "removeExtmapAllowMixed", function () { return $b08d2165ffec3b5d$export$a57d114344295149; });
$parcel$export($b08d2165ffec3b5d$exports, "shimAddIceCandidateNullOrEmpty", function () { return $b08d2165ffec3b5d$export$51d5e40b48c771c7; });
$parcel$export($b08d2165ffec3b5d$exports, "shimParameterlessSetLocalDescription", function () { return $b08d2165ffec3b5d$export$7170d04e59f9d553; });
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ var $cb9aa1c4a58a062b$exports = {};
/* eslint-env node */ "use strict";
// SDP helpers.
const $cb9aa1c4a58a062b$var$SDPUtils = {};
// Generate an alphanumeric identifier for cname or mids.
// TODO: use UUIDs instead? https://gist.github.com/jed/982883
$cb9aa1c4a58a062b$var$SDPUtils.generateIdentifier = function() {
    return Math.random().toString(36).substring(2, 12);
};
// The RTCP CNAME used by all peerconnections from the same JS.
$cb9aa1c4a58a062b$var$SDPUtils.localCName = $cb9aa1c4a58a062b$var$SDPUtils.generateIdentifier();
// Splits SDP into lines, dealing with both CRLF and LF.
$cb9aa1c4a58a062b$var$SDPUtils.splitLines = function(blob) {
    return blob.trim().split("\n").map((line)=>line.trim());
};
// Splits SDP into sessionpart and mediasections. Ensures CRLF.
$cb9aa1c4a58a062b$var$SDPUtils.splitSections = function(blob) {
    const parts = blob.split("\nm=");
    return parts.map((part, index)=>(index > 0 ? "m=" + part : part).trim() + "\r\n");
};
// Returns the session description.
$cb9aa1c4a58a062b$var$SDPUtils.getDescription = function(blob) {
    const sections = $cb9aa1c4a58a062b$var$SDPUtils.splitSections(blob);
    return sections && sections[0];
};
// Returns the individual media sections.
$cb9aa1c4a58a062b$var$SDPUtils.getMediaSections = function(blob) {
    const sections = $cb9aa1c4a58a062b$var$SDPUtils.splitSections(blob);
    sections.shift();
    return sections;
};
// Returns lines that start with a certain prefix.
$cb9aa1c4a58a062b$var$SDPUtils.matchPrefix = function(blob, prefix) {
    return $cb9aa1c4a58a062b$var$SDPUtils.splitLines(blob).filter((line)=>line.indexOf(prefix) === 0);
};
// Parses an ICE candidate line. Sample input:
// candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
// rport 55996"
// Input can be prefixed with a=.
$cb9aa1c4a58a062b$var$SDPUtils.parseCandidate = function(line) {
    let parts;
    // Parse both variants.
    if (line.indexOf("a=candidate:") === 0) parts = line.substring(12).split(" ");
    else parts = line.substring(10).split(" ");
    const candidate = {
        foundation: parts[0],
        component: {
            1: "rtp",
            2: "rtcp"
        }[parts[1]] || parts[1],
        protocol: parts[2].toLowerCase(),
        priority: parseInt(parts[3], 10),
        ip: parts[4],
        address: parts[4],
        port: parseInt(parts[5], 10),
        // skip parts[6] == 'typ'
        type: parts[7]
    };
    for(let i = 8; i < parts.length; i += 2)switch(parts[i]){
        case "raddr":
            candidate.relatedAddress = parts[i + 1];
            break;
        case "rport":
            candidate.relatedPort = parseInt(parts[i + 1], 10);
            break;
        case "tcptype":
            candidate.tcpType = parts[i + 1];
            break;
        case "ufrag":
            candidate.ufrag = parts[i + 1]; // for backward compatibility.
            candidate.usernameFragment = parts[i + 1];
            break;
        default:
            if (candidate[parts[i]] === undefined) candidate[parts[i]] = parts[i + 1];
            break;
    }
    return candidate;
};
// Translates a candidate object into SDP candidate attribute.
// This does not include the a= prefix!
$cb9aa1c4a58a062b$var$SDPUtils.writeCandidate = function(candidate) {
    const sdp = [];
    sdp.push(candidate.foundation);
    const component = candidate.component;
    if (component === "rtp") sdp.push(1);
    else if (component === "rtcp") sdp.push(2);
    else sdp.push(component);
    sdp.push(candidate.protocol.toUpperCase());
    sdp.push(candidate.priority);
    sdp.push(candidate.address || candidate.ip);
    sdp.push(candidate.port);
    const type = candidate.type;
    sdp.push("typ");
    sdp.push(type);
    if (type !== "host" && candidate.relatedAddress && candidate.relatedPort) {
        sdp.push("raddr");
        sdp.push(candidate.relatedAddress);
        sdp.push("rport");
        sdp.push(candidate.relatedPort);
    }
    if (candidate.tcpType && candidate.protocol.toLowerCase() === "tcp") {
        sdp.push("tcptype");
        sdp.push(candidate.tcpType);
    }
    if (candidate.usernameFragment || candidate.ufrag) {
        sdp.push("ufrag");
        sdp.push(candidate.usernameFragment || candidate.ufrag);
    }
    return "candidate:" + sdp.join(" ");
};
// Parses an ice-options line, returns an array of option tags.
// Sample input:
// a=ice-options:foo bar
$cb9aa1c4a58a062b$var$SDPUtils.parseIceOptions = function(line) {
    return line.substring(14).split(" ");
};
// Parses a rtpmap line, returns RTCRtpCoddecParameters. Sample input:
// a=rtpmap:111 opus/48000/2
$cb9aa1c4a58a062b$var$SDPUtils.parseRtpMap = function(line) {
    let parts = line.substring(9).split(" ");
    const parsed = {
        payloadType: parseInt(parts.shift(), 10)
    };
    parts = parts[0].split("/");
    parsed.name = parts[0];
    parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
    parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
    // legacy alias, got renamed back to channels in ORTC.
    parsed.numChannels = parsed.channels;
    return parsed;
};
// Generates a rtpmap line from RTCRtpCodecCapability or
// RTCRtpCodecParameters.
$cb9aa1c4a58a062b$var$SDPUtils.writeRtpMap = function(codec) {
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    const channels = codec.channels || codec.numChannels || 1;
    return "a=rtpmap:" + pt + " " + codec.name + "/" + codec.clockRate + (channels !== 1 ? "/" + channels : "") + "\r\n";
};
// Parses a extmap line (headerextension from RFC 5285). Sample input:
// a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
// a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
$cb9aa1c4a58a062b$var$SDPUtils.parseExtmap = function(line) {
    const parts = line.substring(9).split(" ");
    return {
        id: parseInt(parts[0], 10),
        direction: parts[0].indexOf("/") > 0 ? parts[0].split("/")[1] : "sendrecv",
        uri: parts[1],
        attributes: parts.slice(2).join(" ")
    };
};
// Generates an extmap line from RTCRtpHeaderExtensionParameters or
// RTCRtpHeaderExtension.
$cb9aa1c4a58a062b$var$SDPUtils.writeExtmap = function(headerExtension) {
    return "a=extmap:" + (headerExtension.id || headerExtension.preferredId) + (headerExtension.direction && headerExtension.direction !== "sendrecv" ? "/" + headerExtension.direction : "") + " " + headerExtension.uri + (headerExtension.attributes ? " " + headerExtension.attributes : "") + "\r\n";
};
// Parses a fmtp line, returns dictionary. Sample input:
// a=fmtp:96 vbr=on;cng=on
// Also deals with vbr=on; cng=on
$cb9aa1c4a58a062b$var$SDPUtils.parseFmtp = function(line) {
    const parsed = {};
    let kv;
    const parts = line.substring(line.indexOf(" ") + 1).split(";");
    for(let j = 0; j < parts.length; j++){
        kv = parts[j].trim().split("=");
        parsed[kv[0].trim()] = kv[1];
    }
    return parsed;
};
// Generates a fmtp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
$cb9aa1c4a58a062b$var$SDPUtils.writeFmtp = function(codec) {
    let line = "";
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.parameters && Object.keys(codec.parameters).length) {
        const params = [];
        Object.keys(codec.parameters).forEach((param)=>{
            if (codec.parameters[param] !== undefined) params.push(param + "=" + codec.parameters[param]);
            else params.push(param);
        });
        line += "a=fmtp:" + pt + " " + params.join(";") + "\r\n";
    }
    return line;
};
// Parses a rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
// a=rtcp-fb:98 nack rpsi
$cb9aa1c4a58a062b$var$SDPUtils.parseRtcpFb = function(line) {
    const parts = line.substring(line.indexOf(" ") + 1).split(" ");
    return {
        type: parts.shift(),
        parameter: parts.join(" ")
    };
};
// Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
$cb9aa1c4a58a062b$var$SDPUtils.writeRtcpFb = function(codec) {
    let lines = "";
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.rtcpFeedback && codec.rtcpFeedback.length) // FIXME: special handling for trr-int?
    codec.rtcpFeedback.forEach((fb)=>{
        lines += "a=rtcp-fb:" + pt + " " + fb.type + (fb.parameter && fb.parameter.length ? " " + fb.parameter : "") + "\r\n";
    });
    return lines;
};
// Parses a RFC 5576 ssrc media attribute. Sample input:
// a=ssrc:3735928559 cname:something
$cb9aa1c4a58a062b$var$SDPUtils.parseSsrcMedia = function(line) {
    const sp = line.indexOf(" ");
    const parts = {
        ssrc: parseInt(line.substring(7, sp), 10)
    };
    const colon = line.indexOf(":", sp);
    if (colon > -1) {
        parts.attribute = line.substring(sp + 1, colon);
        parts.value = line.substring(colon + 1);
    } else parts.attribute = line.substring(sp + 1);
    return parts;
};
// Parse a ssrc-group line (see RFC 5576). Sample input:
// a=ssrc-group:semantics 12 34
$cb9aa1c4a58a062b$var$SDPUtils.parseSsrcGroup = function(line) {
    const parts = line.substring(13).split(" ");
    return {
        semantics: parts.shift(),
        ssrcs: parts.map((ssrc)=>parseInt(ssrc, 10))
    };
};
// Extracts the MID (RFC 5888) from a media section.
// Returns the MID or undefined if no mid line was found.
$cb9aa1c4a58a062b$var$SDPUtils.getMid = function(mediaSection) {
    const mid = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection, "a=mid:")[0];
    if (mid) return mid.substring(6);
};
// Parses a fingerprint line for DTLS-SRTP.
$cb9aa1c4a58a062b$var$SDPUtils.parseFingerprint = function(line) {
    const parts = line.substring(14).split(" ");
    return {
        algorithm: parts[0].toLowerCase(),
        value: parts[1].toUpperCase()
    };
};
// Extracts DTLS parameters from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the fingerprint line as input. See also getIceParameters.
$cb9aa1c4a58a062b$var$SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
    const lines = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=fingerprint:");
    // Note: a=setup line is ignored since we use the 'auto' role in Edge.
    return {
        role: "auto",
        fingerprints: lines.map($cb9aa1c4a58a062b$var$SDPUtils.parseFingerprint)
    };
};
// Serializes DTLS parameters to SDP.
$cb9aa1c4a58a062b$var$SDPUtils.writeDtlsParameters = function(params, setupType) {
    let sdp = "a=setup:" + setupType + "\r\n";
    params.fingerprints.forEach((fp)=>{
        sdp += "a=fingerprint:" + fp.algorithm + " " + fp.value + "\r\n";
    });
    return sdp;
};
// Parses a=crypto lines into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
$cb9aa1c4a58a062b$var$SDPUtils.parseCryptoLine = function(line) {
    const parts = line.substring(9).split(" ");
    return {
        tag: parseInt(parts[0], 10),
        cryptoSuite: parts[1],
        keyParams: parts[2],
        sessionParams: parts.slice(3)
    };
};
$cb9aa1c4a58a062b$var$SDPUtils.writeCryptoLine = function(parameters) {
    return "a=crypto:" + parameters.tag + " " + parameters.cryptoSuite + " " + (typeof parameters.keyParams === "object" ? $cb9aa1c4a58a062b$var$SDPUtils.writeCryptoKeyParams(parameters.keyParams) : parameters.keyParams) + (parameters.sessionParams ? " " + parameters.sessionParams.join(" ") : "") + "\r\n";
};
// Parses the crypto key parameters into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
$cb9aa1c4a58a062b$var$SDPUtils.parseCryptoKeyParams = function(keyParams) {
    if (keyParams.indexOf("inline:") !== 0) return null;
    const parts = keyParams.substring(7).split("|");
    return {
        keyMethod: "inline",
        keySalt: parts[0],
        lifeTime: parts[1],
        mkiValue: parts[2] ? parts[2].split(":")[0] : undefined,
        mkiLength: parts[2] ? parts[2].split(":")[1] : undefined
    };
};
$cb9aa1c4a58a062b$var$SDPUtils.writeCryptoKeyParams = function(keyParams) {
    return keyParams.keyMethod + ":" + keyParams.keySalt + (keyParams.lifeTime ? "|" + keyParams.lifeTime : "") + (keyParams.mkiValue && keyParams.mkiLength ? "|" + keyParams.mkiValue + ":" + keyParams.mkiLength : "");
};
// Extracts all SDES parameters.
$cb9aa1c4a58a062b$var$SDPUtils.getCryptoParameters = function(mediaSection, sessionpart) {
    const lines = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=crypto:");
    return lines.map($cb9aa1c4a58a062b$var$SDPUtils.parseCryptoLine);
};
// Parses ICE information from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the ice-ufrag and ice-pwd lines as input.
$cb9aa1c4a58a062b$var$SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
    const ufrag = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=ice-ufrag:")[0];
    const pwd = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=ice-pwd:")[0];
    if (!(ufrag && pwd)) return null;
    return {
        usernameFragment: ufrag.substring(12),
        password: pwd.substring(10)
    };
};
// Serializes ICE parameters to SDP.
$cb9aa1c4a58a062b$var$SDPUtils.writeIceParameters = function(params) {
    let sdp = "a=ice-ufrag:" + params.usernameFragment + "\r\n" + "a=ice-pwd:" + params.password + "\r\n";
    if (params.iceLite) sdp += "a=ice-lite\r\n";
    return sdp;
};
// Parses the SDP media section and returns RTCRtpParameters.
$cb9aa1c4a58a062b$var$SDPUtils.parseRtpParameters = function(mediaSection) {
    const description = {
        codecs: [],
        headerExtensions: [],
        fecMechanisms: [],
        rtcp: []
    };
    const lines = $cb9aa1c4a58a062b$var$SDPUtils.splitLines(mediaSection);
    const mline = lines[0].split(" ");
    description.profile = mline[2];
    for(let i = 3; i < mline.length; i++){
        const pt = mline[i];
        const rtpmapline = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection, "a=rtpmap:" + pt + " ")[0];
        if (rtpmapline) {
            const codec = $cb9aa1c4a58a062b$var$SDPUtils.parseRtpMap(rtpmapline);
            const fmtps = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection, "a=fmtp:" + pt + " ");
            // Only the first a=fmtp:<pt> is considered.
            codec.parameters = fmtps.length ? $cb9aa1c4a58a062b$var$SDPUtils.parseFmtp(fmtps[0]) : {};
            codec.rtcpFeedback = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-fb:" + pt + " ").map($cb9aa1c4a58a062b$var$SDPUtils.parseRtcpFb);
            description.codecs.push(codec);
            // parse FEC mechanisms from rtpmap lines.
            switch(codec.name.toUpperCase()){
                case "RED":
                case "ULPFEC":
                    description.fecMechanisms.push(codec.name.toUpperCase());
                    break;
                default:
                    break;
            }
        }
    }
    $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection, "a=extmap:").forEach((line)=>{
        description.headerExtensions.push($cb9aa1c4a58a062b$var$SDPUtils.parseExtmap(line));
    });
    const wildcardRtcpFb = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-fb:* ").map($cb9aa1c4a58a062b$var$SDPUtils.parseRtcpFb);
    description.codecs.forEach((codec)=>{
        wildcardRtcpFb.forEach((fb)=>{
            const duplicate = codec.rtcpFeedback.find((existingFeedback)=>{
                return existingFeedback.type === fb.type && existingFeedback.parameter === fb.parameter;
            });
            if (!duplicate) codec.rtcpFeedback.push(fb);
        });
    });
    // FIXME: parse rtcp.
    return description;
};
// Generates parts of the SDP media section describing the capabilities /
// parameters.
$cb9aa1c4a58a062b$var$SDPUtils.writeRtpDescription = function(kind, caps) {
    let sdp = "";
    // Build the mline.
    sdp += "m=" + kind + " ";
    sdp += caps.codecs.length > 0 ? "9" : "0"; // reject if no codecs.
    sdp += " " + (caps.profile || "UDP/TLS/RTP/SAVPF") + " ";
    sdp += caps.codecs.map((codec)=>{
        if (codec.preferredPayloadType !== undefined) return codec.preferredPayloadType;
        return codec.payloadType;
    }).join(" ") + "\r\n";
    sdp += "c=IN IP4 0.0.0.0\r\n";
    sdp += "a=rtcp:9 IN IP4 0.0.0.0\r\n";
    // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
    caps.codecs.forEach((codec)=>{
        sdp += $cb9aa1c4a58a062b$var$SDPUtils.writeRtpMap(codec);
        sdp += $cb9aa1c4a58a062b$var$SDPUtils.writeFmtp(codec);
        sdp += $cb9aa1c4a58a062b$var$SDPUtils.writeRtcpFb(codec);
    });
    let maxptime = 0;
    caps.codecs.forEach((codec)=>{
        if (codec.maxptime > maxptime) maxptime = codec.maxptime;
    });
    if (maxptime > 0) sdp += "a=maxptime:" + maxptime + "\r\n";
    if (caps.headerExtensions) caps.headerExtensions.forEach((extension)=>{
        sdp += $cb9aa1c4a58a062b$var$SDPUtils.writeExtmap(extension);
    });
    // FIXME: write fecMechanisms.
    return sdp;
};
// Parses the SDP media section and returns an array of
// RTCRtpEncodingParameters.
$cb9aa1c4a58a062b$var$SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
    const encodingParameters = [];
    const description = $cb9aa1c4a58a062b$var$SDPUtils.parseRtpParameters(mediaSection);
    const hasRed = description.fecMechanisms.indexOf("RED") !== -1;
    const hasUlpfec = description.fecMechanisms.indexOf("ULPFEC") !== -1;
    // filter a=ssrc:... cname:, ignore PlanB-msid
    const ssrcs = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map((line)=>$cb9aa1c4a58a062b$var$SDPUtils.parseSsrcMedia(line)).filter((parts)=>parts.attribute === "cname");
    const primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
    let secondarySsrc;
    const flows = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc-group:FID").map((line)=>{
        const parts = line.substring(17).split(" ");
        return parts.map((part)=>parseInt(part, 10));
    });
    if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) secondarySsrc = flows[0][1];
    description.codecs.forEach((codec)=>{
        if (codec.name.toUpperCase() === "RTX" && codec.parameters.apt) {
            let encParam = {
                ssrc: primarySsrc,
                codecPayloadType: parseInt(codec.parameters.apt, 10)
            };
            if (primarySsrc && secondarySsrc) encParam.rtx = {
                ssrc: secondarySsrc
            };
            encodingParameters.push(encParam);
            if (hasRed) {
                encParam = JSON.parse(JSON.stringify(encParam));
                encParam.fec = {
                    ssrc: primarySsrc,
                    mechanism: hasUlpfec ? "red+ulpfec" : "red"
                };
                encodingParameters.push(encParam);
            }
        }
    });
    if (encodingParameters.length === 0 && primarySsrc) encodingParameters.push({
        ssrc: primarySsrc
    });
    // we support both b=AS and b=TIAS but interpret AS as TIAS.
    let bandwidth = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection, "b=");
    if (bandwidth.length) {
        if (bandwidth[0].indexOf("b=TIAS:") === 0) bandwidth = parseInt(bandwidth[0].substring(7), 10);
        else if (bandwidth[0].indexOf("b=AS:") === 0) // use formula from JSEP to convert b=AS to TIAS value.
        bandwidth = parseInt(bandwidth[0].substring(5), 10) * 950 - 16000;
        else bandwidth = undefined;
        encodingParameters.forEach((params)=>{
            params.maxBitrate = bandwidth;
        });
    }
    return encodingParameters;
};
// parses http://draft.ortc.org/#rtcrtcpparameters*
$cb9aa1c4a58a062b$var$SDPUtils.parseRtcpParameters = function(mediaSection) {
    const rtcpParameters = {};
    // Gets the first SSRC. Note that with RTX there might be multiple
    // SSRCs.
    const remoteSsrc = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map((line)=>$cb9aa1c4a58a062b$var$SDPUtils.parseSsrcMedia(line)).filter((obj)=>obj.attribute === "cname")[0];
    if (remoteSsrc) {
        rtcpParameters.cname = remoteSsrc.value;
        rtcpParameters.ssrc = remoteSsrc.ssrc;
    }
    // Edge uses the compound attribute instead of reducedSize
    // compound is !reducedSize
    const rsize = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-rsize");
    rtcpParameters.reducedSize = rsize.length > 0;
    rtcpParameters.compound = rsize.length === 0;
    // parses the rtcp-mux attrіbute.
    // Note that Edge does not support unmuxed RTCP.
    const mux = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-mux");
    rtcpParameters.mux = mux.length > 0;
    return rtcpParameters;
};
$cb9aa1c4a58a062b$var$SDPUtils.writeRtcpParameters = function(rtcpParameters) {
    let sdp = "";
    if (rtcpParameters.reducedSize) sdp += "a=rtcp-rsize\r\n";
    if (rtcpParameters.mux) sdp += "a=rtcp-mux\r\n";
    if (rtcpParameters.ssrc !== undefined && rtcpParameters.cname) sdp += "a=ssrc:" + rtcpParameters.ssrc + " cname:" + rtcpParameters.cname + "\r\n";
    return sdp;
};
// parses either a=msid: or a=ssrc:... msid lines and returns
// the id of the MediaStream and MediaStreamTrack.
$cb9aa1c4a58a062b$var$SDPUtils.parseMsid = function(mediaSection) {
    let parts;
    const spec = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection, "a=msid:");
    if (spec.length === 1) {
        parts = spec[0].substring(7).split(" ");
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
    const planB = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map((line)=>$cb9aa1c4a58a062b$var$SDPUtils.parseSsrcMedia(line)).filter((msidParts)=>msidParts.attribute === "msid");
    if (planB.length > 0) {
        parts = planB[0].value.split(" ");
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
};
// SCTP
// parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
// to draft-ietf-mmusic-sctp-sdp-05
$cb9aa1c4a58a062b$var$SDPUtils.parseSctpDescription = function(mediaSection) {
    const mline = $cb9aa1c4a58a062b$var$SDPUtils.parseMLine(mediaSection);
    const maxSizeLine = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection, "a=max-message-size:");
    let maxMessageSize;
    if (maxSizeLine.length > 0) maxMessageSize = parseInt(maxSizeLine[0].substring(19), 10);
    if (isNaN(maxMessageSize)) maxMessageSize = 65536;
    const sctpPort = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection, "a=sctp-port:");
    if (sctpPort.length > 0) return {
        port: parseInt(sctpPort[0].substring(12), 10),
        protocol: mline.fmt,
        maxMessageSize: maxMessageSize
    };
    const sctpMapLines = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection, "a=sctpmap:");
    if (sctpMapLines.length > 0) {
        const parts = sctpMapLines[0].substring(10).split(" ");
        return {
            port: parseInt(parts[0], 10),
            protocol: parts[1],
            maxMessageSize: maxMessageSize
        };
    }
};
// SCTP
// outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
// support by now receiving in this format, unless we originally parsed
// as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
// protocol of DTLS/SCTP -- without UDP/ or TCP/)
$cb9aa1c4a58a062b$var$SDPUtils.writeSctpDescription = function(media, sctp) {
    let output = [];
    if (media.protocol !== "DTLS/SCTP") output = [
        "m=" + media.kind + " 9 " + media.protocol + " " + sctp.protocol + "\r\n",
        "c=IN IP4 0.0.0.0\r\n",
        "a=sctp-port:" + sctp.port + "\r\n"
    ];
    else output = [
        "m=" + media.kind + " 9 " + media.protocol + " " + sctp.port + "\r\n",
        "c=IN IP4 0.0.0.0\r\n",
        "a=sctpmap:" + sctp.port + " " + sctp.protocol + " 65535\r\n"
    ];
    if (sctp.maxMessageSize !== undefined) output.push("a=max-message-size:" + sctp.maxMessageSize + "\r\n");
    return output.join("");
};
// Generate a session ID for SDP.
// https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
// recommends using a cryptographically random +ve 64-bit value
// but right now this should be acceptable and within the right range
$cb9aa1c4a58a062b$var$SDPUtils.generateSessionId = function() {
    return Math.random().toString().substr(2, 22);
};
// Write boiler plate for start of SDP
// sessId argument is optional - if not supplied it will
// be generated randomly
// sessVersion is optional and defaults to 2
// sessUser is optional and defaults to 'thisisadapterortc'
$cb9aa1c4a58a062b$var$SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
    let sessionId;
    const version = sessVer !== undefined ? sessVer : 2;
    if (sessId) sessionId = sessId;
    else sessionId = $cb9aa1c4a58a062b$var$SDPUtils.generateSessionId();
    const user = sessUser || "thisisadapterortc";
    // FIXME: sess-id should be an NTP timestamp.
    return "v=0\r\no=" + user + " " + sessionId + " " + version + " IN IP4 127.0.0.1\r\n" + "s=-\r\n" + "t=0 0\r\n";
};
// Gets the direction from the mediaSection or the sessionpart.
$cb9aa1c4a58a062b$var$SDPUtils.getDirection = function(mediaSection, sessionpart) {
    // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
    const lines = $cb9aa1c4a58a062b$var$SDPUtils.splitLines(mediaSection);
    for(let i = 0; i < lines.length; i++)switch(lines[i]){
        case "a=sendrecv":
        case "a=sendonly":
        case "a=recvonly":
        case "a=inactive":
            return lines[i].substring(2);
        default:
    }
    if (sessionpart) return $cb9aa1c4a58a062b$var$SDPUtils.getDirection(sessionpart);
    return "sendrecv";
};
$cb9aa1c4a58a062b$var$SDPUtils.getKind = function(mediaSection) {
    const lines = $cb9aa1c4a58a062b$var$SDPUtils.splitLines(mediaSection);
    const mline = lines[0].split(" ");
    return mline[0].substring(2);
};
$cb9aa1c4a58a062b$var$SDPUtils.isRejected = function(mediaSection) {
    return mediaSection.split(" ", 2)[1] === "0";
};
$cb9aa1c4a58a062b$var$SDPUtils.parseMLine = function(mediaSection) {
    const lines = $cb9aa1c4a58a062b$var$SDPUtils.splitLines(mediaSection);
    const parts = lines[0].substring(2).split(" ");
    return {
        kind: parts[0],
        port: parseInt(parts[1], 10),
        protocol: parts[2],
        fmt: parts.slice(3).join(" ")
    };
};
$cb9aa1c4a58a062b$var$SDPUtils.parseOLine = function(mediaSection) {
    const line = $cb9aa1c4a58a062b$var$SDPUtils.matchPrefix(mediaSection, "o=")[0];
    const parts = line.substring(2).split(" ");
    return {
        username: parts[0],
        sessionId: parts[1],
        sessionVersion: parseInt(parts[2], 10),
        netType: parts[3],
        addressType: parts[4],
        address: parts[5]
    };
};
// a very naive interpretation of a valid SDP.
$cb9aa1c4a58a062b$var$SDPUtils.isValidSDP = function(blob) {
    if (typeof blob !== "string" || blob.length === 0) return false;
    const lines = $cb9aa1c4a58a062b$var$SDPUtils.splitLines(blob);
    for(let i = 0; i < lines.length; i++){
        if (lines[i].length < 2 || lines[i].charAt(1) !== "=") return false;
    // TODO: check the modifier a bit more.
    }
    return true;
};
$cb9aa1c4a58a062b$exports = $cb9aa1c4a58a062b$var$SDPUtils;



"use strict";
function $b08d2165ffec3b5d$export$cf133661e444ccfe(window) {
    // foundation is arbitrarily chosen as an indicator for full support for
    // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
    if (!window.RTCIceCandidate || window.RTCIceCandidate && "foundation" in window.RTCIceCandidate.prototype) return;
    const NativeRTCIceCandidate = window.RTCIceCandidate;
    window.RTCIceCandidate = function RTCIceCandidate(args) {
        // Remove the a= which shouldn't be part of the candidate string.
        if (typeof args === "object" && args.candidate && args.candidate.indexOf("a=") === 0) {
            args = JSON.parse(JSON.stringify(args));
            args.candidate = args.candidate.substring(2);
        }
        if (args.candidate && args.candidate.length) {
            // Augment the native candidate with the parsed fields.
            const nativeCandidate = new NativeRTCIceCandidate(args);
            const parsedCandidate = (0, (/*@__PURE__*/$parcel$interopDefault($cb9aa1c4a58a062b$exports))).parseCandidate(args.candidate);
            for(const key in parsedCandidate)if (!(key in nativeCandidate)) Object.defineProperty(nativeCandidate, key, {
                value: parsedCandidate[key]
            });
            // Override serializer to not serialize the extra attributes.
            nativeCandidate.toJSON = function toJSON() {
                return {
                    candidate: nativeCandidate.candidate,
                    sdpMid: nativeCandidate.sdpMid,
                    sdpMLineIndex: nativeCandidate.sdpMLineIndex,
                    usernameFragment: nativeCandidate.usernameFragment
                };
            };
            return nativeCandidate;
        }
        return new NativeRTCIceCandidate(args);
    };
    window.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $8c32ceb1592ddcbb$export$1f48841962b828b1(window, "icecandidate", (e)=>{
        if (e.candidate) Object.defineProperty(e, "candidate", {
            value: new window.RTCIceCandidate(e.candidate),
            writable: "false"
        });
        return e;
    });
}
function $b08d2165ffec3b5d$export$fdafb8d8280e29b5(window) {
    if (!window.RTCIceCandidate || window.RTCIceCandidate && "relayProtocol" in window.RTCIceCandidate.prototype) return;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $8c32ceb1592ddcbb$export$1f48841962b828b1(window, "icecandidate", (e)=>{
        if (e.candidate) {
            const parsedCandidate = (0, (/*@__PURE__*/$parcel$interopDefault($cb9aa1c4a58a062b$exports))).parseCandidate(e.candidate.candidate);
            if (parsedCandidate.type === "relay") // This is a libwebrtc-specific mapping of local type preference
            // to relayProtocol.
            e.candidate.relayProtocol = ({
                0: "tls",
                1: "tcp",
                2: "udp"
            })[parsedCandidate.priority >> 24];
        }
        return e;
    });
}
function $b08d2165ffec3b5d$export$a99147c78a56edc4(window, browserDetails) {
    if (!window.RTCPeerConnection) return;
    if (!("sctp" in window.RTCPeerConnection.prototype)) Object.defineProperty(window.RTCPeerConnection.prototype, "sctp", {
        get () {
            return typeof this._sctp === "undefined" ? null : this._sctp;
        }
    });
    const sctpInDescription = function(description) {
        if (!description || !description.sdp) return false;
        const sections = (0, (/*@__PURE__*/$parcel$interopDefault($cb9aa1c4a58a062b$exports))).splitSections(description.sdp);
        sections.shift();
        return sections.some((mediaSection)=>{
            const mLine = (0, (/*@__PURE__*/$parcel$interopDefault($cb9aa1c4a58a062b$exports))).parseMLine(mediaSection);
            return mLine && mLine.kind === "application" && mLine.protocol.indexOf("SCTP") !== -1;
        });
    };
    const getRemoteFirefoxVersion = function(description) {
        // TODO: Is there a better solution for detecting Firefox?
        const match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
        if (match === null || match.length < 2) return -1;
        const version = parseInt(match[1], 10);
        // Test for NaN (yes, this is ugly)
        return version !== version ? -1 : version;
    };
    const getCanSendMaxMessageSize = function(remoteIsFirefox) {
        // Every implementation we know can send at least 64 KiB.
        // Note: Although Chrome is technically able to send up to 256 KiB, the
        //       data does not reach the other peer reliably.
        //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
        let canSendMaxMessageSize = 65536;
        if (browserDetails.browser === "firefox") {
            if (browserDetails.version < 57) {
                if (remoteIsFirefox === -1) // FF < 57 will send in 16 KiB chunks using the deprecated PPID
                // fragmentation.
                canSendMaxMessageSize = 16384;
                else // However, other FF (and RAWRTC) can reassemble PPID-fragmented
                // messages. Thus, supporting ~2 GiB when sending.
                canSendMaxMessageSize = 2147483637;
            } else if (browserDetails.version < 60) // Currently, all FF >= 57 will reset the remote maximum message size
            // to the default value when a data channel is created at a later
            // stage. :(
            // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
            canSendMaxMessageSize = browserDetails.version === 57 ? 65535 : 65536;
            else // FF >= 60 supports sending ~2 GiB
            canSendMaxMessageSize = 2147483637;
        }
        return canSendMaxMessageSize;
    };
    const getMaxMessageSize = function(description, remoteIsFirefox) {
        // Note: 65536 bytes is the default value from the SDP spec. Also,
        //       every implementation we know supports receiving 65536 bytes.
        let maxMessageSize = 65536;
        // FF 57 has a slightly incorrect default remote max message size, so
        // we need to adjust it here to avoid a failure when sending.
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697
        if (browserDetails.browser === "firefox" && browserDetails.version === 57) maxMessageSize = 65535;
        const match = (0, (/*@__PURE__*/$parcel$interopDefault($cb9aa1c4a58a062b$exports))).matchPrefix(description.sdp, "a=max-message-size:");
        if (match.length > 0) maxMessageSize = parseInt(match[0].substring(19), 10);
        else if (browserDetails.browser === "firefox" && remoteIsFirefox !== -1) // If the maximum message size is not present in the remote SDP and
        // both local and remote are Firefox, the remote peer can receive
        // ~2 GiB.
        maxMessageSize = 2147483637;
        return maxMessageSize;
    };
    const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
        this._sctp = null;
        // Chrome decided to not expose .sctp in plan-b mode.
        // As usual, adapter.js has to do an 'ugly worakaround'
        // to cover up the mess.
        if (browserDetails.browser === "chrome" && browserDetails.version >= 76) {
            const { sdpSemantics: sdpSemantics } = this.getConfiguration();
            if (sdpSemantics === "plan-b") Object.defineProperty(this, "sctp", {
                get () {
                    return typeof this._sctp === "undefined" ? null : this._sctp;
                },
                enumerable: true,
                configurable: true
            });
        }
        if (sctpInDescription(arguments[0])) {
            // Check if the remote is FF.
            const isFirefox = getRemoteFirefoxVersion(arguments[0]);
            // Get the maximum message size the local peer is capable of sending
            const canSendMMS = getCanSendMaxMessageSize(isFirefox);
            // Get the maximum message size of the remote peer.
            const remoteMMS = getMaxMessageSize(arguments[0], isFirefox);
            // Determine final maximum message size
            let maxMessageSize;
            if (canSendMMS === 0 && remoteMMS === 0) maxMessageSize = Number.POSITIVE_INFINITY;
            else if (canSendMMS === 0 || remoteMMS === 0) maxMessageSize = Math.max(canSendMMS, remoteMMS);
            else maxMessageSize = Math.min(canSendMMS, remoteMMS);
            // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
            // attribute.
            const sctp = {};
            Object.defineProperty(sctp, "maxMessageSize", {
                get () {
                    return maxMessageSize;
                }
            });
            this._sctp = sctp;
        }
        return origSetRemoteDescription.apply(this, arguments);
    };
}
function $b08d2165ffec3b5d$export$d461c8d5c5db5da7(window) {
    if (!(window.RTCPeerConnection && "createDataChannel" in window.RTCPeerConnection.prototype)) return;
    // Note: Although Firefox >= 57 has a native implementation, the maximum
    //       message size can be reset for all data channels at a later stage.
    //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
    function wrapDcSend(dc, pc) {
        const origDataChannelSend = dc.send;
        dc.send = function send() {
            const data = arguments[0];
            const length = data.length || data.size || data.byteLength;
            if (dc.readyState === "open" && pc.sctp && length > pc.sctp.maxMessageSize) throw new TypeError("Message too large (can send a maximum of " + pc.sctp.maxMessageSize + " bytes)");
            return origDataChannelSend.apply(dc, arguments);
        };
    }
    const origCreateDataChannel = window.RTCPeerConnection.prototype.createDataChannel;
    window.RTCPeerConnection.prototype.createDataChannel = function createDataChannel() {
        const dataChannel = origCreateDataChannel.apply(this, arguments);
        wrapDcSend(dataChannel, this);
        return dataChannel;
    };
    $8c32ceb1592ddcbb$export$1f48841962b828b1(window, "datachannel", (e)=>{
        wrapDcSend(e.channel, e.target);
        return e;
    });
}
function $b08d2165ffec3b5d$export$63bb816cc75460(window) {
    if (!window.RTCPeerConnection || "connectionState" in window.RTCPeerConnection.prototype) return;
    const proto = window.RTCPeerConnection.prototype;
    Object.defineProperty(proto, "connectionState", {
        get () {
            return ({
                completed: "connected",
                checking: "connecting"
            })[this.iceConnectionState] || this.iceConnectionState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(proto, "onconnectionstatechange", {
        get () {
            return this._onconnectionstatechange || null;
        },
        set (cb) {
            if (this._onconnectionstatechange) {
                this.removeEventListener("connectionstatechange", this._onconnectionstatechange);
                delete this._onconnectionstatechange;
            }
            if (cb) this.addEventListener("connectionstatechange", this._onconnectionstatechange = cb);
        },
        enumerable: true,
        configurable: true
    });
    [
        "setLocalDescription",
        "setRemoteDescription"
    ].forEach((method)=>{
        const origMethod = proto[method];
        proto[method] = function() {
            if (!this._connectionstatechangepoly) {
                this._connectionstatechangepoly = (e)=>{
                    const pc = e.target;
                    if (pc._lastConnectionState !== pc.connectionState) {
                        pc._lastConnectionState = pc.connectionState;
                        const newEvent = new Event("connectionstatechange", e);
                        pc.dispatchEvent(newEvent);
                    }
                    return e;
                };
                this.addEventListener("iceconnectionstatechange", this._connectionstatechangepoly);
            }
            return origMethod.apply(this, arguments);
        };
    });
}
function $b08d2165ffec3b5d$export$a57d114344295149(window, browserDetails) {
    /* remove a=extmap-allow-mixed for webrtc.org < M71 */ if (!window.RTCPeerConnection) return;
    if (browserDetails.browser === "chrome" && browserDetails.version >= 71) return;
    if (browserDetails.browser === "safari" && browserDetails.version >= 605) return;
    const nativeSRD = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription(desc) {
        if (desc && desc.sdp && desc.sdp.indexOf("\na=extmap-allow-mixed") !== -1) {
            const sdp = desc.sdp.split("\n").filter((line)=>{
                return line.trim() !== "a=extmap-allow-mixed";
            }).join("\n");
            // Safari enforces read-only-ness of RTCSessionDescription fields.
            if (window.RTCSessionDescription && desc instanceof window.RTCSessionDescription) arguments[0] = new window.RTCSessionDescription({
                type: desc.type,
                sdp: sdp
            });
            else desc.sdp = sdp;
        }
        return nativeSRD.apply(this, arguments);
    };
}
function $b08d2165ffec3b5d$export$51d5e40b48c771c7(window, browserDetails) {
    // Support for addIceCandidate(null or undefined)
    // as well as addIceCandidate({candidate: "", ...})
    // https://bugs.chromium.org/p/chromium/issues/detail?id=978582
    // Note: must be called before other polyfills which change the signature.
    if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) return;
    const nativeAddIceCandidate = window.RTCPeerConnection.prototype.addIceCandidate;
    if (!nativeAddIceCandidate || nativeAddIceCandidate.length === 0) return;
    window.RTCPeerConnection.prototype.addIceCandidate = function addIceCandidate() {
        if (!arguments[0]) {
            if (arguments[1]) arguments[1].apply(null);
            return Promise.resolve();
        }
        // Firefox 68+ emits and processes {candidate: "", ...}, ignore
        // in older versions.
        // Native support for ignoring exists for Chrome M77+.
        // Safari ignores as well, exact version unknown but works in the same
        // version that also ignores addIceCandidate(null).
        if ((browserDetails.browser === "chrome" && browserDetails.version < 78 || browserDetails.browser === "firefox" && browserDetails.version < 68 || browserDetails.browser === "safari") && arguments[0] && arguments[0].candidate === "") return Promise.resolve();
        return nativeAddIceCandidate.apply(this, arguments);
    };
}
function $b08d2165ffec3b5d$export$7170d04e59f9d553(window, browserDetails) {
    if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) return;
    const nativeSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;
    if (!nativeSetLocalDescription || nativeSetLocalDescription.length === 0) return;
    window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        let desc = arguments[0] || {};
        if (typeof desc !== "object" || desc.type && desc.sdp) return nativeSetLocalDescription.apply(this, arguments);
        // The remaining steps should technically happen when SLD comes off the
        // RTCPeerConnection's operations chain (not ahead of going on it), but
        // this is too difficult to shim. Instead, this shim only covers the
        // common case where the operations chain is empty. This is imperfect, but
        // should cover many cases. Rationale: Even if we can't reduce the glare
        // window to zero on imperfect implementations, there's value in tapping
        // into the perfect negotiation pattern that several browsers support.
        desc = {
            type: desc.type,
            sdp: desc.sdp
        };
        if (!desc.type) switch(this.signalingState){
            case "stable":
            case "have-local-offer":
            case "have-remote-pranswer":
                desc.type = "offer";
                break;
            default:
                desc.type = "answer";
                break;
        }
        if (desc.sdp || desc.type !== "offer" && desc.type !== "answer") return nativeSetLocalDescription.apply(this, [
            desc
        ]);
        const func = desc.type === "offer" ? this.createOffer : this.createAnswer;
        return func.apply(this).then((d)=>nativeSetLocalDescription.apply(this, [
                d
            ]));
    };
}



function $6b6fd4ed6456a86f$export$e77bf46c04ac7d12({ window: window } = {}, options = {
    shimChrome: true,
    shimFirefox: true,
    shimSafari: true
}) {
    // Utils.
    const logging = $8c32ceb1592ddcbb$export$bef1f36f5486a6a3;
    const browserDetails = $8c32ceb1592ddcbb$export$2d31490a0c05f094(window);
    const adapter = {
        browserDetails: browserDetails,
        commonShim: $b08d2165ffec3b5d$exports,
        extractVersion: $8c32ceb1592ddcbb$export$e3c02be309be1f23,
        disableLog: $8c32ceb1592ddcbb$export$afbfee8cc06fd3e4,
        disableWarnings: $8c32ceb1592ddcbb$export$51516be4b019e41e,
        sdp: // Expose sdp as a convenience. For production apps include directly.
        $cb9aa1c4a58a062b$exports
    };
    // Shim browser if found.
    switch(browserDetails.browser){
        case "chrome":
            if (!$0383d60919cdcbbd$exports || !$0383d60919cdcbbd$exports.shimPeerConnection || !options.shimChrome) {
                logging("Chrome shim is not included in this adapter release.");
                return adapter;
            }
            if (browserDetails.version === null) {
                logging("Chrome shim can not determine version, not shimming.");
                return adapter;
            }
            logging("adapter.js shimming chrome.");
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $0383d60919cdcbbd$exports;
            // Must be called before shimPeerConnection.
            $b08d2165ffec3b5d$export$51d5e40b48c771c7(window, browserDetails);
            $b08d2165ffec3b5d$export$7170d04e59f9d553(window, browserDetails);
            $0383d60919cdcbbd$exports.shimGetUserMedia(window, browserDetails);
            $0383d60919cdcbbd$exports.shimMediaStream(window, browserDetails);
            $0383d60919cdcbbd$exports.shimPeerConnection(window, browserDetails);
            $0383d60919cdcbbd$exports.shimOnTrack(window, browserDetails);
            $0383d60919cdcbbd$exports.shimAddTrackRemoveTrack(window, browserDetails);
            $0383d60919cdcbbd$exports.shimGetSendersWithDtmf(window, browserDetails);
            $0383d60919cdcbbd$exports.shimGetStats(window, browserDetails);
            $0383d60919cdcbbd$exports.shimSenderReceiverGetStats(window, browserDetails);
            $0383d60919cdcbbd$exports.fixNegotiationNeeded(window, browserDetails);
            $b08d2165ffec3b5d$export$cf133661e444ccfe(window, browserDetails);
            $b08d2165ffec3b5d$export$fdafb8d8280e29b5(window, browserDetails);
            $b08d2165ffec3b5d$export$63bb816cc75460(window, browserDetails);
            $b08d2165ffec3b5d$export$a99147c78a56edc4(window, browserDetails);
            $b08d2165ffec3b5d$export$d461c8d5c5db5da7(window, browserDetails);
            $b08d2165ffec3b5d$export$a57d114344295149(window, browserDetails);
            break;
        case "firefox":
            if (!$023795fee9cfe0ef$exports || !$023795fee9cfe0ef$exports.shimPeerConnection || !options.shimFirefox) {
                logging("Firefox shim is not included in this adapter release.");
                return adapter;
            }
            logging("adapter.js shimming firefox.");
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $023795fee9cfe0ef$exports;
            // Must be called before shimPeerConnection.
            $b08d2165ffec3b5d$export$51d5e40b48c771c7(window, browserDetails);
            $b08d2165ffec3b5d$export$7170d04e59f9d553(window, browserDetails);
            $023795fee9cfe0ef$exports.shimGetUserMedia(window, browserDetails);
            $023795fee9cfe0ef$exports.shimPeerConnection(window, browserDetails);
            $023795fee9cfe0ef$exports.shimOnTrack(window, browserDetails);
            $023795fee9cfe0ef$exports.shimRemoveStream(window, browserDetails);
            $023795fee9cfe0ef$exports.shimSenderGetStats(window, browserDetails);
            $023795fee9cfe0ef$exports.shimReceiverGetStats(window, browserDetails);
            $023795fee9cfe0ef$exports.shimRTCDataChannel(window, browserDetails);
            $023795fee9cfe0ef$exports.shimAddTransceiver(window, browserDetails);
            $023795fee9cfe0ef$exports.shimGetParameters(window, browserDetails);
            $023795fee9cfe0ef$exports.shimCreateOffer(window, browserDetails);
            $023795fee9cfe0ef$exports.shimCreateAnswer(window, browserDetails);
            $b08d2165ffec3b5d$export$cf133661e444ccfe(window, browserDetails);
            $b08d2165ffec3b5d$export$63bb816cc75460(window, browserDetails);
            $b08d2165ffec3b5d$export$a99147c78a56edc4(window, browserDetails);
            $b08d2165ffec3b5d$export$d461c8d5c5db5da7(window, browserDetails);
            break;
        case "safari":
            if (!$34b63042928c15c2$exports || !options.shimSafari) {
                logging("Safari shim is not included in this adapter release.");
                return adapter;
            }
            logging("adapter.js shimming safari.");
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $34b63042928c15c2$exports;
            // Must be called before shimCallbackAPI.
            $b08d2165ffec3b5d$export$51d5e40b48c771c7(window, browserDetails);
            $b08d2165ffec3b5d$export$7170d04e59f9d553(window, browserDetails);
            $34b63042928c15c2$exports.shimRTCIceServerUrls(window, browserDetails);
            $34b63042928c15c2$exports.shimCreateOfferLegacy(window, browserDetails);
            $34b63042928c15c2$exports.shimCallbacksAPI(window, browserDetails);
            $34b63042928c15c2$exports.shimLocalStreamsAPI(window, browserDetails);
            $34b63042928c15c2$exports.shimRemoteStreamsAPI(window, browserDetails);
            $34b63042928c15c2$exports.shimTrackEventTransceiver(window, browserDetails);
            $34b63042928c15c2$exports.shimGetUserMedia(window, browserDetails);
            $34b63042928c15c2$exports.shimAudioContext(window, browserDetails);
            $b08d2165ffec3b5d$export$cf133661e444ccfe(window, browserDetails);
            $b08d2165ffec3b5d$export$fdafb8d8280e29b5(window, browserDetails);
            $b08d2165ffec3b5d$export$a99147c78a56edc4(window, browserDetails);
            $b08d2165ffec3b5d$export$d461c8d5c5db5da7(window, browserDetails);
            $b08d2165ffec3b5d$export$a57d114344295149(window, browserDetails);
            break;
        default:
            logging("Unsupported browser!");
            break;
    }
    return adapter;
}


"use strict";
const $464b48a621604b0f$var$adapter = (0, $6b6fd4ed6456a86f$export$e77bf46c04ac7d12)({
    window: typeof window === "undefined" ? undefined : window
});
var $464b48a621604b0f$export$2e2bcd8739ae039 = $464b48a621604b0f$var$adapter;



var $gzLuY = parcelRequire("gzLuY");
var $f3f604935c83ab88$require$Buffer = $gzLuY.Buffer;
let $f3f604935c83ab88$var$decoder;
try {
    $f3f604935c83ab88$var$decoder = new TextDecoder();
} catch (error) {}
let $f3f604935c83ab88$var$src;
let $f3f604935c83ab88$var$srcEnd;
let $f3f604935c83ab88$var$position = 0;
let $f3f604935c83ab88$var$alreadySet;
const $f3f604935c83ab88$var$EMPTY_ARRAY = [];
const $f3f604935c83ab88$var$LEGACY_RECORD_INLINE_ID = 105;
const $f3f604935c83ab88$var$RECORD_DEFINITIONS_ID = 0xdffe;
const $f3f604935c83ab88$var$RECORD_INLINE_ID = 0xdfff // temporary first-come first-serve tag // proposed tag: 0x7265 // 're'
;
const $f3f604935c83ab88$var$BUNDLED_STRINGS_ID = 0xdff9;
const $f3f604935c83ab88$var$PACKED_TABLE_TAG_ID = 51;
const $f3f604935c83ab88$var$PACKED_REFERENCE_TAG_ID = 6;
const $f3f604935c83ab88$var$STOP_CODE = {};
let $f3f604935c83ab88$var$strings = $f3f604935c83ab88$var$EMPTY_ARRAY;
let $f3f604935c83ab88$var$stringPosition = 0;
let $f3f604935c83ab88$var$currentDecoder = {};
let $f3f604935c83ab88$var$currentStructures;
let $f3f604935c83ab88$var$srcString;
let $f3f604935c83ab88$var$srcStringStart = 0;
let $f3f604935c83ab88$var$srcStringEnd = 0;
let $f3f604935c83ab88$var$bundledStrings;
let $f3f604935c83ab88$var$referenceMap;
let $f3f604935c83ab88$var$currentExtensions = [];
let $f3f604935c83ab88$var$currentExtensionRanges = [];
let $f3f604935c83ab88$var$packedValues;
let $f3f604935c83ab88$var$dataView;
let $f3f604935c83ab88$var$restoreMapsAsObject;
let $f3f604935c83ab88$var$defaultOptions = {
    useRecords: false,
    mapsAsObjects: true
};
let $f3f604935c83ab88$var$sequentialMode = false;
let $f3f604935c83ab88$var$inlineObjectReadThreshold = 2;
var $f3f604935c83ab88$var$BlockedFunction // we use search and replace to change the next call to BlockedFunction to avoid CSP issues for
;
// no-eval build
try {
    new Function("");
} catch (error) {
    // if eval variants are not supported, do not create inline object readers ever
    $f3f604935c83ab88$var$inlineObjectReadThreshold = Infinity;
}
class $f3f604935c83ab88$export$f9de6ca0bc043724 {
    /*
	decodeKey(key) {
		return this.keyMap
			? Object.keys(this.keyMap)[Object.values(this.keyMap).indexOf(key)] || key
			: key
	}
	*/ decodeKey(key) {
        return this.keyMap ? this.mapKey.get(key) || key : key;
    }
    encodeKey(key) {
        return this.keyMap && this.keyMap.hasOwnProperty(key) ? this.keyMap[key] : key;
    }
    encodeKeys(rec) {
        if (!this._keyMap) return rec;
        let map = new Map();
        for (let [k, v] of Object.entries(rec))map.set(this._keyMap.hasOwnProperty(k) ? this._keyMap[k] : k, v);
        return map;
    }
    decodeKeys(map) {
        if (!this._keyMap || map.constructor.name != "Map") return map;
        if (!this._mapKey) {
            this._mapKey = new Map();
            for (let [k, v] of Object.entries(this._keyMap))this._mapKey.set(v, k);
        }
        let res = {};
        //map.forEach((v,k) => res[Object.keys(this._keyMap)[Object.values(this._keyMap).indexOf(k)] || k] = v)
        map.forEach((v, k)=>res[$f3f604935c83ab88$var$safeKey(this._mapKey.has(k) ? this._mapKey.get(k) : k)] = v);
        return res;
    }
    mapDecode(source, end) {
        let res = this.decode(source);
        if (this._keyMap) //Experiemntal support for Optimised KeyMap  decoding 
        switch(res.constructor.name){
            case "Array":
                return res.map((r)=>this.decodeKeys(r));
        }
        return res;
    }
    decode(source, end) {
        if ($f3f604935c83ab88$var$src) // re-entrant execution, save the state and restore it after we do this decode
        return $f3f604935c83ab88$var$saveState(()=>{
            $f3f604935c83ab88$export$e6f020404d5b6c15();
            return this ? this.decode(source, end) : $f3f604935c83ab88$export$f9de6ca0bc043724.prototype.decode.call($f3f604935c83ab88$var$defaultOptions, source, end);
        });
        $f3f604935c83ab88$var$srcEnd = end > -1 ? end : source.length;
        $f3f604935c83ab88$var$position = 0;
        $f3f604935c83ab88$var$stringPosition = 0;
        $f3f604935c83ab88$var$srcStringEnd = 0;
        $f3f604935c83ab88$var$srcString = null;
        $f3f604935c83ab88$var$strings = $f3f604935c83ab88$var$EMPTY_ARRAY;
        $f3f604935c83ab88$var$bundledStrings = null;
        $f3f604935c83ab88$var$src = source;
        // this provides cached access to the data view for a buffer if it is getting reused, which is a recommend
        // technique for getting data from a database where it can be copied into an existing buffer instead of creating
        // new ones
        try {
            $f3f604935c83ab88$var$dataView = source.dataView || (source.dataView = new DataView(source.buffer, source.byteOffset, source.byteLength));
        } catch (error) {
            // if it doesn't have a buffer, maybe it is the wrong type of object
            $f3f604935c83ab88$var$src = null;
            if (source instanceof Uint8Array) throw error;
            throw new Error("Source must be a Uint8Array or Buffer but was a " + (source && typeof source == "object" ? source.constructor.name : typeof source));
        }
        if (this instanceof $f3f604935c83ab88$export$f9de6ca0bc043724) {
            $f3f604935c83ab88$var$currentDecoder = this;
            $f3f604935c83ab88$var$packedValues = this.sharedValues && (this.pack ? new Array(this.maxPrivatePackedValues || 16).concat(this.sharedValues) : this.sharedValues);
            if (this.structures) {
                $f3f604935c83ab88$var$currentStructures = this.structures;
                return $f3f604935c83ab88$export$8cb90b5f58dd32e2();
            } else if (!$f3f604935c83ab88$var$currentStructures || $f3f604935c83ab88$var$currentStructures.length > 0) $f3f604935c83ab88$var$currentStructures = [];
        } else {
            $f3f604935c83ab88$var$currentDecoder = $f3f604935c83ab88$var$defaultOptions;
            if (!$f3f604935c83ab88$var$currentStructures || $f3f604935c83ab88$var$currentStructures.length > 0) $f3f604935c83ab88$var$currentStructures = [];
            $f3f604935c83ab88$var$packedValues = null;
        }
        return $f3f604935c83ab88$export$8cb90b5f58dd32e2();
    }
    decodeMultiple(source, forEach) {
        let values, lastPosition = 0;
        try {
            let size = source.length;
            $f3f604935c83ab88$var$sequentialMode = true;
            let value = this ? this.decode(source, size) : $f3f604935c83ab88$var$defaultDecoder.decode(source, size);
            if (forEach) {
                if (forEach(value) === false) return;
                while($f3f604935c83ab88$var$position < size){
                    lastPosition = $f3f604935c83ab88$var$position;
                    if (forEach($f3f604935c83ab88$export$8cb90b5f58dd32e2()) === false) return;
                }
            } else {
                values = [
                    value
                ];
                while($f3f604935c83ab88$var$position < size){
                    lastPosition = $f3f604935c83ab88$var$position;
                    values.push($f3f604935c83ab88$export$8cb90b5f58dd32e2());
                }
                return values;
            }
        } catch (error) {
            error.lastPosition = lastPosition;
            error.values = values;
            throw error;
        } finally{
            $f3f604935c83ab88$var$sequentialMode = false;
            $f3f604935c83ab88$export$e6f020404d5b6c15();
        }
    }
    constructor(options){
        if (options) {
            if ((options.keyMap || options._keyMap) && !options.useRecords) {
                options.useRecords = false;
                options.mapsAsObjects = true;
            }
            if (options.useRecords === false && options.mapsAsObjects === undefined) options.mapsAsObjects = true;
            if (options.getStructures) options.getShared = options.getStructures;
            if (options.getShared && !options.structures) (options.structures = []).uninitialized = true // this is what we use to denote an uninitialized structures
            ;
            if (options.keyMap) {
                this.mapKey = new Map();
                for (let [k, v] of Object.entries(options.keyMap))this.mapKey.set(v, k);
            }
        }
        Object.assign(this, options);
    }
}
function $f3f604935c83ab88$export$1690e12b840569b9() {
    return $f3f604935c83ab88$var$position;
}
function $f3f604935c83ab88$export$8cb90b5f58dd32e2() {
    try {
        let result = $f3f604935c83ab88$export$aafa59e2e03f2942();
        if ($f3f604935c83ab88$var$bundledStrings) {
            if ($f3f604935c83ab88$var$position >= $f3f604935c83ab88$var$bundledStrings.postBundlePosition) {
                let error = new Error("Unexpected bundle position");
                error.incomplete = true;
                throw error;
            }
            // bundled strings to skip past
            $f3f604935c83ab88$var$position = $f3f604935c83ab88$var$bundledStrings.postBundlePosition;
            $f3f604935c83ab88$var$bundledStrings = null;
        }
        if ($f3f604935c83ab88$var$position == $f3f604935c83ab88$var$srcEnd) {
            // finished reading this source, cleanup references
            $f3f604935c83ab88$var$currentStructures = null;
            $f3f604935c83ab88$var$src = null;
            if ($f3f604935c83ab88$var$referenceMap) $f3f604935c83ab88$var$referenceMap = null;
        } else if ($f3f604935c83ab88$var$position > $f3f604935c83ab88$var$srcEnd) {
            // over read
            let error = new Error("Unexpected end of CBOR data");
            error.incomplete = true;
            throw error;
        } else if (!$f3f604935c83ab88$var$sequentialMode) throw new Error("Data read, but end of buffer not reached");
        // else more to read, but we are reading sequentially, so don't clear source yet
        return result;
    } catch (error) {
        $f3f604935c83ab88$export$e6f020404d5b6c15();
        if (error instanceof RangeError || error.message.startsWith("Unexpected end of buffer")) error.incomplete = true;
        throw error;
    }
}
function $f3f604935c83ab88$export$aafa59e2e03f2942() {
    let token = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
    let majorType = token >> 5;
    token = token & 0x1f;
    if (token > 0x17) switch(token){
        case 0x18:
            token = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
            break;
        case 0x19:
            if (majorType == 7) return $f3f604935c83ab88$var$getFloat16();
            token = $f3f604935c83ab88$var$dataView.getUint16($f3f604935c83ab88$var$position);
            $f3f604935c83ab88$var$position += 2;
            break;
        case 0x1a:
            if (majorType == 7) {
                let value = $f3f604935c83ab88$var$dataView.getFloat32($f3f604935c83ab88$var$position);
                if ($f3f604935c83ab88$var$currentDecoder.useFloat32 > 2) {
                    // this does rounding of numbers that were encoded in 32-bit float to nearest significant decimal digit that could be preserved
                    let multiplier = $f3f604935c83ab88$export$c652a5bbb6be7a36[($f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position] & 0x7f) << 1 | $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position + 1] >> 7];
                    $f3f604935c83ab88$var$position += 4;
                    return (multiplier * value + (value > 0 ? 0.5 : -0.5) >> 0) / multiplier;
                }
                $f3f604935c83ab88$var$position += 4;
                return value;
            }
            token = $f3f604935c83ab88$var$dataView.getUint32($f3f604935c83ab88$var$position);
            $f3f604935c83ab88$var$position += 4;
            break;
        case 0x1b:
            if (majorType == 7) {
                let value = $f3f604935c83ab88$var$dataView.getFloat64($f3f604935c83ab88$var$position);
                $f3f604935c83ab88$var$position += 8;
                return value;
            }
            if (majorType > 1) {
                if ($f3f604935c83ab88$var$dataView.getUint32($f3f604935c83ab88$var$position) > 0) throw new Error("JavaScript does not support arrays, maps, or strings with length over 4294967295");
                token = $f3f604935c83ab88$var$dataView.getUint32($f3f604935c83ab88$var$position + 4);
            } else if ($f3f604935c83ab88$var$currentDecoder.int64AsNumber) {
                token = $f3f604935c83ab88$var$dataView.getUint32($f3f604935c83ab88$var$position) * 0x100000000;
                token += $f3f604935c83ab88$var$dataView.getUint32($f3f604935c83ab88$var$position + 4);
            } else token = $f3f604935c83ab88$var$dataView.getBigUint64($f3f604935c83ab88$var$position);
            $f3f604935c83ab88$var$position += 8;
            break;
        case 0x1f:
            // indefinite length
            switch(majorType){
                case 2:
                case 3:
                    throw new Error("Indefinite length not supported for byte or text strings");
                case 4:
                    let array = [];
                    let value, i = 0;
                    while((value = $f3f604935c83ab88$export$aafa59e2e03f2942()) != $f3f604935c83ab88$var$STOP_CODE)array[i++] = value;
                    return majorType == 4 ? array : majorType == 3 ? array.join("") : $f3f604935c83ab88$require$Buffer.concat(array);
                case 5:
                    let key;
                    if ($f3f604935c83ab88$var$currentDecoder.mapsAsObjects) {
                        let object = {};
                        if ($f3f604935c83ab88$var$currentDecoder.keyMap) while((key = $f3f604935c83ab88$export$aafa59e2e03f2942()) != $f3f604935c83ab88$var$STOP_CODE)object[$f3f604935c83ab88$var$safeKey($f3f604935c83ab88$var$currentDecoder.decodeKey(key))] = $f3f604935c83ab88$export$aafa59e2e03f2942();
                        else while((key = $f3f604935c83ab88$export$aafa59e2e03f2942()) != $f3f604935c83ab88$var$STOP_CODE)object[$f3f604935c83ab88$var$safeKey(key)] = $f3f604935c83ab88$export$aafa59e2e03f2942();
                        return object;
                    } else {
                        if ($f3f604935c83ab88$var$restoreMapsAsObject) {
                            $f3f604935c83ab88$var$currentDecoder.mapsAsObjects = true;
                            $f3f604935c83ab88$var$restoreMapsAsObject = false;
                        }
                        let map = new Map();
                        if ($f3f604935c83ab88$var$currentDecoder.keyMap) while((key = $f3f604935c83ab88$export$aafa59e2e03f2942()) != $f3f604935c83ab88$var$STOP_CODE)map.set($f3f604935c83ab88$var$currentDecoder.decodeKey(key), $f3f604935c83ab88$export$aafa59e2e03f2942());
                        else while((key = $f3f604935c83ab88$export$aafa59e2e03f2942()) != $f3f604935c83ab88$var$STOP_CODE)map.set(key, $f3f604935c83ab88$export$aafa59e2e03f2942());
                        return map;
                    }
                case 7:
                    return $f3f604935c83ab88$var$STOP_CODE;
                default:
                    throw new Error("Invalid major type for indefinite length " + majorType);
            }
        default:
            throw new Error("Unknown token " + token);
    }
    switch(majorType){
        case 0:
            return token;
        case 1:
            return ~token;
        case 2:
            return $f3f604935c83ab88$var$readBin(token);
        case 3:
            if ($f3f604935c83ab88$var$srcStringEnd >= $f3f604935c83ab88$var$position) return $f3f604935c83ab88$var$srcString.slice($f3f604935c83ab88$var$position - $f3f604935c83ab88$var$srcStringStart, ($f3f604935c83ab88$var$position += token) - $f3f604935c83ab88$var$srcStringStart);
            if ($f3f604935c83ab88$var$srcStringEnd == 0 && $f3f604935c83ab88$var$srcEnd < 140 && token < 32) {
                // for small blocks, avoiding the overhead of the extract call is helpful
                let string = token < 16 ? $f3f604935c83ab88$var$shortStringInJS(token) : $f3f604935c83ab88$var$longStringInJS(token);
                if (string != null) return string;
            }
            return $f3f604935c83ab88$var$readFixedString(token);
        case 4:
            let array1 = new Array(token);
            //if (currentDecoder.keyMap) for (let i = 0; i < token; i++) array[i] = currentDecoder.decodeKey(read())	
            //else 
            for(let i = 0; i < token; i++)array1[i] = $f3f604935c83ab88$export$aafa59e2e03f2942();
            return array1;
        case 5:
            if ($f3f604935c83ab88$var$currentDecoder.mapsAsObjects) {
                let object = {};
                if ($f3f604935c83ab88$var$currentDecoder.keyMap) for(let i = 0; i < token; i++)object[$f3f604935c83ab88$var$safeKey($f3f604935c83ab88$var$currentDecoder.decodeKey($f3f604935c83ab88$export$aafa59e2e03f2942()))] = $f3f604935c83ab88$export$aafa59e2e03f2942();
                else for(let i = 0; i < token; i++)object[$f3f604935c83ab88$var$safeKey($f3f604935c83ab88$export$aafa59e2e03f2942())] = $f3f604935c83ab88$export$aafa59e2e03f2942();
                return object;
            } else {
                if ($f3f604935c83ab88$var$restoreMapsAsObject) {
                    $f3f604935c83ab88$var$currentDecoder.mapsAsObjects = true;
                    $f3f604935c83ab88$var$restoreMapsAsObject = false;
                }
                let map = new Map();
                if ($f3f604935c83ab88$var$currentDecoder.keyMap) for(let i = 0; i < token; i++)map.set($f3f604935c83ab88$var$currentDecoder.decodeKey($f3f604935c83ab88$export$aafa59e2e03f2942()), $f3f604935c83ab88$export$aafa59e2e03f2942());
                else for(let i = 0; i < token; i++)map.set($f3f604935c83ab88$export$aafa59e2e03f2942(), $f3f604935c83ab88$export$aafa59e2e03f2942());
                return map;
            }
        case 6:
            if (token >= $f3f604935c83ab88$var$BUNDLED_STRINGS_ID) {
                let structure = $f3f604935c83ab88$var$currentStructures[token & 0x1fff] // check record structures first
                ;
                // At some point we may provide an option for dynamic tag assignment with a range like token >= 8 && (token < 16 || (token > 0x80 && token < 0xc0) || (token > 0x130 && token < 0x4000))
                if (structure) {
                    if (!structure.read) structure.read = $f3f604935c83ab88$var$createStructureReader(structure);
                    return structure.read();
                }
                if (token < 0x10000) {
                    if (token == $f3f604935c83ab88$var$RECORD_INLINE_ID) {
                        // currentExtensions as densely stored array (v8 stores arrays densely under about 3000 elements)
                        let length = $f3f604935c83ab88$var$readJustLength();
                        let id = $f3f604935c83ab88$export$aafa59e2e03f2942();
                        let structure = $f3f604935c83ab88$export$aafa59e2e03f2942();
                        $f3f604935c83ab88$var$recordDefinition(id, structure);
                        let object = {};
                        if ($f3f604935c83ab88$var$currentDecoder.keyMap) for(let i = 2; i < length; i++){
                            let key = $f3f604935c83ab88$var$currentDecoder.decodeKey(structure[i - 2]);
                            object[$f3f604935c83ab88$var$safeKey(key)] = $f3f604935c83ab88$export$aafa59e2e03f2942();
                        }
                        else for(let i = 2; i < length; i++){
                            let key = structure[i - 2];
                            object[$f3f604935c83ab88$var$safeKey(key)] = $f3f604935c83ab88$export$aafa59e2e03f2942();
                        }
                        return object;
                    } else if (token == $f3f604935c83ab88$var$RECORD_DEFINITIONS_ID) {
                        let length = $f3f604935c83ab88$var$readJustLength();
                        let id = $f3f604935c83ab88$export$aafa59e2e03f2942();
                        for(let i = 2; i < length; i++)$f3f604935c83ab88$var$recordDefinition(id++, $f3f604935c83ab88$export$aafa59e2e03f2942());
                        return $f3f604935c83ab88$export$aafa59e2e03f2942();
                    } else if (token == $f3f604935c83ab88$var$BUNDLED_STRINGS_ID) return $f3f604935c83ab88$var$readBundleExt();
                    if ($f3f604935c83ab88$var$currentDecoder.getShared) {
                        $f3f604935c83ab88$var$loadShared();
                        structure = $f3f604935c83ab88$var$currentStructures[token & 0x1fff];
                        if (structure) {
                            if (!structure.read) structure.read = $f3f604935c83ab88$var$createStructureReader(structure);
                            return structure.read();
                        }
                    }
                }
            }
            let extension = $f3f604935c83ab88$var$currentExtensions[token];
            if (extension) {
                if (extension.handlesRead) return extension($f3f604935c83ab88$export$aafa59e2e03f2942);
                else return extension($f3f604935c83ab88$export$aafa59e2e03f2942());
            } else {
                let input = $f3f604935c83ab88$export$aafa59e2e03f2942();
                for(let i = 0; i < $f3f604935c83ab88$var$currentExtensionRanges.length; i++){
                    let value = $f3f604935c83ab88$var$currentExtensionRanges[i](token, input);
                    if (value !== undefined) return value;
                }
                return new $f3f604935c83ab88$export$3288d34c523a1192(input, token);
            }
        case 7:
            switch(token){
                case 0x14:
                    return false;
                case 0x15:
                    return true;
                case 0x16:
                    return null;
                case 0x17:
                    return; // undefined
                case 0x1f:
                default:
                    let packedValue = ($f3f604935c83ab88$var$packedValues || $f3f604935c83ab88$var$getPackedValues())[token];
                    if (packedValue !== undefined) return packedValue;
                    throw new Error("Unknown token " + token);
            }
        default:
            if (isNaN(token)) {
                let error = new Error("Unexpected end of CBOR data");
                error.incomplete = true;
                throw error;
            }
            throw new Error("Unknown CBOR token " + token);
    }
}
const $f3f604935c83ab88$var$validName = /^[a-zA-Z_$][a-zA-Z\d_$]*$/;
function $f3f604935c83ab88$var$createStructureReader(structure) {
    function readObject() {
        // get the array size from the header
        let length = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
        //let majorType = token >> 5
        length = length & 0x1f;
        if (length > 0x17) switch(length){
            case 0x18:
                length = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
                break;
            case 0x19:
                length = $f3f604935c83ab88$var$dataView.getUint16($f3f604935c83ab88$var$position);
                $f3f604935c83ab88$var$position += 2;
                break;
            case 0x1a:
                length = $f3f604935c83ab88$var$dataView.getUint32($f3f604935c83ab88$var$position);
                $f3f604935c83ab88$var$position += 4;
                break;
            default:
                throw new Error("Expected array header, but got " + $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position - 1]);
        }
        // This initial function is quick to instantiate, but runs slower. After several iterations pay the cost to build the faster function
        let compiledReader = this.compiledReader // first look to see if we have the fast compiled function
        ;
        while(compiledReader){
            // we have a fast compiled object literal reader
            if (compiledReader.propertyCount === length) return compiledReader($f3f604935c83ab88$export$aafa59e2e03f2942) // with the right length, so we use it
            ;
            compiledReader = compiledReader.next // see if there is another reader with the right length
            ;
        }
        if (this.slowReads++ >= $f3f604935c83ab88$var$inlineObjectReadThreshold) {
            let array = this.length == length ? this : this.slice(0, length);
            compiledReader = $f3f604935c83ab88$var$currentDecoder.keyMap ? new Function("r", "return {" + array.map((k)=>$f3f604935c83ab88$var$currentDecoder.decodeKey(k)).map((k)=>$f3f604935c83ab88$var$validName.test(k) ? $f3f604935c83ab88$var$safeKey(k) + ":r()" : "[" + JSON.stringify(k) + "]:r()").join(",") + "}") : new Function("r", "return {" + array.map((key)=>$f3f604935c83ab88$var$validName.test(key) ? $f3f604935c83ab88$var$safeKey(key) + ":r()" : "[" + JSON.stringify(key) + "]:r()").join(",") + "}");
            if (this.compiledReader) compiledReader.next = this.compiledReader // if there is an existing one, we store multiple readers as a linked list because it is usually pretty rare to have multiple readers (of different length) for the same structure
            ;
            compiledReader.propertyCount = length;
            this.compiledReader = compiledReader;
            return compiledReader($f3f604935c83ab88$export$aafa59e2e03f2942);
        }
        let object = {};
        if ($f3f604935c83ab88$var$currentDecoder.keyMap) for(let i = 0; i < length; i++)object[$f3f604935c83ab88$var$safeKey($f3f604935c83ab88$var$currentDecoder.decodeKey(this[i]))] = $f3f604935c83ab88$export$aafa59e2e03f2942();
        else for(let i = 0; i < length; i++)object[$f3f604935c83ab88$var$safeKey(this[i])] = $f3f604935c83ab88$export$aafa59e2e03f2942();
        return object;
    }
    structure.slowReads = 0;
    return readObject;
}
function $f3f604935c83ab88$var$safeKey(key) {
    return key === "__proto__" ? "__proto_" : key;
}
let $f3f604935c83ab88$var$readFixedString = $f3f604935c83ab88$var$readStringJS;
let $f3f604935c83ab88$var$readString8 = $f3f604935c83ab88$var$readStringJS;
let $f3f604935c83ab88$var$readString16 = $f3f604935c83ab88$var$readStringJS;
let $f3f604935c83ab88$var$readString32 = $f3f604935c83ab88$var$readStringJS;
let $f3f604935c83ab88$export$ae7c2166c4fa454a = false;
function $f3f604935c83ab88$export$b9cf06aee99126ca(extractStrings) {
    $f3f604935c83ab88$export$ae7c2166c4fa454a = true;
    $f3f604935c83ab88$var$readFixedString = readString(1);
    $f3f604935c83ab88$var$readString8 = readString(2);
    $f3f604935c83ab88$var$readString16 = readString(3);
    $f3f604935c83ab88$var$readString32 = readString(5);
    function readString(headerLength) {
        return function readString(length) {
            let string = $f3f604935c83ab88$var$strings[$f3f604935c83ab88$var$stringPosition++];
            if (string == null) {
                if ($f3f604935c83ab88$var$bundledStrings) return $f3f604935c83ab88$var$readStringJS(length);
                let extraction = extractStrings($f3f604935c83ab88$var$position, $f3f604935c83ab88$var$srcEnd, length, $f3f604935c83ab88$var$src);
                if (typeof extraction == "string") {
                    string = extraction;
                    $f3f604935c83ab88$var$strings = $f3f604935c83ab88$var$EMPTY_ARRAY;
                } else {
                    $f3f604935c83ab88$var$strings = extraction;
                    $f3f604935c83ab88$var$stringPosition = 1;
                    $f3f604935c83ab88$var$srcStringEnd = 1 // even if a utf-8 string was decoded, must indicate we are in the midst of extracted strings and can't skip strings
                    ;
                    string = $f3f604935c83ab88$var$strings[0];
                    if (string === undefined) throw new Error("Unexpected end of buffer");
                }
            }
            let srcStringLength = string.length;
            if (srcStringLength <= length) {
                $f3f604935c83ab88$var$position += length;
                return string;
            }
            $f3f604935c83ab88$var$srcString = string;
            $f3f604935c83ab88$var$srcStringStart = $f3f604935c83ab88$var$position;
            $f3f604935c83ab88$var$srcStringEnd = $f3f604935c83ab88$var$position + srcStringLength;
            $f3f604935c83ab88$var$position += length;
            return string.slice(0, length) // we know we just want the beginning
            ;
        };
    }
}
function $f3f604935c83ab88$var$readStringJS(length) {
    let result;
    if (length < 16) {
        if (result = $f3f604935c83ab88$var$shortStringInJS(length)) return result;
    }
    if (length > 64 && $f3f604935c83ab88$var$decoder) return $f3f604935c83ab88$var$decoder.decode($f3f604935c83ab88$var$src.subarray($f3f604935c83ab88$var$position, $f3f604935c83ab88$var$position += length));
    const end = $f3f604935c83ab88$var$position + length;
    const units = [];
    result = "";
    while($f3f604935c83ab88$var$position < end){
        const byte1 = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
        if ((byte1 & 0x80) === 0) // 1 byte
        units.push(byte1);
        else if ((byte1 & 0xe0) === 0xc0) {
            // 2 bytes
            const byte2 = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++] & 0x3f;
            units.push((byte1 & 0x1f) << 6 | byte2);
        } else if ((byte1 & 0xf0) === 0xe0) {
            // 3 bytes
            const byte2 = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++] & 0x3f;
            const byte3 = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++] & 0x3f;
            units.push((byte1 & 0x1f) << 12 | byte2 << 6 | byte3);
        } else if ((byte1 & 0xf8) === 0xf0) {
            // 4 bytes
            const byte2 = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++] & 0x3f;
            const byte3 = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++] & 0x3f;
            const byte4 = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++] & 0x3f;
            let unit = (byte1 & 0x07) << 0x12 | byte2 << 0x0c | byte3 << 0x06 | byte4;
            if (unit > 0xffff) {
                unit -= 0x10000;
                units.push(unit >>> 10 & 0x3ff | 0xd800);
                unit = 0xdc00 | unit & 0x3ff;
            }
            units.push(unit);
        } else units.push(byte1);
        if (units.length >= 0x1000) {
            result += $f3f604935c83ab88$var$fromCharCode.apply(String, units);
            units.length = 0;
        }
    }
    if (units.length > 0) result += $f3f604935c83ab88$var$fromCharCode.apply(String, units);
    return result;
}
let $f3f604935c83ab88$var$fromCharCode = String.fromCharCode;
function $f3f604935c83ab88$var$longStringInJS(length) {
    let start = $f3f604935c83ab88$var$position;
    let bytes = new Array(length);
    for(let i = 0; i < length; i++){
        const byte = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
        if ((byte & 0x80) > 0) {
            $f3f604935c83ab88$var$position = start;
            return;
        }
        bytes[i] = byte;
    }
    return $f3f604935c83ab88$var$fromCharCode.apply(String, bytes);
}
function $f3f604935c83ab88$var$shortStringInJS(length) {
    if (length < 4) {
        if (length < 2) {
            if (length === 0) return "";
            else {
                let a = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
                if ((a & 0x80) > 1) {
                    $f3f604935c83ab88$var$position -= 1;
                    return;
                }
                return $f3f604935c83ab88$var$fromCharCode(a);
            }
        } else {
            let a = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
            let b = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
            if ((a & 0x80) > 0 || (b & 0x80) > 0) {
                $f3f604935c83ab88$var$position -= 2;
                return;
            }
            if (length < 3) return $f3f604935c83ab88$var$fromCharCode(a, b);
            let c = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
            if ((c & 0x80) > 0) {
                $f3f604935c83ab88$var$position -= 3;
                return;
            }
            return $f3f604935c83ab88$var$fromCharCode(a, b, c);
        }
    } else {
        let a = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
        let b = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
        let c = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
        let d = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
        if ((a & 0x80) > 0 || (b & 0x80) > 0 || (c & 0x80) > 0 || (d & 0x80) > 0) {
            $f3f604935c83ab88$var$position -= 4;
            return;
        }
        if (length < 6) {
            if (length === 4) return $f3f604935c83ab88$var$fromCharCode(a, b, c, d);
            else {
                let e = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
                if ((e & 0x80) > 0) {
                    $f3f604935c83ab88$var$position -= 5;
                    return;
                }
                return $f3f604935c83ab88$var$fromCharCode(a, b, c, d, e);
            }
        } else if (length < 8) {
            let e = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
            let f = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
            if ((e & 0x80) > 0 || (f & 0x80) > 0) {
                $f3f604935c83ab88$var$position -= 6;
                return;
            }
            if (length < 7) return $f3f604935c83ab88$var$fromCharCode(a, b, c, d, e, f);
            let g = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
            if ((g & 0x80) > 0) {
                $f3f604935c83ab88$var$position -= 7;
                return;
            }
            return $f3f604935c83ab88$var$fromCharCode(a, b, c, d, e, f, g);
        } else {
            let e = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
            let f = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
            let g = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
            let h = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
            if ((e & 0x80) > 0 || (f & 0x80) > 0 || (g & 0x80) > 0 || (h & 0x80) > 0) {
                $f3f604935c83ab88$var$position -= 8;
                return;
            }
            if (length < 10) {
                if (length === 8) return $f3f604935c83ab88$var$fromCharCode(a, b, c, d, e, f, g, h);
                else {
                    let i = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
                    if ((i & 0x80) > 0) {
                        $f3f604935c83ab88$var$position -= 9;
                        return;
                    }
                    return $f3f604935c83ab88$var$fromCharCode(a, b, c, d, e, f, g, h, i);
                }
            } else if (length < 12) {
                let i = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
                let j = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
                if ((i & 0x80) > 0 || (j & 0x80) > 0) {
                    $f3f604935c83ab88$var$position -= 10;
                    return;
                }
                if (length < 11) return $f3f604935c83ab88$var$fromCharCode(a, b, c, d, e, f, g, h, i, j);
                let k = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
                if ((k & 0x80) > 0) {
                    $f3f604935c83ab88$var$position -= 11;
                    return;
                }
                return $f3f604935c83ab88$var$fromCharCode(a, b, c, d, e, f, g, h, i, j, k);
            } else {
                let i = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
                let j = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
                let k = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
                let l = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
                if ((i & 0x80) > 0 || (j & 0x80) > 0 || (k & 0x80) > 0 || (l & 0x80) > 0) {
                    $f3f604935c83ab88$var$position -= 12;
                    return;
                }
                if (length < 14) {
                    if (length === 12) return $f3f604935c83ab88$var$fromCharCode(a, b, c, d, e, f, g, h, i, j, k, l);
                    else {
                        let m = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
                        if ((m & 0x80) > 0) {
                            $f3f604935c83ab88$var$position -= 13;
                            return;
                        }
                        return $f3f604935c83ab88$var$fromCharCode(a, b, c, d, e, f, g, h, i, j, k, l, m);
                    }
                } else {
                    let m = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
                    let n = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
                    if ((m & 0x80) > 0 || (n & 0x80) > 0) {
                        $f3f604935c83ab88$var$position -= 14;
                        return;
                    }
                    if (length < 15) return $f3f604935c83ab88$var$fromCharCode(a, b, c, d, e, f, g, h, i, j, k, l, m, n);
                    let o = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
                    if ((o & 0x80) > 0) {
                        $f3f604935c83ab88$var$position -= 15;
                        return;
                    }
                    return $f3f604935c83ab88$var$fromCharCode(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o);
                }
            }
        }
    }
}
function $f3f604935c83ab88$var$readBin(length) {
    return $f3f604935c83ab88$var$currentDecoder.copyBuffers ? // specifically use the copying slice (not the node one)
    Uint8Array.prototype.slice.call($f3f604935c83ab88$var$src, $f3f604935c83ab88$var$position, $f3f604935c83ab88$var$position += length) : $f3f604935c83ab88$var$src.subarray($f3f604935c83ab88$var$position, $f3f604935c83ab88$var$position += length);
}
function $f3f604935c83ab88$var$readExt(length) {
    let type = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
    if ($f3f604935c83ab88$var$currentExtensions[type]) return $f3f604935c83ab88$var$currentExtensions[type]($f3f604935c83ab88$var$src.subarray($f3f604935c83ab88$var$position, $f3f604935c83ab88$var$position += length));
    else throw new Error("Unknown extension type " + type);
}
let $f3f604935c83ab88$var$f32Array = new Float32Array(1);
let $f3f604935c83ab88$var$u8Array = new Uint8Array($f3f604935c83ab88$var$f32Array.buffer, 0, 4);
function $f3f604935c83ab88$var$getFloat16() {
    let byte0 = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
    let byte1 = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
    let exponent = (byte0 & 0x7f) >> 2;
    if (exponent === 0x1f) {
        if (byte1 || byte0 & 3) return NaN;
        return byte0 & 0x80 ? -Infinity : Infinity;
    }
    if (exponent === 0) {
        // significand with 10 fractional bits and divided by 2^14
        let abs = ((byte0 & 3) << 8 | byte1) / 16777216;
        return byte0 & 0x80 ? -abs : abs;
    }
    $f3f604935c83ab88$var$u8Array[3] = byte0 & 0x80 | // sign bit
    (exponent >> 1) + 56 // 4 of 5 of the exponent bits, re-offset-ed
    ;
    $f3f604935c83ab88$var$u8Array[2] = (byte0 & 7) << 5 | // last exponent bit and first two mantissa bits
    byte1 >> 3 // next 5 bits of mantissa
    ;
    $f3f604935c83ab88$var$u8Array[1] = byte1 << 5; // last three bits of mantissa
    $f3f604935c83ab88$var$u8Array[0] = 0;
    return $f3f604935c83ab88$var$f32Array[0];
}
let $f3f604935c83ab88$var$keyCache = new Array(4096);
function $f3f604935c83ab88$var$readKey() {
    let length = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
    if (length >= 0x60 && length < 0x78) {
        // fixstr, potentially use key cache
        length = length - 0x60;
        if ($f3f604935c83ab88$var$srcStringEnd >= $f3f604935c83ab88$var$position) return $f3f604935c83ab88$var$srcString.slice($f3f604935c83ab88$var$position - $f3f604935c83ab88$var$srcStringStart, ($f3f604935c83ab88$var$position += length) - $f3f604935c83ab88$var$srcStringStart);
        else if (!($f3f604935c83ab88$var$srcStringEnd == 0 && $f3f604935c83ab88$var$srcEnd < 180)) return $f3f604935c83ab88$var$readFixedString(length);
    } else {
        $f3f604935c83ab88$var$position--;
        return $f3f604935c83ab88$export$aafa59e2e03f2942();
    }
    let key = (length << 5 ^ (length > 1 ? $f3f604935c83ab88$var$dataView.getUint16($f3f604935c83ab88$var$position) : length > 0 ? $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position] : 0)) & 0xfff;
    let entry = $f3f604935c83ab88$var$keyCache[key];
    let checkPosition = $f3f604935c83ab88$var$position;
    let end = $f3f604935c83ab88$var$position + length - 3;
    let chunk;
    let i = 0;
    if (entry && entry.bytes == length) {
        while(checkPosition < end){
            chunk = $f3f604935c83ab88$var$dataView.getUint32(checkPosition);
            if (chunk != entry[i++]) {
                checkPosition = 0x70000000;
                break;
            }
            checkPosition += 4;
        }
        end += 3;
        while(checkPosition < end){
            chunk = $f3f604935c83ab88$var$src[checkPosition++];
            if (chunk != entry[i++]) {
                checkPosition = 0x70000000;
                break;
            }
        }
        if (checkPosition === end) {
            $f3f604935c83ab88$var$position = checkPosition;
            return entry.string;
        }
        end -= 3;
        checkPosition = $f3f604935c83ab88$var$position;
    }
    entry = [];
    $f3f604935c83ab88$var$keyCache[key] = entry;
    entry.bytes = length;
    while(checkPosition < end){
        chunk = $f3f604935c83ab88$var$dataView.getUint32(checkPosition);
        entry.push(chunk);
        checkPosition += 4;
    }
    end += 3;
    while(checkPosition < end){
        chunk = $f3f604935c83ab88$var$src[checkPosition++];
        entry.push(chunk);
    }
    // for small blocks, avoiding the overhead of the extract call is helpful
    let string = length < 16 ? $f3f604935c83ab88$var$shortStringInJS(length) : $f3f604935c83ab88$var$longStringInJS(length);
    if (string != null) return entry.string = string;
    return entry.string = $f3f604935c83ab88$var$readFixedString(length);
}
class $f3f604935c83ab88$export$3288d34c523a1192 {
    constructor(value, tag){
        this.value = value;
        this.tag = tag;
    }
}
$f3f604935c83ab88$var$currentExtensions[0] = (dateString)=>{
    // string date extension
    return new Date(dateString);
};
$f3f604935c83ab88$var$currentExtensions[1] = (epochSec)=>{
    // numeric date extension
    return new Date(Math.round(epochSec * 1000));
};
$f3f604935c83ab88$var$currentExtensions[2] = (buffer)=>{
    // bigint extension
    let value = BigInt(0);
    for(let i = 0, l = buffer.byteLength; i < l; i++)value = BigInt(buffer[i]) + value << BigInt(8);
    return value;
};
$f3f604935c83ab88$var$currentExtensions[3] = (buffer)=>{
    // negative bigint extension
    return BigInt(-1) - $f3f604935c83ab88$var$currentExtensions[2](buffer);
};
$f3f604935c83ab88$var$currentExtensions[4] = (fraction)=>{
    // best to reparse to maintain accuracy
    return +(fraction[1] + "e" + fraction[0]);
};
$f3f604935c83ab88$var$currentExtensions[5] = (fraction)=>{
    // probably not sufficiently accurate
    return fraction[1] * Math.exp(fraction[0] * Math.log(2));
};
// the registration of the record definition extension
const $f3f604935c83ab88$var$recordDefinition = (id, structure)=>{
    id = id - 0xe000;
    let existingStructure = $f3f604935c83ab88$var$currentStructures[id];
    if (existingStructure && existingStructure.isShared) ($f3f604935c83ab88$var$currentStructures.restoreStructures || ($f3f604935c83ab88$var$currentStructures.restoreStructures = []))[id] = existingStructure;
    $f3f604935c83ab88$var$currentStructures[id] = structure;
    structure.read = $f3f604935c83ab88$var$createStructureReader(structure);
};
$f3f604935c83ab88$var$currentExtensions[$f3f604935c83ab88$var$LEGACY_RECORD_INLINE_ID] = (data)=>{
    let length = data.length;
    let structure = data[1];
    $f3f604935c83ab88$var$recordDefinition(data[0], structure);
    let object = {};
    for(let i = 2; i < length; i++){
        let key = structure[i - 2];
        object[$f3f604935c83ab88$var$safeKey(key)] = data[i];
    }
    return object;
};
$f3f604935c83ab88$var$currentExtensions[14] = (value)=>{
    if ($f3f604935c83ab88$var$bundledStrings) return $f3f604935c83ab88$var$bundledStrings[0].slice($f3f604935c83ab88$var$bundledStrings.position0, $f3f604935c83ab88$var$bundledStrings.position0 += value);
    return new $f3f604935c83ab88$export$3288d34c523a1192(value, 14);
};
$f3f604935c83ab88$var$currentExtensions[15] = (value)=>{
    if ($f3f604935c83ab88$var$bundledStrings) return $f3f604935c83ab88$var$bundledStrings[1].slice($f3f604935c83ab88$var$bundledStrings.position1, $f3f604935c83ab88$var$bundledStrings.position1 += value);
    return new $f3f604935c83ab88$export$3288d34c523a1192(value, 15);
};
let $f3f604935c83ab88$var$glbl = {
    Error: Error,
    RegExp: RegExp
};
$f3f604935c83ab88$var$currentExtensions[27] = (data)=>{
    return ($f3f604935c83ab88$var$glbl[data[0]] || Error)(data[1], data[2]);
};
const $f3f604935c83ab88$var$packedTable = (read)=>{
    if ($f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++] != 0x84) throw new Error("Packed values structure must be followed by a 4 element array");
    let newPackedValues = read() // packed values
    ;
    $f3f604935c83ab88$var$packedValues = $f3f604935c83ab88$var$packedValues ? newPackedValues.concat($f3f604935c83ab88$var$packedValues.slice(newPackedValues.length)) : newPackedValues;
    $f3f604935c83ab88$var$packedValues.prefixes = read();
    $f3f604935c83ab88$var$packedValues.suffixes = read();
    return read() // read the rump
    ;
};
$f3f604935c83ab88$var$packedTable.handlesRead = true;
$f3f604935c83ab88$var$currentExtensions[51] = $f3f604935c83ab88$var$packedTable;
$f3f604935c83ab88$var$currentExtensions[$f3f604935c83ab88$var$PACKED_REFERENCE_TAG_ID] = (data)=>{
    if (!$f3f604935c83ab88$var$packedValues) {
        if ($f3f604935c83ab88$var$currentDecoder.getShared) $f3f604935c83ab88$var$loadShared();
        else return new $f3f604935c83ab88$export$3288d34c523a1192(data, $f3f604935c83ab88$var$PACKED_REFERENCE_TAG_ID);
    }
    if (typeof data == "number") return $f3f604935c83ab88$var$packedValues[16 + (data >= 0 ? 2 * data : -2 * data - 1)];
    throw new Error("No support for non-integer packed references yet");
};
// The following code is an incomplete implementation of http://cbor.schmorp.de/stringref
// the real thing would need to implemennt more logic to populate the stringRefs table and
// maintain a stack of stringRef "namespaces".
//
// currentExtensions[25] = (id) => {
// 	return stringRefs[id]
// }
// currentExtensions[256] = (read) => {
// 	stringRefs = []
// 	try {
// 		return read()
// 	} finally {
// 		stringRefs = null
// 	}
// }
// currentExtensions[256].handlesRead = true
$f3f604935c83ab88$var$currentExtensions[28] = (read)=>{
    // shareable http://cbor.schmorp.de/value-sharing (for structured clones)
    if (!$f3f604935c83ab88$var$referenceMap) {
        $f3f604935c83ab88$var$referenceMap = new Map();
        $f3f604935c83ab88$var$referenceMap.id = 0;
    }
    let id = $f3f604935c83ab88$var$referenceMap.id++;
    let token = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position];
    let target;
    // TODO: handle Maps, Sets, and other types that can cycle; this is complicated, because you potentially need to read
    // ahead past references to record structure definitions
    if (token >> 5 == 4) target = [];
    else target = {};
    let refEntry = {
        target: target
    } // a placeholder object
    ;
    $f3f604935c83ab88$var$referenceMap.set(id, refEntry);
    let targetProperties = read() // read the next value as the target object to id
    ;
    if (refEntry.used) return Object.assign(target, targetProperties);
    refEntry.target = targetProperties // the placeholder wasn't used, replace with the deserialized one
    ;
    return targetProperties // no cycle, can just use the returned read object
    ;
};
$f3f604935c83ab88$var$currentExtensions[28].handlesRead = true;
$f3f604935c83ab88$var$currentExtensions[29] = (id)=>{
    // sharedref http://cbor.schmorp.de/value-sharing (for structured clones)
    let refEntry = $f3f604935c83ab88$var$referenceMap.get(id);
    refEntry.used = true;
    return refEntry.target;
};
$f3f604935c83ab88$var$currentExtensions[258] = (array)=>new Set(array); // https://github.com/input-output-hk/cbor-sets-spec/blob/master/CBOR_SETS.md
($f3f604935c83ab88$var$currentExtensions[259] = (read)=>{
    // https://github.com/shanewholloway/js-cbor-codec/blob/master/docs/CBOR-259-spec
    // for decoding as a standard Map
    if ($f3f604935c83ab88$var$currentDecoder.mapsAsObjects) {
        $f3f604935c83ab88$var$currentDecoder.mapsAsObjects = false;
        $f3f604935c83ab88$var$restoreMapsAsObject = true;
    }
    return read();
}).handlesRead = true;
function $f3f604935c83ab88$var$combine(a, b) {
    if (typeof a === "string") return a + b;
    if (a instanceof Array) return a.concat(b);
    return Object.assign({}, a, b);
}
function $f3f604935c83ab88$var$getPackedValues() {
    if (!$f3f604935c83ab88$var$packedValues) {
        if ($f3f604935c83ab88$var$currentDecoder.getShared) $f3f604935c83ab88$var$loadShared();
        else throw new Error("No packed values available");
    }
    return $f3f604935c83ab88$var$packedValues;
}
const $f3f604935c83ab88$var$SHARED_DATA_TAG_ID = 0x53687264 // ascii 'Shrd'
;
$f3f604935c83ab88$var$currentExtensionRanges.push((tag, input)=>{
    if (tag >= 225 && tag <= 255) return $f3f604935c83ab88$var$combine($f3f604935c83ab88$var$getPackedValues().prefixes[tag - 224], input);
    if (tag >= 28704 && tag <= 32767) return $f3f604935c83ab88$var$combine($f3f604935c83ab88$var$getPackedValues().prefixes[tag - 28672], input);
    if (tag >= 1879052288 && tag <= 2147483647) return $f3f604935c83ab88$var$combine($f3f604935c83ab88$var$getPackedValues().prefixes[tag - 1879048192], input);
    if (tag >= 216 && tag <= 223) return $f3f604935c83ab88$var$combine(input, $f3f604935c83ab88$var$getPackedValues().suffixes[tag - 216]);
    if (tag >= 27647 && tag <= 28671) return $f3f604935c83ab88$var$combine(input, $f3f604935c83ab88$var$getPackedValues().suffixes[tag - 27639]);
    if (tag >= 1811940352 && tag <= 1879048191) return $f3f604935c83ab88$var$combine(input, $f3f604935c83ab88$var$getPackedValues().suffixes[tag - 1811939328]);
    if (tag == $f3f604935c83ab88$var$SHARED_DATA_TAG_ID) return {
        packedValues: $f3f604935c83ab88$var$packedValues,
        structures: $f3f604935c83ab88$var$currentStructures.slice(0),
        version: input
    };
    if (tag == 55799) return input;
});
const $f3f604935c83ab88$var$isLittleEndianMachine = new Uint8Array(new Uint16Array([
    1
]).buffer)[0] == 1;
const $f3f604935c83ab88$export$aae3eaec024a56b7 = [
    Uint8Array,
    Uint8ClampedArray,
    Uint16Array,
    Uint32Array,
    typeof BigUint64Array == "undefined" ? {
        name: "BigUint64Array"
    } : BigUint64Array,
    Int8Array,
    Int16Array,
    Int32Array,
    typeof BigInt64Array == "undefined" ? {
        name: "BigInt64Array"
    } : BigInt64Array,
    Float32Array,
    Float64Array
];
const $f3f604935c83ab88$var$typedArrayTags = [
    64,
    68,
    69,
    70,
    71,
    72,
    77,
    78,
    79,
    85,
    86
];
for(let i = 0; i < $f3f604935c83ab88$export$aae3eaec024a56b7.length; i++)$f3f604935c83ab88$var$registerTypedArray($f3f604935c83ab88$export$aae3eaec024a56b7[i], $f3f604935c83ab88$var$typedArrayTags[i]);
function $f3f604935c83ab88$var$registerTypedArray(TypedArray, tag) {
    let dvMethod = "get" + TypedArray.name.slice(0, -5);
    let bytesPerElement;
    if (typeof TypedArray === "function") bytesPerElement = TypedArray.BYTES_PER_ELEMENT;
    else TypedArray = null;
    for(let littleEndian = 0; littleEndian < 2; littleEndian++){
        if (!littleEndian && bytesPerElement == 1) continue;
        let sizeShift = bytesPerElement == 2 ? 1 : bytesPerElement == 4 ? 2 : 3;
        $f3f604935c83ab88$var$currentExtensions[littleEndian ? tag : tag - 4] = bytesPerElement == 1 || littleEndian == $f3f604935c83ab88$var$isLittleEndianMachine ? (buffer)=>{
            if (!TypedArray) throw new Error("Could not find typed array for code " + tag);
            // we have to always slice/copy here to get a new ArrayBuffer that is word/byte aligned
            return new TypedArray(Uint8Array.prototype.slice.call(buffer, 0).buffer);
        } : (buffer)=>{
            if (!TypedArray) throw new Error("Could not find typed array for code " + tag);
            let dv = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
            let elements = buffer.length >> sizeShift;
            let ta = new TypedArray(elements);
            let method = dv[dvMethod];
            for(let i = 0; i < elements; i++)ta[i] = method.call(dv, i << sizeShift, littleEndian);
            return ta;
        };
    }
}
function $f3f604935c83ab88$var$readBundleExt() {
    let length = $f3f604935c83ab88$var$readJustLength();
    let bundlePosition = $f3f604935c83ab88$var$position + $f3f604935c83ab88$export$aafa59e2e03f2942();
    for(let i = 2; i < length; i++){
        // skip past bundles that were already read
        let bundleLength = $f3f604935c83ab88$var$readJustLength() // this will increment position, so must add to position afterwards
        ;
        $f3f604935c83ab88$var$position += bundleLength;
    }
    let dataPosition = $f3f604935c83ab88$var$position;
    $f3f604935c83ab88$var$position = bundlePosition;
    $f3f604935c83ab88$var$bundledStrings = [
        $f3f604935c83ab88$var$readStringJS($f3f604935c83ab88$var$readJustLength()),
        $f3f604935c83ab88$var$readStringJS($f3f604935c83ab88$var$readJustLength())
    ];
    $f3f604935c83ab88$var$bundledStrings.position0 = 0;
    $f3f604935c83ab88$var$bundledStrings.position1 = 0;
    $f3f604935c83ab88$var$bundledStrings.postBundlePosition = $f3f604935c83ab88$var$position;
    $f3f604935c83ab88$var$position = dataPosition;
    return $f3f604935c83ab88$export$aafa59e2e03f2942();
}
function $f3f604935c83ab88$var$readJustLength() {
    let token = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++] & 0x1f;
    if (token > 0x17) switch(token){
        case 0x18:
            token = $f3f604935c83ab88$var$src[$f3f604935c83ab88$var$position++];
            break;
        case 0x19:
            token = $f3f604935c83ab88$var$dataView.getUint16($f3f604935c83ab88$var$position);
            $f3f604935c83ab88$var$position += 2;
            break;
        case 0x1a:
            token = $f3f604935c83ab88$var$dataView.getUint32($f3f604935c83ab88$var$position);
            $f3f604935c83ab88$var$position += 4;
            break;
    }
    return token;
}
function $f3f604935c83ab88$var$loadShared() {
    if ($f3f604935c83ab88$var$currentDecoder.getShared) {
        let sharedData = $f3f604935c83ab88$var$saveState(()=>{
            // save the state in case getShared modifies our buffer
            $f3f604935c83ab88$var$src = null;
            return $f3f604935c83ab88$var$currentDecoder.getShared();
        }) || {};
        let updatedStructures = sharedData.structures || [];
        $f3f604935c83ab88$var$currentDecoder.sharedVersion = sharedData.version;
        $f3f604935c83ab88$var$packedValues = $f3f604935c83ab88$var$currentDecoder.sharedValues = sharedData.packedValues;
        if ($f3f604935c83ab88$var$currentStructures === true) $f3f604935c83ab88$var$currentDecoder.structures = $f3f604935c83ab88$var$currentStructures = updatedStructures;
        else $f3f604935c83ab88$var$currentStructures.splice.apply($f3f604935c83ab88$var$currentStructures, [
            0,
            updatedStructures.length
        ].concat(updatedStructures));
    }
}
function $f3f604935c83ab88$var$saveState(callback) {
    let savedSrcEnd = $f3f604935c83ab88$var$srcEnd;
    let savedPosition = $f3f604935c83ab88$var$position;
    let savedStringPosition = $f3f604935c83ab88$var$stringPosition;
    let savedSrcStringStart = $f3f604935c83ab88$var$srcStringStart;
    let savedSrcStringEnd = $f3f604935c83ab88$var$srcStringEnd;
    let savedSrcString = $f3f604935c83ab88$var$srcString;
    let savedStrings = $f3f604935c83ab88$var$strings;
    let savedReferenceMap = $f3f604935c83ab88$var$referenceMap;
    let savedBundledStrings = $f3f604935c83ab88$var$bundledStrings;
    // TODO: We may need to revisit this if we do more external calls to user code (since it could be slow)
    let savedSrc = new Uint8Array($f3f604935c83ab88$var$src.slice(0, $f3f604935c83ab88$var$srcEnd)) // we copy the data in case it changes while external data is processed
    ;
    let savedStructures = $f3f604935c83ab88$var$currentStructures;
    let savedDecoder = $f3f604935c83ab88$var$currentDecoder;
    let savedSequentialMode = $f3f604935c83ab88$var$sequentialMode;
    let value = callback();
    $f3f604935c83ab88$var$srcEnd = savedSrcEnd;
    $f3f604935c83ab88$var$position = savedPosition;
    $f3f604935c83ab88$var$stringPosition = savedStringPosition;
    $f3f604935c83ab88$var$srcStringStart = savedSrcStringStart;
    $f3f604935c83ab88$var$srcStringEnd = savedSrcStringEnd;
    $f3f604935c83ab88$var$srcString = savedSrcString;
    $f3f604935c83ab88$var$strings = savedStrings;
    $f3f604935c83ab88$var$referenceMap = savedReferenceMap;
    $f3f604935c83ab88$var$bundledStrings = savedBundledStrings;
    $f3f604935c83ab88$var$src = savedSrc;
    $f3f604935c83ab88$var$sequentialMode = savedSequentialMode;
    $f3f604935c83ab88$var$currentStructures = savedStructures;
    $f3f604935c83ab88$var$currentDecoder = savedDecoder;
    $f3f604935c83ab88$var$dataView = new DataView($f3f604935c83ab88$var$src.buffer, $f3f604935c83ab88$var$src.byteOffset, $f3f604935c83ab88$var$src.byteLength);
    return value;
}
function $f3f604935c83ab88$export$e6f020404d5b6c15() {
    $f3f604935c83ab88$var$src = null;
    $f3f604935c83ab88$var$referenceMap = null;
    $f3f604935c83ab88$var$currentStructures = null;
}
function $f3f604935c83ab88$export$4e11b2f4fcd6c82d(extension) {
    $f3f604935c83ab88$var$currentExtensions[extension.tag] = extension.decode;
}
const $f3f604935c83ab88$export$c652a5bbb6be7a36 = new Array(147) // this is a table matching binary exponents to the multiplier to determine significant digit rounding
;
for(let i = 0; i < 256; i++)$f3f604935c83ab88$export$c652a5bbb6be7a36[i] = +("1e" + Math.floor(45.15 - i * 0.30103));
let $f3f604935c83ab88$var$defaultDecoder = new $f3f604935c83ab88$export$f9de6ca0bc043724({
    useRecords: false
});
const $f3f604935c83ab88$export$2f872c0f2117be69 = $f3f604935c83ab88$var$defaultDecoder.decode;
const $f3f604935c83ab88$export$ddfa300a3790ac32 = $f3f604935c83ab88$var$defaultDecoder.decodeMultiple;
const $f3f604935c83ab88$export$2239e49a3e351685 = {
    NEVER: 0,
    ALWAYS: 1,
    DECIMAL_ROUND: 3,
    DECIMAL_FIT: 4
};
function $f3f604935c83ab88$export$36da082398e4f139(float32Number) {
    $f3f604935c83ab88$var$f32Array[0] = float32Number;
    let multiplier = $f3f604935c83ab88$export$c652a5bbb6be7a36[($f3f604935c83ab88$var$u8Array[3] & 0x7f) << 1 | $f3f604935c83ab88$var$u8Array[2] >> 7];
    return (multiplier * float32Number + (float32Number > 0 ? 0.5 : -0.5) >> 0) / multiplier;
}


let $1213990bd941e1f8$var$textEncoder;
try {
    $1213990bd941e1f8$var$textEncoder = new TextEncoder();
} catch (error) {}
let $1213990bd941e1f8$var$extensions, $1213990bd941e1f8$var$extensionClasses;
const $1213990bd941e1f8$var$Buffer = typeof globalThis === "object" && globalThis.Buffer;
const $1213990bd941e1f8$var$hasNodeBuffer = typeof $1213990bd941e1f8$var$Buffer !== "undefined";
const $1213990bd941e1f8$var$ByteArrayAllocate = $1213990bd941e1f8$var$hasNodeBuffer ? $1213990bd941e1f8$var$Buffer.allocUnsafeSlow : Uint8Array;
const $1213990bd941e1f8$var$ByteArray = $1213990bd941e1f8$var$hasNodeBuffer ? $1213990bd941e1f8$var$Buffer : Uint8Array;
const $1213990bd941e1f8$var$MAX_STRUCTURES = 0x100;
const $1213990bd941e1f8$var$MAX_BUFFER_SIZE = $1213990bd941e1f8$var$hasNodeBuffer ? 0x100000000 : 0x7fd00000;
let $1213990bd941e1f8$var$serializationId = 1;
let $1213990bd941e1f8$var$throwOnIterable;
let $1213990bd941e1f8$var$target;
let $1213990bd941e1f8$var$targetView;
let $1213990bd941e1f8$var$position = 0;
let $1213990bd941e1f8$var$safeEnd;
let $1213990bd941e1f8$var$bundledStrings = null;
const $1213990bd941e1f8$var$MAX_BUNDLE_SIZE = 0xf000;
const $1213990bd941e1f8$var$hasNonLatin = /[\u0080-\uFFFF]/;
const $1213990bd941e1f8$var$RECORD_SYMBOL = Symbol("record-id");
class $1213990bd941e1f8$export$a50aceb0e02a00aa extends (0, $f3f604935c83ab88$export$f9de6ca0bc043724) {
    useBuffer(buffer) {
        // this means we are finished using our own buffer and we can write over it safely
        $1213990bd941e1f8$var$target = buffer;
        $1213990bd941e1f8$var$targetView = new DataView($1213990bd941e1f8$var$target.buffer, $1213990bd941e1f8$var$target.byteOffset, $1213990bd941e1f8$var$target.byteLength);
        $1213990bd941e1f8$var$position = 0;
    }
    clearSharedData() {
        if (this.structures) this.structures = [];
        if (this.sharedValues) this.sharedValues = undefined;
    }
    updateSharedData() {
        let lastVersion = this.sharedVersion || 0;
        this.sharedVersion = lastVersion + 1;
        let structuresCopy = this.structures.slice(0);
        let sharedData = new $1213990bd941e1f8$var$SharedData(structuresCopy, this.sharedValues, this.sharedVersion);
        let saveResults = this.saveShared(sharedData, (existingShared)=>(existingShared && existingShared.version || 0) == lastVersion);
        if (saveResults === false) {
            // get updated structures and try again if the update failed
            sharedData = this.getShared() || {};
            this.structures = sharedData.structures || [];
            this.sharedValues = sharedData.packedValues;
            this.sharedVersion = sharedData.version;
            this.structures.nextId = this.structures.length;
        } else // restore structures
        structuresCopy.forEach((structure, i)=>this.structures[i] = structure);
        // saveShared may fail to write and reload, or may have reloaded to check compatibility and overwrite saved data, either way load the correct shared data
        return saveResults;
    }
    constructor(options){
        super(options);
        this.offset = 0;
        let typeBuffer;
        let start;
        let sharedStructures;
        let hasSharedUpdate;
        let structures;
        let referenceMap;
        options = options || {};
        let encodeUtf8 = $1213990bd941e1f8$var$ByteArray.prototype.utf8Write ? function(string, position, maxBytes) {
            return $1213990bd941e1f8$var$target.utf8Write(string, position, maxBytes);
        } : $1213990bd941e1f8$var$textEncoder && $1213990bd941e1f8$var$textEncoder.encodeInto ? function(string, position) {
            return $1213990bd941e1f8$var$textEncoder.encodeInto(string, $1213990bd941e1f8$var$target.subarray(position)).written;
        } : false;
        let encoder = this;
        let hasSharedStructures = options.structures || options.saveStructures;
        let maxSharedStructures = options.maxSharedStructures;
        if (maxSharedStructures == null) maxSharedStructures = hasSharedStructures ? 128 : 0;
        if (maxSharedStructures > 8190) throw new Error("Maximum maxSharedStructure is 8190");
        let isSequential = options.sequential;
        if (isSequential) maxSharedStructures = 0;
        if (!this.structures) this.structures = [];
        if (this.saveStructures) this.saveShared = this.saveStructures;
        let samplingPackedValues, packedObjectMap1, sharedValues = options.sharedValues;
        let sharedPackedObjectMap1;
        if (sharedValues) {
            sharedPackedObjectMap1 = Object.create(null);
            for(let i = 0, l = sharedValues.length; i < l; i++)sharedPackedObjectMap1[sharedValues[i]] = i;
        }
        let recordIdsToRemove = [];
        let transitionsCount = 0;
        let serializationsSinceTransitionRebuild = 0;
        this.mapEncode = function(value, encodeOptions) {
            // Experimental support for premapping keys using _keyMap instad of keyMap - not optiimised yet)
            if (this._keyMap && !this._mapped) //console.log('encoding ', value)
            switch(value.constructor.name){
                case "Array":
                    value = value.map((r)=>this.encodeKeys(r));
                    break;
            }
            return this.encode(value, encodeOptions);
        };
        this.encode = function(value, encodeOptions) {
            if (!$1213990bd941e1f8$var$target) {
                $1213990bd941e1f8$var$target = new $1213990bd941e1f8$var$ByteArrayAllocate(8192);
                $1213990bd941e1f8$var$targetView = new DataView($1213990bd941e1f8$var$target.buffer, 0, 8192);
                $1213990bd941e1f8$var$position = 0;
            }
            $1213990bd941e1f8$var$safeEnd = $1213990bd941e1f8$var$target.length - 10;
            if ($1213990bd941e1f8$var$safeEnd - $1213990bd941e1f8$var$position < 0x800) {
                // don't start too close to the end, 
                $1213990bd941e1f8$var$target = new $1213990bd941e1f8$var$ByteArrayAllocate($1213990bd941e1f8$var$target.length);
                $1213990bd941e1f8$var$targetView = new DataView($1213990bd941e1f8$var$target.buffer, 0, $1213990bd941e1f8$var$target.length);
                $1213990bd941e1f8$var$safeEnd = $1213990bd941e1f8$var$target.length - 10;
                $1213990bd941e1f8$var$position = 0;
            } else if (encodeOptions === $1213990bd941e1f8$export$d41ac1453288b342) $1213990bd941e1f8$var$position = $1213990bd941e1f8$var$position + 7 & 0x7ffffff8 // Word align to make any future copying of this buffer faster
            ;
            start = $1213990bd941e1f8$var$position;
            if (encoder.useSelfDescribedHeader) {
                $1213990bd941e1f8$var$targetView.setUint32($1213990bd941e1f8$var$position, 0xd9d9f700) // tag two byte, then self-descriptive tag
                ;
                $1213990bd941e1f8$var$position += 3;
            }
            referenceMap = encoder.structuredClone ? new Map() : null;
            if (encoder.bundleStrings && typeof value !== "string") {
                $1213990bd941e1f8$var$bundledStrings = [];
                $1213990bd941e1f8$var$bundledStrings.size = Infinity // force a new bundle start on first string
                ;
            } else $1213990bd941e1f8$var$bundledStrings = null;
            sharedStructures = encoder.structures;
            if (sharedStructures) {
                if (sharedStructures.uninitialized) {
                    let sharedData = encoder.getShared() || {};
                    encoder.structures = sharedStructures = sharedData.structures || [];
                    encoder.sharedVersion = sharedData.version;
                    let sharedValues = encoder.sharedValues = sharedData.packedValues;
                    if (sharedValues) {
                        sharedPackedObjectMap1 = {};
                        for(let i = 0, l = sharedValues.length; i < l; i++)sharedPackedObjectMap1[sharedValues[i]] = i;
                    }
                }
                let sharedStructuresLength = sharedStructures.length;
                if (sharedStructuresLength > maxSharedStructures && !isSequential) sharedStructuresLength = maxSharedStructures;
                if (!sharedStructures.transitions) {
                    // rebuild our structure transitions
                    sharedStructures.transitions = Object.create(null);
                    for(let i = 0; i < sharedStructuresLength; i++){
                        let keys = sharedStructures[i];
                        //console.log('shared struct keys:', keys)
                        if (!keys) continue;
                        let nextTransition, transition = sharedStructures.transitions;
                        for(let j = 0, l = keys.length; j < l; j++){
                            if (transition[$1213990bd941e1f8$var$RECORD_SYMBOL] === undefined) transition[$1213990bd941e1f8$var$RECORD_SYMBOL] = i;
                            let key = keys[j];
                            nextTransition = transition[key];
                            if (!nextTransition) nextTransition = transition[key] = Object.create(null);
                            transition = nextTransition;
                        }
                        transition[$1213990bd941e1f8$var$RECORD_SYMBOL] = i | 0x100000;
                    }
                }
                if (!isSequential) sharedStructures.nextId = sharedStructuresLength;
            }
            if (hasSharedUpdate) hasSharedUpdate = false;
            structures = sharedStructures || [];
            packedObjectMap1 = sharedPackedObjectMap1;
            if (options.pack) {
                let packedValues = new Map();
                packedValues.values = [];
                packedValues.encoder = encoder;
                packedValues.maxValues = options.maxPrivatePackedValues || (sharedPackedObjectMap1 ? 16 : Infinity);
                packedValues.objectMap = sharedPackedObjectMap1 || false;
                packedValues.samplingPackedValues = samplingPackedValues;
                $1213990bd941e1f8$var$findRepetitiveStrings(value, packedValues);
                if (packedValues.values.length > 0) {
                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xd8 // one-byte tag
                    ;
                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 51 // tag 51 for packed shared structures https://www.potaroo.net/ietf/ids/draft-ietf-cbor-packed-03.txt
                    ;
                    $1213990bd941e1f8$var$writeArrayHeader(4);
                    let valuesArray = packedValues.values;
                    encode(valuesArray);
                    $1213990bd941e1f8$var$writeArrayHeader(0) // prefixes
                    ;
                    $1213990bd941e1f8$var$writeArrayHeader(0) // suffixes
                    ;
                    packedObjectMap1 = Object.create(sharedPackedObjectMap1 || null);
                    for(let i = 0, l = valuesArray.length; i < l; i++)packedObjectMap1[valuesArray[i]] = i;
                }
            }
            $1213990bd941e1f8$var$throwOnIterable = encodeOptions & $1213990bd941e1f8$export$e724ae76933ea297;
            try {
                if ($1213990bd941e1f8$var$throwOnIterable) return;
                encode(value);
                if ($1213990bd941e1f8$var$bundledStrings) $1213990bd941e1f8$var$writeBundles(start, encode);
                encoder.offset = $1213990bd941e1f8$var$position // update the offset so next serialization doesn't write over our buffer, but can continue writing to same buffer sequentially
                ;
                if (referenceMap && referenceMap.idsToInsert) {
                    $1213990bd941e1f8$var$position += referenceMap.idsToInsert.length * 2;
                    if ($1213990bd941e1f8$var$position > $1213990bd941e1f8$var$safeEnd) makeRoom($1213990bd941e1f8$var$position);
                    encoder.offset = $1213990bd941e1f8$var$position;
                    let serialized = $1213990bd941e1f8$var$insertIds($1213990bd941e1f8$var$target.subarray(start, $1213990bd941e1f8$var$position), referenceMap.idsToInsert);
                    referenceMap = null;
                    return serialized;
                }
                if (encodeOptions & $1213990bd941e1f8$export$d41ac1453288b342) {
                    $1213990bd941e1f8$var$target.start = start;
                    $1213990bd941e1f8$var$target.end = $1213990bd941e1f8$var$position;
                    return $1213990bd941e1f8$var$target;
                }
                return $1213990bd941e1f8$var$target.subarray(start, $1213990bd941e1f8$var$position) // position can change if we call encode again in saveShared, so we get the buffer now
                ;
            } finally{
                if (sharedStructures) {
                    if (serializationsSinceTransitionRebuild < 10) serializationsSinceTransitionRebuild++;
                    if (sharedStructures.length > maxSharedStructures) sharedStructures.length = maxSharedStructures;
                    if (transitionsCount > 10000) {
                        // force a rebuild occasionally after a lot of transitions so it can get cleaned up
                        sharedStructures.transitions = null;
                        serializationsSinceTransitionRebuild = 0;
                        transitionsCount = 0;
                        if (recordIdsToRemove.length > 0) recordIdsToRemove = [];
                    } else if (recordIdsToRemove.length > 0 && !isSequential) {
                        for(let i = 0, l = recordIdsToRemove.length; i < l; i++)recordIdsToRemove[i][$1213990bd941e1f8$var$RECORD_SYMBOL] = undefined;
                        recordIdsToRemove = [];
                    //sharedStructures.nextId = maxSharedStructures
                    }
                }
                if (hasSharedUpdate && encoder.saveShared) {
                    if (encoder.structures.length > maxSharedStructures) encoder.structures = encoder.structures.slice(0, maxSharedStructures);
                    // we can't rely on start/end with REUSE_BUFFER_MODE since they will (probably) change when we save
                    let returnBuffer = $1213990bd941e1f8$var$target.subarray(start, $1213990bd941e1f8$var$position);
                    if (encoder.updateSharedData() === false) return encoder.encode(value) // re-encode if it fails
                    ;
                    return returnBuffer;
                }
                if (encodeOptions & $1213990bd941e1f8$export$5687accb6effa257) $1213990bd941e1f8$var$position = start;
            }
        };
        this.findCommonStringsToPack = ()=>{
            samplingPackedValues = new Map();
            if (!sharedPackedObjectMap1) sharedPackedObjectMap1 = Object.create(null);
            return (options)=>{
                let threshold = options && options.threshold || 4;
                let position = this.pack ? options.maxPrivatePackedValues || 16 : 0;
                if (!sharedValues) sharedValues = this.sharedValues = [];
                for (let [key, status] of samplingPackedValues)if (status.count > threshold) {
                    sharedPackedObjectMap1[key] = position++;
                    sharedValues.push(key);
                    hasSharedUpdate = true;
                }
                while(this.saveShared && this.updateSharedData() === false);
                samplingPackedValues = null;
            };
        };
        const encode = (value)=>{
            if ($1213990bd941e1f8$var$position > $1213990bd941e1f8$var$safeEnd) $1213990bd941e1f8$var$target = makeRoom($1213990bd941e1f8$var$position);
            var type = typeof value;
            var length;
            if (type === "string") {
                if (packedObjectMap1) {
                    let packedPosition = packedObjectMap1[value];
                    if (packedPosition >= 0) {
                        if (packedPosition < 16) $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = packedPosition + 0xe0 // simple values, defined in https://www.potaroo.net/ietf/ids/draft-ietf-cbor-packed-03.txt
                        ;
                        else {
                            $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xc6 // tag 6 defined in https://www.potaroo.net/ietf/ids/draft-ietf-cbor-packed-03.txt
                            ;
                            if (packedPosition & 1) encode(15 - packedPosition >> 1);
                            else encode(packedPosition - 16 >> 1);
                        }
                        return;
                    /*						} else if (packedStatus.serializationId != serializationId) {
							packedStatus.serializationId = serializationId
							packedStatus.count = 1
							if (options.sharedPack) {
								let sharedCount = packedStatus.sharedCount = (packedStatus.sharedCount || 0) + 1
								if (shareCount > (options.sharedPack.threshold || 5)) {
									let sharedPosition = packedStatus.position = packedStatus.nextSharedPosition
									hasSharedUpdate = true
									if (sharedPosition < 16)
										target[position++] = sharedPosition + 0xc0

								}
							}
						} // else any in-doc incrementation?*/ } else if (samplingPackedValues && !options.pack) {
                        let status = samplingPackedValues.get(value);
                        if (status) status.count++;
                        else samplingPackedValues.set(value, {
                            count: 1
                        });
                    }
                }
                let strLength = value.length;
                if ($1213990bd941e1f8$var$bundledStrings && strLength >= 4 && strLength < 0x400) {
                    if (($1213990bd941e1f8$var$bundledStrings.size += strLength) > $1213990bd941e1f8$var$MAX_BUNDLE_SIZE) {
                        let extStart;
                        let maxBytes = ($1213990bd941e1f8$var$bundledStrings[0] ? $1213990bd941e1f8$var$bundledStrings[0].length * 3 + $1213990bd941e1f8$var$bundledStrings[1].length : 0) + 10;
                        if ($1213990bd941e1f8$var$position + maxBytes > $1213990bd941e1f8$var$safeEnd) $1213990bd941e1f8$var$target = makeRoom($1213990bd941e1f8$var$position + maxBytes);
                        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xd9 // tag 16-bit
                        ;
                        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xdf // tag 0xdff9
                        ;
                        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xf9;
                        // TODO: If we only have one bundle with any string data, only write one string bundle
                        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = $1213990bd941e1f8$var$bundledStrings.position ? 0x84 : 0x82 // array of 4 or 2 elements depending on if we write bundles
                        ;
                        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x1a // 32-bit unsigned int
                        ;
                        extStart = $1213990bd941e1f8$var$position - start;
                        $1213990bd941e1f8$var$position += 4 // reserve for writing bundle reference
                        ;
                        if ($1213990bd941e1f8$var$bundledStrings.position) $1213990bd941e1f8$var$writeBundles(start, encode) // write the last bundles
                        ;
                        $1213990bd941e1f8$var$bundledStrings = [
                            "",
                            ""
                        ] // create new ones
                        ;
                        $1213990bd941e1f8$var$bundledStrings.size = 0;
                        $1213990bd941e1f8$var$bundledStrings.position = extStart;
                    }
                    let twoByte = $1213990bd941e1f8$var$hasNonLatin.test(value);
                    $1213990bd941e1f8$var$bundledStrings[twoByte ? 0 : 1] += value;
                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = twoByte ? 0xce : 0xcf;
                    encode(strLength);
                    return;
                }
                let headerSize;
                // first we estimate the header size, so we can write to the correct location
                if (strLength < 0x20) headerSize = 1;
                else if (strLength < 0x100) headerSize = 2;
                else if (strLength < 0x10000) headerSize = 3;
                else headerSize = 5;
                let maxBytes = strLength * 3;
                if ($1213990bd941e1f8$var$position + maxBytes > $1213990bd941e1f8$var$safeEnd) $1213990bd941e1f8$var$target = makeRoom($1213990bd941e1f8$var$position + maxBytes);
                if (strLength < 0x40 || !encodeUtf8) {
                    let i, c1, c2, strPosition = $1213990bd941e1f8$var$position + headerSize;
                    for(i = 0; i < strLength; i++){
                        c1 = value.charCodeAt(i);
                        if (c1 < 0x80) $1213990bd941e1f8$var$target[strPosition++] = c1;
                        else if (c1 < 0x800) {
                            $1213990bd941e1f8$var$target[strPosition++] = c1 >> 6 | 0xc0;
                            $1213990bd941e1f8$var$target[strPosition++] = c1 & 0x3f | 0x80;
                        } else if ((c1 & 0xfc00) === 0xd800 && ((c2 = value.charCodeAt(i + 1)) & 0xfc00) === 0xdc00) {
                            c1 = 0x10000 + ((c1 & 0x03ff) << 10) + (c2 & 0x03ff);
                            i++;
                            $1213990bd941e1f8$var$target[strPosition++] = c1 >> 18 | 0xf0;
                            $1213990bd941e1f8$var$target[strPosition++] = c1 >> 12 & 0x3f | 0x80;
                            $1213990bd941e1f8$var$target[strPosition++] = c1 >> 6 & 0x3f | 0x80;
                            $1213990bd941e1f8$var$target[strPosition++] = c1 & 0x3f | 0x80;
                        } else {
                            $1213990bd941e1f8$var$target[strPosition++] = c1 >> 12 | 0xe0;
                            $1213990bd941e1f8$var$target[strPosition++] = c1 >> 6 & 0x3f | 0x80;
                            $1213990bd941e1f8$var$target[strPosition++] = c1 & 0x3f | 0x80;
                        }
                    }
                    length = strPosition - $1213990bd941e1f8$var$position - headerSize;
                } else length = encodeUtf8(value, $1213990bd941e1f8$var$position + headerSize, maxBytes);
                if (length < 0x18) $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x60 | length;
                else if (length < 0x100) {
                    if (headerSize < 2) $1213990bd941e1f8$var$target.copyWithin($1213990bd941e1f8$var$position + 2, $1213990bd941e1f8$var$position + 1, $1213990bd941e1f8$var$position + 1 + length);
                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x78;
                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = length;
                } else if (length < 0x10000) {
                    if (headerSize < 3) $1213990bd941e1f8$var$target.copyWithin($1213990bd941e1f8$var$position + 3, $1213990bd941e1f8$var$position + 2, $1213990bd941e1f8$var$position + 2 + length);
                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x79;
                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = length >> 8;
                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = length & 0xff;
                } else {
                    if (headerSize < 5) $1213990bd941e1f8$var$target.copyWithin($1213990bd941e1f8$var$position + 5, $1213990bd941e1f8$var$position + 3, $1213990bd941e1f8$var$position + 3 + length);
                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x7a;
                    $1213990bd941e1f8$var$targetView.setUint32($1213990bd941e1f8$var$position, length);
                    $1213990bd941e1f8$var$position += 4;
                }
                $1213990bd941e1f8$var$position += length;
            } else if (type === "number") {
                if (!this.alwaysUseFloat && value >>> 0 === value) {
                    // positive uint
                    if (value < 0x18) $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = value;
                    else if (value < 0x100) {
                        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x18;
                        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = value;
                    } else if (value < 0x10000) {
                        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x19;
                        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = value >> 8;
                        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = value & 0xff;
                    } else {
                        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x1a;
                        $1213990bd941e1f8$var$targetView.setUint32($1213990bd941e1f8$var$position, value);
                        $1213990bd941e1f8$var$position += 4;
                    }
                } else if (!this.alwaysUseFloat && value >> 0 === value) {
                    if (value >= -24) $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x1f - value;
                    else if (value >= -256) {
                        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x38;
                        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = ~value;
                    } else if (value >= -65536) {
                        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x39;
                        $1213990bd941e1f8$var$targetView.setUint16($1213990bd941e1f8$var$position, ~value);
                        $1213990bd941e1f8$var$position += 2;
                    } else {
                        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x3a;
                        $1213990bd941e1f8$var$targetView.setUint32($1213990bd941e1f8$var$position, ~value);
                        $1213990bd941e1f8$var$position += 4;
                    }
                } else {
                    let useFloat32;
                    if ((useFloat32 = this.useFloat32) > 0 && value < 0x100000000 && value >= -2147483648) {
                        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xfa;
                        $1213990bd941e1f8$var$targetView.setFloat32($1213990bd941e1f8$var$position, value);
                        let xShifted;
                        if (useFloat32 < 4 || (xShifted = value * (0, $f3f604935c83ab88$export$c652a5bbb6be7a36)[($1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position] & 0x7f) << 1 | $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position + 1] >> 7]) >> 0 === xShifted) {
                            $1213990bd941e1f8$var$position += 4;
                            return;
                        } else $1213990bd941e1f8$var$position-- // move back into position for writing a double
                        ;
                    }
                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xfb;
                    $1213990bd941e1f8$var$targetView.setFloat64($1213990bd941e1f8$var$position, value);
                    $1213990bd941e1f8$var$position += 8;
                }
            } else if (type === "object") {
                if (!value) $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xf6;
                else {
                    if (referenceMap) {
                        let referee = referenceMap.get(value);
                        if (referee) {
                            $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xd8;
                            $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 29 // http://cbor.schmorp.de/value-sharing
                            ;
                            $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x19 // 16-bit uint
                            ;
                            if (!referee.references) {
                                let idsToInsert = referenceMap.idsToInsert || (referenceMap.idsToInsert = []);
                                referee.references = [];
                                idsToInsert.push(referee);
                            }
                            referee.references.push($1213990bd941e1f8$var$position - start);
                            $1213990bd941e1f8$var$position += 2 // TODO: also support 32-bit
                            ;
                            return;
                        } else referenceMap.set(value, {
                            offset: $1213990bd941e1f8$var$position - start
                        });
                    }
                    let constructor = value.constructor;
                    if (constructor === Object) writeObject(value, true);
                    else if (constructor === Array) {
                        length = value.length;
                        if (length < 0x18) $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x80 | length;
                        else $1213990bd941e1f8$var$writeArrayHeader(length);
                        for(let i = 0; i < length; i++)encode(value[i]);
                    } else if (constructor === Map) {
                        if (this.mapsAsObjects ? this.useTag259ForMaps !== false : this.useTag259ForMaps) {
                            // use Tag 259 (https://github.com/shanewholloway/js-cbor-codec/blob/master/docs/CBOR-259-spec--explicit-maps.md) for maps if the user wants it that way
                            $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xd9;
                            $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 1;
                            $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 3;
                        }
                        length = value.size;
                        if (length < 0x18) $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xa0 | length;
                        else if (length < 0x100) {
                            $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xb8;
                            $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = length;
                        } else if (length < 0x10000) {
                            $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xb9;
                            $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = length >> 8;
                            $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = length & 0xff;
                        } else {
                            $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xba;
                            $1213990bd941e1f8$var$targetView.setUint32($1213990bd941e1f8$var$position, length);
                            $1213990bd941e1f8$var$position += 4;
                        }
                        if (encoder.keyMap) for (let [key, entryValue] of value){
                            encode(encoder.encodeKey(key));
                            encode(entryValue);
                        }
                        else for (let [key, entryValue] of value){
                            encode(key);
                            encode(entryValue);
                        }
                    } else {
                        for(let i = 0, l = $1213990bd941e1f8$var$extensions.length; i < l; i++){
                            let extensionClass = $1213990bd941e1f8$var$extensionClasses[i];
                            if (value instanceof extensionClass) {
                                let extension = $1213990bd941e1f8$var$extensions[i];
                                let tag = extension.tag;
                                if (tag == undefined) tag = extension.getTag && extension.getTag.call(this, value);
                                if (tag < 0x18) $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xc0 | tag;
                                else if (tag < 0x100) {
                                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xd8;
                                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = tag;
                                } else if (tag < 0x10000) {
                                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xd9;
                                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = tag >> 8;
                                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = tag & 0xff;
                                } else if (tag > -1) {
                                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xda;
                                    $1213990bd941e1f8$var$targetView.setUint32($1213990bd941e1f8$var$position, tag);
                                    $1213990bd941e1f8$var$position += 4;
                                } // else undefined, don't write tag
                                extension.encode.call(this, value, encode, makeRoom);
                                return;
                            }
                        }
                        if (value[Symbol.iterator]) {
                            if ($1213990bd941e1f8$var$throwOnIterable) {
                                let error = new Error("Iterable should be serialized as iterator");
                                error.iteratorNotHandled = true;
                                throw error;
                            }
                            $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x9f // indefinite length array
                            ;
                            for (let entry of value)encode(entry);
                            $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xff // stop-code
                            ;
                            return;
                        }
                        if (value[Symbol.asyncIterator] || $1213990bd941e1f8$var$isBlob(value)) {
                            let error = new Error("Iterable/blob should be serialized as iterator");
                            error.iteratorNotHandled = true;
                            throw error;
                        }
                        if (this.useToJSON && value.toJSON) {
                            const json = value.toJSON();
                            // if for some reason value.toJSON returns itself it'll loop forever
                            if (json !== value) return encode(json);
                        }
                        // no extension found, write as object
                        writeObject(value, !value.hasOwnProperty) // if it doesn't have hasOwnProperty, don't do hasOwnProperty checks
                        ;
                    }
                }
            } else if (type === "boolean") $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = value ? 0xf5 : 0xf4;
            else if (type === "bigint") {
                if (value < BigInt(1) << BigInt(64) && value >= 0) {
                    // use an unsigned int as long as it fits
                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x1b;
                    $1213990bd941e1f8$var$targetView.setBigUint64($1213990bd941e1f8$var$position, value);
                } else if (value > -(BigInt(1) << BigInt(64)) && value < 0) {
                    // if we can fit an unsigned int, use that
                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x3b;
                    $1213990bd941e1f8$var$targetView.setBigUint64($1213990bd941e1f8$var$position, -value - BigInt(1));
                } else {
                    // overflow
                    if (this.largeBigIntToFloat) {
                        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xfb;
                        $1213990bd941e1f8$var$targetView.setFloat64($1213990bd941e1f8$var$position, Number(value));
                    } else throw new RangeError(value + " was too large to fit in CBOR 64-bit integer format, set largeBigIntToFloat to convert to float-64");
                }
                $1213990bd941e1f8$var$position += 8;
            } else if (type === "undefined") $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xf7;
            else throw new Error("Unknown type: " + type);
        };
        const writeObject = this.useRecords === false ? this.variableMapSize ? (object)=>{
            // this method is slightly slower, but generates "preferred serialization" (optimally small for smaller objects)
            let keys = Object.keys(object);
            let vals = Object.values(object);
            let length = keys.length;
            if (length < 0x18) $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xa0 | length;
            else if (length < 0x100) {
                $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xb8;
                $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = length;
            } else if (length < 0x10000) {
                $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xb9;
                $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = length >> 8;
                $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = length & 0xff;
            } else {
                $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xba;
                $1213990bd941e1f8$var$targetView.setUint32($1213990bd941e1f8$var$position, length);
                $1213990bd941e1f8$var$position += 4;
            }
            let key;
            if (encoder.keyMap) for(let i = 0; i < length; i++){
                encode(encoder.encodeKey(keys[i]));
                encode(vals[i]);
            }
            else for(let i = 0; i < length; i++){
                encode(keys[i]);
                encode(vals[i]);
            }
        } : (object, safePrototype)=>{
            $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xb9 // always use map 16, so we can preallocate and set the length afterwards
            ;
            let objectOffset = $1213990bd941e1f8$var$position - start;
            $1213990bd941e1f8$var$position += 2;
            let size = 0;
            if (encoder.keyMap) {
                for(let key in object)if (safePrototype || object.hasOwnProperty(key)) {
                    encode(encoder.encodeKey(key));
                    encode(object[key]);
                    size++;
                }
            } else {
                for(let key in object)if (safePrototype || object.hasOwnProperty(key)) {
                    encode(key);
                    encode(object[key]);
                    size++;
                }
            }
            $1213990bd941e1f8$var$target[objectOffset++ + start] = size >> 8;
            $1213990bd941e1f8$var$target[objectOffset + start] = size & 0xff;
        } : (object, safePrototype)=>{
            let nextTransition, transition = structures.transitions || (structures.transitions = Object.create(null));
            let newTransitions = 0;
            let length = 0;
            let parentRecordId;
            let keys;
            if (this.keyMap) {
                keys = Object.keys(object).map((k)=>this.encodeKey(k));
                length = keys.length;
                for(let i = 0; i < length; i++){
                    let key = keys[i];
                    nextTransition = transition[key];
                    if (!nextTransition) {
                        nextTransition = transition[key] = Object.create(null);
                        newTransitions++;
                    }
                    transition = nextTransition;
                }
            } else {
                for(let key in object)if (safePrototype || object.hasOwnProperty(key)) {
                    nextTransition = transition[key];
                    if (!nextTransition) {
                        if (transition[$1213990bd941e1f8$var$RECORD_SYMBOL] & 0x100000) parentRecordId = transition[$1213990bd941e1f8$var$RECORD_SYMBOL] & 0xffff;
                        nextTransition = transition[key] = Object.create(null);
                        newTransitions++;
                    }
                    transition = nextTransition;
                    length++;
                }
            }
            let recordId = transition[$1213990bd941e1f8$var$RECORD_SYMBOL];
            if (recordId !== undefined) {
                recordId &= 0xffff;
                $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xd9;
                $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = recordId >> 8 | 0xe0;
                $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = recordId & 0xff;
            } else {
                if (!keys) keys = transition.__keys__ || (transition.__keys__ = Object.keys(object));
                if (parentRecordId === undefined) {
                    recordId = structures.nextId++;
                    if (!recordId) {
                        recordId = 0;
                        structures.nextId = 1;
                    }
                    if (recordId >= $1213990bd941e1f8$var$MAX_STRUCTURES) structures.nextId = (recordId = maxSharedStructures) + 1;
                } else recordId = parentRecordId;
                structures[recordId] = keys;
                if (recordId < maxSharedStructures) {
                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xd9;
                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = recordId >> 8 | 0xe0;
                    $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = recordId & 0xff;
                    transition = structures.transitions;
                    for(let i = 0; i < length; i++){
                        if (transition[$1213990bd941e1f8$var$RECORD_SYMBOL] === undefined || transition[$1213990bd941e1f8$var$RECORD_SYMBOL] & 0x100000) transition[$1213990bd941e1f8$var$RECORD_SYMBOL] = recordId;
                        transition = transition[keys[i]];
                    }
                    transition[$1213990bd941e1f8$var$RECORD_SYMBOL] = recordId | 0x100000 // indicates it is a extendable terminal
                    ;
                    hasSharedUpdate = true;
                } else {
                    transition[$1213990bd941e1f8$var$RECORD_SYMBOL] = recordId;
                    $1213990bd941e1f8$var$targetView.setUint32($1213990bd941e1f8$var$position, 0xd9dfff00) // tag two byte, then record definition id
                    ;
                    $1213990bd941e1f8$var$position += 3;
                    if (newTransitions) transitionsCount += serializationsSinceTransitionRebuild * newTransitions;
                    // record the removal of the id, we can maintain our shared structure
                    if (recordIdsToRemove.length >= $1213990bd941e1f8$var$MAX_STRUCTURES - maxSharedStructures) recordIdsToRemove.shift()[$1213990bd941e1f8$var$RECORD_SYMBOL] = undefined // we are cycling back through, and have to remove old ones
                    ;
                    recordIdsToRemove.push(transition);
                    $1213990bd941e1f8$var$writeArrayHeader(length + 2);
                    encode(0xe000 + recordId);
                    encode(keys);
                    if (safePrototype === null) return; // special exit for iterator
                    for(let key in object)if (safePrototype || object.hasOwnProperty(key)) encode(object[key]);
                    return;
                }
            }
            if (length < 0x18) $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x80 | length;
            else $1213990bd941e1f8$var$writeArrayHeader(length);
            if (safePrototype === null) return; // special exit for iterator
            for(let key in object)if (safePrototype || object.hasOwnProperty(key)) encode(object[key]);
        };
        const makeRoom = (end)=>{
            let newSize;
            if (end > 0x1000000) {
                // special handling for really large buffers
                if (end - start > $1213990bd941e1f8$var$MAX_BUFFER_SIZE) throw new Error("Encoded buffer would be larger than maximum buffer size");
                newSize = Math.min($1213990bd941e1f8$var$MAX_BUFFER_SIZE, Math.round(Math.max((end - start) * (end > 0x4000000 ? 1.25 : 2), 0x400000) / 0x1000) * 0x1000);
            } else newSize = (Math.max(end - start << 2, $1213990bd941e1f8$var$target.length - 1) >> 12) + 1 << 12;
            let newBuffer = new $1213990bd941e1f8$var$ByteArrayAllocate(newSize);
            $1213990bd941e1f8$var$targetView = new DataView(newBuffer.buffer, 0, newSize);
            if ($1213990bd941e1f8$var$target.copy) $1213990bd941e1f8$var$target.copy(newBuffer, 0, start, end);
            else newBuffer.set($1213990bd941e1f8$var$target.slice(start, end));
            $1213990bd941e1f8$var$position -= start;
            start = 0;
            $1213990bd941e1f8$var$safeEnd = newBuffer.length - 10;
            return $1213990bd941e1f8$var$target = newBuffer;
        };
        let chunkThreshold = 100;
        let continuedChunkThreshold = 1000;
        this.encodeAsIterable = function(value, options) {
            return startEncoding(value, options, encodeObjectAsIterable);
        };
        this.encodeAsAsyncIterable = function(value, options) {
            return startEncoding(value, options, encodeObjectAsAsyncIterable);
        };
        function* encodeObjectAsIterable(object, iterateProperties, finalIterable) {
            let constructor = object.constructor;
            if (constructor === Object) {
                let useRecords = encoder.useRecords !== false;
                if (useRecords) writeObject(object, null); // write the record identifier
                else $1213990bd941e1f8$var$writeEntityLength(Object.keys(object).length, 0xa0);
                for(let key in object){
                    let value = object[key];
                    if (!useRecords) encode(key);
                    if (value && typeof value === "object") {
                        if (iterateProperties[key]) yield* encodeObjectAsIterable(value, iterateProperties[key]);
                        else yield* tryEncode(value, iterateProperties, key);
                    } else encode(value);
                }
            } else if (constructor === Array) {
                let length = object.length;
                $1213990bd941e1f8$var$writeArrayHeader(length);
                for(let i = 0; i < length; i++){
                    let value = object[i];
                    if (value && (typeof value === "object" || $1213990bd941e1f8$var$position - start > chunkThreshold)) {
                        if (iterateProperties.element) yield* encodeObjectAsIterable(value, iterateProperties.element);
                        else yield* tryEncode(value, iterateProperties, "element");
                    } else encode(value);
                }
            } else if (object[Symbol.iterator]) {
                $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x9f; // start indefinite array
                for (let value of object)if (value && (typeof value === "object" || $1213990bd941e1f8$var$position - start > chunkThreshold)) {
                    if (iterateProperties.element) yield* encodeObjectAsIterable(value, iterateProperties.element);
                    else yield* tryEncode(value, iterateProperties, "element");
                } else encode(value);
                $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xff; // stop byte
            } else if ($1213990bd941e1f8$var$isBlob(object)) {
                $1213990bd941e1f8$var$writeEntityLength(object.size, 0x40); // encode as binary data
                yield $1213990bd941e1f8$var$target.subarray(start, $1213990bd941e1f8$var$position);
                yield object; // directly return blobs, they have to be encoded asynchronously
                restartEncoding();
            } else if (object[Symbol.asyncIterator]) {
                $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x9f; // start indefinite array
                yield $1213990bd941e1f8$var$target.subarray(start, $1213990bd941e1f8$var$position);
                yield object; // directly return async iterators, they have to be encoded asynchronously
                restartEncoding();
                $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xff; // stop byte
            } else encode(object);
            if (finalIterable && $1213990bd941e1f8$var$position > start) yield $1213990bd941e1f8$var$target.subarray(start, $1213990bd941e1f8$var$position);
            else if ($1213990bd941e1f8$var$position - start > chunkThreshold) {
                yield $1213990bd941e1f8$var$target.subarray(start, $1213990bd941e1f8$var$position);
                restartEncoding();
            }
        }
        function* tryEncode(value, iterateProperties, key) {
            let restart = $1213990bd941e1f8$var$position - start;
            try {
                encode(value);
                if ($1213990bd941e1f8$var$position - start > chunkThreshold) {
                    yield $1213990bd941e1f8$var$target.subarray(start, $1213990bd941e1f8$var$position);
                    restartEncoding();
                }
            } catch (error) {
                if (error.iteratorNotHandled) {
                    iterateProperties[key] = {};
                    $1213990bd941e1f8$var$position = start + restart; // restart our position so we don't have partial data from last encode
                    yield* encodeObjectAsIterable.call(this, value, iterateProperties[key]);
                } else throw error;
            }
        }
        function restartEncoding() {
            chunkThreshold = continuedChunkThreshold;
            encoder.encode(null, $1213990bd941e1f8$export$e724ae76933ea297); // restart encoding
        }
        function startEncoding(value, options, encodeIterable) {
            if (options && options.chunkThreshold) chunkThreshold = continuedChunkThreshold = options.chunkThreshold;
            else chunkThreshold = 100;
            if (value && typeof value === "object") {
                encoder.encode(null, $1213990bd941e1f8$export$e724ae76933ea297); // start encoding
                return encodeIterable(value, encoder.iterateProperties || (encoder.iterateProperties = {}), true);
            }
            return [
                encoder.encode(value)
            ];
        }
        async function* encodeObjectAsAsyncIterable(value, iterateProperties) {
            for (let encodedValue of encodeObjectAsIterable(value, iterateProperties, true)){
                let constructor = encodedValue.constructor;
                if (constructor === $1213990bd941e1f8$var$ByteArray || constructor === Uint8Array) yield encodedValue;
                else if ($1213990bd941e1f8$var$isBlob(encodedValue)) {
                    let reader = encodedValue.stream().getReader();
                    let next;
                    while(!(next = await reader.read()).done)yield next.value;
                } else if (encodedValue[Symbol.asyncIterator]) for await (let asyncValue of encodedValue){
                    restartEncoding();
                    if (asyncValue) yield* encodeObjectAsAsyncIterable(asyncValue, iterateProperties.async || (iterateProperties.async = {}));
                    else yield encoder.encode(asyncValue);
                }
                else yield encodedValue;
            }
        }
    }
}
function $1213990bd941e1f8$var$writeEntityLength(length, majorValue) {
    if (length < 0x18) $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = majorValue | length;
    else if (length < 0x100) {
        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = majorValue | 0x18;
        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = length;
    } else if (length < 0x10000) {
        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = majorValue | 0x19;
        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = length >> 8;
        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = length & 0xff;
    } else {
        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = majorValue | 0x1a;
        $1213990bd941e1f8$var$targetView.setUint32($1213990bd941e1f8$var$position, length);
        $1213990bd941e1f8$var$position += 4;
    }
}
class $1213990bd941e1f8$var$SharedData {
    constructor(structures, values, version){
        this.structures = structures;
        this.packedValues = values;
        this.version = version;
    }
}
function $1213990bd941e1f8$var$writeArrayHeader(length) {
    if (length < 0x18) $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x80 | length;
    else if (length < 0x100) {
        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x98;
        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = length;
    } else if (length < 0x10000) {
        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x99;
        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = length >> 8;
        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = length & 0xff;
    } else {
        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x9a;
        $1213990bd941e1f8$var$targetView.setUint32($1213990bd941e1f8$var$position, length);
        $1213990bd941e1f8$var$position += 4;
    }
}
const $1213990bd941e1f8$var$BlobConstructor = typeof Blob === "undefined" ? function() {} : Blob;
function $1213990bd941e1f8$var$isBlob(object) {
    if (object instanceof $1213990bd941e1f8$var$BlobConstructor) return true;
    let tag = object[Symbol.toStringTag];
    return tag === "Blob" || tag === "File";
}
function $1213990bd941e1f8$var$findRepetitiveStrings(value, packedValues) {
    switch(typeof value){
        case "string":
            if (value.length > 3) {
                if (packedValues.objectMap[value] > -1 || packedValues.values.length >= packedValues.maxValues) return;
                let packedStatus = packedValues.get(value);
                if (packedStatus) {
                    if (++packedStatus.count == 2) packedValues.values.push(value);
                } else {
                    packedValues.set(value, {
                        count: 1
                    });
                    if (packedValues.samplingPackedValues) {
                        let status = packedValues.samplingPackedValues.get(value);
                        if (status) status.count++;
                        else packedValues.samplingPackedValues.set(value, {
                            count: 1
                        });
                    }
                }
            }
            break;
        case "object":
            if (value) {
                if (value instanceof Array) for(let i = 0, l = value.length; i < l; i++)$1213990bd941e1f8$var$findRepetitiveStrings(value[i], packedValues);
                else {
                    let includeKeys = !packedValues.encoder.useRecords;
                    for(var key in value)if (value.hasOwnProperty(key)) {
                        if (includeKeys) $1213990bd941e1f8$var$findRepetitiveStrings(key, packedValues);
                        $1213990bd941e1f8$var$findRepetitiveStrings(value[key], packedValues);
                    }
                }
            }
            break;
        case "function":
            console.log(value);
    }
}
const $1213990bd941e1f8$var$isLittleEndianMachine = new Uint8Array(new Uint16Array([
    1
]).buffer)[0] == 1;
$1213990bd941e1f8$var$extensionClasses = [
    Date,
    Set,
    Error,
    RegExp,
    (0, $f3f604935c83ab88$export$3288d34c523a1192),
    ArrayBuffer,
    Uint8Array,
    Uint8ClampedArray,
    Uint16Array,
    Uint32Array,
    typeof BigUint64Array == "undefined" ? function() {} : BigUint64Array,
    Int8Array,
    Int16Array,
    Int32Array,
    typeof BigInt64Array == "undefined" ? function() {} : BigInt64Array,
    Float32Array,
    Float64Array,
    $1213990bd941e1f8$var$SharedData
];
//Object.getPrototypeOf(Uint8Array.prototype).constructor /*TypedArray*/
$1213990bd941e1f8$var$extensions = [
    {
        tag: 1,
        encode (date, encode) {
            let seconds = date.getTime() / 1000;
            if ((this.useTimestamp32 || date.getMilliseconds() === 0) && seconds >= 0 && seconds < 0x100000000) {
                // Timestamp 32
                $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x1a;
                $1213990bd941e1f8$var$targetView.setUint32($1213990bd941e1f8$var$position, seconds);
                $1213990bd941e1f8$var$position += 4;
            } else {
                // Timestamp float64
                $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xfb;
                $1213990bd941e1f8$var$targetView.setFloat64($1213990bd941e1f8$var$position, seconds);
                $1213990bd941e1f8$var$position += 8;
            }
        }
    },
    {
        tag: 258,
        encode (set, encode) {
            let array = Array.from(set);
            encode(array);
        }
    },
    {
        tag: 27,
        encode (error, encode) {
            encode([
                error.name,
                error.message
            ]);
        }
    },
    {
        tag: 27,
        encode (regex, encode) {
            encode([
                "RegExp",
                regex.source,
                regex.flags
            ]);
        }
    },
    {
        getTag (tag) {
            return tag.tag;
        },
        encode (tag, encode) {
            encode(tag.value);
        }
    },
    {
        encode (arrayBuffer, encode, makeRoom) {
            $1213990bd941e1f8$var$writeBuffer(arrayBuffer, makeRoom);
        }
    },
    {
        getTag (typedArray) {
            if (typedArray.constructor === Uint8Array) {
                if (this.tagUint8Array || $1213990bd941e1f8$var$hasNodeBuffer && this.tagUint8Array !== false) return 64;
            } // else no tag
        },
        encode (typedArray, encode, makeRoom) {
            $1213990bd941e1f8$var$writeBuffer(typedArray, makeRoom);
        }
    },
    $1213990bd941e1f8$var$typedArrayEncoder(68, 1),
    $1213990bd941e1f8$var$typedArrayEncoder(69, 2),
    $1213990bd941e1f8$var$typedArrayEncoder(70, 4),
    $1213990bd941e1f8$var$typedArrayEncoder(71, 8),
    $1213990bd941e1f8$var$typedArrayEncoder(72, 1),
    $1213990bd941e1f8$var$typedArrayEncoder(77, 2),
    $1213990bd941e1f8$var$typedArrayEncoder(78, 4),
    $1213990bd941e1f8$var$typedArrayEncoder(79, 8),
    $1213990bd941e1f8$var$typedArrayEncoder(85, 4),
    $1213990bd941e1f8$var$typedArrayEncoder(86, 8),
    {
        encode (sharedData, encode) {
            let packedValues = sharedData.packedValues || [];
            let sharedStructures = sharedData.structures || [];
            if (packedValues.values.length > 0) {
                $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0xd8 // one-byte tag
                ;
                $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 51 // tag 51 for packed shared structures https://www.potaroo.net/ietf/ids/draft-ietf-cbor-packed-03.txt
                ;
                $1213990bd941e1f8$var$writeArrayHeader(4);
                let valuesArray = packedValues.values;
                encode(valuesArray);
                $1213990bd941e1f8$var$writeArrayHeader(0) // prefixes
                ;
                $1213990bd941e1f8$var$writeArrayHeader(0) // suffixes
                ;
                packedObjectMap = Object.create(sharedPackedObjectMap || null);
                for(let i = 0, l = valuesArray.length; i < l; i++)packedObjectMap[valuesArray[i]] = i;
            }
            if (sharedStructures) {
                $1213990bd941e1f8$var$targetView.setUint32($1213990bd941e1f8$var$position, 0xd9dffe00);
                $1213990bd941e1f8$var$position += 3;
                let definitions = sharedStructures.slice(0);
                definitions.unshift(0xe000);
                definitions.push(new (0, $f3f604935c83ab88$export$3288d34c523a1192)(sharedData.version, 0x53687264));
                encode(definitions);
            } else encode(new (0, $f3f604935c83ab88$export$3288d34c523a1192)(sharedData.version, 0x53687264));
        }
    }
];
function $1213990bd941e1f8$var$typedArrayEncoder(tag, size) {
    if (!$1213990bd941e1f8$var$isLittleEndianMachine && size > 1) tag -= 4 // the big endian equivalents are 4 less
    ;
    return {
        tag: tag,
        encode: function writeExtBuffer(typedArray, encode) {
            let length = typedArray.byteLength;
            let offset = typedArray.byteOffset || 0;
            let buffer = typedArray.buffer || typedArray;
            encode($1213990bd941e1f8$var$hasNodeBuffer ? $1213990bd941e1f8$var$Buffer.from(buffer, offset, length) : new Uint8Array(buffer, offset, length));
        }
    };
}
function $1213990bd941e1f8$var$writeBuffer(buffer, makeRoom) {
    let length = buffer.byteLength;
    if (length < 0x18) $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x40 + length;
    else if (length < 0x100) {
        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x58;
        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = length;
    } else if (length < 0x10000) {
        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x59;
        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = length >> 8;
        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = length & 0xff;
    } else {
        $1213990bd941e1f8$var$target[$1213990bd941e1f8$var$position++] = 0x5a;
        $1213990bd941e1f8$var$targetView.setUint32($1213990bd941e1f8$var$position, length);
        $1213990bd941e1f8$var$position += 4;
    }
    if ($1213990bd941e1f8$var$position + length >= $1213990bd941e1f8$var$target.length) makeRoom($1213990bd941e1f8$var$position + length);
    // if it is already a typed array (has an ArrayBuffer), use that, but if it is an ArrayBuffer itself,
    // must wrap it to set it.
    $1213990bd941e1f8$var$target.set(buffer.buffer ? buffer : new Uint8Array(buffer), $1213990bd941e1f8$var$position);
    $1213990bd941e1f8$var$position += length;
}
function $1213990bd941e1f8$var$insertIds(serialized, idsToInsert) {
    // insert the ids that need to be referenced for structured clones
    let nextId;
    let distanceToMove = idsToInsert.length * 2;
    let lastEnd = serialized.length - distanceToMove;
    idsToInsert.sort((a, b)=>a.offset > b.offset ? 1 : -1);
    for(let id = 0; id < idsToInsert.length; id++){
        let referee = idsToInsert[id];
        referee.id = id;
        for (let position of referee.references){
            serialized[position++] = id >> 8;
            serialized[position] = id & 0xff;
        }
    }
    while(nextId = idsToInsert.pop()){
        let offset = nextId.offset;
        serialized.copyWithin(offset + distanceToMove, offset, lastEnd);
        distanceToMove -= 2;
        let position = offset + distanceToMove;
        serialized[position++] = 0xd8;
        serialized[position++] = 28 // http://cbor.schmorp.de/value-sharing
        ;
        lastEnd = offset;
    }
    return serialized;
}
function $1213990bd941e1f8$var$writeBundles(start, encode) {
    $1213990bd941e1f8$var$targetView.setUint32($1213990bd941e1f8$var$bundledStrings.position + start, $1213990bd941e1f8$var$position - $1213990bd941e1f8$var$bundledStrings.position - start + 1) // the offset to bundle
    ;
    let writeStrings = $1213990bd941e1f8$var$bundledStrings;
    $1213990bd941e1f8$var$bundledStrings = null;
    encode(writeStrings[0]);
    encode(writeStrings[1]);
}
function $1213990bd941e1f8$export$4e11b2f4fcd6c82d(extension) {
    if (extension.Class) {
        if (!extension.encode) throw new Error("Extension has no encode function");
        $1213990bd941e1f8$var$extensionClasses.unshift(extension.Class);
        $1213990bd941e1f8$var$extensions.unshift(extension);
    }
    (0, $f3f604935c83ab88$export$4e11b2f4fcd6c82d)(extension);
}
let $1213990bd941e1f8$var$defaultEncoder = new $1213990bd941e1f8$export$a50aceb0e02a00aa({
    useRecords: false
});
const $1213990bd941e1f8$export$c564cdbbe6da493 = $1213990bd941e1f8$var$defaultEncoder.encode;
const $1213990bd941e1f8$export$62a5d0ccbd8ba53e = $1213990bd941e1f8$var$defaultEncoder.encodeAsIterable;
const $1213990bd941e1f8$export$ba03bcdfc44f370a = $1213990bd941e1f8$var$defaultEncoder.encodeAsAsyncIterable;
const { NEVER: $1213990bd941e1f8$export$96c94437c95d7862, ALWAYS: $1213990bd941e1f8$export$9252627518dcde93, DECIMAL_ROUND: $1213990bd941e1f8$export$50de32e2440ab0bf, DECIMAL_FIT: $1213990bd941e1f8$export$fa7c7714126eb380 } = (0, $f3f604935c83ab88$export$2239e49a3e351685);
const $1213990bd941e1f8$export$d41ac1453288b342 = 512;
const $1213990bd941e1f8$export$5687accb6effa257 = 1024;
const $1213990bd941e1f8$export$e724ae76933ea297 = 2048;






var $gzLuY = parcelRequire("gzLuY");
var $e7c1969bf0532578$require$Buffer = $gzLuY.Buffer;
function $e7c1969bf0532578$export$82db1b517a03d6f4(objectIterator, options = {}) {
    if (!objectIterator || typeof objectIterator !== "object") throw new Error("first argument must be an Iterable, Async Iterable, or a Promise for an Async Iterable");
    else if (typeof objectIterator[Symbol.iterator] === "function") return $e7c1969bf0532578$var$encodeIterSync(objectIterator, options);
    else if (typeof objectIterator.then === "function" || typeof objectIterator[Symbol.asyncIterator] === "function") return $e7c1969bf0532578$var$encodeIterAsync(objectIterator, options);
    else throw new Error("first argument must be an Iterable, Async Iterable, Iterator, Async Iterator, or a Promise");
}
function* $e7c1969bf0532578$var$encodeIterSync(objectIterator, options) {
    const encoder = new (0, $1213990bd941e1f8$export$a50aceb0e02a00aa)(options);
    for (const value of objectIterator)yield encoder.encode(value);
}
async function* $e7c1969bf0532578$var$encodeIterAsync(objectIterator, options) {
    const encoder = new (0, $1213990bd941e1f8$export$a50aceb0e02a00aa)(options);
    for await (const value of objectIterator)yield encoder.encode(value);
}
function $e7c1969bf0532578$export$5201756020406471(bufferIterator, options = {}) {
    if (!bufferIterator || typeof bufferIterator !== "object") throw new Error("first argument must be an Iterable, Async Iterable, Iterator, Async Iterator, or a promise");
    const decoder = new (0, $f3f604935c83ab88$export$f9de6ca0bc043724)(options);
    let incomplete;
    const parser = (chunk)=>{
        let yields;
        // if there's incomplete data from previous chunk, concatinate and try again
        if (incomplete) {
            chunk = $e7c1969bf0532578$require$Buffer.concat([
                incomplete,
                chunk
            ]);
            incomplete = undefined;
        }
        try {
            yields = decoder.decodeMultiple(chunk);
        } catch (err) {
            if (err.incomplete) {
                incomplete = chunk.slice(err.lastPosition);
                yields = err.values;
            } else throw err;
        }
        return yields;
    };
    if (typeof bufferIterator[Symbol.iterator] === "function") return function* iter() {
        for (const value of bufferIterator)yield* parser(value);
    }();
    else if (typeof bufferIterator[Symbol.asyncIterator] === "function") return async function* iter() {
        for await (const value of bufferIterator)yield* parser(value);
    }();
}




var $7990493837413dda$exports = {};

$parcel$export($7990493837413dda$exports, "decodeMultiStream", function () { return $7990493837413dda$export$bf87d8a088c760fb; });
var $55f187cab2542bc0$exports = {};

$parcel$export($55f187cab2542bc0$exports, "Decoder", function () { return $55f187cab2542bc0$export$f9de6ca0bc043724; });
function $7c4a7fd8af273aa0$export$78406e843f5312da(byte) {
    return "".concat(byte < 0 ? "-" : "", "0x").concat(Math.abs(byte).toString(16).padStart(2, "0"));
}


// ExtensionCodec to handle MessagePack extensions
/**
 * ExtData is used to handle Extension Types that are not registered to ExtensionCodec.
 */ var $e525a6ab528088ac$export$bcbeb236456bc779 = /** @class */ function() {
    function ExtData(type, data) {
        this.type = type;
        this.data = data;
    }
    return ExtData;
}();


// https://github.com/msgpack/msgpack/blob/master/spec.md#timestamp-extension-type
var $a4491bb2a6ad27d5$exports = {};

$parcel$export($a4491bb2a6ad27d5$exports, "DecodeError", function () { return $a4491bb2a6ad27d5$export$ef3eed12d06c0285; });
var $a4491bb2a6ad27d5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a4491bb2a6ad27d5$export$ef3eed12d06c0285 = /** @class */ function(_super) {
    $a4491bb2a6ad27d5$var$__extends(DecodeError, _super);
    function DecodeError(message) {
        var _this = _super.call(this, message) || this;
        // fix the prototype chain in a cross-platform way
        var proto = Object.create(DecodeError.prototype);
        Object.setPrototypeOf(_this, proto);
        Object.defineProperty(_this, "name", {
            configurable: true,
            enumerable: false,
            value: DecodeError.name
        });
        return _this;
    }
    return DecodeError;
}(Error);


// Integer Utility
var $fdb0ae6cfa73dfa2$export$3314b2c271c86d70 = 4294967295;
function $fdb0ae6cfa73dfa2$export$20f71c4c8b0f96c3(view, offset, value) {
    var high = value / 4294967296;
    var low = value; // high bits are truncated by DataView
    view.setUint32(offset, high);
    view.setUint32(offset + 4, low);
}
function $fdb0ae6cfa73dfa2$export$8532a5209571c04a(view, offset, value) {
    var high = Math.floor(value / 4294967296);
    var low = value; // high bits are truncated by DataView
    view.setUint32(offset, high);
    view.setUint32(offset + 4, low);
}
function $fdb0ae6cfa73dfa2$export$69825c7adcc820c6(view, offset) {
    var high = view.getInt32(offset);
    var low = view.getUint32(offset + 4);
    return high * 4294967296 + low;
}
function $fdb0ae6cfa73dfa2$export$59a2dbf579ff9568(view, offset) {
    var high = view.getUint32(offset);
    var low = view.getUint32(offset + 4);
    return high * 4294967296 + low;
}


var $3b90bccd83761114$export$f18369fc203f4e13 = -1;
var $3b90bccd83761114$var$TIMESTAMP32_MAX_SEC = 4294967295; // 32-bit unsigned int
var $3b90bccd83761114$var$TIMESTAMP64_MAX_SEC = 17179869183; // 34-bit unsigned int
function $3b90bccd83761114$export$2fd05b828dd81159(_a) {
    var sec = _a.sec, nsec = _a.nsec;
    if (sec >= 0 && nsec >= 0 && sec <= $3b90bccd83761114$var$TIMESTAMP64_MAX_SEC) {
        // Here sec >= 0 && nsec >= 0
        if (nsec === 0 && sec <= $3b90bccd83761114$var$TIMESTAMP32_MAX_SEC) {
            // timestamp 32 = { sec32 (unsigned) }
            var rv = new Uint8Array(4);
            var view = new DataView(rv.buffer);
            view.setUint32(0, sec);
            return rv;
        } else {
            // timestamp 64 = { nsec30 (unsigned), sec34 (unsigned) }
            var secHigh = sec / 0x100000000;
            var secLow = sec & 0xffffffff;
            var rv = new Uint8Array(8);
            var view = new DataView(rv.buffer);
            // nsec30 | secHigh2
            view.setUint32(0, nsec << 2 | secHigh & 0x3);
            // secLow32
            view.setUint32(4, secLow);
            return rv;
        }
    } else {
        // timestamp 96 = { nsec32 (unsigned), sec64 (signed) }
        var rv = new Uint8Array(12);
        var view = new DataView(rv.buffer);
        view.setUint32(0, nsec);
        (0, $fdb0ae6cfa73dfa2$export$8532a5209571c04a)(view, 4, sec);
        return rv;
    }
}
function $3b90bccd83761114$export$221d97b3b00b03c2(date) {
    var msec = date.getTime();
    var sec = Math.floor(msec / 1e3);
    var nsec = (msec - sec * 1e3) * 1e6;
    // Normalizes { sec, nsec } to ensure nsec is unsigned.
    var nsecInSec = Math.floor(nsec / 1e9);
    return {
        sec: sec + nsecInSec,
        nsec: nsec - nsecInSec * 1e9
    };
}
function $3b90bccd83761114$export$32420f352fe0fc83(object) {
    if (object instanceof Date) {
        var timeSpec = $3b90bccd83761114$export$221d97b3b00b03c2(object);
        return $3b90bccd83761114$export$2fd05b828dd81159(timeSpec);
    } else return null;
}
function $3b90bccd83761114$export$abfc8800a5159711(data) {
    var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
    // data may be 32, 64, or 96 bits
    switch(data.byteLength){
        case 4:
            // timestamp 32 = { sec32 }
            var sec = view.getUint32(0);
            var nsec = 0;
            return {
                sec: sec,
                nsec: nsec
            };
        case 8:
            // timestamp 64 = { nsec30, sec34 }
            var nsec30AndSecHigh2 = view.getUint32(0);
            var secLow32 = view.getUint32(4);
            var sec = (nsec30AndSecHigh2 & 0x3) * 0x100000000 + secLow32;
            var nsec = nsec30AndSecHigh2 >>> 2;
            return {
                sec: sec,
                nsec: nsec
            };
        case 12:
            // timestamp 96 = { nsec32 (unsigned), sec64 (signed) }
            var sec = (0, $fdb0ae6cfa73dfa2$export$69825c7adcc820c6)(view, 4);
            var nsec = view.getUint32(0);
            return {
                sec: sec,
                nsec: nsec
            };
        default:
            throw new (0, $a4491bb2a6ad27d5$exports.DecodeError)("Unrecognized data size for timestamp (expected 4, 8, or 12): ".concat(data.length));
    }
}
function $3b90bccd83761114$export$80b8ff9315e4298f(data) {
    var timeSpec = $3b90bccd83761114$export$abfc8800a5159711(data);
    return new Date(timeSpec.sec * 1e3 + timeSpec.nsec / 1e6);
}
var $3b90bccd83761114$export$8654479533463da1 = {
    type: $3b90bccd83761114$export$f18369fc203f4e13,
    encode: $3b90bccd83761114$export$32420f352fe0fc83,
    decode: $3b90bccd83761114$export$80b8ff9315e4298f
};


var $50b6761edf3a4a35$export$12677a794dbd89d7 = /** @class */ function() {
    function ExtensionCodec() {
        // built-in extensions
        this.builtInEncoders = [];
        this.builtInDecoders = [];
        // custom extensions
        this.encoders = [];
        this.decoders = [];
        this.register((0, $3b90bccd83761114$export$8654479533463da1));
    }
    ExtensionCodec.prototype.register = function(_a) {
        var type = _a.type, encode = _a.encode, decode = _a.decode;
        if (type >= 0) {
            // custom extensions
            this.encoders[type] = encode;
            this.decoders[type] = decode;
        } else {
            // built-in extensions
            var index = 1 + type;
            this.builtInEncoders[index] = encode;
            this.builtInDecoders[index] = decode;
        }
    };
    ExtensionCodec.prototype.tryToEncode = function(object, context) {
        // built-in extensions
        for(var i = 0; i < this.builtInEncoders.length; i++){
            var encodeExt = this.builtInEncoders[i];
            if (encodeExt != null) {
                var data = encodeExt(object, context);
                if (data != null) {
                    var type = -1 - i;
                    return new (0, $e525a6ab528088ac$export$bcbeb236456bc779)(type, data);
                }
            }
        }
        // custom extensions
        for(var i = 0; i < this.encoders.length; i++){
            var encodeExt = this.encoders[i];
            if (encodeExt != null) {
                var data = encodeExt(object, context);
                if (data != null) {
                    var type = i;
                    return new (0, $e525a6ab528088ac$export$bcbeb236456bc779)(type, data);
                }
            }
        }
        if (object instanceof (0, $e525a6ab528088ac$export$bcbeb236456bc779)) // to keep ExtData as is
        return object;
        return null;
    };
    ExtensionCodec.prototype.decode = function(data, type, context) {
        var decodeExt = type < 0 ? this.builtInDecoders[-1 - type] : this.decoders[type];
        if (decodeExt) return decodeExt(data, type, context);
        else // decode() does not fail, returns ExtData instead.
        return new (0, $e525a6ab528088ac$export$bcbeb236456bc779)(type, data);
    };
    ExtensionCodec.defaultCodec = new ExtensionCodec();
    return ExtensionCodec;
}();





var $aqbQf = parcelRequire("aqbQf");
var $fb497f06276ad0b3$var$_a, $fb497f06276ad0b3$var$_b, $fb497f06276ad0b3$var$_c;
var $fb497f06276ad0b3$var$TEXT_ENCODING_AVAILABLE = (typeof $aqbQf === "undefined" || (($fb497f06276ad0b3$var$_a = $aqbQf === null || $aqbQf === void 0 ? void 0 : $aqbQf.env) === null || $fb497f06276ad0b3$var$_a === void 0 ? void 0 : $fb497f06276ad0b3$var$_a["TEXT_ENCODING"]) !== "never") && typeof TextEncoder !== "undefined" && typeof TextDecoder !== "undefined";
function $fb497f06276ad0b3$export$b61de95301265227(str) {
    var strLength = str.length;
    var byteLength = 0;
    var pos = 0;
    while(pos < strLength){
        var value = str.charCodeAt(pos++);
        if ((value & 0xffffff80) === 0) {
            // 1-byte
            byteLength++;
            continue;
        } else if ((value & 0xfffff800) === 0) // 2-bytes
        byteLength += 2;
        else {
            // handle surrogate pair
            if (value >= 0xd800 && value <= 0xdbff) // high surrogate
            {
                if (pos < strLength) {
                    var extra = str.charCodeAt(pos);
                    if ((extra & 0xfc00) === 0xdc00) {
                        ++pos;
                        value = ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000;
                    }
                }
            }
            if ((value & 0xffff0000) === 0) // 3-byte
            byteLength += 3;
            else // 4-byte
            byteLength += 4;
        }
    }
    return byteLength;
}
function $fb497f06276ad0b3$export$1042e4338f1ef853(str, output, outputOffset) {
    var strLength = str.length;
    var offset = outputOffset;
    var pos = 0;
    while(pos < strLength){
        var value = str.charCodeAt(pos++);
        if ((value & 0xffffff80) === 0) {
            // 1-byte
            output[offset++] = value;
            continue;
        } else if ((value & 0xfffff800) === 0) // 2-bytes
        output[offset++] = value >> 6 & 0x1f | 0xc0;
        else {
            // handle surrogate pair
            if (value >= 0xd800 && value <= 0xdbff) // high surrogate
            {
                if (pos < strLength) {
                    var extra = str.charCodeAt(pos);
                    if ((extra & 0xfc00) === 0xdc00) {
                        ++pos;
                        value = ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000;
                    }
                }
            }
            if ((value & 0xffff0000) === 0) {
                // 3-byte
                output[offset++] = value >> 12 & 0x0f | 0xe0;
                output[offset++] = value >> 6 & 0x3f | 0x80;
            } else {
                // 4-byte
                output[offset++] = value >> 18 & 0x07 | 0xf0;
                output[offset++] = value >> 12 & 0x3f | 0x80;
                output[offset++] = value >> 6 & 0x3f | 0x80;
            }
        }
        output[offset++] = value & 0x3f | 0x80;
    }
}
var $fb497f06276ad0b3$var$sharedTextEncoder = $fb497f06276ad0b3$var$TEXT_ENCODING_AVAILABLE ? new TextEncoder() : undefined;
var $fb497f06276ad0b3$export$ed34c0622b397238 = !$fb497f06276ad0b3$var$TEXT_ENCODING_AVAILABLE ? (0, $fdb0ae6cfa73dfa2$export$3314b2c271c86d70) : typeof $aqbQf !== "undefined" && (($fb497f06276ad0b3$var$_b = $aqbQf === null || $aqbQf === void 0 ? void 0 : $aqbQf.env) === null || $fb497f06276ad0b3$var$_b === void 0 ? void 0 : $fb497f06276ad0b3$var$_b["TEXT_ENCODING"]) !== "force" ? 200 : 0;
function $fb497f06276ad0b3$var$utf8EncodeTEencode(str, output, outputOffset) {
    output.set($fb497f06276ad0b3$var$sharedTextEncoder.encode(str), outputOffset);
}
function $fb497f06276ad0b3$var$utf8EncodeTEencodeInto(str, output, outputOffset) {
    $fb497f06276ad0b3$var$sharedTextEncoder.encodeInto(str, output.subarray(outputOffset));
}
var $fb497f06276ad0b3$export$34cfdc82d430524 = ($fb497f06276ad0b3$var$sharedTextEncoder === null || $fb497f06276ad0b3$var$sharedTextEncoder === void 0 ? void 0 : $fb497f06276ad0b3$var$sharedTextEncoder.encodeInto) ? $fb497f06276ad0b3$var$utf8EncodeTEencodeInto : $fb497f06276ad0b3$var$utf8EncodeTEencode;
var $fb497f06276ad0b3$var$CHUNK_SIZE = 4096;
function $fb497f06276ad0b3$export$551117984c2adf4f(bytes, inputOffset, byteLength) {
    var offset = inputOffset;
    var end = offset + byteLength;
    var units = [];
    var result = "";
    while(offset < end){
        var byte1 = bytes[offset++];
        if ((byte1 & 0x80) === 0) // 1 byte
        units.push(byte1);
        else if ((byte1 & 0xe0) === 0xc0) {
            // 2 bytes
            var byte2 = bytes[offset++] & 0x3f;
            units.push((byte1 & 0x1f) << 6 | byte2);
        } else if ((byte1 & 0xf0) === 0xe0) {
            // 3 bytes
            var byte2 = bytes[offset++] & 0x3f;
            var byte3 = bytes[offset++] & 0x3f;
            units.push((byte1 & 0x1f) << 12 | byte2 << 6 | byte3);
        } else if ((byte1 & 0xf8) === 0xf0) {
            // 4 bytes
            var byte2 = bytes[offset++] & 0x3f;
            var byte3 = bytes[offset++] & 0x3f;
            var byte4 = bytes[offset++] & 0x3f;
            var unit = (byte1 & 0x07) << 0x12 | byte2 << 0x0c | byte3 << 0x06 | byte4;
            if (unit > 0xffff) {
                unit -= 0x10000;
                units.push(unit >>> 10 & 0x3ff | 0xd800);
                unit = 0xdc00 | unit & 0x3ff;
            }
            units.push(unit);
        } else units.push(byte1);
        if (units.length >= $fb497f06276ad0b3$var$CHUNK_SIZE) {
            result += String.fromCharCode.apply(String, units);
            units.length = 0;
        }
    }
    if (units.length > 0) result += String.fromCharCode.apply(String, units);
    return result;
}
var $fb497f06276ad0b3$var$sharedTextDecoder = $fb497f06276ad0b3$var$TEXT_ENCODING_AVAILABLE ? new TextDecoder() : null;
var $fb497f06276ad0b3$export$d866281c5a66d1ef = !$fb497f06276ad0b3$var$TEXT_ENCODING_AVAILABLE ? (0, $fdb0ae6cfa73dfa2$export$3314b2c271c86d70) : typeof $aqbQf !== "undefined" && (($fb497f06276ad0b3$var$_c = $aqbQf === null || $aqbQf === void 0 ? void 0 : $aqbQf.env) === null || $fb497f06276ad0b3$var$_c === void 0 ? void 0 : $fb497f06276ad0b3$var$_c["TEXT_DECODER"]) !== "force" ? 200 : 0;
function $fb497f06276ad0b3$export$6ed79e41309992dc(bytes, inputOffset, byteLength) {
    var stringBytes = bytes.subarray(inputOffset, inputOffset + byteLength);
    return $fb497f06276ad0b3$var$sharedTextDecoder.decode(stringBytes);
}


function $8a6379bd6faea12c$export$f8d669c2a17882f2(buffer) {
    if (buffer instanceof Uint8Array) return buffer;
    else if (ArrayBuffer.isView(buffer)) return new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    else if (buffer instanceof ArrayBuffer) return new Uint8Array(buffer);
    else // ArrayLike<number>
    return Uint8Array.from(buffer);
}
function $8a6379bd6faea12c$export$7277868462c1ba02(buffer) {
    if (buffer instanceof ArrayBuffer) return new DataView(buffer);
    var bufferView = $8a6379bd6faea12c$export$f8d669c2a17882f2(buffer);
    return new DataView(bufferView.buffer, bufferView.byteOffset, bufferView.byteLength);
}



var $5a3b937d73b23b2f$var$DEFAULT_MAX_KEY_LENGTH = 16;
var $5a3b937d73b23b2f$var$DEFAULT_MAX_LENGTH_PER_KEY = 16;
var $5a3b937d73b23b2f$export$529b830450faf29c = /** @class */ function() {
    function CachedKeyDecoder(maxKeyLength, maxLengthPerKey) {
        if (maxKeyLength === void 0) maxKeyLength = $5a3b937d73b23b2f$var$DEFAULT_MAX_KEY_LENGTH;
        if (maxLengthPerKey === void 0) maxLengthPerKey = $5a3b937d73b23b2f$var$DEFAULT_MAX_LENGTH_PER_KEY;
        this.maxKeyLength = maxKeyLength;
        this.maxLengthPerKey = maxLengthPerKey;
        this.hit = 0;
        this.miss = 0;
        // avoid `new Array(N)`, which makes a sparse array,
        // because a sparse array is typically slower than a non-sparse array.
        this.caches = [];
        for(var i = 0; i < this.maxKeyLength; i++)this.caches.push([]);
    }
    CachedKeyDecoder.prototype.canBeCached = function(byteLength) {
        return byteLength > 0 && byteLength <= this.maxKeyLength;
    };
    CachedKeyDecoder.prototype.find = function(bytes, inputOffset, byteLength) {
        var records = this.caches[byteLength - 1];
        FIND_CHUNK: for(var _i = 0, records_1 = records; _i < records_1.length; _i++){
            var record = records_1[_i];
            var recordBytes = record.bytes;
            for(var j = 0; j < byteLength; j++){
                if (recordBytes[j] !== bytes[inputOffset + j]) continue FIND_CHUNK;
            }
            return record.str;
        }
        return null;
    };
    CachedKeyDecoder.prototype.store = function(bytes, value) {
        var records = this.caches[bytes.length - 1];
        var record = {
            bytes: bytes,
            str: value
        };
        if (records.length >= this.maxLengthPerKey) // `records` are full!
        // Set `record` to an arbitrary position.
        records[Math.random() * records.length | 0] = record;
        else records.push(record);
    };
    CachedKeyDecoder.prototype.decode = function(bytes, inputOffset, byteLength) {
        var cachedValue = this.find(bytes, inputOffset, byteLength);
        if (cachedValue != null) {
            this.hit++;
            return cachedValue;
        }
        this.miss++;
        var str = (0, $fb497f06276ad0b3$export$551117984c2adf4f)(bytes, inputOffset, byteLength);
        // Ensure to copy a slice of bytes because the byte may be NodeJS Buffer and Buffer#slice() returns a reference to its internal ArrayBuffer.
        var slicedCopyOfBytes = Uint8Array.prototype.slice.call(bytes, inputOffset, inputOffset + byteLength);
        this.store(slicedCopyOfBytes, str);
        return str;
    };
    return CachedKeyDecoder;
}();



var $55f187cab2542bc0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $55f187cab2542bc0$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $55f187cab2542bc0$var$__asyncValues = undefined && undefined.__asyncValues || function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $55f187cab2542bc0$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $55f187cab2542bc0$var$__await ? (this.v = v, this) : new $55f187cab2542bc0$var$__await(v);
};
var $55f187cab2542bc0$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $55f187cab2542bc0$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $55f187cab2542bc0$var$isValidMapKeyType = function(key) {
    var keyType = typeof key;
    return keyType === "string" || keyType === "number";
};
var $55f187cab2542bc0$var$HEAD_BYTE_REQUIRED = -1;
var $55f187cab2542bc0$var$EMPTY_VIEW = new DataView(new ArrayBuffer(0));
var $55f187cab2542bc0$var$EMPTY_BYTES = new Uint8Array($55f187cab2542bc0$var$EMPTY_VIEW.buffer);
var $55f187cab2542bc0$export$449c37eaf7093493 = function() {
    try {
        // IE11: The spec says it should throw RangeError,
        // IE11: but in IE11 it throws TypeError.
        $55f187cab2542bc0$var$EMPTY_VIEW.getInt8(0);
    } catch (e) {
        return e.constructor;
    }
    throw new Error("never reached");
}();
var $55f187cab2542bc0$var$MORE_DATA = new $55f187cab2542bc0$export$449c37eaf7093493("Insufficient data");
var $55f187cab2542bc0$var$sharedCachedKeyDecoder = new (0, $5a3b937d73b23b2f$export$529b830450faf29c)();
var $55f187cab2542bc0$export$f9de6ca0bc043724 = /** @class */ function() {
    function Decoder(extensionCodec, context, maxStrLength, maxBinLength, maxArrayLength, maxMapLength, maxExtLength, keyDecoder) {
        if (extensionCodec === void 0) extensionCodec = (0, $50b6761edf3a4a35$export$12677a794dbd89d7).defaultCodec;
        if (context === void 0) context = undefined;
        if (maxStrLength === void 0) maxStrLength = (0, $fdb0ae6cfa73dfa2$export$3314b2c271c86d70);
        if (maxBinLength === void 0) maxBinLength = (0, $fdb0ae6cfa73dfa2$export$3314b2c271c86d70);
        if (maxArrayLength === void 0) maxArrayLength = (0, $fdb0ae6cfa73dfa2$export$3314b2c271c86d70);
        if (maxMapLength === void 0) maxMapLength = (0, $fdb0ae6cfa73dfa2$export$3314b2c271c86d70);
        if (maxExtLength === void 0) maxExtLength = (0, $fdb0ae6cfa73dfa2$export$3314b2c271c86d70);
        if (keyDecoder === void 0) keyDecoder = $55f187cab2542bc0$var$sharedCachedKeyDecoder;
        this.extensionCodec = extensionCodec;
        this.context = context;
        this.maxStrLength = maxStrLength;
        this.maxBinLength = maxBinLength;
        this.maxArrayLength = maxArrayLength;
        this.maxMapLength = maxMapLength;
        this.maxExtLength = maxExtLength;
        this.keyDecoder = keyDecoder;
        this.totalPos = 0;
        this.pos = 0;
        this.view = $55f187cab2542bc0$var$EMPTY_VIEW;
        this.bytes = $55f187cab2542bc0$var$EMPTY_BYTES;
        this.headByte = $55f187cab2542bc0$var$HEAD_BYTE_REQUIRED;
        this.stack = [];
    }
    Decoder.prototype.reinitializeState = function() {
        this.totalPos = 0;
        this.headByte = $55f187cab2542bc0$var$HEAD_BYTE_REQUIRED;
        this.stack.length = 0;
    // view, bytes, and pos will be re-initialized in setBuffer()
    };
    Decoder.prototype.setBuffer = function(buffer) {
        this.bytes = (0, $8a6379bd6faea12c$export$f8d669c2a17882f2)(buffer);
        this.view = (0, $8a6379bd6faea12c$export$7277868462c1ba02)(this.bytes);
        this.pos = 0;
    };
    Decoder.prototype.appendBuffer = function(buffer) {
        if (this.headByte === $55f187cab2542bc0$var$HEAD_BYTE_REQUIRED && !this.hasRemaining(1)) this.setBuffer(buffer);
        else {
            var remainingData = this.bytes.subarray(this.pos);
            var newData = (0, $8a6379bd6faea12c$export$f8d669c2a17882f2)(buffer);
            // concat remainingData + newData
            var newBuffer = new Uint8Array(remainingData.length + newData.length);
            newBuffer.set(remainingData);
            newBuffer.set(newData, remainingData.length);
            this.setBuffer(newBuffer);
        }
    };
    Decoder.prototype.hasRemaining = function(size) {
        return this.view.byteLength - this.pos >= size;
    };
    Decoder.prototype.createExtraByteError = function(posToShow) {
        var _a = this, view = _a.view, pos = _a.pos;
        return new RangeError("Extra ".concat(view.byteLength - pos, " of ").concat(view.byteLength, " byte(s) found at buffer[").concat(posToShow, "]"));
    };
    /**
     * @throws {@link DecodeError}
     * @throws {@link RangeError}
     */ Decoder.prototype.decode = function(buffer) {
        this.reinitializeState();
        this.setBuffer(buffer);
        var object = this.doDecodeSync();
        if (this.hasRemaining(1)) throw this.createExtraByteError(this.pos);
        return object;
    };
    Decoder.prototype.decodeMulti = function(buffer) {
        return $55f187cab2542bc0$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    this.reinitializeState();
                    this.setBuffer(buffer);
                    _a.label = 1;
                case 1:
                    if (!this.hasRemaining(1)) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        this.doDecodeSync()
                    ];
                case 2:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    Decoder.prototype.decodeAsync = function(stream) {
        var stream_1, stream_1_1;
        var e_1, _a;
        return $55f187cab2542bc0$var$__awaiter(this, void 0, void 0, function() {
            var decoded, object, buffer, e_1_1, _b, headByte, pos, totalPos;
            return $55f187cab2542bc0$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        decoded = false;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            6,
                            7,
                            12
                        ]);
                        stream_1 = $55f187cab2542bc0$var$__asyncValues(stream);
                        _c.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            stream_1.next()
                        ];
                    case 3:
                        if (!(stream_1_1 = _c.sent(), !stream_1_1.done)) return [
                            3 /*break*/ ,
                            5
                        ];
                        buffer = stream_1_1.value;
                        if (decoded) throw this.createExtraByteError(this.totalPos);
                        this.appendBuffer(buffer);
                        try {
                            object = this.doDecodeSync();
                            decoded = true;
                        } catch (e) {
                            if (!(e instanceof $55f187cab2542bc0$export$449c37eaf7093493)) throw e; // rethrow
                        // fallthrough
                        }
                        this.totalPos += this.pos;
                        _c.label = 4;
                    case 4:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 6:
                        e_1_1 = _c.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 7:
                        _c.trys.push([
                            7,
                            ,
                            10,
                            11
                        ]);
                        if (!(stream_1_1 && !stream_1_1.done && (_a = stream_1.return))) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(stream_1)
                        ];
                    case 8:
                        _c.sent();
                        _c.label = 9;
                    case 9:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        if (e_1) throw e_1.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 11:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 12:
                        if (decoded) {
                            if (this.hasRemaining(1)) throw this.createExtraByteError(this.totalPos);
                            return [
                                2 /*return*/ ,
                                object
                            ];
                        }
                        _b = this, headByte = _b.headByte, pos = _b.pos, totalPos = _b.totalPos;
                        throw new RangeError("Insufficient data in parsing ".concat((0, $7c4a7fd8af273aa0$export$78406e843f5312da)(headByte), " at ").concat(totalPos, " (").concat(pos, " in the current buffer)"));
                }
            });
        });
    };
    Decoder.prototype.decodeArrayStream = function(stream) {
        return this.decodeMultiAsync(stream, true);
    };
    Decoder.prototype.decodeStream = function(stream) {
        return this.decodeMultiAsync(stream, false);
    };
    Decoder.prototype.decodeMultiAsync = function(stream, isArray) {
        return $55f187cab2542bc0$var$__asyncGenerator(this, arguments, function decodeMultiAsync_1() {
            var isArrayHeaderRequired, arrayItemsLeft, stream_2, stream_2_1, buffer, e_2, e_3_1;
            var e_3, _a;
            return $55f187cab2542bc0$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        isArrayHeaderRequired = isArray;
                        arrayItemsLeft = -1;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            13,
                            14,
                            19
                        ]);
                        stream_2 = $55f187cab2542bc0$var$__asyncValues(stream);
                        _b.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            $55f187cab2542bc0$var$__await(stream_2.next())
                        ];
                    case 3:
                        if (!(stream_2_1 = _b.sent(), !stream_2_1.done)) return [
                            3 /*break*/ ,
                            12
                        ];
                        buffer = stream_2_1.value;
                        if (isArray && arrayItemsLeft === 0) throw this.createExtraByteError(this.totalPos);
                        this.appendBuffer(buffer);
                        if (isArrayHeaderRequired) {
                            arrayItemsLeft = this.readArraySize();
                            isArrayHeaderRequired = false;
                            this.complete();
                        }
                        _b.label = 4;
                    case 4:
                        _b.trys.push([
                            4,
                            9,
                            ,
                            10
                        ]);
                        _b.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            $55f187cab2542bc0$var$__await(this.doDecodeSync())
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 7:
                        _b.sent();
                        if (--arrayItemsLeft === 0) return [
                            3 /*break*/ ,
                            8
                        ];
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        e_2 = _b.sent();
                        if (!(e_2 instanceof $55f187cab2542bc0$export$449c37eaf7093493)) throw e_2; // rethrow
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 10:
                        this.totalPos += this.pos;
                        _b.label = 11;
                    case 11:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 12:
                        return [
                            3 /*break*/ ,
                            19
                        ];
                    case 13:
                        e_3_1 = _b.sent();
                        e_3 = {
                            error: e_3_1
                        };
                        return [
                            3 /*break*/ ,
                            19
                        ];
                    case 14:
                        _b.trys.push([
                            14,
                            ,
                            17,
                            18
                        ]);
                        if (!(stream_2_1 && !stream_2_1.done && (_a = stream_2.return))) return [
                            3 /*break*/ ,
                            16
                        ];
                        return [
                            4 /*yield*/ ,
                            $55f187cab2542bc0$var$__await(_a.call(stream_2))
                        ];
                    case 15:
                        _b.sent();
                        _b.label = 16;
                    case 16:
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 17:
                        if (e_3) throw e_3.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 18:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 19:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Decoder.prototype.doDecodeSync = function() {
        DECODE: while(true){
            var headByte = this.readHeadByte();
            var object = void 0;
            if (headByte >= 0xe0) // negative fixint (111x xxxx) 0xe0 - 0xff
            object = headByte - 0x100;
            else if (headByte < 0xc0) {
                if (headByte < 0x80) // positive fixint (0xxx xxxx) 0x00 - 0x7f
                object = headByte;
                else if (headByte < 0x90) {
                    // fixmap (1000 xxxx) 0x80 - 0x8f
                    var size = headByte - 0x80;
                    if (size !== 0) {
                        this.pushMapState(size);
                        this.complete();
                        continue DECODE;
                    } else object = {};
                } else if (headByte < 0xa0) {
                    // fixarray (1001 xxxx) 0x90 - 0x9f
                    var size = headByte - 0x90;
                    if (size !== 0) {
                        this.pushArrayState(size);
                        this.complete();
                        continue DECODE;
                    } else object = [];
                } else {
                    // fixstr (101x xxxx) 0xa0 - 0xbf
                    var byteLength = headByte - 0xa0;
                    object = this.decodeUtf8String(byteLength, 0);
                }
            } else if (headByte === 0xc0) // nil
            object = null;
            else if (headByte === 0xc2) // false
            object = false;
            else if (headByte === 0xc3) // true
            object = true;
            else if (headByte === 0xca) // float 32
            object = this.readF32();
            else if (headByte === 0xcb) // float 64
            object = this.readF64();
            else if (headByte === 0xcc) // uint 8
            object = this.readU8();
            else if (headByte === 0xcd) // uint 16
            object = this.readU16();
            else if (headByte === 0xce) // uint 32
            object = this.readU32();
            else if (headByte === 0xcf) // uint 64
            object = this.readU64();
            else if (headByte === 0xd0) // int 8
            object = this.readI8();
            else if (headByte === 0xd1) // int 16
            object = this.readI16();
            else if (headByte === 0xd2) // int 32
            object = this.readI32();
            else if (headByte === 0xd3) // int 64
            object = this.readI64();
            else if (headByte === 0xd9) {
                // str 8
                var byteLength = this.lookU8();
                object = this.decodeUtf8String(byteLength, 1);
            } else if (headByte === 0xda) {
                // str 16
                var byteLength = this.lookU16();
                object = this.decodeUtf8String(byteLength, 2);
            } else if (headByte === 0xdb) {
                // str 32
                var byteLength = this.lookU32();
                object = this.decodeUtf8String(byteLength, 4);
            } else if (headByte === 0xdc) {
                // array 16
                var size = this.readU16();
                if (size !== 0) {
                    this.pushArrayState(size);
                    this.complete();
                    continue DECODE;
                } else object = [];
            } else if (headByte === 0xdd) {
                // array 32
                var size = this.readU32();
                if (size !== 0) {
                    this.pushArrayState(size);
                    this.complete();
                    continue DECODE;
                } else object = [];
            } else if (headByte === 0xde) {
                // map 16
                var size = this.readU16();
                if (size !== 0) {
                    this.pushMapState(size);
                    this.complete();
                    continue DECODE;
                } else object = {};
            } else if (headByte === 0xdf) {
                // map 32
                var size = this.readU32();
                if (size !== 0) {
                    this.pushMapState(size);
                    this.complete();
                    continue DECODE;
                } else object = {};
            } else if (headByte === 0xc4) {
                // bin 8
                var size = this.lookU8();
                object = this.decodeBinary(size, 1);
            } else if (headByte === 0xc5) {
                // bin 16
                var size = this.lookU16();
                object = this.decodeBinary(size, 2);
            } else if (headByte === 0xc6) {
                // bin 32
                var size = this.lookU32();
                object = this.decodeBinary(size, 4);
            } else if (headByte === 0xd4) // fixext 1
            object = this.decodeExtension(1, 0);
            else if (headByte === 0xd5) // fixext 2
            object = this.decodeExtension(2, 0);
            else if (headByte === 0xd6) // fixext 4
            object = this.decodeExtension(4, 0);
            else if (headByte === 0xd7) // fixext 8
            object = this.decodeExtension(8, 0);
            else if (headByte === 0xd8) // fixext 16
            object = this.decodeExtension(16, 0);
            else if (headByte === 0xc7) {
                // ext 8
                var size = this.lookU8();
                object = this.decodeExtension(size, 1);
            } else if (headByte === 0xc8) {
                // ext 16
                var size = this.lookU16();
                object = this.decodeExtension(size, 2);
            } else if (headByte === 0xc9) {
                // ext 32
                var size = this.lookU32();
                object = this.decodeExtension(size, 4);
            } else throw new (0, $a4491bb2a6ad27d5$exports.DecodeError)("Unrecognized type byte: ".concat((0, $7c4a7fd8af273aa0$export$78406e843f5312da)(headByte)));
            this.complete();
            var stack = this.stack;
            while(stack.length > 0){
                // arrays and maps
                var state = stack[stack.length - 1];
                if (state.type === 0 /* State.ARRAY */ ) {
                    state.array[state.position] = object;
                    state.position++;
                    if (state.position === state.size) {
                        stack.pop();
                        object = state.array;
                    } else continue DECODE;
                } else if (state.type === 1 /* State.MAP_KEY */ ) {
                    if (!$55f187cab2542bc0$var$isValidMapKeyType(object)) throw new (0, $a4491bb2a6ad27d5$exports.DecodeError)("The type of key must be string or number but " + typeof object);
                    if (object === "__proto__") throw new (0, $a4491bb2a6ad27d5$exports.DecodeError)("The key __proto__ is not allowed");
                    state.key = object;
                    state.type = 2 /* State.MAP_VALUE */ ;
                    continue DECODE;
                } else {
                    // it must be `state.type === State.MAP_VALUE` here
                    state.map[state.key] = object;
                    state.readCount++;
                    if (state.readCount === state.size) {
                        stack.pop();
                        object = state.map;
                    } else {
                        state.key = null;
                        state.type = 1 /* State.MAP_KEY */ ;
                        continue DECODE;
                    }
                }
            }
            return object;
        }
    };
    Decoder.prototype.readHeadByte = function() {
        if (this.headByte === $55f187cab2542bc0$var$HEAD_BYTE_REQUIRED) this.headByte = this.readU8();
        return this.headByte;
    };
    Decoder.prototype.complete = function() {
        this.headByte = $55f187cab2542bc0$var$HEAD_BYTE_REQUIRED;
    };
    Decoder.prototype.readArraySize = function() {
        var headByte = this.readHeadByte();
        switch(headByte){
            case 0xdc:
                return this.readU16();
            case 0xdd:
                return this.readU32();
            default:
                if (headByte < 0xa0) return headByte - 0x90;
                else throw new (0, $a4491bb2a6ad27d5$exports.DecodeError)("Unrecognized array type byte: ".concat((0, $7c4a7fd8af273aa0$export$78406e843f5312da)(headByte)));
        }
    };
    Decoder.prototype.pushMapState = function(size) {
        if (size > this.maxMapLength) throw new (0, $a4491bb2a6ad27d5$exports.DecodeError)("Max length exceeded: map length (".concat(size, ") > maxMapLengthLength (").concat(this.maxMapLength, ")"));
        this.stack.push({
            type: 1 /* State.MAP_KEY */ ,
            size: size,
            key: null,
            readCount: 0,
            map: {}
        });
    };
    Decoder.prototype.pushArrayState = function(size) {
        if (size > this.maxArrayLength) throw new (0, $a4491bb2a6ad27d5$exports.DecodeError)("Max length exceeded: array length (".concat(size, ") > maxArrayLength (").concat(this.maxArrayLength, ")"));
        this.stack.push({
            type: 0 /* State.ARRAY */ ,
            size: size,
            array: new Array(size),
            position: 0
        });
    };
    Decoder.prototype.decodeUtf8String = function(byteLength, headerOffset) {
        var _a;
        if (byteLength > this.maxStrLength) throw new (0, $a4491bb2a6ad27d5$exports.DecodeError)("Max length exceeded: UTF-8 byte length (".concat(byteLength, ") > maxStrLength (").concat(this.maxStrLength, ")"));
        if (this.bytes.byteLength < this.pos + headerOffset + byteLength) throw $55f187cab2542bc0$var$MORE_DATA;
        var offset = this.pos + headerOffset;
        var object;
        if (this.stateIsMapKey() && ((_a = this.keyDecoder) === null || _a === void 0 ? void 0 : _a.canBeCached(byteLength))) object = this.keyDecoder.decode(this.bytes, offset, byteLength);
        else if (byteLength > (0, $fb497f06276ad0b3$export$d866281c5a66d1ef)) object = (0, $fb497f06276ad0b3$export$6ed79e41309992dc)(this.bytes, offset, byteLength);
        else object = (0, $fb497f06276ad0b3$export$551117984c2adf4f)(this.bytes, offset, byteLength);
        this.pos += headerOffset + byteLength;
        return object;
    };
    Decoder.prototype.stateIsMapKey = function() {
        if (this.stack.length > 0) {
            var state = this.stack[this.stack.length - 1];
            return state.type === 1 /* State.MAP_KEY */ ;
        }
        return false;
    };
    Decoder.prototype.decodeBinary = function(byteLength, headOffset) {
        if (byteLength > this.maxBinLength) throw new (0, $a4491bb2a6ad27d5$exports.DecodeError)("Max length exceeded: bin length (".concat(byteLength, ") > maxBinLength (").concat(this.maxBinLength, ")"));
        if (!this.hasRemaining(byteLength + headOffset)) throw $55f187cab2542bc0$var$MORE_DATA;
        var offset = this.pos + headOffset;
        var object = this.bytes.subarray(offset, offset + byteLength);
        this.pos += headOffset + byteLength;
        return object;
    };
    Decoder.prototype.decodeExtension = function(size, headOffset) {
        if (size > this.maxExtLength) throw new (0, $a4491bb2a6ad27d5$exports.DecodeError)("Max length exceeded: ext length (".concat(size, ") > maxExtLength (").concat(this.maxExtLength, ")"));
        var extType = this.view.getInt8(this.pos + headOffset);
        var data = this.decodeBinary(size, headOffset + 1 /* extType */ );
        return this.extensionCodec.decode(data, extType, this.context);
    };
    Decoder.prototype.lookU8 = function() {
        return this.view.getUint8(this.pos);
    };
    Decoder.prototype.lookU16 = function() {
        return this.view.getUint16(this.pos);
    };
    Decoder.prototype.lookU32 = function() {
        return this.view.getUint32(this.pos);
    };
    Decoder.prototype.readU8 = function() {
        var value = this.view.getUint8(this.pos);
        this.pos++;
        return value;
    };
    Decoder.prototype.readI8 = function() {
        var value = this.view.getInt8(this.pos);
        this.pos++;
        return value;
    };
    Decoder.prototype.readU16 = function() {
        var value = this.view.getUint16(this.pos);
        this.pos += 2;
        return value;
    };
    Decoder.prototype.readI16 = function() {
        var value = this.view.getInt16(this.pos);
        this.pos += 2;
        return value;
    };
    Decoder.prototype.readU32 = function() {
        var value = this.view.getUint32(this.pos);
        this.pos += 4;
        return value;
    };
    Decoder.prototype.readI32 = function() {
        var value = this.view.getInt32(this.pos);
        this.pos += 4;
        return value;
    };
    Decoder.prototype.readU64 = function() {
        var value = (0, $fdb0ae6cfa73dfa2$export$59a2dbf579ff9568)(this.view, this.pos);
        this.pos += 8;
        return value;
    };
    Decoder.prototype.readI64 = function() {
        var value = (0, $fdb0ae6cfa73dfa2$export$69825c7adcc820c6)(this.view, this.pos);
        this.pos += 8;
        return value;
    };
    Decoder.prototype.readF32 = function() {
        var value = this.view.getFloat32(this.pos);
        this.pos += 4;
        return value;
    };
    Decoder.prototype.readF64 = function() {
        var value = this.view.getFloat64(this.pos);
        this.pos += 8;
        return value;
    };
    return Decoder;
}();


var $f1dfd7b4fc0faa4a$exports = {};

$parcel$export($f1dfd7b4fc0faa4a$exports, "ensureAsyncIterable", function () { return $f1dfd7b4fc0faa4a$export$bf99ef56e8bd104; });
// utility for whatwg streams
var $f1dfd7b4fc0faa4a$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f1dfd7b4fc0faa4a$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $f1dfd7b4fc0faa4a$var$__await ? (this.v = v, this) : new $f1dfd7b4fc0faa4a$var$__await(v);
};
var $f1dfd7b4fc0faa4a$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f1dfd7b4fc0faa4a$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $f1dfd7b4fc0faa4a$export$edb10ab8dd75a915(object) {
    return object[Symbol.asyncIterator] != null;
}
function $f1dfd7b4fc0faa4a$var$assertNonNull(value) {
    if (value == null) throw new Error("Assertion Failure: value must not be null nor undefined");
}
function $f1dfd7b4fc0faa4a$export$f62cf0e66867a58e(stream) {
    return $f1dfd7b4fc0faa4a$var$__asyncGenerator(this, arguments, function asyncIterableFromStream_1() {
        var reader, _a, done, value;
        return $f1dfd7b4fc0faa4a$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = stream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4 /*yield*/ ,
                        $f1dfd7b4fc0faa4a$var$__await(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (!done) return [
                        3 /*break*/ ,
                        5
                    ];
                    return [
                        4 /*yield*/ ,
                        $f1dfd7b4fc0faa4a$var$__await(void 0)
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        _b.sent()
                    ];
                case 5:
                    $f1dfd7b4fc0faa4a$var$assertNonNull(value);
                    return [
                        4 /*yield*/ ,
                        $f1dfd7b4fc0faa4a$var$__await(value)
                    ];
                case 6:
                    return [
                        4 /*yield*/ ,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 8:
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 10:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $f1dfd7b4fc0faa4a$export$bf99ef56e8bd104(streamLike) {
    if ($f1dfd7b4fc0faa4a$export$edb10ab8dd75a915(streamLike)) return streamLike;
    else return $f1dfd7b4fc0faa4a$export$f62cf0e66867a58e(streamLike);
}



var $7c03e13d2d5e1691$export$ca6ec972f712a9eb = {};
function $7c03e13d2d5e1691$export$2f872c0f2117be69(buffer, options) {
    if (options === void 0) options = $7c03e13d2d5e1691$export$ca6ec972f712a9eb;
    var decoder = new (0, $55f187cab2542bc0$exports.Decoder)(options.extensionCodec, options.context, options.maxStrLength, options.maxBinLength, options.maxArrayLength, options.maxMapLength, options.maxExtLength);
    return decoder.decode(buffer);
}
function $7c03e13d2d5e1691$export$43cc91859d9fdc54(buffer, options) {
    if (options === void 0) options = $7c03e13d2d5e1691$export$ca6ec972f712a9eb;
    var decoder = new (0, $55f187cab2542bc0$exports.Decoder)(options.extensionCodec, options.context, options.maxStrLength, options.maxBinLength, options.maxArrayLength, options.maxMapLength, options.maxExtLength);
    return decoder.decodeMulti(buffer);
}


var $7990493837413dda$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7990493837413dda$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function $7990493837413dda$export$e4c183687a6ff9b(streamLike, options) {
    if (options === void 0) options = (0, $7c03e13d2d5e1691$export$ca6ec972f712a9eb);
    return $7990493837413dda$var$__awaiter(this, void 0, void 0, function() {
        var stream, decoder;
        return $7990493837413dda$var$__generator(this, function(_a) {
            stream = (0, $f1dfd7b4fc0faa4a$exports.ensureAsyncIterable)(streamLike);
            decoder = new (0, $55f187cab2542bc0$exports.Decoder)(options.extensionCodec, options.context, options.maxStrLength, options.maxBinLength, options.maxArrayLength, options.maxMapLength, options.maxExtLength);
            return [
                2 /*return*/ ,
                decoder.decodeAsync(stream)
            ];
        });
    });
}
function $7990493837413dda$export$b1b94ac44d9853a4(streamLike, options) {
    if (options === void 0) options = (0, $7c03e13d2d5e1691$export$ca6ec972f712a9eb);
    var stream = (0, $f1dfd7b4fc0faa4a$exports.ensureAsyncIterable)(streamLike);
    var decoder = new (0, $55f187cab2542bc0$exports.Decoder)(options.extensionCodec, options.context, options.maxStrLength, options.maxBinLength, options.maxArrayLength, options.maxMapLength, options.maxExtLength);
    return decoder.decodeArrayStream(stream);
}
function $7990493837413dda$export$bf87d8a088c760fb(streamLike, options) {
    if (options === void 0) options = (0, $7c03e13d2d5e1691$export$ca6ec972f712a9eb);
    var stream = (0, $f1dfd7b4fc0faa4a$exports.ensureAsyncIterable)(streamLike);
    var decoder = new (0, $55f187cab2542bc0$exports.Decoder)(options.extensionCodec, options.context, options.maxStrLength, options.maxBinLength, options.maxArrayLength, options.maxMapLength, options.maxExtLength);
    return decoder.decodeStream(stream);
}
function $7990493837413dda$export$7fb0f205e4fd0bbe(streamLike, options) {
    if (options === void 0) options = (0, $7c03e13d2d5e1691$export$ca6ec972f712a9eb);
    return $7990493837413dda$export$bf87d8a088c760fb(streamLike, options);
}





var $f37fc301bc8d0fe8$export$2c6de1218fe0e46d = 100;
var $f37fc301bc8d0fe8$export$29659805a45f979c = 2048;
var $f37fc301bc8d0fe8$export$a50aceb0e02a00aa = /** @class */ function() {
    function Encoder(extensionCodec, context, maxDepth, initialBufferSize, sortKeys, forceFloat32, ignoreUndefined, forceIntegerToFloat) {
        if (extensionCodec === void 0) extensionCodec = (0, $50b6761edf3a4a35$export$12677a794dbd89d7).defaultCodec;
        if (context === void 0) context = undefined;
        if (maxDepth === void 0) maxDepth = $f37fc301bc8d0fe8$export$2c6de1218fe0e46d;
        if (initialBufferSize === void 0) initialBufferSize = $f37fc301bc8d0fe8$export$29659805a45f979c;
        if (sortKeys === void 0) sortKeys = false;
        if (forceFloat32 === void 0) forceFloat32 = false;
        if (ignoreUndefined === void 0) ignoreUndefined = false;
        if (forceIntegerToFloat === void 0) forceIntegerToFloat = false;
        this.extensionCodec = extensionCodec;
        this.context = context;
        this.maxDepth = maxDepth;
        this.initialBufferSize = initialBufferSize;
        this.sortKeys = sortKeys;
        this.forceFloat32 = forceFloat32;
        this.ignoreUndefined = ignoreUndefined;
        this.forceIntegerToFloat = forceIntegerToFloat;
        this.pos = 0;
        this.view = new DataView(new ArrayBuffer(this.initialBufferSize));
        this.bytes = new Uint8Array(this.view.buffer);
    }
    Encoder.prototype.reinitializeState = function() {
        this.pos = 0;
    };
    /**
     * This is almost equivalent to {@link Encoder#encode}, but it returns an reference of the encoder's internal buffer and thus much faster than {@link Encoder#encode}.
     *
     * @returns Encodes the object and returns a shared reference the encoder's internal buffer.
     */ Encoder.prototype.encodeSharedRef = function(object) {
        this.reinitializeState();
        this.doEncode(object, 1);
        return this.bytes.subarray(0, this.pos);
    };
    /**
     * @returns Encodes the object and returns a copy of the encoder's internal buffer.
     */ Encoder.prototype.encode = function(object) {
        this.reinitializeState();
        this.doEncode(object, 1);
        return this.bytes.slice(0, this.pos);
    };
    Encoder.prototype.doEncode = function(object, depth) {
        if (depth > this.maxDepth) throw new Error("Too deep objects in depth ".concat(depth));
        if (object == null) this.encodeNil();
        else if (typeof object === "boolean") this.encodeBoolean(object);
        else if (typeof object === "number") this.encodeNumber(object);
        else if (typeof object === "string") this.encodeString(object);
        else this.encodeObject(object, depth);
    };
    Encoder.prototype.ensureBufferSizeToWrite = function(sizeToWrite) {
        var requiredSize = this.pos + sizeToWrite;
        if (this.view.byteLength < requiredSize) this.resizeBuffer(requiredSize * 2);
    };
    Encoder.prototype.resizeBuffer = function(newSize) {
        var newBuffer = new ArrayBuffer(newSize);
        var newBytes = new Uint8Array(newBuffer);
        var newView = new DataView(newBuffer);
        newBytes.set(this.bytes);
        this.view = newView;
        this.bytes = newBytes;
    };
    Encoder.prototype.encodeNil = function() {
        this.writeU8(0xc0);
    };
    Encoder.prototype.encodeBoolean = function(object) {
        if (object === false) this.writeU8(0xc2);
        else this.writeU8(0xc3);
    };
    Encoder.prototype.encodeNumber = function(object) {
        if (Number.isSafeInteger(object) && !this.forceIntegerToFloat) {
            if (object >= 0) {
                if (object < 0x80) // positive fixint
                this.writeU8(object);
                else if (object < 0x100) {
                    // uint 8
                    this.writeU8(0xcc);
                    this.writeU8(object);
                } else if (object < 0x10000) {
                    // uint 16
                    this.writeU8(0xcd);
                    this.writeU16(object);
                } else if (object < 0x100000000) {
                    // uint 32
                    this.writeU8(0xce);
                    this.writeU32(object);
                } else {
                    // uint 64
                    this.writeU8(0xcf);
                    this.writeU64(object);
                }
            } else {
                if (object >= -32) // negative fixint
                this.writeU8(0xe0 | object + 0x20);
                else if (object >= -128) {
                    // int 8
                    this.writeU8(0xd0);
                    this.writeI8(object);
                } else if (object >= -32768) {
                    // int 16
                    this.writeU8(0xd1);
                    this.writeI16(object);
                } else if (object >= -2147483648) {
                    // int 32
                    this.writeU8(0xd2);
                    this.writeI32(object);
                } else {
                    // int 64
                    this.writeU8(0xd3);
                    this.writeI64(object);
                }
            }
        } else // non-integer numbers
        if (this.forceFloat32) {
            // float 32
            this.writeU8(0xca);
            this.writeF32(object);
        } else {
            // float 64
            this.writeU8(0xcb);
            this.writeF64(object);
        }
    };
    Encoder.prototype.writeStringHeader = function(byteLength) {
        if (byteLength < 32) // fixstr
        this.writeU8(0xa0 + byteLength);
        else if (byteLength < 0x100) {
            // str 8
            this.writeU8(0xd9);
            this.writeU8(byteLength);
        } else if (byteLength < 0x10000) {
            // str 16
            this.writeU8(0xda);
            this.writeU16(byteLength);
        } else if (byteLength < 0x100000000) {
            // str 32
            this.writeU8(0xdb);
            this.writeU32(byteLength);
        } else throw new Error("Too long string: ".concat(byteLength, " bytes in UTF-8"));
    };
    Encoder.prototype.encodeString = function(object) {
        var maxHeaderSize = 5;
        var strLength = object.length;
        if (strLength > (0, $fb497f06276ad0b3$export$ed34c0622b397238)) {
            var byteLength = (0, $fb497f06276ad0b3$export$b61de95301265227)(object);
            this.ensureBufferSizeToWrite(maxHeaderSize + byteLength);
            this.writeStringHeader(byteLength);
            (0, $fb497f06276ad0b3$export$34cfdc82d430524)(object, this.bytes, this.pos);
            this.pos += byteLength;
        } else {
            var byteLength = (0, $fb497f06276ad0b3$export$b61de95301265227)(object);
            this.ensureBufferSizeToWrite(maxHeaderSize + byteLength);
            this.writeStringHeader(byteLength);
            (0, $fb497f06276ad0b3$export$1042e4338f1ef853)(object, this.bytes, this.pos);
            this.pos += byteLength;
        }
    };
    Encoder.prototype.encodeObject = function(object, depth) {
        // try to encode objects with custom codec first of non-primitives
        var ext = this.extensionCodec.tryToEncode(object, this.context);
        if (ext != null) this.encodeExtension(ext);
        else if (Array.isArray(object)) this.encodeArray(object, depth);
        else if (ArrayBuffer.isView(object)) this.encodeBinary(object);
        else if (typeof object === "object") this.encodeMap(object, depth);
        else // symbol, function and other special object come here unless extensionCodec handles them.
        throw new Error("Unrecognized object: ".concat(Object.prototype.toString.apply(object)));
    };
    Encoder.prototype.encodeBinary = function(object) {
        var size = object.byteLength;
        if (size < 0x100) {
            // bin 8
            this.writeU8(0xc4);
            this.writeU8(size);
        } else if (size < 0x10000) {
            // bin 16
            this.writeU8(0xc5);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // bin 32
            this.writeU8(0xc6);
            this.writeU32(size);
        } else throw new Error("Too large binary: ".concat(size));
        var bytes = (0, $8a6379bd6faea12c$export$f8d669c2a17882f2)(object);
        this.writeU8a(bytes);
    };
    Encoder.prototype.encodeArray = function(object, depth) {
        var size = object.length;
        if (size < 16) // fixarray
        this.writeU8(0x90 + size);
        else if (size < 0x10000) {
            // array 16
            this.writeU8(0xdc);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // array 32
            this.writeU8(0xdd);
            this.writeU32(size);
        } else throw new Error("Too large array: ".concat(size));
        for(var _i = 0, object_1 = object; _i < object_1.length; _i++){
            var item = object_1[_i];
            this.doEncode(item, depth + 1);
        }
    };
    Encoder.prototype.countWithoutUndefined = function(object, keys) {
        var count = 0;
        for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
            var key = keys_1[_i];
            if (object[key] !== undefined) count++;
        }
        return count;
    };
    Encoder.prototype.encodeMap = function(object, depth) {
        var keys = Object.keys(object);
        if (this.sortKeys) keys.sort();
        var size = this.ignoreUndefined ? this.countWithoutUndefined(object, keys) : keys.length;
        if (size < 16) // fixmap
        this.writeU8(0x80 + size);
        else if (size < 0x10000) {
            // map 16
            this.writeU8(0xde);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // map 32
            this.writeU8(0xdf);
            this.writeU32(size);
        } else throw new Error("Too large map object: ".concat(size));
        for(var _i = 0, keys_2 = keys; _i < keys_2.length; _i++){
            var key = keys_2[_i];
            var value = object[key];
            if (!(this.ignoreUndefined && value === undefined)) {
                this.encodeString(key);
                this.doEncode(value, depth + 1);
            }
        }
    };
    Encoder.prototype.encodeExtension = function(ext) {
        var size = ext.data.length;
        if (size === 1) // fixext 1
        this.writeU8(0xd4);
        else if (size === 2) // fixext 2
        this.writeU8(0xd5);
        else if (size === 4) // fixext 4
        this.writeU8(0xd6);
        else if (size === 8) // fixext 8
        this.writeU8(0xd7);
        else if (size === 16) // fixext 16
        this.writeU8(0xd8);
        else if (size < 0x100) {
            // ext 8
            this.writeU8(0xc7);
            this.writeU8(size);
        } else if (size < 0x10000) {
            // ext 16
            this.writeU8(0xc8);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // ext 32
            this.writeU8(0xc9);
            this.writeU32(size);
        } else throw new Error("Too large extension object: ".concat(size));
        this.writeI8(ext.type);
        this.writeU8a(ext.data);
    };
    Encoder.prototype.writeU8 = function(value) {
        this.ensureBufferSizeToWrite(1);
        this.view.setUint8(this.pos, value);
        this.pos++;
    };
    Encoder.prototype.writeU8a = function(values) {
        var size = values.length;
        this.ensureBufferSizeToWrite(size);
        this.bytes.set(values, this.pos);
        this.pos += size;
    };
    Encoder.prototype.writeI8 = function(value) {
        this.ensureBufferSizeToWrite(1);
        this.view.setInt8(this.pos, value);
        this.pos++;
    };
    Encoder.prototype.writeU16 = function(value) {
        this.ensureBufferSizeToWrite(2);
        this.view.setUint16(this.pos, value);
        this.pos += 2;
    };
    Encoder.prototype.writeI16 = function(value) {
        this.ensureBufferSizeToWrite(2);
        this.view.setInt16(this.pos, value);
        this.pos += 2;
    };
    Encoder.prototype.writeU32 = function(value) {
        this.ensureBufferSizeToWrite(4);
        this.view.setUint32(this.pos, value);
        this.pos += 4;
    };
    Encoder.prototype.writeI32 = function(value) {
        this.ensureBufferSizeToWrite(4);
        this.view.setInt32(this.pos, value);
        this.pos += 4;
    };
    Encoder.prototype.writeF32 = function(value) {
        this.ensureBufferSizeToWrite(4);
        this.view.setFloat32(this.pos, value);
        this.pos += 4;
    };
    Encoder.prototype.writeF64 = function(value) {
        this.ensureBufferSizeToWrite(8);
        this.view.setFloat64(this.pos, value);
        this.pos += 8;
    };
    Encoder.prototype.writeU64 = function(value) {
        this.ensureBufferSizeToWrite(8);
        (0, $fdb0ae6cfa73dfa2$export$20f71c4c8b0f96c3)(this.view, this.pos, value);
        this.pos += 8;
    };
    Encoder.prototype.writeI64 = function(value) {
        this.ensureBufferSizeToWrite(8);
        (0, $fdb0ae6cfa73dfa2$export$8532a5209571c04a)(this.view, this.pos, value);
        this.pos += 8;
    };
    return Encoder;
}();


function $478396ff7932844e$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
class $478396ff7932844e$var$$fcbcc7538a6776d5$export$f1c5f4c9cb95390b {
    constructor(){
        this.chunkedMTU = 16300 // The original 60000 bytes setting does not work when sending data from Firefox to Chrome, which is "cut off" after 16384 bytes and delivered individually.
        ;
        // Binary stuff
        this._dataCount = 1;
        this.chunk = (blob)=>{
            const chunks = [];
            const size = blob.byteLength;
            const total = Math.ceil(size / this.chunkedMTU);
            let index = 0;
            let start = 0;
            while(start < size){
                const end = Math.min(size, start + this.chunkedMTU);
                const b = blob.slice(start, end);
                const chunk = {
                    __peerData: this._dataCount,
                    n: index,
                    data: b,
                    total: total
                };
                chunks.push(chunk);
                start = end;
                index++;
            }
            this._dataCount++;
            return chunks;
        };
    }
}
function $478396ff7932844e$var$$fcbcc7538a6776d5$export$52c89ebcdc4f53f2(bufs) {
    let size = 0;
    for (const buf of bufs)size += buf.byteLength;
    const result = new Uint8Array(size);
    let offset = 0;
    for (const buf of bufs){
        result.set(buf, offset);
        offset += buf.byteLength;
    }
    return result;
}
const $478396ff7932844e$var$$fb63e766cfafaab9$var$webRTCAdapter = (0, $464b48a621604b0f$export$2e2bcd8739ae039).default || (0, $464b48a621604b0f$export$2e2bcd8739ae039);
const $478396ff7932844e$var$$fb63e766cfafaab9$export$25be9502477c137d = new class {
    isWebRTCSupported() {
        return typeof RTCPeerConnection !== "undefined";
    }
    isBrowserSupported() {
        const browser = this.getBrowser();
        const version = this.getVersion();
        const validBrowser = this.supportedBrowsers.includes(browser);
        if (!validBrowser) return false;
        if (browser === "chrome") return version >= this.minChromeVersion;
        if (browser === "firefox") return version >= this.minFirefoxVersion;
        if (browser === "safari") return !this.isIOS && version >= this.minSafariVersion;
        return false;
    }
    getBrowser() {
        return $478396ff7932844e$var$$fb63e766cfafaab9$var$webRTCAdapter.browserDetails.browser;
    }
    getVersion() {
        return $478396ff7932844e$var$$fb63e766cfafaab9$var$webRTCAdapter.browserDetails.version || 0;
    }
    isUnifiedPlanSupported() {
        const browser = this.getBrowser();
        const version = $478396ff7932844e$var$$fb63e766cfafaab9$var$webRTCAdapter.browserDetails.version || 0;
        if (browser === "chrome" && version < this.minChromeVersion) return false;
        if (browser === "firefox" && version >= this.minFirefoxVersion) return true;
        if (!window.RTCRtpTransceiver || !("currentDirection" in RTCRtpTransceiver.prototype)) return false;
        let tempPc;
        let supported = false;
        try {
            tempPc = new RTCPeerConnection();
            tempPc.addTransceiver("audio");
            supported = true;
        } catch (e) {} finally{
            if (tempPc) tempPc.close();
        }
        return supported;
    }
    toString() {
        return `Supports:
    browser:${this.getBrowser()}
    version:${this.getVersion()}
    isIOS:${this.isIOS}
    isWebRTCSupported:${this.isWebRTCSupported()}
    isBrowserSupported:${this.isBrowserSupported()}
    isUnifiedPlanSupported:${this.isUnifiedPlanSupported()}`;
    }
    constructor(){
        this.isIOS = [
            "iPad",
            "iPhone",
            "iPod"
        ].includes(navigator.platform);
        this.supportedBrowsers = [
            "firefox",
            "chrome",
            "safari"
        ];
        this.minFirefoxVersion = 59;
        this.minChromeVersion = 72;
        this.minSafariVersion = 605;
    }
}();
const $478396ff7932844e$var$$9a84a32bf0bf36bb$export$f35f128fd59ea256 = (id)=>{
    // Allow empty ids
    return !id || /^[A-Za-z0-9]+(?:[ _-][A-Za-z0-9]+)*$/.test(id);
};
const $478396ff7932844e$var$$0e5fd1585784c252$export$4e61f672936bec77 = ()=>Math.random().toString(36).slice(2);
const $478396ff7932844e$var$$4f4134156c446392$var$DEFAULT_CONFIG = {
    iceServers: [
        {
            urls: "stun:stun.l.google.com:19302"
        },
        {
            urls: [
                "turn:eu-0.turn.peerjs.com:3478",
                "turn:us-0.turn.peerjs.com:3478"
            ],
            username: "peerjs",
            credential: "peerjsp"
        }
    ],
    sdpSemantics: "unified-plan"
};
class $478396ff7932844e$var$$4f4134156c446392$export$f8f26dd395d7e1bd extends $478396ff7932844e$var$$fcbcc7538a6776d5$export$f1c5f4c9cb95390b {
    noop() {}
    blobToArrayBuffer(blob, cb) {
        const fr = new FileReader();
        fr.onload = function(evt) {
            if (evt.target) cb(evt.target.result);
        };
        fr.readAsArrayBuffer(blob);
        return fr;
    }
    binaryStringToArrayBuffer(binary) {
        const byteArray = new Uint8Array(binary.length);
        for(let i = 0; i < binary.length; i++)byteArray[i] = binary.charCodeAt(i) & 0xff;
        return byteArray.buffer;
    }
    isSecure() {
        return location.protocol === "https:";
    }
    constructor(...args){
        super(...args);
        this.CLOUD_HOST = "0.peerjs.com";
        this.CLOUD_PORT = 443;
        // Browsers that need chunking:
        this.chunkedBrowsers = {
            Chrome: 1,
            chrome: 1
        };
        // Returns browser-agnostic default config
        this.defaultConfig = $478396ff7932844e$var$$4f4134156c446392$var$DEFAULT_CONFIG;
        this.browser = $478396ff7932844e$var$$fb63e766cfafaab9$export$25be9502477c137d.getBrowser();
        this.browserVersion = $478396ff7932844e$var$$fb63e766cfafaab9$export$25be9502477c137d.getVersion();
        this.pack = (0, $d9b1b8e8a2890313$export$2a703dbb0cb35339);
        this.unpack = (0, $d9b1b8e8a2890313$export$417857010dc9287f);
        /**
	 * A hash of WebRTC features mapped to booleans that correspond to whether the feature is supported by the current browser.
	 *
	 * :::caution
	 * Only the properties documented here are guaranteed to be present on `util.supports`
	 * :::
	 */ this.supports = function() {
            const supported = {
                browser: $478396ff7932844e$var$$fb63e766cfafaab9$export$25be9502477c137d.isBrowserSupported(),
                webRTC: $478396ff7932844e$var$$fb63e766cfafaab9$export$25be9502477c137d.isWebRTCSupported(),
                audioVideo: false,
                data: false,
                binaryBlob: false,
                reliable: false
            };
            if (!supported.webRTC) return supported;
            let pc;
            try {
                pc = new RTCPeerConnection($478396ff7932844e$var$$4f4134156c446392$var$DEFAULT_CONFIG);
                supported.audioVideo = true;
                let dc;
                try {
                    dc = pc.createDataChannel("_PEERJSTEST", {
                        ordered: true
                    });
                    supported.data = true;
                    supported.reliable = !!dc.ordered;
                    // Binary test
                    try {
                        dc.binaryType = "blob";
                        supported.binaryBlob = !$478396ff7932844e$var$$fb63e766cfafaab9$export$25be9502477c137d.isIOS;
                    } catch (e) {}
                } catch (e) {} finally{
                    if (dc) dc.close();
                }
            } catch (e) {} finally{
                if (pc) pc.close();
            }
            return supported;
        }();
        // Ensure alphanumeric ids
        this.validateId = $478396ff7932844e$var$$9a84a32bf0bf36bb$export$f35f128fd59ea256;
        this.randomToken = $478396ff7932844e$var$$0e5fd1585784c252$export$4e61f672936bec77;
    }
}
const $478396ff7932844e$export$7debb50ef11d5e0b = new $478396ff7932844e$var$$4f4134156c446392$export$f8f26dd395d7e1bd();
const $478396ff7932844e$var$$257947e92926277a$var$LOG_PREFIX = "PeerJS: ";
var $478396ff7932844e$var$$257947e92926277a$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel[/**
	 * Prints no logs.
	 */ "Disabled"] = 0] = "Disabled";
    LogLevel[LogLevel[/**
	 * Prints only errors.
	 */ "Errors"] = 1] = "Errors";
    LogLevel[LogLevel[/**
	 * Prints errors and warnings.
	 */ "Warnings"] = 2] = "Warnings";
    LogLevel[LogLevel[/**
	 * Prints all logs.
	 */ "All"] = 3] = "All";
})($478396ff7932844e$var$$257947e92926277a$export$243e62d78d3b544d || ($478396ff7932844e$var$$257947e92926277a$export$243e62d78d3b544d = {}));
class $478396ff7932844e$var$$257947e92926277a$var$Logger {
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(logLevel) {
        this._logLevel = logLevel;
    }
    log(...args) {
        if (this._logLevel >= $478396ff7932844e$var$$257947e92926277a$export$243e62d78d3b544d.All) this._print($478396ff7932844e$var$$257947e92926277a$export$243e62d78d3b544d.All, ...args);
    }
    warn(...args) {
        if (this._logLevel >= $478396ff7932844e$var$$257947e92926277a$export$243e62d78d3b544d.Warnings) this._print($478396ff7932844e$var$$257947e92926277a$export$243e62d78d3b544d.Warnings, ...args);
    }
    error(...args) {
        if (this._logLevel >= $478396ff7932844e$var$$257947e92926277a$export$243e62d78d3b544d.Errors) this._print($478396ff7932844e$var$$257947e92926277a$export$243e62d78d3b544d.Errors, ...args);
    }
    setLogFunction(fn) {
        this._print = fn;
    }
    _print(logLevel, ...rest) {
        const copy = [
            $478396ff7932844e$var$$257947e92926277a$var$LOG_PREFIX,
            ...rest
        ];
        for(const i in copy)if (copy[i] instanceof Error) copy[i] = "(" + copy[i].name + ") " + copy[i].message;
        if (logLevel >= $478396ff7932844e$var$$257947e92926277a$export$243e62d78d3b544d.All) console.log(...copy);
        else if (logLevel >= $478396ff7932844e$var$$257947e92926277a$export$243e62d78d3b544d.Warnings) console.warn("WARNING", ...copy);
        else if (logLevel >= $478396ff7932844e$var$$257947e92926277a$export$243e62d78d3b544d.Errors) console.error("ERROR", ...copy);
    }
    constructor(){
        this._logLevel = $478396ff7932844e$var$$257947e92926277a$export$243e62d78d3b544d.Disabled;
    }
}
var $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039 = new $478396ff7932844e$var$$257947e92926277a$var$Logger();
var $478396ff7932844e$var$$c4dcfd1d1ea86647$exports = {};
"use strict";
var $478396ff7932844e$var$$c4dcfd1d1ea86647$var$has = Object.prototype.hasOwnProperty, $478396ff7932844e$var$$c4dcfd1d1ea86647$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $478396ff7932844e$var$$c4dcfd1d1ea86647$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $478396ff7932844e$var$$c4dcfd1d1ea86647$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $478396ff7932844e$var$$c4dcfd1d1ea86647$var$Events().__proto__) $478396ff7932844e$var$$c4dcfd1d1ea86647$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $478396ff7932844e$var$$c4dcfd1d1ea86647$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $478396ff7932844e$var$$c4dcfd1d1ea86647$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $478396ff7932844e$var$$c4dcfd1d1ea86647$var$EE(fn, context || emitter, once), evt = $478396ff7932844e$var$$c4dcfd1d1ea86647$var$prefix ? $478396ff7932844e$var$$c4dcfd1d1ea86647$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $478396ff7932844e$var$$c4dcfd1d1ea86647$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $478396ff7932844e$var$$c4dcfd1d1ea86647$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $478396ff7932844e$var$$c4dcfd1d1ea86647$var$EventEmitter() {
    this._events = new $478396ff7932844e$var$$c4dcfd1d1ea86647$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $478396ff7932844e$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($478396ff7932844e$var$$c4dcfd1d1ea86647$var$has.call(events, name)) names.push($478396ff7932844e$var$$c4dcfd1d1ea86647$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $478396ff7932844e$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $478396ff7932844e$var$$c4dcfd1d1ea86647$var$prefix ? $478396ff7932844e$var$$c4dcfd1d1ea86647$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $478396ff7932844e$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $478396ff7932844e$var$$c4dcfd1d1ea86647$var$prefix ? $478396ff7932844e$var$$c4dcfd1d1ea86647$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $478396ff7932844e$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $478396ff7932844e$var$$c4dcfd1d1ea86647$var$prefix ? $478396ff7932844e$var$$c4dcfd1d1ea86647$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $478396ff7932844e$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $478396ff7932844e$var$$c4dcfd1d1ea86647$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $478396ff7932844e$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $478396ff7932844e$var$$c4dcfd1d1ea86647$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $478396ff7932844e$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $478396ff7932844e$var$$c4dcfd1d1ea86647$var$prefix ? $478396ff7932844e$var$$c4dcfd1d1ea86647$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $478396ff7932844e$var$$c4dcfd1d1ea86647$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $478396ff7932844e$var$$c4dcfd1d1ea86647$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $478396ff7932844e$var$$c4dcfd1d1ea86647$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $478396ff7932844e$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $478396ff7932844e$var$$c4dcfd1d1ea86647$var$prefix ? $478396ff7932844e$var$$c4dcfd1d1ea86647$var$prefix + event : event;
        if (this._events[evt]) $478396ff7932844e$var$$c4dcfd1d1ea86647$var$clearEvent(this, evt);
    } else {
        this._events = new $478396ff7932844e$var$$c4dcfd1d1ea86647$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$478396ff7932844e$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.off = $478396ff7932844e$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.removeListener;
$478396ff7932844e$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.addListener = $478396ff7932844e$var$$c4dcfd1d1ea86647$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$478396ff7932844e$var$$c4dcfd1d1ea86647$var$EventEmitter.prefixed = $478396ff7932844e$var$$c4dcfd1d1ea86647$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$478396ff7932844e$var$$c4dcfd1d1ea86647$var$EventEmitter.EventEmitter = $478396ff7932844e$var$$c4dcfd1d1ea86647$var$EventEmitter;
$478396ff7932844e$var$$c4dcfd1d1ea86647$exports = $478396ff7932844e$var$$c4dcfd1d1ea86647$var$EventEmitter;
var $478396ff7932844e$var$$78455e22dea96b8c$exports = {};
$478396ff7932844e$var$$parcel$export($478396ff7932844e$var$$78455e22dea96b8c$exports, "ConnectionType", ()=>$478396ff7932844e$export$3157d57b4135e3bc);
$478396ff7932844e$var$$parcel$export($478396ff7932844e$var$$78455e22dea96b8c$exports, "PeerErrorType", ()=>$478396ff7932844e$export$9547aaa2e39030ff);
$478396ff7932844e$var$$parcel$export($478396ff7932844e$var$$78455e22dea96b8c$exports, "BaseConnectionErrorType", ()=>$478396ff7932844e$export$7974935686149686);
$478396ff7932844e$var$$parcel$export($478396ff7932844e$var$$78455e22dea96b8c$exports, "DataConnectionErrorType", ()=>$478396ff7932844e$export$49ae800c114df41d);
$478396ff7932844e$var$$parcel$export($478396ff7932844e$var$$78455e22dea96b8c$exports, "SerializationType", ()=>$478396ff7932844e$export$89f507cf986a947);
$478396ff7932844e$var$$parcel$export($478396ff7932844e$var$$78455e22dea96b8c$exports, "SocketEventType", ()=>$478396ff7932844e$export$3b5c4a4b6354f023);
$478396ff7932844e$var$$parcel$export($478396ff7932844e$var$$78455e22dea96b8c$exports, "ServerMessageType", ()=>$478396ff7932844e$export$adb4a1754da6f10d);
var $478396ff7932844e$export$3157d57b4135e3bc;
(function(ConnectionType) {
    ConnectionType["Data"] = "data";
    ConnectionType["Media"] = "media";
})($478396ff7932844e$export$3157d57b4135e3bc || ($478396ff7932844e$export$3157d57b4135e3bc = {}));
var $478396ff7932844e$export$9547aaa2e39030ff;
(function(PeerErrorType) {
    PeerErrorType[/**
	 * The client's browser does not support some or all WebRTC features that you are trying to use.
	 */ "BrowserIncompatible"] = "browser-incompatible";
    PeerErrorType[/**
	 * You've already disconnected this peer from the server and can no longer make any new connections on it.
	 */ "Disconnected"] = "disconnected";
    PeerErrorType[/**
	 * The ID passed into the Peer constructor contains illegal characters.
	 */ "InvalidID"] = "invalid-id";
    PeerErrorType[/**
	 * The API key passed into the Peer constructor contains illegal characters or is not in the system (cloud server only).
	 */ "InvalidKey"] = "invalid-key";
    PeerErrorType[/**
	 * Lost or cannot establish a connection to the signalling server.
	 */ "Network"] = "network";
    PeerErrorType[/**
	 * The peer you're trying to connect to does not exist.
	 */ "PeerUnavailable"] = "peer-unavailable";
    PeerErrorType[/**
	 * PeerJS is being used securely, but the cloud server does not support SSL. Use a custom PeerServer.
	 */ "SslUnavailable"] = "ssl-unavailable";
    PeerErrorType[/**
	 * Unable to reach the server.
	 */ "ServerError"] = "server-error";
    PeerErrorType[/**
	 * An error from the underlying socket.
	 */ "SocketError"] = "socket-error";
    PeerErrorType[/**
	 * The underlying socket closed unexpectedly.
	 */ "SocketClosed"] = "socket-closed";
    PeerErrorType[/**
	 * The ID passed into the Peer constructor is already taken.
	 *
	 * :::caution
	 * This error is not fatal if your peer has open peer-to-peer connections.
	 * This can happen if you attempt to {@apilink Peer.reconnect} a peer that has been disconnected from the server,
	 * but its old ID has now been taken.
	 * :::
	 */ "UnavailableID"] = "unavailable-id";
    PeerErrorType[/**
	 * Native WebRTC errors.
	 */ "WebRTC"] = "webrtc";
})($478396ff7932844e$export$9547aaa2e39030ff || ($478396ff7932844e$export$9547aaa2e39030ff = {}));
var $478396ff7932844e$export$7974935686149686;
(function(BaseConnectionErrorType) {
    BaseConnectionErrorType["NegotiationFailed"] = "negotiation-failed";
    BaseConnectionErrorType["ConnectionClosed"] = "connection-closed";
})($478396ff7932844e$export$7974935686149686 || ($478396ff7932844e$export$7974935686149686 = {}));
var $478396ff7932844e$export$49ae800c114df41d;
(function(DataConnectionErrorType) {
    DataConnectionErrorType["NotOpenYet"] = "not-open-yet";
    DataConnectionErrorType["MessageToBig"] = "message-too-big";
})($478396ff7932844e$export$49ae800c114df41d || ($478396ff7932844e$export$49ae800c114df41d = {}));
var $478396ff7932844e$export$89f507cf986a947;
(function(SerializationType) {
    SerializationType["Binary"] = "binary";
    SerializationType["BinaryUTF8"] = "binary-utf8";
    SerializationType["JSON"] = "json";
    SerializationType["None"] = "raw";
})($478396ff7932844e$export$89f507cf986a947 || ($478396ff7932844e$export$89f507cf986a947 = {}));
var $478396ff7932844e$export$3b5c4a4b6354f023;
(function(SocketEventType) {
    SocketEventType["Message"] = "message";
    SocketEventType["Disconnected"] = "disconnected";
    SocketEventType["Error"] = "error";
    SocketEventType["Close"] = "close";
})($478396ff7932844e$export$3b5c4a4b6354f023 || ($478396ff7932844e$export$3b5c4a4b6354f023 = {}));
var $478396ff7932844e$export$adb4a1754da6f10d;
(function(ServerMessageType) {
    ServerMessageType["Heartbeat"] = "HEARTBEAT";
    ServerMessageType["Candidate"] = "CANDIDATE";
    ServerMessageType["Offer"] = "OFFER";
    ServerMessageType["Answer"] = "ANSWER";
    ServerMessageType["Open"] = "OPEN";
    ServerMessageType["Error"] = "ERROR";
    ServerMessageType["IdTaken"] = "ID-TAKEN";
    ServerMessageType["InvalidKey"] = "INVALID-KEY";
    ServerMessageType["Leave"] = "LEAVE";
    ServerMessageType["Expire"] = "EXPIRE";
})($478396ff7932844e$export$adb4a1754da6f10d || ($478396ff7932844e$export$adb4a1754da6f10d = {}));
var $478396ff7932844e$var$$f5f881ec4575f1fc$exports = {};
$478396ff7932844e$var$$f5f881ec4575f1fc$exports = JSON.parse('{"name":"peerjs","version":"1.5.1","keywords":["peerjs","webrtc","p2p","rtc"],"description":"PeerJS client","homepage":"https://peerjs.com","bugs":{"url":"https://github.com/peers/peerjs/issues"},"repository":{"type":"git","url":"https://github.com/peers/peerjs"},"license":"MIT","contributors":["Michelle Bu <michelle@michellebu.com>","afrokick <devbyru@gmail.com>","ericz <really.ez@gmail.com>","Jairo <kidandcat@gmail.com>","Jonas Gloning <34194370+jonasgloning@users.noreply.github.com>","Jairo Caro-Accino Viciana <jairo@galax.be>","Carlos Caballero <carlos.caballero.gonzalez@gmail.com>","hc <hheennrryy@gmail.com>","Muhammad Asif <capripio@gmail.com>","PrashoonB <prashoonbhattacharjee@gmail.com>","Harsh Bardhan Mishra <47351025+HarshCasper@users.noreply.github.com>","akotynski <aleksanderkotbury@gmail.com>","lmb <i@lmb.io>","Jairooo <jairocaro@msn.com>","Moritz St\xfcckler <moritz.stueckler@gmail.com>","Simon <crydotsnakegithub@gmail.com>","Denis Lukov <denismassters@gmail.com>","Philipp Hancke <fippo@andyet.net>","Hans Oksendahl <hansoksendahl@gmail.com>","Jess <jessachandler@gmail.com>","khankuan <khankuan@gmail.com>","DUODVK <kurmanov.work@gmail.com>","XiZhao <kwang1imsa@gmail.com>","Matthias Lohr <matthias@lohr.me>","=frank tree <=frnktrb@googlemail.com>","Andre Eckardt <aeckardt@outlook.com>","Chris Cowan <agentme49@gmail.com>","Alex Chuev <alex@chuev.com>","alxnull <alxnull@e.mail.de>","Yemel Jardi <angel.jardi@gmail.com>","Ben Parnell <benjaminparnell.94@gmail.com>","Benny Lichtner <bennlich@gmail.com>","fresheneesz <bitetrudpublic@gmail.com>","bob.barstead@exaptive.com <bob.barstead@exaptive.com>","chandika <chandika@gmail.com>","emersion <contact@emersion.fr>","Christopher Van <cvan@users.noreply.github.com>","eddieherm <edhermoso@gmail.com>","Eduardo Pinho <enet4mikeenet@gmail.com>","Evandro Zanatta <ezanatta@tray.net.br>","Gardner Bickford <gardner@users.noreply.github.com>","Gian Luca <gianluca.cecchi@cynny.com>","PatrickJS <github@gdi2290.com>","jonnyf <github@jonathanfoss.co.uk>","Hizkia Felix <hizkifw@gmail.com>","Hristo Oskov <hristo.oskov@gmail.com>","Isaac Madwed <i.madwed@gmail.com>","Ilya Konanykhin <ilya.konanykhin@gmail.com>","jasonbarry <jasbarry@me.com>","Jonathan Burke <jonathan.burke.1311@googlemail.com>","Josh Hamit <josh.hamit@gmail.com>","Jordan Austin <jrax86@gmail.com>","Joel Wetzell <jwetzell@yahoo.com>","xizhao <kevin.wang@cloudera.com>","Alberto Torres <kungfoobar@gmail.com>","Jonathan Mayol <mayoljonathan@gmail.com>","Jefferson Felix <me@jsfelix.dev>","Rolf Erik Lekang <me@rolflekang.com>","Kevin Mai-Husan Chia <mhchia@users.noreply.github.com>","Pepijn de Vos <pepijndevos@gmail.com>","JooYoung <qkdlql@naver.com>","Tobias Speicher <rootcommander@gmail.com>","Steve Blaurock <sblaurock@gmail.com>","Kyrylo Shegeda <shegeda@ualberta.ca>","Diwank Singh Tomer <singh@diwank.name>","Sören Balko <Soeren.Balko@gmail.com>","Arpit Solanki <solankiarpit1997@gmail.com>","Yuki Ito <yuki@gnnk.net>","Artur Zayats <zag2art@gmail.com>"],"funding":{"type":"opencollective","url":"https://opencollective.com/peer"},"collective":{"type":"opencollective","url":"https://opencollective.com/peer"},"files":["dist/*"],"sideEffects":["lib/global.ts","lib/supports.ts"],"main":"dist/bundler.cjs","module":"dist/bundler.mjs","browser-minified":"dist/peerjs.min.js","browser-unminified":"dist/peerjs.js","browser-minified-cbor":"dist/serializer.cbor.mjs","browser-minified-msgpack":"dist/serializer.msgpack.mjs","types":"dist/types.d.ts","engines":{"node":">= 14"},"targets":{"types":{"source":"lib/exports.ts"},"main":{"source":"lib/exports.ts","sourceMap":{"inlineSources":true}},"module":{"source":"lib/exports.ts","includeNodeModules":["eventemitter3"],"sourceMap":{"inlineSources":true}},"browser-minified":{"context":"browser","outputFormat":"global","optimize":true,"engines":{"browsers":"chrome >= 83, edge >= 83, firefox >= 80, safari >= 15"},"source":"lib/global.ts"},"browser-unminified":{"context":"browser","outputFormat":"global","optimize":false,"engines":{"browsers":"chrome >= 83, edge >= 83, firefox >= 80, safari >= 15"},"source":"lib/global.ts"},"browser-minified-cbor":{"context":"browser","outputFormat":"esmodule","isLibrary":true,"optimize":true,"engines":{"browsers":"chrome >= 83, edge >= 83, firefox >= 102, safari >= 15"},"source":"lib/dataconnection/StreamConnection/Cbor.ts"},"browser-minified-msgpack":{"context":"browser","outputFormat":"esmodule","isLibrary":true,"optimize":true,"engines":{"browsers":"chrome >= 83, edge >= 83, firefox >= 102, safari >= 15"},"source":"lib/dataconnection/StreamConnection/MsgPack.ts"}},"scripts":{"contributors":"git-authors-cli --print=false && prettier --write package.json && git add package.json package-lock.json && git commit -m \\"chore(contributors): update and sort contributors list\\"","check":"tsc --noEmit && tsc -p e2e/tsconfig.json --noEmit","watch":"parcel watch","build":"rm -rf dist && parcel build","prepublishOnly":"npm run build","test":"jest","test:watch":"jest --watch","coverage":"jest --coverage --collectCoverageFrom=\\"./lib/**\\"","format":"prettier --write .","format:check":"prettier --check .","semantic-release":"semantic-release","e2e":"wdio run e2e/wdio.local.conf.ts","e2e:bstack":"wdio run e2e/wdio.bstack.conf.ts"},"devDependencies":{"@parcel/config-default":"^2.9.3","@parcel/packager-ts":"^2.9.3","@parcel/transformer-typescript-tsc":"^2.9.3","@parcel/transformer-typescript-types":"^2.9.3","@semantic-release/changelog":"^6.0.1","@semantic-release/git":"^10.0.1","@swc/core":"^1.3.27","@swc/jest":"^0.2.24","@types/jasmine":"^4.3.4","@wdio/browserstack-service":"^8.11.2","@wdio/cli":"^8.11.2","@wdio/globals":"^8.11.2","@wdio/jasmine-framework":"^8.11.2","@wdio/local-runner":"^8.11.2","@wdio/spec-reporter":"^8.11.2","@wdio/types":"^8.10.4","http-server":"^14.1.1","jest":"^29.3.1","jest-environment-jsdom":"^29.3.1","mock-socket":"^9.0.0","parcel":"^2.9.3","prettier":"^3.0.0","semantic-release":"^21.0.0","ts-node":"^10.9.1","typescript":"^5.0.0","wdio-geckodriver-service":"^5.0.1"},"dependencies":{"@msgpack/msgpack":"^2.8.0","cbor-x":"^1.5.3","eventemitter3":"^4.0.7","peerjs-js-binarypack":"^2.0.0","webrtc-adapter":"^8.0.0"},"alias":{"process":false,"buffer":false}}');
class $478396ff7932844e$var$$8f5bfa60836d261d$export$4798917dbf149b79 extends $478396ff7932844e$var$$c4dcfd1d1ea86647$exports.EventEmitter {
    start(id, token) {
        this._id = id;
        const wsUrl = `${this._baseUrl}&id=${id}&token=${token}`;
        if (!!this._socket || !this._disconnected) return;
        this._socket = new WebSocket(wsUrl + "&version=" + $478396ff7932844e$var$$f5f881ec4575f1fc$exports.version);
        this._disconnected = false;
        this._socket.onmessage = (event)=>{
            let data;
            try {
                data = JSON.parse(event.data);
                $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Server message received:", data);
            } catch (e) {
                $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Invalid server message", event.data);
                return;
            }
            this.emit($478396ff7932844e$export$3b5c4a4b6354f023.Message, data);
        };
        this._socket.onclose = (event)=>{
            if (this._disconnected) return;
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Socket closed.", event);
            this._cleanup();
            this._disconnected = true;
            this.emit($478396ff7932844e$export$3b5c4a4b6354f023.Disconnected);
        };
        // Take care of the queue of connections if necessary and make sure Peer knows
        // socket is open.
        this._socket.onopen = ()=>{
            if (this._disconnected) return;
            this._sendQueuedMessages();
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Socket open");
            this._scheduleHeartbeat();
        };
    }
    _scheduleHeartbeat() {
        this._wsPingTimer = setTimeout(()=>{
            this._sendHeartbeat();
        }, this.pingInterval);
    }
    _sendHeartbeat() {
        if (!this._wsOpen()) {
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Cannot send heartbeat, because socket closed`);
            return;
        }
        const message = JSON.stringify({
            type: $478396ff7932844e$export$adb4a1754da6f10d.Heartbeat
        });
        this._socket.send(message);
        this._scheduleHeartbeat();
    }
    /** Is the websocket currently open? */ _wsOpen() {
        return !!this._socket && this._socket.readyState === 1;
    }
    /** Send queued messages. */ _sendQueuedMessages() {
        //Create copy of queue and clear it,
        //because send method push the message back to queue if smth will go wrong
        const copiedQueue = [
            ...this._messagesQueue
        ];
        this._messagesQueue = [];
        for (const message of copiedQueue)this.send(message);
    }
    /** Exposed send for DC & Peer. */ send(data) {
        if (this._disconnected) return;
        // If we didn't get an ID yet, we can't yet send anything so we should queue
        // up these messages.
        if (!this._id) {
            this._messagesQueue.push(data);
            return;
        }
        if (!data.type) {
            this.emit($478396ff7932844e$export$3b5c4a4b6354f023.Error, "Invalid message");
            return;
        }
        if (!this._wsOpen()) return;
        const message = JSON.stringify(data);
        this._socket.send(message);
    }
    close() {
        if (this._disconnected) return;
        this._cleanup();
        this._disconnected = true;
    }
    _cleanup() {
        if (this._socket) {
            this._socket.onopen = this._socket.onmessage = this._socket.onclose = null;
            this._socket.close();
            this._socket = undefined;
        }
        clearTimeout(this._wsPingTimer);
    }
    constructor(secure, host, port, path, key, pingInterval = 5000){
        super();
        this.pingInterval = pingInterval;
        this._disconnected = true;
        this._messagesQueue = [];
        const wsProtocol = secure ? "wss://" : "ws://";
        this._baseUrl = wsProtocol + host + ":" + port + path + "peerjs?key=" + key;
    }
}
class $478396ff7932844e$var$$b82fb8fc0514bfc1$export$89e6bb5ad64bf4a {
    /** Returns a PeerConnection object set up correctly (for data, media). */ startConnection(options) {
        const peerConnection = this._startPeerConnection();
        // Set the connection's PC.
        this.connection.peerConnection = peerConnection;
        if (this.connection.type === $478396ff7932844e$export$3157d57b4135e3bc.Media && options._stream) this._addTracksToConnection(options._stream, peerConnection);
        // What do we need to do now?
        if (options.originator) {
            const dataConnection = this.connection;
            const config = {
                ordered: !!options.reliable
            };
            const dataChannel = peerConnection.createDataChannel(dataConnection.label, config);
            dataConnection._initializeDataChannel(dataChannel);
            this._makeOffer();
        } else this.handleSDP("OFFER", options.sdp);
    }
    /** Start a PC. */ _startPeerConnection() {
        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Creating RTCPeerConnection.");
        const peerConnection = new RTCPeerConnection(this.connection.provider.options.config);
        this._setupListeners(peerConnection);
        return peerConnection;
    }
    /** Set up various WebRTC listeners. */ _setupListeners(peerConnection) {
        const peerId = this.connection.peer;
        const connectionId = this.connection.connectionId;
        const connectionType = this.connection.type;
        const provider = this.connection.provider;
        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Listening for ICE candidates.");
        peerConnection.onicecandidate = (evt)=>{
            if (!evt.candidate || !evt.candidate.candidate) return;
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Received ICE candidates for ${peerId}:`, evt.candidate);
            provider.socket.send({
                type: $478396ff7932844e$export$adb4a1754da6f10d.Candidate,
                payload: {
                    candidate: evt.candidate,
                    type: connectionType,
                    connectionId: connectionId
                },
                dst: peerId
            });
        };
        peerConnection.oniceconnectionstatechange = ()=>{
            switch(peerConnection.iceConnectionState){
                case "failed":
                    $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("iceConnectionState is failed, closing connections to " + peerId);
                    this.connection.emitError($478396ff7932844e$export$7974935686149686.NegotiationFailed, "Negotiation of connection to " + peerId + " failed.");
                    this.connection.close();
                    break;
                case "closed":
                    $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("iceConnectionState is closed, closing connections to " + peerId);
                    this.connection.emitError($478396ff7932844e$export$7974935686149686.ConnectionClosed, "Connection to " + peerId + " closed.");
                    this.connection.close();
                    break;
                case "disconnected":
                    $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("iceConnectionState changed to disconnected on the connection with " + peerId);
                    break;
                case "completed":
                    peerConnection.onicecandidate = ()=>{};
                    break;
            }
            this.connection.emit("iceStateChanged", peerConnection.iceConnectionState);
        };
        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Listening for data channel");
        // Fired between offer and answer, so options should already be saved
        // in the options hash.
        peerConnection.ondatachannel = (evt)=>{
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Received data channel");
            const dataChannel = evt.channel;
            const connection = provider.getConnection(peerId, connectionId);
            connection._initializeDataChannel(dataChannel);
        };
        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Listening for remote stream");
        peerConnection.ontrack = (evt)=>{
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Received remote stream");
            const stream = evt.streams[0];
            const connection = provider.getConnection(peerId, connectionId);
            if (connection.type === $478396ff7932844e$export$3157d57b4135e3bc.Media) {
                const mediaConnection = connection;
                this._addStreamToMediaConnection(stream, mediaConnection);
            }
        };
    }
    cleanup() {
        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Cleaning up PeerConnection to " + this.connection.peer);
        const peerConnection = this.connection.peerConnection;
        if (!peerConnection) return;
        this.connection.peerConnection = null;
        //unsubscribe from all PeerConnection's events
        peerConnection.onicecandidate = peerConnection.oniceconnectionstatechange = peerConnection.ondatachannel = peerConnection.ontrack = ()=>{};
        const peerConnectionNotClosed = peerConnection.signalingState !== "closed";
        let dataChannelNotClosed = false;
        const dataChannel = this.connection.dataChannel;
        if (dataChannel) dataChannelNotClosed = !!dataChannel.readyState && dataChannel.readyState !== "closed";
        if (peerConnectionNotClosed || dataChannelNotClosed) peerConnection.close();
    }
    async _makeOffer() {
        const peerConnection = this.connection.peerConnection;
        const provider = this.connection.provider;
        try {
            const offer = await peerConnection.createOffer(this.connection.options.constraints);
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Created offer.");
            if (this.connection.options.sdpTransform && typeof this.connection.options.sdpTransform === "function") offer.sdp = this.connection.options.sdpTransform(offer.sdp) || offer.sdp;
            try {
                await peerConnection.setLocalDescription(offer);
                $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Set localDescription:", offer, `for:${this.connection.peer}`);
                let payload = {
                    sdp: offer,
                    type: this.connection.type,
                    connectionId: this.connection.connectionId,
                    metadata: this.connection.metadata
                };
                if (this.connection.type === $478396ff7932844e$export$3157d57b4135e3bc.Data) {
                    const dataConnection = this.connection;
                    payload = {
                        ...payload,
                        label: dataConnection.label,
                        reliable: dataConnection.reliable,
                        serialization: dataConnection.serialization
                    };
                }
                provider.socket.send({
                    type: $478396ff7932844e$export$adb4a1754da6f10d.Offer,
                    payload: payload,
                    dst: this.connection.peer
                });
            } catch (err) {
                // TODO: investigate why _makeOffer is being called from the answer
                if (err != "OperationError: Failed to set local offer sdp: Called in wrong state: kHaveRemoteOffer") {
                    provider.emitError($478396ff7932844e$export$9547aaa2e39030ff.WebRTC, err);
                    $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Failed to setLocalDescription, ", err);
                }
            }
        } catch (err_1) {
            provider.emitError($478396ff7932844e$export$9547aaa2e39030ff.WebRTC, err_1);
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Failed to createOffer, ", err_1);
        }
    }
    async _makeAnswer() {
        const peerConnection = this.connection.peerConnection;
        const provider = this.connection.provider;
        try {
            const answer = await peerConnection.createAnswer();
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Created answer.");
            if (this.connection.options.sdpTransform && typeof this.connection.options.sdpTransform === "function") answer.sdp = this.connection.options.sdpTransform(answer.sdp) || answer.sdp;
            try {
                await peerConnection.setLocalDescription(answer);
                $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Set localDescription:`, answer, `for:${this.connection.peer}`);
                provider.socket.send({
                    type: $478396ff7932844e$export$adb4a1754da6f10d.Answer,
                    payload: {
                        sdp: answer,
                        type: this.connection.type,
                        connectionId: this.connection.connectionId
                    },
                    dst: this.connection.peer
                });
            } catch (err) {
                provider.emitError($478396ff7932844e$export$9547aaa2e39030ff.WebRTC, err);
                $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Failed to setLocalDescription, ", err);
            }
        } catch (err_1) {
            provider.emitError($478396ff7932844e$export$9547aaa2e39030ff.WebRTC, err_1);
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Failed to create answer, ", err_1);
        }
    }
    /** Handle an SDP. */ async handleSDP(type, sdp) {
        sdp = new RTCSessionDescription(sdp);
        const peerConnection = this.connection.peerConnection;
        const provider = this.connection.provider;
        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Setting remote description", sdp);
        const self = this;
        try {
            await peerConnection.setRemoteDescription(sdp);
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Set remoteDescription:${type} for:${this.connection.peer}`);
            if (type === "OFFER") await self._makeAnswer();
        } catch (err) {
            provider.emitError($478396ff7932844e$export$9547aaa2e39030ff.WebRTC, err);
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Failed to setRemoteDescription, ", err);
        }
    }
    /** Handle a candidate. */ async handleCandidate(ice) {
        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log(`handleCandidate:`, ice);
        try {
            await this.connection.peerConnection.addIceCandidate(ice);
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Added ICE candidate for:${this.connection.peer}`);
        } catch (err) {
            this.connection.provider.emitError($478396ff7932844e$export$9547aaa2e39030ff.WebRTC, err);
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Failed to handleCandidate, ", err);
        }
    }
    _addTracksToConnection(stream, peerConnection) {
        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log(`add tracks from stream ${stream.id} to peer connection`);
        if (!peerConnection.addTrack) return $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.error(`Your browser does't support RTCPeerConnection#addTrack. Ignored.`);
        stream.getTracks().forEach((track)=>{
            peerConnection.addTrack(track, stream);
        });
    }
    _addStreamToMediaConnection(stream, mediaConnection) {
        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log(`add stream ${stream.id} to media connection ${mediaConnection.connectionId}`);
        mediaConnection.addStream(stream);
    }
    constructor(connection){
        this.connection = connection;
    }
}
class $478396ff7932844e$var$$23779d1881157a18$export$6a678e589c8a4542 extends $478396ff7932844e$var$$c4dcfd1d1ea86647$exports.EventEmitter {
    /**
	 * Emits a typed error message.
	 *
	 * @internal
	 */ emitError(type, err) {
        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.error("Error:", err);
        // @ts-ignore
        this.emit("error", new $478396ff7932844e$export$98871882f492de82(`${type}`, err));
    }
}
class $478396ff7932844e$export$98871882f492de82 extends Error {
    /**
	 * @internal
	 */ constructor(type, err){
        if (typeof err === "string") super(err);
        else {
            super();
            Object.assign(this, err);
        }
        this.type = type;
    }
}
class $478396ff7932844e$var$$5045192fc6d387ba$export$23a2a68283c24d80 extends $478396ff7932844e$var$$23779d1881157a18$export$6a678e589c8a4542 {
    /**
	 * Whether the media connection is active (e.g. your call has been answered).
	 * You can check this if you want to set a maximum wait time for a one-sided call.
	 */ get open() {
        return this._open;
    }
    constructor(peer, provider, options){
        super();
        this.peer = peer;
        this.provider = provider;
        this.options = options;
        this._open = false;
        this.metadata = options.metadata;
    }
}
class $478396ff7932844e$var$$5c1d08c7c57da9a3$export$4a84e95a2324ac29 extends $478396ff7932844e$var$$5045192fc6d387ba$export$23a2a68283c24d80 {
    /**
	 * For media connections, this is always 'media'.
	 */ get type() {
        return $478396ff7932844e$export$3157d57b4135e3bc.Media;
    }
    get localStream() {
        return this._localStream;
    }
    get remoteStream() {
        return this._remoteStream;
    }
    /** Called by the Negotiator when the DataChannel is ready. */ _initializeDataChannel(dc) {
        this.dataChannel = dc;
        this.dataChannel.onopen = ()=>{
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log(`DC#${this.connectionId} dc connection success`);
            this.emit("willCloseOnRemote");
        };
        this.dataChannel.onclose = ()=>{
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log(`DC#${this.connectionId} dc closed for:`, this.peer);
            this.close();
        };
    }
    addStream(remoteStream) {
        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log("Receiving stream", remoteStream);
        this._remoteStream = remoteStream;
        super.emit("stream", remoteStream); // Should we call this `open`?
    }
    /**
	 * @internal
	 */ handleMessage(message) {
        const type = message.type;
        const payload = message.payload;
        switch(message.type){
            case $478396ff7932844e$export$adb4a1754da6f10d.Answer:
                this._negotiator.handleSDP(type, payload.sdp);
                this._open = true;
                break;
            case $478396ff7932844e$export$adb4a1754da6f10d.Candidate:
                this._negotiator.handleCandidate(payload.candidate);
                break;
            default:
                $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.warn(`Unrecognized message type:${type} from peer:${this.peer}`);
                break;
        }
    }
    /**
     * When receiving a {@apilink PeerEvents | `call`} event on a peer, you can call
     * `answer` on the media connection provided by the callback to accept the call
     * and optionally send your own media stream.

     *
     * @param stream A WebRTC media stream.
     * @param options
     * @returns
     */ answer(stream, options = {}) {
        if (this._localStream) {
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.warn("Local stream already exists on this MediaConnection. Are you answering a call twice?");
            return;
        }
        this._localStream = stream;
        if (options && options.sdpTransform) this.options.sdpTransform = options.sdpTransform;
        this._negotiator.startConnection({
            ...this.options._payload,
            _stream: stream
        });
        // Retrieve lost messages stored because PeerConnection not set up.
        const messages = this.provider._getMessages(this.connectionId);
        for (const message of messages)this.handleMessage(message);
        this._open = true;
    }
    /**
	 * Exposed functionality for users.
	 */ /**
	 * Closes the media connection.
	 */ close() {
        if (this._negotiator) {
            this._negotiator.cleanup();
            this._negotiator = null;
        }
        this._localStream = null;
        this._remoteStream = null;
        if (this.provider) {
            this.provider._removeConnection(this);
            this.provider = null;
        }
        if (this.options && this.options._stream) this.options._stream = null;
        if (!this.open) return;
        this._open = false;
        super.emit("close");
    }
    constructor(peerId, provider, options){
        super(peerId, provider, options);
        this._localStream = this.options._stream;
        this.connectionId = this.options.connectionId || $478396ff7932844e$var$$5c1d08c7c57da9a3$export$4a84e95a2324ac29.ID_PREFIX + $478396ff7932844e$export$7debb50ef11d5e0b.randomToken();
        this._negotiator = new $478396ff7932844e$var$$b82fb8fc0514bfc1$export$89e6bb5ad64bf4a(this);
        if (this._localStream) this._negotiator.startConnection({
            _stream: this._localStream,
            originator: true
        });
    }
}
var $478396ff7932844e$var$__ = {
    writable: true,
    value: (()=>{
        $478396ff7932844e$var$$5c1d08c7c57da9a3$export$4a84e95a2324ac29.ID_PREFIX = "mc_";
    })()
};
class $478396ff7932844e$var$$abf266641927cd89$export$2c4e825dc9120f87 {
    _buildRequest(method) {
        const protocol = this._options.secure ? "https" : "http";
        const { host: host, port: port, path: path, key: key } = this._options;
        const url = new URL(`${protocol}://${host}:${port}${path}${key}/${method}`);
        // TODO: Why timestamp, why random?
        url.searchParams.set("ts", `${Date.now()}${Math.random()}`);
        url.searchParams.set("version", $478396ff7932844e$var$$f5f881ec4575f1fc$exports.version);
        return fetch(url.href, {
            referrerPolicy: this._options.referrerPolicy
        });
    }
    /** Get a unique ID from the server via XHR and initialize with it. */ async retrieveId() {
        try {
            const response = await this._buildRequest("id");
            if (response.status !== 200) throw new Error(`Error. Status:${response.status}`);
            return response.text();
        } catch (error) {
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.error("Error retrieving ID", error);
            let pathError = "";
            if (this._options.path === "/" && this._options.host !== $478396ff7932844e$export$7debb50ef11d5e0b.CLOUD_HOST) pathError = " If you passed in a `path` to your self-hosted PeerServer, you'll also need to pass in that same path when creating a new Peer.";
            throw new Error("Could not get an ID from the server." + pathError);
        }
    }
    /** @deprecated */ async listAllPeers() {
        try {
            const response = await this._buildRequest("peers");
            if (response.status !== 200) {
                if (response.status === 401) {
                    let helpfulError = "";
                    if (this._options.host === $478396ff7932844e$export$7debb50ef11d5e0b.CLOUD_HOST) helpfulError = "It looks like you're using the cloud server. You can email team@peerjs.com to enable peer listing for your API key.";
                    else helpfulError = "You need to enable `allow_discovery` on your self-hosted PeerServer to use this feature.";
                    throw new Error("It doesn't look like you have permission to list peers IDs. " + helpfulError);
                }
                throw new Error(`Error. Status:${response.status}`);
            }
            return response.json();
        } catch (error) {
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.error("Error retrieving list peers", error);
            throw new Error("Could not get list peers from the server." + error);
        }
    }
    constructor(_options){
        this._options = _options;
    }
}
class $478396ff7932844e$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9 extends $478396ff7932844e$var$$5045192fc6d387ba$export$23a2a68283c24d80 {
    get type() {
        return $478396ff7932844e$export$3157d57b4135e3bc.Data;
    }
    /** Called by the Negotiator when the DataChannel is ready. */ _initializeDataChannel(dc) {
        this.dataChannel = dc;
        this.dataChannel.onopen = ()=>{
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log(`DC#${this.connectionId} dc connection success`);
            this._open = true;
            this.emit("open");
        };
        this.dataChannel.onmessage = (e)=>{
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log(`DC#${this.connectionId} dc onmessage:`, e.data);
        // this._handleDataMessage(e);
        };
        this.dataChannel.onclose = ()=>{
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log(`DC#${this.connectionId} dc closed for:`, this.peer);
            this.close();
        };
    }
    /**
	 * Exposed functionality for users.
	 */ /** Allows user to close connection. */ close(options) {
        if (options === null || options === void 0 ? void 0 : options.flush) {
            this.send({
                __peerData: {
                    type: "close"
                }
            });
            return;
        }
        if (this._negotiator) {
            this._negotiator.cleanup();
            this._negotiator = null;
        }
        if (this.provider) {
            this.provider._removeConnection(this);
            this.provider = null;
        }
        if (this.dataChannel) {
            this.dataChannel.onopen = null;
            this.dataChannel.onmessage = null;
            this.dataChannel.onclose = null;
            this.dataChannel = null;
        }
        if (!this.open) return;
        this._open = false;
        super.emit("close");
    }
    /** Allows user to send data. */ send(data, chunked = false) {
        if (!this.open) {
            this.emitError($478396ff7932844e$export$49ae800c114df41d.NotOpenYet, "Connection is not open. You should listen for the `open` event before sending messages.");
            return;
        }
        return this._send(data, chunked);
    }
    async handleMessage(message) {
        const payload = message.payload;
        switch(message.type){
            case $478396ff7932844e$export$adb4a1754da6f10d.Answer:
                await this._negotiator.handleSDP(message.type, payload.sdp);
                break;
            case $478396ff7932844e$export$adb4a1754da6f10d.Candidate:
                await this._negotiator.handleCandidate(payload.candidate);
                break;
            default:
                $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.warn("Unrecognized message type:", message.type, "from peer:", this.peer);
                break;
        }
    }
    constructor(peerId, provider, options){
        super(peerId, provider, options);
        this.connectionId = this.options.connectionId || $478396ff7932844e$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9.ID_PREFIX + $478396ff7932844e$var$$0e5fd1585784c252$export$4e61f672936bec77();
        this.label = this.options.label || this.connectionId;
        this.reliable = !!this.options.reliable;
        this._negotiator = new $478396ff7932844e$var$$b82fb8fc0514bfc1$export$89e6bb5ad64bf4a(this);
        this._negotiator.startConnection(this.options._payload || {
            originator: true,
            reliable: this.reliable
        });
    }
}
var $478396ff7932844e$var$__1 = {
    writable: true,
    value: (()=>{
        $478396ff7932844e$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9.ID_PREFIX = "dc_";
    })()
};
var $478396ff7932844e$var$__11 = {
    writable: true,
    value: (()=>{
        $478396ff7932844e$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9.MAX_BUFFERED_AMOUNT = 8388608;
    })()
};
class $478396ff7932844e$export$ff7c9d4c11d94e8b extends $478396ff7932844e$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9 {
    get bufferSize() {
        return this._bufferSize;
    }
    _initializeDataChannel(dc) {
        super._initializeDataChannel(dc);
        this.dataChannel.binaryType = "arraybuffer";
        this.dataChannel.addEventListener("message", (e)=>this._handleDataMessage(e));
    }
    _bufferedSend(msg) {
        if (this._buffering || !this._trySend(msg)) {
            this._buffer.push(msg);
            this._bufferSize = this._buffer.length;
        }
    }
    // Returns true if the send succeeds.
    _trySend(msg) {
        if (!this.open) return false;
        if (this.dataChannel.bufferedAmount > $478396ff7932844e$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9.MAX_BUFFERED_AMOUNT) {
            this._buffering = true;
            setTimeout(()=>{
                this._buffering = false;
                this._tryBuffer();
            }, 50);
            return false;
        }
        try {
            this.dataChannel.send(msg);
        } catch (e) {
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.error(`DC#:${this.connectionId} Error when sending:`, e);
            this._buffering = true;
            this.close();
            return false;
        }
        return true;
    }
    // Try to send the first message in the buffer.
    _tryBuffer() {
        if (!this.open) return;
        if (this._buffer.length === 0) return;
        const msg = this._buffer[0];
        if (this._trySend(msg)) {
            this._buffer.shift();
            this._bufferSize = this._buffer.length;
            this._tryBuffer();
        }
    }
    close(options) {
        if (options === null || options === void 0 ? void 0 : options.flush) {
            this.send({
                __peerData: {
                    type: "close"
                }
            });
            return;
        }
        this._buffer = [];
        this._bufferSize = 0;
        super.close();
    }
    constructor(...args){
        super(...args);
        this._buffer = [];
        this._bufferSize = 0;
        this._buffering = false;
    }
}
class $478396ff7932844e$var$$9fcfddb3ae148f88$export$f0a5a64d5bb37108 extends $478396ff7932844e$export$ff7c9d4c11d94e8b {
    close(options) {
        super.close(options);
        this._chunkedData = {};
    }
    // Handles a DataChannel message.
    _handleDataMessage({ data: data }) {
        const deserializedData = (0, $d9b1b8e8a2890313$export$417857010dc9287f)(data);
        // PeerJS specific message
        const peerData = deserializedData["__peerData"];
        if (peerData) {
            if (peerData.type === "close") {
                this.close();
                return;
            }
            // Chunked data -- piece things back together.
            // @ts-ignore
            this._handleChunk(deserializedData);
            return;
        }
        this.emit("data", deserializedData);
    }
    _handleChunk(data) {
        const id = data.__peerData;
        const chunkInfo = this._chunkedData[id] || {
            data: [],
            count: 0,
            total: data.total
        };
        chunkInfo.data[data.n] = new Uint8Array(data.data);
        chunkInfo.count++;
        this._chunkedData[id] = chunkInfo;
        if (chunkInfo.total === chunkInfo.count) {
            // Clean up before making the recursive call to `_handleDataMessage`.
            delete this._chunkedData[id];
            // We've received all the chunks--time to construct the complete data.
            // const data = new Blob(chunkInfo.data);
            const data = $478396ff7932844e$var$$fcbcc7538a6776d5$export$52c89ebcdc4f53f2(chunkInfo.data);
            this._handleDataMessage({
                data: data
            });
        }
    }
    _send(data, chunked) {
        if (data instanceof Blob) return data.arrayBuffer().then((buffer)=>{
            this._send(buffer, chunked);
        });
        const blob = (0, $d9b1b8e8a2890313$export$2a703dbb0cb35339)(data);
        if (!chunked && blob.byteLength > this.chunker.chunkedMTU) {
            this._sendChunks(blob);
            return;
        }
        this._bufferedSend(blob);
    }
    _sendChunks(blob) {
        const blobs = this.chunker.chunk(blob);
        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log(`DC#${this.connectionId} Try to send ${blobs.length} chunks...`);
        for (const blob of blobs)this.send(blob, true);
    }
    constructor(peerId, provider, options){
        super(peerId, provider, options);
        this.chunker = new $478396ff7932844e$var$$fcbcc7538a6776d5$export$f1c5f4c9cb95390b();
        this.serialization = $478396ff7932844e$export$89f507cf986a947.Binary;
        this._chunkedData = {};
    }
}
class $478396ff7932844e$var$$bbaee3f15f714663$export$6f88fe47d32c9c94 extends $478396ff7932844e$export$ff7c9d4c11d94e8b {
    _handleDataMessage({ data: data }) {
        super.emit("data", data);
    }
    _send(data, _chunked) {
        this._bufferedSend(data);
    }
    constructor(...args){
        super(...args);
        this.serialization = $478396ff7932844e$export$89f507cf986a947.None;
    }
}
class $478396ff7932844e$var$$817f931e3f9096cf$export$48880ac635f47186 extends $478396ff7932844e$export$ff7c9d4c11d94e8b {
    // Handles a DataChannel message.
    _handleDataMessage({ data: data }) {
        const deserializedData = this.parse(this.decoder.decode(data));
        // PeerJS specific message
        const peerData = deserializedData["__peerData"];
        if (peerData && peerData.type === "close") {
            this.close();
            return;
        }
        this.emit("data", deserializedData);
    }
    _send(data, _chunked) {
        const encodedData = this.encoder.encode(this.stringify(data));
        if (encodedData.byteLength >= $478396ff7932844e$export$7debb50ef11d5e0b.chunkedMTU) {
            this.emitError($478396ff7932844e$export$49ae800c114df41d.MessageToBig, "Message too big for JSON channel");
            return;
        }
        this._bufferedSend(encodedData);
    }
    constructor(...args){
        super(...args);
        this.serialization = $478396ff7932844e$export$89f507cf986a947.JSON;
        this.encoder = new TextEncoder();
        this.decoder = new TextDecoder();
        this.stringify = JSON.stringify;
        this.parse = JSON.parse;
    }
}
class $478396ff7932844e$var$$416260bce337df90$var$PeerOptions {
}
class $478396ff7932844e$export$ecd1fc136c422448 extends $478396ff7932844e$var$$23779d1881157a18$export$6a678e589c8a4542 {
    /**
	 * The brokering ID of this peer
	 *
	 * If no ID was specified in {@apilink Peer | the constructor},
	 * this will be `undefined` until the {@apilink PeerEvents | `open`} event is emitted.
	 */ get id() {
        return this._id;
    }
    get options() {
        return this._options;
    }
    get open() {
        return this._open;
    }
    /**
	 * @internal
	 */ get socket() {
        return this._socket;
    }
    /**
	 * A hash of all connections associated with this peer, keyed by the remote peer's ID.
	 * @deprecated
	 * Return type will change from Object to Map<string,[]>
	 */ get connections() {
        const plainConnections = Object.create(null);
        for (const [k, v] of this._connections)plainConnections[k] = v;
        return plainConnections;
    }
    /**
	 * true if this peer and all of its connections can no longer be used.
	 */ get destroyed() {
        return this._destroyed;
    }
    /**
	 * false if there is an active connection to the PeerServer.
	 */ get disconnected() {
        return this._disconnected;
    }
    _createServerConnection() {
        const socket = new $478396ff7932844e$var$$8f5bfa60836d261d$export$4798917dbf149b79(this._options.secure, this._options.host, this._options.port, this._options.path, this._options.key, this._options.pingInterval);
        socket.on($478396ff7932844e$export$3b5c4a4b6354f023.Message, (data)=>{
            this._handleMessage(data);
        });
        socket.on($478396ff7932844e$export$3b5c4a4b6354f023.Error, (error)=>{
            this._abort($478396ff7932844e$export$9547aaa2e39030ff.SocketError, error);
        });
        socket.on($478396ff7932844e$export$3b5c4a4b6354f023.Disconnected, ()=>{
            if (this.disconnected) return;
            this.emitError($478396ff7932844e$export$9547aaa2e39030ff.Network, "Lost connection to server.");
            this.disconnect();
        });
        socket.on($478396ff7932844e$export$3b5c4a4b6354f023.Close, ()=>{
            if (this.disconnected) return;
            this._abort($478396ff7932844e$export$9547aaa2e39030ff.SocketClosed, "Underlying socket is already closed.");
        });
        return socket;
    }
    /** Initialize a connection with the server. */ _initialize(id) {
        this._id = id;
        this.socket.start(id, this._options.token);
    }
    /** Handles messages from the server. */ _handleMessage(message) {
        const type = message.type;
        const payload = message.payload;
        const peerId = message.src;
        switch(type){
            case $478396ff7932844e$export$adb4a1754da6f10d.Open:
                this._lastServerId = this.id;
                this._open = true;
                this.emit("open", this.id);
                break;
            case $478396ff7932844e$export$adb4a1754da6f10d.Error:
                this._abort($478396ff7932844e$export$9547aaa2e39030ff.ServerError, payload.msg);
                break;
            case $478396ff7932844e$export$adb4a1754da6f10d.IdTaken:
                this._abort($478396ff7932844e$export$9547aaa2e39030ff.UnavailableID, `ID "${this.id}" is taken`);
                break;
            case $478396ff7932844e$export$adb4a1754da6f10d.InvalidKey:
                this._abort($478396ff7932844e$export$9547aaa2e39030ff.InvalidKey, `API KEY "${this._options.key}" is invalid`);
                break;
            case $478396ff7932844e$export$adb4a1754da6f10d.Leave:
                $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Received leave message from ${peerId}`);
                this._cleanupPeer(peerId);
                this._connections.delete(peerId);
                break;
            case $478396ff7932844e$export$adb4a1754da6f10d.Expire:
                this.emitError($478396ff7932844e$export$9547aaa2e39030ff.PeerUnavailable, `Could not connect to peer ${peerId}`);
                break;
            case $478396ff7932844e$export$adb4a1754da6f10d.Offer:
                {
                    // we should consider switching this to CALL/CONNECT, but this is the least breaking option.
                    const connectionId = payload.connectionId;
                    let connection = this.getConnection(peerId, connectionId);
                    if (connection) {
                        connection.close();
                        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.warn(`Offer received for existing Connection ID:${connectionId}`);
                    }
                    // Create a new connection.
                    if (payload.type === $478396ff7932844e$export$3157d57b4135e3bc.Media) {
                        const mediaConnection = new $478396ff7932844e$var$$5c1d08c7c57da9a3$export$4a84e95a2324ac29(peerId, this, {
                            connectionId: connectionId,
                            _payload: payload,
                            metadata: payload.metadata
                        });
                        connection = mediaConnection;
                        this._addConnection(peerId, connection);
                        this.emit("call", mediaConnection);
                    } else if (payload.type === $478396ff7932844e$export$3157d57b4135e3bc.Data) {
                        const dataConnection = new this._serializers[payload.serialization](peerId, this, {
                            connectionId: connectionId,
                            _payload: payload,
                            metadata: payload.metadata,
                            label: payload.label,
                            serialization: payload.serialization,
                            reliable: payload.reliable
                        });
                        connection = dataConnection;
                        this._addConnection(peerId, connection);
                        this.emit("connection", dataConnection);
                    } else {
                        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.warn(`Received malformed connection type:${payload.type}`);
                        return;
                    }
                    // Find messages.
                    const messages = this._getMessages(connectionId);
                    for (const message of messages)connection.handleMessage(message);
                    break;
                }
            default:
                {
                    if (!payload) {
                        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.warn(`You received a malformed message from ${peerId} of type ${type}`);
                        return;
                    }
                    const connectionId = payload.connectionId;
                    const connection = this.getConnection(peerId, connectionId);
                    if (connection && connection.peerConnection) connection.handleMessage(message);
                    else if (connectionId) this._storeMessage(connectionId, message);
                    else $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.warn("You received an unrecognized message:", message);
                    break;
                }
        }
    }
    /** Stores messages without a set up connection, to be claimed later. */ _storeMessage(connectionId, message) {
        if (!this._lostMessages.has(connectionId)) this._lostMessages.set(connectionId, []);
        this._lostMessages.get(connectionId).push(message);
    }
    /**
	 * Retrieve messages from lost message store
	 * @internal
	 */ //TODO Change it to private
    _getMessages(connectionId) {
        const messages = this._lostMessages.get(connectionId);
        if (messages) {
            this._lostMessages.delete(connectionId);
            return messages;
        }
        return [];
    }
    /**
	 * Connects to the remote peer specified by id and returns a data connection.
	 * @param peer The brokering ID of the remote peer (their {@apilink Peer.id}).
	 * @param options for specifying details about Peer Connection
	 */ connect(peer, options = {}) {
        options = {
            serialization: "default",
            ...options
        };
        if (this.disconnected) {
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.warn("You cannot connect to a new Peer because you called .disconnect() on this Peer and ended your connection with the server. You can create a new Peer to reconnect, or call reconnect on this peer if you believe its ID to still be available.");
            this.emitError($478396ff7932844e$export$9547aaa2e39030ff.Disconnected, "Cannot connect to new Peer after disconnecting from server.");
            return;
        }
        const dataConnection = new this._serializers[options.serialization](peer, this, options);
        this._addConnection(peer, dataConnection);
        return dataConnection;
    }
    /**
	 * Calls the remote peer specified by id and returns a media connection.
	 * @param peer The brokering ID of the remote peer (their peer.id).
	 * @param stream The caller's media stream
	 * @param options Metadata associated with the connection, passed in by whoever initiated the connection.
	 */ call(peer, stream, options = {}) {
        if (this.disconnected) {
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.warn("You cannot connect to a new Peer because you called .disconnect() on this Peer and ended your connection with the server. You can create a new Peer to reconnect.");
            this.emitError($478396ff7932844e$export$9547aaa2e39030ff.Disconnected, "Cannot connect to new Peer after disconnecting from server.");
            return;
        }
        if (!stream) {
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.error("To call a peer, you must provide a stream from your browser's `getUserMedia`.");
            return;
        }
        const mediaConnection = new $478396ff7932844e$var$$5c1d08c7c57da9a3$export$4a84e95a2324ac29(peer, this, {
            ...options,
            _stream: stream
        });
        this._addConnection(peer, mediaConnection);
        return mediaConnection;
    }
    /** Add a data/media connection to this peer. */ _addConnection(peerId, connection) {
        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log(`add connection ${connection.type}:${connection.connectionId} to peerId:${peerId}`);
        if (!this._connections.has(peerId)) this._connections.set(peerId, []);
        this._connections.get(peerId).push(connection);
    }
    //TODO should be private
    _removeConnection(connection) {
        const connections = this._connections.get(connection.peer);
        if (connections) {
            const index = connections.indexOf(connection);
            if (index !== -1) connections.splice(index, 1);
        }
        //remove from lost messages
        this._lostMessages.delete(connection.connectionId);
    }
    /** Retrieve a data/media connection for this peer. */ getConnection(peerId, connectionId) {
        const connections = this._connections.get(peerId);
        if (!connections) return null;
        for (const connection of connections){
            if (connection.connectionId === connectionId) return connection;
        }
        return null;
    }
    _delayedAbort(type, message) {
        setTimeout(()=>{
            this._abort(type, message);
        }, 0);
    }
    /**
	 * Emits an error message and destroys the Peer.
	 * The Peer is not destroyed if it's in a disconnected state, in which case
	 * it retains its disconnected state and its existing connections.
	 */ _abort(type, message) {
        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.error("Aborting!");
        this.emitError(type, message);
        if (!this._lastServerId) this.destroy();
        else this.disconnect();
    }
    /**
	 * Destroys the Peer: closes all active connections as well as the connection
	 * to the server.
	 *
	 * :::caution
	 * This cannot be undone; the respective peer object will no longer be able
	 * to create or receive any connections, its ID will be forfeited on the server,
	 * and all of its data and media connections will be closed.
	 * :::
	 */ destroy() {
        if (this.destroyed) return;
        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Destroy peer with ID:${this.id}`);
        this.disconnect();
        this._cleanup();
        this._destroyed = true;
        this.emit("close");
    }
    /** Disconnects every connection on this peer. */ _cleanup() {
        for (const peerId of this._connections.keys()){
            this._cleanupPeer(peerId);
            this._connections.delete(peerId);
        }
        this.socket.removeAllListeners();
    }
    /** Closes all connections to this peer. */ _cleanupPeer(peerId) {
        const connections = this._connections.get(peerId);
        if (!connections) return;
        for (const connection of connections)connection.close();
    }
    /**
	 * Disconnects the Peer's connection to the PeerServer. Does not close any
	 *  active connections.
	 * Warning: The peer can no longer create or accept connections after being
	 *  disconnected. It also cannot reconnect to the server.
	 */ disconnect() {
        if (this.disconnected) return;
        const currentId = this.id;
        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Disconnect peer with ID:${currentId}`);
        this._disconnected = true;
        this._open = false;
        this.socket.close();
        this._lastServerId = currentId;
        this._id = null;
        this.emit("disconnected", currentId);
    }
    /** Attempts to reconnect with the same ID.
	 *
	 * Only {@apilink Peer.disconnect | disconnected peers} can be reconnected.
	 * Destroyed peers cannot be reconnected.
	 * If the connection fails (as an example, if the peer's old ID is now taken),
	 * the peer's existing connections will not close, but any associated errors events will fire.
	 */ reconnect() {
        if (this.disconnected && !this.destroyed) {
            $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.log(`Attempting reconnection to server with ID ${this._lastServerId}`);
            this._disconnected = false;
            this._initialize(this._lastServerId);
        } else if (this.destroyed) throw new Error("This peer cannot reconnect to the server. It has already been destroyed.");
        else if (!this.disconnected && !this.open) $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.error("In a hurry? We're still trying to make the initial connection!");
        else throw new Error(`Peer ${this.id} cannot reconnect because it is not disconnected from the server!`);
    }
    /**
	 * Get a list of available peer IDs. If you're running your own server, you'll
	 * want to set allow_discovery: true in the PeerServer options. If you're using
	 * the cloud server, email team@peerjs.com to get the functionality enabled for
	 * your key.
	 */ listAllPeers(cb = (_)=>{}) {
        this._api.listAllPeers().then((peers)=>cb(peers)).catch((error)=>this._abort($478396ff7932844e$export$9547aaa2e39030ff.ServerError, error));
    }
    constructor(id, options){
        super();
        this._serializers = {
            raw: $478396ff7932844e$var$$bbaee3f15f714663$export$6f88fe47d32c9c94,
            json: $478396ff7932844e$var$$817f931e3f9096cf$export$48880ac635f47186,
            binary: $478396ff7932844e$var$$9fcfddb3ae148f88$export$f0a5a64d5bb37108,
            "binary-utf8": $478396ff7932844e$var$$9fcfddb3ae148f88$export$f0a5a64d5bb37108,
            default: $478396ff7932844e$var$$9fcfddb3ae148f88$export$f0a5a64d5bb37108
        };
        this._id = null;
        this._lastServerId = null;
        // States.
        this._destroyed = false // Connections have been killed
        ;
        this._disconnected = false // Connection to PeerServer killed but P2P connections still active
        ;
        this._open = false // Sockets and such are not yet open.
        ;
        this._connections = new Map() // All connections for this peer.
        ;
        this._lostMessages = new Map() // src => [list of messages]
        ;
        let userId;
        // Deal with overloading
        if (id && id.constructor == Object) options = id;
        else if (id) userId = id.toString();
        // Configurize options
        options = {
            debug: 0,
            host: $478396ff7932844e$export$7debb50ef11d5e0b.CLOUD_HOST,
            port: $478396ff7932844e$export$7debb50ef11d5e0b.CLOUD_PORT,
            path: "/",
            key: $478396ff7932844e$export$ecd1fc136c422448.DEFAULT_KEY,
            token: $478396ff7932844e$export$7debb50ef11d5e0b.randomToken(),
            config: $478396ff7932844e$export$7debb50ef11d5e0b.defaultConfig,
            referrerPolicy: "strict-origin-when-cross-origin",
            serializers: {},
            ...options
        };
        this._options = options;
        this._serializers = {
            ...this._serializers,
            ...this.options.serializers
        };
        // Detect relative URL host.
        if (this._options.host === "/") this._options.host = window.location.hostname;
        // Set path correctly.
        if (this._options.path) {
            if (this._options.path[0] !== "/") this._options.path = "/" + this._options.path;
            if (this._options.path[this._options.path.length - 1] !== "/") this._options.path += "/";
        }
        // Set whether we use SSL to same as current host
        if (this._options.secure === undefined && this._options.host !== $478396ff7932844e$export$7debb50ef11d5e0b.CLOUD_HOST) this._options.secure = $478396ff7932844e$export$7debb50ef11d5e0b.isSecure();
        else if (this._options.host == $478396ff7932844e$export$7debb50ef11d5e0b.CLOUD_HOST) this._options.secure = true;
        // Set a custom log function if present
        if (this._options.logFunction) $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.setLogFunction(this._options.logFunction);
        $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.logLevel = this._options.debug || 0;
        this._api = new $478396ff7932844e$var$$abf266641927cd89$export$2c4e825dc9120f87(options);
        this._socket = this._createServerConnection();
        // Sanity checks
        // Ensure WebRTC supported
        if (!$478396ff7932844e$export$7debb50ef11d5e0b.supports.audioVideo && !$478396ff7932844e$export$7debb50ef11d5e0b.supports.data) {
            this._delayedAbort($478396ff7932844e$export$9547aaa2e39030ff.BrowserIncompatible, "The current browser does not support WebRTC");
            return;
        }
        // Ensure alphanumeric id
        if (!!userId && !$478396ff7932844e$export$7debb50ef11d5e0b.validateId(userId)) {
            this._delayedAbort($478396ff7932844e$export$9547aaa2e39030ff.InvalidID, `ID "${userId}" is invalid`);
            return;
        }
        if (userId) this._initialize(userId);
        else this._api.retrieveId().then((id)=>this._initialize(id)).catch((error)=>this._abort($478396ff7932844e$export$9547aaa2e39030ff.ServerError, error));
    }
}
var $478396ff7932844e$var$__2 = {
    writable: true,
    value: (()=>{
        $478396ff7932844e$export$ecd1fc136c422448.DEFAULT_KEY = "peerjs";
    })()
};
class $478396ff7932844e$export$72aa44612e2200cd extends $478396ff7932844e$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9 {
    _initializeDataChannel(dc) {
        super._initializeDataChannel(dc);
        this.dataChannel.binaryType = "arraybuffer";
        this.dataChannel.bufferedAmountLowThreshold = $478396ff7932844e$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9.MAX_BUFFERED_AMOUNT / 2;
    }
    constructor(peerId, provider, options){
        super(peerId, provider, {
            ...options,
            reliable: true
        });
        this._CHUNK_SIZE = 32768;
        this._splitStream = new TransformStream({
            transform: (chunk, controller)=>{
                for(let split = 0; split < chunk.length; split += this._CHUNK_SIZE)controller.enqueue(chunk.subarray(split, split + this._CHUNK_SIZE));
            }
        });
        this._rawSendStream = new WritableStream({
            write: async (chunk, controller)=>{
                const openEvent = new Promise((resolve)=>this.dataChannel.addEventListener("bufferedamountlow", resolve, {
                        once: true
                    }));
                // if we can send the chunk now, send it
                // if not, we wait until at least half of the sending buffer is free again
                await (this.dataChannel.bufferedAmount <= $478396ff7932844e$var$$6366c4ca161bc297$export$d365f7ad9d7df9c9.MAX_BUFFERED_AMOUNT - chunk.byteLength || openEvent);
                // TODO: what can go wrong here?
                try {
                    this.dataChannel.send(chunk);
                } catch (e) {
                    $478396ff7932844e$var$$257947e92926277a$export$2e2bcd8739ae039.error(`DC#:${this.connectionId} Error when sending:`, e);
                    controller.error(e);
                    this.close();
                }
            }
        });
        this.writer = this._splitStream.writable.getWriter();
        this._rawReadStream = new ReadableStream({
            start: (controller)=>{
                this.once("open", ()=>{
                    this.dataChannel.addEventListener("message", (e)=>{
                        controller.enqueue(e.data);
                    });
                });
            }
        });
        this._splitStream.readable.pipeTo(this._rawSendStream);
    }
}
const $478396ff7932844e$var$$dcf98445f54823f4$var$NullValue = Symbol.for(null);
function $478396ff7932844e$var$$dcf98445f54823f4$var$concatUint8Array(buffer1, buffer2) {
    const tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
    tmp.set(buffer1, 0);
    tmp.set(buffer2, buffer1.byteLength);
    return new Uint8Array(tmp.buffer);
}
const $478396ff7932844e$var$$dcf98445f54823f4$var$iterateOver = async function*(stream) {
    const reader = stream.getReader();
    try {
        while(true){
            const { done: done, value: value } = await reader.read();
            if (done) return;
            yield value;
        }
    } finally{
        reader.releaseLock();
    }
};
class $478396ff7932844e$export$7e9583c3c8a0a2cc extends $478396ff7932844e$export$72aa44612e2200cd {
    _send(data) {
        return this.writer.write(this._encoder.encode(data));
    }
    constructor(peerId, provider, options){
        super(peerId, provider, {
            ...options,
            reliable: true
        });
        this.serialization = "Cbor";
        this._encoder = new (0, $1213990bd941e1f8$export$a50aceb0e02a00aa)();
        this._decoder = new (0, $f3f604935c83ab88$export$f9de6ca0bc043724)();
        this._decoderStream = new TransformStream({
            transform: (abchunk, controller)=>{
                let chunk = new Uint8Array(abchunk);
                if (this._inc) {
                    chunk = $478396ff7932844e$var$$dcf98445f54823f4$var$concatUint8Array(this._inc, chunk);
                    this._inc = null;
                }
                let values;
                try {
                    values = this._decoder.decodeMultiple(chunk);
                } catch (error) {
                    if (error.incomplete) {
                        this._inc = chunk.subarray(error.lastPosition);
                        values = error.values;
                    } else throw error;
                } finally{
                    for (let value of values || []){
                        if (value === null) value = $478396ff7932844e$var$$dcf98445f54823f4$var$NullValue;
                        controller.enqueue(value);
                    }
                }
            }
        });
        this._rawReadStream.pipeTo(this._decoderStream.writable);
        (async ()=>{
            for await (const msg of $478396ff7932844e$var$$dcf98445f54823f4$var$iterateOver(this._decoderStream.readable)){
                var _msg___peerData;
                if (((_msg___peerData = msg.__peerData) === null || _msg___peerData === void 0 ? void 0 : _msg___peerData.type) === "close") {
                    this.close();
                    return;
                }
                this.emit("data", msg);
            }
        })();
    }
}
class $478396ff7932844e$export$f6a74c7ffa2903e6 extends $478396ff7932844e$export$ecd1fc136c422448 {
    constructor(...args){
        super(...args);
        this._serializers = {
            Cbor: $478396ff7932844e$export$7e9583c3c8a0a2cc,
            default: $478396ff7932844e$export$7e9583c3c8a0a2cc
        };
    }
}
class $478396ff7932844e$export$80f5de1a66c4d624 extends $478396ff7932844e$export$72aa44612e2200cd {
    _send(data) {
        return this.writer.write(this._encoder.encode(data));
    }
    constructor(peerId, provider, options){
        super(peerId, provider, options);
        this.serialization = "MsgPack";
        this._encoder = new (0, $f37fc301bc8d0fe8$export$a50aceb0e02a00aa)();
        (async ()=>{
            for await (const msg of (0, $7990493837413dda$exports.decodeMultiStream)(this._rawReadStream)){
                var _msg___peerData;
                // @ts-ignore
                if (((_msg___peerData = msg.__peerData) === null || _msg___peerData === void 0 ? void 0 : _msg___peerData.type) === "close") {
                    this.close();
                    return;
                }
                this.emit("data", msg);
            }
        })();
    }
}
class $478396ff7932844e$export$d72c7bf8eef50853 extends $478396ff7932844e$export$ecd1fc136c422448 {
    constructor(...args){
        super(...args);
        this._serializers = {
            MsgPack: $478396ff7932844e$export$80f5de1a66c4d624,
            default: $478396ff7932844e$export$80f5de1a66c4d624
        };
    }
}
var $478396ff7932844e$export$2e2bcd8739ae039 = $478396ff7932844e$export$ecd1fc136c422448;


class $b651910f1e50d638$var$RoomPeer {
    async startCall() {
        if (!this.connection) return this.roomInstance.setCallState((0, $773044369c5cd207$export$3f6e35e5a5245cb7).CALLING);
        if (!this.peer || !this.connection) return console.log("CANT CALL, IS NOT CONNECTED");
        if (!this.roomInstance.RIVAL && !this.connectedPeer) return console.log("CANT CALL, NO ONE IS CONNECTED");
        this.roomInstance.setCallState((0, $773044369c5cd207$export$3f6e35e5a5245cb7).WAITING_PERMISSIONS);
        await this.addStreamTracks({
            audio: true
        }).then(()=>{
            var _this_roomInstance_RIVAL, _this_peer;
            if (!this.localStream) return this.answerCall(false);
            let peer = ((_this_roomInstance_RIVAL = this.roomInstance.RIVAL) === null || _this_roomInstance_RIVAL === void 0 ? void 0 : _this_roomInstance_RIVAL.avatarID) || this.connectedPeer;
            let call = (_this_peer = this.peer) === null || _this_peer === void 0 ? void 0 : _this_peer.call(peer, this.localStream);
            this.incomingCall = call;
            this.initializeCall(call);
            this.roomInstance.setCallState((0, $773044369c5cd207$export$3f6e35e5a5245cb7).CALLING);
        });
        return Promise.resolve();
    }
    async answerCall(accept) {
        if (!accept) {
            var _this_roomInstance, _this_roomInstance1;
            (_this_roomInstance = this.roomInstance) === null || _this_roomInstance === void 0 ? void 0 : _this_roomInstance.setCallState((0, $773044369c5cd207$export$3f6e35e5a5245cb7).IDLE);
            this.clear();
            await ((_this_roomInstance1 = this.roomInstance) === null || _this_roomInstance1 === void 0 ? void 0 : _this_roomInstance1.doSend((0, $db396e8726140e32$export$92a1a3b7554e9387).REJECT_CALL));
            return;
        }
        if (!this.peer || !this.incomingCall) return;
        let newStream = await this.addStreamTracks({
            audio: true
        });
        if (!newStream) return this.answerCall(false);
        this.initializeCall(this.incomingCall);
        await this.incomingCall.answer(this.localStream);
    }
    assignRoom(roomInstance) {
        this.roomInstance = roomInstance;
        if (!roomInstance) return;
        this.conquer.Signal.get(this.roomInstance.eventsKey + ":onChat", (message)=>{
            this.onMessageReceived(message);
        });
    }
    createConnection() {
        var _this_roomInstance;
        if (this.isCreated) return;
        this.peer = new (0, $478396ff7932844e$export$ecd1fc136c422448)((_this_roomInstance = this.roomInstance) === null || _this_roomInstance === void 0 ? void 0 : _this_roomInstance.ME.avatarID, {
            // host: "nowwa.io",
            // port: 9010,
            // path: "/systems/chatpeer",
            config: {
                "iceServers": [
                    {
                        url: "stun:stun01.sipphone.com"
                    },
                    {
                        url: "stun:stun.ekiga.net"
                    },
                    {
                        url: "stun:stun.fwdnet.net"
                    },
                    {
                        url: "stun:stun.ideasip.com"
                    },
                    {
                        url: "stun:stun.iptel.org"
                    },
                    {
                        url: "stun:stun.rixtelecom.se"
                    },
                    {
                        url: "stun:stun.schlund.de"
                    },
                    {
                        url: "stun:stun.l.google.com:19302"
                    },
                    {
                        url: "stun:stun1.l.google.com:19302"
                    },
                    {
                        url: "stun:stun2.l.google.com:19302"
                    },
                    {
                        url: "stun:stun3.l.google.com:19302"
                    },
                    {
                        url: "stun:stun4.l.google.com:19302"
                    },
                    {
                        url: "stun:stunserver.org"
                    },
                    {
                        url: "stun:stun.softjoys.com"
                    },
                    {
                        url: "stun:stun.voiparound.com"
                    },
                    {
                        url: "stun:stun.voipbuster.com"
                    },
                    {
                        url: "stun:stun.voipstunt.com"
                    },
                    {
                        url: "stun:stun.voxgratia.org"
                    },
                    {
                        url: "stun:stun.xten.com"
                    }
                ]
            },
            debug: 3
        });
        this.peer.on("connection", (conn)=>{
            this.initializeConnection(conn);
        });
        this.peer.on("error", (err)=>{
            console.log("ERROR:", err);
            this.clear();
        });
        this.isCreated = true;
    }
    disconnect() {
        this.clear();
    }
    initializeConnection(conn) {
        var _this_peer;
        if (!conn) return console.log("ERROR WHILE TRYING TO CONNECT:", conn);
        this.connection = conn;
        this.isConnected = true;
        this.connectedPeer = this.connection.peer;
        (_this_peer = this.peer) === null || _this_peer === void 0 ? void 0 : _this_peer.on("call", (call)=>{
            this.roomInstance.setCallState((0, $773044369c5cd207$export$3f6e35e5a5245cb7).RECEIVED);
            this.incomingCall = call;
        });
    // this.connection.on('data', (data:any) => {
    //     console.log('MESSAGE',data);
    // });
    }
    async startConnection() {
        var _this_peer, _this_roomInstance;
        this.connection = (_this_peer = this.peer) === null || _this_peer === void 0 ? void 0 : _this_peer.connect((_this_roomInstance = this.roomInstance) === null || _this_roomInstance === void 0 ? void 0 : _this_roomInstance.RIVAL.avatarID);
        this.initializeConnection(this.connection);
    }
    async addStreamTracks(permissions) {
        let stream;
        await navigator.mediaDevices.getUserMedia(permissions).then((newStream)=>{
            stream = newStream;
        }).catch((err)=>{
            console.log("ERRORRRR", err);
        });
        if (!stream) return;
        this.localStream = stream;
        if (this.localStream.getVideoTracks().length == 0) this.localStream.addTrack(this.getDummy().getVideoTracks()[0]); //Fake Video
        return stream;
    }
    async initializeCall(call) {
        call === null || call === void 0 ? void 0 : call.on("stream", (stream)=>{
            this.remoteStream = stream;
            if (this.roomInstance.callState !== (0, $773044369c5cd207$export$3f6e35e5a5245cb7).IN_PROGRESS) this.roomInstance.setCallState((0, $773044369c5cd207$export$3f6e35e5a5245cb7).IN_PROGRESS);
        });
    }
    async toggleMute() {
        var _this, _this_messageHandler;
        if (!this.connection) return Promise.resolve();
        this.localStream.getAudioTracks().forEach((track)=>track.enabled = !track.enabled);
        let isActive = this.localStream.getAudioTracks()[0].enabled;
        (_this_messageHandler = (_this = this).messageHandler) === null || _this_messageHandler === void 0 ? void 0 : _this_messageHandler.call(_this, "onLocalAudioStateChanged", isActive);
        await this.roomInstance.doSend((0, $db396e8726140e32$export$92a1a3b7554e9387).CHAT_MUTE_CHANGE, {
            isActive: isActive
        });
        return Promise.resolve();
    }
    async toggleCamera() {
        var _this, _this_messageHandler;
        if (!this.videoAsked) {
            let newStream = await this.addStreamTracks({
                video: true,
                audio: true
            });
            if (!newStream) return;
            this.incomingCall.peerConnection.getSenders()[1].replaceTrack(newStream.getVideoTracks()[0]);
            this.incomingCall.peerConnection.getSenders()[0].replaceTrack(newStream.getAudioTracks()[0]);
            this.videoAsked = true;
        } else this.localStream.getVideoTracks().forEach((track)=>track.enabled = !track.enabled);
        let isActive = this.localStream.getVideoTracks()[0].enabled && this.localStream;
        (_this_messageHandler = (_this = this).messageHandler) === null || _this_messageHandler === void 0 ? void 0 : _this_messageHandler.call(_this, "onLocalVideoStateChanged", isActive);
        await this.roomInstance.doSend((0, $db396e8726140e32$export$92a1a3b7554e9387).CHAT_VIDEO_CHANGE, {
            isActive: isActive
        });
    }
    onMessageReceived(message) {
        if (message.action == (0, $db396e8726140e32$export$92a1a3b7554e9387).REJECT_CALL && this.roomInstance.callState != (0, $773044369c5cd207$export$3f6e35e5a5245cb7).IDLE) this.answerCall(false);
        // if( message.action == ACTIONS.CALL || message.action == ACTIONS.ACCEPT_CALL ) this.onSignalResponse( message.data );
        // if( message.action == ACTIONS.CHAT_ICECANDIDATE ) this.receiveIceCandidate( message.data );
        if (message.action == (0, $db396e8726140e32$export$92a1a3b7554e9387).CHAT_VIDEO_CHANGE) this.onVideoStateChanged(message.data);
        if (message.action == (0, $db396e8726140e32$export$92a1a3b7554e9387).CHAT_MUTE_CHANGE) this.onMuteStateChanged(message.data);
    }
    onMuteStateChanged(data) {
        var _this, _this_messageHandler;
        this.remoteStream.getAudioTracks().forEach((track)=>track.enabled = data.isActive);
        (_this_messageHandler = (_this = this).messageHandler) === null || _this_messageHandler === void 0 ? void 0 : _this_messageHandler.call(_this, "onAudioStateChanged", data.isActive);
    }
    onVideoStateChanged(data) {
        var _this, _this_messageHandler;
        (_this_messageHandler = (_this = this).messageHandler) === null || _this_messageHandler === void 0 ? void 0 : _this_messageHandler.call(_this, "onVideoStateChanged", data.isActive ? this.remoteStream : undefined);
    }
    getDummy() {
        let audio = this.localStream.getAudioTracks()[0];
        const width = 640;
        const height = 480;
        const canvas = Object.assign(this.fakeCanvas, {
            width: width,
            height: height
        });
        canvas.getContext("2d").fillRect(0, 0, width, height);
        const stream = canvas.captureStream();
        const track = stream.getVideoTracks()[0];
        let black = Object.assign(track, {
            enabled: false
        });
        let blackSilence = new MediaStream([
            audio,
            black
        ]);
        let draw = ()=>{
            canvas.getContext("2d").fillRect(0, 0, width, height);
            this.fakeDrawTimeout = setTimeout(draw, 10);
        };
        clearTimeout(this.fakeDrawTimeout);
        draw();
        return blackSilence;
    }
    clear() {
        var _this_roomInstance;
        if (this.incomingCall) this.incomingCall.close();
        this.incomingCall = false;
        this.videoAsked = false;
        this.isCreated = false;
        this.isConnected = false;
        (_this_roomInstance = this.roomInstance) === null || _this_roomInstance === void 0 ? void 0 : _this_roomInstance.setCallState((0, $773044369c5cd207$export$3f6e35e5a5245cb7).IDLE);
        if (this.localStream) this.localStream.getTracks().forEach(function(track) {
            track.stop();
        });
        if (this.remoteStream) this.remoteStream.getTracks().forEach(function(track) {
            track.stop();
        });
    }
    constructor(conquer){
        this.videoAsked = false;
        this.localStream = false;
        this.remoteStream = false;
        this.state = "";
        this.isConnected = false;
        this.isCreated = false;
        this.fakeCanvas = document.createElement("canvas");
        this.messageHandler = function(e) {};
        this.conquer = conquer;
    }
}
var $b651910f1e50d638$export$2e2bcd8739ae039 = $b651910f1e50d638$var$RoomPeer;



const $6f1bf46da84b3f6c$var$ChatVideocall = ({ roomInstance: roomInstance, getTargetAvatar: getTargetAvatar, peer: peer })=>{
    const ownVideoRef = (0, $6cds3.useRef)();
    const otherVideoRef = (0, $6cds3.useRef)();
    const [userData, setUserData] = (0, $6cds3.useState)();
    const [localMedia, setLocalMedia] = (0, $6cds3.useState)(false);
    const [streamMedia, setStreamMedia] = (0, $6cds3.useState)(false);
    const [muteText, setMuteText] = (0, $6cds3.useState)("Mute");
    function eventsHandler(action, data) {
        if (action == "onVideoStateChanged") {
            if (data) otherVideoRef.current.srcObject = data;
            setStreamMedia(data);
        }
        if (action == "onLocalVideoStateChanged") {
            let stream = data ? peer.localStream : undefined;
            ownVideoRef.current.srcObject = stream;
            setLocalMedia(stream);
        }
        if (action == "onLocalAudioStateChanged") setMuteText(data ? "Mute" : "Unmute");
    // if( action == 'onMutedStateChanged' ) setStreamMedia( roomInstance.peer.remoteStream );
    }
    const toggleCamera = async ()=>{
        await peer.toggleCamera();
    };
    const toggleMute = async ()=>{
        await peer.toggleMute();
    };
    const stopCall = async ()=>{
        await peer.answerCall(false);
    };
    (0, $6cds3.useEffect)(()=>{
        otherVideoRef.current.srcObject = peer.remoteStream;
        peer.messageHandler = eventsHandler;
    // window.addEventListener('beforeunload', () => { alert('ON UNLOAD'); roomInstance.reject() });
    // return () => { roomInstance.reject(); console.log('EXITTING') };
    }, []);
    (0, $6cds3.useEffect)(()=>{
        setUserData(getTargetAvatar());
    }, [
        roomInstance
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($26abb23381f93eca$exports))).videocallContainer,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($26abb23381f93eca$exports))).videos,
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($26abb23381f93eca$exports))).videoContainer,
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("video", {
                                ref: ownVideoRef,
                                autoPlay: true,
                                playsInline: true,
                                muted: true,
                                className: localMedia ? "" : (0, (/*@__PURE__*/$parcel$interopDefault($26abb23381f93eca$exports))).hide
                            }),
                            !localMedia && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6d7bf74e72bae737$export$2e2bcd8739ae039), {
                                fallbackToMe: true,
                                removeOnline: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($26abb23381f93eca$exports))).videoContainer,
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)("video", {
                                ref: otherVideoRef,
                                autoPlay: true,
                                playsInline: true,
                                className: streamMedia ? "" : (0, (/*@__PURE__*/$parcel$interopDefault($26abb23381f93eca$exports))).hide
                            }),
                            !streamMedia && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6d7bf74e72bae737$export$2e2bcd8739ae039), {
                                userData: userData,
                                fallbackToMe: false,
                                removeOnline: true
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($26abb23381f93eca$exports))).actionBar,
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                        className: "button small",
                        onClick: toggleCamera,
                        children: localMedia ? "Stop Video" : "Show Video"
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                        className: "button small",
                        onClick: toggleMute,
                        children: "Mute"
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                        className: "button small",
                        onClick: stopCall,
                        children: "Hang"
                    })
                ]
            })
        ]
    });
};
var $6f1bf46da84b3f6c$export$2e2bcd8739ae039 = $6f1bf46da84b3f6c$var$ChatVideocall;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
var $f2cf1e97db21fce3$exports = {};

$parcel$export($f2cf1e97db21fce3$exports, "btnContainer", function () { return $f2cf1e97db21fce3$export$cb6c30b631422a13; }, function (v) { return $f2cf1e97db21fce3$export$cb6c30b631422a13 = v; });
$parcel$export($f2cf1e97db21fce3$exports, "container", function () { return $f2cf1e97db21fce3$export$34e0f9847d4c02dd; }, function (v) { return $f2cf1e97db21fce3$export$34e0f9847d4c02dd = v; });
var $f2cf1e97db21fce3$export$cb6c30b631422a13;
var $f2cf1e97db21fce3$export$34e0f9847d4c02dd;
$f2cf1e97db21fce3$export$cb6c30b631422a13 = `l4pmKa_btnContainer`;
$f2cf1e97db21fce3$export$34e0f9847d4c02dd = `l4pmKa_container`;


const $964f92771f5dbb21$var$ChatCalling = ({ roomInstance: roomInstance, callback: callback, isCaller: isCaller, peer: peer })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f2cf1e97db21fce3$exports))).container,
        children: [
            isCaller && /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                children: "You are calling this user"
            }),
            !isCaller && /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                children: "This user is calling you."
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f2cf1e97db21fce3$exports))).btnContainer,
                children: isCaller ? /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                    className: "button",
                    onClick: ()=>{
                        peer.answerCall(false);
                        callback === null || callback === void 0 ? void 0 : callback();
                    },
                    children: "Cancel"
                }) : /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                            className: "button",
                            onClick: ()=>{
                                console.log("Accepting");
                                peer.answerCall(true);
                                callback === null || callback === void 0 ? void 0 : callback();
                            },
                            children: "Accept"
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                            className: "button",
                            onClick: ()=>{
                                console.log("Rejecting");
                                peer.answerCall(false);
                                callback === null || callback === void 0 ? void 0 : callback();
                            },
                            children: "Reject"
                        })
                    ]
                })
            })
        ]
    });
};
var $964f92771f5dbb21$export$2e2bcd8739ae039 = $964f92771f5dbb21$var$ChatCalling;



function $4cd32de111801470$var$useCallStatus(roomInstance, peer) {
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const { show: show, hide: hide } = (0, $6cds3.useContext)((0, $fbd77a4ebafd8162$export$ab57792b9b6974a6));
    const [status, setStatus] = (0, $6cds3.useState)((0, $773044369c5cd207$export$3f6e35e5a5245cb7).IDLE);
    function updateState(state) {
        setStatus(state);
        if (state == (0, $773044369c5cd207$export$3f6e35e5a5245cb7).IN_PROGRESS || state == (0, $773044369c5cd207$export$3f6e35e5a5245cb7).IDLE) return hide(), conquer.Sounds.Ambiance.stop();
        if (state != (0, $773044369c5cd207$export$3f6e35e5a5245cb7).CALLING && state != (0, $773044369c5cd207$export$3f6e35e5a5245cb7).RECEIVED) return;
        show({
            title: "CALL",
            content: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $964f92771f5dbb21$export$2e2bcd8739ae039), {
                roomInstance: roomInstance,
                peer: peer,
                isCaller: state == (0, $773044369c5cd207$export$3f6e35e5a5245cb7).CALLING
            }),
            closeOutside: false,
            onClose: onClose
        });
        conquer.Sounds.Ambiance.loop("Casual - Level 2 (Loop_02)");
    }
    function onClose() {
        peer === null || peer === void 0 ? void 0 : peer.answerCall(false);
    }
    (0, $6cds3.useEffect)(()=>{
        if (roomInstance) roomInstance.onCallState = updateState;
    }, [
        roomInstance,
        peer
    ]);
    return status;
}
var $4cd32de111801470$export$2e2bcd8739ae039 = $4cd32de111801470$var$useCallStatus;




const $9dd9c06d2f2bed70$export$c67103b336b90275 = /*#__PURE__*/ (0, $6cds3.createContext)();
const $9dd9c06d2f2bed70$var$ChatContextProvider = ({ roomKeys: roomKeys, isPersistent: isPersistent = false, isLoadingCallback: isLoadingCallback, children: children })=>{
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const userContext = (0, $6cds3.useContext)((0, $260d68481938071c$export$38ee920e59704589));
    const [roomInstance, setRoomInstance] = (0, $6cds3.useState)(false);
    const [messages, setMessages] = (0, $6cds3.useState)([]);
    const [avatars, setAvatars] = (0, $6cds3.useState)({});
    const [isOnCall, setIsOnCall] = (0, $6cds3.useState)(false);
    const [peer, setPeer] = (0, $6cds3.useState)(false);
    const [rivalID, setRivalID] = (0, $6cds3.useState)(false);
    const messagesRef = (0, $6cds3.useRef)();
    const roomRef = (0, $6cds3.useRef)();
    const peerRef = (0, $6cds3.useRef)();
    messagesRef.current = messages;
    roomRef.current = roomInstance;
    const callStatus = (0, $4cd32de111801470$export$2e2bcd8739ae039)(roomRef.current, peerRef.current);
    function tryToLoadRoom() {
        setMessages([]);
        async function doWork() {
            if (!userContext.userData.isLogged && isPersistent || !roomKeys) {
                if (roomInstance) setRoomInstance(false);
                return;
            }
            isLoadingCallback === null || isLoadingCallback === void 0 ? void 0 : isLoadingCallback(true);
            let room = await conquer.Rooms.getOne(roomKeys);
            isLoadingCallback === null || isLoadingCallback === void 0 ? void 0 : isLoadingCallback(false);
            room.isGroup = !Array.isArray(roomKeys);
            setRoomInstance(room);
            if (room.error) return false;
            await room.join();
            room.onMessage = onMessageReceived;
            room.onJoin = onPlayerJoin;
            if (!room.isGroup) {
                let totalAvatars = {};
                if (room.avatarIDs) for (const eachAvatar of room.avatarIDs){
                    if (eachAvatar != conquer.User.avatarID) setRivalID(eachAvatar);
                    let friendAvatar = await conquer.Avatars.get(eachAvatar);
                    totalAvatars[friendAvatar.avatarID] = friendAvatar;
                }
                setAvatars(totalAvatars);
            }
            if (isPersistent) {
                let storedMessages = await room.Entries.get();
                setMessages(storedMessages.reverse());
            }
        }
        doWork();
    }
    (0, $6cds3.useEffect)(tryToLoadRoom, [
        roomKeys,
        userContext.userData.isLogged
    ]);
    (0, $6cds3.useEffect)(()=>{
        setIsOnCall(callStatus == (0, $773044369c5cd207$export$3f6e35e5a5245cb7).IN_PROGRESS);
    }, [
        callStatus
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!userContext.userData.isLogged) {
            if (peerRef.current) peerRef.current.disconnect();
            return setPeer(false);
        }
        if (!peerRef.current) {
            let newPeer = new (0, $b651910f1e50d638$export$2e2bcd8739ae039)(conquer);
            setPeer(newPeer);
            peerRef.current = newPeer;
        }
        if (roomRef.current) peerRef.current.assignRoom(roomRef.current);
    }, [
        userContext.userData.isLogged,
        roomInstance
    ]);
    function onMessageReceived(message, metadata) {
        if (roomRef.current.isGroup && message.action == (0, $db396e8726140e32$export$92a1a3b7554e9387).GAMEDATA) return updatePlayers(message);
        if (typeof message == "string") message = {
            action: (0, $db396e8726140e32$export$92a1a3b7554e9387).CHAT,
            text: message,
            metadata: metadata,
            avatarID: conquer.User.avatarID
        };
        if (message.action == (0, $db396e8726140e32$export$92a1a3b7554e9387).PLAYERJOIN && peerRef.current) setTimeout(()=>{
            peerRef.current.startConnection();
        }, 2000);
        if (!message.timestamp && (!message.data || !message.data.timestamp)) message.timestamp = Date.now();
        if (message.action != (0, $db396e8726140e32$export$92a1a3b7554e9387).CHAT) return;
        let newMessages = [
            ...messagesRef.current
        ];
        newMessages.unshift(message);
        setMessages(newMessages);
        roomInstance.onMessage = onMessageReceived;
    }
    function onPlayerJoin() {
        if (!peerRef.current || peerRef.current.isCreated || !isPersistent) return;
        peerRef.current.createConnection();
    }
    (0, $6cds3.useEffect)(()=>{
        if (roomInstance.peer) setIsOnCall(roomInstance.peer.isOnCall);
    }, [
        (roomInstance.peer || {}).isOnCall
    ]);
    function updatePlayers(gameData) {
        let totalAvatars = gameData.data.online;
        setAvatars(totalAvatars);
    }
    async function sendMessage(text, metadata) {
        await isPersistent ? roomRef.current.entry(text, metadata) : roomRef.current.chat(text);
        onMessageReceived(text, metadata);
    }
    function getTargetAvatar() {
        for (const eachFriend of Object.values(avatars)){
            if (eachFriend.avatarID == userContext.userData.avatarID) continue;
            return eachFriend;
        }
        return {};
    }
    if (!roomKeys) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {});
    return /*#__PURE__*/ (0, $lBpE3.jsxs)($9dd9c06d2f2bed70$export$c67103b336b90275.Provider, {
        value: {
            roomInstance: roomInstance,
            setRoomInstance: setRoomInstance,
            isPersistent: isPersistent,
            avatars: avatars,
            messages: messages,
            sendMessage: sendMessage,
            getTargetAvatar: getTargetAvatar,
            peer: peerRef.current
        },
        children: [
            isOnCall && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6f1bf46da84b3f6c$export$2e2bcd8739ae039), {
                peer: peer,
                roomInstance: roomInstance,
                getTargetAvatar: getTargetAvatar
            }),
            children
        ]
    });
};
var $9dd9c06d2f2bed70$export$2e2bcd8739ae039 = $9dd9c06d2f2bed70$var$ChatContextProvider;


var $43ef091565fe9a57$exports = {};
"use strict";
"use client";

Object.defineProperty($43ef091565fe9a57$exports, "__esModule", {
    value: true
});
$43ef091565fe9a57$exports.default = void 0;

var $43ef091565fe9a57$var$_createSvgIcon = $4bfaad0176813de2$exports((parcelRequire("1kJnE")));

var $lBpE3 = parcelRequire("lBpE3");
var $43ef091565fe9a57$var$_default = (0, $43ef091565fe9a57$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $lBpE3.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
}), "ArrowBack");
$43ef091565fe9a57$exports.default = $43ef091565fe9a57$var$_default;




var $6PPF0 = parcelRequire("6PPF0");
var $b53843906d538e34$exports = {};
"use strict";
"use client";

Object.defineProperty($b53843906d538e34$exports, "__esModule", {
    value: true
});
$b53843906d538e34$exports.default = void 0;

var $b53843906d538e34$var$_createSvgIcon = $4bfaad0176813de2$exports((parcelRequire("1kJnE")));

var $lBpE3 = parcelRequire("lBpE3");
var $b53843906d538e34$var$_default = (0, $b53843906d538e34$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $lBpE3.jsx)("path", {
    d: "M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"
}), "Call");
$b53843906d538e34$exports.default = $b53843906d538e34$var$_default;



var $8pKQA = parcelRequire("8pKQA");

var $dpDEA = parcelRequire("dpDEA");

var $6cds3 = parcelRequire("6cds3");


var $aPjpj = parcelRequire("aPjpj");


var $619SG = parcelRequire("619SG");

var $lVNFJ = parcelRequire("lVNFJ");

var $iHVyY = parcelRequire("iHVyY");

var $9ScrR = parcelRequire("9ScrR");

var $dpDEA = parcelRequire("dpDEA");

var $8pKQA = parcelRequire("8pKQA");

var $6cds3 = parcelRequire("6cds3");


var $aPjpj = parcelRequire("aPjpj");


var $619SG = parcelRequire("619SG");

var $iHVyY = parcelRequire("iHVyY");

var $9ScrR = parcelRequire("9ScrR");

var $6cds3 = parcelRequire("6cds3");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $53dd8d186939a3fc$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


"use client";
function $2448620fcc6b13b6$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $6cds3.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $53dd8d186939a3fc$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


"use client";
var $f1ebb1ef3f17e320$export$2e2bcd8739ae039 = (0, $2448620fcc6b13b6$export$2e2bcd8739ae039);



var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
"use client";
const $f799349b61a53021$var$useEnhancedEffect = typeof window !== "undefined" ? $6cds3.useLayoutEffect : $6cds3.useEffect;
var $f799349b61a53021$export$2e2bcd8739ae039 = $f799349b61a53021$var$useEnhancedEffect;


"use client";
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */ function $f5b2dd89eab84a00$var$useEventCallback(fn) {
    const ref = $6cds3.useRef(fn);
    (0, $f799349b61a53021$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $6cds3.useCallback((...args)=>// @ts-expect-error hide `this`
        // tslint:disable-next-line:ban-comma-operator
        (0, ref.current)(...args), []);
}
var $f5b2dd89eab84a00$export$2e2bcd8739ae039 = $f5b2dd89eab84a00$var$useEventCallback;


"use client";
var $384dd9801ee34704$export$2e2bcd8739ae039 = (0, $f5b2dd89eab84a00$export$2e2bcd8739ae039);



var $6cds3 = parcelRequire("6cds3");
"use client";
let $6bd2239c13a1661b$var$hadKeyboardEvent = true;
let $6bd2239c13a1661b$var$hadFocusVisibleRecently = false;
let $6bd2239c13a1661b$var$hadFocusVisibleRecentlyTimeout;
const $6bd2239c13a1661b$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $6bd2239c13a1661b$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $6bd2239c13a1661b$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $6bd2239c13a1661b$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $6bd2239c13a1661b$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $6bd2239c13a1661b$var$handlePointerDown() {
    $6bd2239c13a1661b$var$hadKeyboardEvent = false;
}
function $6bd2239c13a1661b$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($6bd2239c13a1661b$var$hadFocusVisibleRecently) $6bd2239c13a1661b$var$hadKeyboardEvent = true;
    }
}
function $6bd2239c13a1661b$var$prepare(doc) {
    doc.addEventListener("keydown", $6bd2239c13a1661b$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $6bd2239c13a1661b$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $6bd2239c13a1661b$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $6bd2239c13a1661b$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $6bd2239c13a1661b$var$handleVisibilityChange, true);
}
function $6bd2239c13a1661b$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $6bd2239c13a1661b$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $6bd2239c13a1661b$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $6bd2239c13a1661b$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $6bd2239c13a1661b$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $6bd2239c13a1661b$var$handleVisibilityChange, true);
}
function $6bd2239c13a1661b$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $6bd2239c13a1661b$var$hadKeyboardEvent || $6bd2239c13a1661b$var$focusTriggersKeyboardModality(target);
}
function $6bd2239c13a1661b$export$2e2bcd8739ae039() {
    const ref = $6cds3.useCallback((node)=>{
        if (node != null) $6bd2239c13a1661b$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $6cds3.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $6bd2239c13a1661b$var$hadFocusVisibleRecently = true;
            window.clearTimeout($6bd2239c13a1661b$var$hadFocusVisibleRecentlyTimeout);
            $6bd2239c13a1661b$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(()=>{
                $6bd2239c13a1661b$var$hadFocusVisibleRecently = false;
            }, 100);
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($6bd2239c13a1661b$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


"use client";
var $950d2a6b8a8cea50$export$2e2bcd8739ae039 = (0, $6bd2239c13a1661b$export$2e2bcd8739ae039);



var $dpDEA = parcelRequire("dpDEA");

var $8pKQA = parcelRequire("8pKQA");

var $6cds3 = parcelRequire("6cds3");


var $guWa8 = parcelRequire("guWa8");

var $aPjpj = parcelRequire("aPjpj");

var $iMGg1 = parcelRequire("iMGg1");

var $iHVyY = parcelRequire("iHVyY");

var $9ScrR = parcelRequire("9ScrR");

var $6cds3 = parcelRequire("6cds3");


var $aPjpj = parcelRequire("aPjpj");

var $lBpE3 = parcelRequire("lBpE3");
"use client";
function $66fc5a5be8c92d33$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $6cds3.useState(false);
    const rippleClassName = (0, $aPjpj.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $aPjpj.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $6cds3.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
            className: childClassName
        })
    });
}
var $66fc5a5be8c92d33$export$2e2bcd8739ae039 = $66fc5a5be8c92d33$var$Ripple;



var $3DnVy = parcelRequire("3DnVy");

var $3hxuv = parcelRequire("3hxuv");
function $2121e11d7f176e40$export$b464606f735ab902(slot) {
    return (0, $3hxuv.default)("MuiTouchRipple", slot);
}
const $2121e11d7f176e40$var$touchRippleClasses = (0, $3DnVy.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $2121e11d7f176e40$export$2e2bcd8739ae039 = $2121e11d7f176e40$var$touchRippleClasses;



var $lBpE3 = parcelRequire("lBpE3");
"use client";
let $8d8b5b9e9d20af57$var$_ = (t)=>t, $8d8b5b9e9d20af57$var$t, $8d8b5b9e9d20af57$var$t1, $8d8b5b9e9d20af57$var$t2, $8d8b5b9e9d20af57$var$t3;
const $8d8b5b9e9d20af57$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $8d8b5b9e9d20af57$var$_1 = (t)=>t, $8d8b5b9e9d20af57$var$_t, $8d8b5b9e9d20af57$var$_t2, $8d8b5b9e9d20af57$var$_t3, $8d8b5b9e9d20af57$var$_t4;
const $8d8b5b9e9d20af57$var$DURATION = 550;
const $8d8b5b9e9d20af57$export$95d0c9356b2231a3 = 80;
const $8d8b5b9e9d20af57$var$enterKeyframe = (0, $iMGg1.keyframes)($8d8b5b9e9d20af57$var$_t || ($8d8b5b9e9d20af57$var$_t = $8d8b5b9e9d20af57$var$_1($8d8b5b9e9d20af57$var$t || ($8d8b5b9e9d20af57$var$t = $8d8b5b9e9d20af57$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`))));
const $8d8b5b9e9d20af57$var$exitKeyframe = (0, $iMGg1.keyframes)($8d8b5b9e9d20af57$var$_t2 || ($8d8b5b9e9d20af57$var$_t2 = $8d8b5b9e9d20af57$var$_1($8d8b5b9e9d20af57$var$t1 || ($8d8b5b9e9d20af57$var$t1 = $8d8b5b9e9d20af57$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`))));
const $8d8b5b9e9d20af57$var$pulsateKeyframe = (0, $iMGg1.keyframes)($8d8b5b9e9d20af57$var$_t3 || ($8d8b5b9e9d20af57$var$_t3 = $8d8b5b9e9d20af57$var$_1($8d8b5b9e9d20af57$var$t2 || ($8d8b5b9e9d20af57$var$t2 = $8d8b5b9e9d20af57$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`))));
const $8d8b5b9e9d20af57$export$f6b7418508c72c25 = (0, $iHVyY.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $8d8b5b9e9d20af57$export$676cfe7b12693c4b = (0, $iHVyY.default)((0, $66fc5a5be8c92d33$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($8d8b5b9e9d20af57$var$_t4 || ($8d8b5b9e9d20af57$var$_t4 = $8d8b5b9e9d20af57$var$_1($8d8b5b9e9d20af57$var$t3 || ($8d8b5b9e9d20af57$var$t3 = $8d8b5b9e9d20af57$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)), (0, $2121e11d7f176e40$export$2e2bcd8739ae039).rippleVisible, $8d8b5b9e9d20af57$var$enterKeyframe, $8d8b5b9e9d20af57$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $2121e11d7f176e40$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $2121e11d7f176e40$export$2e2bcd8739ae039).child, (0, $2121e11d7f176e40$export$2e2bcd8739ae039).childLeaving, $8d8b5b9e9d20af57$var$exitKeyframe, $8d8b5b9e9d20af57$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $2121e11d7f176e40$export$2e2bcd8739ae039).childPulsate, $8d8b5b9e9d20af57$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $8d8b5b9e9d20af57$var$TouchRipple = /*#__PURE__*/ $6cds3.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $9ScrR.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $8pKQA.default)(props, $8d8b5b9e9d20af57$var$_excluded);
    const [ripples, setRipples] = $6cds3.useState([]);
    const nextKey = $6cds3.useRef(0);
    const rippleCallback = $6cds3.useRef(null);
    $6cds3.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $6cds3.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = $6cds3.useRef(0);
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $6cds3.useRef(null);
    const container = $6cds3.useRef(null);
    $6cds3.useEffect(()=>{
        return ()=>{
            if (startTimer.current) clearTimeout(startTimer.current);
        };
    }, []);
    const startCommit = $6cds3.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $lBpE3.jsx)($8d8b5b9e9d20af57$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $aPjpj.default)(classes.ripple, (0, $2121e11d7f176e40$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $aPjpj.default)(classes.rippleVisible, (0, $2121e11d7f176e40$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $aPjpj.default)(classes.ripplePulsate, (0, $2121e11d7f176e40$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $aPjpj.default)(classes.child, (0, $2121e11d7f176e40$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $aPjpj.default)(classes.childLeaving, (0, $2121e11d7f176e40$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $aPjpj.default)(classes.childPulsate, (0, $2121e11d7f176e40$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $8d8b5b9e9d20af57$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $6cds3.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $8d8b5b9e9d20af57$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    const pulsate = $6cds3.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $6cds3.useCallback((event, cb)=>{
        clearTimeout(startTimer.current);
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $6cds3.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsx)($8d8b5b9e9d20af57$export$f6b7418508c72c25, (0, $dpDEA.default)({
        className: (0, $aPjpj.default)((0, $2121e11d7f176e40$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $guWa8.default), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $8d8b5b9e9d20af57$export$2e2bcd8739ae039 = $8d8b5b9e9d20af57$var$TouchRipple;



var $3DnVy = parcelRequire("3DnVy");

var $3hxuv = parcelRequire("3hxuv");
function $776df9f23da44a1c$export$fccb0498dcd99783(slot) {
    return (0, $3hxuv.default)("MuiButtonBase", slot);
}
const $776df9f23da44a1c$var$buttonBaseClasses = (0, $3DnVy.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $776df9f23da44a1c$export$2e2bcd8739ae039 = $776df9f23da44a1c$var$buttonBaseClasses;



var $lBpE3 = parcelRequire("lBpE3");
"use client";
const $b13c455b14e0570e$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $b13c455b14e0570e$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $619SG.default)(slots, (0, $776df9f23da44a1c$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $b13c455b14e0570e$export$7ec0dcc5e3cdcd36 = (0, $iHVyY.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $776df9f23da44a1c$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $b13c455b14e0570e$var$ButtonBase = /*#__PURE__*/ $6cds3.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $9ScrR.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $8pKQA.default)(props, $b13c455b14e0570e$var$_excluded);
    const buttonRef = $6cds3.useRef(null);
    const rippleRef = $6cds3.useRef(null);
    const handleRippleRef = (0, $f1ebb1ef3f17e320$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $950d2a6b8a8cea50$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $6cds3.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $6cds3.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $6cds3.useState(false);
    $6cds3.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $6cds3.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $384dd9801ee34704$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $384dd9801ee34704$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $6cds3.useRef(false);
    const handleKeyDown = (0, $384dd9801ee34704$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $384dd9801ee34704$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $f1ebb1ef3f17e320$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $dpDEA.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $b13c455b14e0570e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)($b13c455b14e0570e$export$7ec0dcc5e3cdcd36, (0, $dpDEA.default)({
        as: ComponentProp,
        className: (0, $aPjpj.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $lBpE3.jsx)((0, $8d8b5b9e9d20af57$export$2e2bcd8739ae039), (0, $dpDEA.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $b13c455b14e0570e$export$2e2bcd8739ae039 = $b13c455b14e0570e$var$ButtonBase;



var $4DxKp = parcelRequire("4DxKp");

var $3DnVy = parcelRequire("3DnVy");

var $3hxuv = parcelRequire("3hxuv");
function $ef21c4a8a27d50f3$export$5e8702d71474f093(slot) {
    return (0, $3hxuv.default)("MuiIconButton", slot);
}
const $ef21c4a8a27d50f3$var$iconButtonClasses = (0, $3DnVy.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $ef21c4a8a27d50f3$export$2e2bcd8739ae039 = $ef21c4a8a27d50f3$var$iconButtonClasses;



var $lBpE3 = parcelRequire("lBpE3");
"use client";
const $f1d5dc25ad93042b$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $f1d5dc25ad93042b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $4DxKp.default)(color)}`,
            edge && `edge${(0, $4DxKp.default)(edge)}`,
            `size${(0, $4DxKp.default)(size)}`
        ]
    };
    return (0, $619SG.default)(slots, (0, $ef21c4a8a27d50f3$export$5e8702d71474f093), classes);
};
const $f1d5dc25ad93042b$var$IconButtonRoot = (0, $iHVyY.default)((0, $b13c455b14e0570e$export$2e2bcd8739ae039), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $4DxKp.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $4DxKp.default)(ownerState.edge)}`],
            styles[`size${(0, $4DxKp.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $dpDEA.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $lVNFJ.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $dpDEA.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $dpDEA.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $dpDEA.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $lVNFJ.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $ef21c4a8a27d50f3$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $f1d5dc25ad93042b$var$IconButton = /*#__PURE__*/ $6cds3.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $9ScrR.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $8pKQA.default)(props, $f1d5dc25ad93042b$var$_excluded);
    const ownerState = (0, $dpDEA.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $f1d5dc25ad93042b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $lBpE3.jsx)($f1d5dc25ad93042b$var$IconButtonRoot, (0, $dpDEA.default)({
        className: (0, $aPjpj.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $f1d5dc25ad93042b$export$2e2bcd8739ae039 = $f1d5dc25ad93042b$var$IconButton;


const $4e49aa9497b308a3$var$ChatHeader = ({ onBackCallback: onBackCallback })=>{
    const userContext = (0, $6cds3.useContext)((0, $260d68481938071c$export$38ee920e59704589));
    const chatContext = (0, $6cds3.useContext)((0, $9dd9c06d2f2bed70$export$c67103b336b90275));
    const connectedFriends = Object.values(chatContext.avatars);
    let currentUser = chatContext.getTargetAvatar();
    // if( !chatContext.roomInstance.isGroup ) return <></>;
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($48f12740132cc051$exports))).container, chatContext.roomInstance.isGroup && (0, (/*@__PURE__*/$parcel$interopDefault($48f12740132cc051$exports))).group),
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($48f12740132cc051$exports))).container__left,
            children: [
                onBackCallback && /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))("button small", (0, (/*@__PURE__*/$parcel$interopDefault($48f12740132cc051$exports))).backButton),
                    onClick: onBackCallback,
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($43ef091565fe9a57$exports))), {})
                }),
                !chatContext.roomInstance.isGroup ? /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($48f12740132cc051$exports))).avatar,
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6d7bf74e72bae737$export$2e2bcd8739ae039), {
                                    data: currentUser,
                                    fallbackToMe: false
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($48f12740132cc051$exports))).name,
                                    children: currentUser.firstName
                                })
                            ]
                        }),
                        chatContext.isPersistent && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($48f12740132cc051$exports))).chatAction,
                            "aria-label": "send",
                            onClick: ()=>{
                                chatContext.peer.startCall();
                            },
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b53843906d538e34$exports))), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($48f12740132cc051$exports))).container__inputRight__send
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $lBpE3.jsxs)("p", {
                    children: [
                        "Users Online ",
                        connectedFriends.length
                    ]
                })
            ]
        })
    });
};
var $4e49aa9497b308a3$export$2e2bcd8739ae039 = $4e49aa9497b308a3$var$ChatHeader;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
var $3897d506c0a6c605$exports = {};

$parcel$export($3897d506c0a6c605$exports, "chatAction", function () { return $3897d506c0a6c605$export$1b8e722337485284; }, function (v) { return $3897d506c0a6c605$export$1b8e722337485284 = v; });
$parcel$export($3897d506c0a6c605$exports, "container", function () { return $3897d506c0a6c605$export$34e0f9847d4c02dd; }, function (v) { return $3897d506c0a6c605$export$34e0f9847d4c02dd = v; });
$parcel$export($3897d506c0a6c605$exports, "container__inputEmoji", function () { return $3897d506c0a6c605$export$3f24f89b69f9f998; }, function (v) { return $3897d506c0a6c605$export$3f24f89b69f9f998 = v; });
$parcel$export($3897d506c0a6c605$exports, "container__inputLeft", function () { return $3897d506c0a6c605$export$a7d1544a9c286b01; }, function (v) { return $3897d506c0a6c605$export$a7d1544a9c286b01 = v; });
$parcel$export($3897d506c0a6c605$exports, "container__inputRight", function () { return $3897d506c0a6c605$export$f5b0247795536bd0; }, function (v) { return $3897d506c0a6c605$export$f5b0247795536bd0 = v; });
$parcel$export($3897d506c0a6c605$exports, "container__inputRight__attach", function () { return $3897d506c0a6c605$export$762f6b0eaea7bbfb; }, function (v) { return $3897d506c0a6c605$export$762f6b0eaea7bbfb = v; });
$parcel$export($3897d506c0a6c605$exports, "container__inputRight__emoj", function () { return $3897d506c0a6c605$export$80845f4943675cc2; }, function (v) { return $3897d506c0a6c605$export$80845f4943675cc2 = v; });
$parcel$export($3897d506c0a6c605$exports, "container__inputRight__mic", function () { return $3897d506c0a6c605$export$e63fc08e2498d5a6; }, function (v) { return $3897d506c0a6c605$export$e63fc08e2498d5a6 = v; });
$parcel$export($3897d506c0a6c605$exports, "container__inputRight__send", function () { return $3897d506c0a6c605$export$e0a836616ef74fb1; }, function (v) { return $3897d506c0a6c605$export$e0a836616ef74fb1 = v; });
$parcel$export($3897d506c0a6c605$exports, "emoji_container", function () { return $3897d506c0a6c605$export$1d6a7fa2eaa03615; }, function (v) { return $3897d506c0a6c605$export$1d6a7fa2eaa03615 = v; });
$parcel$export($3897d506c0a6c605$exports, "grid_container", function () { return $3897d506c0a6c605$export$229f8541ff50149b; }, function (v) { return $3897d506c0a6c605$export$229f8541ff50149b = v; });
$parcel$export($3897d506c0a6c605$exports, "grid_item", function () { return $3897d506c0a6c605$export$c358ddc4badb7c84; }, function (v) { return $3897d506c0a6c605$export$c358ddc4badb7c84 = v; });
$parcel$export($3897d506c0a6c605$exports, "open_panel", function () { return $3897d506c0a6c605$export$8c3b2e5023155b9a; }, function (v) { return $3897d506c0a6c605$export$8c3b2e5023155b9a = v; });
var $3897d506c0a6c605$export$1b8e722337485284;
var $3897d506c0a6c605$export$34e0f9847d4c02dd;
var $3897d506c0a6c605$export$3f24f89b69f9f998;
var $3897d506c0a6c605$export$a7d1544a9c286b01;
var $3897d506c0a6c605$export$f5b0247795536bd0;
var $3897d506c0a6c605$export$762f6b0eaea7bbfb;
var $3897d506c0a6c605$export$80845f4943675cc2;
var $3897d506c0a6c605$export$e63fc08e2498d5a6;
var $3897d506c0a6c605$export$e0a836616ef74fb1;
var $3897d506c0a6c605$export$1d6a7fa2eaa03615;
var $3897d506c0a6c605$export$229f8541ff50149b;
var $3897d506c0a6c605$export$c358ddc4badb7c84;
var $3897d506c0a6c605$export$8c3b2e5023155b9a;
$3897d506c0a6c605$export$1b8e722337485284 = `_6h2UNW_chatAction`;
$3897d506c0a6c605$export$34e0f9847d4c02dd = `_6h2UNW_container`;
$3897d506c0a6c605$export$3f24f89b69f9f998 = `_6h2UNW_container__inputEmoji`;
$3897d506c0a6c605$export$a7d1544a9c286b01 = `_6h2UNW_container__inputLeft`;
$3897d506c0a6c605$export$f5b0247795536bd0 = `_6h2UNW_container__inputRight`;
$3897d506c0a6c605$export$762f6b0eaea7bbfb = `_6h2UNW_container__inputRight__attach`;
$3897d506c0a6c605$export$80845f4943675cc2 = `_6h2UNW_container__inputRight__emoj`;
$3897d506c0a6c605$export$e63fc08e2498d5a6 = `_6h2UNW_container__inputRight__mic`;
$3897d506c0a6c605$export$e0a836616ef74fb1 = `_6h2UNW_container__inputRight__send`;
$3897d506c0a6c605$export$1d6a7fa2eaa03615 = `_6h2UNW_emoji_container`;
$3897d506c0a6c605$export$229f8541ff50149b = `_6h2UNW_grid_container`;
$3897d506c0a6c605$export$c358ddc4badb7c84 = `_6h2UNW_grid_item`;
$3897d506c0a6c605$export$8c3b2e5023155b9a = `_6h2UNW_open_panel`;



var $3600d46bdfcd25bf$exports = {};
$3600d46bdfcd25bf$exports = JSON.parse('["\uD83D\uDE42","\uD83D\uDE00","\uD83D\uDE03","\uD83D\uDE04","\uD83D\uDE01","\uD83D\uDE05","\uD83D\uDE06","\uD83E\uDD23","\uD83D\uDE02","\uD83D\uDE43","\uD83D\uDE09","\uD83D\uDE0A","\uD83D\uDE07","\uD83D\uDE0E","\uD83E\uDD13","\uD83E\uDDD0","\uD83E\uDD73","\uD83E\uDD70","\uD83D\uDE0D","\uD83E\uDD29","\uD83D\uDE18","\uD83D\uDE17","\uD83D\uDE1A","\uD83D\uDE19","\uD83D\uDE0B","\uD83D\uDE1B","\uD83D\uDE1C","\uD83E\uDD2A","\uD83D\uDE1D","\uD83E\uDD11","\uD83E\uDD17","\uD83E\uDD2D","\uD83E\uDD2B","\uD83E\uDD14","\uD83D\uDE10","\uD83E\uDD10","\uD83E\uDD28","\uD83D\uDE11","\uD83D\uDE36","\uD83D\uDE0F","\uD83D\uDE12","\uD83D\uDE44","\uD83D\uDE2C","\uD83E\uDD25","\uD83D\uDE2A","\uD83D\uDE34","\uD83D\uDE0C","\uD83D\uDE14","\uD83E\uDD24","\uD83D\uDE37","\uD83E\uDD12","\uD83E\uDD15","\uD83E\uDD22","\uD83E\uDD2E","\uD83E\uDD27","\uD83E\uDD75"]');



var $2cf7055e1164871b$exports = {};
"use strict";
"use client";

Object.defineProperty($2cf7055e1164871b$exports, "__esModule", {
    value: true
});
$2cf7055e1164871b$exports.default = void 0;

var $2cf7055e1164871b$var$_createSvgIcon = $4bfaad0176813de2$exports((parcelRequire("1kJnE")));

var $lBpE3 = parcelRequire("lBpE3");
var $2cf7055e1164871b$var$_default = (0, $2cf7055e1164871b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $lBpE3.jsx)("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
}), "InsertEmoticon");
$2cf7055e1164871b$exports.default = $2cf7055e1164871b$var$_default;




var $a5c56376183b9fcf$exports = {};
"use strict";
"use client";

Object.defineProperty($a5c56376183b9fcf$exports, "__esModule", {
    value: true
});
$a5c56376183b9fcf$exports.default = void 0;

var $a5c56376183b9fcf$var$_createSvgIcon = $4bfaad0176813de2$exports((parcelRequire("1kJnE")));

var $lBpE3 = parcelRequire("lBpE3");
var $a5c56376183b9fcf$var$_default = (0, $a5c56376183b9fcf$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $lBpE3.jsx)("path", {
    d: "M2.01 21 23 12 2.01 3 2 10l15 2-15 2z"
}), "Send");
$a5c56376183b9fcf$exports.default = $a5c56376183b9fcf$var$_default;


var $7df19f29292ddecf$exports = {};
"use strict";
"use client";

Object.defineProperty($7df19f29292ddecf$exports, "__esModule", {
    value: true
});
$7df19f29292ddecf$exports.default = void 0;

var $7df19f29292ddecf$var$_createSvgIcon = $4bfaad0176813de2$exports((parcelRequire("1kJnE")));

var $lBpE3 = parcelRequire("lBpE3");
var $7df19f29292ddecf$var$_default = (0, $7df19f29292ddecf$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $lBpE3.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
$7df19f29292ddecf$exports.default = $7df19f29292ddecf$var$_default;




var $2af592220c7dfcfe$exports = {};
"use strict";
"use client";

Object.defineProperty($2af592220c7dfcfe$exports, "__esModule", {
    value: true
});
$2af592220c7dfcfe$exports.default = void 0;

var $2af592220c7dfcfe$var$_createSvgIcon = $4bfaad0176813de2$exports((parcelRequire("1kJnE")));

var $lBpE3 = parcelRequire("lBpE3");
var $2af592220c7dfcfe$var$_default = (0, $2af592220c7dfcfe$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $lBpE3.jsx)("path", {
    d: "m21.58 16.09-1.09-7.66C20.21 6.46 18.52 5 16.53 5H7.47C5.48 5 3.79 6.46 3.51 8.43l-1.09 7.66C2.2 17.63 3.39 19 4.94 19c.68 0 1.32-.27 1.8-.75L9 16h6l2.25 2.25c.48.48 1.13.75 1.8.75 1.56 0 2.75-1.37 2.53-2.91zM11 11H9v2H8v-2H6v-1h2V8h1v2h2v1zm4-1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
}), "SportsEsports");
$2af592220c7dfcfe$exports.default = $2af592220c7dfcfe$var$_default;




var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $3100aed831e01e11$exports = {};

$parcel$export($3100aed831e01e11$exports, "gameCard", function () { return $3100aed831e01e11$export$a02092af2b19702e; }, function (v) { return $3100aed831e01e11$export$a02092af2b19702e = v; });
$parcel$export($3100aed831e01e11$exports, "playbutton", function () { return $3100aed831e01e11$export$2b80bbb7f2f54380; }, function (v) { return $3100aed831e01e11$export$2b80bbb7f2f54380 = v; });
$parcel$export($3100aed831e01e11$exports, "title", function () { return $3100aed831e01e11$export$fb184b623420d9be; }, function (v) { return $3100aed831e01e11$export$fb184b623420d9be = v; });
var $3100aed831e01e11$export$a02092af2b19702e;
var $3100aed831e01e11$export$2b80bbb7f2f54380;
var $3100aed831e01e11$export$fb184b623420d9be;
$3100aed831e01e11$export$a02092af2b19702e = `hKwaNG_gameCard`;
$3100aed831e01e11$export$2b80bbb7f2f54380 = `hKwaNG_playbutton`;
$3100aed831e01e11$export$fb184b623420d9be = `hKwaNG_title`;




var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");


var $ac698f04cbf7dc13$exports = {};

$parcel$export($ac698f04cbf7dc13$exports, "container", function () { return $ac698f04cbf7dc13$export$34e0f9847d4c02dd; }, function (v) { return $ac698f04cbf7dc13$export$34e0f9847d4c02dd = v; });
var $ac698f04cbf7dc13$export$34e0f9847d4c02dd;
$ac698f04cbf7dc13$export$34e0f9847d4c02dd = `_8y8mQW_container`;




const $e0479fcc28ea666f$var$GameInjector = ({ gameKey: gameKey, onExitCallback: onExitCallback, history: history, location: location })=>{
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const [gameURL, setGameURL] = (0, $6cds3.useState)("");
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(false);
    (0, $6cds3.useEffect)(()=>{
        async function doWork() {
            setIsLoading(true);
            let response = await conquer.Games.getData(gameKey);
            setIsLoading(false);
            let parsedUrl = (0, $b07e5453767f2b67$export$2e2bcd8739ae039).vars.PUBLIC_FULL_URL + "/" + response.web.substring(0, response.web.lastIndexOf("/"));
            setGameURL(parsedUrl);
        }
        doWork();
    }, [
        gameKey
    ]);
    (0, $6cds3.useEffect)(()=>{
        conquer.Signal.get("SKIN:Home", doExit);
        window.addEventListener("popstate", doExit);
        history.push(location.pathname);
    }, []);
    const doExit = ()=>{
        onExitCallback === null || onExitCallback === void 0 ? void 0 : onExitCallback();
        conquer.Signal.remove("SKIN:Home", doExit);
    };
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ac698f04cbf7dc13$exports))).container,
        children: isLoading ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a22e9bdfa443b231$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $lBpE3.jsx)("iframe", {
            src: gameURL
        })
    });
};
var $e0479fcc28ea666f$export$2e2bcd8739ae039 = (0, $cff2dc0cc7b954fc$export$369b6b2b30582e8e)($e0479fcc28ea666f$var$GameInjector);



const $b4d9cd075d4200a0$var$GameCard = ({ gameData: gameData = {}, onClick: onClick })=>{
    const thumbnail = (0, $b07e5453767f2b67$export$2e2bcd8739ae039).vars.PUBLIC_FULL_URL + "/" + gameData.splashLandscape;
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("button", {
            onClick: ()=>{
                onClick === null || onClick === void 0 ? void 0 : onClick(gameData);
            },
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3100aed831e01e11$exports))).gameCard,
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("img", {
                        src: thumbnail
                    })
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("h4", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3100aed831e01e11$exports))).title,
                    children: gameData.name
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3100aed831e01e11$exports))).playbutton,
                    children: "PLAY"
                })
            ]
        })
    });
};
var $b4d9cd075d4200a0$export$2e2bcd8739ae039 = $b4d9cd075d4200a0$var$GameCard;


var $96190474f63297a7$exports = {};

$parcel$export($96190474f63297a7$exports, "gamesGrid", function () { return $96190474f63297a7$export$cef19d9718134143; }, function (v) { return $96190474f63297a7$export$cef19d9718134143 = v; });
var $96190474f63297a7$export$cef19d9718134143;
$96190474f63297a7$export$cef19d9718134143 = `z6L4JG_gamesGrid`;


const $d160d4a789ae9fc1$var$GamesGrid = ({ gamesData: gamesData = [], onGameClick: onGameClick })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($96190474f63297a7$exports))).gamesGrid,
        children: gamesData.map((gameData)=>/*#__PURE__*/ (0, $lBpE3.jsx)((0, $b4d9cd075d4200a0$export$2e2bcd8739ae039), {
                gameData: gameData,
                onClick: onGameClick
            }, gameData.name))
    });
};
var $d160d4a789ae9fc1$export$2e2bcd8739ae039 = $d160d4a789ae9fc1$var$GamesGrid;



var $6PPF0 = parcelRequire("6PPF0");

var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

const $23ce7075e3b2a522$export$588b243cb1e880c7 = /*#__PURE__*/ (0, $6cds3.createContext)();
const $23ce7075e3b2a522$var$GameContextProvider = ({ children: children })=>{
    const [params, setParams] = (0, $6cds3.useState)({});
    function show(params) {
        setParams(params);
    }
    function hide() {
        setParams(false);
    }
    function onExit() {
        let cachedCallback = params.onCloseCallback;
        hide();
        cachedCallback === null || cachedCallback === void 0 ? void 0 : cachedCallback();
    }
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            params.gameKey && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $e0479fcc28ea666f$export$2e2bcd8739ae039), {
                gameKey: params.gameKey,
                onExitCallback: onExit
            }),
            !params.clear && /*#__PURE__*/ (0, $lBpE3.jsx)($23ce7075e3b2a522$export$588b243cb1e880c7.Provider, {
                value: {
                    show: show,
                    hide: hide
                },
                children: children
            })
        ]
    });
};
var $23ce7075e3b2a522$export$2e2bcd8739ae039 = $23ce7075e3b2a522$var$GameContextProvider;



const $ce5b667dcce8db53$var$ChatFooter = ({})=>{
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const chatContext = (0, $6cds3.useContext)((0, $9dd9c06d2f2bed70$export$c67103b336b90275));
    const { show: show, hide: hide } = (0, $6cds3.useContext)((0, $23ce7075e3b2a522$export$588b243cb1e880c7));
    const [inputText, setInputText] = (0, $6cds3.useState)("");
    const [showEmojiBox, setShowEmojiBox] = (0, $6cds3.useState)(false);
    const [showGamesBox, setShowGamesBox] = (0, $6cds3.useState)(false);
    const [gamesData, setGamesData] = (0, $6cds3.useState)([]);
    (0, $6cds3.useEffect)(()=>{
        const LoadGames = async function() {
            let games = await conquer.Games.get();
            setGamesData(games);
        };
        LoadGames();
    });
    const handleKeyDown = (event)=>{
        if (event.key === "Enter") doSendMessage();
    };
    const handleSendButton = ()=>{
        doSendMessage();
    };
    const onGameClick = (gameData)=>{
        chatContext.sendMessage("Let's play " + gameData.name, {
            gameKey: gameData.gameKey
        });
        show({
            gameKey: gameData.gameKey
        });
        setShowGamesBox(false);
    };
    const doSendMessage = async ()=>{
        if (inputText !== "") chatContext.sendMessage(inputText);
        setInputText("");
        setShowEmojiBox(false);
    };
    const handleClickOneEmoji = (emoji)=>{
        setInputText(inputText + emoji);
    };
    const handleEmojiButton = ()=>{
        setShowEmojiBox((prev)=>{
            return !prev;
        });
    };
    const handleGamesButton = ()=>{
        setShowGamesBox((prev)=>{
            return !prev;
        });
    };
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            showEmojiBox && /*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e0a1893f069f0ea4$exports))), {
                onOutsideClick: ()=>{
                    setShowEmojiBox(false);
                },
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($3897d506c0a6c605$exports))).emoji_container, (0, (/*@__PURE__*/$parcel$interopDefault($3897d506c0a6c605$exports))).open_panel),
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3897d506c0a6c605$exports))).grid_container,
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($3600d46bdfcd25bf$exports))).map((emoji)=>{
                            return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($3897d506c0a6c605$exports))).grid_item,
                                onClick: ()=>handleClickOneEmoji(emoji),
                                children: emoji
                            });
                        })
                    })
                })
            }),
            showGamesBox && /*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e0a1893f069f0ea4$exports))), {
                onOutsideClick: ()=>{
                    setShowGamesBox(false);
                },
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($3897d506c0a6c605$exports))).games_container, (0, (/*@__PURE__*/$parcel$interopDefault($3897d506c0a6c605$exports))).open_panel),
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3897d506c0a6c605$exports))).grid_container,
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $d160d4a789ae9fc1$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3897d506c0a6c605$exports))).gamesGridChat,
                            gamesData: gamesData,
                            onGameClick: onGameClick
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3897d506c0a6c605$exports))).container,
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3897d506c0a6c605$exports))).container__inputEmoji,
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                            "aria-label": "emoj",
                            onClick: handleEmojiButton,
                            children: showEmojiBox ? /*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7df19f29292ddecf$exports))), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($3897d506c0a6c605$exports))).container__inputRight__emoj
                            }) : /*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2cf7055e1164871b$exports))), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($3897d506c0a6c605$exports))).container__inputRight__emoj
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3897d506c0a6c605$exports))).container__inputLeft,
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("input", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3897d506c0a6c605$exports))).input,
                            type: "text",
                            name: "message",
                            value: inputText,
                            placeholder: "Start typing...",
                            onKeyDown: handleKeyDown,
                            onChange: (e)=>setInputText(e.target.value)
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3897d506c0a6c605$exports))).container__inputRight,
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                "aria-label": "games",
                                onClick: handleGamesButton,
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2af592220c7dfcfe$exports))), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3897d506c0a6c605$exports))).container__inputRight__send
                                })
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $f1d5dc25ad93042b$export$2e2bcd8739ae039), {
                                "aria-label": "send",
                                onClick: handleSendButton,
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a5c56376183b9fcf$exports))), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3897d506c0a6c605$exports))).container__inputRight__send
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $ce5b667dcce8db53$export$2e2bcd8739ae039 = $ce5b667dcce8db53$var$ChatFooter;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
var $d788d90607f38f11$exports = {};

$parcel$export($d788d90607f38f11$exports, "avatar", function () { return $d788d90607f38f11$export$345c5736c8054f22; }, function (v) { return $d788d90607f38f11$export$345c5736c8054f22 = v; });
$parcel$export($d788d90607f38f11$exports, "container", function () { return $d788d90607f38f11$export$34e0f9847d4c02dd; }, function (v) { return $d788d90607f38f11$export$34e0f9847d4c02dd = v; });
$parcel$export($d788d90607f38f11$exports, "content", function () { return $d788d90607f38f11$export$a7db06668cad9adb; }, function (v) { return $d788d90607f38f11$export$a7db06668cad9adb = v; });
$parcel$export($d788d90607f38f11$exports, "message", function () { return $d788d90607f38f11$export$a8ecead220dd38a6; }, function (v) { return $d788d90607f38f11$export$a8ecead220dd38a6 = v; });
$parcel$export($d788d90607f38f11$exports, "mine", function () { return $d788d90607f38f11$export$25c810edd2c6953a; }, function (v) { return $d788d90607f38f11$export$25c810edd2c6953a = v; });
$parcel$export($d788d90607f38f11$exports, "ownLastMessage", function () { return $d788d90607f38f11$export$142f46c306acca25; }, function (v) { return $d788d90607f38f11$export$142f46c306acca25 = v; });
$parcel$export($d788d90607f38f11$exports, "sharedContent", function () { return $d788d90607f38f11$export$1fc083349ed6401f; }, function (v) { return $d788d90607f38f11$export$1fc083349ed6401f = v; });
$parcel$export($d788d90607f38f11$exports, "sharedImage", function () { return $d788d90607f38f11$export$4f9193978229132c; }, function (v) { return $d788d90607f38f11$export$4f9193978229132c = v; });
$parcel$export($d788d90607f38f11$exports, "sharedText", function () { return $d788d90607f38f11$export$e84122ab3916833a; }, function (v) { return $d788d90607f38f11$export$e84122ab3916833a = v; });
$parcel$export($d788d90607f38f11$exports, "showAvatar", function () { return $d788d90607f38f11$export$7a7b5e92967c534; }, function (v) { return $d788d90607f38f11$export$7a7b5e92967c534 = v; });
$parcel$export($d788d90607f38f11$exports, "time", function () { return $d788d90607f38f11$export$2da9be4cfdb689b1; }, function (v) { return $d788d90607f38f11$export$2da9be4cfdb689b1 = v; });
var $d788d90607f38f11$export$345c5736c8054f22;
var $d788d90607f38f11$export$34e0f9847d4c02dd;
var $d788d90607f38f11$export$a7db06668cad9adb;
var $d788d90607f38f11$export$a8ecead220dd38a6;
var $d788d90607f38f11$export$25c810edd2c6953a;
var $d788d90607f38f11$export$142f46c306acca25;
var $d788d90607f38f11$export$1fc083349ed6401f;
var $d788d90607f38f11$export$4f9193978229132c;
var $d788d90607f38f11$export$e84122ab3916833a;
var $d788d90607f38f11$export$7a7b5e92967c534;
var $d788d90607f38f11$export$2da9be4cfdb689b1;
$d788d90607f38f11$export$345c5736c8054f22 = `_1wsTga_avatar`;
$d788d90607f38f11$export$34e0f9847d4c02dd = `_1wsTga_container`;
$d788d90607f38f11$export$a7db06668cad9adb = `_1wsTga_content`;
$d788d90607f38f11$export$a8ecead220dd38a6 = `_1wsTga_message`;
$d788d90607f38f11$export$25c810edd2c6953a = `_1wsTga_mine`;
$d788d90607f38f11$export$142f46c306acca25 = `_1wsTga_ownLastMessage`;
$d788d90607f38f11$export$1fc083349ed6401f = `_1wsTga_sharedContent`;
$d788d90607f38f11$export$4f9193978229132c = `_1wsTga_sharedImage`;
$d788d90607f38f11$export$e84122ab3916833a = `_1wsTga_sharedText`;
$d788d90607f38f11$export$7a7b5e92967c534 = `_1wsTga_showAvatar`;
$d788d90607f38f11$export$2da9be4cfdb689b1 = `_1wsTga_time`;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");



parcelRequire("6PPF0");


const $49db233a06c1394b$var$ChatMessage = ({ data: data, isOwnLastMessage: isOwnLastMessage })=>{
    data = data.data && typeof data.data != "string" ? data.data : data;
    const chatContext = (0, $6cds3.useContext)((0, $9dd9c06d2f2bed70$export$c67103b336b90275));
    const ownerAvatar = chatContext.avatars[data.avatarID];
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d788d90607f38f11$exports))).avatar,
                children: isOwnLastMessage && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6d7bf74e72bae737$export$2e2bcd8739ae039), {
                    data: ownerAvatar
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d788d90607f38f11$exports))).content,
                children: [
                    " ",
                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                        children: data.text || data.data
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d788d90607f38f11$exports))).time,
                children: data.dateString
            })
        ]
    });
};
var $49db233a06c1394b$export$2e2bcd8739ae039 = $49db233a06c1394b$var$ChatMessage;





var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");



parcelRequire("6PPF0");






const $3dfb76a7ea0f6ce6$var$ChatShare = ({ data: data, isOwnLastMessage: isOwnLastMessage })=>{
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const { show: show, hide: hide } = (0, $6cds3.useContext)((0, $23ce7075e3b2a522$export$588b243cb1e880c7));
    data = data.data && typeof data.data != "string" ? data.data : data;
    const chatContext = (0, $6cds3.useContext)((0, $9dd9c06d2f2bed70$export$c67103b336b90275));
    const ownerAvatar = chatContext.avatars[data.avatarID];
    const [gameData, setGameData] = (0, $6cds3.useState)({});
    (0, $6cds3.useEffect)(()=>{
        async function doWork() {
            let response = await conquer.Games.getData(data.metadata.gameKey);
            response.square = (0, $b07e5453767f2b67$export$2e2bcd8739ae039).vars.PUBLIC_FULL_URL + "/" + response.square;
            setGameData(response);
        }
        doWork();
    }, []);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d788d90607f38f11$exports))).avatar,
                children: isOwnLastMessage && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6d7bf74e72bae737$export$2e2bcd8739ae039), {
                    data: ownerAvatar
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d788d90607f38f11$exports))).sharedContent && (0, (/*@__PURE__*/$parcel$interopDefault($d788d90607f38f11$exports))).content,
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                        onClick: ()=>{
                            show({
                                gameKey: data.metadata.gameKey,
                                clear: false
                            });
                        },
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("img", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($d788d90607f38f11$exports))).sharedImage,
                            src: gameData.square,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($d788d90607f38f11$exports))).sharedText,
                        children: [
                            /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $lBpE3.jsx)("span", {
                                        children: data.text || data.data
                                    }),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($d788d90607f38f11$exports))).time,
                                children: data.dateString
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $3dfb76a7ea0f6ce6$export$2e2bcd8739ae039 = $3dfb76a7ea0f6ce6$var$ChatShare;



var $6PPF0 = parcelRequire("6PPF0");
const $411a234f42f90080$var$ChatMessages = ({})=>{
    const chatContext = (0, $6cds3.useContext)((0, $9dd9c06d2f2bed70$export$c67103b336b90275));
    const userContext = (0, $6cds3.useContext)((0, $260d68481938071c$export$38ee920e59704589));
    function checkIfIsLastMessage(index, data) {
        if (index == 0) return true;
        if (chatContext.messages[index - 1].avatarID != data.avatarID) return true;
        return false;
    }
    function isToday(dateToCompare) {
        const today = new Date();
        return dateToCompare.getDate() == today.getDate() && dateToCompare.getMonth() == today.getMonth() && dateToCompare.getFullYear() == today.getFullYear();
    }
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d788d90607f38f11$exports))).container,
        children: chatContext.messages && chatContext.messages.map((message, index)=>{
            const isME = message.avatarID == userContext.userData.avatarID;
            const isOwnLastMessage = checkIfIsLastMessage(index, message);
            const isLastMessage = index == 0;
            const showAvatar = isOwnLastMessage && !isLastMessage && (0, (/*@__PURE__*/$parcel$interopDefault($d788d90607f38f11$exports))).ownLastMessage;
            let component;
            let date = new Date(message.timestamp);
            message.dateString = isToday(date) ? "Today " + date.toLocaleTimeString(undefined, {
                timeStyle: "short"
            }) : date.toLocaleString(undefined, {
                dateStyle: "short",
                timeStyle: "short"
            });
            if (!message.metadata) component = /*#__PURE__*/ (0, $lBpE3.jsx)((0, $49db233a06c1394b$export$2e2bcd8739ae039), {
                data: message,
                isOwnLastMessage: isOwnLastMessage
            });
            else component = /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3dfb76a7ea0f6ce6$export$2e2bcd8739ae039), {
                data: message,
                isOwnLastMessage: isOwnLastMessage
            });
            return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($d788d90607f38f11$exports))).message, isME && (0, (/*@__PURE__*/$parcel$interopDefault($d788d90607f38f11$exports))).mine, showAvatar && (0, (/*@__PURE__*/$parcel$interopDefault($d788d90607f38f11$exports))).showAvatar),
                children: component
            }, index);
        })
    });
};
var $411a234f42f90080$export$2e2bcd8739ae039 = $411a234f42f90080$var$ChatMessages;


const $4e3e775865eb4955$var$ChatContent = ({ onBackCallback: onBackCallback })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a96ef94ef7a08820$exports))).main_container,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4e49aa9497b308a3$export$2e2bcd8739ae039), {
                onBackCallback: onBackCallback
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $411a234f42f90080$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ce5b667dcce8db53$export$2e2bcd8739ae039), {})
        ]
    });
};
var $4e3e775865eb4955$export$2e2bcd8739ae039 = $4e3e775865eb4955$var$ChatContent;




var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
var $d9bd7c8254789df4$exports = {};

$parcel$export($d9bd7c8254789df4$exports, "container", function () { return $d9bd7c8254789df4$export$34e0f9847d4c02dd; }, function (v) { return $d9bd7c8254789df4$export$34e0f9847d4c02dd = v; });
var $d9bd7c8254789df4$export$34e0f9847d4c02dd;
$d9bd7c8254789df4$export$34e0f9847d4c02dd = `HSVZfq_container`;



const $f6cde27869d70e02$var$WelcomeMessage = ({ isLoading: isLoading })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d9bd7c8254789df4$exports))).container,
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                children: "Welcome!"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                children: "Select a friend to start chatting!"
            }),
            isLoading && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a22e9bdfa443b231$export$2e2bcd8739ae039), {})
        ]
    });
};
var $f6cde27869d70e02$export$2e2bcd8739ae039 = $f6cde27869d70e02$var$WelcomeMessage;






const $88d30e180adec12f$var$Chat = ({ simple: simple, history: history })=>{
    const userContext = (0, $6cds3.useContext)((0, $260d68481938071c$export$38ee920e59704589));
    const { friendID: friendID } = (0, $cff2dc0cc7b954fc$export$99eaa27ddbbb95ef)();
    const [roomKey, setRoomKey] = (0, $6cds3.useState)(false);
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(false);
    async function onFriendSelected(friendData) {
        if (!friendData) {
            history.push("/chat");
            return false;
        }
        if (friendData.status != "active") {
            setRoomKey(false);
            return false;
        }
        // if (!userContext.userData.isLogged) return false;
        if (simple) history.push("/chat/" + friendData.avatarID);
        setRoomKey([
            friendData.avatarID
        ]);
        return true;
    }
    function onLoadingStateChange(newIsLoading) {
        setIsLoading(newIsLoading);
    }
    function onBackCallback() {
        setRoomKey(false);
    }
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($ea3ac5dab7415ac7$exports))).container, simple && (0, (/*@__PURE__*/$parcel$interopDefault($ea3ac5dab7415ac7$exports))).simple),
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ea3ac5dab7415ac7$exports))).column_messages,
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $e3dc9a043b396d07$export$2e2bcd8739ae039), {
                    onSelected: onFriendSelected,
                    initialSelectedFriend: friendID,
                    simple: simple
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($ea3ac5dab7415ac7$exports))).column_chat, roomKey && (0, (/*@__PURE__*/$parcel$interopDefault($ea3ac5dab7415ac7$exports))).active),
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $9dd9c06d2f2bed70$export$2e2bcd8739ae039), {
                    isLoadingCallback: onLoadingStateChange,
                    roomKeys: roomKey,
                    isPersistent: true,
                    children: !isLoading && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4e3e775865eb4955$export$2e2bcd8739ae039), {
                        onBackCallback: onBackCallback
                    })
                })
            })
        ]
    });
};
var $88d30e180adec12f$export$2e2bcd8739ae039 = (0, $cff2dc0cc7b954fc$export$369b6b2b30582e8e)($88d30e180adec12f$var$Chat);


const $a8cd7ad3ca45ec97$var$Leftbar = ({ children: children, history: history, location: location, className: className })=>{
    const isChat = location.pathname.includes("chat");
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("nav", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($bbb668af7bc774ac$exports))).navContainer, className, !isChat && (0, (/*@__PURE__*/$parcel$interopDefault($bbb668af7bc774ac$exports))).simple)
        })
    });
};
var $a8cd7ad3ca45ec97$export$2e2bcd8739ae039 = (0, $cff2dc0cc7b954fc$export$369b6b2b30582e8e)($a8cd7ad3ca45ec97$var$Leftbar);



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
var $9f8051c12610e649$export$89da14300d534261;
var $9f8051c12610e649$export$345c5736c8054f22;
var $9f8051c12610e649$export$d927737047eb3867;
var $9f8051c12610e649$export$34e0f9847d4c02dd;
var $9f8051c12610e649$export$db3c28d99448dcff;
var $9f8051c12610e649$export$f68e44d881264486;
var $9f8051c12610e649$export$ddb906a32562356c;
$9f8051c12610e649$export$89da14300d534261 = `_3GEwwW_active`;
$9f8051c12610e649$export$345c5736c8054f22 = `_3GEwwW_avatar`;
$9f8051c12610e649$export$d927737047eb3867 = `_3GEwwW_bar`;
$9f8051c12610e649$export$34e0f9847d4c02dd = `_3GEwwW_container`;
$9f8051c12610e649$export$db3c28d99448dcff = `_3GEwwW_logo`;
$9f8051c12610e649$export$f68e44d881264486 = `_3GEwwW_menuitem`;
$9f8051c12610e649$export$ddb906a32562356c = `_3GEwwW_user`;


parcelRequire("6PPF0");





const $3aaebbfb262397c4$var$Rightbar = ({ children: children })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {});
};
var $3aaebbfb262397c4$export$2e2bcd8739ae039 = $3aaebbfb262397c4$var$Rightbar;



var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
var $2683712ed4ffeffb$exports = {};

$parcel$export($2683712ed4ffeffb$exports, "footerNav", function () { return $2683712ed4ffeffb$export$b518e15883e48b4c; }, function (v) { return $2683712ed4ffeffb$export$b518e15883e48b4c = v; });
$parcel$export($2683712ed4ffeffb$exports, "notification", function () { return $2683712ed4ffeffb$export$2adf6238a2d0dafa; }, function (v) { return $2683712ed4ffeffb$export$2adf6238a2d0dafa = v; });
$parcel$export($2683712ed4ffeffb$exports, "user", function () { return $2683712ed4ffeffb$export$ddb906a32562356c; }, function (v) { return $2683712ed4ffeffb$export$ddb906a32562356c = v; });
var $2683712ed4ffeffb$export$b518e15883e48b4c;
var $2683712ed4ffeffb$export$2adf6238a2d0dafa;
var $2683712ed4ffeffb$export$ddb906a32562356c;
$2683712ed4ffeffb$export$b518e15883e48b4c = `OIuvaW_footerNav`;
$2683712ed4ffeffb$export$2adf6238a2d0dafa = `OIuvaW_notification`;
$2683712ed4ffeffb$export$ddb906a32562356c = `OIuvaW_user`;



var $6PPF0 = parcelRequire("6PPF0");




const $6b75071be37f420d$var$MobileFooter = ({ className: className, location: location })=>{
    const isChat = location.pathname.includes("chat");
    const isHome = location.pathname == "/";
    const homeIcon = isHome ? "/assets/icon_home.png" : "/assets/icon_home_blue.png";
    const chatIcon = isChat ? "/assets/icon_chat.png" : "/assets/icon_chat_blue.png";
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("nav", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))(className, (0, (/*@__PURE__*/$parcel$interopDefault($2683712ed4ffeffb$exports))).footerNav),
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $60fd0126d8b57f34$export$a6c7ac8248d6e38a), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($2683712ed4ffeffb$exports))).head),
                to: "/",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $df8278a96b606336$export$2e2bcd8739ae039), {
                    src: homeIcon,
                    srcDark: homeIcon
                })
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $89ae40cc09440c69$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2683712ed4ffeffb$exports))).notification
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $c51dc355b0a1efd3$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2683712ed4ffeffb$exports))).user
            })
        ]
    });
};
var $6b75071be37f420d$export$2e2bcd8739ae039 = (0, $cff2dc0cc7b954fc$export$369b6b2b30582e8e)($6b75071be37f420d$var$MobileFooter);




var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
var $d7488025351894d7$exports = {};

$parcel$export($d7488025351894d7$exports, "hide", function () { return $d7488025351894d7$export$fe8985bb6374093c; }, function (v) { return $d7488025351894d7$export$fe8985bb6374093c = v; });
$parcel$export($d7488025351894d7$exports, "preloader", function () { return $d7488025351894d7$export$8ddba6b40106a7ae; }, function (v) { return $d7488025351894d7$export$8ddba6b40106a7ae = v; });
var $d7488025351894d7$export$fe8985bb6374093c;
var $d7488025351894d7$export$8ddba6b40106a7ae;
$d7488025351894d7$export$fe8985bb6374093c = `C4awgG_hide`;
$d7488025351894d7$export$8ddba6b40106a7ae = `C4awgG_preloader`;



var $6PPF0 = parcelRequire("6PPF0");
const $62ef87d33fd89b94$var$Preloader = ({ visibility: visibility = false })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($d7488025351894d7$exports))).preloader, visibility ? "" : (0, (/*@__PURE__*/$parcel$interopDefault($d7488025351894d7$exports))).hide),
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("img", {
            src: "assets/Logo.svg"
        })
    });
};
var $62ef87d33fd89b94$export$2e2bcd8739ae039 = $62ef87d33fd89b94$var$Preloader;







var $6PPF0 = parcelRequire("6PPF0");
const $ceb0b27808fde394$var$Page = ({ noRightBar: noRightBar = true, noLeftBar: noLeftBar = false, children: children })=>{
    const userContext = (0, $6cds3.useContext)((0, $260d68481938071c$export$38ee920e59704589));
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const { show: show, hide: hide } = (0, $6cds3.useContext)((0, $fbd77a4ebafd8162$export$ab57792b9b6974a6));
    (0, $6cds3.useEffect)(()=>{
        window.scrollTo(0, 0);
        (0, $3b4e05b540ea4d30$export$45a3ef215b2a5866)();
    }, [
        location.pathname
    ]);
    (0, $6cds3.useEffect)(()=>{
        function doCheck() {
            if (!userContext.userData.isLogged) return;
            if (userContext.userData.isVerified) return hide();
            show({
                content: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $b87228da460983d8$export$2e2bcd8739ae039), {
                    email: userContext.userData.username
                }),
                title: "Verify Email",
                closeButton: false,
                closeOutside: false
            });
        }
        doCheck();
    }, [
        userContext.userData
    ]);
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($59054c12ba7db3de$exports))).page),
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $62ef87d33fd89b94$export$2e2bcd8739ae039), {
                visibility: !conquer
            }),
            conquer && /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $7ef34d46dd7dad80$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($59054c12ba7db3de$exports))).inner, location.pathname.includes("chat") && (0, (/*@__PURE__*/$parcel$interopDefault($59054c12ba7db3de$exports))).chat),
                        children: [
                            !noLeftBar && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a8cd7ad3ca45ec97$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($59054c12ba7db3de$exports))).column_left, !location.pathname.includes("chat") && (0, (/*@__PURE__*/$parcel$interopDefault($59054c12ba7db3de$exports))).hide)
                            }),
                            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($59054c12ba7db3de$exports))).column_center,
                                children: children
                            }),
                            !noRightBar && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $2125686102fb0a1f$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($59054c12ba7db3de$exports))).side_section, (0, (/*@__PURE__*/$parcel$interopDefault($59054c12ba7db3de$exports))).column_right),
                                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $3aaebbfb262397c4$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6b75071be37f420d$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $ceb0b27808fde394$export$2e2bcd8739ae039 = (0, $cff2dc0cc7b954fc$export$369b6b2b30582e8e)($ceb0b27808fde394$var$Page);



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $6PPF0 = parcelRequire("6PPF0");
var $49140a8877c83ab1$exports = {};

$parcel$export($49140a8877c83ab1$exports, "avatar", function () { return $49140a8877c83ab1$export$345c5736c8054f22; }, function (v) { return $49140a8877c83ab1$export$345c5736c8054f22 = v; });
$parcel$export($49140a8877c83ab1$exports, "box", function () { return $49140a8877c83ab1$export$827f4ee28efc37; }, function (v) { return $49140a8877c83ab1$export$827f4ee28efc37 = v; });
$parcel$export($49140a8877c83ab1$exports, "btns", function () { return $49140a8877c83ab1$export$14c07582bada11e3; }, function (v) { return $49140a8877c83ab1$export$14c07582bada11e3 = v; });
$parcel$export($49140a8877c83ab1$exports, "button", function () { return $49140a8877c83ab1$export$2ba01fb71ed41cb6; }, function (v) { return $49140a8877c83ab1$export$2ba01fb71ed41cb6 = v; });
$parcel$export($49140a8877c83ab1$exports, "category", function () { return $49140a8877c83ab1$export$657ee1858213601f; }, function (v) { return $49140a8877c83ab1$export$657ee1858213601f = v; });
$parcel$export($49140a8877c83ab1$exports, "clear", function () { return $49140a8877c83ab1$export$42ffd38884aecdac; }, function (v) { return $49140a8877c83ab1$export$42ffd38884aecdac = v; });
$parcel$export($49140a8877c83ab1$exports, "col", function () { return $49140a8877c83ab1$export$aba86695643891f5; }, function (v) { return $49140a8877c83ab1$export$aba86695643891f5 = v; });
$parcel$export($49140a8877c83ab1$exports, "container", function () { return $49140a8877c83ab1$export$34e0f9847d4c02dd; }, function (v) { return $49140a8877c83ab1$export$34e0f9847d4c02dd = v; });
$parcel$export($49140a8877c83ab1$exports, "details", function () { return $49140a8877c83ab1$export$41ee12f6f6f05843; }, function (v) { return $49140a8877c83ab1$export$41ee12f6f6f05843 = v; });
$parcel$export($49140a8877c83ab1$exports, "field", function () { return $49140a8877c83ab1$export$e0f35d825088c098; }, function (v) { return $49140a8877c83ab1$export$e0f35d825088c098 = v; });
$parcel$export($49140a8877c83ab1$exports, "fieldset", function () { return $49140a8877c83ab1$export$a38812d1aa1302d9; }, function (v) { return $49140a8877c83ab1$export$a38812d1aa1302d9 = v; });
$parcel$export($49140a8877c83ab1$exports, "file", function () { return $49140a8877c83ab1$export$c2a28f090bb0afd6; }, function (v) { return $49140a8877c83ab1$export$c2a28f090bb0afd6 = v; });
$parcel$export($49140a8877c83ab1$exports, "form__title", function () { return $49140a8877c83ab1$export$a90c3fc2db73d8e2; }, function (v) { return $49140a8877c83ab1$export$a90c3fc2db73d8e2 = v; });
$parcel$export($49140a8877c83ab1$exports, "form_divisor", function () { return $49140a8877c83ab1$export$f59a7dbb91e842ab; }, function (v) { return $49140a8877c83ab1$export$f59a7dbb91e842ab = v; });
$parcel$export($49140a8877c83ab1$exports, "info", function () { return $49140a8877c83ab1$export$a80b3bd66acc52ff; }, function (v) { return $49140a8877c83ab1$export$a80b3bd66acc52ff = v; });
$parcel$export($49140a8877c83ab1$exports, "input_button", function () { return $49140a8877c83ab1$export$85eefdceda29f40f; }, function (v) { return $49140a8877c83ab1$export$85eefdceda29f40f = v; });
$parcel$export($49140a8877c83ab1$exports, "item", function () { return $49140a8877c83ab1$export$7061c75fc5af8b7e; }, function (v) { return $49140a8877c83ab1$export$7061c75fc5af8b7e = v; });
$parcel$export($49140a8877c83ab1$exports, "list", function () { return $49140a8877c83ab1$export$8837f4fc672e936d; }, function (v) { return $49140a8877c83ab1$export$8837f4fc672e936d = v; });
$parcel$export($49140a8877c83ab1$exports, "load", function () { return $49140a8877c83ab1$export$11e63f7b0f3d9900; }, function (v) { return $49140a8877c83ab1$export$11e63f7b0f3d9900 = v; });
$parcel$export($49140a8877c83ab1$exports, "loaderContainer", function () { return $49140a8877c83ab1$export$f9f0aa96487d9fcb; }, function (v) { return $49140a8877c83ab1$export$f9f0aa96487d9fcb = v; });
$parcel$export($49140a8877c83ab1$exports, "modal_container", function () { return $49140a8877c83ab1$export$b0e0fdbd3d5b5a34; }, function (v) { return $49140a8877c83ab1$export$b0e0fdbd3d5b5a34 = v; });
$parcel$export($49140a8877c83ab1$exports, "note", function () { return $49140a8877c83ab1$export$a92e4c44d367d0af; }, function (v) { return $49140a8877c83ab1$export$a92e4c44d367d0af = v; });
$parcel$export($49140a8877c83ab1$exports, "photo_edit_container", function () { return $49140a8877c83ab1$export$512e50a5acca2101; }, function (v) { return $49140a8877c83ab1$export$512e50a5acca2101 = v; });
$parcel$export($49140a8877c83ab1$exports, "profile_image", function () { return $49140a8877c83ab1$export$dad045a851781611; }, function (v) { return $49140a8877c83ab1$export$dad045a851781611 = v; });
$parcel$export($49140a8877c83ab1$exports, "row", function () { return $49140a8877c83ab1$export$120ff0929b202a6d; }, function (v) { return $49140a8877c83ab1$export$120ff0929b202a6d = v; });
$parcel$export($49140a8877c83ab1$exports, "stage", function () { return $49140a8877c83ab1$export$dcd5b5e093923286; }, function (v) { return $49140a8877c83ab1$export$dcd5b5e093923286 = v; });
$parcel$export($49140a8877c83ab1$exports, "text", function () { return $49140a8877c83ab1$export$6f093cfa640b7166; }, function (v) { return $49140a8877c83ab1$export$6f093cfa640b7166 = v; });
$parcel$export($49140a8877c83ab1$exports, "title", function () { return $49140a8877c83ab1$export$fb184b623420d9be; }, function (v) { return $49140a8877c83ab1$export$fb184b623420d9be = v; });
$parcel$export($49140a8877c83ab1$exports, "top", function () { return $49140a8877c83ab1$export$1e95b668f3b82d; }, function (v) { return $49140a8877c83ab1$export$1e95b668f3b82d = v; });
$parcel$export($49140a8877c83ab1$exports, "user", function () { return $49140a8877c83ab1$export$ddb906a32562356c; }, function (v) { return $49140a8877c83ab1$export$ddb906a32562356c = v; });
var $49140a8877c83ab1$export$345c5736c8054f22;
var $49140a8877c83ab1$export$827f4ee28efc37;
var $49140a8877c83ab1$export$14c07582bada11e3;
var $49140a8877c83ab1$export$2ba01fb71ed41cb6;
var $49140a8877c83ab1$export$657ee1858213601f;
var $49140a8877c83ab1$export$42ffd38884aecdac;
var $49140a8877c83ab1$export$aba86695643891f5;
var $49140a8877c83ab1$export$34e0f9847d4c02dd;
var $49140a8877c83ab1$export$41ee12f6f6f05843;
var $49140a8877c83ab1$export$e0f35d825088c098;
var $49140a8877c83ab1$export$a38812d1aa1302d9;
var $49140a8877c83ab1$export$c2a28f090bb0afd6;
var $49140a8877c83ab1$export$a90c3fc2db73d8e2;
var $49140a8877c83ab1$export$f59a7dbb91e842ab;
var $49140a8877c83ab1$export$a80b3bd66acc52ff;
var $49140a8877c83ab1$export$85eefdceda29f40f;
var $49140a8877c83ab1$export$7061c75fc5af8b7e;
var $49140a8877c83ab1$export$8837f4fc672e936d;
var $49140a8877c83ab1$export$11e63f7b0f3d9900;
var $49140a8877c83ab1$export$f9f0aa96487d9fcb;
var $49140a8877c83ab1$export$b0e0fdbd3d5b5a34;
var $49140a8877c83ab1$export$a92e4c44d367d0af;
var $49140a8877c83ab1$export$512e50a5acca2101;
var $49140a8877c83ab1$export$dad045a851781611;
var $49140a8877c83ab1$export$120ff0929b202a6d;
var $49140a8877c83ab1$export$dcd5b5e093923286;
var $49140a8877c83ab1$export$6f093cfa640b7166;
var $49140a8877c83ab1$export$fb184b623420d9be;
var $49140a8877c83ab1$export$1e95b668f3b82d;
var $49140a8877c83ab1$export$ddb906a32562356c;
$49140a8877c83ab1$export$345c5736c8054f22 = `AAP7Qa_avatar`;
$49140a8877c83ab1$export$827f4ee28efc37 = `AAP7Qa_box`;
$49140a8877c83ab1$export$14c07582bada11e3 = `AAP7Qa_btns`;
$49140a8877c83ab1$export$2ba01fb71ed41cb6 = `AAP7Qa_button`;
$49140a8877c83ab1$export$657ee1858213601f = `AAP7Qa_category`;
$49140a8877c83ab1$export$42ffd38884aecdac = `AAP7Qa_clear`;
$49140a8877c83ab1$export$aba86695643891f5 = `AAP7Qa_col`;
$49140a8877c83ab1$export$34e0f9847d4c02dd = `AAP7Qa_container`;
$49140a8877c83ab1$export$41ee12f6f6f05843 = `AAP7Qa_details`;
$49140a8877c83ab1$export$e0f35d825088c098 = `AAP7Qa_field`;
$49140a8877c83ab1$export$a38812d1aa1302d9 = `AAP7Qa_fieldset`;
$49140a8877c83ab1$export$c2a28f090bb0afd6 = `AAP7Qa_file`;
$49140a8877c83ab1$export$a90c3fc2db73d8e2 = `AAP7Qa_form__title`;
$49140a8877c83ab1$export$f59a7dbb91e842ab = `AAP7Qa_form_divisor`;
$49140a8877c83ab1$export$a80b3bd66acc52ff = `AAP7Qa_info`;
$49140a8877c83ab1$export$85eefdceda29f40f = `AAP7Qa_input_button`;
$49140a8877c83ab1$export$7061c75fc5af8b7e = `AAP7Qa_item`;
$49140a8877c83ab1$export$8837f4fc672e936d = `AAP7Qa_list`;
$49140a8877c83ab1$export$11e63f7b0f3d9900 = `AAP7Qa_load`;
$49140a8877c83ab1$export$f9f0aa96487d9fcb = `AAP7Qa_loaderContainer`;
$49140a8877c83ab1$export$b0e0fdbd3d5b5a34 = `AAP7Qa_modal_container`;
$49140a8877c83ab1$export$a92e4c44d367d0af = `AAP7Qa_note`;
$49140a8877c83ab1$export$512e50a5acca2101 = `AAP7Qa_photo_edit_container`;
$49140a8877c83ab1$export$dad045a851781611 = `AAP7Qa_profile_image`;
$49140a8877c83ab1$export$120ff0929b202a6d = `AAP7Qa_row`;
$49140a8877c83ab1$export$dcd5b5e093923286 = `AAP7Qa_stage`;
$49140a8877c83ab1$export$6f093cfa640b7166 = `AAP7Qa_text`;
$49140a8877c83ab1$export$fb184b623420d9be = `AAP7Qa_title`;
$49140a8877c83ab1$export$1e95b668f3b82d = `AAP7Qa_top`;
$49140a8877c83ab1$export$ddb906a32562356c = `AAP7Qa_user`;




var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");

var $6PPF0 = parcelRequire("6PPF0");
var $f6bc54e6cb612dc8$exports = {};

$parcel$export($f6bc54e6cb612dc8$exports, "label", function () { return $f6bc54e6cb612dc8$export$1237798dc640739a; }, function (v) { return $f6bc54e6cb612dc8$export$1237798dc640739a = v; });
$parcel$export($f6bc54e6cb612dc8$exports, "textarea", function () { return $f6bc54e6cb612dc8$export$a3574df893ffa88d; }, function (v) { return $f6bc54e6cb612dc8$export$a3574df893ffa88d = v; });
var $f6bc54e6cb612dc8$export$1237798dc640739a;
var $f6bc54e6cb612dc8$export$a3574df893ffa88d;
$f6bc54e6cb612dc8$export$1237798dc640739a = `_3OJPBq_label`;
$f6bc54e6cb612dc8$export$a3574df893ffa88d = `_3OJPBq_textarea`;


const $e2098e9aadd392ac$var$TextArea = ({ className: className, label: label, ...props })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($f6bc54e6cb612dc8$exports))).field, className),
        children: [
            label && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f6bc54e6cb612dc8$exports))).label,
                children: label
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f6bc54e6cb612dc8$exports))).wrap,
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("textarea", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f6bc54e6cb612dc8$exports))).textarea,
                    ...props
                })
            })
        ]
    });
};
var $e2098e9aadd392ac$export$2e2bcd8739ae039 = $e2098e9aadd392ac$var$TextArea;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");




parcelRequire("6PPF0");


const $765fb83a1a620ff6$var$EmailSection = ()=>{
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const userContext = (0, $6cds3.useContext)((0, $260d68481938071c$export$38ee920e59704589));
    const { show: show, hide: hide } = (0, $6cds3.useContext)((0, $fbd77a4ebafd8162$export$ab57792b9b6974a6));
    const [email, setEmail] = (0, $6cds3.useState)(userContext.userData.email);
    const [error, setError] = (0, $6cds3.useState)("");
    async function tryToChangeEmail() {
        showError("");
        if (!/\S+@\S+\.\S+/.test(email)) return showError("The email doesnt have a valid format");
        let emailChangeResponse = await conquer.Email.change(email);
        if (emailChangeResponse.error) return showError(emailChangeResponse.error);
        show({
            content: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $b87228da460983d8$export$2e2bcd8739ae039), {
                onFinishCallback: hide,
                email: email
            }),
            title: "Verify Email"
        });
    }
    function showError(message) {
        setError(message);
        return false;
    }
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $742193a6f0a9c5fe$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).field,
                label: "Change Email",
                name: "email",
                type: "email",
                placeholder: "Enter Email",
                onChange: (event)=>{
                    setEmail(event.target.value);
                },
                required: true,
                value: email
            }),
            error && /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                className: "error",
                children: error
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: "btn_container",
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                    className: "button",
                    onClick: tryToChangeEmail,
                    children: "Change Email"
                })
            })
        ]
    });
};
var $765fb83a1a620ff6$export$2e2bcd8739ae039 = $765fb83a1a620ff6$var$EmailSection;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");





var $6PPF0 = parcelRequire("6PPF0");


const $31806003a61d6124$var$PasswordSection = ()=>{
    const { show: show, hide: hide } = (0, $6cds3.useContext)((0, $fbd77a4ebafd8162$export$ab57792b9b6974a6));
    const userContext = (0, $6cds3.useContext)((0, $260d68481938071c$export$38ee920e59704589));
    function tryToChangePassword() {
        console.log(userContext.userData);
        show({
            content: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ff076cc56efa415f$export$2e2bcd8739ae039), {
                customEmail: userContext.userData.email,
                onFinishCallback: hide
            }),
            title: "Change Password"
        });
    }
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
        children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))("button", (0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).button),
            onClick: tryToChangePassword,
            children: "Change Password"
        })
    });
};
var $31806003a61d6124$export$2e2bcd8739ae039 = $31806003a61d6124$var$PasswordSection;






const $4eadc04625a0fba7$var$ProfileEdit = ()=>{
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const userContext = (0, $6cds3.useContext)((0, $260d68481938071c$export$38ee920e59704589));
    const userData = userContext && userContext.userData ? userContext.userData : {};
    const [firstName, setFirstname] = (0, $6cds3.useState)(userData.firstName || "");
    const [lastName, setLastname] = (0, $6cds3.useState)(userData.lastName || "");
    const [bio, setBio] = (0, $6cds3.useState)(userData.bio || "");
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(false);
    function doLogout() {
        if (!userData.isLogged) return;
        conquer.Auth.logout();
        userContext.refresh();
    }
    async function updateProfile() {
        if (!userData.isLogged) return;
        setIsLoading(true);
        let response = await conquer.Avatars.ME.change({
            bio: bio,
            firstName: firstName,
            lastName: lastName
        });
        setIsLoading(false);
    }
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).container),
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).top,
                children: /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))("h2", (0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).title),
                    children: "Profile"
                })
            }),
            isLoading && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).loaderContainer,
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a22e9bdfa443b231$export$2e2bcd8739ae039), {})
            }),
            !isLoading && /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).row,
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).user,
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).avatar,
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6d7bf74e72bae737$export$2e2bcd8739ae039), {
                                fallbackToMe: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).col,
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).list,
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).item,
                                    children: [
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).fieldset,
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)((0, $742193a6f0a9c5fe$export$2e2bcd8739ae039), {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).field,
                                                    label: "Firstname",
                                                    name: "firstname",
                                                    type: "text",
                                                    placeholder: "Enter your firstname",
                                                    required: true,
                                                    value: firstName,
                                                    onChange: (event)=>{
                                                        setFirstname(event.target.value);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)((0, $742193a6f0a9c5fe$export$2e2bcd8739ae039), {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).field,
                                                    label: "Lastname",
                                                    name: "lastname",
                                                    type: "text",
                                                    placeholder: "Enter your lastname",
                                                    required: true,
                                                    value: lastName,
                                                    onChange: (event)=>{
                                                        setLastname(event.target.value);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)((0, $e2098e9aadd392ac$export$2e2bcd8739ae039), {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).field,
                                                    label: "Bio",
                                                    name: "Bio",
                                                    placeholder: "About yourself in a few words",
                                                    required: "required",
                                                    value: bio,
                                                    onChange: (event)=>{
                                                        setBio(event.target.value);
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).btns,
                                            children: [
                                                /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))("button", (0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).button),
                                                    onClick: updateProfile,
                                                    children: "Update Profile"
                                                }),
                                                /*#__PURE__*/ (0, $lBpE3.jsx)((0, $31806003a61d6124$export$2e2bcd8739ae039), {})
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).item,
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).fieldset,
                                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $765fb83a1a620ff6$export$2e2bcd8739ae039), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($49140a8877c83ab1$exports))).item, "btn_container"),
                                    children: /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))("button", "secondary"),
                                        onClick: doLogout,
                                        children: "Logout"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $4eadc04625a0fba7$export$2e2bcd8739ae039 = $4eadc04625a0fba7$var$ProfileEdit;



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $d7b59d5432c941ca$exports = {};

$parcel$export($d7b59d5432c941ca$exports, "gameContainer", function () { return $d7b59d5432c941ca$export$2db4b18a983ed9e5; }, function (v) { return $d7b59d5432c941ca$export$2db4b18a983ed9e5 = v; });
$parcel$export($d7b59d5432c941ca$exports, "gamesGrid", function () { return $d7b59d5432c941ca$export$cef19d9718134143; }, function (v) { return $d7b59d5432c941ca$export$cef19d9718134143 = v; });
$parcel$export($d7b59d5432c941ca$exports, "trending", function () { return $d7b59d5432c941ca$export$b48acbb431ee271a; }, function (v) { return $d7b59d5432c941ca$export$b48acbb431ee271a = v; });
$parcel$export($d7b59d5432c941ca$exports, "trendingTitle", function () { return $d7b59d5432c941ca$export$ebb26b6a2b4b2dfe; }, function (v) { return $d7b59d5432c941ca$export$ebb26b6a2b4b2dfe = v; });
var $d7b59d5432c941ca$export$2db4b18a983ed9e5;
var $d7b59d5432c941ca$export$cef19d9718134143;
var $d7b59d5432c941ca$export$b48acbb431ee271a;
var $d7b59d5432c941ca$export$ebb26b6a2b4b2dfe;
$d7b59d5432c941ca$export$2db4b18a983ed9e5 = `CltKYG_gameContainer`;
$d7b59d5432c941ca$export$cef19d9718134143 = `CltKYG_gamesGrid`;
$d7b59d5432c941ca$export$b48acbb431ee271a = `CltKYG_trending`;
$d7b59d5432c941ca$export$ebb26b6a2b4b2dfe = `CltKYG_trendingTitle`;




var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");



var $cff167e85a694661$exports = {};

$parcel$export($cff167e85a694661$exports, "container", function () { return $cff167e85a694661$export$34e0f9847d4c02dd; }, function (v) { return $cff167e85a694661$export$34e0f9847d4c02dd = v; });
var $cff167e85a694661$export$34e0f9847d4c02dd;
$cff167e85a694661$export$34e0f9847d4c02dd = `_1A59pW_container`;


const $cac30e3739c3e086$var$GameChat = ({ gameKey: gameKey })=>{
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(false);
    function onLoadingStateChange(newIsLoading) {
        setIsLoading(newIsLoading);
    }
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($cff167e85a694661$exports))).container,
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $9dd9c06d2f2bed70$export$2e2bcd8739ae039), {
            isLoadingCallback: onLoadingStateChange,
            roomKeys: gameKey,
            isPersistent: false,
            children: [
                isLoading && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a22e9bdfa443b231$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4e3e775865eb4955$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $cac30e3739c3e086$export$2e2bcd8739ae039 = $cac30e3739c3e086$var$GameChat;







var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
var $a71514309562ed1d$exports = {};

$parcel$export($a71514309562ed1d$exports, "addbutton", function () { return $a71514309562ed1d$export$e01cbee4f2dfc9e1; }, function (v) { return $a71514309562ed1d$export$e01cbee4f2dfc9e1 = v; });
$parcel$export($a71514309562ed1d$exports, "buttonbox", function () { return $a71514309562ed1d$export$22534e017b88a22; }, function (v) { return $a71514309562ed1d$export$22534e017b88a22 = v; });
$parcel$export($a71514309562ed1d$exports, "column", function () { return $a71514309562ed1d$export$4e0c71f277ca26b3; }, function (v) { return $a71514309562ed1d$export$4e0c71f277ca26b3 = v; });
$parcel$export($a71514309562ed1d$exports, "container", function () { return $a71514309562ed1d$export$34e0f9847d4c02dd; }, function (v) { return $a71514309562ed1d$export$34e0f9847d4c02dd = v; });
$parcel$export($a71514309562ed1d$exports, "container__hero", function () { return $a71514309562ed1d$export$58205443e9729425; }, function (v) { return $a71514309562ed1d$export$58205443e9729425 = v; });
$parcel$export($a71514309562ed1d$exports, "hero", function () { return $a71514309562ed1d$export$124049a9e3d0d4c3; }, function (v) { return $a71514309562ed1d$export$124049a9e3d0d4c3 = v; });
$parcel$export($a71514309562ed1d$exports, "overlayActioner", function () { return $a71514309562ed1d$export$983cd585a2758c18; }, function (v) { return $a71514309562ed1d$export$983cd585a2758c18 = v; });
$parcel$export($a71514309562ed1d$exports, "playbutton", function () { return $a71514309562ed1d$export$2b80bbb7f2f54380; }, function (v) { return $a71514309562ed1d$export$2b80bbb7f2f54380 = v; });
$parcel$export($a71514309562ed1d$exports, "player", function () { return $a71514309562ed1d$export$615455393ee443ca; }, function (v) { return $a71514309562ed1d$export$615455393ee443ca = v; });
$parcel$export($a71514309562ed1d$exports, "player__comment", function () { return $a71514309562ed1d$export$e136e268542644da; }, function (v) { return $a71514309562ed1d$export$e136e268542644da = v; });
$parcel$export($a71514309562ed1d$exports, "rating", function () { return $a71514309562ed1d$export$8121c87bde23d44; }, function (v) { return $a71514309562ed1d$export$8121c87bde23d44 = v; });
$parcel$export($a71514309562ed1d$exports, "rating__fill", function () { return $a71514309562ed1d$export$ec6ee5eb7a88744e; }, function (v) { return $a71514309562ed1d$export$ec6ee5eb7a88744e = v; });
$parcel$export($a71514309562ed1d$exports, "rating__outline", function () { return $a71514309562ed1d$export$c555b1bef2d2ed40; }, function (v) { return $a71514309562ed1d$export$c555b1bef2d2ed40 = v; });
$parcel$export($a71514309562ed1d$exports, "row", function () { return $a71514309562ed1d$export$120ff0929b202a6d; }, function (v) { return $a71514309562ed1d$export$120ff0929b202a6d = v; });
$parcel$export($a71514309562ed1d$exports, "row__player", function () { return $a71514309562ed1d$export$c23a13f4368f5a4; }, function (v) { return $a71514309562ed1d$export$c23a13f4368f5a4 = v; });
$parcel$export($a71514309562ed1d$exports, "row__player__comment", function () { return $a71514309562ed1d$export$6b76763a9fa6fe48; }, function (v) { return $a71514309562ed1d$export$6b76763a9fa6fe48 = v; });
$parcel$export($a71514309562ed1d$exports, "row__rating", function () { return $a71514309562ed1d$export$c7427fd06bfbc640; }, function (v) { return $a71514309562ed1d$export$c7427fd06bfbc640 = v; });
$parcel$export($a71514309562ed1d$exports, "row__rating__fill", function () { return $a71514309562ed1d$export$8a1e6b7e8a9d3f4d; }, function (v) { return $a71514309562ed1d$export$8a1e6b7e8a9d3f4d = v; });
$parcel$export($a71514309562ed1d$exports, "row__rating__outline", function () { return $a71514309562ed1d$export$7e715173feb9c25c; }, function (v) { return $a71514309562ed1d$export$7e715173feb9c25c = v; });
$parcel$export($a71514309562ed1d$exports, "row__rating__text", function () { return $a71514309562ed1d$export$9d7a5741764ad5e4; }, function (v) { return $a71514309562ed1d$export$9d7a5741764ad5e4 = v; });
$parcel$export($a71514309562ed1d$exports, "sharebutton", function () { return $a71514309562ed1d$export$8dc5a80f26dda36e; }, function (v) { return $a71514309562ed1d$export$8dc5a80f26dda36e = v; });
$parcel$export($a71514309562ed1d$exports, "subtitle", function () { return $a71514309562ed1d$export$c96745152eb2740f; }, function (v) { return $a71514309562ed1d$export$c96745152eb2740f = v; });
$parcel$export($a71514309562ed1d$exports, "text", function () { return $a71514309562ed1d$export$6f093cfa640b7166; }, function (v) { return $a71514309562ed1d$export$6f093cfa640b7166 = v; });
$parcel$export($a71514309562ed1d$exports, "textbox", function () { return $a71514309562ed1d$export$4e4e15c4caa470ab; }, function (v) { return $a71514309562ed1d$export$4e4e15c4caa470ab = v; });
$parcel$export($a71514309562ed1d$exports, "title", function () { return $a71514309562ed1d$export$fb184b623420d9be; }, function (v) { return $a71514309562ed1d$export$fb184b623420d9be = v; });
$parcel$export($a71514309562ed1d$exports, "titlebox", function () { return $a71514309562ed1d$export$b4b629cbcbf56205; }, function (v) { return $a71514309562ed1d$export$b4b629cbcbf56205 = v; });
var $a71514309562ed1d$export$e01cbee4f2dfc9e1;
var $a71514309562ed1d$export$22534e017b88a22;
var $a71514309562ed1d$export$4e0c71f277ca26b3;
var $a71514309562ed1d$export$34e0f9847d4c02dd;
var $a71514309562ed1d$export$58205443e9729425;
var $a71514309562ed1d$export$124049a9e3d0d4c3;
var $a71514309562ed1d$export$983cd585a2758c18;
var $a71514309562ed1d$export$2b80bbb7f2f54380;
var $a71514309562ed1d$export$615455393ee443ca;
var $a71514309562ed1d$export$e136e268542644da;
var $a71514309562ed1d$export$8121c87bde23d44;
var $a71514309562ed1d$export$ec6ee5eb7a88744e;
var $a71514309562ed1d$export$c555b1bef2d2ed40;
var $a71514309562ed1d$export$120ff0929b202a6d;
var $a71514309562ed1d$export$c23a13f4368f5a4;
var $a71514309562ed1d$export$6b76763a9fa6fe48;
var $a71514309562ed1d$export$c7427fd06bfbc640;
var $a71514309562ed1d$export$8a1e6b7e8a9d3f4d;
var $a71514309562ed1d$export$7e715173feb9c25c;
var $a71514309562ed1d$export$9d7a5741764ad5e4;
var $a71514309562ed1d$export$8dc5a80f26dda36e;
var $a71514309562ed1d$export$c96745152eb2740f;
var $a71514309562ed1d$export$6f093cfa640b7166;
var $a71514309562ed1d$export$4e4e15c4caa470ab;
var $a71514309562ed1d$export$fb184b623420d9be;
var $a71514309562ed1d$export$b4b629cbcbf56205;
$a71514309562ed1d$export$e01cbee4f2dfc9e1 = `_5rp5qq_addbutton`;
$a71514309562ed1d$export$22534e017b88a22 = `_5rp5qq_buttonbox`;
$a71514309562ed1d$export$4e0c71f277ca26b3 = `_5rp5qq_column`;
$a71514309562ed1d$export$34e0f9847d4c02dd = `_5rp5qq_container`;
$a71514309562ed1d$export$58205443e9729425 = `_5rp5qq_container__hero`;
$a71514309562ed1d$export$124049a9e3d0d4c3 = `_5rp5qq_hero`;
$a71514309562ed1d$export$983cd585a2758c18 = `_5rp5qq_overlayActioner`;
$a71514309562ed1d$export$2b80bbb7f2f54380 = `_5rp5qq_playbutton`;
$a71514309562ed1d$export$615455393ee443ca = `_5rp5qq_player`;
$a71514309562ed1d$export$e136e268542644da = `_5rp5qq_player__comment`;
$a71514309562ed1d$export$8121c87bde23d44 = `_5rp5qq_rating`;
$a71514309562ed1d$export$ec6ee5eb7a88744e = `_5rp5qq_rating__fill`;
$a71514309562ed1d$export$c555b1bef2d2ed40 = `_5rp5qq_rating__outline`;
$a71514309562ed1d$export$120ff0929b202a6d = `_5rp5qq_row`;
$a71514309562ed1d$export$c23a13f4368f5a4 = `_5rp5qq_row__player`;
$a71514309562ed1d$export$6b76763a9fa6fe48 = `_5rp5qq_row__player__comment`;
$a71514309562ed1d$export$c7427fd06bfbc640 = `_5rp5qq_row__rating`;
$a71514309562ed1d$export$8a1e6b7e8a9d3f4d = `_5rp5qq_row__rating__fill`;
$a71514309562ed1d$export$7e715173feb9c25c = `_5rp5qq_row__rating__outline`;
$a71514309562ed1d$export$9d7a5741764ad5e4 = `_5rp5qq_row__rating__text`;
$a71514309562ed1d$export$8dc5a80f26dda36e = `_5rp5qq_sharebutton`;
$a71514309562ed1d$export$c96745152eb2740f = `_5rp5qq_subtitle`;
$a71514309562ed1d$export$6f093cfa640b7166 = `_5rp5qq_text`;
$a71514309562ed1d$export$4e4e15c4caa470ab = `_5rp5qq_textbox`;
$a71514309562ed1d$export$fb184b623420d9be = `_5rp5qq_title`;
$a71514309562ed1d$export$b4b629cbcbf56205 = `_5rp5qq_titlebox`;









var $6PPF0 = parcelRequire("6PPF0");

const $4cddc92d54ab68fe$var$Hero = ({ game: game, onGameClick: onGameClick })=>{
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {
        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($a71514309562ed1d$exports))).hero,
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)("iframe", {
                    src: "https://www.youtube-nocookie.com/embed/" + game.videoUrl + "?playlist=" + game.videoUrl + "&vq=hd1080&autohide=0&branding=0&cc_load_policy=0&controls=0&fs=0&iv_load_policy=3&modestbranding=1&playsinline=1&rel=0&showinfo=0&wmode=opaque&widgetid=1&autoplay=1&mute=1&version=3&loop=1&origin=https://www.supersnappy.io",
                    allowfullscreen: "false"
                }),
                /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a71514309562ed1d$exports))).titlebox,
                    children: [
                        /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a71514309562ed1d$exports))).subtitle,
                            children: "FEATURED"
                        }),
                        /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($a71514309562ed1d$exports))).title,
                            children: game.name
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))("button", (0, (/*@__PURE__*/$parcel$interopDefault($a71514309562ed1d$exports))).playbutton),
                    onClick: onGameClick,
                    children: "PLAY"
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)("button", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a71514309562ed1d$exports))).overlayActioner,
                    onClick: onGameClick
                })
            ]
        })
    });
};
var $4cddc92d54ab68fe$export$2e2bcd8739ae039 = $4cddc92d54ab68fe$var$Hero;



const $b5568492a65d1c4c$var$NHome = ({ history: history })=>{
    const userData = (0, $6cds3.useContext)((0, $260d68481938071c$export$38ee920e59704589));
    const { show: show, hide: hide } = (0, $6cds3.useContext)((0, $23ce7075e3b2a522$export$588b243cb1e880c7));
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const [gamesData, setGamesData] = (0, $6cds3.useState)([]);
    const [randomGame, setRandomGame] = (0, $6cds3.useState)({});
    (0, $6cds3.useEffect)(()=>{
        const LoadGames = async function() {
            let games = await conquer.Games.get();
            setGamesData(games);
            setRandomGame(games[Math.floor(Math.random() * games.length)]);
        };
        LoadGames();
        console.log("Verified");
    }, []);
    const onGameExit = ()=>{
        conquer.Sounds.stop();
    };
    const onGameClick = (gameData)=>{
        conquer.Sounds.stop();
        // show( {gameKey: gameData.gameKey, clear: true, onCloseCallback: onGameExit} );
        history.push("/game/" + gameData.gameKey);
    };
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4cddc92d54ab68fe$export$2e2bcd8739ae039), {
                game: randomGame,
                onGameClick: ()=>{
                    onGameClick(randomGame);
                }
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("h2", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d7b59d5432c941ca$exports))).trending,
                children: "TRENDING"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("h1", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d7b59d5432c941ca$exports))).trendingTitle,
                children: "#EarlyAccess"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d7b59d5432c941ca$exports))).gamesGrid,
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $d160d4a789ae9fc1$export$2e2bcd8739ae039), {
                    gamesData: gamesData,
                    onGameClick: onGameClick
                })
            })
        ]
    });
};
var $b5568492a65d1c4c$export$2e2bcd8739ae039 = (0, $cff2dc0cc7b954fc$export$369b6b2b30582e8e)($b5568492a65d1c4c$var$NHome);



var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
var $c970f52508eb9898$exports = {};

$parcel$export($c970f52508eb9898$exports, "accordion", function () { return $c970f52508eb9898$export$77f5744dadf9dca6; }, function (v) { return $c970f52508eb9898$export$77f5744dadf9dca6 = v; });
$parcel$export($c970f52508eb9898$exports, "accordion_item", function () { return $c970f52508eb9898$export$ed03eeca709258fd; }, function (v) { return $c970f52508eb9898$export$ed03eeca709258fd = v; });
$parcel$export($c970f52508eb9898$exports, "activities", function () { return $c970f52508eb9898$export$5d47b729ff09b139; }, function (v) { return $c970f52508eb9898$export$5d47b729ff09b139 = v; });
$parcel$export($c970f52508eb9898$exports, "addicon", function () { return $c970f52508eb9898$export$7349f40b213ad05f; }, function (v) { return $c970f52508eb9898$export$7349f40b213ad05f = v; });
$parcel$export($c970f52508eb9898$exports, "avatar", function () { return $c970f52508eb9898$export$345c5736c8054f22; }, function (v) { return $c970f52508eb9898$export$345c5736c8054f22 = v; });
$parcel$export($c970f52508eb9898$exports, "avatar_group", function () { return $c970f52508eb9898$export$b03cd8f013b12fe8; }, function (v) { return $c970f52508eb9898$export$b03cd8f013b12fe8 = v; });
$parcel$export($c970f52508eb9898$exports, "container", function () { return $c970f52508eb9898$export$34e0f9847d4c02dd; }, function (v) { return $c970f52508eb9898$export$34e0f9847d4c02dd = v; });
$parcel$export($c970f52508eb9898$exports, "game", function () { return $c970f52508eb9898$export$119d2a93e2780362; }, function (v) { return $c970f52508eb9898$export$119d2a93e2780362 = v; });
$parcel$export($c970f52508eb9898$exports, "game_header", function () { return $c970f52508eb9898$export$6be184eb260ed9d5; }, function (v) { return $c970f52508eb9898$export$6be184eb260ed9d5 = v; });
$parcel$export($c970f52508eb9898$exports, "gray_box", function () { return $c970f52508eb9898$export$c02ae7d9a5273679; }, function (v) { return $c970f52508eb9898$export$c02ae7d9a5273679 = v; });
$parcel$export($c970f52508eb9898$exports, "iconbox", function () { return $c970f52508eb9898$export$902d7645c73f3b8e; }, function (v) { return $c970f52508eb9898$export$902d7645c73f3b8e = v; });
$parcel$export($c970f52508eb9898$exports, "name", function () { return $c970f52508eb9898$export$a8ff84c12d48cfa6; }, function (v) { return $c970f52508eb9898$export$a8ff84c12d48cfa6 = v; });
$parcel$export($c970f52508eb9898$exports, "namebox", function () { return $c970f52508eb9898$export$6b466d017fa5750e; }, function (v) { return $c970f52508eb9898$export$6b466d017fa5750e = v; });
$parcel$export($c970f52508eb9898$exports, "section_friends", function () { return $c970f52508eb9898$export$3582f36acef0d927; }, function (v) { return $c970f52508eb9898$export$3582f36acef0d927 = v; });
$parcel$export($c970f52508eb9898$exports, "section_picture", function () { return $c970f52508eb9898$export$d84d7008f2349d33; }, function (v) { return $c970f52508eb9898$export$d84d7008f2349d33 = v; });
$parcel$export($c970f52508eb9898$exports, "text_mute", function () { return $c970f52508eb9898$export$d38d5b1321c6c897; }, function (v) { return $c970f52508eb9898$export$d38d5b1321c6c897 = v; });
$parcel$export($c970f52508eb9898$exports, "text_small", function () { return $c970f52508eb9898$export$c1da52be6ae25326; }, function (v) { return $c970f52508eb9898$export$c1da52be6ae25326 = v; });
$parcel$export($c970f52508eb9898$exports, "username", function () { return $c970f52508eb9898$export$5e1be761f603d585; }, function (v) { return $c970f52508eb9898$export$5e1be761f603d585 = v; });
var $c970f52508eb9898$export$77f5744dadf9dca6;
var $c970f52508eb9898$export$ed03eeca709258fd;
var $c970f52508eb9898$export$5d47b729ff09b139;
var $c970f52508eb9898$export$7349f40b213ad05f;
var $c970f52508eb9898$export$345c5736c8054f22;
var $c970f52508eb9898$export$b03cd8f013b12fe8;
var $c970f52508eb9898$export$34e0f9847d4c02dd;
var $c970f52508eb9898$export$119d2a93e2780362;
var $c970f52508eb9898$export$6be184eb260ed9d5;
var $c970f52508eb9898$export$c02ae7d9a5273679;
var $c970f52508eb9898$export$902d7645c73f3b8e;
var $c970f52508eb9898$export$a8ff84c12d48cfa6;
var $c970f52508eb9898$export$6b466d017fa5750e;
var $c970f52508eb9898$export$3582f36acef0d927;
var $c970f52508eb9898$export$d84d7008f2349d33;
var $c970f52508eb9898$export$d38d5b1321c6c897;
var $c970f52508eb9898$export$c1da52be6ae25326;
var $c970f52508eb9898$export$5e1be761f603d585;
$c970f52508eb9898$export$77f5744dadf9dca6 = `ENWioq_accordion`;
$c970f52508eb9898$export$ed03eeca709258fd = `ENWioq_accordion_item`;
$c970f52508eb9898$export$5d47b729ff09b139 = `ENWioq_activities`;
$c970f52508eb9898$export$7349f40b213ad05f = `ENWioq_addicon`;
$c970f52508eb9898$export$345c5736c8054f22 = `ENWioq_avatar`;
$c970f52508eb9898$export$b03cd8f013b12fe8 = `ENWioq_avatar_group`;
$c970f52508eb9898$export$34e0f9847d4c02dd = `ENWioq_container`;
$c970f52508eb9898$export$119d2a93e2780362 = `ENWioq_game`;
$c970f52508eb9898$export$6be184eb260ed9d5 = `ENWioq_game_header`;
$c970f52508eb9898$export$c02ae7d9a5273679 = `ENWioq_gray_box`;
$c970f52508eb9898$export$902d7645c73f3b8e = `ENWioq_iconbox`;
$c970f52508eb9898$export$a8ff84c12d48cfa6 = `ENWioq_name`;
$c970f52508eb9898$export$6b466d017fa5750e = `ENWioq_namebox`;
$c970f52508eb9898$export$3582f36acef0d927 = `ENWioq_section_friends`;
$c970f52508eb9898$export$d84d7008f2349d33 = `ENWioq_section_picture`;
$c970f52508eb9898$export$d38d5b1321c6c897 = `ENWioq_text_mute`;
$c970f52508eb9898$export$c1da52be6ae25326 = `ENWioq_text_small`;
$c970f52508eb9898$export$5e1be761f603d585 = `ENWioq_username`;



var $6PPF0 = parcelRequire("6PPF0");

var $8pKQA = parcelRequire("8pKQA");

var $dpDEA = parcelRequire("dpDEA");

var $6cds3 = parcelRequire("6cds3");


var $aPjpj = parcelRequire("aPjpj");

var $4w6kZ = parcelRequire("4w6kZ");

var $619SG = parcelRequire("619SG");


var $iHVyY = parcelRequire("iHVyY");

var $9ScrR = parcelRequire("9ScrR");
parcelRequire("6cds3");

var $jdf6F = parcelRequire("jdf6F");

var $2aEPG = parcelRequire("2aEPG");

var $hDE6h = parcelRequire("hDE6h");
"use client";
function $e4373026cf7a4827$export$2e2bcd8739ae039() {
    const theme = (0, $jdf6F.default)((0, $2aEPG.default));
    return theme[0, $hDE6h.default] || theme;
}



var $6cds3 = parcelRequire("6cds3");
"use client";
/**
 * @ignore - internal component.
 */ const $df0cf38061935309$var$GridContext = /*#__PURE__*/ $6cds3.createContext();
var $df0cf38061935309$export$2e2bcd8739ae039 = $df0cf38061935309$var$GridContext;



var $3DnVy = parcelRequire("3DnVy");

var $3hxuv = parcelRequire("3hxuv");
function $5d790d538b0439fb$export$9973ac5fd0181f33(slot) {
    return (0, $3hxuv.default)("MuiGrid", slot);
}
const $5d790d538b0439fb$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $5d790d538b0439fb$var$DIRECTIONS = [
    "column-reverse",
    "column",
    "row-reverse",
    "row"
];
const $5d790d538b0439fb$var$WRAPS = [
    "nowrap",
    "wrap-reverse",
    "wrap"
];
const $5d790d538b0439fb$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $5d790d538b0439fb$var$gridClasses = (0, $3DnVy.default)("MuiGrid", [
    "root",
    "container",
    "item",
    "zeroMinWidth",
    // spacings
    ...$5d790d538b0439fb$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$5d790d538b0439fb$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$5d790d538b0439fb$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$5d790d538b0439fb$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$5d790d538b0439fb$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$5d790d538b0439fb$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$5d790d538b0439fb$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$5d790d538b0439fb$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $5d790d538b0439fb$export$2e2bcd8739ae039 = $5d790d538b0439fb$var$gridClasses;



var $lBpE3 = parcelRequire("lBpE3");
"use client";
const $d612865e85810080$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $d612865e85810080$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), "") || "px"}`;
}
function $d612865e85810080$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        else if (size === "auto") styles = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        else {
            const columnsBreakpointValues = (0, $4w6kZ.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== "0px") {
                    const fullWidth = `calc(${width} + ${$d612865e85810080$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $dpDEA.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $d612865e85810080$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $4w6kZ.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $4w6kZ.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf("column") === 0) output[`& > .${(0, $5d790d538b0439fb$export$2e2bcd8739ae039).item}`] = {
            maxWidth: "none"
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $d612865e85810080$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = "";
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== "") return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $d612865e85810080$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $4w6kZ.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === "object") zeroValueBreakpointKeys = $d612865e85810080$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $4w6kZ.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                marginTop: `-${$d612865e85810080$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $5d790d538b0439fb$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $d612865e85810080$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $5d790d538b0439fb$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $d612865e85810080$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $4w6kZ.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === "object") zeroValueBreakpointKeys = $d612865e85810080$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $4w6kZ.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                width: `calc(100% + ${$d612865e85810080$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$d612865e85810080$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $5d790d538b0439fb$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $d612865e85810080$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: "100%",
                marginLeft: 0,
                [`& > .${(0, $5d790d538b0439fb$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $d612865e85810080$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $d612865e85810080$var$GridRoot = (0, $iHVyY.default)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $d612865e85810080$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== "row" && styles[`direction-xs-${String(direction)}`],
            wrap !== "wrap" && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $dpDEA.default)({
        boxSizing: "border-box"
    }, ownerState.container && {
        display: "flex",
        flexWrap: "wrap",
        width: "100%"
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }), $d612865e85810080$export$71d4225eeb1bc13e, $d612865e85810080$export$380604d7c79f9e8f, $d612865e85810080$export$4315fba5128fb4a1, $d612865e85810080$export$ca2a698f6020fda);
function $d612865e85810080$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $d612865e85810080$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $d612865e85810080$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            "root",
            container && "container",
            item && "item",
            zeroMinWidth && "zeroMinWidth",
            ...spacingClasses,
            direction !== "row" && `direction-xs-${String(direction)}`,
            wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $619SG.default)(slots, (0, $5d790d538b0439fb$export$9973ac5fd0181f33), classes);
};
const $d612865e85810080$var$Grid = /*#__PURE__*/ $6cds3.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $9ScrR.default)({
        props: inProps,
        name: "MuiGrid"
    });
    const { breakpoints: breakpoints } = (0, $e4373026cf7a4827$export$2e2bcd8739ae039)();
    const props = (0, $f885dc3e6bc22d53$export$2e2bcd8739ae039)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = "div", container: container = false, direction: direction = "row", item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = "wrap", zeroMinWidth: zeroMinWidth = false } = props, other = (0, $8pKQA.default)(props, $d612865e85810080$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $6cds3.useContext((0, $df0cf38061935309$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $dpDEA.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $dpDEA.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $d612865e85810080$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $df0cf38061935309$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $lBpE3.jsx)($d612865e85810080$var$GridRoot, (0, $dpDEA.default)({
            ownerState: ownerState,
            className: (0, $aPjpj.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $d612865e85810080$export$2e2bcd8739ae039 = $d612865e85810080$var$Grid;


var $863e1c1e149ce97e$exports = {};
"use strict";
"use client";

Object.defineProperty($863e1c1e149ce97e$exports, "__esModule", {
    value: true
});
$863e1c1e149ce97e$exports.default = void 0;

var $863e1c1e149ce97e$var$_createSvgIcon = $4bfaad0176813de2$exports((parcelRequire("1kJnE")));

var $lBpE3 = parcelRequire("lBpE3");
var $863e1c1e149ce97e$var$_default = (0, $863e1c1e149ce97e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $lBpE3.jsx)("path", {
    d: "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
}), "PersonOutlineOutlined");
$863e1c1e149ce97e$exports.default = $863e1c1e149ce97e$var$_default;



var $1SOLG = parcelRequire("1SOLG");

var $lBpE3 = parcelRequire("lBpE3");
"use client";
var $58fff0a83463d92a$export$2e2bcd8739ae039 = (0, $1SOLG.default)(/*#__PURE__*/ (0, $lBpE3.jsx)("path", {
    d: "m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"
}), "Logout");





var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
var $5c65493ad09ccbd0$exports = {};

$parcel$export($5c65493ad09ccbd0$exports, "accordion_item", function () { return $5c65493ad09ccbd0$export$ed03eeca709258fd; }, function (v) { return $5c65493ad09ccbd0$export$ed03eeca709258fd = v; });
var $5c65493ad09ccbd0$export$ed03eeca709258fd;
$5c65493ad09ccbd0$export$ed03eeca709258fd = `CQ6v0q_accordion_item`;



var $87de578cff10d8ec$exports = {};
"use strict";
"use client";

Object.defineProperty($87de578cff10d8ec$exports, "__esModule", {
    value: true
});
$87de578cff10d8ec$exports.default = void 0;

var $87de578cff10d8ec$var$_createSvgIcon = $4bfaad0176813de2$exports((parcelRequire("1kJnE")));

var $lBpE3 = parcelRequire("lBpE3");
var $87de578cff10d8ec$var$_default = (0, $87de578cff10d8ec$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $lBpE3.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "KeyboardArrowRight");
$87de578cff10d8ec$exports.default = $87de578cff10d8ec$var$_default;



var $6PPF0 = parcelRequire("6PPF0");


const $1a6f52029884a665$var$AccountItem = ({ title: title, onClick: onClick, icon: icon, path: path })=>{
    const getContent = ()=>{
        return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $d612865e85810080$export$2e2bcd8739ae039), {
            container: true,
            spacing: 2,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($5c65493ad09ccbd0$exports))).accordion_item),
            children: [
                /*#__PURE__*/ (0, $lBpE3.jsx)((0, $d612865e85810080$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 1,
                    style: {
                        textAlign: "right"
                    },
                    children: icon
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)((0, $d612865e85810080$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 10,
                    children: title
                }),
                /*#__PURE__*/ (0, $lBpE3.jsx)((0, $d612865e85810080$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 1,
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($87de578cff10d8ec$exports))), {})
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
        children: [
            path && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $60fd0126d8b57f34$export$a6c7ac8248d6e38a), {
                to: path,
                className: "link",
                children: getContent()
            }),
            onClick && /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
                onClick: onClick,
                className: "link",
                children: getContent()
            })
        ]
    });
};
var $1a6f52029884a665$export$2e2bcd8739ae039 = $1a6f52029884a665$var$AccountItem;




const $3720f4f6811a1c7d$var$NAccount = ({ children: children })=>{
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const userContext = (0, $6cds3.useContext)((0, $260d68481938071c$export$38ee920e59704589));
    const userData = userContext && userContext.userData ? userContext.userData : {};
    function doLogout() {
        if (!userData.isLogged) return;
        conquer.Auth.logout();
        userContext.refresh();
    }
    return /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c970f52508eb9898$exports))).container,
        children: [
            conquer.isInitialized && !userData.isLogged && /*#__PURE__*/ (0, $lBpE3.jsx)((0, $cff2dc0cc7b954fc$export$2d8d895a0a0f636e), {
                to: "/"
            }),
            /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $d612865e85810080$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $d612865e85810080$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 8,
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c970f52508eb9898$exports))).section_picture,
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)((0, $6d7bf74e72bae737$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $lBpE3.jsx)((0, $d612865e85810080$export$2e2bcd8739ae039), {
                                    container: true,
                                    spacing: 0,
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c970f52508eb9898$exports))).namebox,
                                    children: /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $d612865e85810080$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 10,
                                        style: {
                                            paddingTop: "0px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c970f52508eb9898$exports))).name,
                                                children: userData.firstName
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c970f52508eb9898$exports))).username,
                                                children: userData.username
                                            }),
                                            /*#__PURE__*/ (0, $lBpE3.jsx)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c970f52508eb9898$exports))).text_small,
                                                children: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonum"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $d612865e85810080$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 4
                    }),
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $d612865e85810080$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 8,
                        children: /*#__PURE__*/ (0, $lBpE3.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($6PPF0)))((0, (/*@__PURE__*/$parcel$interopDefault($c970f52508eb9898$exports))).gray_box, (0, (/*@__PURE__*/$parcel$interopDefault($c970f52508eb9898$exports))).accordion),
                            children: [
                                /*#__PURE__*/ (0, $lBpE3.jsx)((0, $1a6f52029884a665$export$2e2bcd8739ae039), {
                                    title: "Edit Account",
                                    icon: /*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($863e1c1e149ce97e$exports))), {}),
                                    path: "/profile-edit"
                                }),
                                /*#__PURE__*/ (0, $lBpE3.jsx)((0, $1a6f52029884a665$export$2e2bcd8739ae039), {
                                    title: "Logout",
                                    icon: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $58fff0a83463d92a$export$2e2bcd8739ae039), {}),
                                    onClick: doLogout
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $3720f4f6811a1c7d$export$2e2bcd8739ae039 = $3720f4f6811a1c7d$var$NAccount;




var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");
var $42500a8ff7acd8f9$export$34e0f9847d4c02dd;
var $42500a8ff7acd8f9$export$fb184b623420d9be;
$42500a8ff7acd8f9$export$34e0f9847d4c02dd = `_8PQIXq_container`;
$42500a8ff7acd8f9$export$fb184b623420d9be = `_8PQIXq_title`;







const $4b28ea78aa7605cb$var$Game = ({ history: history })=>{
    const { show: show, hide: hide } = (0, $6cds3.useContext)((0, $23ce7075e3b2a522$export$588b243cb1e880c7));
    const conquer = (0, $6cds3.useContext)((0, $7e8bea31627b54c7$export$e01a68034b8b230));
    const { gameKey: gameKey } = (0, $cff2dc0cc7b954fc$export$99eaa27ddbbb95ef)();
    // const [ gameData, setGameData ] = useState();
    const LoadGame = async function() {
        let response = await conquer.Games.getData(gameKey);
        console.log("LOAD GAME RESPONSE:", response);
        // setGameData( response );
        if (!response) return goBackToHome();
        show({
            gameKey: gameKey,
            onCloseCallback: goBackToHome,
            clear: true
        });
    };
    (0, $6cds3.useEffect)(()=>{
        LoadGame();
    }, []);
    function goBackToHome() {
        console.log("BACK TO HOME FROM GAME");
        history.push("/");
    }
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {});
// return (
//     <div className={styles.container}>
//         <Hero game={gameData}/>
//         <GameChat gameKey={gameKey}/>
//     </div>
// );
};
var $4b28ea78aa7605cb$export$2e2bcd8739ae039 = (0, $cff2dc0cc7b954fc$export$369b6b2b30582e8e)($4b28ea78aa7605cb$var$Game);







var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");




const $9bfb94483ac68ba4$var$PageContent = ({ children: children, needsLogin: needsLogin })=>{
    const { show: show, hide: hide } = (0, $6cds3.useContext)((0, $fbd77a4ebafd8162$export$ab57792b9b6974a6));
    const userContext = (0, $6cds3.useContext)((0, $260d68481938071c$export$38ee920e59704589));
    const [forceHome, setForceHome] = (0, $6cds3.useState)(false);
    const [isBlocked, setIsBlocked] = (0, $6cds3.useState)(false);
    (0, $6cds3.useEffect)(()=>{
        if (!userContext.userData.isLogged && needsLogin && !isBlocked) {
            show({
                content: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $157bd6031ad0a800$export$2e2bcd8739ae039), {
                    onFinishCallback: hide
                }),
                title: "Login",
                onClose: onClose
            });
            setIsBlocked(true);
        } else if (userContext.userData.isLogged && isBlocked) onClose(), hide();
    }, [
        userContext.userData.isLogged
    ]);
    function onClose() {
        if (!userContext.userData.isLogged) return setForceHome(true);
        setIsBlocked(false);
    }
    if (forceHome) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $cff2dc0cc7b954fc$export$2d8d895a0a0f636e), {
        to: "/"
    });
    if (isBlocked) return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {});
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {
        children: children
    });
};
var $9bfb94483ac68ba4$export$2e2bcd8739ae039 = $9bfb94483ac68ba4$var$PageContent;




function $07c365c5f735c5f3$var$App() {
    const renderRoute = function({ path: path, content: content, needsLogin: needsLogin = false }) {
        return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $cff2dc0cc7b954fc$export$e7b0ac011bb776c6), {
            exact: true,
            path: path,
            render: ({})=>/*#__PURE__*/ (0, $lBpE3.jsx)((0, $9bfb94483ac68ba4$export$2e2bcd8739ae039), {
                    needsLogin: needsLogin,
                    children: content
                })
        }, path);
    };
    return /*#__PURE__*/ (0, $lBpE3.jsx)((0, $7e8bea31627b54c7$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $260d68481938071c$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $fbd77a4ebafd8162$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $f7a30d3cc05f1d27$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $60fd0126d8b57f34$export$9ba4e89fdfa1fc54), {
                        children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $23ce7075e3b2a522$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $ceb0b27808fde394$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $cff2dc0cc7b954fc$export$b5d5cf8927ab7262), {
                                    children: [
                                        renderRoute({
                                            path: "/",
                                            content: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $b5568492a65d1c4c$export$2e2bcd8739ae039), {}),
                                            needsLogin: false
                                        }),
                                        renderRoute({
                                            path: "/profile",
                                            content: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4eadc04625a0fba7$export$2e2bcd8739ae039), {}),
                                            needsLogin: true
                                        }),
                                        renderRoute({
                                            path: "/friends",
                                            content: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $e3dc9a043b396d07$export$2e2bcd8739ae039), {}),
                                            needsLogin: true
                                        }),
                                        renderRoute({
                                            path: "/chat/:friendID?",
                                            content: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $lBpE3.Fragment), {}),
                                            needsLogin: true
                                        }),
                                        renderRoute({
                                            path: "/game/:gameKey?",
                                            content: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $4b28ea78aa7605cb$export$2e2bcd8739ae039), {}),
                                            needsLogin: false
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        })
    });
}
var $07c365c5f735c5f3$export$2e2bcd8739ae039 = $07c365c5f735c5f3$var$App;



var $6cds3 = parcelRequire("6cds3");

var $feaa9a02344f813e$export$638354e3e7cf979c;
(function(ConnectorEvent) {
    ConnectorEvent["Update"] = "Web3ReactUpdate";
    ConnectorEvent["Error"] = "Web3ReactError";
    ConnectorEvent["Deactivate"] = "Web3ReactDeactivate";
})($feaa9a02344f813e$export$638354e3e7cf979c || ($feaa9a02344f813e$export$638354e3e7cf979c = {}));



const $28aebedb0958c5ea$export$83d89fbfd8236492 = "logger/5.7.0";


"use strict";
let $4eebf1ca9f327f54$var$_permanentCensorErrors = false;
let $4eebf1ca9f327f54$var$_censorErrors = false;
const $4eebf1ca9f327f54$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $4eebf1ca9f327f54$var$_logLevel = $4eebf1ca9f327f54$var$LogLevels["default"];
let $4eebf1ca9f327f54$var$_globalLogger = null;
function $4eebf1ca9f327f54$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $4eebf1ca9f327f54$var$_normalizeError = $4eebf1ca9f327f54$var$_checkNormalize();
var $4eebf1ca9f327f54$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($4eebf1ca9f327f54$export$243e62d78d3b544d || ($4eebf1ca9f327f54$export$243e62d78d3b544d = {}));
var $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})($4eebf1ca9f327f54$export$d4e71bc0b80dc0fb || ($4eebf1ca9f327f54$export$d4e71bc0b80dc0fb = {}));
const $4eebf1ca9f327f54$var$HEX = "0123456789abcdef";
class $4eebf1ca9f327f54$export$efa9a398d6368992 {
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($4eebf1ca9f327f54$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($4eebf1ca9f327f54$var$_logLevel > $4eebf1ca9f327f54$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($4eebf1ca9f327f54$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($4eebf1ca9f327f54$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($4eebf1ca9f327f54$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($4eebf1ca9f327f54$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $4eebf1ca9f327f54$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $4eebf1ca9f327f54$var$HEX[value[i] >> 4];
                        hex += $4eebf1ca9f327f54$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $4eebf1ca9f327f54$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($4eebf1ca9f327f54$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $4eebf1ca9f327f54$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $4eebf1ca9f327f54$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $4eebf1ca9f327f54$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $4eebf1ca9f327f54$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $4eebf1ca9f327f54$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $4eebf1ca9f327f54$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $4eebf1ca9f327f54$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $4eebf1ca9f327f54$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $4eebf1ca9f327f54$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$4eebf1ca9f327f54$var$_globalLogger) $4eebf1ca9f327f54$var$_globalLogger = new $4eebf1ca9f327f54$export$efa9a398d6368992((0, $28aebedb0958c5ea$export$83d89fbfd8236492));
        return $4eebf1ca9f327f54$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $4eebf1ca9f327f54$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($4eebf1ca9f327f54$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $4eebf1ca9f327f54$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $4eebf1ca9f327f54$var$_censorErrors = !!censorship;
        $4eebf1ca9f327f54$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $4eebf1ca9f327f54$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $4eebf1ca9f327f54$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $4eebf1ca9f327f54$var$_logLevel = level;
    }
    static from(version) {
        return new $4eebf1ca9f327f54$export$efa9a398d6368992(version);
    }
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
}
$4eebf1ca9f327f54$export$efa9a398d6368992.errors = $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb;
$4eebf1ca9f327f54$export$efa9a398d6368992.levels = $4eebf1ca9f327f54$export$243e62d78d3b544d;


const $a82bd087aad0b6d2$export$83d89fbfd8236492 = "bytes/5.7.0";


"use strict";
const $ddc3d9704a40b613$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $a82bd087aad0b6d2$export$83d89fbfd8236492));
///////////////////////////////
function $ddc3d9704a40b613$var$isHexable(value) {
    return !!value.toHexString;
}
function $ddc3d9704a40b613$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $ddc3d9704a40b613$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $ddc3d9704a40b613$export$9a14abb1a440cd5e(value) {
    return $ddc3d9704a40b613$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $ddc3d9704a40b613$export$c6fabfbfd097fc30(value);
}
function $ddc3d9704a40b613$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $ddc3d9704a40b613$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$ddc3d9704a40b613$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$ddc3d9704a40b613$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $ddc3d9704a40b613$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $ddc3d9704a40b613$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $ddc3d9704a40b613$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($ddc3d9704a40b613$var$isHexable(value)) value = value.toHexString();
    if ($ddc3d9704a40b613$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $ddc3d9704a40b613$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $ddc3d9704a40b613$var$addSlice(new Uint8Array(result));
    }
    if ($ddc3d9704a40b613$export$c6fabfbfd097fc30(value)) return $ddc3d9704a40b613$var$addSlice(new Uint8Array(value));
    return $ddc3d9704a40b613$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $ddc3d9704a40b613$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$ddc3d9704a40b613$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $ddc3d9704a40b613$var$addSlice(result);
}
function $ddc3d9704a40b613$export$a8f4574d0e56446c(value) {
    let result = $ddc3d9704a40b613$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $ddc3d9704a40b613$export$3cdc770bf8b2ed3d(value, length) {
    value = $ddc3d9704a40b613$export$3131421a7d01b4fb(value);
    if (value.length > length) $ddc3d9704a40b613$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $ddc3d9704a40b613$var$addSlice(result);
}
function $ddc3d9704a40b613$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $ddc3d9704a40b613$var$HexCharacters = "0123456789abcdef";
function $ddc3d9704a40b613$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $ddc3d9704a40b613$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $ddc3d9704a40b613$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($ddc3d9704a40b613$var$isHexable(value)) return value.toHexString();
    if ($ddc3d9704a40b613$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $ddc3d9704a40b613$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($ddc3d9704a40b613$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $ddc3d9704a40b613$var$HexCharacters[(v & 0xf0) >> 4] + $ddc3d9704a40b613$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $ddc3d9704a40b613$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $ddc3d9704a40b613$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(data);
    else if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $ddc3d9704a40b613$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(data);
    else if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(data) || data.length % 2) $ddc3d9704a40b613$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $ddc3d9704a40b613$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $ddc3d9704a40b613$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $ddc3d9704a40b613$export$6916af760a341dd3(value) {
    const trimmed = $ddc3d9704a40b613$export$967bc0082a978949($ddc3d9704a40b613$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $ddc3d9704a40b613$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(value);
    if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(value)) $ddc3d9704a40b613$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $ddc3d9704a40b613$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(value);
    else if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(value)) $ddc3d9704a40b613$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $ddc3d9704a40b613$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $ddc3d9704a40b613$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($ddc3d9704a40b613$export$9a14abb1a440cd5e(signature)) {
        let bytes = $ddc3d9704a40b613$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $ddc3d9704a40b613$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $ddc3d9704a40b613$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $ddc3d9704a40b613$export$3cdc770bf8b2ed3d($ddc3d9704a40b613$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $ddc3d9704a40b613$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $ddc3d9704a40b613$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $ddc3d9704a40b613$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $ddc3d9704a40b613$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$ddc3d9704a40b613$export$b02a40aff8e4ad18(result.r)) $ddc3d9704a40b613$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $ddc3d9704a40b613$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$ddc3d9704a40b613$export$b02a40aff8e4ad18(result.s)) $ddc3d9704a40b613$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $ddc3d9704a40b613$export$e9c46a54370b47e8(result.s, 32);
        const vs = $ddc3d9704a40b613$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $ddc3d9704a40b613$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(result._vs)) $ddc3d9704a40b613$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $ddc3d9704a40b613$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $ddc3d9704a40b613$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $ddc3d9704a40b613$export$71bb9d78a59bbe25(signature) {
    signature = $ddc3d9704a40b613$export$7fb170f1e457988f(signature);
    return $ddc3d9704a40b613$export$2b0d6b5fbe698c70($ddc3d9704a40b613$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}



var $cCjFr = parcelRequire("cCjFr");

"use strict";
function $344909d1f36347b2$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($cCjFr))).keccak_256((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(data));
}


function $607a80a0a69e28c2$var$_extends() {
    $607a80a0a69e28c2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $607a80a0a69e28c2$var$_extends.apply(this, arguments);
}
function $607a80a0a69e28c2$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $607a80a0a69e28c2$var$_setPrototypeOf(subClass, superClass);
}
function $607a80a0a69e28c2$var$_getPrototypeOf(o) {
    $607a80a0a69e28c2$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $607a80a0a69e28c2$var$_getPrototypeOf(o);
}
function $607a80a0a69e28c2$var$_setPrototypeOf(o, p) {
    $607a80a0a69e28c2$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $607a80a0a69e28c2$var$_setPrototypeOf(o, p);
}
function $607a80a0a69e28c2$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $607a80a0a69e28c2$var$_construct(Parent, args, Class) {
    if ($607a80a0a69e28c2$var$_isNativeReflectConstruct()) $607a80a0a69e28c2$var$_construct = Reflect.construct;
    else $607a80a0a69e28c2$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $607a80a0a69e28c2$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $607a80a0a69e28c2$var$_construct.apply(null, arguments);
}
function $607a80a0a69e28c2$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $607a80a0a69e28c2$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $607a80a0a69e28c2$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$607a80a0a69e28c2$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $607a80a0a69e28c2$var$_construct(Class, arguments, $607a80a0a69e28c2$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $607a80a0a69e28c2$var$_setPrototypeOf(Wrapper, Class);
    };
    return $607a80a0a69e28c2$var$_wrapNativeSuper(Class);
}
// A type of promise-like that resolves synchronously and supports only one observer
var $607a80a0a69e28c2$var$_iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = /*#__PURE__*/ Symbol("Symbol.iterator")) : "@@iterator"; // Asynchronously iterate through an object's values
var $607a80a0a69e28c2$var$_asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator = /*#__PURE__*/ Symbol("Symbol.asyncIterator")) : "@@asyncIterator"; // Asynchronously iterate on a value using it's async iterator if present, or its synchronous iterator if missing
function $607a80a0a69e28c2$var$_catch(body, recover) {
    try {
        var result = body();
    } catch (e) {
        return recover(e);
    }
    if (result && result.then) return result.then(void 0, recover);
    return result;
} // Asynchronously await a promise and pass the result to a finally continuation
function $607a80a0a69e28c2$var$normalizeChainId(chainId) {
    if (typeof chainId === "string") {
        // Temporary fix until the next version of Metamask Mobile gets released.
        // In the current version (0.2.13), the chainId starts with “Ox” rather
        // than “0x”. Fix: https://github.com/MetaMask/metamask-mobile/pull/1275
        chainId = chainId.replace(/^Ox/, "0x");
        var parsedChainId = Number.parseInt(chainId, chainId.trim().substring(0, 2) === "0x" ? 16 : 10);
        !!Number.isNaN(parsedChainId) && (0, $ad70c57529687670$export$2e2bcd8739ae039)(false);
        return parsedChainId;
    } else {
        !Number.isInteger(chainId) && (0, $ad70c57529687670$export$2e2bcd8739ae039)(false);
        return chainId;
    }
} // https://github.com/ethers-io/ethers.js/blob/d9d438a119bb11f8516fc9cf02c534ab3816fcb3/packages/address/src.ts/index.ts
function $607a80a0a69e28c2$var$normalizeAccount(_address) {
    !(typeof _address === "string" && _address.match(/^(0x)?[0-9a-fA-F]{40}$/)) && (0, $ad70c57529687670$export$2e2bcd8739ae039)(false);
    var address = _address.substring(0, 2) === "0x" ? _address : "0x" + _address;
    var chars = address.toLowerCase().substring(2).split("");
    var charsArray = new Uint8Array(40);
    for(var i = 0; i < 40; i++)charsArray[i] = chars[i].charCodeAt(0);
    var hashed = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)((0, $344909d1f36347b2$export$f8151fce47ad1c35)(charsArray));
    for(var _i = 0; _i < 40; _i += 2){
        if (hashed[_i >> 1] >> 4 >= 8) chars[_i] = chars[_i].toUpperCase();
        if ((hashed[_i >> 1] & 0x0f) >= 8) chars[_i + 1] = chars[_i + 1].toUpperCase();
    }
    var addressChecksum = "0x" + chars.join("");
    !!(address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && address !== addressChecksum) && (0, $ad70c57529687670$export$2e2bcd8739ae039)(false);
    return addressChecksum;
}
var $607a80a0a69e28c2$var$augmentConnectorUpdate = function augmentConnectorUpdate(connector, update) {
    try {
        var _temp3 = function _temp3(provider) {
            return Promise.resolve(Promise.all([
                update.chainId === undefined ? connector.getChainId() : update.chainId,
                update.account === undefined ? connector.getAccount() : update.account
            ])).then(function(_ref2) {
                var _chainId = _ref2[0], _account = _ref2[1];
                var chainId = $607a80a0a69e28c2$var$normalizeChainId(_chainId);
                if (!!connector.supportedChainIds && !connector.supportedChainIds.includes(chainId)) throw new $607a80a0a69e28c2$export$fc97cac2ba066ec7(chainId, connector.supportedChainIds);
                var account = _account === null ? _account : $607a80a0a69e28c2$var$normalizeAccount(_account);
                return {
                    provider: provider,
                    chainId: chainId,
                    account: account
                };
            });
        };
        var _temp4 = update.provider === undefined;
        return Promise.resolve(_temp4 ? Promise.resolve(connector.getProvider()).then(_temp3) : _temp3(update.provider));
    } catch (e) {
        return Promise.reject(e);
    }
};
var $607a80a0a69e28c2$var$StaleConnectorError = /*#__PURE__*/ function(_Error) {
    $607a80a0a69e28c2$var$_inheritsLoose(StaleConnectorError, _Error);
    function StaleConnectorError() {
        var _this;
        _this = _Error.call(this) || this;
        _this.name = _this.constructor.name;
        return _this;
    }
    return StaleConnectorError;
}(/*#__PURE__*/ $607a80a0a69e28c2$var$_wrapNativeSuper(Error));
var $607a80a0a69e28c2$export$fc97cac2ba066ec7 = /*#__PURE__*/ function(_Error2) {
    $607a80a0a69e28c2$var$_inheritsLoose(UnsupportedChainIdError, _Error2);
    function UnsupportedChainIdError(unsupportedChainId, supportedChainIds) {
        var _this2;
        _this2 = _Error2.call(this) || this;
        _this2.name = _this2.constructor.name;
        _this2.message = "Unsupported chain id: " + unsupportedChainId + ". Supported chain ids are: " + supportedChainIds + ".";
        return _this2;
    }
    return UnsupportedChainIdError;
}(/*#__PURE__*/ $607a80a0a69e28c2$var$_wrapNativeSuper(Error));
var $607a80a0a69e28c2$var$ActionType;
(function(ActionType) {
    ActionType[ActionType["ACTIVATE_CONNECTOR"] = 0] = "ACTIVATE_CONNECTOR";
    ActionType[ActionType["UPDATE"] = 1] = "UPDATE";
    ActionType[ActionType["UPDATE_FROM_ERROR"] = 2] = "UPDATE_FROM_ERROR";
    ActionType[ActionType["ERROR"] = 3] = "ERROR";
    ActionType[ActionType["ERROR_FROM_ACTIVATION"] = 4] = "ERROR_FROM_ACTIVATION";
    ActionType[ActionType["DEACTIVATE_CONNECTOR"] = 5] = "DEACTIVATE_CONNECTOR";
})($607a80a0a69e28c2$var$ActionType || ($607a80a0a69e28c2$var$ActionType = {}));
function $607a80a0a69e28c2$var$reducer(state, _ref) {
    var type = _ref.type, payload = _ref.payload;
    switch(type){
        case $607a80a0a69e28c2$var$ActionType.ACTIVATE_CONNECTOR:
            var connector = payload.connector, provider = payload.provider, chainId = payload.chainId, account = payload.account, onError = payload.onError;
            return {
                connector: connector,
                provider: provider,
                chainId: chainId,
                account: account,
                onError: onError
            };
        case $607a80a0a69e28c2$var$ActionType.UPDATE:
            var _provider = payload.provider, _chainId2 = payload.chainId, _account2 = payload.account;
            return $607a80a0a69e28c2$var$_extends({}, state, _provider === undefined ? {} : {
                provider: _provider
            }, _chainId2 === undefined ? {} : {
                chainId: _chainId2
            }, _account2 === undefined ? {} : {
                account: _account2
            });
        case $607a80a0a69e28c2$var$ActionType.UPDATE_FROM_ERROR:
            var _provider2 = payload.provider, _chainId3 = payload.chainId, _account3 = payload.account;
            return $607a80a0a69e28c2$var$_extends({}, state, _provider2 === undefined ? {} : {
                provider: _provider2
            }, _chainId3 === undefined ? {} : {
                chainId: _chainId3
            }, _account3 === undefined ? {} : {
                account: _account3
            }, {
                error: undefined
            });
        case $607a80a0a69e28c2$var$ActionType.ERROR:
            var error = payload.error;
            var _connector = state.connector, _onError = state.onError;
            return {
                connector: _connector,
                error: error,
                onError: _onError
            };
        case $607a80a0a69e28c2$var$ActionType.ERROR_FROM_ACTIVATION:
            var _connector2 = payload.connector, _error = payload.error;
            return {
                connector: _connector2,
                error: _error
            };
        case $607a80a0a69e28c2$var$ActionType.DEACTIVATE_CONNECTOR:
            return {};
    }
}
function $607a80a0a69e28c2$var$useWeb3ReactManager() {
    var _useReducer = (0, $6cds3.useReducer)($607a80a0a69e28c2$var$reducer, {}), state = _useReducer[0], dispatch = _useReducer[1];
    var connector = state.connector, provider = state.provider, chainId = state.chainId, account = state.account, onError = state.onError, error = state.error;
    var updateBusterRef = (0, $6cds3.useRef)(-1);
    updateBusterRef.current += 1;
    var activate = (0, $6cds3.useCallback)(function(connector, onError, throwErrors) {
        if (throwErrors === void 0) throwErrors = false;
        try {
            var updateBusterInitial = updateBusterRef.current;
            var activated = false;
            return Promise.resolve($607a80a0a69e28c2$var$_catch(function() {
                return Promise.resolve(connector.activate().then(function(update) {
                    activated = true;
                    return update;
                })).then(function(update) {
                    return Promise.resolve($607a80a0a69e28c2$var$augmentConnectorUpdate(connector, update)).then(function(augmentedUpdate) {
                        if (updateBusterRef.current > updateBusterInitial) throw new $607a80a0a69e28c2$var$StaleConnectorError();
                        dispatch({
                            type: $607a80a0a69e28c2$var$ActionType.ACTIVATE_CONNECTOR,
                            payload: $607a80a0a69e28c2$var$_extends({
                                connector: connector
                            }, augmentedUpdate, {
                                onError: onError
                            })
                        });
                    });
                });
            }, function(error) {
                if (error instanceof $607a80a0a69e28c2$var$StaleConnectorError) activated && connector.deactivate();
                else if (throwErrors) {
                    activated && connector.deactivate();
                    throw error;
                } else if (onError) {
                    activated && connector.deactivate();
                    onError(error);
                } else // we don't call activated && connector.deactivate() here because it'll be handled in the useEffect
                dispatch({
                    type: $607a80a0a69e28c2$var$ActionType.ERROR_FROM_ACTIVATION,
                    payload: {
                        connector: connector,
                        error: error
                    }
                });
            }));
        } catch (e) {
            return Promise.reject(e);
        }
    }, []);
    var setError = (0, $6cds3.useCallback)(function(error) {
        dispatch({
            type: $607a80a0a69e28c2$var$ActionType.ERROR,
            payload: {
                error: error
            }
        });
    }, []);
    var deactivate = (0, $6cds3.useCallback)(function() {
        dispatch({
            type: $607a80a0a69e28c2$var$ActionType.DEACTIVATE_CONNECTOR
        });
    }, []);
    var handleUpdate = (0, $6cds3.useCallback)(function(update) {
        try {
            if (!connector) throw Error("This should never happen, it's just so Typescript stops complaining");
            var updateBusterInitial = updateBusterRef.current; // updates are handled differently depending on whether the connector is active vs in an error state
            return Promise.resolve(function() {
                if (!error) {
                    var _chainId4 = update.chainId === undefined ? undefined : $607a80a0a69e28c2$var$normalizeChainId(update.chainId);
                    if (_chainId4 !== undefined && !!connector.supportedChainIds && !connector.supportedChainIds.includes(_chainId4)) {
                        var _error2 = new $607a80a0a69e28c2$export$fc97cac2ba066ec7(_chainId4, connector.supportedChainIds);
                        onError ? onError(_error2) : dispatch({
                            type: $607a80a0a69e28c2$var$ActionType.ERROR,
                            payload: {
                                error: _error2
                            }
                        });
                    } else {
                        var _account4 = typeof update.account === "string" ? $607a80a0a69e28c2$var$normalizeAccount(update.account) : update.account;
                        dispatch({
                            type: $607a80a0a69e28c2$var$ActionType.UPDATE,
                            payload: {
                                provider: update.provider,
                                chainId: _chainId4,
                                account: _account4
                            }
                        });
                    }
                } else return $607a80a0a69e28c2$var$_catch(function() {
                    return Promise.resolve($607a80a0a69e28c2$var$augmentConnectorUpdate(connector, update)).then(function(augmentedUpdate) {
                        if (updateBusterRef.current > updateBusterInitial) throw new $607a80a0a69e28c2$var$StaleConnectorError();
                        dispatch({
                            type: $607a80a0a69e28c2$var$ActionType.UPDATE_FROM_ERROR,
                            payload: augmentedUpdate
                        });
                    });
                }, function(error) {
                    if (error instanceof $607a80a0a69e28c2$var$StaleConnectorError) ;
                    else // though we don't have to, we're re-circulating the new error
                    onError ? onError(error) : dispatch({
                        type: $607a80a0a69e28c2$var$ActionType.ERROR,
                        payload: {
                            error: error
                        }
                    });
                });
            }());
        } catch (e) {
            return Promise.reject(e);
        }
    }, [
        connector,
        error,
        onError
    ]);
    var handleError = (0, $6cds3.useCallback)(function(error) {
        onError ? onError(error) : dispatch({
            type: $607a80a0a69e28c2$var$ActionType.ERROR,
            payload: {
                error: error
            }
        });
    }, [
        onError
    ]);
    var handleDeactivate = (0, $6cds3.useCallback)(function() {
        dispatch({
            type: $607a80a0a69e28c2$var$ActionType.DEACTIVATE_CONNECTOR
        });
    }, []); // ensure that connectors which were set are deactivated
    (0, $6cds3.useEffect)(function() {
        return function() {
            if (connector) connector.deactivate();
        };
    }, [
        connector
    ]); // ensure that events emitted from the set connector are handled appropriately
    (0, $6cds3.useEffect)(function() {
        if (connector) connector.on((0, $feaa9a02344f813e$export$638354e3e7cf979c).Update, handleUpdate).on((0, $feaa9a02344f813e$export$638354e3e7cf979c).Error, handleError).on((0, $feaa9a02344f813e$export$638354e3e7cf979c).Deactivate, handleDeactivate);
        return function() {
            if (connector) connector.off((0, $feaa9a02344f813e$export$638354e3e7cf979c).Update, handleUpdate).off((0, $feaa9a02344f813e$export$638354e3e7cf979c).Error, handleError).off((0, $feaa9a02344f813e$export$638354e3e7cf979c).Deactivate, handleDeactivate);
        };
    }, [
        connector,
        handleUpdate,
        handleError,
        handleDeactivate
    ]);
    return {
        connector: connector,
        provider: provider,
        chainId: chainId,
        account: account,
        activate: activate,
        setError: setError,
        deactivate: deactivate,
        error: error
    };
}
var $607a80a0a69e28c2$export$2791565425944a18 = "primary";
var $607a80a0a69e28c2$var$CONTEXTS = {};
function $607a80a0a69e28c2$export$243b2c701c025ba8(key) {
    !!$607a80a0a69e28c2$var$CONTEXTS[key] && (0, $ad70c57529687670$export$2e2bcd8739ae039)(false);
    $607a80a0a69e28c2$var$CONTEXTS[key] = (0, $6cds3.createContext)({
        activate: function() {
            try {
                (0, $ad70c57529687670$export$2e2bcd8739ae039)(false);
                return Promise.resolve();
            } catch (e) {
                return Promise.reject(e);
            }
        },
        setError: function setError() {
            (0, $ad70c57529687670$export$2e2bcd8739ae039)(false);
        },
        deactivate: function deactivate() {
            (0, $ad70c57529687670$export$2e2bcd8739ae039)(false);
        },
        active: false
    });
    $607a80a0a69e28c2$var$CONTEXTS[key].displayName = "Web3ReactContext - " + key;
    var Provider = $607a80a0a69e28c2$var$CONTEXTS[key].Provider;
    return function Web3ReactProvider(_ref) {
        var getLibrary = _ref.getLibrary, children = _ref.children;
        var _useWeb3ReactManager = $607a80a0a69e28c2$var$useWeb3ReactManager(), connector = _useWeb3ReactManager.connector, provider = _useWeb3ReactManager.provider, chainId = _useWeb3ReactManager.chainId, account = _useWeb3ReactManager.account, activate = _useWeb3ReactManager.activate, setError = _useWeb3ReactManager.setError, deactivate = _useWeb3ReactManager.deactivate, error = _useWeb3ReactManager.error;
        var active = connector !== undefined && chainId !== undefined && account !== undefined && !!!error;
        var library = (0, $6cds3.useMemo)(function() {
            return active && chainId !== undefined && Number.isInteger(chainId) && !!connector ? getLibrary(provider, connector) : undefined;
        }, [
            active,
            getLibrary,
            provider,
            connector,
            chainId
        ]);
        var web3ReactContext = {
            connector: connector,
            library: library,
            chainId: chainId,
            account: account,
            activate: activate,
            setError: setError,
            deactivate: deactivate,
            active: active,
            error: error
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(Provider, {
            value: web3ReactContext
        }, children);
    };
}
var $607a80a0a69e28c2$export$f5c33efe7118b551 = /*#__PURE__*/ $607a80a0a69e28c2$export$243b2c701c025ba8($607a80a0a69e28c2$export$2791565425944a18);
function $607a80a0a69e28c2$export$1897809d6ba3ce9b(key) {
    if (key === void 0) key = $607a80a0a69e28c2$export$2791565425944a18;
    !Object.keys($607a80a0a69e28c2$var$CONTEXTS).includes(key) && (0, $ad70c57529687670$export$2e2bcd8739ae039)(false);
    return $607a80a0a69e28c2$var$CONTEXTS[key];
}
function $607a80a0a69e28c2$export$6826ddb52637cda3(key) {
    return (0, $6cds3.useContext)($607a80a0a69e28c2$export$1897809d6ba3ce9b(key));
}



var $6IEmH = parcelRequire("6IEmH");


const $7d66624d621f023f$export$83d89fbfd8236492 = "bignumber/5.7.0";


"use strict";
var $c37d64fad2cf3dce$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($6IEmH))).BN;
const $c37d64fad2cf3dce$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $7d66624d621f023f$export$83d89fbfd8236492));
const $c37d64fad2cf3dce$var$_constructorGuard = {};
const $c37d64fad2cf3dce$var$MAX_SAFE = 0x1fffffffffffff;
function $c37d64fad2cf3dce$export$a3d0a7fa9b65683b(value) {
    return value != null && ($c37d64fad2cf3dce$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(value) || typeof value === "bigint" || (0, $ddc3d9704a40b613$export$c6fabfbfd097fc30)(value));
}
// Only warn about passing 10 into radix once
let $c37d64fad2cf3dce$var$_warnedToStringRadix = false;
class $c37d64fad2cf3dce$export$d97aa349ed20696 {
    fromTwos(value) {
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $c37d64fad2cf3dce$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).add($c37d64fad2cf3dce$var$toBN(other)));
    }
    sub(other) {
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).sub($c37d64fad2cf3dce$var$toBN(other)));
    }
    div(other) {
        const o = $c37d64fad2cf3dce$export$d97aa349ed20696.from(other);
        if (o.isZero()) $c37d64fad2cf3dce$var$throwFault("division-by-zero", "div");
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).div($c37d64fad2cf3dce$var$toBN(other)));
    }
    mul(other) {
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).mul($c37d64fad2cf3dce$var$toBN(other)));
    }
    mod(other) {
        const value = $c37d64fad2cf3dce$var$toBN(other);
        if (value.isNeg()) $c37d64fad2cf3dce$var$throwFault("division-by-zero", "mod");
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $c37d64fad2cf3dce$var$toBN(other);
        if (value.isNeg()) $c37d64fad2cf3dce$var$throwFault("negative-power", "pow");
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $c37d64fad2cf3dce$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $c37d64fad2cf3dce$var$throwFault("unbound-bitwise-result", "and");
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).and(value));
    }
    or(other) {
        const value = $c37d64fad2cf3dce$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $c37d64fad2cf3dce$var$throwFault("unbound-bitwise-result", "or");
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $c37d64fad2cf3dce$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $c37d64fad2cf3dce$var$throwFault("unbound-bitwise-result", "xor");
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $c37d64fad2cf3dce$var$throwFault("negative-width", "mask");
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $c37d64fad2cf3dce$var$throwFault("negative-width", "shl");
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $c37d64fad2cf3dce$var$throwFault("negative-width", "shr");
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $c37d64fad2cf3dce$var$toBN(this).eq($c37d64fad2cf3dce$var$toBN(other));
    }
    lt(other) {
        return $c37d64fad2cf3dce$var$toBN(this).lt($c37d64fad2cf3dce$var$toBN(other));
    }
    lte(other) {
        return $c37d64fad2cf3dce$var$toBN(this).lte($c37d64fad2cf3dce$var$toBN(other));
    }
    gt(other) {
        return $c37d64fad2cf3dce$var$toBN(this).gt($c37d64fad2cf3dce$var$toBN(other));
    }
    gte(other) {
        return $c37d64fad2cf3dce$var$toBN(this).gte($c37d64fad2cf3dce$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $c37d64fad2cf3dce$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $c37d64fad2cf3dce$var$toBN(this).toNumber();
        } catch (error) {
            $c37d64fad2cf3dce$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $c37d64fad2cf3dce$var$logger.throwError("this platform does not support BigInt", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$c37d64fad2cf3dce$var$_warnedToStringRadix) {
                    $c37d64fad2cf3dce$var$_warnedToStringRadix = true;
                    $c37d64fad2cf3dce$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $c37d64fad2cf3dce$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
            else $c37d64fad2cf3dce$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $c37d64fad2cf3dce$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $c37d64fad2cf3dce$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $c37d64fad2cf3dce$export$d97aa349ed20696($c37d64fad2cf3dce$var$_constructorGuard, $c37d64fad2cf3dce$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $c37d64fad2cf3dce$export$d97aa349ed20696($c37d64fad2cf3dce$var$_constructorGuard, $c37d64fad2cf3dce$var$toHex(new $c37d64fad2cf3dce$var$BN(value)));
            return $c37d64fad2cf3dce$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $c37d64fad2cf3dce$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $c37d64fad2cf3dce$var$MAX_SAFE || value <= -$c37d64fad2cf3dce$var$MAX_SAFE) $c37d64fad2cf3dce$var$throwFault("overflow", "BigNumber.from", value);
            return $c37d64fad2cf3dce$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $c37d64fad2cf3dce$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $ddc3d9704a40b613$export$c6fabfbfd097fc30)(anyValue)) return $c37d64fad2cf3dce$export$d97aa349ed20696.from((0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $c37d64fad2cf3dce$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(hex) || hex[0] === "-" && (0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(hex.substring(1))) return $c37d64fad2cf3dce$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $c37d64fad2cf3dce$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
    constructor(constructorGuard, hex){
        if (constructorGuard !== $c37d64fad2cf3dce$var$_constructorGuard) $c37d64fad2cf3dce$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
}
// Normalize the hex string
function $c37d64fad2cf3dce$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $c37d64fad2cf3dce$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $c37d64fad2cf3dce$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $c37d64fad2cf3dce$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $c37d64fad2cf3dce$var$toBigNumber(value) {
    return $c37d64fad2cf3dce$export$d97aa349ed20696.from($c37d64fad2cf3dce$var$toHex(value));
}
function $c37d64fad2cf3dce$var$toBN(value) {
    const hex = $c37d64fad2cf3dce$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $c37d64fad2cf3dce$var$BN("-" + hex.substring(3), 16);
    return new $c37d64fad2cf3dce$var$BN(hex.substring(2), 16);
}
function $c37d64fad2cf3dce$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $c37d64fad2cf3dce$var$logger.throwError(fault, (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.NUMERIC_FAULT, params);
}
function $c37d64fad2cf3dce$export$51e4a08295f7770f(value) {
    return new $c37d64fad2cf3dce$var$BN(value, 36).toString(16);
}
function $c37d64fad2cf3dce$export$1293db5d29c264ff(value) {
    return new $c37d64fad2cf3dce$var$BN(value, 16).toString(36);
}





var $a139c5939e084c8c$exports = {};

$parcel$export($a139c5939e084c8c$exports, "encode", function () { return $a139c5939e084c8c$export$c564cdbbe6da493; });
$parcel$export($a139c5939e084c8c$exports, "decode", function () { return $a139c5939e084c8c$export$2f872c0f2117be69; });


const $ddffd2eacde14166$export$83d89fbfd8236492 = "rlp/5.7.0";


"use strict";
const $a139c5939e084c8c$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $ddffd2eacde14166$export$83d89fbfd8236492));
function $a139c5939e084c8c$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $a139c5939e084c8c$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $a139c5939e084c8c$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($a139c5939e084c8c$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $a139c5939e084c8c$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $ddc3d9704a40b613$export$9a14abb1a440cd5e)(object)) $a139c5939e084c8c$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $a139c5939e084c8c$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $a139c5939e084c8c$export$c564cdbbe6da493(object) {
    return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)($a139c5939e084c8c$var$_encode(object));
}
function $a139c5939e084c8c$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $a139c5939e084c8c$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $a139c5939e084c8c$var$logger.throwError("child data too short", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $a139c5939e084c8c$var$_decode(data, offset) {
    if (data.length === 0) $a139c5939e084c8c$var$logger.throwError("data too short", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $a139c5939e084c8c$var$logger.throwError("data short segment too short", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const length = $a139c5939e084c8c$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $a139c5939e084c8c$var$logger.throwError("data long segment too short", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $a139c5939e084c8c$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $a139c5939e084c8c$var$logger.throwError("data array too short", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $a139c5939e084c8c$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $a139c5939e084c8c$var$logger.throwError("data array too short", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const length = $a139c5939e084c8c$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $a139c5939e084c8c$var$logger.throwError("data array too short", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const result = (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $a139c5939e084c8c$var$logger.throwError("data too short", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const result = (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(data[offset])
    };
}
function $a139c5939e084c8c$export$2f872c0f2117be69(data) {
    const bytes = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(data);
    const decoded = $a139c5939e084c8c$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $a139c5939e084c8c$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}



const $03c1c59590656f19$export$83d89fbfd8236492 = "address/5.7.0";


"use strict";
const $a4b82b374f356b4b$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $03c1c59590656f19$export$83d89fbfd8236492));
function $a4b82b374f356b4b$var$getChecksumAddress(address) {
    if (!(0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(address, 20)) $a4b82b374f356b4b$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)((0, $344909d1f36347b2$export$f8151fce47ad1c35)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $a4b82b374f356b4b$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $a4b82b374f356b4b$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $a4b82b374f356b4b$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$a4b82b374f356b4b$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$a4b82b374f356b4b$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $a4b82b374f356b4b$var$safeDigits = Math.floor($a4b82b374f356b4b$var$log10($a4b82b374f356b4b$var$MAX_SAFE_INTEGER));
function $a4b82b374f356b4b$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $a4b82b374f356b4b$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $a4b82b374f356b4b$var$safeDigits){
        let block = expanded.substring(0, $a4b82b374f356b4b$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $a4b82b374f356b4b$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $a4b82b374f356b4b$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $a4b82b374f356b4b$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $a4b82b374f356b4b$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $a4b82b374f356b4b$var$ibanChecksum(address)) $a4b82b374f356b4b$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $c37d64fad2cf3dce$export$51e4a08295f7770f)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $a4b82b374f356b4b$var$getChecksumAddress("0x" + result);
    } else $a4b82b374f356b4b$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $a4b82b374f356b4b$export$977e255126d763d6(address) {
    try {
        $a4b82b374f356b4b$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $a4b82b374f356b4b$export$962c4ddada9f668f(address) {
    let base36 = (0, $c37d64fad2cf3dce$export$1293db5d29c264ff)($a4b82b374f356b4b$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $a4b82b374f356b4b$var$ibanChecksum("XE00" + base36) + base36;
}
function $a4b82b374f356b4b$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $a4b82b374f356b4b$export$88411125f012957a(transaction.from);
    } catch (error) {
        $a4b82b374f356b4b$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $ddc3d9704a40b613$export$a8f4574d0e56446c)((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)((0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(transaction.nonce).toHexString()));
    return $a4b82b374f356b4b$export$88411125f012957a((0, $ddc3d9704a40b613$export$15da666eba198c18)((0, $344909d1f36347b2$export$f8151fce47ad1c35)((0, $a139c5939e084c8c$export$c564cdbbe6da493)([
        from,
        nonce
    ])), 12));
}
function $a4b82b374f356b4b$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $ddc3d9704a40b613$export$13882f896d3c0683)(salt) !== 32) $a4b82b374f356b4b$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $ddc3d9704a40b613$export$13882f896d3c0683)(initCodeHash) !== 32) $a4b82b374f356b4b$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $a4b82b374f356b4b$export$88411125f012957a((0, $ddc3d9704a40b613$export$15da666eba198c18)((0, $344909d1f36347b2$export$f8151fce47ad1c35)((0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
        "0xff",
        $a4b82b374f356b4b$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}


var $fcd53023be51494b$exports = {};

$parcel$export($fcd53023be51494b$exports, "BaseContract", function () { return $fcd53023be51494b$export$304faa4fc17528db; });
$parcel$export($fcd53023be51494b$exports, "Contract", function () { return $fcd53023be51494b$export$8517d80acf00e19a; });
$parcel$export($fcd53023be51494b$exports, "ContractFactory", function () { return $fcd53023be51494b$export$505569a6bf584fd9; });


var $19462b55124983f4$exports = {};

$parcel$export($19462b55124983f4$exports, "defineReadOnly", function () { return $19462b55124983f4$export$104236534534f9be; });
$parcel$export($19462b55124983f4$exports, "getStatic", function () { return $19462b55124983f4$export$f695fbbf3cdaaf47; });
$parcel$export($19462b55124983f4$exports, "resolveProperties", function () { return $19462b55124983f4$export$d503dd157d963b60; });
$parcel$export($19462b55124983f4$exports, "checkProperties", function () { return $19462b55124983f4$export$ae5a316ba623b73a; });
$parcel$export($19462b55124983f4$exports, "shallowCopy", function () { return $19462b55124983f4$export$9c13236873b118a5; });
$parcel$export($19462b55124983f4$exports, "deepCopy", function () { return $19462b55124983f4$export$6c40052bed430212; });
$parcel$export($19462b55124983f4$exports, "Description", function () { return $19462b55124983f4$export$393edc798c47379d; });

const $1b45f0663293159e$export$83d89fbfd8236492 = "properties/5.7.0";


"use strict";
var $19462b55124983f4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $19462b55124983f4$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $1b45f0663293159e$export$83d89fbfd8236492));
function $19462b55124983f4$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $19462b55124983f4$export$f695fbbf3cdaaf47(ctor, key) {
    for(let i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $19462b55124983f4$export$d503dd157d963b60(object) {
    return $19462b55124983f4$var$__awaiter(this, void 0, void 0, function*() {
        const promises = Object.keys(object).map((key)=>{
            const value = object[key];
            return Promise.resolve(value).then((v)=>({
                    key: key,
                    value: v
                }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result)=>{
            accum[result.key] = result.value;
            return accum;
        }, {});
    });
}
function $19462b55124983f4$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $19462b55124983f4$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach((key)=>{
        if (!properties[key]) $19462b55124983f4$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $19462b55124983f4$export$9c13236873b118a5(object) {
    const result = {};
    for(const key in object)result[key] = object[key];
    return result;
}
const $19462b55124983f4$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $19462b55124983f4$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $19462b55124983f4$var$opaque[typeof object]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        const keys = Object.keys(object);
        for(let i = 0; i < keys.length; i++){
            let value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!$19462b55124983f4$var$_isFrozen(value)) return false;
        }
        return true;
    }
    return $19462b55124983f4$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $19462b55124983f4$var$_deepCopy(object) {
    if ($19462b55124983f4$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map((item)=>$19462b55124983f4$export$6c40052bed430212(item)));
    if (typeof object === "object") {
        const result = {};
        for(const key in object){
            const value = object[key];
            if (value === undefined) continue;
            $19462b55124983f4$export$104236534534f9be(result, key, $19462b55124983f4$export$6c40052bed430212(value));
        }
        return result;
    }
    return $19462b55124983f4$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
function $19462b55124983f4$export$6c40052bed430212(object) {
    return $19462b55124983f4$var$_deepCopy(object);
}
class $19462b55124983f4$export$393edc798c47379d {
    constructor(info){
        for(const key in info)this[key] = $19462b55124983f4$export$6c40052bed430212(info[key]);
    }
}



const $d53f0a8655f612f5$export$83d89fbfd8236492 = "abi/5.7.0";


"use strict";
const $bd6d84ecef385088$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d53f0a8655f612f5$export$83d89fbfd8236492));
function $bd6d84ecef385088$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
class $bd6d84ecef385088$export$2c0c39526f8bad46 {
    _throwError(message, value) {
        $bd6d84ecef385088$var$logger.throwArgumentError(message, this.localName, value);
    }
    constructor(name, type, localName, dynamic){
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
}
class $bd6d84ecef385088$export$d7a960146e1a269e {
    get data() {
        return (0, $ddc3d9704a40b613$export$6d4b99629b38754a)(this._data);
    }
    get length() {
        return this._dataLength;
    }
    _writeData(data) {
        this._data.push(data);
        this._dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this._writeData((0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)(writer._data));
    }
    // Arrayish items; padded on the right to wordSize
    writeBytes(value) {
        let bytes = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(value);
        const paddingOffset = bytes.length % this.wordSize;
        if (paddingOffset) bytes = (0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
            bytes,
            this._padding.slice(paddingOffset)
        ]);
        return this._writeData(bytes);
    }
    _getValue(value) {
        let bytes = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)((0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(value));
        if (bytes.length > this.wordSize) $bd6d84ecef385088$var$logger.throwError("value out-of-bounds", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
            length: this.wordSize,
            offset: bytes.length
        });
        if (bytes.length % this.wordSize) bytes = (0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
            this._padding.slice(bytes.length % this.wordSize),
            bytes
        ]);
        return bytes;
    }
    // BigNumberish items; padded on the left to wordSize
    writeValue(value) {
        return this._writeData(this._getValue(value));
    }
    writeUpdatableValue() {
        const offset = this._data.length;
        this._data.push(this._padding);
        this._dataLength += this.wordSize;
        return (value)=>{
            this._data[offset] = this._getValue(value);
        };
    }
    constructor(wordSize){
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
}
class $bd6d84ecef385088$export$2f7a2f0e90c07dc4 {
    get data() {
        return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(this._data);
    }
    get consumed() {
        return this._offset;
    }
    // The default Coerce function
    static coerce(name, value) {
        let match = name.match("^u?int([0-9]+)$");
        if (match && parseInt(match[1]) <= 48) value = value.toNumber();
        return value;
    }
    coerce(name, value) {
        if (this._coerceFunc) return this._coerceFunc(name, value);
        return $bd6d84ecef385088$export$2f7a2f0e90c07dc4.coerce(name, value);
    }
    _peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
        if (this._offset + alignedLength > this._data.length) {
            if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
            else $bd6d84ecef385088$var$logger.throwError("data out-of-bounds", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
                length: this._data.length,
                offset: this._offset + alignedLength
            });
        }
        return this._data.slice(this._offset, this._offset + alignedLength);
    }
    subReader(offset) {
        return new $bd6d84ecef385088$export$2f7a2f0e90c07dc4(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
    }
    readBytes(length, loose) {
        let bytes = this._peekBytes(0, length, !!loose);
        this._offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    readValue() {
        return (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(this.readBytes(this.wordSize));
    }
    constructor(data, wordSize, coerceFunc, allowLoose){
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "_data", (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(data));
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "wordSize", wordSize || 32);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "_coerceFunc", coerceFunc);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
}







const $a583a447fefad3f0$export$83d89fbfd8236492 = "strings/5.7.0";


"use strict";
const $169c6c93221d2e48$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $a583a447fefad3f0$export$83d89fbfd8236492));
var $169c6c93221d2e48$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($169c6c93221d2e48$export$c6986442964129f5 || ($169c6c93221d2e48$export$c6986442964129f5 = {}));
var $169c6c93221d2e48$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($169c6c93221d2e48$export$c285fa6ac15ff6a6 || ($169c6c93221d2e48$export$c285fa6ac15ff6a6 = {}));
function $169c6c93221d2e48$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $169c6c93221d2e48$var$logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $169c6c93221d2e48$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $169c6c93221d2e48$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $169c6c93221d2e48$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $169c6c93221d2e48$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $169c6c93221d2e48$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $169c6c93221d2e48$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $169c6c93221d2e48$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $169c6c93221d2e48$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $169c6c93221d2e48$var$errorFunc,
    ignore: $169c6c93221d2e48$var$ignoreFunc,
    replace: $169c6c93221d2e48$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $169c6c93221d2e48$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $169c6c93221d2e48$export$c6e2180c5bb5bc05.error;
    bytes = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $169c6c93221d2e48$export$8feeb310b4b4752f(str, form = $169c6c93221d2e48$export$c6986442964129f5.current) {
    if (form != $169c6c93221d2e48$export$c6986442964129f5.current) {
        $169c6c93221d2e48$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(result);
}
function $169c6c93221d2e48$var$escapeChar(value) {
    const hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $169c6c93221d2e48$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $169c6c93221d2e48$var$getUtf8CodePoints(bytes, onError).map((codePoint)=>{
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $169c6c93221d2e48$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $169c6c93221d2e48$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $169c6c93221d2e48$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $169c6c93221d2e48$export$232e1dab03132235(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $169c6c93221d2e48$export$7643a1dc2c38d5eb(bytes, onError) {
    return $169c6c93221d2e48$export$232e1dab03132235($169c6c93221d2e48$var$getUtf8CodePoints(bytes, onError));
}
function $169c6c93221d2e48$export$ae470a36a31b28c2(str, form = $169c6c93221d2e48$export$c6986442964129f5.current) {
    return $169c6c93221d2e48$var$getUtf8CodePoints($169c6c93221d2e48$export$8feeb310b4b4752f(str, form));
}


function $337ebfbf1ce1b46f$export$d560c7e4a29451c2(text) {
    return (0, $344909d1f36347b2$export$f8151fce47ad1c35)((0, $169c6c93221d2e48$export$8feeb310b4b4752f)(text));
}












"use strict";
class $2e096dc236f9984b$export$59dbbded7775bfe7 extends (0, $bd6d84ecef385088$export$2c0c39526f8bad46) {
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, value) {
        try {
            value = (0, $a4b82b374f356b4b$export$88411125f012957a)(value);
        } catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $a4b82b374f356b4b$export$88411125f012957a)((0, $ddc3d9704a40b613$export$e9c46a54370b47e8)(reader.readValue().toHexString(), 20));
    }
    constructor(localName){
        super("address", "address", localName, false);
    }
}






"use strict";
class $eb98e254fcc8743b$export$87c41d1139a03fa2 extends (0, $bd6d84ecef385088$export$2c0c39526f8bad46) {
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
    constructor(coder){
        super(coder.name, coder.type, undefined, coder.dynamic);
        this.coder = coder;
    }
}


"use strict";
const $4aced1a0cbed513e$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d53f0a8655f612f5$export$83d89fbfd8236492));
function $4aced1a0cbed513e$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            if (!name) $4aced1a0cbed513e$var$logger.throwError("cannot encode object for signature with missing names", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) $4aced1a0cbed513e$var$logger.throwError("cannot encode object for signature with duplicate names", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else $4aced1a0cbed513e$var$logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) $4aced1a0cbed513e$var$logger.throwArgumentError("types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $bd6d84ecef385088$export$d7a960146e1a269e)(writer.wordSize);
    let dynamicWriter = new (0, $bd6d84ecef385088$export$d7a960146e1a269e)(writer.wordSize);
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $4aced1a0cbed513e$export$417857010dc9287f(reader, coders) {
    let values = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readValue();
            let offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    const uniqueNames = coders.reduce((accum, coder)=>{
        const name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach((coder, index)=>{
        let name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        const value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
        else values[name] = value;
    });
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
    }
    return Object.freeze(values);
}
class $4aced1a0cbed513e$export$88bc419d2df11f54 extends (0, $bd6d84ecef385088$export$2c0c39526f8bad46) {
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, value) {
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        $4aced1a0cbed513e$var$logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $4aced1a0cbed513e$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readValue().toNumber();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            if (count * 32 > reader._data.length) $4aced1a0cbed513e$var$logger.throwError("insufficient data length", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
                length: reader._data.length,
                count: count
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $eb98e254fcc8743b$export$87c41d1139a03fa2)(this.coder));
        return reader.coerce(this.name, $4aced1a0cbed513e$export$417857010dc9287f(reader, coders));
    }
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        this.coder = coder;
        this.length = length;
    }
}



"use strict";
class $209954548c523c50$export$fe9118d6c093150c extends (0, $bd6d84ecef385088$export$2c0c39526f8bad46) {
    defaultValue() {
        return false;
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
    constructor(localName){
        super("bool", "bool", localName, false);
    }
}




"use strict";
class $b7e55f4d821202a8$export$db9eadd8df12ad2e extends (0, $bd6d84ecef385088$export$2c0c39526f8bad46) {
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readValue().toNumber(), true);
    }
    constructor(type, localName){
        super(type, type, localName, true);
    }
}
class $b7e55f4d821202a8$export$e5823e9574df18d2 extends $b7e55f4d821202a8$export$db9eadd8df12ad2e {
    decode(reader) {
        return reader.coerce(this.name, (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(super.decode(reader)));
    }
    constructor(localName){
        super("bytes", localName);
    }
}




"use strict";
class $df8e38a8c8e0bc75$export$7dec9db68e6bcf5a extends (0, $bd6d84ecef385088$export$2c0c39526f8bad46) {
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, value) {
        let data = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(value);
        if (data.length !== this.size) this._throwError("incorrect data length", value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(reader.readBytes(this.size)));
    }
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        this.size = size;
    }
}



"use strict";
class $2d21708e754b0ab4$export$70982cadf2d6b4ec extends (0, $bd6d84ecef385088$export$2c0c39526f8bad46) {
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes([]);
    }
    decode(reader) {
        reader.readBytes(0);
        return reader.coerce(this.name, null);
    }
    constructor(localName){
        super("null", "", localName, false);
    }
}




const $af43ef4e381177e0$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(-1);
const $af43ef4e381177e0$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(0);
const $af43ef4e381177e0$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(1);
const $af43ef4e381177e0$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(2);
const $af43ef4e381177e0$export$c8db55bd7405209e = /*#__PURE__*/ (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from("1000000000000000000");
const $af43ef4e381177e0$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $af43ef4e381177e0$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const $af43ef4e381177e0$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");



"use strict";
class $bd7b0b14ce22a0d4$export$b934dc8cfe13938c extends (0, $bd6d84ecef385088$export$2c0c39526f8bad46) {
    defaultValue() {
        return 0;
    }
    encode(writer, value) {
        let v = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(value);
        // Check bounds are safe for encoding
        let maxUintValue = (0, $af43ef4e381177e0$export$1b53890de5aabdd0).mask(writer.wordSize * 8);
        if (this.signed) {
            let bounds = maxUintValue.mask(this.size * 8 - 1);
            if (v.gt(bounds) || v.lt(bounds.add((0, $af43ef4e381177e0$export$9aa05a5866350bcf)).mul((0, $af43ef4e381177e0$export$c83ef0909a6ddeec)))) this._throwError("value out-of-bounds", value);
        } else if (v.lt((0, $af43ef4e381177e0$export$aaef8a3eae948f03)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
        v = v.toTwos(this.size * 8).mask(this.size * 8);
        if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
        return writer.writeValue(v);
    }
    decode(reader) {
        let value = reader.readValue().mask(this.size * 8);
        if (this.signed) value = value.fromTwos(this.size * 8);
        return reader.coerce(this.name, value);
    }
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        this.size = size;
        this.signed = signed;
    }
}




"use strict";
class $335e72c6451b9b9a$export$2d1b854518731426 extends (0, $b7e55f4d821202a8$export$db9eadd8df12ad2e) {
    defaultValue() {
        return "";
    }
    encode(writer, value) {
        return super.encode(writer, (0, $169c6c93221d2e48$export$8feeb310b4b4752f)(value));
    }
    decode(reader) {
        return (0, $169c6c93221d2e48$export$7643a1dc2c38d5eb)(super.decode(reader));
    }
    constructor(localName){
        super("string", localName);
    }
}




"use strict";
class $d29e821f1f0ced09$export$e9fceba8f110fea6 extends (0, $bd6d84ecef385088$export$2c0c39526f8bad46) {
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, value) {
        return (0, $4aced1a0cbed513e$export$2a703dbb0cb35339)(writer, this.coders, value);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $4aced1a0cbed513e$export$417857010dc9287f)(reader, this.coders));
    }
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        this.coders = coders;
    }
}






"use strict";
const $4d2654448f804eaa$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d53f0a8655f612f5$export$83d89fbfd8236492));
const $4d2654448f804eaa$var$_constructorGuard = {};
let $4d2654448f804eaa$var$ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
let $4d2654448f804eaa$var$ModifiersNest = {
    calldata: true,
    memory: true
};
function $4d2654448f804eaa$var$checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if ($4d2654448f804eaa$var$ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if ($4d2654448f804eaa$var$ModifiersNest[name]) return true;
    }
    if ($4d2654448f804eaa$var$ModifiersBytes[name] || name === "payable") $4d2654448f804eaa$var$logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function $4d2654448f804eaa$var$parseParamType(param, allowIndexed) {
    let originalParam = param;
    function throwError(i) {
        $4d2654448f804eaa$var$logger.throwArgumentError(`unexpected character at position ${i}`, "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        let node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    }
    let parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    let node = parent;
    for(let i = 0; i < param.length; i++){
        let c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $4d2654448f804eaa$var$verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($4d2654448f804eaa$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $4d2654448f804eaa$var$verifyType(node.type);
                let child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($4d2654448f804eaa$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $4d2654448f804eaa$var$verifyType(node.type);
                let sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $4d2654448f804eaa$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if ($4d2654448f804eaa$var$checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) $4d2654448f804eaa$var$logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if ($4d2654448f804eaa$var$checkModifier(node.type, node.name)) node.name = "";
    parent.type = $4d2654448f804eaa$var$verifyType(parent.type);
    return parent;
}
function $4d2654448f804eaa$var$populate(object, params) {
    for(let key in params)(0, $19462b55124983f4$exports.defineReadOnly)(object, key, params[key]);
}
const $4d2654448f804eaa$export$f010f239efc4d445 = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
const $4d2654448f804eaa$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class $4d2654448f804eaa$export$426dc07f493a4c47 {
    // Format the parameter fragment
    //   - sighash: "(uint256,address)"
    //   - minimal: "tuple(uint256,address) indexed"
    //   - full:    "tuple(uint256 foo, address bar) indexed baz"
    format(format) {
        if (!format) format = $4d2654448f804eaa$export$f010f239efc4d445.sighash;
        if (!$4d2654448f804eaa$export$f010f239efc4d445[format]) $4d2654448f804eaa$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $4d2654448f804eaa$export$f010f239efc4d445.json) {
            let result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: this.name || undefined
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.components) result.components = this.components.map((comp)=>JSON.parse(comp.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.baseType === "array") {
            result += this.arrayChildren.format(format);
            result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
        } else if (this.baseType === "tuple") {
            if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) result += this.type;
            result += "(" + this.components.map((comp)=>comp.format(format)).join(format === $4d2654448f804eaa$export$f010f239efc4d445.full ? ", " : ",") + ")";
        } else result += this.type;
        if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) {
            if (this.indexed === true) result += " indexed";
            if (format === $4d2654448f804eaa$export$f010f239efc4d445.full && this.name) result += " " + this.name;
        }
        return result;
    }
    static from(value, allowIndexed) {
        if (typeof value === "string") return $4d2654448f804eaa$export$426dc07f493a4c47.fromString(value, allowIndexed);
        return $4d2654448f804eaa$export$426dc07f493a4c47.fromObject(value);
    }
    static fromObject(value) {
        if ($4d2654448f804eaa$export$426dc07f493a4c47.isParamType(value)) return value;
        return new $4d2654448f804eaa$export$426dc07f493a4c47($4d2654448f804eaa$var$_constructorGuard, {
            name: value.name || null,
            type: $4d2654448f804eaa$var$verifyType(value.type),
            indexed: value.indexed == null ? null : !!value.indexed,
            components: value.components ? value.components.map($4d2654448f804eaa$export$426dc07f493a4c47.fromObject) : null
        });
    }
    static fromString(value, allowIndexed) {
        function ParamTypify(node) {
            return $4d2654448f804eaa$export$426dc07f493a4c47.fromObject({
                name: node.name,
                type: node.type,
                indexed: node.indexed,
                components: node.components
            });
        }
        return ParamTypify($4d2654448f804eaa$var$parseParamType(value, !!allowIndexed));
    }
    static isParamType(value) {
        return !!(value != null && value._isParamType);
    }
    constructor(constructorGuard, params){
        if (constructorGuard !== $4d2654448f804eaa$var$_constructorGuard) $4d2654448f804eaa$var$logger.throwError("use fromString", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        $4d2654448f804eaa$var$populate(this, params);
        let match = this.type.match($4d2654448f804eaa$var$paramTypeArray);
        if (match) $4d2654448f804eaa$var$populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: $4d2654448f804eaa$export$426dc07f493a4c47.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else $4d2654448f804eaa$var$populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
}
function $4d2654448f804eaa$var$parseParams(value, allowIndex) {
    return $4d2654448f804eaa$var$splitNesting(value).map((param)=>$4d2654448f804eaa$export$426dc07f493a4c47.fromString(param, allowIndex));
}
class $4d2654448f804eaa$export$ffb0004e005737fa {
    static from(value) {
        if ($4d2654448f804eaa$export$ffb0004e005737fa.isFragment(value)) return value;
        if (typeof value === "string") return $4d2654448f804eaa$export$ffb0004e005737fa.fromString(value);
        return $4d2654448f804eaa$export$ffb0004e005737fa.fromObject(value);
    }
    static fromObject(value) {
        if ($4d2654448f804eaa$export$ffb0004e005737fa.isFragment(value)) return value;
        switch(value.type){
            case "function":
                return $4d2654448f804eaa$export$8d576c928b93668f.fromObject(value);
            case "event":
                return $4d2654448f804eaa$export$958548f08bac2833.fromObject(value);
            case "constructor":
                return $4d2654448f804eaa$export$3ac5c9504f801ea4.fromObject(value);
            case "error":
                return $4d2654448f804eaa$export$2c42c6d543aa9b59.fromObject(value);
            case "fallback":
            case "receive":
                // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                return null;
        }
        return $4d2654448f804eaa$var$logger.throwArgumentError("invalid fragment object", "value", value);
    }
    static fromString(value) {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        value = value.replace(/\s/g, " ");
        value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        value = value.trim();
        if (value.split(" ")[0] === "event") return $4d2654448f804eaa$export$958548f08bac2833.fromString(value.substring(5).trim());
        else if (value.split(" ")[0] === "function") return $4d2654448f804eaa$export$8d576c928b93668f.fromString(value.substring(8).trim());
        else if (value.split("(")[0].trim() === "constructor") return $4d2654448f804eaa$export$3ac5c9504f801ea4.fromString(value.trim());
        else if (value.split(" ")[0] === "error") return $4d2654448f804eaa$export$2c42c6d543aa9b59.fromString(value.substring(5).trim());
        return $4d2654448f804eaa$var$logger.throwArgumentError("unsupported fragment", "value", value);
    }
    static isFragment(value) {
        return !!(value && value._isFragment);
    }
    constructor(constructorGuard, params){
        if (constructorGuard !== $4d2654448f804eaa$var$_constructorGuard) $4d2654448f804eaa$var$logger.throwError("use a static from method", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        $4d2654448f804eaa$var$populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
}
class $4d2654448f804eaa$export$958548f08bac2833 extends $4d2654448f804eaa$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $4d2654448f804eaa$export$f010f239efc4d445.sighash;
        if (!$4d2654448f804eaa$export$f010f239efc4d445[format]) $4d2654448f804eaa$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $4d2654448f804eaa$export$f010f239efc4d445.json) return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) result += "event ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $4d2654448f804eaa$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) {
            if (this.anonymous) result += "anonymous ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $4d2654448f804eaa$export$958548f08bac2833.fromString(value);
        return $4d2654448f804eaa$export$958548f08bac2833.fromObject(value);
    }
    static fromObject(value) {
        if ($4d2654448f804eaa$export$958548f08bac2833.isEventFragment(value)) return value;
        if (value.type !== "event") $4d2654448f804eaa$var$logger.throwArgumentError("invalid event object", "value", value);
        const params = {
            name: $4d2654448f804eaa$var$verifyIdentifier(value.name),
            anonymous: value.anonymous,
            inputs: value.inputs ? value.inputs.map($4d2654448f804eaa$export$426dc07f493a4c47.fromObject) : [],
            type: "event"
        };
        return new $4d2654448f804eaa$export$958548f08bac2833($4d2654448f804eaa$var$_constructorGuard, params);
    }
    static fromString(value) {
        let match = value.match($4d2654448f804eaa$var$regexParen);
        if (!match) $4d2654448f804eaa$var$logger.throwArgumentError("invalid event string", "value", value);
        let anonymous = false;
        match[3].split(" ").forEach((modifier)=>{
            switch(modifier.trim()){
                case "anonymous":
                    anonymous = true;
                    break;
                case "":
                    break;
                default:
                    $4d2654448f804eaa$var$logger.warn("unknown modifier: " + modifier);
            }
        });
        return $4d2654448f804eaa$export$958548f08bac2833.fromObject({
            name: match[1].trim(),
            anonymous: anonymous,
            inputs: $4d2654448f804eaa$var$parseParams(match[2], true),
            type: "event"
        });
    }
    static isEventFragment(value) {
        return value && value._isFragment && value.type === "event";
    }
}
function $4d2654448f804eaa$var$parseGas(value, params) {
    params.gas = null;
    let comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) $4d2654448f804eaa$var$logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) $4d2654448f804eaa$var$logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(comps[1]);
        return comps[0];
    }
    return value;
}
function $4d2654448f804eaa$var$parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach((modifier)=>{
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function $4d2654448f804eaa$var$verifyState(value) {
    let result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) $4d2654448f804eaa$var$logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) $4d2654448f804eaa$var$logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") $4d2654448f804eaa$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) $4d2654448f804eaa$var$logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") $4d2654448f804eaa$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
class $4d2654448f804eaa$export$3ac5c9504f801ea4 extends $4d2654448f804eaa$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $4d2654448f804eaa$export$f010f239efc4d445.sighash;
        if (!$4d2654448f804eaa$export$f010f239efc4d445[format]) $4d2654448f804eaa$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $4d2654448f804eaa$export$f010f239efc4d445.json) return JSON.stringify({
            type: "constructor",
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        if (format === $4d2654448f804eaa$export$f010f239efc4d445.sighash) $4d2654448f804eaa$var$logger.throwError("cannot format a constructor for sighash", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "format(sighash)"
        });
        let result = "constructor(" + this.inputs.map((input)=>input.format(format)).join(format === $4d2654448f804eaa$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $4d2654448f804eaa$export$3ac5c9504f801ea4.fromString(value);
        return $4d2654448f804eaa$export$3ac5c9504f801ea4.fromObject(value);
    }
    static fromObject(value) {
        if ($4d2654448f804eaa$export$3ac5c9504f801ea4.isConstructorFragment(value)) return value;
        if (value.type !== "constructor") $4d2654448f804eaa$var$logger.throwArgumentError("invalid constructor object", "value", value);
        let state = $4d2654448f804eaa$var$verifyState(value);
        if (state.constant) $4d2654448f804eaa$var$logger.throwArgumentError("constructor cannot be constant", "value", value);
        const params = {
            name: null,
            type: value.type,
            inputs: value.inputs ? value.inputs.map($4d2654448f804eaa$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(value.gas) : null
        };
        return new $4d2654448f804eaa$export$3ac5c9504f801ea4($4d2654448f804eaa$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "constructor"
        };
        value = $4d2654448f804eaa$var$parseGas(value, params);
        let parens = value.match($4d2654448f804eaa$var$regexParen);
        if (!parens || parens[1].trim() !== "constructor") $4d2654448f804eaa$var$logger.throwArgumentError("invalid constructor string", "value", value);
        params.inputs = $4d2654448f804eaa$var$parseParams(parens[2].trim(), false);
        $4d2654448f804eaa$var$parseModifiers(parens[3].trim(), params);
        return $4d2654448f804eaa$export$3ac5c9504f801ea4.fromObject(params);
    }
    static isConstructorFragment(value) {
        return value && value._isFragment && value.type === "constructor";
    }
}
class $4d2654448f804eaa$export$8d576c928b93668f extends $4d2654448f804eaa$export$3ac5c9504f801ea4 {
    format(format) {
        if (!format) format = $4d2654448f804eaa$export$f010f239efc4d445.sighash;
        if (!$4d2654448f804eaa$export$f010f239efc4d445[format]) $4d2654448f804eaa$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $4d2654448f804eaa$export$f010f239efc4d445.json) return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format))),
            outputs: this.outputs.map((output)=>JSON.parse(output.format(format)))
        });
        let result = "";
        if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) result += "function ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $4d2654448f804eaa$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) {
            if (this.stateMutability) {
                if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
            } else if (this.constant) result += "view ";
            if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map((output)=>output.format(format)).join(", ") + ") ";
            if (this.gas != null) result += "@" + this.gas.toString() + " ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $4d2654448f804eaa$export$8d576c928b93668f.fromString(value);
        return $4d2654448f804eaa$export$8d576c928b93668f.fromObject(value);
    }
    static fromObject(value) {
        if ($4d2654448f804eaa$export$8d576c928b93668f.isFunctionFragment(value)) return value;
        if (value.type !== "function") $4d2654448f804eaa$var$logger.throwArgumentError("invalid function object", "value", value);
        let state = $4d2654448f804eaa$var$verifyState(value);
        const params = {
            type: value.type,
            name: $4d2654448f804eaa$var$verifyIdentifier(value.name),
            constant: state.constant,
            inputs: value.inputs ? value.inputs.map($4d2654448f804eaa$export$426dc07f493a4c47.fromObject) : [],
            outputs: value.outputs ? value.outputs.map($4d2654448f804eaa$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(value.gas) : null
        };
        return new $4d2654448f804eaa$export$8d576c928b93668f($4d2654448f804eaa$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "function"
        };
        value = $4d2654448f804eaa$var$parseGas(value, params);
        let comps = value.split(" returns ");
        if (comps.length > 2) $4d2654448f804eaa$var$logger.throwArgumentError("invalid function string", "value", value);
        let parens = comps[0].match($4d2654448f804eaa$var$regexParen);
        if (!parens) $4d2654448f804eaa$var$logger.throwArgumentError("invalid function signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $4d2654448f804eaa$var$verifyIdentifier(params.name);
        params.inputs = $4d2654448f804eaa$var$parseParams(parens[2], false);
        $4d2654448f804eaa$var$parseModifiers(parens[3].trim(), params);
        // We have outputs
        if (comps.length > 1) {
            let returns = comps[1].match($4d2654448f804eaa$var$regexParen);
            if (returns[1].trim() != "" || returns[3].trim() != "") $4d2654448f804eaa$var$logger.throwArgumentError("unexpected tokens", "value", value);
            params.outputs = $4d2654448f804eaa$var$parseParams(returns[2], false);
        } else params.outputs = [];
        return $4d2654448f804eaa$export$8d576c928b93668f.fromObject(params);
    }
    static isFunctionFragment(value) {
        return value && value._isFragment && value.type === "function";
    }
}
//export class StructFragment extends Fragment {
//}
function $4d2654448f804eaa$var$checkForbidden(fragment) {
    const sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") $4d2654448f804eaa$var$logger.throwArgumentError(`cannot specify user defined ${sig} error`, "fragment", fragment);
    return fragment;
}
class $4d2654448f804eaa$export$2c42c6d543aa9b59 extends $4d2654448f804eaa$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $4d2654448f804eaa$export$f010f239efc4d445.sighash;
        if (!$4d2654448f804eaa$export$f010f239efc4d445[format]) $4d2654448f804eaa$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $4d2654448f804eaa$export$f010f239efc4d445.json) return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) result += "error ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $4d2654448f804eaa$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $4d2654448f804eaa$export$2c42c6d543aa9b59.fromString(value);
        return $4d2654448f804eaa$export$2c42c6d543aa9b59.fromObject(value);
    }
    static fromObject(value) {
        if ($4d2654448f804eaa$export$2c42c6d543aa9b59.isErrorFragment(value)) return value;
        if (value.type !== "error") $4d2654448f804eaa$var$logger.throwArgumentError("invalid error object", "value", value);
        const params = {
            type: value.type,
            name: $4d2654448f804eaa$var$verifyIdentifier(value.name),
            inputs: value.inputs ? value.inputs.map($4d2654448f804eaa$export$426dc07f493a4c47.fromObject) : []
        };
        return $4d2654448f804eaa$var$checkForbidden(new $4d2654448f804eaa$export$2c42c6d543aa9b59($4d2654448f804eaa$var$_constructorGuard, params));
    }
    static fromString(value) {
        let params = {
            type: "error"
        };
        let parens = value.match($4d2654448f804eaa$var$regexParen);
        if (!parens) $4d2654448f804eaa$var$logger.throwArgumentError("invalid error signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $4d2654448f804eaa$var$verifyIdentifier(params.name);
        params.inputs = $4d2654448f804eaa$var$parseParams(parens[2], false);
        return $4d2654448f804eaa$var$checkForbidden($4d2654448f804eaa$export$2c42c6d543aa9b59.fromObject(params));
    }
    static isErrorFragment(value) {
        return value && value._isFragment && value.type === "error";
    }
}
function $4d2654448f804eaa$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
const $4d2654448f804eaa$var$regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function $4d2654448f804eaa$var$verifyIdentifier(value) {
    if (!value || !value.match($4d2654448f804eaa$var$regexIdentifier)) $4d2654448f804eaa$var$logger.throwArgumentError(`invalid identifier "${value}"`, "value", value);
    return value;
}
const $4d2654448f804eaa$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function $4d2654448f804eaa$var$splitNesting(value) {
    value = value.trim();
    let result = [];
    let accum = "";
    let depth = 0;
    for(let offset = 0; offset < value.length; offset++){
        let c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) $4d2654448f804eaa$var$logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}


"use strict";
const $068794918994f80d$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d53f0a8655f612f5$export$83d89fbfd8236492));
const $068794918994f80d$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $068794918994f80d$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class $068794918994f80d$export$fe041e1a83d3efc6 {
    _getCoder(param) {
        switch(param.baseType){
            case "address":
                return new (0, $2e096dc236f9984b$export$59dbbded7775bfe7)(param.name);
            case "bool":
                return new (0, $209954548c523c50$export$fe9118d6c093150c)(param.name);
            case "string":
                return new (0, $335e72c6451b9b9a$export$2d1b854518731426)(param.name);
            case "bytes":
                return new (0, $b7e55f4d821202a8$export$e5823e9574df18d2)(param.name);
            case "array":
                return new (0, $4aced1a0cbed513e$export$88bc419d2df11f54)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
            case "tuple":
                return new (0, $d29e821f1f0ced09$export$e9fceba8f110fea6)((param.components || []).map((component)=>{
                    return this._getCoder(component);
                }), param.name);
            case "":
                return new (0, $2d21708e754b0ab4$export$70982cadf2d6b4ec)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($068794918994f80d$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            if (size === 0 || size > 256 || size % 8 !== 0) $068794918994f80d$var$logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
            return new (0, $bd7b0b14ce22a0d4$export$b934dc8cfe13938c)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($068794918994f80d$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            if (size === 0 || size > 32) $068794918994f80d$var$logger.throwArgumentError("invalid bytes length", "param", param);
            return new (0, $df8e38a8c8e0bc75$export$7dec9db68e6bcf5a)(size, param.name);
        }
        return $068794918994f80d$var$logger.throwArgumentError("invalid type", "type", param.type);
    }
    _getWordSize() {
        return 32;
    }
    _getReader(data, allowLoose) {
        return new (0, $bd6d84ecef385088$export$2f7a2f0e90c07dc4)(data, this._getWordSize(), this.coerceFunc, allowLoose);
    }
    _getWriter() {
        return new (0, $bd6d84ecef385088$export$d7a960146e1a269e)(this._getWordSize());
    }
    getDefaultValue(types) {
        const coders = types.map((type)=>this._getCoder((0, $4d2654448f804eaa$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $d29e821f1f0ced09$export$e9fceba8f110fea6)(coders, "_");
        return coder.defaultValue();
    }
    encode(types, values) {
        if (types.length !== values.length) $068794918994f80d$var$logger.throwError("types/values length mismatch", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
            count: {
                types: types.length,
                values: values.length
            },
            value: {
                types: types,
                values: values
            }
        });
        const coders = types.map((type)=>this._getCoder((0, $4d2654448f804eaa$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $d29e821f1f0ced09$export$e9fceba8f110fea6)(coders, "_");
        const writer = this._getWriter();
        coder.encode(writer, values);
        return writer.data;
    }
    decode(types, data, loose) {
        const coders = types.map((type)=>this._getCoder((0, $4d2654448f804eaa$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $d29e821f1f0ced09$export$e9fceba8f110fea6)(coders, "_");
        return coder.decode(this._getReader((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(data), loose));
    }
    constructor(coerceFunc){
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "coerceFunc", coerceFunc || null);
    }
}
const $068794918994f80d$export$51d1cfcdb913adff = new $068794918994f80d$export$fe041e1a83d3efc6();






"use strict";
const $6df659078ac9448c$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d53f0a8655f612f5$export$83d89fbfd8236492));
class $6df659078ac9448c$export$c2ab6499be98b3c5 extends (0, $19462b55124983f4$exports.Description) {
}
class $6df659078ac9448c$export$7a3223b0fadb690b extends (0, $19462b55124983f4$exports.Description) {
}
class $6df659078ac9448c$export$cfba08fc0e40e2ab extends (0, $19462b55124983f4$exports.Description) {
}
class $6df659078ac9448c$export$8ef99100a3c56f8c extends (0, $19462b55124983f4$exports.Description) {
    static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
}
const $6df659078ac9448c$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: true
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ]
    }
};
function $6df659078ac9448c$var$wrapAccessError(property, error) {
    const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
    wrap.error = error;
    return wrap;
}
class $6df659078ac9448c$export$48cefb51a4e315b2 {
    format(format) {
        if (!format) format = (0, $4d2654448f804eaa$export$f010f239efc4d445).full;
        if (format === (0, $4d2654448f804eaa$export$f010f239efc4d445).sighash) $6df659078ac9448c$var$logger.throwArgumentError("interface does not support formatting sighash", "format", format);
        const abi = this.fragments.map((fragment)=>fragment.format(format));
        // We need to re-bundle the JSON fragments a bit
        if (format === (0, $4d2654448f804eaa$export$f010f239efc4d445).json) return JSON.stringify(abi.map((j)=>JSON.parse(j)));
        return abi;
    }
    // Sub-classes can override these to handle other blockchains
    static getAbiCoder() {
        return 0, $068794918994f80d$export$51d1cfcdb913adff;
    }
    static getAddress(address) {
        return (0, $a4b82b374f356b4b$export$88411125f012957a)(address);
    }
    static getSighash(fragment) {
        return (0, $ddc3d9704a40b613$export$15da666eba198c18)((0, $337ebfbf1ce1b46f$export$d560c7e4a29451c2)(fragment.format()), 0, 4);
    }
    static getEventTopic(eventFragment) {
        return (0, $337ebfbf1ce1b46f$export$d560c7e4a29451c2)(eventFragment.format());
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getFunction(nameOrSignatureOrSighash) {
        if ((0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(nameOrSignatureOrSighash)) {
            for(const name in this.functions){
                if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
            }
            $6df659078ac9448c$var$logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.functions).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $6df659078ac9448c$var$logger.throwArgumentError("no matching function", "name", name);
            else if (matching.length > 1) $6df659078ac9448c$var$logger.throwArgumentError("multiple matching functions", "name", name);
            return this.functions[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.functions[(0, $4d2654448f804eaa$export$8d576c928b93668f).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $6df659078ac9448c$var$logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    getEvent(nameOrSignatureOrTopic) {
        if ((0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(nameOrSignatureOrTopic)) {
            const topichash = nameOrSignatureOrTopic.toLowerCase();
            for(const name in this.events){
                if (topichash === this.getEventTopic(name)) return this.events[name];
            }
            $6df659078ac9448c$var$logger.throwArgumentError("no matching event", "topichash", topichash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrTopic.indexOf("(") === -1) {
            const name = nameOrSignatureOrTopic.trim();
            const matching = Object.keys(this.events).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $6df659078ac9448c$var$logger.throwArgumentError("no matching event", "name", name);
            else if (matching.length > 1) $6df659078ac9448c$var$logger.throwArgumentError("multiple matching events", "name", name);
            return this.events[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.events[(0, $4d2654448f804eaa$export$958548f08bac2833).fromString(nameOrSignatureOrTopic).format()];
        if (!result) $6df659078ac9448c$var$logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
        return result;
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getError(nameOrSignatureOrSighash) {
        if ((0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(nameOrSignatureOrSighash)) {
            const getSighash = (0, $19462b55124983f4$exports.getStatic)(this.constructor, "getSighash");
            for(const name in this.errors){
                const error = this.errors[name];
                if (nameOrSignatureOrSighash === getSighash(error)) return this.errors[name];
            }
            $6df659078ac9448c$var$logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.errors).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $6df659078ac9448c$var$logger.throwArgumentError("no matching error", "name", name);
            else if (matching.length > 1) $6df659078ac9448c$var$logger.throwArgumentError("multiple matching errors", "name", name);
            return this.errors[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.errors[(0, $4d2654448f804eaa$export$8d576c928b93668f).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $6df659078ac9448c$var$logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Get the sighash (the bytes4 selector) used by Solidity to identify a function
    getSighash(fragment) {
        if (typeof fragment === "string") try {
            fragment = this.getFunction(fragment);
        } catch (error) {
            try {
                fragment = this.getError(fragment);
            } catch (_) {
                throw error;
            }
        }
        return (0, $19462b55124983f4$exports.getStatic)(this.constructor, "getSighash")(fragment);
    }
    // Get the topic (the bytes32 hash) used by Solidity to identify an event
    getEventTopic(eventFragment) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        return (0, $19462b55124983f4$exports.getStatic)(this.constructor, "getEventTopic")(eventFragment);
    }
    _decodeParams(params, data) {
        return this._abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this._abiCoder.encode(params, values);
    }
    encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        const bytes = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(data);
        if ((0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) !== this.getSighash(fragment)) $6df659078ac9448c$var$logger.throwArgumentError(`data signature does not match error ${fragment.name}.`, "data", (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(bytes));
        return this._decodeParams(fragment.inputs, bytes.slice(4));
    }
    encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)((0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
            this.getSighash(fragment),
            this._encodeParams(fragment.inputs, values || [])
        ]));
    }
    // Decode the data for a function call (e.g. tx.data)
    decodeFunctionData(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        const bytes = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(data);
        if ((0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) $6df659078ac9448c$var$logger.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(bytes));
        return this._decodeParams(functionFragment.inputs, bytes.slice(4));
    }
    // Encode the data for a function call (e.g. tx.data)
    encodeFunctionData(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)((0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
            this.getSighash(functionFragment),
            this._encodeParams(functionFragment.inputs, values || [])
        ]));
    }
    // Decode the result from a function call (e.g. from eth_call)
    decodeFunctionResult(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        let bytes = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(data);
        let reason = null;
        let message = "";
        let errorArgs = null;
        let errorName = null;
        let errorSignature = null;
        switch(bytes.length % this._abiCoder._getWordSize()){
            case 0:
                try {
                    return this._abiCoder.decode(functionFragment.outputs, bytes);
                } catch (error) {}
                break;
            case 4:
                {
                    const selector = (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(bytes.slice(0, 4));
                    const builtin = $6df659078ac9448c$var$BuiltinErrors[selector];
                    if (builtin) {
                        errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                        errorName = builtin.name;
                        errorSignature = builtin.signature;
                        if (builtin.reason) reason = errorArgs[0];
                        if (errorName === "Error") message = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(errorArgs[0])}`;
                        else if (errorName === "Panic") message = `; VM Exception while processing transaction: reverted with panic code ${errorArgs[0]}`;
                    } else try {
                        const error = this.getError(selector);
                        errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
                        errorName = error.name;
                        errorSignature = error.format();
                    } catch (error) {}
                    break;
                }
        }
        return $6df659078ac9448c$var$logger.throwError("call revert exception" + message, (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
            method: functionFragment.format(),
            data: (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(data),
            errorArgs: errorArgs,
            errorName: errorName,
            errorSignature: errorSignature,
            reason: reason
        });
    }
    // Encode the result for a function call (e.g. for eth_call)
    encodeFunctionResult(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(this._abiCoder.encode(functionFragment.outputs, values || []));
    }
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (values.length > eventFragment.inputs.length) $6df659078ac9448c$var$logger.throwError("too many arguments for " + eventFragment.format(), (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {
            argument: "values",
            value: values
        });
        let topics = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $337ebfbf1ce1b46f$export$d560c7e4a29451c2)(value);
            else if (param.type === "bytes") return (0, $344909d1f36347b2$export$f8151fce47ad1c35)((0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            if (param.type.match(/^u?int/)) value = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(value).toHexString();
            // Check addresses are valid
            if (param.type === "address") this._abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)((0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(value), 32);
        };
        values.forEach((value, index)=>{
            let param = eventFragment.inputs[index];
            if (!param.indexed) {
                if (value != null) $6df659078ac9448c$var$logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") $6df659078ac9448c$var$logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        if (values.length !== eventFragment.inputs.length) $6df659078ac9448c$var$logger.throwArgumentError("event arguments/values mismatch", "values", values);
        eventFragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $337ebfbf1ce1b46f$export$d560c7e4a29451c2)(value));
                else if (param.type === "bytes") topics.push((0, $344909d1f36347b2$export$f8151fce47ad1c35)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this._abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this._abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(eventFragment, data, topics) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (topics != null && !eventFragment.anonymous) {
            let topicHash = this.getEventTopic(eventFragment);
            if (!(0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) $6df659078ac9448c$var$logger.throwError("fragment/topic mismatch", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "topics[0]",
                expected: topicHash,
                value: topics[0]
            });
            topics = topics.slice(1);
        }
        let indexed = [];
        let nonIndexed = [];
        let dynamic = [];
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $4d2654448f804eaa$export$426dc07f493a4c47).fromObject({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        let resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)(topics)) : null;
        let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
        let result = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (resultIndexed == null) result[index] = new $6df659078ac9448c$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: null
                });
                else if (dynamic[index]) result[index] = new $6df659078ac9448c$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: resultIndexed[indexedIndex++]
                });
                else try {
                    result[index] = resultIndexed[indexedIndex++];
                } catch (error) {
                    result[index] = error;
                }
            } else try {
                result[index] = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                result[index] = error;
            }
            // Add the keyword argument if named and safe
            if (param.name && result[param.name] == null) {
                const value = result[index];
                // Make error named values throw on access
                if (value instanceof Error) Object.defineProperty(result, param.name, {
                    enumerable: true,
                    get: ()=>{
                        throw $6df659078ac9448c$var$wrapAccessError(`property ${JSON.stringify(param.name)}`, value);
                    }
                });
                else result[param.name] = value;
            }
        });
        // Make all error indexed values throw on access
        for(let i = 0; i < result.length; i++){
            const value = result[i];
            if (value instanceof Error) Object.defineProperty(result, i, {
                enumerable: true,
                get: ()=>{
                    throw $6df659078ac9448c$var$wrapAccessError(`index ${i}`, value);
                }
            });
        }
        return Object.freeze(result);
    }
    // Given a transaction, find the matching function fragment (if any) and
    // determine all its properties and call parameters
    parseTransaction(tx) {
        let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $6df659078ac9448c$export$7a3223b0fadb690b({
            args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
            functionFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
            value: (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(tx.value || "0")
        });
    }
    // @TODO
    //parseCallResult(data: BytesLike): ??
    // Given an event log, find the matching event fragment (if any) and
    // determine all its properties and values
    parseLog(log) {
        let fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $6df659078ac9448c$export$c2ab6499be98b3c5({
            eventFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            topic: this.getEventTopic(fragment),
            args: this.decodeEventLog(fragment, log.data, log.topics)
        });
    }
    parseError(data) {
        const hexData = (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(data);
        let fragment = this.getError(hexData.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $6df659078ac9448c$export$cfba08fc0e40e2ab({
            args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
            errorFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment)
        });
    }
    /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ static isInterface(value) {
        return !!(value && value._isInterface);
    }
    constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "fragments", abi.map((fragment)=>{
            return (0, $4d2654448f804eaa$export$ffb0004e005737fa).from(fragment);
        }).filter((fragment)=>fragment != null));
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "_abiCoder", (0, $19462b55124983f4$exports.getStatic)(new.target, "getAbiCoder")());
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "functions", {});
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "errors", {});
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "events", {});
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach((fragment)=>{
            let bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        $6df659078ac9448c$var$logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $19462b55124983f4$exports.defineReadOnly)(this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.events;
                    break;
                case "error":
                    bucket = this.errors;
                    break;
                default:
                    return;
            }
            let signature = fragment.format();
            if (bucket[signature]) {
                $6df659078ac9448c$var$logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $19462b55124983f4$exports.defineReadOnly)(this, "deploy", (0, $4d2654448f804eaa$export$3ac5c9504f801ea4).from({
            payable: false,
            type: "constructor"
        }));
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "_isInterface", true);
    }
}


var $fd80fed41b6901ec$exports = {};

$parcel$export($fd80fed41b6901ec$exports, "ForkEvent", function () { return $fd80fed41b6901ec$export$406ece1549ccd00e; });
$parcel$export($fd80fed41b6901ec$exports, "Provider", function () { return $fd80fed41b6901ec$export$2881499e37b75b9a; });




const $866623cc4d757217$export$83d89fbfd8236492 = "abstract-provider/5.7.0";


"use strict";
var $fd80fed41b6901ec$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $fd80fed41b6901ec$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $866623cc4d757217$export$83d89fbfd8236492));
class $fd80fed41b6901ec$export$406ece1549ccd00e extends (0, $19462b55124983f4$exports.Description) {
    static isForkEvent(value) {
        return !!(value && value._isForkEvent);
    }
}
class $fd80fed41b6901ec$export$5b2cada8494f9d99 extends $fd80fed41b6901ec$export$406ece1549ccd00e {
    constructor(blockHash, expiry){
        if (!(0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(blockHash, 32)) $fd80fed41b6901ec$var$logger.throwArgumentError("invalid blockHash", "blockHash", blockHash);
        super({
            _isForkEvent: true,
            _isBlockForkEvent: true,
            expiry: expiry || 0,
            blockHash: blockHash
        });
    }
}
class $fd80fed41b6901ec$export$26bcd61a55716c98 extends $fd80fed41b6901ec$export$406ece1549ccd00e {
    constructor(hash, expiry){
        if (!(0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(hash, 32)) $fd80fed41b6901ec$var$logger.throwArgumentError("invalid transaction hash", "hash", hash);
        super({
            _isForkEvent: true,
            _isTransactionForkEvent: true,
            expiry: expiry || 0,
            hash: hash
        });
    }
}
class $fd80fed41b6901ec$export$8f8609bfee47c93 extends $fd80fed41b6901ec$export$406ece1549ccd00e {
    constructor(beforeHash, afterHash, expiry){
        if (!(0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(beforeHash, 32)) $fd80fed41b6901ec$var$logger.throwArgumentError("invalid transaction hash", "beforeHash", beforeHash);
        if (!(0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(afterHash, 32)) $fd80fed41b6901ec$var$logger.throwArgumentError("invalid transaction hash", "afterHash", afterHash);
        super({
            _isForkEvent: true,
            _isTransactionOrderForkEvent: true,
            expiry: expiry || 0,
            beforeHash: beforeHash,
            afterHash: afterHash
        });
    }
}
class $fd80fed41b6901ec$export$2881499e37b75b9a {
    getFeeData() {
        return $fd80fed41b6901ec$var$__awaiter(this, void 0, void 0, function*() {
            const { block: block, gasPrice: gasPrice } = yield (0, $19462b55124983f4$exports.resolveProperties)({
                block: this.getBlock("latest"),
                gasPrice: this.getGasPrice().catch((error)=>{
                    // @TODO: Why is this now failing on Calaveras?
                    //console.log(error);
                    return null;
                })
            });
            let lastBaseFeePerGas = null, maxFeePerGas = null, maxPriorityFeePerGas = null;
            if (block && block.baseFeePerGas) {
                // We may want to compute this more accurately in the future,
                // using the formula "check if the base fee is correct".
                // See: https://eips.ethereum.org/EIPS/eip-1559
                lastBaseFeePerGas = block.baseFeePerGas;
                maxPriorityFeePerGas = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from("1500000000");
                maxFeePerGas = block.baseFeePerGas.mul(2).add(maxPriorityFeePerGas);
            }
            return {
                lastBaseFeePerGas: lastBaseFeePerGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                gasPrice: gasPrice
            };
        });
    }
    // Alias for "on"
    addListener(eventName, listener) {
        return this.on(eventName, listener);
    }
    // Alias for "off"
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
    static isProvider(value) {
        return !!(value && value._isProvider);
    }
    constructor(){
        $fd80fed41b6901ec$var$logger.checkAbstract(new.target, $fd80fed41b6901ec$export$2881499e37b75b9a);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "_isProvider", true);
    }
}


var $d9b7eb644de5bd3c$exports = {};

$parcel$export($d9b7eb644de5bd3c$exports, "Signer", function () { return $d9b7eb644de5bd3c$export$fdf54fdde81cc9f0; });
$parcel$export($d9b7eb644de5bd3c$exports, "VoidSigner", function () { return $d9b7eb644de5bd3c$export$7dbc56d9b9612bad; });


const $efbf3b320c61292d$export$83d89fbfd8236492 = "abstract-signer/5.7.0";


"use strict";
var $d9b7eb644de5bd3c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $d9b7eb644de5bd3c$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $efbf3b320c61292d$export$83d89fbfd8236492));
const $d9b7eb644de5bd3c$var$allowedTransactionKeys = [
    "accessList",
    "ccipReadEnabled",
    "chainId",
    "customData",
    "data",
    "from",
    "gasLimit",
    "gasPrice",
    "maxFeePerGas",
    "maxPriorityFeePerGas",
    "nonce",
    "to",
    "type",
    "value"
];
const $d9b7eb644de5bd3c$var$forwardErrors = [
    (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS,
    (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.NONCE_EXPIRED,
    (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED
];
class $d9b7eb644de5bd3c$export$fdf54fdde81cc9f0 {
    ///////////////////
    // Sub-classes MAY override these
    getBalance(blockTag) {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getBalance");
            return yield this.provider.getBalance(this.getAddress(), blockTag);
        });
    }
    getTransactionCount(blockTag) {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getTransactionCount");
            return yield this.provider.getTransactionCount(this.getAddress(), blockTag);
        });
    }
    // Populates "from" if unspecified, and estimates the gas for the transaction
    estimateGas(transaction) {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("estimateGas");
            const tx = yield (0, $19462b55124983f4$exports.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.estimateGas(tx);
        });
    }
    // Populates "from" if unspecified, and calls with the transaction
    call(transaction, blockTag) {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("call");
            const tx = yield (0, $19462b55124983f4$exports.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.call(tx, blockTag);
        });
    }
    // Populates all fields in a transaction, signs it and sends it to the network
    sendTransaction(transaction) {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("sendTransaction");
            const tx = yield this.populateTransaction(transaction);
            const signedTx = yield this.signTransaction(tx);
            return yield this.provider.sendTransaction(signedTx);
        });
    }
    getChainId() {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getChainId");
            const network = yield this.provider.getNetwork();
            return network.chainId;
        });
    }
    getGasPrice() {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getGasPrice");
            return yield this.provider.getGasPrice();
        });
    }
    getFeeData() {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getFeeData");
            return yield this.provider.getFeeData();
        });
    }
    resolveName(name) {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("resolveName");
            return yield this.provider.resolveName(name);
        });
    }
    // Checks a transaction does not contain invalid keys and if
    // no "from" is provided, populates it.
    // - does NOT require a provider
    // - adds "from" is not present
    // - returns a COPY (safe to mutate the result)
    // By default called from: (overriding these prevents it)
    //   - call
    //   - estimateGas
    //   - populateTransaction (and therefor sendTransaction)
    checkTransaction(transaction) {
        for(const key in transaction)if ($d9b7eb644de5bd3c$var$allowedTransactionKeys.indexOf(key) === -1) $d9b7eb644de5bd3c$var$logger.throwArgumentError("invalid transaction key: " + key, "transaction", transaction);
        const tx = (0, $19462b55124983f4$exports.shallowCopy)(transaction);
        if (tx.from == null) tx.from = this.getAddress();
        else // Make sure any provided address matches this signer
        tx.from = Promise.all([
            Promise.resolve(tx.from),
            this.getAddress()
        ]).then((result)=>{
            if (result[0].toLowerCase() !== result[1].toLowerCase()) $d9b7eb644de5bd3c$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            return result[0];
        });
        return tx;
    }
    // Populates ALL keys for a transaction and checks that "from" matches
    // this Signer. Should be used by sendTransaction but NOT by signTransaction.
    // By default called from: (overriding these prevents it)
    //   - sendTransaction
    //
    // Notes:
    //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
    populateTransaction(transaction) {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            const tx = yield (0, $19462b55124983f4$exports.resolveProperties)(this.checkTransaction(transaction));
            if (tx.to != null) {
                tx.to = Promise.resolve(tx.to).then((to)=>$d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
                        if (to == null) return null;
                        const address = yield this.resolveName(to);
                        if (address == null) $d9b7eb644de5bd3c$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                        return address;
                    }));
                // Prevent this error from causing an UnhandledPromiseException
                tx.to.catch((error)=>{});
            }
            // Do not allow mixing pre-eip-1559 and eip-1559 properties
            const hasEip1559 = tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null;
            if (tx.gasPrice != null && (tx.type === 2 || hasEip1559)) $d9b7eb644de5bd3c$var$logger.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", transaction);
            else if ((tx.type === 0 || tx.type === 1) && hasEip1559) $d9b7eb644de5bd3c$var$logger.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", transaction);
            if ((tx.type === 2 || tx.type == null) && tx.maxFeePerGas != null && tx.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
            tx.type = 2;
            else if (tx.type === 0 || tx.type === 1) // Explicit Legacy or EIP-2930 transaction
            // Populate missing gasPrice
            {
                if (tx.gasPrice == null) tx.gasPrice = this.getGasPrice();
            } else {
                // We need to get fee data to determine things
                const feeData = yield this.getFeeData();
                if (tx.type == null) {
                    // We need to auto-detect the intended type of this transaction...
                    if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                        // The network supports EIP-1559!
                        // Upgrade transaction from null to eip-1559
                        tx.type = 2;
                        if (tx.gasPrice != null) {
                            // Using legacy gasPrice property on an eip-1559 network,
                            // so use gasPrice as both fee properties
                            const gasPrice = tx.gasPrice;
                            delete tx.gasPrice;
                            tx.maxFeePerGas = gasPrice;
                            tx.maxPriorityFeePerGas = gasPrice;
                        } else {
                            // Populate missing fee data
                            if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                            if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                        }
                    } else if (feeData.gasPrice != null) {
                        // Network doesn't support EIP-1559...
                        // ...but they are trying to use EIP-1559 properties
                        if (hasEip1559) $d9b7eb644de5bd3c$var$logger.throwError("network does not support EIP-1559", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                            operation: "populateTransaction"
                        });
                        // Populate missing fee data
                        if (tx.gasPrice == null) tx.gasPrice = feeData.gasPrice;
                        // Explicitly set untyped transaction to legacy
                        tx.type = 0;
                    } else // getFeeData has failed us.
                    $d9b7eb644de5bd3c$var$logger.throwError("failed to get consistent fee data", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                        operation: "signer.getFeeData"
                    });
                } else if (tx.type === 2) {
                    // Explicitly using EIP-1559
                    // Populate missing fee data
                    if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                    if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                }
            }
            if (tx.nonce == null) tx.nonce = this.getTransactionCount("pending");
            if (tx.gasLimit == null) tx.gasLimit = this.estimateGas(tx).catch((error)=>{
                if ($d9b7eb644de5bd3c$var$forwardErrors.indexOf(error.code) >= 0) throw error;
                return $d9b7eb644de5bd3c$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
                    error: error,
                    tx: tx
                });
            });
            if (tx.chainId == null) tx.chainId = this.getChainId();
            else tx.chainId = Promise.all([
                Promise.resolve(tx.chainId),
                this.getChainId()
            ]).then((results)=>{
                if (results[1] !== 0 && results[0] !== results[1]) $d9b7eb644de5bd3c$var$logger.throwArgumentError("chainId address mismatch", "transaction", transaction);
                return results[0];
            });
            return yield (0, $19462b55124983f4$exports.resolveProperties)(tx);
        });
    }
    ///////////////////
    // Sub-classes SHOULD leave these alone
    _checkProvider(operation) {
        if (!this.provider) $d9b7eb644de5bd3c$var$logger.throwError("missing provider", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: operation || "_checkProvider"
        });
    }
    static isSigner(value) {
        return !!(value && value._isSigner);
    }
    ///////////////////
    // Sub-classes MUST call super
    constructor(){
        $d9b7eb644de5bd3c$var$logger.checkAbstract(new.target, $d9b7eb644de5bd3c$export$fdf54fdde81cc9f0);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "_isSigner", true);
    }
}
class $d9b7eb644de5bd3c$export$7dbc56d9b9612bad extends $d9b7eb644de5bd3c$export$fdf54fdde81cc9f0 {
    getAddress() {
        return Promise.resolve(this.address);
    }
    _fail(message, operation) {
        return Promise.resolve().then(()=>{
            $d9b7eb644de5bd3c$var$logger.throwError(message, (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: operation
            });
        });
    }
    signMessage(message) {
        return this._fail("VoidSigner cannot sign messages", "signMessage");
    }
    signTransaction(transaction) {
        return this._fail("VoidSigner cannot sign transactions", "signTransaction");
    }
    _signTypedData(domain, types, value) {
        return this._fail("VoidSigner cannot sign typed data", "signTypedData");
    }
    connect(provider) {
        return new $d9b7eb644de5bd3c$export$7dbc56d9b9612bad(this.address, provider);
    }
    constructor(address, provider){
        super();
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "address", address);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "provider", provider || null);
    }
}














var $i4ZT1 = parcelRequire("i4ZT1");

var $dMFrt = parcelRequire("dMFrt");
var $34c5a7a115bc641e$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $34c5a7a115bc641e$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function $34c5a7a115bc641e$var$createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function(path, base) {
            return $34c5a7a115bc641e$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $34c5a7a115bc641e$var$getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") ? n["default"] : n;
}
function $34c5a7a115bc641e$var$getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") && Object.keys(n).length === 1 ? n["default"] : n;
}
function $34c5a7a115bc641e$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
function $34c5a7a115bc641e$var$commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $34c5a7a115bc641e$var$minimalisticAssert = $34c5a7a115bc641e$var$assert;
function $34c5a7a115bc641e$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$34c5a7a115bc641e$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};
var $34c5a7a115bc641e$var$utils_1 = $34c5a7a115bc641e$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== "string") {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
        if (word.length === 1) return "0" + word;
        else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
        var res = "";
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === "hex") return toHex(arr);
        else return arr;
    };
});
var $34c5a7a115bc641e$var$utils_1$1 = $34c5a7a115bc641e$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    utils.assert = $34c5a7a115bc641e$var$minimalisticAssert;
    utils.toArray = $34c5a7a115bc641e$var$utils_1.toArray;
    utils.zero2 = $34c5a7a115bc641e$var$utils_1.zero2;
    utils.toHex = $34c5a7a115bc641e$var$utils_1.toHex;
    utils.encode = $34c5a7a115bc641e$var$utils_1.encode;
    // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);
        var ws = 1 << w + 1;
        var k = num.clone();
        for(var i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    utils.getNAF = getNAF;
    // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
        var key = "_" + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
        return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(bytes, "hex", "le");
    }
    utils.intFromLE = intFromLE;
});
"use strict";
var $34c5a7a115bc641e$var$getNAF = $34c5a7a115bc641e$var$utils_1$1.getNAF;
var $34c5a7a115bc641e$var$getJSF = $34c5a7a115bc641e$var$utils_1$1.getJSF;
var $34c5a7a115bc641e$var$assert$1 = $34c5a7a115bc641e$var$utils_1$1.assert;
function $34c5a7a115bc641e$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1))).red(conf.prime) : (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1))).mont(this.p);
    // Useful for many curves
    this.zero = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(0).toRed(this.red);
    this.one = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(1).toRed(this.red);
    this.two = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var $34c5a7a115bc641e$var$base = $34c5a7a115bc641e$var$BaseCurve;
$34c5a7a115bc641e$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$34c5a7a115bc641e$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$34c5a7a115bc641e$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $34c5a7a115bc641e$var$assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $34c5a7a115bc641e$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$34c5a7a115bc641e$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $34c5a7a115bc641e$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $34c5a7a115bc641e$var$assert$1(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$34c5a7a115bc641e$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $34c5a7a115bc641e$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $34c5a7a115bc641e$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $34c5a7a115bc641e$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $34c5a7a115bc641e$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$34c5a7a115bc641e$var$BaseCurve.BasePoint = $34c5a7a115bc641e$var$BasePoint;
$34c5a7a115bc641e$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$34c5a7a115bc641e$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$34c5a7a115bc641e$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $34c5a7a115bc641e$var$utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $34c5a7a115bc641e$var$assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $34c5a7a115bc641e$var$assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$34c5a7a115bc641e$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$34c5a7a115bc641e$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$34c5a7a115bc641e$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $34c5a7a115bc641e$var$utils_1$1.encode(this._encode(compact), enc);
};
$34c5a7a115bc641e$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$34c5a7a115bc641e$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$34c5a7a115bc641e$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$34c5a7a115bc641e$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$34c5a7a115bc641e$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$34c5a7a115bc641e$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var $34c5a7a115bc641e$var$inherits_browser = $34c5a7a115bc641e$var$createCommonjsModule(function(module) {
    if (typeof Object.create === "function") // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
"use strict";
var $34c5a7a115bc641e$var$assert$2 = $34c5a7a115bc641e$var$utils_1$1.assert;
function $34c5a7a115bc641e$var$ShortCurve(conf) {
    $34c5a7a115bc641e$var$base.call(this, "short", conf);
    this.a = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(conf.a, 16).toRed(this.red);
    this.b = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$34c5a7a115bc641e$var$inherits_browser($34c5a7a115bc641e$var$ShortCurve, $34c5a7a115bc641e$var$base);
var $34c5a7a115bc641e$var$short_1 = $34c5a7a115bc641e$var$ShortCurve;
$34c5a7a115bc641e$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $34c5a7a115bc641e$var$assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(vec.a, 16),
            b: new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$34c5a7a115bc641e$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1))).mont(num);
    var tinv = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$34c5a7a115bc641e$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(1);
    var y1 = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(0);
    var x2 = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(0);
    var y2 = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$34c5a7a115bc641e$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$34c5a7a115bc641e$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$34c5a7a115bc641e$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$34c5a7a115bc641e$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $34c5a7a115bc641e$var$Point(curve, x, y, isRed) {
    $34c5a7a115bc641e$var$base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$34c5a7a115bc641e$var$inherits_browser($34c5a7a115bc641e$var$Point, $34c5a7a115bc641e$var$base.BasePoint);
$34c5a7a115bc641e$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $34c5a7a115bc641e$var$Point(this, x, y, isRed);
};
$34c5a7a115bc641e$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $34c5a7a115bc641e$var$Point.fromJSON(this, obj, red);
};
$34c5a7a115bc641e$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$34c5a7a115bc641e$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$34c5a7a115bc641e$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$34c5a7a115bc641e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$34c5a7a115bc641e$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$34c5a7a115bc641e$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$34c5a7a115bc641e$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$34c5a7a115bc641e$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$34c5a7a115bc641e$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$34c5a7a115bc641e$var$Point.prototype.mul = function mul(k) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$34c5a7a115bc641e$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$34c5a7a115bc641e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$34c5a7a115bc641e$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$34c5a7a115bc641e$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$34c5a7a115bc641e$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $34c5a7a115bc641e$var$JPoint(curve, x, y, z) {
    $34c5a7a115bc641e$var$base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(0);
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(y, 16);
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$34c5a7a115bc641e$var$inherits_browser($34c5a7a115bc641e$var$JPoint, $34c5a7a115bc641e$var$base.BasePoint);
$34c5a7a115bc641e$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $34c5a7a115bc641e$var$JPoint(this, x, y, z);
};
$34c5a7a115bc641e$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$34c5a7a115bc641e$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$34c5a7a115bc641e$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$34c5a7a115bc641e$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$34c5a7a115bc641e$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$34c5a7a115bc641e$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$34c5a7a115bc641e$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$34c5a7a115bc641e$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$34c5a7a115bc641e$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$34c5a7a115bc641e$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$34c5a7a115bc641e$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(k, kbase);
    return this.curve._wnafMul(this, k);
};
$34c5a7a115bc641e$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$34c5a7a115bc641e$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$34c5a7a115bc641e$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$34c5a7a115bc641e$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var $34c5a7a115bc641e$var$curve_1 = $34c5a7a115bc641e$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curve = exports;
    curve.base = $34c5a7a115bc641e$var$base;
    curve.short = $34c5a7a115bc641e$var$short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var $34c5a7a115bc641e$var$curves_1 = $34c5a7a115bc641e$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curves = exports;
    var assert = $34c5a7a115bc641e$var$utils_1$1.assert;
    function PresetCurve(options) {
        if (options.type === "short") this.curve = new $34c5a7a115bc641e$var$curve_1.short(options);
        else if (options.type === "edwards") this.curve = new $34c5a7a115bc641e$var$curve_1.edwards(options);
        else this.curve = new $34c5a7a115bc641e$var$curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        assert(this.g.validate(), "Invalid curve");
        assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    defineCurve("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256,
        gRed: false,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    });
    defineCurve("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256,
        gRed: false,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    });
    defineCurve("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256,
        gRed: false,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    });
    defineCurve("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256,
        gRed: false,
        g: [
            "9"
        ]
    });
    defineCurve("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        // -121665 * (121666^(-1)) (mod P)
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256,
        gRed: false,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            // 4/5
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256,
        // Precomputed endomorphism
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: false,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            pre
        ]
    });
});
"use strict";
function $34c5a7a115bc641e$var$HmacDRBG(options) {
    if (!(this instanceof $34c5a7a115bc641e$var$HmacDRBG)) return new $34c5a7a115bc641e$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $34c5a7a115bc641e$var$utils_1.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $34c5a7a115bc641e$var$utils_1.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $34c5a7a115bc641e$var$utils_1.toArray(options.pers, options.persEnc || "hex");
    $34c5a7a115bc641e$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
var $34c5a7a115bc641e$var$hmacDrbg = $34c5a7a115bc641e$var$HmacDRBG;
$34c5a7a115bc641e$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$34c5a7a115bc641e$var$HmacDRBG.prototype._hmac = function hmac() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).hmac(this.hash, this.K);
};
$34c5a7a115bc641e$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$34c5a7a115bc641e$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $34c5a7a115bc641e$var$utils_1.toArray(entropy, entropyEnc);
    add = $34c5a7a115bc641e$var$utils_1.toArray(add, addEnc);
    $34c5a7a115bc641e$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$34c5a7a115bc641e$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $34c5a7a115bc641e$var$utils_1.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $34c5a7a115bc641e$var$utils_1.encode(res, enc);
};
"use strict";
var $34c5a7a115bc641e$var$assert$3 = $34c5a7a115bc641e$var$utils_1$1.assert;
function $34c5a7a115bc641e$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var $34c5a7a115bc641e$var$key = $34c5a7a115bc641e$var$KeyPair;
$34c5a7a115bc641e$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $34c5a7a115bc641e$var$KeyPair) return pub;
    return new $34c5a7a115bc641e$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$34c5a7a115bc641e$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $34c5a7a115bc641e$var$KeyPair) return priv;
    return new $34c5a7a115bc641e$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$34c5a7a115bc641e$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$34c5a7a115bc641e$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$34c5a7a115bc641e$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$34c5a7a115bc641e$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$34c5a7a115bc641e$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $34c5a7a115bc641e$var$assert$3(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $34c5a7a115bc641e$var$assert$3(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$34c5a7a115bc641e$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $34c5a7a115bc641e$var$assert$3(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$34c5a7a115bc641e$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$34c5a7a115bc641e$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$34c5a7a115bc641e$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
"use strict";
var $34c5a7a115bc641e$var$assert$4 = $34c5a7a115bc641e$var$utils_1$1.assert;
function $34c5a7a115bc641e$var$Signature(options, enc) {
    if (options instanceof $34c5a7a115bc641e$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $34c5a7a115bc641e$var$assert$4(options.r && options.s, "Signature without r or s");
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(options.r, 16);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var $34c5a7a115bc641e$var$signature = $34c5a7a115bc641e$var$Signature;
function $34c5a7a115bc641e$var$Position() {
    this.place = 0;
}
function $34c5a7a115bc641e$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $34c5a7a115bc641e$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$34c5a7a115bc641e$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $34c5a7a115bc641e$var$utils_1$1.toArray(data, enc);
    var p = new $34c5a7a115bc641e$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $34c5a7a115bc641e$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $34c5a7a115bc641e$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $34c5a7a115bc641e$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(r);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(s);
    this.recoveryParam = null;
    return true;
};
function $34c5a7a115bc641e$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$34c5a7a115bc641e$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $34c5a7a115bc641e$var$rmPadding(r);
    s = $34c5a7a115bc641e$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $34c5a7a115bc641e$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $34c5a7a115bc641e$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $34c5a7a115bc641e$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $34c5a7a115bc641e$var$utils_1$1.encode(res, enc);
};
"use strict";
var $34c5a7a115bc641e$var$rand = /*RicMoo:ethers:require(brorand)*/ function() {
    throw new Error("unsupported");
};
var $34c5a7a115bc641e$var$assert$5 = $34c5a7a115bc641e$var$utils_1$1.assert;
function $34c5a7a115bc641e$var$EC(options) {
    if (!(this instanceof $34c5a7a115bc641e$var$EC)) return new $34c5a7a115bc641e$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $34c5a7a115bc641e$var$assert$5(Object.prototype.hasOwnProperty.call($34c5a7a115bc641e$var$curves_1, options), "Unknown curve " + options);
        options = $34c5a7a115bc641e$var$curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $34c5a7a115bc641e$var$curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var $34c5a7a115bc641e$var$ec = $34c5a7a115bc641e$var$EC;
$34c5a7a115bc641e$var$EC.prototype.keyPair = function keyPair(options) {
    return new $34c5a7a115bc641e$var$key(this, options);
};
$34c5a7a115bc641e$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $34c5a7a115bc641e$var$key.fromPrivate(this, priv, enc);
};
$34c5a7a115bc641e$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $34c5a7a115bc641e$var$key.fromPublic(this, pub, enc);
};
$34c5a7a115bc641e$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $34c5a7a115bc641e$var$hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $34c5a7a115bc641e$var$rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(2));
    for(;;){
        var priv = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$34c5a7a115bc641e$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$34c5a7a115bc641e$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $34c5a7a115bc641e$var$hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $34c5a7a115bc641e$var$signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$34c5a7a115bc641e$var$EC.prototype.verify = function verify(msg, signature$1, key, enc) {
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature$1 = new $34c5a7a115bc641e$var$signature(signature$1, "hex");
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$34c5a7a115bc641e$var$EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    $34c5a7a115bc641e$var$assert$5((3 & j) === j, "The recovery param is more than two bits");
    signature$1 = new $34c5a7a115bc641e$var$signature(signature$1, enc);
    var n = this.n;
    var e = new (0, (/*@__PURE__*/$parcel$interopDefault($i4ZT1)))(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$34c5a7a115bc641e$var$EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new $34c5a7a115bc641e$var$signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $34c5a7a115bc641e$var$elliptic_1 = $34c5a7a115bc641e$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var elliptic = exports;
    elliptic.version = "6.5.4";
    elliptic.utils = $34c5a7a115bc641e$var$utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error("unsupported");
    };
    elliptic.curve = $34c5a7a115bc641e$var$curve_1;
    elliptic.curves = $34c5a7a115bc641e$var$curves_1;
    // Protocols
    elliptic.ec = $34c5a7a115bc641e$var$ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var $34c5a7a115bc641e$export$129fe12d32abc311 = $34c5a7a115bc641e$var$elliptic_1.ec;





const $08e74d9fa9766383$export$83d89fbfd8236492 = "signing-key/5.7.0";


"use strict";
const $378334ead6ec6b6e$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $08e74d9fa9766383$export$83d89fbfd8236492));
let $378334ead6ec6b6e$var$_curve = null;
function $378334ead6ec6b6e$var$getCurve() {
    if (!$378334ead6ec6b6e$var$_curve) $378334ead6ec6b6e$var$_curve = new (0, $34c5a7a115bc641e$export$129fe12d32abc311)("secp256k1");
    return $378334ead6ec6b6e$var$_curve;
}
class $378334ead6ec6b6e$export$21643ca94aed3e83 {
    _addPoint(other) {
        const p0 = $378334ead6ec6b6e$var$getCurve().keyFromPublic((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(this.publicKey));
        const p1 = $378334ead6ec6b6e$var$getCurve().keyFromPublic((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = $378334ead6ec6b6e$var$getCurve().keyFromPrivate((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(this.privateKey));
        const digestBytes = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(digest);
        if (digestBytes.length !== 32) $378334ead6ec6b6e$var$logger.throwArgumentError("bad digest length", "digest", digest);
        const signature = keyPair.sign(digestBytes, {
            canonical: true
        });
        return (0, $ddc3d9704a40b613$export$7fb170f1e457988f)({
            recoveryParam: signature.recoveryParam,
            r: (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)("0x" + signature.r.toString(16), 32),
            s: (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)("0x" + signature.s.toString(16), 32)
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = $378334ead6ec6b6e$var$getCurve().keyFromPrivate((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(this.privateKey));
        const otherKeyPair = $378334ead6ec6b6e$var$getCurve().keyFromPublic((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)($378334ead6ec6b6e$export$4a89473d39301224(otherKey)));
        return (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
    constructor(privateKey){
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "curve", "secp256k1");
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "privateKey", (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(privateKey));
        if ((0, $ddc3d9704a40b613$export$13882f896d3c0683)(this.privateKey) !== 32) $378334ead6ec6b6e$var$logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        const keyPair = $378334ead6ec6b6e$var$getCurve().keyFromPrivate((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(this.privateKey));
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "_isSigningKey", true);
    }
}
function $378334ead6ec6b6e$export$952dd09fbe0232b7(digest, signature) {
    const sig = (0, $ddc3d9704a40b613$export$7fb170f1e457988f)(signature);
    const rs = {
        r: (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(sig.r),
        s: (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(sig.s)
    };
    return "0x" + $378334ead6ec6b6e$var$getCurve().recoverPubKey((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function $378334ead6ec6b6e$export$4a89473d39301224(key, compressed) {
    const bytes = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(key);
    if (bytes.length === 32) {
        const signingKey = new $378334ead6ec6b6e$export$21643ca94aed3e83(bytes);
        if (compressed) return "0x" + $378334ead6ec6b6e$var$getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(bytes);
        return "0x" + $378334ead6ec6b6e$var$getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(bytes);
        return "0x" + $378334ead6ec6b6e$var$getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return $378334ead6ec6b6e$var$logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}



const $c32b6c36440c9df1$export$83d89fbfd8236492 = "transactions/5.7.0";


"use strict";
const $cd7e99036b8e7d03$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $c32b6c36440c9df1$export$83d89fbfd8236492));
var $cd7e99036b8e7d03$export$80349e05e0724e11;
(function(TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})($cd7e99036b8e7d03$export$80349e05e0724e11 || ($cd7e99036b8e7d03$export$80349e05e0724e11 = {}));
///////////////////////////////
function $cd7e99036b8e7d03$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $a4b82b374f356b4b$export$88411125f012957a)(value);
}
function $cd7e99036b8e7d03$var$handleNumber(value) {
    if (value === "0x") return 0, $af43ef4e381177e0$export$aaef8a3eae948f03;
    return (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(value);
}
// Legacy Transaction Fields
const $cd7e99036b8e7d03$var$transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
const $cd7e99036b8e7d03$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    type: true,
    value: true
};
function $cd7e99036b8e7d03$export$e67e2732ba9803f9(key) {
    const publicKey = (0, $378334ead6ec6b6e$export$4a89473d39301224)(key);
    return (0, $a4b82b374f356b4b$export$88411125f012957a)((0, $ddc3d9704a40b613$export$15da666eba198c18)((0, $344909d1f36347b2$export$f8151fce47ad1c35)((0, $ddc3d9704a40b613$export$15da666eba198c18)(publicKey, 1)), 12));
}
function $cd7e99036b8e7d03$export$23cc18f96d8510e2(digest, signature) {
    return $cd7e99036b8e7d03$export$e67e2732ba9803f9((0, $378334ead6ec6b6e$export$952dd09fbe0232b7)((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(digest), signature));
}
function $cd7e99036b8e7d03$var$formatNumber(value, name) {
    const result = (0, $ddc3d9704a40b613$export$a8f4574d0e56446c)((0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(value).toHexString());
    if (result.length > 32) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function $cd7e99036b8e7d03$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $a4b82b374f356b4b$export$88411125f012957a)(addr),
        storageKeys: (storageKeys || []).map((storageKey, index)=>{
            if ((0, $ddc3d9704a40b613$export$13882f896d3c0683)(storageKey) !== 32) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $cd7e99036b8e7d03$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            if (set.length > 2) $cd7e99036b8e7d03$var$logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
            return $cd7e99036b8e7d03$var$accessSetify(set[0], set[1]);
        }
        return $cd7e99036b8e7d03$var$accessSetify(set.address, set.storageKeys);
    });
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $cd7e99036b8e7d03$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}
function $cd7e99036b8e7d03$var$formatAccessList(value) {
    return $cd7e99036b8e7d03$export$6c8662b1600dce2(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $cd7e99036b8e7d03$var$_serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        const gasPrice = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(transaction.gasPrice);
        const maxFeePerGas = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) $cd7e99036b8e7d03$var$logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas
        });
    }
    const fields = [
        $cd7e99036b8e7d03$var$formatNumber(transaction.chainId || 0, "chainId"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.nonce || 0, "nonce"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $a4b82b374f356b4b$export$88411125f012957a)(transaction.to) : "0x",
        $cd7e99036b8e7d03$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $cd7e99036b8e7d03$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $ddc3d9704a40b613$export$7fb170f1e457988f)(signature);
        fields.push($cd7e99036b8e7d03$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $ddc3d9704a40b613$export$a8f4574d0e56446c)(sig.r));
        fields.push((0, $ddc3d9704a40b613$export$a8f4574d0e56446c)(sig.s));
    }
    return (0, $ddc3d9704a40b613$export$6d4b99629b38754a)([
        "0x02",
        $a139c5939e084c8c$export$c564cdbbe6da493(fields)
    ]);
}
function $cd7e99036b8e7d03$var$_serializeEip2930(transaction, signature) {
    const fields = [
        $cd7e99036b8e7d03$var$formatNumber(transaction.chainId || 0, "chainId"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.nonce || 0, "nonce"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.gasPrice || 0, "gasPrice"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $a4b82b374f356b4b$export$88411125f012957a)(transaction.to) : "0x",
        $cd7e99036b8e7d03$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $cd7e99036b8e7d03$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $ddc3d9704a40b613$export$7fb170f1e457988f)(signature);
        fields.push($cd7e99036b8e7d03$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $ddc3d9704a40b613$export$a8f4574d0e56446c)(sig.r));
        fields.push((0, $ddc3d9704a40b613$export$a8f4574d0e56446c)(sig.s));
    }
    return (0, $ddc3d9704a40b613$export$6d4b99629b38754a)([
        "0x01",
        $a139c5939e084c8c$export$c564cdbbe6da493(fields)
    ]);
}
// Legacy Transactions and EIP-155
function $cd7e99036b8e7d03$var$_serialize(transaction, signature) {
    (0, $19462b55124983f4$exports.checkProperties)(transaction, $cd7e99036b8e7d03$var$allowedTransactionKeys);
    const raw = [];
    $cd7e99036b8e7d03$var$transactionFields.forEach(function(fieldInfo) {
        let value = transaction[fieldInfo.name] || [];
        const options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)((0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, $ddc3d9704a40b613$export$a8f4574d0e56446c)(value);
            if (value.length > fieldInfo.maxLength) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(value));
    });
    let chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, $ddc3d9704a40b613$export$9a14abb1a440cd5e)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) return $a139c5939e084c8c$export$c564cdbbe6da493(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    const sig = (0, $ddc3d9704a40b613$export$7fb170f1e457988f)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    let v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) $cd7e99036b8e7d03$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) $cd7e99036b8e7d03$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(v));
    raw.push((0, $ddc3d9704a40b613$export$a8f4574d0e56446c)((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(sig.r)));
    raw.push((0, $ddc3d9704a40b613$export$a8f4574d0e56446c)((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(sig.s)));
    return $a139c5939e084c8c$export$c564cdbbe6da493(raw);
}
function $cd7e99036b8e7d03$export$dfdc1655ccc5b9cb(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) $cd7e99036b8e7d03$var$logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return $cd7e99036b8e7d03$var$_serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return $cd7e99036b8e7d03$var$_serializeEip2930(transaction, signature);
        case 2:
            return $cd7e99036b8e7d03$var$_serializeEip1559(transaction, signature);
        default:
            break;
    }
    return $cd7e99036b8e7d03$var$logger.throwError(`unsupported transaction type: ${transaction.type}`, (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function $cd7e99036b8e7d03$var$_parseEipSignature(tx, fields, serialize) {
    try {
        const recid = $cd7e99036b8e7d03$var$handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)(fields[1], 32);
    tx.s = (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)(fields[2], 32);
    try {
        const digest = (0, $344909d1f36347b2$export$f8151fce47ad1c35)(serialize(tx));
        tx.from = $cd7e99036b8e7d03$export$23cc18f96d8510e2(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {}
}
function $cd7e99036b8e7d03$var$_parseEip1559(payload) {
    const transaction = $a139c5939e084c8c$export$2f872c0f2117be69(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(payload));
    const maxPriorityFeePerGas = $cd7e99036b8e7d03$var$handleNumber(transaction[2]);
    const maxFeePerGas = $cd7e99036b8e7d03$var$handleNumber(transaction[3]);
    const tx = {
        type: 2,
        chainId: $cd7e99036b8e7d03$var$handleNumber(transaction[0]).toNumber(),
        nonce: $cd7e99036b8e7d03$var$handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: $cd7e99036b8e7d03$var$handleNumber(transaction[4]),
        to: $cd7e99036b8e7d03$var$handleAddress(transaction[5]),
        value: $cd7e99036b8e7d03$var$handleNumber(transaction[6]),
        data: transaction[7],
        accessList: $cd7e99036b8e7d03$export$6c8662b1600dce2(transaction[8])
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) return tx;
    tx.hash = (0, $344909d1f36347b2$export$f8151fce47ad1c35)(payload);
    $cd7e99036b8e7d03$var$_parseEipSignature(tx, transaction.slice(9), $cd7e99036b8e7d03$var$_serializeEip1559);
    return tx;
}
function $cd7e99036b8e7d03$var$_parseEip2930(payload) {
    const transaction = $a139c5939e084c8c$export$2f872c0f2117be69(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(payload));
    const tx = {
        type: 1,
        chainId: $cd7e99036b8e7d03$var$handleNumber(transaction[0]).toNumber(),
        nonce: $cd7e99036b8e7d03$var$handleNumber(transaction[1]).toNumber(),
        gasPrice: $cd7e99036b8e7d03$var$handleNumber(transaction[2]),
        gasLimit: $cd7e99036b8e7d03$var$handleNumber(transaction[3]),
        to: $cd7e99036b8e7d03$var$handleAddress(transaction[4]),
        value: $cd7e99036b8e7d03$var$handleNumber(transaction[5]),
        data: transaction[6],
        accessList: $cd7e99036b8e7d03$export$6c8662b1600dce2(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    tx.hash = (0, $344909d1f36347b2$export$f8151fce47ad1c35)(payload);
    $cd7e99036b8e7d03$var$_parseEipSignature(tx, transaction.slice(8), $cd7e99036b8e7d03$var$_serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function $cd7e99036b8e7d03$var$_parse(rawTransaction) {
    const transaction = $a139c5939e084c8c$export$2f872c0f2117be69(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    const tx = {
        nonce: $cd7e99036b8e7d03$var$handleNumber(transaction[0]).toNumber(),
        gasPrice: $cd7e99036b8e7d03$var$handleNumber(transaction[1]),
        gasLimit: $cd7e99036b8e7d03$var$handleNumber(transaction[2]),
        to: $cd7e99036b8e7d03$var$handleAddress(transaction[3]),
        value: $cd7e99036b8e7d03$var$handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(transaction[6]).toNumber();
    } catch (error) {
        // @TODO: What makes snese to do? The v is too big
        return tx;
    }
    tx.r = (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)(transaction[7], 32);
    tx.s = (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)(transaction[8], 32);
    if ((0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(tx.r).isZero() && (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = (0, $344909d1f36347b2$export$f8151fce47ad1c35)($a139c5939e084c8c$export$c564cdbbe6da493(raw));
        try {
            tx.from = $cd7e99036b8e7d03$export$23cc18f96d8510e2(digest, {
                r: (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(tx.r),
                s: (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {}
        tx.hash = (0, $344909d1f36347b2$export$f8151fce47ad1c35)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function $cd7e99036b8e7d03$export$98e6a39c04603d36(rawTransaction) {
    const payload = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return $cd7e99036b8e7d03$var$_parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return $cd7e99036b8e7d03$var$_parseEip2930(payload);
        case 2:
            return $cd7e99036b8e7d03$var$_parseEip1559(payload);
        default:
            break;
    }
    return $cd7e99036b8e7d03$var$logger.throwError(`unsupported transaction type: ${payload[0]}`, (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}



const $cf008b3f8bbab545$export$83d89fbfd8236492 = "contracts/5.7.0";


"use strict";
var $fcd53023be51494b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $fcd53023be51494b$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $cf008b3f8bbab545$export$83d89fbfd8236492));
///////////////////////////////
const $fcd53023be51494b$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    from: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true,
    customData: true,
    ccipReadEnabled: true
};
function $fcd53023be51494b$var$resolveName(resolver, nameOrPromise) {
    return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function*() {
        const name = yield nameOrPromise;
        if (typeof name !== "string") $fcd53023be51494b$var$logger.throwArgumentError("invalid address or ENS name", "name", name);
        // If it is already an address, just use it (after adding checksum)
        try {
            return (0, $a4b82b374f356b4b$export$88411125f012957a)(name);
        } catch (error) {}
        if (!resolver) $fcd53023be51494b$var$logger.throwError("a provider or signer is needed to resolve ENS names", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "resolveName"
        });
        const address = yield resolver.resolveName(name);
        if (address == null) $fcd53023be51494b$var$logger.throwArgumentError("resolver or addr is not configured for ENS name", "name", name);
        return address;
    });
}
// Recursively replaces ENS names with promises to resolve the name and resolves all properties
function $fcd53023be51494b$var$resolveAddresses(resolver, value, paramType) {
    return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function*() {
        if (Array.isArray(paramType)) return yield Promise.all(paramType.map((paramType, index)=>{
            return $fcd53023be51494b$var$resolveAddresses(resolver, Array.isArray(value) ? value[index] : value[paramType.name], paramType);
        }));
        if (paramType.type === "address") return yield $fcd53023be51494b$var$resolveName(resolver, value);
        if (paramType.type === "tuple") return yield $fcd53023be51494b$var$resolveAddresses(resolver, value, paramType.components);
        if (paramType.baseType === "array") {
            if (!Array.isArray(value)) return Promise.reject($fcd53023be51494b$var$logger.makeError("invalid value for array", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "value",
                value: value
            }));
            return yield Promise.all(value.map((v)=>$fcd53023be51494b$var$resolveAddresses(resolver, v, paramType.arrayChildren)));
        }
        return value;
    });
}
function $fcd53023be51494b$var$populateTransaction(contract, fragment, args) {
    return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function*() {
        // If an extra argument is given, it is overrides
        let overrides = {};
        if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") overrides = (0, $19462b55124983f4$exports.shallowCopy)(args.pop());
        // Make sure the parameter count matches
        $fcd53023be51494b$var$logger.checkArgumentCount(args.length, fragment.inputs.length, "passed to contract");
        // Populate "from" override (allow promises)
        if (contract.signer) {
            if (overrides.from) // Contracts with a Signer are from the Signer's frame-of-reference;
            // but we allow overriding "from" if it matches the signer
            overrides.from = (0, $19462b55124983f4$exports.resolveProperties)({
                override: $fcd53023be51494b$var$resolveName(contract.signer, overrides.from),
                signer: contract.signer.getAddress()
            }).then((check)=>$fcd53023be51494b$var$__awaiter(this, void 0, void 0, function*() {
                    if ((0, $a4b82b374f356b4b$export$88411125f012957a)(check.signer) !== check.override) $fcd53023be51494b$var$logger.throwError("Contract with a Signer cannot override from", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                        operation: "overrides.from"
                    });
                    return check.override;
                }));
            else overrides.from = contract.signer.getAddress();
        } else if (overrides.from) overrides.from = $fcd53023be51494b$var$resolveName(contract.provider, overrides.from);
        // Wait for all dependencies to be resolved (prefer the signer over the provider)
        const resolved = yield (0, $19462b55124983f4$exports.resolveProperties)({
            args: $fcd53023be51494b$var$resolveAddresses(contract.signer || contract.provider, args, fragment.inputs),
            address: contract.resolvedAddress,
            overrides: (0, $19462b55124983f4$exports.resolveProperties)(overrides) || {}
        });
        // The ABI coded transaction
        const data = contract.interface.encodeFunctionData(fragment, resolved.args);
        const tx = {
            data: data,
            to: resolved.address
        };
        // Resolved Overrides
        const ro = resolved.overrides;
        // Populate simple overrides
        if (ro.nonce != null) tx.nonce = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(ro.nonce).toNumber();
        if (ro.gasLimit != null) tx.gasLimit = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(ro.gasLimit);
        if (ro.gasPrice != null) tx.gasPrice = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(ro.gasPrice);
        if (ro.maxFeePerGas != null) tx.maxFeePerGas = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(ro.maxFeePerGas);
        if (ro.maxPriorityFeePerGas != null) tx.maxPriorityFeePerGas = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(ro.maxPriorityFeePerGas);
        if (ro.from != null) tx.from = ro.from;
        if (ro.type != null) tx.type = ro.type;
        if (ro.accessList != null) tx.accessList = (0, $cd7e99036b8e7d03$export$6c8662b1600dce2)(ro.accessList);
        // If there was no "gasLimit" override, but the ABI specifies a default, use it
        if (tx.gasLimit == null && fragment.gas != null) {
            // Compute the intrinsic gas cost for this transaction
            // @TODO: This is based on the yellow paper as of Petersburg; this is something
            // we may wish to parameterize in v6 as part of the Network object. Since this
            // is always a non-nil to address, we can ignore G_create, but may wish to add
            // similar logic to the ContractFactory.
            let intrinsic = 21000;
            const bytes = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(data);
            for(let i = 0; i < bytes.length; i++){
                intrinsic += 4;
                if (bytes[i]) intrinsic += 64;
            }
            tx.gasLimit = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(fragment.gas).add(intrinsic);
        }
        // Populate "value" override
        if (ro.value) {
            const roValue = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(ro.value);
            if (!roValue.isZero() && !fragment.payable) $fcd53023be51494b$var$logger.throwError("non-payable method cannot override value", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: overrides.value
            });
            tx.value = roValue;
        }
        if (ro.customData) tx.customData = (0, $19462b55124983f4$exports.shallowCopy)(ro.customData);
        if (ro.ccipReadEnabled) tx.ccipReadEnabled = !!ro.ccipReadEnabled;
        // Remove the overrides
        delete overrides.nonce;
        delete overrides.gasLimit;
        delete overrides.gasPrice;
        delete overrides.from;
        delete overrides.value;
        delete overrides.type;
        delete overrides.accessList;
        delete overrides.maxFeePerGas;
        delete overrides.maxPriorityFeePerGas;
        delete overrides.customData;
        delete overrides.ccipReadEnabled;
        // Make sure there are no stray overrides, which may indicate a
        // typo or using an unsupported key.
        const leftovers = Object.keys(overrides).filter((key)=>overrides[key] != null);
        if (leftovers.length) $fcd53023be51494b$var$logger.throwError(`cannot override ${leftovers.map((l)=>JSON.stringify(l)).join(",")}`, (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "overrides",
            overrides: leftovers
        });
        return tx;
    });
}
function $fcd53023be51494b$var$buildPopulate(contract, fragment) {
    return function(...args) {
        return $fcd53023be51494b$var$populateTransaction(contract, fragment, args);
    };
}
function $fcd53023be51494b$var$buildEstimate(contract, fragment) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function*() {
            if (!signerOrProvider) $fcd53023be51494b$var$logger.throwError("estimate require a provider or signer", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "estimateGas"
            });
            const tx = yield $fcd53023be51494b$var$populateTransaction(contract, fragment, args);
            return yield signerOrProvider.estimateGas(tx);
        });
    };
}
function $fcd53023be51494b$var$addContractWait(contract, tx) {
    const wait = tx.wait.bind(tx);
    tx.wait = (confirmations)=>{
        return wait(confirmations).then((receipt)=>{
            receipt.events = receipt.logs.map((log)=>{
                let event = (0, $19462b55124983f4$exports.deepCopy)(log);
                let parsed = null;
                try {
                    parsed = contract.interface.parseLog(log);
                } catch (e) {}
                // Successfully parsed the event log; include it
                if (parsed) {
                    event.args = parsed.args;
                    event.decode = (data, topics)=>{
                        return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                }
                // Useful operations
                event.removeListener = ()=>{
                    return contract.provider;
                };
                event.getBlock = ()=>{
                    return contract.provider.getBlock(receipt.blockHash);
                };
                event.getTransaction = ()=>{
                    return contract.provider.getTransaction(receipt.transactionHash);
                };
                event.getTransactionReceipt = ()=>{
                    return Promise.resolve(receipt);
                };
                return event;
            });
            return receipt;
        });
    };
}
function $fcd53023be51494b$var$buildCall(contract, fragment, collapseSimple) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function*() {
            // Extract the "blockTag" override if present
            let blockTag = undefined;
            if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") {
                const overrides = (0, $19462b55124983f4$exports.shallowCopy)(args.pop());
                if (overrides.blockTag != null) blockTag = yield overrides.blockTag;
                delete overrides.blockTag;
                args.push(overrides);
            }
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed(blockTag);
            // Call a node and get the result
            const tx = yield $fcd53023be51494b$var$populateTransaction(contract, fragment, args);
            const result = yield signerOrProvider.call(tx, blockTag);
            try {
                let value = contract.interface.decodeFunctionResult(fragment, result);
                if (collapseSimple && fragment.outputs.length === 1) value = value[0];
                return value;
            } catch (error) {
                if (error.code === (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.CALL_EXCEPTION) {
                    error.address = contract.address;
                    error.args = args;
                    error.transaction = tx;
                }
                throw error;
            }
        });
    };
}
function $fcd53023be51494b$var$buildSend(contract, fragment) {
    return function(...args) {
        return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function*() {
            if (!contract.signer) $fcd53023be51494b$var$logger.throwError("sending a transaction requires a signer", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "sendTransaction"
            });
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed();
            const txRequest = yield $fcd53023be51494b$var$populateTransaction(contract, fragment, args);
            const tx = yield contract.signer.sendTransaction(txRequest);
            // Tweak the tx.wait so the receipt has extra properties
            $fcd53023be51494b$var$addContractWait(contract, tx);
            return tx;
        });
    };
}
function $fcd53023be51494b$var$buildDefault(contract, fragment, collapseSimple) {
    if (fragment.constant) return $fcd53023be51494b$var$buildCall(contract, fragment, collapseSimple);
    return $fcd53023be51494b$var$buildSend(contract, fragment);
}
function $fcd53023be51494b$var$getEventTag(filter) {
    if (filter.address && (filter.topics == null || filter.topics.length === 0)) return "*";
    return (filter.address || "*") + "@" + (filter.topics ? filter.topics.map((topic)=>{
        if (Array.isArray(topic)) return topic.join("|");
        return topic;
    }).join(":") : "");
}
class $fcd53023be51494b$var$RunningEvent {
    addListener(listener, once) {
        this._listeners.push({
            listener: listener,
            once: once
        });
    }
    removeListener(listener) {
        let done = false;
        this._listeners = this._listeners.filter((item)=>{
            if (done || item.listener !== listener) return true;
            done = true;
            return false;
        });
    }
    removeAllListeners() {
        this._listeners = [];
    }
    listeners() {
        return this._listeners.map((i)=>i.listener);
    }
    listenerCount() {
        return this._listeners.length;
    }
    run(args) {
        const listenerCount = this.listenerCount();
        this._listeners = this._listeners.filter((item)=>{
            const argsCopy = args.slice();
            // Call the callback in the next event loop
            setTimeout(()=>{
                item.listener.apply(this, argsCopy);
            }, 0);
            // Reschedule it if it not "once"
            return !item.once;
        });
        return listenerCount;
    }
    prepareEvent(event) {}
    // Returns the array that will be applied to an emit
    getEmit(event) {
        return [
            event
        ];
    }
    constructor(tag, filter){
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "tag", tag);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "filter", filter);
        this._listeners = [];
    }
}
class $fcd53023be51494b$var$ErrorRunningEvent extends $fcd53023be51494b$var$RunningEvent {
    constructor(){
        super("error", null);
    }
}
// @TODO Fragment should inherit Wildcard? and just override getEmit?
//       or have a common abstract super class, with enough constructor
//       options to configure both.
// A Fragment Event will populate all the properties that Wildcard
// will, and additionally dereference the arguments when emitting
class $fcd53023be51494b$var$FragmentRunningEvent extends $fcd53023be51494b$var$RunningEvent {
    prepareEvent(event) {
        super.prepareEvent(event);
        event.event = this.fragment.name;
        event.eventSignature = this.fragment.format();
        event.decode = (data, topics)=>{
            return this.interface.decodeEventLog(this.fragment, data, topics);
        };
        try {
            event.args = this.interface.decodeEventLog(this.fragment, event.data, event.topics);
        } catch (error) {
            event.args = null;
            event.decodeError = error;
        }
    }
    getEmit(event) {
        const errors = (0, $bd6d84ecef385088$export$5546b9ec21157cc2)(event.args);
        if (errors.length) throw errors[0].error;
        const args = (event.args || []).slice();
        args.push(event);
        return args;
    }
    constructor(address, contractInterface, fragment, topics){
        const filter = {
            address: address
        };
        let topic = contractInterface.getEventTopic(fragment);
        if (topics) {
            if (topic !== topics[0]) $fcd53023be51494b$var$logger.throwArgumentError("topic mismatch", "topics", topics);
            filter.topics = topics.slice();
        } else filter.topics = [
            topic
        ];
        super($fcd53023be51494b$var$getEventTag(filter), filter);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "address", address);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "interface", contractInterface);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "fragment", fragment);
    }
}
// A Wildcard Event will attempt to populate:
//  - event            The name of the event name
//  - eventSignature   The full signature of the event
//  - decode           A function to decode data and topics
//  - args             The decoded data and topics
class $fcd53023be51494b$var$WildcardRunningEvent extends $fcd53023be51494b$var$RunningEvent {
    prepareEvent(event) {
        super.prepareEvent(event);
        try {
            const parsed = this.interface.parseLog(event);
            event.event = parsed.name;
            event.eventSignature = parsed.signature;
            event.decode = (data, topics)=>{
                return this.interface.decodeEventLog(parsed.eventFragment, data, topics);
            };
            event.args = parsed.args;
        } catch (error) {
        // No matching event
        }
    }
    constructor(address, contractInterface){
        super("*", {
            address: address
        });
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "address", address);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "interface", contractInterface);
    }
}
class $fcd53023be51494b$export$304faa4fc17528db {
    static getContractAddress(transaction) {
        return (0, $a4b82b374f356b4b$export$b7fbffef12272e40)(transaction);
    }
    static getInterface(contractInterface) {
        if ((0, $6df659078ac9448c$export$48cefb51a4e315b2).isInterface(contractInterface)) return contractInterface;
        return new (0, $6df659078ac9448c$export$48cefb51a4e315b2)(contractInterface);
    }
    // @TODO: Allow timeout?
    deployed() {
        return this._deployed();
    }
    _deployed(blockTag) {
        if (!this._deployedPromise) {
            // If we were just deployed, we know the transaction we should occur in
            if (this.deployTransaction) this._deployedPromise = this.deployTransaction.wait().then(()=>{
                return this;
            });
            else // @TODO: Once we allow a timeout to be passed in, we will wait
            // up to that many blocks for getCode
            // Otherwise, poll for our code to be deployed
            this._deployedPromise = this.provider.getCode(this.address, blockTag).then((code)=>{
                if (code === "0x") $fcd53023be51494b$var$logger.throwError("contract not deployed", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    contractAddress: this.address,
                    operation: "getDeployed"
                });
                return this;
            });
        }
        return this._deployedPromise;
    }
    // @TODO:
    // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
    // @TODO:
    // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
    fallback(overrides) {
        if (!this.signer) $fcd53023be51494b$var$logger.throwError("sending a transactions require a signer", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "sendTransaction(fallback)"
        });
        const tx = (0, $19462b55124983f4$exports.shallowCopy)(overrides || {});
        [
            "from",
            "to"
        ].forEach(function(key) {
            if (tx[key] == null) return;
            $fcd53023be51494b$var$logger.throwError("cannot override " + key, (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        tx.to = this.resolvedAddress;
        return this.deployed().then(()=>{
            return this.signer.sendTransaction(tx);
        });
    }
    // Reconnect to a different signer or provider
    connect(signerOrProvider) {
        if (typeof signerOrProvider === "string") signerOrProvider = new (0, $d9b7eb644de5bd3c$exports.VoidSigner)(signerOrProvider, this.provider);
        const contract = new this.constructor(this.address, this.interface, signerOrProvider);
        if (this.deployTransaction) (0, $19462b55124983f4$exports.defineReadOnly)(contract, "deployTransaction", this.deployTransaction);
        return contract;
    }
    // Re-attach to a different on-chain instance of this contract
    attach(addressOrName) {
        return new this.constructor(addressOrName, this.interface, this.signer || this.provider);
    }
    static isIndexed(value) {
        return (0, $6df659078ac9448c$export$8ef99100a3c56f8c).isIndexed(value);
    }
    _normalizeRunningEvent(runningEvent) {
        // Already have an instance of this event running; we can re-use it
        if (this._runningEvents[runningEvent.tag]) return this._runningEvents[runningEvent.tag];
        return runningEvent;
    }
    _getRunningEvent(eventName) {
        if (typeof eventName === "string") {
            // Listen for "error" events (if your contract has an error event, include
            // the full signature to bypass this special event keyword)
            if (eventName === "error") return this._normalizeRunningEvent(new $fcd53023be51494b$var$ErrorRunningEvent());
            // Listen for any event that is registered
            if (eventName === "event") return this._normalizeRunningEvent(new $fcd53023be51494b$var$RunningEvent("event", null));
            // Listen for any event
            if (eventName === "*") return this._normalizeRunningEvent(new $fcd53023be51494b$var$WildcardRunningEvent(this.address, this.interface));
            // Get the event Fragment (throws if ambiguous/unknown event)
            const fragment = this.interface.getEvent(eventName);
            return this._normalizeRunningEvent(new $fcd53023be51494b$var$FragmentRunningEvent(this.address, this.interface, fragment));
        }
        // We have topics to filter by...
        if (eventName.topics && eventName.topics.length > 0) {
            // Is it a known topichash? (throws if no matching topichash)
            try {
                const topic = eventName.topics[0];
                if (typeof topic !== "string") throw new Error("invalid topic"); // @TODO: May happen for anonymous events
                const fragment = this.interface.getEvent(topic);
                return this._normalizeRunningEvent(new $fcd53023be51494b$var$FragmentRunningEvent(this.address, this.interface, fragment, eventName.topics));
            } catch (error) {}
            // Filter by the unknown topichash
            const filter = {
                address: this.address,
                topics: eventName.topics
            };
            return this._normalizeRunningEvent(new $fcd53023be51494b$var$RunningEvent($fcd53023be51494b$var$getEventTag(filter), filter));
        }
        return this._normalizeRunningEvent(new $fcd53023be51494b$var$WildcardRunningEvent(this.address, this.interface));
    }
    _checkRunningEvents(runningEvent) {
        if (runningEvent.listenerCount() === 0) {
            delete this._runningEvents[runningEvent.tag];
            // If we have a poller for this, remove it
            const emit = this._wrappedEmits[runningEvent.tag];
            if (emit && runningEvent.filter) {
                this.provider.off(runningEvent.filter, emit);
                delete this._wrappedEmits[runningEvent.tag];
            }
        }
    }
    // Subclasses can override this to gracefully recover
    // from parse errors if they wish
    _wrapEvent(runningEvent, log, listener) {
        const event = (0, $19462b55124983f4$exports.deepCopy)(log);
        event.removeListener = ()=>{
            if (!listener) return;
            runningEvent.removeListener(listener);
            this._checkRunningEvents(runningEvent);
        };
        event.getBlock = ()=>{
            return this.provider.getBlock(log.blockHash);
        };
        event.getTransaction = ()=>{
            return this.provider.getTransaction(log.transactionHash);
        };
        event.getTransactionReceipt = ()=>{
            return this.provider.getTransactionReceipt(log.transactionHash);
        };
        // This may throw if the topics and data mismatch the signature
        runningEvent.prepareEvent(event);
        return event;
    }
    _addEventListener(runningEvent, listener, once) {
        if (!this.provider) $fcd53023be51494b$var$logger.throwError("events require a provider or a signer with a provider", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "once"
        });
        runningEvent.addListener(listener, once);
        // Track this running event and its listeners (may already be there; but no hard in updating)
        this._runningEvents[runningEvent.tag] = runningEvent;
        // If we are not polling the provider, start polling
        if (!this._wrappedEmits[runningEvent.tag]) {
            const wrappedEmit = (log)=>{
                let event = this._wrapEvent(runningEvent, log, listener);
                // Try to emit the result for the parameterized event...
                if (event.decodeError == null) try {
                    const args = runningEvent.getEmit(event);
                    this.emit(runningEvent.filter, ...args);
                } catch (error) {
                    event.decodeError = error.error;
                }
                // Always emit "event" for fragment-base events
                if (runningEvent.filter != null) this.emit("event", event);
                // Emit "error" if there was an error
                if (event.decodeError != null) this.emit("error", event.decodeError, event);
            };
            this._wrappedEmits[runningEvent.tag] = wrappedEmit;
            // Special events, like "error" do not have a filter
            if (runningEvent.filter != null) this.provider.on(runningEvent.filter, wrappedEmit);
        }
    }
    queryFilter(event, fromBlockOrBlockhash, toBlock) {
        const runningEvent = this._getRunningEvent(event);
        const filter = (0, $19462b55124983f4$exports.shallowCopy)(runningEvent.filter);
        if (typeof fromBlockOrBlockhash === "string" && (0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(fromBlockOrBlockhash, 32)) {
            if (toBlock != null) $fcd53023be51494b$var$logger.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", toBlock);
            filter.blockHash = fromBlockOrBlockhash;
        } else {
            filter.fromBlock = fromBlockOrBlockhash != null ? fromBlockOrBlockhash : 0;
            filter.toBlock = toBlock != null ? toBlock : "latest";
        }
        return this.provider.getLogs(filter).then((logs)=>{
            return logs.map((log)=>this._wrapEvent(runningEvent, log, null));
        });
    }
    on(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, false);
        return this;
    }
    once(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, true);
        return this;
    }
    emit(eventName, ...args) {
        if (!this.provider) return false;
        const runningEvent = this._getRunningEvent(eventName);
        const result = runningEvent.run(args) > 0;
        // May have drained all the "once" events; check for living events
        this._checkRunningEvents(runningEvent);
        return result;
    }
    listenerCount(eventName) {
        if (!this.provider) return 0;
        if (eventName == null) return Object.keys(this._runningEvents).reduce((accum, key)=>{
            return accum + this._runningEvents[key].listenerCount();
        }, 0);
        return this._getRunningEvent(eventName).listenerCount();
    }
    listeners(eventName) {
        if (!this.provider) return [];
        if (eventName == null) {
            const result = [];
            for(let tag in this._runningEvents)this._runningEvents[tag].listeners().forEach((listener)=>{
                result.push(listener);
            });
            return result;
        }
        return this._getRunningEvent(eventName).listeners();
    }
    removeAllListeners(eventName) {
        if (!this.provider) return this;
        if (eventName == null) {
            for(const tag in this._runningEvents){
                const runningEvent = this._runningEvents[tag];
                runningEvent.removeAllListeners();
                this._checkRunningEvents(runningEvent);
            }
            return this;
        }
        // Delete any listeners
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeAllListeners();
        this._checkRunningEvents(runningEvent);
        return this;
    }
    off(eventName, listener) {
        if (!this.provider) return this;
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeListener(listener);
        this._checkRunningEvents(runningEvent);
        return this;
    }
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
    constructor(addressOrName, contractInterface, signerOrProvider){
        // @TODO: Maybe still check the addressOrName looks like a valid address or name?
        //address = getAddress(address);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "interface", (0, $19462b55124983f4$exports.getStatic)(new.target, "getInterface")(contractInterface));
        if (signerOrProvider == null) {
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "provider", null);
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "signer", null);
        } else if ((0, $d9b7eb644de5bd3c$exports.Signer).isSigner(signerOrProvider)) {
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "provider", signerOrProvider.provider || null);
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "signer", signerOrProvider);
        } else if ((0, $fd80fed41b6901ec$exports.Provider).isProvider(signerOrProvider)) {
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "provider", signerOrProvider);
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "signer", null);
        } else $fcd53023be51494b$var$logger.throwArgumentError("invalid signer or provider", "signerOrProvider", signerOrProvider);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "callStatic", {});
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "estimateGas", {});
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "functions", {});
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "populateTransaction", {});
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "filters", {});
        {
            const uniqueFilters = {};
            Object.keys(this.interface.events).forEach((eventSignature)=>{
                const event = this.interface.events[eventSignature];
                (0, $19462b55124983f4$exports.defineReadOnly)(this.filters, eventSignature, (...args)=>{
                    return {
                        address: this.address,
                        topics: this.interface.encodeFilterTopics(event, args)
                    };
                });
                if (!uniqueFilters[event.name]) uniqueFilters[event.name] = [];
                uniqueFilters[event.name].push(eventSignature);
            });
            Object.keys(uniqueFilters).forEach((name)=>{
                const filters = uniqueFilters[name];
                if (filters.length === 1) (0, $19462b55124983f4$exports.defineReadOnly)(this.filters, name, this.filters[filters[0]]);
                else $fcd53023be51494b$var$logger.warn(`Duplicate definition of ${name} (${filters.join(", ")})`);
            });
        }
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "_runningEvents", {});
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "_wrappedEmits", {});
        if (addressOrName == null) $fcd53023be51494b$var$logger.throwArgumentError("invalid contract address or ENS name", "addressOrName", addressOrName);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "address", addressOrName);
        if (this.provider) (0, $19462b55124983f4$exports.defineReadOnly)(this, "resolvedAddress", $fcd53023be51494b$var$resolveName(this.provider, addressOrName));
        else try {
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "resolvedAddress", Promise.resolve((0, $a4b82b374f356b4b$export$88411125f012957a)(addressOrName)));
        } catch (error) {
            // Without a provider, we cannot use ENS names
            $fcd53023be51494b$var$logger.throwError("provider is required to use ENS name as contract address", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "new Contract"
            });
        }
        // Swallow bad ENS names to prevent Unhandled Exceptions
        this.resolvedAddress.catch((e)=>{});
        const uniqueNames = {};
        const uniqueSignatures = {};
        Object.keys(this.interface.functions).forEach((signature)=>{
            const fragment = this.interface.functions[signature];
            // Check that the signature is unique; if not the ABI generation has
            // not been cleaned or may be incorrectly generated
            if (uniqueSignatures[signature]) {
                $fcd53023be51494b$var$logger.warn(`Duplicate ABI entry for ${JSON.stringify(signature)}`);
                return;
            }
            uniqueSignatures[signature] = true;
            // Track unique names; we only expose bare named functions if they
            // are ambiguous
            {
                const name = fragment.name;
                if (!uniqueNames[`%${name}`]) uniqueNames[`%${name}`] = [];
                uniqueNames[`%${name}`].push(signature);
            }
            if (this[signature] == null) (0, $19462b55124983f4$exports.defineReadOnly)(this, signature, $fcd53023be51494b$var$buildDefault(this, fragment, true));
            // We do not collapse simple calls on this bucket, which allows
            // frameworks to safely use this without introspection as well as
            // allows decoding error recovery.
            if (this.functions[signature] == null) (0, $19462b55124983f4$exports.defineReadOnly)(this.functions, signature, $fcd53023be51494b$var$buildDefault(this, fragment, false));
            if (this.callStatic[signature] == null) (0, $19462b55124983f4$exports.defineReadOnly)(this.callStatic, signature, $fcd53023be51494b$var$buildCall(this, fragment, true));
            if (this.populateTransaction[signature] == null) (0, $19462b55124983f4$exports.defineReadOnly)(this.populateTransaction, signature, $fcd53023be51494b$var$buildPopulate(this, fragment));
            if (this.estimateGas[signature] == null) (0, $19462b55124983f4$exports.defineReadOnly)(this.estimateGas, signature, $fcd53023be51494b$var$buildEstimate(this, fragment));
        });
        Object.keys(uniqueNames).forEach((name)=>{
            // Ambiguous names to not get attached as bare names
            const signatures = uniqueNames[name];
            if (signatures.length > 1) return;
            // Strip off the leading "%" used for prototype protection
            name = name.substring(1);
            const signature = signatures[0];
            // If overwriting a member property that is null, swallow the error
            try {
                if (this[name] == null) (0, $19462b55124983f4$exports.defineReadOnly)(this, name, this[signature]);
            } catch (e) {}
            if (this.functions[name] == null) (0, $19462b55124983f4$exports.defineReadOnly)(this.functions, name, this.functions[signature]);
            if (this.callStatic[name] == null) (0, $19462b55124983f4$exports.defineReadOnly)(this.callStatic, name, this.callStatic[signature]);
            if (this.populateTransaction[name] == null) (0, $19462b55124983f4$exports.defineReadOnly)(this.populateTransaction, name, this.populateTransaction[signature]);
            if (this.estimateGas[name] == null) (0, $19462b55124983f4$exports.defineReadOnly)(this.estimateGas, name, this.estimateGas[signature]);
        });
    }
}
class $fcd53023be51494b$export$8517d80acf00e19a extends $fcd53023be51494b$export$304faa4fc17528db {
}
class $fcd53023be51494b$export$505569a6bf584fd9 {
    // @TODO: Future; rename to populateTransaction?
    getDeployTransaction(...args) {
        let tx = {};
        // If we have 1 additional argument, we allow transaction overrides
        if (args.length === this.interface.deploy.inputs.length + 1 && typeof args[args.length - 1] === "object") {
            tx = (0, $19462b55124983f4$exports.shallowCopy)(args.pop());
            for(const key in tx){
                if (!$fcd53023be51494b$var$allowedTransactionKeys[key]) throw new Error("unknown transaction override " + key);
            }
        }
        // Do not allow these to be overridden in a deployment transaction
        [
            "data",
            "from",
            "to"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            $fcd53023be51494b$var$logger.throwError("cannot override " + key, (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        if (tx.value) {
            const value = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(tx.value);
            if (!value.isZero() && !this.interface.deploy.payable) $fcd53023be51494b$var$logger.throwError("non-payable constructor cannot override value", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: tx.value
            });
        }
        // Make sure the call matches the constructor signature
        $fcd53023be51494b$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
        // Set the data to the bytecode + the encoded constructor arguments
        tx.data = (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)((0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
            this.bytecode,
            this.interface.encodeDeploy(args)
        ]));
        return tx;
    }
    deploy(...args) {
        return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function*() {
            let overrides = {};
            // If 1 extra parameter was passed in, it contains overrides
            if (args.length === this.interface.deploy.inputs.length + 1) overrides = args.pop();
            // Make sure the call matches the constructor signature
            $fcd53023be51494b$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
            // Resolve ENS names and promises in the arguments
            const params = yield $fcd53023be51494b$var$resolveAddresses(this.signer, args, this.interface.deploy.inputs);
            params.push(overrides);
            // Get the deployment transaction (with optional overrides)
            const unsignedTx = this.getDeployTransaction(...params);
            // Send the deployment transaction
            const tx = yield this.signer.sendTransaction(unsignedTx);
            const address = (0, $19462b55124983f4$exports.getStatic)(this.constructor, "getContractAddress")(tx);
            const contract = (0, $19462b55124983f4$exports.getStatic)(this.constructor, "getContract")(address, this.interface, this.signer);
            // Add the modified wait that wraps events
            $fcd53023be51494b$var$addContractWait(contract, tx);
            (0, $19462b55124983f4$exports.defineReadOnly)(contract, "deployTransaction", tx);
            return contract;
        });
    }
    attach(address) {
        return this.constructor.getContract(address, this.interface, this.signer);
    }
    connect(signer) {
        return new this.constructor(this.interface, this.bytecode, signer);
    }
    static fromSolidity(compilerOutput, signer) {
        if (compilerOutput == null) $fcd53023be51494b$var$logger.throwError("missing compiler output", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.MISSING_ARGUMENT, {
            argument: "compilerOutput"
        });
        if (typeof compilerOutput === "string") compilerOutput = JSON.parse(compilerOutput);
        const abi = compilerOutput.abi;
        let bytecode = null;
        if (compilerOutput.bytecode) bytecode = compilerOutput.bytecode;
        else if (compilerOutput.evm && compilerOutput.evm.bytecode) bytecode = compilerOutput.evm.bytecode;
        return new this(abi, bytecode, signer);
    }
    static getInterface(contractInterface) {
        return $fcd53023be51494b$export$8517d80acf00e19a.getInterface(contractInterface);
    }
    static getContractAddress(tx) {
        return (0, $a4b82b374f356b4b$export$b7fbffef12272e40)(tx);
    }
    static getContract(address, contractInterface, signer) {
        return new $fcd53023be51494b$export$8517d80acf00e19a(address, contractInterface, signer);
    }
    constructor(contractInterface, bytecode, signer){
        let bytecodeHex = null;
        if (typeof bytecode === "string") bytecodeHex = bytecode;
        else if ((0, $ddc3d9704a40b613$export$c6fabfbfd097fc30)(bytecode)) bytecodeHex = (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(bytecode);
        else if (bytecode && typeof bytecode.object === "string") // Allow the bytecode object from the Solidity compiler
        bytecodeHex = bytecode.object;
        else // Crash in the next verification step
        bytecodeHex = "!";
        // Make sure it is 0x prefixed
        if (bytecodeHex.substring(0, 2) !== "0x") bytecodeHex = "0x" + bytecodeHex;
        // Make sure the final result is valid bytecode
        if (!(0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(bytecodeHex) || bytecodeHex.length % 2) $fcd53023be51494b$var$logger.throwArgumentError("invalid bytecode", "bytecode", bytecode);
        // If we have a signer, make sure it is valid
        if (signer && !(0, $d9b7eb644de5bd3c$exports.Signer).isSigner(signer)) $fcd53023be51494b$var$logger.throwArgumentError("invalid signer", "signer", signer);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "bytecode", bytecodeHex);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "interface", (0, $19462b55124983f4$exports.getStatic)(new.target, "getInterface")(contractInterface));
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "signer", signer || null);
    }
}


const $3d13afb7ba7a6bb7$export$badd13187c087617 = "0x0000000000000000000000000000000000000000";


var $f72528ab54eeaef8$exports = {};

$parcel$export($f72528ab54eeaef8$exports, "getDefaultProvider", function () { return $f72528ab54eeaef8$export$4f77a1d3c1ac6642; });
$parcel$export($f72528ab54eeaef8$exports, "Provider", function () { return $fd80fed41b6901ec$exports.Provider; });
$parcel$export($f72528ab54eeaef8$exports, "BaseProvider", function () { return $6a1c8a35900dd937$exports.BaseProvider; });
$parcel$export($f72528ab54eeaef8$exports, "Resolver", function () { return $6a1c8a35900dd937$exports.Resolver; });
$parcel$export($f72528ab54eeaef8$exports, "UrlJsonRpcProvider", function () { return $e630fe5b56031581$exports.UrlJsonRpcProvider; });
$parcel$export($f72528ab54eeaef8$exports, "FallbackProvider", function () { return $c71cf52c680b1470$exports.FallbackProvider; });
$parcel$export($f72528ab54eeaef8$exports, "AlchemyProvider", function () { return $990dd48e125b1d3c$export$999cc40da3fbc6f; });
$parcel$export($f72528ab54eeaef8$exports, "AlchemyWebSocketProvider", function () { return $990dd48e125b1d3c$export$f6c13301c7b76371; });
$parcel$export($f72528ab54eeaef8$exports, "AnkrProvider", function () { return $34f96cdeb0f3f720$export$72783b2aefa72a45; });
$parcel$export($f72528ab54eeaef8$exports, "CloudflareProvider", function () { return $93e46fc4025aa2f3$exports.CloudflareProvider; });
$parcel$export($f72528ab54eeaef8$exports, "EtherscanProvider", function () { return $5f74b530f183cf41$exports.EtherscanProvider; });
$parcel$export($f72528ab54eeaef8$exports, "InfuraProvider", function () { return $aafdbc33abd5222f$export$60ff1a559b5c6ebd; });
$parcel$export($f72528ab54eeaef8$exports, "InfuraWebSocketProvider", function () { return $aafdbc33abd5222f$export$dd168a807d60da4f; });
$parcel$export($f72528ab54eeaef8$exports, "JsonRpcProvider", function () { return $7bf56bd7b17e0046$exports.JsonRpcProvider; });
$parcel$export($f72528ab54eeaef8$exports, "JsonRpcBatchProvider", function () { return $b10a6faa86d631b8$export$5a16092bf20edf97; });
$parcel$export($f72528ab54eeaef8$exports, "NodesmithProvider", function () { return $53c9891537aa720d$export$8235cbce3ce273bd; });
$parcel$export($f72528ab54eeaef8$exports, "PocketProvider", function () { return $f6dfb138e1bee94a$export$58bb47e42f6b092e; });
$parcel$export($f72528ab54eeaef8$exports, "StaticJsonRpcProvider", function () { return $e630fe5b56031581$exports.StaticJsonRpcProvider; });
$parcel$export($f72528ab54eeaef8$exports, "Web3Provider", function () { return $f7d2f0b1fa262e29$export$d05096c9fd9d936d; });
$parcel$export($f72528ab54eeaef8$exports, "WebSocketProvider", function () { return $9eaaf2b70511b007$exports.WebSocketProvider; });
$parcel$export($f72528ab54eeaef8$exports, "IpcProvider", function () { return $70b27f74974a2dd3$export$fbe151f90a1ece01; });
$parcel$export($f72528ab54eeaef8$exports, "JsonRpcSigner", function () { return $7bf56bd7b17e0046$exports.JsonRpcSigner; });
$parcel$export($f72528ab54eeaef8$exports, "getNetwork", function () { return $161a25d62c52de9c$export$7de4970ebfd8206d; });
$parcel$export($f72528ab54eeaef8$exports, "isCommunityResource", function () { return $af0c63f6ba6ab466$export$d93d5f61c2498b6; });
$parcel$export($f72528ab54eeaef8$exports, "isCommunityResourcable", function () { return $af0c63f6ba6ab466$export$3091239f5b20b896; });
$parcel$export($f72528ab54eeaef8$exports, "showThrottleMessage", function () { return $af0c63f6ba6ab466$export$4c41bd49e82e82ab; });
$parcel$export($f72528ab54eeaef8$exports, "Formatter", function () { return $af0c63f6ba6ab466$export$a06636add2a09fd8; });


const $796ca7f59363f800$export$83d89fbfd8236492 = "networks/5.7.1";


"use strict";
const $161a25d62c52de9c$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $796ca7f59363f800$export$83d89fbfd8236492));
function $161a25d62c52de9c$var$isRenetworkable(value) {
    return value && typeof value.renetwork === "function";
}
function $161a25d62c52de9c$var$ethDefaultProvider(network) {
    const func = function(providers, options) {
        if (options == null) options = {};
        const providerList = [];
        if (providers.InfuraProvider && options.infura !== "-") try {
            providerList.push(new providers.InfuraProvider(network, options.infura));
        } catch (error) {}
        if (providers.EtherscanProvider && options.etherscan !== "-") try {
            providerList.push(new providers.EtherscanProvider(network, options.etherscan));
        } catch (error) {}
        if (providers.AlchemyProvider && options.alchemy !== "-") try {
            providerList.push(new providers.AlchemyProvider(network, options.alchemy));
        } catch (error) {}
        if (providers.PocketProvider && options.pocket !== "-") {
            // These networks are currently faulty on Pocket as their
            // network does not handle the Berlin hardfork, which is
            // live on these ones.
            // @TODO: This goes away once Pocket has upgraded their nodes
            const skip = [
                "goerli",
                "ropsten",
                "rinkeby",
                "sepolia"
            ];
            try {
                const provider = new providers.PocketProvider(network, options.pocket);
                if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
            } catch (error) {}
        }
        if (providers.CloudflareProvider && options.cloudflare !== "-") try {
            providerList.push(new providers.CloudflareProvider(network));
        } catch (error) {}
        if (providers.AnkrProvider && options.ankr !== "-") try {
            const skip = [
                "ropsten"
            ];
            const provider = new providers.AnkrProvider(network, options.ankr);
            if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
        } catch (error) {}
        if (providerList.length === 0) return null;
        if (providers.FallbackProvider) {
            let quorum = 1;
            if (options.quorum != null) quorum = options.quorum;
            else if (network === "homestead") quorum = 2;
            return new providers.FallbackProvider(providerList, quorum);
        }
        return providerList[0];
    };
    func.renetwork = function(network) {
        return $161a25d62c52de9c$var$ethDefaultProvider(network);
    };
    return func;
}
function $161a25d62c52de9c$var$etcDefaultProvider(url, network) {
    const func = function(providers, options) {
        if (providers.JsonRpcProvider) return new providers.JsonRpcProvider(url, network);
        return null;
    };
    func.renetwork = function(network) {
        return $161a25d62c52de9c$var$etcDefaultProvider(url, network);
    };
    return func;
}
const $161a25d62c52de9c$var$homestead = {
    chainId: 1,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "homestead",
    _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("homestead")
};
const $161a25d62c52de9c$var$ropsten = {
    chainId: 3,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "ropsten",
    _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("ropsten")
};
const $161a25d62c52de9c$var$classicMordor = {
    chainId: 63,
    name: "classicMordor",
    _defaultProvider: $161a25d62c52de9c$var$etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
};
// See: https://chainlist.org
const $161a25d62c52de9c$var$networks = {
    unspecified: {
        chainId: 0,
        name: "unspecified"
    },
    homestead: $161a25d62c52de9c$var$homestead,
    mainnet: $161a25d62c52de9c$var$homestead,
    morden: {
        chainId: 2,
        name: "morden"
    },
    ropsten: $161a25d62c52de9c$var$ropsten,
    testnet: $161a25d62c52de9c$var$ropsten,
    rinkeby: {
        chainId: 4,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "rinkeby",
        _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("rinkeby")
    },
    kovan: {
        chainId: 42,
        name: "kovan",
        _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("kovan")
    },
    goerli: {
        chainId: 5,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "goerli",
        _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("goerli")
    },
    kintsugi: {
        chainId: 1337702,
        name: "kintsugi"
    },
    sepolia: {
        chainId: 11155111,
        name: "sepolia",
        _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("sepolia")
    },
    // ETC (See: #351)
    classic: {
        chainId: 61,
        name: "classic",
        _defaultProvider: $161a25d62c52de9c$var$etcDefaultProvider("https://www.ethercluster.com/etc", "classic")
    },
    classicMorden: {
        chainId: 62,
        name: "classicMorden"
    },
    classicMordor: $161a25d62c52de9c$var$classicMordor,
    classicTestnet: $161a25d62c52de9c$var$classicMordor,
    classicKotti: {
        chainId: 6,
        name: "classicKotti",
        _defaultProvider: $161a25d62c52de9c$var$etcDefaultProvider("https://www.ethercluster.com/kotti", "classicKotti")
    },
    xdai: {
        chainId: 100,
        name: "xdai"
    },
    matic: {
        chainId: 137,
        name: "matic",
        _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("matic")
    },
    maticmum: {
        chainId: 80001,
        name: "maticmum"
    },
    optimism: {
        chainId: 10,
        name: "optimism",
        _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("optimism")
    },
    "optimism-kovan": {
        chainId: 69,
        name: "optimism-kovan"
    },
    "optimism-goerli": {
        chainId: 420,
        name: "optimism-goerli"
    },
    arbitrum: {
        chainId: 42161,
        name: "arbitrum"
    },
    "arbitrum-rinkeby": {
        chainId: 421611,
        name: "arbitrum-rinkeby"
    },
    "arbitrum-goerli": {
        chainId: 421613,
        name: "arbitrum-goerli"
    },
    bnb: {
        chainId: 56,
        name: "bnb"
    },
    bnbt: {
        chainId: 97,
        name: "bnbt"
    }
};
function $161a25d62c52de9c$export$7de4970ebfd8206d(network) {
    // No network (null)
    if (network == null) return null;
    if (typeof network === "number") {
        for(const name in $161a25d62c52de9c$var$networks){
            const standard = $161a25d62c52de9c$var$networks[name];
            if (standard.chainId === network) return {
                name: standard.name,
                chainId: standard.chainId,
                ensAddress: standard.ensAddress || null,
                _defaultProvider: standard._defaultProvider || null
            };
        }
        return {
            chainId: network,
            name: "unknown"
        };
    }
    if (typeof network === "string") {
        const standard = $161a25d62c52de9c$var$networks[network];
        if (standard == null) return null;
        return {
            name: standard.name,
            chainId: standard.chainId,
            ensAddress: standard.ensAddress,
            _defaultProvider: standard._defaultProvider || null
        };
    }
    const standard = $161a25d62c52de9c$var$networks[network.name];
    // Not a standard network; check that it is a valid network in general
    if (!standard) {
        if (typeof network.chainId !== "number") $161a25d62c52de9c$var$logger.throwArgumentError("invalid network chainId", "network", network);
        return network;
    }
    // Make sure the chainId matches the expected network chainId (or is 0; disable EIP-155)
    if (network.chainId !== 0 && network.chainId !== standard.chainId) $161a25d62c52de9c$var$logger.throwArgumentError("network chainId mismatch", "network", network);
    // @TODO: In the next major version add an attach function to a defaultProvider
    // class and move the _defaultProvider internal to this file (extend Network)
    let defaultProvider = network._defaultProvider || null;
    if (defaultProvider == null && standard._defaultProvider) {
        if ($161a25d62c52de9c$var$isRenetworkable(standard._defaultProvider)) defaultProvider = standard._defaultProvider.renetwork(network);
        else defaultProvider = standard._defaultProvider;
    }
    // Standard Network (allow overriding the ENS address)
    return {
        name: network.name,
        chainId: standard.chainId,
        ensAddress: network.ensAddress || standard.ensAddress || null,
        _defaultProvider: defaultProvider
    };
}


var $6a1c8a35900dd937$exports = {};

$parcel$export($6a1c8a35900dd937$exports, "Resolver", function () { return $6a1c8a35900dd937$export$8b4c839865b08288; });
$parcel$export($6a1c8a35900dd937$exports, "BaseProvider", function () { return $6a1c8a35900dd937$export$ff3f6dd83125ac45; });


"use strict";
function $51b0a655b2efccfa$export$2f872c0f2117be69(textData) {
    textData = atob(textData);
    const data = [];
    for(let i = 0; i < textData.length; i++)data.push(textData.charCodeAt(i));
    return (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(data);
}
function $51b0a655b2efccfa$export$c564cdbbe6da493(data) {
    data = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}


/**
 * var basex = require("base-x");
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */ 

class $a538ed25248fff2d$export$240043ab8e806ec7 {
    encode(value) {
        let source = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(value);
        if (source.length === 0) return "";
        let digits = [
            0
        ];
        for(let i = 0; i < source.length; ++i){
            let carry = source[i];
            for(let j = 0; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % this.base;
                carry = carry / this.base | 0;
            }
            while(carry > 0){
                digits.push(carry % this.base);
                carry = carry / this.base | 0;
            }
        }
        let string = "";
        // deal with leading zeros
        for(let k = 0; source[k] === 0 && k < source.length - 1; ++k)string += this._leader;
        // convert digits to a string
        for(let q = digits.length - 1; q >= 0; --q)string += this.alphabet[digits[q]];
        return string;
    }
    decode(value) {
        if (typeof value !== "string") throw new TypeError("Expected String");
        let bytes = [];
        if (value.length === 0) return new Uint8Array(bytes);
        bytes.push(0);
        for(let i = 0; i < value.length; i++){
            let byte = this._alphabetMap[value[i]];
            if (byte === undefined) throw new Error("Non-base" + this.base + " character");
            let carry = byte;
            for(let j = 0; j < bytes.length; ++j){
                carry += bytes[j] * this.base;
                bytes[j] = carry & 0xff;
                carry >>= 8;
            }
            while(carry > 0){
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for(let k = 0; value[k] === this._leader && k < value.length - 1; ++k)bytes.push(0);
        return (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(new Uint8Array(bytes.reverse()));
    }
    constructor(alphabet){
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "alphabet", alphabet);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "base", alphabet.length);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "_alphabetMap", {});
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for(let i = 0; i < alphabet.length; i++)this._alphabetMap[alphabet.charAt(i)] = i;
    }
}
const $a538ed25248fff2d$export$cfabb2852920f5ec = new $a538ed25248fff2d$export$240043ab8e806ec7("abcdefghijklmnopqrstuvwxyz234567");
const $a538ed25248fff2d$export$45a587635c9954b2 = new $a538ed25248fff2d$export$240043ab8e806ec7("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
 //console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
 //console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))




const $43ba40ff64f1a63e$export$71c2e4e213dcb7f2 = "0x0000000000000000000000000000000000000000000000000000000000000000";






const $e531ee7873f6488e$export$83d89fbfd8236492 = "hash/5.7.0";


/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ // https://github.com/behnammodi/polyfill/blob/master/array.polyfill.js
function $1855c0be68a16a45$var$flat(array, depth) {
    if (depth == null) depth = 1;
    const result = [];
    const forEach = result.forEach;
    const flatDeep = function(arr, depth) {
        forEach.call(arr, function(val) {
            if (depth > 0 && Array.isArray(val)) flatDeep(val, depth - 1);
            else result.push(val);
        });
    };
    flatDeep(array, depth);
    return result;
}
function $1855c0be68a16a45$var$fromEntries(array) {
    const result = {};
    for(let i = 0; i < array.length; i++){
        const value = array[i];
        result[value[0]] = value[1];
    }
    return result;
}
function $1855c0be68a16a45$export$956eeed0f8f2ceff(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = Math.pow(2, N);
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
function $1855c0be68a16a45$export$2cda812f22276871(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function $1855c0be68a16a45$export$671d8b4ebc0c42ad(bytes) {
    return $1855c0be68a16a45$export$2cda812f22276871($1855c0be68a16a45$export$956eeed0f8f2ceff(bytes));
}
function $1855c0be68a16a45$export$a785de3a2a8dd1aa(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $1855c0be68a16a45$var$read_counts(n, next) {
    let v = Array(n);
    for(let i = 0; i < n; i++)v[i] = 1 + next();
    return v;
}
function $1855c0be68a16a45$var$read_ascending(n, next) {
    let v = Array(n);
    for(let i = 0, x = -1; i < n; i++)v[i] = x += 1 + next();
    return v;
}
function $1855c0be68a16a45$var$read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += $1855c0be68a16a45$export$a785de3a2a8dd1aa(next());
    return v;
}
function $1855c0be68a16a45$export$9303bf4e1ede4914(next, lookup) {
    let v = $1855c0be68a16a45$var$read_ascending(next(), next);
    let n = next();
    let vX = $1855c0be68a16a45$var$read_ascending(n, next);
    let vN = $1855c0be68a16a45$var$read_counts(n, next);
    for(let i = 0; i < n; i++)for(let j = 0; j < vN[i]; j++)v.push(vX[i] + j);
    return lookup ? v.map((x)=>lookup[x]) : v;
}
function $1855c0be68a16a45$export$824d00fb01c38bd9(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push($1855c0be68a16a45$var$read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push($1855c0be68a16a45$var$read_replacement_table(w, next));
    }
    return $1855c0be68a16a45$var$fromEntries($1855c0be68a16a45$var$flat(ret));
}
function $1855c0be68a16a45$export$e9011071590ab431(next) {
    let v = [];
    while(true){
        let i = next();
        if (i == 0) break;
        v.push(i);
    }
    return v;
}
function $1855c0be68a16a45$var$read_transposed(n, w, next) {
    let m = Array(n).fill(undefined).map(()=>[]);
    for(let i = 0; i < w; i++)$1855c0be68a16a45$var$read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
function $1855c0be68a16a45$var$read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = $1855c0be68a16a45$export$e9011071590ab431(next);
    let m = $1855c0be68a16a45$var$read_transposed(vN.length, 1 + w, next);
    return $1855c0be68a16a45$var$flat(m.map((v, i)=>{
        const x = v[0], ys = v.slice(1);
        //let [x, ...ys] = v;
        //return Array(vN[i]).fill().map((_, j) => {
        return Array(vN[i]).fill(undefined).map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    }));
}
function $1855c0be68a16a45$var$read_replacement_table(w, next) {
    let n = 1 + next();
    let m = $1855c0be68a16a45$var$read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
function $1855c0be68a16a45$export$d7b24c6ce369e1b7(next) {
    let sorted = $1855c0be68a16a45$export$9303bf4e1ede4914(next).sort((a, b)=>a - b);
    return read();
    function read() {
        let branches = [];
        while(true){
            let keys = $1855c0be68a16a45$export$9303bf4e1ede4914(next, sorted);
            if (keys.length == 0) break;
            branches.push({
                set: new Set(keys),
                node: read()
            });
        }
        branches.sort((a, b)=>b.set.size - a.set.size); // sort by likelihood
        let temp = next();
        let valid = temp % 3;
        temp = temp / 3 | 0;
        let fe0f = !!(temp & 1);
        temp >>= 1;
        let save = temp == 1;
        let check = temp == 2;
        return {
            branches: branches,
            valid: valid,
            fe0f: fe0f,
            save: save,
            check: check
        };
    }
}


function $9a9a30743d5267a8$export$7a171f172be0782e() {
    return (0, $1855c0be68a16a45$export$671d8b4ebc0c42ad)((0, $51b0a655b2efccfa$export$2f872c0f2117be69)("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"));
}



const $f466fac178eacead$var$r = (0, $9a9a30743d5267a8$export$7a171f172be0782e)();
// @TODO: This should be lazily loaded
const $f466fac178eacead$var$VALID = new Set((0, $1855c0be68a16a45$export$9303bf4e1ede4914)($f466fac178eacead$var$r));
const $f466fac178eacead$var$IGNORED = new Set((0, $1855c0be68a16a45$export$9303bf4e1ede4914)($f466fac178eacead$var$r));
const $f466fac178eacead$var$MAPPED = (0, $1855c0be68a16a45$export$824d00fb01c38bd9)($f466fac178eacead$var$r);
const $f466fac178eacead$var$EMOJI_ROOT = (0, $1855c0be68a16a45$export$d7b24c6ce369e1b7)($f466fac178eacead$var$r);
//const NFC_CHECK = new Set(read_member_array(r, Array.from(VALID.values()).sort((a, b) => a - b)));
//const STOP = 0x2E;
const $f466fac178eacead$var$HYPHEN = 0x2D;
const $f466fac178eacead$var$UNDERSCORE = 0x5F;
function $f466fac178eacead$var$explode_cp(name) {
    return (0, $169c6c93221d2e48$export$ae470a36a31b28c2)(name);
}
function $f466fac178eacead$var$filter_fe0f(cps) {
    return cps.filter((cp)=>cp != 0xFE0F);
}
function $f466fac178eacead$export$5252e54b57fcf4fd(name) {
    for (let label of name.split(".")){
        let cps = $f466fac178eacead$var$explode_cp(label);
        try {
            for(let i = cps.lastIndexOf($f466fac178eacead$var$UNDERSCORE) - 1; i >= 0; i--){
                if (cps[i] !== $f466fac178eacead$var$UNDERSCORE) throw new Error(`underscore only allowed at start`);
            }
            if (cps.length >= 4 && cps.every((cp)=>cp < 0x80) && cps[2] === $f466fac178eacead$var$HYPHEN && cps[3] === $f466fac178eacead$var$HYPHEN) throw new Error(`invalid label extension`);
        } catch (err) {
            throw new Error(`Invalid label "${label}": ${err.message}`);
        }
    }
    return name;
}
function $f466fac178eacead$export$499f715881831a51(name) {
    return $f466fac178eacead$export$5252e54b57fcf4fd($f466fac178eacead$var$normalize(name, $f466fac178eacead$var$filter_fe0f));
}
function $f466fac178eacead$var$normalize(name, emoji_filter) {
    let input = $f466fac178eacead$var$explode_cp(name).reverse(); // flip for pop
    let output = [];
    while(input.length){
        let emoji = $f466fac178eacead$var$consume_emoji_reversed(input);
        if (emoji) {
            output.push(...emoji_filter(emoji));
            continue;
        }
        let cp = input.pop();
        if ($f466fac178eacead$var$VALID.has(cp)) {
            output.push(cp);
            continue;
        }
        if ($f466fac178eacead$var$IGNORED.has(cp)) continue;
        let cps = $f466fac178eacead$var$MAPPED[cp];
        if (cps) {
            output.push(...cps);
            continue;
        }
        throw new Error(`Disallowed codepoint: 0x${cp.toString(16).toUpperCase()}`);
    }
    return $f466fac178eacead$export$5252e54b57fcf4fd($f466fac178eacead$var$nfc(String.fromCodePoint(...output)));
}
function $f466fac178eacead$var$nfc(s) {
    return s.normalize("NFC");
}
function $f466fac178eacead$var$consume_emoji_reversed(cps, eaten) {
    var _a;
    let node = $f466fac178eacead$var$EMOJI_ROOT;
    let emoji;
    let saved;
    let stack = [];
    let pos = cps.length;
    if (eaten) eaten.length = 0; // clear input buffer (if needed)
    while(pos){
        let cp = cps[--pos];
        node = (_a = node.branches.find((x)=>x.set.has(cp))) === null || _a === void 0 ? void 0 : _a.node;
        if (!node) break;
        if (node.save) saved = cp;
        else if (node.check) {
            if (cp === saved) break;
        }
        stack.push(cp);
        if (node.fe0f) {
            stack.push(0xFE0F);
            if (pos > 0 && cps[pos - 1] == 0xFE0F) pos--; // consume optional FE0F
        }
        if (node.valid) {
            emoji = stack.slice(); // copy stack
            if (node.valid == 2) emoji.splice(1, 1); // delete FE0F at position 1 (RGI ZWJ don't follow spec!)
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // copy input (if needed)
            cps.length = pos; // truncate
        }
    }
    return emoji;
}


const $3715ffed660cd02c$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $e531ee7873f6488e$export$83d89fbfd8236492));
const $3715ffed660cd02c$var$Zeros = new Uint8Array(32);
$3715ffed660cd02c$var$Zeros.fill(0);
function $3715ffed660cd02c$var$checkComponent(comp) {
    if (comp.length === 0) throw new Error("invalid ENS name; empty component");
    return comp;
}
function $3715ffed660cd02c$var$ensNameSplit(name) {
    const bytes = (0, $169c6c93221d2e48$export$8feeb310b4b4752f)((0, $f466fac178eacead$export$499f715881831a51)(name));
    const comps = [];
    if (name.length === 0) return comps;
    let last = 0;
    for(let i = 0; i < bytes.length; i++){
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push($3715ffed660cd02c$var$checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    if (last >= bytes.length) throw new Error("invalid ENS name; empty component");
    comps.push($3715ffed660cd02c$var$checkComponent(bytes.slice(last)));
    return comps;
}
function $3715ffed660cd02c$export$5f232fd2f1a1e8ac(name) {
    return $3715ffed660cd02c$var$ensNameSplit(name).map((comp)=>(0, $169c6c93221d2e48$export$7643a1dc2c38d5eb)(comp)).join(".");
}
function $3715ffed660cd02c$export$cce2300886e7ace6(name) {
    try {
        return $3715ffed660cd02c$var$ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function $3715ffed660cd02c$export$91d651ee363e1209(name) {
    /* istanbul ignore if */ if (typeof name !== "string") $3715ffed660cd02c$var$logger.throwArgumentError("invalid ENS name; not a string", "name", name);
    let result = $3715ffed660cd02c$var$Zeros;
    const comps = $3715ffed660cd02c$var$ensNameSplit(name);
    while(comps.length)result = (0, $344909d1f36347b2$export$f8151fce47ad1c35)((0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
        result,
        (0, $344909d1f36347b2$export$f8151fce47ad1c35)(comps.pop())
    ]));
    return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(result);
}
function $3715ffed660cd02c$export$6c0a8cdae51cb512(name) {
    return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)((0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)($3715ffed660cd02c$var$ensNameSplit(name).map((comp)=>{
        // DNS does not allow components over 63 bytes in length
        if (comp.length > 63) throw new Error("invalid DNS encoded entry; length exceeds 63 bytes");
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}





var $dMFrt = parcelRequire("dMFrt");

var $7bbd5149c083ead5$export$d2a8849cfb277c;
(function(SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})($7bbd5149c083ead5$export$d2a8849cfb277c || ($7bbd5149c083ead5$export$d2a8849cfb277c = {}));



const $7901a7f807ca448e$export$83d89fbfd8236492 = "sha2/5.7.0";


"use strict";
const $5c9a0ceac3511c58$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $7901a7f807ca448e$export$83d89fbfd8236492));
function $5c9a0ceac3511c58$export$d1cea0ee4e3f0d3e(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).ripemd160().update((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $5c9a0ceac3511c58$export$bced8d2aada2d1c9(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256().update((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $5c9a0ceac3511c58$export$a888d2532e6dc7bb(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha512().update((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $5c9a0ceac3511c58$export$967075d2f3b8e7ff(algorithm, key, data) {
    if (!(0, $7bbd5149c083ead5$export$d2a8849cfb277c)[algorithm]) $5c9a0ceac3511c58$var$logger.throwError("unsupported algorithm " + algorithm, (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "hmac",
        algorithm: algorithm
    });
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).hmac((0, (/*@__PURE__*/$parcel$interopDefault($dMFrt)))[algorithm], (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(key)).update((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(data)).digest("hex");
}



var $bf63a14489d0132f$exports = {};

$parcel$export($bf63a14489d0132f$exports, "_fetchData", function () { return $bf63a14489d0132f$export$e37fa27017c6c012; });
$parcel$export($bf63a14489d0132f$exports, "fetchJson", function () { return $bf63a14489d0132f$export$6d71b655afe1638d; });
$parcel$export($bf63a14489d0132f$exports, "poll", function () { return $bf63a14489d0132f$export$e0c10349b2c5e1d4; });





const $acb2a463b6dabef3$export$83d89fbfd8236492 = "web/5.7.1";


var $b85ee7d721e8a835$exports = {};

$parcel$export($b85ee7d721e8a835$exports, "getUrl", function () { return $b85ee7d721e8a835$export$94df0e59ebebf4a7; });

"use strict";
var $b85ee7d721e8a835$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $b85ee7d721e8a835$export$94df0e59ebebf4a7(href, options) {
    return $b85ee7d721e8a835$var$__awaiter(this, void 0, void 0, function*() {
        if (options == null) options = {};
        const request = {
            method: options.method || "GET",
            headers: options.headers || {},
            body: options.body || undefined
        };
        if (options.skipFetchSetup !== true) {
            request.mode = "cors"; // no-cors, cors, *same-origin
            request.cache = "no-cache"; // *default, no-cache, reload, force-cache, only-if-cached
            request.credentials = "same-origin"; // include, *same-origin, omit
            request.redirect = "follow"; // manual, *follow, error
            request.referrer = "client"; // no-referrer, *client
        }
        if (options.fetchOptions != null) {
            const opts = options.fetchOptions;
            if (opts.mode) request.mode = opts.mode;
            if (opts.cache) request.cache = opts.cache;
            if (opts.credentials) request.credentials = opts.credentials;
            if (opts.redirect) request.redirect = opts.redirect;
            if (opts.referrer) request.referrer = opts.referrer;
        }
        const response = yield fetch(href, request);
        const body = yield response.arrayBuffer();
        const headers = {};
        if (response.headers.forEach) response.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        else response.headers.keys().forEach((key)=>{
            headers[key.toLowerCase()] = response.headers.get(key);
        });
        return {
            headers: headers,
            statusCode: response.status,
            statusMessage: response.statusText,
            body: (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(new Uint8Array(body))
        };
    });
}


"use strict";
var $bf63a14489d0132f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $bf63a14489d0132f$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $acb2a463b6dabef3$export$83d89fbfd8236492));
function $bf63a14489d0132f$var$staller(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $bf63a14489d0132f$var$bodyify(value, type) {
    if (value == null) return null;
    if (typeof value === "string") return value;
    if ((0, $ddc3d9704a40b613$export$9a14abb1a440cd5e)(value)) {
        if (type && (type.split("/")[0] === "text" || type.split(";")[0].trim() === "application/json")) try {
            return (0, $169c6c93221d2e48$export$7643a1dc2c38d5eb)(value);
        } catch (error) {}
        return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(value);
    }
    return value;
}
function $bf63a14489d0132f$var$unpercent(value) {
    return (0, $169c6c93221d2e48$export$8feeb310b4b4752f)(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code)=>{
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function $bf63a14489d0132f$export$e37fa27017c6c012(connection, body, processFunc) {
    // How many times to retry in the event of a throttle
    const attemptLimit = typeof connection === "object" && connection.throttleLimit != null ? connection.throttleLimit : 12;
    $bf63a14489d0132f$var$logger.assertArgument(attemptLimit > 0 && attemptLimit % 1 === 0, "invalid connection throttle limit", "connection.throttleLimit", attemptLimit);
    const throttleCallback = typeof connection === "object" ? connection.throttleCallback : null;
    const throttleSlotInterval = typeof connection === "object" && typeof connection.throttleSlotInterval === "number" ? connection.throttleSlotInterval : 100;
    $bf63a14489d0132f$var$logger.assertArgument(throttleSlotInterval > 0 && throttleSlotInterval % 1 === 0, "invalid connection throttle slot interval", "connection.throttleSlotInterval", throttleSlotInterval);
    const errorPassThrough = typeof connection === "object" ? !!connection.errorPassThrough : false;
    const headers = {};
    let url = null;
    // @TODO: Allow ConnectionInfo to override some of these values
    const options = {
        method: "GET"
    };
    let allow304 = false;
    let timeout = 120000;
    if (typeof connection === "string") url = connection;
    else if (typeof connection === "object") {
        if (connection == null || connection.url == null) $bf63a14489d0132f$var$logger.throwArgumentError("missing URL", "connection.url", connection);
        url = connection.url;
        if (typeof connection.timeout === "number" && connection.timeout > 0) timeout = connection.timeout;
        if (connection.headers) for(const key in connection.headers){
            headers[key.toLowerCase()] = {
                key: key,
                value: String(connection.headers[key])
            };
            if ([
                "if-none-match",
                "if-modified-since"
            ].indexOf(key.toLowerCase()) >= 0) allow304 = true;
        }
        options.allowGzip = !!connection.allowGzip;
        if (connection.user != null && connection.password != null) {
            if (url.substring(0, 6) !== "https:" && connection.allowInsecureAuthentication !== true) $bf63a14489d0132f$var$logger.throwError("basic authentication requires a secure https url", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "url",
                url: url,
                user: connection.user,
                password: "[REDACTED]"
            });
            const authorization = connection.user + ":" + connection.password;
            headers["authorization"] = {
                key: "Authorization",
                value: "Basic " + (0, $51b0a655b2efccfa$export$c564cdbbe6da493)((0, $169c6c93221d2e48$export$8feeb310b4b4752f)(authorization))
            };
        }
        if (connection.skipFetchSetup != null) options.skipFetchSetup = !!connection.skipFetchSetup;
        if (connection.fetchOptions != null) options.fetchOptions = (0, $19462b55124983f4$exports.shallowCopy)(connection.fetchOptions);
    }
    const reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
    const dataMatch = url ? url.match(reData) : null;
    if (dataMatch) try {
        const response = {
            statusCode: 200,
            statusMessage: "OK",
            headers: {
                "content-type": dataMatch[1] || "text/plain"
            },
            body: dataMatch[2] ? (0, $51b0a655b2efccfa$export$2f872c0f2117be69)(dataMatch[3]) : $bf63a14489d0132f$var$unpercent(dataMatch[3])
        };
        let result = response.body;
        if (processFunc) result = processFunc(response.body, response);
        return Promise.resolve(result);
    } catch (error) {
        $bf63a14489d0132f$var$logger.throwError("processing response error", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR, {
            body: $bf63a14489d0132f$var$bodyify(dataMatch[1], dataMatch[2]),
            error: error,
            requestBody: null,
            requestMethod: "GET",
            url: url
        });
    }
    if (body) {
        options.method = "POST";
        options.body = body;
        if (headers["content-type"] == null) headers["content-type"] = {
            key: "Content-Type",
            value: "application/octet-stream"
        };
        if (headers["content-length"] == null) headers["content-length"] = {
            key: "Content-Length",
            value: String(body.length)
        };
    }
    const flatHeaders = {};
    Object.keys(headers).forEach((key)=>{
        const header = headers[key];
        flatHeaders[header.key] = header.value;
    });
    options.headers = flatHeaders;
    const runningTimeout = function() {
        let timer = null;
        const promise = new Promise(function(resolve, reject) {
            if (timeout) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                reject($bf63a14489d0132f$var$logger.makeError("timeout", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.TIMEOUT, {
                    requestBody: $bf63a14489d0132f$var$bodyify(options.body, flatHeaders["content-type"]),
                    requestMethod: options.method,
                    timeout: timeout,
                    url: url
                }));
            }, timeout);
        });
        const cancel = function() {
            if (timer == null) return;
            clearTimeout(timer);
            timer = null;
        };
        return {
            promise: promise,
            cancel: cancel
        };
    }();
    const runningFetch = function() {
        return $bf63a14489d0132f$var$__awaiter(this, void 0, void 0, function*() {
            for(let attempt = 0; attempt < attemptLimit; attempt++){
                let response = null;
                try {
                    response = yield (0, $b85ee7d721e8a835$exports.getUrl)(url, options);
                    if (attempt < attemptLimit) {
                        if (response.statusCode === 301 || response.statusCode === 302) {
                            // Redirection; for now we only support absolute locataions
                            const location = response.headers.location || "";
                            if (options.method === "GET" && location.match(/^https:/)) {
                                url = response.headers.location;
                                continue;
                            }
                        } else if (response.statusCode === 429) {
                            // Exponential back-off throttling
                            let tryAgain = true;
                            if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                            if (tryAgain) {
                                let stall = 0;
                                const retryAfter = response.headers["retry-after"];
                                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) stall = parseInt(retryAfter) * 1000;
                                else stall = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                                //console.log("Stalling 429");
                                yield $bf63a14489d0132f$var$staller(stall);
                                continue;
                            }
                        }
                    }
                } catch (error) {
                    response = error.response;
                    if (response == null) {
                        runningTimeout.cancel();
                        $bf63a14489d0132f$var$logger.throwError("missing response", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR, {
                            requestBody: $bf63a14489d0132f$var$bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            serverError: error,
                            url: url
                        });
                    }
                }
                let body = response.body;
                if (allow304 && response.statusCode === 304) body = null;
                else if (!errorPassThrough && (response.statusCode < 200 || response.statusCode >= 300)) {
                    runningTimeout.cancel();
                    $bf63a14489d0132f$var$logger.throwError("bad response", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR, {
                        status: response.statusCode,
                        headers: response.headers,
                        body: $bf63a14489d0132f$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        requestBody: $bf63a14489d0132f$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                if (processFunc) try {
                    const result = yield processFunc(body, response);
                    runningTimeout.cancel();
                    return result;
                } catch (error) {
                    // Allow the processFunc to trigger a throttle
                    if (error.throttleRetry && attempt < attemptLimit) {
                        let tryAgain = true;
                        if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                        if (tryAgain) {
                            const timeout = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                            //console.log("Stalling callback");
                            yield $bf63a14489d0132f$var$staller(timeout);
                            continue;
                        }
                    }
                    runningTimeout.cancel();
                    $bf63a14489d0132f$var$logger.throwError("processing response error", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR, {
                        body: $bf63a14489d0132f$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        error: error,
                        requestBody: $bf63a14489d0132f$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                runningTimeout.cancel();
                // If we had a processFunc, it either returned a T or threw above.
                // The "body" is now a Uint8Array.
                return body;
            }
            return $bf63a14489d0132f$var$logger.throwError("failed response", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR, {
                requestBody: $bf63a14489d0132f$var$bodyify(options.body, flatHeaders["content-type"]),
                requestMethod: options.method,
                url: url
            });
        });
    }();
    return Promise.race([
        runningTimeout.promise,
        runningFetch
    ]);
}
function $bf63a14489d0132f$export$6d71b655afe1638d(connection, json, processFunc) {
    let processJsonFunc = (value, response)=>{
        let result = null;
        if (value != null) try {
            result = JSON.parse((0, $169c6c93221d2e48$export$7643a1dc2c38d5eb)(value));
        } catch (error) {
            $bf63a14489d0132f$var$logger.throwError("invalid JSON", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR, {
                body: value,
                error: error
            });
        }
        if (processFunc) result = processFunc(result, response);
        return result;
    };
    // If we have json to send, we must
    // - add content-type of application/json (unless already overridden)
    // - convert the json to bytes
    let body = null;
    if (json != null) {
        body = (0, $169c6c93221d2e48$export$8feeb310b4b4752f)(json);
        // Create a connection with the content-type set for JSON
        const updated = typeof connection === "string" ? {
            url: connection
        } : (0, $19462b55124983f4$exports.shallowCopy)(connection);
        if (updated.headers) {
            const hasContentType = Object.keys(updated.headers).filter((k)=>k.toLowerCase() === "content-type").length !== 0;
            if (!hasContentType) {
                updated.headers = (0, $19462b55124983f4$exports.shallowCopy)(updated.headers);
                updated.headers["content-type"] = "application/json";
            }
        } else updated.headers = {
            "content-type": "application/json"
        };
        connection = updated;
    }
    return $bf63a14489d0132f$export$e37fa27017c6c012(connection, body, processJsonFunc);
}
function $bf63a14489d0132f$export$e0c10349b2c5e1d4(func, options) {
    if (!options) options = {};
    options = (0, $19462b55124983f4$exports.shallowCopy)(options);
    if (options.floor == null) options.floor = 0;
    if (options.ceiling == null) options.ceiling = 10000;
    if (options.interval == null) options.interval = 250;
    return new Promise(function(resolve, reject) {
        let timer = null;
        let done = false;
        // Returns true if cancel was successful. Unsuccessful cancel means we're already done.
        const cancel = ()=>{
            if (done) return false;
            done = true;
            if (timer) clearTimeout(timer);
            return true;
        };
        if (options.timeout) timer = setTimeout(()=>{
            if (cancel()) reject(new Error("timeout"));
        }, options.timeout);
        const retryLimit = options.retryLimit;
        let attempt = 0;
        function check() {
            return func().then(function(result) {
                // If we have a result, or are allowed null then we're done
                if (result !== undefined) {
                    if (cancel()) resolve(result);
                } else if (options.oncePoll) options.oncePoll.once("poll", check);
                else if (options.onceBlock) options.onceBlock.once("block", check);
                else if (!done) {
                    attempt++;
                    if (attempt > retryLimit) {
                        if (cancel()) reject(new Error("retry limit reached"));
                        return;
                    }
                    let timeout = options.interval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                    if (timeout < options.floor) timeout = options.floor;
                    if (timeout > options.ceiling) timeout = options.ceiling;
                    setTimeout(check, timeout);
                }
                return null;
            }, function(error) {
                if (cancel()) reject(error);
            });
        }
        check();
    });
}


var $c01d4687d4f4d3ac$exports = {};
"use strict";
var $c01d4687d4f4d3ac$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
// pre-compute lookup table
var $c01d4687d4f4d3ac$var$ALPHABET_MAP = {};
for(var $c01d4687d4f4d3ac$var$z = 0; $c01d4687d4f4d3ac$var$z < $c01d4687d4f4d3ac$var$ALPHABET.length; $c01d4687d4f4d3ac$var$z++){
    var $c01d4687d4f4d3ac$var$x = $c01d4687d4f4d3ac$var$ALPHABET.charAt($c01d4687d4f4d3ac$var$z);
    if ($c01d4687d4f4d3ac$var$ALPHABET_MAP[$c01d4687d4f4d3ac$var$x] !== undefined) throw new TypeError($c01d4687d4f4d3ac$var$x + " is ambiguous");
    $c01d4687d4f4d3ac$var$ALPHABET_MAP[$c01d4687d4f4d3ac$var$x] = $c01d4687d4f4d3ac$var$z;
}
function $c01d4687d4f4d3ac$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $c01d4687d4f4d3ac$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $c01d4687d4f4d3ac$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $c01d4687d4f4d3ac$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $c01d4687d4f4d3ac$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $c01d4687d4f4d3ac$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $c01d4687d4f4d3ac$var$prefixChk(prefix);
    if (typeof chk === "string") throw new Error(chk);
    var result = prefix + "1";
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error("Non 5-bit word");
        chk = $c01d4687d4f4d3ac$var$polymodStep(chk) ^ x;
        result += $c01d4687d4f4d3ac$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $c01d4687d4f4d3ac$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $c01d4687d4f4d3ac$var$ALPHABET.charAt(v);
    }
    return result;
}
function $c01d4687d4f4d3ac$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + " too short";
    if (str.length > LIMIT) return "Exceeds length limit";
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
    str = lowered;
    var split = str.lastIndexOf("1");
    if (split === -1) return "No separator character for " + str;
    if (split === 0) return "Missing prefix for " + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return "Data too short";
    var chk = $c01d4687d4f4d3ac$var$prefixChk(prefix);
    if (typeof chk === "string") return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $c01d4687d4f4d3ac$var$ALPHABET_MAP[c];
        if (v === undefined) return "Unknown character " + c;
        chk = $c01d4687d4f4d3ac$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return "Invalid checksum for " + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $c01d4687d4f4d3ac$var$decodeUnsafe() {
    var res = $c01d4687d4f4d3ac$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
}
function $c01d4687d4f4d3ac$var$decode(str) {
    var res = $c01d4687d4f4d3ac$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
    throw new Error(res);
}
function $c01d4687d4f4d3ac$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $c01d4687d4f4d3ac$var$toWordsUnsafe(bytes) {
    var res = $c01d4687d4f4d3ac$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $c01d4687d4f4d3ac$var$toWords(bytes) {
    var res = $c01d4687d4f4d3ac$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $c01d4687d4f4d3ac$var$fromWordsUnsafe(words) {
    var res = $c01d4687d4f4d3ac$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $c01d4687d4f4d3ac$var$fromWords(words) {
    var res = $c01d4687d4f4d3ac$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
$c01d4687d4f4d3ac$exports = {
    decodeUnsafe: $c01d4687d4f4d3ac$var$decodeUnsafe,
    decode: $c01d4687d4f4d3ac$var$decode,
    encode: $c01d4687d4f4d3ac$var$encode,
    toWordsUnsafe: $c01d4687d4f4d3ac$var$toWordsUnsafe,
    toWords: $c01d4687d4f4d3ac$var$toWords,
    fromWordsUnsafe: $c01d4687d4f4d3ac$var$fromWordsUnsafe,
    fromWords: $c01d4687d4f4d3ac$var$fromWords
};



const $d9347b79faa289ba$export$83d89fbfd8236492 = "providers/5.7.2";










"use strict";
const $af0c63f6ba6ab466$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d9347b79faa289ba$export$83d89fbfd8236492));
class $af0c63f6ba6ab466$export$a06636add2a09fd8 {
    getDefaultFormats() {
        const formats = {};
        const address = this.address.bind(this);
        const bigNumber = this.bigNumber.bind(this);
        const blockTag = this.blockTag.bind(this);
        const data = this.data.bind(this);
        const hash = this.hash.bind(this);
        const hex = this.hex.bind(this);
        const number = this.number.bind(this);
        const type = this.type.bind(this);
        const strictData = (v)=>{
            return this.data(v, true);
        };
        formats.transaction = {
            hash: hash,
            type: type,
            accessList: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null),
            blockHash: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(hash, null),
            blockNumber: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(number, null),
            transactionIndex: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(number, null),
            confirmations: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(number, null),
            from: address,
            // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
            // must be set
            gasPrice: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber),
            gasLimit: bigNumber,
            to: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(address, null),
            value: bigNumber,
            nonce: number,
            data: data,
            r: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(this.uint256),
            s: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(this.uint256),
            v: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(number),
            creates: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(address, null),
            raw: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(data)
        };
        formats.transactionRequest = {
            from: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(address),
            nonce: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(number),
            gasLimit: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber),
            gasPrice: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber),
            to: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(address),
            value: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber),
            data: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(strictData),
            type: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(number),
            accessList: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null)
        };
        formats.receiptLog = {
            transactionIndex: number,
            blockNumber: number,
            transactionHash: hash,
            address: address,
            topics: $af0c63f6ba6ab466$export$a06636add2a09fd8.arrayOf(hash),
            data: data,
            logIndex: number,
            blockHash: hash
        };
        formats.receipt = {
            to: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(this.address, null),
            from: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(this.address, null),
            contractAddress: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(address, null),
            transactionIndex: number,
            // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
            root: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(hex),
            gasUsed: bigNumber,
            logsBloom: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(data),
            blockHash: hash,
            transactionHash: hash,
            logs: $af0c63f6ba6ab466$export$a06636add2a09fd8.arrayOf(this.receiptLog.bind(this)),
            blockNumber: number,
            confirmations: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(number, null),
            cumulativeGasUsed: bigNumber,
            effectiveGasPrice: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber),
            status: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(number),
            type: type
        };
        formats.block = {
            hash: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(hash),
            parentHash: hash,
            number: number,
            timestamp: number,
            nonce: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(hex),
            difficulty: this.difficulty.bind(this),
            gasLimit: bigNumber,
            gasUsed: bigNumber,
            miner: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(address),
            extraData: data,
            transactions: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull($af0c63f6ba6ab466$export$a06636add2a09fd8.arrayOf(hash)),
            baseFeePerGas: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber)
        };
        formats.blockWithTransactions = (0, $19462b55124983f4$exports.shallowCopy)(formats.block);
        formats.blockWithTransactions.transactions = $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull($af0c63f6ba6ab466$export$a06636add2a09fd8.arrayOf(this.transactionResponse.bind(this)));
        formats.filter = {
            fromBlock: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            toBlock: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            blockHash: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(hash, undefined),
            address: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(address, undefined),
            topics: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(this.topics.bind(this), undefined)
        };
        formats.filterLog = {
            blockNumber: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(number),
            blockHash: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(hash),
            transactionIndex: number,
            removed: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(this.boolean.bind(this)),
            address: address,
            data: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowFalsish(data, "0x"),
            topics: $af0c63f6ba6ab466$export$a06636add2a09fd8.arrayOf(hash),
            transactionHash: hash,
            logIndex: number
        };
        return formats;
    }
    accessList(accessList) {
        return (0, $cd7e99036b8e7d03$export$6c8662b1600dce2)(accessList || []);
    }
    // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
    // Strict! Used on input.
    number(number) {
        if (number === "0x") return 0;
        return (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(number).toNumber();
    }
    type(number) {
        if (number === "0x" || number == null) return 0;
        return (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(number).toNumber();
    }
    // Strict! Used on input.
    bigNumber(value) {
        return (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(value);
    }
    // Requires a boolean, "true" or  "false"; returns a boolean
    boolean(value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "string") {
            value = value.toLowerCase();
            if (value === "true") return true;
            if (value === "false") return false;
        }
        throw new Error("invalid boolean - " + value);
    }
    hex(value, strict) {
        if (typeof value === "string") {
            if (!strict && value.substring(0, 2) !== "0x") value = "0x" + value;
            if ((0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(value)) return value.toLowerCase();
        }
        return $af0c63f6ba6ab466$var$logger.throwArgumentError("invalid hash", "value", value);
    }
    data(value, strict) {
        const result = this.hex(value, strict);
        if (result.length % 2 !== 0) throw new Error("invalid data; odd-length - " + value);
        return result;
    }
    // Requires an address
    // Strict! Used on input.
    address(value) {
        return (0, $a4b82b374f356b4b$export$88411125f012957a)(value);
    }
    callAddress(value) {
        if (!(0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(value, 32)) return null;
        const address = (0, $a4b82b374f356b4b$export$88411125f012957a)((0, $ddc3d9704a40b613$export$15da666eba198c18)(value, 12));
        return address === (0, $3d13afb7ba7a6bb7$export$badd13187c087617) ? null : address;
    }
    contractAddress(value) {
        return (0, $a4b82b374f356b4b$export$b7fbffef12272e40)(value);
    }
    // Strict! Used on input.
    blockTag(blockTag) {
        if (blockTag == null) return "latest";
        if (blockTag === "earliest") return "0x0";
        switch(blockTag){
            case "earliest":
                return "0x0";
            case "latest":
            case "pending":
            case "safe":
            case "finalized":
                return blockTag;
        }
        if (typeof blockTag === "number" || (0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(blockTag)) return (0, $ddc3d9704a40b613$export$6916af760a341dd3)(blockTag);
        throw new Error("invalid blockTag");
    }
    // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
    hash(value, strict) {
        const result = this.hex(value, strict);
        if ((0, $ddc3d9704a40b613$export$13882f896d3c0683)(result) !== 32) return $af0c63f6ba6ab466$var$logger.throwArgumentError("invalid hash", "value", value);
        return result;
    }
    // Returns the difficulty as a number, or if too large (i.e. PoA network) null
    difficulty(value) {
        if (value == null) return null;
        const v = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(value);
        try {
            return v.toNumber();
        } catch (error) {}
        return null;
    }
    uint256(value) {
        if (!(0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(value)) throw new Error("invalid uint256");
        return (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)(value, 32);
    }
    _block(value, format) {
        if (value.author != null && value.miner == null) value.miner = value.author;
        // The difficulty may need to come from _difficulty in recursed blocks
        const difficulty = value._difficulty != null ? value._difficulty : value.difficulty;
        const result = $af0c63f6ba6ab466$export$a06636add2a09fd8.check(format, value);
        result._difficulty = difficulty == null ? null : (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(difficulty);
        return result;
    }
    block(value) {
        return this._block(value, this.formats.block);
    }
    blockWithTransactions(value) {
        return this._block(value, this.formats.blockWithTransactions);
    }
    // Strict! Used on input.
    transactionRequest(value) {
        return $af0c63f6ba6ab466$export$a06636add2a09fd8.check(this.formats.transactionRequest, value);
    }
    transactionResponse(transaction) {
        // Rename gas to gasLimit
        if (transaction.gas != null && transaction.gasLimit == null) transaction.gasLimit = transaction.gas;
        // Some clients (TestRPC) do strange things like return 0x0 for the
        // 0 address; correct this to be a real address
        if (transaction.to && (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(transaction.to).isZero()) transaction.to = "0x0000000000000000000000000000000000000000";
        // Rename input to data
        if (transaction.input != null && transaction.data == null) transaction.data = transaction.input;
        // If to and creates are empty, populate the creates from the transaction
        if (transaction.to == null && transaction.creates == null) transaction.creates = this.contractAddress(transaction);
        if ((transaction.type === 1 || transaction.type === 2) && transaction.accessList == null) transaction.accessList = [];
        const result = $af0c63f6ba6ab466$export$a06636add2a09fd8.check(this.formats.transaction, transaction);
        if (transaction.chainId != null) {
            let chainId = transaction.chainId;
            if ((0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(chainId)) chainId = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(chainId).toNumber();
            result.chainId = chainId;
        } else {
            let chainId = transaction.networkId;
            // geth-etc returns chainId
            if (chainId == null && result.v == null) chainId = transaction.chainId;
            if ((0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(chainId)) chainId = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(chainId).toNumber();
            if (typeof chainId !== "number" && result.v != null) {
                chainId = (result.v - 35) / 2;
                if (chainId < 0) chainId = 0;
                chainId = parseInt(chainId);
            }
            if (typeof chainId !== "number") chainId = 0;
            result.chainId = chainId;
        }
        // 0x0000... should actually be null
        if (result.blockHash && result.blockHash.replace(/0/g, "") === "x") result.blockHash = null;
        return result;
    }
    transaction(value) {
        return (0, $cd7e99036b8e7d03$export$98e6a39c04603d36)(value);
    }
    receiptLog(value) {
        return $af0c63f6ba6ab466$export$a06636add2a09fd8.check(this.formats.receiptLog, value);
    }
    receipt(value) {
        const result = $af0c63f6ba6ab466$export$a06636add2a09fd8.check(this.formats.receipt, value);
        // RSK incorrectly implemented EIP-658, so we munge things a bit here for it
        if (result.root != null) {
            if (result.root.length <= 4) {
                // Could be 0x00, 0x0, 0x01 or 0x1
                const value = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(result.root).toNumber();
                if (value === 0 || value === 1) {
                    // Make sure if both are specified, they match
                    if (result.status != null && result.status !== value) $af0c63f6ba6ab466$var$logger.throwArgumentError("alt-root-status/status mismatch", "value", {
                        root: result.root,
                        status: result.status
                    });
                    result.status = value;
                    delete result.root;
                } else $af0c63f6ba6ab466$var$logger.throwArgumentError("invalid alt-root-status", "value.root", result.root);
            } else if (result.root.length !== 66) // Must be a valid bytes32
            $af0c63f6ba6ab466$var$logger.throwArgumentError("invalid root hash", "value.root", result.root);
        }
        if (result.status != null) result.byzantium = true;
        return result;
    }
    topics(value) {
        if (Array.isArray(value)) return value.map((v)=>this.topics(v));
        else if (value != null) return this.hash(value, true);
        return null;
    }
    filter(value) {
        return $af0c63f6ba6ab466$export$a06636add2a09fd8.check(this.formats.filter, value);
    }
    filterLog(value) {
        return $af0c63f6ba6ab466$export$a06636add2a09fd8.check(this.formats.filterLog, value);
    }
    static check(format, object) {
        const result = {};
        for(const key in format)try {
            const value = format[key](object[key]);
            if (value !== undefined) result[key] = value;
        } catch (error) {
            error.checkKey = key;
            error.checkValue = object[key];
            throw error;
        }
        return result;
    }
    // if value is null-ish, nullValue is returned
    static allowNull(format, nullValue) {
        return function(value) {
            if (value == null) return nullValue;
            return format(value);
        };
    }
    // If value is false-ish, replaceValue is returned
    static allowFalsish(format, replaceValue) {
        return function(value) {
            if (!value) return replaceValue;
            return format(value);
        };
    }
    // Requires an Array satisfying check
    static arrayOf(format) {
        return function(array) {
            if (!Array.isArray(array)) throw new Error("not an array");
            const result = [];
            array.forEach(function(value) {
                result.push(format(value));
            });
            return result;
        };
    }
    constructor(){
        this.formats = this.getDefaultFormats();
    }
}
function $af0c63f6ba6ab466$export$3091239f5b20b896(value) {
    return value && typeof value.isCommunityResource === "function";
}
function $af0c63f6ba6ab466$export$d93d5f61c2498b6(value) {
    return $af0c63f6ba6ab466$export$3091239f5b20b896(value) && value.isCommunityResource();
}
// Show the throttle message only once
let $af0c63f6ba6ab466$var$throttleMessage = false;
function $af0c63f6ba6ab466$export$4c41bd49e82e82ab() {
    if ($af0c63f6ba6ab466$var$throttleMessage) return;
    $af0c63f6ba6ab466$var$throttleMessage = true;
    console.log("========= NOTICE =========");
    console.log("Request-Rate Exceeded  (this message will not be repeated)");
    console.log("");
    console.log("The default API keys for each service are provided as a highly-throttled,");
    console.log("community resource for low-traffic projects and early prototyping.");
    console.log("");
    console.log("While your application will continue to function, we highly recommended");
    console.log("signing up for your own API keys to improve performance, increase your");
    console.log("request rate/limit and enable other perks, such as metrics and advanced APIs.");
    console.log("");
    console.log("For more details: https://docs.ethers.io/api-keys/");
    console.log("==========================");
}


"use strict";
var $6a1c8a35900dd937$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $6a1c8a35900dd937$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d9347b79faa289ba$export$83d89fbfd8236492));
const $6a1c8a35900dd937$var$MAX_CCIP_REDIRECTS = 10;
//////////////////////////////
// Event Serializeing
function $6a1c8a35900dd937$var$checkTopic(topic) {
    if (topic == null) return "null";
    if ((0, $ddc3d9704a40b613$export$13882f896d3c0683)(topic) !== 32) $6a1c8a35900dd937$var$logger.throwArgumentError("invalid topic", "topic", topic);
    return topic.toLowerCase();
}
function $6a1c8a35900dd937$var$serializeTopics(topics) {
    // Remove trailing null AND-topics; they are redundant
    topics = topics.slice();
    while(topics.length > 0 && topics[topics.length - 1] == null)topics.pop();
    return topics.map((topic)=>{
        if (Array.isArray(topic)) {
            // Only track unique OR-topics
            const unique = {};
            topic.forEach((topic)=>{
                unique[$6a1c8a35900dd937$var$checkTopic(topic)] = true;
            });
            // The order of OR-topics does not matter
            const sorted = Object.keys(unique);
            sorted.sort();
            return sorted.join("|");
        } else return $6a1c8a35900dd937$var$checkTopic(topic);
    }).join("&");
}
function $6a1c8a35900dd937$var$deserializeTopics(data) {
    if (data === "") return [];
    return data.split(/&/g).map((topic)=>{
        if (topic === "") return [];
        const comps = topic.split("|").map((topic)=>{
            return topic === "null" ? null : topic;
        });
        return comps.length === 1 ? comps[0] : comps;
    });
}
function $6a1c8a35900dd937$var$getEventTag(eventName) {
    if (typeof eventName === "string") {
        eventName = eventName.toLowerCase();
        if ((0, $ddc3d9704a40b613$export$13882f896d3c0683)(eventName) === 32) return "tx:" + eventName;
        if (eventName.indexOf(":") === -1) return eventName;
    } else if (Array.isArray(eventName)) return "filter:*:" + $6a1c8a35900dd937$var$serializeTopics(eventName);
    else if ((0, $fd80fed41b6901ec$exports.ForkEvent).isForkEvent(eventName)) {
        $6a1c8a35900dd937$var$logger.warn("not implemented");
        throw new Error("not implemented");
    } else if (eventName && typeof eventName === "object") return "filter:" + (eventName.address || "*") + ":" + $6a1c8a35900dd937$var$serializeTopics(eventName.topics || []);
    throw new Error("invalid event - " + eventName);
}
//////////////////////////////
// Helper Object
function $6a1c8a35900dd937$var$getTime() {
    return new Date().getTime();
}
function $6a1c8a35900dd937$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
//////////////////////////////
// Provider Object
/**
 *  EventType
 *   - "block"
 *   - "poll"
 *   - "didPoll"
 *   - "pending"
 *   - "error"
 *   - "network"
 *   - filter
 *   - topics array
 *   - transaction hash
 */ const $6a1c8a35900dd937$var$PollableEvents = [
    "block",
    "network",
    "pending",
    "poll"
];
class $6a1c8a35900dd937$export$d61e24a684f9e51 {
    get event() {
        switch(this.type){
            case "tx":
                return this.hash;
            case "filter":
                return this.filter;
        }
        return this.tag;
    }
    get type() {
        return this.tag.split(":")[0];
    }
    get hash() {
        const comps = this.tag.split(":");
        if (comps[0] !== "tx") return null;
        return comps[1];
    }
    get filter() {
        const comps = this.tag.split(":");
        if (comps[0] !== "filter") return null;
        const address = comps[1];
        const topics = $6a1c8a35900dd937$var$deserializeTopics(comps[2]);
        const filter = {};
        if (topics.length > 0) filter.topics = topics;
        if (address && address !== "*") filter.address = address;
        return filter;
    }
    pollable() {
        return this.tag.indexOf(":") >= 0 || $6a1c8a35900dd937$var$PollableEvents.indexOf(this.tag) >= 0;
    }
    constructor(tag, listener, once){
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "tag", tag);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "listener", listener);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "once", once);
        this._lastBlockNumber = -2;
        this._inflight = false;
    }
}
// https://github.com/satoshilabs/slips/blob/master/slip-0044.md
const $6a1c8a35900dd937$var$coinInfos = {
    "0": {
        symbol: "btc",
        p2pkh: 0x00,
        p2sh: 0x05,
        prefix: "bc"
    },
    "2": {
        symbol: "ltc",
        p2pkh: 0x30,
        p2sh: 0x32,
        prefix: "ltc"
    },
    "3": {
        symbol: "doge",
        p2pkh: 0x1e,
        p2sh: 0x16
    },
    "60": {
        symbol: "eth",
        ilk: "eth"
    },
    "61": {
        symbol: "etc",
        ilk: "eth"
    },
    "700": {
        symbol: "xdai",
        ilk: "eth"
    }
};
function $6a1c8a35900dd937$var$bytes32ify(value) {
    return (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)((0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(value).toHexString(), 32);
}
// Compute the Base58Check encoded data (checksum is first 4 bytes of sha256d)
function $6a1c8a35900dd937$var$base58Encode(data) {
    return (0, $a538ed25248fff2d$export$45a587635c9954b2).encode((0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
        data,
        (0, $ddc3d9704a40b613$export$15da666eba198c18)((0, $5c9a0ceac3511c58$export$bced8d2aada2d1c9)((0, $5c9a0ceac3511c58$export$bced8d2aada2d1c9)(data)), 0, 4)
    ]));
}
const $6a1c8a35900dd937$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
const $6a1c8a35900dd937$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $6a1c8a35900dd937$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
function $6a1c8a35900dd937$var$_parseString(result, start) {
    try {
        return (0, $169c6c93221d2e48$export$7643a1dc2c38d5eb)($6a1c8a35900dd937$var$_parseBytes(result, start));
    } catch (error) {}
    return null;
}
function $6a1c8a35900dd937$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    const offset = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from((0, $ddc3d9704a40b613$export$15da666eba198c18)(result, start, start + 32)).toNumber();
    const length = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from((0, $ddc3d9704a40b613$export$15da666eba198c18)(result, offset, offset + 32)).toNumber();
    return (0, $ddc3d9704a40b613$export$15da666eba198c18)(result, offset + 32, offset + 32 + length);
}
// Trim off the ipfs:// prefix and return the default gateway URL
function $6a1c8a35900dd937$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else $6a1c8a35900dd937$var$logger.throwArgumentError("unsupported IPFS format", "link", link);
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
function $6a1c8a35900dd937$var$numPad(value) {
    const result = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $6a1c8a35900dd937$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
// ABI Encodes a series of (bytes, bytes, ...)
function $6a1c8a35900dd937$var$encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for(let i = 0; i < datas.length; i++){
        result.push(null);
        byteCount += 32;
    }
    for(let i = 0; i < datas.length; i++){
        const data = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(datas[i]);
        // Update the bytes offset
        result[i] = $6a1c8a35900dd937$var$numPad(byteCount);
        // The length and padded value of data
        result.push($6a1c8a35900dd937$var$numPad(data.length));
        result.push($6a1c8a35900dd937$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $ddc3d9704a40b613$export$6d4b99629b38754a)(result);
}
class $6a1c8a35900dd937$export$8b4c839865b08288 {
    supportsWildcard() {
        if (!this._supportsEip2544) // supportsInterface(bytes4 = selector("resolve(bytes,bytes)"))
        this._supportsEip2544 = this.provider.call({
            to: this.address,
            data: "0x01ffc9a79061b92300000000000000000000000000000000000000000000000000000000"
        }).then((result)=>{
            return (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(result).eq(1);
        }).catch((error)=>{
            if (error.code === (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.CALL_EXCEPTION) return false;
            // Rethrow the error: link is down, etc. Let future attempts retry.
            this._supportsEip2544 = null;
            throw error;
        });
        return this._supportsEip2544;
    }
    _fetch(selector, parameters) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            // e.g. keccak256("addr(bytes32,uint256)")
            const tx = {
                to: this.address,
                ccipReadEnabled: true,
                data: (0, $ddc3d9704a40b613$export$6d4b99629b38754a)([
                    selector,
                    (0, $3715ffed660cd02c$export$91d651ee363e1209)(this.name),
                    parameters || "0x"
                ])
            };
            // Wildcard support; use EIP-2544 to resolve the request
            let parseBytes = false;
            if (yield this.supportsWildcard()) {
                parseBytes = true;
                // selector("resolve(bytes,bytes)")
                tx.data = (0, $ddc3d9704a40b613$export$6d4b99629b38754a)([
                    "0x9061b923",
                    $6a1c8a35900dd937$var$encodeBytes([
                        (0, $3715ffed660cd02c$export$6c0a8cdae51cb512)(this.name),
                        tx.data
                    ])
                ]);
            }
            try {
                let result = yield this.provider.call(tx);
                if ((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(result).length % 32 === 4) $6a1c8a35900dd937$var$logger.throwError("resolver threw error", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    transaction: tx,
                    data: result
                });
                if (parseBytes) result = $6a1c8a35900dd937$var$_parseBytes(result, 0);
                return result;
            } catch (error) {
                if (error.code === (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.CALL_EXCEPTION) return null;
                throw error;
            }
        });
    }
    _fetchBytes(selector, parameters) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._fetch(selector, parameters);
            if (result != null) return $6a1c8a35900dd937$var$_parseBytes(result, 0);
            return null;
        });
    }
    _getAddress(coinType, hexBytes) {
        const coinInfo = $6a1c8a35900dd937$var$coinInfos[String(coinType)];
        if (coinInfo == null) $6a1c8a35900dd937$var$logger.throwError(`unsupported coin type: ${coinType}`, (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: `getAddress(${coinType})`
        });
        if (coinInfo.ilk === "eth") return this.provider.formatter.address(hexBytes);
        const bytes = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(hexBytes);
        // P2PKH: OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG
        if (coinInfo.p2pkh != null) {
            const p2pkh = hexBytes.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
            if (p2pkh) {
                const length = parseInt(p2pkh[1], 16);
                if (p2pkh[2].length === length * 2 && length >= 1 && length <= 75) return $6a1c8a35900dd937$var$base58Encode((0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
                    [
                        coinInfo.p2pkh
                    ],
                    "0x" + p2pkh[2]
                ]));
            }
        }
        // P2SH: OP_HASH160 <scriptHash> OP_EQUAL
        if (coinInfo.p2sh != null) {
            const p2sh = hexBytes.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
            if (p2sh) {
                const length = parseInt(p2sh[1], 16);
                if (p2sh[2].length === length * 2 && length >= 1 && length <= 75) return $6a1c8a35900dd937$var$base58Encode((0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
                    [
                        coinInfo.p2sh
                    ],
                    "0x" + p2sh[2]
                ]));
            }
        }
        // Bech32
        if (coinInfo.prefix != null) {
            const length = bytes[1];
            // https://github.com/bitcoin/bips/blob/master/bip-0141.mediawiki#witness-program
            let version = bytes[0];
            if (version === 0x00) {
                if (length !== 20 && length !== 32) version = -1;
            } else version = -1;
            if (version >= 0 && bytes.length === 2 + length && length >= 1 && length <= 75) {
                const words = (0, (/*@__PURE__*/$parcel$interopDefault($c01d4687d4f4d3ac$exports))).toWords(bytes.slice(2));
                words.unshift(version);
                return (0, (/*@__PURE__*/$parcel$interopDefault($c01d4687d4f4d3ac$exports))).encode(coinInfo.prefix, words);
            }
        }
        return null;
    }
    getAddress(coinType) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            if (coinType == null) coinType = 60;
            // If Ethereum, use the standard `addr(bytes32)`
            if (coinType === 60) try {
                // keccak256("addr(bytes32)")
                const result = yield this._fetch("0x3b3b57de");
                // No address
                if (result === "0x" || result === (0, $43ba40ff64f1a63e$export$71c2e4e213dcb7f2)) return null;
                return this.provider.formatter.callAddress(result);
            } catch (error) {
                if (error.code === (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.CALL_EXCEPTION) return null;
                throw error;
            }
            // keccak256("addr(bytes32,uint256")
            const hexBytes = yield this._fetchBytes("0xf1cb7e06", $6a1c8a35900dd937$var$bytes32ify(coinType));
            // No address
            if (hexBytes == null || hexBytes === "0x") return null;
            // Compute the address
            const address = this._getAddress(coinType, hexBytes);
            if (address == null) $6a1c8a35900dd937$var$logger.throwError(`invalid or unsupported coin data`, (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: `getAddress(${coinType})`,
                coinType: coinType,
                data: hexBytes
            });
            return address;
        });
    }
    getAvatar() {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            const linkage = [
                {
                    type: "name",
                    content: this.name
                }
            ];
            try {
                // test data for ricmoo.eth
                //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
                const avatar = yield this.getText("avatar");
                if (avatar == null) return null;
                for(let i = 0; i < $6a1c8a35900dd937$var$matchers.length; i++){
                    const match = avatar.match($6a1c8a35900dd937$var$matchers[i]);
                    if (match == null) continue;
                    const scheme = match[1].toLowerCase();
                    switch(scheme){
                        case "https":
                            linkage.push({
                                type: "url",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "data":
                            linkage.push({
                                type: "data",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "ipfs":
                            linkage.push({
                                type: "ipfs",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: $6a1c8a35900dd937$var$getIpfsLink(avatar)
                            };
                        case "erc721":
                        case "erc1155":
                            {
                                // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                                const selector = scheme === "erc721" ? "0xc87b56dd" : "0x0e89341c";
                                linkage.push({
                                    type: scheme,
                                    content: avatar
                                });
                                // The owner of this name
                                const owner = this._resolvedAddress || (yield this.getAddress());
                                const comps = (match[2] || "").split("/");
                                if (comps.length !== 2) return null;
                                const addr = yield this.provider.formatter.address(comps[0]);
                                const tokenId = (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)((0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(comps[1]).toHexString(), 32);
                                // Check that this account owns the token
                                if (scheme === "erc721") {
                                    // ownerOf(uint256 tokenId)
                                    const tokenOwner = this.provider.formatter.callAddress((yield this.provider.call({
                                        to: addr,
                                        data: (0, $ddc3d9704a40b613$export$6d4b99629b38754a)([
                                            "0x6352211e",
                                            tokenId
                                        ])
                                    })));
                                    if (owner !== tokenOwner) return null;
                                    linkage.push({
                                        type: "owner",
                                        content: tokenOwner
                                    });
                                } else if (scheme === "erc1155") {
                                    // balanceOf(address owner, uint256 tokenId)
                                    const balance = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from((yield this.provider.call({
                                        to: addr,
                                        data: (0, $ddc3d9704a40b613$export$6d4b99629b38754a)([
                                            "0x00fdd58e",
                                            (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)(owner, 32),
                                            tokenId
                                        ])
                                    })));
                                    if (balance.isZero()) return null;
                                    linkage.push({
                                        type: "balance",
                                        content: balance.toString()
                                    });
                                }
                                // Call the token contract for the metadata URL
                                const tx = {
                                    to: this.provider.formatter.address(comps[0]),
                                    data: (0, $ddc3d9704a40b613$export$6d4b99629b38754a)([
                                        selector,
                                        tokenId
                                    ])
                                };
                                let metadataUrl = $6a1c8a35900dd937$var$_parseString((yield this.provider.call(tx)), 0);
                                if (metadataUrl == null) return null;
                                linkage.push({
                                    type: "metadata-url-base",
                                    content: metadataUrl
                                });
                                // ERC-1155 allows a generic {id} in the URL
                                if (scheme === "erc1155") {
                                    metadataUrl = metadataUrl.replace("{id}", tokenId.substring(2));
                                    linkage.push({
                                        type: "metadata-url-expanded",
                                        content: metadataUrl
                                    });
                                }
                                // Transform IPFS metadata links
                                if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $6a1c8a35900dd937$var$getIpfsLink(metadataUrl);
                                linkage.push({
                                    type: "metadata-url",
                                    content: metadataUrl
                                });
                                // Get the token metadata
                                const metadata = yield (0, $bf63a14489d0132f$exports.fetchJson)(metadataUrl);
                                if (!metadata) return null;
                                linkage.push({
                                    type: "metadata",
                                    content: JSON.stringify(metadata)
                                });
                                // Pull the image URL out
                                let imageUrl = metadata.image;
                                if (typeof imageUrl !== "string") return null;
                                if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                                else {
                                    // Transform IPFS link to gateway
                                    const ipfs = imageUrl.match($6a1c8a35900dd937$var$matcherIpfs);
                                    if (ipfs == null) return null;
                                    linkage.push({
                                        type: "url-ipfs",
                                        content: imageUrl
                                    });
                                    imageUrl = $6a1c8a35900dd937$var$getIpfsLink(imageUrl);
                                }
                                linkage.push({
                                    type: "url",
                                    content: imageUrl
                                });
                                return {
                                    linkage: linkage,
                                    url: imageUrl
                                };
                            }
                    }
                }
            } catch (error) {}
            return null;
        });
    }
    getContentHash() {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            // keccak256("contenthash()")
            const hexBytes = yield this._fetchBytes("0xbc1c58d1");
            // No contenthash
            if (hexBytes == null || hexBytes === "0x") return null;
            // IPFS (CID: 1, Type: DAG-PB)
            const ipfs = hexBytes.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipfs) {
                const length = parseInt(ipfs[3], 16);
                if (ipfs[4].length === length * 2) return "ipfs://" + (0, $a538ed25248fff2d$export$45a587635c9954b2).encode("0x" + ipfs[1]);
            }
            // IPNS (CID: 1, Type: libp2p-key)
            const ipns = hexBytes.match(/^0xe5010172(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipns) {
                const length = parseInt(ipns[3], 16);
                if (ipns[4].length === length * 2) return "ipns://" + (0, $a538ed25248fff2d$export$45a587635c9954b2).encode("0x" + ipns[1]);
            }
            // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
            const swarm = hexBytes.match(/^0xe40101fa011b20([0-9a-f]*)$/);
            if (swarm) {
                if (swarm[1].length === 64) return "bzz://" + swarm[1];
            }
            const skynet = hexBytes.match(/^0x90b2c605([0-9a-f]*)$/);
            if (skynet) {
                if (skynet[1].length === 68) {
                    // URL Safe base64; https://datatracker.ietf.org/doc/html/rfc4648#section-5
                    const urlSafe = {
                        "=": "",
                        "+": "-",
                        "/": "_"
                    };
                    const hash = (0, $51b0a655b2efccfa$export$c564cdbbe6da493)("0x" + skynet[1]).replace(/[=+\/]/g, (a)=>urlSafe[a]);
                    return "sia://" + hash;
                }
            }
            return $6a1c8a35900dd937$var$logger.throwError(`invalid or unsupported content hash data`, (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "getContentHash()",
                data: hexBytes
            });
        });
    }
    getText(key) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            // The key encoded as parameter to fetchBytes
            let keyBytes = (0, $169c6c93221d2e48$export$8feeb310b4b4752f)(key);
            // The nodehash consumes the first slot, so the string pointer targets
            // offset 64, with the length at offset 64 and data starting at offset 96
            keyBytes = (0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
                $6a1c8a35900dd937$var$bytes32ify(64),
                $6a1c8a35900dd937$var$bytes32ify(keyBytes.length),
                keyBytes
            ]);
            // Pad to word-size (32 bytes)
            if (keyBytes.length % 32 !== 0) keyBytes = (0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
                keyBytes,
                (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)("0x", 32 - key.length % 32)
            ]);
            const hexBytes = yield this._fetchBytes("0x59d1d43c", (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(keyBytes));
            if (hexBytes == null || hexBytes === "0x") return null;
            return (0, $169c6c93221d2e48$export$7643a1dc2c38d5eb)(hexBytes);
        });
    }
    // The resolvedAddress is only for creating a ReverseLookup resolver
    constructor(provider, address, name, resolvedAddress){
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "provider", provider);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "name", name);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "address", provider.formatter.address(address));
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "_resolvedAddress", resolvedAddress);
    }
}
let $6a1c8a35900dd937$var$defaultFormatter = null;
let $6a1c8a35900dd937$var$nextPollId = 1;
class $6a1c8a35900dd937$export$ff3f6dd83125ac45 extends (0, $fd80fed41b6901ec$exports.Provider) {
    _ready() {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            if (this._network == null) {
                let network = null;
                if (this._networkPromise) try {
                    network = yield this._networkPromise;
                } catch (error) {}
                // Try the Provider's network detection (this MUST throw if it cannot)
                if (network == null) network = yield this.detectNetwork();
                // This should never happen; every Provider sub-class should have
                // suggested a network by here (or have thrown).
                if (!network) $6a1c8a35900dd937$var$logger.throwError("no network detected", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {});
                // Possible this call stacked so do not call defineReadOnly again
                if (this._network == null) {
                    if (this.anyNetwork) this._network = network;
                    else (0, $19462b55124983f4$exports.defineReadOnly)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return this._network;
        });
    }
    // This will always return the most recently established network.
    // For "any", this can change (a "network" event is emitted before
    // any change is reflected); otherwise this cannot change
    get ready() {
        return (0, $bf63a14489d0132f$exports.poll)(()=>{
            return this._ready().then((network)=>{
                return network;
            }, (error)=>{
                // If the network isn't running yet, we will wait
                if (error.code === (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.NETWORK_ERROR && error.event === "noNetwork") return undefined;
                throw error;
            });
        });
    }
    // @TODO: Remove this and just create a singleton formatter
    static getFormatter() {
        if ($6a1c8a35900dd937$var$defaultFormatter == null) $6a1c8a35900dd937$var$defaultFormatter = new (0, $af0c63f6ba6ab466$export$a06636add2a09fd8)();
        return $6a1c8a35900dd937$var$defaultFormatter;
    }
    // @TODO: Remove this and just use getNetwork
    static getNetwork(network) {
        return (0, $161a25d62c52de9c$export$7de4970ebfd8206d)(network == null ? "homestead" : network);
    }
    ccipReadFetch(tx, calldata, urls) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            if (this.disableCcipRead || urls.length === 0) return null;
            const sender = tx.to.toLowerCase();
            const data = calldata.toLowerCase();
            const errorMessages = [];
            for(let i = 0; i < urls.length; i++){
                const url = urls[i];
                // URL expansion
                const href = url.replace("{sender}", sender).replace("{data}", data);
                // If no {data} is present, use POST; otherwise GET
                const json = url.indexOf("{data}") >= 0 ? null : JSON.stringify({
                    data: data,
                    sender: sender
                });
                const result = yield (0, $bf63a14489d0132f$exports.fetchJson)({
                    url: href,
                    errorPassThrough: true
                }, json, (value, response)=>{
                    value.status = response.statusCode;
                    return value;
                });
                if (result.data) return result.data;
                const errorMessage = result.message || "unknown error";
                // 4xx indicates the result is not present; stop
                if (result.status >= 400 && result.status < 500) return $6a1c8a35900dd937$var$logger.throwError(`response not found during CCIP fetch: ${errorMessage}`, (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    url: url,
                    errorMessage: errorMessage
                });
                // 5xx indicates server issue; try the next url
                errorMessages.push(errorMessage);
            }
            return $6a1c8a35900dd937$var$logger.throwError(`error encountered during CCIP fetch: ${errorMessages.map((m)=>JSON.stringify(m)).join(", ")}`, (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR, {
                urls: urls,
                errorMessages: errorMessages
            });
        });
    }
    // Fetches the blockNumber, but will reuse any result that is less
    // than maxAge old or has been requested since the last request
    _getInternalBlockNumber(maxAge) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this._ready();
            // Allowing stale data up to maxAge old
            if (maxAge > 0) // While there are pending internal block requests...
            while(this._internalBlockNumber){
                // ..."remember" which fetch we started with
                const internalBlockNumber = this._internalBlockNumber;
                try {
                    // Check the result is not too stale
                    const result = yield internalBlockNumber;
                    if ($6a1c8a35900dd937$var$getTime() - result.respTime <= maxAge) return result.blockNumber;
                    break;
                } catch (error) {
                    // The fetch rejected; if we are the first to get the
                    // rejection, drop through so we replace it with a new
                    // fetch; all others blocked will then get that fetch
                    // which won't match the one they "remembered" and loop
                    if (this._internalBlockNumber === internalBlockNumber) break;
                }
            }
            const reqTime = $6a1c8a35900dd937$var$getTime();
            const checkInternalBlockNumber = (0, $19462b55124983f4$exports.resolveProperties)({
                blockNumber: this.perform("getBlockNumber", {}),
                networkError: this.getNetwork().then((network)=>null, (error)=>error)
            }).then(({ blockNumber: blockNumber, networkError: networkError })=>{
                if (networkError) {
                    // Unremember this bad internal block number
                    if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
                    throw networkError;
                }
                const respTime = $6a1c8a35900dd937$var$getTime();
                blockNumber = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(blockNumber).toNumber();
                if (blockNumber < this._maxInternalBlockNumber) blockNumber = this._maxInternalBlockNumber;
                this._maxInternalBlockNumber = blockNumber;
                this._setFastBlockNumber(blockNumber); // @TODO: Still need this?
                return {
                    blockNumber: blockNumber,
                    reqTime: reqTime,
                    respTime: respTime
                };
            });
            this._internalBlockNumber = checkInternalBlockNumber;
            // Swallow unhandled exceptions; if needed they are handled else where
            checkInternalBlockNumber.catch((error)=>{
                // Don't null the dead (rejected) fetch, if it has already been updated
                if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
            });
            return (yield checkInternalBlockNumber).blockNumber;
        });
    }
    poll() {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            const pollId = $6a1c8a35900dd937$var$nextPollId++;
            // Track all running promises, so we can trigger a post-poll once they are complete
            const runners = [];
            let blockNumber = null;
            try {
                blockNumber = yield this._getInternalBlockNumber(100 + this.pollingInterval / 2);
            } catch (error) {
                this.emit("error", error);
                return;
            }
            this._setFastBlockNumber(blockNumber);
            // Emit a poll event after we have the latest (fast) block number
            this.emit("poll", pollId, blockNumber);
            // If the block has not changed, meh.
            if (blockNumber === this._lastBlockNumber) {
                this.emit("didPoll", pollId);
                return;
            }
            // First polling cycle, trigger a "block" events
            if (this._emitted.block === -2) this._emitted.block = blockNumber - 1;
            if (Math.abs(this._emitted.block - blockNumber) > 1000) {
                $6a1c8a35900dd937$var$logger.warn(`network block skew detected; skipping block events (emitted=${this._emitted.block} blockNumber${blockNumber})`);
                this.emit("error", $6a1c8a35900dd937$var$logger.makeError("network block skew detected", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                    blockNumber: blockNumber,
                    event: "blockSkew",
                    previousBlockNumber: this._emitted.block
                }));
                this.emit("block", blockNumber);
            } else // Notify all listener for each block that has passed
            for(let i = this._emitted.block + 1; i <= blockNumber; i++)this.emit("block", i);
            // The emitted block was updated, check for obsolete events
            if (this._emitted.block !== blockNumber) {
                this._emitted.block = blockNumber;
                Object.keys(this._emitted).forEach((key)=>{
                    // The block event does not expire
                    if (key === "block") return;
                    // The block we were at when we emitted this event
                    const eventBlockNumber = this._emitted[key];
                    // We cannot garbage collect pending transactions or blocks here
                    // They should be garbage collected by the Provider when setting
                    // "pending" events
                    if (eventBlockNumber === "pending") return;
                    // Evict any transaction hashes or block hashes over 12 blocks
                    // old, since they should not return null anyways
                    if (blockNumber - eventBlockNumber > 12) delete this._emitted[key];
                });
            }
            // First polling cycle
            if (this._lastBlockNumber === -2) this._lastBlockNumber = blockNumber - 1;
            // Find all transaction hashes we are waiting on
            this._events.forEach((event)=>{
                switch(event.type){
                    case "tx":
                        {
                            const hash = event.hash;
                            let runner = this.getTransactionReceipt(hash).then((receipt)=>{
                                if (!receipt || receipt.blockNumber == null) return null;
                                this._emitted["t:" + hash] = receipt.blockNumber;
                                this.emit(hash, receipt);
                                return null;
                            }).catch((error)=>{
                                this.emit("error", error);
                            });
                            runners.push(runner);
                            break;
                        }
                    case "filter":
                        // We only allow a single getLogs to be in-flight at a time
                        if (!event._inflight) {
                            event._inflight = true;
                            // This is the first filter for this event, so we want to
                            // restrict events to events that happened no earlier than now
                            if (event._lastBlockNumber === -2) event._lastBlockNumber = blockNumber - 1;
                            // Filter from the last *known* event; due to load-balancing
                            // and some nodes returning updated block numbers before
                            // indexing events, a logs result with 0 entries cannot be
                            // trusted and we must retry a range which includes it again
                            const filter = event.filter;
                            filter.fromBlock = event._lastBlockNumber + 1;
                            filter.toBlock = blockNumber;
                            // Prevent fitler ranges from growing too wild, since it is quite
                            // likely there just haven't been any events to move the lastBlockNumber.
                            const minFromBlock = filter.toBlock - this._maxFilterBlockRange;
                            if (minFromBlock > filter.fromBlock) filter.fromBlock = minFromBlock;
                            if (filter.fromBlock < 0) filter.fromBlock = 0;
                            const runner = this.getLogs(filter).then((logs)=>{
                                // Allow the next getLogs
                                event._inflight = false;
                                if (logs.length === 0) return;
                                logs.forEach((log)=>{
                                    // Only when we get an event for a given block number
                                    // can we trust the events are indexed
                                    if (log.blockNumber > event._lastBlockNumber) event._lastBlockNumber = log.blockNumber;
                                    // Make sure we stall requests to fetch blocks and txs
                                    this._emitted["b:" + log.blockHash] = log.blockNumber;
                                    this._emitted["t:" + log.transactionHash] = log.blockNumber;
                                    this.emit(filter, log);
                                });
                            }).catch((error)=>{
                                this.emit("error", error);
                                // Allow another getLogs (the range was not updated)
                                event._inflight = false;
                            });
                            runners.push(runner);
                        }
                        break;
                }
            });
            this._lastBlockNumber = blockNumber;
            // Once all events for this loop have been processed, emit "didPoll"
            Promise.all(runners).then(()=>{
                this.emit("didPoll", pollId);
            }).catch((error)=>{
                this.emit("error", error);
            });
            return;
        });
    }
    // Deprecated; do not use this
    resetEventsBlock(blockNumber) {
        this._lastBlockNumber = blockNumber - 1;
        if (this.polling) this.poll();
    }
    get network() {
        return this._network;
    }
    // This method should query the network if the underlying network
    // can change, such as when connected to a JSON-RPC backend
    detectNetwork() {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            return $6a1c8a35900dd937$var$logger.throwError("provider does not support network detection", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "provider.detectNetwork"
            });
        });
    }
    getNetwork() {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            const network = yield this._ready();
            // Make sure we are still connected to the same network; this is
            // only an external call for backends which can have the underlying
            // network change spontaneously
            const currentNetwork = yield this.detectNetwork();
            if (network.chainId !== currentNetwork.chainId) {
                // We are allowing network changes, things can get complex fast;
                // make sure you know what you are doing if you use "any"
                if (this.anyNetwork) {
                    this._network = currentNetwork;
                    // Reset all internal block number guards and caches
                    this._lastBlockNumber = -2;
                    this._fastBlockNumber = null;
                    this._fastBlockNumberPromise = null;
                    this._fastQueryDate = 0;
                    this._emitted.block = -2;
                    this._maxInternalBlockNumber = -1024;
                    this._internalBlockNumber = null;
                    // The "network" event MUST happen before this method resolves
                    // so any events have a chance to unregister, so we stall an
                    // additional event loop before returning from /this/ call
                    this.emit("network", currentNetwork, network);
                    yield $6a1c8a35900dd937$var$stall(0);
                    return this._network;
                }
                const error = $6a1c8a35900dd937$var$logger.makeError("underlying network changed", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                    event: "changed",
                    network: network,
                    detectedNetwork: currentNetwork
                });
                this.emit("error", error);
                throw error;
            }
            return network;
        });
    }
    get blockNumber() {
        this._getInternalBlockNumber(100 + this.pollingInterval / 2).then((blockNumber)=>{
            this._setFastBlockNumber(blockNumber);
        }, (error)=>{});
        return this._fastBlockNumber != null ? this._fastBlockNumber : -1;
    }
    get polling() {
        return this._poller != null;
    }
    set polling(value) {
        if (value && !this._poller) {
            this._poller = setInterval(()=>{
                this.poll();
            }, this.pollingInterval);
            if (!this._bootstrapPoll) this._bootstrapPoll = setTimeout(()=>{
                this.poll();
                // We block additional polls until the polling interval
                // is done, to prevent overwhelming the poll function
                this._bootstrapPoll = setTimeout(()=>{
                    // If polling was disabled, something may require a poke
                    // since starting the bootstrap poll and it was disabled
                    if (!this._poller) this.poll();
                    // Clear out the bootstrap so we can do another
                    this._bootstrapPoll = null;
                }, this.pollingInterval);
            }, 0);
        } else if (!value && this._poller) {
            clearInterval(this._poller);
            this._poller = null;
        }
    }
    get pollingInterval() {
        return this._pollingInterval;
    }
    set pollingInterval(value) {
        if (typeof value !== "number" || value <= 0 || parseInt(String(value)) != value) throw new Error("invalid polling interval");
        this._pollingInterval = value;
        if (this._poller) {
            clearInterval(this._poller);
            this._poller = setInterval(()=>{
                this.poll();
            }, this._pollingInterval);
        }
    }
    _getFastBlockNumber() {
        const now = $6a1c8a35900dd937$var$getTime();
        // Stale block number, request a newer value
        if (now - this._fastQueryDate > 2 * this._pollingInterval) {
            this._fastQueryDate = now;
            this._fastBlockNumberPromise = this.getBlockNumber().then((blockNumber)=>{
                if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) this._fastBlockNumber = blockNumber;
                return this._fastBlockNumber;
            });
        }
        return this._fastBlockNumberPromise;
    }
    _setFastBlockNumber(blockNumber) {
        // Older block, maybe a stale request
        if (this._fastBlockNumber != null && blockNumber < this._fastBlockNumber) return;
        // Update the time we updated the blocknumber
        this._fastQueryDate = $6a1c8a35900dd937$var$getTime();
        // Newer block number, use  it
        if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
            this._fastBlockNumber = blockNumber;
            this._fastBlockNumberPromise = Promise.resolve(blockNumber);
        }
    }
    waitForTransaction(transactionHash, confirmations, timeout) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            return this._waitForTransaction(transactionHash, confirmations == null ? 1 : confirmations, timeout || 0, null);
        });
    }
    _waitForTransaction(transactionHash, confirmations, timeout, replaceable) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            const receipt = yield this.getTransactionReceipt(transactionHash);
            // Receipt is already good
            if ((receipt ? receipt.confirmations : 0) >= confirmations) return receipt;
            // Poll until the receipt is good...
            return new Promise((resolve, reject)=>{
                const cancelFuncs = [];
                let done = false;
                const alreadyDone = function() {
                    if (done) return true;
                    done = true;
                    cancelFuncs.forEach((func)=>{
                        func();
                    });
                    return false;
                };
                const minedHandler = (receipt)=>{
                    if (receipt.confirmations < confirmations) return;
                    if (alreadyDone()) return;
                    resolve(receipt);
                };
                this.on(transactionHash, minedHandler);
                cancelFuncs.push(()=>{
                    this.removeListener(transactionHash, minedHandler);
                });
                if (replaceable) {
                    let lastBlockNumber = replaceable.startBlock;
                    let scannedBlock = null;
                    const replaceHandler = (blockNumber)=>$6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
                            if (done) return;
                            // Wait 1 second; this is only used in the case of a fault, so
                            // we will trade off a little bit of latency for more consistent
                            // results and fewer JSON-RPC calls
                            yield $6a1c8a35900dd937$var$stall(1000);
                            this.getTransactionCount(replaceable.from).then((nonce)=>$6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
                                    if (done) return;
                                    if (nonce <= replaceable.nonce) lastBlockNumber = blockNumber;
                                    else {
                                        // First check if the transaction was mined
                                        {
                                            const mined = yield this.getTransaction(transactionHash);
                                            if (mined && mined.blockNumber != null) return;
                                        }
                                        // First time scanning. We start a little earlier for some
                                        // wiggle room here to handle the eventually consistent nature
                                        // of blockchain (e.g. the getTransactionCount was for a
                                        // different block)
                                        if (scannedBlock == null) {
                                            scannedBlock = lastBlockNumber - 3;
                                            if (scannedBlock < replaceable.startBlock) scannedBlock = replaceable.startBlock;
                                        }
                                        while(scannedBlock <= blockNumber){
                                            if (done) return;
                                            const block = yield this.getBlockWithTransactions(scannedBlock);
                                            for(let ti = 0; ti < block.transactions.length; ti++){
                                                const tx = block.transactions[ti];
                                                // Successfully mined!
                                                if (tx.hash === transactionHash) return;
                                                // Matches our transaction from and nonce; its a replacement
                                                if (tx.from === replaceable.from && tx.nonce === replaceable.nonce) {
                                                    if (done) return;
                                                    // Get the receipt of the replacement
                                                    const receipt = yield this.waitForTransaction(tx.hash, confirmations);
                                                    // Already resolved or rejected (prolly a timeout)
                                                    if (alreadyDone()) return;
                                                    // The reason we were replaced
                                                    let reason = "replaced";
                                                    if (tx.data === replaceable.data && tx.to === replaceable.to && tx.value.eq(replaceable.value)) reason = "repriced";
                                                    else if (tx.data === "0x" && tx.from === tx.to && tx.value.isZero()) reason = "cancelled";
                                                    // Explain why we were replaced
                                                    reject($6a1c8a35900dd937$var$logger.makeError("transaction was replaced", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.TRANSACTION_REPLACED, {
                                                        cancelled: reason === "replaced" || reason === "cancelled",
                                                        reason: reason,
                                                        replacement: this._wrapTransaction(tx),
                                                        hash: transactionHash,
                                                        receipt: receipt
                                                    }));
                                                    return;
                                                }
                                            }
                                            scannedBlock++;
                                        }
                                    }
                                    if (done) return;
                                    this.once("block", replaceHandler);
                                }), (error)=>{
                                if (done) return;
                                this.once("block", replaceHandler);
                            });
                        });
                    if (done) return;
                    this.once("block", replaceHandler);
                    cancelFuncs.push(()=>{
                        this.removeListener("block", replaceHandler);
                    });
                }
                if (typeof timeout === "number" && timeout > 0) {
                    const timer = setTimeout(()=>{
                        if (alreadyDone()) return;
                        reject($6a1c8a35900dd937$var$logger.makeError("timeout exceeded", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.TIMEOUT, {
                            timeout: timeout
                        }));
                    }, timeout);
                    if (timer.unref) timer.unref();
                    cancelFuncs.push(()=>{
                        clearTimeout(timer);
                    });
                }
            });
        });
    }
    getBlockNumber() {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            return this._getInternalBlockNumber(0);
        });
    }
    getGasPrice() {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const result = yield this.perform("getGasPrice", {});
            try {
                return (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(result);
            } catch (error) {
                return $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getGasPrice",
                    result: result,
                    error: error
                });
            }
        });
    }
    getBalance(addressOrName, blockTag) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $19462b55124983f4$exports.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getBalance", params);
            try {
                return (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(result);
            } catch (error) {
                return $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getBalance",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getTransactionCount(addressOrName, blockTag) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $19462b55124983f4$exports.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getTransactionCount", params);
            try {
                return (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(result).toNumber();
            } catch (error) {
                return $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getTransactionCount",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getCode(addressOrName, blockTag) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $19462b55124983f4$exports.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getCode", params);
            try {
                return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(result);
            } catch (error) {
                return $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getCode",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getStorageAt(addressOrName, position, blockTag) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $19462b55124983f4$exports.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag),
                position: Promise.resolve(position).then((p)=>(0, $ddc3d9704a40b613$export$6916af760a341dd3)(p))
            });
            const result = yield this.perform("getStorageAt", params);
            try {
                return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(result);
            } catch (error) {
                return $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getStorageAt",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    // This should be called by any subclass wrapping a TransactionResponse
    _wrapTransaction(tx, hash, startBlock) {
        if (hash != null && (0, $ddc3d9704a40b613$export$13882f896d3c0683)(hash) !== 32) throw new Error("invalid response - sendTransaction");
        const result = tx;
        // Check the hash we expect is the same as the hash the server reported
        if (hash != null && tx.hash !== hash) $6a1c8a35900dd937$var$logger.throwError("Transaction hash mismatch from Provider.sendTransaction.", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {
            expectedHash: tx.hash,
            returnedHash: hash
        });
        result.wait = (confirms, timeout)=>$6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
                if (confirms == null) confirms = 1;
                if (timeout == null) timeout = 0;
                // Get the details to detect replacement
                let replacement = undefined;
                if (confirms !== 0 && startBlock != null) replacement = {
                    data: tx.data,
                    from: tx.from,
                    nonce: tx.nonce,
                    to: tx.to,
                    value: tx.value,
                    startBlock: startBlock
                };
                const receipt = yield this._waitForTransaction(tx.hash, confirms, timeout, replacement);
                if (receipt == null && confirms === 0) return null;
                // No longer pending, allow the polling loop to garbage collect this
                this._emitted["t:" + tx.hash] = receipt.blockNumber;
                if (receipt.status === 0) $6a1c8a35900dd937$var$logger.throwError("transaction failed", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    transactionHash: tx.hash,
                    transaction: tx,
                    receipt: receipt
                });
                return receipt;
            });
        return result;
    }
    sendTransaction(signedTransaction) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const hexTx = yield Promise.resolve(signedTransaction).then((t)=>(0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(t));
            const tx = this.formatter.transaction(signedTransaction);
            if (tx.confirmations == null) tx.confirmations = 0;
            const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
            try {
                const hash = yield this.perform("sendTransaction", {
                    signedTransaction: hexTx
                });
                return this._wrapTransaction(tx, hash, blockNumber);
            } catch (error) {
                error.transaction = tx;
                error.transactionHash = tx.hash;
                throw error;
            }
        });
    }
    _getTransactionRequest(transaction) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            const values = yield transaction;
            const tx = {};
            [
                "from",
                "to"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? this._getAddress(v) : null);
            });
            [
                "gasLimit",
                "gasPrice",
                "maxFeePerGas",
                "maxPriorityFeePerGas",
                "value"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(v) : null);
            });
            [
                "type"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v != null ? v : null);
            });
            if (values.accessList) tx.accessList = this.formatter.accessList(values.accessList);
            [
                "data"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(v) : null);
            });
            return this.formatter.transactionRequest((yield (0, $19462b55124983f4$exports.resolveProperties)(tx)));
        });
    }
    _getFilter(filter) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            filter = yield filter;
            const result = {};
            if (filter.address != null) result.address = this._getAddress(filter.address);
            [
                "blockHash",
                "topics"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = filter[key];
            });
            [
                "fromBlock",
                "toBlock"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = this._getBlockTag(filter[key]);
            });
            return this.formatter.filter((yield (0, $19462b55124983f4$exports.resolveProperties)(result)));
        });
    }
    _call(transaction, blockTag, attempt) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            if (attempt >= $6a1c8a35900dd937$var$MAX_CCIP_REDIRECTS) $6a1c8a35900dd937$var$logger.throwError("CCIP read exceeded maximum redirections", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR, {
                redirects: attempt,
                transaction: transaction
            });
            const txSender = transaction.to;
            const result = yield this.perform("call", {
                transaction: transaction,
                blockTag: blockTag
            });
            // CCIP Read request via OffchainLookup(address,string[],bytes,bytes4,bytes)
            if (attempt >= 0 && blockTag === "latest" && txSender != null && result.substring(0, 10) === "0x556f1830" && (0, $ddc3d9704a40b613$export$13882f896d3c0683)(result) % 32 === 4) try {
                const data = (0, $ddc3d9704a40b613$export$15da666eba198c18)(result, 4);
                // Check the sender of the OffchainLookup matches the transaction
                const sender = (0, $ddc3d9704a40b613$export$15da666eba198c18)(data, 0, 32);
                if (!(0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(sender).eq(txSender)) $6a1c8a35900dd937$var$logger.throwError("CCIP Read sender did not match", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                // Read the URLs from the response
                const urls = [];
                const urlsOffset = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from((0, $ddc3d9704a40b613$export$15da666eba198c18)(data, 32, 64)).toNumber();
                const urlsLength = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from((0, $ddc3d9704a40b613$export$15da666eba198c18)(data, urlsOffset, urlsOffset + 32)).toNumber();
                const urlsData = (0, $ddc3d9704a40b613$export$15da666eba198c18)(data, urlsOffset + 32);
                for(let u = 0; u < urlsLength; u++){
                    const url = $6a1c8a35900dd937$var$_parseString(urlsData, u * 32);
                    if (url == null) $6a1c8a35900dd937$var$logger.throwError("CCIP Read contained corrupt URL string", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                        name: "OffchainLookup",
                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                        transaction: transaction,
                        data: result
                    });
                    urls.push(url);
                }
                // Get the CCIP calldata to forward
                const calldata = $6a1c8a35900dd937$var$_parseBytes(data, 64);
                // Get the callbackSelector (bytes4)
                if (!(0, $c37d64fad2cf3dce$export$d97aa349ed20696).from((0, $ddc3d9704a40b613$export$15da666eba198c18)(data, 100, 128)).isZero()) $6a1c8a35900dd937$var$logger.throwError("CCIP Read callback selector included junk", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const callbackSelector = (0, $ddc3d9704a40b613$export$15da666eba198c18)(data, 96, 100);
                // Get the extra data to send back to the contract as context
                const extraData = $6a1c8a35900dd937$var$_parseBytes(data, 128);
                const ccipResult = yield this.ccipReadFetch(transaction, calldata, urls);
                if (ccipResult == null) $6a1c8a35900dd937$var$logger.throwError("CCIP Read disabled or provided no URLs", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const tx = {
                    to: txSender,
                    data: (0, $ddc3d9704a40b613$export$6d4b99629b38754a)([
                        callbackSelector,
                        $6a1c8a35900dd937$var$encodeBytes([
                            ccipResult,
                            extraData
                        ])
                    ])
                };
                return this._call(tx, blockTag, attempt + 1);
            } catch (error) {
                if (error.code === (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR) throw error;
            }
            try {
                return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(result);
            } catch (error) {
                return $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "call",
                    params: {
                        transaction: transaction,
                        blockTag: blockTag
                    },
                    result: result,
                    error: error
                });
            }
        });
    }
    call(transaction, blockTag) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const resolved = yield (0, $19462b55124983f4$exports.resolveProperties)({
                transaction: this._getTransactionRequest(transaction),
                blockTag: this._getBlockTag(blockTag),
                ccipReadEnabled: Promise.resolve(transaction.ccipReadEnabled)
            });
            return this._call(resolved.transaction, resolved.blockTag, resolved.ccipReadEnabled ? 0 : -1);
        });
    }
    estimateGas(transaction) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $19462b55124983f4$exports.resolveProperties)({
                transaction: this._getTransactionRequest(transaction)
            });
            const result = yield this.perform("estimateGas", params);
            try {
                return (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(result);
            } catch (error) {
                return $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "estimateGas",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    _getAddress(addressOrName) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            addressOrName = yield addressOrName;
            if (typeof addressOrName !== "string") $6a1c8a35900dd937$var$logger.throwArgumentError("invalid address or ENS name", "name", addressOrName);
            const address = yield this.resolveName(addressOrName);
            if (address == null) $6a1c8a35900dd937$var$logger.throwError("ENS name not configured", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: `resolveName(${JSON.stringify(addressOrName)})`
            });
            return address;
        });
    }
    _getBlock(blockHashOrBlockTag, includeTransactions) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            blockHashOrBlockTag = yield blockHashOrBlockTag;
            // If blockTag is a number (not "latest", etc), this is the block number
            let blockNumber = -128;
            const params = {
                includeTransactions: !!includeTransactions
            };
            if ((0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(blockHashOrBlockTag, 32)) params.blockHash = blockHashOrBlockTag;
            else try {
                params.blockTag = yield this._getBlockTag(blockHashOrBlockTag);
                if ((0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(params.blockTag)) blockNumber = parseInt(params.blockTag.substring(2), 16);
            } catch (error) {
                $6a1c8a35900dd937$var$logger.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", blockHashOrBlockTag);
            }
            return (0, $bf63a14489d0132f$exports.poll)(()=>$6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
                    const block = yield this.perform("getBlock", params);
                    // Block was not found
                    if (block == null) {
                        // For blockhashes, if we didn't say it existed, that blockhash may
                        // not exist. If we did see it though, perhaps from a log, we know
                        // it exists, and this node is just not caught up yet.
                        if (params.blockHash != null) {
                            if (this._emitted["b:" + params.blockHash] == null) return null;
                        }
                        // For block tags, if we are asking for a future block, we return null
                        if (params.blockTag != null) {
                            if (blockNumber > this._emitted.block) return null;
                        }
                        // Retry on the next block
                        return undefined;
                    }
                    // Add transactions
                    if (includeTransactions) {
                        let blockNumber = null;
                        for(let i = 0; i < block.transactions.length; i++){
                            const tx = block.transactions[i];
                            if (tx.blockNumber == null) tx.confirmations = 0;
                            else if (tx.confirmations == null) {
                                if (blockNumber == null) blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                                // Add the confirmations using the fast block number (pessimistic)
                                let confirmations = blockNumber - tx.blockNumber + 1;
                                if (confirmations <= 0) confirmations = 1;
                                tx.confirmations = confirmations;
                            }
                        }
                        const blockWithTxs = this.formatter.blockWithTransactions(block);
                        blockWithTxs.transactions = blockWithTxs.transactions.map((tx)=>this._wrapTransaction(tx));
                        return blockWithTxs;
                    }
                    return this.formatter.block(block);
                }), {
                oncePoll: this
            });
        });
    }
    getBlock(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, false);
    }
    getBlockWithTransactions(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, true);
    }
    getTransaction(transactionHash) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $bf63a14489d0132f$exports.poll)(()=>$6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransaction", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    const tx = this.formatter.transactionResponse(result);
                    if (tx.blockNumber == null) tx.confirmations = 0;
                    else if (tx.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - tx.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        tx.confirmations = confirmations;
                    }
                    return this._wrapTransaction(tx);
                }), {
                oncePoll: this
            });
        });
    }
    getTransactionReceipt(transactionHash) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $bf63a14489d0132f$exports.poll)(()=>$6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransactionReceipt", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    // "geth-etc" returns receipts before they are ready
                    if (result.blockHash == null) return undefined;
                    const receipt = this.formatter.receipt(result);
                    if (receipt.blockNumber == null) receipt.confirmations = 0;
                    else if (receipt.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - receipt.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        receipt.confirmations = confirmations;
                    }
                    return receipt;
                }), {
                oncePoll: this
            });
        });
    }
    getLogs(filter) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $19462b55124983f4$exports.resolveProperties)({
                filter: this._getFilter(filter)
            });
            const logs = yield this.perform("getLogs", params);
            logs.forEach((log)=>{
                if (log.removed == null) log.removed = false;
            });
            return (0, $af0c63f6ba6ab466$export$a06636add2a09fd8).arrayOf(this.formatter.filterLog.bind(this.formatter))(logs);
        });
    }
    getEtherPrice() {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            return this.perform("getEtherPrice", {});
        });
    }
    _getBlockTag(blockTag) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            blockTag = yield blockTag;
            if (typeof blockTag === "number" && blockTag < 0) {
                if (blockTag % 1) $6a1c8a35900dd937$var$logger.throwArgumentError("invalid BlockTag", "blockTag", blockTag);
                let blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                blockNumber += blockTag;
                if (blockNumber < 0) blockNumber = 0;
                return this.formatter.blockTag(blockNumber);
            }
            return this.formatter.blockTag(blockTag);
        });
    }
    getResolver(name) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            let currentName = name;
            while(true){
                if (currentName === "" || currentName === ".") return null;
                // Optimization since the eth node cannot change and does
                // not have a wildcard resolver
                if (name !== "eth" && currentName === "eth") return null;
                // Check the current node for a resolver
                const addr = yield this._getResolver(currentName, "getResolver");
                // Found a resolver!
                if (addr != null) {
                    const resolver = new $6a1c8a35900dd937$export$8b4c839865b08288(this, addr, name);
                    // Legacy resolver found, using EIP-2544 so it isn't safe to use
                    if (currentName !== name && !(yield resolver.supportsWildcard())) return null;
                    return resolver;
                }
                // Get the parent node
                currentName = currentName.split(".").slice(1).join(".");
            }
        });
    }
    _getResolver(name, operation) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            if (operation == null) operation = "ENS";
            const network = yield this.getNetwork();
            // No ENS...
            if (!network.ensAddress) $6a1c8a35900dd937$var$logger.throwError("network does not support ENS", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: operation,
                network: network.name
            });
            try {
                // keccak256("resolver(bytes32)")
                const addrData = yield this.call({
                    to: network.ensAddress,
                    data: "0x0178b8bf" + (0, $3715ffed660cd02c$export$91d651ee363e1209)(name).substring(2)
                });
                return this.formatter.callAddress(addrData);
            } catch (error) {
            // ENS registry cannot throw errors on resolver(bytes32)
            }
            return null;
        });
    }
    resolveName(name) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            name = yield name;
            // If it is already an address, nothing to resolve
            try {
                return Promise.resolve(this.formatter.address(name));
            } catch (error) {
                // If is is a hexstring, the address is bad (See #694)
                if ((0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(name)) throw error;
            }
            if (typeof name !== "string") $6a1c8a35900dd937$var$logger.throwArgumentError("invalid ENS name", "name", name);
            // Get the addr from the resolver
            const resolver = yield this.getResolver(name);
            if (!resolver) return null;
            return yield resolver.getAddress();
        });
    }
    lookupAddress(address) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            address = yield address;
            address = this.formatter.address(address);
            const node = address.substring(2).toLowerCase() + ".addr.reverse";
            const resolverAddr = yield this._getResolver(node, "lookupAddress");
            if (resolverAddr == null) return null;
            // keccak("name(bytes32)")
            const name = $6a1c8a35900dd937$var$_parseString((yield this.call({
                to: resolverAddr,
                data: "0x691f3431" + (0, $3715ffed660cd02c$export$91d651ee363e1209)(node).substring(2)
            })), 0);
            const addr = yield this.resolveName(name);
            if (addr != address) return null;
            return name;
        });
    }
    getAvatar(nameOrAddress) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            let resolver = null;
            if ((0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(nameOrAddress)) {
                // Address; reverse lookup
                const address = this.formatter.address(nameOrAddress);
                const node = address.substring(2).toLowerCase() + ".addr.reverse";
                const resolverAddress = yield this._getResolver(node, "getAvatar");
                if (!resolverAddress) return null;
                // Try resolving the avatar against the addr.reverse resolver
                resolver = new $6a1c8a35900dd937$export$8b4c839865b08288(this, resolverAddress, node);
                try {
                    const avatar = yield resolver.getAvatar();
                    if (avatar) return avatar.url;
                } catch (error) {
                    if (error.code !== (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.CALL_EXCEPTION) throw error;
                }
                // Try getting the name and performing forward lookup; allowing wildcards
                try {
                    // keccak("name(bytes32)")
                    const name = $6a1c8a35900dd937$var$_parseString((yield this.call({
                        to: resolverAddress,
                        data: "0x691f3431" + (0, $3715ffed660cd02c$export$91d651ee363e1209)(node).substring(2)
                    })), 0);
                    resolver = yield this.getResolver(name);
                } catch (error) {
                    if (error.code !== (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.CALL_EXCEPTION) throw error;
                    return null;
                }
            } else {
                // ENS name; forward lookup with wildcard
                resolver = yield this.getResolver(nameOrAddress);
                if (!resolver) return null;
            }
            const avatar = yield resolver.getAvatar();
            if (avatar == null) return null;
            return avatar.url;
        });
    }
    perform(method, params) {
        return $6a1c8a35900dd937$var$logger.throwError(method + " not implemented", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.NOT_IMPLEMENTED, {
            operation: method
        });
    }
    _startEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _stopEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _addEventListener(eventName, listener, once) {
        const event = new $6a1c8a35900dd937$export$d61e24a684f9e51($6a1c8a35900dd937$var$getEventTag(eventName), listener, once);
        this._events.push(event);
        this._startEvent(event);
        return this;
    }
    on(eventName, listener) {
        return this._addEventListener(eventName, listener, false);
    }
    once(eventName, listener) {
        return this._addEventListener(eventName, listener, true);
    }
    emit(eventName, ...args) {
        let result = false;
        let stopped = [];
        let eventTag = $6a1c8a35900dd937$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag) return true;
            setTimeout(()=>{
                event.listener.apply(this, args);
            }, 0);
            result = true;
            if (event.once) {
                stopped.push(event);
                return false;
            }
            return true;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return result;
    }
    listenerCount(eventName) {
        if (!eventName) return this._events.length;
        let eventTag = $6a1c8a35900dd937$var$getEventTag(eventName);
        return this._events.filter((event)=>{
            return event.tag === eventTag;
        }).length;
    }
    listeners(eventName) {
        if (eventName == null) return this._events.map((event)=>event.listener);
        let eventTag = $6a1c8a35900dd937$var$getEventTag(eventName);
        return this._events.filter((event)=>event.tag === eventTag).map((event)=>event.listener);
    }
    off(eventName, listener) {
        if (listener == null) return this.removeAllListeners(eventName);
        const stopped = [];
        let found = false;
        let eventTag = $6a1c8a35900dd937$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag || event.listener != listener) return true;
            if (found) return true;
            found = true;
            stopped.push(event);
            return false;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
    removeAllListeners(eventName) {
        let stopped = [];
        if (eventName == null) {
            stopped = this._events;
            this._events = [];
        } else {
            const eventTag = $6a1c8a35900dd937$var$getEventTag(eventName);
            this._events = this._events.filter((event)=>{
                if (event.tag !== eventTag) return true;
                stopped.push(event);
                return false;
            });
        }
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
    /**
     *  ready
     *
     *  A Promise<Network> that resolves only once the provider is ready.
     *
     *  Sub-classes that call the super with a network without a chainId
     *  MUST set this. Standard named networks have a known chainId.
     *
     */ constructor(network){
        super();
        // Events being listened to
        this._events = [];
        this._emitted = {
            block: -2
        };
        this.disableCcipRead = false;
        this.formatter = new.target.getFormatter();
        // If network is any, this Provider allows the underlying
        // network to change dynamically, and we auto-detect the
        // current network
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "anyNetwork", network === "any");
        if (this.anyNetwork) network = this.detectNetwork();
        if (network instanceof Promise) {
            this._networkPromise = network;
            // Squash any "unhandled promise" errors; that do not need to be handled
            network.catch((error)=>{});
            // Trigger initial network setting (async)
            this._ready().catch((error)=>{});
        } else {
            const knownNetwork = (0, $19462b55124983f4$exports.getStatic)(new.target, "getNetwork")(network);
            if (knownNetwork) {
                (0, $19462b55124983f4$exports.defineReadOnly)(this, "_network", knownNetwork);
                this.emit("network", knownNetwork, null);
            } else $6a1c8a35900dd937$var$logger.throwArgumentError("invalid network", "network", network);
        }
        this._maxInternalBlockNumber = -1024;
        this._lastBlockNumber = -2;
        this._maxFilterBlockRange = 10;
        this._pollingInterval = 4000;
        this._fastQueryDate = 0;
    }
}




var $9eaaf2b70511b007$exports = {};

$parcel$export($9eaaf2b70511b007$exports, "WebSocketProvider", function () { return $9eaaf2b70511b007$export$bfafe629242f30bd; });


var $7bf56bd7b17e0046$exports = {};

$parcel$export($7bf56bd7b17e0046$exports, "JsonRpcSigner", function () { return $7bf56bd7b17e0046$export$5f7b5fca3508545a; });
$parcel$export($7bf56bd7b17e0046$exports, "JsonRpcProvider", function () { return $7bf56bd7b17e0046$export$da28308012bf6748; });



var $eb73d9441da70c0d$exports = {};

$parcel$export($eb73d9441da70c0d$exports, "TypedDataEncoder", function () { return $eb73d9441da70c0d$export$458ab927ae635c3; });








var $eb73d9441da70c0d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $eb73d9441da70c0d$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $e531ee7873f6488e$export$83d89fbfd8236492));
const $eb73d9441da70c0d$var$padding = new Uint8Array(32);
$eb73d9441da70c0d$var$padding.fill(0);
const $eb73d9441da70c0d$var$NegativeOne = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(-1);
const $eb73d9441da70c0d$var$Zero = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(0);
const $eb73d9441da70c0d$var$One = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(1);
const $eb73d9441da70c0d$var$MaxUint256 = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $eb73d9441da70c0d$var$hexPadRight(value) {
    const bytes = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $ddc3d9704a40b613$export$6d4b99629b38754a)([
        bytes,
        $eb73d9441da70c0d$var$padding.slice(padOffset)
    ]);
    return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(bytes);
}
const $eb73d9441da70c0d$var$hexTrue = (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)($eb73d9441da70c0d$var$One.toHexString(), 32);
const $eb73d9441da70c0d$var$hexFalse = (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)($eb73d9441da70c0d$var$Zero.toHexString(), 32);
const $eb73d9441da70c0d$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $eb73d9441da70c0d$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $eb73d9441da70c0d$var$checkString(key) {
    return function(value) {
        if (typeof value !== "string") $eb73d9441da70c0d$var$logger.throwArgumentError(`invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $eb73d9441da70c0d$var$domainChecks = {
    name: $eb73d9441da70c0d$var$checkString("name"),
    version: $eb73d9441da70c0d$var$checkString("version"),
    chainId: function(value) {
        try {
            return (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(value).toString();
        } catch (error) {}
        return $eb73d9441da70c0d$var$logger.throwArgumentError(`invalid domain value for "chainId"`, "domain.chainId", value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $a4b82b374f356b4b$export$88411125f012957a)(value).toLowerCase();
        } catch (error) {}
        return $eb73d9441da70c0d$var$logger.throwArgumentError(`invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        try {
            const bytes = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(value);
            if (bytes.length !== 32) throw new Error("bad length");
            return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(bytes);
        } catch (error) {}
        return $eb73d9441da70c0d$var$logger.throwArgumentError(`invalid domain value "salt"`, "domain.salt", value);
    }
};
function $eb73d9441da70c0d$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d*)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2] || "256");
            if (width % 8 !== 0 || width > 256 || match[2] && match[2] !== String(width)) $eb73d9441da70c0d$var$logger.throwArgumentError("invalid numeric width", "type", type);
            const boundsUpper = $eb73d9441da70c0d$var$MaxUint256.mask(signed ? width - 1 : width);
            const boundsLower = signed ? boundsUpper.add($eb73d9441da70c0d$var$One).mul($eb73d9441da70c0d$var$NegativeOne) : $eb73d9441da70c0d$var$Zero;
            return function(value) {
                const v = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(value);
                if (v.lt(boundsLower) || v.gt(boundsUpper)) $eb73d9441da70c0d$var$logger.throwArgumentError(`value out-of-bounds for ${type}`, "value", value);
                return (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)(v.toTwos(256).toHexString(), 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            if (width === 0 || width > 32 || match[1] !== String(width)) $eb73d9441da70c0d$var$logger.throwArgumentError("invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(value);
                if (bytes.length !== width) $eb73d9441da70c0d$var$logger.throwArgumentError(`invalid length for ${type}`, "value", value);
                return $eb73d9441da70c0d$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)((0, $a4b82b374f356b4b$export$88411125f012957a)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $eb73d9441da70c0d$var$hexFalse : $eb73d9441da70c0d$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $344909d1f36347b2$export$f8151fce47ad1c35)(value);
            };
        case "string":
            return function(value) {
                return (0, $337ebfbf1ce1b46f$export$d560c7e4a29451c2)(value);
            };
    }
    return null;
}
function $eb73d9441da70c0d$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
class $eb73d9441da70c0d$export$458ab927ae635c3 {
    getEncoder(type) {
        let encoder = this._encoderCache[type];
        if (!encoder) encoder = this._encoderCache[type] = this._getEncoder(type);
        return encoder;
    }
    _getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $eb73d9441da70c0d$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const subEncoder = this.getEncoder(subtype);
            const length = parseInt(match[3]);
            return (value)=>{
                if (length >= 0 && value.length !== length) $eb73d9441da70c0d$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                let result = value.map(subEncoder);
                if (this._types[subtype]) result = result.map((0, $344909d1f36347b2$export$f8151fce47ad1c35));
                return (0, $344909d1f36347b2$export$f8151fce47ad1c35)((0, $ddc3d9704a40b613$export$6d4b99629b38754a)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $337ebfbf1ce1b46f$export$d560c7e4a29451c2)(this._types[type]);
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this._types[type]) return (0, $344909d1f36347b2$export$f8151fce47ad1c35)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $ddc3d9704a40b613$export$6d4b99629b38754a)(values);
            };
        }
        return $eb73d9441da70c0d$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    encodeType(name) {
        const result = this._types[name];
        if (!result) $eb73d9441da70c0d$var$logger.throwArgumentError(`unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    hashStruct(name, value) {
        return (0, $344909d1f36347b2$export$f8151fce47ad1c35)(this.encodeData(name, value));
    }
    encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $eb73d9441da70c0d$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const length = parseInt(match[3]);
            if (length >= 0 && value.length !== length) $eb73d9441da70c0d$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
            return value.map((v)=>this._visit(subtype, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        return $eb73d9441da70c0d$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    static from(types) {
        return new $eb73d9441da70c0d$export$458ab927ae635c3(types);
    }
    static getPrimaryType(types) {
        return $eb73d9441da70c0d$export$458ab927ae635c3.from(types).primaryType;
    }
    static hashStruct(name, types, value) {
        return $eb73d9441da70c0d$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            const type = $eb73d9441da70c0d$var$domainFieldTypes[name];
            if (!type) $eb73d9441da70c0d$var$logger.throwArgumentError(`invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $eb73d9441da70c0d$var$domainFieldNames.indexOf(a.name) - $eb73d9441da70c0d$var$domainFieldNames.indexOf(b.name);
        });
        return $eb73d9441da70c0d$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    static encode(domain, types, value) {
        return (0, $ddc3d9704a40b613$export$6d4b99629b38754a)([
            "0x1901",
            $eb73d9441da70c0d$export$458ab927ae635c3.hashDomain(domain),
            $eb73d9441da70c0d$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    static hash(domain, types, value) {
        return (0, $344909d1f36347b2$export$f8151fce47ad1c35)($eb73d9441da70c0d$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    static resolveNames(domain, types, value, resolveName) {
        return $eb73d9441da70c0d$var$__awaiter(this, void 0, void 0, function*() {
            // Make a copy to isolate it from the object passed in
            domain = (0, $19462b55124983f4$exports.shallowCopy)(domain);
            // Look up all ENS names
            const ensCache = {};
            // Do we need to look up the domain's verifyingContract?
            if (domain.verifyingContract && !(0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
            // We are going to use the encoder to visit all the base values
            const encoder = $eb73d9441da70c0d$export$458ab927ae635c3.from(types);
            // Get a list of all the addresses
            encoder.visit(value, (type, value)=>{
                if (type === "address" && !(0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(value, 20)) ensCache[value] = "0x";
                return value;
            });
            // Lookup each name
            for(const name in ensCache)ensCache[name] = yield resolveName(name);
            // Replace the domain verifyingContract if needed
            if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
            // Replace all ENS names with their address
            value = encoder.visit(value, (type, value)=>{
                if (type === "address" && ensCache[value]) return ensCache[value];
                return value;
            });
            return {
                domain: domain,
                value: value
            };
        });
    }
    static getPayload(domain, types, value) {
        // Validate the domain fields
        $eb73d9441da70c0d$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $eb73d9441da70c0d$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $eb73d9441da70c0d$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $eb73d9441da70c0d$var$domainFieldTypes[name]
            });
        });
        const encoder = $eb73d9441da70c0d$export$458ab927ae635c3.from(types);
        const typesWithDomain = (0, $19462b55124983f4$exports.shallowCopy)(types);
        if (typesWithDomain.EIP712Domain) $eb73d9441da70c0d$var$logger.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", types);
        else typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        if (typeof value !== "string") $eb73d9441da70c0d$var$logger.throwArgumentError(`invalid string`, "value", value);
                        return value;
                }
                return $eb73d9441da70c0d$var$logger.throwArgumentError("unsupported type", "type", type);
            })
        };
    }
    constructor(types){
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "types", Object.freeze((0, $19462b55124983f4$exports.deepCopy)(types)));
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "_encoderCache", {});
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "_types", {});
        // Link struct types to their direct child structs
        const links = {};
        // Link structs to structs which contain them as a child
        const parents = {};
        // Link all subtypes within a given struct
        const subtypes = {};
        Object.keys(types).forEach((type)=>{
            links[type] = {};
            parents[type] = [];
            subtypes[type] = {};
        });
        for(const name in types){
            const uniqueNames = {};
            types[name].forEach((field)=>{
                // Check each field has a unique name
                if (uniqueNames[field.name]) $eb73d9441da70c0d$var$logger.throwArgumentError(`duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", types);
                uniqueNames[field.name] = true;
                // Get the base type (drop any array specifiers)
                const baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
                if (baseType === name) $eb73d9441da70c0d$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(baseType)}`, "types", types);
                // Is this a base encoding type?
                const encoder = $eb73d9441da70c0d$var$getBaseEncoder(baseType);
                if (encoder) return;
                if (!parents[baseType]) $eb73d9441da70c0d$var$logger.throwArgumentError(`unknown type ${JSON.stringify(baseType)}`, "types", types);
                // Add linkage
                parents[baseType].push(name);
                links[name][baseType] = true;
            });
        }
        // Deduce the primary type
        const primaryTypes = Object.keys(parents).filter((n)=>parents[n].length === 0);
        if (primaryTypes.length === 0) $eb73d9441da70c0d$var$logger.throwArgumentError("missing primary type", "types", types);
        else if (primaryTypes.length > 1) $eb73d9441da70c0d$var$logger.throwArgumentError(`ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", types);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "primaryType", primaryTypes[0]);
        // Check for circular type references
        function checkCircular(type, found) {
            if (found[type]) $eb73d9441da70c0d$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(type)}`, "types", types);
            found[type] = true;
            Object.keys(links[type]).forEach((child)=>{
                if (!parents[child]) return;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                Object.keys(found).forEach((subtype)=>{
                    subtypes[subtype][child] = true;
                });
            });
            delete found[type];
        }
        checkCircular(this.primaryType, {});
        // Compute each fully describe type
        for(const name in subtypes){
            const st = Object.keys(subtypes[name]);
            st.sort();
            this._types[name] = $eb73d9441da70c0d$var$encodeType(name, types[name]) + st.map((t)=>$eb73d9441da70c0d$var$encodeType(t, types[t])).join("");
        }
    }
}









"use strict";
var $7bf56bd7b17e0046$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $7bf56bd7b17e0046$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d9347b79faa289ba$export$83d89fbfd8236492));
const $7bf56bd7b17e0046$var$errorGas = [
    "call",
    "estimateGas"
];
function $7bf56bd7b17e0046$var$spelunk(value, requireData) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match("reverted")) {
        const data = (0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(value.data) ? value.data : null;
        if (!requireData || data) return {
            message: value.message,
            data: data
        };
    }
    // Spelunk further...
    if (typeof value === "object") {
        for(const key in value){
            const result = $7bf56bd7b17e0046$var$spelunk(value[key], requireData);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $7bf56bd7b17e0046$var$spelunk(JSON.parse(value), requireData);
    } catch (error) {}
    return null;
}
function $7bf56bd7b17e0046$var$checkError(method, error, params) {
    const transaction = params.transaction || params.signedTransaction;
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call") {
        const result = $7bf56bd7b17e0046$var$spelunk(error, true);
        if (result) return result.data;
        // Nothing descriptive..
        $7bf56bd7b17e0046$var$logger.throwError("missing revert data in call exception; Transaction reverted without a reason string", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
            data: "0x",
            transaction: transaction,
            error: error
        });
    }
    if (method === "estimateGas") {
        // Try to find something, with a preference on SERVER_ERROR body
        let result = $7bf56bd7b17e0046$var$spelunk(error.body, false);
        if (result == null) result = $7bf56bd7b17e0046$var$spelunk(error, false);
        // Found "reverted", this is a CALL_EXCEPTION
        if (result) $7bf56bd7b17e0046$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
            reason: result.message,
            method: method,
            transaction: transaction,
            error: error
        });
    }
    // @TODO: Should we spelunk for message too?
    let message = error.message;
    if (error.code === (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR && error.error && typeof error.error.message === "string") message = error.error.message;
    else if (typeof error.body === "string") message = error.body;
    else if (typeof error.responseText === "string") message = error.responseText;
    message = (message || "").toLowerCase();
    // "insufficient funds for gas * price + value + cost(data)"
    if (message.match(/insufficient funds|base fee exceeds gas limit|InsufficientFunds/i)) $7bf56bd7b17e0046$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "nonce too low"
    if (message.match(/nonce (is )?too low/i)) $7bf56bd7b17e0046$var$logger.throwError("nonce has already been used", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/replacement transaction underpriced|transaction gas price.*too low/i)) $7bf56bd7b17e0046$var$logger.throwError("replacement fee too low", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/only replay-protected/i)) $7bf56bd7b17e0046$var$logger.throwError("legacy pre-eip-155 transactions not supported", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        error: error,
        method: method,
        transaction: transaction
    });
    if ($7bf56bd7b17e0046$var$errorGas.indexOf(method) >= 0 && message.match(/gas required exceeds allowance|always failing transaction|execution reverted|revert/)) $7bf56bd7b17e0046$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
function $7bf56bd7b17e0046$var$timer(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $7bf56bd7b17e0046$var$getResult(payload) {
    if (payload.error) {
        // @TODO: not any
        const error = new Error(payload.error.message);
        error.code = payload.error.code;
        error.data = payload.error.data;
        throw error;
    }
    return payload.result;
}
function $7bf56bd7b17e0046$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
const $7bf56bd7b17e0046$var$_constructorGuard = {};
class $7bf56bd7b17e0046$export$5f7b5fca3508545a extends (0, $d9b7eb644de5bd3c$exports.Signer) {
    connect(provider) {
        return $7bf56bd7b17e0046$var$logger.throwError("cannot alter JSON-RPC Signer connection", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "connect"
        });
    }
    connectUnchecked() {
        return new $7bf56bd7b17e0046$var$UncheckedJsonRpcSigner($7bf56bd7b17e0046$var$_constructorGuard, this.provider, this._address || this._index);
    }
    getAddress() {
        if (this._address) return Promise.resolve(this._address);
        return this.provider.send("eth_accounts", []).then((accounts)=>{
            if (accounts.length <= this._index) $7bf56bd7b17e0046$var$logger.throwError("unknown account #" + this._index, (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "getAddress"
            });
            return this.provider.formatter.address(accounts[this._index]);
        });
    }
    sendUncheckedTransaction(transaction) {
        transaction = (0, $19462b55124983f4$exports.shallowCopy)(transaction);
        const fromAddress = this.getAddress().then((address)=>{
            if (address) address = address.toLowerCase();
            return address;
        });
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (transaction.gasLimit == null) {
            const estimate = (0, $19462b55124983f4$exports.shallowCopy)(transaction);
            estimate.from = fromAddress;
            transaction.gasLimit = this.provider.estimateGas(estimate);
        }
        if (transaction.to != null) transaction.to = Promise.resolve(transaction.to).then((to)=>$7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function*() {
                if (to == null) return null;
                const address = yield this.provider.resolveName(to);
                if (address == null) $7bf56bd7b17e0046$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                return address;
            }));
        return (0, $19462b55124983f4$exports.resolveProperties)({
            tx: (0, $19462b55124983f4$exports.resolveProperties)(transaction),
            sender: fromAddress
        }).then(({ tx: tx, sender: sender })=>{
            if (tx.from != null) {
                if (tx.from.toLowerCase() !== sender) $7bf56bd7b17e0046$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            } else tx.from = sender;
            const hexTx = this.provider.constructor.hexlifyTransaction(tx, {
                from: true
            });
            return this.provider.send("eth_sendTransaction", [
                hexTx
            ]).then((hash)=>{
                return hash;
            }, (error)=>{
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $7bf56bd7b17e0046$var$logger.throwError("user rejected transaction", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                    action: "sendTransaction",
                    transaction: tx
                });
                return $7bf56bd7b17e0046$var$checkError("sendTransaction", error, hexTx);
            });
        });
    }
    signTransaction(transaction) {
        return $7bf56bd7b17e0046$var$logger.throwError("signing transactions is unsupported", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "signTransaction"
        });
    }
    sendTransaction(transaction) {
        return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function*() {
            // This cannot be mined any earlier than any recent block
            const blockNumber = yield this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval);
            // Send the transaction
            const hash = yield this.sendUncheckedTransaction(transaction);
            try {
                // Unfortunately, JSON-RPC only provides and opaque transaction hash
                // for a response, and we need the actual transaction, so we poll
                // for it; it should show up very quickly
                return yield (0, $bf63a14489d0132f$exports.poll)(()=>$7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function*() {
                        const tx = yield this.provider.getTransaction(hash);
                        if (tx === null) return undefined;
                        return this.provider._wrapTransaction(tx, hash, blockNumber);
                    }), {
                    oncePoll: this.provider
                });
            } catch (error) {
                error.transactionHash = hash;
                throw error;
            }
        });
    }
    signMessage(message) {
        return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $169c6c93221d2e48$export$8feeb310b4b4752f)(message) : message;
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("personal_sign", [
                    (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(data),
                    address.toLowerCase()
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $7bf56bd7b17e0046$var$logger.throwError("user rejected signing", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                    action: "signMessage",
                    from: address,
                    messageData: message
                });
                throw error;
            }
        });
    }
    _legacySignMessage(message) {
        return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $169c6c93221d2e48$export$8feeb310b4b4752f)(message) : message;
            const address = yield this.getAddress();
            try {
                // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
                return yield this.provider.send("eth_sign", [
                    address.toLowerCase(),
                    (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(data)
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $7bf56bd7b17e0046$var$logger.throwError("user rejected signing", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                    action: "_legacySignMessage",
                    from: address,
                    messageData: message
                });
                throw error;
            }
        });
    }
    _signTypedData(domain, types, value) {
        return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names (in-place)
            const populated = yield (0, $eb73d9441da70c0d$exports.TypedDataEncoder).resolveNames(domain, types, value, (name)=>{
                return this.provider.resolveName(name);
            });
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("eth_signTypedData_v4", [
                    address.toLowerCase(),
                    JSON.stringify((0, $eb73d9441da70c0d$exports.TypedDataEncoder).getPayload(populated.domain, types, populated.value))
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $7bf56bd7b17e0046$var$logger.throwError("user rejected signing", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                    action: "_signTypedData",
                    from: address,
                    messageData: {
                        domain: populated.domain,
                        types: types,
                        value: populated.value
                    }
                });
                throw error;
            }
        });
    }
    unlock(password) {
        return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function*() {
            const provider = this.provider;
            const address = yield this.getAddress();
            return provider.send("personal_unlockAccount", [
                address.toLowerCase(),
                password,
                null
            ]);
        });
    }
    constructor(constructorGuard, provider, addressOrIndex){
        super();
        if (constructorGuard !== $7bf56bd7b17e0046$var$_constructorGuard) throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "provider", provider);
        if (addressOrIndex == null) addressOrIndex = 0;
        if (typeof addressOrIndex === "string") {
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "_address", this.provider.formatter.address(addressOrIndex));
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "_index", null);
        } else if (typeof addressOrIndex === "number") {
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "_index", addressOrIndex);
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "_address", null);
        } else $7bf56bd7b17e0046$var$logger.throwArgumentError("invalid address or index", "addressOrIndex", addressOrIndex);
    }
}
class $7bf56bd7b17e0046$var$UncheckedJsonRpcSigner extends $7bf56bd7b17e0046$export$5f7b5fca3508545a {
    sendTransaction(transaction) {
        return this.sendUncheckedTransaction(transaction).then((hash)=>{
            return {
                hash: hash,
                nonce: null,
                gasLimit: null,
                gasPrice: null,
                data: null,
                value: null,
                chainId: null,
                confirmations: 0,
                from: null,
                wait: (confirmations)=>{
                    return this.provider.waitForTransaction(hash, confirmations);
                }
            };
        });
    }
}
const $7bf56bd7b17e0046$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true
};
class $7bf56bd7b17e0046$export$da28308012bf6748 extends (0, $6a1c8a35900dd937$exports.BaseProvider) {
    get _cache() {
        if (this._eventLoopCache == null) this._eventLoopCache = {};
        return this._eventLoopCache;
    }
    static defaultUrl() {
        return "http://localhost:8545";
    }
    detectNetwork() {
        if (!this._cache["detectNetwork"]) {
            this._cache["detectNetwork"] = this._uncachedDetectNetwork();
            // Clear this cache at the beginning of the next event loop
            setTimeout(()=>{
                this._cache["detectNetwork"] = null;
            }, 0);
        }
        return this._cache["detectNetwork"];
    }
    _uncachedDetectNetwork() {
        return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function*() {
            yield $7bf56bd7b17e0046$var$timer(0);
            let chainId = null;
            try {
                chainId = yield this.send("eth_chainId", []);
            } catch (error) {
                try {
                    chainId = yield this.send("net_version", []);
                } catch (error) {}
            }
            if (chainId != null) {
                const getNetwork = (0, $19462b55124983f4$exports.getStatic)(this.constructor, "getNetwork");
                try {
                    return getNetwork((0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(chainId).toNumber());
                } catch (error) {
                    return $7bf56bd7b17e0046$var$logger.throwError("could not detect network", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                        chainId: chainId,
                        event: "invalidNetwork",
                        serverError: error
                    });
                }
            }
            return $7bf56bd7b17e0046$var$logger.throwError("could not detect network", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                event: "noNetwork"
            });
        });
    }
    getSigner(addressOrIndex) {
        return new $7bf56bd7b17e0046$export$5f7b5fca3508545a($7bf56bd7b17e0046$var$_constructorGuard, this, addressOrIndex);
    }
    getUncheckedSigner(addressOrIndex) {
        return this.getSigner(addressOrIndex).connectUnchecked();
    }
    listAccounts() {
        return this.send("eth_accounts", []).then((accounts)=>{
            return accounts.map((a)=>this.formatter.address(a));
        });
    }
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        this.emit("debug", {
            action: "request",
            request: (0, $19462b55124983f4$exports.deepCopy)(request),
            provider: this
        });
        // We can expand this in the future to any call, but for now these
        // are the biggest wins and do not require any serializing parameters.
        const cache = [
            "eth_chainId",
            "eth_blockNumber"
        ].indexOf(method) >= 0;
        if (cache && this._cache[method]) return this._cache[method];
        const result = (0, $bf63a14489d0132f$exports.fetchJson)(this.connection, JSON.stringify(request), $7bf56bd7b17e0046$var$getResult).then((result)=>{
            this.emit("debug", {
                action: "response",
                request: request,
                response: result,
                provider: this
            });
            return result;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                error: error,
                request: request,
                provider: this
            });
            throw error;
        });
        // Cache the fetch, but clear it on the next event loop
        if (cache) {
            this._cache[method] = result;
            setTimeout(()=>{
                this._cache[method] = null;
            }, 0);
        }
        return result;
    }
    prepareRequest(method, params) {
        switch(method){
            case "getBlockNumber":
                return [
                    "eth_blockNumber",
                    []
                ];
            case "getGasPrice":
                return [
                    "eth_gasPrice",
                    []
                ];
            case "getBalance":
                return [
                    "eth_getBalance",
                    [
                        $7bf56bd7b17e0046$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getTransactionCount":
                return [
                    "eth_getTransactionCount",
                    [
                        $7bf56bd7b17e0046$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getCode":
                return [
                    "eth_getCode",
                    [
                        $7bf56bd7b17e0046$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getStorageAt":
                return [
                    "eth_getStorageAt",
                    [
                        $7bf56bd7b17e0046$var$getLowerCase(params.address),
                        (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)(params.position, 32),
                        params.blockTag
                    ]
                ];
            case "sendTransaction":
                return [
                    "eth_sendRawTransaction",
                    [
                        params.signedTransaction
                    ]
                ];
            case "getBlock":
                if (params.blockTag) return [
                    "eth_getBlockByNumber",
                    [
                        params.blockTag,
                        !!params.includeTransactions
                    ]
                ];
                else if (params.blockHash) return [
                    "eth_getBlockByHash",
                    [
                        params.blockHash,
                        !!params.includeTransactions
                    ]
                ];
                return null;
            case "getTransaction":
                return [
                    "eth_getTransactionByHash",
                    [
                        params.transactionHash
                    ]
                ];
            case "getTransactionReceipt":
                return [
                    "eth_getTransactionReceipt",
                    [
                        params.transactionHash
                    ]
                ];
            case "call":
                {
                    const hexlifyTransaction = (0, $19462b55124983f4$exports.getStatic)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_call",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            }),
                            params.blockTag
                        ]
                    ];
                }
            case "estimateGas":
                {
                    const hexlifyTransaction = (0, $19462b55124983f4$exports.getStatic)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_estimateGas",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            })
                        ]
                    ];
                }
            case "getLogs":
                if (params.filter && params.filter.address != null) params.filter.address = $7bf56bd7b17e0046$var$getLowerCase(params.filter.address);
                return [
                    "eth_getLogs",
                    [
                        params.filter
                    ]
                ];
            default:
                break;
        }
        return null;
    }
    perform(method, params) {
        return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function*() {
            // Legacy networks do not like the type field being passed along (which
            // is fair), so we delete type if it is 0 and a non-EIP-1559 network
            if (method === "call" || method === "estimateGas") {
                const tx = params.transaction;
                if (tx && tx.type != null && (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(tx.type).isZero()) // If there are no EIP-1559 properties, it might be non-EIP-1559
                {
                    if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                        const feeData = yield this.getFeeData();
                        if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) {
                            // Network doesn't know about EIP-1559 (and hence type)
                            params = (0, $19462b55124983f4$exports.shallowCopy)(params);
                            params.transaction = (0, $19462b55124983f4$exports.shallowCopy)(tx);
                            delete params.transaction.type;
                        }
                    }
                }
            }
            const args = this.prepareRequest(method, params);
            if (args == null) $7bf56bd7b17e0046$var$logger.throwError(method + " not implemented", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.NOT_IMPLEMENTED, {
                operation: method
            });
            try {
                return yield this.send(args[0], args[1]);
            } catch (error) {
                return $7bf56bd7b17e0046$var$checkError(method, error, params);
            }
        });
    }
    _startEvent(event) {
        if (event.tag === "pending") this._startPending();
        super._startEvent(event);
    }
    _startPending() {
        if (this._pendingFilter != null) return;
        const self = this;
        const pendingFilter = this.send("eth_newPendingTransactionFilter", []);
        this._pendingFilter = pendingFilter;
        pendingFilter.then(function(filterId) {
            function poll() {
                self.send("eth_getFilterChanges", [
                    filterId
                ]).then(function(hashes) {
                    if (self._pendingFilter != pendingFilter) return null;
                    let seq = Promise.resolve();
                    hashes.forEach(function(hash) {
                        // @TODO: This should be garbage collected at some point... How? When?
                        self._emitted["t:" + hash.toLowerCase()] = "pending";
                        seq = seq.then(function() {
                            return self.getTransaction(hash).then(function(tx) {
                                self.emit("pending", tx);
                                return null;
                            });
                        });
                    });
                    return seq.then(function() {
                        return $7bf56bd7b17e0046$var$timer(1000);
                    });
                }).then(function() {
                    if (self._pendingFilter != pendingFilter) {
                        self.send("eth_uninstallFilter", [
                            filterId
                        ]);
                        return;
                    }
                    setTimeout(function() {
                        poll();
                    }, 0);
                    return null;
                }).catch((error)=>{});
            }
            poll();
            return filterId;
        }).catch((error)=>{});
    }
    _stopEvent(event) {
        if (event.tag === "pending" && this.listenerCount("pending") === 0) this._pendingFilter = null;
        super._stopEvent(event);
    }
    // Convert an ethers.js transaction into a JSON-RPC transaction
    //  - gasLimit => gas
    //  - All values hexlified
    //  - All numeric values zero-striped
    //  - All addresses are lowercased
    // NOTE: This allows a TransactionRequest, but all values should be resolved
    //       before this is called
    // @TODO: This will likely be removed in future versions and prepareRequest
    //        will be the preferred method for this.
    static hexlifyTransaction(transaction, allowExtra) {
        // Check only allowed properties are given
        const allowed = (0, $19462b55124983f4$exports.shallowCopy)($7bf56bd7b17e0046$var$allowedTransactionKeys);
        if (allowExtra) {
            for(const key in allowExtra)if (allowExtra[key]) allowed[key] = true;
        }
        (0, $19462b55124983f4$exports.checkProperties)(transaction, allowed);
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        [
            "chainId",
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            const value = (0, $ddc3d9704a40b613$export$6916af760a341dd3)((0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(transaction[key]));
            if (key === "gasLimit") key = "gas";
            result[key] = value;
        });
        [
            "from",
            "to",
            "data"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            result[key] = (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(transaction[key]);
        });
        if (transaction.accessList) result["accessList"] = (0, $cd7e99036b8e7d03$export$6c8662b1600dce2)(transaction.accessList);
        return result;
    }
    constructor(url, network){
        let networkOrReady = network;
        // The network is unknown, query the JSON-RPC for it
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then((network)=>{
                    resolve(network);
                }, (error)=>{
                    reject(error);
                });
            }, 0);
        });
        super(networkOrReady);
        // Default URL
        if (!url) url = (0, $19462b55124983f4$exports.getStatic)(this.constructor, "defaultUrl")();
        if (typeof url === "string") (0, $19462b55124983f4$exports.defineReadOnly)(this, "connection", Object.freeze({
            url: url
        }));
        else (0, $19462b55124983f4$exports.defineReadOnly)(this, "connection", Object.freeze((0, $19462b55124983f4$exports.shallowCopy)(url)));
        this._nextId = 42;
    }
}




"use strict";
let $c9925991f78188b7$export$3909fb301d3dc8c9 = null;
try {
    $c9925991f78188b7$export$3909fb301d3dc8c9 = WebSocket;
    if ($c9925991f78188b7$export$3909fb301d3dc8c9 == null) throw new Error("inject please");
} catch (error) {
    const logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d9347b79faa289ba$export$83d89fbfd8236492));
    $c9925991f78188b7$export$3909fb301d3dc8c9 = function() {
        logger.throwError("WebSockets not supported in this environment", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new WebSocket()"
        });
    };
}




"use strict";
var $9eaaf2b70511b007$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $9eaaf2b70511b007$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d9347b79faa289ba$export$83d89fbfd8236492));
/**
 *  Notes:
 *
 *  This provider differs a bit from the polling providers. One main
 *  difference is how it handles consistency. The polling providers
 *  will stall responses to ensure a consistent state, while this
 *  WebSocket provider assumes the connected backend will manage this.
 *
 *  For example, if a polling provider emits an event which indicates
 *  the event occurred in blockhash XXX, a call to fetch that block by
 *  its hash XXX, if not present will retry until it is present. This
 *  can occur when querying a pool of nodes that are mildly out of sync
 *  with each other.
 */ let $9eaaf2b70511b007$var$NextId = 1;
class $9eaaf2b70511b007$export$bfafe629242f30bd extends (0, $7bf56bd7b17e0046$exports.JsonRpcProvider) {
    // Cannot narrow the type of _websocket, as that is not backwards compatible
    // so we add a getter and let the WebSocket be a public API.
    get websocket() {
        return this._websocket;
    }
    detectNetwork() {
        return this._detectNetwork;
    }
    get pollingInterval() {
        return 0;
    }
    resetEventsBlock(blockNumber) {
        $9eaaf2b70511b007$var$logger.throwError("cannot reset events block on WebSocketProvider", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "resetEventBlock"
        });
    }
    set pollingInterval(value) {
        $9eaaf2b70511b007$var$logger.throwError("cannot set polling interval on WebSocketProvider", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "setPollingInterval"
        });
    }
    poll() {
        return $9eaaf2b70511b007$var$__awaiter(this, void 0, void 0, function*() {
            return null;
        });
    }
    set polling(value) {
        if (!value) return;
        $9eaaf2b70511b007$var$logger.throwError("cannot set polling on WebSocketProvider", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "setPolling"
        });
    }
    send(method, params) {
        const rid = $9eaaf2b70511b007$var$NextId++;
        return new Promise((resolve, reject)=>{
            function callback(error, result) {
                if (error) return reject(error);
                return resolve(result);
            }
            const payload = JSON.stringify({
                method: method,
                params: params,
                id: rid,
                jsonrpc: "2.0"
            });
            this.emit("debug", {
                action: "request",
                request: JSON.parse(payload),
                provider: this
            });
            this._requests[String(rid)] = {
                callback: callback,
                payload: payload
            };
            if (this._wsReady) this.websocket.send(payload);
        });
    }
    static defaultUrl() {
        return "ws://localhost:8546";
    }
    _subscribe(tag, param, processFunc) {
        return $9eaaf2b70511b007$var$__awaiter(this, void 0, void 0, function*() {
            let subIdPromise = this._subIds[tag];
            if (subIdPromise == null) {
                subIdPromise = Promise.all(param).then((param)=>{
                    return this.send("eth_subscribe", param);
                });
                this._subIds[tag] = subIdPromise;
            }
            const subId = yield subIdPromise;
            this._subs[subId] = {
                tag: tag,
                processFunc: processFunc
            };
        });
    }
    _startEvent(event) {
        switch(event.type){
            case "block":
                this._subscribe("block", [
                    "newHeads"
                ], (result)=>{
                    const blockNumber = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(result.number).toNumber();
                    this._emitted.block = blockNumber;
                    this.emit("block", blockNumber);
                });
                break;
            case "pending":
                this._subscribe("pending", [
                    "newPendingTransactions"
                ], (result)=>{
                    this.emit("pending", result);
                });
                break;
            case "filter":
                this._subscribe(event.tag, [
                    "logs",
                    this._getFilter(event.filter)
                ], (result)=>{
                    if (result.removed == null) result.removed = false;
                    this.emit(event.filter, this.formatter.filterLog(result));
                });
                break;
            case "tx":
                {
                    const emitReceipt = (event)=>{
                        const hash = event.hash;
                        this.getTransactionReceipt(hash).then((receipt)=>{
                            if (!receipt) return;
                            this.emit(hash, receipt);
                        });
                    };
                    // In case it is already mined
                    emitReceipt(event);
                    // To keep things simple, we start up a single newHeads subscription
                    // to keep an eye out for transactions we are watching for.
                    // Starting a subscription for an event (i.e. "tx") that is already
                    // running is (basically) a nop.
                    this._subscribe("tx", [
                        "newHeads"
                    ], (result)=>{
                        this._events.filter((e)=>e.type === "tx").forEach(emitReceipt);
                    });
                    break;
                }
            // Nothing is needed
            case "debug":
            case "poll":
            case "willPoll":
            case "didPoll":
            case "error":
                break;
            default:
                console.log("unhandled:", event);
                break;
        }
    }
    _stopEvent(event) {
        let tag = event.tag;
        if (event.type === "tx") {
            // There are remaining transaction event listeners
            if (this._events.filter((e)=>e.type === "tx").length) return;
            tag = "tx";
        } else if (this.listenerCount(event.event)) // There are remaining event listeners
        return;
        const subId = this._subIds[tag];
        if (!subId) return;
        delete this._subIds[tag];
        subId.then((subId)=>{
            if (!this._subs[subId]) return;
            delete this._subs[subId];
            this.send("eth_unsubscribe", [
                subId
            ]);
        });
    }
    destroy() {
        return $9eaaf2b70511b007$var$__awaiter(this, void 0, void 0, function*() {
            // Wait until we have connected before trying to disconnect
            if (this.websocket.readyState === (0, $c9925991f78188b7$export$3909fb301d3dc8c9).CONNECTING) yield new Promise((resolve)=>{
                this.websocket.onopen = function() {
                    resolve(true);
                };
                this.websocket.onerror = function() {
                    resolve(false);
                };
            });
            // Hangup
            // See: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes
            this.websocket.close(1000);
        });
    }
    constructor(url, network){
        // This will be added in the future; please open an issue to expedite
        if (network === "any") $9eaaf2b70511b007$var$logger.throwError("WebSocketProvider does not support 'any' network yet", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "network:any"
        });
        if (typeof url === "string") super(url, network);
        else super("_websocket", network);
        this._pollingInterval = -1;
        this._wsReady = false;
        if (typeof url === "string") (0, $19462b55124983f4$exports.defineReadOnly)(this, "_websocket", new (0, $c9925991f78188b7$export$3909fb301d3dc8c9)(this.connection.url));
        else (0, $19462b55124983f4$exports.defineReadOnly)(this, "_websocket", url);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "_requests", {});
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "_subs", {});
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "_subIds", {});
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "_detectNetwork", super.detectNetwork());
        // Stall sending requests until the socket is open...
        this.websocket.onopen = ()=>{
            this._wsReady = true;
            Object.keys(this._requests).forEach((id)=>{
                this.websocket.send(this._requests[id].payload);
            });
        };
        this.websocket.onmessage = (messageEvent)=>{
            const data = messageEvent.data;
            const result = JSON.parse(data);
            if (result.id != null) {
                const id = String(result.id);
                const request = this._requests[id];
                delete this._requests[id];
                if (result.result !== undefined) {
                    request.callback(null, result.result);
                    this.emit("debug", {
                        action: "response",
                        request: JSON.parse(request.payload),
                        response: result.result,
                        provider: this
                    });
                } else {
                    let error = null;
                    if (result.error) {
                        error = new Error(result.error.message || "unknown error");
                        (0, $19462b55124983f4$exports.defineReadOnly)(error, "code", result.error.code || null);
                        (0, $19462b55124983f4$exports.defineReadOnly)(error, "response", data);
                    } else error = new Error("unknown error");
                    request.callback(error, undefined);
                    this.emit("debug", {
                        action: "response",
                        error: error,
                        request: JSON.parse(request.payload),
                        provider: this
                    });
                }
            } else if (result.method === "eth_subscription") {
                // Subscription...
                const sub = this._subs[result.params.subscription];
                if (sub) //this.emit.apply(this,                  );
                sub.processFunc(result.params.result);
            } else console.warn("this should not happen");
        };
        // This Provider does not actually poll, but we want to trigger
        // poll events for things that depend on them (like stalling for
        // block and transaction lookups)
        const fauxPoll = setInterval(()=>{
            this.emit("poll");
        }, 1000);
        if (fauxPoll.unref) fauxPoll.unref();
    }
}




var $e630fe5b56031581$exports = {};

$parcel$export($e630fe5b56031581$exports, "StaticJsonRpcProvider", function () { return $e630fe5b56031581$export$b3d647c1c29df44d; });
$parcel$export($e630fe5b56031581$exports, "UrlJsonRpcProvider", function () { return $e630fe5b56031581$export$664128d6239ccf96; });




"use strict";
var $e630fe5b56031581$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $e630fe5b56031581$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d9347b79faa289ba$export$83d89fbfd8236492));
class $e630fe5b56031581$export$b3d647c1c29df44d extends (0, $7bf56bd7b17e0046$exports.JsonRpcProvider) {
    detectNetwork() {
        const _super = Object.create(null, {
            detectNetwork: {
                get: ()=>super.detectNetwork
            }
        });
        return $e630fe5b56031581$var$__awaiter(this, void 0, void 0, function*() {
            let network = this.network;
            if (network == null) {
                network = yield _super.detectNetwork.call(this);
                if (!network) $e630fe5b56031581$var$logger.throwError("no network detected", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {});
                // If still not set, set it
                if (this._network == null) {
                    // A static network does not support "any"
                    (0, $19462b55124983f4$exports.defineReadOnly)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return network;
        });
    }
}
class $e630fe5b56031581$export$664128d6239ccf96 extends $e630fe5b56031581$export$b3d647c1c29df44d {
    _startPending() {
        $e630fe5b56031581$var$logger.warn("WARNING: API provider does not support pending filters");
    }
    isCommunityResource() {
        return false;
    }
    getSigner(address) {
        return $e630fe5b56031581$var$logger.throwError("API provider does not support signing", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "getSigner"
        });
    }
    listAccounts() {
        return Promise.resolve([]);
    }
    // Return a defaultApiKey if null, otherwise validate the API key
    static getApiKey(apiKey) {
        return apiKey;
    }
    // Returns the url or connection for the given network and API key. The
    // API key will have been sanitized by the getApiKey first, so any validation
    // or transformations can be done there.
    static getUrl(network, apiKey) {
        return $e630fe5b56031581$var$logger.throwError("not implemented; sub-classes must override getUrl", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.NOT_IMPLEMENTED, {
            operation: "getUrl"
        });
    }
    constructor(network, apiKey){
        $e630fe5b56031581$var$logger.checkAbstract(new.target, $e630fe5b56031581$export$664128d6239ccf96);
        // Normalize the Network and API Key
        network = (0, $19462b55124983f4$exports.getStatic)(new.target, "getNetwork")(network);
        apiKey = (0, $19462b55124983f4$exports.getStatic)(new.target, "getApiKey")(apiKey);
        const connection = (0, $19462b55124983f4$exports.getStatic)(new.target, "getUrl")(network, apiKey);
        super(connection, network);
        if (typeof apiKey === "string") (0, $19462b55124983f4$exports.defineReadOnly)(this, "apiKey", apiKey);
        else if (apiKey != null) Object.keys(apiKey).forEach((key)=>{
            (0, $19462b55124983f4$exports.defineReadOnly)(this, key, apiKey[key]);
        });
    }
}


"use strict";
const $990dd48e125b1d3c$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d9347b79faa289ba$export$83d89fbfd8236492));
// This key was provided to ethers.js by Alchemy to be used by the
// default provider, but it is recommended that for your own
// production environments, that you acquire your own API key at:
//   https://dashboard.alchemyapi.io
const $990dd48e125b1d3c$var$defaultApiKey = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
class $990dd48e125b1d3c$export$f6c13301c7b76371 extends (0, $9eaaf2b70511b007$exports.WebSocketProvider) {
    isCommunityResource() {
        return this.apiKey === $990dd48e125b1d3c$var$defaultApiKey;
    }
    constructor(network, apiKey){
        const provider = new $990dd48e125b1d3c$export$999cc40da3fbc6f(network, apiKey);
        const url = provider.connection.url.replace(/^http/i, "ws").replace(".alchemyapi.", ".ws.alchemyapi.");
        super(url, provider.network);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "apiKey", provider.apiKey);
    }
}
class $990dd48e125b1d3c$export$999cc40da3fbc6f extends (0, $e630fe5b56031581$exports.UrlJsonRpcProvider) {
    static getWebSocketProvider(network, apiKey) {
        return new $990dd48e125b1d3c$export$f6c13301c7b76371(network, apiKey);
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $990dd48e125b1d3c$var$defaultApiKey;
        if (apiKey && typeof apiKey !== "string") $990dd48e125b1d3c$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "eth-mainnet.alchemyapi.io/v2/";
                break;
            case "goerli":
                host = "eth-goerli.g.alchemy.com/v2/";
                break;
            case "matic":
                host = "polygon-mainnet.g.alchemy.com/v2/";
                break;
            case "maticmum":
                host = "polygon-mumbai.g.alchemy.com/v2/";
                break;
            case "arbitrum":
                host = "arb-mainnet.g.alchemy.com/v2/";
                break;
            case "arbitrum-goerli":
                host = "arb-goerli.g.alchemy.com/v2/";
                break;
            case "optimism":
                host = "opt-mainnet.g.alchemy.com/v2/";
                break;
            case "optimism-goerli":
                host = "opt-goerli.g.alchemy.com/v2/";
                break;
            default:
                $990dd48e125b1d3c$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return {
            allowGzip: true,
            url: "https://" + host + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey === $990dd48e125b1d3c$var$defaultApiKey) (0, $af0c63f6ba6ab466$export$4c41bd49e82e82ab)();
                return Promise.resolve(true);
            }
        };
    }
    isCommunityResource() {
        return this.apiKey === $990dd48e125b1d3c$var$defaultApiKey;
    }
}






const $34f96cdeb0f3f720$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d9347b79faa289ba$export$83d89fbfd8236492));
const $34f96cdeb0f3f720$var$defaultApiKey = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
function $34f96cdeb0f3f720$var$getHost(name) {
    switch(name){
        case "homestead":
            return "rpc.ankr.com/eth/";
        case "ropsten":
            return "rpc.ankr.com/eth_ropsten/";
        case "rinkeby":
            return "rpc.ankr.com/eth_rinkeby/";
        case "goerli":
            return "rpc.ankr.com/eth_goerli/";
        case "matic":
            return "rpc.ankr.com/polygon/";
        case "arbitrum":
            return "rpc.ankr.com/arbitrum/";
    }
    return $34f96cdeb0f3f720$var$logger.throwArgumentError("unsupported network", "name", name);
}
class $34f96cdeb0f3f720$export$72783b2aefa72a45 extends (0, $e630fe5b56031581$exports.UrlJsonRpcProvider) {
    isCommunityResource() {
        return this.apiKey === $34f96cdeb0f3f720$var$defaultApiKey;
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $34f96cdeb0f3f720$var$defaultApiKey;
        return apiKey;
    }
    static getUrl(network, apiKey) {
        if (apiKey == null) apiKey = $34f96cdeb0f3f720$var$defaultApiKey;
        const connection = {
            allowGzip: true,
            url: "https://" + $34f96cdeb0f3f720$var$getHost(network.name) + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey.apiKey === $34f96cdeb0f3f720$var$defaultApiKey) (0, $af0c63f6ba6ab466$export$4c41bd49e82e82ab)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
}


var $93e46fc4025aa2f3$exports = {};

$parcel$export($93e46fc4025aa2f3$exports, "CloudflareProvider", function () { return $93e46fc4025aa2f3$export$7113381f8f264fc0; });



"use strict";
var $93e46fc4025aa2f3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $93e46fc4025aa2f3$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d9347b79faa289ba$export$83d89fbfd8236492));
class $93e46fc4025aa2f3$export$7113381f8f264fc0 extends (0, $e630fe5b56031581$exports.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        if (apiKey != null) $93e46fc4025aa2f3$var$logger.throwArgumentError("apiKey not supported for cloudflare", "apiKey", apiKey);
        return null;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://cloudflare-eth.com/";
                break;
            default:
                $93e46fc4025aa2f3$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host;
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $93e46fc4025aa2f3$var$__awaiter(this, void 0, void 0, function*() {
            // The Cloudflare provider does not support eth_blockNumber,
            // so we get the latest block and pull it from that
            if (method === "getBlockNumber") {
                const block = yield _super.perform.call(this, "getBlock", {
                    blockTag: "latest"
                });
                return block.number;
            }
            return _super.perform.call(this, method, params);
        });
    }
}


var $5f74b530f183cf41$exports = {};

$parcel$export($5f74b530f183cf41$exports, "EtherscanProvider", function () { return $5f74b530f183cf41$export$dd1d942a536c7912; });








"use strict";
var $5f74b530f183cf41$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $5f74b530f183cf41$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d9347b79faa289ba$export$83d89fbfd8236492));
// The transaction has already been sanitized by the calls in Provider
function $5f74b530f183cf41$var$getTransactionPostData(transaction) {
    const result = {};
    for(let key in transaction){
        if (transaction[key] == null) continue;
        let value = transaction[key];
        if (key === "type" && value === 0) continue;
        // Quantity-types require no leading zero, unless 0
        if (({
            type: true,
            gasLimit: true,
            gasPrice: true,
            maxFeePerGs: true,
            maxPriorityFeePerGas: true,
            nonce: true,
            value: true
        })[key]) value = (0, $ddc3d9704a40b613$export$6916af760a341dd3)((0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(value));
        else if (key === "accessList") value = "[" + (0, $cd7e99036b8e7d03$export$6c8662b1600dce2)(value).map((set)=>{
            return `{address:"${set.address}",storageKeys:["${set.storageKeys.join('","')}"]}`;
        }).join(",") + "]";
        else value = (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(value);
        result[key] = value;
    }
    return result;
}
function $5f74b530f183cf41$var$getResult(result) {
    // getLogs, getHistory have weird success responses
    if (result.status == 0 && (result.message === "No records found" || result.message === "No transactions found")) return result.result;
    if (result.status != 1 || typeof result.message !== "string" || !result.message.match(/^OK/)) {
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        if ((result.result || "").toLowerCase().indexOf("rate limit") >= 0) error.throttleRetry = true;
        throw error;
    }
    return result.result;
}
function $5f74b530f183cf41$var$getJsonResult(result) {
    // This response indicates we are being throttled
    if (result && result.status == 0 && result.message == "NOTOK" && (result.result || "").toLowerCase().indexOf("rate limit") >= 0) {
        const error = new Error("throttled response");
        error.result = JSON.stringify(result);
        error.throttleRetry = true;
        throw error;
    }
    if (result.jsonrpc != "2.0") {
        // @TODO: not any
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        throw error;
    }
    if (result.error) {
        // @TODO: not any
        const error = new Error(result.error.message || "unknown error");
        if (result.error.code) error.code = result.error.code;
        if (result.error.data) error.data = result.error.data;
        throw error;
    }
    return result.result;
}
// The blockTag was normalized as a string by the Provider pre-perform operations
function $5f74b530f183cf41$var$checkLogTag(blockTag) {
    if (blockTag === "pending") throw new Error("pending not supported");
    if (blockTag === "latest") return blockTag;
    return parseInt(blockTag.substring(2), 16);
}
function $5f74b530f183cf41$var$checkError(method, error, transaction) {
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call" && error.code === (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR) {
        const e = error.error;
        // Etherscan keeps changing their string
        if (e && (e.message.match(/reverted/i) || e.message.match(/VM execution error/i))) {
            // Etherscan prefixes the data like "Reverted 0x1234"
            let data = e.data;
            if (data) data = "0x" + data.replace(/^.*0x/i, "");
            if ((0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(data)) return data;
            $5f74b530f183cf41$var$logger.throwError("missing revert data in call exception", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                error: error,
                data: "0x"
            });
        }
    }
    // Get the message from any nested error structure
    let message = error.message;
    if (error.code === (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR) {
        if (error.error && typeof error.error.message === "string") message = error.error.message;
        else if (typeof error.body === "string") message = error.body;
        else if (typeof error.responseText === "string") message = error.responseText;
    }
    message = (message || "").toLowerCase();
    // "Insufficient funds. The account you tried to send transaction from does not have enough funds. Required 21464000000000 and got: 0"
    if (message.match(/insufficient funds/)) $5f74b530f183cf41$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction with the same hash was already imported."
    if (message.match(/same hash was already imported|transaction nonce is too low|nonce too low/)) $5f74b530f183cf41$var$logger.throwError("nonce has already been used", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction gas price is too low. There is another transaction with same nonce in the queue. Try increasing the gas price or incrementing the nonce."
    if (message.match(/another transaction with same nonce/)) $5f74b530f183cf41$var$logger.throwError("replacement fee too low", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    if (message.match(/execution failed due to an exception|execution reverted/)) $5f74b530f183cf41$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
class $5f74b530f183cf41$export$dd1d942a536c7912 extends (0, $6a1c8a35900dd937$exports.BaseProvider) {
    getBaseUrl() {
        switch(this.network ? this.network.name : "invalid"){
            case "homestead":
                return "https://api.etherscan.io";
            case "goerli":
                return "https://api-goerli.etherscan.io";
            case "sepolia":
                return "https://api-sepolia.etherscan.io";
            case "matic":
                return "https://api.polygonscan.com";
            case "maticmum":
                return "https://api-testnet.polygonscan.com";
            case "arbitrum":
                return "https://api.arbiscan.io";
            case "arbitrum-goerli":
                return "https://api-goerli.arbiscan.io";
            case "optimism":
                return "https://api-optimistic.etherscan.io";
            case "optimism-goerli":
                return "https://api-goerli-optimistic.etherscan.io";
            default:
        }
        return $5f74b530f183cf41$var$logger.throwArgumentError("unsupported network", "network", this.network.name);
    }
    getUrl(module, params) {
        const query = Object.keys(params).reduce((accum, key)=>{
            const value = params[key];
            if (value != null) accum += `&${key}=${value}`;
            return accum;
        }, "");
        const apiKey = this.apiKey ? `&apikey=${this.apiKey}` : "";
        return `${this.baseUrl}/api?module=${module}${query}${apiKey}`;
    }
    getPostUrl() {
        return `${this.baseUrl}/api`;
    }
    getPostData(module, params) {
        params.module = module;
        params.apikey = this.apiKey;
        return params;
    }
    fetch(module, params, post) {
        return $5f74b530f183cf41$var$__awaiter(this, void 0, void 0, function*() {
            const url = post ? this.getPostUrl() : this.getUrl(module, params);
            const payload = post ? this.getPostData(module, params) : null;
            const procFunc = module === "proxy" ? $5f74b530f183cf41$var$getJsonResult : $5f74b530f183cf41$var$getResult;
            this.emit("debug", {
                action: "request",
                request: url,
                provider: this
            });
            const connection = {
                url: url,
                throttleSlotInterval: 1000,
                throttleCallback: (attempt, url)=>{
                    if (this.isCommunityResource()) (0, $af0c63f6ba6ab466$export$4c41bd49e82e82ab)();
                    return Promise.resolve(true);
                }
            };
            let payloadStr = null;
            if (payload) {
                connection.headers = {
                    "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
                };
                payloadStr = Object.keys(payload).map((key)=>{
                    return `${key}=${payload[key]}`;
                }).join("&");
            }
            const result = yield (0, $bf63a14489d0132f$exports.fetchJson)(connection, payloadStr, procFunc || $5f74b530f183cf41$var$getJsonResult);
            this.emit("debug", {
                action: "response",
                request: url,
                response: (0, $19462b55124983f4$exports.deepCopy)(result),
                provider: this
            });
            return result;
        });
    }
    detectNetwork() {
        return $5f74b530f183cf41$var$__awaiter(this, void 0, void 0, function*() {
            return this.network;
        });
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $5f74b530f183cf41$var$__awaiter(this, void 0, void 0, function*() {
            switch(method){
                case "getBlockNumber":
                    return this.fetch("proxy", {
                        action: "eth_blockNumber"
                    });
                case "getGasPrice":
                    return this.fetch("proxy", {
                        action: "eth_gasPrice"
                    });
                case "getBalance":
                    // Returns base-10 result
                    return this.fetch("account", {
                        action: "balance",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getTransactionCount":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionCount",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getCode":
                    return this.fetch("proxy", {
                        action: "eth_getCode",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getStorageAt":
                    return this.fetch("proxy", {
                        action: "eth_getStorageAt",
                        address: params.address,
                        position: params.position,
                        tag: params.blockTag
                    });
                case "sendTransaction":
                    return this.fetch("proxy", {
                        action: "eth_sendRawTransaction",
                        hex: params.signedTransaction
                    }, true).catch((error)=>{
                        return $5f74b530f183cf41$var$checkError("sendTransaction", error, params.signedTransaction);
                    });
                case "getBlock":
                    if (params.blockTag) return this.fetch("proxy", {
                        action: "eth_getBlockByNumber",
                        tag: params.blockTag,
                        boolean: params.includeTransactions ? "true" : "false"
                    });
                    throw new Error("getBlock by blockHash not implemented");
                case "getTransaction":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionByHash",
                        txhash: params.transactionHash
                    });
                case "getTransactionReceipt":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionReceipt",
                        txhash: params.transactionHash
                    });
                case "call":
                    {
                        if (params.blockTag !== "latest") throw new Error("EtherscanProvider does not support blockTag for call");
                        const postData = $5f74b530f183cf41$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_call";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $5f74b530f183cf41$var$checkError("call", error, params.transaction);
                        }
                    }
                case "estimateGas":
                    {
                        const postData = $5f74b530f183cf41$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_estimateGas";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $5f74b530f183cf41$var$checkError("estimateGas", error, params.transaction);
                        }
                    }
                case "getLogs":
                    {
                        const args = {
                            action: "getLogs"
                        };
                        if (params.filter.fromBlock) args.fromBlock = $5f74b530f183cf41$var$checkLogTag(params.filter.fromBlock);
                        if (params.filter.toBlock) args.toBlock = $5f74b530f183cf41$var$checkLogTag(params.filter.toBlock);
                        if (params.filter.address) args.address = params.filter.address;
                        // @TODO: We can handle slightly more complicated logs using the logs API
                        if (params.filter.topics && params.filter.topics.length > 0) {
                            if (params.filter.topics.length > 1) $5f74b530f183cf41$var$logger.throwError("unsupported topic count", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                                topics: params.filter.topics
                            });
                            if (params.filter.topics.length === 1) {
                                const topic0 = params.filter.topics[0];
                                if (typeof topic0 !== "string" || topic0.length !== 66) $5f74b530f183cf41$var$logger.throwError("unsupported topic format", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                                    topic0: topic0
                                });
                                args.topic0 = topic0;
                            }
                        }
                        const logs = yield this.fetch("logs", args);
                        // Cache txHash => blockHash
                        let blocks = {};
                        // Add any missing blockHash to the logs
                        for(let i = 0; i < logs.length; i++){
                            const log = logs[i];
                            if (log.blockHash != null) continue;
                            if (blocks[log.blockNumber] == null) {
                                const block = yield this.getBlock(log.blockNumber);
                                if (block) blocks[log.blockNumber] = block.hash;
                            }
                            log.blockHash = blocks[log.blockNumber];
                        }
                        return logs;
                    }
                case "getEtherPrice":
                    if (this.network.name !== "homestead") return 0.0;
                    return parseFloat((yield this.fetch("stats", {
                        action: "ethprice"
                    })).ethusd);
                default:
                    break;
            }
            return _super.perform.call(this, method, params);
        });
    }
    // Note: The `page` page parameter only allows pagination within the
    //       10,000 window available without a page and offset parameter
    //       Error: Result window is too large, PageNo x Offset size must
    //              be less than or equal to 10000
    getHistory(addressOrName, startBlock, endBlock) {
        return $5f74b530f183cf41$var$__awaiter(this, void 0, void 0, function*() {
            const params = {
                action: "txlist",
                address: yield this.resolveName(addressOrName),
                startblock: startBlock == null ? 0 : startBlock,
                endblock: endBlock == null ? 99999999 : endBlock,
                sort: "asc"
            };
            const result = yield this.fetch("account", params);
            return result.map((tx)=>{
                [
                    "contractAddress",
                    "to"
                ].forEach(function(key) {
                    if (tx[key] == "") delete tx[key];
                });
                if (tx.creates == null && tx.contractAddress != null) tx.creates = tx.contractAddress;
                const item = this.formatter.transactionResponse(tx);
                if (tx.timeStamp) item.timestamp = parseInt(tx.timeStamp);
                return item;
            });
        });
    }
    isCommunityResource() {
        return this.apiKey == null;
    }
    constructor(network, apiKey){
        super(network);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "baseUrl", this.getBaseUrl());
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "apiKey", apiKey || null);
    }
}


var $c71cf52c680b1470$exports = {};

$parcel$export($c71cf52c680b1470$exports, "FallbackProvider", function () { return $c71cf52c680b1470$export$cb1d0beacb55feb7; });




"use strict";
function $3c41ee55241bf87e$export$e6c7296801b9b341(array) {
    array = array.slice();
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
    return array;
}







"use strict";
var $c71cf52c680b1470$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $c71cf52c680b1470$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d9347b79faa289ba$export$83d89fbfd8236492));
function $c71cf52c680b1470$var$now() {
    return new Date().getTime();
}
// Returns to network as long as all agree, or null if any is null.
// Throws an error if any two networks do not match.
function $c71cf52c680b1470$var$checkNetworks(networks) {
    let result = null;
    for(let i = 0; i < networks.length; i++){
        const network = networks[i];
        // Null! We do not know our network; bail.
        if (network == null) return null;
        if (result) // Make sure the network matches the previous networks
        {
            if (!(result.name === network.name && result.chainId === network.chainId && (result.ensAddress === network.ensAddress || result.ensAddress == null && network.ensAddress == null))) $c71cf52c680b1470$var$logger.throwArgumentError("provider mismatch", "networks", networks);
        } else result = network;
    }
    return result;
}
function $c71cf52c680b1470$var$median(values, maxDelta) {
    values = values.slice().sort();
    const middle = Math.floor(values.length / 2);
    // Odd length; take the middle
    if (values.length % 2) return values[middle];
    // Even length; take the average of the two middle
    const a = values[middle - 1], b = values[middle];
    if (maxDelta != null && Math.abs(a - b) > maxDelta) return null;
    return (a + b) / 2;
}
function $c71cf52c680b1470$var$serialize(value) {
    if (value === null) return "null";
    else if (typeof value === "number" || typeof value === "boolean") return JSON.stringify(value);
    else if (typeof value === "string") return value;
    else if ((0, $c37d64fad2cf3dce$export$d97aa349ed20696).isBigNumber(value)) return value.toString();
    else if (Array.isArray(value)) return JSON.stringify(value.map((i)=>$c71cf52c680b1470$var$serialize(i)));
    else if (typeof value === "object") {
        const keys = Object.keys(value);
        keys.sort();
        return "{" + keys.map((key)=>{
            let v = value[key];
            if (typeof v === "function") v = "[function]";
            else v = $c71cf52c680b1470$var$serialize(v);
            return JSON.stringify(key) + ":" + v;
        }).join(",") + "}";
    }
    throw new Error("unknown value type: " + typeof value);
}
// Next request ID to use for emitting debug info
let $c71cf52c680b1470$var$nextRid = 1;
function $c71cf52c680b1470$var$stall(duration) {
    let cancel = null;
    let timer = null;
    let promise = new Promise((resolve)=>{
        cancel = function() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            resolve();
        };
        timer = setTimeout(cancel, duration);
    });
    const wait = (func)=>{
        promise = promise.then(func);
        return promise;
    };
    function getPromise() {
        return promise;
    }
    return {
        cancel: cancel,
        getPromise: getPromise,
        wait: wait
    };
}
const $c71cf52c680b1470$var$ForwardErrors = [
    (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.CALL_EXCEPTION,
    (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS,
    (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.NONCE_EXPIRED,
    (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED,
    (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT
];
const $c71cf52c680b1470$var$ForwardProperties = [
    "address",
    "args",
    "errorArgs",
    "errorSignature",
    "method",
    "transaction"
];
function $c71cf52c680b1470$var$exposeDebugConfig(config, now) {
    const result = {
        weight: config.weight
    };
    Object.defineProperty(result, "provider", {
        get: ()=>config.provider
    });
    if (config.start) result.start = config.start;
    if (now) result.duration = now - config.start;
    if (config.done) {
        if (config.error) result.error = config.error;
        else result.result = config.result || null;
    }
    return result;
}
function $c71cf52c680b1470$var$normalizedTally(normalize, quorum) {
    return function(configs) {
        // Count the votes for each result
        const tally = {};
        configs.forEach((c)=>{
            const value = normalize(c.result);
            if (!tally[value]) tally[value] = {
                count: 0,
                result: c.result
            };
            tally[value].count++;
        });
        // Check for a quorum on any given result
        const keys = Object.keys(tally);
        for(let i = 0; i < keys.length; i++){
            const check = tally[keys[i]];
            if (check.count >= quorum) return check.result;
        }
        // No quroum
        return undefined;
    };
}
function $c71cf52c680b1470$var$getProcessFunc(provider, method, params) {
    let normalize = $c71cf52c680b1470$var$serialize;
    switch(method){
        case "getBlockNumber":
            // Return the median value, unless there is (median + 1) is also
            // present, in which case that is probably true and the median
            // is going to be stale soon. In the event of a malicious node,
            // the lie will be true soon enough.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                // Get the median block number
                let blockNumber = $c71cf52c680b1470$var$median(configs.map((c)=>c.result), 2);
                if (blockNumber == null) return undefined;
                blockNumber = Math.ceil(blockNumber);
                // If the next block height is present, its prolly safe to use
                if (values.indexOf(blockNumber + 1) >= 0) blockNumber++;
                // Don't ever roll back the blockNumber
                if (blockNumber >= provider._highestBlockNumber) provider._highestBlockNumber = blockNumber;
                return provider._highestBlockNumber;
            };
        case "getGasPrice":
            // Return the middle (round index up) value, similar to median
            // but do not average even entries and choose the higher.
            // Malicious actors must compromise 50% of the nodes to lie.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                values.sort();
                return values[Math.floor(values.length / 2)];
            };
        case "getEtherPrice":
            // Returns the median price. Malicious actors must compromise at
            // least 50% of the nodes to lie (in a meaningful way).
            return function(configs) {
                return $c71cf52c680b1470$var$median(configs.map((c)=>c.result));
            };
        // No additional normalizing required; serialize is enough
        case "getBalance":
        case "getTransactionCount":
        case "getCode":
        case "getStorageAt":
        case "call":
        case "estimateGas":
        case "getLogs":
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getTransaction":
        case "getTransactionReceipt":
            normalize = function(tx) {
                if (tx == null) return null;
                tx = (0, $19462b55124983f4$exports.shallowCopy)(tx);
                tx.confirmations = -1;
                return $c71cf52c680b1470$var$serialize(tx);
            };
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getBlock":
            // We drop the confirmations from transactions as it is approximate
            if (params.includeTransactions) normalize = function(block) {
                if (block == null) return null;
                block = (0, $19462b55124983f4$exports.shallowCopy)(block);
                block.transactions = block.transactions.map((tx)=>{
                    tx = (0, $19462b55124983f4$exports.shallowCopy)(tx);
                    tx.confirmations = -1;
                    return tx;
                });
                return $c71cf52c680b1470$var$serialize(block);
            };
            else normalize = function(block) {
                if (block == null) return null;
                return $c71cf52c680b1470$var$serialize(block);
            };
            break;
        default:
            throw new Error("unknown method: " + method);
    }
    // Return the result if and only if the expected quorum is
    // satisfied and agreed upon for the final result.
    return $c71cf52c680b1470$var$normalizedTally(normalize, provider.quorum);
}
// If we are doing a blockTag query, we need to make sure the backend is
// caught up to the FallbackProvider, before sending a request to it.
function $c71cf52c680b1470$var$waitForSync(config, blockNumber) {
    return $c71cf52c680b1470$var$__awaiter(this, void 0, void 0, function*() {
        const provider = config.provider;
        if (provider.blockNumber != null && provider.blockNumber >= blockNumber || blockNumber === -1) return provider;
        return (0, $bf63a14489d0132f$exports.poll)(()=>{
            return new Promise((resolve, reject)=>{
                setTimeout(function() {
                    // We are synced
                    if (provider.blockNumber >= blockNumber) return resolve(provider);
                    // We're done; just quit
                    if (config.cancelled) return resolve(null);
                    // Try again, next block
                    return resolve(undefined);
                }, 0);
            });
        }, {
            oncePoll: provider
        });
    });
}
function $c71cf52c680b1470$var$getRunner(config, currentBlockNumber, method, params) {
    return $c71cf52c680b1470$var$__awaiter(this, void 0, void 0, function*() {
        let provider = config.provider;
        switch(method){
            case "getBlockNumber":
            case "getGasPrice":
                return provider[method]();
            case "getEtherPrice":
                if (provider.getEtherPrice) return provider.getEtherPrice();
                break;
            case "getBalance":
            case "getTransactionCount":
            case "getCode":
                if (params.blockTag && (0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(params.blockTag)) provider = yield $c71cf52c680b1470$var$waitForSync(config, currentBlockNumber);
                return provider[method](params.address, params.blockTag || "latest");
            case "getStorageAt":
                if (params.blockTag && (0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(params.blockTag)) provider = yield $c71cf52c680b1470$var$waitForSync(config, currentBlockNumber);
                return provider.getStorageAt(params.address, params.position, params.blockTag || "latest");
            case "getBlock":
                if (params.blockTag && (0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(params.blockTag)) provider = yield $c71cf52c680b1470$var$waitForSync(config, currentBlockNumber);
                return provider[params.includeTransactions ? "getBlockWithTransactions" : "getBlock"](params.blockTag || params.blockHash);
            case "call":
            case "estimateGas":
                if (params.blockTag && (0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(params.blockTag)) provider = yield $c71cf52c680b1470$var$waitForSync(config, currentBlockNumber);
                if (method === "call" && params.blockTag) return provider[method](params.transaction, params.blockTag);
                return provider[method](params.transaction);
            case "getTransaction":
            case "getTransactionReceipt":
                return provider[method](params.transactionHash);
            case "getLogs":
                {
                    let filter = params.filter;
                    if (filter.fromBlock && (0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(filter.fromBlock) || filter.toBlock && (0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(filter.toBlock)) provider = yield $c71cf52c680b1470$var$waitForSync(config, currentBlockNumber);
                    return provider.getLogs(filter);
                }
        }
        return $c71cf52c680b1470$var$logger.throwError("unknown method error", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {
            method: method,
            params: params
        });
    });
}
class $c71cf52c680b1470$export$cb1d0beacb55feb7 extends (0, $6a1c8a35900dd937$exports.BaseProvider) {
    detectNetwork() {
        return $c71cf52c680b1470$var$__awaiter(this, void 0, void 0, function*() {
            const networks = yield Promise.all(this.providerConfigs.map((c)=>c.provider.getNetwork()));
            return $c71cf52c680b1470$var$checkNetworks(networks);
        });
    }
    perform(method, params) {
        return $c71cf52c680b1470$var$__awaiter(this, void 0, void 0, function*() {
            // Sending transactions is special; always broadcast it to all backends
            if (method === "sendTransaction") {
                const results = yield Promise.all(this.providerConfigs.map((c)=>{
                    return c.provider.sendTransaction(params.signedTransaction).then((result)=>{
                        return result.hash;
                    }, (error)=>{
                        return error;
                    });
                }));
                // Any success is good enough (other errors are likely "already seen" errors
                for(let i = 0; i < results.length; i++){
                    const result = results[i];
                    if (typeof result === "string") return result;
                }
                // They were all an error; pick the first error
                throw results[0];
            }
            // We need to make sure we are in sync with our backends, so we need
            // to know this before we can make a lot of calls
            if (this._highestBlockNumber === -1 && method !== "getBlockNumber") yield this.getBlockNumber();
            const processFunc = $c71cf52c680b1470$var$getProcessFunc(this, method, params);
            // Shuffle the providers and then sort them by their priority; we
            // shallowCopy them since we will store the result in them too
            const configs = (0, $3c41ee55241bf87e$export$e6c7296801b9b341)(this.providerConfigs.map((0, $19462b55124983f4$exports.shallowCopy)));
            configs.sort((a, b)=>a.priority - b.priority);
            const currentBlockNumber = this._highestBlockNumber;
            let i = 0;
            let first = true;
            while(true){
                const t0 = $c71cf52c680b1470$var$now();
                // Compute the inflight weight (exclude anything past)
                let inflightWeight = configs.filter((c)=>c.runner && t0 - c.start < c.stallTimeout).reduce((accum, c)=>accum + c.weight, 0);
                // Start running enough to meet quorum
                while(inflightWeight < this.quorum && i < configs.length){
                    const config = configs[i++];
                    const rid = $c71cf52c680b1470$var$nextRid++;
                    config.start = $c71cf52c680b1470$var$now();
                    config.staller = $c71cf52c680b1470$var$stall(config.stallTimeout);
                    config.staller.wait(()=>{
                        config.staller = null;
                    });
                    config.runner = $c71cf52c680b1470$var$getRunner(config, currentBlockNumber, method, params).then((result)=>{
                        config.done = true;
                        config.result = result;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $c71cf52c680b1470$var$exposeDebugConfig(config, $c71cf52c680b1470$var$now()),
                            request: {
                                method: method,
                                params: (0, $19462b55124983f4$exports.deepCopy)(params)
                            },
                            provider: this
                        });
                    }, (error)=>{
                        config.done = true;
                        config.error = error;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $c71cf52c680b1470$var$exposeDebugConfig(config, $c71cf52c680b1470$var$now()),
                            request: {
                                method: method,
                                params: (0, $19462b55124983f4$exports.deepCopy)(params)
                            },
                            provider: this
                        });
                    });
                    if (this.listenerCount("debug")) this.emit("debug", {
                        action: "request",
                        rid: rid,
                        backend: $c71cf52c680b1470$var$exposeDebugConfig(config, null),
                        request: {
                            method: method,
                            params: (0, $19462b55124983f4$exports.deepCopy)(params)
                        },
                        provider: this
                    });
                    inflightWeight += config.weight;
                }
                // Wait for anything meaningful to finish or stall out
                const waiting = [];
                configs.forEach((c)=>{
                    if (c.done || !c.runner) return;
                    waiting.push(c.runner);
                    if (c.staller) waiting.push(c.staller.getPromise());
                });
                if (waiting.length) yield Promise.race(waiting);
                // Check the quorum and process the results; the process function
                // may additionally decide the quorum is not met
                const results = configs.filter((c)=>c.done && c.error == null);
                if (results.length >= this.quorum) {
                    const result = processFunc(results);
                    if (result !== undefined) {
                        // Shut down any stallers
                        configs.forEach((c)=>{
                            if (c.staller) c.staller.cancel();
                            c.cancelled = true;
                        });
                        return result;
                    }
                    if (!first) yield $c71cf52c680b1470$var$stall(100).getPromise();
                    first = false;
                }
                // No result, check for errors that should be forwarded
                const errors = configs.reduce((accum, c)=>{
                    if (!c.done || c.error == null) return accum;
                    const code = c.error.code;
                    if ($c71cf52c680b1470$var$ForwardErrors.indexOf(code) >= 0) {
                        if (!accum[code]) accum[code] = {
                            error: c.error,
                            weight: 0
                        };
                        accum[code].weight += c.weight;
                    }
                    return accum;
                }, {});
                Object.keys(errors).forEach((errorCode)=>{
                    const tally = errors[errorCode];
                    if (tally.weight < this.quorum) return;
                    // Shut down any stallers
                    configs.forEach((c)=>{
                        if (c.staller) c.staller.cancel();
                        c.cancelled = true;
                    });
                    const e = tally.error;
                    const props = {};
                    $c71cf52c680b1470$var$ForwardProperties.forEach((name)=>{
                        if (e[name] == null) return;
                        props[name] = e[name];
                    });
                    $c71cf52c680b1470$var$logger.throwError(e.reason || e.message, errorCode, props);
                });
                // All configs have run to completion; we will never get more data
                if (configs.filter((c)=>!c.done).length === 0) break;
            }
            // Shut down any stallers; shouldn't be any
            configs.forEach((c)=>{
                if (c.staller) c.staller.cancel();
                c.cancelled = true;
            });
            return $c71cf52c680b1470$var$logger.throwError("failed to meet quorum", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.SERVER_ERROR, {
                method: method,
                params: params,
                //results: configs.map((c) => c.result),
                //errors: configs.map((c) => c.error),
                results: configs.map((c)=>$c71cf52c680b1470$var$exposeDebugConfig(c)),
                provider: this
            });
        });
    }
    constructor(providers, quorum){
        if (providers.length === 0) $c71cf52c680b1470$var$logger.throwArgumentError("missing providers", "providers", providers);
        const providerConfigs = providers.map((configOrProvider, index)=>{
            if ((0, $fd80fed41b6901ec$exports.Provider).isProvider(configOrProvider)) {
                const stallTimeout = (0, $af0c63f6ba6ab466$export$d93d5f61c2498b6)(configOrProvider) ? 2000 : 750;
                const priority = 1;
                return Object.freeze({
                    provider: configOrProvider,
                    weight: 1,
                    stallTimeout: stallTimeout,
                    priority: priority
                });
            }
            const config = (0, $19462b55124983f4$exports.shallowCopy)(configOrProvider);
            if (config.priority == null) config.priority = 1;
            if (config.stallTimeout == null) config.stallTimeout = (0, $af0c63f6ba6ab466$export$d93d5f61c2498b6)(configOrProvider) ? 2000 : 750;
            if (config.weight == null) config.weight = 1;
            const weight = config.weight;
            if (weight % 1 || weight > 512 || weight < 1) $c71cf52c680b1470$var$logger.throwArgumentError("invalid weight; must be integer in [1, 512]", `providers[${index}].weight`, weight);
            return Object.freeze(config);
        });
        const total = providerConfigs.reduce((accum, c)=>accum + c.weight, 0);
        if (quorum == null) quorum = total / 2;
        else if (quorum > total) $c71cf52c680b1470$var$logger.throwArgumentError("quorum will always fail; larger than total weight", "quorum", quorum);
        // Are all providers' networks are known
        let networkOrReady = $c71cf52c680b1470$var$checkNetworks(providerConfigs.map((c)=>c.provider.network));
        // Not all networks are known; we must stall
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then(resolve, reject);
            }, 0);
        });
        super(networkOrReady);
        // Preserve a copy, so we do not get mutated
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "providerConfigs", Object.freeze(providerConfigs));
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "quorum", quorum);
        this._highestBlockNumber = -1;
    }
}


"use strict";
const $70b27f74974a2dd3$export$fbe151f90a1ece01 = null;








"use strict";
const $aafdbc33abd5222f$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d9347b79faa289ba$export$83d89fbfd8236492));
const $aafdbc33abd5222f$var$defaultProjectId = "84842078b09946638c03157f83405213";
class $aafdbc33abd5222f$export$dd168a807d60da4f extends (0, $9eaaf2b70511b007$exports.WebSocketProvider) {
    isCommunityResource() {
        return this.projectId === $aafdbc33abd5222f$var$defaultProjectId;
    }
    constructor(network, apiKey){
        const provider = new $aafdbc33abd5222f$export$60ff1a559b5c6ebd(network, apiKey);
        const connection = provider.connection;
        if (connection.password) $aafdbc33abd5222f$var$logger.throwError("INFURA WebSocket project secrets unsupported", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "InfuraProvider.getWebSocketProvider()"
        });
        const url = connection.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
        super(url, network);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "apiKey", provider.projectId);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "projectId", provider.projectId);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "projectSecret", provider.projectSecret);
    }
}
class $aafdbc33abd5222f$export$60ff1a559b5c6ebd extends (0, $e630fe5b56031581$exports.UrlJsonRpcProvider) {
    static getWebSocketProvider(network, apiKey) {
        return new $aafdbc33abd5222f$export$dd168a807d60da4f(network, apiKey);
    }
    static getApiKey(apiKey) {
        const apiKeyObj = {
            apiKey: $aafdbc33abd5222f$var$defaultProjectId,
            projectId: $aafdbc33abd5222f$var$defaultProjectId,
            projectSecret: null
        };
        if (apiKey == null) return apiKeyObj;
        if (typeof apiKey === "string") apiKeyObj.projectId = apiKey;
        else if (apiKey.projectSecret != null) {
            $aafdbc33abd5222f$var$logger.assertArgument(typeof apiKey.projectId === "string", "projectSecret requires a projectId", "projectId", apiKey.projectId);
            $aafdbc33abd5222f$var$logger.assertArgument(typeof apiKey.projectSecret === "string", "invalid projectSecret", "projectSecret", "[REDACTED]");
            apiKeyObj.projectId = apiKey.projectId;
            apiKeyObj.projectSecret = apiKey.projectSecret;
        } else if (apiKey.projectId) apiKeyObj.projectId = apiKey.projectId;
        apiKeyObj.apiKey = apiKeyObj.projectId;
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "homestead":
                host = "mainnet.infura.io";
                break;
            case "goerli":
                host = "goerli.infura.io";
                break;
            case "sepolia":
                host = "sepolia.infura.io";
                break;
            case "matic":
                host = "polygon-mainnet.infura.io";
                break;
            case "maticmum":
                host = "polygon-mumbai.infura.io";
                break;
            case "optimism":
                host = "optimism-mainnet.infura.io";
                break;
            case "optimism-goerli":
                host = "optimism-goerli.infura.io";
                break;
            case "arbitrum":
                host = "arbitrum-mainnet.infura.io";
                break;
            case "arbitrum-goerli":
                host = "arbitrum-goerli.infura.io";
                break;
            default:
                $aafdbc33abd5222f$var$logger.throwError("unsupported network", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const connection = {
            allowGzip: true,
            url: "https://" + host + "/v3/" + apiKey.projectId,
            throttleCallback: (attempt, url)=>{
                if (apiKey.projectId === $aafdbc33abd5222f$var$defaultProjectId) (0, $af0c63f6ba6ab466$export$4c41bd49e82e82ab)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
    isCommunityResource() {
        return this.projectId === $aafdbc33abd5222f$var$defaultProjectId;
    }
}






class $b10a6faa86d631b8$export$5a16092bf20edf97 extends (0, $7bf56bd7b17e0046$exports.JsonRpcProvider) {
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        if (this._pendingBatch == null) this._pendingBatch = [];
        const inflightRequest = {
            request: request,
            resolve: null,
            reject: null
        };
        const promise = new Promise((resolve, reject)=>{
            inflightRequest.resolve = resolve;
            inflightRequest.reject = reject;
        });
        this._pendingBatch.push(inflightRequest);
        if (!this._pendingBatchAggregator) // Schedule batch for next event loop + short duration
        this._pendingBatchAggregator = setTimeout(()=>{
            // Get teh current batch and clear it, so new requests
            // go into the next batch
            const batch = this._pendingBatch;
            this._pendingBatch = null;
            this._pendingBatchAggregator = null;
            // Get the request as an array of requests
            const request = batch.map((inflight)=>inflight.request);
            this.emit("debug", {
                action: "requestBatch",
                request: (0, $19462b55124983f4$exports.deepCopy)(request),
                provider: this
            });
            return (0, $bf63a14489d0132f$exports.fetchJson)(this.connection, JSON.stringify(request)).then((result)=>{
                this.emit("debug", {
                    action: "response",
                    request: request,
                    response: result,
                    provider: this
                });
                // For each result, feed it to the correct Promise, depending
                // on whether it was a success or error
                batch.forEach((inflightRequest, index)=>{
                    const payload = result[index];
                    if (payload.error) {
                        const error = new Error(payload.error.message);
                        error.code = payload.error.code;
                        error.data = payload.error.data;
                        inflightRequest.reject(error);
                    } else inflightRequest.resolve(payload.result);
                });
            }, (error)=>{
                this.emit("debug", {
                    action: "response",
                    error: error,
                    request: request,
                    provider: this
                });
                batch.forEach((inflightRequest)=>{
                    inflightRequest.reject(error);
                });
            });
        }, 10);
        return promise;
    }
}


/* istanbul ignore file */ 


"use strict";
const $53c9891537aa720d$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d9347b79faa289ba$export$83d89fbfd8236492));
// Special API key provided by Nodesmith for ethers.js
const $53c9891537aa720d$var$defaultApiKey = "ETHERS_JS_SHARED";
class $53c9891537aa720d$export$8235cbce3ce273bd extends (0, $e630fe5b56031581$exports.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        if (apiKey && typeof apiKey !== "string") $53c9891537aa720d$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey || $53c9891537aa720d$var$defaultApiKey;
    }
    static getUrl(network, apiKey) {
        $53c9891537aa720d$var$logger.warn("NodeSmith will be discontinued on 2019-12-20; please migrate to another platform.");
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://ethereum.api.nodesmith.io/v1/mainnet/jsonrpc";
                break;
            case "ropsten":
                host = "https://ethereum.api.nodesmith.io/v1/ropsten/jsonrpc";
                break;
            case "rinkeby":
                host = "https://ethereum.api.nodesmith.io/v1/rinkeby/jsonrpc";
                break;
            case "goerli":
                host = "https://ethereum.api.nodesmith.io/v1/goerli/jsonrpc";
                break;
            case "kovan":
                host = "https://ethereum.api.nodesmith.io/v1/kovan/jsonrpc";
                break;
            default:
                $53c9891537aa720d$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host + "?apiKey=" + apiKey;
    }
}





"use strict";
const $f6dfb138e1bee94a$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d9347b79faa289ba$export$83d89fbfd8236492));
const $f6dfb138e1bee94a$var$defaultApplicationId = "62e1ad51b37b8e00394bda3b";
class $f6dfb138e1bee94a$export$58bb47e42f6b092e extends (0, $e630fe5b56031581$exports.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        const apiKeyObj = {
            applicationId: null,
            loadBalancer: true,
            applicationSecretKey: null
        };
        // Parse applicationId and applicationSecretKey
        if (apiKey == null) apiKeyObj.applicationId = $f6dfb138e1bee94a$var$defaultApplicationId;
        else if (typeof apiKey === "string") apiKeyObj.applicationId = apiKey;
        else if (apiKey.applicationSecretKey != null) {
            apiKeyObj.applicationId = apiKey.applicationId;
            apiKeyObj.applicationSecretKey = apiKey.applicationSecretKey;
        } else if (apiKey.applicationId) apiKeyObj.applicationId = apiKey.applicationId;
        else $f6dfb138e1bee94a$var$logger.throwArgumentError("unsupported PocketProvider apiKey", "apiKey", apiKey);
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "goerli":
                host = "eth-goerli.gateway.pokt.network";
                break;
            case "homestead":
                host = "eth-mainnet.gateway.pokt.network";
                break;
            case "kovan":
                host = "poa-kovan.gateway.pokt.network";
                break;
            case "matic":
                host = "poly-mainnet.gateway.pokt.network";
                break;
            case "maticmum":
                host = "polygon-mumbai-rpc.gateway.pokt.network";
                break;
            case "rinkeby":
                host = "eth-rinkeby.gateway.pokt.network";
                break;
            case "ropsten":
                host = "eth-ropsten.gateway.pokt.network";
                break;
            default:
                $f6dfb138e1bee94a$var$logger.throwError("unsupported network", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const url = `https:/\/${host}/v1/lb/${apiKey.applicationId}`;
        const connection = {
            headers: {},
            url: url
        };
        if (apiKey.applicationSecretKey != null) {
            connection.user = "";
            connection.password = apiKey.applicationSecretKey;
        }
        return connection;
    }
    isCommunityResource() {
        return this.applicationId === $f6dfb138e1bee94a$var$defaultApplicationId;
    }
}







"use strict";
const $f7d2f0b1fa262e29$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d9347b79faa289ba$export$83d89fbfd8236492));
let $f7d2f0b1fa262e29$var$_nextId = 1;
function $f7d2f0b1fa262e29$var$buildWeb3LegacyFetcher(provider, sendFunc) {
    const fetcher = "Web3LegacyFetcher";
    return function(method, params) {
        const request = {
            method: method,
            params: params,
            id: $f7d2f0b1fa262e29$var$_nextId++,
            jsonrpc: "2.0"
        };
        return new Promise((resolve, reject)=>{
            this.emit("debug", {
                action: "request",
                fetcher: fetcher,
                request: (0, $19462b55124983f4$exports.deepCopy)(request),
                provider: this
            });
            sendFunc(request, (error, response)=>{
                if (error) {
                    this.emit("debug", {
                        action: "response",
                        fetcher: fetcher,
                        error: error,
                        request: request,
                        provider: this
                    });
                    return reject(error);
                }
                this.emit("debug", {
                    action: "response",
                    fetcher: fetcher,
                    request: request,
                    response: response,
                    provider: this
                });
                if (response.error) {
                    const error = new Error(response.error.message);
                    error.code = response.error.code;
                    error.data = response.error.data;
                    return reject(error);
                }
                resolve(response.result);
            });
        });
    };
}
function $f7d2f0b1fa262e29$var$buildEip1193Fetcher(provider) {
    return function(method, params) {
        if (params == null) params = [];
        const request = {
            method: method,
            params: params
        };
        this.emit("debug", {
            action: "request",
            fetcher: "Eip1193Fetcher",
            request: (0, $19462b55124983f4$exports.deepCopy)(request),
            provider: this
        });
        return provider.request(request).then((response)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                response: response,
                provider: this
            });
            return response;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                error: error,
                provider: this
            });
            throw error;
        });
    };
}
class $f7d2f0b1fa262e29$export$d05096c9fd9d936d extends (0, $7bf56bd7b17e0046$exports.JsonRpcProvider) {
    send(method, params) {
        return this.jsonRpcFetchFunc(method, params);
    }
    constructor(provider, network){
        if (provider == null) $f7d2f0b1fa262e29$var$logger.throwArgumentError("missing provider", "provider", provider);
        let path = null;
        let jsonRpcFetchFunc = null;
        let subprovider = null;
        if (typeof provider === "function") {
            path = "unknown:";
            jsonRpcFetchFunc = provider;
        } else {
            path = provider.host || provider.path || "";
            if (!path && provider.isMetaMask) path = "metamask";
            subprovider = provider;
            if (provider.request) {
                if (path === "") path = "eip-1193:";
                jsonRpcFetchFunc = $f7d2f0b1fa262e29$var$buildEip1193Fetcher(provider);
            } else if (provider.sendAsync) jsonRpcFetchFunc = $f7d2f0b1fa262e29$var$buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
            else if (provider.send) jsonRpcFetchFunc = $f7d2f0b1fa262e29$var$buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
            else $f7d2f0b1fa262e29$var$logger.throwArgumentError("unsupported provider", "provider", provider);
            if (!path) path = "unknown:";
        }
        super(path, network);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "jsonRpcFetchFunc", jsonRpcFetchFunc);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "provider", subprovider);
    }
}






"use strict";
const $f72528ab54eeaef8$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $d9347b79faa289ba$export$83d89fbfd8236492));
////////////////////////
// Helper Functions
function $f72528ab54eeaef8$export$4f77a1d3c1ac6642(network, options) {
    if (network == null) network = "homestead";
    // If passed a URL, figure out the right type of provider based on the scheme
    if (typeof network === "string") {
        // @TODO: Add support for IpcProvider; maybe if it ends in ".ipc"?
        // Handle http and ws (and their secure variants)
        const match = network.match(/^(ws|http)s?:/i);
        if (match) switch(match[1].toLowerCase()){
            case "http":
            case "https":
                return new (0, $7bf56bd7b17e0046$exports.JsonRpcProvider)(network);
            case "ws":
            case "wss":
                return new (0, $9eaaf2b70511b007$exports.WebSocketProvider)(network);
            default:
                $f72528ab54eeaef8$var$logger.throwArgumentError("unsupported URL scheme", "network", network);
        }
    }
    const n = (0, $161a25d62c52de9c$export$7de4970ebfd8206d)(network);
    if (!n || !n._defaultProvider) $f72528ab54eeaef8$var$logger.throwError("unsupported getDefaultProvider network", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.NETWORK_ERROR, {
        operation: "getDefaultProvider",
        network: network
    });
    return n._defaultProvider({
        FallbackProvider: $c71cf52c680b1470$exports.FallbackProvider,
        AlchemyProvider: $990dd48e125b1d3c$export$999cc40da3fbc6f,
        AnkrProvider: $34f96cdeb0f3f720$export$72783b2aefa72a45,
        CloudflareProvider: $93e46fc4025aa2f3$exports.CloudflareProvider,
        EtherscanProvider: $5f74b530f183cf41$exports.EtherscanProvider,
        InfuraProvider: $aafdbc33abd5222f$export$60ff1a559b5c6ebd,
        JsonRpcProvider: $7bf56bd7b17e0046$exports.JsonRpcProvider,
        NodesmithProvider: $53c9891537aa720d$export$8235cbce3ce273bd,
        PocketProvider: $f6dfb138e1bee94a$export$58bb47e42f6b092e,
        Web3Provider: $f7d2f0b1fa262e29$export$d05096c9fd9d936d,
        IpcProvider: $70b27f74974a2dd3$export$fbe151f90a1ece01
    }, options);
}


var $29b78df16cc81472$exports = {};

$parcel$export($29b78df16cc81472$exports, "logger", function () { return $29b78df16cc81472$export$af88d00dbe7f521; });
$parcel$export($29b78df16cc81472$exports, "Signer", function () { return $d9b7eb644de5bd3c$exports.Signer; });
$parcel$export($29b78df16cc81472$exports, "Wallet", function () { return $3b1688dbad3fbfea$exports.Wallet; });
$parcel$export($29b78df16cc81472$exports, "VoidSigner", function () { return $d9b7eb644de5bd3c$exports.VoidSigner; });
$parcel$export($29b78df16cc81472$exports, "getDefaultProvider", function () { return $f72528ab54eeaef8$export$4f77a1d3c1ac6642; });
$parcel$export($29b78df16cc81472$exports, "providers", function () { return $f72528ab54eeaef8$exports; });
$parcel$export($29b78df16cc81472$exports, "BaseContract", function () { return $fcd53023be51494b$exports.BaseContract; });
$parcel$export($29b78df16cc81472$exports, "Contract", function () { return $fcd53023be51494b$exports.Contract; });
$parcel$export($29b78df16cc81472$exports, "ContractFactory", function () { return $fcd53023be51494b$exports.ContractFactory; });
$parcel$export($29b78df16cc81472$exports, "BigNumber", function () { return $c37d64fad2cf3dce$export$d97aa349ed20696; });
$parcel$export($29b78df16cc81472$exports, "FixedNumber", function () { return $0ca80bf34c50fe44$export$d4693c66c2213e45; });
$parcel$export($29b78df16cc81472$exports, "constants", function () { return $273a5a8df3bb8508$exports; });
$parcel$export($29b78df16cc81472$exports, "errors", function () { return $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb; });
$parcel$export($29b78df16cc81472$exports, "utils", function () { return $a4175433b234909f$exports; });
$parcel$export($29b78df16cc81472$exports, "wordlists", function () { return $0dfacc88dba7f7bc$export$e8e1b4711c2d1939; });
$parcel$export($29b78df16cc81472$exports, "version", function () { return $98e9ced0691461ae$export$83d89fbfd8236492; });
$parcel$export($29b78df16cc81472$exports, "Wordlist", function () { return $c996913613c064e5$export$4d9531a8ddb0ebca; });





"use strict";
const $0ca80bf34c50fe44$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $7d66624d621f023f$export$83d89fbfd8236492));
const $0ca80bf34c50fe44$var$_constructorGuard = {};
const $0ca80bf34c50fe44$var$Zero = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(0);
const $0ca80bf34c50fe44$var$NegativeOne = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(-1);
function $0ca80bf34c50fe44$var$throwFault(message, fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value !== undefined) params.value = value;
    return $0ca80bf34c50fe44$var$logger.throwError(message, (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.NUMERIC_FAULT, params);
}
// Constant to pull zeros from for multipliers
let $0ca80bf34c50fe44$var$zeros = "0";
while($0ca80bf34c50fe44$var$zeros.length < 256)$0ca80bf34c50fe44$var$zeros += $0ca80bf34c50fe44$var$zeros;
// Returns a string "1" followed by decimal "0"s
function $0ca80bf34c50fe44$var$getMultiplier(decimals) {
    if (typeof decimals !== "number") try {
        decimals = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(decimals).toNumber();
    } catch (e) {}
    if (typeof decimals === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) return "1" + $0ca80bf34c50fe44$var$zeros.substring(0, decimals);
    return $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function $0ca80bf34c50fe44$export$cc011b843b5d69f2(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $0ca80bf34c50fe44$var$getMultiplier(decimals);
    // Make sure wei is a big number (convert as necessary)
    value = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(value);
    const negative = value.lt($0ca80bf34c50fe44$var$Zero);
    if (negative) value = value.mul($0ca80bf34c50fe44$var$NegativeOne);
    let fraction = value.mod(multiplier).toString();
    while(fraction.length < multiplier.length - 1)fraction = "0" + fraction;
    // Strip training 0
    fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    const whole = value.div(multiplier).toString();
    if (multiplier.length === 1) value = whole;
    else value = whole + "." + fraction;
    if (negative) value = "-" + value;
    return value;
}
function $0ca80bf34c50fe44$export$1b039987e86d7269(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $0ca80bf34c50fe44$var$getMultiplier(decimals);
    if (typeof value !== "string" || !value.match(/^-?[0-9.]+$/)) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid decimal value", "value", value);
    // Is it negative?
    const negative = value.substring(0, 1) === "-";
    if (negative) value = value.substring(1);
    if (value === ".") $0ca80bf34c50fe44$var$logger.throwArgumentError("missing value", "value", value);
    // Split it into a whole and fractional part
    const comps = value.split(".");
    if (comps.length > 2) $0ca80bf34c50fe44$var$logger.throwArgumentError("too many decimal points", "value", value);
    let whole = comps[0], fraction = comps[1];
    if (!whole) whole = "0";
    if (!fraction) fraction = "0";
    // Trim trailing zeros
    while(fraction[fraction.length - 1] === "0")fraction = fraction.substring(0, fraction.length - 1);
    // Check the fraction doesn't exceed our decimals size
    if (fraction.length > multiplier.length - 1) $0ca80bf34c50fe44$var$throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
    // If decimals is 0, we have an empty string for fraction
    if (fraction === "") fraction = "0";
    // Fully pad the string with zeros to get to wei
    while(fraction.length < multiplier.length - 1)fraction += "0";
    const wholeValue = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(whole);
    const fractionValue = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(fraction);
    let wei = wholeValue.mul(multiplier).add(fractionValue);
    if (negative) wei = wei.mul($0ca80bf34c50fe44$var$NegativeOne);
    return wei;
}
class $0ca80bf34c50fe44$export$1f3ec5b8f47ebd4d {
    static from(value) {
        if (value instanceof $0ca80bf34c50fe44$export$1f3ec5b8f47ebd4d) return value;
        if (typeof value === "number") value = `fixed128x${value}`;
        let signed = true;
        let width = 128;
        let decimals = 18;
        if (typeof value === "string") {
            if (value === "fixed") ;
            else if (value === "ufixed") signed = false;
            else {
                const match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                if (!match) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid fixed format", "format", value);
                signed = match[1] !== "u";
                width = parseInt(match[2]);
                decimals = parseInt(match[3]);
            }
        } else if (value) {
            const check = (key, type, defaultValue)=>{
                if (value[key] == null) return defaultValue;
                if (typeof value[key] !== type) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
                return value[key];
            };
            signed = check("signed", "boolean", signed);
            width = check("width", "number", width);
            decimals = check("decimals", "number", decimals);
        }
        if (width % 8) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
        if (decimals > 80) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
        return new $0ca80bf34c50fe44$export$1f3ec5b8f47ebd4d($0ca80bf34c50fe44$var$_constructorGuard, signed, width, decimals);
    }
    constructor(constructorGuard, signed, width, decimals){
        if (constructorGuard !== $0ca80bf34c50fe44$var$_constructorGuard) $0ca80bf34c50fe44$var$logger.throwError("cannot use FixedFormat constructor; use FixedFormat.from", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.signed = signed;
        this.width = width;
        this.decimals = decimals;
        this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
        this._multiplier = $0ca80bf34c50fe44$var$getMultiplier(decimals);
        Object.freeze(this);
    }
}
class $0ca80bf34c50fe44$export$d4693c66c2213e45 {
    _checkFormat(other) {
        if (this.format.name !== other.format.name) $0ca80bf34c50fe44$var$logger.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
    }
    addUnsafe(other) {
        this._checkFormat(other);
        const a = $0ca80bf34c50fe44$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $0ca80bf34c50fe44$export$1b039987e86d7269(other._value, other.format.decimals);
        return $0ca80bf34c50fe44$export$d4693c66c2213e45.fromValue(a.add(b), this.format.decimals, this.format);
    }
    subUnsafe(other) {
        this._checkFormat(other);
        const a = $0ca80bf34c50fe44$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $0ca80bf34c50fe44$export$1b039987e86d7269(other._value, other.format.decimals);
        return $0ca80bf34c50fe44$export$d4693c66c2213e45.fromValue(a.sub(b), this.format.decimals, this.format);
    }
    mulUnsafe(other) {
        this._checkFormat(other);
        const a = $0ca80bf34c50fe44$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $0ca80bf34c50fe44$export$1b039987e86d7269(other._value, other.format.decimals);
        return $0ca80bf34c50fe44$export$d4693c66c2213e45.fromValue(a.mul(b).div(this.format._multiplier), this.format.decimals, this.format);
    }
    divUnsafe(other) {
        this._checkFormat(other);
        const a = $0ca80bf34c50fe44$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $0ca80bf34c50fe44$export$1b039987e86d7269(other._value, other.format.decimals);
        return $0ca80bf34c50fe44$export$d4693c66c2213e45.fromValue(a.mul(this.format._multiplier).div(b), this.format.decimals, this.format);
    }
    floor() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $0ca80bf34c50fe44$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (this.isNegative() && hasFraction) result = result.subUnsafe($0ca80bf34c50fe44$var$ONE.toFormat(result.format));
        return result;
    }
    ceiling() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $0ca80bf34c50fe44$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (!this.isNegative() && hasFraction) result = result.addUnsafe($0ca80bf34c50fe44$var$ONE.toFormat(result.format));
        return result;
    }
    // @TODO: Support other rounding algorithms
    round(decimals) {
        if (decimals == null) decimals = 0;
        // If we are already in range, we're done
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        if (decimals < 0 || decimals > 80 || decimals % 1) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid decimal count", "decimals", decimals);
        if (comps[1].length <= decimals) return this;
        const factor = $0ca80bf34c50fe44$export$d4693c66c2213e45.from("1" + $0ca80bf34c50fe44$var$zeros.substring(0, decimals), this.format);
        const bump = $0ca80bf34c50fe44$var$BUMP.toFormat(this.format);
        return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
    }
    isZero() {
        return this._value === "0.0" || this._value === "0";
    }
    isNegative() {
        return this._value[0] === "-";
    }
    toString() {
        return this._value;
    }
    toHexString(width) {
        if (width == null) return this._hex;
        if (width % 8) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid byte width", "width", width);
        const hex = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
        return (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)(hex, width / 8);
    }
    toUnsafeFloat() {
        return parseFloat(this.toString());
    }
    toFormat(format) {
        return $0ca80bf34c50fe44$export$d4693c66c2213e45.fromString(this._value, format);
    }
    static fromValue(value, decimals, format) {
        // If decimals looks more like a format, and there is no format, shift the parameters
        if (format == null && decimals != null && !(0, $c37d64fad2cf3dce$export$a3d0a7fa9b65683b)(decimals)) {
            format = decimals;
            decimals = null;
        }
        if (decimals == null) decimals = 0;
        if (format == null) format = "fixed";
        return $0ca80bf34c50fe44$export$d4693c66c2213e45.fromString($0ca80bf34c50fe44$export$cc011b843b5d69f2(value, decimals), $0ca80bf34c50fe44$export$1f3ec5b8f47ebd4d.from(format));
    }
    static fromString(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $0ca80bf34c50fe44$export$1f3ec5b8f47ebd4d.from(format);
        const numeric = $0ca80bf34c50fe44$export$1b039987e86d7269(value, fixedFormat.decimals);
        if (!fixedFormat.signed && numeric.lt($0ca80bf34c50fe44$var$Zero)) $0ca80bf34c50fe44$var$throwFault("unsigned value cannot be negative", "overflow", "value", value);
        let hex = null;
        if (fixedFormat.signed) hex = numeric.toTwos(fixedFormat.width).toHexString();
        else {
            hex = numeric.toHexString();
            hex = (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)(hex, fixedFormat.width / 8);
        }
        const decimal = $0ca80bf34c50fe44$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $0ca80bf34c50fe44$export$d4693c66c2213e45($0ca80bf34c50fe44$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static fromBytes(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $0ca80bf34c50fe44$export$1f3ec5b8f47ebd4d.from(format);
        if ((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(value).length > fixedFormat.width / 8) throw new Error("overflow");
        let numeric = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(value);
        if (fixedFormat.signed) numeric = numeric.fromTwos(fixedFormat.width);
        const hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
        const decimal = $0ca80bf34c50fe44$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $0ca80bf34c50fe44$export$d4693c66c2213e45($0ca80bf34c50fe44$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static from(value, format) {
        if (typeof value === "string") return $0ca80bf34c50fe44$export$d4693c66c2213e45.fromString(value, format);
        if ((0, $ddc3d9704a40b613$export$c6fabfbfd097fc30)(value)) return $0ca80bf34c50fe44$export$d4693c66c2213e45.fromBytes(value, format);
        try {
            return $0ca80bf34c50fe44$export$d4693c66c2213e45.fromValue(value, 0, format);
        } catch (error) {
            // Allow NUMERIC_FAULT to bubble up
            if (error.code !== (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.INVALID_ARGUMENT) throw error;
        }
        return $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid FixedNumber value", "value", value);
    }
    static isFixedNumber(value) {
        return !!(value && value._isFixedNumber);
    }
    constructor(constructorGuard, hex, value, format){
        if (constructorGuard !== $0ca80bf34c50fe44$var$_constructorGuard) $0ca80bf34c50fe44$var$logger.throwError("cannot use FixedNumber constructor; use FixedNumber.from", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.format = format;
        this._hex = hex;
        this._value = value;
        this._isFixedNumber = true;
        Object.freeze(this);
    }
}
const $0ca80bf34c50fe44$var$ONE = $0ca80bf34c50fe44$export$d4693c66c2213e45.from(1);
const $0ca80bf34c50fe44$var$BUMP = $0ca80bf34c50fe44$export$d4693c66c2213e45.from("0.5");



var $3b1688dbad3fbfea$exports = {};

$parcel$export($3b1688dbad3fbfea$exports, "Wallet", function () { return $3b1688dbad3fbfea$export$bcca3ea514774656; });
$parcel$export($3b1688dbad3fbfea$exports, "verifyMessage", function () { return $3b1688dbad3fbfea$export$228d0e772cc158cb; });
$parcel$export($3b1688dbad3fbfea$exports, "verifyTypedData", function () { return $3b1688dbad3fbfea$export$3603b1c1bcd76798; });







const $578b0e6ea1b3b477$export$1ff3fdc4802a2ba6 = "\x19Ethereum Signed Message:\n";
function $578b0e6ea1b3b477$export$d4c241cec96564c1(message) {
    if (typeof message === "string") message = (0, $169c6c93221d2e48$export$8feeb310b4b4752f)(message);
    return (0, $344909d1f36347b2$export$f8151fce47ad1c35)((0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
        (0, $169c6c93221d2e48$export$8feeb310b4b4752f)($578b0e6ea1b3b477$export$1ff3fdc4802a2ba6),
        (0, $169c6c93221d2e48$export$8feeb310b4b4752f)(String(message.length)),
        message
    ]));
}








"use strict";
function $ab7da8db31000bcc$export$448fa22aedc9dbca(password, salt, iterations, keylen, hashAlgorithm) {
    password = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(password);
    salt = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(salt);
    let hLen;
    let l = 1;
    const DK = new Uint8Array(keylen);
    const block1 = new Uint8Array(salt.length + 4);
    block1.set(salt);
    //salt.copy(block1, 0, 0, salt.length)
    let r;
    let T;
    for(let i = 1; i <= l; i++){
        //block1.writeUInt32BE(i, salt.length)
        block1[salt.length] = i >> 24 & 0xff;
        block1[salt.length + 1] = i >> 16 & 0xff;
        block1[salt.length + 2] = i >> 8 & 0xff;
        block1[salt.length + 3] = i & 0xff;
        //let U = createHmac(password).update(block1).digest();
        let U = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)((0, $5c9a0ceac3511c58$export$967075d2f3b8e7ff)(hashAlgorithm, password, block1));
        if (!hLen) {
            hLen = U.length;
            T = new Uint8Array(hLen);
            l = Math.ceil(keylen / hLen);
            r = keylen - (l - 1) * hLen;
        }
        //U.copy(T, 0, 0, hLen)
        T.set(U);
        for(let j = 1; j < iterations; j++){
            //U = createHmac(password).update(U).digest();
            U = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)((0, $5c9a0ceac3511c58$export$967075d2f3b8e7ff)(hashAlgorithm, password, U));
            for(let k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        const destPos = (i - 1) * hLen;
        const len = i === l ? r : hLen;
        //T.copy(DK, destPos, 0, len)
        DK.set((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(T).slice(0, len), destPos);
    }
    return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(DK);
}









const $c4714a102efec208$export$83d89fbfd8236492 = "wordlists/5.7.0";


"use strict";
// This gets overridden by rollup
const $c996913613c064e5$var$exportWordlist = false;
const $c996913613c064e5$export$af88d00dbe7f521 = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $c4714a102efec208$export$83d89fbfd8236492));
class $c996913613c064e5$export$4d9531a8ddb0ebca {
    // Subclasses may override this
    split(mnemonic) {
        return mnemonic.toLowerCase().split(/ +/g);
    }
    // Subclasses may override this
    join(words) {
        return words.join(" ");
    }
    static check(wordlist) {
        const words = [];
        for(let i = 0; i < 2048; i++){
            const word = wordlist.getWord(i);
            /* istanbul ignore if */ if (i !== wordlist.getWordIndex(word)) return "0x";
            words.push(word);
        }
        return (0, $337ebfbf1ce1b46f$export$d560c7e4a29451c2)(words.join("\n") + "\n");
    }
    static register(lang, name) {
        if (!name) name = lang.locale;
        /* istanbul ignore if */ if ($c996913613c064e5$var$exportWordlist) try {
            const anyGlobal = window;
            if (anyGlobal._ethers && anyGlobal._ethers.wordlists) {
                if (!anyGlobal._ethers.wordlists[name]) (0, $19462b55124983f4$exports.defineReadOnly)(anyGlobal._ethers.wordlists, name, lang);
            }
        } catch (error) {}
    }
    constructor(locale){
        $c996913613c064e5$export$af88d00dbe7f521.checkAbstract(new.target, $c996913613c064e5$export$4d9531a8ddb0ebca);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "locale", locale);
    }
}


"use strict";
const $97afaf669a13bce7$var$words = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
let $97afaf669a13bce7$var$wordlist = null;
function $97afaf669a13bce7$var$loadWords(lang) {
    if ($97afaf669a13bce7$var$wordlist != null) return;
    $97afaf669a13bce7$var$wordlist = $97afaf669a13bce7$var$words.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" ");
    // Verify the computed list matches the official list
    /* istanbul ignore if */ if ((0, $c996913613c064e5$export$4d9531a8ddb0ebca).check(lang) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60") {
        $97afaf669a13bce7$var$wordlist = null;
        throw new Error("BIP39 Wordlist for en (English) FAILED");
    }
}
class $97afaf669a13bce7$var$LangEn extends (0, $c996913613c064e5$export$4d9531a8ddb0ebca) {
    getWord(index) {
        $97afaf669a13bce7$var$loadWords(this);
        return $97afaf669a13bce7$var$wordlist[index];
    }
    getWordIndex(word) {
        $97afaf669a13bce7$var$loadWords(this);
        return $97afaf669a13bce7$var$wordlist.indexOf(word);
    }
    constructor(){
        super("en");
    }
}
const $97afaf669a13bce7$export$a2c9518710cf1f49 = new $97afaf669a13bce7$var$LangEn();
(0, $c996913613c064e5$export$4d9531a8ddb0ebca).register($97afaf669a13bce7$export$a2c9518710cf1f49);


"use strict";
const $0dfacc88dba7f7bc$export$e8e1b4711c2d1939 = {
    en: (0, $97afaf669a13bce7$export$a2c9518710cf1f49)
};



const $335e81f973d32d11$export$83d89fbfd8236492 = "hdnode/5.7.0";


"use strict";
const $3dbe328f09720d4a$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $335e81f973d32d11$export$83d89fbfd8236492));
const $3dbe328f09720d4a$var$N = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
// "Bitcoin seed"
const $3dbe328f09720d4a$var$MasterSecret = (0, $169c6c93221d2e48$export$8feeb310b4b4752f)("Bitcoin seed");
const $3dbe328f09720d4a$var$HardenedBit = 0x80000000;
// Returns a byte with the MSB bits set
function $3dbe328f09720d4a$var$getUpperMask(bits) {
    return (1 << bits) - 1 << 8 - bits;
}
// Returns a byte with the LSB bits set
function $3dbe328f09720d4a$var$getLowerMask(bits) {
    return (1 << bits) - 1;
}
function $3dbe328f09720d4a$var$bytes32(value) {
    return (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)((0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(value), 32);
}
function $3dbe328f09720d4a$var$base58check(data) {
    return (0, $a538ed25248fff2d$export$45a587635c9954b2).encode((0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
        data,
        (0, $ddc3d9704a40b613$export$15da666eba198c18)((0, $5c9a0ceac3511c58$export$bced8d2aada2d1c9)((0, $5c9a0ceac3511c58$export$bced8d2aada2d1c9)(data)), 0, 4)
    ]));
}
function $3dbe328f09720d4a$var$getWordlist(wordlist) {
    if (wordlist == null) return (0, $0dfacc88dba7f7bc$export$e8e1b4711c2d1939)["en"];
    if (typeof wordlist === "string") {
        const words = (0, $0dfacc88dba7f7bc$export$e8e1b4711c2d1939)[wordlist];
        if (words == null) $3dbe328f09720d4a$var$logger.throwArgumentError("unknown locale", "wordlist", wordlist);
        return words;
    }
    return wordlist;
}
const $3dbe328f09720d4a$var$_constructorGuard = {};
const $3dbe328f09720d4a$export$d48ad89f7e11a603 = "m/44'/60'/0'/0/0";
class $3dbe328f09720d4a$export$b68640c53e22b952 {
    get extendedKey() {
        // We only support the mainnet values for now, but if anyone needs
        // testnet values, let me know. I believe current sentiment is that
        // we should always use mainnet, and use BIP-44 to derive the network
        //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
        //   - Testnet: public=0x043587CF, private=0x04358394
        if (this.depth >= 256) throw new Error("Depth too large!");
        return $3dbe328f09720d4a$var$base58check((0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
            this.privateKey != null ? "0x0488ADE4" : "0x0488B21E",
            (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(this.depth),
            this.parentFingerprint,
            (0, $ddc3d9704a40b613$export$e9c46a54370b47e8)((0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(this.index), 4),
            this.chainCode,
            this.privateKey != null ? (0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
                "0x00",
                this.privateKey
            ]) : this.publicKey
        ]));
    }
    neuter() {
        return new $3dbe328f09720d4a$export$b68640c53e22b952($3dbe328f09720d4a$var$_constructorGuard, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, this.path);
    }
    _derive(index) {
        if (index > 0xffffffff) throw new Error("invalid index - " + String(index));
        // Base path
        let path = this.path;
        if (path) path += "/" + (index & ~$3dbe328f09720d4a$var$HardenedBit);
        const data = new Uint8Array(37);
        if (index & $3dbe328f09720d4a$var$HardenedBit) {
            if (!this.privateKey) throw new Error("cannot derive child of neutered node");
            // Data = 0x00 || ser_256(k_par)
            data.set((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(this.privateKey), 1);
            // Hardened path
            if (path) path += "'";
        } else // Data = ser_p(point(k_par))
        data.set((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(this.publicKey));
        // Data += ser_32(i)
        for(let i = 24; i >= 0; i -= 8)data[33 + (i >> 3)] = index >> 24 - i & 0xff;
        const I = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)((0, $5c9a0ceac3511c58$export$967075d2f3b8e7ff)((0, $7bbd5149c083ead5$export$d2a8849cfb277c).sha512, this.chainCode, data));
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // The private key
        let ki = null;
        // The public key
        let Ki = null;
        if (this.privateKey) ki = $3dbe328f09720d4a$var$bytes32((0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(IL).add(this.privateKey).mod($3dbe328f09720d4a$var$N));
        else {
            const ek = new (0, $378334ead6ec6b6e$export$21643ca94aed3e83)((0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(IL));
            Ki = ek._addPoint(this.publicKey);
        }
        let mnemonicOrPath = path;
        const srcMnemonic = this.mnemonic;
        if (srcMnemonic) mnemonicOrPath = Object.freeze({
            phrase: srcMnemonic.phrase,
            path: path,
            locale: srcMnemonic.locale || "en"
        });
        return new $3dbe328f09720d4a$export$b68640c53e22b952($3dbe328f09720d4a$var$_constructorGuard, ki, Ki, this.fingerprint, $3dbe328f09720d4a$var$bytes32(IR), index, this.depth + 1, mnemonicOrPath);
    }
    derivePath(path) {
        const components = path.split("/");
        if (components.length === 0 || components[0] === "m" && this.depth !== 0) throw new Error("invalid path - " + path);
        if (components[0] === "m") components.shift();
        let result = this;
        for(let i = 0; i < components.length; i++){
            const component = components[i];
            if (component.match(/^[0-9]+'$/)) {
                const index = parseInt(component.substring(0, component.length - 1));
                if (index >= $3dbe328f09720d4a$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive($3dbe328f09720d4a$var$HardenedBit + index);
            } else if (component.match(/^[0-9]+$/)) {
                const index = parseInt(component);
                if (index >= $3dbe328f09720d4a$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive(index);
            } else throw new Error("invalid path component - " + component);
        }
        return result;
    }
    static _fromSeed(seed, mnemonic) {
        const seedArray = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(seed);
        if (seedArray.length < 16 || seedArray.length > 64) throw new Error("invalid seed");
        const I = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)((0, $5c9a0ceac3511c58$export$967075d2f3b8e7ff)((0, $7bbd5149c083ead5$export$d2a8849cfb277c).sha512, $3dbe328f09720d4a$var$MasterSecret, seedArray));
        return new $3dbe328f09720d4a$export$b68640c53e22b952($3dbe328f09720d4a$var$_constructorGuard, $3dbe328f09720d4a$var$bytes32(I.slice(0, 32)), null, "0x00000000", $3dbe328f09720d4a$var$bytes32(I.slice(32)), 0, 0, mnemonic);
    }
    static fromMnemonic(mnemonic, password, wordlist) {
        // If a locale name was passed in, find the associated wordlist
        wordlist = $3dbe328f09720d4a$var$getWordlist(wordlist);
        // Normalize the case and spacing in the mnemonic (throws if the mnemonic is invalid)
        mnemonic = $3dbe328f09720d4a$export$4becd65eb23312e6($3dbe328f09720d4a$export$135e090d58b310ca(mnemonic, wordlist), wordlist);
        return $3dbe328f09720d4a$export$b68640c53e22b952._fromSeed($3dbe328f09720d4a$export$3dee74f1204ab09f(mnemonic, password), {
            phrase: mnemonic,
            path: "m",
            locale: wordlist.locale
        });
    }
    static fromSeed(seed) {
        return $3dbe328f09720d4a$export$b68640c53e22b952._fromSeed(seed, null);
    }
    static fromExtendedKey(extendedKey) {
        const bytes = (0, $a538ed25248fff2d$export$45a587635c9954b2).decode(extendedKey);
        if (bytes.length !== 82 || $3dbe328f09720d4a$var$base58check(bytes.slice(0, 78)) !== extendedKey) $3dbe328f09720d4a$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
        const depth = bytes[4];
        const parentFingerprint = (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(bytes.slice(5, 9));
        const index = parseInt((0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(bytes.slice(9, 13)).substring(2), 16);
        const chainCode = (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(bytes.slice(13, 45));
        const key = bytes.slice(45, 78);
        switch((0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(bytes.slice(0, 4))){
            // Public Key
            case "0x0488b21e":
            case "0x043587cf":
                return new $3dbe328f09720d4a$export$b68640c53e22b952($3dbe328f09720d4a$var$_constructorGuard, null, (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(key), parentFingerprint, chainCode, index, depth, null);
            // Private Key
            case "0x0488ade4":
            case "0x04358394 ":
                if (key[0] !== 0) break;
                return new $3dbe328f09720d4a$export$b68640c53e22b952($3dbe328f09720d4a$var$_constructorGuard, (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(key.slice(1)), null, parentFingerprint, chainCode, index, depth, null);
        }
        return $3dbe328f09720d4a$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
    }
    /**
     *  This constructor should not be called directly.
     *
     *  Please use:
     *   - fromMnemonic
     *   - fromSeed
     */ constructor(constructorGuard, privateKey, publicKey, parentFingerprint, chainCode, index, depth, mnemonicOrPath){
        /* istanbul ignore if */ if (constructorGuard !== $3dbe328f09720d4a$var$_constructorGuard) throw new Error("HDNode constructor cannot be called directly");
        if (privateKey) {
            const signingKey = new (0, $378334ead6ec6b6e$export$21643ca94aed3e83)(privateKey);
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "privateKey", signingKey.privateKey);
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "publicKey", signingKey.compressedPublicKey);
        } else {
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "privateKey", null);
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "publicKey", (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(publicKey));
        }
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "parentFingerprint", parentFingerprint);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "fingerprint", (0, $ddc3d9704a40b613$export$15da666eba198c18)((0, $5c9a0ceac3511c58$export$d1cea0ee4e3f0d3e)((0, $5c9a0ceac3511c58$export$bced8d2aada2d1c9)(this.publicKey)), 0, 4));
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "address", (0, $cd7e99036b8e7d03$export$e67e2732ba9803f9)(this.publicKey));
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "chainCode", chainCode);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "index", index);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "depth", depth);
        if (mnemonicOrPath == null) {
            // From a source that does not preserve the path (e.g. extended keys)
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "mnemonic", null);
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "path", null);
        } else if (typeof mnemonicOrPath === "string") {
            // From a source that does not preserve the mnemonic (e.g. neutered)
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "mnemonic", null);
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "path", mnemonicOrPath);
        } else {
            // From a fully qualified source
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "mnemonic", mnemonicOrPath);
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "path", mnemonicOrPath.path);
        }
    }
}
function $3dbe328f09720d4a$export$3dee74f1204ab09f(mnemonic, password) {
    if (!password) password = "";
    const salt = (0, $169c6c93221d2e48$export$8feeb310b4b4752f)("mnemonic" + password, (0, $169c6c93221d2e48$export$c6986442964129f5).NFKD);
    return (0, $ab7da8db31000bcc$export$448fa22aedc9dbca)((0, $169c6c93221d2e48$export$8feeb310b4b4752f)(mnemonic, (0, $169c6c93221d2e48$export$c6986442964129f5).NFKD), salt, 2048, 64, "sha512");
}
function $3dbe328f09720d4a$export$135e090d58b310ca(mnemonic, wordlist) {
    wordlist = $3dbe328f09720d4a$var$getWordlist(wordlist);
    $3dbe328f09720d4a$var$logger.checkNormalize();
    const words = wordlist.split(mnemonic);
    if (words.length % 3 !== 0) throw new Error("invalid mnemonic");
    const entropy = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(new Uint8Array(Math.ceil(11 * words.length / 8)));
    let offset = 0;
    for(let i = 0; i < words.length; i++){
        let index = wordlist.getWordIndex(words[i].normalize("NFKD"));
        if (index === -1) throw new Error("invalid mnemonic");
        for(let bit = 0; bit < 11; bit++){
            if (index & 1 << 10 - bit) entropy[offset >> 3] |= 1 << 7 - offset % 8;
            offset++;
        }
    }
    const entropyBits = 32 * words.length / 3;
    const checksumBits = words.length / 3;
    const checksumMask = $3dbe328f09720d4a$var$getUpperMask(checksumBits);
    const checksum = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)((0, $5c9a0ceac3511c58$export$bced8d2aada2d1c9)(entropy.slice(0, entropyBits / 8)))[0] & checksumMask;
    if (checksum !== (entropy[entropy.length - 1] & checksumMask)) throw new Error("invalid checksum");
    return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(entropy.slice(0, entropyBits / 8));
}
function $3dbe328f09720d4a$export$4becd65eb23312e6(entropy, wordlist) {
    wordlist = $3dbe328f09720d4a$var$getWordlist(wordlist);
    entropy = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(entropy);
    if (entropy.length % 4 !== 0 || entropy.length < 16 || entropy.length > 32) throw new Error("invalid entropy");
    const indices = [
        0
    ];
    let remainingBits = 11;
    for(let i = 0; i < entropy.length; i++)// Consume the whole byte (with still more to go)
    if (remainingBits > 8) {
        indices[indices.length - 1] <<= 8;
        indices[indices.length - 1] |= entropy[i];
        remainingBits -= 8;
    // This byte will complete an 11-bit index
    } else {
        indices[indices.length - 1] <<= remainingBits;
        indices[indices.length - 1] |= entropy[i] >> 8 - remainingBits;
        // Start the next word
        indices.push(entropy[i] & $3dbe328f09720d4a$var$getLowerMask(8 - remainingBits));
        remainingBits += 3;
    }
    // Compute the checksum bits
    const checksumBits = entropy.length / 4;
    const checksum = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)((0, $5c9a0ceac3511c58$export$bced8d2aada2d1c9)(entropy))[0] & $3dbe328f09720d4a$var$getUpperMask(checksumBits);
    // Shift the checksum into the word indices
    indices[indices.length - 1] <<= checksumBits;
    indices[indices.length - 1] |= checksum >> 8 - checksumBits;
    return wordlist.join(indices.map((index)=>wordlist.getWord(index)));
}
function $3dbe328f09720d4a$export$5eea3393c6119c80(mnemonic, wordlist) {
    try {
        $3dbe328f09720d4a$export$135e090d58b310ca(mnemonic, wordlist);
        return true;
    } catch (error) {}
    return false;
}
function $3dbe328f09720d4a$export$22b80e4f9eff636d(index) {
    if (typeof index !== "number" || index < 0 || index >= $3dbe328f09720d4a$var$HardenedBit || index % 1) $3dbe328f09720d4a$var$logger.throwArgumentError("invalid account index", "index", index);
    return `m/44'/60'/${index}'/0/0`;
}






const $b43b519c9c02dc79$export$83d89fbfd8236492 = "random/5.7.0";


"use strict";
const $32835a60ff995f3a$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $b43b519c9c02dc79$export$83d89fbfd8236492));
// Debugging line for testing browser lib in node
//const window = { crypto: { getRandomValues: () => { } } };
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $32835a60ff995f3a$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $32835a60ff995f3a$var$anyGlobal = $32835a60ff995f3a$var$getGlobal();
let $32835a60ff995f3a$var$crypto = $32835a60ff995f3a$var$anyGlobal.crypto || $32835a60ff995f3a$var$anyGlobal.msCrypto;
if (!$32835a60ff995f3a$var$crypto || !$32835a60ff995f3a$var$crypto.getRandomValues) {
    $32835a60ff995f3a$var$logger.warn("WARNING: Missing strong random number source");
    $32835a60ff995f3a$var$crypto = {
        getRandomValues: function(buffer) {
            return $32835a60ff995f3a$var$logger.throwError("no secure random source avaialble", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "crypto.getRandomValues"
            });
        }
    };
}
function $32835a60ff995f3a$export$5f828d93ff035aa8(length) {
    if (length <= 0 || length > 1024 || length % 1 || length != length) $32835a60ff995f3a$var$logger.throwArgumentError("invalid length", "length", length);
    const result = new Uint8Array(length);
    $32835a60ff995f3a$var$crypto.getRandomValues(result);
    return (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(result);
}



var $72ea0040e5768fb5$exports = {};
"use strict";
(function(root) {
    function checkInt(value) {
        return parseInt(value) === value;
    }
    function checkInts(arrayish) {
        if (!checkInt(arrayish.length)) return false;
        for(var i = 0; i < arrayish.length; i++){
            if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) return false;
        }
        return true;
    }
    function coerceArray(arg, copy) {
        // ArrayBuffer view
        if (arg.buffer && ArrayBuffer.isView(arg) && arg.name === "Uint8Array") {
            if (copy) {
                if (arg.slice) arg = arg.slice();
                else arg = Array.prototype.slice.call(arg);
            }
            return arg;
        }
        // It's an array; check it is a valid representation of a byte
        if (Array.isArray(arg)) {
            if (!checkInts(arg)) throw new Error("Array contains invalid value: " + arg);
            return new Uint8Array(arg);
        }
        // Something else, but behaves like an array (maybe a Buffer? Arguments?)
        if (checkInt(arg.length) && checkInts(arg)) return new Uint8Array(arg);
        throw new Error("unsupported array-like object");
    }
    function createArray(length) {
        return new Uint8Array(length);
    }
    function copyArray(sourceArray, targetArray, targetStart, sourceStart, sourceEnd) {
        if (sourceStart != null || sourceEnd != null) {
            if (sourceArray.slice) sourceArray = sourceArray.slice(sourceStart, sourceEnd);
            else sourceArray = Array.prototype.slice.call(sourceArray, sourceStart, sourceEnd);
        }
        targetArray.set(sourceArray, targetStart);
    }
    var convertUtf8 = function() {
        function toBytes(text) {
            var result = [], i = 0;
            text = encodeURI(text);
            while(i < text.length){
                var c = text.charCodeAt(i++);
                // if it is a % sign, encode the following 2 bytes as a hex value
                if (c === 37) {
                    result.push(parseInt(text.substr(i, 2), 16));
                    i += 2;
                // otherwise, just the actual byte
                } else result.push(c);
            }
            return coerceArray(result);
        }
        function fromBytes(bytes) {
            var result = [], i = 0;
            while(i < bytes.length){
                var c = bytes[i];
                if (c < 128) {
                    result.push(String.fromCharCode(c));
                    i++;
                } else if (c > 191 && c < 224) {
                    result.push(String.fromCharCode((c & 0x1f) << 6 | bytes[i + 1] & 0x3f));
                    i += 2;
                } else {
                    result.push(String.fromCharCode((c & 0x0f) << 12 | (bytes[i + 1] & 0x3f) << 6 | bytes[i + 2] & 0x3f));
                    i += 3;
                }
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    var convertHex = function() {
        function toBytes(text) {
            var result = [];
            for(var i = 0; i < text.length; i += 2)result.push(parseInt(text.substr(i, 2), 16));
            return result;
        }
        // http://ixti.net/development/javascript/2011/11/11/base64-encodedecode-of-utf8-in-browser-with-js.html
        var Hex = "0123456789abcdef";
        function fromBytes(bytes) {
            var result = [];
            for(var i = 0; i < bytes.length; i++){
                var v = bytes[i];
                result.push(Hex[(v & 0xf0) >> 4] + Hex[v & 0x0f]);
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    // Number of rounds by keysize
    var numberOfRounds = {
        16: 10,
        24: 12,
        32: 14
    };
    // Round constant words
    var rcon = [
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1b,
        0x36,
        0x6c,
        0xd8,
        0xab,
        0x4d,
        0x9a,
        0x2f,
        0x5e,
        0xbc,
        0x63,
        0xc6,
        0x97,
        0x35,
        0x6a,
        0xd4,
        0xb3,
        0x7d,
        0xfa,
        0xef,
        0xc5,
        0x91
    ];
    // S-box and Inverse S-box (S is for Substitution)
    var S = [
        0x63,
        0x7c,
        0x77,
        0x7b,
        0xf2,
        0x6b,
        0x6f,
        0xc5,
        0x30,
        0x01,
        0x67,
        0x2b,
        0xfe,
        0xd7,
        0xab,
        0x76,
        0xca,
        0x82,
        0xc9,
        0x7d,
        0xfa,
        0x59,
        0x47,
        0xf0,
        0xad,
        0xd4,
        0xa2,
        0xaf,
        0x9c,
        0xa4,
        0x72,
        0xc0,
        0xb7,
        0xfd,
        0x93,
        0x26,
        0x36,
        0x3f,
        0xf7,
        0xcc,
        0x34,
        0xa5,
        0xe5,
        0xf1,
        0x71,
        0xd8,
        0x31,
        0x15,
        0x04,
        0xc7,
        0x23,
        0xc3,
        0x18,
        0x96,
        0x05,
        0x9a,
        0x07,
        0x12,
        0x80,
        0xe2,
        0xeb,
        0x27,
        0xb2,
        0x75,
        0x09,
        0x83,
        0x2c,
        0x1a,
        0x1b,
        0x6e,
        0x5a,
        0xa0,
        0x52,
        0x3b,
        0xd6,
        0xb3,
        0x29,
        0xe3,
        0x2f,
        0x84,
        0x53,
        0xd1,
        0x00,
        0xed,
        0x20,
        0xfc,
        0xb1,
        0x5b,
        0x6a,
        0xcb,
        0xbe,
        0x39,
        0x4a,
        0x4c,
        0x58,
        0xcf,
        0xd0,
        0xef,
        0xaa,
        0xfb,
        0x43,
        0x4d,
        0x33,
        0x85,
        0x45,
        0xf9,
        0x02,
        0x7f,
        0x50,
        0x3c,
        0x9f,
        0xa8,
        0x51,
        0xa3,
        0x40,
        0x8f,
        0x92,
        0x9d,
        0x38,
        0xf5,
        0xbc,
        0xb6,
        0xda,
        0x21,
        0x10,
        0xff,
        0xf3,
        0xd2,
        0xcd,
        0x0c,
        0x13,
        0xec,
        0x5f,
        0x97,
        0x44,
        0x17,
        0xc4,
        0xa7,
        0x7e,
        0x3d,
        0x64,
        0x5d,
        0x19,
        0x73,
        0x60,
        0x81,
        0x4f,
        0xdc,
        0x22,
        0x2a,
        0x90,
        0x88,
        0x46,
        0xee,
        0xb8,
        0x14,
        0xde,
        0x5e,
        0x0b,
        0xdb,
        0xe0,
        0x32,
        0x3a,
        0x0a,
        0x49,
        0x06,
        0x24,
        0x5c,
        0xc2,
        0xd3,
        0xac,
        0x62,
        0x91,
        0x95,
        0xe4,
        0x79,
        0xe7,
        0xc8,
        0x37,
        0x6d,
        0x8d,
        0xd5,
        0x4e,
        0xa9,
        0x6c,
        0x56,
        0xf4,
        0xea,
        0x65,
        0x7a,
        0xae,
        0x08,
        0xba,
        0x78,
        0x25,
        0x2e,
        0x1c,
        0xa6,
        0xb4,
        0xc6,
        0xe8,
        0xdd,
        0x74,
        0x1f,
        0x4b,
        0xbd,
        0x8b,
        0x8a,
        0x70,
        0x3e,
        0xb5,
        0x66,
        0x48,
        0x03,
        0xf6,
        0x0e,
        0x61,
        0x35,
        0x57,
        0xb9,
        0x86,
        0xc1,
        0x1d,
        0x9e,
        0xe1,
        0xf8,
        0x98,
        0x11,
        0x69,
        0xd9,
        0x8e,
        0x94,
        0x9b,
        0x1e,
        0x87,
        0xe9,
        0xce,
        0x55,
        0x28,
        0xdf,
        0x8c,
        0xa1,
        0x89,
        0x0d,
        0xbf,
        0xe6,
        0x42,
        0x68,
        0x41,
        0x99,
        0x2d,
        0x0f,
        0xb0,
        0x54,
        0xbb,
        0x16
    ];
    var Si = [
        0x52,
        0x09,
        0x6a,
        0xd5,
        0x30,
        0x36,
        0xa5,
        0x38,
        0xbf,
        0x40,
        0xa3,
        0x9e,
        0x81,
        0xf3,
        0xd7,
        0xfb,
        0x7c,
        0xe3,
        0x39,
        0x82,
        0x9b,
        0x2f,
        0xff,
        0x87,
        0x34,
        0x8e,
        0x43,
        0x44,
        0xc4,
        0xde,
        0xe9,
        0xcb,
        0x54,
        0x7b,
        0x94,
        0x32,
        0xa6,
        0xc2,
        0x23,
        0x3d,
        0xee,
        0x4c,
        0x95,
        0x0b,
        0x42,
        0xfa,
        0xc3,
        0x4e,
        0x08,
        0x2e,
        0xa1,
        0x66,
        0x28,
        0xd9,
        0x24,
        0xb2,
        0x76,
        0x5b,
        0xa2,
        0x49,
        0x6d,
        0x8b,
        0xd1,
        0x25,
        0x72,
        0xf8,
        0xf6,
        0x64,
        0x86,
        0x68,
        0x98,
        0x16,
        0xd4,
        0xa4,
        0x5c,
        0xcc,
        0x5d,
        0x65,
        0xb6,
        0x92,
        0x6c,
        0x70,
        0x48,
        0x50,
        0xfd,
        0xed,
        0xb9,
        0xda,
        0x5e,
        0x15,
        0x46,
        0x57,
        0xa7,
        0x8d,
        0x9d,
        0x84,
        0x90,
        0xd8,
        0xab,
        0x00,
        0x8c,
        0xbc,
        0xd3,
        0x0a,
        0xf7,
        0xe4,
        0x58,
        0x05,
        0xb8,
        0xb3,
        0x45,
        0x06,
        0xd0,
        0x2c,
        0x1e,
        0x8f,
        0xca,
        0x3f,
        0x0f,
        0x02,
        0xc1,
        0xaf,
        0xbd,
        0x03,
        0x01,
        0x13,
        0x8a,
        0x6b,
        0x3a,
        0x91,
        0x11,
        0x41,
        0x4f,
        0x67,
        0xdc,
        0xea,
        0x97,
        0xf2,
        0xcf,
        0xce,
        0xf0,
        0xb4,
        0xe6,
        0x73,
        0x96,
        0xac,
        0x74,
        0x22,
        0xe7,
        0xad,
        0x35,
        0x85,
        0xe2,
        0xf9,
        0x37,
        0xe8,
        0x1c,
        0x75,
        0xdf,
        0x6e,
        0x47,
        0xf1,
        0x1a,
        0x71,
        0x1d,
        0x29,
        0xc5,
        0x89,
        0x6f,
        0xb7,
        0x62,
        0x0e,
        0xaa,
        0x18,
        0xbe,
        0x1b,
        0xfc,
        0x56,
        0x3e,
        0x4b,
        0xc6,
        0xd2,
        0x79,
        0x20,
        0x9a,
        0xdb,
        0xc0,
        0xfe,
        0x78,
        0xcd,
        0x5a,
        0xf4,
        0x1f,
        0xdd,
        0xa8,
        0x33,
        0x88,
        0x07,
        0xc7,
        0x31,
        0xb1,
        0x12,
        0x10,
        0x59,
        0x27,
        0x80,
        0xec,
        0x5f,
        0x60,
        0x51,
        0x7f,
        0xa9,
        0x19,
        0xb5,
        0x4a,
        0x0d,
        0x2d,
        0xe5,
        0x7a,
        0x9f,
        0x93,
        0xc9,
        0x9c,
        0xef,
        0xa0,
        0xe0,
        0x3b,
        0x4d,
        0xae,
        0x2a,
        0xf5,
        0xb0,
        0xc8,
        0xeb,
        0xbb,
        0x3c,
        0x83,
        0x53,
        0x99,
        0x61,
        0x17,
        0x2b,
        0x04,
        0x7e,
        0xba,
        0x77,
        0xd6,
        0x26,
        0xe1,
        0x69,
        0x14,
        0x63,
        0x55,
        0x21,
        0x0c,
        0x7d
    ];
    // Transformations for encryption
    var T1 = [
        0xc66363a5,
        0xf87c7c84,
        0xee777799,
        0xf67b7b8d,
        0xfff2f20d,
        0xd66b6bbd,
        0xde6f6fb1,
        0x91c5c554,
        0x60303050,
        0x02010103,
        0xce6767a9,
        0x562b2b7d,
        0xe7fefe19,
        0xb5d7d762,
        0x4dababe6,
        0xec76769a,
        0x8fcaca45,
        0x1f82829d,
        0x89c9c940,
        0xfa7d7d87,
        0xeffafa15,
        0xb25959eb,
        0x8e4747c9,
        0xfbf0f00b,
        0x41adadec,
        0xb3d4d467,
        0x5fa2a2fd,
        0x45afafea,
        0x239c9cbf,
        0x53a4a4f7,
        0xe4727296,
        0x9bc0c05b,
        0x75b7b7c2,
        0xe1fdfd1c,
        0x3d9393ae,
        0x4c26266a,
        0x6c36365a,
        0x7e3f3f41,
        0xf5f7f702,
        0x83cccc4f,
        0x6834345c,
        0x51a5a5f4,
        0xd1e5e534,
        0xf9f1f108,
        0xe2717193,
        0xabd8d873,
        0x62313153,
        0x2a15153f,
        0x0804040c,
        0x95c7c752,
        0x46232365,
        0x9dc3c35e,
        0x30181828,
        0x379696a1,
        0x0a05050f,
        0x2f9a9ab5,
        0x0e070709,
        0x24121236,
        0x1b80809b,
        0xdfe2e23d,
        0xcdebeb26,
        0x4e272769,
        0x7fb2b2cd,
        0xea75759f,
        0x1209091b,
        0x1d83839e,
        0x582c2c74,
        0x341a1a2e,
        0x361b1b2d,
        0xdc6e6eb2,
        0xb45a5aee,
        0x5ba0a0fb,
        0xa45252f6,
        0x763b3b4d,
        0xb7d6d661,
        0x7db3b3ce,
        0x5229297b,
        0xdde3e33e,
        0x5e2f2f71,
        0x13848497,
        0xa65353f5,
        0xb9d1d168,
        0x00000000,
        0xc1eded2c,
        0x40202060,
        0xe3fcfc1f,
        0x79b1b1c8,
        0xb65b5bed,
        0xd46a6abe,
        0x8dcbcb46,
        0x67bebed9,
        0x7239394b,
        0x944a4ade,
        0x984c4cd4,
        0xb05858e8,
        0x85cfcf4a,
        0xbbd0d06b,
        0xc5efef2a,
        0x4faaaae5,
        0xedfbfb16,
        0x864343c5,
        0x9a4d4dd7,
        0x66333355,
        0x11858594,
        0x8a4545cf,
        0xe9f9f910,
        0x04020206,
        0xfe7f7f81,
        0xa05050f0,
        0x783c3c44,
        0x259f9fba,
        0x4ba8a8e3,
        0xa25151f3,
        0x5da3a3fe,
        0x804040c0,
        0x058f8f8a,
        0x3f9292ad,
        0x219d9dbc,
        0x70383848,
        0xf1f5f504,
        0x63bcbcdf,
        0x77b6b6c1,
        0xafdada75,
        0x42212163,
        0x20101030,
        0xe5ffff1a,
        0xfdf3f30e,
        0xbfd2d26d,
        0x81cdcd4c,
        0x180c0c14,
        0x26131335,
        0xc3ecec2f,
        0xbe5f5fe1,
        0x359797a2,
        0x884444cc,
        0x2e171739,
        0x93c4c457,
        0x55a7a7f2,
        0xfc7e7e82,
        0x7a3d3d47,
        0xc86464ac,
        0xba5d5de7,
        0x3219192b,
        0xe6737395,
        0xc06060a0,
        0x19818198,
        0x9e4f4fd1,
        0xa3dcdc7f,
        0x44222266,
        0x542a2a7e,
        0x3b9090ab,
        0x0b888883,
        0x8c4646ca,
        0xc7eeee29,
        0x6bb8b8d3,
        0x2814143c,
        0xa7dede79,
        0xbc5e5ee2,
        0x160b0b1d,
        0xaddbdb76,
        0xdbe0e03b,
        0x64323256,
        0x743a3a4e,
        0x140a0a1e,
        0x924949db,
        0x0c06060a,
        0x4824246c,
        0xb85c5ce4,
        0x9fc2c25d,
        0xbdd3d36e,
        0x43acacef,
        0xc46262a6,
        0x399191a8,
        0x319595a4,
        0xd3e4e437,
        0xf279798b,
        0xd5e7e732,
        0x8bc8c843,
        0x6e373759,
        0xda6d6db7,
        0x018d8d8c,
        0xb1d5d564,
        0x9c4e4ed2,
        0x49a9a9e0,
        0xd86c6cb4,
        0xac5656fa,
        0xf3f4f407,
        0xcfeaea25,
        0xca6565af,
        0xf47a7a8e,
        0x47aeaee9,
        0x10080818,
        0x6fbabad5,
        0xf0787888,
        0x4a25256f,
        0x5c2e2e72,
        0x381c1c24,
        0x57a6a6f1,
        0x73b4b4c7,
        0x97c6c651,
        0xcbe8e823,
        0xa1dddd7c,
        0xe874749c,
        0x3e1f1f21,
        0x964b4bdd,
        0x61bdbddc,
        0x0d8b8b86,
        0x0f8a8a85,
        0xe0707090,
        0x7c3e3e42,
        0x71b5b5c4,
        0xcc6666aa,
        0x904848d8,
        0x06030305,
        0xf7f6f601,
        0x1c0e0e12,
        0xc26161a3,
        0x6a35355f,
        0xae5757f9,
        0x69b9b9d0,
        0x17868691,
        0x99c1c158,
        0x3a1d1d27,
        0x279e9eb9,
        0xd9e1e138,
        0xebf8f813,
        0x2b9898b3,
        0x22111133,
        0xd26969bb,
        0xa9d9d970,
        0x078e8e89,
        0x339494a7,
        0x2d9b9bb6,
        0x3c1e1e22,
        0x15878792,
        0xc9e9e920,
        0x87cece49,
        0xaa5555ff,
        0x50282878,
        0xa5dfdf7a,
        0x038c8c8f,
        0x59a1a1f8,
        0x09898980,
        0x1a0d0d17,
        0x65bfbfda,
        0xd7e6e631,
        0x844242c6,
        0xd06868b8,
        0x824141c3,
        0x299999b0,
        0x5a2d2d77,
        0x1e0f0f11,
        0x7bb0b0cb,
        0xa85454fc,
        0x6dbbbbd6,
        0x2c16163a
    ];
    var T2 = [
        0xa5c66363,
        0x84f87c7c,
        0x99ee7777,
        0x8df67b7b,
        0x0dfff2f2,
        0xbdd66b6b,
        0xb1de6f6f,
        0x5491c5c5,
        0x50603030,
        0x03020101,
        0xa9ce6767,
        0x7d562b2b,
        0x19e7fefe,
        0x62b5d7d7,
        0xe64dabab,
        0x9aec7676,
        0x458fcaca,
        0x9d1f8282,
        0x4089c9c9,
        0x87fa7d7d,
        0x15effafa,
        0xebb25959,
        0xc98e4747,
        0x0bfbf0f0,
        0xec41adad,
        0x67b3d4d4,
        0xfd5fa2a2,
        0xea45afaf,
        0xbf239c9c,
        0xf753a4a4,
        0x96e47272,
        0x5b9bc0c0,
        0xc275b7b7,
        0x1ce1fdfd,
        0xae3d9393,
        0x6a4c2626,
        0x5a6c3636,
        0x417e3f3f,
        0x02f5f7f7,
        0x4f83cccc,
        0x5c683434,
        0xf451a5a5,
        0x34d1e5e5,
        0x08f9f1f1,
        0x93e27171,
        0x73abd8d8,
        0x53623131,
        0x3f2a1515,
        0x0c080404,
        0x5295c7c7,
        0x65462323,
        0x5e9dc3c3,
        0x28301818,
        0xa1379696,
        0x0f0a0505,
        0xb52f9a9a,
        0x090e0707,
        0x36241212,
        0x9b1b8080,
        0x3ddfe2e2,
        0x26cdebeb,
        0x694e2727,
        0xcd7fb2b2,
        0x9fea7575,
        0x1b120909,
        0x9e1d8383,
        0x74582c2c,
        0x2e341a1a,
        0x2d361b1b,
        0xb2dc6e6e,
        0xeeb45a5a,
        0xfb5ba0a0,
        0xf6a45252,
        0x4d763b3b,
        0x61b7d6d6,
        0xce7db3b3,
        0x7b522929,
        0x3edde3e3,
        0x715e2f2f,
        0x97138484,
        0xf5a65353,
        0x68b9d1d1,
        0x00000000,
        0x2cc1eded,
        0x60402020,
        0x1fe3fcfc,
        0xc879b1b1,
        0xedb65b5b,
        0xbed46a6a,
        0x468dcbcb,
        0xd967bebe,
        0x4b723939,
        0xde944a4a,
        0xd4984c4c,
        0xe8b05858,
        0x4a85cfcf,
        0x6bbbd0d0,
        0x2ac5efef,
        0xe54faaaa,
        0x16edfbfb,
        0xc5864343,
        0xd79a4d4d,
        0x55663333,
        0x94118585,
        0xcf8a4545,
        0x10e9f9f9,
        0x06040202,
        0x81fe7f7f,
        0xf0a05050,
        0x44783c3c,
        0xba259f9f,
        0xe34ba8a8,
        0xf3a25151,
        0xfe5da3a3,
        0xc0804040,
        0x8a058f8f,
        0xad3f9292,
        0xbc219d9d,
        0x48703838,
        0x04f1f5f5,
        0xdf63bcbc,
        0xc177b6b6,
        0x75afdada,
        0x63422121,
        0x30201010,
        0x1ae5ffff,
        0x0efdf3f3,
        0x6dbfd2d2,
        0x4c81cdcd,
        0x14180c0c,
        0x35261313,
        0x2fc3ecec,
        0xe1be5f5f,
        0xa2359797,
        0xcc884444,
        0x392e1717,
        0x5793c4c4,
        0xf255a7a7,
        0x82fc7e7e,
        0x477a3d3d,
        0xacc86464,
        0xe7ba5d5d,
        0x2b321919,
        0x95e67373,
        0xa0c06060,
        0x98198181,
        0xd19e4f4f,
        0x7fa3dcdc,
        0x66442222,
        0x7e542a2a,
        0xab3b9090,
        0x830b8888,
        0xca8c4646,
        0x29c7eeee,
        0xd36bb8b8,
        0x3c281414,
        0x79a7dede,
        0xe2bc5e5e,
        0x1d160b0b,
        0x76addbdb,
        0x3bdbe0e0,
        0x56643232,
        0x4e743a3a,
        0x1e140a0a,
        0xdb924949,
        0x0a0c0606,
        0x6c482424,
        0xe4b85c5c,
        0x5d9fc2c2,
        0x6ebdd3d3,
        0xef43acac,
        0xa6c46262,
        0xa8399191,
        0xa4319595,
        0x37d3e4e4,
        0x8bf27979,
        0x32d5e7e7,
        0x438bc8c8,
        0x596e3737,
        0xb7da6d6d,
        0x8c018d8d,
        0x64b1d5d5,
        0xd29c4e4e,
        0xe049a9a9,
        0xb4d86c6c,
        0xfaac5656,
        0x07f3f4f4,
        0x25cfeaea,
        0xafca6565,
        0x8ef47a7a,
        0xe947aeae,
        0x18100808,
        0xd56fbaba,
        0x88f07878,
        0x6f4a2525,
        0x725c2e2e,
        0x24381c1c,
        0xf157a6a6,
        0xc773b4b4,
        0x5197c6c6,
        0x23cbe8e8,
        0x7ca1dddd,
        0x9ce87474,
        0x213e1f1f,
        0xdd964b4b,
        0xdc61bdbd,
        0x860d8b8b,
        0x850f8a8a,
        0x90e07070,
        0x427c3e3e,
        0xc471b5b5,
        0xaacc6666,
        0xd8904848,
        0x05060303,
        0x01f7f6f6,
        0x121c0e0e,
        0xa3c26161,
        0x5f6a3535,
        0xf9ae5757,
        0xd069b9b9,
        0x91178686,
        0x5899c1c1,
        0x273a1d1d,
        0xb9279e9e,
        0x38d9e1e1,
        0x13ebf8f8,
        0xb32b9898,
        0x33221111,
        0xbbd26969,
        0x70a9d9d9,
        0x89078e8e,
        0xa7339494,
        0xb62d9b9b,
        0x223c1e1e,
        0x92158787,
        0x20c9e9e9,
        0x4987cece,
        0xffaa5555,
        0x78502828,
        0x7aa5dfdf,
        0x8f038c8c,
        0xf859a1a1,
        0x80098989,
        0x171a0d0d,
        0xda65bfbf,
        0x31d7e6e6,
        0xc6844242,
        0xb8d06868,
        0xc3824141,
        0xb0299999,
        0x775a2d2d,
        0x111e0f0f,
        0xcb7bb0b0,
        0xfca85454,
        0xd66dbbbb,
        0x3a2c1616
    ];
    var T3 = [
        0x63a5c663,
        0x7c84f87c,
        0x7799ee77,
        0x7b8df67b,
        0xf20dfff2,
        0x6bbdd66b,
        0x6fb1de6f,
        0xc55491c5,
        0x30506030,
        0x01030201,
        0x67a9ce67,
        0x2b7d562b,
        0xfe19e7fe,
        0xd762b5d7,
        0xabe64dab,
        0x769aec76,
        0xca458fca,
        0x829d1f82,
        0xc94089c9,
        0x7d87fa7d,
        0xfa15effa,
        0x59ebb259,
        0x47c98e47,
        0xf00bfbf0,
        0xadec41ad,
        0xd467b3d4,
        0xa2fd5fa2,
        0xafea45af,
        0x9cbf239c,
        0xa4f753a4,
        0x7296e472,
        0xc05b9bc0,
        0xb7c275b7,
        0xfd1ce1fd,
        0x93ae3d93,
        0x266a4c26,
        0x365a6c36,
        0x3f417e3f,
        0xf702f5f7,
        0xcc4f83cc,
        0x345c6834,
        0xa5f451a5,
        0xe534d1e5,
        0xf108f9f1,
        0x7193e271,
        0xd873abd8,
        0x31536231,
        0x153f2a15,
        0x040c0804,
        0xc75295c7,
        0x23654623,
        0xc35e9dc3,
        0x18283018,
        0x96a13796,
        0x050f0a05,
        0x9ab52f9a,
        0x07090e07,
        0x12362412,
        0x809b1b80,
        0xe23ddfe2,
        0xeb26cdeb,
        0x27694e27,
        0xb2cd7fb2,
        0x759fea75,
        0x091b1209,
        0x839e1d83,
        0x2c74582c,
        0x1a2e341a,
        0x1b2d361b,
        0x6eb2dc6e,
        0x5aeeb45a,
        0xa0fb5ba0,
        0x52f6a452,
        0x3b4d763b,
        0xd661b7d6,
        0xb3ce7db3,
        0x297b5229,
        0xe33edde3,
        0x2f715e2f,
        0x84971384,
        0x53f5a653,
        0xd168b9d1,
        0x00000000,
        0xed2cc1ed,
        0x20604020,
        0xfc1fe3fc,
        0xb1c879b1,
        0x5bedb65b,
        0x6abed46a,
        0xcb468dcb,
        0xbed967be,
        0x394b7239,
        0x4ade944a,
        0x4cd4984c,
        0x58e8b058,
        0xcf4a85cf,
        0xd06bbbd0,
        0xef2ac5ef,
        0xaae54faa,
        0xfb16edfb,
        0x43c58643,
        0x4dd79a4d,
        0x33556633,
        0x85941185,
        0x45cf8a45,
        0xf910e9f9,
        0x02060402,
        0x7f81fe7f,
        0x50f0a050,
        0x3c44783c,
        0x9fba259f,
        0xa8e34ba8,
        0x51f3a251,
        0xa3fe5da3,
        0x40c08040,
        0x8f8a058f,
        0x92ad3f92,
        0x9dbc219d,
        0x38487038,
        0xf504f1f5,
        0xbcdf63bc,
        0xb6c177b6,
        0xda75afda,
        0x21634221,
        0x10302010,
        0xff1ae5ff,
        0xf30efdf3,
        0xd26dbfd2,
        0xcd4c81cd,
        0x0c14180c,
        0x13352613,
        0xec2fc3ec,
        0x5fe1be5f,
        0x97a23597,
        0x44cc8844,
        0x17392e17,
        0xc45793c4,
        0xa7f255a7,
        0x7e82fc7e,
        0x3d477a3d,
        0x64acc864,
        0x5de7ba5d,
        0x192b3219,
        0x7395e673,
        0x60a0c060,
        0x81981981,
        0x4fd19e4f,
        0xdc7fa3dc,
        0x22664422,
        0x2a7e542a,
        0x90ab3b90,
        0x88830b88,
        0x46ca8c46,
        0xee29c7ee,
        0xb8d36bb8,
        0x143c2814,
        0xde79a7de,
        0x5ee2bc5e,
        0x0b1d160b,
        0xdb76addb,
        0xe03bdbe0,
        0x32566432,
        0x3a4e743a,
        0x0a1e140a,
        0x49db9249,
        0x060a0c06,
        0x246c4824,
        0x5ce4b85c,
        0xc25d9fc2,
        0xd36ebdd3,
        0xacef43ac,
        0x62a6c462,
        0x91a83991,
        0x95a43195,
        0xe437d3e4,
        0x798bf279,
        0xe732d5e7,
        0xc8438bc8,
        0x37596e37,
        0x6db7da6d,
        0x8d8c018d,
        0xd564b1d5,
        0x4ed29c4e,
        0xa9e049a9,
        0x6cb4d86c,
        0x56faac56,
        0xf407f3f4,
        0xea25cfea,
        0x65afca65,
        0x7a8ef47a,
        0xaee947ae,
        0x08181008,
        0xbad56fba,
        0x7888f078,
        0x256f4a25,
        0x2e725c2e,
        0x1c24381c,
        0xa6f157a6,
        0xb4c773b4,
        0xc65197c6,
        0xe823cbe8,
        0xdd7ca1dd,
        0x749ce874,
        0x1f213e1f,
        0x4bdd964b,
        0xbddc61bd,
        0x8b860d8b,
        0x8a850f8a,
        0x7090e070,
        0x3e427c3e,
        0xb5c471b5,
        0x66aacc66,
        0x48d89048,
        0x03050603,
        0xf601f7f6,
        0x0e121c0e,
        0x61a3c261,
        0x355f6a35,
        0x57f9ae57,
        0xb9d069b9,
        0x86911786,
        0xc15899c1,
        0x1d273a1d,
        0x9eb9279e,
        0xe138d9e1,
        0xf813ebf8,
        0x98b32b98,
        0x11332211,
        0x69bbd269,
        0xd970a9d9,
        0x8e89078e,
        0x94a73394,
        0x9bb62d9b,
        0x1e223c1e,
        0x87921587,
        0xe920c9e9,
        0xce4987ce,
        0x55ffaa55,
        0x28785028,
        0xdf7aa5df,
        0x8c8f038c,
        0xa1f859a1,
        0x89800989,
        0x0d171a0d,
        0xbfda65bf,
        0xe631d7e6,
        0x42c68442,
        0x68b8d068,
        0x41c38241,
        0x99b02999,
        0x2d775a2d,
        0x0f111e0f,
        0xb0cb7bb0,
        0x54fca854,
        0xbbd66dbb,
        0x163a2c16
    ];
    var T4 = [
        0x6363a5c6,
        0x7c7c84f8,
        0x777799ee,
        0x7b7b8df6,
        0xf2f20dff,
        0x6b6bbdd6,
        0x6f6fb1de,
        0xc5c55491,
        0x30305060,
        0x01010302,
        0x6767a9ce,
        0x2b2b7d56,
        0xfefe19e7,
        0xd7d762b5,
        0xababe64d,
        0x76769aec,
        0xcaca458f,
        0x82829d1f,
        0xc9c94089,
        0x7d7d87fa,
        0xfafa15ef,
        0x5959ebb2,
        0x4747c98e,
        0xf0f00bfb,
        0xadadec41,
        0xd4d467b3,
        0xa2a2fd5f,
        0xafafea45,
        0x9c9cbf23,
        0xa4a4f753,
        0x727296e4,
        0xc0c05b9b,
        0xb7b7c275,
        0xfdfd1ce1,
        0x9393ae3d,
        0x26266a4c,
        0x36365a6c,
        0x3f3f417e,
        0xf7f702f5,
        0xcccc4f83,
        0x34345c68,
        0xa5a5f451,
        0xe5e534d1,
        0xf1f108f9,
        0x717193e2,
        0xd8d873ab,
        0x31315362,
        0x15153f2a,
        0x04040c08,
        0xc7c75295,
        0x23236546,
        0xc3c35e9d,
        0x18182830,
        0x9696a137,
        0x05050f0a,
        0x9a9ab52f,
        0x0707090e,
        0x12123624,
        0x80809b1b,
        0xe2e23ddf,
        0xebeb26cd,
        0x2727694e,
        0xb2b2cd7f,
        0x75759fea,
        0x09091b12,
        0x83839e1d,
        0x2c2c7458,
        0x1a1a2e34,
        0x1b1b2d36,
        0x6e6eb2dc,
        0x5a5aeeb4,
        0xa0a0fb5b,
        0x5252f6a4,
        0x3b3b4d76,
        0xd6d661b7,
        0xb3b3ce7d,
        0x29297b52,
        0xe3e33edd,
        0x2f2f715e,
        0x84849713,
        0x5353f5a6,
        0xd1d168b9,
        0x00000000,
        0xeded2cc1,
        0x20206040,
        0xfcfc1fe3,
        0xb1b1c879,
        0x5b5bedb6,
        0x6a6abed4,
        0xcbcb468d,
        0xbebed967,
        0x39394b72,
        0x4a4ade94,
        0x4c4cd498,
        0x5858e8b0,
        0xcfcf4a85,
        0xd0d06bbb,
        0xefef2ac5,
        0xaaaae54f,
        0xfbfb16ed,
        0x4343c586,
        0x4d4dd79a,
        0x33335566,
        0x85859411,
        0x4545cf8a,
        0xf9f910e9,
        0x02020604,
        0x7f7f81fe,
        0x5050f0a0,
        0x3c3c4478,
        0x9f9fba25,
        0xa8a8e34b,
        0x5151f3a2,
        0xa3a3fe5d,
        0x4040c080,
        0x8f8f8a05,
        0x9292ad3f,
        0x9d9dbc21,
        0x38384870,
        0xf5f504f1,
        0xbcbcdf63,
        0xb6b6c177,
        0xdada75af,
        0x21216342,
        0x10103020,
        0xffff1ae5,
        0xf3f30efd,
        0xd2d26dbf,
        0xcdcd4c81,
        0x0c0c1418,
        0x13133526,
        0xecec2fc3,
        0x5f5fe1be,
        0x9797a235,
        0x4444cc88,
        0x1717392e,
        0xc4c45793,
        0xa7a7f255,
        0x7e7e82fc,
        0x3d3d477a,
        0x6464acc8,
        0x5d5de7ba,
        0x19192b32,
        0x737395e6,
        0x6060a0c0,
        0x81819819,
        0x4f4fd19e,
        0xdcdc7fa3,
        0x22226644,
        0x2a2a7e54,
        0x9090ab3b,
        0x8888830b,
        0x4646ca8c,
        0xeeee29c7,
        0xb8b8d36b,
        0x14143c28,
        0xdede79a7,
        0x5e5ee2bc,
        0x0b0b1d16,
        0xdbdb76ad,
        0xe0e03bdb,
        0x32325664,
        0x3a3a4e74,
        0x0a0a1e14,
        0x4949db92,
        0x06060a0c,
        0x24246c48,
        0x5c5ce4b8,
        0xc2c25d9f,
        0xd3d36ebd,
        0xacacef43,
        0x6262a6c4,
        0x9191a839,
        0x9595a431,
        0xe4e437d3,
        0x79798bf2,
        0xe7e732d5,
        0xc8c8438b,
        0x3737596e,
        0x6d6db7da,
        0x8d8d8c01,
        0xd5d564b1,
        0x4e4ed29c,
        0xa9a9e049,
        0x6c6cb4d8,
        0x5656faac,
        0xf4f407f3,
        0xeaea25cf,
        0x6565afca,
        0x7a7a8ef4,
        0xaeaee947,
        0x08081810,
        0xbabad56f,
        0x787888f0,
        0x25256f4a,
        0x2e2e725c,
        0x1c1c2438,
        0xa6a6f157,
        0xb4b4c773,
        0xc6c65197,
        0xe8e823cb,
        0xdddd7ca1,
        0x74749ce8,
        0x1f1f213e,
        0x4b4bdd96,
        0xbdbddc61,
        0x8b8b860d,
        0x8a8a850f,
        0x707090e0,
        0x3e3e427c,
        0xb5b5c471,
        0x6666aacc,
        0x4848d890,
        0x03030506,
        0xf6f601f7,
        0x0e0e121c,
        0x6161a3c2,
        0x35355f6a,
        0x5757f9ae,
        0xb9b9d069,
        0x86869117,
        0xc1c15899,
        0x1d1d273a,
        0x9e9eb927,
        0xe1e138d9,
        0xf8f813eb,
        0x9898b32b,
        0x11113322,
        0x6969bbd2,
        0xd9d970a9,
        0x8e8e8907,
        0x9494a733,
        0x9b9bb62d,
        0x1e1e223c,
        0x87879215,
        0xe9e920c9,
        0xcece4987,
        0x5555ffaa,
        0x28287850,
        0xdfdf7aa5,
        0x8c8c8f03,
        0xa1a1f859,
        0x89898009,
        0x0d0d171a,
        0xbfbfda65,
        0xe6e631d7,
        0x4242c684,
        0x6868b8d0,
        0x4141c382,
        0x9999b029,
        0x2d2d775a,
        0x0f0f111e,
        0xb0b0cb7b,
        0x5454fca8,
        0xbbbbd66d,
        0x16163a2c
    ];
    // Transformations for decryption
    var T5 = [
        0x51f4a750,
        0x7e416553,
        0x1a17a4c3,
        0x3a275e96,
        0x3bab6bcb,
        0x1f9d45f1,
        0xacfa58ab,
        0x4be30393,
        0x2030fa55,
        0xad766df6,
        0x88cc7691,
        0xf5024c25,
        0x4fe5d7fc,
        0xc52acbd7,
        0x26354480,
        0xb562a38f,
        0xdeb15a49,
        0x25ba1b67,
        0x45ea0e98,
        0x5dfec0e1,
        0xc32f7502,
        0x814cf012,
        0x8d4697a3,
        0x6bd3f9c6,
        0x038f5fe7,
        0x15929c95,
        0xbf6d7aeb,
        0x955259da,
        0xd4be832d,
        0x587421d3,
        0x49e06929,
        0x8ec9c844,
        0x75c2896a,
        0xf48e7978,
        0x99583e6b,
        0x27b971dd,
        0xbee14fb6,
        0xf088ad17,
        0xc920ac66,
        0x7dce3ab4,
        0x63df4a18,
        0xe51a3182,
        0x97513360,
        0x62537f45,
        0xb16477e0,
        0xbb6bae84,
        0xfe81a01c,
        0xf9082b94,
        0x70486858,
        0x8f45fd19,
        0x94de6c87,
        0x527bf8b7,
        0xab73d323,
        0x724b02e2,
        0xe31f8f57,
        0x6655ab2a,
        0xb2eb2807,
        0x2fb5c203,
        0x86c57b9a,
        0xd33708a5,
        0x302887f2,
        0x23bfa5b2,
        0x02036aba,
        0xed16825c,
        0x8acf1c2b,
        0xa779b492,
        0xf307f2f0,
        0x4e69e2a1,
        0x65daf4cd,
        0x0605bed5,
        0xd134621f,
        0xc4a6fe8a,
        0x342e539d,
        0xa2f355a0,
        0x058ae132,
        0xa4f6eb75,
        0x0b83ec39,
        0x4060efaa,
        0x5e719f06,
        0xbd6e1051,
        0x3e218af9,
        0x96dd063d,
        0xdd3e05ae,
        0x4de6bd46,
        0x91548db5,
        0x71c45d05,
        0x0406d46f,
        0x605015ff,
        0x1998fb24,
        0xd6bde997,
        0x894043cc,
        0x67d99e77,
        0xb0e842bd,
        0x07898b88,
        0xe7195b38,
        0x79c8eedb,
        0xa17c0a47,
        0x7c420fe9,
        0xf8841ec9,
        0x00000000,
        0x09808683,
        0x322bed48,
        0x1e1170ac,
        0x6c5a724e,
        0xfd0efffb,
        0x0f853856,
        0x3daed51e,
        0x362d3927,
        0x0a0fd964,
        0x685ca621,
        0x9b5b54d1,
        0x24362e3a,
        0x0c0a67b1,
        0x9357e70f,
        0xb4ee96d2,
        0x1b9b919e,
        0x80c0c54f,
        0x61dc20a2,
        0x5a774b69,
        0x1c121a16,
        0xe293ba0a,
        0xc0a02ae5,
        0x3c22e043,
        0x121b171d,
        0x0e090d0b,
        0xf28bc7ad,
        0x2db6a8b9,
        0x141ea9c8,
        0x57f11985,
        0xaf75074c,
        0xee99ddbb,
        0xa37f60fd,
        0xf701269f,
        0x5c72f5bc,
        0x44663bc5,
        0x5bfb7e34,
        0x8b432976,
        0xcb23c6dc,
        0xb6edfc68,
        0xb8e4f163,
        0xd731dcca,
        0x42638510,
        0x13972240,
        0x84c61120,
        0x854a247d,
        0xd2bb3df8,
        0xaef93211,
        0xc729a16d,
        0x1d9e2f4b,
        0xdcb230f3,
        0x0d8652ec,
        0x77c1e3d0,
        0x2bb3166c,
        0xa970b999,
        0x119448fa,
        0x47e96422,
        0xa8fc8cc4,
        0xa0f03f1a,
        0x567d2cd8,
        0x223390ef,
        0x87494ec7,
        0xd938d1c1,
        0x8ccaa2fe,
        0x98d40b36,
        0xa6f581cf,
        0xa57ade28,
        0xdab78e26,
        0x3fadbfa4,
        0x2c3a9de4,
        0x5078920d,
        0x6a5fcc9b,
        0x547e4662,
        0xf68d13c2,
        0x90d8b8e8,
        0x2e39f75e,
        0x82c3aff5,
        0x9f5d80be,
        0x69d0937c,
        0x6fd52da9,
        0xcf2512b3,
        0xc8ac993b,
        0x10187da7,
        0xe89c636e,
        0xdb3bbb7b,
        0xcd267809,
        0x6e5918f4,
        0xec9ab701,
        0x834f9aa8,
        0xe6956e65,
        0xaaffe67e,
        0x21bccf08,
        0xef15e8e6,
        0xbae79bd9,
        0x4a6f36ce,
        0xea9f09d4,
        0x29b07cd6,
        0x31a4b2af,
        0x2a3f2331,
        0xc6a59430,
        0x35a266c0,
        0x744ebc37,
        0xfc82caa6,
        0xe090d0b0,
        0x33a7d815,
        0xf104984a,
        0x41ecdaf7,
        0x7fcd500e,
        0x1791f62f,
        0x764dd68d,
        0x43efb04d,
        0xccaa4d54,
        0xe49604df,
        0x9ed1b5e3,
        0x4c6a881b,
        0xc12c1fb8,
        0x4665517f,
        0x9d5eea04,
        0x018c355d,
        0xfa877473,
        0xfb0b412e,
        0xb3671d5a,
        0x92dbd252,
        0xe9105633,
        0x6dd64713,
        0x9ad7618c,
        0x37a10c7a,
        0x59f8148e,
        0xeb133c89,
        0xcea927ee,
        0xb761c935,
        0xe11ce5ed,
        0x7a47b13c,
        0x9cd2df59,
        0x55f2733f,
        0x1814ce79,
        0x73c737bf,
        0x53f7cdea,
        0x5ffdaa5b,
        0xdf3d6f14,
        0x7844db86,
        0xcaaff381,
        0xb968c43e,
        0x3824342c,
        0xc2a3405f,
        0x161dc372,
        0xbce2250c,
        0x283c498b,
        0xff0d9541,
        0x39a80171,
        0x080cb3de,
        0xd8b4e49c,
        0x6456c190,
        0x7bcb8461,
        0xd532b670,
        0x486c5c74,
        0xd0b85742
    ];
    var T6 = [
        0x5051f4a7,
        0x537e4165,
        0xc31a17a4,
        0x963a275e,
        0xcb3bab6b,
        0xf11f9d45,
        0xabacfa58,
        0x934be303,
        0x552030fa,
        0xf6ad766d,
        0x9188cc76,
        0x25f5024c,
        0xfc4fe5d7,
        0xd7c52acb,
        0x80263544,
        0x8fb562a3,
        0x49deb15a,
        0x6725ba1b,
        0x9845ea0e,
        0xe15dfec0,
        0x02c32f75,
        0x12814cf0,
        0xa38d4697,
        0xc66bd3f9,
        0xe7038f5f,
        0x9515929c,
        0xebbf6d7a,
        0xda955259,
        0x2dd4be83,
        0xd3587421,
        0x2949e069,
        0x448ec9c8,
        0x6a75c289,
        0x78f48e79,
        0x6b99583e,
        0xdd27b971,
        0xb6bee14f,
        0x17f088ad,
        0x66c920ac,
        0xb47dce3a,
        0x1863df4a,
        0x82e51a31,
        0x60975133,
        0x4562537f,
        0xe0b16477,
        0x84bb6bae,
        0x1cfe81a0,
        0x94f9082b,
        0x58704868,
        0x198f45fd,
        0x8794de6c,
        0xb7527bf8,
        0x23ab73d3,
        0xe2724b02,
        0x57e31f8f,
        0x2a6655ab,
        0x07b2eb28,
        0x032fb5c2,
        0x9a86c57b,
        0xa5d33708,
        0xf2302887,
        0xb223bfa5,
        0xba02036a,
        0x5ced1682,
        0x2b8acf1c,
        0x92a779b4,
        0xf0f307f2,
        0xa14e69e2,
        0xcd65daf4,
        0xd50605be,
        0x1fd13462,
        0x8ac4a6fe,
        0x9d342e53,
        0xa0a2f355,
        0x32058ae1,
        0x75a4f6eb,
        0x390b83ec,
        0xaa4060ef,
        0x065e719f,
        0x51bd6e10,
        0xf93e218a,
        0x3d96dd06,
        0xaedd3e05,
        0x464de6bd,
        0xb591548d,
        0x0571c45d,
        0x6f0406d4,
        0xff605015,
        0x241998fb,
        0x97d6bde9,
        0xcc894043,
        0x7767d99e,
        0xbdb0e842,
        0x8807898b,
        0x38e7195b,
        0xdb79c8ee,
        0x47a17c0a,
        0xe97c420f,
        0xc9f8841e,
        0x00000000,
        0x83098086,
        0x48322bed,
        0xac1e1170,
        0x4e6c5a72,
        0xfbfd0eff,
        0x560f8538,
        0x1e3daed5,
        0x27362d39,
        0x640a0fd9,
        0x21685ca6,
        0xd19b5b54,
        0x3a24362e,
        0xb10c0a67,
        0x0f9357e7,
        0xd2b4ee96,
        0x9e1b9b91,
        0x4f80c0c5,
        0xa261dc20,
        0x695a774b,
        0x161c121a,
        0x0ae293ba,
        0xe5c0a02a,
        0x433c22e0,
        0x1d121b17,
        0x0b0e090d,
        0xadf28bc7,
        0xb92db6a8,
        0xc8141ea9,
        0x8557f119,
        0x4caf7507,
        0xbbee99dd,
        0xfda37f60,
        0x9ff70126,
        0xbc5c72f5,
        0xc544663b,
        0x345bfb7e,
        0x768b4329,
        0xdccb23c6,
        0x68b6edfc,
        0x63b8e4f1,
        0xcad731dc,
        0x10426385,
        0x40139722,
        0x2084c611,
        0x7d854a24,
        0xf8d2bb3d,
        0x11aef932,
        0x6dc729a1,
        0x4b1d9e2f,
        0xf3dcb230,
        0xec0d8652,
        0xd077c1e3,
        0x6c2bb316,
        0x99a970b9,
        0xfa119448,
        0x2247e964,
        0xc4a8fc8c,
        0x1aa0f03f,
        0xd8567d2c,
        0xef223390,
        0xc787494e,
        0xc1d938d1,
        0xfe8ccaa2,
        0x3698d40b,
        0xcfa6f581,
        0x28a57ade,
        0x26dab78e,
        0xa43fadbf,
        0xe42c3a9d,
        0x0d507892,
        0x9b6a5fcc,
        0x62547e46,
        0xc2f68d13,
        0xe890d8b8,
        0x5e2e39f7,
        0xf582c3af,
        0xbe9f5d80,
        0x7c69d093,
        0xa96fd52d,
        0xb3cf2512,
        0x3bc8ac99,
        0xa710187d,
        0x6ee89c63,
        0x7bdb3bbb,
        0x09cd2678,
        0xf46e5918,
        0x01ec9ab7,
        0xa8834f9a,
        0x65e6956e,
        0x7eaaffe6,
        0x0821bccf,
        0xe6ef15e8,
        0xd9bae79b,
        0xce4a6f36,
        0xd4ea9f09,
        0xd629b07c,
        0xaf31a4b2,
        0x312a3f23,
        0x30c6a594,
        0xc035a266,
        0x37744ebc,
        0xa6fc82ca,
        0xb0e090d0,
        0x1533a7d8,
        0x4af10498,
        0xf741ecda,
        0x0e7fcd50,
        0x2f1791f6,
        0x8d764dd6,
        0x4d43efb0,
        0x54ccaa4d,
        0xdfe49604,
        0xe39ed1b5,
        0x1b4c6a88,
        0xb8c12c1f,
        0x7f466551,
        0x049d5eea,
        0x5d018c35,
        0x73fa8774,
        0x2efb0b41,
        0x5ab3671d,
        0x5292dbd2,
        0x33e91056,
        0x136dd647,
        0x8c9ad761,
        0x7a37a10c,
        0x8e59f814,
        0x89eb133c,
        0xeecea927,
        0x35b761c9,
        0xede11ce5,
        0x3c7a47b1,
        0x599cd2df,
        0x3f55f273,
        0x791814ce,
        0xbf73c737,
        0xea53f7cd,
        0x5b5ffdaa,
        0x14df3d6f,
        0x867844db,
        0x81caaff3,
        0x3eb968c4,
        0x2c382434,
        0x5fc2a340,
        0x72161dc3,
        0x0cbce225,
        0x8b283c49,
        0x41ff0d95,
        0x7139a801,
        0xde080cb3,
        0x9cd8b4e4,
        0x906456c1,
        0x617bcb84,
        0x70d532b6,
        0x74486c5c,
        0x42d0b857
    ];
    var T7 = [
        0xa75051f4,
        0x65537e41,
        0xa4c31a17,
        0x5e963a27,
        0x6bcb3bab,
        0x45f11f9d,
        0x58abacfa,
        0x03934be3,
        0xfa552030,
        0x6df6ad76,
        0x769188cc,
        0x4c25f502,
        0xd7fc4fe5,
        0xcbd7c52a,
        0x44802635,
        0xa38fb562,
        0x5a49deb1,
        0x1b6725ba,
        0x0e9845ea,
        0xc0e15dfe,
        0x7502c32f,
        0xf012814c,
        0x97a38d46,
        0xf9c66bd3,
        0x5fe7038f,
        0x9c951592,
        0x7aebbf6d,
        0x59da9552,
        0x832dd4be,
        0x21d35874,
        0x692949e0,
        0xc8448ec9,
        0x896a75c2,
        0x7978f48e,
        0x3e6b9958,
        0x71dd27b9,
        0x4fb6bee1,
        0xad17f088,
        0xac66c920,
        0x3ab47dce,
        0x4a1863df,
        0x3182e51a,
        0x33609751,
        0x7f456253,
        0x77e0b164,
        0xae84bb6b,
        0xa01cfe81,
        0x2b94f908,
        0x68587048,
        0xfd198f45,
        0x6c8794de,
        0xf8b7527b,
        0xd323ab73,
        0x02e2724b,
        0x8f57e31f,
        0xab2a6655,
        0x2807b2eb,
        0xc2032fb5,
        0x7b9a86c5,
        0x08a5d337,
        0x87f23028,
        0xa5b223bf,
        0x6aba0203,
        0x825ced16,
        0x1c2b8acf,
        0xb492a779,
        0xf2f0f307,
        0xe2a14e69,
        0xf4cd65da,
        0xbed50605,
        0x621fd134,
        0xfe8ac4a6,
        0x539d342e,
        0x55a0a2f3,
        0xe132058a,
        0xeb75a4f6,
        0xec390b83,
        0xefaa4060,
        0x9f065e71,
        0x1051bd6e,
        0x8af93e21,
        0x063d96dd,
        0x05aedd3e,
        0xbd464de6,
        0x8db59154,
        0x5d0571c4,
        0xd46f0406,
        0x15ff6050,
        0xfb241998,
        0xe997d6bd,
        0x43cc8940,
        0x9e7767d9,
        0x42bdb0e8,
        0x8b880789,
        0x5b38e719,
        0xeedb79c8,
        0x0a47a17c,
        0x0fe97c42,
        0x1ec9f884,
        0x00000000,
        0x86830980,
        0xed48322b,
        0x70ac1e11,
        0x724e6c5a,
        0xfffbfd0e,
        0x38560f85,
        0xd51e3dae,
        0x3927362d,
        0xd9640a0f,
        0xa621685c,
        0x54d19b5b,
        0x2e3a2436,
        0x67b10c0a,
        0xe70f9357,
        0x96d2b4ee,
        0x919e1b9b,
        0xc54f80c0,
        0x20a261dc,
        0x4b695a77,
        0x1a161c12,
        0xba0ae293,
        0x2ae5c0a0,
        0xe0433c22,
        0x171d121b,
        0x0d0b0e09,
        0xc7adf28b,
        0xa8b92db6,
        0xa9c8141e,
        0x198557f1,
        0x074caf75,
        0xddbbee99,
        0x60fda37f,
        0x269ff701,
        0xf5bc5c72,
        0x3bc54466,
        0x7e345bfb,
        0x29768b43,
        0xc6dccb23,
        0xfc68b6ed,
        0xf163b8e4,
        0xdccad731,
        0x85104263,
        0x22401397,
        0x112084c6,
        0x247d854a,
        0x3df8d2bb,
        0x3211aef9,
        0xa16dc729,
        0x2f4b1d9e,
        0x30f3dcb2,
        0x52ec0d86,
        0xe3d077c1,
        0x166c2bb3,
        0xb999a970,
        0x48fa1194,
        0x642247e9,
        0x8cc4a8fc,
        0x3f1aa0f0,
        0x2cd8567d,
        0x90ef2233,
        0x4ec78749,
        0xd1c1d938,
        0xa2fe8cca,
        0x0b3698d4,
        0x81cfa6f5,
        0xde28a57a,
        0x8e26dab7,
        0xbfa43fad,
        0x9de42c3a,
        0x920d5078,
        0xcc9b6a5f,
        0x4662547e,
        0x13c2f68d,
        0xb8e890d8,
        0xf75e2e39,
        0xaff582c3,
        0x80be9f5d,
        0x937c69d0,
        0x2da96fd5,
        0x12b3cf25,
        0x993bc8ac,
        0x7da71018,
        0x636ee89c,
        0xbb7bdb3b,
        0x7809cd26,
        0x18f46e59,
        0xb701ec9a,
        0x9aa8834f,
        0x6e65e695,
        0xe67eaaff,
        0xcf0821bc,
        0xe8e6ef15,
        0x9bd9bae7,
        0x36ce4a6f,
        0x09d4ea9f,
        0x7cd629b0,
        0xb2af31a4,
        0x23312a3f,
        0x9430c6a5,
        0x66c035a2,
        0xbc37744e,
        0xcaa6fc82,
        0xd0b0e090,
        0xd81533a7,
        0x984af104,
        0xdaf741ec,
        0x500e7fcd,
        0xf62f1791,
        0xd68d764d,
        0xb04d43ef,
        0x4d54ccaa,
        0x04dfe496,
        0xb5e39ed1,
        0x881b4c6a,
        0x1fb8c12c,
        0x517f4665,
        0xea049d5e,
        0x355d018c,
        0x7473fa87,
        0x412efb0b,
        0x1d5ab367,
        0xd25292db,
        0x5633e910,
        0x47136dd6,
        0x618c9ad7,
        0x0c7a37a1,
        0x148e59f8,
        0x3c89eb13,
        0x27eecea9,
        0xc935b761,
        0xe5ede11c,
        0xb13c7a47,
        0xdf599cd2,
        0x733f55f2,
        0xce791814,
        0x37bf73c7,
        0xcdea53f7,
        0xaa5b5ffd,
        0x6f14df3d,
        0xdb867844,
        0xf381caaf,
        0xc43eb968,
        0x342c3824,
        0x405fc2a3,
        0xc372161d,
        0x250cbce2,
        0x498b283c,
        0x9541ff0d,
        0x017139a8,
        0xb3de080c,
        0xe49cd8b4,
        0xc1906456,
        0x84617bcb,
        0xb670d532,
        0x5c74486c,
        0x5742d0b8
    ];
    var T8 = [
        0xf4a75051,
        0x4165537e,
        0x17a4c31a,
        0x275e963a,
        0xab6bcb3b,
        0x9d45f11f,
        0xfa58abac,
        0xe303934b,
        0x30fa5520,
        0x766df6ad,
        0xcc769188,
        0x024c25f5,
        0xe5d7fc4f,
        0x2acbd7c5,
        0x35448026,
        0x62a38fb5,
        0xb15a49de,
        0xba1b6725,
        0xea0e9845,
        0xfec0e15d,
        0x2f7502c3,
        0x4cf01281,
        0x4697a38d,
        0xd3f9c66b,
        0x8f5fe703,
        0x929c9515,
        0x6d7aebbf,
        0x5259da95,
        0xbe832dd4,
        0x7421d358,
        0xe0692949,
        0xc9c8448e,
        0xc2896a75,
        0x8e7978f4,
        0x583e6b99,
        0xb971dd27,
        0xe14fb6be,
        0x88ad17f0,
        0x20ac66c9,
        0xce3ab47d,
        0xdf4a1863,
        0x1a3182e5,
        0x51336097,
        0x537f4562,
        0x6477e0b1,
        0x6bae84bb,
        0x81a01cfe,
        0x082b94f9,
        0x48685870,
        0x45fd198f,
        0xde6c8794,
        0x7bf8b752,
        0x73d323ab,
        0x4b02e272,
        0x1f8f57e3,
        0x55ab2a66,
        0xeb2807b2,
        0xb5c2032f,
        0xc57b9a86,
        0x3708a5d3,
        0x2887f230,
        0xbfa5b223,
        0x036aba02,
        0x16825ced,
        0xcf1c2b8a,
        0x79b492a7,
        0x07f2f0f3,
        0x69e2a14e,
        0xdaf4cd65,
        0x05bed506,
        0x34621fd1,
        0xa6fe8ac4,
        0x2e539d34,
        0xf355a0a2,
        0x8ae13205,
        0xf6eb75a4,
        0x83ec390b,
        0x60efaa40,
        0x719f065e,
        0x6e1051bd,
        0x218af93e,
        0xdd063d96,
        0x3e05aedd,
        0xe6bd464d,
        0x548db591,
        0xc45d0571,
        0x06d46f04,
        0x5015ff60,
        0x98fb2419,
        0xbde997d6,
        0x4043cc89,
        0xd99e7767,
        0xe842bdb0,
        0x898b8807,
        0x195b38e7,
        0xc8eedb79,
        0x7c0a47a1,
        0x420fe97c,
        0x841ec9f8,
        0x00000000,
        0x80868309,
        0x2bed4832,
        0x1170ac1e,
        0x5a724e6c,
        0x0efffbfd,
        0x8538560f,
        0xaed51e3d,
        0x2d392736,
        0x0fd9640a,
        0x5ca62168,
        0x5b54d19b,
        0x362e3a24,
        0x0a67b10c,
        0x57e70f93,
        0xee96d2b4,
        0x9b919e1b,
        0xc0c54f80,
        0xdc20a261,
        0x774b695a,
        0x121a161c,
        0x93ba0ae2,
        0xa02ae5c0,
        0x22e0433c,
        0x1b171d12,
        0x090d0b0e,
        0x8bc7adf2,
        0xb6a8b92d,
        0x1ea9c814,
        0xf1198557,
        0x75074caf,
        0x99ddbbee,
        0x7f60fda3,
        0x01269ff7,
        0x72f5bc5c,
        0x663bc544,
        0xfb7e345b,
        0x4329768b,
        0x23c6dccb,
        0xedfc68b6,
        0xe4f163b8,
        0x31dccad7,
        0x63851042,
        0x97224013,
        0xc6112084,
        0x4a247d85,
        0xbb3df8d2,
        0xf93211ae,
        0x29a16dc7,
        0x9e2f4b1d,
        0xb230f3dc,
        0x8652ec0d,
        0xc1e3d077,
        0xb3166c2b,
        0x70b999a9,
        0x9448fa11,
        0xe9642247,
        0xfc8cc4a8,
        0xf03f1aa0,
        0x7d2cd856,
        0x3390ef22,
        0x494ec787,
        0x38d1c1d9,
        0xcaa2fe8c,
        0xd40b3698,
        0xf581cfa6,
        0x7ade28a5,
        0xb78e26da,
        0xadbfa43f,
        0x3a9de42c,
        0x78920d50,
        0x5fcc9b6a,
        0x7e466254,
        0x8d13c2f6,
        0xd8b8e890,
        0x39f75e2e,
        0xc3aff582,
        0x5d80be9f,
        0xd0937c69,
        0xd52da96f,
        0x2512b3cf,
        0xac993bc8,
        0x187da710,
        0x9c636ee8,
        0x3bbb7bdb,
        0x267809cd,
        0x5918f46e,
        0x9ab701ec,
        0x4f9aa883,
        0x956e65e6,
        0xffe67eaa,
        0xbccf0821,
        0x15e8e6ef,
        0xe79bd9ba,
        0x6f36ce4a,
        0x9f09d4ea,
        0xb07cd629,
        0xa4b2af31,
        0x3f23312a,
        0xa59430c6,
        0xa266c035,
        0x4ebc3774,
        0x82caa6fc,
        0x90d0b0e0,
        0xa7d81533,
        0x04984af1,
        0xecdaf741,
        0xcd500e7f,
        0x91f62f17,
        0x4dd68d76,
        0xefb04d43,
        0xaa4d54cc,
        0x9604dfe4,
        0xd1b5e39e,
        0x6a881b4c,
        0x2c1fb8c1,
        0x65517f46,
        0x5eea049d,
        0x8c355d01,
        0x877473fa,
        0x0b412efb,
        0x671d5ab3,
        0xdbd25292,
        0x105633e9,
        0xd647136d,
        0xd7618c9a,
        0xa10c7a37,
        0xf8148e59,
        0x133c89eb,
        0xa927eece,
        0x61c935b7,
        0x1ce5ede1,
        0x47b13c7a,
        0xd2df599c,
        0xf2733f55,
        0x14ce7918,
        0xc737bf73,
        0xf7cdea53,
        0xfdaa5b5f,
        0x3d6f14df,
        0x44db8678,
        0xaff381ca,
        0x68c43eb9,
        0x24342c38,
        0xa3405fc2,
        0x1dc37216,
        0xe2250cbc,
        0x3c498b28,
        0x0d9541ff,
        0xa8017139,
        0x0cb3de08,
        0xb4e49cd8,
        0x56c19064,
        0xcb84617b,
        0x32b670d5,
        0x6c5c7448,
        0xb85742d0
    ];
    // Transformations for decryption key expansion
    var U1 = [
        0x00000000,
        0x0e090d0b,
        0x1c121a16,
        0x121b171d,
        0x3824342c,
        0x362d3927,
        0x24362e3a,
        0x2a3f2331,
        0x70486858,
        0x7e416553,
        0x6c5a724e,
        0x62537f45,
        0x486c5c74,
        0x4665517f,
        0x547e4662,
        0x5a774b69,
        0xe090d0b0,
        0xee99ddbb,
        0xfc82caa6,
        0xf28bc7ad,
        0xd8b4e49c,
        0xd6bde997,
        0xc4a6fe8a,
        0xcaaff381,
        0x90d8b8e8,
        0x9ed1b5e3,
        0x8ccaa2fe,
        0x82c3aff5,
        0xa8fc8cc4,
        0xa6f581cf,
        0xb4ee96d2,
        0xbae79bd9,
        0xdb3bbb7b,
        0xd532b670,
        0xc729a16d,
        0xc920ac66,
        0xe31f8f57,
        0xed16825c,
        0xff0d9541,
        0xf104984a,
        0xab73d323,
        0xa57ade28,
        0xb761c935,
        0xb968c43e,
        0x9357e70f,
        0x9d5eea04,
        0x8f45fd19,
        0x814cf012,
        0x3bab6bcb,
        0x35a266c0,
        0x27b971dd,
        0x29b07cd6,
        0x038f5fe7,
        0x0d8652ec,
        0x1f9d45f1,
        0x119448fa,
        0x4be30393,
        0x45ea0e98,
        0x57f11985,
        0x59f8148e,
        0x73c737bf,
        0x7dce3ab4,
        0x6fd52da9,
        0x61dc20a2,
        0xad766df6,
        0xa37f60fd,
        0xb16477e0,
        0xbf6d7aeb,
        0x955259da,
        0x9b5b54d1,
        0x894043cc,
        0x87494ec7,
        0xdd3e05ae,
        0xd33708a5,
        0xc12c1fb8,
        0xcf2512b3,
        0xe51a3182,
        0xeb133c89,
        0xf9082b94,
        0xf701269f,
        0x4de6bd46,
        0x43efb04d,
        0x51f4a750,
        0x5ffdaa5b,
        0x75c2896a,
        0x7bcb8461,
        0x69d0937c,
        0x67d99e77,
        0x3daed51e,
        0x33a7d815,
        0x21bccf08,
        0x2fb5c203,
        0x058ae132,
        0x0b83ec39,
        0x1998fb24,
        0x1791f62f,
        0x764dd68d,
        0x7844db86,
        0x6a5fcc9b,
        0x6456c190,
        0x4e69e2a1,
        0x4060efaa,
        0x527bf8b7,
        0x5c72f5bc,
        0x0605bed5,
        0x080cb3de,
        0x1a17a4c3,
        0x141ea9c8,
        0x3e218af9,
        0x302887f2,
        0x223390ef,
        0x2c3a9de4,
        0x96dd063d,
        0x98d40b36,
        0x8acf1c2b,
        0x84c61120,
        0xaef93211,
        0xa0f03f1a,
        0xb2eb2807,
        0xbce2250c,
        0xe6956e65,
        0xe89c636e,
        0xfa877473,
        0xf48e7978,
        0xdeb15a49,
        0xd0b85742,
        0xc2a3405f,
        0xccaa4d54,
        0x41ecdaf7,
        0x4fe5d7fc,
        0x5dfec0e1,
        0x53f7cdea,
        0x79c8eedb,
        0x77c1e3d0,
        0x65daf4cd,
        0x6bd3f9c6,
        0x31a4b2af,
        0x3fadbfa4,
        0x2db6a8b9,
        0x23bfa5b2,
        0x09808683,
        0x07898b88,
        0x15929c95,
        0x1b9b919e,
        0xa17c0a47,
        0xaf75074c,
        0xbd6e1051,
        0xb3671d5a,
        0x99583e6b,
        0x97513360,
        0x854a247d,
        0x8b432976,
        0xd134621f,
        0xdf3d6f14,
        0xcd267809,
        0xc32f7502,
        0xe9105633,
        0xe7195b38,
        0xf5024c25,
        0xfb0b412e,
        0x9ad7618c,
        0x94de6c87,
        0x86c57b9a,
        0x88cc7691,
        0xa2f355a0,
        0xacfa58ab,
        0xbee14fb6,
        0xb0e842bd,
        0xea9f09d4,
        0xe49604df,
        0xf68d13c2,
        0xf8841ec9,
        0xd2bb3df8,
        0xdcb230f3,
        0xcea927ee,
        0xc0a02ae5,
        0x7a47b13c,
        0x744ebc37,
        0x6655ab2a,
        0x685ca621,
        0x42638510,
        0x4c6a881b,
        0x5e719f06,
        0x5078920d,
        0x0a0fd964,
        0x0406d46f,
        0x161dc372,
        0x1814ce79,
        0x322bed48,
        0x3c22e043,
        0x2e39f75e,
        0x2030fa55,
        0xec9ab701,
        0xe293ba0a,
        0xf088ad17,
        0xfe81a01c,
        0xd4be832d,
        0xdab78e26,
        0xc8ac993b,
        0xc6a59430,
        0x9cd2df59,
        0x92dbd252,
        0x80c0c54f,
        0x8ec9c844,
        0xa4f6eb75,
        0xaaffe67e,
        0xb8e4f163,
        0xb6edfc68,
        0x0c0a67b1,
        0x02036aba,
        0x10187da7,
        0x1e1170ac,
        0x342e539d,
        0x3a275e96,
        0x283c498b,
        0x26354480,
        0x7c420fe9,
        0x724b02e2,
        0x605015ff,
        0x6e5918f4,
        0x44663bc5,
        0x4a6f36ce,
        0x587421d3,
        0x567d2cd8,
        0x37a10c7a,
        0x39a80171,
        0x2bb3166c,
        0x25ba1b67,
        0x0f853856,
        0x018c355d,
        0x13972240,
        0x1d9e2f4b,
        0x47e96422,
        0x49e06929,
        0x5bfb7e34,
        0x55f2733f,
        0x7fcd500e,
        0x71c45d05,
        0x63df4a18,
        0x6dd64713,
        0xd731dcca,
        0xd938d1c1,
        0xcb23c6dc,
        0xc52acbd7,
        0xef15e8e6,
        0xe11ce5ed,
        0xf307f2f0,
        0xfd0efffb,
        0xa779b492,
        0xa970b999,
        0xbb6bae84,
        0xb562a38f,
        0x9f5d80be,
        0x91548db5,
        0x834f9aa8,
        0x8d4697a3
    ];
    var U2 = [
        0x00000000,
        0x0b0e090d,
        0x161c121a,
        0x1d121b17,
        0x2c382434,
        0x27362d39,
        0x3a24362e,
        0x312a3f23,
        0x58704868,
        0x537e4165,
        0x4e6c5a72,
        0x4562537f,
        0x74486c5c,
        0x7f466551,
        0x62547e46,
        0x695a774b,
        0xb0e090d0,
        0xbbee99dd,
        0xa6fc82ca,
        0xadf28bc7,
        0x9cd8b4e4,
        0x97d6bde9,
        0x8ac4a6fe,
        0x81caaff3,
        0xe890d8b8,
        0xe39ed1b5,
        0xfe8ccaa2,
        0xf582c3af,
        0xc4a8fc8c,
        0xcfa6f581,
        0xd2b4ee96,
        0xd9bae79b,
        0x7bdb3bbb,
        0x70d532b6,
        0x6dc729a1,
        0x66c920ac,
        0x57e31f8f,
        0x5ced1682,
        0x41ff0d95,
        0x4af10498,
        0x23ab73d3,
        0x28a57ade,
        0x35b761c9,
        0x3eb968c4,
        0x0f9357e7,
        0x049d5eea,
        0x198f45fd,
        0x12814cf0,
        0xcb3bab6b,
        0xc035a266,
        0xdd27b971,
        0xd629b07c,
        0xe7038f5f,
        0xec0d8652,
        0xf11f9d45,
        0xfa119448,
        0x934be303,
        0x9845ea0e,
        0x8557f119,
        0x8e59f814,
        0xbf73c737,
        0xb47dce3a,
        0xa96fd52d,
        0xa261dc20,
        0xf6ad766d,
        0xfda37f60,
        0xe0b16477,
        0xebbf6d7a,
        0xda955259,
        0xd19b5b54,
        0xcc894043,
        0xc787494e,
        0xaedd3e05,
        0xa5d33708,
        0xb8c12c1f,
        0xb3cf2512,
        0x82e51a31,
        0x89eb133c,
        0x94f9082b,
        0x9ff70126,
        0x464de6bd,
        0x4d43efb0,
        0x5051f4a7,
        0x5b5ffdaa,
        0x6a75c289,
        0x617bcb84,
        0x7c69d093,
        0x7767d99e,
        0x1e3daed5,
        0x1533a7d8,
        0x0821bccf,
        0x032fb5c2,
        0x32058ae1,
        0x390b83ec,
        0x241998fb,
        0x2f1791f6,
        0x8d764dd6,
        0x867844db,
        0x9b6a5fcc,
        0x906456c1,
        0xa14e69e2,
        0xaa4060ef,
        0xb7527bf8,
        0xbc5c72f5,
        0xd50605be,
        0xde080cb3,
        0xc31a17a4,
        0xc8141ea9,
        0xf93e218a,
        0xf2302887,
        0xef223390,
        0xe42c3a9d,
        0x3d96dd06,
        0x3698d40b,
        0x2b8acf1c,
        0x2084c611,
        0x11aef932,
        0x1aa0f03f,
        0x07b2eb28,
        0x0cbce225,
        0x65e6956e,
        0x6ee89c63,
        0x73fa8774,
        0x78f48e79,
        0x49deb15a,
        0x42d0b857,
        0x5fc2a340,
        0x54ccaa4d,
        0xf741ecda,
        0xfc4fe5d7,
        0xe15dfec0,
        0xea53f7cd,
        0xdb79c8ee,
        0xd077c1e3,
        0xcd65daf4,
        0xc66bd3f9,
        0xaf31a4b2,
        0xa43fadbf,
        0xb92db6a8,
        0xb223bfa5,
        0x83098086,
        0x8807898b,
        0x9515929c,
        0x9e1b9b91,
        0x47a17c0a,
        0x4caf7507,
        0x51bd6e10,
        0x5ab3671d,
        0x6b99583e,
        0x60975133,
        0x7d854a24,
        0x768b4329,
        0x1fd13462,
        0x14df3d6f,
        0x09cd2678,
        0x02c32f75,
        0x33e91056,
        0x38e7195b,
        0x25f5024c,
        0x2efb0b41,
        0x8c9ad761,
        0x8794de6c,
        0x9a86c57b,
        0x9188cc76,
        0xa0a2f355,
        0xabacfa58,
        0xb6bee14f,
        0xbdb0e842,
        0xd4ea9f09,
        0xdfe49604,
        0xc2f68d13,
        0xc9f8841e,
        0xf8d2bb3d,
        0xf3dcb230,
        0xeecea927,
        0xe5c0a02a,
        0x3c7a47b1,
        0x37744ebc,
        0x2a6655ab,
        0x21685ca6,
        0x10426385,
        0x1b4c6a88,
        0x065e719f,
        0x0d507892,
        0x640a0fd9,
        0x6f0406d4,
        0x72161dc3,
        0x791814ce,
        0x48322bed,
        0x433c22e0,
        0x5e2e39f7,
        0x552030fa,
        0x01ec9ab7,
        0x0ae293ba,
        0x17f088ad,
        0x1cfe81a0,
        0x2dd4be83,
        0x26dab78e,
        0x3bc8ac99,
        0x30c6a594,
        0x599cd2df,
        0x5292dbd2,
        0x4f80c0c5,
        0x448ec9c8,
        0x75a4f6eb,
        0x7eaaffe6,
        0x63b8e4f1,
        0x68b6edfc,
        0xb10c0a67,
        0xba02036a,
        0xa710187d,
        0xac1e1170,
        0x9d342e53,
        0x963a275e,
        0x8b283c49,
        0x80263544,
        0xe97c420f,
        0xe2724b02,
        0xff605015,
        0xf46e5918,
        0xc544663b,
        0xce4a6f36,
        0xd3587421,
        0xd8567d2c,
        0x7a37a10c,
        0x7139a801,
        0x6c2bb316,
        0x6725ba1b,
        0x560f8538,
        0x5d018c35,
        0x40139722,
        0x4b1d9e2f,
        0x2247e964,
        0x2949e069,
        0x345bfb7e,
        0x3f55f273,
        0x0e7fcd50,
        0x0571c45d,
        0x1863df4a,
        0x136dd647,
        0xcad731dc,
        0xc1d938d1,
        0xdccb23c6,
        0xd7c52acb,
        0xe6ef15e8,
        0xede11ce5,
        0xf0f307f2,
        0xfbfd0eff,
        0x92a779b4,
        0x99a970b9,
        0x84bb6bae,
        0x8fb562a3,
        0xbe9f5d80,
        0xb591548d,
        0xa8834f9a,
        0xa38d4697
    ];
    var U3 = [
        0x00000000,
        0x0d0b0e09,
        0x1a161c12,
        0x171d121b,
        0x342c3824,
        0x3927362d,
        0x2e3a2436,
        0x23312a3f,
        0x68587048,
        0x65537e41,
        0x724e6c5a,
        0x7f456253,
        0x5c74486c,
        0x517f4665,
        0x4662547e,
        0x4b695a77,
        0xd0b0e090,
        0xddbbee99,
        0xcaa6fc82,
        0xc7adf28b,
        0xe49cd8b4,
        0xe997d6bd,
        0xfe8ac4a6,
        0xf381caaf,
        0xb8e890d8,
        0xb5e39ed1,
        0xa2fe8cca,
        0xaff582c3,
        0x8cc4a8fc,
        0x81cfa6f5,
        0x96d2b4ee,
        0x9bd9bae7,
        0xbb7bdb3b,
        0xb670d532,
        0xa16dc729,
        0xac66c920,
        0x8f57e31f,
        0x825ced16,
        0x9541ff0d,
        0x984af104,
        0xd323ab73,
        0xde28a57a,
        0xc935b761,
        0xc43eb968,
        0xe70f9357,
        0xea049d5e,
        0xfd198f45,
        0xf012814c,
        0x6bcb3bab,
        0x66c035a2,
        0x71dd27b9,
        0x7cd629b0,
        0x5fe7038f,
        0x52ec0d86,
        0x45f11f9d,
        0x48fa1194,
        0x03934be3,
        0x0e9845ea,
        0x198557f1,
        0x148e59f8,
        0x37bf73c7,
        0x3ab47dce,
        0x2da96fd5,
        0x20a261dc,
        0x6df6ad76,
        0x60fda37f,
        0x77e0b164,
        0x7aebbf6d,
        0x59da9552,
        0x54d19b5b,
        0x43cc8940,
        0x4ec78749,
        0x05aedd3e,
        0x08a5d337,
        0x1fb8c12c,
        0x12b3cf25,
        0x3182e51a,
        0x3c89eb13,
        0x2b94f908,
        0x269ff701,
        0xbd464de6,
        0xb04d43ef,
        0xa75051f4,
        0xaa5b5ffd,
        0x896a75c2,
        0x84617bcb,
        0x937c69d0,
        0x9e7767d9,
        0xd51e3dae,
        0xd81533a7,
        0xcf0821bc,
        0xc2032fb5,
        0xe132058a,
        0xec390b83,
        0xfb241998,
        0xf62f1791,
        0xd68d764d,
        0xdb867844,
        0xcc9b6a5f,
        0xc1906456,
        0xe2a14e69,
        0xefaa4060,
        0xf8b7527b,
        0xf5bc5c72,
        0xbed50605,
        0xb3de080c,
        0xa4c31a17,
        0xa9c8141e,
        0x8af93e21,
        0x87f23028,
        0x90ef2233,
        0x9de42c3a,
        0x063d96dd,
        0x0b3698d4,
        0x1c2b8acf,
        0x112084c6,
        0x3211aef9,
        0x3f1aa0f0,
        0x2807b2eb,
        0x250cbce2,
        0x6e65e695,
        0x636ee89c,
        0x7473fa87,
        0x7978f48e,
        0x5a49deb1,
        0x5742d0b8,
        0x405fc2a3,
        0x4d54ccaa,
        0xdaf741ec,
        0xd7fc4fe5,
        0xc0e15dfe,
        0xcdea53f7,
        0xeedb79c8,
        0xe3d077c1,
        0xf4cd65da,
        0xf9c66bd3,
        0xb2af31a4,
        0xbfa43fad,
        0xa8b92db6,
        0xa5b223bf,
        0x86830980,
        0x8b880789,
        0x9c951592,
        0x919e1b9b,
        0x0a47a17c,
        0x074caf75,
        0x1051bd6e,
        0x1d5ab367,
        0x3e6b9958,
        0x33609751,
        0x247d854a,
        0x29768b43,
        0x621fd134,
        0x6f14df3d,
        0x7809cd26,
        0x7502c32f,
        0x5633e910,
        0x5b38e719,
        0x4c25f502,
        0x412efb0b,
        0x618c9ad7,
        0x6c8794de,
        0x7b9a86c5,
        0x769188cc,
        0x55a0a2f3,
        0x58abacfa,
        0x4fb6bee1,
        0x42bdb0e8,
        0x09d4ea9f,
        0x04dfe496,
        0x13c2f68d,
        0x1ec9f884,
        0x3df8d2bb,
        0x30f3dcb2,
        0x27eecea9,
        0x2ae5c0a0,
        0xb13c7a47,
        0xbc37744e,
        0xab2a6655,
        0xa621685c,
        0x85104263,
        0x881b4c6a,
        0x9f065e71,
        0x920d5078,
        0xd9640a0f,
        0xd46f0406,
        0xc372161d,
        0xce791814,
        0xed48322b,
        0xe0433c22,
        0xf75e2e39,
        0xfa552030,
        0xb701ec9a,
        0xba0ae293,
        0xad17f088,
        0xa01cfe81,
        0x832dd4be,
        0x8e26dab7,
        0x993bc8ac,
        0x9430c6a5,
        0xdf599cd2,
        0xd25292db,
        0xc54f80c0,
        0xc8448ec9,
        0xeb75a4f6,
        0xe67eaaff,
        0xf163b8e4,
        0xfc68b6ed,
        0x67b10c0a,
        0x6aba0203,
        0x7da71018,
        0x70ac1e11,
        0x539d342e,
        0x5e963a27,
        0x498b283c,
        0x44802635,
        0x0fe97c42,
        0x02e2724b,
        0x15ff6050,
        0x18f46e59,
        0x3bc54466,
        0x36ce4a6f,
        0x21d35874,
        0x2cd8567d,
        0x0c7a37a1,
        0x017139a8,
        0x166c2bb3,
        0x1b6725ba,
        0x38560f85,
        0x355d018c,
        0x22401397,
        0x2f4b1d9e,
        0x642247e9,
        0x692949e0,
        0x7e345bfb,
        0x733f55f2,
        0x500e7fcd,
        0x5d0571c4,
        0x4a1863df,
        0x47136dd6,
        0xdccad731,
        0xd1c1d938,
        0xc6dccb23,
        0xcbd7c52a,
        0xe8e6ef15,
        0xe5ede11c,
        0xf2f0f307,
        0xfffbfd0e,
        0xb492a779,
        0xb999a970,
        0xae84bb6b,
        0xa38fb562,
        0x80be9f5d,
        0x8db59154,
        0x9aa8834f,
        0x97a38d46
    ];
    var U4 = [
        0x00000000,
        0x090d0b0e,
        0x121a161c,
        0x1b171d12,
        0x24342c38,
        0x2d392736,
        0x362e3a24,
        0x3f23312a,
        0x48685870,
        0x4165537e,
        0x5a724e6c,
        0x537f4562,
        0x6c5c7448,
        0x65517f46,
        0x7e466254,
        0x774b695a,
        0x90d0b0e0,
        0x99ddbbee,
        0x82caa6fc,
        0x8bc7adf2,
        0xb4e49cd8,
        0xbde997d6,
        0xa6fe8ac4,
        0xaff381ca,
        0xd8b8e890,
        0xd1b5e39e,
        0xcaa2fe8c,
        0xc3aff582,
        0xfc8cc4a8,
        0xf581cfa6,
        0xee96d2b4,
        0xe79bd9ba,
        0x3bbb7bdb,
        0x32b670d5,
        0x29a16dc7,
        0x20ac66c9,
        0x1f8f57e3,
        0x16825ced,
        0x0d9541ff,
        0x04984af1,
        0x73d323ab,
        0x7ade28a5,
        0x61c935b7,
        0x68c43eb9,
        0x57e70f93,
        0x5eea049d,
        0x45fd198f,
        0x4cf01281,
        0xab6bcb3b,
        0xa266c035,
        0xb971dd27,
        0xb07cd629,
        0x8f5fe703,
        0x8652ec0d,
        0x9d45f11f,
        0x9448fa11,
        0xe303934b,
        0xea0e9845,
        0xf1198557,
        0xf8148e59,
        0xc737bf73,
        0xce3ab47d,
        0xd52da96f,
        0xdc20a261,
        0x766df6ad,
        0x7f60fda3,
        0x6477e0b1,
        0x6d7aebbf,
        0x5259da95,
        0x5b54d19b,
        0x4043cc89,
        0x494ec787,
        0x3e05aedd,
        0x3708a5d3,
        0x2c1fb8c1,
        0x2512b3cf,
        0x1a3182e5,
        0x133c89eb,
        0x082b94f9,
        0x01269ff7,
        0xe6bd464d,
        0xefb04d43,
        0xf4a75051,
        0xfdaa5b5f,
        0xc2896a75,
        0xcb84617b,
        0xd0937c69,
        0xd99e7767,
        0xaed51e3d,
        0xa7d81533,
        0xbccf0821,
        0xb5c2032f,
        0x8ae13205,
        0x83ec390b,
        0x98fb2419,
        0x91f62f17,
        0x4dd68d76,
        0x44db8678,
        0x5fcc9b6a,
        0x56c19064,
        0x69e2a14e,
        0x60efaa40,
        0x7bf8b752,
        0x72f5bc5c,
        0x05bed506,
        0x0cb3de08,
        0x17a4c31a,
        0x1ea9c814,
        0x218af93e,
        0x2887f230,
        0x3390ef22,
        0x3a9de42c,
        0xdd063d96,
        0xd40b3698,
        0xcf1c2b8a,
        0xc6112084,
        0xf93211ae,
        0xf03f1aa0,
        0xeb2807b2,
        0xe2250cbc,
        0x956e65e6,
        0x9c636ee8,
        0x877473fa,
        0x8e7978f4,
        0xb15a49de,
        0xb85742d0,
        0xa3405fc2,
        0xaa4d54cc,
        0xecdaf741,
        0xe5d7fc4f,
        0xfec0e15d,
        0xf7cdea53,
        0xc8eedb79,
        0xc1e3d077,
        0xdaf4cd65,
        0xd3f9c66b,
        0xa4b2af31,
        0xadbfa43f,
        0xb6a8b92d,
        0xbfa5b223,
        0x80868309,
        0x898b8807,
        0x929c9515,
        0x9b919e1b,
        0x7c0a47a1,
        0x75074caf,
        0x6e1051bd,
        0x671d5ab3,
        0x583e6b99,
        0x51336097,
        0x4a247d85,
        0x4329768b,
        0x34621fd1,
        0x3d6f14df,
        0x267809cd,
        0x2f7502c3,
        0x105633e9,
        0x195b38e7,
        0x024c25f5,
        0x0b412efb,
        0xd7618c9a,
        0xde6c8794,
        0xc57b9a86,
        0xcc769188,
        0xf355a0a2,
        0xfa58abac,
        0xe14fb6be,
        0xe842bdb0,
        0x9f09d4ea,
        0x9604dfe4,
        0x8d13c2f6,
        0x841ec9f8,
        0xbb3df8d2,
        0xb230f3dc,
        0xa927eece,
        0xa02ae5c0,
        0x47b13c7a,
        0x4ebc3774,
        0x55ab2a66,
        0x5ca62168,
        0x63851042,
        0x6a881b4c,
        0x719f065e,
        0x78920d50,
        0x0fd9640a,
        0x06d46f04,
        0x1dc37216,
        0x14ce7918,
        0x2bed4832,
        0x22e0433c,
        0x39f75e2e,
        0x30fa5520,
        0x9ab701ec,
        0x93ba0ae2,
        0x88ad17f0,
        0x81a01cfe,
        0xbe832dd4,
        0xb78e26da,
        0xac993bc8,
        0xa59430c6,
        0xd2df599c,
        0xdbd25292,
        0xc0c54f80,
        0xc9c8448e,
        0xf6eb75a4,
        0xffe67eaa,
        0xe4f163b8,
        0xedfc68b6,
        0x0a67b10c,
        0x036aba02,
        0x187da710,
        0x1170ac1e,
        0x2e539d34,
        0x275e963a,
        0x3c498b28,
        0x35448026,
        0x420fe97c,
        0x4b02e272,
        0x5015ff60,
        0x5918f46e,
        0x663bc544,
        0x6f36ce4a,
        0x7421d358,
        0x7d2cd856,
        0xa10c7a37,
        0xa8017139,
        0xb3166c2b,
        0xba1b6725,
        0x8538560f,
        0x8c355d01,
        0x97224013,
        0x9e2f4b1d,
        0xe9642247,
        0xe0692949,
        0xfb7e345b,
        0xf2733f55,
        0xcd500e7f,
        0xc45d0571,
        0xdf4a1863,
        0xd647136d,
        0x31dccad7,
        0x38d1c1d9,
        0x23c6dccb,
        0x2acbd7c5,
        0x15e8e6ef,
        0x1ce5ede1,
        0x07f2f0f3,
        0x0efffbfd,
        0x79b492a7,
        0x70b999a9,
        0x6bae84bb,
        0x62a38fb5,
        0x5d80be9f,
        0x548db591,
        0x4f9aa883,
        0x4697a38d
    ];
    function convertToInt32(bytes) {
        var result = [];
        for(var i = 0; i < bytes.length; i += 4)result.push(bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]);
        return result;
    }
    var AES = function(key) {
        if (!(this instanceof AES)) throw Error("AES must be instanitated with `new`");
        Object.defineProperty(this, "key", {
            value: coerceArray(key, true)
        });
        this._prepare();
    };
    AES.prototype._prepare = function() {
        var rounds = numberOfRounds[this.key.length];
        if (rounds == null) throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
        // encryption round keys
        this._Ke = [];
        // decryption round keys
        this._Kd = [];
        for(var i = 0; i <= rounds; i++){
            this._Ke.push([
                0,
                0,
                0,
                0
            ]);
            this._Kd.push([
                0,
                0,
                0,
                0
            ]);
        }
        var roundKeyCount = (rounds + 1) * 4;
        var KC = this.key.length / 4;
        // convert the key into ints
        var tk = convertToInt32(this.key);
        // copy values into round key arrays
        var index;
        for(var i = 0; i < KC; i++){
            index = i >> 2;
            this._Ke[index][i % 4] = tk[i];
            this._Kd[rounds - index][i % 4] = tk[i];
        }
        // key expansion (fips-197 section 5.2)
        var rconpointer = 0;
        var t = KC, tt;
        while(t < roundKeyCount){
            tt = tk[KC - 1];
            tk[0] ^= S[tt >> 16 & 0xFF] << 24 ^ S[tt >> 8 & 0xFF] << 16 ^ S[tt & 0xFF] << 8 ^ S[tt >> 24 & 0xFF] ^ rcon[rconpointer] << 24;
            rconpointer += 1;
            // key expansion (for non-256 bit)
            if (KC != 8) for(var i = 1; i < KC; i++)tk[i] ^= tk[i - 1];
            else {
                for(var i = 1; i < KC / 2; i++)tk[i] ^= tk[i - 1];
                tt = tk[KC / 2 - 1];
                tk[KC / 2] ^= S[tt & 0xFF] ^ S[tt >> 8 & 0xFF] << 8 ^ S[tt >> 16 & 0xFF] << 16 ^ S[tt >> 24 & 0xFF] << 24;
                for(var i = KC / 2 + 1; i < KC; i++)tk[i] ^= tk[i - 1];
            }
            // copy values into round key arrays
            var i = 0, r, c;
            while(i < KC && t < roundKeyCount){
                r = t >> 2;
                c = t % 4;
                this._Ke[r][c] = tk[i];
                this._Kd[rounds - r][c] = tk[i++];
                t++;
            }
        }
        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for(var r = 1; r < rounds; r++)for(var c = 0; c < 4; c++){
            tt = this._Kd[r][c];
            this._Kd[r][c] = U1[tt >> 24 & 0xFF] ^ U2[tt >> 16 & 0xFF] ^ U3[tt >> 8 & 0xFF] ^ U4[tt & 0xFF];
        }
    };
    AES.prototype.encrypt = function(plaintext) {
        if (plaintext.length != 16) throw new Error("invalid plaintext size (must be 16 bytes)");
        var rounds = this._Ke.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(plaintext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Ke[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T1[t[i] >> 24 & 0xff] ^ T2[t[(i + 1) % 4] >> 16 & 0xff] ^ T3[t[(i + 2) % 4] >> 8 & 0xff] ^ T4[t[(i + 3) % 4] & 0xff] ^ this._Ke[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Ke[rounds][i];
            result[4 * i] = (S[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (S[t[(i + 1) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (S[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (S[t[(i + 3) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    AES.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length != 16) throw new Error("invalid ciphertext size (must be 16 bytes)");
        var rounds = this._Kd.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(ciphertext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Kd[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T5[t[i] >> 24 & 0xff] ^ T6[t[(i + 3) % 4] >> 16 & 0xff] ^ T7[t[(i + 2) % 4] >> 8 & 0xff] ^ T8[t[(i + 1) % 4] & 0xff] ^ this._Kd[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Kd[rounds][i];
            result[4 * i] = (Si[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (Si[t[(i + 3) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (Si[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (Si[t[(i + 1) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    /**
     *  Mode Of Operation - Electonic Codebook (ECB)
     */ var ModeOfOperationECB = function(key) {
        if (!(this instanceof ModeOfOperationECB)) throw Error("AES must be instanitated with `new`");
        this.description = "Electronic Code Block";
        this.name = "ecb";
        this._aes = new AES(key);
    };
    ModeOfOperationECB.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            block = this._aes.encrypt(block);
            copyArray(block, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationECB.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            copyArray(block, plaintext, i);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Block Chaining (CBC)
     */ var ModeOfOperationCBC = function(key, iv) {
        if (!(this instanceof ModeOfOperationCBC)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Block Chaining";
        this.name = "cbc";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastCipherblock = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCBC.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            for(var j = 0; j < 16; j++)block[j] ^= this._lastCipherblock[j];
            this._lastCipherblock = this._aes.encrypt(block);
            copyArray(this._lastCipherblock, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationCBC.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            for(var j = 0; j < 16; j++)plaintext[i + j] = block[j] ^ this._lastCipherblock[j];
            copyArray(ciphertext, this._lastCipherblock, 0, i, i + 16);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Feedback (CFB)
     */ var ModeOfOperationCFB = function(key, iv, segmentSize) {
        if (!(this instanceof ModeOfOperationCFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Feedback";
        this.name = "cfb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 size)");
        if (!segmentSize) segmentSize = 1;
        this.segmentSize = segmentSize;
        this._shiftRegister = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCFB.prototype.encrypt = function(plaintext) {
        if (plaintext.length % this.segmentSize != 0) throw new Error("invalid plaintext size (must be segmentSize bytes)");
        var encrypted = coerceArray(plaintext, true);
        var xorSegment;
        for(var i = 0; i < encrypted.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)encrypted[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(encrypted, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return encrypted;
    };
    ModeOfOperationCFB.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length % this.segmentSize != 0) throw new Error("invalid ciphertext size (must be segmentSize bytes)");
        var plaintext = coerceArray(ciphertext, true);
        var xorSegment;
        for(var i = 0; i < plaintext.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)plaintext[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(ciphertext, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Output Feedback (OFB)
     */ var ModeOfOperationOFB = function(key, iv) {
        if (!(this instanceof ModeOfOperationOFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Output Feedback";
        this.name = "ofb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastPrecipher = coerceArray(iv, true);
        this._lastPrecipherIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationOFB.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._lastPrecipherIndex === 16) {
                this._lastPrecipher = this._aes.encrypt(this._lastPrecipher);
                this._lastPrecipherIndex = 0;
            }
            encrypted[i] ^= this._lastPrecipher[this._lastPrecipherIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationOFB.prototype.decrypt = ModeOfOperationOFB.prototype.encrypt;
    /**
     *  Counter object for CTR common mode of operation
     */ var Counter = function(initialValue) {
        if (!(this instanceof Counter)) throw Error("Counter must be instanitated with `new`");
        // We allow 0, but anything false-ish uses the default 1
        if (initialValue !== 0 && !initialValue) initialValue = 1;
        if (typeof initialValue === "number") {
            this._counter = createArray(16);
            this.setValue(initialValue);
        } else this.setBytes(initialValue);
    };
    Counter.prototype.setValue = function(value) {
        if (typeof value !== "number" || parseInt(value) != value) throw new Error("invalid counter value (must be an integer)");
        for(var index = 15; index >= 0; --index){
            this._counter[index] = value % 256;
            value = value >> 8;
        }
    };
    Counter.prototype.setBytes = function(bytes) {
        bytes = coerceArray(bytes, true);
        if (bytes.length != 16) throw new Error("invalid counter bytes size (must be 16 bytes)");
        this._counter = bytes;
    };
    Counter.prototype.increment = function() {
        for(var i = 15; i >= 0; i--)if (this._counter[i] === 255) this._counter[i] = 0;
        else {
            this._counter[i]++;
            break;
        }
    };
    /**
     *  Mode Of Operation - Counter (CTR)
     */ var ModeOfOperationCTR = function(key, counter) {
        if (!(this instanceof ModeOfOperationCTR)) throw Error("AES must be instanitated with `new`");
        this.description = "Counter";
        this.name = "ctr";
        if (!(counter instanceof Counter)) counter = new Counter(counter);
        this._counter = counter;
        this._remainingCounter = null;
        this._remainingCounterIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationCTR.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._remainingCounterIndex === 16) {
                this._remainingCounter = this._aes.encrypt(this._counter._counter);
                this._remainingCounterIndex = 0;
                this._counter.increment();
            }
            encrypted[i] ^= this._remainingCounter[this._remainingCounterIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationCTR.prototype.decrypt = ModeOfOperationCTR.prototype.encrypt;
    ///////////////////////
    // Padding
    // See:https://tools.ietf.org/html/rfc2315
    function pkcs7pad(data) {
        data = coerceArray(data, true);
        var padder = 16 - data.length % 16;
        var result = createArray(data.length + padder);
        copyArray(data, result);
        for(var i = data.length; i < result.length; i++)result[i] = padder;
        return result;
    }
    function pkcs7strip(data) {
        data = coerceArray(data, true);
        if (data.length < 16) throw new Error("PKCS#7 invalid length");
        var padder = data[data.length - 1];
        if (padder > 16) throw new Error("PKCS#7 padding byte out of range");
        var length = data.length - padder;
        for(var i = 0; i < padder; i++){
            if (data[length + i] !== padder) throw new Error("PKCS#7 invalid padding byte");
        }
        var result = createArray(length);
        copyArray(data, result, 0, 0, length);
        return result;
    }
    ///////////////////////
    // Exporting
    // The block cipher
    var aesjs = {
        AES: AES,
        Counter: Counter,
        ModeOfOperation: {
            ecb: ModeOfOperationECB,
            cbc: ModeOfOperationCBC,
            cfb: ModeOfOperationCFB,
            ofb: ModeOfOperationOFB,
            ctr: ModeOfOperationCTR
        },
        utils: {
            hex: convertHex,
            utf8: convertUtf8
        },
        padding: {
            pkcs7: {
                pad: pkcs7pad,
                strip: pkcs7strip
            }
        },
        _arrayTest: {
            coerceArray: coerceArray,
            createArray: createArray,
            copyArray: copyArray
        }
    };
    $72ea0040e5768fb5$exports = aesjs;
})($72ea0040e5768fb5$exports);









const $a4c18596bcdbd717$export$83d89fbfd8236492 = "json-wallets/5.7.0";




"use strict";
function $85bc5d60031db318$export$2cde08bde0cfd932(hexString) {
    if (typeof hexString === "string" && hexString.substring(0, 2) !== "0x") hexString = "0x" + hexString;
    return (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(hexString);
}
function $85bc5d60031db318$export$67752b99d3bc61c6(value, length) {
    value = String(value);
    while(value.length < length)value = "0" + value;
    return value;
}
function $85bc5d60031db318$export$350bd33120f7413e(password) {
    if (typeof password === "string") return (0, $169c6c93221d2e48$export$8feeb310b4b4752f)(password, (0, $169c6c93221d2e48$export$c6986442964129f5).NFKC);
    return (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(password);
}
function $85bc5d60031db318$export$5a5c1dbd910e2c32(object, path) {
    let currentChild = object;
    const comps = path.toLowerCase().split("/");
    for(let i = 0; i < comps.length; i++){
        // Search for a child object with a case-insensitive matching key
        let matchingChild = null;
        for(const key in currentChild)if (key.toLowerCase() === comps[i]) {
            matchingChild = currentChild[key];
            break;
        }
        // Didn't find one. :'(
        if (matchingChild === null) return null;
        // Now check this child...
        currentChild = matchingChild;
    }
    return currentChild;
}
function $85bc5d60031db318$export$ec7b18ebad55a3a9(randomBytes) {
    const bytes = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(randomBytes);
    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = bytes[6] & 0x0f | 0x40;
    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = bytes[8] & 0x3f | 0x80;
    const value = (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(bytes);
    return [
        value.substring(2, 10),
        value.substring(10, 14),
        value.substring(14, 18),
        value.substring(18, 22),
        value.substring(22, 34)
    ].join("-");
}


"use strict";
const $ca811ee56d4e2b01$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $a4c18596bcdbd717$export$83d89fbfd8236492));
class $ca811ee56d4e2b01$export$93a76d16f88f2b3 extends (0, $19462b55124983f4$exports.Description) {
    isCrowdsaleAccount(value) {
        return !!(value && value._isCrowdsaleAccount);
    }
}
function $ca811ee56d4e2b01$export$e85a0c9a1067c5d3(json, password) {
    const data = JSON.parse(json);
    password = (0, $85bc5d60031db318$export$350bd33120f7413e)(password);
    // Ethereum Address
    const ethaddr = (0, $a4b82b374f356b4b$export$88411125f012957a)((0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "ethaddr"));
    // Encrypted Seed
    const encseed = (0, $85bc5d60031db318$export$2cde08bde0cfd932)((0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "encseed"));
    if (!encseed || encseed.length % 16 !== 0) $ca811ee56d4e2b01$var$logger.throwArgumentError("invalid encseed", "json", json);
    const key = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)((0, $ab7da8db31000bcc$export$448fa22aedc9dbca)(password, password, 2000, 32, "sha256")).slice(0, 16);
    const iv = encseed.slice(0, 16);
    const encryptedSeed = encseed.slice(16);
    // Decrypt the seed
    const aesCbc = new (0, (/*@__PURE__*/$parcel$interopDefault($72ea0040e5768fb5$exports))).ModeOfOperation.cbc(key, iv);
    const seed = (0, (/*@__PURE__*/$parcel$interopDefault($72ea0040e5768fb5$exports))).padding.pkcs7.strip((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(aesCbc.decrypt(encryptedSeed)));
    // This wallet format is weird... Convert the binary encoded hex to a string.
    let seedHex = "";
    for(let i = 0; i < seed.length; i++)seedHex += String.fromCharCode(seed[i]);
    const seedHexBytes = (0, $169c6c93221d2e48$export$8feeb310b4b4752f)(seedHex);
    const privateKey = (0, $344909d1f36347b2$export$f8151fce47ad1c35)(seedHexBytes);
    return new $ca811ee56d4e2b01$export$93a76d16f88f2b3({
        _isCrowdsaleAccount: true,
        address: ethaddr,
        privateKey: privateKey
    });
}



"use strict";
function $4999eee0db3e68cf$export$724d6cf6b9fd8578(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    return data.encseed && data.ethaddr;
}
function $4999eee0db3e68cf$export$67dc926b8e68b2d8(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    if (!data.version || parseInt(data.version) !== data.version || parseInt(data.version) !== 3) return false;
    // @TODO: Put more checks to make sure it has kdf, iv and all that good stuff
    return true;
}
function $4999eee0db3e68cf$export$9a68ee9f8f3afd38(json) {
    if ($4999eee0db3e68cf$export$724d6cf6b9fd8578(json)) try {
        return (0, $a4b82b374f356b4b$export$88411125f012957a)(JSON.parse(json).ethaddr);
    } catch (error) {
        return null;
    }
    if ($4999eee0db3e68cf$export$67dc926b8e68b2d8(json)) try {
        return (0, $a4b82b374f356b4b$export$88411125f012957a)(JSON.parse(json).address);
    } catch (error) {
        return null;
    }
    return null;
}


var $5cd719aa79671b4c$exports = {};

$parcel$export($5cd719aa79671b4c$exports, "decryptSync", function () { return $5cd719aa79671b4c$export$9bd2c37889ee5e36; });
$parcel$export($5cd719aa79671b4c$exports, "decrypt", function () { return $5cd719aa79671b4c$export$e85a0c9a1067c5d3; });
$parcel$export($5cd719aa79671b4c$exports, "encrypt", function () { return $5cd719aa79671b4c$export$5b0f6292f11d1d18; });

var $a4ccce1783a297c7$exports = {};
"use strict";
(function(root) {
    const MAX_VALUE = 0x7fffffff;
    // The SHA256 and PBKDF2 implementation are from scrypt-async-js:
    // See: https://github.com/dchest/scrypt-async-js
    function SHA256(m) {
        const K = new Uint32Array([
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
        ]);
        let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a;
        let h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
        const w = new Uint32Array(64);
        function blocks(p) {
            let off = 0, len = p.length;
            while(len >= 64){
                let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, u, i, j, t1, t2;
                for(i = 0; i < 16; i++){
                    j = off + i * 4;
                    w[i] = (p[j] & 0xff) << 24 | (p[j + 1] & 0xff) << 16 | (p[j + 2] & 0xff) << 8 | p[j + 3] & 0xff;
                }
                for(i = 16; i < 64; i++){
                    u = w[i - 2];
                    t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                    u = w[i - 15];
                    t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                    w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0) | 0;
                }
                for(i = 0; i < 64; i++){
                    t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + (K[i] + w[i] | 0) | 0) | 0;
                    t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                h0 = h0 + a | 0;
                h1 = h1 + b | 0;
                h2 = h2 + c | 0;
                h3 = h3 + d | 0;
                h4 = h4 + e | 0;
                h5 = h5 + f | 0;
                h6 = h6 + g | 0;
                h7 = h7 + h | 0;
                off += 64;
                len -= 64;
            }
        }
        blocks(m);
        let i, bytesLeft = m.length % 64, bitLenHi = m.length / 0x20000000 | 0, bitLenLo = m.length << 3, numZeros = bytesLeft < 56 ? 56 : 120, p = m.slice(m.length - bytesLeft, m.length);
        p.push(0x80);
        for(i = bytesLeft + 1; i < numZeros; i++)p.push(0);
        p.push(bitLenHi >>> 24 & 0xff);
        p.push(bitLenHi >>> 16 & 0xff);
        p.push(bitLenHi >>> 8 & 0xff);
        p.push(bitLenHi >>> 0 & 0xff);
        p.push(bitLenLo >>> 24 & 0xff);
        p.push(bitLenLo >>> 16 & 0xff);
        p.push(bitLenLo >>> 8 & 0xff);
        p.push(bitLenLo >>> 0 & 0xff);
        blocks(p);
        return [
            h0 >>> 24 & 0xff,
            h0 >>> 16 & 0xff,
            h0 >>> 8 & 0xff,
            h0 >>> 0 & 0xff,
            h1 >>> 24 & 0xff,
            h1 >>> 16 & 0xff,
            h1 >>> 8 & 0xff,
            h1 >>> 0 & 0xff,
            h2 >>> 24 & 0xff,
            h2 >>> 16 & 0xff,
            h2 >>> 8 & 0xff,
            h2 >>> 0 & 0xff,
            h3 >>> 24 & 0xff,
            h3 >>> 16 & 0xff,
            h3 >>> 8 & 0xff,
            h3 >>> 0 & 0xff,
            h4 >>> 24 & 0xff,
            h4 >>> 16 & 0xff,
            h4 >>> 8 & 0xff,
            h4 >>> 0 & 0xff,
            h5 >>> 24 & 0xff,
            h5 >>> 16 & 0xff,
            h5 >>> 8 & 0xff,
            h5 >>> 0 & 0xff,
            h6 >>> 24 & 0xff,
            h6 >>> 16 & 0xff,
            h6 >>> 8 & 0xff,
            h6 >>> 0 & 0xff,
            h7 >>> 24 & 0xff,
            h7 >>> 16 & 0xff,
            h7 >>> 8 & 0xff,
            h7 >>> 0 & 0xff
        ];
    }
    function PBKDF2_HMAC_SHA256_OneIter(password, salt, dkLen) {
        // compress password if it's longer than hash block length
        password = password.length <= 64 ? password : SHA256(password);
        const innerLen = 64 + salt.length + 4;
        const inner = new Array(innerLen);
        const outerKey = new Array(64);
        let i;
        let dk = [];
        // inner = (password ^ ipad) || salt || counter
        for(i = 0; i < 64; i++)inner[i] = 0x36;
        for(i = 0; i < password.length; i++)inner[i] ^= password[i];
        for(i = 0; i < salt.length; i++)inner[64 + i] = salt[i];
        for(i = innerLen - 4; i < innerLen; i++)inner[i] = 0;
        // outerKey = password ^ opad
        for(i = 0; i < 64; i++)outerKey[i] = 0x5c;
        for(i = 0; i < password.length; i++)outerKey[i] ^= password[i];
        // increments counter inside inner
        function incrementCounter() {
            for(let i = innerLen - 1; i >= innerLen - 4; i--){
                inner[i]++;
                if (inner[i] <= 0xff) return;
                inner[i] = 0;
            }
        }
        // output blocks = SHA256(outerKey || SHA256(inner)) ...
        while(dkLen >= 32){
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))));
            dkLen -= 32;
        }
        if (dkLen > 0) {
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))).slice(0, dkLen));
        }
        return dk;
    }
    // The following is an adaptation of scryptsy
    // See: https://www.npmjs.com/package/scryptsy
    function blockmix_salsa8(BY, Yi, r, x, _X) {
        let i;
        arraycopy(BY, (2 * r - 1) * 16, _X, 0, 16);
        for(i = 0; i < 2 * r; i++){
            blockxor(BY, i * 16, _X, 16);
            salsa20_8(_X, x);
            arraycopy(_X, 0, BY, Yi + i * 16, 16);
        }
        for(i = 0; i < r; i++)arraycopy(BY, Yi + i * 32, BY, i * 16, 16);
        for(i = 0; i < r; i++)arraycopy(BY, Yi + (i * 2 + 1) * 16, BY, (i + r) * 16, 16);
    }
    function R(a, b) {
        return a << b | a >>> 32 - b;
    }
    function salsa20_8(B, x) {
        arraycopy(B, 0, x, 0, 16);
        for(let i = 8; i > 0; i -= 2){
            x[4] ^= R(x[0] + x[12], 7);
            x[8] ^= R(x[4] + x[0], 9);
            x[12] ^= R(x[8] + x[4], 13);
            x[0] ^= R(x[12] + x[8], 18);
            x[9] ^= R(x[5] + x[1], 7);
            x[13] ^= R(x[9] + x[5], 9);
            x[1] ^= R(x[13] + x[9], 13);
            x[5] ^= R(x[1] + x[13], 18);
            x[14] ^= R(x[10] + x[6], 7);
            x[2] ^= R(x[14] + x[10], 9);
            x[6] ^= R(x[2] + x[14], 13);
            x[10] ^= R(x[6] + x[2], 18);
            x[3] ^= R(x[15] + x[11], 7);
            x[7] ^= R(x[3] + x[15], 9);
            x[11] ^= R(x[7] + x[3], 13);
            x[15] ^= R(x[11] + x[7], 18);
            x[1] ^= R(x[0] + x[3], 7);
            x[2] ^= R(x[1] + x[0], 9);
            x[3] ^= R(x[2] + x[1], 13);
            x[0] ^= R(x[3] + x[2], 18);
            x[6] ^= R(x[5] + x[4], 7);
            x[7] ^= R(x[6] + x[5], 9);
            x[4] ^= R(x[7] + x[6], 13);
            x[5] ^= R(x[4] + x[7], 18);
            x[11] ^= R(x[10] + x[9], 7);
            x[8] ^= R(x[11] + x[10], 9);
            x[9] ^= R(x[8] + x[11], 13);
            x[10] ^= R(x[9] + x[8], 18);
            x[12] ^= R(x[15] + x[14], 7);
            x[13] ^= R(x[12] + x[15], 9);
            x[14] ^= R(x[13] + x[12], 13);
            x[15] ^= R(x[14] + x[13], 18);
        }
        for(let i = 0; i < 16; ++i)B[i] += x[i];
    }
    // naive approach... going back to loop unrolling may yield additional performance
    function blockxor(S, Si, D, len) {
        for(let i = 0; i < len; i++)D[i] ^= S[Si + i];
    }
    function arraycopy(src, srcPos, dest, destPos, length) {
        while(length--)dest[destPos++] = src[srcPos++];
    }
    function checkBufferish(o) {
        if (!o || typeof o.length !== "number") return false;
        for(let i = 0; i < o.length; i++){
            const v = o[i];
            if (typeof v !== "number" || v % 1 || v < 0 || v >= 256) return false;
        }
        return true;
    }
    function ensureInteger(value, name) {
        if (typeof value !== "number" || value % 1) throw new Error("invalid " + name);
        return value;
    }
    // N = Cpu cost, r = Memory cost, p = parallelization cost
    // callback(error, progress, key)
    function _scrypt(password, salt, N, r, p, dkLen, callback) {
        N = ensureInteger(N, "N");
        r = ensureInteger(r, "r");
        p = ensureInteger(p, "p");
        dkLen = ensureInteger(dkLen, "dkLen");
        if (N === 0 || (N & N - 1) !== 0) throw new Error("N must be power of 2");
        if (N > MAX_VALUE / 128 / r) throw new Error("N too large");
        if (r > MAX_VALUE / 128 / p) throw new Error("r too large");
        if (!checkBufferish(password)) throw new Error("password must be an array or buffer");
        password = Array.prototype.slice.call(password);
        if (!checkBufferish(salt)) throw new Error("salt must be an array or buffer");
        salt = Array.prototype.slice.call(salt);
        let b = PBKDF2_HMAC_SHA256_OneIter(password, salt, p * 128 * r);
        const B = new Uint32Array(p * 32 * r);
        for(let i = 0; i < B.length; i++){
            const j = i * 4;
            B[i] = (b[j + 3] & 0xff) << 24 | (b[j + 2] & 0xff) << 16 | (b[j + 1] & 0xff) << 8 | (b[j + 0] & 0xff) << 0;
        }
        const XY = new Uint32Array(64 * r);
        const V = new Uint32Array(32 * r * N);
        const Yi = 32 * r;
        // scratch space
        const x = new Uint32Array(16); // salsa20_8
        const _X = new Uint32Array(16); // blockmix_salsa8
        const totalOps = p * N * 2;
        let currentOp = 0;
        let lastPercent10 = null;
        // Set this to true to abandon the scrypt on the next step
        let stop = false;
        // State information
        let state = 0;
        let i0 = 0, i1;
        let Bi;
        // How many blockmix_salsa8 can we do per step?
        const limit = callback ? parseInt(1000 / r) : 0xffffffff;
        // Trick from scrypt-async; if there is a setImmediate shim in place, use it
        const nextTick = typeof setImmediate !== "undefined" ? setImmediate : setTimeout;
        // This is really all I changed; making scryptsy a state machine so we occasionally
        // stop and give other evnts on the evnt loop a chance to run. ~RicMoo
        const incrementalSMix = function() {
            if (stop) return callback(new Error("cancelled"), currentOp / totalOps);
            let steps;
            switch(state){
                case 0:
                    // for (var i = 0; i < p; i++)...
                    Bi = i0 * 32 * r;
                    arraycopy(B, Bi, XY, 0, Yi); // ROMix - 1
                    state = 1; // Move to ROMix 2
                    i1 = 0;
                // Fall through
                case 1:
                    // Run up to 1000 steps of the first inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        arraycopy(XY, 0, V, (i1 + i) * Yi, Yi) // ROMix - 3
                        ;
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 4
                    }
                    // for (var i = 0; i < N; i++)
                    i1 += steps;
                    currentOp += steps;
                    if (callback) {
                        // Call the callback with the progress (optionally stopping us)
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    i1 = 0; // Move to ROMix 6
                    state = 2;
                // Fall through
                case 2:
                    // Run up to 1000 steps of the second inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        const offset = (2 * r - 1) * 16; // ROMix - 7
                        const j = XY[offset] & N - 1;
                        blockxor(V, j * Yi, XY, Yi); // ROMix - 8 (inner)
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 9 (outer)
                    }
                    // for (var i = 0; i < N; i++)...
                    i1 += steps;
                    currentOp += steps;
                    // Call the callback with the progress (optionally stopping us)
                    if (callback) {
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    arraycopy(XY, 0, B, Bi, Yi); // ROMix - 10
                    // for (var i = 0; i < p; i++)...
                    i0++;
                    if (i0 < p) {
                        state = 0;
                        break;
                    }
                    b = [];
                    for(let i = 0; i < B.length; i++){
                        b.push(B[i] >> 0 & 0xff);
                        b.push(B[i] >> 8 & 0xff);
                        b.push(B[i] >> 16 & 0xff);
                        b.push(B[i] >> 24 & 0xff);
                    }
                    const derivedKey = PBKDF2_HMAC_SHA256_OneIter(password, b, dkLen);
                    // Send the result to the callback
                    if (callback) callback(null, 1.0, derivedKey);
                    // Done; don't break (which would reschedule)
                    return derivedKey;
            }
            // Schedule the next steps
            if (callback) nextTick(incrementalSMix);
        };
        // Run the smix state machine until completion
        if (!callback) while(true){
            const derivedKey = incrementalSMix();
            if (derivedKey != undefined) return derivedKey;
        }
        // Bootstrap the async incremental smix
        incrementalSMix();
    }
    const lib = {
        scrypt: function(password, salt, N, r, p, dkLen, progressCallback) {
            return new Promise(function(resolve, reject) {
                let lastProgress = 0;
                if (progressCallback) progressCallback(0);
                _scrypt(password, salt, N, r, p, dkLen, function(error, progress, key) {
                    if (error) reject(error);
                    else if (key) {
                        if (progressCallback && lastProgress !== 1) progressCallback(1);
                        resolve(new Uint8Array(key));
                    } else if (progressCallback && progress !== lastProgress) {
                        lastProgress = progress;
                        return progressCallback(progress);
                    }
                });
            });
        },
        syncScrypt: function(password, salt, N, r, p, dkLen) {
            return new Uint8Array(_scrypt(password, salt, N, r, p, dkLen));
        }
    };
    // node.js
    if (typeof $a4ccce1783a297c7$exports !== "undefined") $a4ccce1783a297c7$exports = lib;
    else if (typeof define === "function" && define.amd) define(lib);
    else if (root) {
        // If there was an existing library "scrypt", make sure it is still available
        if (root.scrypt) root._scrypt = root.scrypt;
        root.scrypt = lib;
    }
})($a4ccce1783a297c7$exports);













"use strict";
var $5cd719aa79671b4c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $5cd719aa79671b4c$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $a4c18596bcdbd717$export$83d89fbfd8236492));
// Exported Types
function $5cd719aa79671b4c$var$hasMnemonic(value) {
    return value != null && value.mnemonic && value.mnemonic.phrase;
}
class $5cd719aa79671b4c$export$cf9dc4fd6dde0315 extends (0, $19462b55124983f4$exports.Description) {
    isKeystoreAccount(value) {
        return !!(value && value._isKeystoreAccount);
    }
}
function $5cd719aa79671b4c$var$_decrypt(data, key, ciphertext) {
    const cipher = (0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "crypto/cipher");
    if (cipher === "aes-128-ctr") {
        const iv = (0, $85bc5d60031db318$export$2cde08bde0cfd932)((0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "crypto/cipherparams/iv"));
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($72ea0040e5768fb5$exports))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($72ea0040e5768fb5$exports))).ModeOfOperation.ctr(key, counter);
        return (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(aesCtr.decrypt(ciphertext));
    }
    return null;
}
function $5cd719aa79671b4c$var$_getAccount(data, key) {
    const ciphertext = (0, $85bc5d60031db318$export$2cde08bde0cfd932)((0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "crypto/ciphertext"));
    const computedMAC = (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)((0, $344909d1f36347b2$export$f8151fce47ad1c35)((0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
        key.slice(16, 32),
        ciphertext
    ]))).substring(2);
    if (computedMAC !== (0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "crypto/mac").toLowerCase()) throw new Error("invalid password");
    const privateKey = $5cd719aa79671b4c$var$_decrypt(data, key.slice(0, 16), ciphertext);
    if (!privateKey) $5cd719aa79671b4c$var$logger.throwError("unsupported cipher", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "decrypt"
    });
    const mnemonicKey = key.slice(32, 64);
    const address = (0, $cd7e99036b8e7d03$export$e67e2732ba9803f9)(privateKey);
    if (data.address) {
        let check = data.address.toLowerCase();
        if (check.substring(0, 2) !== "0x") check = "0x" + check;
        if ((0, $a4b82b374f356b4b$export$88411125f012957a)(check) !== address) throw new Error("address mismatch");
    }
    const account = {
        _isKeystoreAccount: true,
        address: address,
        privateKey: (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(privateKey)
    };
    // Version 0.1 x-ethers metadata must contain an encrypted mnemonic phrase
    if ((0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "x-ethers/version") === "0.1") {
        const mnemonicCiphertext = (0, $85bc5d60031db318$export$2cde08bde0cfd932)((0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "x-ethers/mnemonicCiphertext"));
        const mnemonicIv = (0, $85bc5d60031db318$export$2cde08bde0cfd932)((0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "x-ethers/mnemonicCounter"));
        const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($72ea0040e5768fb5$exports))).Counter(mnemonicIv);
        const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($72ea0040e5768fb5$exports))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
        const path = (0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "x-ethers/path") || (0, $3dbe328f09720d4a$export$d48ad89f7e11a603);
        const locale = (0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "x-ethers/locale") || "en";
        const entropy = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(mnemonicAesCtr.decrypt(mnemonicCiphertext));
        try {
            const mnemonic = (0, $3dbe328f09720d4a$export$4becd65eb23312e6)(entropy, locale);
            const node = (0, $3dbe328f09720d4a$export$b68640c53e22b952).fromMnemonic(mnemonic, null, locale).derivePath(path);
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
            account.mnemonic = node.mnemonic;
        } catch (error) {
            // If we don't have the locale wordlist installed to
            // read this mnemonic, just bail and don't set the
            // mnemonic
            if (error.code !== (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.INVALID_ARGUMENT || error.argument !== "wordlist") throw error;
        }
    }
    return new $5cd719aa79671b4c$export$cf9dc4fd6dde0315(account);
}
function $5cd719aa79671b4c$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc) {
    return (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)((0, $ab7da8db31000bcc$export$448fa22aedc9dbca)(passwordBytes, salt, count, dkLen, prfFunc));
}
function $5cd719aa79671b4c$var$pbkdf2(passwordBytes, salt, count, dkLen, prfFunc) {
    return Promise.resolve($5cd719aa79671b4c$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc));
}
function $5cd719aa79671b4c$var$_computeKdfKey(data, password, pbkdf2Func, scryptFunc, progressCallback) {
    const passwordBytes = (0, $85bc5d60031db318$export$350bd33120f7413e)(password);
    const kdf = (0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "crypto/kdf");
    if (kdf && typeof kdf === "string") {
        const throwError = function(name, value) {
            return $5cd719aa79671b4c$var$logger.throwArgumentError("invalid key-derivation function parameters", name, value);
        };
        if (kdf.toLowerCase() === "scrypt") {
            const salt = (0, $85bc5d60031db318$export$2cde08bde0cfd932)((0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/salt"));
            const N = parseInt((0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/n"));
            const r = parseInt((0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/r"));
            const p = parseInt((0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/p"));
            // Check for all required parameters
            if (!N || !r || !p) throwError("kdf", kdf);
            // Make sure N is a power of 2
            if ((N & N - 1) !== 0) throwError("N", N);
            const dkLen = parseInt((0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return scryptFunc(passwordBytes, salt, N, r, p, 64, progressCallback);
        } else if (kdf.toLowerCase() === "pbkdf2") {
            const salt = (0, $85bc5d60031db318$export$2cde08bde0cfd932)((0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/salt"));
            let prfFunc = null;
            const prf = (0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/prf");
            if (prf === "hmac-sha256") prfFunc = "sha256";
            else if (prf === "hmac-sha512") prfFunc = "sha512";
            else throwError("prf", prf);
            const count = parseInt((0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/c"));
            const dkLen = parseInt((0, $85bc5d60031db318$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return pbkdf2Func(passwordBytes, salt, count, dkLen, prfFunc);
        }
    }
    return $5cd719aa79671b4c$var$logger.throwArgumentError("unsupported key-derivation function", "kdf", kdf);
}
function $5cd719aa79671b4c$export$9bd2c37889ee5e36(json, password) {
    const data = JSON.parse(json);
    const key = $5cd719aa79671b4c$var$_computeKdfKey(data, password, $5cd719aa79671b4c$var$pbkdf2Sync, (0, (/*@__PURE__*/$parcel$interopDefault($a4ccce1783a297c7$exports))).syncScrypt);
    return $5cd719aa79671b4c$var$_getAccount(data, key);
}
function $5cd719aa79671b4c$export$e85a0c9a1067c5d3(json, password, progressCallback) {
    return $5cd719aa79671b4c$var$__awaiter(this, void 0, void 0, function*() {
        const data = JSON.parse(json);
        const key = yield $5cd719aa79671b4c$var$_computeKdfKey(data, password, $5cd719aa79671b4c$var$pbkdf2, (0, (/*@__PURE__*/$parcel$interopDefault($a4ccce1783a297c7$exports))).scrypt, progressCallback);
        return $5cd719aa79671b4c$var$_getAccount(data, key);
    });
}
function $5cd719aa79671b4c$export$5b0f6292f11d1d18(account, password, options, progressCallback) {
    try {
        // Check the address matches the private key
        if ((0, $a4b82b374f356b4b$export$88411125f012957a)(account.address) !== (0, $cd7e99036b8e7d03$export$e67e2732ba9803f9)(account.privateKey)) throw new Error("address/privateKey mismatch");
        // Check the mnemonic (if any) matches the private key
        if ($5cd719aa79671b4c$var$hasMnemonic(account)) {
            const mnemonic = account.mnemonic;
            const node = (0, $3dbe328f09720d4a$export$b68640c53e22b952).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path || (0, $3dbe328f09720d4a$export$d48ad89f7e11a603));
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
        }
    } catch (e) {
        return Promise.reject(e);
    }
    // The options are optional, so adjust the call as needed
    if (typeof options === "function" && !progressCallback) {
        progressCallback = options;
        options = {};
    }
    if (!options) options = {};
    const privateKey = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(account.privateKey);
    const passwordBytes = (0, $85bc5d60031db318$export$350bd33120f7413e)(password);
    let entropy = null;
    let path = null;
    let locale = null;
    if ($5cd719aa79671b4c$var$hasMnemonic(account)) {
        const srcMnemonic = account.mnemonic;
        entropy = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)((0, $3dbe328f09720d4a$export$135e090d58b310ca)(srcMnemonic.phrase, srcMnemonic.locale || "en"));
        path = srcMnemonic.path || (0, $3dbe328f09720d4a$export$d48ad89f7e11a603);
        locale = srcMnemonic.locale || "en";
    }
    let client = options.client;
    if (!client) client = "ethers.js";
    // Check/generate the salt
    let salt = null;
    if (options.salt) salt = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(options.salt);
    else salt = (0, $32835a60ff995f3a$export$5f828d93ff035aa8)(32);
    // Override initialization vector
    let iv = null;
    if (options.iv) {
        iv = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(options.iv);
        if (iv.length !== 16) throw new Error("invalid iv");
    } else iv = (0, $32835a60ff995f3a$export$5f828d93ff035aa8)(16);
    // Override the uuid
    let uuidRandom = null;
    if (options.uuid) {
        uuidRandom = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(options.uuid);
        if (uuidRandom.length !== 16) throw new Error("invalid uuid");
    } else uuidRandom = (0, $32835a60ff995f3a$export$5f828d93ff035aa8)(16);
    // Override the scrypt password-based key derivation function parameters
    let N = 131072, r = 8, p = 1;
    if (options.scrypt) {
        if (options.scrypt.N) N = options.scrypt.N;
        if (options.scrypt.r) r = options.scrypt.r;
        if (options.scrypt.p) p = options.scrypt.p;
    }
    // We take 64 bytes:
    //   - 32 bytes   As normal for the Web3 secret storage (derivedKey, macPrefix)
    //   - 32 bytes   AES key to encrypt mnemonic with (required here to be Ethers Wallet)
    return (0, (/*@__PURE__*/$parcel$interopDefault($a4ccce1783a297c7$exports))).scrypt(passwordBytes, salt, N, r, p, 64, progressCallback).then((key)=>{
        key = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(key);
        // This will be used to encrypt the wallet (as per Web3 secret storage)
        const derivedKey = key.slice(0, 16);
        const macPrefix = key.slice(16, 32);
        // This will be used to encrypt the mnemonic phrase (if any)
        const mnemonicKey = key.slice(32, 64);
        // Encrypt the private key
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($72ea0040e5768fb5$exports))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($72ea0040e5768fb5$exports))).ModeOfOperation.ctr(derivedKey, counter);
        const ciphertext = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(aesCtr.encrypt(privateKey));
        // Compute the message authentication code, used to check the password
        const mac = (0, $344909d1f36347b2$export$f8151fce47ad1c35)((0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
            macPrefix,
            ciphertext
        ]));
        // See: https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition
        const data = {
            address: account.address.substring(2).toLowerCase(),
            id: (0, $85bc5d60031db318$export$ec7b18ebad55a3a9)(uuidRandom),
            version: 3,
            crypto: {
                cipher: "aes-128-ctr",
                cipherparams: {
                    iv: (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(iv).substring(2)
                },
                ciphertext: (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(ciphertext).substring(2),
                kdf: "scrypt",
                kdfparams: {
                    salt: (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(salt).substring(2),
                    n: N,
                    dklen: 32,
                    p: p,
                    r: r
                },
                mac: mac.substring(2)
            }
        };
        // If we have a mnemonic, encrypt it into the JSON wallet
        if (entropy) {
            const mnemonicIv = (0, $32835a60ff995f3a$export$5f828d93ff035aa8)(16);
            const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($72ea0040e5768fb5$exports))).Counter(mnemonicIv);
            const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($72ea0040e5768fb5$exports))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
            const mnemonicCiphertext = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(mnemonicAesCtr.encrypt(entropy));
            const now = new Date();
            const timestamp = now.getUTCFullYear() + "-" + (0, $85bc5d60031db318$export$67752b99d3bc61c6)(now.getUTCMonth() + 1, 2) + "-" + (0, $85bc5d60031db318$export$67752b99d3bc61c6)(now.getUTCDate(), 2) + "T" + (0, $85bc5d60031db318$export$67752b99d3bc61c6)(now.getUTCHours(), 2) + "-" + (0, $85bc5d60031db318$export$67752b99d3bc61c6)(now.getUTCMinutes(), 2) + "-" + (0, $85bc5d60031db318$export$67752b99d3bc61c6)(now.getUTCSeconds(), 2) + ".0Z";
            data["x-ethers"] = {
                client: client,
                gethFilename: "UTC--" + timestamp + "--" + data.address,
                mnemonicCounter: (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(mnemonicIv).substring(2),
                mnemonicCiphertext: (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)(mnemonicCiphertext).substring(2),
                path: path,
                locale: locale,
                version: "0.1"
            };
        }
        return JSON.stringify(data);
    });
}


"use strict";
function $b47df5b3ead53646$export$e74fcde37488267a(json, password, progressCallback) {
    if ((0, $4999eee0db3e68cf$export$724d6cf6b9fd8578)(json)) {
        if (progressCallback) progressCallback(0);
        const account = (0, $ca811ee56d4e2b01$export$e85a0c9a1067c5d3)(json, password);
        if (progressCallback) progressCallback(1);
        return Promise.resolve(account);
    }
    if ((0, $4999eee0db3e68cf$export$67dc926b8e68b2d8)(json)) return (0, $5cd719aa79671b4c$exports.decrypt)(json, password, progressCallback);
    return Promise.reject(new Error("invalid JSON wallet"));
}
function $b47df5b3ead53646$export$7a81c437a678891a(json, password) {
    if ((0, $4999eee0db3e68cf$export$724d6cf6b9fd8578)(json)) return (0, $ca811ee56d4e2b01$export$e85a0c9a1067c5d3)(json, password);
    if ((0, $4999eee0db3e68cf$export$67dc926b8e68b2d8)(json)) return (0, $5cd719aa79671b4c$exports.decryptSync)(json, password);
    throw new Error("invalid JSON wallet");
}




const $ab5ebdfa7aaeb9e4$export$83d89fbfd8236492 = "wallet/5.7.0";


"use strict";
var $3b1688dbad3fbfea$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $3b1688dbad3fbfea$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $ab5ebdfa7aaeb9e4$export$83d89fbfd8236492));
function $3b1688dbad3fbfea$var$isAccount(value) {
    return value != null && (0, $ddc3d9704a40b613$export$b02a40aff8e4ad18)(value.privateKey, 32) && value.address != null;
}
function $3b1688dbad3fbfea$var$hasMnemonic(value) {
    const mnemonic = value.mnemonic;
    return mnemonic && mnemonic.phrase;
}
class $3b1688dbad3fbfea$export$bcca3ea514774656 extends (0, $d9b7eb644de5bd3c$exports.Signer) {
    get mnemonic() {
        return this._mnemonic();
    }
    get privateKey() {
        return this._signingKey().privateKey;
    }
    get publicKey() {
        return this._signingKey().publicKey;
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    connect(provider) {
        return new $3b1688dbad3fbfea$export$bcca3ea514774656(this, provider);
    }
    signTransaction(transaction) {
        return (0, $19462b55124983f4$exports.resolveProperties)(transaction).then((tx)=>{
            if (tx.from != null) {
                if ((0, $a4b82b374f356b4b$export$88411125f012957a)(tx.from) !== this.address) $3b1688dbad3fbfea$var$logger.throwArgumentError("transaction from address mismatch", "transaction.from", transaction.from);
                delete tx.from;
            }
            const signature = this._signingKey().signDigest((0, $344909d1f36347b2$export$f8151fce47ad1c35)((0, $cd7e99036b8e7d03$export$dfdc1655ccc5b9cb)(tx)));
            return (0, $cd7e99036b8e7d03$export$dfdc1655ccc5b9cb)(tx, signature);
        });
    }
    signMessage(message) {
        return $3b1688dbad3fbfea$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $ddc3d9704a40b613$export$71bb9d78a59bbe25)(this._signingKey().signDigest((0, $578b0e6ea1b3b477$export$d4c241cec96564c1)(message)));
        });
    }
    _signTypedData(domain, types, value) {
        return $3b1688dbad3fbfea$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names
            const populated = yield (0, $eb73d9441da70c0d$exports.TypedDataEncoder).resolveNames(domain, types, value, (name)=>{
                if (this.provider == null) $3b1688dbad3fbfea$var$logger.throwError("cannot resolve ENS names without a provider", (0, $4eebf1ca9f327f54$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    operation: "resolveName",
                    value: name
                });
                return this.provider.resolveName(name);
            });
            return (0, $ddc3d9704a40b613$export$71bb9d78a59bbe25)(this._signingKey().signDigest((0, $eb73d9441da70c0d$exports.TypedDataEncoder).hash(populated.domain, types, populated.value)));
        });
    }
    encrypt(password, options, progressCallback) {
        if (typeof options === "function" && !progressCallback) {
            progressCallback = options;
            options = {};
        }
        if (progressCallback && typeof progressCallback !== "function") throw new Error("invalid callback");
        if (!options) options = {};
        return (0, $5cd719aa79671b4c$exports.encrypt)(this, password, options, progressCallback);
    }
    /**
     *  Static methods to create Wallet instances.
     */ static createRandom(options) {
        let entropy = (0, $32835a60ff995f3a$export$5f828d93ff035aa8)(16);
        if (!options) options = {};
        if (options.extraEntropy) entropy = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)((0, $ddc3d9704a40b613$export$15da666eba198c18)((0, $344909d1f36347b2$export$f8151fce47ad1c35)((0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
            entropy,
            options.extraEntropy
        ])), 0, 16));
        const mnemonic = (0, $3dbe328f09720d4a$export$4becd65eb23312e6)(entropy, options.locale);
        return $3b1688dbad3fbfea$export$bcca3ea514774656.fromMnemonic(mnemonic, options.path, options.locale);
    }
    static fromEncryptedJson(json, password, progressCallback) {
        return (0, $b47df5b3ead53646$export$e74fcde37488267a)(json, password, progressCallback).then((account)=>{
            return new $3b1688dbad3fbfea$export$bcca3ea514774656(account);
        });
    }
    static fromEncryptedJsonSync(json, password) {
        return new $3b1688dbad3fbfea$export$bcca3ea514774656((0, $b47df5b3ead53646$export$7a81c437a678891a)(json, password));
    }
    static fromMnemonic(mnemonic, path, wordlist) {
        if (!path) path = (0, $3dbe328f09720d4a$export$d48ad89f7e11a603);
        return new $3b1688dbad3fbfea$export$bcca3ea514774656((0, $3dbe328f09720d4a$export$b68640c53e22b952).fromMnemonic(mnemonic, null, wordlist).derivePath(path));
    }
    constructor(privateKey, provider){
        super();
        if ($3b1688dbad3fbfea$var$isAccount(privateKey)) {
            const signingKey = new (0, $378334ead6ec6b6e$export$21643ca94aed3e83)(privateKey.privateKey);
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "_signingKey", ()=>signingKey);
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "address", (0, $cd7e99036b8e7d03$export$e67e2732ba9803f9)(this.publicKey));
            if (this.address !== (0, $a4b82b374f356b4b$export$88411125f012957a)(privateKey.address)) $3b1688dbad3fbfea$var$logger.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]");
            if ($3b1688dbad3fbfea$var$hasMnemonic(privateKey)) {
                const srcMnemonic = privateKey.mnemonic;
                (0, $19462b55124983f4$exports.defineReadOnly)(this, "_mnemonic", ()=>({
                        phrase: srcMnemonic.phrase,
                        path: srcMnemonic.path || (0, $3dbe328f09720d4a$export$d48ad89f7e11a603),
                        locale: srcMnemonic.locale || "en"
                    }));
                const mnemonic = this.mnemonic;
                const node = (0, $3dbe328f09720d4a$export$b68640c53e22b952).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path);
                if ((0, $cd7e99036b8e7d03$export$e67e2732ba9803f9)(node.privateKey) !== this.address) $3b1688dbad3fbfea$var$logger.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
            } else (0, $19462b55124983f4$exports.defineReadOnly)(this, "_mnemonic", ()=>null);
        } else {
            if ((0, $378334ead6ec6b6e$export$21643ca94aed3e83).isSigningKey(privateKey)) {
                /* istanbul ignore if */ if (privateKey.curve !== "secp256k1") $3b1688dbad3fbfea$var$logger.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]");
                (0, $19462b55124983f4$exports.defineReadOnly)(this, "_signingKey", ()=>privateKey);
            } else {
                // A lot of common tools do not prefix private keys with a 0x (see: #1166)
                if (typeof privateKey === "string") {
                    if (privateKey.match(/^[0-9a-f]*$/i) && privateKey.length === 64) privateKey = "0x" + privateKey;
                }
                const signingKey = new (0, $378334ead6ec6b6e$export$21643ca94aed3e83)(privateKey);
                (0, $19462b55124983f4$exports.defineReadOnly)(this, "_signingKey", ()=>signingKey);
            }
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "_mnemonic", ()=>null);
            (0, $19462b55124983f4$exports.defineReadOnly)(this, "address", (0, $cd7e99036b8e7d03$export$e67e2732ba9803f9)(this.publicKey));
        }
        /* istanbul ignore if */ if (provider && !(0, $fd80fed41b6901ec$exports.Provider).isProvider(provider)) $3b1688dbad3fbfea$var$logger.throwArgumentError("invalid provider", "provider", provider);
        (0, $19462b55124983f4$exports.defineReadOnly)(this, "provider", provider || null);
    }
}
function $3b1688dbad3fbfea$export$228d0e772cc158cb(message, signature) {
    return (0, $cd7e99036b8e7d03$export$23cc18f96d8510e2)((0, $578b0e6ea1b3b477$export$d4c241cec96564c1)(message), signature);
}
function $3b1688dbad3fbfea$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $cd7e99036b8e7d03$export$23cc18f96d8510e2)((0, $eb73d9441da70c0d$exports.TypedDataEncoder).hash(domain, types, value), signature);
}


var $273a5a8df3bb8508$exports = {};

$parcel$export($273a5a8df3bb8508$exports, "AddressZero", function () { return $3d13afb7ba7a6bb7$export$badd13187c087617; });
$parcel$export($273a5a8df3bb8508$exports, "NegativeOne", function () { return $af43ef4e381177e0$export$c83ef0909a6ddeec; });
$parcel$export($273a5a8df3bb8508$exports, "Zero", function () { return $af43ef4e381177e0$export$aaef8a3eae948f03; });
$parcel$export($273a5a8df3bb8508$exports, "One", function () { return $af43ef4e381177e0$export$9aa05a5866350bcf; });
$parcel$export($273a5a8df3bb8508$exports, "Two", function () { return $af43ef4e381177e0$export$9276dd97bf62cc8d; });
$parcel$export($273a5a8df3bb8508$exports, "WeiPerEther", function () { return $af43ef4e381177e0$export$c8db55bd7405209e; });
$parcel$export($273a5a8df3bb8508$exports, "MaxUint256", function () { return $af43ef4e381177e0$export$1b53890de5aabdd0; });
$parcel$export($273a5a8df3bb8508$exports, "MinInt256", function () { return $af43ef4e381177e0$export$963c9b9317b80aaf; });
$parcel$export($273a5a8df3bb8508$exports, "MaxInt256", function () { return $af43ef4e381177e0$export$6f8dbb07ebe6d738; });
$parcel$export($273a5a8df3bb8508$exports, "HashZero", function () { return $43ba40ff64f1a63e$export$71c2e4e213dcb7f2; });
$parcel$export($273a5a8df3bb8508$exports, "EtherSymbol", function () { return $eeea301a94b49b51$export$c7e79fcb6f8ac048; });



// NFKC (composed)             // (decomposed)
const $eeea301a94b49b51$export$c7e79fcb6f8ac048 = "Ξ"; // "\uD835\uDF63";


"use strict";




var $a4175433b234909f$exports = {};

$parcel$export($a4175433b234909f$exports, "AbiCoder", function () { return $068794918994f80d$export$fe041e1a83d3efc6; });
$parcel$export($a4175433b234909f$exports, "defaultAbiCoder", function () { return $068794918994f80d$export$51d1cfcdb913adff; });
$parcel$export($a4175433b234909f$exports, "Fragment", function () { return $4d2654448f804eaa$export$ffb0004e005737fa; });
$parcel$export($a4175433b234909f$exports, "ConstructorFragment", function () { return $4d2654448f804eaa$export$3ac5c9504f801ea4; });
$parcel$export($a4175433b234909f$exports, "ErrorFragment", function () { return $4d2654448f804eaa$export$2c42c6d543aa9b59; });
$parcel$export($a4175433b234909f$exports, "EventFragment", function () { return $4d2654448f804eaa$export$958548f08bac2833; });
$parcel$export($a4175433b234909f$exports, "FunctionFragment", function () { return $4d2654448f804eaa$export$8d576c928b93668f; });
$parcel$export($a4175433b234909f$exports, "ParamType", function () { return $4d2654448f804eaa$export$426dc07f493a4c47; });
$parcel$export($a4175433b234909f$exports, "FormatTypes", function () { return $4d2654448f804eaa$export$f010f239efc4d445; });
$parcel$export($a4175433b234909f$exports, "checkResultErrors", function () { return $bd6d84ecef385088$export$5546b9ec21157cc2; });
$parcel$export($a4175433b234909f$exports, "Logger", function () { return $4eebf1ca9f327f54$export$efa9a398d6368992; });
$parcel$export($a4175433b234909f$exports, "RLP", function () { return $a139c5939e084c8c$exports; });
$parcel$export($a4175433b234909f$exports, "_fetchData", function () { return $bf63a14489d0132f$exports._fetchData; });
$parcel$export($a4175433b234909f$exports, "fetchJson", function () { return $bf63a14489d0132f$exports.fetchJson; });
$parcel$export($a4175433b234909f$exports, "poll", function () { return $bf63a14489d0132f$exports.poll; });
$parcel$export($a4175433b234909f$exports, "checkProperties", function () { return $19462b55124983f4$exports.checkProperties; });
$parcel$export($a4175433b234909f$exports, "deepCopy", function () { return $19462b55124983f4$exports.deepCopy; });
$parcel$export($a4175433b234909f$exports, "defineReadOnly", function () { return $19462b55124983f4$exports.defineReadOnly; });
$parcel$export($a4175433b234909f$exports, "getStatic", function () { return $19462b55124983f4$exports.getStatic; });
$parcel$export($a4175433b234909f$exports, "resolveProperties", function () { return $19462b55124983f4$exports.resolveProperties; });
$parcel$export($a4175433b234909f$exports, "shallowCopy", function () { return $19462b55124983f4$exports.shallowCopy; });
$parcel$export($a4175433b234909f$exports, "arrayify", function () { return $ddc3d9704a40b613$export$3131421a7d01b4fb; });
$parcel$export($a4175433b234909f$exports, "concat", function () { return $ddc3d9704a40b613$export$ee1b3e54f0441b22; });
$parcel$export($a4175433b234909f$exports, "stripZeros", function () { return $ddc3d9704a40b613$export$a8f4574d0e56446c; });
$parcel$export($a4175433b234909f$exports, "zeroPad", function () { return $ddc3d9704a40b613$export$3cdc770bf8b2ed3d; });
$parcel$export($a4175433b234909f$exports, "isBytes", function () { return $ddc3d9704a40b613$export$c6fabfbfd097fc30; });
$parcel$export($a4175433b234909f$exports, "isBytesLike", function () { return $ddc3d9704a40b613$export$9a14abb1a440cd5e; });
$parcel$export($a4175433b234909f$exports, "defaultPath", function () { return $3dbe328f09720d4a$export$d48ad89f7e11a603; });
$parcel$export($a4175433b234909f$exports, "HDNode", function () { return $3dbe328f09720d4a$export$b68640c53e22b952; });
$parcel$export($a4175433b234909f$exports, "SigningKey", function () { return $378334ead6ec6b6e$export$21643ca94aed3e83; });
$parcel$export($a4175433b234909f$exports, "Interface", function () { return $6df659078ac9448c$export$48cefb51a4e315b2; });
$parcel$export($a4175433b234909f$exports, "LogDescription", function () { return $6df659078ac9448c$export$c2ab6499be98b3c5; });
$parcel$export($a4175433b234909f$exports, "TransactionDescription", function () { return $6df659078ac9448c$export$7a3223b0fadb690b; });
$parcel$export($a4175433b234909f$exports, "base58", function () { return $a538ed25248fff2d$export$45a587635c9954b2; });
$parcel$export($a4175433b234909f$exports, "base64", function () { return $c9c551e26c372c1d$exports; });
$parcel$export($a4175433b234909f$exports, "hexlify", function () { return $ddc3d9704a40b613$export$2b0d6b5fbe698c70; });
$parcel$export($a4175433b234909f$exports, "isHexString", function () { return $ddc3d9704a40b613$export$b02a40aff8e4ad18; });
$parcel$export($a4175433b234909f$exports, "hexConcat", function () { return $ddc3d9704a40b613$export$6d4b99629b38754a; });
$parcel$export($a4175433b234909f$exports, "hexStripZeros", function () { return $ddc3d9704a40b613$export$967bc0082a978949; });
$parcel$export($a4175433b234909f$exports, "hexValue", function () { return $ddc3d9704a40b613$export$6916af760a341dd3; });
$parcel$export($a4175433b234909f$exports, "hexZeroPad", function () { return $ddc3d9704a40b613$export$e9c46a54370b47e8; });
$parcel$export($a4175433b234909f$exports, "hexDataLength", function () { return $ddc3d9704a40b613$export$13882f896d3c0683; });
$parcel$export($a4175433b234909f$exports, "hexDataSlice", function () { return $ddc3d9704a40b613$export$15da666eba198c18; });
$parcel$export($a4175433b234909f$exports, "nameprep", function () { return $ab2f1c24fdde7ddc$export$94f0b6f93c619bc; });
$parcel$export($a4175433b234909f$exports, "_toEscapedUtf8String", function () { return $169c6c93221d2e48$export$a7a0ec15960b9055; });
$parcel$export($a4175433b234909f$exports, "toUtf8Bytes", function () { return $169c6c93221d2e48$export$8feeb310b4b4752f; });
$parcel$export($a4175433b234909f$exports, "toUtf8CodePoints", function () { return $169c6c93221d2e48$export$ae470a36a31b28c2; });
$parcel$export($a4175433b234909f$exports, "toUtf8String", function () { return $169c6c93221d2e48$export$7643a1dc2c38d5eb; });
$parcel$export($a4175433b234909f$exports, "Utf8ErrorFuncs", function () { return $169c6c93221d2e48$export$c6e2180c5bb5bc05; });
$parcel$export($a4175433b234909f$exports, "formatBytes32String", function () { return $6d6cbd4d8329f5fa$export$b97e949c0076e971; });
$parcel$export($a4175433b234909f$exports, "parseBytes32String", function () { return $6d6cbd4d8329f5fa$export$49340cb8f3954db8; });
$parcel$export($a4175433b234909f$exports, "dnsEncode", function () { return $3715ffed660cd02c$export$6c0a8cdae51cb512; });
$parcel$export($a4175433b234909f$exports, "hashMessage", function () { return $578b0e6ea1b3b477$export$d4c241cec96564c1; });
$parcel$export($a4175433b234909f$exports, "namehash", function () { return $3715ffed660cd02c$export$91d651ee363e1209; });
$parcel$export($a4175433b234909f$exports, "isValidName", function () { return $3715ffed660cd02c$export$cce2300886e7ace6; });
$parcel$export($a4175433b234909f$exports, "id", function () { return $337ebfbf1ce1b46f$export$d560c7e4a29451c2; });
$parcel$export($a4175433b234909f$exports, "_TypedDataEncoder", function () { return $eb73d9441da70c0d$exports.TypedDataEncoder; });
$parcel$export($a4175433b234909f$exports, "getAddress", function () { return $a4b82b374f356b4b$export$88411125f012957a; });
$parcel$export($a4175433b234909f$exports, "getIcapAddress", function () { return $a4b82b374f356b4b$export$962c4ddada9f668f; });
$parcel$export($a4175433b234909f$exports, "getContractAddress", function () { return $a4b82b374f356b4b$export$b7fbffef12272e40; });
$parcel$export($a4175433b234909f$exports, "getCreate2Address", function () { return $a4b82b374f356b4b$export$e0b22d96621f73a2; });
$parcel$export($a4175433b234909f$exports, "isAddress", function () { return $a4b82b374f356b4b$export$977e255126d763d6; });
$parcel$export($a4175433b234909f$exports, "formatEther", function () { return $2eea55bfa3f06576$export$11bc63b4c03ea518; });
$parcel$export($a4175433b234909f$exports, "parseEther", function () { return $2eea55bfa3f06576$export$642c4e67bbdc0bc7; });
$parcel$export($a4175433b234909f$exports, "formatUnits", function () { return $2eea55bfa3f06576$export$bd39b96f71da1885; });
$parcel$export($a4175433b234909f$exports, "parseUnits", function () { return $2eea55bfa3f06576$export$203ae30b4f6490b3; });
$parcel$export($a4175433b234909f$exports, "commify", function () { return $2eea55bfa3f06576$export$de1294767e6ef661; });
$parcel$export($a4175433b234909f$exports, "computeHmac", function () { return $5c9a0ceac3511c58$export$967075d2f3b8e7ff; });
$parcel$export($a4175433b234909f$exports, "keccak256", function () { return $344909d1f36347b2$export$f8151fce47ad1c35; });
$parcel$export($a4175433b234909f$exports, "ripemd160", function () { return $5c9a0ceac3511c58$export$d1cea0ee4e3f0d3e; });
$parcel$export($a4175433b234909f$exports, "sha256", function () { return $5c9a0ceac3511c58$export$bced8d2aada2d1c9; });
$parcel$export($a4175433b234909f$exports, "sha512", function () { return $5c9a0ceac3511c58$export$a888d2532e6dc7bb; });
$parcel$export($a4175433b234909f$exports, "randomBytes", function () { return $32835a60ff995f3a$export$5f828d93ff035aa8; });
$parcel$export($a4175433b234909f$exports, "shuffled", function () { return $3c41ee55241bf87e$export$e6c7296801b9b341; });
$parcel$export($a4175433b234909f$exports, "solidityPack", function () { return $d504cf4938ca3d9c$export$2a703dbb0cb35339; });
$parcel$export($a4175433b234909f$exports, "solidityKeccak256", function () { return $d504cf4938ca3d9c$export$f8151fce47ad1c35; });
$parcel$export($a4175433b234909f$exports, "soliditySha256", function () { return $d504cf4938ca3d9c$export$bced8d2aada2d1c9; });
$parcel$export($a4175433b234909f$exports, "splitSignature", function () { return $ddc3d9704a40b613$export$7fb170f1e457988f; });
$parcel$export($a4175433b234909f$exports, "joinSignature", function () { return $ddc3d9704a40b613$export$71bb9d78a59bbe25; });
$parcel$export($a4175433b234909f$exports, "accessListify", function () { return $cd7e99036b8e7d03$export$6c8662b1600dce2; });
$parcel$export($a4175433b234909f$exports, "parseTransaction", function () { return $cd7e99036b8e7d03$export$98e6a39c04603d36; });
$parcel$export($a4175433b234909f$exports, "serializeTransaction", function () { return $cd7e99036b8e7d03$export$dfdc1655ccc5b9cb; });
$parcel$export($a4175433b234909f$exports, "TransactionTypes", function () { return $cd7e99036b8e7d03$export$80349e05e0724e11; });
$parcel$export($a4175433b234909f$exports, "getJsonWalletAddress", function () { return $4999eee0db3e68cf$export$9a68ee9f8f3afd38; });
$parcel$export($a4175433b234909f$exports, "computeAddress", function () { return $cd7e99036b8e7d03$export$e67e2732ba9803f9; });
$parcel$export($a4175433b234909f$exports, "recoverAddress", function () { return $cd7e99036b8e7d03$export$23cc18f96d8510e2; });
$parcel$export($a4175433b234909f$exports, "computePublicKey", function () { return $378334ead6ec6b6e$export$4a89473d39301224; });
$parcel$export($a4175433b234909f$exports, "recoverPublicKey", function () { return $378334ead6ec6b6e$export$952dd09fbe0232b7; });
$parcel$export($a4175433b234909f$exports, "verifyMessage", function () { return $3b1688dbad3fbfea$exports.verifyMessage; });
$parcel$export($a4175433b234909f$exports, "verifyTypedData", function () { return $3b1688dbad3fbfea$exports.verifyTypedData; });
$parcel$export($a4175433b234909f$exports, "getAccountPath", function () { return $3dbe328f09720d4a$export$22b80e4f9eff636d; });
$parcel$export($a4175433b234909f$exports, "mnemonicToEntropy", function () { return $3dbe328f09720d4a$export$135e090d58b310ca; });
$parcel$export($a4175433b234909f$exports, "entropyToMnemonic", function () { return $3dbe328f09720d4a$export$4becd65eb23312e6; });
$parcel$export($a4175433b234909f$exports, "isValidMnemonic", function () { return $3dbe328f09720d4a$export$5eea3393c6119c80; });
$parcel$export($a4175433b234909f$exports, "mnemonicToSeed", function () { return $3dbe328f09720d4a$export$3dee74f1204ab09f; });
$parcel$export($a4175433b234909f$exports, "SupportedAlgorithm", function () { return $7bbd5149c083ead5$export$d2a8849cfb277c; });
$parcel$export($a4175433b234909f$exports, "UnicodeNormalizationForm", function () { return $169c6c93221d2e48$export$c6986442964129f5; });
$parcel$export($a4175433b234909f$exports, "Utf8ErrorReason", function () { return $169c6c93221d2e48$export$c285fa6ac15ff6a6; });
$parcel$export($a4175433b234909f$exports, "Indexed", function () { return $6df659078ac9448c$export$8ef99100a3c56f8c; });


var $c9c551e26c372c1d$exports = {};

$parcel$export($c9c551e26c372c1d$exports, "decode", function () { return $51b0a655b2efccfa$export$2f872c0f2117be69; });
$parcel$export($c9c551e26c372c1d$exports, "encode", function () { return $51b0a655b2efccfa$export$c564cdbbe6da493; });

"use strict";
















const $3d2a4f1744e3e1a9$export$83d89fbfd8236492 = "solidity/5.7.0";


"use strict";
const $d504cf4938ca3d9c$var$regexBytes = new RegExp("^bytes([0-9]+)$");
const $d504cf4938ca3d9c$var$regexNumber = new RegExp("^(u?int)([0-9]*)$");
const $d504cf4938ca3d9c$var$regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$");
const $d504cf4938ca3d9c$var$Zeros = "0000000000000000000000000000000000000000000000000000000000000000";
const $d504cf4938ca3d9c$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $3d2a4f1744e3e1a9$export$83d89fbfd8236492));
function $d504cf4938ca3d9c$var$_pack(type, value, isArray) {
    switch(type){
        case "address":
            if (isArray) return (0, $ddc3d9704a40b613$export$3cdc770bf8b2ed3d)(value, 32);
            return (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(value);
        case "string":
            return (0, $169c6c93221d2e48$export$8feeb310b4b4752f)(value);
        case "bytes":
            return (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(value);
        case "bool":
            value = value ? "0x01" : "0x00";
            if (isArray) return (0, $ddc3d9704a40b613$export$3cdc770bf8b2ed3d)(value, 32);
            return (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(value);
    }
    let match = type.match($d504cf4938ca3d9c$var$regexNumber);
    if (match) {
        //let signed = (match[1] === "int")
        let size = parseInt(match[2] || "256");
        if (match[2] && String(size) !== match[2] || size % 8 !== 0 || size === 0 || size > 256) $d504cf4938ca3d9c$var$logger.throwArgumentError("invalid number type", "type", type);
        if (isArray) size = 256;
        value = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(value).toTwos(size);
        return (0, $ddc3d9704a40b613$export$3cdc770bf8b2ed3d)(value, size / 8);
    }
    match = type.match($d504cf4938ca3d9c$var$regexBytes);
    if (match) {
        const size = parseInt(match[1]);
        if (String(size) !== match[1] || size === 0 || size > 32) $d504cf4938ca3d9c$var$logger.throwArgumentError("invalid bytes type", "type", type);
        if ((0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(value).byteLength !== size) $d504cf4938ca3d9c$var$logger.throwArgumentError(`invalid value for ${type}`, "value", value);
        if (isArray) return (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)((value + $d504cf4938ca3d9c$var$Zeros).substring(0, 66));
        return value;
    }
    match = type.match($d504cf4938ca3d9c$var$regexArray);
    if (match && Array.isArray(value)) {
        const baseType = match[1];
        const count = parseInt(match[2] || String(value.length));
        if (count != value.length) $d504cf4938ca3d9c$var$logger.throwArgumentError(`invalid array length for ${type}`, "value", value);
        const result = [];
        value.forEach(function(value) {
            result.push($d504cf4938ca3d9c$var$_pack(baseType, value, true));
        });
        return (0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)(result);
    }
    return $d504cf4938ca3d9c$var$logger.throwArgumentError("invalid type", "type", type);
}
function $d504cf4938ca3d9c$export$2a703dbb0cb35339(types, values) {
    if (types.length != values.length) $d504cf4938ca3d9c$var$logger.throwArgumentError("wrong number of values; expected ${ types.length }", "values", values);
    const tight = [];
    types.forEach(function(type, index) {
        tight.push($d504cf4938ca3d9c$var$_pack(type, values[index]));
    });
    return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)((0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)(tight));
}
function $d504cf4938ca3d9c$export$f8151fce47ad1c35(types, values) {
    return (0, $344909d1f36347b2$export$f8151fce47ad1c35)($d504cf4938ca3d9c$export$2a703dbb0cb35339(types, values));
}
function $d504cf4938ca3d9c$export$bced8d2aada2d1c9(types, values) {
    return (0, $5c9a0ceac3511c58$export$bced8d2aada2d1c9)($d504cf4938ca3d9c$export$2a703dbb0cb35339(types, values));
}









"use strict";
function $6d6cbd4d8329f5fa$export$b97e949c0076e971(text) {
    // Get the bytes
    const bytes = (0, $169c6c93221d2e48$export$8feeb310b4b4752f)(text);
    // Check we have room for null-termination
    if (bytes.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
    // Zero-pad (implicitly null-terminates)
    return (0, $ddc3d9704a40b613$export$2b0d6b5fbe698c70)((0, $ddc3d9704a40b613$export$ee1b3e54f0441b22)([
        bytes,
        (0, $43ba40ff64f1a63e$export$71c2e4e213dcb7f2)
    ]).slice(0, 32));
}
function $6d6cbd4d8329f5fa$export$49340cb8f3954db8(bytes) {
    const data = (0, $ddc3d9704a40b613$export$3131421a7d01b4fb)(bytes);
    // Must be 32 bytes with a null-termination
    if (data.length !== 32) throw new Error("invalid bytes32 - not 32 bytes long");
    if (data[31] !== 0) throw new Error("invalid bytes32 string - no null terminator");
    // Find the null termination
    let length = 31;
    while(data[length - 1] === 0)length--;
    // Determine the string value
    return (0, $169c6c93221d2e48$export$7643a1dc2c38d5eb)(data.slice(0, length));
}


"use strict";
function $ab2f1c24fdde7ddc$var$bytes2(data) {
    if (data.length % 4 !== 0) throw new Error("bad data");
    let result = [];
    for(let i = 0; i < data.length; i += 4)result.push(parseInt(data.substring(i, i + 4), 16));
    return result;
}
function $ab2f1c24fdde7ddc$var$createTable(data, func) {
    if (!func) func = function(value) {
        return [
            parseInt(value, 16)
        ];
    };
    let lo = 0;
    let result = {};
    data.split(",").forEach((pair)=>{
        let comps = pair.split(":");
        lo += parseInt(comps[0], 16);
        result[lo] = func(comps[1]);
    });
    return result;
}
function $ab2f1c24fdde7ddc$var$createRangeTable(data) {
    let hi = 0;
    return data.split(",").map((v)=>{
        let comps = v.split("-");
        if (comps.length === 1) comps[1] = "0";
        else if (comps[1] === "") comps[1] = "1";
        let lo = hi + parseInt(comps[0], 16);
        hi = parseInt(comps[1], 16);
        return {
            l: lo,
            h: hi
        };
    });
}
function $ab2f1c24fdde7ddc$var$matchMap(value, ranges) {
    let lo = 0;
    for(let i = 0; i < ranges.length; i++){
        let range = ranges[i];
        lo += range.l;
        if (value >= lo && value <= lo + range.h && (value - lo) % (range.d || 1) === 0) {
            if (range.e && range.e.indexOf(value - lo) !== -1) continue;
            return range;
        }
    }
    return null;
}
const $ab2f1c24fdde7ddc$var$Table_A_1_ranges = $ab2f1c24fdde7ddc$var$createRangeTable("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d");
// @TODO: Make this relative...
const $ab2f1c24fdde7ddc$var$Table_B_1_flags = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((v)=>parseInt(v, 16));
const $ab2f1c24fdde7ddc$var$Table_B_2_ranges = [
    {
        h: 25,
        s: 32,
        l: 65
    },
    {
        h: 30,
        s: 32,
        e: [
            23
        ],
        l: 127
    },
    {
        h: 54,
        s: 1,
        e: [
            48
        ],
        l: 64,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 57,
        d: 2
    },
    {
        h: 44,
        s: 1,
        l: 17,
        d: 2
    },
    {
        h: 10,
        s: 1,
        e: [
            2,
            6,
            8
        ],
        l: 61,
        d: 2
    },
    {
        h: 16,
        s: 1,
        l: 68,
        d: 2
    },
    {
        h: 84,
        s: 1,
        e: [
            18,
            24,
            66
        ],
        l: 19,
        d: 2
    },
    {
        h: 26,
        s: 32,
        e: [
            17
        ],
        l: 435
    },
    {
        h: 22,
        s: 1,
        l: 71,
        d: 2
    },
    {
        h: 15,
        s: 80,
        l: 40
    },
    {
        h: 31,
        s: 32,
        l: 16
    },
    {
        h: 32,
        s: 1,
        l: 80,
        d: 2
    },
    {
        h: 52,
        s: 1,
        l: 42,
        d: 2
    },
    {
        h: 12,
        s: 1,
        l: 55,
        d: 2
    },
    {
        h: 40,
        s: 1,
        e: [
            38
        ],
        l: 15,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 48,
        d: 2
    },
    {
        h: 37,
        s: 48,
        l: 49
    },
    {
        h: 148,
        s: 1,
        l: 6351,
        d: 2
    },
    {
        h: 88,
        s: 1,
        l: 160,
        d: 2
    },
    {
        h: 15,
        s: 16,
        l: 704
    },
    {
        h: 25,
        s: 26,
        l: 854
    },
    {
        h: 25,
        s: 32,
        l: 55915
    },
    {
        h: 37,
        s: 40,
        l: 1247
    },
    {
        h: 25,
        s: -119711,
        l: 53248
    },
    {
        h: 25,
        s: -119763,
        l: 52
    },
    {
        h: 25,
        s: -119815,
        l: 52
    },
    {
        h: 25,
        s: -119867,
        e: [
            1,
            4,
            5,
            7,
            8,
            11,
            12,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -119919,
        l: 52
    },
    {
        h: 24,
        s: -119971,
        e: [
            2,
            7,
            8,
            17
        ],
        l: 52
    },
    {
        h: 24,
        s: -120023,
        e: [
            2,
            7,
            13,
            15,
            16,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -120075,
        l: 52
    },
    {
        h: 25,
        s: -120127,
        l: 52
    },
    {
        h: 25,
        s: -120179,
        l: 52
    },
    {
        h: 25,
        s: -120231,
        l: 52
    },
    {
        h: 25,
        s: -120283,
        l: 52
    },
    {
        h: 25,
        s: -120335,
        l: 52
    },
    {
        h: 24,
        s: -119543,
        e: [
            17
        ],
        l: 56
    },
    {
        h: 24,
        s: -119601,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119659,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119717,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119775,
        e: [
            17
        ],
        l: 58
    }
];
const $ab2f1c24fdde7ddc$var$Table_B_2_lut_abs = $ab2f1c24fdde7ddc$var$createTable("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3");
const $ab2f1c24fdde7ddc$var$Table_B_2_lut_rel = $ab2f1c24fdde7ddc$var$createTable("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7");
const $ab2f1c24fdde7ddc$var$Table_B_2_complex = $ab2f1c24fdde7ddc$var$createTable("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $ab2f1c24fdde7ddc$var$bytes2);
const $ab2f1c24fdde7ddc$var$Table_C_ranges = $ab2f1c24fdde7ddc$var$createRangeTable("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function $ab2f1c24fdde7ddc$var$flatten(values) {
    return values.reduce((accum, value)=>{
        value.forEach((value)=>{
            accum.push(value);
        });
        return accum;
    }, []);
}
function $ab2f1c24fdde7ddc$export$d1ae0d802533bef0(codepoint) {
    return !!$ab2f1c24fdde7ddc$var$matchMap(codepoint, $ab2f1c24fdde7ddc$var$Table_A_1_ranges);
}
function $ab2f1c24fdde7ddc$export$9630a1f26a43b76c(codepoint) {
    let range = $ab2f1c24fdde7ddc$var$matchMap(codepoint, $ab2f1c24fdde7ddc$var$Table_B_2_ranges);
    if (range) return [
        codepoint + range.s
    ];
    let codes = $ab2f1c24fdde7ddc$var$Table_B_2_lut_abs[codepoint];
    if (codes) return codes;
    let shift = $ab2f1c24fdde7ddc$var$Table_B_2_lut_rel[codepoint];
    if (shift) return [
        codepoint + shift[0]
    ];
    let complex = $ab2f1c24fdde7ddc$var$Table_B_2_complex[codepoint];
    if (complex) return complex;
    return null;
}
function $ab2f1c24fdde7ddc$export$e07a548cae6d1553(codepoint) {
    return !!$ab2f1c24fdde7ddc$var$matchMap(codepoint, $ab2f1c24fdde7ddc$var$Table_C_ranges);
}
function $ab2f1c24fdde7ddc$export$94f0b6f93c619bc(value) {
    // This allows platforms with incomplete normalize to bypass
    // it for very basic names which the built-in toLowerCase
    // will certainly handle correctly
    if (value.match(/^[a-z0-9-]*$/i) && value.length <= 59) return value.toLowerCase();
    // Get the code points (keeping the current normalization)
    let codes = (0, $169c6c93221d2e48$export$ae470a36a31b28c2)(value);
    codes = $ab2f1c24fdde7ddc$var$flatten(codes.map((code)=>{
        // Substitute Table B.1 (Maps to Nothing)
        if ($ab2f1c24fdde7ddc$var$Table_B_1_flags.indexOf(code) >= 0) return [];
        if (code >= 0xfe00 && code <= 0xfe0f) return [];
        // Substitute Table B.2 (Case Folding)
        let codesTableB2 = $ab2f1c24fdde7ddc$export$9630a1f26a43b76c(code);
        if (codesTableB2) return codesTableB2;
        // No Substitution
        return [
            code
        ];
    }));
    // Normalize using form KC
    codes = (0, $169c6c93221d2e48$export$ae470a36a31b28c2)((0, $169c6c93221d2e48$export$232e1dab03132235)(codes), (0, $169c6c93221d2e48$export$c6986442964129f5).NFKC);
    // Prohibit Tables C.1.2, C.2.2, C.3, C.4, C.5, C.6, C.7, C.8, C.9
    codes.forEach((code)=>{
        if ($ab2f1c24fdde7ddc$export$e07a548cae6d1553(code)) throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
    });
    // Prohibit Unassigned Code Points (Table A.1)
    codes.forEach((code)=>{
        if ($ab2f1c24fdde7ddc$export$d1ae0d802533bef0(code)) throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
    });
    // IDNA extras
    let name = (0, $169c6c93221d2e48$export$232e1dab03132235)(codes);
    // IDNA: 4.2.3.1
    if (name.substring(0, 1) === "-" || name.substring(2, 4) === "--" || name.substring(name.length - 1) === "-") throw new Error("invalid hyphen");
    return name;
}





const $0c6d9d62ef0f8aae$export$83d89fbfd8236492 = "units/5.7.0";


"use strict";
const $2eea55bfa3f06576$var$logger = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $0c6d9d62ef0f8aae$export$83d89fbfd8236492));
const $2eea55bfa3f06576$var$names = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
];
function $2eea55bfa3f06576$export$de1294767e6ef661(value) {
    const comps = String(value).split(".");
    if (comps.length > 2 || !comps[0].match(/^-?[0-9]*$/) || comps[1] && !comps[1].match(/^[0-9]*$/) || value === "." || value === "-.") $2eea55bfa3f06576$var$logger.throwArgumentError("invalid value", "value", value);
    // Make sure we have at least one whole digit (0 if none)
    let whole = comps[0];
    let negative = "";
    if (whole.substring(0, 1) === "-") {
        negative = "-";
        whole = whole.substring(1);
    }
    // Make sure we have at least 1 whole digit with no leading zeros
    while(whole.substring(0, 1) === "0")whole = whole.substring(1);
    if (whole === "") whole = "0";
    let suffix = "";
    if (comps.length === 2) suffix = "." + (comps[1] || "0");
    while(suffix.length > 2 && suffix[suffix.length - 1] === "0")suffix = suffix.substring(0, suffix.length - 1);
    const formatted = [];
    while(whole.length)if (whole.length <= 3) {
        formatted.unshift(whole);
        break;
    } else {
        const index = whole.length - 3;
        formatted.unshift(whole.substring(index));
        whole = whole.substring(0, index);
    }
    return negative + formatted.join(",") + suffix;
}
function $2eea55bfa3f06576$export$bd39b96f71da1885(value, unitName) {
    if (typeof unitName === "string") {
        const index = $2eea55bfa3f06576$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $0ca80bf34c50fe44$export$cc011b843b5d69f2)(value, unitName != null ? unitName : 18);
}
function $2eea55bfa3f06576$export$203ae30b4f6490b3(value, unitName) {
    if (typeof value !== "string") $2eea55bfa3f06576$var$logger.throwArgumentError("value must be a string", "value", value);
    if (typeof unitName === "string") {
        const index = $2eea55bfa3f06576$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $0ca80bf34c50fe44$export$1b039987e86d7269)(value, unitName != null ? unitName : 18);
}
function $2eea55bfa3f06576$export$11bc63b4c03ea518(wei) {
    return $2eea55bfa3f06576$export$bd39b96f71da1885(wei, 18);
}
function $2eea55bfa3f06576$export$642c4e67bbdc0bc7(ether) {
    return $2eea55bfa3f06576$export$203ae30b4f6490b3(ether, 18);
}




"use strict";



const $98e9ced0691461ae$export$83d89fbfd8236492 = "ethers/5.7.2";


"use strict";
const $29b78df16cc81472$export$af88d00dbe7f521 = new (0, $4eebf1ca9f327f54$export$efa9a398d6368992)((0, $98e9ced0691461ae$export$83d89fbfd8236492));


"use strict";
try {
    const anyGlobal = window;
    if (anyGlobal._ethers == null) anyGlobal._ethers = $29b78df16cc81472$exports;
} catch (error) {}



class $06f3bb292d29f172$export$2eabee031a58b47f {
    static min(...values) {
        let lowest = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(values[0]);
        for(let i = 1; i < values.length; i++){
            const value = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(values[i]);
            if (value.lt(lowest)) lowest = value;
        }
        return lowest;
    }
    static max(...values) {
        let highest = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(values[0]);
        for(let i = 1; i < values.length; i++){
            const value = (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(values[i]);
            if (value.gt(highest)) highest = value;
        }
        return highest;
    }
}
var $06f3bb292d29f172$export$2e2bcd8739ae039 = $06f3bb292d29f172$export$2eabee031a58b47f;


function $9dcc00a39e7f7954$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}





class $b4231298f6b055c1$var$Fraction {
    static convert(sdk) {
        return new $b4231298f6b055c1$var$Fraction((0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(sdk.numerator.toString()), (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(sdk.denominator.toString()));
    }
    static from(numerator, denominator) {
        return new $b4231298f6b055c1$var$Fraction((0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(numerator), (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(denominator));
    }
    static parse(value) {
        return value === "" ? $b4231298f6b055c1$var$Fraction.NAN : (0, $73e0d52c1734bc21$export$141eca273a04dc3e)(value) ? $b4231298f6b055c1$var$Fraction.ZERO : new $b4231298f6b055c1$var$Fraction((0, $73e0d52c1734bc21$export$1c321cb4a6645f1f)(value, 18), $b4231298f6b055c1$var$Fraction.BASE);
    }
    isZero() {
        return !this.isNaN() && this.numerator.isZero();
    }
    isNaN() {
        return this.denominator.isZero();
    }
    eq(fraction) {
        return this.numerator.mul(fraction.denominator).div(fraction.numerator).eq(this.denominator);
    }
    gt(fraction) {
        return this.numerator.mul(fraction.denominator).div(fraction.numerator).gt(this.denominator);
    }
    lt(fraction) {
        return this.numerator.mul(fraction.denominator).div(fraction.numerator).lt(this.denominator);
    }
    toString(maxFractions = 8) {
        if (this.isNaN()) return "";
        if (this.isZero()) return "0";
        let str = (0, $73e0d52c1734bc21$export$cc3bc0b518c1c6b8)(this.numerator.mul($b4231298f6b055c1$var$Fraction.BASE).div(this.denominator), 18, maxFractions);
        if (str.endsWith(".0")) str = str.substring(0, str.length - 2);
        return str;
    }
    apply(value) {
        return this.denominator.isZero() ? (0, $af43ef4e381177e0$export$aaef8a3eae948f03) : this.numerator.mul(value).div(this.denominator);
    }
    constructor(numerator, denominator){
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "numerator", void 0);
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "denominator", void 0);
        this.numerator = numerator;
        this.denominator = denominator;
    }
}
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($b4231298f6b055c1$var$Fraction, "BASE", (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(10).pow(18));
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($b4231298f6b055c1$var$Fraction, "NAN", new $b4231298f6b055c1$var$Fraction((0, $af43ef4e381177e0$export$aaef8a3eae948f03), (0, $af43ef4e381177e0$export$aaef8a3eae948f03)));
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($b4231298f6b055c1$var$Fraction, "ZERO", new $b4231298f6b055c1$var$Fraction((0, $af43ef4e381177e0$export$aaef8a3eae948f03), (0, $af43ef4e381177e0$export$9aa05a5866350bcf)));
var $b4231298f6b055c1$export$2e2bcd8739ae039 = $b4231298f6b055c1$var$Fraction;




function $73e0d52c1734bc21$export$977e255126d763d6(value) {
    try {
        return (0, $a4b82b374f356b4b$export$88411125f012957a)(value);
    } catch  {
        return false;
    }
}
function $73e0d52c1734bc21$export$c128ec6fd8bee8d4(library, account) {
    return library.getSigner(account).connectUnchecked();
}
function $73e0d52c1734bc21$export$ac1c072de08e42dc(library, account) {
    return account ? $73e0d52c1734bc21$export$c128ec6fd8bee8d4(library, account) : library;
}
function $73e0d52c1734bc21$export$f518c38144e1f9d(address, ABI, library, account) {
    if (!$73e0d52c1734bc21$export$977e255126d763d6(address) || address === (0, $3d13afb7ba7a6bb7$export$badd13187c087617)) throw Error(`Invalid 'address' parameter '${address}'.`);
    return new (0, $fcd53023be51494b$exports.Contract)(address, ABI, $73e0d52c1734bc21$export$ac1c072de08e42dc(library, account));
}
const $73e0d52c1734bc21$export$bcd62654ac98e9b3 = (value, decimals = 18)=>{
    if (value) return (0, $b4231298f6b055c1$export$2e2bcd8739ae039).from((0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(value), (0, $c37d64fad2cf3dce$export$d97aa349ed20696).from(10).pow(decimals)).toString();
    else return "";
};
const $73e0d52c1734bc21$export$cc3bc0b518c1c6b8 = (value, decimals = 18, maxFraction = 0)=>{
    const formatted = (0, $29b78df16cc81472$exports).utils.formatUnits(value, decimals);
    if (maxFraction > 0) {
        const split = formatted.split(".");
        if (split.length > 1) return split[0] + "." + split[1].substr(0, maxFraction);
    }
    return formatted;
};
const $73e0d52c1734bc21$export$1c321cb4a6645f1f = (value, decimals = 18)=>{
    return (0, $29b78df16cc81472$exports).utils.parseUnits(value || "0", decimals);
};
const $73e0d52c1734bc21$export$141eca273a04dc3e = (text)=>(0, $29b78df16cc81472$exports).BigNumber.isBigNumber(text) ? (0, $29b78df16cc81472$exports).BigNumber.from(text).isZero() : text === "" || text.replace(/0/g, "").replace(/\./, "") === "";
const $73e0d52c1734bc21$export$4ee790420cb91ffc = (err)=>{
    let status = "Transaction failed because you have insufficient funds or sales not started";
    let status1 = "Sent incorrect ETH value";
    if (JSON.stringify(err).indexOf("insufficient") > -1) return status;
    if (JSON.stringify(err).indexOf(status1) > -1) return status1;
    if (err.message) return err.message.substr(err.message.indexOf(":") + 1);
    if (!err.error) return err;
    let errorContainer = err.error && err.error.message ? err.error.message : "";
    let errorBody = errorContainer.substr(errorContainer.indexOf(":") + 1);
    return errorBody;
};
const $73e0d52c1734bc21$export$b80d5513bcafc6b2 = (provider)=>{
    const library = new (0, $f7d2f0b1fa262e29$export$d05096c9fd9d936d)(provider, "any");
    library.pollingInterval = 15000;
    return library;
};




var $6cds3 = parcelRequire("6cds3");
const $c7b134c1d77bb7b4$export$c06e1e7429de6283 = {
    MAINNET: 1,
    ROPSTEN: 3,
    RINKEBY: 4,
    GOERLI: 5,
    KOVAN: 42,
    MATIC: 137,
    MATIC_TESTNET: 80001,
    FANTOM: 250,
    FANTOM_TESTNET: 4002,
    XDAI: 100,
    BSC: 56,
    BSC_TESTNET: 97,
    ARBITRUM: 79377087078960,
    MOONBASE: 1287,
    AVALANCHE: 43114,
    FUJI: 43113,
    HECO: 128,
    HECO_TESTNET: 256,
    HARMONY: 1666600000,
    HARMONY_TESTNET: 1666700000
};
const $c7b134c1d77bb7b4$export$57fdaa7bda896a9a = {
    [$c7b134c1d77bb7b4$export$c06e1e7429de6283["MAINNET"]]: "",
    [$c7b134c1d77bb7b4$export$c06e1e7429de6283["GOERLI"]]: "0xE74da0A4E7C5FC09fa793498ccE70e598D8432b2"
};
const $c7b134c1d77bb7b4$export$8ebda9bf7e04e6d2 = $c7b134c1d77bb7b4$export$c06e1e7429de6283.MAINNET;
const $c7b134c1d77bb7b4$export$f0fc59941d3d2580 = $c7b134c1d77bb7b4$export$c06e1e7429de6283.GOERLI;
const $c7b134c1d77bb7b4$export$5ba719c428d2852 = "NETWORK";
const $c7b134c1d77bb7b4$export$6586c12bbf6d0c20 = {
    "-32002": "Already processing Metamask wallet connect. Please confirm metamask modal."
};
const $c7b134c1d77bb7b4$export$51360b6aa3a7b134 = {
    WALLET: 1,
    MINDMAP: 2,
    GALLERY: 3
};
const $c7b134c1d77bb7b4$export$16bd37df0047a29c = {
    Background: [
        "Blue",
        "Yellow",
        "Purple",
        "Orange",
        "Pink",
        "Green",
        "Bathroom",
        "Crime Scene"
    ],
    Bag: [
        "Grey Backpack",
        "Tate",
        "Brown Backpack",
        "Green Chest Bag",
        "Yellow Chest Bag",
        "Duffel Bag",
        "Black Chest Bag",
        "Grey Backpack with Slingshot"
    ],
    Ears: [
        "Pencil",
        "Bing Bang Stick",
        "Earrings",
        "Earphones",
        "Headset",
        "Headphones",
        "Headphones with Music",
        "Chalk"
    ],
    Eyes: [
        "Black Nerd Glasses",
        "White Nerd Glasses",
        "Sunglasses",
        "White Glasses",
        "Black Glasses",
        "Brown Glasses",
        "Eye Patch",
        "Pointy Glasses",
        "Nerd Ghost Glasses",
        "Nose Glasses with Black Hair",
        "Nose Glasses with White Hair",
        "Boomer Glasses",
        "Googly Eyes",
        "Cool Glasses",
        "Thief Mask",
        "Swirly Glasses",
        "Radioactive Glasses",
        "Rainbow Glasses",
        "VR Goggles Graph",
        "VR Goggles Moon",
        "Devil Mask"
    ],
    Fannypack: [
        "Green Fannypack",
        "Yellow Fannypack",
        "Black Fannypack",
        "Cream Fannypack"
    ],
    Feet: [
        "Green Shoes",
        "Maroon Shoes",
        "Tan Boots",
        "Rocket Pop Sneakers",
        "Summer Day Sneakers",
        "Ice Grey Sneakers",
        "Dark Blue Slippers",
        "Bubblegum Blue Sneakers",
        "Black Shoes",
        "Light Blue Slippers",
        "Green Boots",
        "Bleached Sand Sneakers",
        "Summer Night Sneakers",
        "Red Shoes",
        "Brown Boots",
        "Yellow Boots",
        "Bunny Slippers",
        "Forest Moss Sneakers",
        "Ocean Blue Sneakers",
        "Cream Slippers",
        "Pink Slippers",
        "Frog Slippers",
        "Chalk Outline",
        "White Slippers"
    ]
};
const $c7b134c1d77bb7b4$export$8f45430ccf837300 = {
    Blue: "#c1d7e5",
    Yellow: "#f7f2bb",
    Purple: "#d0ccf4",
    Orange: "#f6d9c5",
    Pink: "#f9cff2",
    Green: "#cff0ce",
    Default: "#c1d7e5"
};
const $c7b134c1d77bb7b4$export$837c0bfa5df3a978 = {
    serverUrl: "https://ygogtpuez79s.usemoralis.com:2053/server",
    appId: "6STWJ8AyIqe5s56zzLmNyCvriXZeIW2Pr44Jb5bI",
    apiKey: "2kHumt68e3WgGgwT82mkFVMMmlpfnf3Mzi7KWXWnyHrO8lJqpV5aZeAiFts3yYzM"
};


function $20c77486c83a2d5d$export$2e2bcd8739ae039() {
    const { active: active, library: library, chainId: chainId } = (0, $607a80a0a69e28c2$export$6826ddb52637cda3)();
    const switchNetwork = (0, $6cds3.useCallback)(async ()=>{
        await library.provider.request({
            method: "wallet_switchEthereumChain",
            params: [
                {
                    chainId: "0x" + (0, $c7b134c1d77bb7b4$export$f0fc59941d3d2580).toString(16)
                }
            ]
        });
    }, [
        library,
        chainId
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (active && chainId !== (0, $c7b134c1d77bb7b4$export$f0fc59941d3d2580)) switchNetwork();
    }, [
        library,
        chainId,
        active
    ]);
    return null;
}



var $6cds3 = parcelRequire("6cds3");


function $f895bcdfc688a573$export$ba082fd8bb7afc5c() {
    const context = (0, $607a80a0a69e28c2$export$6826ddb52637cda3)();
    const contextNetwork = (0, $607a80a0a69e28c2$export$6826ddb52637cda3)((0, $c7b134c1d77bb7b4$export$5ba719c428d2852));
    return context.active ? context : contextNetwork;
}



var $6cds3 = parcelRequire("6cds3");
function $4b94a551dba7d909$export$2e2bcd8739ae039(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0, $6cds3.useState)(value);
    (0, $6cds3.useEffect)(()=>{
        // Update debounced value after delay
        const handler = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return ()=>{
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}



var $6cds3 = parcelRequire("6cds3");
const $9f58cdf121c09e01$var$VISIBILITY_STATE_SUPPORTED = "visibilityState" in document;
function $9f58cdf121c09e01$var$isWindowVisible() {
    return !$9f58cdf121c09e01$var$VISIBILITY_STATE_SUPPORTED || document.visibilityState !== "hidden";
}
function $9f58cdf121c09e01$export$2e2bcd8739ae039() {
    const [focused, setFocused] = (0, $6cds3.useState)($9f58cdf121c09e01$var$isWindowVisible());
    const listener = (0, $6cds3.useCallback)(()=>{
        setFocused($9f58cdf121c09e01$var$isWindowVisible());
    }, [
        setFocused
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!$9f58cdf121c09e01$var$VISIBILITY_STATE_SUPPORTED) return undefined;
        document.addEventListener("visibilitychange", listener);
        return ()=>{
            document.removeEventListener("visibilitychange", listener);
        };
    }, [
        listener
    ]);
    return focused;
}


var $5713dfbf5b9d650b$exports = {};
"use strict";
var $0d31dff2bedccbaf$exports = {};
"use strict";
var $0d31dff2bedccbaf$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
};
var $0d31dff2bedccbaf$var$createStore = function createStore(createState) {
    return createState ? $0d31dff2bedccbaf$var$createStoreImpl(createState) : $0d31dff2bedccbaf$var$createStoreImpl;
};
var $0d31dff2bedccbaf$var$vanilla = function(createState) {
    return $0d31dff2bedccbaf$var$createStore(createState);
};
$0d31dff2bedccbaf$exports.createStore = $0d31dff2bedccbaf$var$createStore;
$0d31dff2bedccbaf$exports.default = $0d31dff2bedccbaf$var$vanilla;
$0d31dff2bedccbaf$exports = $0d31dff2bedccbaf$var$vanilla;
$0d31dff2bedccbaf$exports.createStore = $0d31dff2bedccbaf$var$createStore;
$0d31dff2bedccbaf$exports.default = $0d31dff2bedccbaf$exports;



var $6cds3 = parcelRequire("6cds3");
var $a14d599760d127f7$exports = {};
"use strict";

$a14d599760d127f7$exports = (parcelRequire("hUlrm"));


var $5713dfbf5b9d650b$var$useSyncExternalStoreWithSelector = $a14d599760d127f7$exports.useSyncExternalStoreWithSelector;
var $5713dfbf5b9d650b$var$didWarnAboutEqualityFn = false;
function $5713dfbf5b9d650b$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = api.getState;
    var slice = $5713dfbf5b9d650b$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getState, selector, equalityFn);
    $6cds3.useDebugValue(slice);
    return slice;
}
var $5713dfbf5b9d650b$var$createImpl = function createImpl(createState) {
    var api = typeof createState === "function" ? $0d31dff2bedccbaf$exports.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $5713dfbf5b9d650b$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $5713dfbf5b9d650b$var$create = function create(createState) {
    return createState ? $5713dfbf5b9d650b$var$createImpl(createState) : $5713dfbf5b9d650b$var$createImpl;
};
var $5713dfbf5b9d650b$var$react = function(createState) {
    return $5713dfbf5b9d650b$var$create(createState);
};
$5713dfbf5b9d650b$exports.create = $5713dfbf5b9d650b$var$create;
$5713dfbf5b9d650b$exports.default = $5713dfbf5b9d650b$var$react;
$5713dfbf5b9d650b$exports.useStore = $5713dfbf5b9d650b$var$useStore;
Object.keys($0d31dff2bedccbaf$exports).forEach(function(k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call($5713dfbf5b9d650b$exports, k)) Object.defineProperty($5713dfbf5b9d650b$exports, k, {
        enumerable: true,
        get: function() {
            return $0d31dff2bedccbaf$exports[k];
        }
    });
});
$5713dfbf5b9d650b$exports = $5713dfbf5b9d650b$var$react;
$5713dfbf5b9d650b$exports.create = $5713dfbf5b9d650b$var$create;
$5713dfbf5b9d650b$exports.useStore = $5713dfbf5b9d650b$var$useStore;
$5713dfbf5b9d650b$exports.createStore = $0d31dff2bedccbaf$exports.createStore;
$5713dfbf5b9d650b$exports.default = $5713dfbf5b9d650b$exports;


function $a041a5dd8ac78658$var$n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function $a041a5dd8ac78658$export$541ac630993a4c84(n) {
    return !!n && !!n[$a041a5dd8ac78658$var$Q];
}
function $a041a5dd8ac78658$export$16e3aed3edb85946(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === $a041a5dd8ac78658$var$Z;
    }(n) || Array.isArray(n) || !!n[$a041a5dd8ac78658$export$6ee2082928bcb0ee] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[$a041a5dd8ac78658$export$6ee2082928bcb0ee]) || $a041a5dd8ac78658$var$s(n) || $a041a5dd8ac78658$var$v(n));
}
function $a041a5dd8ac78658$export$22e8af3f75a010e3(t) {
    return $a041a5dd8ac78658$export$541ac630993a4c84(t) || $a041a5dd8ac78658$var$n(23, t), t[$a041a5dd8ac78658$var$Q].t;
}
function $a041a5dd8ac78658$var$i(n, r, t) {
    void 0 === t && (t = !1), 0 === $a041a5dd8ac78658$var$o(n) ? (t ? Object.keys : $a041a5dd8ac78658$var$nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function $a041a5dd8ac78658$var$o(n) {
    var r = n[$a041a5dd8ac78658$var$Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : $a041a5dd8ac78658$var$s(n) ? 2 : $a041a5dd8ac78658$var$v(n) ? 3 : 0;
}
function $a041a5dd8ac78658$var$u(n, r) {
    return 2 === $a041a5dd8ac78658$var$o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function $a041a5dd8ac78658$var$a(n, r) {
    return 2 === $a041a5dd8ac78658$var$o(n) ? n.get(r) : n[r];
}
function $a041a5dd8ac78658$var$f(n, r, t) {
    var e = $a041a5dd8ac78658$var$o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function $a041a5dd8ac78658$var$c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function $a041a5dd8ac78658$var$s(n) {
    return $a041a5dd8ac78658$var$X && n instanceof Map;
}
function $a041a5dd8ac78658$var$v(n) {
    return $a041a5dd8ac78658$var$q && n instanceof Set;
}
function $a041a5dd8ac78658$var$p(n) {
    return n.o || n.t;
}
function $a041a5dd8ac78658$var$l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = $a041a5dd8ac78658$var$rn(n);
    delete r[$a041a5dd8ac78658$var$Q];
    for(var t = $a041a5dd8ac78658$var$nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function $a041a5dd8ac78658$export$792f3d81ea979f55(n, e) {
    return void 0 === e && (e = !1), $a041a5dd8ac78658$var$y(n) || $a041a5dd8ac78658$export$541ac630993a4c84(n) || !$a041a5dd8ac78658$export$16e3aed3edb85946(n) || ($a041a5dd8ac78658$var$o(n) > 1 && (n.set = n.add = n.clear = n.delete = $a041a5dd8ac78658$var$h), Object.freeze(n), e && $a041a5dd8ac78658$var$i(n, function(n, r) {
        return $a041a5dd8ac78658$export$792f3d81ea979f55(r, !0);
    }, !0)), n;
}
function $a041a5dd8ac78658$var$h() {
    $a041a5dd8ac78658$var$n(2);
}
function $a041a5dd8ac78658$var$y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function $a041a5dd8ac78658$var$b(r) {
    var t = $a041a5dd8ac78658$var$tn[r];
    return t || $a041a5dd8ac78658$var$n(18, r), t;
}
function $a041a5dd8ac78658$var$m(n, r) {
    $a041a5dd8ac78658$var$tn[n] || ($a041a5dd8ac78658$var$tn[n] = r);
}
function $a041a5dd8ac78658$var$_() {
    return $a041a5dd8ac78658$var$U;
}
function $a041a5dd8ac78658$var$j(n, r) {
    r && ($a041a5dd8ac78658$var$b("Patches"), n.u = [], n.s = [], n.v = r);
}
function $a041a5dd8ac78658$var$g(n) {
    $a041a5dd8ac78658$var$O(n), n.p.forEach($a041a5dd8ac78658$var$S), n.p = null;
}
function $a041a5dd8ac78658$var$O(n) {
    n === $a041a5dd8ac78658$var$U && ($a041a5dd8ac78658$var$U = n.l);
}
function $a041a5dd8ac78658$var$w(n) {
    return $a041a5dd8ac78658$var$U = {
        p: [],
        l: $a041a5dd8ac78658$var$U,
        h: n,
        m: !0,
        _: 0
    };
}
function $a041a5dd8ac78658$var$S(n) {
    var r = n[$a041a5dd8ac78658$var$Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function $a041a5dd8ac78658$var$P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || $a041a5dd8ac78658$var$b("ES5").S(e, r, o), o ? (i[$a041a5dd8ac78658$var$Q].P && ($a041a5dd8ac78658$var$g(e), $a041a5dd8ac78658$var$n(4)), $a041a5dd8ac78658$export$16e3aed3edb85946(r) && (r = $a041a5dd8ac78658$var$M(e, r), e.l || $a041a5dd8ac78658$var$x(e, r)), e.u && $a041a5dd8ac78658$var$b("Patches").M(i[$a041a5dd8ac78658$var$Q].t, r, e.u, e.s)) : r = $a041a5dd8ac78658$var$M(e, i, []), $a041a5dd8ac78658$var$g(e), e.u && e.v(e.u, e.s), r !== $a041a5dd8ac78658$export$45b790e32b2810ee ? r : void 0;
}
function $a041a5dd8ac78658$var$M(n, r, t) {
    if ($a041a5dd8ac78658$var$y(r)) return r;
    var e = r[$a041a5dd8ac78658$var$Q];
    if (!e) return $a041a5dd8ac78658$var$i(r, function(i, o) {
        return $a041a5dd8ac78658$var$A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return $a041a5dd8ac78658$var$x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = $a041a5dd8ac78658$var$l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), $a041a5dd8ac78658$var$i(u, function(r, i) {
            return $a041a5dd8ac78658$var$A(n, e, o, r, i, t, a);
        }), $a041a5dd8ac78658$var$x(n, o, !1), t && n.u && $a041a5dd8ac78658$var$b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function $a041a5dd8ac78658$var$A(e, i, o, a, c, s, v) {
    if ($a041a5dd8ac78658$export$541ac630993a4c84(c)) {
        var p = $a041a5dd8ac78658$var$M(e, c, s && i && 3 !== i.i && !$a041a5dd8ac78658$var$u(i.R, a) ? s.concat(a) : void 0);
        if ($a041a5dd8ac78658$var$f(o, a, p), !$a041a5dd8ac78658$export$541ac630993a4c84(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if ($a041a5dd8ac78658$export$16e3aed3edb85946(c) && !$a041a5dd8ac78658$var$y(c)) {
        if (!e.h.D && e._ < 1) return;
        $a041a5dd8ac78658$var$M(e, c), i && i.A.l || $a041a5dd8ac78658$var$x(e, c);
    }
}
function $a041a5dd8ac78658$var$x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && $a041a5dd8ac78658$export$792f3d81ea979f55(r, t);
}
function $a041a5dd8ac78658$var$z(n, r) {
    var t = n[$a041a5dd8ac78658$var$Q];
    return (t ? $a041a5dd8ac78658$var$p(t) : n)[r];
}
function $a041a5dd8ac78658$var$I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function $a041a5dd8ac78658$var$k(n) {
    n.P || (n.P = !0, n.l && $a041a5dd8ac78658$var$k(n.l));
}
function $a041a5dd8ac78658$var$E(n) {
    n.o || (n.o = $a041a5dd8ac78658$var$l(n.t));
}
function $a041a5dd8ac78658$var$N(n, r, t) {
    var e = $a041a5dd8ac78658$var$s(r) ? $a041a5dd8ac78658$var$b("MapSet").F(r, t) : $a041a5dd8ac78658$var$v(r) ? $a041a5dd8ac78658$var$b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : $a041a5dd8ac78658$var$_(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = $a041a5dd8ac78658$var$en;
        t && (i = [
            e
        ], o = $a041a5dd8ac78658$var$on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : $a041a5dd8ac78658$var$b("ES5").J(r, t);
    return (t ? t.A : $a041a5dd8ac78658$var$_()).p.push(e), e;
}
function $a041a5dd8ac78658$export$97aac956da55dae9(e) {
    return $a041a5dd8ac78658$export$541ac630993a4c84(e) || $a041a5dd8ac78658$var$n(22, e), function n(r) {
        if (!$a041a5dd8ac78658$export$16e3aed3edb85946(r)) return r;
        var e, u = r[$a041a5dd8ac78658$var$Q], c = $a041a5dd8ac78658$var$o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !$a041a5dd8ac78658$var$b("ES5").K(u))) return u.t;
            u.I = !0, e = $a041a5dd8ac78658$var$D(r, c), u.I = !1;
        } else e = $a041a5dd8ac78658$var$D(r, c);
        return $a041a5dd8ac78658$var$i(e, function(r, t) {
            u && $a041a5dd8ac78658$var$a(u.t, r) === t || $a041a5dd8ac78658$var$f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function $a041a5dd8ac78658$var$D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return $a041a5dd8ac78658$var$l(n);
}
function $a041a5dd8ac78658$export$56771cf63ee491f5() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[$a041a5dd8ac78658$var$Q];
                return $a041a5dd8ac78658$var$en.get(r, n);
            },
            set: function(r) {
                var t = this[$a041a5dd8ac78658$var$Q];
                $a041a5dd8ac78658$var$en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][$a041a5dd8ac78658$var$Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && $a041a5dd8ac78658$var$k(t);
                    break;
                case 4:
                    o(t) && $a041a5dd8ac78658$var$k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = $a041a5dd8ac78658$var$nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== $a041a5dd8ac78658$var$Q) {
                var a = r[o];
                if (void 0 === a && !$a041a5dd8ac78658$var$u(r, o)) return !0;
                var f = t[o], s = f && f[$a041a5dd8ac78658$var$Q];
                if (s ? s.t !== a : !$a041a5dd8ac78658$var$c(f, a)) return !0;
            }
        }
        var v = !!r[$a041a5dd8ac78658$var$Q];
        return e.length !== $a041a5dd8ac78658$var$nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && $a041a5dd8ac78658$var$n(3, JSON.stringify($a041a5dd8ac78658$var$p(r)));
    }
    var s = {};
    $a041a5dd8ac78658$var$m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = $a041a5dd8ac78658$var$rn(r);
                delete o[$a041a5dd8ac78658$var$Q];
                for(var u = $a041a5dd8ac78658$var$nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : $a041a5dd8ac78658$var$_(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, $a041a5dd8ac78658$var$Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? $a041a5dd8ac78658$export$541ac630993a4c84(t) && t[$a041a5dd8ac78658$var$Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[$a041a5dd8ac78658$var$Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) $a041a5dd8ac78658$var$i(o, function(r) {
                            r !== $a041a5dd8ac78658$var$Q && (void 0 !== e[r] || $a041a5dd8ac78658$var$u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, $a041a5dd8ac78658$var$k(t)));
                        }), $a041a5dd8ac78658$var$i(e, function(n) {
                            void 0 !== o[n] || $a041a5dd8ac78658$var$u(o, n) || (f[n] = !1, $a041a5dd8ac78658$var$k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && ($a041a5dd8ac78658$var$k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function $a041a5dd8ac78658$export$d3a6659991a0696c() {
    function e(n) {
        if (!$a041a5dd8ac78658$export$16e3aed3edb85946(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if ($a041a5dd8ac78658$var$s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if ($a041a5dd8ac78658$var$v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return $a041a5dd8ac78658$var$u(n, $a041a5dd8ac78658$export$6ee2082928bcb0ee) && (r[$a041a5dd8ac78658$export$6ee2082928bcb0ee] = n[$a041a5dd8ac78658$export$6ee2082928bcb0ee]), r;
    }
    function f(n) {
        return $a041a5dd8ac78658$export$541ac630993a4c84(n) ? e(n) : n;
    }
    var c = "add";
    $a041a5dd8ac78658$var$m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = $a041a5dd8ac78658$var$o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || $a041a5dd8ac78658$var$n(24), "function" == typeof f && "prototype" === p && $a041a5dd8ac78658$var$n(24), "object" != typeof (f = $a041a5dd8ac78658$var$a(f, p)) && $a041a5dd8ac78658$var$n(15, i.join("/"));
                }
                var l = $a041a5dd8ac78658$var$o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                $a041a5dd8ac78658$var$n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        $a041a5dd8ac78658$var$n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        $a041a5dd8ac78658$var$i(n.R, function(n, i) {
                            var v = $a041a5dd8ac78658$var$a(o, n), p = $a041a5dd8ac78658$var$a(s, n), l = i ? $a041a5dd8ac78658$var$u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === $a041a5dd8ac78658$export$45b790e32b2810ee ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function $a041a5dd8ac78658$export$7d9f65390203b435() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if ($a041a5dd8ac78658$export$16e3aed3edb85946(r)) {
                var e = $a041a5dd8ac78658$var$N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && $a041a5dd8ac78658$var$n(3, JSON.stringify($a041a5dd8ac78658$var$p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[$a041a5dd8ac78658$var$Q] = {
                i: 2,
                l: r,
                A: r ? r.A : $a041a5dd8ac78658$var$_(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return $a041a5dd8ac78658$var$p(this[$a041a5dd8ac78658$var$Q]).size;
            }
        }), o.has = function(n) {
            return $a041a5dd8ac78658$var$p(this[$a041a5dd8ac78658$var$Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[$a041a5dd8ac78658$var$Q];
            return u(t), $a041a5dd8ac78658$var$p(t).has(n) && $a041a5dd8ac78658$var$p(t).get(n) === r || (e(t), $a041a5dd8ac78658$var$k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[$a041a5dd8ac78658$var$Q];
            return u(r), e(r), $a041a5dd8ac78658$var$k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[$a041a5dd8ac78658$var$Q];
            u(n), $a041a5dd8ac78658$var$p(n).size && (e(n), $a041a5dd8ac78658$var$k(n), n.R = new Map, $a041a5dd8ac78658$var$i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            $a041a5dd8ac78658$var$p(this[$a041a5dd8ac78658$var$Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[$a041a5dd8ac78658$var$Q];
            u(r);
            var i = $a041a5dd8ac78658$var$p(r).get(n);
            if (r.I || !$a041a5dd8ac78658$export$16e3aed3edb85946(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = $a041a5dd8ac78658$var$N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return $a041a5dd8ac78658$var$p(this[$a041a5dd8ac78658$var$Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[$a041a5dd8ac78658$var$V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[$a041a5dd8ac78658$var$V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[$a041a5dd8ac78658$var$V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[$a041a5dd8ac78658$var$Q] = {
                i: 3,
                l: r,
                A: r ? r.A : $a041a5dd8ac78658$var$_(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return $a041a5dd8ac78658$var$p(this[$a041a5dd8ac78658$var$Q]).size;
            }
        }), t.has = function(n) {
            var r = this[$a041a5dd8ac78658$var$Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[$a041a5dd8ac78658$var$Q];
            return u(r), this.has(n) || (o(r), $a041a5dd8ac78658$var$k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[$a041a5dd8ac78658$var$Q];
            return u(r), o(r), $a041a5dd8ac78658$var$k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[$a041a5dd8ac78658$var$Q];
            u(n), $a041a5dd8ac78658$var$p(n).size && (o(n), $a041a5dd8ac78658$var$k(n), n.o.clear());
        }, t.values = function() {
            var n = this[$a041a5dd8ac78658$var$Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[$a041a5dd8ac78658$var$Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[$a041a5dd8ac78658$var$V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    $a041a5dd8ac78658$var$m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function $a041a5dd8ac78658$export$cae049b67c7d1bc9() {
    $a041a5dd8ac78658$export$56771cf63ee491f5(), $a041a5dd8ac78658$export$7d9f65390203b435(), $a041a5dd8ac78658$export$d3a6659991a0696c();
}
function $a041a5dd8ac78658$export$c05b21e3257751e5(n) {
    return n;
}
function $a041a5dd8ac78658$export$20f911b3f8cf0b74(n) {
    return n;
}
var $a041a5dd8ac78658$var$G, $a041a5dd8ac78658$var$U, $a041a5dd8ac78658$var$W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), $a041a5dd8ac78658$var$X = "undefined" != typeof Map, $a041a5dd8ac78658$var$q = "undefined" != typeof Set, $a041a5dd8ac78658$var$B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, $a041a5dd8ac78658$export$45b790e32b2810ee = $a041a5dd8ac78658$var$W ? Symbol.for("immer-nothing") : (($a041a5dd8ac78658$var$G = {})["immer-nothing"] = !0, $a041a5dd8ac78658$var$G), $a041a5dd8ac78658$export$6ee2082928bcb0ee = $a041a5dd8ac78658$var$W ? Symbol.for("immer-draftable") : "__$immer_draftable", $a041a5dd8ac78658$var$Q = $a041a5dd8ac78658$var$W ? Symbol.for("immer-state") : "__$immer_state", $a041a5dd8ac78658$var$V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", $a041a5dd8ac78658$var$Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, $a041a5dd8ac78658$var$Z = "" + Object.prototype.constructor, $a041a5dd8ac78658$var$nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, $a041a5dd8ac78658$var$rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return $a041a5dd8ac78658$var$nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, $a041a5dd8ac78658$var$tn = {}, $a041a5dd8ac78658$var$en = {
    get: function(n, r) {
        if (r === $a041a5dd8ac78658$var$Q) return n;
        var e = $a041a5dd8ac78658$var$p(n);
        if (!$a041a5dd8ac78658$var$u(e, r)) return function(n, r, t) {
            var e, i = $a041a5dd8ac78658$var$I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !$a041a5dd8ac78658$export$16e3aed3edb85946(i) ? i : i === $a041a5dd8ac78658$var$z(n.t, r) ? ($a041a5dd8ac78658$var$E(n), n.o[r] = $a041a5dd8ac78658$var$N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in $a041a5dd8ac78658$var$p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys($a041a5dd8ac78658$var$p(n));
    },
    set: function(n, r, t) {
        var e = $a041a5dd8ac78658$var$I($a041a5dd8ac78658$var$p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = $a041a5dd8ac78658$var$z($a041a5dd8ac78658$var$p(n), r), o = null == i ? void 0 : i[$a041a5dd8ac78658$var$Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if ($a041a5dd8ac78658$var$c(t, i) && (void 0 !== t || $a041a5dd8ac78658$var$u(n.t, r))) return !0;
            $a041a5dd8ac78658$var$E(n), $a041a5dd8ac78658$var$k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== $a041a5dd8ac78658$var$z(n.t, r) || r in n.t ? (n.R[r] = !1, $a041a5dd8ac78658$var$E(n), $a041a5dd8ac78658$var$k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = $a041a5dd8ac78658$var$p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        $a041a5dd8ac78658$var$n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        $a041a5dd8ac78658$var$n(12);
    }
}, $a041a5dd8ac78658$var$on = {};
$a041a5dd8ac78658$var$i($a041a5dd8ac78658$var$en, function(n, r) {
    $a041a5dd8ac78658$var$on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), $a041a5dd8ac78658$var$on.deleteProperty = function(r, t) {
    return $a041a5dd8ac78658$var$on.set.call(this, r, t, void 0);
}, $a041a5dd8ac78658$var$on.set = function(r, t, e) {
    return $a041a5dd8ac78658$var$en.set.call(this, r[0], t, e, r[0]);
};
var $a041a5dd8ac78658$export$aaadc6ff0f822719 = function() {
    function e(r) {
        var e = this;
        this.O = $a041a5dd8ac78658$var$B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && $a041a5dd8ac78658$var$n(6), void 0 !== o && "function" != typeof o && $a041a5dd8ac78658$var$n(7), $a041a5dd8ac78658$export$16e3aed3edb85946(r)) {
                var c = $a041a5dd8ac78658$var$w(e), s = $a041a5dd8ac78658$var$N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? $a041a5dd8ac78658$var$g(c) : $a041a5dd8ac78658$var$O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return $a041a5dd8ac78658$var$j(c, o), $a041a5dd8ac78658$var$P(n, c);
                }, function(n) {
                    throw $a041a5dd8ac78658$var$g(c), n;
                }) : ($a041a5dd8ac78658$var$j(c, o), $a041a5dd8ac78658$var$P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === $a041a5dd8ac78658$export$45b790e32b2810ee && (f = void 0), e.D && $a041a5dd8ac78658$export$792f3d81ea979f55(f, !0), o) {
                    var p = [], l = [];
                    $a041a5dd8ac78658$var$b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            $a041a5dd8ac78658$var$n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        $a041a5dd8ac78658$export$16e3aed3edb85946(e) || $a041a5dd8ac78658$var$n(8), $a041a5dd8ac78658$export$541ac630993a4c84(e) && (e = $a041a5dd8ac78658$export$97aac956da55dae9(e));
        var i = $a041a5dd8ac78658$var$w(this), o = $a041a5dd8ac78658$var$N(this, e, void 0);
        return o[$a041a5dd8ac78658$var$Q].C = !0, $a041a5dd8ac78658$var$O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[$a041a5dd8ac78658$var$Q];
        var i = e.A;
        return $a041a5dd8ac78658$var$j(i, t), $a041a5dd8ac78658$var$P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !$a041a5dd8ac78658$var$B && $a041a5dd8ac78658$var$n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = $a041a5dd8ac78658$var$b("Patches").$;
        return $a041a5dd8ac78658$export$541ac630993a4c84(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), $a041a5dd8ac78658$var$an = new $a041a5dd8ac78658$export$aaadc6ff0f822719, $a041a5dd8ac78658$export$b46cabe22e78bc00 = $a041a5dd8ac78658$var$an.produce, $a041a5dd8ac78658$export$4da66d41c9492c78 = $a041a5dd8ac78658$var$an.produceWithPatches.bind($a041a5dd8ac78658$var$an), $a041a5dd8ac78658$export$573f26f60825c493 = $a041a5dd8ac78658$var$an.setAutoFreeze.bind($a041a5dd8ac78658$var$an), $a041a5dd8ac78658$export$36ccd207ae29b74e = $a041a5dd8ac78658$var$an.setUseProxies.bind($a041a5dd8ac78658$var$an), $a041a5dd8ac78658$export$a8b8e03e6bbe5473 = $a041a5dd8ac78658$var$an.applyPatches.bind($a041a5dd8ac78658$var$an), $a041a5dd8ac78658$export$3c3214997190395f = $a041a5dd8ac78658$var$an.createDraft.bind($a041a5dd8ac78658$var$an), $a041a5dd8ac78658$export$c60f5e69c521b528 = $a041a5dd8ac78658$var$an.finishDraft.bind($a041a5dd8ac78658$var$an);
var $a041a5dd8ac78658$export$2e2bcd8739ae039 = $a041a5dd8ac78658$export$b46cabe22e78bc00;


const $90ac3354bcb37b98$var$now = ()=>new Date().getTime();
const $90ac3354bcb37b98$var$store = (0, (/*@__PURE__*/$parcel$interopDefault($5713dfbf5b9d650b$exports)))((set)=>{
    return {
        openModal: null,
        toggleModal: (modal)=>set((0, $a041a5dd8ac78658$export$2e2bcd8739ae039)((state)=>{
                state.openModal = state.openModal ? null : modal;
            })),
        transactions: {},
        addTransaction: ({ chainId: chainId, from: from, hash: hash, approval: approval, summary: summary, claim: claim })=>{
            return set((0, $a041a5dd8ac78658$export$2e2bcd8739ae039)((state)=>{
                var _state_transactions_chainId;
                if ((_state_transactions_chainId = state.transactions[chainId]) === null || _state_transactions_chainId === void 0 ? void 0 : _state_transactions_chainId[hash]) throw Error("Attempted to add existing transaction.");
                var _state_transactions_chainId1;
                const txs = (_state_transactions_chainId1 = state.transactions[chainId]) !== null && _state_transactions_chainId1 !== void 0 ? _state_transactions_chainId1 : {};
                txs[hash] = {
                    hash: hash,
                    approval: approval,
                    summary: summary,
                    claim: claim,
                    from: from,
                    addedTime: $90ac3354bcb37b98$var$now()
                };
                state.transactions[chainId] = txs;
            }));
        },
        finalizeTransaction: ({ hash: hash, chainId: chainId, receipt: receipt })=>{
            return set((0, $a041a5dd8ac78658$export$2e2bcd8739ae039)((state)=>{
                var _state_transactions_chainId;
                const tx = (_state_transactions_chainId = state.transactions[chainId]) === null || _state_transactions_chainId === void 0 ? void 0 : _state_transactions_chainId[hash];
                if (!tx) return;
                tx.receipt = receipt;
                tx.confirmedTime = $90ac3354bcb37b98$var$now();
            }));
        },
        checkedTransaction: ({ chainId: chainId, hash: hash, blockNumber: blockNumber })=>{
            return set((0, $a041a5dd8ac78658$export$2e2bcd8739ae039)((state)=>{
                var _state_transactions_chainId;
                const tx = (_state_transactions_chainId = state.transactions[chainId]) === null || _state_transactions_chainId === void 0 ? void 0 : _state_transactions_chainId[hash];
                if (!tx) return;
                if (!tx.lastCheckedBlockNumber) tx.lastCheckedBlockNumber = blockNumber;
                else tx.lastCheckedBlockNumber = Math.max(blockNumber, tx.lastCheckedBlockNumber);
            }));
        },
        blockNumber: {},
        updateBlockNumber: ({ chainId: chainId, blockNumber: blockNumber })=>set((0, $a041a5dd8ac78658$export$2e2bcd8739ae039)((state)=>{
                if (typeof state.blockNumber[chainId] !== "number") state.blockNumber[chainId] = blockNumber;
                else state.blockNumber[chainId] = Math.max(blockNumber, state.blockNumber[chainId]);
            }))
    };
});
var $90ac3354bcb37b98$export$2e2bcd8739ae039 = $90ac3354bcb37b98$var$store;


function $a4ca703d41e99e61$export$2e2bcd8739ae039() {
    const { library: library, chainId: chainId } = (0, $f895bcdfc688a573$export$ba082fd8bb7afc5c)();
    const windowVisible = (0, $9f58cdf121c09e01$export$2e2bcd8739ae039)();
    const [state, setState] = (0, $6cds3.useState)({
        chainId: chainId,
        blockNumber: null
    });
    const updateBlockNumber = (0, $90ac3354bcb37b98$export$2e2bcd8739ae039)((state)=>state.updateBlockNumber);
    const blockNumberCallback = (0, $6cds3.useCallback)((blockNumber)=>{
        setState((state)=>{
            if (chainId === state.chainId) {
                if (typeof state.blockNumber !== "number") return {
                    chainId: chainId,
                    blockNumber: blockNumber
                };
                return {
                    chainId: chainId,
                    blockNumber: Math.max(blockNumber, state.blockNumber)
                };
            }
            return state;
        });
    }, [
        chainId,
        setState
    ]);
    // attach/detach listeners
    (0, $6cds3.useEffect)(()=>{
        if (!library || !chainId || !windowVisible) return undefined;
        setState({
            chainId: chainId,
            blockNumber: null
        });
        library.getBlockNumber().then(blockNumberCallback).catch((error)=>console.error(`Failed to get block number for chainId: ${chainId}`, error));
        library.on("block", blockNumberCallback);
        return ()=>{
            library.removeListener("block", blockNumberCallback);
        };
    }, [
        chainId,
        library,
        blockNumberCallback,
        windowVisible
    ]);
    const debouncedState = (0, $4b94a551dba7d909$export$2e2bcd8739ae039)(state, 100);
    (0, $6cds3.useEffect)(()=>{
        if (!debouncedState.chainId || !debouncedState.blockNumber || !windowVisible) return;
        updateBlockNumber({
            chainId: debouncedState.chainId,
            blockNumber: debouncedState.blockNumber
        });
    }, [
        windowVisible,
        debouncedState.blockNumber,
        debouncedState.chainId
    ]);
    return null;
}



var $6cds3 = parcelRequire("6cds3");


var $0c4d44373537a972$exports = {};
"use strict";
Object.defineProperty($0c4d44373537a972$exports, "__esModule", {
    value: true
});
Object.defineProperty($0c4d44373537a972$exports, "NotificationContainer", {
    enumerable: true,
    get: function get() {
        return $0c4d44373537a972$var$_NotificationContainer.default;
    }
});
Object.defineProperty($0c4d44373537a972$exports, "NotificationManager", {
    enumerable: true,
    get: function get() {
        return $0c4d44373537a972$var$_NotificationManager.default;
    }
});
Object.defineProperty($0c4d44373537a972$exports, "Notifications", {
    enumerable: true,
    get: function get() {
        return $0c4d44373537a972$var$_Notifications.default;
    }
});
$0c4d44373537a972$exports.default = void 0;

var $0c4d44373537a972$var$_Notifications = $0c4d44373537a972$var$_interopRequireDefault((parcelRequire("j86fo")));

var $0c4d44373537a972$var$_NotificationContainer = $0c4d44373537a972$var$_interopRequireDefault((parcelRequire("44AIm")));

var $0c4d44373537a972$var$_NotificationManager = $0c4d44373537a972$var$_interopRequireDefault((parcelRequire("diFWH")));
function $0c4d44373537a972$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0c4d44373537a972$var$_default = $0c4d44373537a972$var$_Notifications.default;
$0c4d44373537a972$exports.default = $0c4d44373537a972$var$_default;



var $6cds3 = parcelRequire("6cds3");



function $2f0998f5caada353$export$6ced8bf9cb227539() {
    const toggleModal = (0, $90ac3354bcb37b98$export$2e2bcd8739ae039)((state)=>state.toggleModal);
    return (0, $6cds3.useCallback)(()=>toggleModal((0, $c7b134c1d77bb7b4$export$51360b6aa3a7b134).WALLET), [
        toggleModal
    ]);
}
function $2f0998f5caada353$export$2249c6bd5a7cb66() {
    const toggleModal = (0, $90ac3354bcb37b98$export$2e2bcd8739ae039)((state)=>state.toggleModal);
    return (0, $6cds3.useCallback)(()=>toggleModal((0, $c7b134c1d77bb7b4$export$51360b6aa3a7b134).MINDMAP), [
        toggleModal
    ]);
}
function $2f0998f5caada353$export$f8c072818b8da88a() {
    const toggleModal = (0, $90ac3354bcb37b98$export$2e2bcd8739ae039)((state)=>state.toggleModal);
    return (0, $6cds3.useCallback)(()=>toggleModal((0, $c7b134c1d77bb7b4$export$51360b6aa3a7b134).GALLERY), [
        toggleModal
    ]);
}
function $2f0998f5caada353$export$88a4917dcd7e89cd(modal) {
    const openModal = (0, $90ac3354bcb37b98$export$2e2bcd8739ae039)((state)=>state.openModal);
    return openModal === modal;
}
function $2f0998f5caada353$export$8bf0355f69442463() {
    const { chainId: chainId } = (0, $f895bcdfc688a573$export$ba082fd8bb7afc5c)();
    const blockNumber = (0, $90ac3354bcb37b98$export$2e2bcd8739ae039)((state)=>state.blockNumber);
    return blockNumber[chainId !== null && chainId !== void 0 ? chainId : -1];
}



function $f976db22f346fe21$export$75628842153d31cf(lastBlockNumber, tx) {
    if (tx.receipt) return false;
    if (!tx.lastCheckedBlockNumber) return true;
    const blocksSinceCheck = lastBlockNumber - tx.lastCheckedBlockNumber;
    if (blocksSinceCheck < 1) return false;
    const minutesPending = (new Date().getTime() - tx.addedTime) / 1000 / 60;
    if (minutesPending > 60) // every 10 blocks if pending for longer than an hour
    return blocksSinceCheck > 9;
    else if (minutesPending > 5) // every 3 blocks if pending more than 5 minutes
    return blocksSinceCheck > 2;
    else // otherwise every block
    return true;
}
function $f976db22f346fe21$export$2e2bcd8739ae039() {
    const { chainId: chainId, library: library } = (0, $f895bcdfc688a573$export$ba082fd8bb7afc5c)();
    const lastBlockNumber = (0, $2f0998f5caada353$export$8bf0355f69442463)();
    const state = (0, $90ac3354bcb37b98$export$2e2bcd8739ae039)((state)=>state.transactions);
    const finalizeTransaction = (0, $90ac3354bcb37b98$export$2e2bcd8739ae039)((state)=>state.finalizeTransaction);
    const checkedTransaction = (0, $90ac3354bcb37b98$export$2e2bcd8739ae039)((state)=>state.checkedTransaction);
    var _state_chainId;
    const transactions = chainId ? (_state_chainId = state[chainId]) !== null && _state_chainId !== void 0 ? _state_chainId : {} : {};
    (0, $6cds3.useEffect)(()=>{
        if (!chainId || !library || !lastBlockNumber) return;
        Object.keys(transactions).filter((hash)=>$f976db22f346fe21$export$75628842153d31cf(lastBlockNumber, transactions[hash])).forEach((hash)=>{
            library.getTransactionReceipt(hash).then((receipt)=>{
                if (receipt) {
                    var _transactions_hash;
                    finalizeTransaction({
                        chainId: chainId,
                        hash: hash,
                        receipt: {
                            blockHash: receipt.blockHash,
                            blockNumber: receipt.blockNumber,
                            contractAddress: receipt.contractAddress,
                            from: receipt.from,
                            status: receipt.status,
                            to: receipt.to,
                            transactionHash: receipt.transactionHash,
                            transactionIndex: receipt.transactionIndex
                        }
                    });
                    const success = receipt.status === 1;
                    if (success) (0, $0c4d44373537a972$exports.NotificationManager).success((0, $68e94d90188813cf$export$e6e2bc9967bf256c)(hash, 10), (_transactions_hash = transactions[hash]) === null || _transactions_hash === void 0 ? void 0 : _transactions_hash.summary);
                    else (0, $0c4d44373537a972$exports.NotificationManager).error((0, $68e94d90188813cf$export$e6e2bc9967bf256c)(hash, 10), "Something went wrong!");
                } else checkedTransaction({
                    chainId: chainId,
                    hash: hash,
                    blockNumber: lastBlockNumber
                });
            }).catch((error)=>{
                console.error(`failed to check transaction hash: ${hash}`, error);
            });
        });
    }, [
        chainId,
        library,
        transactions,
        lastBlockNumber
    ]);
    return null;
}



var $wvaTc = parcelRequire("wvaTc");

function $dd883d6545f56a78$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $dd883d6545f56a78$export$c3faceeb92aa39dd = /*#__PURE__*/ function(_EventEmitter) {
    $dd883d6545f56a78$var$_inheritsLoose(AbstractConnector, _EventEmitter);
    function AbstractConnector(_temp) {
        var _this;
        var _ref = _temp === void 0 ? {} : _temp, supportedChainIds = _ref.supportedChainIds;
        _this = _EventEmitter.call(this) || this;
        _this.supportedChainIds = supportedChainIds;
        return _this;
    }
    var _proto = AbstractConnector.prototype;
    _proto.emitUpdate = function emitUpdate(update) {
        this.emit((0, $feaa9a02344f813e$export$638354e3e7cf979c).Update, update);
    };
    _proto.emitError = function emitError(error) {
        this.emit((0, $feaa9a02344f813e$export$638354e3e7cf979c).Error, error);
    };
    _proto.emitDeactivate = function emitDeactivate() {
        this.emit((0, $feaa9a02344f813e$export$638354e3e7cf979c).Deactivate);
    };
    return AbstractConnector;
}((0, $wvaTc.EventEmitter));



function $8f8b172ace3afdd0$var$_extends() {
    $8f8b172ace3afdd0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8f8b172ace3afdd0$var$_extends.apply(this, arguments);
}
function $8f8b172ace3afdd0$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $8f8b172ace3afdd0$var$_getPrototypeOf(o) {
    $8f8b172ace3afdd0$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8f8b172ace3afdd0$var$_getPrototypeOf(o);
}
function $8f8b172ace3afdd0$var$_setPrototypeOf(o, p) {
    $8f8b172ace3afdd0$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8f8b172ace3afdd0$var$_setPrototypeOf(o, p);
}
function $8f8b172ace3afdd0$var$isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8f8b172ace3afdd0$var$_construct(Parent, args, Class) {
    if ($8f8b172ace3afdd0$var$isNativeReflectConstruct()) $8f8b172ace3afdd0$var$_construct = Reflect.construct;
    else $8f8b172ace3afdd0$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $8f8b172ace3afdd0$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $8f8b172ace3afdd0$var$_construct.apply(null, arguments);
}
function $8f8b172ace3afdd0$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $8f8b172ace3afdd0$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $8f8b172ace3afdd0$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$8f8b172ace3afdd0$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $8f8b172ace3afdd0$var$_construct(Class, arguments, $8f8b172ace3afdd0$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $8f8b172ace3afdd0$var$_setPrototypeOf(Wrapper, Class);
    };
    return $8f8b172ace3afdd0$var$_wrapNativeSuper(Class);
}
function $8f8b172ace3afdd0$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
// A type of promise-like that resolves synchronously and supports only one observer
var $8f8b172ace3afdd0$var$_iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = /*#__PURE__*/ Symbol("Symbol.iterator")) : "@@iterator"; // Asynchronously iterate through an object's values
var $8f8b172ace3afdd0$var$_asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator = /*#__PURE__*/ Symbol("Symbol.asyncIterator")) : "@@asyncIterator"; // Asynchronously iterate on a value using it's async iterator if present, or its synchronous iterator if missing
function $8f8b172ace3afdd0$var$_catch(body, recover) {
    try {
        var result = body();
    } catch (e) {
        return recover(e);
    }
    if (result && result.then) return result.then(void 0, recover);
    return result;
} // Asynchronously await a promise and pass the result to a finally continuation
function $8f8b172ace3afdd0$var$parseSendReturn(sendReturn) {
    return sendReturn.hasOwnProperty("result") ? sendReturn.result : sendReturn;
}
var $8f8b172ace3afdd0$export$90a52d569e5b110d = /*#__PURE__*/ function(_Error) {
    $8f8b172ace3afdd0$var$_inheritsLoose(NoEthereumProviderError, _Error);
    function NoEthereumProviderError() {
        var _this;
        _this = _Error.call(this) || this;
        _this.name = _this.constructor.name;
        _this.message = "No Ethereum provider was found on window.ethereum.";
        return _this;
    }
    return NoEthereumProviderError;
}(/*#__PURE__*/ $8f8b172ace3afdd0$var$_wrapNativeSuper(Error));
var $8f8b172ace3afdd0$export$4af5b080d9e9e1a6 = /*#__PURE__*/ function(_Error2) {
    $8f8b172ace3afdd0$var$_inheritsLoose(UserRejectedRequestError, _Error2);
    function UserRejectedRequestError() {
        var _this2;
        _this2 = _Error2.call(this) || this;
        _this2.name = _this2.constructor.name;
        _this2.message = "The user rejected the request.";
        return _this2;
    }
    return UserRejectedRequestError;
}(/*#__PURE__*/ $8f8b172ace3afdd0$var$_wrapNativeSuper(Error));
var $8f8b172ace3afdd0$export$2180bbd5f43a00b6 = /*#__PURE__*/ function(_AbstractConnector) {
    $8f8b172ace3afdd0$var$_inheritsLoose(InjectedConnector, _AbstractConnector);
    function InjectedConnector(kwargs) {
        var _this3;
        _this3 = _AbstractConnector.call(this, kwargs) || this;
        _this3.handleNetworkChanged = _this3.handleNetworkChanged.bind($8f8b172ace3afdd0$var$_assertThisInitialized(_this3));
        _this3.handleChainChanged = _this3.handleChainChanged.bind($8f8b172ace3afdd0$var$_assertThisInitialized(_this3));
        _this3.handleAccountsChanged = _this3.handleAccountsChanged.bind($8f8b172ace3afdd0$var$_assertThisInitialized(_this3));
        _this3.handleClose = _this3.handleClose.bind($8f8b172ace3afdd0$var$_assertThisInitialized(_this3));
        return _this3;
    }
    var _proto = InjectedConnector.prototype;
    _proto.handleChainChanged = function handleChainChanged(chainId) {
        this.emitUpdate({
            chainId: chainId,
            provider: window.ethereum
        });
    };
    _proto.handleAccountsChanged = function handleAccountsChanged(accounts) {
        if (accounts.length === 0) this.emitDeactivate();
        else this.emitUpdate({
            account: accounts[0]
        });
    };
    _proto.handleClose = function handleClose(code, reason) {
        this.emitDeactivate();
    };
    _proto.handleNetworkChanged = function handleNetworkChanged(networkId) {
        this.emitUpdate({
            chainId: networkId,
            provider: window.ethereum
        });
    };
    _proto.activate = function activate() {
        try {
            var _temp5 = function _temp5(_result) {
                if (_exit2) return _result;
                function _temp2() {
                    return $8f8b172ace3afdd0$var$_extends({
                        provider: window.ethereum
                    }, account ? {
                        account: account
                    } : {});
                }
                var _temp = function() {
                    if (!account) // if enable is successful but doesn't return accounts, fall back to getAccount (not happy i have to do this...)
                    return Promise.resolve(window.ethereum.enable().then(function(sendReturn) {
                        return sendReturn && $8f8b172ace3afdd0$var$parseSendReturn(sendReturn)[0];
                    })).then(function(_window$ethereum$enab) {
                        account = _window$ethereum$enab;
                    });
                }();
                // if unsuccessful, try enable
                return _temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp);
            };
            var _exit2 = false;
            var _this5 = this;
            if (!window.ethereum) throw new $8f8b172ace3afdd0$export$90a52d569e5b110d();
            if (window.ethereum.on) {
                window.ethereum.on("chainChanged", _this5.handleChainChanged);
                window.ethereum.on("accountsChanged", _this5.handleAccountsChanged);
                window.ethereum.on("close", _this5.handleClose);
                window.ethereum.on("networkChanged", _this5.handleNetworkChanged);
            }
            if (window.ethereum.isMetaMask) window.ethereum.autoRefreshOnNetworkChange = false;
             // try to activate + get account via eth_requestAccounts
            var account;
            var _temp6 = $8f8b172ace3afdd0$var$_catch(function() {
                return Promise.resolve(window.ethereum.send("eth_requestAccounts").then(function(sendReturn) {
                    return $8f8b172ace3afdd0$var$parseSendReturn(sendReturn)[0];
                })).then(function(_window$ethereum$send) {
                    account = _window$ethereum$send;
                });
            }, function(error) {
                if (error.code === 4001) throw new $8f8b172ace3afdd0$export$4af5b080d9e9e1a6();
            });
            return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(_temp5) : _temp5(_temp6));
        } catch (e) {
            return Promise.reject(e);
        }
    };
    _proto.getProvider = function getProvider() {
        try {
            return Promise.resolve(window.ethereum);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    _proto.getChainId = function getChainId() {
        try {
            var _temp12 = function _temp12() {
                function _temp9() {
                    if (!chainId) try {
                        chainId = $8f8b172ace3afdd0$var$parseSendReturn(window.ethereum.send({
                            method: "net_version"
                        }));
                    } catch (_unused) {}
                    if (!chainId) {
                        if (window.ethereum.isDapper) chainId = $8f8b172ace3afdd0$var$parseSendReturn(window.ethereum.cachedResults.net_version);
                        else chainId = window.ethereum.chainId || window.ethereum.netVersion || window.ethereum.networkVersion || window.ethereum._chainId;
                    }
                    return chainId;
                }
                var _temp8 = function() {
                    if (!chainId) {
                        var _temp14 = $8f8b172ace3afdd0$var$_catch(function() {
                            return Promise.resolve(window.ethereum.send("net_version").then($8f8b172ace3afdd0$var$parseSendReturn)).then(function(_window$ethereum$send3) {
                                chainId = _window$ethereum$send3;
                            });
                        }, function() {});
                        if (_temp14 && _temp14.then) return _temp14.then(function() {});
                    }
                }();
                return _temp8 && _temp8.then ? _temp8.then(_temp9) : _temp9(_temp8);
            };
            if (!window.ethereum) throw new $8f8b172ace3afdd0$export$90a52d569e5b110d();
            var chainId;
            var _temp13 = $8f8b172ace3afdd0$var$_catch(function() {
                return Promise.resolve(window.ethereum.send("eth_chainId").then($8f8b172ace3afdd0$var$parseSendReturn)).then(function(_window$ethereum$send2) {
                    chainId = _window$ethereum$send2;
                });
            }, function() {});
            return Promise.resolve(_temp13 && _temp13.then ? _temp13.then(_temp12) : _temp12(_temp13));
        } catch (e) {
            return Promise.reject(e);
        }
    };
    _proto.getAccount = function getAccount() {
        try {
            var _temp20 = function _temp20() {
                function _temp17() {
                    if (!account) account = $8f8b172ace3afdd0$var$parseSendReturn(window.ethereum.send({
                        method: "eth_accounts"
                    }))[0];
                    return account;
                }
                var _temp16 = function() {
                    if (!account) {
                        var _temp22 = $8f8b172ace3afdd0$var$_catch(function() {
                            return Promise.resolve(window.ethereum.enable().then(function(sendReturn) {
                                return $8f8b172ace3afdd0$var$parseSendReturn(sendReturn)[0];
                            })).then(function(_window$ethereum$enab2) {
                                account = _window$ethereum$enab2;
                            });
                        }, function() {});
                        if (_temp22 && _temp22.then) return _temp22.then(function() {});
                    }
                }();
                return _temp16 && _temp16.then ? _temp16.then(_temp17) : _temp17(_temp16);
            };
            if (!window.ethereum) throw new $8f8b172ace3afdd0$export$90a52d569e5b110d();
            var account;
            var _temp21 = $8f8b172ace3afdd0$var$_catch(function() {
                return Promise.resolve(window.ethereum.send("eth_accounts").then(function(sendReturn) {
                    return $8f8b172ace3afdd0$var$parseSendReturn(sendReturn)[0];
                })).then(function(_window$ethereum$send4) {
                    account = _window$ethereum$send4;
                });
            }, function() {});
            return Promise.resolve(_temp21 && _temp21.then ? _temp21.then(_temp20) : _temp20(_temp21));
        } catch (e) {
            return Promise.reject(e);
        }
    };
    _proto.deactivate = function deactivate() {
        if (window.ethereum && window.ethereum.removeListener) {
            window.ethereum.removeListener("chainChanged", this.handleChainChanged);
            window.ethereum.removeListener("accountsChanged", this.handleAccountsChanged);
            window.ethereum.removeListener("close", this.handleClose);
            window.ethereum.removeListener("networkChanged", this.handleNetworkChanged);
        }
    };
    _proto.isAuthorized = function isAuthorized() {
        try {
            if (!window.ethereum) return Promise.resolve(false);
            return Promise.resolve($8f8b172ace3afdd0$var$_catch(function() {
                return Promise.resolve(window.ethereum.send("eth_accounts").then(function(sendReturn) {
                    if ($8f8b172ace3afdd0$var$parseSendReturn(sendReturn).length > 0) return true;
                    else return false;
                }));
            }, function() {
                return false;
            }));
        } catch (e) {
            return Promise.reject(e);
        }
    };
    return InjectedConnector;
}((0, $dd883d6545f56a78$export$c3faceeb92aa39dd));



function $c59ef1a51a77303b$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $c59ef1a51a77303b$var$_setPrototypeOf(subClass, superClass);
}
function $c59ef1a51a77303b$var$_getPrototypeOf(o) {
    $c59ef1a51a77303b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c59ef1a51a77303b$var$_getPrototypeOf(o);
}
function $c59ef1a51a77303b$var$_setPrototypeOf(o, p) {
    $c59ef1a51a77303b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c59ef1a51a77303b$var$_setPrototypeOf(o, p);
}
function $c59ef1a51a77303b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c59ef1a51a77303b$var$_construct(Parent, args, Class) {
    if ($c59ef1a51a77303b$var$_isNativeReflectConstruct()) $c59ef1a51a77303b$var$_construct = Reflect.construct;
    else $c59ef1a51a77303b$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $c59ef1a51a77303b$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $c59ef1a51a77303b$var$_construct.apply(null, arguments);
}
function $c59ef1a51a77303b$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $c59ef1a51a77303b$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $c59ef1a51a77303b$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$c59ef1a51a77303b$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $c59ef1a51a77303b$var$_construct(Class, arguments, $c59ef1a51a77303b$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $c59ef1a51a77303b$var$_setPrototypeOf(Wrapper, Class);
    };
    return $c59ef1a51a77303b$var$_wrapNativeSuper(Class);
}
function $c59ef1a51a77303b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $c59ef1a51a77303b$export$3cc06e0859936481 = "URI_AVAILABLE";
var $c59ef1a51a77303b$export$4af5b080d9e9e1a6 = /*#__PURE__*/ function(_Error) {
    $c59ef1a51a77303b$var$_inheritsLoose(UserRejectedRequestError, _Error);
    function UserRejectedRequestError() {
        var _this;
        _this = _Error.call(this) || this;
        _this.name = _this.constructor.name;
        _this.message = "The user rejected the request.";
        return _this;
    }
    return UserRejectedRequestError;
}(/*#__PURE__*/ $c59ef1a51a77303b$var$_wrapNativeSuper(Error));
function $c59ef1a51a77303b$var$getSupportedChains(_ref) {
    var supportedChainIds = _ref.supportedChainIds, rpc = _ref.rpc;
    if (supportedChainIds) return supportedChainIds;
    return rpc ? Object.keys(rpc).map(function(k) {
        return Number(k);
    }) : undefined;
}

var $c59ef1a51a77303b$export$c456b2d327ac201f = /*#__PURE__*/ function(_AbstractConnector) {
    $c59ef1a51a77303b$var$_inheritsLoose(WalletConnectConnector, _AbstractConnector);
    function WalletConnectConnector(config) {
        var _this2;
        _this2 = _AbstractConnector.call(this, {
            supportedChainIds: $c59ef1a51a77303b$var$getSupportedChains(config)
        }) || this;
        _this2.config = config;
        _this2.handleChainChanged = _this2.handleChainChanged.bind($c59ef1a51a77303b$var$_assertThisInitialized(_this2));
        _this2.handleAccountsChanged = _this2.handleAccountsChanged.bind($c59ef1a51a77303b$var$_assertThisInitialized(_this2));
        _this2.handleDisconnect = _this2.handleDisconnect.bind($c59ef1a51a77303b$var$_assertThisInitialized(_this2));
        return _this2;
    }
    var _proto = WalletConnectConnector.prototype;
    _proto.handleChainChanged = function handleChainChanged(chainId) {
        this.emitUpdate({
            chainId: chainId
        });
    };
    _proto.handleAccountsChanged = function handleAccountsChanged(accounts) {
        this.emitUpdate({
            account: accounts[0]
        });
    };
    _proto.handleDisconnect = function handleDisconnect() {
        if (this.walletConnectProvider) {
            this.walletConnectProvider.removeListener("chainChanged", this.handleChainChanged);
            this.walletConnectProvider.removeListener("accountsChanged", this.handleAccountsChanged);
            this.walletConnectProvider = undefined;
        }
        this.emitDeactivate();
    };
    _proto.activate = function activate() {
        try {
            var _this4 = this;
            var _temp5 = function _temp5() {
                function _temp2() {
                    var account;
                    return Promise.resolve(new Promise(function(resolve, reject) {
                        var userReject = function userReject() {
                            // Erase the provider manually
                            _this4.walletConnectProvider = undefined;
                            reject(new $c59ef1a51a77303b$export$4af5b080d9e9e1a6());
                        }; // Workaround to bubble up the error when user reject the connection
                        _this4.walletConnectProvider.connector.on("disconnect", function() {
                            // Check provider has not been enabled to prevent this event callback from being called in the future
                            if (!account) userReject();
                        });
                        _this4.walletConnectProvider.enable().then(function(accounts) {
                            return resolve(accounts[0]);
                        })["catch"](function(error) {
                            // TODO ideally this would be a better check
                            if (error.message === "User closed modal") {
                                userReject();
                                return;
                            }
                            reject(error);
                        });
                    })["catch"](function(err) {
                        throw err;
                    })).then(function(_Promise$catch) {
                        account = _Promise$catch;
                        _this4.walletConnectProvider.on("disconnect", _this4.handleDisconnect);
                        _this4.walletConnectProvider.on("chainChanged", _this4.handleChainChanged);
                        _this4.walletConnectProvider.on("accountsChanged", _this4.handleAccountsChanged);
                        return {
                            provider: _this4.walletConnectProvider,
                            account: account
                        };
                    });
                }
                var _temp = function() {
                    if (!_this4.walletConnectProvider.connector.connected) return Promise.resolve(_this4.walletConnectProvider.connector.createSession(_this4.config.chainId ? {
                        chainId: _this4.config.chainId
                    } : undefined)).then(function() {
                        _this4.emit($c59ef1a51a77303b$export$3cc06e0859936481, _this4.walletConnectProvider.connector.uri);
                    });
                }();
                // ensure that the uri is going to be available, and emit an event if there's a new uri
                return _temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp);
            };
            var _temp6 = function() {
                if (!_this4.walletConnectProvider) return Promise.resolve((parcelRequire("kkbyb")).then(function(m) {
                    var _m$default;
                    return (_m$default = m == null ? void 0 : m["default"]) != null ? _m$default : m;
                })).then(function(WalletConnectProvider) {
                    _this4.walletConnectProvider = new WalletConnectProvider(_this4.config);
                });
            }();
            return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(_temp5) : _temp5(_temp6));
        } catch (e) {
            return Promise.reject(e);
        }
    };
    _proto.getProvider = function getProvider() {
        try {
            var _this6 = this;
            return Promise.resolve(_this6.walletConnectProvider);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    _proto.getChainId = function getChainId() {
        try {
            var _this8 = this;
            return Promise.resolve(_this8.walletConnectProvider.chainId);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    _proto.getAccount = function getAccount() {
        try {
            var _this10 = this;
            return Promise.resolve(_this10.walletConnectProvider.accounts).then(function(accounts) {
                return accounts[0];
            });
        } catch (e) {
            return Promise.reject(e);
        }
    };
    _proto.deactivate = function deactivate() {
        if (this.walletConnectProvider) {
            this.walletConnectProvider.removeListener("disconnect", this.handleDisconnect);
            this.walletConnectProvider.removeListener("chainChanged", this.handleChainChanged);
            this.walletConnectProvider.removeListener("accountsChanged", this.handleAccountsChanged);
            this.walletConnectProvider.disconnect();
        }
    };
    _proto.close = function close() {
        try {
            var _this12 = this;
            _this12.emitDeactivate();
            return Promise.resolve();
        } catch (e) {
            return Promise.reject(e);
        }
    };
    return WalletConnectConnector;
}((0, $dd883d6545f56a78$export$c3faceeb92aa39dd));


const $9a7898bfa71d3001$var$RPC = {
    MAINNET: "https://eth-mainnet.alchemyapi.io/v2/WA2AXzOrXOj664de25fmJr7dSzsQXx42",
    ROPSTEN: "https://eth-ropsten.alchemyapi.io/v2/cidKix2Xr-snU3f6f6Zjq_rYdalKKHmW",
    RINKEBY: "https://eth-rinkeby.alchemyapi.io/v2/2bsCK-9_nnvL-mWAuXGF1DoDx5KhtyGU",
    GOERLI: "https://eth-goerli.alchemyapi.io/v2/Dkk5d02QjttYEoGmhZnJG37rKt8Yl3Im",
    KOVAN: "https://eth-kovan.alchemyapi.io/v2/fRJBkIBRRgoyjPZZfZIO3mUcNgraMh5e",
    FANTOM: "https://rpcapi.fantom.network",
    FANTOM_TESTNET: "https://rpc.testnet.fantom.network",
    MATIC: "https://rpc-mainnet.maticvigil.com",
    MATIC_TESTNET: "https://rpc-mumbai.matic.today",
    XDAI: "https://rpc.xdaichain.com",
    BSC: "https://bsc-dataseed.binance.org/",
    BSC_TESTNET: "https://data-seed-prebsc-2-s3.binance.org:8545",
    MOONBASE: "https://rpc.testnet.moonbeam.network",
    AVALANCHE: "https://api.avax.network/ext/bc/C/rpc",
    FUJI: "https://api.avax-test.network/ext/bc/C/rpc",
    HECO: "https://http-mainnet.hecochain.com",
    HECO_TESTNET: "https://http-testnet.hecochain.com",
    HARMONY: "https://explorer.harmony.one",
    HARMONY_TESTNET: "https://explorer.pops.one"
};
const $9a7898bfa71d3001$export$a7a34dad4983656f = new (0, $8f8b172ace3afdd0$export$2180bbd5f43a00b6)({
    supportedChainIds: [
        1,
        3,
        4,
        5,
        42,
        250,
        4002,
        137,
        80001,
        100,
        56,
        97,
        1287,
        43114,
        43113,
        128,
        256,
        1666600000,
        1666700000 // harmony testnet
    ]
});
const $9a7898bfa71d3001$export$8f53618cd78a10fc = new (0, $c59ef1a51a77303b$export$c456b2d327ac201f)({
    rpc: {
        1: $9a7898bfa71d3001$var$RPC.MAINNET,
        5: $9a7898bfa71d3001$var$RPC.GOERLI,
        137: $9a7898bfa71d3001$var$RPC.MATIC
    },
    bridge: "https://bridge.walletconnect.org",
    qrcode: true
});




const $112f0bf3637d3c98$var$Web3ProviderNetwork = (0, $607a80a0a69e28c2$export$243b2c701c025ba8)("NETWORK");
if (!!window.ethereum) window.ethereum.autoRefreshOnNetworkChange = false;
let $112f0bf3637d3c98$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($64d0b1ebdd6bcffe$exports))).createRoot(document.getElementById("root"));
let $112f0bf3637d3c98$var$index = /*#__PURE__*/ (0, $lBpE3.jsxs)((0, $lBpE3.Fragment), {
    children: [
        /*#__PURE__*/ (0, $lBpE3.jsx)((0, $607a80a0a69e28c2$export$f5c33efe7118b551), {
            getLibrary: (0, $73e0d52c1734bc21$export$b80d5513bcafc6b2),
            children: /*#__PURE__*/ (0, $lBpE3.jsxs)($112f0bf3637d3c98$var$Web3ProviderNetwork, {
                getLibrary: (0, $73e0d52c1734bc21$export$b80d5513bcafc6b2),
                children: [
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $20c77486c83a2d5d$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $f976db22f346fe21$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a4ca703d41e99e61$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $lBpE3.jsx)((0, $07c365c5f735c5f3$export$2e2bcd8739ae039), {})
                ]
            })
        }),
        /*#__PURE__*/ (0, $lBpE3.jsx)((0, $0c4d44373537a972$exports.NotificationContainer), {})
    ]
});
$112f0bf3637d3c98$var$root.render($112f0bf3637d3c98$var$index);

})();
//# sourceMappingURL=Index.1d4edae1.js.map
